import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Base StructureDefinition for base64Binary Type: A stream of bytes */
  base64Binary: any;
  /** Base StructureDefinition for canonical type: A URI that is a reference to a canonical URL on a FHIR resource */
  canonical: any;
  /** Base StructureDefinition for code type: A string which has at least one character and no leading or trailing whitespace and where there is no whitespace other than single spaces in the contents */
  code: any;
  /** Base StructureDefinition for date Type: A date or partial date (e.g. just year or year + month). There is no time zone. The format is a union of the schema types gYear, gYearMonth and date.  Dates SHALL be valid dates. */
  date: any;
  /** Base StructureDefinition for dateTime Type: A date, date-time or partial date (e.g. just year or year + month).  If hours and minutes are specified, a time zone SHALL be populated. The format is a union of the schema types gYear, gYearMonth, date and dateTime. Seconds must be provided due to schema type constraints but may be zero-filled and may be ignored.                 Dates SHALL be valid dates. */
  dateTime: any;
  /** Base StructureDefinition for id type: Any combination of letters, numerals, '-' and '.', with a length limit of 64 characters.  (This might be an integer, an unprefixed OID, UUID or any other identifier pattern that meets these constraints.)  Ids are case-insensitive. */
  id: any;
  /** Base StructureDefinition for instant Type: An instant in time - known at least to the second */
  instant: any;
  /** Base StructureDefinition for oid type: An OID represented as a URI */
  oid: any;
  /** Base StructureDefinition for positiveInt type: An integer with a value that is positive (e.g. >0) */
  positiveInt: any;
  /** Base StructureDefinition for time Type: A time during the day, with no date specified */
  time: any;
  /** Base StructureDefinition for token type */
  token: any;
  /** Base StructureDefinition for unsignedInt type: An integer with a value that is not negative (e.g. >= 0) */
  unsignedInt: any;
  /** Base StructureDefinition for uri Type: String of characters used to identify a name or a resource */
  uri: any;
  /** Base StructureDefinition for url type: A URI that is a literal reference */
  url: any;
  /** Base StructureDefinition for uuid type: A UUID, represented as a URI */
  uuid: any;
  /** Base StructureDefinition for xhtml Type */
  xhtml: any;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type AppInternal_Input = {
  /** operationType field data. */
  message?: Maybe<Scalars['String']>;
  /** operationType field data. */
  createOn?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type AppInternal_Schema = {
  __typename?: 'APPInternal_Schema';
  /** operationType field data. */
  message?: Maybe<Scalars['String']>;
  /** operationType field data. */
  createOn?: Maybe<Scalars['String']>;
};

/** APPNotifications_Schema. */
export type AppNotifications = {
  __typename?: 'APPNotifications';
  /** Type of resource */
  resourceType: AppNotifications_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  messageFor?: Maybe<Scalars['Int']>;
  /** logDescription Name. */
  messageForId?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  message?: Maybe<Scalars['String']>;
};

export enum AppNotifications_Enum {
  AppNotifications = 'APPNotifications'
}

export enum AppNotifications_Enum_Input {
  AppNotifications = 'APPNotifications'
}

/** APPNotifications */
export type AppNotifications_Input = {
  /** Type of resource */
  resourceType: AppNotifications_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  messageFor?: Maybe<Scalars['Int']>;
  /** logDescription Name. */
  messageForId?: Maybe<Scalars['String']>;
  /** logDescription Name. */
  messageForType?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  message?: Maybe<Scalars['String']>;
};

/** APPTasks_Schema. */
export type AppTasks = {
  __typename?: 'APPTasks';
  /** Type of resource */
  resourceType: AppTasks_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  taskFor?: Maybe<Scalars['Int']>;
  /** logDescription Name. */
  taskForId?: Maybe<Scalars['String']>;
  /** logDescription Name. */
  taskType?: Maybe<Scalars['String']>;
  /** logDescription Name. */
  taskCount?: Maybe<Scalars['Int']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  tasksList?: Maybe<Array<Maybe<AppInternal_Schema>>>;
};

export enum AppTasks_Enum {
  AppTasks = 'APPTasks'
}

export enum AppTasks_Enum_Input {
  AppTasks = 'APPTasks'
}

/** APPTasks */
export type AppTasks_Input = {
  /** Type of resource */
  resourceType: AppTasks_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  taskFor?: Maybe<Scalars['Int']>;
  /** logDescription Name. */
  taskForId?: Maybe<Scalars['String']>;
  /** logDescription Name. */
  taskType?: Maybe<Scalars['String']>;
  /** logDescription Name. */
  adminTaskType?: Maybe<Scalars['String']>;
  /** logDescription Name. */
  taskCount?: Maybe<Scalars['Int']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  tasksList?: Maybe<Array<Maybe<AppInternal_Input>>>;
};

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track charges for a patient, cost centers, etc.
 */
export type Account = {
  __typename?: 'Account';
  /** Type of resource */
  resourceType: Account_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique identifier used to reference the account.  Might or might not be intended for human use (e.g. credit card number). */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Indicates whether the account is presently used/usable or not. */
  _status?: Maybe<Element>;
  /** Indicates whether the account is presently used/usable or not. */
  status: Scalars['code'];
  /** Categorizes the account for reporting and searching purposes. */
  type?: Maybe<CodeableConcept>;
  /** Name used for the account when displaying it to humans in reports, etc. */
  _name?: Maybe<Element>;
  /** Name used for the account when displaying it to humans in reports, etc. */
  name?: Maybe<Scalars['String']>;
  /**
   * Identifies the entity which incurs the expenses. While the immediate
   * recipients of services or goods might be entities related to the subject, the
   * expenses were ultimately incurred by the subject of the Account.
   */
  subject?: Maybe<Array<Maybe<Accountsubject_Subject_Union>>>;
  /** The date range of services associated with this account. */
  servicePeriod?: Maybe<Period>;
  /**
   * The party(s) that are responsible for covering the payment of this account,
   * and what order should they be applied to the account.
   */
  coverage?: Maybe<Array<Maybe<Accountcoverage>>>;
  /** Indicates the service area, hospital, department, etc. with responsibility for managing the Account. */
  owner?: Maybe<Accountowner_Owner_Union>;
  /** Provides additional information about what the account tracks and how it is used. */
  _description?: Maybe<Element>;
  /** Provides additional information about what the account tracks and how it is used. */
  description?: Maybe<Scalars['String']>;
  /** The parties responsible for balancing the account if other payment options fall short. */
  guarantor?: Maybe<Array<Maybe<Accountguarantor>>>;
  /** Reference to a parent Account. */
  partOf?: Maybe<AccountpartOf_PartOf_Union>;
};

export enum Account_Enum_Schema {
  Account = 'Account'
}

export type Accountcoverage = {
  __typename?: 'Accountcoverage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The party(s) that contribute to payment (or part of) of the charges applied to
   * this account (including self-pay).  A coverage may only be responsible for
   * specific types of charges, and the sequence of the coverages in the account
   * could be important when processing billing.
   */
  coverage: Accountcoveragecoverage_Coverage_Union;
  /** The priority of the coverage in the context of this account. */
  _priority?: Maybe<Element>;
  /** The priority of the coverage in the context of this account. */
  priority?: Maybe<Scalars['positiveInt']>;
};

/**
 * The party(s) that contribute to payment (or part of) of the charges applied to
 * this account (including self-pay).  A coverage may only be responsible for
 * specific types of charges, and the sequence of the coverages in the account
 * could be important when processing billing.
 */
export type Accountcoveragecoverage_Coverage_Union = Coverage;

export type Accountguarantor = {
  __typename?: 'Accountguarantor';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The entity who is responsible. */
  party: Accountguarantorparty_Party_Union;
  /** A guarantor may be placed on credit hold or otherwise have their role temporarily suspended. */
  _onHold?: Maybe<Element>;
  /** A guarantor may be placed on credit hold or otherwise have their role temporarily suspended. */
  onHold?: Maybe<Scalars['Boolean']>;
  /** The timeframe during which the guarantor accepts responsibility for the account. */
  period?: Maybe<Period>;
};

/** The entity who is responsible. */
export type Accountguarantorparty_Party_Union = Patient | RelatedPerson | Organization;

/** Indicates the service area, hospital, department, etc. with responsibility for managing the Account. */
export type Accountowner_Owner_Union = Organization;

/** Reference to a parent Account. */
export type AccountpartOf_PartOf_Union = Account;

/**
 * Identifies the entity which incurs the expenses. While the immediate recipients
 * of services or goods might be entities related to the subject, the expenses were
 * ultimately incurred by the subject of the Account.
 */
export type Accountsubject_Subject_Union = Patient | Device | Practitioner | PractitionerRole | Location | HealthcareService | Organization;

/**
 * This resource allows for the definition of some activity to be performed,
 * independent of a particular patient, practitioner, or other performance context.
 */
export type ActivityDefinition = {
  __typename?: 'ActivityDefinition';
  /** Type of resource */
  resourceType: ActivityDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this activity definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this activity
   * definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the activity definition is
   * stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this activity definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this activity
   * definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the activity definition is
   * stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this activity definition when it
   * is represented in other formats, or referenced in a specification, model,
   * design or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the activity
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the activity definition author
   * and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence. To
   * provide a version consistent with the Decision Support Service specification,
   * use the format Major.Minor.Revision (e.g. 1.0.0). For more information on
   * versioning knowledge assets, refer to the Decision Support Service
   * specification. Note that a version is required for non-experimental active assets.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the activity
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the activity definition author
   * and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence. To
   * provide a version consistent with the Decision Support Service specification,
   * use the format Major.Minor.Revision (e.g. 1.0.0). For more information on
   * versioning knowledge assets, refer to the Decision Support Service
   * specification. Note that a version is required for non-experimental active assets.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the activity definition. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the activity definition. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the activity definition. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the activity definition. */
  title?: Maybe<Scalars['String']>;
  /** An explanatory or alternate title for the activity definition giving additional information about its content. */
  _subtitle?: Maybe<Element>;
  /** An explanatory or alternate title for the activity definition giving additional information about its content. */
  subtitle?: Maybe<Scalars['String']>;
  /** The status of this activity definition. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this activity definition. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this activity definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this activity definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /** A code or group definition that describes the intended subject of the activity being defined. */
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  /** A code or group definition that describes the intended subject of the activity being defined. */
  subjectReference?: Maybe<ActivityDefinitionsubjectReference_SubjectReference_Union>;
  /**
   * The date  (and optionally time) when the activity definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the activity definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the activity definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the activity definition changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the activity definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the activity definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the activity definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the activity definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate activity
   * definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the activity definition is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this activity definition is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this activity definition is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /** A detailed description of how the activity definition is used from a clinical perspective. */
  _usage?: Maybe<Element>;
  /** A detailed description of how the activity definition is used from a clinical perspective. */
  usage?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the activity definition and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the activity definition.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the activity definition and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the activity definition.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the activity definition content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the content of the activity. Topics provide a
   * high-level categorization of the activity that can be useful for filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related artifacts such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** A reference to a Library resource containing any formal logic used by the activity definition. */
  _library?: Maybe<Element>;
  /** A reference to a Library resource containing any formal logic used by the activity definition. */
  library?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * A description of the kind of resource the activity definition is representing.
   * For example, a MedicationRequest, a ServiceRequest, or a CommunicationRequest.
   * Typically, but not always, this is a Request resource.
   */
  _kind?: Maybe<Element>;
  /**
   * A description of the kind of resource the activity definition is representing.
   * For example, a MedicationRequest, a ServiceRequest, or a CommunicationRequest.
   * Typically, but not always, this is a Request resource.
   */
  kind?: Maybe<Scalars['code']>;
  /** A profile to which the target of the activity definition is expected to conform. */
  _profile?: Maybe<Element>;
  /** A profile to which the target of the activity definition is expected to conform. */
  profile?: Maybe<Scalars['canonical']>;
  /** Detailed description of the type of activity; e.g. What lab test, what procedure, what kind of encounter. */
  code?: Maybe<CodeableConcept>;
  /**
   * Indicates the level of authority/intentionality associated with the activity
   * and where the request should fit into the workflow chain.
   */
  _intent?: Maybe<Element>;
  /**
   * Indicates the level of authority/intentionality associated with the activity
   * and where the request should fit into the workflow chain.
   */
  intent?: Maybe<Scalars['code']>;
  /** Indicates how quickly the activity  should be addressed with respect to other requests. */
  _priority?: Maybe<Element>;
  /** Indicates how quickly the activity  should be addressed with respect to other requests. */
  priority?: Maybe<Scalars['code']>;
  /**
   * Set this to true if the definition is to indicate that a particular activity
   * should NOT be performed. If true, this element should be interpreted to
   * reinforce a negative coding. For example NPO as a code with a doNotPerform of
   * true would still indicate to NOT perform the action.
   */
  _doNotPerform?: Maybe<Element>;
  /**
   * Set this to true if the definition is to indicate that a particular activity
   * should NOT be performed. If true, this element should be interpreted to
   * reinforce a negative coding. For example NPO as a code with a doNotPerform of
   * true would still indicate to NOT perform the action.
   */
  doNotPerform?: Maybe<Scalars['Boolean']>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  timingTiming?: Maybe<Timing>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  _timingDateTime?: Maybe<Element>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  timingDateTime?: Maybe<Scalars['dateTime']>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  timingAge?: Maybe<Age>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  timingPeriod?: Maybe<Period>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  timingRange?: Maybe<Range>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  timingDuration?: Maybe<Duration>;
  /** Identifies the facility where the activity will occur; e.g. home, hospital, specific clinic, etc. */
  location?: Maybe<ActivityDefinitionlocation_Location_Union>;
  /** Indicates who should participate in performing the action described. */
  participant?: Maybe<Array<Maybe<ActivityDefinitionparticipant>>>;
  /** Identifies the food, drug or other product being consumed or supplied in the activity. */
  productReference?: Maybe<ActivityDefinitionproductReference_ProductReference_Union>;
  /** Identifies the food, drug or other product being consumed or supplied in the activity. */
  productCodeableConcept?: Maybe<CodeableConcept>;
  /** Identifies the quantity expected to be consumed at once (per dose, per meal, etc.). */
  quantity?: Maybe<Quantity>;
  /** Provides detailed dosage instructions in the same way that they are described for MedicationRequest resources. */
  dosage?: Maybe<Array<Maybe<Dosage>>>;
  /** Indicates the sites on the subject's body where the procedure should be performed (I.e. the target sites). */
  bodySite?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Defines specimen requirements for the action to be performed, such as required specimens for a lab test. */
  specimenRequirement?: Maybe<Array<Maybe<ActivityDefinitionspecimenRequirement_SpecimenRequirement_Union>>>;
  /** Defines observation requirements for the action to be performed, such as body weight or surface area. */
  observationRequirement?: Maybe<Array<Maybe<ActivityDefinitionobservationRequirement_ObservationRequirement_Union>>>;
  /** Defines the observations that are expected to be produced by the action. */
  observationResultRequirement?: Maybe<Array<Maybe<ActivityDefinitionobservationResultRequirement_ObservationResultRequirement_Union>>>;
  /**
   * A reference to a StructureMap resource that defines a transform that can be
   * executed to produce the intent resource using the ActivityDefinition instance as the input.
   */
  _transform?: Maybe<Element>;
  /**
   * A reference to a StructureMap resource that defines a transform that can be
   * executed to produce the intent resource using the ActivityDefinition instance as the input.
   */
  transform?: Maybe<Scalars['canonical']>;
  /**
   * Dynamic values that will be evaluated to produce values for elements of the
   * resulting resource. For example, if the dosage of a medication must be
   * computed based on the patient's weight, a dynamic value would be used to
   * specify an expression that calculated the weight, and the path on the request
   * resource that would contain the result.
   */
  dynamicValue?: Maybe<Array<Maybe<ActivityDefinitiondynamicValue>>>;
};

export enum ActivityDefinition_Enum_Schema {
  ActivityDefinition = 'ActivityDefinition'
}

export type ActivityDefinitiondynamicValue = {
  __typename?: 'ActivityDefinitiondynamicValue';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The path to the element to be customized. This is the path on the resource
   * that will hold the result of the calculation defined by the expression. The
   * specified path SHALL be a FHIRPath resolveable on the specified target type of
   * the ActivityDefinition, and SHALL consist only of identifiers, constant
   * indexers, and a restricted subset of functions. The path is allowed to contain
   * qualifiers (.) to traverse sub-elements, as well as indexers ([x]) to traverse
   * multiple-cardinality sub-elements (see the [Simple FHIRPath
   * Profile](fhirpath.html#simple) for full details).
   */
  _path?: Maybe<Element>;
  /**
   * The path to the element to be customized. This is the path on the resource
   * that will hold the result of the calculation defined by the expression. The
   * specified path SHALL be a FHIRPath resolveable on the specified target type of
   * the ActivityDefinition, and SHALL consist only of identifiers, constant
   * indexers, and a restricted subset of functions. The path is allowed to contain
   * qualifiers (.) to traverse sub-elements, as well as indexers ([x]) to traverse
   * multiple-cardinality sub-elements (see the [Simple FHIRPath
   * Profile](fhirpath.html#simple) for full details).
   */
  path: Scalars['String'];
  /** An expression specifying the value of the customized element. */
  expression: Expression;
};

/** Identifies the facility where the activity will occur; e.g. home, hospital, specific clinic, etc. */
export type ActivityDefinitionlocation_Location_Union = Location;

/** Defines observation requirements for the action to be performed, such as body weight or surface area. */
export type ActivityDefinitionobservationRequirement_ObservationRequirement_Union = ObservationDefinition;

/** Defines the observations that are expected to be produced by the action. */
export type ActivityDefinitionobservationResultRequirement_ObservationResultRequirement_Union = ObservationDefinition;

export type ActivityDefinitionparticipant = {
  __typename?: 'ActivityDefinitionparticipant';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of participant in the action. */
  _type?: Maybe<Element>;
  /** The type of participant in the action. */
  type: Scalars['code'];
  /** The role the participant should play in performing the described action. */
  role?: Maybe<CodeableConcept>;
};

/** Identifies the food, drug or other product being consumed or supplied in the activity. */
export type ActivityDefinitionproductReference_ProductReference_Union = Medication | Substance;

/** Defines specimen requirements for the action to be performed, such as required specimens for a lab test. */
export type ActivityDefinitionspecimenRequirement_SpecimenRequirement_Union = SpecimenDefinition;

/** A code or group definition that describes the intended subject of the activity being defined. */
export type ActivityDefinitionsubjectReference_SubjectReference_Union = Group;

/**
 * Base StructureDefinition for Address Type: An address expressed using postal
 * conventions (as opposed to GPS or other location definition formats).  This data
 * type may be used to convey addresses for use in delivering mail as well as for
 * visiting locations which might not be valid for mail delivery.  There are a
 * variety of postal address formats defined around the world.
 */
export type Address = {
  __typename?: 'Address';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The purpose of this address. */
  _use?: Maybe<Element>;
  /** The purpose of this address. */
  use?: Maybe<Scalars['code']>;
  /**
   * Distinguishes between physical addresses (those you can visit) and mailing
   * addresses (e.g. PO Boxes and care-of addresses). Most addresses are both.
   */
  _type?: Maybe<Element>;
  /**
   * Distinguishes between physical addresses (those you can visit) and mailing
   * addresses (e.g. PO Boxes and care-of addresses). Most addresses are both.
   */
  type?: Maybe<Scalars['code']>;
  /**
   * Specifies the entire address as it should be displayed e.g. on a postal label.
   * This may be provided instead of or as well as the specific parts.
   */
  _text?: Maybe<Element>;
  /**
   * Specifies the entire address as it should be displayed e.g. on a postal label.
   * This may be provided instead of or as well as the specific parts.
   */
  text?: Maybe<Scalars['String']>;
  /**
   * This component contains the house number, apartment number, street name,
   * street direction,  P.O. Box number, delivery hints, and similar address information.
   */
  _line?: Maybe<Element>;
  /**
   * This component contains the house number, apartment number, street name,
   * street direction,  P.O. Box number, delivery hints, and similar address information.
   */
  line?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The name of the city, town, suburb, village or other community or delivery center. */
  _city?: Maybe<Element>;
  /** The name of the city, town, suburb, village or other community or delivery center. */
  city?: Maybe<Scalars['String']>;
  /** The name of the administrative area (county). */
  _district?: Maybe<Element>;
  /** The name of the administrative area (county). */
  district?: Maybe<Scalars['String']>;
  /**
   * Sub-unit of a country with limited sovereignty in a federally organized
   * country. A code may be used if codes are in common use (e.g. US 2 letter state codes).
   */
  _state?: Maybe<Element>;
  /**
   * Sub-unit of a country with limited sovereignty in a federally organized
   * country. A code may be used if codes are in common use (e.g. US 2 letter state codes).
   */
  state?: Maybe<Scalars['String']>;
  /** A postal code designating a region defined by the postal service. */
  _postalCode?: Maybe<Element>;
  /** A postal code designating a region defined by the postal service. */
  postalCode?: Maybe<Scalars['String']>;
  /** Country - a nation as commonly understood or generally accepted. */
  _country?: Maybe<Element>;
  /** Country - a nation as commonly understood or generally accepted. */
  country?: Maybe<Scalars['String']>;
  /** Time period when address was/is in use. */
  period?: Maybe<Period>;
  /** Address Extension to add custom fields. */
  addressExtension?: Maybe<AddressExtension_Input>;
};

/** Base StructureDefinition for PractionerExtension Type: Custom Fields . */
export type AddressExtension = {
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>>>;
};

/** Base StructureDefinition for PractionerExtension Type: Custom Fields . */
export type AddressExtension_Input = {
  __typename?: 'AddressExtension_Input';
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
};

/**
 * Base StructureDefinition for Address Type: An address expressed using postal
 * conventions (as opposed to GPS or other location definition formats).  This data
 * type may be used to convey addresses for use in delivering mail as well as for
 * visiting locations which might not be valid for mail delivery.  There are a
 * variety of postal address formats defined around the world.
 */
export type Address_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The purpose of this address. */
  _use?: Maybe<Element_Input>;
  /** The purpose of this address. */
  use?: Maybe<Scalars['code']>;
  /**
   * Distinguishes between physical addresses (those you can visit) and mailing
   * addresses (e.g. PO Boxes and care-of addresses). Most addresses are both.
   */
  _type?: Maybe<Element_Input>;
  /**
   * Distinguishes between physical addresses (those you can visit) and mailing
   * addresses (e.g. PO Boxes and care-of addresses). Most addresses are both.
   */
  type?: Maybe<Scalars['code']>;
  /**
   * Specifies the entire address as it should be displayed e.g. on a postal label.
   * This may be provided instead of or as well as the specific parts.
   */
  _text?: Maybe<Element_Input>;
  /**
   * Specifies the entire address as it should be displayed e.g. on a postal label.
   * This may be provided instead of or as well as the specific parts.
   */
  text?: Maybe<Scalars['String']>;
  /**
   * This component contains the house number, apartment number, street name,
   * street direction,  P.O. Box number, delivery hints, and similar address information.
   */
  _line?: Maybe<Element_Input>;
  /**
   * This component contains the house number, apartment number, street name,
   * street direction,  P.O. Box number, delivery hints, and similar address information.
   */
  line?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The name of the city, town, suburb, village or other community or delivery center. */
  _city?: Maybe<Element_Input>;
  /** The name of the city, town, suburb, village or other community or delivery center. */
  city?: Maybe<Scalars['String']>;
  /** The name of the administrative area (county). */
  _district?: Maybe<Element_Input>;
  /** The name of the administrative area (county). */
  district?: Maybe<Scalars['String']>;
  /**
   * Sub-unit of a country with limited sovereignty in a federally organized
   * country. A code may be used if codes are in common use (e.g. US 2 letter state codes).
   */
  _state?: Maybe<Element_Input>;
  /**
   * Sub-unit of a country with limited sovereignty in a federally organized
   * country. A code may be used if codes are in common use (e.g. US 2 letter state codes).
   */
  state?: Maybe<Scalars['String']>;
  /** A postal code designating a region defined by the postal service. */
  _postalCode?: Maybe<Element_Input>;
  /** A postal code designating a region defined by the postal service. */
  postalCode?: Maybe<Scalars['String']>;
  /** Country - a nation as commonly understood or generally accepted. */
  _country?: Maybe<Element_Input>;
  /** Country - a nation as commonly understood or generally accepted. */
  country?: Maybe<Scalars['String']>;
  /** Time period when address was/is in use. */
  period?: Maybe<Period_Input>;
  /** Address Extension to add custom fields. */
  addressExtension?: Maybe<AddressExtension>;
};

export enum AdminNotification_Enum_Input {
  AdminNotification = 'AdminNotification'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type AdminNotifications = {
  __typename?: 'AdminNotifications';
  /** Type of resource */
  resourceType: AdminNotification_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  notificationMessage?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  createdOn?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  notificationUrl?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  isRead?: Maybe<Scalars['Boolean']>;
};

export enum AdminNotifications_Enum_Input {
  AdminNotification = 'AdminNotification'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type AdminNotifications_Input = {
  /** Type of resource */
  resourceType: AdminNotifications_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  adminId?: Maybe<Scalars['String']>;
  /** entityType field data. */
  notificationMessage?: Maybe<Scalars['Int']>;
  /** buildingSocietyName field data. */
  createdOn?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  isRead?: Maybe<Scalars['Boolean']>;
  /** buildingSocietyName field data. */
  isNotificationAll?: Maybe<Scalars['Boolean']>;
};

export enum AdminTaskInput_Enum_Input {
  AdminTask = 'AdminTask'
}

export enum AdminTask_Enum_Input {
  AdminTask = 'AdminTask'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type AdminTask_Input = {
  /** Type of resource */
  resourceType: AdminTaskInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  taskCount?: Maybe<Scalars['Int']>;
  /** nationalInsuranceNumber field data. */
  taskType?: Maybe<Scalars['Int']>;
  /** buildingSocietyName field data. */
  taskUrl?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  taskMessage?: Maybe<Scalars['String']>;
  /** nationalInsuranceNumber field data. */
  taskFor?: Maybe<Scalars['Int']>;
};

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type AdminTasks = {
  __typename?: 'AdminTasks';
  /** Type of resource */
  resourceType: AdminTask_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  taskCount?: Maybe<Scalars['Int']>;
  /** nationalInsuranceNumber field data. */
  taskType?: Maybe<Scalars['Int']>;
  /** buildingSocietyName field data. */
  taskUrl?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  taskMessage?: Maybe<Scalars['String']>;
  /** nationalInsuranceNumber field data. */
  taskFor?: Maybe<Scalars['Int']>;
};

/**
 * Actual or  potential/avoided event causing unintended physical injury resulting
 * from or contributed to by medical care, a research study or other healthcare
 * setting factors that requires additional monitoring, treatment, or
 * hospitalization, or that results in death.
 */
export type AdverseEvent = {
  __typename?: 'AdverseEvent';
  /** Type of resource */
  resourceType: AdverseEvent_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this adverse event by the performer or other
   * systems which remain constant as the resource is updated and propagates from
   * server to server.
   */
  identifier?: Maybe<Identifier>;
  /**
   * Whether the event actually happened, or just had the potential to. Note that
   * this is independent of whether anyone was affected or harmed or how severely.
   */
  _actuality?: Maybe<Element>;
  /**
   * Whether the event actually happened, or just had the potential to. Note that
   * this is independent of whether anyone was affected or harmed or how severely.
   */
  actuality: Scalars['code'];
  /** The overall type of event, intended for search and filtering purposes. */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** This element defines the specific type of event that occurred or that was prevented from occurring. */
  event?: Maybe<CodeableConcept>;
  /** This subject or group impacted by the event. */
  subject: AdverseEventsubject_Subject_Union;
  /** The Encounter during which AdverseEvent was created or to which the creation of this record is tightly associated. */
  encounter?: Maybe<AdverseEventencounter_Encounter_Union>;
  /** The date (and perhaps time) when the adverse event occurred. */
  _date?: Maybe<Element>;
  /** The date (and perhaps time) when the adverse event occurred. */
  date?: Maybe<Scalars['dateTime']>;
  /** Estimated or actual date the AdverseEvent began, in the opinion of the reporter. */
  _detected?: Maybe<Element>;
  /** Estimated or actual date the AdverseEvent began, in the opinion of the reporter. */
  detected?: Maybe<Scalars['dateTime']>;
  /** The date on which the existence of the AdverseEvent was first recorded. */
  _recordedDate?: Maybe<Element>;
  /** The date on which the existence of the AdverseEvent was first recorded. */
  recordedDate?: Maybe<Scalars['dateTime']>;
  /**
   * Includes information about the reaction that occurred as a result of exposure
   * to a substance (for example, a drug or a chemical).
   */
  resultingCondition?: Maybe<Array<Maybe<AdverseEventresultingCondition_ResultingCondition_Union>>>;
  /** The information about where the adverse event occurred. */
  location?: Maybe<AdverseEventlocation_Location_Union>;
  /** Assessment whether this event was of real importance. */
  seriousness?: Maybe<CodeableConcept>;
  /**
   * Describes the severity of the adverse event, in relation to the subject.
   * Contrast to AdverseEvent.seriousness - a severe rash might not be serious, but
   * a mild heart problem is.
   */
  severity?: Maybe<CodeableConcept>;
  /** Describes the type of outcome from the adverse event. */
  outcome?: Maybe<CodeableConcept>;
  /** Information on who recorded the adverse event.  May be the patient or a practitioner. */
  recorder?: Maybe<AdverseEventrecorder_Recorder_Union>;
  /**
   * Parties that may or should contribute or have contributed information to the
   * adverse event, which can consist of one or more activities.  Such information
   * includes information leading to the decision to perform the activity and how
   * to perform the activity (e.g. consultant), information that the activity
   * itself seeks to reveal (e.g. informant of clinical history), or information
   * about what activity was performed (e.g. informant witness).
   */
  contributor?: Maybe<Array<Maybe<AdverseEventcontributor_Contributor_Union>>>;
  /** Describes the entity that is suspected to have caused the adverse event. */
  suspectEntity?: Maybe<Array<Maybe<AdverseEventsuspectEntity>>>;
  /** AdverseEvent.subjectMedicalHistory. */
  subjectMedicalHistory?: Maybe<Array<Maybe<AdverseEventsubjectMedicalHistory_SubjectMedicalHistory_Union>>>;
  /** AdverseEvent.referenceDocument. */
  referenceDocument?: Maybe<Array<Maybe<AdverseEventreferenceDocument_ReferenceDocument_Union>>>;
  /** AdverseEvent.study. */
  study?: Maybe<Array<Maybe<AdverseEventstudy_Study_Union>>>;
};

export enum AdverseEvent_Enum_Schema {
  AdverseEvent = 'AdverseEvent'
}

/**
 * Parties that may or should contribute or have contributed information to the
 * adverse event, which can consist of one or more activities.  Such information
 * includes information leading to the decision to perform the activity and how to
 * perform the activity (e.g. consultant), information that the activity itself
 * seeks to reveal (e.g. informant of clinical history), or information about what
 * activity was performed (e.g. informant witness).
 */
export type AdverseEventcontributor_Contributor_Union = Practitioner | PractitionerRole | Device;

/** The Encounter during which AdverseEvent was created or to which the creation of this record is tightly associated. */
export type AdverseEventencounter_Encounter_Union = Encounter;

/** The information about where the adverse event occurred. */
export type AdverseEventlocation_Location_Union = Location;

/** Information on who recorded the adverse event.  May be the patient or a practitioner. */
export type AdverseEventrecorder_Recorder_Union = Patient | Practitioner | PractitionerRole | RelatedPerson;

/** AdverseEvent.referenceDocument. */
export type AdverseEventreferenceDocument_ReferenceDocument_Union = DocumentReference;

/**
 * Includes information about the reaction that occurred as a result of exposure to
 * a substance (for example, a drug or a chemical).
 */
export type AdverseEventresultingCondition_ResultingCondition_Union = Condition;

/** AdverseEvent.study. */
export type AdverseEventstudy_Study_Union = ResearchStudy;

/** AdverseEvent.subjectMedicalHistory. */
export type AdverseEventsubjectMedicalHistory_SubjectMedicalHistory_Union = Condition | Observation | AllergyIntolerance | FamilyMemberHistory | Immunization | Procedure | Media | DocumentReference;

/** This subject or group impacted by the event. */
export type AdverseEventsubject_Subject_Union = Patient | Group | Practitioner | RelatedPerson;

export type AdverseEventsuspectEntity = {
  __typename?: 'AdverseEventsuspectEntity';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Identifies the actual instance of what caused the adverse event.  May be a
   * substance, medication, medication administration, medication statement or a device.
   */
  instance: AdverseEventsuspectEntityinstance_Instance_Union;
  /** Information on the possible cause of the event. */
  causality?: Maybe<Array<Maybe<AdverseEventsuspectEntitycausality>>>;
};

export type AdverseEventsuspectEntitycausality = {
  __typename?: 'AdverseEventsuspectEntitycausality';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Assessment of if the entity caused the event. */
  assessment?: Maybe<CodeableConcept>;
  /** AdverseEvent.suspectEntity.causalityProductRelatedness. */
  _productRelatedness?: Maybe<Element>;
  /** AdverseEvent.suspectEntity.causalityProductRelatedness. */
  productRelatedness?: Maybe<Scalars['String']>;
  /** AdverseEvent.suspectEntity.causalityAuthor. */
  author?: Maybe<AdverseEventsuspectEntitycausalityauthor_Author_Union>;
  /** ProbabilityScale | Bayesian | Checklist. */
  method?: Maybe<CodeableConcept>;
};

/** AdverseEvent.suspectEntity.causalityAuthor. */
export type AdverseEventsuspectEntitycausalityauthor_Author_Union = Practitioner | PractitionerRole;

/**
 * Identifies the actual instance of what caused the adverse event.  May be a
 * substance, medication, medication administration, medication statement or a device.
 */
export type AdverseEventsuspectEntityinstance_Instance_Union = Immunization | Procedure | Substance | Medication | MedicationAdministration | MedicationStatement | Device;

/** Base StructureDefinition for Age Type: A duration of time during which an organism (or a process) has existed. */
export type Age = {
  __typename?: 'Age';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  _value?: Maybe<Element>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  value?: Maybe<Scalars['Float']>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  _comparator?: Maybe<Element>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  comparator?: Maybe<Scalars['code']>;
  /** A human-readable form of the unit. */
  _unit?: Maybe<Element>;
  /** A human-readable form of the unit. */
  unit?: Maybe<Scalars['String']>;
  /** The identification of the system that provides the coded form of the unit. */
  _system?: Maybe<Element>;
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars['uri']>;
  /** A computer processable form of the unit in some unit representation system. */
  _code?: Maybe<Element>;
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars['code']>;
};

/** Base StructureDefinition for Age Type: A duration of time during which an organism (or a process) has existed. */
export type Age_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  _value?: Maybe<Element_Input>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  value?: Maybe<Scalars['Float']>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  _comparator?: Maybe<Element_Input>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  comparator?: Maybe<Scalars['code']>;
  /** A human-readable form of the unit. */
  _unit?: Maybe<Element_Input>;
  /** A human-readable form of the unit. */
  unit?: Maybe<Scalars['String']>;
  /** The identification of the system that provides the coded form of the unit. */
  _system?: Maybe<Element_Input>;
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars['uri']>;
  /** A computer processable form of the unit in some unit representation system. */
  _code?: Maybe<Element_Input>;
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars['code']>;
};

/** Query for get all admin list */
export type All_Admin_List = {
  __typename?: 'All_Admin_List';
  /** phoneNumber. */
  phoneNumber?: Maybe<Scalars['String']>;
};

/**
 * Risk of harmful or undesirable, physiological response which is unique to an
 * individual and associated with exposure to a substance.
 */
export type AllergyIntolerance = {
  __typename?: 'AllergyIntolerance';
  /** Type of resource */
  resourceType: AllergyIntolerance_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this AllergyIntolerance by the performer or
   * other systems which remain constant as the resource is updated and propagates
   * from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The clinical status of the allergy or intolerance. */
  clinicalStatus?: Maybe<CodeableConcept>;
  /**
   * Assertion about certainty associated with the propensity, or potential risk,
   * of a reaction to the identified substance (including pharmaceutical product).
   */
  verificationStatus?: Maybe<CodeableConcept>;
  /** Identification of the underlying physiological mechanism for the reaction risk. */
  _type?: Maybe<Element>;
  /** Identification of the underlying physiological mechanism for the reaction risk. */
  type?: Maybe<Scalars['code']>;
  /** Category of the identified substance. */
  _category?: Maybe<Element>;
  /** Category of the identified substance. */
  category?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** Estimate of the potential clinical harm, or seriousness, of the reaction to the identified substance. */
  _criticality?: Maybe<Element>;
  /** Estimate of the potential clinical harm, or seriousness, of the reaction to the identified substance. */
  criticality?: Maybe<Scalars['code']>;
  /**
   * Code for an allergy or intolerance statement (either a positive or a
   * negated/excluded statement).  This may be a code for a substance or
   * pharmaceutical product that is considered to be responsible for the adverse
   * reaction risk (e.g., 'Latex'), an allergy or intolerance condition (e.g.,
   * 'Latex allergy'), or a negated/excluded code for a specific substance or class
   * (e.g., 'No latex allergy') or a general or categorical negated statement
   * (e.g.,  'No known allergy', 'No known drug allergies').  Note: the substance
   * for a specific reaction may be different from the substance identified as the
   * cause of the risk, but it must be consistent with it. For instance, it may be
   * a more specific substance (e.g. a brand medication) or a composite product
   * that includes the identified substance. It must be clinically safe to only
   * process the 'code' and ignore the 'reaction.substance'.  If a receiving system
   * is unable to confirm that AllergyIntolerance.reaction.substance falls within
   * the semantic scope of AllergyIntolerance.code, then the receiving system
   * should ignore AllergyIntolerance.reaction.substance.
   */
  code?: Maybe<CodeableConcept>;
  /** The patient who has the allergy or intolerance. */
  patient: AllergyIntolerancepatient_Patient_Union;
  /** The encounter when the allergy or intolerance was asserted. */
  encounter?: Maybe<AllergyIntoleranceencounter_Encounter_Union>;
  /** Estimated or actual date,  date-time, or age when allergy or intolerance was identified. */
  _onsetDateTime?: Maybe<Element>;
  /** Estimated or actual date,  date-time, or age when allergy or intolerance was identified. */
  onsetDateTime?: Maybe<Scalars['dateTime']>;
  /** Estimated or actual date,  date-time, or age when allergy or intolerance was identified. */
  onsetAge?: Maybe<Age>;
  /** Estimated or actual date,  date-time, or age when allergy or intolerance was identified. */
  onsetPeriod?: Maybe<Period>;
  /** Estimated or actual date,  date-time, or age when allergy or intolerance was identified. */
  onsetRange?: Maybe<Range>;
  /** Estimated or actual date,  date-time, or age when allergy or intolerance was identified. */
  _onsetString?: Maybe<Element>;
  /** Estimated or actual date,  date-time, or age when allergy or intolerance was identified. */
  onsetString?: Maybe<Scalars['String']>;
  /**
   * The recordedDate represents when this particular AllergyIntolerance record was
   * created in the system, which is often a system-generated date.
   */
  _recordedDate?: Maybe<Element>;
  /**
   * The recordedDate represents when this particular AllergyIntolerance record was
   * created in the system, which is often a system-generated date.
   */
  recordedDate?: Maybe<Scalars['dateTime']>;
  /** Individual who recorded the record and takes responsibility for its content. */
  recorder?: Maybe<AllergyIntolerancerecorder_Recorder_Union>;
  /** The source of the information about the allergy that is recorded. */
  asserter?: Maybe<AllergyIntoleranceasserter_Asserter_Union>;
  /** Represents the date and/or time of the last known occurrence of a reaction event. */
  _lastOccurrence?: Maybe<Element>;
  /** Represents the date and/or time of the last known occurrence of a reaction event. */
  lastOccurrence?: Maybe<Scalars['dateTime']>;
  /** Additional narrative about the propensity for the Adverse Reaction, not captured in other fields. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Details about each adverse reaction event linked to exposure to the identified substance. */
  reaction?: Maybe<Array<Maybe<AllergyIntolerancereaction>>>;
};

export enum AllergyIntolerance_Enum_Schema {
  AllergyIntolerance = 'AllergyIntolerance'
}

/** The source of the information about the allergy that is recorded. */
export type AllergyIntoleranceasserter_Asserter_Union = Patient | RelatedPerson | Practitioner | PractitionerRole;

/** The encounter when the allergy or intolerance was asserted. */
export type AllergyIntoleranceencounter_Encounter_Union = Encounter;

/** The patient who has the allergy or intolerance. */
export type AllergyIntolerancepatient_Patient_Union = Patient;

export type AllergyIntolerancereaction = {
  __typename?: 'AllergyIntolerancereaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Identification of the specific substance (or pharmaceutical product)
   * considered to be responsible for the Adverse Reaction event. Note: the
   * substance for a specific reaction may be different from the substance
   * identified as the cause of the risk, but it must be consistent with it. For
   * instance, it may be a more specific substance (e.g. a brand medication) or a
   * composite product that includes the identified substance. It must be
   * clinically safe to only process the 'code' and ignore the
   * 'reaction.substance'.  If a receiving system is unable to confirm that
   * AllergyIntolerance.reaction.substance falls within the semantic scope of
   * AllergyIntolerance.code, then the receiving system should ignore
   * AllergyIntolerance.reaction.substance.
   */
  substance?: Maybe<CodeableConcept>;
  /** Clinical symptoms and/or signs that are observed or associated with the adverse reaction event. */
  manifestation?: Maybe<Array<CodeableConcept>>;
  /** Text description about the reaction as a whole, including details of the manifestation if required. */
  _description?: Maybe<Element>;
  /** Text description about the reaction as a whole, including details of the manifestation if required. */
  description?: Maybe<Scalars['String']>;
  /** Record of the date and/or time of the onset of the Reaction. */
  _onset?: Maybe<Element>;
  /** Record of the date and/or time of the onset of the Reaction. */
  onset?: Maybe<Scalars['dateTime']>;
  /**
   * Clinical assessment of the severity of the reaction event as a whole,
   * potentially considering multiple different manifestations.
   */
  _severity?: Maybe<Element>;
  /**
   * Clinical assessment of the severity of the reaction event as a whole,
   * potentially considering multiple different manifestations.
   */
  severity?: Maybe<Scalars['code']>;
  /** Identification of the route by which the subject was exposed to the substance. */
  exposureRoute?: Maybe<CodeableConcept>;
  /** Additional text about the adverse reaction event not captured in other fields. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

/** Individual who recorded the record and takes responsibility for its content. */
export type AllergyIntolerancerecorder_Recorder_Union = Practitioner | PractitionerRole | Patient | RelatedPerson;

/**
 * Base StructureDefinition for Annotation Type: A  text note which also  contains
 * information about who made the statement and when.
 */
export type Annotation = {
  __typename?: 'Annotation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The individual responsible for making the annotation. */
  authorReference?: Maybe<AnnotationauthorReference_AuthorReference_Union>;
  /** The individual responsible for making the annotation. */
  _authorString?: Maybe<Element>;
  /** The individual responsible for making the annotation. */
  authorString?: Maybe<Scalars['String']>;
  /** Indicates when this particular annotation was made. */
  _time?: Maybe<Element>;
  /** Indicates when this particular annotation was made. */
  time?: Maybe<Scalars['dateTime']>;
  /** The text of the annotation in markdown format. */
  _text?: Maybe<Element>;
  /** The text of the annotation in markdown format. */
  text: Scalars['String'];
};

/**
 * Base StructureDefinition for Annotation Type: A  text note which also  contains
 * information about who made the statement and when.
 */
export type Annotation_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The individual responsible for making the annotation. */
  authorReference?: Maybe<Scalars['String']>;
  /** The individual responsible for making the annotation. */
  _authorString?: Maybe<Element_Input>;
  /** The individual responsible for making the annotation. */
  authorString?: Maybe<Scalars['String']>;
  /** Indicates when this particular annotation was made. */
  _time?: Maybe<Element_Input>;
  /** Indicates when this particular annotation was made. */
  time?: Maybe<Scalars['dateTime']>;
  /** The text of the annotation in markdown format. */
  _text?: Maybe<Element_Input>;
  /** The text of the annotation in markdown format. */
  text: Scalars['String'];
};

/** The individual responsible for making the annotation. */
export type AnnotationauthorReference_AuthorReference_Union = Practitioner | Patient | RelatedPerson | Organization;

/**
 * A booking of a healthcare event among patient(s), practitioner(s), related
 * person(s) and/or device(s) for a specific date/time. This may result in one or
 * more Encounter(s).
 */
export type Appointment = {
  __typename?: 'Appointment';
  /** Type of resource */
  resourceType: Appointment_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * This records identifiers associated with this appointment concern that are
   * defined by business processes and/or used to refer to it when a direct URL
   * reference to the resource itself is not appropriate (e.g. in CDA documents, or
   * in written / printed documentation).
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The overall status of the Appointment. Each of the participants has their own
   * participation status which indicates their involvement in the process, however
   * this status indicates the shared status.
   */
  _status?: Maybe<Element>;
  /**
   * The overall status of the Appointment. Each of the participants has their own
   * participation status which indicates their involvement in the process, however
   * this status indicates the shared status.
   */
  status: Scalars['code'];
  /**
   * The coded reason for the appointment being cancelled. This is often used in
   * reporting/billing/futher processing to determine if further actions are
   * required, or specific fees apply.
   */
  cancelationReason?: Maybe<CodeableConcept>;
  /** A broad categorization of the service that is to be performed during this appointment. */
  serviceCategory?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The specific service that is to be performed during this appointment. */
  serviceType?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The specialty of a practitioner that would be required to perform the service requested in this appointment. */
  specialty?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The style of appointment or patient that has been booked in the slot (not service type). */
  appointmentType?: Maybe<CodeableConcept>;
  /** The coded reason that this appointment is being scheduled. This is more clinical than administrative. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Reason the appointment has been scheduled to take place, as specified using
   * information from another resource. When the patient arrives and the encounter
   * begins it may be used as the admission diagnosis. The indication will
   * typically be a Condition (with other resources referenced in the
   * evidence.detail), or a Procedure.
   */
  reasonReference?: Maybe<Array<Maybe<AppointmentreasonReference_ReasonReference_Union>>>;
  /**
   * The priority of the appointment. Can be used to make informed decisions if
   * needing to re-prioritize appointments. (The iCal Standard specifies 0 as
   * undefined, 1 as highest, 9 as lowest priority).
   */
  _priority?: Maybe<Element>;
  /**
   * The priority of the appointment. Can be used to make informed decisions if
   * needing to re-prioritize appointments. (The iCal Standard specifies 0 as
   * undefined, 1 as highest, 9 as lowest priority).
   */
  priority?: Maybe<Scalars['unsignedInt']>;
  /**
   * The brief description of the appointment as would be shown on a subject line
   * in a meeting request, or appointment list. Detailed or expanded information
   * should be put in the comment field.
   */
  _description?: Maybe<Element>;
  /**
   * The brief description of the appointment as would be shown on a subject line
   * in a meeting request, or appointment list. Detailed or expanded information
   * should be put in the comment field.
   */
  description?: Maybe<Scalars['String']>;
  /** Additional information to support the appointment provided when making the appointment. */
  supportingInformation?: Maybe<Array<Maybe<AppointmentsupportingInformation_SupportingInformation_Union>>>;
  /** Date/Time that the appointment is to take place. */
  _start?: Maybe<Element>;
  /** Date/Time that the appointment is to take place. */
  start?: Maybe<Scalars['instant']>;
  /** Date/Time that the appointment is to conclude. */
  _end?: Maybe<Element>;
  /** Date/Time that the appointment is to conclude. */
  end?: Maybe<Scalars['instant']>;
  /**
   * Number of minutes that the appointment is to take. This can be less than the
   * duration between the start and end times.  For example, where the actual time
   * of appointment is only an estimate or if a 30 minute appointment is being
   * requested, but any time would work.  Also, if there is, for example, a planned
   * 15 minute break in the middle of a long appointment, the duration may be 15
   * minutes less than the difference between the start and end.
   */
  _minutesDuration?: Maybe<Element>;
  /**
   * Number of minutes that the appointment is to take. This can be less than the
   * duration between the start and end times.  For example, where the actual time
   * of appointment is only an estimate or if a 30 minute appointment is being
   * requested, but any time would work.  Also, if there is, for example, a planned
   * 15 minute break in the middle of a long appointment, the duration may be 15
   * minutes less than the difference between the start and end.
   */
  minutesDuration?: Maybe<Scalars['positiveInt']>;
  /** The slots from the participants' schedules that will be filled by the appointment. */
  slot?: Maybe<Array<Maybe<Appointmentslot_Slot_Union>>>;
  /**
   * The date that this appointment was initially created. This could be different
   * to the meta.lastModified value on the initial entry, as this could have been
   * before the resource was created on the FHIR server, and should remain
   * unchanged over the lifespan of the appointment.
   */
  _created?: Maybe<Element>;
  /**
   * The date that this appointment was initially created. This could be different
   * to the meta.lastModified value on the initial entry, as this could have been
   * before the resource was created on the FHIR server, and should remain
   * unchanged over the lifespan of the appointment.
   */
  created?: Maybe<Scalars['dateTime']>;
  /** Additional comments about the appointment. */
  _comment?: Maybe<Element>;
  /** Additional comments about the appointment. */
  comment?: Maybe<Scalars['String']>;
  /**
   * While Appointment.comment contains information for internal use,
   * Appointment.patientInstructions is used to capture patient facing information
   * about the Appointment (e.g. please bring your referral or fast from 8pm night before).
   */
  _patientInstruction?: Maybe<Element>;
  /**
   * While Appointment.comment contains information for internal use,
   * Appointment.patientInstructions is used to capture patient facing information
   * about the Appointment (e.g. please bring your referral or fast from 8pm night before).
   */
  patientInstruction?: Maybe<Scalars['String']>;
  /** The service request this appointment is allocated to assess (e.g. incoming referral or procedure request). */
  basedOn?: Maybe<Array<Maybe<AppointmentbasedOn_BasedOn_Union>>>;
  /** List of participants involved in the appointment. */
  participant?: Maybe<Array<Appointmentparticipant>>;
  /**
   * A set of date ranges (potentially including times) that the appointment is
   * preferred to be scheduled within.  The duration (usually in minutes) could
   * also be provided to indicate the length of the appointment to fill and
   * populate the start/end times for the actual allocated time. However, in other
   * situations the duration may be calculated by the scheduling system.
   */
  requestedPeriod?: Maybe<Array<Maybe<Period>>>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type AppointmentCancellationPricing_Input = {
  /** operationType field data. */
  cancellationFromDays?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancellationToDays?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancellationAmount?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  cancellationPriceType?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type AppointmentCancellationPricing_Schema = {
  __typename?: 'AppointmentCancellationPricing_Schema';
  /** operationType field data. */
  cancellationFromDays?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancellationToDays?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancellationPriceType?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancellationAmount?: Maybe<Scalars['Float']>;
};

/** Base StructureDefinition for Appointment Extension Input */
export type AppointmentExtension_Input = {
  /** installmentDate field data. */
  installmentDate?: Maybe<Scalars['String']>;
  /** installmentAmount field data. */
  installmentAmount?: Maybe<Scalars['String']>;
  /** appointmentDate field data. */
  appointmentDate?: Maybe<Scalars['String']>;
  /** slotId field data. */
  slotId?: Maybe<Scalars['String']>;
  /** appointmentDate field data. */
  appointmentTime?: Maybe<Scalars['String']>;
  /** installmentPaidStatus field data. */
  installmentPaidStatus?: Maybe<Scalars['Int']>;
  /** installmentPaidOn field data. */
  installmentPaidOn?: Maybe<Scalars['String']>;
  /** selfPayTransactionId field data. */
  selfPayTransactionId?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointmentMode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** appointmentDuration. */
  appointmentDuration?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  discountType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  discountValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  commissionType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  commissionValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  appointmentOriginalPrice?: Maybe<Scalars['Float']>;
};

/** Base StructureDefinition for AppointmentExtension: Custom Fields . */
export type AppointmentExtension_Schema = {
  __typename?: 'AppointmentExtension_Schema';
  /** installmentDate field data. */
  installmentDate?: Maybe<Scalars['String']>;
  /** installmentAmount field data. */
  installmentAmount?: Maybe<Scalars['String']>;
  /** appointmentDate field data. */
  appointmentDate?: Maybe<Scalars['String']>;
  /** slotId field data. */
  slotId?: Maybe<Scalars['String']>;
  /** appointmentDate field data. */
  appointmentTime?: Maybe<Scalars['String']>;
  /** installmentPaidStatus field data. */
  installmentPaidStatus?: Maybe<Scalars['Int']>;
  /** installmentPaidOn field data. */
  installmentPaidOn?: Maybe<Scalars['String']>;
  /** selfPayTransactionId field data. */
  selfPayTransactionId?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointmentMode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** appointmentDuration. */
  appointmentDuration?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  discountType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  discountValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  commissionType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  commissionValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  appointmentOriginalPrice?: Maybe<Scalars['Float']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type AppointmentOccupationalPricing_Input = {
  /** operationType field data. */
  occupationalHealthPrice?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  occupationalHealthSharePercentage?: Maybe<Scalars['Float']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type AppointmentOccupationalPricing_Schema = {
  __typename?: 'AppointmentOccupationalPricing_Schema';
  /** operationType field data. */
  occupationalHealthPrice?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  occupationalHealthSharePercentage?: Maybe<Scalars['Float']>;
};

/** A reply to an appointment request for a patient and/or practitioner(s), such as a confirmation or rejection. */
export type AppointmentResponse = {
  __typename?: 'AppointmentResponse';
  /** Type of resource */
  resourceType: AppointmentResponse_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * This records identifiers associated with this appointment response concern
   * that are defined by business processes and/ or used to refer to it when a
   * direct URL reference to the resource itself is not appropriate.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Appointment that this response is replying to. */
  appointment: AppointmentResponseappointment_Appointment_Union;
  /** Date/Time that the appointment is to take place, or requested new start time. */
  _start?: Maybe<Element>;
  /** Date/Time that the appointment is to take place, or requested new start time. */
  start?: Maybe<Scalars['instant']>;
  /**
   * This may be either the same as the appointment request to confirm the details
   * of the appointment, or alternately a new time to request a re-negotiation of the end time.
   */
  _end?: Maybe<Element>;
  /**
   * This may be either the same as the appointment request to confirm the details
   * of the appointment, or alternately a new time to request a re-negotiation of the end time.
   */
  end?: Maybe<Scalars['instant']>;
  /** Role of participant in the appointment. */
  participantType?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A Person, Location, HealthcareService, or Device that is participating in the appointment. */
  actor?: Maybe<AppointmentResponseactor_Actor_Union>;
  /**
   * Participation status of the participant. When the status is declined or
   * tentative if the start/end times are different to the appointment, then these
   * times should be interpreted as a requested time change. When the status is
   * accepted, the times can either be the time of the appointment (as a
   * confirmation of the time) or can be empty.
   */
  _participantStatus?: Maybe<Element>;
  /**
   * Participation status of the participant. When the status is declined or
   * tentative if the start/end times are different to the appointment, then these
   * times should be interpreted as a requested time change. When the status is
   * accepted, the times can either be the time of the appointment (as a
   * confirmation of the time) or can be empty.
   */
  participantStatus: Scalars['code'];
  /** Additional comments about the appointment. */
  _comment?: Maybe<Element>;
  /** Additional comments about the appointment. */
  comment?: Maybe<Scalars['String']>;
};

export enum AppointmentResponse_Enum_Schema {
  AppointmentResponse = 'AppointmentResponse'
}

/** A Person, Location, HealthcareService, or Device that is participating in the appointment. */
export type AppointmentResponseactor_Actor_Union = Patient | Practitioner | PractitionerRole | RelatedPerson | Device | HealthcareService | Location;

/** Appointment that this response is replying to. */
export type AppointmentResponseappointment_Appointment_Union = Appointment;

export enum AppointmentTypeMaster_Enum_Input {
  AppointmentTypeMaster = 'AppointmentTypeMaster'
}

export enum AppointmentTypeMaster_Enum_Schema {
  AppointmentTypeMaster = 'AppointmentTypeMaster'
}

/** AppointmentTypeMaster */
export type AppointmentTypeMaster_Input = {
  /** Type of resource */
  resourceType: AppointmentTypeMaster_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  professionalTypeRelation?: Maybe<Array<Maybe<ProfessionalTypeRelation_Input>>>;
  /** name. */
  name?: Maybe<Scalars['String']>;
  /** status. */
  status?: Maybe<Scalars['Boolean']>;
};

/** AppointmentTypeMaster */
export type AppointmentTypeMaster_Schema = {
  __typename?: 'AppointmentTypeMaster_Schema';
  /** Type of resource */
  resourceType: AppointmentTypeMaster_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  /** Referral_Type. */
  name?: Maybe<Scalars['String']>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  professionalTypeRelation?: Maybe<Array<Maybe<ProfessionalTypeRelation_Schema>>>;
  /** status. */
  status?: Maybe<Scalars['Boolean']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type AppointmentTypePricing_Input = {
  /** operationType field data. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointment Description field data. */
  appointmentDescription?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentTypeName?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentAgeFrom?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentAgeTo?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentName?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentDuration?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentPrice?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentf2fPrice?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentDiscountType?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentDiscountValue?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentVAT?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentCommission?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentCommissionType?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentOnlineAvailable?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentf2fAvailable?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type AppointmentTypePricing_Schema = {
  __typename?: 'AppointmentTypePricing_Schema';
  /** operationType field data. */
  appointmentType?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentDescription?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentTypeName?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentAgeFrom?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentAgeTo?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentName?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentDuration?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentPrice?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentf2fPrice?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentDiscountType?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentDiscountValue?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentVAT?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentCommission?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentCommissionType?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentOnlineAvailable?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentf2fAvailable?: Maybe<Scalars['Int']>;
  /** appointmentTypeId field data. */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** professionalId field data. */
  professionalId?: Maybe<Scalars['String']>;
};

export enum Appointment_Enum_Schema {
  Appointment = 'Appointment'
}

/** The service request this appointment is allocated to assess (e.g. incoming referral or procedure request). */
export type AppointmentbasedOn_BasedOn_Union = ServiceRequest;

export type Appointmentparticipant = {
  __typename?: 'Appointmentparticipant';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Role of participant in the appointment. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A Person, Location/HealthcareService or Device that is participating in the appointment. */
  actor?: Maybe<Appointmentparticipantactor_Actor_Union>;
  /**
   * Whether this participant is required to be present at the meeting. This covers
   * a use-case where two doctors need to meet to discuss the results for a
   * specific patient, and the patient is not required to be present.
   */
  _required?: Maybe<Element>;
  /**
   * Whether this participant is required to be present at the meeting. This covers
   * a use-case where two doctors need to meet to discuss the results for a
   * specific patient, and the patient is not required to be present.
   */
  required?: Maybe<Scalars['code']>;
  /** Participation status of the actor. */
  _status?: Maybe<Element>;
  /** Participation status of the actor. */
  status: Scalars['code'];
  /** Participation period of the actor. */
  period?: Maybe<Period>;
};

/** A Person, Location/HealthcareService or Device that is participating in the appointment. */
export type Appointmentparticipantactor_Actor_Union = Patient | Practitioner | PractitionerRole | RelatedPerson | Device | HealthcareService | Location;

/**
 * Reason the appointment has been scheduled to take place, as specified using
 * information from another resource. When the patient arrives and the encounter
 * begins it may be used as the admission diagnosis. The indication will typically
 * be a Condition (with other resources referenced in the evidence.detail), or a Procedure.
 */
export type AppointmentreasonReference_ReasonReference_Union = Condition | Procedure | Observation | ImmunizationRecommendation;

/** The slots from the participants' schedules that will be filled by the appointment. */
export type Appointmentslot_Slot_Union = Slot;

/** Additional information to support the appointment provided when making the appointment. */
export type AppointmentsupportingInformation_SupportingInformation_Union = Resource;

/** Base StructureDefinition for Attachment Type: For referring to data content defined in other formats. */
export type Attachment = {
  __typename?: 'Attachment';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Identifies the type of the data in the attachment and allows a method to be
   * chosen to interpret or render the data. Includes mime type parameters such as
   * charset where appropriate.
   */
  _contentType?: Maybe<Element>;
  /**
   * Identifies the type of the data in the attachment and allows a method to be
   * chosen to interpret or render the data. Includes mime type parameters such as
   * charset where appropriate.
   */
  contentType?: Maybe<Scalars['code']>;
  /** documentType */
  documentType?: Maybe<Scalars['code']>;
  /** The human language of the content. The value can be any valid value according to BCP 47. */
  _language?: Maybe<Element>;
  /** The human language of the content. The value can be any valid value according to BCP 47. */
  language?: Maybe<Scalars['code']>;
  /** The actual data of the attachment - a sequence of bytes, base64 encoded. */
  _data?: Maybe<Element>;
  /** The actual data of the attachment - a sequence of bytes, base64 encoded. */
  data?: Maybe<Scalars['base64Binary']>;
  /** A location where the data can be accessed. */
  _url?: Maybe<Element>;
  /** A location where the data can be accessed. */
  url?: Maybe<Scalars['url']>;
  /** The number of bytes of data that make up this attachment (before base64 encoding, if that is done). */
  _size?: Maybe<Element>;
  /** The number of bytes of data that make up this attachment (before base64 encoding, if that is done). */
  size?: Maybe<Scalars['unsignedInt']>;
  /** The calculated hash of the data using SHA-1. Represented using base64. */
  _hash?: Maybe<Element>;
  /** The calculated hash of the data using SHA-1. Represented using base64. */
  hash?: Maybe<Scalars['base64Binary']>;
  /** A label or set of text to display in place of the data. */
  _title?: Maybe<Element>;
  /** A label or set of text to display in place of the data. */
  title?: Maybe<Scalars['String']>;
  /** The date that the attachment was first created. */
  _creation?: Maybe<Element>;
  /** The date that the attachment was first created. */
  creation?: Maybe<Scalars['dateTime']>;
};

/** Base StructureDefinition for Attachment Type: For referring to data content defined in other formats. */
export type Attachment_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * Identifies the type of the data in the attachment and allows a method to be
   * chosen to interpret or render the data. Includes mime type parameters such as
   * charset where appropriate.
   */
  _contentType?: Maybe<Element_Input>;
  /** documentType */
  documentType?: Maybe<Scalars['code']>;
  /**
   * Identifies the type of the data in the attachment and allows a method to be
   * chosen to interpret or render the data. Includes mime type parameters such as
   * charset where appropriate.
   */
  contentType?: Maybe<Scalars['code']>;
  /** The human language of the content. The value can be any valid value according to BCP 47. */
  _language?: Maybe<Element_Input>;
  /** The human language of the content. The value can be any valid value according to BCP 47. */
  language?: Maybe<Scalars['code']>;
  /** The actual data of the attachment - a sequence of bytes, base64 encoded. */
  _data?: Maybe<Element_Input>;
  /** The actual data of the attachment - a sequence of bytes, base64 encoded. */
  data?: Maybe<Scalars['base64Binary']>;
  /** A location where the data can be accessed. */
  _url?: Maybe<Element_Input>;
  /** A location where the data can be accessed. */
  url?: Maybe<Scalars['url']>;
  /** The number of bytes of data that make up this attachment (before base64 encoding, if that is done). */
  _size?: Maybe<Element_Input>;
  /** The number of bytes of data that make up this attachment (before base64 encoding, if that is done). */
  size?: Maybe<Scalars['unsignedInt']>;
  /** The calculated hash of the data using SHA-1. Represented using base64. */
  _hash?: Maybe<Element_Input>;
  /** The calculated hash of the data using SHA-1. Represented using base64. */
  hash?: Maybe<Scalars['base64Binary']>;
  /** A label or set of text to display in place of the data. */
  _title?: Maybe<Element_Input>;
  /** A label or set of text to display in place of the data. */
  title?: Maybe<Scalars['String']>;
  /** The date that the attachment was first created. */
  _creation?: Maybe<Element_Input>;
  /** The date that the attachment was first created. */
  creation?: Maybe<Scalars['dateTime']>;
};

/**
 * A record of an event made for purposes of maintaining a security log. Typical
 * uses include detection of intrusion attempts and monitoring for inappropriate usage.
 */
export type AuditEvent = {
  __typename?: 'AuditEvent';
  /** Type of resource */
  resourceType: AuditEvent_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Identifier for a family of the event.  For example, a menu item, program,
   * rule, policy, function code, application name or URL. It identifies the
   * performed function.
   */
  type: Coding;
  /** Identifier for the category of event. */
  subtype?: Maybe<Array<Maybe<Coding>>>;
  /** Indicator for type of action performed during the event that generated the audit. */
  _action?: Maybe<Element>;
  /** Indicator for type of action performed during the event that generated the audit. */
  action?: Maybe<Scalars['code']>;
  /** The period during which the activity occurred. */
  period?: Maybe<Period>;
  /** The time when the event was recorded. */
  _recorded?: Maybe<Element>;
  /** The time when the event was recorded. */
  recorded: Scalars['instant'];
  /** Indicates whether the event succeeded or failed. */
  _outcome?: Maybe<Element>;
  /** Indicates whether the event succeeded or failed. */
  outcome?: Maybe<Scalars['code']>;
  /** A free text description of the outcome of the event. */
  _outcomeDesc?: Maybe<Element>;
  /** A free text description of the outcome of the event. */
  outcomeDesc?: Maybe<Scalars['String']>;
  /** The purposeOfUse (reason) that was used during the event being recorded. */
  purposeOfEvent?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An actor taking an active role in the event or activity that is logged. */
  agent?: Maybe<Array<AuditEventagent>>;
  /** The system that is reporting the event. */
  source: AuditEventsource;
  /** Specific instances of data or objects that have been accessed. */
  entity?: Maybe<Array<Maybe<AuditEvententity>>>;
};

export enum AuditEvent_Enum_Schema {
  AuditEvent = 'AuditEvent'
}

export type AuditEventagent = {
  __typename?: 'AuditEventagent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Specification of the participation type the user plays when performing the event. */
  type?: Maybe<CodeableConcept>;
  /**
   * The security role that the user was acting under, that come from local codes
   * defined by the access control security system (e.g. RBAC, ABAC) used in the local context.
   */
  role?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Reference to who this agent is that was involved in the event. */
  who?: Maybe<AuditEventagentwho_Who_Union>;
  /**
   * Alternative agent Identifier. For a human, this should be a user identifier
   * text string from authentication system. This identifier would be one known to
   * a common authentication system (e.g. single sign-on), if available.
   */
  _altId?: Maybe<Element>;
  /**
   * Alternative agent Identifier. For a human, this should be a user identifier
   * text string from authentication system. This identifier would be one known to
   * a common authentication system (e.g. single sign-on), if available.
   */
  altId?: Maybe<Scalars['String']>;
  /** Human-meaningful name for the agent. */
  _name?: Maybe<Element>;
  /** Human-meaningful name for the agent. */
  name?: Maybe<Scalars['String']>;
  /** Indicator that the user is or is not the requestor, or initiator, for the event being audited. */
  _requestor?: Maybe<Element>;
  /** Indicator that the user is or is not the requestor, or initiator, for the event being audited. */
  requestor: Scalars['Boolean'];
  /** Where the event occurred. */
  location?: Maybe<AuditEventagentlocation_Location_Union>;
  /**
   * The policy or plan that authorized the activity being recorded. Typically, a
   * single activity may have multiple applicable policies, such as patient
   * consent, guarantor funding, etc. The policy would also indicate the security token used.
   */
  _policy?: Maybe<Element>;
  /**
   * The policy or plan that authorized the activity being recorded. Typically, a
   * single activity may have multiple applicable policies, such as patient
   * consent, guarantor funding, etc. The policy would also indicate the security token used.
   */
  policy?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** Type of media involved. Used when the event is about exporting/importing onto media. */
  media?: Maybe<Coding>;
  /** Logical network location for application activity, if the activity has a network location. */
  network?: Maybe<AuditEventagentnetwork>;
  /** The reason (purpose of use), specific to this agent, that was used during the event being recorded. */
  purposeOfUse?: Maybe<Array<Maybe<CodeableConcept>>>;
};

/** Where the event occurred. */
export type AuditEventagentlocation_Location_Union = Location;

export type AuditEventagentnetwork = {
  __typename?: 'AuditEventagentnetwork';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An identifier for the network access point of the user device for the audit event. */
  _address?: Maybe<Element>;
  /** An identifier for the network access point of the user device for the audit event. */
  address?: Maybe<Scalars['String']>;
  /** An identifier for the type of network access point that originated the audit event. */
  _type?: Maybe<Element>;
  /** An identifier for the type of network access point that originated the audit event. */
  type?: Maybe<Scalars['code']>;
};

/** Reference to who this agent is that was involved in the event. */
export type AuditEventagentwho_Who_Union = PractitionerRole | Practitioner | Organization | Device | Patient | RelatedPerson;

export type AuditEvententity = {
  __typename?: 'AuditEvententity';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifies a specific instance of the entity. The reference should be version specific. */
  what?: Maybe<AuditEvententitywhat_What_Union>;
  /** The type of the object that was involved in this audit event. */
  type?: Maybe<Coding>;
  /** Code representing the role the entity played in the event being audited. */
  role?: Maybe<Coding>;
  /** Identifier for the data life-cycle stage for the entity. */
  lifecycle?: Maybe<Coding>;
  /** Security labels for the identified entity. */
  securityLabel?: Maybe<Array<Maybe<Coding>>>;
  /** A name of the entity in the audit event. */
  _name?: Maybe<Element>;
  /** A name of the entity in the audit event. */
  name?: Maybe<Scalars['String']>;
  /** Text that describes the entity in more detail. */
  _description?: Maybe<Element>;
  /** Text that describes the entity in more detail. */
  description?: Maybe<Scalars['String']>;
  /** The query parameters for a query-type entities. */
  _query?: Maybe<Element>;
  /** The query parameters for a query-type entities. */
  query?: Maybe<Scalars['base64Binary']>;
  /** Tagged value pairs for conveying additional information about the entity. */
  detail?: Maybe<Array<Maybe<AuditEvententitydetail>>>;
};

export type AuditEvententitydetail = {
  __typename?: 'AuditEvententitydetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of extra detail provided in the value. */
  _type?: Maybe<Element>;
  /** The type of extra detail provided in the value. */
  type: Scalars['String'];
  /** The  value of the extra detail. */
  _valueString?: Maybe<Element>;
  /** The  value of the extra detail. */
  valueString: Scalars['String'];
  /** The  value of the extra detail. */
  _valueBase64Binary?: Maybe<Element>;
  /** The  value of the extra detail. */
  valueBase64Binary: Scalars['base64Binary'];
};

/** Identifies a specific instance of the entity. The reference should be version specific. */
export type AuditEvententitywhat_What_Union = Resource;

export type AuditEventsource = {
  __typename?: 'AuditEventsource';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Logical source location within the healthcare enterprise network.  For
   * example, a hospital or other provider location within a multi-entity provider group.
   */
  _site?: Maybe<Element>;
  /**
   * Logical source location within the healthcare enterprise network.  For
   * example, a hospital or other provider location within a multi-entity provider group.
   */
  site?: Maybe<Scalars['String']>;
  /** Identifier of the source where the event was detected. */
  observer: AuditEventsourceobserver_Observer_Union;
  /** Code specifying the type of source where event originated. */
  type?: Maybe<Array<Maybe<Coding>>>;
};

/** Identifier of the source where the event was detected. */
export type AuditEventsourceobserver_Observer_Union = PractitionerRole | Practitioner | Organization | Device | Patient | RelatedPerson;

/**
 * Basic is used for handling concepts not yet defined in FHIR, narrative-only
 * resources that don't map to an existing resource, and custom resources not
 * appropriate for inclusion in the FHIR specification.
 */
export type Basic = {
  __typename?: 'Basic';
  /** Type of resource */
  resourceType: Basic_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier assigned to the resource for business purposes, outside the context of FHIR. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Identifies the 'type' of resource - equivalent to the resource name for other resources. */
  code: CodeableConcept;
  /** Identifies the patient, practitioner, device or any other resource that is the 'focus' of this resource. */
  subject?: Maybe<Basicsubject_Subject_Union>;
  /** Identifies when the resource was first created. */
  _created?: Maybe<Element>;
  /** Identifies when the resource was first created. */
  created?: Maybe<Scalars['date']>;
  /** Indicates who was responsible for creating the resource instance. */
  author?: Maybe<Basicauthor_Author_Union>;
};

export enum Basic_Enum_Schema {
  Basic = 'Basic'
}

/** Indicates who was responsible for creating the resource instance. */
export type Basicauthor_Author_Union = Practitioner | PractitionerRole | Patient | RelatedPerson | Organization;

/** Identifies the patient, practitioner, device or any other resource that is the 'focus' of this resource. */
export type Basicsubject_Subject_Union = Resource;

/**
 * A resource that represents the data of a single raw artifact as digital content
 * accessible in its native format.  A Binary resource can contain any content,
 * whether text, image, pdf, zip archive, etc.
 */
export type Binary = {
  __typename?: 'Binary';
  /** Type of resource */
  resourceType: Binary_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /** MimeType of the binary content represented as a standard MimeType (BCP 13). */
  _contentType?: Maybe<Element>;
  /** MimeType of the binary content represented as a standard MimeType (BCP 13). */
  contentType: Scalars['code'];
  /**
   * This element identifies another resource that can be used as a proxy of the
   * security sensitivity to use when deciding and enforcing access control rules
   * for the Binary resource. Given that the Binary resource contains very few
   * elements that can be used to determine the sensitivity of the data and
   * relationships to individuals, the referenced resource stands in as a proxy
   * equivalent for this purpose. This referenced resource may be related to the
   * Binary (e.g. Media, DocumentReference), or may be some non-related Resource
   * purely as a security proxy. E.g. to identify that the binary resource relates
   * to a patient, and access should only be granted to applications that have
   * access to the patient.
   */
  securityContext?: Maybe<BinarysecurityContext_SecurityContext_Union>;
  /** The actual content, base64 encoded. */
  _data?: Maybe<Element>;
  /** The actual content, base64 encoded. */
  data?: Maybe<Scalars['base64Binary']>;
};

export enum Binary_Enum_Schema {
  Binary = 'Binary'
}

/**
 * This element identifies another resource that can be used as a proxy of the
 * security sensitivity to use when deciding and enforcing access control rules for
 * the Binary resource. Given that the Binary resource contains very few elements
 * that can be used to determine the sensitivity of the data and relationships to
 * individuals, the referenced resource stands in as a proxy equivalent for this
 * purpose. This referenced resource may be related to the Binary (e.g. Media,
 * DocumentReference), or may be some non-related Resource purely as a security
 * proxy. E.g. to identify that the binary resource relates to a patient, and
 * access should only be granted to applications that have access to the patient.
 */
export type BinarysecurityContext_SecurityContext_Union = Resource;

/**
 * A material substance originating from a biological entity intended to be
 * transplanted or infused into another (possibly the same) biological entity.
 */
export type BiologicallyDerivedProduct = {
  __typename?: 'BiologicallyDerivedProduct';
  /** Type of resource */
  resourceType: BiologicallyDerivedProduct_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * This records identifiers associated with this biologically derived product
   * instance that are defined by business processes and/or used to refer to it
   * when a direct URL reference to the resource itself is not appropriate (e.g. in
   * CDA documents, or in written / printed documentation).
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Broad category of this product. */
  _productCategory?: Maybe<Element>;
  /** Broad category of this product. */
  productCategory?: Maybe<Scalars['code']>;
  /** A code that identifies the kind of this biologically derived product (SNOMED Ctcode). */
  productCode?: Maybe<CodeableConcept>;
  /** Whether the product is currently available. */
  _status?: Maybe<Element>;
  /** Whether the product is currently available. */
  status?: Maybe<Scalars['code']>;
  /** Procedure request to obtain this biologically derived product. */
  request?: Maybe<Array<Maybe<BiologicallyDerivedProductrequest_Request_Union>>>;
  /** Number of discrete units within this product. */
  _quantity?: Maybe<Element>;
  /** Number of discrete units within this product. */
  quantity?: Maybe<Scalars['Int']>;
  /** Parent product (if any). */
  parent?: Maybe<Array<Maybe<BiologicallyDerivedProductparent_Parent_Union>>>;
  /** How this product was collected. */
  collection?: Maybe<BiologicallyDerivedProductcollection>;
  /**
   * Any processing of the product during collection that does not change the
   * fundamental nature of the product. For example adding anti-coagulants during
   * the collection of Peripheral Blood Stem Cells.
   */
  processing?: Maybe<Array<Maybe<BiologicallyDerivedProductprocessing>>>;
  /**
   * Any manipulation of product post-collection that is intended to alter the
   * product.  For example a buffy-coat enrichment or CD8 reduction of Peripheral
   * Blood Stem Cells to make it more suitable for infusion.
   */
  manipulation?: Maybe<BiologicallyDerivedProductmanipulation>;
  /** Product storage. */
  storage?: Maybe<Array<Maybe<BiologicallyDerivedProductstorage>>>;
};

export enum BiologicallyDerivedProduct_Enum_Schema {
  BiologicallyDerivedProduct = 'BiologicallyDerivedProduct'
}

export type BiologicallyDerivedProductcollection = {
  __typename?: 'BiologicallyDerivedProductcollection';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Healthcare professional who is performing the collection. */
  collector?: Maybe<BiologicallyDerivedProductcollectioncollector_Collector_Union>;
  /**
   * The patient or entity, such as a hospital or vendor in the case of a
   * processed/manipulated/manufactured product, providing the product.
   */
  source?: Maybe<BiologicallyDerivedProductcollectionsource_Source_Union>;
  /** Time of product collection. */
  _collectedDateTime?: Maybe<Element>;
  /** Time of product collection. */
  collectedDateTime?: Maybe<Scalars['dateTime']>;
  /** Time of product collection. */
  collectedPeriod?: Maybe<Period>;
};

/** Healthcare professional who is performing the collection. */
export type BiologicallyDerivedProductcollectioncollector_Collector_Union = Practitioner | PractitionerRole;

/**
 * The patient or entity, such as a hospital or vendor in the case of a
 * processed/manipulated/manufactured product, providing the product.
 */
export type BiologicallyDerivedProductcollectionsource_Source_Union = Patient | Organization;

export type BiologicallyDerivedProductmanipulation = {
  __typename?: 'BiologicallyDerivedProductmanipulation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Description of manipulation. */
  _description?: Maybe<Element>;
  /** Description of manipulation. */
  description?: Maybe<Scalars['String']>;
  /** Time of manipulation. */
  _timeDateTime?: Maybe<Element>;
  /** Time of manipulation. */
  timeDateTime?: Maybe<Scalars['dateTime']>;
  /** Time of manipulation. */
  timePeriod?: Maybe<Period>;
};

/** Parent product (if any). */
export type BiologicallyDerivedProductparent_Parent_Union = BiologicallyDerivedProduct;

export type BiologicallyDerivedProductprocessing = {
  __typename?: 'BiologicallyDerivedProductprocessing';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Description of of processing. */
  _description?: Maybe<Element>;
  /** Description of of processing. */
  description?: Maybe<Scalars['String']>;
  /** Procesing code. */
  procedure?: Maybe<CodeableConcept>;
  /** Substance added during processing. */
  additive?: Maybe<BiologicallyDerivedProductprocessingadditive_Additive_Union>;
  /** Time of processing. */
  _timeDateTime?: Maybe<Element>;
  /** Time of processing. */
  timeDateTime?: Maybe<Scalars['dateTime']>;
  /** Time of processing. */
  timePeriod?: Maybe<Period>;
};

/** Substance added during processing. */
export type BiologicallyDerivedProductprocessingadditive_Additive_Union = Substance;

/** Procedure request to obtain this biologically derived product. */
export type BiologicallyDerivedProductrequest_Request_Union = ServiceRequest;

export type BiologicallyDerivedProductstorage = {
  __typename?: 'BiologicallyDerivedProductstorage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Description of storage. */
  _description?: Maybe<Element>;
  /** Description of storage. */
  description?: Maybe<Scalars['String']>;
  /** Storage temperature. */
  _temperature?: Maybe<Element>;
  /** Storage temperature. */
  temperature?: Maybe<Scalars['Float']>;
  /** Temperature scale used. */
  _scale?: Maybe<Element>;
  /** Temperature scale used. */
  scale?: Maybe<Scalars['code']>;
  /** Storage timeperiod. */
  duration?: Maybe<Period>;
};

export enum BlogCategory_Enum_Input_Schema {
  BlogCategory = 'BlogCategory'
}

export enum BlogCategory_Enum_Schema {
  BlogCategory = 'BlogCategory'
}

/** BlogCategory */
export type BlogCategory_Input = {
  /** Type of resource */
  resourceType: BlogCategory_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** firstName. */
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Int']>;
  subCategories?: Maybe<Array<Maybe<BlogSubCategory_Input>>>;
};

/** BlogCategory */
export type BlogCategory_Schema = {
  __typename?: 'BlogCategory_Schema';
  /** Type of resource */
  resourceType: BlogCategory_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  /** firstName. */
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Int']>;
  subCategories?: Maybe<Array<Maybe<BlogSubCategory_Schema>>>;
};

/** Base StructureDefinition for BlogSubCategory Extension Input Type: Custom Fields . */
export type BlogSubCategory_Input = {
  /** operationType field data. */
  subCategoryId?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  subCategoryName?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for BlogSubCategory Extension Input Type: Custom Fields . */
export type BlogSubCategory_Schema = {
  __typename?: 'BlogSubCategory_Schema';
  /** operationType field data. */
  subCategoryId?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  subCategoryName?: Maybe<Scalars['String']>;
};

export enum Blogs_Enum_Input_Schema {
  Blogs = 'Blogs'
}

export enum Blogs_Enum_Schema {
  Blogs = 'Blogs'
}

/** Blogs */
export type Blogs_Input = {
  /** Type of resource */
  resourceType: Blogs_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** firstName. */
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  subCategoryName?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['String']>;
  blogTitle?: Maybe<Scalars['String']>;
  blogDescription?: Maybe<Scalars['String']>;
  blogDescriptionHtml?: Maybe<Scalars['String']>;
  blogBannerImage?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  authorTypeId?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  authorDescription?: Maybe<Scalars['String']>;
  authorImage?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
  blogStatus?: Maybe<Scalars['Int']>;
  blogDescriptionPlainText?: Maybe<Scalars['String']>;
  metaTag?: Maybe<Scalars['String']>;
  metaUrl?: Maybe<Scalars['String']>;
  metaDescriptions?: Maybe<Scalars['String']>;
};

/** Blogs */
export type Blogs_Schema = {
  __typename?: 'Blogs_Schema';
  /** Type of resource */
  resourceType: Blogs_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** firstName. */
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  subCategoryName?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['String']>;
  blogTitle?: Maybe<Scalars['String']>;
  blogDescription?: Maybe<Scalars['String']>;
  blogDescriptionHtml?: Maybe<Scalars['String']>;
  blogBannerImage?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  authorTypeId?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  authorDescription?: Maybe<Scalars['String']>;
  authorImage?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
  blogStatus?: Maybe<Scalars['Int']>;
  blogDescriptionPlainText?: Maybe<Scalars['String']>;
  metaTag?: Maybe<Scalars['String']>;
  metaUrl?: Maybe<Scalars['String']>;
  metaDescriptions?: Maybe<Scalars['String']>;
};

/**
 * Record details about an anatomical structure.  This resource may be used when a
 * coded concept does not provide the necessary detail needed for the use case.
 */
export type BodyStructure = {
  __typename?: 'BodyStructure';
  /** Type of resource */
  resourceType: BodyStructure_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier for this instance of the anatomical structure. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Whether this body site is in active use. */
  _active?: Maybe<Element>;
  /** Whether this body site is in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /**
   * The kind of structure being represented by the body structure at
   * `BodyStructure.location`.  This can define both normal and abnormal morphologies.
   */
  morphology?: Maybe<CodeableConcept>;
  /** The anatomical location or region of the specimen, lesion, or body structure. */
  location?: Maybe<CodeableConcept>;
  /**
   * Qualifier to refine the anatomical location.  These include qualifiers for
   * laterality, relative location, directionality, number, and plane.
   */
  locationQualifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A summary, characterization or explanation of the body structure. */
  _description?: Maybe<Element>;
  /** A summary, characterization or explanation of the body structure. */
  description?: Maybe<Scalars['String']>;
  /** Image or images used to identify a location. */
  image?: Maybe<Array<Maybe<Attachment>>>;
  /** The person to which the body site belongs. */
  patient: BodyStructurepatient_Patient_Union;
};

export enum BodyStructure_Enum_Schema {
  BodyStructure = 'BodyStructure'
}

/** The person to which the body site belongs. */
export type BodyStructurepatient_Patient_Union = Patient;

/** A container for a collection of resources. */
export type Bundle = {
  __typename?: 'Bundle';
  /** Type of resource */
  resourceType: Bundle_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /** A persistent identifier for the bundle that won't change as a bundle is copied from server to server. */
  identifier?: Maybe<Identifier>;
  /** Indicates the purpose of this bundle - how it is intended to be used. */
  _type?: Maybe<Element>;
  /** Indicates the purpose of this bundle - how it is intended to be used. */
  type: Scalars['code'];
  /** The date/time that the bundle was assembled - i.e. when the resources were placed in the bundle. */
  _timestamp?: Maybe<Element>;
  /** The date/time that the bundle was assembled - i.e. when the resources were placed in the bundle. */
  timestamp?: Maybe<Scalars['instant']>;
  /**
   * If a set of search matches, this is the total number of entries of type
   * 'match' across all pages in the search.  It does not include search.mode =
   * 'include' or 'outcome' entries and it does not provide a count of the number
   * of entries in the Bundle.
   */
  _total?: Maybe<Element>;
  /**
   * If a set of search matches, this is the total number of entries of type
   * 'match' across all pages in the search.  It does not include search.mode =
   * 'include' or 'outcome' entries and it does not provide a count of the number
   * of entries in the Bundle.
   */
  total?: Maybe<Scalars['unsignedInt']>;
  /** A series of links that provide context to this bundle. */
  link?: Maybe<Array<Maybe<Bundlelink>>>;
  /**
   * An entry in a bundle resource - will either contain a resource or information
   * about a resource (transactions and history only).
   */
  entry?: Maybe<Array<Maybe<Bundleentry>>>;
  /** Digital Signature - base64 encoded. XML-DSig or a JWT. */
  signature?: Maybe<Signature>;
};

export enum Bundle_Enum_Schema {
  Bundle = 'Bundle'
}

export type Bundleentry = {
  __typename?: 'Bundleentry';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The Absolute URL for the resource.  The fullUrl SHALL NOT disagree with the id
   * in the resource - i.e. if the fullUrl is not a urn:uuid, the URL shall be
   * version-independent URL consistent with the Resource.id. The fullUrl is a
   * version independent reference to the resource. The fullUrl element SHALL have
   * a value except that:  * fullUrl can be empty on a POST (although it does not
   * need to when specifying a temporary id for reference in the bundle) * Results
   * from operations might involve resources that are not identified.
   */
  _fullUrl?: Maybe<Element>;
  /**
   * The Absolute URL for the resource.  The fullUrl SHALL NOT disagree with the id
   * in the resource - i.e. if the fullUrl is not a urn:uuid, the URL shall be
   * version-independent URL consistent with the Resource.id. The fullUrl is a
   * version independent reference to the resource. The fullUrl element SHALL have
   * a value except that:  * fullUrl can be empty on a POST (although it does not
   * need to when specifying a temporary id for reference in the bundle) * Results
   * from operations might involve resources that are not identified.
   */
  fullUrl?: Maybe<Scalars['uri']>;
  /** The Resource for the entry. The purpose/meaning of the resource is determined by the Bundle.type. */
  resource?: Maybe<ResourceList>;
  /** Information about the search process that lead to the creation of this entry. */
  search?: Maybe<Bundleentrysearch>;
  /**
   * Additional information about how this entry should be processed as part of a
   * transaction or batch.  For history, it shows how the entry was processed to
   * create the version contained in the entry.
   */
  request?: Maybe<Bundleentryrequest>;
  /**
   * Indicates the results of processing the corresponding 'request' entry in the
   * batch or transaction being responded to or what the results of an operation
   * where when returning history.
   */
  response?: Maybe<Bundleentryresponse>;
};

export type Bundleentryrequest = {
  __typename?: 'Bundleentryrequest';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * In a transaction or batch, this is the HTTP action to be executed for this
   * entry. In a history bundle, this indicates the HTTP action that occurred.
   */
  _method?: Maybe<Element>;
  /**
   * In a transaction or batch, this is the HTTP action to be executed for this
   * entry. In a history bundle, this indicates the HTTP action that occurred.
   */
  method: Scalars['code'];
  /** The URL for this entry, relative to the root (the address to which the request is posted). */
  _url?: Maybe<Element>;
  /** The URL for this entry, relative to the root (the address to which the request is posted). */
  url: Scalars['uri'];
  /**
   * If the ETag values match, return a 304 Not Modified status. See the API
   * documentation for ['Conditional Read'](http.html#cread).
   */
  _ifNoneMatch?: Maybe<Element>;
  /**
   * If the ETag values match, return a 304 Not Modified status. See the API
   * documentation for ['Conditional Read'](http.html#cread).
   */
  ifNoneMatch?: Maybe<Scalars['String']>;
  /**
   * Only perform the operation if the last updated date matches. See the API
   * documentation for ['Conditional Read'](http.html#cread).
   */
  _ifModifiedSince?: Maybe<Element>;
  /**
   * Only perform the operation if the last updated date matches. See the API
   * documentation for ['Conditional Read'](http.html#cread).
   */
  ifModifiedSince?: Maybe<Scalars['instant']>;
  /**
   * Only perform the operation if the Etag value matches. For more information,
   * see the API section ['Managing Resource Contention'](http.html#concurrency).
   */
  _ifMatch?: Maybe<Element>;
  /**
   * Only perform the operation if the Etag value matches. For more information,
   * see the API section ['Managing Resource Contention'](http.html#concurrency).
   */
  ifMatch?: Maybe<Scalars['String']>;
  /**
   * Instruct the server not to perform the create if a specified resource already
   * exists. For further information, see the API documentation for ['Conditional
   * Create'](http.html#ccreate). This is just the query portion of the URL - what
   * follows the '?' (not including the '?').
   */
  _ifNoneExist?: Maybe<Element>;
  /**
   * Instruct the server not to perform the create if a specified resource already
   * exists. For further information, see the API documentation for ['Conditional
   * Create'](http.html#ccreate). This is just the query portion of the URL - what
   * follows the '?' (not including the '?').
   */
  ifNoneExist?: Maybe<Scalars['String']>;
};

export type Bundleentryresponse = {
  __typename?: 'Bundleentryresponse';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The status code returned by processing this entry. The status SHALL start with
   * a 3 digit HTTP code (e.g. 404) and may contain the standard HTTP description
   * associated with the status code.
   */
  _status?: Maybe<Element>;
  /**
   * The status code returned by processing this entry. The status SHALL start with
   * a 3 digit HTTP code (e.g. 404) and may contain the standard HTTP description
   * associated with the status code.
   */
  status: Scalars['String'];
  /** The location header created by processing this operation, populated if the operation returns a location. */
  _location?: Maybe<Element>;
  /** The location header created by processing this operation, populated if the operation returns a location. */
  location?: Maybe<Scalars['uri']>;
  /**
   * The Etag for the resource, if the operation for the entry produced a versioned
   * resource (see [Resource Metadata and Versioning](http.html#versioning) and
   * [Managing Resource Contention](http.html#concurrency)).
   */
  _etag?: Maybe<Element>;
  /**
   * The Etag for the resource, if the operation for the entry produced a versioned
   * resource (see [Resource Metadata and Versioning](http.html#versioning) and
   * [Managing Resource Contention](http.html#concurrency)).
   */
  etag?: Maybe<Scalars['String']>;
  /** The date/time that the resource was modified on the server. */
  _lastModified?: Maybe<Element>;
  /** The date/time that the resource was modified on the server. */
  lastModified?: Maybe<Scalars['instant']>;
  /** An OperationOutcome containing hints and warnings produced as part of processing this entry in a batch or transaction. */
  outcome?: Maybe<ResourceList>;
};

export type Bundleentrysearch = {
  __typename?: 'Bundleentrysearch';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Why this entry is in the result set - whether it's included as a match or
   * because of an _include requirement, or to convey information or warning
   * information about the search process.
   */
  _mode?: Maybe<Element>;
  /**
   * Why this entry is in the result set - whether it's included as a match or
   * because of an _include requirement, or to convey information or warning
   * information about the search process.
   */
  mode?: Maybe<Scalars['code']>;
  /** When searching, the server's search ranking score for the entry. */
  _score?: Maybe<Element>;
  /** When searching, the server's search ranking score for the entry. */
  score?: Maybe<Scalars['Float']>;
};

export type Bundlelink = {
  __typename?: 'Bundlelink';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A name which details the functional use for this link - see [http://www.iana.org/assignments/link-relations/link-relations.xhtml#link-relations-1](http://www.iana.org/assignments/link-relations/link-relations.xhtml#link-relations-1). */
  _relation?: Maybe<Element>;
  /** A name which details the functional use for this link - see [http://www.iana.org/assignments/link-relations/link-relations.xhtml#link-relations-1](http://www.iana.org/assignments/link-relations/link-relations.xhtml#link-relations-1). */
  relation: Scalars['String'];
  /** The reference details for the link. */
  _url?: Maybe<Element>;
  /** The reference details for the link. */
  url: Scalars['uri'];
};

/**
 * A Capability Statement documents a set of capabilities (behaviors) of a FHIR
 * Server for a particular version of FHIR that may be used as a statement of
 * actual server functionality or a statement of required or desired server
 * implementation.
 */
export type CapabilityStatement = {
  __typename?: 'CapabilityStatement';
  /** Type of resource */
  resourceType: CapabilityStatement_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this capability statement when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this capability
   * statement is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the capability statement is stored on
   * different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this capability statement when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this capability
   * statement is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the capability statement is stored on
   * different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * The identifier that is used to identify this version of the capability
   * statement when it is referenced in a specification, model, design or instance.
   * This is an arbitrary value managed by the capability statement author and is
   * not expected to be globally unique. For example, it might be a timestamp (e.g.
   * yyyymmdd) if a managed version is not available. There is also no expectation
   * that versions can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the capability
   * statement when it is referenced in a specification, model, design or instance.
   * This is an arbitrary value managed by the capability statement author and is
   * not expected to be globally unique. For example, it might be a timestamp (e.g.
   * yyyymmdd) if a managed version is not available. There is also no expectation
   * that versions can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the capability statement. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the capability statement. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the capability statement. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the capability statement. */
  title?: Maybe<Scalars['String']>;
  /** The status of this capability statement. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this capability statement. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this capability statement is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this capability statement is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the capability statement was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the capability statement changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the capability statement was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the capability statement changes.
   */
  date: Scalars['dateTime'];
  /** The name of the organization or individual that published the capability statement. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the capability statement. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /**
   * A free text natural language description of the capability statement from a
   * consumer's perspective. Typically, this is used when the capability statement
   * describes a desired rather than an actual solution, for example as a formal
   * expression of requirements as part of an RFP.
   */
  _description?: Maybe<Element>;
  /**
   * A free text natural language description of the capability statement from a
   * consumer's perspective. Typically, this is used when the capability statement
   * describes a desired rather than an actual solution, for example as a formal
   * expression of requirements as part of an RFP.
   */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate capability
   * statement instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the capability statement is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this capability statement is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this capability statement is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the capability statement and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the capability statement.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the capability statement and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the capability statement.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The way that this statement is intended to be used, to describe an actual
   * running instance of software, a particular product (kind, not instance of
   * software) or a class of implementation (e.g. a desired purchase).
   */
  _kind?: Maybe<Element>;
  /**
   * The way that this statement is intended to be used, to describe an actual
   * running instance of software, a particular product (kind, not instance of
   * software) or a class of implementation (e.g. a desired purchase).
   */
  kind: Scalars['code'];
  /**
   * Reference to a canonical URL of another CapabilityStatement that this software
   * implements. This capability statement is a published API description that
   * corresponds to a business service. The server may actually implement a subset
   * of the capability statement it claims to implement, so the capability
   * statement must specify the full capability details.
   */
  _instantiates?: Maybe<Element>;
  /**
   * Reference to a canonical URL of another CapabilityStatement that this software
   * implements. This capability statement is a published API description that
   * corresponds to a business service. The server may actually implement a subset
   * of the capability statement it claims to implement, so the capability
   * statement must specify the full capability details.
   */
  instantiates?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * Reference to a canonical URL of another CapabilityStatement that this software
   * adds to. The capability statement automatically includes everything in the
   * other statement, and it is not duplicated, though the server may repeat the
   * same resources, interactions and operations to add additional details to them.
   */
  _imports?: Maybe<Element>;
  /**
   * Reference to a canonical URL of another CapabilityStatement that this software
   * adds to. The capability statement automatically includes everything in the
   * other statement, and it is not duplicated, though the server may repeat the
   * same resources, interactions and operations to add additional details to them.
   */
  imports?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * Software that is covered by this capability statement.  It is used when the
   * capability statement describes the capabilities of a particular software
   * version, independent of an installation.
   */
  software?: Maybe<CapabilityStatementsoftware>;
  /**
   * Identifies a specific implementation instance that is described by the
   * capability statement - i.e. a particular installation, rather than the
   * capabilities of a software program.
   */
  implementation?: Maybe<CapabilityStatementimplementation>;
  /**
   * The version of the FHIR specification that this CapabilityStatement describes
   * (which SHALL be the same as the FHIR version of the CapabilityStatement
   * itself). There is no default value.
   */
  _fhirVersion?: Maybe<Element>;
  /**
   * The version of the FHIR specification that this CapabilityStatement describes
   * (which SHALL be the same as the FHIR version of the CapabilityStatement
   * itself). There is no default value.
   */
  fhirVersion: Scalars['code'];
  /** A list of the formats supported by this implementation using their content types. */
  _format?: Maybe<Element>;
  /** A list of the formats supported by this implementation using their content types. */
  format?: Maybe<Array<Scalars['code']>>;
  /** A list of the patch formats supported by this implementation using their content types. */
  _patchFormat?: Maybe<Element>;
  /** A list of the patch formats supported by this implementation using their content types. */
  patchFormat?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** A list of implementation guides that the server does (or should) support in their entirety. */
  _implementationGuide?: Maybe<Element>;
  /** A list of implementation guides that the server does (or should) support in their entirety. */
  implementationGuide?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** A definition of the restful capabilities of the solution, if any. */
  rest?: Maybe<Array<Maybe<CapabilityStatementrest>>>;
  /** A description of the messaging capabilities of the solution. */
  messaging?: Maybe<Array<Maybe<CapabilityStatementmessaging>>>;
  /** A document definition. */
  document?: Maybe<Array<Maybe<CapabilityStatementdocument>>>;
};

export enum CapabilityStatement_Enum_Schema {
  CapabilityStatement = 'CapabilityStatement'
}

export type CapabilityStatementdocument = {
  __typename?: 'CapabilityStatementdocument';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Mode of this document declaration - whether an application is a producer or consumer. */
  _mode?: Maybe<Element>;
  /** Mode of this document declaration - whether an application is a producer or consumer. */
  mode: Scalars['code'];
  /**
   * A description of how the application supports or uses the specified document
   * profile.  For example, when documents are created, what action is taken with
   * consumed documents, etc.
   */
  _documentation?: Maybe<Element>;
  /**
   * A description of how the application supports or uses the specified document
   * profile.  For example, when documents are created, what action is taken with
   * consumed documents, etc.
   */
  documentation?: Maybe<Scalars['String']>;
  /** A profile on the document Bundle that constrains which resources are present, and their contents. */
  _profile?: Maybe<Element>;
  /** A profile on the document Bundle that constrains which resources are present, and their contents. */
  profile: Scalars['canonical'];
};

export type CapabilityStatementimplementation = {
  __typename?: 'CapabilityStatementimplementation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Information about the specific installation that this capability statement relates to. */
  _description?: Maybe<Element>;
  /** Information about the specific installation that this capability statement relates to. */
  description: Scalars['String'];
  /**
   * An absolute base URL for the implementation.  This forms the base for REST
   * interfaces as well as the mailbox and document interfaces.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute base URL for the implementation.  This forms the base for REST
   * interfaces as well as the mailbox and document interfaces.
   */
  url?: Maybe<Scalars['url']>;
  /**
   * The organization responsible for the management of the instance and oversight
   * of the data on the server at the specified URL.
   */
  custodian?: Maybe<CapabilityStatementimplementationcustodian_Custodian_Union>;
};

/**
 * The organization responsible for the management of the instance and oversight of
 * the data on the server at the specified URL.
 */
export type CapabilityStatementimplementationcustodian_Custodian_Union = Organization;

export type CapabilityStatementmessaging = {
  __typename?: 'CapabilityStatementmessaging';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An endpoint (network accessible address) to which messages and/or replies are to be sent. */
  endpoint?: Maybe<Array<Maybe<CapabilityStatementmessagingendpoint>>>;
  /**
   * Length if the receiver's reliable messaging cache in minutes (if a receiver)
   * or how long the cache length on the receiver should be (if a sender).
   */
  _reliableCache?: Maybe<Element>;
  /**
   * Length if the receiver's reliable messaging cache in minutes (if a receiver)
   * or how long the cache length on the receiver should be (if a sender).
   */
  reliableCache?: Maybe<Scalars['unsignedInt']>;
  /**
   * Documentation about the system's messaging capabilities for this endpoint not
   * otherwise documented by the capability statement.  For example, the process
   * for becoming an authorized messaging exchange partner.
   */
  _documentation?: Maybe<Element>;
  /**
   * Documentation about the system's messaging capabilities for this endpoint not
   * otherwise documented by the capability statement.  For example, the process
   * for becoming an authorized messaging exchange partner.
   */
  documentation?: Maybe<Scalars['String']>;
  /** References to message definitions for messages this system can send or receive. */
  supportedMessage?: Maybe<Array<Maybe<CapabilityStatementmessagingsupportedMessage>>>;
};

export type CapabilityStatementmessagingendpoint = {
  __typename?: 'CapabilityStatementmessagingendpoint';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A list of the messaging transport protocol(s) identifiers, supported by this endpoint. */
  protocol: Coding;
  /**
   * The network address of the endpoint. For solutions that do not use network
   * addresses for routing, it can be just an identifier.
   */
  _address?: Maybe<Element>;
  /**
   * The network address of the endpoint. For solutions that do not use network
   * addresses for routing, it can be just an identifier.
   */
  address: Scalars['url'];
};

export type CapabilityStatementmessagingsupportedMessage = {
  __typename?: 'CapabilityStatementmessagingsupportedMessage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The mode of this event declaration - whether application is sender or receiver. */
  _mode?: Maybe<Element>;
  /** The mode of this event declaration - whether application is sender or receiver. */
  mode: Scalars['code'];
  /** Points to a message definition that identifies the messaging event, message structure, allowed responses, etc. */
  _definition?: Maybe<Element>;
  /** Points to a message definition that identifies the messaging event, message structure, allowed responses, etc. */
  definition: Scalars['canonical'];
};

export type CapabilityStatementrest = {
  __typename?: 'CapabilityStatementrest';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifies whether this portion of the statement is describing the ability to initiate or receive restful operations. */
  _mode?: Maybe<Element>;
  /** Identifies whether this portion of the statement is describing the ability to initiate or receive restful operations. */
  mode: Scalars['code'];
  /** Information about the system's restful capabilities that apply across all applications, such as security. */
  _documentation?: Maybe<Element>;
  /** Information about the system's restful capabilities that apply across all applications, such as security. */
  documentation?: Maybe<Scalars['String']>;
  /** Information about security implementation from an interface perspective - what a client needs to know. */
  security?: Maybe<CapabilityStatementrestsecurity>;
  /** A specification of the restful capabilities of the solution for a specific resource type. */
  resource?: Maybe<Array<Maybe<CapabilityStatementrestresource>>>;
  /** A specification of restful operations supported by the system. */
  interaction?: Maybe<Array<Maybe<CapabilityStatementrestinteraction>>>;
  /**
   * An absolute URI which is a reference to the definition of a compartment that
   * the system supports. The reference is to a CompartmentDefinition resource by
   * its canonical URL .
   */
  _compartment?: Maybe<Element>;
  /**
   * An absolute URI which is a reference to the definition of a compartment that
   * the system supports. The reference is to a CompartmentDefinition resource by
   * its canonical URL .
   */
  compartment?: Maybe<Array<Maybe<Scalars['canonical']>>>;
};

export type CapabilityStatementrestinteraction = {
  __typename?: 'CapabilityStatementrestinteraction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A coded identifier of the operation, supported by the system. */
  _code?: Maybe<Element>;
  /** A coded identifier of the operation, supported by the system. */
  code: Scalars['code'];
  /**
   * Guidance specific to the implementation of this operation, such as limitations
   * on the kind of transactions allowed, or information about system wide search
   * is implemented.
   */
  _documentation?: Maybe<Element>;
  /**
   * Guidance specific to the implementation of this operation, such as limitations
   * on the kind of transactions allowed, or information about system wide search
   * is implemented.
   */
  documentation?: Maybe<Scalars['String']>;
};

export type CapabilityStatementrestresource = {
  __typename?: 'CapabilityStatementrestresource';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A type of resource exposed via the restful interface. */
  _type?: Maybe<Element>;
  /** A type of resource exposed via the restful interface. */
  type: Scalars['code'];
  /**
   * A specification of the profile that describes the solution's overall support
   * for the resource, including any constraints on cardinality, bindings, lengths
   * or other limitations. See further discussion in [Using
   * Profiles](profiling.html#profile-uses).
   */
  _profile?: Maybe<Element>;
  /**
   * A specification of the profile that describes the solution's overall support
   * for the resource, including any constraints on cardinality, bindings, lengths
   * or other limitations. See further discussion in [Using
   * Profiles](profiling.html#profile-uses).
   */
  profile?: Maybe<Scalars['canonical']>;
  /**
   * A list of profiles that represent different use cases supported by the system.
   * For a server, 'supported by the system' means the system hosts/produces a set
   * of resources that are conformant to a particular profile, and allows clients
   * that use its services to search using this profile and to find appropriate
   * data. For a client, it means the system will search by this profile and
   * process data according to the guidance implicit in the profile. See further
   * discussion in [Using Profiles](profiling.html#profile-uses).
   */
  _supportedProfile?: Maybe<Element>;
  /**
   * A list of profiles that represent different use cases supported by the system.
   * For a server, 'supported by the system' means the system hosts/produces a set
   * of resources that are conformant to a particular profile, and allows clients
   * that use its services to search using this profile and to find appropriate
   * data. For a client, it means the system will search by this profile and
   * process data according to the guidance implicit in the profile. See further
   * discussion in [Using Profiles](profiling.html#profile-uses).
   */
  supportedProfile?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** Additional information about the resource type used by the system. */
  _documentation?: Maybe<Element>;
  /** Additional information about the resource type used by the system. */
  documentation?: Maybe<Scalars['String']>;
  /** Identifies a restful operation supported by the solution. */
  interaction?: Maybe<Array<Maybe<CapabilityStatementrestresourceinteraction>>>;
  /**
   * This field is set to no-version to specify that the system does not support
   * (server) or use (client) versioning for this resource type. If this has some
   * other value, the server must at least correctly track and populate the
   * versionId meta-property on resources. If the value is 'versioned-update', then
   * the server supports all the versioning features, including using e-tags for
   * version integrity in the API.
   */
  _versioning?: Maybe<Element>;
  /**
   * This field is set to no-version to specify that the system does not support
   * (server) or use (client) versioning for this resource type. If this has some
   * other value, the server must at least correctly track and populate the
   * versionId meta-property on resources. If the value is 'versioned-update', then
   * the server supports all the versioning features, including using e-tags for
   * version integrity in the API.
   */
  versioning?: Maybe<Scalars['code']>;
  /** A flag for whether the server is able to return past versions as part of the vRead operation. */
  _readHistory?: Maybe<Element>;
  /** A flag for whether the server is able to return past versions as part of the vRead operation. */
  readHistory?: Maybe<Scalars['Boolean']>;
  /**
   * A flag to indicate that the server allows or needs to allow the client to
   * create new identities on the server (that is, the client PUTs to a location
   * where there is no existing resource). Allowing this operation means that the
   * server allows the client to create new identities on the server.
   */
  _updateCreate?: Maybe<Element>;
  /**
   * A flag to indicate that the server allows or needs to allow the client to
   * create new identities on the server (that is, the client PUTs to a location
   * where there is no existing resource). Allowing this operation means that the
   * server allows the client to create new identities on the server.
   */
  updateCreate?: Maybe<Scalars['Boolean']>;
  /** A flag that indicates that the server supports conditional create. */
  _conditionalCreate?: Maybe<Element>;
  /** A flag that indicates that the server supports conditional create. */
  conditionalCreate?: Maybe<Scalars['Boolean']>;
  /** A code that indicates how the server supports conditional read. */
  _conditionalRead?: Maybe<Element>;
  /** A code that indicates how the server supports conditional read. */
  conditionalRead?: Maybe<Scalars['code']>;
  /** A flag that indicates that the server supports conditional update. */
  _conditionalUpdate?: Maybe<Element>;
  /** A flag that indicates that the server supports conditional update. */
  conditionalUpdate?: Maybe<Scalars['Boolean']>;
  /** A code that indicates how the server supports conditional delete. */
  _conditionalDelete?: Maybe<Element>;
  /** A code that indicates how the server supports conditional delete. */
  conditionalDelete?: Maybe<Scalars['code']>;
  /** A set of flags that defines how references are supported. */
  _referencePolicy?: Maybe<Element>;
  /** A set of flags that defines how references are supported. */
  referencePolicy?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** A list of _include values supported by the server. */
  _searchInclude?: Maybe<Element>;
  /** A list of _include values supported by the server. */
  searchInclude?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of _revinclude (reverse include) values supported by the server. */
  _searchRevInclude?: Maybe<Element>;
  /** A list of _revinclude (reverse include) values supported by the server. */
  searchRevInclude?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Search parameters for implementations to support and/or make use of - either
   * references to ones defined in the specification, or additional ones defined
   * for/by the implementation.
   */
  searchParam?: Maybe<Array<Maybe<CapabilityStatementrestresourcesearchParam>>>;
  /**
   * Definition of an operation or a named query together with its parameters and
   * their meaning and type. Consult the definition of the operation for details
   * about how to invoke the operation, and the parameters.
   */
  operation?: Maybe<Array<Maybe<CapabilityStatementrestresourceoperation>>>;
};

export type CapabilityStatementrestresourceinteraction = {
  __typename?: 'CapabilityStatementrestresourceinteraction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Coded identifier of the operation, supported by the system resource. */
  _code?: Maybe<Element>;
  /** Coded identifier of the operation, supported by the system resource. */
  code: Scalars['code'];
  /**
   * Guidance specific to the implementation of this operation, such as 'delete is
   * a logical delete' or 'updates are only allowed with version id' or 'creates
   * permitted from pre-authorized certificates only'.
   */
  _documentation?: Maybe<Element>;
  /**
   * Guidance specific to the implementation of this operation, such as 'delete is
   * a logical delete' or 'updates are only allowed with version id' or 'creates
   * permitted from pre-authorized certificates only'.
   */
  documentation?: Maybe<Scalars['String']>;
};

export type CapabilityStatementrestresourceoperation = {
  __typename?: 'CapabilityStatementrestresourceoperation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The name of the operation or query. For an operation, this is the name
   * prefixed with $ and used in the URL. For a query, this is the name used in the
   * _query parameter when the query is called.
   */
  _name?: Maybe<Element>;
  /**
   * The name of the operation or query. For an operation, this is the name
   * prefixed with $ and used in the URL. For a query, this is the name used in the
   * _query parameter when the query is called.
   */
  name: Scalars['String'];
  /**
   * Where the formal definition can be found. If a server references the base
   * definition of an Operation (i.e. from the specification itself such as
   * ```http://hl7.org/fhir/OperationDefinition/ValueSet-expand```), that means it
   * supports the full capabilities of the operation - e.g. both GET and POST
   * invocation.  If it only supports a subset, it must define its own custom
   * [OperationDefinition](operationdefinition.html#) with a 'base' of the original
   * OperationDefinition.  The custom definition would describe the specific subset
   * of functionality supported.
   */
  _definition?: Maybe<Element>;
  /**
   * Where the formal definition can be found. If a server references the base
   * definition of an Operation (i.e. from the specification itself such as
   * ```http://hl7.org/fhir/OperationDefinition/ValueSet-expand```), that means it
   * supports the full capabilities of the operation - e.g. both GET and POST
   * invocation.  If it only supports a subset, it must define its own custom
   * [OperationDefinition](operationdefinition.html#) with a 'base' of the original
   * OperationDefinition.  The custom definition would describe the specific subset
   * of functionality supported.
   */
  definition: Scalars['canonical'];
  /**
   * Documentation that describes anything special about the operation behavior,
   * possibly detailing different behavior for system, type and instance-level
   * invocation of the operation.
   */
  _documentation?: Maybe<Element>;
  /**
   * Documentation that describes anything special about the operation behavior,
   * possibly detailing different behavior for system, type and instance-level
   * invocation of the operation.
   */
  documentation?: Maybe<Scalars['String']>;
};

export type CapabilityStatementrestresourcesearchParam = {
  __typename?: 'CapabilityStatementrestresourcesearchParam';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of the search parameter used in the interface. */
  _name?: Maybe<Element>;
  /** The name of the search parameter used in the interface. */
  name: Scalars['String'];
  /**
   * An absolute URI that is a formal reference to where this parameter was first
   * defined, so that a client can be confident of the meaning of the search
   * parameter (a reference to
   * [SearchParameter.url](searchparameter-definitions.html#SearchParameter.url)).
   * This element SHALL be populated if the search parameter refers to a
   * SearchParameter defined by the FHIR core specification or externally defined IGs.
   */
  _definition?: Maybe<Element>;
  /**
   * An absolute URI that is a formal reference to where this parameter was first
   * defined, so that a client can be confident of the meaning of the search
   * parameter (a reference to
   * [SearchParameter.url](searchparameter-definitions.html#SearchParameter.url)).
   * This element SHALL be populated if the search parameter refers to a
   * SearchParameter defined by the FHIR core specification or externally defined IGs.
   */
  definition?: Maybe<Scalars['canonical']>;
  /** The type of value a search parameter refers to, and how the content is interpreted. */
  _type?: Maybe<Element>;
  /** The type of value a search parameter refers to, and how the content is interpreted. */
  type: Scalars['code'];
  /**
   * This allows documentation of any distinct behaviors about how the search
   * parameter is used.  For example, text matching algorithms.
   */
  _documentation?: Maybe<Element>;
  /**
   * This allows documentation of any distinct behaviors about how the search
   * parameter is used.  For example, text matching algorithms.
   */
  documentation?: Maybe<Scalars['String']>;
};

export type CapabilityStatementrestsecurity = {
  __typename?: 'CapabilityStatementrestsecurity';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Server adds CORS headers when responding to requests - this enables Javascript applications to use the server. */
  _cors?: Maybe<Element>;
  /** Server adds CORS headers when responding to requests - this enables Javascript applications to use the server. */
  cors?: Maybe<Scalars['Boolean']>;
  /** Types of security services that are supported/required by the system. */
  service?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** General description of how security works. */
  _description?: Maybe<Element>;
  /** General description of how security works. */
  description?: Maybe<Scalars['String']>;
};

export type CapabilityStatementsoftware = {
  __typename?: 'CapabilityStatementsoftware';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Name the software is known by. */
  _name?: Maybe<Element>;
  /** Name the software is known by. */
  name: Scalars['String'];
  /** The version identifier for the software covered by this statement. */
  _version?: Maybe<Element>;
  /** The version identifier for the software covered by this statement. */
  version?: Maybe<Scalars['String']>;
  /** Date this version of the software was released. */
  _releaseDate?: Maybe<Element>;
  /** Date this version of the software was released. */
  releaseDate?: Maybe<Scalars['dateTime']>;
};

/**
 * Describes the intention of how one or more practitioners intend to deliver care
 * for a particular patient, group or community for a period of time, possibly
 * limited to care for a specific condition or set of conditions.
 */
export type CarePlan = {
  __typename?: 'CarePlan';
  /** Type of resource */
  resourceType: CarePlan_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this care plan by the performer or other
   * systems which remain constant as the resource is updated and propagates from
   * server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, questionnaire or other
   * definition that is adhered to in whole or in part by this CarePlan.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, questionnaire or other
   * definition that is adhered to in whole or in part by this CarePlan.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * The URL pointing to an externally maintained protocol, guideline,
   * questionnaire or other definition that is adhered to in whole or in part by this CarePlan.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * The URL pointing to an externally maintained protocol, guideline,
   * questionnaire or other definition that is adhered to in whole or in part by this CarePlan.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** A care plan that is fulfilled in whole or in part by this care plan. */
  basedOn?: Maybe<Array<Maybe<CarePlanbasedOn_BasedOn_Union>>>;
  /** Completed or terminated care plan whose function is taken by this new care plan. */
  replaces?: Maybe<Array<Maybe<CarePlanreplaces_Replaces_Union>>>;
  /** A larger care plan of which this particular care plan is a component or step. */
  partOf?: Maybe<Array<Maybe<CarePlanpartOf_PartOf_Union>>>;
  /** Indicates whether the plan is currently being acted upon, represents future intentions or is now a historical record. */
  _status?: Maybe<Element>;
  /** Indicates whether the plan is currently being acted upon, represents future intentions or is now a historical record. */
  status: Scalars['code'];
  /**
   * Indicates the level of authority/intentionality associated with the care plan
   * and where the care plan fits into the workflow chain.
   */
  _intent?: Maybe<Element>;
  /**
   * Indicates the level of authority/intentionality associated with the care plan
   * and where the care plan fits into the workflow chain.
   */
  intent: Scalars['code'];
  /**
   * Identifies what 'kind' of plan this is to support differentiation between
   * multiple co-existing plans; e.g. 'Home health', 'psychiatric', 'asthma',
   * 'disease management', 'wellness plan', etc.
   */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Human-friendly name for the care plan. */
  _title?: Maybe<Element>;
  /** Human-friendly name for the care plan. */
  title?: Maybe<Scalars['String']>;
  /** A description of the scope and nature of the plan. */
  _description?: Maybe<Element>;
  /** A description of the scope and nature of the plan. */
  description?: Maybe<Scalars['String']>;
  /** Identifies the patient or group whose intended care is described by the plan. */
  subject: CarePlansubject_Subject_Union;
  /** The Encounter during which this CarePlan was created or to which the creation of this record is tightly associated. */
  encounter?: Maybe<CarePlanencounter_Encounter_Union>;
  /** Indicates when the plan did (or is intended to) come into effect and end. */
  period?: Maybe<Period>;
  /** Represents when this particular CarePlan record was created in the system, which is often a system-generated date. */
  _created?: Maybe<Element>;
  /** Represents when this particular CarePlan record was created in the system, which is often a system-generated date. */
  created?: Maybe<Scalars['dateTime']>;
  /** When populated, the author is responsible for the care plan.  The care plan is attributed to the author. */
  author?: Maybe<CarePlanauthor_Author_Union>;
  /** Identifies the individual(s) or organization who provided the contents of the care plan. */
  contributor?: Maybe<Array<Maybe<CarePlancontributor_Contributor_Union>>>;
  /** Identifies all people and organizations who are expected to be involved in the care envisioned by this plan. */
  careTeam?: Maybe<Array<Maybe<CarePlancareTeam_CareTeam_Union>>>;
  /** Identifies the conditions/problems/concerns/diagnoses/etc. whose management and/or mitigation are handled by this plan. */
  addresses?: Maybe<Array<Maybe<CarePlanaddresses_Addresses_Union>>>;
  /**
   * Identifies portions of the patient's record that specifically influenced the
   * formation of the plan.  These might include comorbidities, recent procedures,
   * limitations, recent assessments, etc.
   */
  supportingInfo?: Maybe<Array<Maybe<CarePlansupportingInfo_SupportingInfo_Union>>>;
  /** Describes the intended objective(s) of carrying out the care plan. */
  goal?: Maybe<Array<Maybe<CarePlangoal_Goal_Union>>>;
  /**
   * Identifies a planned action to occur as part of the plan.  For example, a
   * medication to be used, lab tests to perform, self-monitoring, education, etc.
   */
  activity?: Maybe<Array<Maybe<CarePlanactivity>>>;
  /** General notes about the care plan not covered elsewhere. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export enum CarePlan_Enum_Schema {
  CarePlan = 'CarePlan'
}

export type CarePlanactivity = {
  __typename?: 'CarePlanactivity';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Identifies the outcome at the point when the status of the activity is
   * assessed.  For example, the outcome of an education activity could be patient
   * understands (or not).
   */
  outcomeCodeableConcept?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Details of the outcome or action resulting from the activity.  The reference
   * to an 'event' resource, such as Procedure or Encounter or Observation, is the
   * result/outcome of the activity itself.  The activity can be conveyed using
   * CarePlan.activity.detail OR using the CarePlan.activity.reference (a reference
   * to a “request” resource).
   */
  outcomeReference?: Maybe<Array<Maybe<CarePlanactivityoutcomeReference_OutcomeReference_Union>>>;
  /** Notes about the adherence/status/progress of the activity. */
  progress?: Maybe<Array<Maybe<Annotation>>>;
  /** The details of the proposed activity represented in a specific resource. */
  reference?: Maybe<CarePlanactivityreference_Reference_Union>;
  /**
   * A simple summary of a planned activity suitable for a general care plan system
   * (e.g. form driven) that doesn't know about specific resources such as procedure etc.
   */
  detail?: Maybe<CarePlanactivitydetail>;
};

export type CarePlanactivitydetail = {
  __typename?: 'CarePlanactivitydetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A description of the kind of resource the in-line definition of a care plan
   * activity is representing.  The CarePlan.activity.detail is an in-line
   * definition when a resource is not referenced using
   * CarePlan.activity.reference.  For example, a MedicationRequest, a
   * ServiceRequest, or a CommunicationRequest.
   */
  _kind?: Maybe<Element>;
  /**
   * A description of the kind of resource the in-line definition of a care plan
   * activity is representing.  The CarePlan.activity.detail is an in-line
   * definition when a resource is not referenced using
   * CarePlan.activity.reference.  For example, a MedicationRequest, a
   * ServiceRequest, or a CommunicationRequest.
   */
  kind?: Maybe<Scalars['code']>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, questionnaire or other
   * definition that is adhered to in whole or in part by this CarePlan activity.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, questionnaire or other
   * definition that is adhered to in whole or in part by this CarePlan activity.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * The URL pointing to an externally maintained protocol, guideline,
   * questionnaire or other definition that is adhered to in whole or in part by
   * this CarePlan activity.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * The URL pointing to an externally maintained protocol, guideline,
   * questionnaire or other definition that is adhered to in whole or in part by
   * this CarePlan activity.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** Detailed description of the type of planned activity; e.g. what lab test, what procedure, what kind of encounter. */
  code?: Maybe<CodeableConcept>;
  /**
   * Provides the rationale that drove the inclusion of this particular activity as
   * part of the plan or the reason why the activity was prohibited.
   */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Indicates another resource, such as the health condition(s), whose existence
   * justifies this request and drove the inclusion of this particular activity as
   * part of the plan.
   */
  reasonReference?: Maybe<Array<Maybe<CarePlanactivitydetailreasonReference_ReasonReference_Union>>>;
  /** Internal reference that identifies the goals that this activity is intended to contribute towards meeting. */
  goal?: Maybe<Array<Maybe<CarePlanactivitydetailgoal_Goal_Union>>>;
  /** Identifies what progress is being made for the specific activity. */
  _status?: Maybe<Element>;
  /** Identifies what progress is being made for the specific activity. */
  status: Scalars['code'];
  /** Provides reason why the activity isn't yet started, is on hold, was cancelled, etc. */
  statusReason?: Maybe<CodeableConcept>;
  /**
   * If true, indicates that the described activity is one that must NOT be engaged
   * in when following the plan.  If false, or missing, indicates that the
   * described activity is one that should be engaged in when following the plan.
   */
  _doNotPerform?: Maybe<Element>;
  /**
   * If true, indicates that the described activity is one that must NOT be engaged
   * in when following the plan.  If false, or missing, indicates that the
   * described activity is one that should be engaged in when following the plan.
   */
  doNotPerform?: Maybe<Scalars['Boolean']>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  scheduledTiming?: Maybe<Timing>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  scheduledPeriod?: Maybe<Period>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  _scheduledString?: Maybe<Element>;
  /** The period, timing or frequency upon which the described activity is to occur. */
  scheduledString?: Maybe<Scalars['String']>;
  /** Identifies the facility where the activity will occur; e.g. home, hospital, specific clinic, etc. */
  location?: Maybe<CarePlanactivitydetaillocation_Location_Union>;
  /** Identifies who's expected to be involved in the activity. */
  performer?: Maybe<Array<Maybe<CarePlanactivitydetailperformer_Performer_Union>>>;
  /** Identifies the food, drug or other product to be consumed or supplied in the activity. */
  productCodeableConcept?: Maybe<CodeableConcept>;
  /** Identifies the food, drug or other product to be consumed or supplied in the activity. */
  productReference?: Maybe<CarePlanactivitydetailproductReference_ProductReference_Union>;
  /** Identifies the quantity expected to be consumed in a given day. */
  dailyAmount?: Maybe<Quantity>;
  /** Identifies the quantity expected to be supplied, administered or consumed by the subject. */
  quantity?: Maybe<Quantity>;
  /**
   * This provides a textual description of constraints on the intended activity
   * occurrence, including relation to other activities.  It may also include
   * objectives, pre-conditions and end-conditions.  Finally, it may convey
   * specifics about the activity such as body site, method, route, etc.
   */
  _description?: Maybe<Element>;
  /**
   * This provides a textual description of constraints on the intended activity
   * occurrence, including relation to other activities.  It may also include
   * objectives, pre-conditions and end-conditions.  Finally, it may convey
   * specifics about the activity such as body site, method, route, etc.
   */
  description?: Maybe<Scalars['String']>;
};

/** Internal reference that identifies the goals that this activity is intended to contribute towards meeting. */
export type CarePlanactivitydetailgoal_Goal_Union = Goal;

/** Identifies the facility where the activity will occur; e.g. home, hospital, specific clinic, etc. */
export type CarePlanactivitydetaillocation_Location_Union = Location;

/** Identifies who's expected to be involved in the activity. */
export type CarePlanactivitydetailperformer_Performer_Union = Practitioner | PractitionerRole | Organization | RelatedPerson | Patient | CareTeam | HealthcareService | Device;

/** Identifies the food, drug or other product to be consumed or supplied in the activity. */
export type CarePlanactivitydetailproductReference_ProductReference_Union = Medication | Substance;

/**
 * Indicates another resource, such as the health condition(s), whose existence
 * justifies this request and drove the inclusion of this particular activity as
 * part of the plan.
 */
export type CarePlanactivitydetailreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference;

/**
 * Details of the outcome or action resulting from the activity.  The reference to
 * an 'event' resource, such as Procedure or Encounter or Observation, is the
 * result/outcome of the activity itself.  The activity can be conveyed using
 * CarePlan.activity.detail OR using the CarePlan.activity.reference (a reference
 * to a “request” resource).
 */
export type CarePlanactivityoutcomeReference_OutcomeReference_Union = Resource;

/** The details of the proposed activity represented in a specific resource. */
export type CarePlanactivityreference_Reference_Union = Appointment | CommunicationRequest | DeviceRequest | MedicationRequest | NutritionOrder | Task | ServiceRequest | VisionPrescription | RequestGroup;

/** Identifies the conditions/problems/concerns/diagnoses/etc. whose management and/or mitigation are handled by this plan. */
export type CarePlanaddresses_Addresses_Union = Condition;

/** When populated, the author is responsible for the care plan.  The care plan is attributed to the author. */
export type CarePlanauthor_Author_Union = Patient | Practitioner | PractitionerRole | Device | RelatedPerson | Organization | CareTeam;

/** A care plan that is fulfilled in whole or in part by this care plan. */
export type CarePlanbasedOn_BasedOn_Union = CarePlan;

/** Identifies all people and organizations who are expected to be involved in the care envisioned by this plan. */
export type CarePlancareTeam_CareTeam_Union = CareTeam;

/** Identifies the individual(s) or organization who provided the contents of the care plan. */
export type CarePlancontributor_Contributor_Union = Patient | Practitioner | PractitionerRole | Device | RelatedPerson | Organization | CareTeam;

/** The Encounter during which this CarePlan was created or to which the creation of this record is tightly associated. */
export type CarePlanencounter_Encounter_Union = Encounter;

/** Describes the intended objective(s) of carrying out the care plan. */
export type CarePlangoal_Goal_Union = Goal;

/** A larger care plan of which this particular care plan is a component or step. */
export type CarePlanpartOf_PartOf_Union = CarePlan;

/** Completed or terminated care plan whose function is taken by this new care plan. */
export type CarePlanreplaces_Replaces_Union = CarePlan;

/** Identifies the patient or group whose intended care is described by the plan. */
export type CarePlansubject_Subject_Union = Patient | Group;

/**
 * Identifies portions of the patient's record that specifically influenced the
 * formation of the plan.  These might include comorbidities, recent procedures,
 * limitations, recent assessments, etc.
 */
export type CarePlansupportingInfo_SupportingInfo_Union = Resource;

/**
 * The Care Team includes all the people and organizations who plan to participate
 * in the coordination and delivery of care for a patient.
 */
export type CareTeam = {
  __typename?: 'CareTeam';
  /** Type of resource */
  resourceType: CareTeam_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this care team by the performer or other
   * systems which remain constant as the resource is updated and propagates from
   * server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Indicates the current state of the care team. */
  _status?: Maybe<Element>;
  /** Indicates the current state of the care team. */
  status?: Maybe<Scalars['code']>;
  /**
   * Identifies what kind of team.  This is to support differentiation between
   * multiple co-existing teams, such as care plan team, episode of care team,
   * longitudinal care team.
   */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A label for human use intended to distinguish like teams.  E.g. the 'red' vs. 'green' trauma teams. */
  _name?: Maybe<Element>;
  /** A label for human use intended to distinguish like teams.  E.g. the 'red' vs. 'green' trauma teams. */
  name?: Maybe<Scalars['String']>;
  /** Identifies the patient or group whose intended care is handled by the team. */
  subject?: Maybe<CareTeamsubject_Subject_Union>;
  /** The Encounter during which this CareTeam was created or to which the creation of this record is tightly associated. */
  encounter?: Maybe<CareTeamencounter_Encounter_Union>;
  /** Indicates when the team did (or is intended to) come into effect and end. */
  period?: Maybe<Period>;
  /** Identifies all people and organizations who are expected to be involved in the care team. */
  participant?: Maybe<Array<Maybe<CareTeamparticipant>>>;
  /** Describes why the care team exists. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Condition(s) that this care team addresses. */
  reasonReference?: Maybe<Array<Maybe<CareTeamreasonReference_ReasonReference_Union>>>;
  /** The organization responsible for the care team. */
  managingOrganization?: Maybe<Array<Maybe<CareTeammanagingOrganization_ManagingOrganization_Union>>>;
  /** A central contact detail for the care team (that applies to all members). */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** Comments made about the CareTeam. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export enum CareTeam_Enum_Schema {
  CareTeam = 'CareTeam'
}

/** The Encounter during which this CareTeam was created or to which the creation of this record is tightly associated. */
export type CareTeamencounter_Encounter_Union = Encounter;

/** The organization responsible for the care team. */
export type CareTeammanagingOrganization_ManagingOrganization_Union = Organization;

export type CareTeamparticipant = {
  __typename?: 'CareTeamparticipant';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Indicates specific responsibility of an individual within the care team, such
   * as 'Primary care physician', 'Trained social worker counselor', 'Caregiver', etc.
   */
  role?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The specific person or organization who is participating/expected to participate in the care team. */
  member?: Maybe<CareTeamparticipantmember_Member_Union>;
  /** The organization of the practitioner. */
  onBehalfOf?: Maybe<CareTeamparticipantonBehalfOf_OnBehalfOf_Union>;
  /** Indicates when the specific member or organization did (or is intended to) come into effect and end. */
  period?: Maybe<Period>;
};

/** The specific person or organization who is participating/expected to participate in the care team. */
export type CareTeamparticipantmember_Member_Union = Practitioner | PractitionerRole | RelatedPerson | Patient | Organization | CareTeam;

/** The organization of the practitioner. */
export type CareTeamparticipantonBehalfOf_OnBehalfOf_Union = Organization;

/** Condition(s) that this care team addresses. */
export type CareTeamreasonReference_ReasonReference_Union = Condition;

/** Identifies the patient or group whose intended care is handled by the team. */
export type CareTeamsubject_Subject_Union = Patient | Group;

/** Catalog entries are wrappers that contextualize items included in a catalog. */
export type CatalogEntry = {
  __typename?: 'CatalogEntry';
  /** Type of resource */
  resourceType: CatalogEntry_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Used in supporting different identifiers for the same product, e.g. manufacturer code and retailer code. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The type of item - medication, device, service, protocol or other. */
  type?: Maybe<CodeableConcept>;
  /** Whether the entry represents an orderable item. */
  _orderable?: Maybe<Element>;
  /** Whether the entry represents an orderable item. */
  orderable: Scalars['Boolean'];
  /** The item in a catalog or definition. */
  referencedItem: CatalogEntryreferencedItem_ReferencedItem_Union;
  /** Used in supporting related concepts, e.g. NDC to RxNorm. */
  additionalIdentifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Classes of devices, or ATC for medication. */
  classification?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Used to support catalog exchange even for unsupported products, e.g. getting list of medications even if not prescribable. */
  _status?: Maybe<Element>;
  /** Used to support catalog exchange even for unsupported products, e.g. getting list of medications even if not prescribable. */
  status?: Maybe<Scalars['code']>;
  /** The time period in which this catalog entry is expected to be active. */
  validityPeriod?: Maybe<Period>;
  /** The date until which this catalog entry is expected to be active. */
  _validTo?: Maybe<Element>;
  /** The date until which this catalog entry is expected to be active. */
  validTo?: Maybe<Scalars['dateTime']>;
  /**
   * Typically date of issue is different from the beginning of the validity. This
   * can be used to see when an item was last updated.
   */
  _lastUpdated?: Maybe<Element>;
  /**
   * Typically date of issue is different from the beginning of the validity. This
   * can be used to see when an item was last updated.
   */
  lastUpdated?: Maybe<Scalars['dateTime']>;
  /** Used for examplefor Out of Formulary, or any specifics. */
  additionalCharacteristic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** User for example for ATC classification, or. */
  additionalClassification?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Used for example, to point to a substance, or to a device used to administer a medication. */
  relatedEntry?: Maybe<Array<Maybe<CatalogEntryrelatedEntry>>>;
};

export enum CatalogEntry_Enum_Schema {
  CatalogEntry = 'CatalogEntry'
}

/** The item in a catalog or definition. */
export type CatalogEntryreferencedItem_ReferencedItem_Union = Medication | Device | Organization | Practitioner | PractitionerRole | HealthcareService | ActivityDefinition | PlanDefinition | SpecimenDefinition | ObservationDefinition | Binary;

export type CatalogEntryrelatedEntry = {
  __typename?: 'CatalogEntryrelatedEntry';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of relation to the related item: child, parent, packageContent, containerPackage, usedIn, uses, requires, etc. */
  _relationtype?: Maybe<Element>;
  /** The type of relation to the related item: child, parent, packageContent, containerPackage, usedIn, uses, requires, etc. */
  relationtype: Scalars['code'];
  /** The reference to the related item. */
  item: CatalogEntryrelatedEntryitem_Item_Union;
};

/** The reference to the related item. */
export type CatalogEntryrelatedEntryitem_Item_Union = CatalogEntry;

/**
 * The resource ChargeItem describes the provision of healthcare provider products
 * for a certain patient, therefore referring not only to the product, but
 * containing in addition details of the provision, like date, time, amounts and
 * participating organizations and persons. Main Usage of the ChargeItem is to
 * enable the billing process and internal cost allocation.
 */
export type ChargeItem = {
  __typename?: 'ChargeItem';
  /** Type of resource */
  resourceType: ChargeItem_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifiers assigned to this event performer or other systems. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** References the (external) source of pricing information, rules of application for the code this ChargeItem uses. */
  _definitionUri?: Maybe<Element>;
  /** References the (external) source of pricing information, rules of application for the code this ChargeItem uses. */
  definitionUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** References the source of pricing information, rules of application for the code this ChargeItem uses. */
  _definitionCanonical?: Maybe<Element>;
  /** References the source of pricing information, rules of application for the code this ChargeItem uses. */
  definitionCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** The current state of the ChargeItem. */
  _status?: Maybe<Element>;
  /** The current state of the ChargeItem. */
  status: Scalars['code'];
  /** ChargeItems can be grouped to larger ChargeItems covering the whole set. */
  partOf?: Maybe<Array<Maybe<ChargeItempartOf_PartOf_Union>>>;
  /** A code that identifies the charge, like a billing code. */
  code: CodeableConcept;
  /** The individual or set of individuals the action is being or was performed on. */
  subject: ChargeItemsubject_Subject_Union;
  /** The encounter or episode of care that establishes the context for this event. */
  context?: Maybe<ChargeItemcontext_Context_Union>;
  /** Date/time(s) or duration when the charged service was applied. */
  _occurrenceDateTime?: Maybe<Element>;
  /** Date/time(s) or duration when the charged service was applied. */
  occurrenceDateTime?: Maybe<Scalars['dateTime']>;
  /** Date/time(s) or duration when the charged service was applied. */
  occurrencePeriod?: Maybe<Period>;
  /** Date/time(s) or duration when the charged service was applied. */
  occurrenceTiming?: Maybe<Timing>;
  /** Indicates who or what performed or participated in the charged service. */
  performer?: Maybe<Array<Maybe<ChargeItemperformer>>>;
  /** The organization requesting the service. */
  performingOrganization?: Maybe<ChargeItemperformingOrganization_PerformingOrganization_Union>;
  /** The organization performing the service. */
  requestingOrganization?: Maybe<ChargeItemrequestingOrganization_RequestingOrganization_Union>;
  /** The financial cost center permits the tracking of charge attribution. */
  costCenter?: Maybe<ChargeItemcostCenter_CostCenter_Union>;
  /** Quantity of which the charge item has been serviced. */
  quantity?: Maybe<Quantity>;
  /** The anatomical location where the related service has been applied. */
  bodysite?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Factor overriding the factor determined by the rules associated with the code. */
  _factorOverride?: Maybe<Element>;
  /** Factor overriding the factor determined by the rules associated with the code. */
  factorOverride?: Maybe<Scalars['Float']>;
  /** Total price of the charge overriding the list price associated with the code. */
  priceOverride?: Maybe<Money>;
  /**
   * If the list price or the rule-based factor associated with the code is
   * overridden, this attribute can capture a text to indicate the  reason for this action.
   */
  _overrideReason?: Maybe<Element>;
  /**
   * If the list price or the rule-based factor associated with the code is
   * overridden, this attribute can capture a text to indicate the  reason for this action.
   */
  overrideReason?: Maybe<Scalars['String']>;
  /** The device, practitioner, etc. who entered the charge item. */
  enterer?: Maybe<ChargeItementerer_Enterer_Union>;
  /** Date the charge item was entered. */
  _enteredDate?: Maybe<Element>;
  /** Date the charge item was entered. */
  enteredDate?: Maybe<Scalars['dateTime']>;
  /** Describes why the event occurred in coded or textual form. */
  reason?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicated the rendered service that caused this charge. */
  service?: Maybe<Array<Maybe<ChargeItemservice_Service_Union>>>;
  /** Identifies the device, food, drug or other product being charged either by type code or reference to an instance. */
  productReference?: Maybe<ChargeItemproductReference_ProductReference_Union>;
  /** Identifies the device, food, drug or other product being charged either by type code or reference to an instance. */
  productCodeableConcept?: Maybe<CodeableConcept>;
  /** Account into which this ChargeItems belongs. */
  account?: Maybe<Array<Maybe<ChargeItemaccount_Account_Union>>>;
  /** Comments made about the event by the performer, subject or other participants. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Further information supporting this charge. */
  supportingInformation?: Maybe<Array<Maybe<ChargeItemsupportingInformation_SupportingInformation_Union>>>;
};

/**
 * The ChargeItemDefinition resource provides the properties that apply to the
 * (billing) codes necessary to calculate costs and prices. The properties may
 * differ largely depending on type and realm, therefore this resource gives only a
 * rough structure and requires profiling for each type of billing code system.
 */
export type ChargeItemDefinition = {
  __typename?: 'ChargeItemDefinition';
  /** Type of resource */
  resourceType: ChargeItemDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this charge item definition when it
   * is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this charge
   * item definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the charge item definition
   * is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this charge item definition when it
   * is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this charge
   * item definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the charge item definition
   * is stored on different servers.
   */
  url: Scalars['uri'];
  /**
   * A formal identifier that is used to identify this charge item definition when
   * it is represented in other formats, or referenced in a specification, model,
   * design or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the charge item
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the charge item definition
   * author and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence. To
   * provide a version consistent with the Decision Support Service specification,
   * use the format Major.Minor.Revision (e.g. 1.0.0). For more information on
   * versioning knowledge assets, refer to the Decision Support Service
   * specification. Note that a version is required for non-experimental active assets.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the charge item
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the charge item definition
   * author and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence. To
   * provide a version consistent with the Decision Support Service specification,
   * use the format Major.Minor.Revision (e.g. 1.0.0). For more information on
   * versioning knowledge assets, refer to the Decision Support Service
   * specification. Note that a version is required for non-experimental active assets.
   */
  version?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the charge item definition. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the charge item definition. */
  title?: Maybe<Scalars['String']>;
  /**
   * The URL pointing to an externally-defined charge item definition that is
   * adhered to in whole or in part by this definition.
   */
  _derivedFromUri?: Maybe<Element>;
  /**
   * The URL pointing to an externally-defined charge item definition that is
   * adhered to in whole or in part by this definition.
   */
  derivedFromUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** A larger definition of which this particular definition is a component or step. */
  _partOf?: Maybe<Element>;
  /** A larger definition of which this particular definition is a component or step. */
  partOf?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * As new versions of a protocol or guideline are defined, allows identification
   * of what versions are replaced by a new instance.
   */
  _replaces?: Maybe<Element>;
  /**
   * As new versions of a protocol or guideline are defined, allows identification
   * of what versions are replaced by a new instance.
   */
  replaces?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** The current state of the ChargeItemDefinition. */
  _status?: Maybe<Element>;
  /** The current state of the ChargeItemDefinition. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this charge item definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this charge item definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the charge item definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the charge item definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the charge item definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the charge item definition changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the charge item definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the charge item definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the charge item definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the charge item definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate charge item
   * definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the charge item definition is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * A copyright statement relating to the charge item definition and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the charge item definition.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the charge item definition and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the charge item definition.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the charge item definition content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /** The defined billing details in this resource pertain to the given billing code. */
  code?: Maybe<CodeableConcept>;
  /** The defined billing details in this resource pertain to the given product instance(s). */
  instance?: Maybe<Array<Maybe<ChargeItemDefinitioninstance_Instance_Union>>>;
  /** Expressions that describe applicability criteria for the billing code. */
  applicability?: Maybe<Array<Maybe<ChargeItemDefinitionapplicability>>>;
  /**
   * Group of properties which are applicable under the same conditions. If no
   * applicability rules are established for the group, then all properties always apply.
   */
  propertyGroup?: Maybe<Array<Maybe<ChargeItemDefinitionpropertyGroup>>>;
};

export enum ChargeItemDefinition_Enum_Schema {
  ChargeItemDefinition = 'ChargeItemDefinition'
}

export type ChargeItemDefinitionapplicability = {
  __typename?: 'ChargeItemDefinitionapplicability';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A brief, natural language description of the condition that effectively communicates the intended semantics. */
  _description?: Maybe<Element>;
  /** A brief, natural language description of the condition that effectively communicates the intended semantics. */
  description?: Maybe<Scalars['String']>;
  /**
   * The media type of the language for the expression, e.g. 'text/cql' for
   * Clinical Query Language expressions or 'text/fhirpath' for FHIRPath expressions.
   */
  _language?: Maybe<Element>;
  /**
   * The media type of the language for the expression, e.g. 'text/cql' for
   * Clinical Query Language expressions or 'text/fhirpath' for FHIRPath expressions.
   */
  language?: Maybe<Scalars['String']>;
  /**
   * An expression that returns true or false, indicating whether the condition is
   * satisfied. When using FHIRPath expressions, the %context environment variable
   * must be replaced at runtime with the ChargeItem resource to which this
   * definition is applied.
   */
  _expression?: Maybe<Element>;
  /**
   * An expression that returns true or false, indicating whether the condition is
   * satisfied. When using FHIRPath expressions, the %context environment variable
   * must be replaced at runtime with the ChargeItem resource to which this
   * definition is applied.
   */
  expression?: Maybe<Scalars['String']>;
};

/** The defined billing details in this resource pertain to the given product instance(s). */
export type ChargeItemDefinitioninstance_Instance_Union = Medication | Substance | Device;

export type ChargeItemDefinitionpropertyGroup = {
  __typename?: 'ChargeItemDefinitionpropertyGroup';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The price for a ChargeItem may be calculated as a base price with
   * surcharges/deductions that apply in certain conditions. A ChargeItemDefinition
   * resource that defines the prices, factors and conditions that apply to a
   * billing code is currently under development. The priceComponent element can be
   * used to offer transparency to the recipient of the Invoice of how the prices
   * have been calculated.
   */
  priceComponent?: Maybe<Array<Maybe<ChargeItemDefinitionpropertyGrouppriceComponent>>>;
};

export type ChargeItemDefinitionpropertyGrouppriceComponent = {
  __typename?: 'ChargeItemDefinitionpropertyGrouppriceComponent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** This code identifies the type of the component. */
  _type?: Maybe<Element>;
  /** This code identifies the type of the component. */
  type: Scalars['code'];
  /**
   * A code that identifies the component. Codes may be used to differentiate
   * between kinds of taxes, surcharges, discounts etc.
   */
  code?: Maybe<CodeableConcept>;
  /** The factor that has been applied on the base price for calculating this component. */
  _factor?: Maybe<Element>;
  /** The factor that has been applied on the base price for calculating this component. */
  factor?: Maybe<Scalars['Float']>;
  /** The amount calculated for this component. */
  amount?: Maybe<Money>;
};

export enum ChargeItem_Enum_Schema {
  ChargeItem = 'ChargeItem'
}

/** Account into which this ChargeItems belongs. */
export type ChargeItemaccount_Account_Union = Account;

/** The encounter or episode of care that establishes the context for this event. */
export type ChargeItemcontext_Context_Union = Encounter | EpisodeOfCare;

/** The financial cost center permits the tracking of charge attribution. */
export type ChargeItemcostCenter_CostCenter_Union = Organization;

/** The device, practitioner, etc. who entered the charge item. */
export type ChargeItementerer_Enterer_Union = Practitioner | PractitionerRole | Organization | Patient | Device | RelatedPerson;

/** ChargeItems can be grouped to larger ChargeItems covering the whole set. */
export type ChargeItempartOf_PartOf_Union = ChargeItem;

export type ChargeItemperformer = {
  __typename?: 'ChargeItemperformer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Describes the type of performance or participation(e.g. primary surgeon, anesthesiologiest, etc.). */
  function?: Maybe<CodeableConcept>;
  /** The device, practitioner, etc. who performed or participated in the service. */
  actor: ChargeItemperformeractor_Actor_Union;
};

/** The device, practitioner, etc. who performed or participated in the service. */
export type ChargeItemperformeractor_Actor_Union = Practitioner | PractitionerRole | Organization | CareTeam | Patient | Device | RelatedPerson;

/** The organization requesting the service. */
export type ChargeItemperformingOrganization_PerformingOrganization_Union = Organization;

/** Identifies the device, food, drug or other product being charged either by type code or reference to an instance. */
export type ChargeItemproductReference_ProductReference_Union = Device | Medication | Substance;

/** The organization performing the service. */
export type ChargeItemrequestingOrganization_RequestingOrganization_Union = Organization;

/** Indicated the rendered service that caused this charge. */
export type ChargeItemservice_Service_Union = DiagnosticReport | ImagingStudy | Immunization | MedicationAdministration | MedicationDispense | Observation | Procedure | SupplyDelivery;

/** The individual or set of individuals the action is being or was performed on. */
export type ChargeItemsubject_Subject_Union = Patient | Group;

/** Further information supporting this charge. */
export type ChargeItemsupportingInformation_SupportingInformation_Union = Resource;

/** ChatTrackerType */
export type ChatTrackerType_Schema = {
  __typename?: 'ChatTrackerType_Schema';
  /** Type of resource */
  resourceType: ChatTracker_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  /** IP Address name. */
  ipAddress?: Maybe<Scalars['String']>;
  /** status. */
  status?: Maybe<Scalars['Boolean']>;
};

export enum ChatTracker_Enum_Input_Schema {
  ChatTracker = 'ChatTracker'
}

export enum ChatTracker_Enum_Schema {
  ChatTracker = 'ChatTracker'
}

/** ChatTracker_Input */
export type ChatTracker_Input = {
  /** Type of resource */
  resourceType: ChatTracker_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  /** Referral_Type. */
  ipAddress?: Maybe<Scalars['String']>;
  /** Referral_Type. */
  status?: Maybe<Scalars['Boolean']>;
};

/**
 * A provider issued list of professional services and products which have been
 * provided, or are to be provided, to a patient which is sent to an insurer for reimbursement.
 */
export type Claim = {
  __typename?: 'Claim';
  /** Type of resource */
  resourceType: Claim_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this claim. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status: Scalars['code'];
  /** The category of claim, e.g. oral, pharmacy, vision, institutional, professional. */
  type: CodeableConcept;
  /**
   * A finer grained suite of claim type codes which may convey additional
   * information such as Inpatient vs Outpatient and/or a specialty service.
   */
  subType?: Maybe<CodeableConcept>;
  /**
   * A code to indicate whether the nature of the request is: to request
   * adjudication of products and services previously rendered; or requesting
   * authorization and adjudication for provision in the future; or requesting the
   * non-binding adjudication of the listed products and services which could be
   * provided in the future.
   */
  _use?: Maybe<Element>;
  /**
   * A code to indicate whether the nature of the request is: to request
   * adjudication of products and services previously rendered; or requesting
   * authorization and adjudication for provision in the future; or requesting the
   * non-binding adjudication of the listed products and services which could be
   * provided in the future.
   */
  use: Scalars['code'];
  /**
   * The party to whom the professional services and/or products have been supplied
   * or are being considered and for whom actual or forecast reimbursement is sought.
   */
  patient: Claimpatient_Patient_Union;
  /** The period for which charges are being submitted. */
  billablePeriod?: Maybe<Period>;
  /** The date this resource was created. */
  _created?: Maybe<Element>;
  /** The date this resource was created. */
  created: Scalars['dateTime'];
  /** Individual who created the claim, predetermination or preauthorization. */
  enterer?: Maybe<Claimenterer_Enterer_Union>;
  /** The Insurer who is target of the request. */
  insurer?: Maybe<Claiminsurer_Insurer_Union>;
  /** The provider which is responsible for the claim, predetermination or preauthorization. */
  provider: Claimprovider_Provider_Union;
  /** The provider-required urgency of processing the request. Typical values include: stat, routine deferred. */
  priority: CodeableConcept;
  /** A code to indicate whether and for whom funds are to be reserved for future claims. */
  fundsReserve?: Maybe<CodeableConcept>;
  /**
   * Other claims which are related to this claim such as prior submissions or
   * claims for related services or for the same event.
   */
  related?: Maybe<Array<Maybe<Claimrelated>>>;
  /** Prescription to support the dispensing of pharmacy, device or vision products. */
  prescription?: Maybe<Claimprescription_Prescription_Union>;
  /**
   * Original prescription which has been superseded by this prescription to
   * support the dispensing of pharmacy services, medications or products.
   */
  originalPrescription?: Maybe<ClaimoriginalPrescription_OriginalPrescription_Union>;
  /** The party to be reimbursed for cost of the products and services according to the terms of the policy. */
  payee?: Maybe<Claimpayee>;
  /** A reference to a referral resource. */
  referral?: Maybe<Claimreferral_Referral_Union>;
  /** Facility where the services were provided. */
  facility?: Maybe<Claimfacility_Facility_Union>;
  /** The members of the team who provided the products and services. */
  careTeam?: Maybe<Array<Maybe<ClaimcareTeam>>>;
  /**
   * Additional information codes regarding exceptions, special considerations, the
   * condition, situation, prior or concurrent issues.
   */
  supportingInfo?: Maybe<Array<Maybe<ClaimsupportingInfo>>>;
  /** Information about diagnoses relevant to the claim items. */
  diagnosis?: Maybe<Array<Maybe<Claimdiagnosis>>>;
  /** Procedures performed on the patient relevant to the billing items with the claim. */
  procedure?: Maybe<Array<Maybe<Claimprocedure>>>;
  /** Financial instruments for reimbursement for the health care products and services specified on the claim. */
  insurance?: Maybe<Array<Claiminsurance>>;
  /** Details of an accident which resulted in injuries which required the products and services listed in the claim. */
  accident?: Maybe<Claimaccident>;
  /**
   * A claim line. Either a simple  product or service or a 'group' of details
   * which can each be a simple items or groups of sub-details.
   */
  item?: Maybe<Array<Maybe<Claimitem>>>;
  /** The total value of the all the items in the claim. */
  total?: Maybe<Money>;
};

/** This resource provides the adjudication details from the processing of a Claim resource. */
export type ClaimResponse = {
  __typename?: 'ClaimResponse';
  /** Type of resource */
  resourceType: ClaimResponse_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this claim response. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status: Scalars['code'];
  /**
   * A finer grained suite of claim type codes which may convey additional
   * information such as Inpatient vs Outpatient and/or a specialty service.
   */
  type: CodeableConcept;
  /**
   * A finer grained suite of claim type codes which may convey additional
   * information such as Inpatient vs Outpatient and/or a specialty service.
   */
  subType?: Maybe<CodeableConcept>;
  /**
   * A code to indicate whether the nature of the request is: to request
   * adjudication of products and services previously rendered; or requesting
   * authorization and adjudication for provision in the future; or requesting the
   * non-binding adjudication of the listed products and services which could be
   * provided in the future.
   */
  _use?: Maybe<Element>;
  /**
   * A code to indicate whether the nature of the request is: to request
   * adjudication of products and services previously rendered; or requesting
   * authorization and adjudication for provision in the future; or requesting the
   * non-binding adjudication of the listed products and services which could be
   * provided in the future.
   */
  use: Scalars['code'];
  /**
   * The party to whom the professional services and/or products have been supplied
   * or are being considered and for whom actual for facast reimbursement is sought.
   */
  patient: ClaimResponsepatient_Patient_Union;
  /** The date this resource was created. */
  _created?: Maybe<Element>;
  /** The date this resource was created. */
  created: Scalars['dateTime'];
  /** The party responsible for authorization, adjudication and reimbursement. */
  insurer: ClaimResponseinsurer_Insurer_Union;
  /** The provider which is responsible for the claim, predetermination or preauthorization. */
  requestor?: Maybe<ClaimResponserequestor_Requestor_Union>;
  /** Original request resource reference. */
  request?: Maybe<ClaimResponserequest_Request_Union>;
  /** The outcome of the claim, predetermination, or preauthorization processing. */
  _outcome?: Maybe<Element>;
  /** The outcome of the claim, predetermination, or preauthorization processing. */
  outcome: Scalars['code'];
  /** A human readable description of the status of the adjudication. */
  _disposition?: Maybe<Element>;
  /** A human readable description of the status of the adjudication. */
  disposition?: Maybe<Scalars['String']>;
  /** Reference from the Insurer which is used in later communications which refers to this adjudication. */
  _preAuthRef?: Maybe<Element>;
  /** Reference from the Insurer which is used in later communications which refers to this adjudication. */
  preAuthRef?: Maybe<Scalars['String']>;
  /** The time frame during which this authorization is effective. */
  preAuthPeriod?: Maybe<Period>;
  /** Type of Party to be reimbursed: subscriber, provider, other. */
  payeeType?: Maybe<CodeableConcept>;
  /**
   * A claim line. Either a simple (a product or service) or a 'group' of details
   * which can also be a simple items or groups of sub-details.
   */
  item?: Maybe<Array<Maybe<ClaimResponseitem>>>;
  /** The first-tier service adjudications for payor added product or service lines. */
  addItem?: Maybe<Array<Maybe<ClaimResponseaddItem>>>;
  /** Categorized monetary totals for the adjudication. */
  total?: Maybe<Array<Maybe<ClaimResponsetotal>>>;
  /** Payment details for the adjudication of the claim. */
  payment?: Maybe<ClaimResponsepayment>;
  /**
   * A code, used only on a response to a preauthorization, to indicate whether the
   * benefits payable have been reserved and for whom.
   */
  fundsReserve?: Maybe<CodeableConcept>;
  /** A code for the form to be used for printing the content. */
  formCode?: Maybe<CodeableConcept>;
  /** The actual form, by reference or inclusion, for printing the content or an EOB. */
  form?: Maybe<Attachment>;
  /** A note that describes or explains adjudication results in a human readable form. */
  processNote?: Maybe<Array<Maybe<ClaimResponseprocessNote>>>;
  /** Request for additional supporting or authorizing information. */
  communicationRequest?: Maybe<Array<Maybe<ClaimResponsecommunicationRequest_CommunicationRequest_Union>>>;
  /** Financial instruments for reimbursement for the health care products and services specified on the claim. */
  insurance?: Maybe<Array<Maybe<ClaimResponseinsurance>>>;
  /** Errors encountered during the processing of the adjudication. */
  error?: Maybe<Array<Maybe<ClaimResponseerror>>>;
};

export enum ClaimResponse_Enum_Schema {
  ClaimResponse = 'ClaimResponse'
}

export type ClaimResponseaddItem = {
  __typename?: 'ClaimResponseaddItem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Claim items which this service line is intended to replace. */
  _itemSequence?: Maybe<Element>;
  /** Claim items which this service line is intended to replace. */
  itemSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The sequence number of the details within the claim item which this line is intended to replace. */
  _detailSequence?: Maybe<Element>;
  /** The sequence number of the details within the claim item which this line is intended to replace. */
  detailSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The sequence number of the sub-details within the details within the claim item which this line is intended to replace. */
  _subdetailSequence?: Maybe<Element>;
  /** The sequence number of the sub-details within the details within the claim item which this line is intended to replace. */
  subdetailSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The providers who are authorized for the services rendered to the patient. */
  provider?: Maybe<Array<Maybe<ClaimResponseaddItemprovider_Provider_Union>>>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Identifies the program under which this may be recovered. */
  programCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  _servicedDate?: Maybe<Element>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  servicedDate?: Maybe<Scalars['date']>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  servicedPeriod?: Maybe<Period>;
  /** Where the product or service was provided. */
  locationCodeableConcept?: Maybe<CodeableConcept>;
  /** Where the product or service was provided. */
  locationAddress?: Maybe<Address>;
  /** Where the product or service was provided. */
  locationReference?: Maybe<ClaimResponseaddItemlocationReference_LocationReference_Union>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** Physical service site on the patient (limb, tooth, etc.). */
  bodySite?: Maybe<CodeableConcept>;
  /** A region or surface of the bodySite, e.g. limb region or tooth surface(s). */
  subSite?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The second-tier service adjudications for payor added services. */
  detail?: Maybe<Array<Maybe<ClaimResponseaddItemdetail>>>;
};

export type ClaimResponseaddItemdetail = {
  __typename?: 'ClaimResponseaddItemdetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The third-tier service adjudications for payor added services. */
  subDetail?: Maybe<Array<Maybe<ClaimResponseaddItemdetailsubDetail>>>;
};

export type ClaimResponseaddItemdetailsubDetail = {
  __typename?: 'ClaimResponseaddItemdetailsubDetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
};

/** Where the product or service was provided. */
export type ClaimResponseaddItemlocationReference_LocationReference_Union = Location;

/** The providers who are authorized for the services rendered to the patient. */
export type ClaimResponseaddItemprovider_Provider_Union = Practitioner | PractitionerRole | Organization;

/** Request for additional supporting or authorizing information. */
export type ClaimResponsecommunicationRequest_CommunicationRequest_Union = CommunicationRequest;

export type ClaimResponseerror = {
  __typename?: 'ClaimResponseerror';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The sequence number of the line item submitted which contains the error. This
   * value is omitted when the error occurs outside of the item structure.
   */
  _itemSequence?: Maybe<Element>;
  /**
   * The sequence number of the line item submitted which contains the error. This
   * value is omitted when the error occurs outside of the item structure.
   */
  itemSequence?: Maybe<Scalars['positiveInt']>;
  /**
   * The sequence number of the detail within the line item submitted which
   * contains the error. This value is omitted when the error occurs outside of the
   * item structure.
   */
  _detailSequence?: Maybe<Element>;
  /**
   * The sequence number of the detail within the line item submitted which
   * contains the error. This value is omitted when the error occurs outside of the
   * item structure.
   */
  detailSequence?: Maybe<Scalars['positiveInt']>;
  /**
   * The sequence number of the sub-detail within the detail within the line item
   * submitted which contains the error. This value is omitted when the error
   * occurs outside of the item structure.
   */
  _subDetailSequence?: Maybe<Element>;
  /**
   * The sequence number of the sub-detail within the detail within the line item
   * submitted which contains the error. This value is omitted when the error
   * occurs outside of the item structure.
   */
  subDetailSequence?: Maybe<Scalars['positiveInt']>;
  /** An error code, from a specified code system, which details why the claim could not be adjudicated. */
  code: CodeableConcept;
};

export type ClaimResponseinsurance = {
  __typename?: 'ClaimResponseinsurance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A number to uniquely identify insurance entries and provide a sequence of
   * coverages to convey coordination of benefit order.
   */
  _sequence?: Maybe<Element>;
  /**
   * A number to uniquely identify insurance entries and provide a sequence of
   * coverages to convey coordination of benefit order.
   */
  sequence: Scalars['positiveInt'];
  /** A flag to indicate that this Coverage is to be used for adjudication of this claim when set to true. */
  _focal?: Maybe<Element>;
  /** A flag to indicate that this Coverage is to be used for adjudication of this claim when set to true. */
  focal: Scalars['Boolean'];
  /**
   * Reference to the insurance card level information contained in the Coverage
   * resource. The coverage issuing insurer will use these details to locate the
   * patient's actual coverage within the insurer's information system.
   */
  coverage: ClaimResponseinsurancecoverage_Coverage_Union;
  /** A business agreement number established between the provider and the insurer for special business processing purposes. */
  _businessArrangement?: Maybe<Element>;
  /** A business agreement number established between the provider and the insurer for special business processing purposes. */
  businessArrangement?: Maybe<Scalars['String']>;
  /** The result of the adjudication of the line items for the Coverage specified in this insurance. */
  claimResponse?: Maybe<ClaimResponseinsuranceclaimResponse_ClaimResponse_Union>;
};

/** The result of the adjudication of the line items for the Coverage specified in this insurance. */
export type ClaimResponseinsuranceclaimResponse_ClaimResponse_Union = ClaimResponse;

/**
 * Reference to the insurance card level information contained in the Coverage
 * resource. The coverage issuing insurer will use these details to locate the
 * patient's actual coverage within the insurer's information system.
 */
export type ClaimResponseinsurancecoverage_Coverage_Union = Coverage;

/** The party responsible for authorization, adjudication and reimbursement. */
export type ClaimResponseinsurer_Insurer_Union = Organization;

export type ClaimResponseitem = {
  __typename?: 'ClaimResponseitem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely reference the claim item entries. */
  _itemSequence?: Maybe<Element>;
  /** A number to uniquely reference the claim item entries. */
  itemSequence: Scalars['positiveInt'];
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /**
   * If this item is a group then the values here are a summary of the adjudication
   * of the detail items. If this item is a simple product or service then this is
   * the result of the adjudication of this item.
   */
  adjudication?: Maybe<Array<ClaimResponseitemadjudication>>;
  /** A claim detail. Either a simple (a product or service) or a 'group' of sub-details which are simple items. */
  detail?: Maybe<Array<Maybe<ClaimResponseitemdetail>>>;
};

export type ClaimResponseitemadjudication = {
  __typename?: 'ClaimResponseitemadjudication';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A code to indicate the information type of this adjudication record.
   * Information types may include the value submitted, maximum values or
   * percentages allowed or payable under the plan, amounts that: the patient is
   * responsible for in aggregate or pertaining to this item; amounts paid by other
   * coverages; and, the benefit payable for this item.
   */
  category: CodeableConcept;
  /** A code supporting the understanding of the adjudication result and explaining variance from expected amount. */
  reason?: Maybe<CodeableConcept>;
  /** Monetary amount associated with the category. */
  amount?: Maybe<Money>;
  /** A non-monetary value associated with the category. Mutually exclusive to the amount element above. */
  _value?: Maybe<Element>;
  /** A non-monetary value associated with the category. Mutually exclusive to the amount element above. */
  value?: Maybe<Scalars['Float']>;
};

export type ClaimResponseitemdetail = {
  __typename?: 'ClaimResponseitemdetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely reference the claim detail entry. */
  _detailSequence?: Maybe<Element>;
  /** A number to uniquely reference the claim detail entry. */
  detailSequence: Scalars['positiveInt'];
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** A sub-detail adjudication of a simple product or service. */
  subDetail?: Maybe<Array<Maybe<ClaimResponseitemdetailsubDetail>>>;
};

export type ClaimResponseitemdetailsubDetail = {
  __typename?: 'ClaimResponseitemdetailsubDetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely reference the claim sub-detail entry. */
  _subDetailSequence?: Maybe<Element>;
  /** A number to uniquely reference the claim sub-detail entry. */
  subDetailSequence: Scalars['positiveInt'];
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
};

/**
 * The party to whom the professional services and/or products have been supplied
 * or are being considered and for whom actual for facast reimbursement is sought.
 */
export type ClaimResponsepatient_Patient_Union = Patient;

export type ClaimResponsepayment = {
  __typename?: 'ClaimResponsepayment';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Whether this represents partial or complete payment of the benefits payable. */
  type: CodeableConcept;
  /**
   * Total amount of all adjustments to this payment included in this transaction
   * which are not related to this claim's adjudication.
   */
  adjustment?: Maybe<Money>;
  /** Reason for the payment adjustment. */
  adjustmentReason?: Maybe<CodeableConcept>;
  /** Estimated date the payment will be issued or the actual issue date of payment. */
  _date?: Maybe<Element>;
  /** Estimated date the payment will be issued or the actual issue date of payment. */
  date?: Maybe<Scalars['date']>;
  /** Benefits payable less any payment adjustment. */
  amount: Money;
  /** Issuer's unique identifier for the payment instrument. */
  identifier?: Maybe<Identifier>;
};

export type ClaimResponseprocessNote = {
  __typename?: 'ClaimResponseprocessNote';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify a note entry. */
  _number?: Maybe<Element>;
  /** A number to uniquely identify a note entry. */
  number?: Maybe<Scalars['positiveInt']>;
  /** The business purpose of the note text. */
  _type?: Maybe<Element>;
  /** The business purpose of the note text. */
  type?: Maybe<Scalars['code']>;
  /** The explanation or description associated with the processing. */
  _text?: Maybe<Element>;
  /** The explanation or description associated with the processing. */
  text: Scalars['String'];
  /** A code to define the language used in the text of the note. */
  language?: Maybe<CodeableConcept>;
};

/** Original request resource reference. */
export type ClaimResponserequest_Request_Union = Claim;

/** The provider which is responsible for the claim, predetermination or preauthorization. */
export type ClaimResponserequestor_Requestor_Union = Practitioner | PractitionerRole | Organization;

export type ClaimResponsetotal = {
  __typename?: 'ClaimResponsetotal';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A code to indicate the information type of this adjudication record.
   * Information types may include: the value submitted, maximum values or
   * percentages allowed or payable under the plan, amounts that the patient is
   * responsible for in aggregate or pertaining to this item, amounts paid by other
   * coverages, and the benefit payable for this item.
   */
  category: CodeableConcept;
  /** Monetary total amount associated with the category. */
  amount: Money;
};

export enum Claim_Enum_Schema {
  Claim = 'Claim'
}

export type Claimaccident = {
  __typename?: 'Claimaccident';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Date of an accident event  related to the products and services contained in the claim. */
  _date?: Maybe<Element>;
  /** Date of an accident event  related to the products and services contained in the claim. */
  date: Scalars['date'];
  /**
   * The type or context of the accident event for the purposes of selection of
   * potential insurance coverages and determination of coordination between insurers.
   */
  type?: Maybe<CodeableConcept>;
  /** The physical location of the accident event. */
  locationAddress?: Maybe<Address>;
  /** The physical location of the accident event. */
  locationReference?: Maybe<ClaimaccidentlocationReference_LocationReference_Union>;
};

/** The physical location of the accident event. */
export type ClaimaccidentlocationReference_LocationReference_Union = Location;

export type ClaimcareTeam = {
  __typename?: 'ClaimcareTeam';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify care team entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify care team entries. */
  sequence: Scalars['positiveInt'];
  /** Member of the team who provided the product or service. */
  provider: ClaimcareTeamprovider_Provider_Union;
  /** The party who is billing and/or responsible for the claimed products or services. */
  _responsible?: Maybe<Element>;
  /** The party who is billing and/or responsible for the claimed products or services. */
  responsible?: Maybe<Scalars['Boolean']>;
  /** The lead, assisting or supervising practitioner and their discipline if a multidisciplinary team. */
  role?: Maybe<CodeableConcept>;
  /** The qualification of the practitioner which is applicable for this service. */
  qualification?: Maybe<CodeableConcept>;
};

/** Member of the team who provided the product or service. */
export type ClaimcareTeamprovider_Provider_Union = Practitioner | PractitionerRole | Organization;

export type Claimdiagnosis = {
  __typename?: 'Claimdiagnosis';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify diagnosis entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify diagnosis entries. */
  sequence: Scalars['positiveInt'];
  /** The nature of illness or problem in a coded form or as a reference to an external defined Condition. */
  diagnosisCodeableConcept: CodeableConcept;
  /** The nature of illness or problem in a coded form or as a reference to an external defined Condition. */
  diagnosisReference: ClaimdiagnosisdiagnosisReference_DiagnosisReference_Union;
  /** When the condition was observed or the relative ranking. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indication of whether the diagnosis was present on admission to a facility. */
  onAdmission?: Maybe<CodeableConcept>;
  /**
   * A package billing code or bundle code used to group products and services to a
   * particular health condition (such as heart attack) which is based on a
   * predetermined grouping code system.
   */
  packageCode?: Maybe<CodeableConcept>;
};

/** The nature of illness or problem in a coded form or as a reference to an external defined Condition. */
export type ClaimdiagnosisdiagnosisReference_DiagnosisReference_Union = Condition;

/** Individual who created the claim, predetermination or preauthorization. */
export type Claimenterer_Enterer_Union = Practitioner | PractitionerRole;

/** Facility where the services were provided. */
export type Claimfacility_Facility_Union = Location;

export type Claiminsurance = {
  __typename?: 'Claiminsurance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A number to uniquely identify insurance entries and provide a sequence of
   * coverages to convey coordination of benefit order.
   */
  _sequence?: Maybe<Element>;
  /**
   * A number to uniquely identify insurance entries and provide a sequence of
   * coverages to convey coordination of benefit order.
   */
  sequence: Scalars['positiveInt'];
  /** A flag to indicate that this Coverage is to be used for adjudication of this claim when set to true. */
  _focal?: Maybe<Element>;
  /** A flag to indicate that this Coverage is to be used for adjudication of this claim when set to true. */
  focal: Scalars['Boolean'];
  /** The business identifier to be used when the claim is sent for adjudication against this insurance policy. */
  identifier?: Maybe<Identifier>;
  /**
   * Reference to the insurance card level information contained in the Coverage
   * resource. The coverage issuing insurer will use these details to locate the
   * patient's actual coverage within the insurer's information system.
   */
  coverage: Claiminsurancecoverage_Coverage_Union;
  /** A business agreement number established between the provider and the insurer for special business processing purposes. */
  _businessArrangement?: Maybe<Element>;
  /** A business agreement number established between the provider and the insurer for special business processing purposes. */
  businessArrangement?: Maybe<Scalars['String']>;
  /**
   * Reference numbers previously provided by the insurer to the provider to be
   * quoted on subsequent claims containing services or products related to the
   * prior authorization.
   */
  _preAuthRef?: Maybe<Element>;
  /**
   * Reference numbers previously provided by the insurer to the provider to be
   * quoted on subsequent claims containing services or products related to the
   * prior authorization.
   */
  preAuthRef?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The result of the adjudication of the line items for the Coverage specified in this insurance. */
  claimResponse?: Maybe<ClaiminsuranceclaimResponse_ClaimResponse_Union>;
};

/** The result of the adjudication of the line items for the Coverage specified in this insurance. */
export type ClaiminsuranceclaimResponse_ClaimResponse_Union = ClaimResponse;

/**
 * Reference to the insurance card level information contained in the Coverage
 * resource. The coverage issuing insurer will use these details to locate the
 * patient's actual coverage within the insurer's information system.
 */
export type Claiminsurancecoverage_Coverage_Union = Coverage;

/** The Insurer who is target of the request. */
export type Claiminsurer_Insurer_Union = Organization;

export type Claimitem = {
  __typename?: 'Claimitem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify item entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify item entries. */
  sequence: Scalars['positiveInt'];
  /** CareTeam members related to this service or product. */
  _careTeamSequence?: Maybe<Element>;
  /** CareTeam members related to this service or product. */
  careTeamSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** Diagnosis applicable for this service or product. */
  _diagnosisSequence?: Maybe<Element>;
  /** Diagnosis applicable for this service or product. */
  diagnosisSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** Procedures applicable for this service or product. */
  _procedureSequence?: Maybe<Element>;
  /** Procedures applicable for this service or product. */
  procedureSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** Exceptions, special conditions and supporting information applicable for this service or product. */
  _informationSequence?: Maybe<Element>;
  /** Exceptions, special conditions and supporting information applicable for this service or product. */
  informationSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The type of revenue or cost center providing the product and/or service. */
  revenue?: Maybe<CodeableConcept>;
  /** Code to identify the general type of benefits under which products and services are provided. */
  category?: Maybe<CodeableConcept>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Identifies the program under which this may be recovered. */
  programCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  _servicedDate?: Maybe<Element>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  servicedDate?: Maybe<Scalars['date']>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  servicedPeriod?: Maybe<Period>;
  /** Where the product or service was provided. */
  locationCodeableConcept?: Maybe<CodeableConcept>;
  /** Where the product or service was provided. */
  locationAddress?: Maybe<Address>;
  /** Where the product or service was provided. */
  locationReference?: Maybe<ClaimitemlocationReference_LocationReference_Union>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** Unique Device Identifiers associated with this line item. */
  udi?: Maybe<Array<Maybe<Claimitemudi_Udi_Union>>>;
  /** Physical service site on the patient (limb, tooth, etc.). */
  bodySite?: Maybe<CodeableConcept>;
  /** A region or surface of the bodySite, e.g. limb region or tooth surface(s). */
  subSite?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The Encounters during which this Claim was created or to which the creation of this record is tightly associated. */
  encounter?: Maybe<Array<Maybe<Claimitemencounter_Encounter_Union>>>;
  /** A claim detail line. Either a simple (a product or service) or a 'group' of sub-details which are simple items. */
  detail?: Maybe<Array<Maybe<Claimitemdetail>>>;
};

export type Claimitemdetail = {
  __typename?: 'Claimitemdetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify item entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify item entries. */
  sequence: Scalars['positiveInt'];
  /** The type of revenue or cost center providing the product and/or service. */
  revenue?: Maybe<CodeableConcept>;
  /** Code to identify the general type of benefits under which products and services are provided. */
  category?: Maybe<CodeableConcept>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Identifies the program under which this may be recovered. */
  programCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** Unique Device Identifiers associated with this line item. */
  udi?: Maybe<Array<Maybe<Claimitemdetailudi_Udi_Union>>>;
  /** A claim detail line. Either a simple (a product or service) or a 'group' of sub-details which are simple items. */
  subDetail?: Maybe<Array<Maybe<ClaimitemdetailsubDetail>>>;
};

export type ClaimitemdetailsubDetail = {
  __typename?: 'ClaimitemdetailsubDetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify item entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify item entries. */
  sequence: Scalars['positiveInt'];
  /** The type of revenue or cost center providing the product and/or service. */
  revenue?: Maybe<CodeableConcept>;
  /** Code to identify the general type of benefits under which products and services are provided. */
  category?: Maybe<CodeableConcept>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Identifies the program under which this may be recovered. */
  programCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** Unique Device Identifiers associated with this line item. */
  udi?: Maybe<Array<Maybe<ClaimitemdetailsubDetailudi_Udi_Union>>>;
};

/** Unique Device Identifiers associated with this line item. */
export type ClaimitemdetailsubDetailudi_Udi_Union = Device;

/** Unique Device Identifiers associated with this line item. */
export type Claimitemdetailudi_Udi_Union = Device;

/** The Encounters during which this Claim was created or to which the creation of this record is tightly associated. */
export type Claimitemencounter_Encounter_Union = Encounter;

/** Where the product or service was provided. */
export type ClaimitemlocationReference_LocationReference_Union = Location;

/** Unique Device Identifiers associated with this line item. */
export type Claimitemudi_Udi_Union = Device;

/**
 * Original prescription which has been superseded by this prescription to support
 * the dispensing of pharmacy services, medications or products.
 */
export type ClaimoriginalPrescription_OriginalPrescription_Union = DeviceRequest | MedicationRequest | VisionPrescription;

/**
 * The party to whom the professional services and/or products have been supplied
 * or are being considered and for whom actual or forecast reimbursement is sought.
 */
export type Claimpatient_Patient_Union = Patient;

export type Claimpayee = {
  __typename?: 'Claimpayee';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of Party to be reimbursed: subscriber, provider, other. */
  type: CodeableConcept;
  /** Reference to the individual or organization to whom any payment will be made. */
  party?: Maybe<Claimpayeeparty_Party_Union>;
};

/** Reference to the individual or organization to whom any payment will be made. */
export type Claimpayeeparty_Party_Union = Practitioner | PractitionerRole | Organization | Patient | RelatedPerson;

/** Prescription to support the dispensing of pharmacy, device or vision products. */
export type Claimprescription_Prescription_Union = DeviceRequest | MedicationRequest | VisionPrescription;

export type Claimprocedure = {
  __typename?: 'Claimprocedure';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify procedure entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify procedure entries. */
  sequence: Scalars['positiveInt'];
  /** When the condition was observed or the relative ranking. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Date and optionally time the procedure was performed. */
  _date?: Maybe<Element>;
  /** Date and optionally time the procedure was performed. */
  date?: Maybe<Scalars['dateTime']>;
  /** The code or reference to a Procedure resource which identifies the clinical intervention performed. */
  procedureCodeableConcept: CodeableConcept;
  /** The code or reference to a Procedure resource which identifies the clinical intervention performed. */
  procedureReference: ClaimprocedureprocedureReference_ProcedureReference_Union;
  /** Unique Device Identifiers associated with this line item. */
  udi?: Maybe<Array<Maybe<Claimprocedureudi_Udi_Union>>>;
};

/** The code or reference to a Procedure resource which identifies the clinical intervention performed. */
export type ClaimprocedureprocedureReference_ProcedureReference_Union = Procedure;

/** Unique Device Identifiers associated with this line item. */
export type Claimprocedureudi_Udi_Union = Device;

/** The provider which is responsible for the claim, predetermination or preauthorization. */
export type Claimprovider_Provider_Union = Practitioner | PractitionerRole | Organization;

/** A reference to a referral resource. */
export type Claimreferral_Referral_Union = ServiceRequest;

export type Claimrelated = {
  __typename?: 'Claimrelated';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Reference to a related claim. */
  claim?: Maybe<Claimrelatedclaim_Claim_Union>;
  /** A code to convey how the claims are related. */
  relationship?: Maybe<CodeableConcept>;
  /** An alternate organizational reference to the case or file to which this particular claim pertains. */
  reference?: Maybe<Identifier>;
};

/** Reference to a related claim. */
export type Claimrelatedclaim_Claim_Union = Claim;

export type ClaimsupportingInfo = {
  __typename?: 'ClaimsupportingInfo';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify supporting information entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify supporting information entries. */
  sequence: Scalars['positiveInt'];
  /** The general class of the information supplied: information; exception; accident, employment; onset, etc. */
  category: CodeableConcept;
  /**
   * System and code pertaining to the specific information regarding special
   * conditions relating to the setting, treatment or patient  for which care is sought.
   */
  code?: Maybe<CodeableConcept>;
  /** The date when or period to which this information refers. */
  _timingDate?: Maybe<Element>;
  /** The date when or period to which this information refers. */
  timingDate?: Maybe<Scalars['date']>;
  /** The date when or period to which this information refers. */
  timingPeriod?: Maybe<Period>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  _valueBoolean?: Maybe<Element>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  _valueString?: Maybe<Element>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  valueString?: Maybe<Scalars['String']>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  valueQuantity?: Maybe<Quantity>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  valueAttachment?: Maybe<Attachment>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  valueReference?: Maybe<ClaimsupportingInfovalueReference_ValueReference_Union>;
  /** Provides the reason in the situation where a reason code is required in addition to the content. */
  reason?: Maybe<CodeableConcept>;
};

/**
 * Additional data or information such as resources, documents, images etc.
 * including references to the data or the actual inclusion of the data.
 */
export type ClaimsupportingInfovalueReference_ValueReference_Union = Resource;

/**
 * A record of a clinical assessment performed to determine what problem(s) may
 * affect the patient and before planning the treatments or management strategies
 * that are best to manage a patient's condition. Assessments are often 1:1 with a
 * clinical consultation / encounter,  but this varies greatly depending on the
 * clinical workflow. This resource is called 'ClinicalImpression' rather than
 * 'ClinicalAssessment' to avoid confusion with the recording of assessment tools
 * such as Apgar score.
 */
export type ClinicalImpression = {
  __typename?: 'ClinicalImpression';
  /** Type of resource */
  resourceType: ClinicalImpression_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this clinical impression by the performer or
   * other systems which remain constant as the resource is updated and propagates
   * from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Identifies the workflow status of the assessment. */
  _status?: Maybe<Element>;
  /** Identifies the workflow status of the assessment. */
  status: Scalars['code'];
  /** Captures the reason for the current state of the ClinicalImpression. */
  statusReason?: Maybe<CodeableConcept>;
  /** Categorizes the type of clinical assessment performed. */
  code?: Maybe<CodeableConcept>;
  /**
   * A summary of the context and/or cause of the assessment - why / where it was
   * performed, and what patient events/status prompted it.
   */
  _description?: Maybe<Element>;
  /**
   * A summary of the context and/or cause of the assessment - why / where it was
   * performed, and what patient events/status prompted it.
   */
  description?: Maybe<Scalars['String']>;
  /** The patient or group of individuals assessed as part of this record. */
  subject: ClinicalImpressionsubject_Subject_Union;
  /**
   * The Encounter during which this ClinicalImpression was created or to which the
   * creation of this record is tightly associated.
   */
  encounter?: Maybe<ClinicalImpressionencounter_Encounter_Union>;
  /** The point in time or period over which the subject was assessed. */
  _effectiveDateTime?: Maybe<Element>;
  /** The point in time or period over which the subject was assessed. */
  effectiveDateTime?: Maybe<Scalars['dateTime']>;
  /** The point in time or period over which the subject was assessed. */
  effectivePeriod?: Maybe<Period>;
  /** Indicates when the documentation of the assessment was complete. */
  _date?: Maybe<Element>;
  /** Indicates when the documentation of the assessment was complete. */
  date?: Maybe<Scalars['dateTime']>;
  /** The clinician performing the assessment. */
  assessor?: Maybe<ClinicalImpressionassessor_Assessor_Union>;
  /**
   * A reference to the last assessment that was conducted on this patient.
   * Assessments are often/usually ongoing in nature; a care provider (practitioner
   * or team) will make new assessments on an ongoing basis as new data arises or
   * the patient's conditions changes.
   */
  previous?: Maybe<ClinicalImpressionprevious_Previous_Union>;
  /** A list of the relevant problems/conditions for a patient. */
  problem?: Maybe<Array<Maybe<ClinicalImpressionproblem_Problem_Union>>>;
  /**
   * One or more sets of investigations (signs, symptoms, etc.). The actual
   * grouping of investigations varies greatly depending on the type and context of
   * the assessment. These investigations may include data generated during the
   * assessment process, or data previously generated and recorded that is
   * pertinent to the outcomes.
   */
  investigation?: Maybe<Array<Maybe<ClinicalImpressioninvestigation>>>;
  /**
   * Reference to a specific published clinical protocol that was followed during
   * this assessment, and/or that provides evidence in support of the diagnosis.
   */
  _protocol?: Maybe<Element>;
  /**
   * Reference to a specific published clinical protocol that was followed during
   * this assessment, and/or that provides evidence in support of the diagnosis.
   */
  protocol?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** A text summary of the investigations and the diagnosis. */
  _summary?: Maybe<Element>;
  /** A text summary of the investigations and the diagnosis. */
  summary?: Maybe<Scalars['String']>;
  /** Specific findings or diagnoses that were considered likely or relevant to ongoing treatment. */
  finding?: Maybe<Array<Maybe<ClinicalImpressionfinding>>>;
  /** Estimate of likely outcome. */
  prognosisCodeableConcept?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** RiskAssessment expressing likely outcome. */
  prognosisReference?: Maybe<Array<Maybe<ClinicalImpressionprognosisReference_PrognosisReference_Union>>>;
  /** Information supporting the clinical impression. */
  supportingInfo?: Maybe<Array<Maybe<ClinicalImpressionsupportingInfo_SupportingInfo_Union>>>;
  /**
   * Commentary about the impression, typically recorded after the impression
   * itself was made, though supplemental notes by the original author could also appear.
   */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export enum ClinicalImpression_Enum_Schema {
  ClinicalImpression = 'ClinicalImpression'
}

/** The clinician performing the assessment. */
export type ClinicalImpressionassessor_Assessor_Union = Practitioner | PractitionerRole;

/**
 * The Encounter during which this ClinicalImpression was created or to which the
 * creation of this record is tightly associated.
 */
export type ClinicalImpressionencounter_Encounter_Union = Encounter;

export type ClinicalImpressionfinding = {
  __typename?: 'ClinicalImpressionfinding';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Specific text or code for finding or diagnosis, which may include ruled-out or resolved conditions. */
  itemCodeableConcept?: Maybe<CodeableConcept>;
  /** Specific reference for finding or diagnosis, which may include ruled-out or resolved conditions. */
  itemReference?: Maybe<ClinicalImpressionfindingitemReference_ItemReference_Union>;
  /** Which investigations support finding or diagnosis. */
  _basis?: Maybe<Element>;
  /** Which investigations support finding or diagnosis. */
  basis?: Maybe<Scalars['String']>;
};

/** Specific reference for finding or diagnosis, which may include ruled-out or resolved conditions. */
export type ClinicalImpressionfindingitemReference_ItemReference_Union = Condition | Observation | Media;

export type ClinicalImpressioninvestigation = {
  __typename?: 'ClinicalImpressioninvestigation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A name/code for the group ('set') of investigations. Typically, this will be
   * something like 'signs', 'symptoms', 'clinical', 'diagnostic', but the list is
   * not constrained, and others such groups such as
   * (exposure|family|travel|nutritional) history may be used.
   */
  code: CodeableConcept;
  /** A record of a specific investigation that was undertaken. */
  item?: Maybe<Array<Maybe<ClinicalImpressioninvestigationitem_Item_Union>>>;
};

/** A record of a specific investigation that was undertaken. */
export type ClinicalImpressioninvestigationitem_Item_Union = Observation | QuestionnaireResponse | FamilyMemberHistory | DiagnosticReport | RiskAssessment | ImagingStudy | Media;

/**
 * A reference to the last assessment that was conducted on this patient.
 * Assessments are often/usually ongoing in nature; a care provider (practitioner
 * or team) will make new assessments on an ongoing basis as new data arises or the
 * patient's conditions changes.
 */
export type ClinicalImpressionprevious_Previous_Union = ClinicalImpression;

/** A list of the relevant problems/conditions for a patient. */
export type ClinicalImpressionproblem_Problem_Union = Condition | AllergyIntolerance;

/** RiskAssessment expressing likely outcome. */
export type ClinicalImpressionprognosisReference_PrognosisReference_Union = RiskAssessment;

/** The patient or group of individuals assessed as part of this record. */
export type ClinicalImpressionsubject_Subject_Union = Patient | Group;

/** Information supporting the clinical impression. */
export type ClinicalImpressionsupportingInfo_SupportingInfo_Union = Resource;

/**
 * The CodeSystem resource is used to declare the existence of and describe a code
 * system or code system supplement and its key properties, and optionally define a
 * part or all of its content.
 */
export type CodeSystem = {
  __typename?: 'CodeSystem';
  /** Type of resource */
  resourceType: CodeSystem_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this code system when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this code system is (or
   * will be) published. This URL can be the target of a canonical reference. It
   * SHALL remain the same when the code system is stored on different servers.
   * This is used in [Coding](datatypes.html#Coding).system.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this code system when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this code system is (or
   * will be) published. This URL can be the target of a canonical reference. It
   * SHALL remain the same when the code system is stored on different servers.
   * This is used in [Coding](datatypes.html#Coding).system.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this code system when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the code system when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the code system author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence. This is used in
   * [Coding](datatypes.html#Coding).version.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the code system when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the code system author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence. This is used in
   * [Coding](datatypes.html#Coding).version.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the code system. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the code system. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the code system. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the code system. */
  title?: Maybe<Scalars['String']>;
  /** The date (and optionally time) when the code system resource was created or revised. */
  _status?: Maybe<Element>;
  /** The date (and optionally time) when the code system resource was created or revised. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this code system is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this code system is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the code system was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the code system changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the code system was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the code system changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the code system. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the code system. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the code system from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the code system from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate code system instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the code system is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this code system is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this code system is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the code system and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the code system.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the code system and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the code system.
   */
  copyright?: Maybe<Scalars['String']>;
  /** If code comparison is case sensitive when codes within this system are compared to each other. */
  _caseSensitive?: Maybe<Element>;
  /** If code comparison is case sensitive when codes within this system are compared to each other. */
  caseSensitive?: Maybe<Scalars['Boolean']>;
  /** Canonical reference to the value set that contains the entire code system. */
  _valueSet?: Maybe<Element>;
  /** Canonical reference to the value set that contains the entire code system. */
  valueSet?: Maybe<Scalars['canonical']>;
  /** The meaning of the hierarchy of concepts as represented in this resource. */
  _hierarchyMeaning?: Maybe<Element>;
  /** The meaning of the hierarchy of concepts as represented in this resource. */
  hierarchyMeaning?: Maybe<Scalars['code']>;
  /** The code system defines a compositional (post-coordination) grammar. */
  _compositional?: Maybe<Element>;
  /** The code system defines a compositional (post-coordination) grammar. */
  compositional?: Maybe<Scalars['Boolean']>;
  /**
   * This flag is used to signify that the code system does not commit to concept
   * permanence across versions. If true, a version must be specified when
   * referencing this code system.
   */
  _versionNeeded?: Maybe<Element>;
  /**
   * This flag is used to signify that the code system does not commit to concept
   * permanence across versions. If true, a version must be specified when
   * referencing this code system.
   */
  versionNeeded?: Maybe<Scalars['Boolean']>;
  /**
   * The extent of the content of the code system (the concepts and codes it
   * defines) are represented in this resource instance.
   */
  _content?: Maybe<Element>;
  /**
   * The extent of the content of the code system (the concepts and codes it
   * defines) are represented in this resource instance.
   */
  content: Scalars['code'];
  /** The canonical URL of the code system that this code system supplement is adding designations and properties to. */
  _supplements?: Maybe<Element>;
  /** The canonical URL of the code system that this code system supplement is adding designations and properties to. */
  supplements?: Maybe<Scalars['canonical']>;
  /**
   * The total number of concepts defined by the code system. Where the code system
   * has a compositional grammar, the basis of this count is defined by the system steward.
   */
  _count?: Maybe<Element>;
  /**
   * The total number of concepts defined by the code system. Where the code system
   * has a compositional grammar, the basis of this count is defined by the system steward.
   */
  count?: Maybe<Scalars['unsignedInt']>;
  /** A filter that can be used in a value set compose statement when selecting concepts using a filter. */
  filter?: Maybe<Array<Maybe<CodeSystemfilter>>>;
  /** A property defines an additional slot through which additional information can be provided about a concept. */
  property?: Maybe<Array<Maybe<CodeSystemproperty>>>;
  /**
   * Concepts that are in the code system. The concept definitions are inherently
   * hierarchical, but the definitions must be consulted to determine what the
   * meanings of the hierarchical relationships are.
   */
  concept?: Maybe<Array<Maybe<CodeSystemconcept>>>;
};

export enum CodeSystem_Enum_Schema {
  CodeSystem = 'CodeSystem'
}

export type CodeSystemconcept = {
  __typename?: 'CodeSystemconcept';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A code - a text symbol - that uniquely identifies the concept within the code system. */
  _code?: Maybe<Element>;
  /** A code - a text symbol - that uniquely identifies the concept within the code system. */
  code: Scalars['code'];
  /** A human readable string that is the recommended default way to present this concept to a user. */
  _display?: Maybe<Element>;
  /** A human readable string that is the recommended default way to present this concept to a user. */
  display?: Maybe<Scalars['String']>;
  /**
   * The formal definition of the concept. The code system resource does not make
   * formal definitions required, because of the prevalence of legacy systems.
   * However, they are highly recommended, as without them there is no formal
   * meaning associated with the concept.
   */
  _definition?: Maybe<Element>;
  /**
   * The formal definition of the concept. The code system resource does not make
   * formal definitions required, because of the prevalence of legacy systems.
   * However, they are highly recommended, as without them there is no formal
   * meaning associated with the concept.
   */
  definition?: Maybe<Scalars['String']>;
  /**
   * Additional representations for the concept - other languages, aliases,
   * specialized purposes, used for particular purposes, etc.
   */
  designation?: Maybe<Array<Maybe<CodeSystemconceptdesignation>>>;
  /** A property value for this concept. */
  property?: Maybe<Array<Maybe<CodeSystemconceptproperty>>>;
};

export type CodeSystemconceptdesignation = {
  __typename?: 'CodeSystemconceptdesignation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The language this designation is defined for. */
  _language?: Maybe<Element>;
  /** The language this designation is defined for. */
  language?: Maybe<Scalars['code']>;
  /** A code that details how this designation would be used. */
  use?: Maybe<Coding>;
  /** The text value for this designation. */
  _value?: Maybe<Element>;
  /** The text value for this designation. */
  value: Scalars['String'];
};

export type CodeSystemconceptproperty = {
  __typename?: 'CodeSystemconceptproperty';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A code that is a reference to CodeSystem.property.code. */
  _code?: Maybe<Element>;
  /** A code that is a reference to CodeSystem.property.code. */
  code: Scalars['code'];
  /** The value of this property. */
  _valueCode?: Maybe<Element>;
  /** The value of this property. */
  valueCode: Scalars['code'];
  /** The value of this property. */
  valueCoding: Coding;
  /** The value of this property. */
  _valueString?: Maybe<Element>;
  /** The value of this property. */
  valueString: Scalars['String'];
  /** The value of this property. */
  _valueInteger?: Maybe<Element>;
  /** The value of this property. */
  valueInteger: Scalars['Int'];
  /** The value of this property. */
  _valueBoolean?: Maybe<Element>;
  /** The value of this property. */
  valueBoolean: Scalars['Boolean'];
  /** The value of this property. */
  _valueDateTime?: Maybe<Element>;
  /** The value of this property. */
  valueDateTime: Scalars['dateTime'];
  /** The value of this property. */
  _valueDecimal?: Maybe<Element>;
  /** The value of this property. */
  valueDecimal: Scalars['Float'];
};

export type CodeSystemfilter = {
  __typename?: 'CodeSystemfilter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The code that identifies this filter when it is used as a filter in [ValueSet](valueset.html#).compose.include.filter. */
  _code?: Maybe<Element>;
  /** The code that identifies this filter when it is used as a filter in [ValueSet](valueset.html#).compose.include.filter. */
  code: Scalars['code'];
  /** A description of how or why the filter is used. */
  _description?: Maybe<Element>;
  /** A description of how or why the filter is used. */
  description?: Maybe<Scalars['String']>;
  /** A list of operators that can be used with the filter. */
  _operator?: Maybe<Element>;
  /** A list of operators that can be used with the filter. */
  operator?: Maybe<Array<Scalars['code']>>;
  /** A description of what the value for the filter should be. */
  _value?: Maybe<Element>;
  /** A description of what the value for the filter should be. */
  value: Scalars['String'];
};

export type CodeSystemproperty = {
  __typename?: 'CodeSystemproperty';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A code that is used to identify the property. The code is used internally (in
   * CodeSystem.concept.property.code) and also externally, such as in property filters.
   */
  _code?: Maybe<Element>;
  /**
   * A code that is used to identify the property. The code is used internally (in
   * CodeSystem.concept.property.code) and also externally, such as in property filters.
   */
  code: Scalars['code'];
  /**
   * Reference to the formal meaning of the property. One possible source of
   * meaning is the [Concept Properties](codesystem-concept-properties.html) code system.
   */
  _uri?: Maybe<Element>;
  /**
   * Reference to the formal meaning of the property. One possible source of
   * meaning is the [Concept Properties](codesystem-concept-properties.html) code system.
   */
  uri?: Maybe<Scalars['uri']>;
  /** A description of the property- why it is defined, and how its value might be used. */
  _description?: Maybe<Element>;
  /** A description of the property- why it is defined, and how its value might be used. */
  description?: Maybe<Scalars['String']>;
  /**
   * The type of the property value. Properties of type 'code' contain a code
   * defined by the code system (e.g. a reference to another defined concept).
   */
  _type?: Maybe<Element>;
  /**
   * The type of the property value. Properties of type 'code' contain a code
   * defined by the code system (e.g. a reference to another defined concept).
   */
  type: Scalars['code'];
};

/**
 * Base StructureDefinition for CodeableConcept Type: A concept that may be defined
 * by a formal reference to a terminology or ontology or may be provided by text.
 */
export type CodeableConcept = {
  __typename?: 'CodeableConcept';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** A reference to a code defined by a terminology system. */
  coding?: Maybe<Array<Maybe<Coding>>>;
  /**
   * A human language representation of the concept as seen/selected/uttered by the
   * user who entered the data and/or which represents the intended meaning of the user.
   */
  _text?: Maybe<Element>;
  /**
   * A human language representation of the concept as seen/selected/uttered by the
   * user who entered the data and/or which represents the intended meaning of the user.
   */
  text?: Maybe<Scalars['String']>;
};

/**
 * Base StructureDefinition for CodeableConcept Type: A concept that may be defined
 * by a formal reference to a terminology or ontology or may be provided by text.
 */
export type CodeableConcept_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A reference to a code defined by a terminology system. */
  coding?: Maybe<Array<Maybe<Coding_Input>>>;
  /**
   * A human language representation of the concept as seen/selected/uttered by the
   * user who entered the data and/or which represents the intended meaning of the user.
   */
  _text?: Maybe<Element_Input>;
  /**
   * A human language representation of the concept as seen/selected/uttered by the
   * user who entered the data and/or which represents the intended meaning of the user.
   */
  text?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Coding Type: A reference to a code defined by a terminology system. */
export type Coding = {
  __typename?: 'Coding';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The identification of the code system that defines the meaning of the symbol in the code. */
  _system?: Maybe<Element>;
  /** The identification of the code system that defines the meaning of the symbol in the code. */
  system?: Maybe<Scalars['uri']>;
  /**
   * The version of the code system which was used when choosing this code. Note
   * that a well-maintained code system does not need the version reported, because
   * the meaning of codes is consistent across versions. However this cannot
   * consistently be assured, and when the meaning is not guaranteed to be
   * consistent, the version SHOULD be exchanged.
   */
  _version?: Maybe<Element>;
  /**
   * The version of the code system which was used when choosing this code. Note
   * that a well-maintained code system does not need the version reported, because
   * the meaning of codes is consistent across versions. However this cannot
   * consistently be assured, and when the meaning is not guaranteed to be
   * consistent, the version SHOULD be exchanged.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A symbol in syntax defined by the system. The symbol may be a predefined code
   * or an expression in a syntax defined by the coding system (e.g.
   * post-coordination).
   */
  _code?: Maybe<Element>;
  /**
   * A symbol in syntax defined by the system. The symbol may be a predefined code
   * or an expression in a syntax defined by the coding system (e.g.
   * post-coordination).
   */
  code?: Maybe<Scalars['code']>;
  /** A representation of the meaning of the code in the system, following the rules of the system. */
  brandYear?: Maybe<CodingProfessionalExtension_Input>;
  /** A representation of the meaning of the code in the system, following the rules of the system. */
  _display?: Maybe<Element>;
  /** A representation of the meaning of the code in the system, following the rules of the system. */
  display?: Maybe<Scalars['String']>;
  /** Indicates that this coding was chosen by a user directly - e.g. off a pick list of available items (codes or displays). */
  _userSelected?: Maybe<Element>;
  /** Indicates that this coding was chosen by a user directly - e.g. off a pick list of available items (codes or displays). */
  userSelected?: Maybe<Scalars['Boolean']>;
};

/** Base StructureDefinition for CodingProfessionalExtension Type: Custom Fields . */
export type CodingProfessionalExtension_Input = {
  __typename?: 'CodingProfessionalExtension_Input';
  /** band field data. */
  band?: Maybe<Scalars['Int']>;
  /** yearsOfExp field data. */
  yearsOfExp?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Coding Type: A reference to a code defined by a terminology system. */
export type Coding_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The identification of the code system that defines the meaning of the symbol in the code. */
  _system?: Maybe<Element_Input>;
  /** The identification of the code system that defines the meaning of the symbol in the code. */
  system?: Maybe<Scalars['uri']>;
  /**
   * The version of the code system which was used when choosing this code. Note
   * that a well-maintained code system does not need the version reported, because
   * the meaning of codes is consistent across versions. However this cannot
   * consistently be assured, and when the meaning is not guaranteed to be
   * consistent, the version SHOULD be exchanged.
   */
  _version?: Maybe<Element_Input>;
  /**
   * The version of the code system which was used when choosing this code. Note
   * that a well-maintained code system does not need the version reported, because
   * the meaning of codes is consistent across versions. However this cannot
   * consistently be assured, and when the meaning is not guaranteed to be
   * consistent, the version SHOULD be exchanged.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A symbol in syntax defined by the system. The symbol may be a predefined code
   * or an expression in a syntax defined by the coding system (e.g.
   * post-coordination).
   */
  _code?: Maybe<Element_Input>;
  /**
   * A symbol in syntax defined by the system. The symbol may be a predefined code
   * or an expression in a syntax defined by the coding system (e.g.
   * post-coordination).
   */
  code?: Maybe<Scalars['code']>;
  /** A representation of the meaning of the code in the system, following the rules of the system. */
  _display?: Maybe<Element_Input>;
  /** A representation of the meaning of the code in the system, following the rules of the system. */
  display?: Maybe<Scalars['String']>;
  /** Indicates that this coding was chosen by a user directly - e.g. off a pick list of available items (codes or displays). */
  _userSelected?: Maybe<Element_Input>;
  /** Indicates that this coding was chosen by a user directly - e.g. off a pick list of available items (codes or displays). */
  userSelected?: Maybe<Scalars['Boolean']>;
};

/**
 * An occurrence of information being transmitted; e.g. an alert that was sent to a
 * responsible provider, a public health agency that was notified about a
 * reportable condition.
 */
export type Communication = {
  __typename?: 'Communication';
  /** Type of resource */
  resourceType: Communication_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this communication by the performer or other
   * systems which remain constant as the resource is updated and propagates from
   * server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this Communication.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this Communication.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this Communication.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this Communication.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** An order, proposal or plan fulfilled in whole or in part by this Communication. */
  basedOn?: Maybe<Array<Maybe<CommunicationbasedOn_BasedOn_Union>>>;
  /** Part of this action. */
  partOf?: Maybe<Array<Maybe<CommunicationpartOf_PartOf_Union>>>;
  /** Prior communication that this communication is in response to. */
  inResponseTo?: Maybe<Array<Maybe<CommunicationinResponseTo_InResponseTo_Union>>>;
  /** The status of the transmission. */
  _status?: Maybe<Element>;
  /** The status of the transmission. */
  status: Scalars['code'];
  /** Captures the reason for the current state of the Communication. */
  statusReason?: Maybe<CodeableConcept>;
  /** The type of message conveyed such as alert, notification, reminder, instruction, etc. */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Characterizes how quickly the planned or in progress communication must be
   * addressed. Includes concepts such as stat, urgent, routine.
   */
  _priority?: Maybe<Element>;
  /**
   * Characterizes how quickly the planned or in progress communication must be
   * addressed. Includes concepts such as stat, urgent, routine.
   */
  priority?: Maybe<Scalars['code']>;
  /** A channel that was used for this communication (e.g. email, fax). */
  medium?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The patient or group that was the focus of this communication. */
  subject?: Maybe<Communicationsubject_Subject_Union>;
  /** Description of the purpose/content, similar to a subject line in an email. */
  topic?: Maybe<CodeableConcept>;
  /** Other resources that pertain to this communication and to which this communication should be associated. */
  about?: Maybe<Array<Maybe<Communicationabout_About_Union>>>;
  /** The Encounter during which this Communication was created or to which the creation of this record is tightly associated. */
  encounter?: Maybe<Communicationencounter_Encounter_Union>;
  /** The time when this communication was sent. */
  _sent?: Maybe<Element>;
  /** The time when this communication was sent. */
  sent?: Maybe<Scalars['dateTime']>;
  /** The time when this communication arrived at the destination. */
  _received?: Maybe<Element>;
  /** The time when this communication arrived at the destination. */
  received?: Maybe<Scalars['dateTime']>;
  /**
   * The entity (e.g. person, organization, clinical information system, care team
   * or device) which was the target of the communication. If receipts need to be
   * tracked by an individual, a separate resource instance will need to be created
   * for each recipient.  Multiple recipient communications are intended where
   * either receipts are not tracked (e.g. a mass mail-out) or a receipt is
   * captured in aggregate (all emails confirmed received by a particular time).
   */
  recipient?: Maybe<Array<Maybe<Communicationrecipient_Recipient_Union>>>;
  /** The entity (e.g. person, organization, clinical information system, or device) which was the source of the communication. */
  sender?: Maybe<Communicationsender_Sender_Union>;
  /** The reason or justification for the communication. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates another resource whose existence justifies this communication. */
  reasonReference?: Maybe<Array<Maybe<CommunicationreasonReference_ReasonReference_Union>>>;
  /** Text, attachment(s), or resource(s) that was communicated to the recipient. */
  payload?: Maybe<Array<Maybe<Communicationpayload>>>;
  /** Additional notes or commentary about the communication by the sender, receiver or other interested parties. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

/**
 * A request to convey information; e.g. the CDS system proposes that an alert be
 * sent to a responsible provider, the CDS system proposes that the public health
 * agency be notified about a reportable condition.
 */
export type CommunicationRequest = {
  __typename?: 'CommunicationRequest';
  /** Type of resource */
  resourceType: CommunicationRequest_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this communication request by the performer
   * or other systems which remain constant as the resource is updated and
   * propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A plan or proposal that is fulfilled in whole or in part by this request. */
  basedOn?: Maybe<Array<Maybe<CommunicationRequestbasedOn_BasedOn_Union>>>;
  /** Completed or terminated request(s) whose function is taken by this new request. */
  replaces?: Maybe<Array<Maybe<CommunicationRequestreplaces_Replaces_Union>>>;
  /**
   * A shared identifier common to all requests that were authorized more or less
   * simultaneously by a single author, representing the identifier of the
   * requisition, prescription or similar form.
   */
  groupIdentifier?: Maybe<Identifier>;
  /** The status of the proposal or order. */
  _status?: Maybe<Element>;
  /** The status of the proposal or order. */
  status: Scalars['code'];
  /** Captures the reason for the current state of the CommunicationRequest. */
  statusReason?: Maybe<CodeableConcept>;
  /** The type of message to be sent such as alert, notification, reminder, instruction, etc. */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Characterizes how quickly the proposed act must be initiated. Includes concepts such as stat, urgent, routine. */
  _priority?: Maybe<Element>;
  /** Characterizes how quickly the proposed act must be initiated. Includes concepts such as stat, urgent, routine. */
  priority?: Maybe<Scalars['code']>;
  /** If true indicates that the CommunicationRequest is asking for the specified action to *not* occur. */
  _doNotPerform?: Maybe<Element>;
  /** If true indicates that the CommunicationRequest is asking for the specified action to *not* occur. */
  doNotPerform?: Maybe<Scalars['Boolean']>;
  /** A channel that was used for this communication (e.g. email, fax). */
  medium?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The patient or group that is the focus of this communication request. */
  subject?: Maybe<CommunicationRequestsubject_Subject_Union>;
  /** Other resources that pertain to this communication request and to which this communication request should be associated. */
  about?: Maybe<Array<Maybe<CommunicationRequestabout_About_Union>>>;
  /**
   * The Encounter during which this CommunicationRequest was created or to which
   * the creation of this record is tightly associated.
   */
  encounter?: Maybe<CommunicationRequestencounter_Encounter_Union>;
  /** Text, attachment(s), or resource(s) to be communicated to the recipient. */
  payload?: Maybe<Array<Maybe<CommunicationRequestpayload>>>;
  /** The time when this communication is to occur. */
  _occurrenceDateTime?: Maybe<Element>;
  /** The time when this communication is to occur. */
  occurrenceDateTime?: Maybe<Scalars['dateTime']>;
  /** The time when this communication is to occur. */
  occurrencePeriod?: Maybe<Period>;
  /**
   * For draft requests, indicates the date of initial creation.  For requests with
   * other statuses, indicates the date of activation.
   */
  _authoredOn?: Maybe<Element>;
  /**
   * For draft requests, indicates the date of initial creation.  For requests with
   * other statuses, indicates the date of activation.
   */
  authoredOn?: Maybe<Scalars['dateTime']>;
  /** The device, individual, or organization who initiated the request and has responsibility for its activation. */
  requester?: Maybe<CommunicationRequestrequester_Requester_Union>;
  /**
   * The entity (e.g. person, organization, clinical information system, device,
   * group, or care team) which is the intended target of the communication.
   */
  recipient?: Maybe<Array<Maybe<CommunicationRequestrecipient_Recipient_Union>>>;
  /**
   * The entity (e.g. person, organization, clinical information system, or device)
   * which is to be the source of the communication.
   */
  sender?: Maybe<CommunicationRequestsender_Sender_Union>;
  /** Describes why the request is being made in coded or textual form. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates another resource whose existence justifies this request. */
  reasonReference?: Maybe<Array<Maybe<CommunicationRequestreasonReference_ReasonReference_Union>>>;
  /** Comments made about the request by the requester, sender, recipient, subject or other participants. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export enum CommunicationRequest_Enum_Schema {
  CommunicationRequest = 'CommunicationRequest'
}

/** Other resources that pertain to this communication request and to which this communication request should be associated. */
export type CommunicationRequestabout_About_Union = Resource;

/** A plan or proposal that is fulfilled in whole or in part by this request. */
export type CommunicationRequestbasedOn_BasedOn_Union = Resource;

/**
 * The Encounter during which this CommunicationRequest was created or to which the
 * creation of this record is tightly associated.
 */
export type CommunicationRequestencounter_Encounter_Union = Encounter;

export type CommunicationRequestpayload = {
  __typename?: 'CommunicationRequestpayload';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The communicated content (or for multi-part communications, one portion of the communication). */
  _contentString?: Maybe<Element>;
  /** The communicated content (or for multi-part communications, one portion of the communication). */
  contentString: Scalars['String'];
  /** The communicated content (or for multi-part communications, one portion of the communication). */
  contentAttachment: Attachment;
  /** The communicated content (or for multi-part communications, one portion of the communication). */
  contentReference: CommunicationRequestpayloadcontentReference_ContentReference_Union;
};

/** The communicated content (or for multi-part communications, one portion of the communication). */
export type CommunicationRequestpayloadcontentReference_ContentReference_Union = Resource;

/** Indicates another resource whose existence justifies this request. */
export type CommunicationRequestreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference;

/**
 * The entity (e.g. person, organization, clinical information system, device,
 * group, or care team) which is the intended target of the communication.
 */
export type CommunicationRequestrecipient_Recipient_Union = Device | Organization | Patient | Practitioner | PractitionerRole | RelatedPerson | Group | CareTeam | HealthcareService;

/** Completed or terminated request(s) whose function is taken by this new request. */
export type CommunicationRequestreplaces_Replaces_Union = CommunicationRequest;

/** The device, individual, or organization who initiated the request and has responsibility for its activation. */
export type CommunicationRequestrequester_Requester_Union = Practitioner | PractitionerRole | Organization | Patient | RelatedPerson | Device;

/**
 * The entity (e.g. person, organization, clinical information system, or device)
 * which is to be the source of the communication.
 */
export type CommunicationRequestsender_Sender_Union = Device | Organization | Patient | Practitioner | PractitionerRole | RelatedPerson | HealthcareService;

/** The patient or group that is the focus of this communication request. */
export type CommunicationRequestsubject_Subject_Union = Patient | Group;

export enum Communication_Enum_Schema {
  Communication = 'Communication'
}

/** Other resources that pertain to this communication and to which this communication should be associated. */
export type Communicationabout_About_Union = Resource;

/** An order, proposal or plan fulfilled in whole or in part by this Communication. */
export type CommunicationbasedOn_BasedOn_Union = Resource;

/** The Encounter during which this Communication was created or to which the creation of this record is tightly associated. */
export type Communicationencounter_Encounter_Union = Encounter;

/** Prior communication that this communication is in response to. */
export type CommunicationinResponseTo_InResponseTo_Union = Communication;

/** Part of this action. */
export type CommunicationpartOf_PartOf_Union = Resource;

export type Communicationpayload = {
  __typename?: 'Communicationpayload';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A communicated content (or for multi-part communications, one portion of the communication). */
  _contentString?: Maybe<Element>;
  /** A communicated content (or for multi-part communications, one portion of the communication). */
  contentString: Scalars['String'];
  /** A communicated content (or for multi-part communications, one portion of the communication). */
  contentAttachment: Attachment;
  /** A communicated content (or for multi-part communications, one portion of the communication). */
  contentReference: CommunicationpayloadcontentReference_ContentReference_Union;
};

/** A communicated content (or for multi-part communications, one portion of the communication). */
export type CommunicationpayloadcontentReference_ContentReference_Union = Resource;

/** Indicates another resource whose existence justifies this communication. */
export type CommunicationreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference;

/**
 * The entity (e.g. person, organization, clinical information system, care team or
 * device) which was the target of the communication. If receipts need to be
 * tracked by an individual, a separate resource instance will need to be created
 * for each recipient.  Multiple recipient communications are intended where either
 * receipts are not tracked (e.g. a mass mail-out) or a receipt is captured in
 * aggregate (all emails confirmed received by a particular time).
 */
export type Communicationrecipient_Recipient_Union = Device | Organization | Patient | Practitioner | PractitionerRole | RelatedPerson | Group | CareTeam | HealthcareService;

/** The entity (e.g. person, organization, clinical information system, or device) which was the source of the communication. */
export type Communicationsender_Sender_Union = Device | Organization | Patient | Practitioner | PractitionerRole | RelatedPerson | HealthcareService;

/** The patient or group that was the focus of this communication. */
export type Communicationsubject_Subject_Union = Patient | Group;

/** A compartment definition that defines how resources are accessed on a server. */
export type CompartmentDefinition = {
  __typename?: 'CompartmentDefinition';
  /** Type of resource */
  resourceType: CompartmentDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this compartment definition when it
   * is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this
   * compartment definition is (or will be) published. This URL can be the target
   * of a canonical reference. It SHALL remain the same when the compartment
   * definition is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this compartment definition when it
   * is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this
   * compartment definition is (or will be) published. This URL can be the target
   * of a canonical reference. It SHALL remain the same when the compartment
   * definition is stored on different servers.
   */
  url: Scalars['uri'];
  /**
   * The identifier that is used to identify this version of the compartment
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the compartment definition
   * author and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the compartment
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the compartment definition
   * author and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the compartment definition. This name
   * should be usable as an identifier for the module by machine processing
   * applications such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the compartment definition. This name
   * should be usable as an identifier for the module by machine processing
   * applications such as code generation.
   */
  name: Scalars['String'];
  /** The status of this compartment definition. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this compartment definition. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this compartment definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this compartment definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the compartment definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the compartment definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the compartment definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the compartment definition changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the compartment definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the compartment definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the compartment definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the compartment definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate compartment
   * definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** Explanation of why this compartment definition is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this compartment definition is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /** Which compartment this definition describes. */
  _code?: Maybe<Element>;
  /** Which compartment this definition describes. */
  code: Scalars['code'];
  /** Whether the search syntax is supported,. */
  _search?: Maybe<Element>;
  /** Whether the search syntax is supported,. */
  search: Scalars['Boolean'];
  /** Information about how a resource is related to the compartment. */
  resource?: Maybe<Array<Maybe<CompartmentDefinitionresource>>>;
};

export enum CompartmentDefinition_Enum_Schema {
  CompartmentDefinition = 'CompartmentDefinition'
}

export type CompartmentDefinitionresource = {
  __typename?: 'CompartmentDefinitionresource';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of a resource supported by the server. */
  _code?: Maybe<Element>;
  /** The name of a resource supported by the server. */
  code: Scalars['code'];
  /**
   * The name of a search parameter that represents the link to the compartment.
   * More than one may be listed because a resource may be linked to a compartment
   * in more than one way,.
   */
  _param?: Maybe<Element>;
  /**
   * The name of a search parameter that represents the link to the compartment.
   * More than one may be listed because a resource may be linked to a compartment
   * in more than one way,.
   */
  param?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Additional documentation about the resource and compartment. */
  _documentation?: Maybe<Element>;
  /** Additional documentation about the resource and compartment. */
  documentation?: Maybe<Scalars['String']>;
};

/**
 * A set of healthcare-related information that is assembled together into a single
 * logical package that provides a single coherent statement of meaning,
 * establishes its own context and that has clinical attestation with regard to who
 * is making the statement. A Composition defines the structure and narrative
 * content necessary for a document. However, a Composition alone does not
 * constitute a document. Rather, the Composition must be the first entry in a
 * Bundle where Bundle.type=document, and any other resources referenced from
 * Composition must be included as subsequent entries in the Bundle (for example
 * Patient, Practitioner, Encounter, etc.).
 */
export type Composition = {
  __typename?: 'Composition';
  /** Type of resource */
  resourceType: Composition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A version-independent identifier for the Composition. This identifier stays
   * constant as the composition is changed over time.
   */
  identifier?: Maybe<Identifier>;
  /** The workflow/clinical status of this composition. The status is a marker for the clinical standing of the document. */
  _status?: Maybe<Element>;
  /** The workflow/clinical status of this composition. The status is a marker for the clinical standing of the document. */
  status: Scalars['code'];
  /**
   * Specifies the particular kind of composition (e.g. History and Physical,
   * Discharge Summary, Progress Note). This usually equates to the purpose of
   * making the composition.
   */
  type: CodeableConcept;
  /**
   * A categorization for the type of the composition - helps for indexing and
   * searching. This may be implied by or derived from the code specified in the
   * Composition Type.
   */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Who or what the composition is about. The composition can be about a person,
   * (patient or healthcare practitioner), a device (e.g. a machine) or even a
   * group of subjects (such as a document about a herd of livestock, or a set of
   * patients that share a common exposure).
   */
  subject?: Maybe<Compositionsubject_Subject_Union>;
  /** Describes the clinical encounter or type of care this documentation is associated with. */
  encounter?: Maybe<Compositionencounter_Encounter_Union>;
  /** The composition editing time, when the composition was last logically changed by the author. */
  _date?: Maybe<Element>;
  /** The composition editing time, when the composition was last logically changed by the author. */
  date: Scalars['dateTime'];
  /** Identifies who is responsible for the information in the composition, not necessarily who typed it in. */
  author?: Maybe<Array<Compositionauthor_Author_Union>>;
  /** Official human-readable label for the composition. */
  _title?: Maybe<Element>;
  /** Official human-readable label for the composition. */
  title: Scalars['String'];
  /** The code specifying the level of confidentiality of the Composition. */
  _confidentiality?: Maybe<Element>;
  /** The code specifying the level of confidentiality of the Composition. */
  confidentiality?: Maybe<Scalars['code']>;
  /** A participant who has attested to the accuracy of the composition/document. */
  attester?: Maybe<Array<Maybe<Compositionattester>>>;
  /**
   * Identifies the organization or group who is responsible for ongoing
   * maintenance of and access to the composition/document information.
   */
  custodian?: Maybe<Compositioncustodian_Custodian_Union>;
  /** Relationships that this composition has with other compositions or documents that already exist. */
  relatesTo?: Maybe<Array<Maybe<CompositionrelatesTo>>>;
  /** The clinical service, such as a colonoscopy or an appendectomy, being documented. */
  event?: Maybe<Array<Maybe<Compositionevent>>>;
  /** The root of the sections that make up the composition. */
  section?: Maybe<Array<Maybe<Compositionsection>>>;
};

export enum Composition_Enum_Schema {
  Composition = 'Composition'
}

export type Compositionattester = {
  __typename?: 'Compositionattester';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of attestation the authenticator offers. */
  _mode?: Maybe<Element>;
  /** The type of attestation the authenticator offers. */
  mode: Scalars['code'];
  /** When the composition was attested by the party. */
  _time?: Maybe<Element>;
  /** When the composition was attested by the party. */
  time?: Maybe<Scalars['dateTime']>;
  /** Who attested the composition in the specified way. */
  party?: Maybe<Compositionattesterparty_Party_Union>;
};

/** Who attested the composition in the specified way. */
export type Compositionattesterparty_Party_Union = Patient | RelatedPerson | Practitioner | PractitionerRole | Organization;

/** Identifies who is responsible for the information in the composition, not necessarily who typed it in. */
export type Compositionauthor_Author_Union = Practitioner | PractitionerRole | Device | Patient | RelatedPerson | Organization;

/**
 * Identifies the organization or group who is responsible for ongoing maintenance
 * of and access to the composition/document information.
 */
export type Compositioncustodian_Custodian_Union = Organization;

/** Describes the clinical encounter or type of care this documentation is associated with. */
export type Compositionencounter_Encounter_Union = Encounter;

export type Compositionevent = {
  __typename?: 'Compositionevent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * This list of codes represents the main clinical acts, such as a colonoscopy or
   * an appendectomy, being documented. In some cases, the event is inherent in the
   * typeCode, such as a 'History and Physical Report' in which the procedure being
   * documented is necessarily a 'History and Physical' act.
   */
  code?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * The period of time covered by the documentation. There is no assertion that
   * the documentation is a complete representation for this period, only that it
   * documents events during this time.
   */
  period?: Maybe<Period>;
  /**
   * The description and/or reference of the event(s) being documented. For
   * example, this could be used to document such a colonoscopy or an appendectomy.
   */
  detail?: Maybe<Array<Maybe<Compositioneventdetail_Detail_Union>>>;
};

/**
 * The description and/or reference of the event(s) being documented. For example,
 * this could be used to document such a colonoscopy or an appendectomy.
 */
export type Compositioneventdetail_Detail_Union = Resource;

export type CompositionrelatesTo = {
  __typename?: 'CompositionrelatesTo';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of relationship that this composition has with anther composition or document. */
  _code?: Maybe<Element>;
  /** The type of relationship that this composition has with anther composition or document. */
  code: Scalars['code'];
  /** The target composition/document of this relationship. */
  targetIdentifier: Identifier;
  /** The target composition/document of this relationship. */
  targetReference: CompositionrelatesTotargetReference_TargetReference_Union;
};

/** The target composition/document of this relationship. */
export type CompositionrelatesTotargetReference_TargetReference_Union = Composition;

export type Compositionsection = {
  __typename?: 'Compositionsection';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The label for this particular section.  This will be part of the rendered
   * content for the document, and is often used to build a table of contents.
   */
  _title?: Maybe<Element>;
  /**
   * The label for this particular section.  This will be part of the rendered
   * content for the document, and is often used to build a table of contents.
   */
  title?: Maybe<Scalars['String']>;
  /** A code identifying the kind of content contained within the section. This must be consistent with the section title. */
  code?: Maybe<CodeableConcept>;
  /** Identifies who is responsible for the information in this section, not necessarily who typed it in. */
  author?: Maybe<Array<Maybe<Compositionsectionauthor_Author_Union>>>;
  /**
   * The actual focus of the section when it is not the subject of the composition,
   * but instead represents something or someone associated with the subject such
   * as (for a patient subject) a spouse, parent, fetus, or donor. If not focus is
   * specified, the focus is assumed to be focus of the parent section, or, for a
   * section in the Composition itself, the subject of the composition. Sections
   * with a focus SHALL only include resources where the logical subject (patient,
   * subject, focus, etc.) matches the section focus, or the resources have no
   * logical subject (few resources).
   */
  focus?: Maybe<Compositionsectionfocus_Focus_Union>;
  /**
   * A human-readable narrative that contains the attested content of the section,
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   */
  text?: Maybe<Narrative>;
  /**
   * How the entry list was prepared - whether it is a working list that is
   * suitable for being maintained on an ongoing basis, or if it represents a
   * snapshot of a list of items from another source, or whether it is a prepared
   * list where items may be marked as added, modified or deleted.
   */
  _mode?: Maybe<Element>;
  /**
   * How the entry list was prepared - whether it is a working list that is
   * suitable for being maintained on an ongoing basis, or if it represents a
   * snapshot of a list of items from another source, or whether it is a prepared
   * list where items may be marked as added, modified or deleted.
   */
  mode?: Maybe<Scalars['code']>;
  /** Specifies the order applied to the items in the section entries. */
  orderedBy?: Maybe<CodeableConcept>;
  /** A reference to the actual resource from which the narrative in the section is derived. */
  entry?: Maybe<Array<Maybe<Compositionsectionentry_Entry_Union>>>;
  /** If the section is empty, why the list is empty. An empty section typically has some text explaining the empty reason. */
  emptyReason?: Maybe<CodeableConcept>;
};

/** Identifies who is responsible for the information in this section, not necessarily who typed it in. */
export type Compositionsectionauthor_Author_Union = Practitioner | PractitionerRole | Device | Patient | RelatedPerson | Organization;

/** A reference to the actual resource from which the narrative in the section is derived. */
export type Compositionsectionentry_Entry_Union = Resource;

/**
 * The actual focus of the section when it is not the subject of the composition,
 * but instead represents something or someone associated with the subject such as
 * (for a patient subject) a spouse, parent, fetus, or donor. If not focus is
 * specified, the focus is assumed to be focus of the parent section, or, for a
 * section in the Composition itself, the subject of the composition. Sections with
 * a focus SHALL only include resources where the logical subject (patient,
 * subject, focus, etc.) matches the section focus, or the resources have no
 * logical subject (few resources).
 */
export type Compositionsectionfocus_Focus_Union = Resource;

/**
 * Who or what the composition is about. The composition can be about a person,
 * (patient or healthcare practitioner), a device (e.g. a machine) or even a group
 * of subjects (such as a document about a herd of livestock, or a set of patients
 * that share a common exposure).
 */
export type Compositionsubject_Subject_Union = Resource;

/**
 * A statement of relationships from one set of concepts to one or more other
 * concepts - either concepts in code systems, or data element/data element
 * concepts, or classes in class models.
 */
export type ConceptMap = {
  __typename?: 'ConceptMap';
  /** Type of resource */
  resourceType: ConceptMap_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this concept map when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this concept map is (or
   * will be) published. This URL can be the target of a canonical reference. It
   * SHALL remain the same when the concept map is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this concept map when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this concept map is (or
   * will be) published. This URL can be the target of a canonical reference. It
   * SHALL remain the same when the concept map is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this concept map when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Identifier>;
  /**
   * The identifier that is used to identify this version of the concept map when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the concept map author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the concept map when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the concept map author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the concept map. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the concept map. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the concept map. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the concept map. */
  title?: Maybe<Scalars['String']>;
  /** The status of this concept map. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this concept map. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this concept map is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this concept map is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the concept map was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the concept map changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the concept map was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the concept map changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the concept map. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the concept map. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the concept map from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the concept map from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate concept map instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the concept map is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this concept map is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this concept map is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the concept map and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the concept map.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the concept map and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the concept map.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * Identifier for the source value set that contains the concepts that are being
   * mapped and provides context for the mappings.
   */
  _sourceUri?: Maybe<Element>;
  /**
   * Identifier for the source value set that contains the concepts that are being
   * mapped and provides context for the mappings.
   */
  sourceUri?: Maybe<Scalars['uri']>;
  /**
   * Identifier for the source value set that contains the concepts that are being
   * mapped and provides context for the mappings.
   */
  _sourceCanonical?: Maybe<Element>;
  /**
   * Identifier for the source value set that contains the concepts that are being
   * mapped and provides context for the mappings.
   */
  sourceCanonical?: Maybe<Scalars['canonical']>;
  /**
   * The target value set provides context for the mappings. Note that the mapping
   * is made between concepts, not between value sets, but the value set provides
   * important context about how the concept mapping choices are made.
   */
  _targetUri?: Maybe<Element>;
  /**
   * The target value set provides context for the mappings. Note that the mapping
   * is made between concepts, not between value sets, but the value set provides
   * important context about how the concept mapping choices are made.
   */
  targetUri?: Maybe<Scalars['uri']>;
  /**
   * The target value set provides context for the mappings. Note that the mapping
   * is made between concepts, not between value sets, but the value set provides
   * important context about how the concept mapping choices are made.
   */
  _targetCanonical?: Maybe<Element>;
  /**
   * The target value set provides context for the mappings. Note that the mapping
   * is made between concepts, not between value sets, but the value set provides
   * important context about how the concept mapping choices are made.
   */
  targetCanonical?: Maybe<Scalars['canonical']>;
  /** A group of mappings that all have the same source and target system. */
  group?: Maybe<Array<Maybe<ConceptMapgroup>>>;
};

export enum ConceptMap_Enum_Schema {
  ConceptMap = 'ConceptMap'
}

export type ConceptMapgroup = {
  __typename?: 'ConceptMapgroup';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An absolute URI that identifies the source system where the concepts to be mapped are defined. */
  _source?: Maybe<Element>;
  /** An absolute URI that identifies the source system where the concepts to be mapped are defined. */
  source?: Maybe<Scalars['uri']>;
  /** The specific version of the code system, as determined by the code system authority. */
  _sourceVersion?: Maybe<Element>;
  /** The specific version of the code system, as determined by the code system authority. */
  sourceVersion?: Maybe<Scalars['String']>;
  /** An absolute URI that identifies the target system that the concepts will be mapped to. */
  _target?: Maybe<Element>;
  /** An absolute URI that identifies the target system that the concepts will be mapped to. */
  target?: Maybe<Scalars['uri']>;
  /** The specific version of the code system, as determined by the code system authority. */
  _targetVersion?: Maybe<Element>;
  /** The specific version of the code system, as determined by the code system authority. */
  targetVersion?: Maybe<Scalars['String']>;
  /** Mappings for an individual concept in the source to one or more concepts in the target. */
  element?: Maybe<Array<ConceptMapgroupelement>>;
  /**
   * What to do when there is no mapping for the source concept. 'Unmapped' does
   * not include codes that are unmatched, and the unmapped element is ignored in a
   * code is specified to have equivalence = unmatched.
   */
  unmapped?: Maybe<ConceptMapgroupunmapped>;
};

export type ConceptMapgroupelement = {
  __typename?: 'ConceptMapgroupelement';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identity (code or path) or the element/item being mapped. */
  _code?: Maybe<Element>;
  /** Identity (code or path) or the element/item being mapped. */
  code?: Maybe<Scalars['code']>;
  /** The display for the code. The display is only provided to help editors when editing the concept map. */
  _display?: Maybe<Element>;
  /** The display for the code. The display is only provided to help editors when editing the concept map. */
  display?: Maybe<Scalars['String']>;
  /** A concept from the target value set that this concept maps to. */
  target?: Maybe<Array<Maybe<ConceptMapgroupelementtarget>>>;
};

export type ConceptMapgroupelementtarget = {
  __typename?: 'ConceptMapgroupelementtarget';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identity (code or path) or the element/item that the map refers to. */
  _code?: Maybe<Element>;
  /** Identity (code or path) or the element/item that the map refers to. */
  code?: Maybe<Scalars['code']>;
  /** The display for the code. The display is only provided to help editors when editing the concept map. */
  _display?: Maybe<Element>;
  /** The display for the code. The display is only provided to help editors when editing the concept map. */
  display?: Maybe<Scalars['String']>;
  /**
   * The equivalence between the source and target concepts (counting for the
   * dependencies and products). The equivalence is read from target to source
   * (e.g. the target is 'wider' than the source).
   */
  _equivalence?: Maybe<Element>;
  /**
   * The equivalence between the source and target concepts (counting for the
   * dependencies and products). The equivalence is read from target to source
   * (e.g. the target is 'wider' than the source).
   */
  equivalence: Scalars['code'];
  /** A description of status/issues in mapping that conveys additional information not represented in  the structured data. */
  _comment?: Maybe<Element>;
  /** A description of status/issues in mapping that conveys additional information not represented in  the structured data. */
  comment?: Maybe<Scalars['String']>;
  /**
   * A set of additional dependencies for this mapping to hold. This mapping is
   * only applicable if the specified element can be resolved, and it has the
   * specified value.
   */
  dependsOn?: Maybe<Array<Maybe<ConceptMapgroupelementtargetdependsOn>>>;
};

export type ConceptMapgroupelementtargetdependsOn = {
  __typename?: 'ConceptMapgroupelementtargetdependsOn';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A reference to an element that holds a coded value that corresponds to a code
   * system property. The idea is that the information model carries an element
   * somewhere that is labeled to correspond with a code system property.
   */
  _property?: Maybe<Element>;
  /**
   * A reference to an element that holds a coded value that corresponds to a code
   * system property. The idea is that the information model carries an element
   * somewhere that is labeled to correspond with a code system property.
   */
  property: Scalars['uri'];
  /**
   * An absolute URI that identifies the code system of the dependency code (if the
   * source/dependency is a value set that crosses code systems).
   */
  _system?: Maybe<Element>;
  /**
   * An absolute URI that identifies the code system of the dependency code (if the
   * source/dependency is a value set that crosses code systems).
   */
  system?: Maybe<Scalars['canonical']>;
  /** Identity (code or path) or the element/item/ValueSet/text that the map depends on / refers to. */
  _value?: Maybe<Element>;
  /** Identity (code or path) or the element/item/ValueSet/text that the map depends on / refers to. */
  value: Scalars['String'];
  /** The display for the code. The display is only provided to help editors when editing the concept map. */
  _display?: Maybe<Element>;
  /** The display for the code. The display is only provided to help editors when editing the concept map. */
  display?: Maybe<Scalars['String']>;
};

export type ConceptMapgroupunmapped = {
  __typename?: 'ConceptMapgroupunmapped';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Defines which action to take if there is no match for the source concept in
   * the target system designated for the group. One of 3 actions are possible: use
   * the unmapped code (this is useful when doing a mapping between versions, and
   * only a few codes have changed), use a fixed code (a default code), or
   * alternatively, a reference to a different concept map can be provided (by
   * canonical URL).
   */
  _mode?: Maybe<Element>;
  /**
   * Defines which action to take if there is no match for the source concept in
   * the target system designated for the group. One of 3 actions are possible: use
   * the unmapped code (this is useful when doing a mapping between versions, and
   * only a few codes have changed), use a fixed code (a default code), or
   * alternatively, a reference to a different concept map can be provided (by
   * canonical URL).
   */
  mode: Scalars['code'];
  /** The fixed code to use when the mode = 'fixed'  - all unmapped codes are mapped to a single fixed code. */
  _code?: Maybe<Element>;
  /** The fixed code to use when the mode = 'fixed'  - all unmapped codes are mapped to a single fixed code. */
  code?: Maybe<Scalars['code']>;
  /** The display for the code. The display is only provided to help editors when editing the concept map. */
  _display?: Maybe<Element>;
  /** The display for the code. The display is only provided to help editors when editing the concept map. */
  display?: Maybe<Scalars['String']>;
  /**
   * The canonical reference to an additional ConceptMap resource instance to use
   * for mapping if this ConceptMap resource contains no matching mapping for the
   * source concept.
   */
  _url?: Maybe<Element>;
  /**
   * The canonical reference to an additional ConceptMap resource instance to use
   * for mapping if this ConceptMap resource contains no matching mapping for the
   * source concept.
   */
  url?: Maybe<Scalars['canonical']>;
};

/**
 * A clinical condition, problem, diagnosis, or other event, situation, issue, or
 * clinical concept that has risen to a level of concern.
 */
export type Condition = {
  __typename?: 'Condition';
  /** Type of resource */
  resourceType: Condition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this condition by the performer or other
   * systems which remain constant as the resource is updated and propagates from
   * server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The clinical status of the condition. */
  clinicalStatus?: Maybe<CodeableConcept>;
  /** The verification status to support the clinical status of the condition. */
  verificationStatus?: Maybe<CodeableConcept>;
  /** A category assigned to the condition. */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A subjective assessment of the severity of the condition as evaluated by the clinician. */
  severity?: Maybe<CodeableConcept>;
  /** Identification of the condition, problem or diagnosis. */
  code?: Maybe<CodeableConcept>;
  /** The anatomical location where this condition manifests itself. */
  bodySite?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates the patient or group who the condition record is associated with. */
  subject: Conditionsubject_Subject_Union;
  /** The Encounter during which this Condition was created or to which the creation of this record is tightly associated. */
  encounter?: Maybe<Conditionencounter_Encounter_Union>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  _onsetDateTime?: Maybe<Element>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  onsetDateTime?: Maybe<Scalars['dateTime']>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  onsetAge?: Maybe<Age>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  onsetPeriod?: Maybe<Period>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  onsetRange?: Maybe<Range>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  _onsetString?: Maybe<Element>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  onsetString?: Maybe<Scalars['String']>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  _abatementDateTime?: Maybe<Element>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  abatementDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  abatementAge?: Maybe<Age>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  abatementPeriod?: Maybe<Period>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  abatementRange?: Maybe<Range>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  _abatementString?: Maybe<Element>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  abatementString?: Maybe<Scalars['String']>;
  /**
   * The recordedDate represents when this particular Condition record was created
   * in the system, which is often a system-generated date.
   */
  _recordedDate?: Maybe<Element>;
  /**
   * The recordedDate represents when this particular Condition record was created
   * in the system, which is often a system-generated date.
   */
  recordedDate?: Maybe<Scalars['dateTime']>;
  /** Individual who recorded the record and takes responsibility for its content. */
  recorder?: Maybe<Conditionrecorder_Recorder_Union>;
  /** Individual who is making the condition statement. */
  asserter?: Maybe<Conditionasserter_Asserter_Union>;
  /** Clinical stage or grade of a condition. May include formal severity assessments. */
  stage?: Maybe<Array<Maybe<Conditionstage>>>;
  /**
   * Supporting evidence / manifestations that are the basis of the Condition's
   * verification status, such as evidence that confirmed or refuted the condition.
   */
  evidence?: Maybe<Array<Maybe<Conditionevidence>>>;
  /**
   * Additional information about the Condition. This is a general notes/comments
   * entry  for description of the Condition, its diagnosis and prognosis.
   */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export enum Condition_Enum_Input {
  Condition = 'Condition'
}

export enum Condition_Enum_Schema {
  Condition = 'Condition'
}

/**
 * A clinical condition, problem, diagnosis, or other event, situation, issue, or
 * clinical concept that has risen to a level of concern.
 */
export type Condition_Input = {
  /** Type of resource */
  resourceType: Condition_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * Business identifiers assigned to this condition by the performer or other
   * systems which remain constant as the resource is updated and propagates from
   * server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /** The clinical status of the condition. */
  clinicalStatus?: Maybe<CodeableConcept_Input>;
  /** The verification status to support the clinical status of the condition. */
  verificationStatus?: Maybe<CodeableConcept_Input>;
  /** A category assigned to the condition. */
  category?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** A subjective assessment of the severity of the condition as evaluated by the clinician. */
  severity?: Maybe<CodeableConcept_Input>;
  /** Identification of the condition, problem or diagnosis. */
  code?: Maybe<CodeableConcept_Input>;
  /** The anatomical location where this condition manifests itself. */
  bodySite?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Indicates the patient or group who the condition record is associated with. */
  subject: Scalars['String'];
  /** The Encounter during which this Condition was created or to which the creation of this record is tightly associated. */
  encounter?: Maybe<Scalars['String']>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  _onsetDateTime?: Maybe<Element_Input>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  onsetDateTime?: Maybe<Scalars['dateTime']>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  onsetAge?: Maybe<Age_Input>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  onsetPeriod?: Maybe<Period_Input>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  onsetRange?: Maybe<Range_Input>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  _onsetString?: Maybe<Element_Input>;
  /** Estimated or actual date or date-time  the condition began, in the opinion of the clinician. */
  onsetString?: Maybe<Scalars['String']>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  _abatementDateTime?: Maybe<Element_Input>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  abatementDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  abatementAge?: Maybe<Age_Input>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  abatementPeriod?: Maybe<Period_Input>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  abatementRange?: Maybe<Range_Input>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  _abatementString?: Maybe<Element_Input>;
  /**
   * The date or estimated date that the condition resolved or went into remission.
   * This is called 'abatement' because of the many overloaded connotations
   * associated with 'remission' or 'resolution' - Conditions are never really
   * resolved, but they can abate.
   */
  abatementString?: Maybe<Scalars['String']>;
  /**
   * The recordedDate represents when this particular Condition record was created
   * in the system, which is often a system-generated date.
   */
  _recordedDate?: Maybe<Element_Input>;
  /**
   * The recordedDate represents when this particular Condition record was created
   * in the system, which is often a system-generated date.
   */
  recordedDate?: Maybe<Scalars['dateTime']>;
  /** Individual who recorded the record and takes responsibility for its content. */
  recorder?: Maybe<Scalars['String']>;
  /** Individual who is making the condition statement. */
  asserter?: Maybe<Scalars['String']>;
  /** Clinical stage or grade of a condition. May include formal severity assessments. */
  stage?: Maybe<Array<Maybe<Conditionstage_Input>>>;
  /**
   * Supporting evidence / manifestations that are the basis of the Condition's
   * verification status, such as evidence that confirmed or refuted the condition.
   */
  evidence?: Maybe<Array<Maybe<Conditionevidence_Input>>>;
  /**
   * Additional information about the Condition. This is a general notes/comments
   * entry  for description of the Condition, its diagnosis and prognosis.
   */
  note?: Maybe<Array<Maybe<Annotation_Input>>>;
};

/** Individual who is making the condition statement. */
export type Conditionasserter_Asserter_Union = Practitioner | PractitionerRole | Patient | RelatedPerson;

/** The Encounter during which this Condition was created or to which the creation of this record is tightly associated. */
export type Conditionencounter_Encounter_Union = Encounter;

export type Conditionevidence = {
  __typename?: 'Conditionevidence';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A manifestation or symptom that led to the recording of this condition. */
  code?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Links to other relevant information, including pathology reports. */
  detail?: Maybe<Array<Maybe<Conditionevidencedetail_Detail_Union>>>;
};

export type Conditionevidence_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A manifestation or symptom that led to the recording of this condition. */
  code?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Links to other relevant information, including pathology reports. */
  detail?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Links to other relevant information, including pathology reports. */
export type Conditionevidencedetail_Detail_Union = Resource;

/** Individual who recorded the record and takes responsibility for its content. */
export type Conditionrecorder_Recorder_Union = Practitioner | PractitionerRole | Patient | RelatedPerson;

export type Conditionstage = {
  __typename?: 'Conditionstage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A simple summary of the stage such as 'Stage 3'. The determination of the stage is disease-specific. */
  summary?: Maybe<CodeableConcept>;
  /** Reference to a formal record of the evidence on which the staging assessment is based. */
  assessment?: Maybe<Array<Maybe<Conditionstageassessment_Assessment_Union>>>;
  /** The kind of staging, such as pathological or clinical staging. */
  type?: Maybe<CodeableConcept>;
};

export type Conditionstage_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A simple summary of the stage such as 'Stage 3'. The determination of the stage is disease-specific. */
  summary?: Maybe<CodeableConcept_Input>;
  /** Reference to a formal record of the evidence on which the staging assessment is based. */
  assessment?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The kind of staging, such as pathological or clinical staging. */
  type?: Maybe<CodeableConcept_Input>;
};

/** Reference to a formal record of the evidence on which the staging assessment is based. */
export type Conditionstageassessment_Assessment_Union = ClinicalImpression | DiagnosticReport | Observation;

/** Indicates the patient or group who the condition record is associated with. */
export type Conditionsubject_Subject_Union = Patient | Group;

/**
 * A record of a healthcare consumer’s  choices, which permits or denies identified
 * recipient(s) or recipient role(s) to perform one or more actions within a given
 * policy context, for specific purposes and periods of time.
 */
export type Consent = {
  __typename?: 'Consent';
  /** Type of resource */
  resourceType: Consent_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique identifier for this copy of the Consent Statement. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Indicates the current state of this consent. */
  _status?: Maybe<Element>;
  /** Indicates the current state of this consent. */
  status: Scalars['code'];
  /** A selector of the type of consent being presented: ADR, Privacy, Treatment, Research.  This list is now extensible. */
  scope: CodeableConcept;
  /**
   * A classification of the type of consents found in the statement. This element
   * supports indexing and retrieval of consent statements.
   */
  category?: Maybe<Array<CodeableConcept>>;
  /** The patient/healthcare consumer to whom this consent applies. */
  patient?: Maybe<Consentpatient_Patient_Union>;
  /** When this  Consent was issued / created / indexed. */
  _dateTime?: Maybe<Element>;
  /** When this  Consent was issued / created / indexed. */
  dateTime?: Maybe<Scalars['dateTime']>;
  /**
   * Either the Grantor, which is the entity responsible for granting the rights
   * listed in a Consent Directive or the Grantee, which is the entity responsible
   * for complying with the Consent Directive, including any obligations or
   * limitations on authorizations and enforcement of prohibitions.
   */
  performer?: Maybe<Array<Maybe<Consentperformer_Performer_Union>>>;
  /** The organization that manages the consent, and the framework within which it is executed. */
  organization?: Maybe<Array<Maybe<Consentorganization_Organization_Union>>>;
  /**
   * The source on which this consent statement is based. The source might be a
   * scanned original paper form, or a reference to a consent that links back to
   * such a source, a reference to a document repository (e.g. XDS) that stores the
   * original consent document.
   */
  sourceAttachment?: Maybe<Attachment>;
  /**
   * The source on which this consent statement is based. The source might be a
   * scanned original paper form, or a reference to a consent that links back to
   * such a source, a reference to a document repository (e.g. XDS) that stores the
   * original consent document.
   */
  sourceReference?: Maybe<ConsentsourceReference_SourceReference_Union>;
  /**
   * The references to the policies that are included in this consent scope.
   * Policies may be organizational, but are often defined jurisdictionally, or in law.
   */
  policy?: Maybe<Array<Maybe<Consentpolicy>>>;
  /** A reference to the specific base computable regulation or policy. */
  policyRule?: Maybe<CodeableConcept>;
  /**
   * Whether a treatment instruction (e.g. artificial respiration yes or no) was
   * verified with the patient, his/her family or another authorized person.
   */
  verification?: Maybe<Array<Maybe<Consentverification>>>;
  /** An exception to the base policy of this consent. An exception can be an addition or removal of access permissions. */
  provision?: Maybe<Consentprovision>;
};

export enum Consent_Enum_Schema {
  Consent = 'Consent'
}

/** The organization that manages the consent, and the framework within which it is executed. */
export type Consentorganization_Organization_Union = Organization;

/** The patient/healthcare consumer to whom this consent applies. */
export type Consentpatient_Patient_Union = Patient;

/**
 * Either the Grantor, which is the entity responsible for granting the rights
 * listed in a Consent Directive or the Grantee, which is the entity responsible
 * for complying with the Consent Directive, including any obligations or
 * limitations on authorizations and enforcement of prohibitions.
 */
export type Consentperformer_Performer_Union = Organization | Patient | Practitioner | RelatedPerson | PractitionerRole;

export type Consentpolicy = {
  __typename?: 'Consentpolicy';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Entity or Organization having regulatory jurisdiction or accountability for
   * enforcing policies pertaining to Consent Directives.
   */
  _authority?: Maybe<Element>;
  /**
   * Entity or Organization having regulatory jurisdiction or accountability for
   * enforcing policies pertaining to Consent Directives.
   */
  authority?: Maybe<Scalars['uri']>;
  /**
   * The references to the policies that are included in this consent scope.
   * Policies may be organizational, but are often defined jurisdictionally, or in law.
   */
  _uri?: Maybe<Element>;
  /**
   * The references to the policies that are included in this consent scope.
   * Policies may be organizational, but are often defined jurisdictionally, or in law.
   */
  uri?: Maybe<Scalars['uri']>;
};

export type Consentprovision = {
  __typename?: 'Consentprovision';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Action  to take - permit or deny - when the rule conditions are met.  Not
   * permitted in root rule, required in all nested rules.
   */
  _type?: Maybe<Element>;
  /**
   * Action  to take - permit or deny - when the rule conditions are met.  Not
   * permitted in root rule, required in all nested rules.
   */
  type?: Maybe<Scalars['code']>;
  /** The timeframe in this rule is valid. */
  period?: Maybe<Period>;
  /**
   * Who or what is controlled by this rule. Use group to identify a set of actors
   * by some property they share (e.g. 'admitting officers').
   */
  actor?: Maybe<Array<Maybe<Consentprovisionactor>>>;
  /** Actions controlled by this Rule. */
  action?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * A security label, comprised of 0..* security label fields (Privacy tags),
   * which define which resources are controlled by this exception.
   */
  securityLabel?: Maybe<Array<Maybe<Coding>>>;
  /** The context of the activities a user is taking - why the user is accessing the data - that are controlled by this rule. */
  purpose?: Maybe<Array<Maybe<Coding>>>;
  /**
   * The class of information covered by this rule. The type can be a FHIR resource
   * type, a profile on a type, or a CDA document, or some other type that
   * indicates what sort of information the consent relates to.
   */
  class?: Maybe<Array<Maybe<Coding>>>;
  /** If this code is found in an instance, then the rule applies. */
  code?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Clinical or Operational Relevant period of time that bounds the data controlled by this rule. */
  dataPeriod?: Maybe<Period>;
  /** The resources controlled by this rule if specific resources are referenced. */
  data?: Maybe<Array<Maybe<Consentprovisiondata>>>;
};

export type Consentprovisionactor = {
  __typename?: 'Consentprovisionactor';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** How the individual is involved in the resources content that is described in the exception. */
  role: CodeableConcept;
  /**
   * The resource that identifies the actor. To identify actors by type, use group
   * to identify a set of actors by some property they share (e.g. 'admitting officers').
   */
  reference: Consentprovisionactorreference_Reference_Union;
};

/**
 * The resource that identifies the actor. To identify actors by type, use group to
 * identify a set of actors by some property they share (e.g. 'admitting officers').
 */
export type Consentprovisionactorreference_Reference_Union = Device | Group | CareTeam | Organization | Patient | Practitioner | RelatedPerson | PractitionerRole;

export type Consentprovisiondata = {
  __typename?: 'Consentprovisiondata';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** How the resource reference is interpreted when testing consent restrictions. */
  _meaning?: Maybe<Element>;
  /** How the resource reference is interpreted when testing consent restrictions. */
  meaning: Scalars['code'];
  /** A reference to a specific resource that defines which resources are covered by this consent. */
  reference: Consentprovisiondatareference_Reference_Union;
};

/** A reference to a specific resource that defines which resources are covered by this consent. */
export type Consentprovisiondatareference_Reference_Union = Resource;

/**
 * The source on which this consent statement is based. The source might be a
 * scanned original paper form, or a reference to a consent that links back to such
 * a source, a reference to a document repository (e.g. XDS) that stores the
 * original consent document.
 */
export type ConsentsourceReference_SourceReference_Union = Consent | DocumentReference | Contract | QuestionnaireResponse;

export type Consentverification = {
  __typename?: 'Consentverification';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Has the instruction been verified. */
  _verified?: Maybe<Element>;
  /** Has the instruction been verified. */
  verified: Scalars['Boolean'];
  /** Who verified the instruction (Patient, Relative or other Authorized Person). */
  verifiedWith?: Maybe<ConsentverificationverifiedWith_VerifiedWith_Union>;
  /** Date verification was collected. */
  _verificationDate?: Maybe<Element>;
  /** Date verification was collected. */
  verificationDate?: Maybe<Scalars['dateTime']>;
};

/** Who verified the instruction (Patient, Relative or other Authorized Person). */
export type ConsentverificationverifiedWith_VerifiedWith_Union = Patient | RelatedPerson;

/** Base StructureDefinition for ContactDetail Type: Specifies contact information for a person or organization. */
export type ContactDetail = {
  __typename?: 'ContactDetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of an individual to contact. */
  _name?: Maybe<Element>;
  /** The name of an individual to contact. */
  name?: Maybe<Scalars['String']>;
  /** The contact details for the individual (if a name was provided) or the organization. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
};

/** Base StructureDefinition for ContactDetail Type: Specifies contact information for a person or organization. */
export type ContactDetail_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The name of an individual to contact. */
  _name?: Maybe<Element_Input>;
  /** The name of an individual to contact. */
  name?: Maybe<Scalars['String']>;
  /** The contact details for the individual (if a name was provided) or the organization. */
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>>>;
};

/**
 * Base StructureDefinition for ContactPoint Type: Details for all kinds of
 * technology mediated contact points for a person or organization, including
 * telephone, email, etc.
 */
export type ContactPoint = {
  __typename?: 'ContactPoint';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** Telecommunications form for contact point - what communications system is required to make use of the contact. */
  _system?: Maybe<Element>;
  /** Telecommunications form for contact point - what communications system is required to make use of the contact. */
  system?: Maybe<Scalars['code']>;
  /**
   * The actual contact point details, in a form that is meaningful to the
   * designated communication system (i.e. phone number or email address).
   */
  _value?: Maybe<Element>;
  /**
   * The actual contact point details, in a form that is meaningful to the
   * designated communication system (i.e. phone number or email address).
   */
  value?: Maybe<Scalars['String']>;
  /** Identifies the purpose for the contact point. */
  _use?: Maybe<Element>;
  /** Identifies the purpose for the contact point. */
  use?: Maybe<Scalars['code']>;
  /**
   * Specifies a preferred order in which to use a set of contacts. ContactPoints
   * with lower rank values are more preferred than those with higher rank values.
   */
  _rank?: Maybe<Element>;
  /**
   * Specifies a preferred order in which to use a set of contacts. ContactPoints
   * with lower rank values are more preferred than those with higher rank values.
   */
  rank?: Maybe<Scalars['positiveInt']>;
  /** Time period when the contact point was/is in use. */
  period?: Maybe<Period>;
};

/**
 * Base StructureDefinition for ContactPoint Type: Details for all kinds of
 * technology mediated contact points for a person or organization, including
 * telephone, email, etc.
 */
export type ContactPoint_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Telecommunications form for contact point - what communications system is required to make use of the contact. */
  _system?: Maybe<Element_Input>;
  /** Telecommunications form for contact point - what communications system is required to make use of the contact. */
  system?: Maybe<Scalars['code']>;
  /**
   * The actual contact point details, in a form that is meaningful to the
   * designated communication system (i.e. phone number or email address).
   */
  _value?: Maybe<Element_Input>;
  /**
   * The actual contact point details, in a form that is meaningful to the
   * designated communication system (i.e. phone number or email address).
   */
  value?: Maybe<Scalars['String']>;
  /** Identifies the purpose for the contact point. */
  _use?: Maybe<Element_Input>;
  /** Identifies the purpose for the contact point. */
  use?: Maybe<Scalars['code']>;
  /**
   * Specifies a preferred order in which to use a set of contacts. ContactPoints
   * with lower rank values are more preferred than those with higher rank values.
   */
  _rank?: Maybe<Element_Input>;
  /**
   * Specifies a preferred order in which to use a set of contacts. ContactPoints
   * with lower rank values are more preferred than those with higher rank values.
   */
  rank?: Maybe<Scalars['positiveInt']>;
  /** Time period when the contact point was/is in use. */
  period?: Maybe<Period_Input>;
};

/** Legally enforceable, formally recorded unilateral or bilateral directive i.e., a policy or agreement. */
export type Contract = {
  __typename?: 'Contract';
  /** Type of resource */
  resourceType: Contract_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique identifier for this Contract or a derivative that references a Source Contract. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Canonical identifier for this contract, represented as a URI (globally unique). */
  _url?: Maybe<Element>;
  /** Canonical identifier for this contract, represented as a URI (globally unique). */
  url?: Maybe<Scalars['uri']>;
  /** An edition identifier used for business purposes to label business significant variants. */
  _version?: Maybe<Element>;
  /** An edition identifier used for business purposes to label business significant variants. */
  version?: Maybe<Scalars['String']>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status?: Maybe<Scalars['code']>;
  /**
   * Legal states of the formation of a legal instrument, which is a formally
   * executed written document that can be formally attributed to its author,
   * records and formally expresses a legally enforceable act, process, or
   * contractual duty, obligation, or right, and therefore evidences that act,
   * process, or agreement.
   */
  legalState?: Maybe<CodeableConcept>;
  /** The URL pointing to a FHIR-defined Contract Definition that is adhered to in whole or part by this Contract. */
  instantiatesCanonical?: Maybe<ContractinstantiatesCanonical_InstantiatesCanonical_Union>;
  /** The URL pointing to an externally maintained definition that is adhered to in whole or in part by this Contract. */
  _instantiatesUri?: Maybe<Element>;
  /** The URL pointing to an externally maintained definition that is adhered to in whole or in part by this Contract. */
  instantiatesUri?: Maybe<Scalars['uri']>;
  /** The minimal content derived from the basal information source at a specific stage in its lifecycle. */
  contentDerivative?: Maybe<CodeableConcept>;
  /** When this  Contract was issued. */
  _issued?: Maybe<Element>;
  /** When this  Contract was issued. */
  issued?: Maybe<Scalars['dateTime']>;
  /** Relevant time or time-period when this Contract is applicable. */
  applies?: Maybe<Period>;
  /** Event resulting in discontinuation or termination of this Contract instance by one or more parties to the contract. */
  expirationType?: Maybe<CodeableConcept>;
  /** The target entity impacted by or of interest to parties to the agreement. */
  subject?: Maybe<Array<Maybe<Contractsubject_Subject_Union>>>;
  /**
   * A formally or informally recognized grouping of people, principals,
   * organizations, or jurisdictions formed for the purpose of achieving some form
   * of collective action such as the promulgation, administration and enforcement
   * of contracts and policies.
   */
  authority?: Maybe<Array<Maybe<Contractauthority_Authority_Union>>>;
  /**
   * Recognized governance framework or system operating with a circumscribed scope
   * in accordance with specified principles, policies, processes or procedures for
   * managing rights, actions, or behaviors of parties or principals relative to resources.
   */
  domain?: Maybe<Array<Maybe<Contractdomain_Domain_Union>>>;
  /** Sites in which the contract is complied with,  exercised, or in force. */
  site?: Maybe<Array<Maybe<Contractsite_Site_Union>>>;
  /**
   * A natural language name identifying this Contract definition, derivative, or
   * instance in any legal state. Provides additional information about its
   * content. This name should be usable as an identifier for the module by machine
   * processing applications such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying this Contract definition, derivative, or
   * instance in any legal state. Provides additional information about its
   * content. This name should be usable as an identifier for the module by machine
   * processing applications such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * A short, descriptive, user-friendly title for this Contract definition,
   * derivative, or instance in any legal state.t giving additional information
   * about its content.
   */
  _title?: Maybe<Element>;
  /**
   * A short, descriptive, user-friendly title for this Contract definition,
   * derivative, or instance in any legal state.t giving additional information
   * about its content.
   */
  title?: Maybe<Scalars['String']>;
  /**
   * An explanatory or alternate user-friendly title for this Contract definition,
   * derivative, or instance in any legal state.t giving additional information
   * about its content.
   */
  _subtitle?: Maybe<Element>;
  /**
   * An explanatory or alternate user-friendly title for this Contract definition,
   * derivative, or instance in any legal state.t giving additional information
   * about its content.
   */
  subtitle?: Maybe<Scalars['String']>;
  /**
   * Alternative representation of the title for this Contract definition,
   * derivative, or instance in any legal state., e.g., a domain specific contract
   * number related to legislation.
   */
  _alias?: Maybe<Element>;
  /**
   * Alternative representation of the title for this Contract definition,
   * derivative, or instance in any legal state., e.g., a domain specific contract
   * number related to legislation.
   */
  alias?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The individual or organization that authored the Contract definition, derivative, or instance in any legal state. */
  author?: Maybe<Contractauthor_Author_Union>;
  /** A selector of legal concerns for this Contract definition, derivative, or instance in any legal state. */
  scope?: Maybe<CodeableConcept>;
  /** Narrows the range of legal concerns to focus on the achievement of specific contractual objectives. */
  topicCodeableConcept?: Maybe<CodeableConcept>;
  /** Narrows the range of legal concerns to focus on the achievement of specific contractual objectives. */
  topicReference?: Maybe<ContracttopicReference_TopicReference_Union>;
  /**
   * A high-level category for the legal instrument, whether constructed as a
   * Contract definition, derivative, or instance in any legal state.  Provides
   * additional information about its content within the context of the Contract's
   * scope to distinguish the kinds of systems that would be interested in the contract.
   */
  type?: Maybe<CodeableConcept>;
  /**
   * Sub-category for the Contract that distinguishes the kinds of systems that
   * would be interested in the Contract within the context of the Contract's scope.
   */
  subType?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Precusory content developed with a focus and intent of supporting the
   * formation a Contract instance, which may be associated with and transformable
   * into a Contract.
   */
  contentDefinition?: Maybe<ContractcontentDefinition>;
  /** One or more Contract Provisions, which may be related and conveyed as a group, and may contain nested groups. */
  term?: Maybe<Array<Maybe<Contractterm>>>;
  /** Information that may be needed by/relevant to the performer in their execution of this term action. */
  supportingInfo?: Maybe<Array<Maybe<ContractsupportingInfo_SupportingInfo_Union>>>;
  /**
   * Links to Provenance records for past versions of this Contract definition,
   * derivative, or instance, which identify key state transitions or updates that
   * are likely to be relevant to a user looking at the current version of the
   * Contract.  The Provence.entity indicates the target that was changed in the
   * update. http://build.fhir.org/provenance-definitions.html#Provenance.entity.
   */
  relevantHistory?: Maybe<Array<Maybe<ContractrelevantHistory_RelevantHistory_Union>>>;
  /**
   * Parties with legal standing in the Contract, including the principal parties,
   * the grantor(s) and grantee(s), which are any person or organization bound by
   * the contract, and any ancillary parties, which facilitate the execution of the
   * contract such as a notary or witness.
   */
  signer?: Maybe<Array<Maybe<Contractsigner>>>;
  /**
   * The 'patient friendly language' versionof the Contract in whole or in parts.
   * 'Patient friendly language' means the representation of the Contract and
   * Contract Provisions in a manner that is readily accessible and understandable
   * by a layperson in accordance with best practices for communication styles that
   * ensure that those agreeing to or signing the Contract understand the roles,
   * actions, obligations, responsibilities, and implication of the agreement.
   */
  friendly?: Maybe<Array<Maybe<Contractfriendly>>>;
  /** List of Legal expressions or representations of this Contract. */
  legal?: Maybe<Array<Maybe<Contractlegal>>>;
  /** List of Computable Policy Rule Language Representations of this Contract. */
  rule?: Maybe<Array<Maybe<Contractrule>>>;
  /**
   * Legally binding Contract: This is the signed and legally recognized
   * representation of the Contract, which is considered the 'source of truth' and
   * which would be the basis for legal action related to enforcement of this Contract.
   */
  legallyBindingAttachment?: Maybe<Attachment>;
  /**
   * Legally binding Contract: This is the signed and legally recognized
   * representation of the Contract, which is considered the 'source of truth' and
   * which would be the basis for legal action related to enforcement of this Contract.
   */
  legallyBindingReference?: Maybe<ContractlegallyBindingReference_LegallyBindingReference_Union>;
};

export enum Contract_Enum_Schema {
  Contract = 'Contract'
}

/** The individual or organization that authored the Contract definition, derivative, or instance in any legal state. */
export type Contractauthor_Author_Union = Patient | Practitioner | PractitionerRole | Organization;

/**
 * A formally or informally recognized grouping of people, principals,
 * organizations, or jurisdictions formed for the purpose of achieving some form of
 * collective action such as the promulgation, administration and enforcement of
 * contracts and policies.
 */
export type Contractauthority_Authority_Union = Organization;

export type ContractcontentDefinition = {
  __typename?: 'ContractcontentDefinition';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Precusory content structure and use, i.e., a boilerplate, template,
   * application for a contract such as an insurance policy or benefits under a
   * program, e.g., workers compensation.
   */
  type: CodeableConcept;
  /** Detailed Precusory content type. */
  subType?: Maybe<CodeableConcept>;
  /** The  individual or organization that published the Contract precursor content. */
  publisher?: Maybe<ContractcontentDefinitionpublisher_Publisher_Union>;
  /**
   * The date (and optionally time) when the contract was published. The date must
   * change when the business version changes and it must change if the status code
   * changes. In addition, it should change when the substantive content of the
   * contract changes.
   */
  _publicationDate?: Maybe<Element>;
  /**
   * The date (and optionally time) when the contract was published. The date must
   * change when the business version changes and it must change if the status code
   * changes. In addition, it should change when the substantive content of the
   * contract changes.
   */
  publicationDate?: Maybe<Scalars['dateTime']>;
  /** draft | active | retired | unknown. */
  _publicationStatus?: Maybe<Element>;
  /** draft | active | retired | unknown. */
  publicationStatus: Scalars['code'];
  /**
   * A copyright statement relating to Contract precursor content. Copyright
   * statements are generally legal restrictions on the use and publishing of the
   * Contract precursor content.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to Contract precursor content. Copyright
   * statements are generally legal restrictions on the use and publishing of the
   * Contract precursor content.
   */
  copyright?: Maybe<Scalars['String']>;
};

/** The  individual or organization that published the Contract precursor content. */
export type ContractcontentDefinitionpublisher_Publisher_Union = Practitioner | PractitionerRole | Organization;

/**
 * Recognized governance framework or system operating with a circumscribed scope
 * in accordance with specified principles, policies, processes or procedures for
 * managing rights, actions, or behaviors of parties or principals relative to resources.
 */
export type Contractdomain_Domain_Union = Location;

export type Contractfriendly = {
  __typename?: 'Contractfriendly';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Human readable rendering of this Contract in a format and representation
   * intended to enhance comprehension and ensure understandability.
   */
  contentAttachment: Attachment;
  /**
   * Human readable rendering of this Contract in a format and representation
   * intended to enhance comprehension and ensure understandability.
   */
  contentReference: ContractfriendlycontentReference_ContentReference_Union;
};

/**
 * Human readable rendering of this Contract in a format and representation
 * intended to enhance comprehension and ensure understandability.
 */
export type ContractfriendlycontentReference_ContentReference_Union = Composition | DocumentReference | QuestionnaireResponse;

/** The URL pointing to a FHIR-defined Contract Definition that is adhered to in whole or part by this Contract. */
export type ContractinstantiatesCanonical_InstantiatesCanonical_Union = Contract;

export type Contractlegal = {
  __typename?: 'Contractlegal';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Contract legal text in human renderable form. */
  contentAttachment: Attachment;
  /** Contract legal text in human renderable form. */
  contentReference: ContractlegalcontentReference_ContentReference_Union;
};

/** Contract legal text in human renderable form. */
export type ContractlegalcontentReference_ContentReference_Union = Composition | DocumentReference | QuestionnaireResponse;

/**
 * Legally binding Contract: This is the signed and legally recognized
 * representation of the Contract, which is considered the 'source of truth' and
 * which would be the basis for legal action related to enforcement of this Contract.
 */
export type ContractlegallyBindingReference_LegallyBindingReference_Union = Composition | DocumentReference | QuestionnaireResponse | Contract;

/**
 * Links to Provenance records for past versions of this Contract definition,
 * derivative, or instance, which identify key state transitions or updates that
 * are likely to be relevant to a user looking at the current version of the
 * Contract.  The Provence.entity indicates the target that was changed in the
 * update. http://build.fhir.org/provenance-definitions.html#Provenance.entity.
 */
export type ContractrelevantHistory_RelevantHistory_Union = Provenance;

export type Contractrule = {
  __typename?: 'Contractrule';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Computable Contract conveyed using a policy rule language (e.g. XACML, DKAL, SecPal). */
  contentAttachment: Attachment;
  /** Computable Contract conveyed using a policy rule language (e.g. XACML, DKAL, SecPal). */
  contentReference: ContractrulecontentReference_ContentReference_Union;
};

/** Computable Contract conveyed using a policy rule language (e.g. XACML, DKAL, SecPal). */
export type ContractrulecontentReference_ContentReference_Union = DocumentReference;

export type Contractsigner = {
  __typename?: 'Contractsigner';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Role of this Contract signer, e.g. notary, grantee. */
  type: Coding;
  /** Party which is a signator to this Contract. */
  party: Contractsignerparty_Party_Union;
  /** Legally binding Contract DSIG signature contents in Base64. */
  signature?: Maybe<Array<Signature>>;
};

/** Party which is a signator to this Contract. */
export type Contractsignerparty_Party_Union = Organization | Patient | Practitioner | PractitionerRole | RelatedPerson;

/** Sites in which the contract is complied with,  exercised, or in force. */
export type Contractsite_Site_Union = Location;

/** The target entity impacted by or of interest to parties to the agreement. */
export type Contractsubject_Subject_Union = Resource;

/** Information that may be needed by/relevant to the performer in their execution of this term action. */
export type ContractsupportingInfo_SupportingInfo_Union = Resource;

export type Contractterm = {
  __typename?: 'Contractterm';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique identifier for this particular Contract Provision. */
  identifier?: Maybe<Identifier>;
  /** When this Contract Provision was issued. */
  _issued?: Maybe<Element>;
  /** When this Contract Provision was issued. */
  issued?: Maybe<Scalars['dateTime']>;
  /** Relevant time or time-period when this Contract Provision is applicable. */
  applies?: Maybe<Period>;
  /** The entity that the term applies to. */
  topicCodeableConcept?: Maybe<CodeableConcept>;
  /** The entity that the term applies to. */
  topicReference?: Maybe<ContracttermtopicReference_TopicReference_Union>;
  /**
   * A legal clause or condition contained within a contract that requires one or
   * both parties to perform a particular requirement by some specified time or
   * prevents one or both parties from performing a particular requirement by some
   * specified time.
   */
  type?: Maybe<CodeableConcept>;
  /** A specialized legal clause or condition based on overarching contract type. */
  subType?: Maybe<CodeableConcept>;
  /** Statement of a provision in a policy or a contract. */
  _text?: Maybe<Element>;
  /** Statement of a provision in a policy or a contract. */
  text?: Maybe<Scalars['String']>;
  /**
   * Security labels that protect the handling of information about the term and
   * its elements, which may be specifically identified..
   */
  securityLabel?: Maybe<Array<Maybe<ContracttermsecurityLabel>>>;
  /** The matter of concern in the context of this provision of the agrement. */
  offer: Contracttermoffer;
  /** Contract Term Asset List. */
  asset?: Maybe<Array<Maybe<Contracttermasset>>>;
  /**
   * An actor taking a role in an activity for which it can be assigned some degree
   * of responsibility for the activity taking place.
   */
  action?: Maybe<Array<Maybe<Contracttermaction>>>;
};

export type Contracttermaction = {
  __typename?: 'Contracttermaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** True if the term prohibits the  action. */
  _doNotPerform?: Maybe<Element>;
  /** True if the term prohibits the  action. */
  doNotPerform?: Maybe<Scalars['Boolean']>;
  /**
   * Activity or service obligation to be done or not done, performed or not
   * performed, effectuated or not by this Contract term.
   */
  type: CodeableConcept;
  /** Entity of the action. */
  subject?: Maybe<Array<Maybe<Contracttermactionsubject>>>;
  /** Reason or purpose for the action stipulated by this Contract Provision. */
  intent: CodeableConcept;
  /** Id [identifier??] of the clause or question text related to this action in the referenced form or QuestionnaireResponse. */
  _linkId?: Maybe<Element>;
  /** Id [identifier??] of the clause or question text related to this action in the referenced form or QuestionnaireResponse. */
  linkId?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Current state of the term action. */
  status: CodeableConcept;
  /** Encounter or Episode with primary association to specified term activity. */
  context?: Maybe<Contracttermactioncontext_Context_Union>;
  /**
   * Id [identifier??] of the clause or question text related to the requester of
   * this action in the referenced form or QuestionnaireResponse.
   */
  _contextLinkId?: Maybe<Element>;
  /**
   * Id [identifier??] of the clause or question text related to the requester of
   * this action in the referenced form or QuestionnaireResponse.
   */
  contextLinkId?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** When action happens. */
  _occurrenceDateTime?: Maybe<Element>;
  /** When action happens. */
  occurrenceDateTime?: Maybe<Scalars['dateTime']>;
  /** When action happens. */
  occurrencePeriod?: Maybe<Period>;
  /** When action happens. */
  occurrenceTiming?: Maybe<Timing>;
  /** Who or what initiated the action and has responsibility for its activation. */
  requester?: Maybe<Array<Maybe<Contracttermactionrequester_Requester_Union>>>;
  /**
   * Id [identifier??] of the clause or question text related to the requester of
   * this action in the referenced form or QuestionnaireResponse.
   */
  _requesterLinkId?: Maybe<Element>;
  /**
   * Id [identifier??] of the clause or question text related to the requester of
   * this action in the referenced form or QuestionnaireResponse.
   */
  requesterLinkId?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The type of individual that is desired or required to perform or not perform the action. */
  performerType?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The type of role or competency of an individual desired or required to perform or not perform the action. */
  performerRole?: Maybe<CodeableConcept>;
  /** Indicates who or what is being asked to perform (or not perform) the ction. */
  performer?: Maybe<Contracttermactionperformer_Performer_Union>;
  /**
   * Id [identifier??] of the clause or question text related to the reason type or
   * reference of this  action in the referenced form or QuestionnaireResponse.
   */
  _performerLinkId?: Maybe<Element>;
  /**
   * Id [identifier??] of the clause or question text related to the reason type or
   * reference of this  action in the referenced form or QuestionnaireResponse.
   */
  performerLinkId?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Rationale for the action to be performed or not performed. Describes why the action is permitted or prohibited. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates another resource whose existence justifies permitting or not permitting this action. */
  reasonReference?: Maybe<Array<Maybe<ContracttermactionreasonReference_ReasonReference_Union>>>;
  /** Describes why the action is to be performed or not performed in textual form. */
  _reason?: Maybe<Element>;
  /** Describes why the action is to be performed or not performed in textual form. */
  reason?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Id [identifier??] of the clause or question text related to the reason type or
   * reference of this  action in the referenced form or QuestionnaireResponse.
   */
  _reasonLinkId?: Maybe<Element>;
  /**
   * Id [identifier??] of the clause or question text related to the reason type or
   * reference of this  action in the referenced form or QuestionnaireResponse.
   */
  reasonLinkId?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Comments made about the term action made by the requester, performer, subject or other participants. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Security labels that protects the action. */
  _securityLabelNumber?: Maybe<Element>;
  /** Security labels that protects the action. */
  securityLabelNumber?: Maybe<Array<Maybe<Scalars['unsignedInt']>>>;
};

/** Encounter or Episode with primary association to specified term activity. */
export type Contracttermactioncontext_Context_Union = Encounter | EpisodeOfCare;

/** Indicates who or what is being asked to perform (or not perform) the ction. */
export type Contracttermactionperformer_Performer_Union = RelatedPerson | Patient | Practitioner | PractitionerRole | CareTeam | Device | Substance | Organization | Location;

/** Indicates another resource whose existence justifies permitting or not permitting this action. */
export type ContracttermactionreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference | Questionnaire | QuestionnaireResponse;

/** Who or what initiated the action and has responsibility for its activation. */
export type Contracttermactionrequester_Requester_Union = Patient | RelatedPerson | Practitioner | PractitionerRole | Device | Group | Organization;

export type Contracttermactionsubject = {
  __typename?: 'Contracttermactionsubject';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The entity the action is performed or not performed on or for. */
  reference?: Maybe<Array<Contracttermactionsubjectreference_Reference_Union>>;
  /** Role type of agent assigned roles in this Contract. */
  role?: Maybe<CodeableConcept>;
};

/** The entity the action is performed or not performed on or for. */
export type Contracttermactionsubjectreference_Reference_Union = Patient | RelatedPerson | Practitioner | PractitionerRole | Device | Group | Organization;

export type Contracttermasset = {
  __typename?: 'Contracttermasset';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Differentiates the kind of the asset . */
  scope?: Maybe<CodeableConcept>;
  /** Target entity type about which the term may be concerned. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Associated entities. */
  typeReference?: Maybe<Array<Maybe<ContracttermassettypeReference_TypeReference_Union>>>;
  /** May be a subtype or part of an offered asset. */
  subtype?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Specifies the applicability of the term to an asset resource instance, and
   * instances it refers to orinstances that refer to it, and/or are owned by the offeree.
   */
  relationship?: Maybe<Coding>;
  /** Circumstance of the asset. */
  context?: Maybe<Array<Maybe<Contracttermassetcontext>>>;
  /** Description of the quality and completeness of the asset that imay be a factor in its valuation. */
  _condition?: Maybe<Element>;
  /** Description of the quality and completeness of the asset that imay be a factor in its valuation. */
  condition?: Maybe<Scalars['String']>;
  /** Type of Asset availability for use or ownership. */
  periodType?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Asset relevant contractual time period. */
  period?: Maybe<Array<Maybe<Period>>>;
  /** Time period of asset use. */
  usePeriod?: Maybe<Array<Maybe<Period>>>;
  /**
   * Clause or question text (Prose Object) concerning the asset in a linked form,
   * such as a QuestionnaireResponse used in the formation of the contract.
   */
  _text?: Maybe<Element>;
  /**
   * Clause or question text (Prose Object) concerning the asset in a linked form,
   * such as a QuestionnaireResponse used in the formation of the contract.
   */
  text?: Maybe<Scalars['String']>;
  /** Id [identifier??] of the clause or question text about the asset in the referenced form or QuestionnaireResponse. */
  _linkId?: Maybe<Element>;
  /** Id [identifier??] of the clause or question text about the asset in the referenced form or QuestionnaireResponse. */
  linkId?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Security labels that protects the asset. */
  _securityLabelNumber?: Maybe<Element>;
  /** Security labels that protects the asset. */
  securityLabelNumber?: Maybe<Array<Maybe<Scalars['unsignedInt']>>>;
  /** Contract Valued Item List. */
  valuedItem?: Maybe<Array<Maybe<ContracttermassetvaluedItem>>>;
};

export type Contracttermassetcontext = {
  __typename?: 'Contracttermassetcontext';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Asset context reference may include the creator, custodian, or owning Person
   * or Organization (e.g., bank, repository),  location held, e.g., building,  jurisdiction.
   */
  reference?: Maybe<Contracttermassetcontextreference_Reference_Union>;
  /** Coded representation of the context generally or of the Referenced entity, such as the asset holder type or location. */
  code?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Context description. */
  _text?: Maybe<Element>;
  /** Context description. */
  text?: Maybe<Scalars['String']>;
};

/**
 * Asset context reference may include the creator, custodian, or owning Person or
 * Organization (e.g., bank, repository),  location held, e.g., building,  jurisdiction.
 */
export type Contracttermassetcontextreference_Reference_Union = Resource;

/** Associated entities. */
export type ContracttermassettypeReference_TypeReference_Union = Resource;

export type ContracttermassetvaluedItem = {
  __typename?: 'ContracttermassetvaluedItem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Specific type of Contract Valued Item that may be priced. */
  entityCodeableConcept?: Maybe<CodeableConcept>;
  /** Specific type of Contract Valued Item that may be priced. */
  entityReference?: Maybe<ContracttermassetvaluedItementityReference_EntityReference_Union>;
  /** Identifies a Contract Valued Item instance. */
  identifier?: Maybe<Identifier>;
  /** Indicates the time during which this Contract ValuedItem information is effective. */
  _effectiveTime?: Maybe<Element>;
  /** Indicates the time during which this Contract ValuedItem information is effective. */
  effectiveTime?: Maybe<Scalars['dateTime']>;
  /**
   * Specifies the units by which the Contract Valued Item is measured or counted,
   * and quantifies the countable or measurable Contract Valued Item instances.
   */
  quantity?: Maybe<Quantity>;
  /** A Contract Valued Item unit valuation measure. */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of the Contract Valued Item delivered. The concept of a Factor allows
   * for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of the Contract Valued Item delivered. The concept of a Factor allows
   * for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /**
   * An amount that expresses the weighting (based on difficulty, cost and/or
   * resource intensiveness) associated with the Contract Valued Item delivered.
   * The concept of Points allows for assignment of point values for a Contract
   * Valued Item, such that a monetary amount can be assigned to each point.
   */
  _points?: Maybe<Element>;
  /**
   * An amount that expresses the weighting (based on difficulty, cost and/or
   * resource intensiveness) associated with the Contract Valued Item delivered.
   * The concept of Points allows for assignment of point values for a Contract
   * Valued Item, such that a monetary amount can be assigned to each point.
   */
  points?: Maybe<Scalars['Float']>;
  /**
   * Expresses the product of the Contract Valued Item unitQuantity and the
   * unitPriceAmt. For example, the formula: unit Quantity * unit Price (Cost per
   * Point) * factor Number  * points = net Amount. Quantity, factor and points are
   * assumed to be 1 if not supplied.
   */
  net?: Maybe<Money>;
  /** Terms of valuation. */
  _payment?: Maybe<Element>;
  /** Terms of valuation. */
  payment?: Maybe<Scalars['String']>;
  /** When payment is due. */
  _paymentDate?: Maybe<Element>;
  /** When payment is due. */
  paymentDate?: Maybe<Scalars['dateTime']>;
  /** Who will make payment. */
  responsible?: Maybe<ContracttermassetvaluedItemresponsible_Responsible_Union>;
  /** Who will receive payment. */
  recipient?: Maybe<ContracttermassetvaluedItemrecipient_Recipient_Union>;
  /**
   * Id  of the clause or question text related to the context of this valuedItem
   * in the referenced form or QuestionnaireResponse.
   */
  _linkId?: Maybe<Element>;
  /**
   * Id  of the clause or question text related to the context of this valuedItem
   * in the referenced form or QuestionnaireResponse.
   */
  linkId?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A set of security labels that define which terms are controlled by this condition. */
  _securityLabelNumber?: Maybe<Element>;
  /** A set of security labels that define which terms are controlled by this condition. */
  securityLabelNumber?: Maybe<Array<Maybe<Scalars['unsignedInt']>>>;
};

/** Specific type of Contract Valued Item that may be priced. */
export type ContracttermassetvaluedItementityReference_EntityReference_Union = Resource;

/** Who will receive payment. */
export type ContracttermassetvaluedItemrecipient_Recipient_Union = Organization | Patient | Practitioner | PractitionerRole | RelatedPerson;

/** Who will make payment. */
export type ContracttermassetvaluedItemresponsible_Responsible_Union = Organization | Patient | Practitioner | PractitionerRole | RelatedPerson;

export type Contracttermoffer = {
  __typename?: 'Contracttermoffer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique identifier for this particular Contract Provision. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Offer Recipient. */
  party?: Maybe<Array<Maybe<Contracttermofferparty>>>;
  /**
   * The owner of an asset has the residual control rights over the asset: the
   * right to decide all usages of the asset in any way not inconsistent with a
   * prior contract, custom, or law (Hart, 1995, p. 30).
   */
  topic?: Maybe<Contracttermoffertopic_Topic_Union>;
  /**
   * Type of Contract Provision such as specific requirements, purposes for
   * actions, obligations, prohibitions, e.g. life time maximum benefit.
   */
  type?: Maybe<CodeableConcept>;
  /** Type of choice made by accepting party with respect to an offer made by an offeror/ grantee. */
  decision?: Maybe<CodeableConcept>;
  /** How the decision about a Contract was conveyed. */
  decisionMode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Response to offer text. */
  answer?: Maybe<Array<Maybe<Contracttermofferanswer>>>;
  /** Human readable form of this Contract Offer. */
  _text?: Maybe<Element>;
  /** Human readable form of this Contract Offer. */
  text?: Maybe<Scalars['String']>;
  /** The id of the clause or question text of the offer in the referenced questionnaire/response. */
  _linkId?: Maybe<Element>;
  /** The id of the clause or question text of the offer in the referenced questionnaire/response. */
  linkId?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Security labels that protects the offer. */
  _securityLabelNumber?: Maybe<Element>;
  /** Security labels that protects the offer. */
  securityLabelNumber?: Maybe<Array<Maybe<Scalars['unsignedInt']>>>;
};

export type Contracttermofferanswer = {
  __typename?: 'Contracttermofferanswer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  _valueBoolean?: Maybe<Element>;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueBoolean: Scalars['Boolean'];
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  _valueDecimal?: Maybe<Element>;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueDecimal: Scalars['Float'];
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  _valueInteger?: Maybe<Element>;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueInteger: Scalars['Int'];
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  _valueDate?: Maybe<Element>;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueDate: Scalars['date'];
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  _valueDateTime?: Maybe<Element>;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueDateTime: Scalars['dateTime'];
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  _valueTime?: Maybe<Element>;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueTime: Scalars['time'];
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  _valueString?: Maybe<Element>;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueString: Scalars['String'];
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  _valueUri?: Maybe<Element>;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueUri: Scalars['uri'];
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueAttachment: Attachment;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueCoding: Coding;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueQuantity: Quantity;
  /**
   * Response to an offer clause or question text,  which enables selection of
   * values to be agreed to, e.g., the period of participation, the date of
   * occupancy of a rental, warrently duration, or whether biospecimen may be used
   * for further research.
   */
  valueReference: ContracttermofferanswervalueReference_ValueReference_Union;
};

/**
 * Response to an offer clause or question text,  which enables selection of values
 * to be agreed to, e.g., the period of participation, the date of occupancy of a
 * rental, warrently duration, or whether biospecimen may be used for further research.
 */
export type ContracttermofferanswervalueReference_ValueReference_Union = Resource;

export type Contracttermofferparty = {
  __typename?: 'Contracttermofferparty';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Participant in the offer. */
  reference?: Maybe<Array<Contracttermofferpartyreference_Reference_Union>>;
  /** How the party participates in the offer. */
  role: CodeableConcept;
};

/** Participant in the offer. */
export type Contracttermofferpartyreference_Reference_Union = Patient | RelatedPerson | Practitioner | PractitionerRole | Device | Group | Organization;

/**
 * The owner of an asset has the residual control rights over the asset: the right
 * to decide all usages of the asset in any way not inconsistent with a prior
 * contract, custom, or law (Hart, 1995, p. 30).
 */
export type Contracttermoffertopic_Topic_Union = Resource;

export type ContracttermsecurityLabel = {
  __typename?: 'ContracttermsecurityLabel';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Number used to link this term or term element to the applicable Security Label. */
  _number?: Maybe<Element>;
  /** Number used to link this term or term element to the applicable Security Label. */
  number?: Maybe<Array<Maybe<Scalars['unsignedInt']>>>;
  /**
   * Security label privacy tag that species the level of confidentiality
   * protection required for this term and/or term elements.
   */
  classification: Coding;
  /**
   * Security label privacy tag that species the applicable privacy and security
   * policies governing this term and/or term elements.
   */
  category?: Maybe<Array<Maybe<Coding>>>;
  /** Security label privacy tag that species the manner in which term and/or term elements are to be protected. */
  control?: Maybe<Array<Maybe<Coding>>>;
};

/** The entity that the term applies to. */
export type ContracttermtopicReference_TopicReference_Union = Resource;

/** Narrows the range of legal concerns to focus on the achievement of specific contractual objectives. */
export type ContracttopicReference_TopicReference_Union = Resource;

/**
 * Base StructureDefinition for Contributor Type: A contributor to the content of a
 * knowledge asset, including authors, editors, reviewers, and endorsers.
 */
export type Contributor = {
  __typename?: 'Contributor';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of contributor. */
  _type?: Maybe<Element>;
  /** The type of contributor. */
  type: Scalars['code'];
  /** The name of the individual or organization responsible for the contribution. */
  _name?: Maybe<Element>;
  /** The name of the individual or organization responsible for the contribution. */
  name: Scalars['String'];
  /** Contact details to assist a user in finding and communicating with the contributor. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
};

/**
 * Base StructureDefinition for Contributor Type: A contributor to the content of a
 * knowledge asset, including authors, editors, reviewers, and endorsers.
 */
export type Contributor_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The type of contributor. */
  _type?: Maybe<Element_Input>;
  /** The type of contributor. */
  type: Scalars['code'];
  /** The name of the individual or organization responsible for the contribution. */
  _name?: Maybe<Element_Input>;
  /** The name of the individual or organization responsible for the contribution. */
  name: Scalars['String'];
  /** Contact details to assist a user in finding and communicating with the contributor. */
  contact?: Maybe<Array<Maybe<ContactDetail_Input>>>;
};

/**
 * Base StructureDefinition for Count Type: A measured amount (or an amount that
 * can potentially be measured). Note that measured amounts include amounts that
 * are not precisely quantified, including amounts involving arbitrary units and
 * floating currencies.
 */
export type Count = {
  __typename?: 'Count';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  _value?: Maybe<Element>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  value?: Maybe<Scalars['Float']>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  _comparator?: Maybe<Element>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  comparator?: Maybe<Scalars['code']>;
  /** A human-readable form of the unit. */
  _unit?: Maybe<Element>;
  /** A human-readable form of the unit. */
  unit?: Maybe<Scalars['String']>;
  /** The identification of the system that provides the coded form of the unit. */
  _system?: Maybe<Element>;
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars['uri']>;
  /** A computer processable form of the unit in some unit representation system. */
  _code?: Maybe<Element>;
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars['code']>;
};

/**
 * Base StructureDefinition for Count Type: A measured amount (or an amount that
 * can potentially be measured). Note that measured amounts include amounts that
 * are not precisely quantified, including amounts involving arbitrary units and
 * floating currencies.
 */
export type Count_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  _value?: Maybe<Element_Input>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  value?: Maybe<Scalars['Float']>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  _comparator?: Maybe<Element_Input>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  comparator?: Maybe<Scalars['code']>;
  /** A human-readable form of the unit. */
  _unit?: Maybe<Element_Input>;
  /** A human-readable form of the unit. */
  unit?: Maybe<Scalars['String']>;
  /** The identification of the system that provides the coded form of the unit. */
  _system?: Maybe<Element_Input>;
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars['uri']>;
  /** A computer processable form of the unit in some unit representation system. */
  _code?: Maybe<Element_Input>;
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars['code']>;
};

/**
 * Financial instrument which may be used to reimburse or pay for health care
 * products and services. Includes both insurance and self-payment.
 */
export type Coverage = {
  __typename?: 'Coverage';
  /** Type of resource */
  resourceType: Coverage_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this coverage. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status: Scalars['code'];
  /**
   * The type of coverage: social program, medical plan, accident coverage (workers
   * compensation, auto), group health or payment by an individual or organization.
   */
  type?: Maybe<CodeableConcept>;
  /** The party who 'owns' the insurance policy. */
  policyHolder?: Maybe<CoveragepolicyHolder_PolicyHolder_Union>;
  /**
   * The party who has signed-up for or 'owns' the contractual relationship to the
   * policy or to whom the benefit of the policy for services rendered to them or
   * their family is due.
   */
  subscriber?: Maybe<Coveragesubscriber_Subscriber_Union>;
  /** The insurer assigned ID for the Subscriber. */
  _subscriberId?: Maybe<Element>;
  /** The insurer assigned ID for the Subscriber. */
  subscriberId?: Maybe<Scalars['String']>;
  /** The party who benefits from the insurance coverage; the patient when products and/or services are provided. */
  beneficiary: Coveragebeneficiary_Beneficiary_Union;
  /** A unique identifier for a dependent under the coverage. */
  _dependent?: Maybe<Element>;
  /** A unique identifier for a dependent under the coverage. */
  dependent?: Maybe<Scalars['String']>;
  /** The relationship of beneficiary (patient) to the subscriber. */
  relationship?: Maybe<CodeableConcept>;
  /**
   * Time period during which the coverage is in force. A missing start date
   * indicates the start date isn't known, a missing end date means the coverage is
   * continuing to be in force.
   */
  period?: Maybe<Period>;
  /**
   * The program or plan underwriter or payor including both insurance and
   * non-insurance agreements, such as patient-pay agreements.
   */
  payor?: Maybe<Array<Coveragepayor_Payor_Union>>;
  /** A suite of underwriter specific classifiers. */
  class?: Maybe<Array<Maybe<Coverageclass>>>;
  /**
   * The order of applicability of this coverage relative to other coverages which
   * are currently in force. Note, there may be gaps in the numbering and this does
   * not imply primary, secondary etc. as the specific positioning of coverages
   * depends upon the episode of care.
   */
  _order?: Maybe<Element>;
  /**
   * The order of applicability of this coverage relative to other coverages which
   * are currently in force. Note, there may be gaps in the numbering and this does
   * not imply primary, secondary etc. as the specific positioning of coverages
   * depends upon the episode of care.
   */
  order?: Maybe<Scalars['positiveInt']>;
  /**
   * The insurer-specific identifier for the insurer-defined network of providers
   * to which the beneficiary may seek treatment which will be covered at the
   * 'in-network' rate, otherwise 'out of network' terms and conditions apply.
   */
  _network?: Maybe<Element>;
  /**
   * The insurer-specific identifier for the insurer-defined network of providers
   * to which the beneficiary may seek treatment which will be covered at the
   * 'in-network' rate, otherwise 'out of network' terms and conditions apply.
   */
  network?: Maybe<Scalars['String']>;
  /**
   * A suite of codes indicating the cost category and associated amount which have
   * been detailed in the policy and may have been  included on the health card.
   */
  costToBeneficiary?: Maybe<Array<Maybe<CoveragecostToBeneficiary>>>;
  /**
   * When 'subrogation=true' this insurance instance has been included not for
   * adjudication but to provide insurers with the details to recover costs.
   */
  _subrogation?: Maybe<Element>;
  /**
   * When 'subrogation=true' this insurance instance has been included not for
   * adjudication but to provide insurers with the details to recover costs.
   */
  subrogation?: Maybe<Scalars['Boolean']>;
  /** The policy(s) which constitute this insurance coverage. */
  contract?: Maybe<Array<Maybe<Coveragecontract_Contract_Union>>>;
};

/**
 * The CoverageEligibilityRequest provides patient and insurance coverage
 * information to an insurer for them to respond, in the form of an
 * CoverageEligibilityResponse, with information regarding whether the stated
 * coverage is valid and in-force and optionally to provide the insurance details of the policy.
 */
export type CoverageEligibilityRequest = {
  __typename?: 'CoverageEligibilityRequest';
  /** Type of resource */
  resourceType: CoverageEligibilityRequest_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this coverage eligiblity request. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status: Scalars['code'];
  /** When the requestor expects the processor to complete processing. */
  priority?: Maybe<CodeableConcept>;
  /**
   * Code to specify whether requesting: prior authorization requirements for some
   * service categories or billing codes; benefits for coverages specified or
   * discovered; discovery and return of coverages for the patient; and/or
   * validation that the specified coverage is in-force at the date/period
   * specified or 'now' if not specified.
   */
  _purpose?: Maybe<Element>;
  /**
   * Code to specify whether requesting: prior authorization requirements for some
   * service categories or billing codes; benefits for coverages specified or
   * discovered; discovery and return of coverages for the patient; and/or
   * validation that the specified coverage is in-force at the date/period
   * specified or 'now' if not specified.
   */
  purpose?: Maybe<Array<Scalars['code']>>;
  /** The party who is the beneficiary of the supplied coverage and for whom eligibility is sought. */
  patient: CoverageEligibilityRequestpatient_Patient_Union;
  /** The date or dates when the enclosed suite of services were performed or completed. */
  _servicedDate?: Maybe<Element>;
  /** The date or dates when the enclosed suite of services were performed or completed. */
  servicedDate?: Maybe<Scalars['date']>;
  /** The date or dates when the enclosed suite of services were performed or completed. */
  servicedPeriod?: Maybe<Period>;
  /** The date when this resource was created. */
  _created?: Maybe<Element>;
  /** The date when this resource was created. */
  created: Scalars['dateTime'];
  /** Person who created the request. */
  enterer?: Maybe<CoverageEligibilityRequestenterer_Enterer_Union>;
  /** The provider which is responsible for the request. */
  provider?: Maybe<CoverageEligibilityRequestprovider_Provider_Union>;
  /** The Insurer who issued the coverage in question and is the recipient of the request. */
  insurer: CoverageEligibilityRequestinsurer_Insurer_Union;
  /** Facility where the services are intended to be provided. */
  facility?: Maybe<CoverageEligibilityRequestfacility_Facility_Union>;
  /**
   * Additional information codes regarding exceptions, special considerations, the
   * condition, situation, prior or concurrent issues.
   */
  supportingInfo?: Maybe<Array<Maybe<CoverageEligibilityRequestsupportingInfo>>>;
  /** Financial instruments for reimbursement for the health care products and services. */
  insurance?: Maybe<Array<Maybe<CoverageEligibilityRequestinsurance>>>;
  /**
   * Service categories or billable services for which benefit details and/or an
   * authorization prior to service delivery may be required by the payor.
   */
  item?: Maybe<Array<Maybe<CoverageEligibilityRequestitem>>>;
};

export enum CoverageEligibilityRequest_Enum_Schema {
  CoverageEligibilityRequest = 'CoverageEligibilityRequest'
}

/** Person who created the request. */
export type CoverageEligibilityRequestenterer_Enterer_Union = Practitioner | PractitionerRole;

/** Facility where the services are intended to be provided. */
export type CoverageEligibilityRequestfacility_Facility_Union = Location;

export type CoverageEligibilityRequestinsurance = {
  __typename?: 'CoverageEligibilityRequestinsurance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A flag to indicate that this Coverage is to be used for evaluation of this request when set to true. */
  _focal?: Maybe<Element>;
  /** A flag to indicate that this Coverage is to be used for evaluation of this request when set to true. */
  focal?: Maybe<Scalars['Boolean']>;
  /**
   * Reference to the insurance card level information contained in the Coverage
   * resource. The coverage issuing insurer will use these details to locate the
   * patient's actual coverage within the insurer's information system.
   */
  coverage: CoverageEligibilityRequestinsurancecoverage_Coverage_Union;
  /** A business agreement number established between the provider and the insurer for special business processing purposes. */
  _businessArrangement?: Maybe<Element>;
  /** A business agreement number established between the provider and the insurer for special business processing purposes. */
  businessArrangement?: Maybe<Scalars['String']>;
};

/**
 * Reference to the insurance card level information contained in the Coverage
 * resource. The coverage issuing insurer will use these details to locate the
 * patient's actual coverage within the insurer's information system.
 */
export type CoverageEligibilityRequestinsurancecoverage_Coverage_Union = Coverage;

/** The Insurer who issued the coverage in question and is the recipient of the request. */
export type CoverageEligibilityRequestinsurer_Insurer_Union = Organization;

export type CoverageEligibilityRequestitem = {
  __typename?: 'CoverageEligibilityRequestitem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Exceptions, special conditions and supporting information applicable for this service or product line. */
  _supportingInfoSequence?: Maybe<Element>;
  /** Exceptions, special conditions and supporting information applicable for this service or product line. */
  supportingInfoSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** Code to identify the general type of benefits under which products and services are provided. */
  category?: Maybe<CodeableConcept>;
  /** This contains the product, service, drug or other billing code for the item. */
  productOrService?: Maybe<CodeableConcept>;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The practitioner who is responsible for the product or service to be rendered to the patient. */
  provider?: Maybe<CoverageEligibilityRequestitemprovider_Provider_Union>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /** The amount charged to the patient by the provider for a single unit. */
  unitPrice?: Maybe<Money>;
  /** Facility where the services will be provided. */
  facility?: Maybe<CoverageEligibilityRequestitemfacility_Facility_Union>;
  /** Patient diagnosis for which care is sought. */
  diagnosis?: Maybe<Array<Maybe<CoverageEligibilityRequestitemdiagnosis>>>;
  /** The plan/proposal/order describing the proposed service in detail. */
  detail?: Maybe<Array<Maybe<CoverageEligibilityRequestitemdetail_Detail_Union>>>;
};

/** The plan/proposal/order describing the proposed service in detail. */
export type CoverageEligibilityRequestitemdetail_Detail_Union = Resource;

export type CoverageEligibilityRequestitemdiagnosis = {
  __typename?: 'CoverageEligibilityRequestitemdiagnosis';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The nature of illness or problem in a coded form or as a reference to an external defined Condition. */
  diagnosisCodeableConcept?: Maybe<CodeableConcept>;
  /** The nature of illness or problem in a coded form or as a reference to an external defined Condition. */
  diagnosisReference?: Maybe<CoverageEligibilityRequestitemdiagnosisdiagnosisReference_DiagnosisReference_Union>;
};

/** The nature of illness or problem in a coded form or as a reference to an external defined Condition. */
export type CoverageEligibilityRequestitemdiagnosisdiagnosisReference_DiagnosisReference_Union = Condition;

/** Facility where the services will be provided. */
export type CoverageEligibilityRequestitemfacility_Facility_Union = Location | Organization;

/** The practitioner who is responsible for the product or service to be rendered to the patient. */
export type CoverageEligibilityRequestitemprovider_Provider_Union = Practitioner | PractitionerRole;

/** The party who is the beneficiary of the supplied coverage and for whom eligibility is sought. */
export type CoverageEligibilityRequestpatient_Patient_Union = Patient;

/** The provider which is responsible for the request. */
export type CoverageEligibilityRequestprovider_Provider_Union = Practitioner | PractitionerRole | Organization;

export type CoverageEligibilityRequestsupportingInfo = {
  __typename?: 'CoverageEligibilityRequestsupportingInfo';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify supporting information entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify supporting information entries. */
  sequence: Scalars['positiveInt'];
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  information: CoverageEligibilityRequestsupportingInfoinformation_Information_Union;
  /** The supporting materials are applicable for all detail items, product/servce categories and specific billing codes. */
  _appliesToAll?: Maybe<Element>;
  /** The supporting materials are applicable for all detail items, product/servce categories and specific billing codes. */
  appliesToAll?: Maybe<Scalars['Boolean']>;
};

/**
 * Additional data or information such as resources, documents, images etc.
 * including references to the data or the actual inclusion of the data.
 */
export type CoverageEligibilityRequestsupportingInfoinformation_Information_Union = Resource;

/** This resource provides eligibility and plan details from the processing of an CoverageEligibilityRequest resource. */
export type CoverageEligibilityResponse = {
  __typename?: 'CoverageEligibilityResponse';
  /** Type of resource */
  resourceType: CoverageEligibilityResponse_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this coverage eligiblity request. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status: Scalars['code'];
  /**
   * Code to specify whether requesting: prior authorization requirements for some
   * service categories or billing codes; benefits for coverages specified or
   * discovered; discovery and return of coverages for the patient; and/or
   * validation that the specified coverage is in-force at the date/period
   * specified or 'now' if not specified.
   */
  _purpose?: Maybe<Element>;
  /**
   * Code to specify whether requesting: prior authorization requirements for some
   * service categories or billing codes; benefits for coverages specified or
   * discovered; discovery and return of coverages for the patient; and/or
   * validation that the specified coverage is in-force at the date/period
   * specified or 'now' if not specified.
   */
  purpose?: Maybe<Array<Scalars['code']>>;
  /** The party who is the beneficiary of the supplied coverage and for whom eligibility is sought. */
  patient: CoverageEligibilityResponsepatient_Patient_Union;
  /** The date or dates when the enclosed suite of services were performed or completed. */
  _servicedDate?: Maybe<Element>;
  /** The date or dates when the enclosed suite of services were performed or completed. */
  servicedDate?: Maybe<Scalars['date']>;
  /** The date or dates when the enclosed suite of services were performed or completed. */
  servicedPeriod?: Maybe<Period>;
  /** The date this resource was created. */
  _created?: Maybe<Element>;
  /** The date this resource was created. */
  created: Scalars['dateTime'];
  /** The provider which is responsible for the request. */
  requestor?: Maybe<CoverageEligibilityResponserequestor_Requestor_Union>;
  /** Reference to the original request resource. */
  request: CoverageEligibilityResponserequest_Request_Union;
  /** The outcome of the request processing. */
  _outcome?: Maybe<Element>;
  /** The outcome of the request processing. */
  outcome: Scalars['code'];
  /** A human readable description of the status of the adjudication. */
  _disposition?: Maybe<Element>;
  /** A human readable description of the status of the adjudication. */
  disposition?: Maybe<Scalars['String']>;
  /** The Insurer who issued the coverage in question and is the author of the response. */
  insurer: CoverageEligibilityResponseinsurer_Insurer_Union;
  /** Financial instruments for reimbursement for the health care products and services. */
  insurance?: Maybe<Array<Maybe<CoverageEligibilityResponseinsurance>>>;
  /**
   * A reference from the Insurer to which these services pertain to be used on
   * further communication and as proof that the request occurred.
   */
  _preAuthRef?: Maybe<Element>;
  /**
   * A reference from the Insurer to which these services pertain to be used on
   * further communication and as proof that the request occurred.
   */
  preAuthRef?: Maybe<Scalars['String']>;
  /** A code for the form to be used for printing the content. */
  form?: Maybe<CodeableConcept>;
  /** Errors encountered during the processing of the request. */
  error?: Maybe<Array<Maybe<CoverageEligibilityResponseerror>>>;
};

export enum CoverageEligibilityResponse_Enum_Schema {
  CoverageEligibilityResponse = 'CoverageEligibilityResponse'
}

export type CoverageEligibilityResponseerror = {
  __typename?: 'CoverageEligibilityResponseerror';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An error code,from a specified code system, which details why the eligibility check could not be performed. */
  code: CodeableConcept;
};

export type CoverageEligibilityResponseinsurance = {
  __typename?: 'CoverageEligibilityResponseinsurance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Reference to the insurance card level information contained in the Coverage
   * resource. The coverage issuing insurer will use these details to locate the
   * patient's actual coverage within the insurer's information system.
   */
  coverage: CoverageEligibilityResponseinsurancecoverage_Coverage_Union;
  /**
   * Flag indicating if the coverage provided is inforce currently if no service
   * date(s) specified or for the whole duration of the service dates.
   */
  _inforce?: Maybe<Element>;
  /**
   * Flag indicating if the coverage provided is inforce currently if no service
   * date(s) specified or for the whole duration of the service dates.
   */
  inforce?: Maybe<Scalars['Boolean']>;
  /** The term of the benefits documented in this response. */
  benefitPeriod?: Maybe<Period>;
  /** Benefits and optionally current balances, and authorization details by category or service. */
  item?: Maybe<Array<Maybe<CoverageEligibilityResponseinsuranceitem>>>;
};

/**
 * Reference to the insurance card level information contained in the Coverage
 * resource. The coverage issuing insurer will use these details to locate the
 * patient's actual coverage within the insurer's information system.
 */
export type CoverageEligibilityResponseinsurancecoverage_Coverage_Union = Coverage;

export type CoverageEligibilityResponseinsuranceitem = {
  __typename?: 'CoverageEligibilityResponseinsuranceitem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Code to identify the general type of benefits under which products and services are provided. */
  category?: Maybe<CodeableConcept>;
  /** This contains the product, service, drug or other billing code for the item. */
  productOrService?: Maybe<CodeableConcept>;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The practitioner who is eligible for the provision of the product or service. */
  provider?: Maybe<CoverageEligibilityResponseinsuranceitemprovider_Provider_Union>;
  /**
   * True if the indicated class of service is excluded from the plan, missing or
   * False indicates the product or service is included in the coverage.
   */
  _excluded?: Maybe<Element>;
  /**
   * True if the indicated class of service is excluded from the plan, missing or
   * False indicates the product or service is included in the coverage.
   */
  excluded?: Maybe<Scalars['Boolean']>;
  /** A short name or tag for the benefit. */
  _name?: Maybe<Element>;
  /** A short name or tag for the benefit. */
  name?: Maybe<Scalars['String']>;
  /** A richer description of the benefit or services covered. */
  _description?: Maybe<Element>;
  /** A richer description of the benefit or services covered. */
  description?: Maybe<Scalars['String']>;
  /** Is a flag to indicate whether the benefits refer to in-network providers or out-of-network providers. */
  network?: Maybe<CodeableConcept>;
  /** Indicates if the benefits apply to an individual or to the family. */
  unit?: Maybe<CodeableConcept>;
  /** The term or period of the values such as 'maximum lifetime benefit' or 'maximum annual visits'. */
  term?: Maybe<CodeableConcept>;
  /** Benefits used to date. */
  benefit?: Maybe<Array<Maybe<CoverageEligibilityResponseinsuranceitembenefit>>>;
  /** A boolean flag indicating whether a preauthorization is required prior to actual service delivery. */
  _authorizationRequired?: Maybe<Element>;
  /** A boolean flag indicating whether a preauthorization is required prior to actual service delivery. */
  authorizationRequired?: Maybe<Scalars['Boolean']>;
  /** Codes or comments regarding information or actions associated with the preauthorization. */
  authorizationSupporting?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A web location for obtaining requirements or descriptive information regarding the preauthorization. */
  _authorizationUrl?: Maybe<Element>;
  /** A web location for obtaining requirements or descriptive information regarding the preauthorization. */
  authorizationUrl?: Maybe<Scalars['uri']>;
};

export type CoverageEligibilityResponseinsuranceitembenefit = {
  __typename?: 'CoverageEligibilityResponseinsuranceitembenefit';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Classification of benefit being provided. */
  type: CodeableConcept;
  /** The quantity of the benefit which is permitted under the coverage. */
  _allowedUnsignedInt?: Maybe<Element>;
  /** The quantity of the benefit which is permitted under the coverage. */
  allowedUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /** The quantity of the benefit which is permitted under the coverage. */
  _allowedString?: Maybe<Element>;
  /** The quantity of the benefit which is permitted under the coverage. */
  allowedString?: Maybe<Scalars['String']>;
  /** The quantity of the benefit which is permitted under the coverage. */
  allowedMoney?: Maybe<Money>;
  /** The quantity of the benefit which have been consumed to date. */
  _usedUnsignedInt?: Maybe<Element>;
  /** The quantity of the benefit which have been consumed to date. */
  usedUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /** The quantity of the benefit which have been consumed to date. */
  _usedString?: Maybe<Element>;
  /** The quantity of the benefit which have been consumed to date. */
  usedString?: Maybe<Scalars['String']>;
  /** The quantity of the benefit which have been consumed to date. */
  usedMoney?: Maybe<Money>;
};

/** The practitioner who is eligible for the provision of the product or service. */
export type CoverageEligibilityResponseinsuranceitemprovider_Provider_Union = Practitioner | PractitionerRole;

/** The Insurer who issued the coverage in question and is the author of the response. */
export type CoverageEligibilityResponseinsurer_Insurer_Union = Organization;

/** The party who is the beneficiary of the supplied coverage and for whom eligibility is sought. */
export type CoverageEligibilityResponsepatient_Patient_Union = Patient;

/** Reference to the original request resource. */
export type CoverageEligibilityResponserequest_Request_Union = CoverageEligibilityRequest;

/** The provider which is responsible for the request. */
export type CoverageEligibilityResponserequestor_Requestor_Union = Practitioner | PractitionerRole | Organization;

export enum Coverage_Enum_Schema {
  Coverage = 'Coverage'
}

/** The party who benefits from the insurance coverage; the patient when products and/or services are provided. */
export type Coveragebeneficiary_Beneficiary_Union = Patient;

export type Coverageclass = {
  __typename?: 'Coverageclass';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The type of classification for which an insurer-specific class label or number
   * and optional name is provided, for example may be used to identify a class of
   * coverage or employer group, Policy, Plan.
   */
  type: CodeableConcept;
  /** The alphanumeric string value associated with the insurer issued label. */
  _value?: Maybe<Element>;
  /** The alphanumeric string value associated with the insurer issued label. */
  value: Scalars['String'];
  /** A short description for the class. */
  _name?: Maybe<Element>;
  /** A short description for the class. */
  name?: Maybe<Scalars['String']>;
};

/** The policy(s) which constitute this insurance coverage. */
export type Coveragecontract_Contract_Union = Contract;

export type CoveragecostToBeneficiary = {
  __typename?: 'CoveragecostToBeneficiary';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The category of patient centric costs associated with treatment. */
  type?: Maybe<CodeableConcept>;
  /** The amount due from the patient for the cost category. */
  valueQuantity: Quantity;
  /** The amount due from the patient for the cost category. */
  valueMoney: Money;
  /** A suite of codes indicating exceptions or reductions to patient costs and their effective periods. */
  exception?: Maybe<Array<Maybe<CoveragecostToBeneficiaryexception>>>;
};

export type CoveragecostToBeneficiaryexception = {
  __typename?: 'CoveragecostToBeneficiaryexception';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The code for the specific exception. */
  type: CodeableConcept;
  /** The timeframe during when the exception is in force. */
  period?: Maybe<Period>;
};

/**
 * The program or plan underwriter or payor including both insurance and
 * non-insurance agreements, such as patient-pay agreements.
 */
export type Coveragepayor_Payor_Union = Organization | Patient | RelatedPerson;

/** The party who 'owns' the insurance policy. */
export type CoveragepolicyHolder_PolicyHolder_Union = Patient | RelatedPerson | Organization;

/**
 * The party who has signed-up for or 'owns' the contractual relationship to the
 * policy or to whom the benefit of the policy for services rendered to them or
 * their family is due.
 */
export type Coveragesubscriber_Subscriber_Union = Patient | RelatedPerson;

/** CrisisSafeguard_Input. */
export type CrisisSafeguard = {
  __typename?: 'CrisisSafeguard';
  /** Type of resource */
  resourceType: CrisisSafeguard_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** templateName. */
  countAll?: Maybe<Scalars['Int']>;
  /** templateName. */
  templateName?: Maybe<Scalars['String']>;
  /** templateMode. */
  templateMode?: Maybe<Scalars['String']>;
  /** templateType. */
  templateType?: Maybe<Scalars['String']>;
  /** templateData. */
  templateData?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** practitionerId. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitionerName. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitionerSpeciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** status */
  patientId?: Maybe<Scalars['String']>;
  /** message */
  status?: Maybe<Scalars['String']>;
  /** message */
  name?: Maybe<Scalars['String']>;
  /** message */
  email?: Maybe<Scalars['String']>;
  /** templateData. */
  templateJsonData?: Maybe<Scalars['String']>;
  /** status */
  patientName?: Maybe<Scalars['String']>;
  /** status */
  gpName?: Maybe<Scalars['String']>;
  /** status */
  gpEmail?: Maybe<Scalars['String']>;
  /** status */
  gpPractitionerName?: Maybe<Scalars['String']>;
  /** notificationMessage */
  notificationMessage?: Maybe<Scalars['String']>;
  /** adminName */
  adminName?: Maybe<Scalars['String']>;
  /** adminEmail */
  adminEmail?: Maybe<Scalars['String']>;
  /** GraphQLBoolean */
  adminLetter?: Maybe<Scalars['Boolean']>;
  /** status */
  letterType?: Maybe<Scalars['Int']>;
  /** practitioner Id. */
  letterUploadUrl?: Maybe<Scalars['String']>;
};

export enum CrisisSafeguardInput_Enum_Input {
  CrisisSafeguard = 'CrisisSafeguard'
}

export enum CrisisSafeguard_Enum {
  CrisisSafeguard = 'CrisisSafeguard'
}

/** Crisis Safeguard */
export type CrisisSafeguard_Input = {
  /** Type of resource */
  resourceType: CrisisSafeguardInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** templateName. */
  templateName?: Maybe<Scalars['String']>;
  /** templateMode. */
  templateMode?: Maybe<Scalars['String']>;
  /** templateType. */
  templateType?: Maybe<Scalars['String']>;
  /** templateData. */
  templateData?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** practitionerId. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitionerName. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitionerSpeciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** status */
  patientId?: Maybe<Scalars['String']>;
  /** message */
  status?: Maybe<Scalars['String']>;
  /** message */
  name?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  email?: Maybe<Scalars['String']>;
  /** templateData. */
  templateJsonData?: Maybe<Scalars['String']>;
  /** status */
  patientName?: Maybe<Scalars['String']>;
  /** status */
  gpName?: Maybe<Scalars['String']>;
  /** status */
  gpEmail?: Maybe<Scalars['String']>;
  /** status */
  gpPractitionerName?: Maybe<Scalars['String']>;
  /** notificationMessage */
  notificationMessage?: Maybe<Scalars['String']>;
};

/**
 * Base StructureDefinition for DataRequirement Type: Describes a required data
 * item for evaluation in terms of the type of data, and optional code or
 * date-based filters of the data.
 */
export type DataRequirement = {
  __typename?: 'DataRequirement';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The type of the required data, specified as the type name of a resource. For
   * profiles, this value is set to the type of the base resource of the profile.
   */
  _type?: Maybe<Element>;
  /**
   * The type of the required data, specified as the type name of a resource. For
   * profiles, this value is set to the type of the base resource of the profile.
   */
  type: Scalars['code'];
  /** The profile of the required data, specified as the uri of the profile definition. */
  _profile?: Maybe<Element>;
  /** The profile of the required data, specified as the uri of the profile definition. */
  profile?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** The intended subjects of the data requirement. If this element is not provided, a Patient subject is assumed. */
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  /** The intended subjects of the data requirement. If this element is not provided, a Patient subject is assumed. */
  subjectReference?: Maybe<DataRequirementsubjectReference_SubjectReference_Union>;
  /**
   * Indicates that specific elements of the type are referenced by the knowledge
   * module and must be supported by the consumer in order to obtain an effective
   * evaluation. This does not mean that a value is required for this element, only
   * that the consuming system must understand the element and be able to provide
   * values for it if they are available.   The value of mustSupport SHALL be a
   * FHIRPath resolveable on the type of the DataRequirement. The path SHALL
   * consist only of identifiers, constant indexers, and .resolve() (see the
   * [Simple FHIRPath Profile](fhirpath.html#simple) for full details).
   */
  _mustSupport?: Maybe<Element>;
  /**
   * Indicates that specific elements of the type are referenced by the knowledge
   * module and must be supported by the consumer in order to obtain an effective
   * evaluation. This does not mean that a value is required for this element, only
   * that the consuming system must understand the element and be able to provide
   * values for it if they are available.   The value of mustSupport SHALL be a
   * FHIRPath resolveable on the type of the DataRequirement. The path SHALL
   * consist only of identifiers, constant indexers, and .resolve() (see the
   * [Simple FHIRPath Profile](fhirpath.html#simple) for full details).
   */
  mustSupport?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Code filters specify additional constraints on the data, specifying the value
   * set of interest for a particular element of the data. Each code filter defines
   * an additional constraint on the data, i.e. code filters are AND'ed, not OR'ed.
   */
  codeFilter?: Maybe<Array<Maybe<Element>>>;
  /**
   * Date filters specify additional constraints on the data in terms of the
   * applicable date range for specific elements. Each date filter specifies an
   * additional constraint on the data, i.e. date filters are AND'ed, not OR'ed.
   */
  dateFilter?: Maybe<Array<Maybe<Element>>>;
  /** Specifies a maximum number of results that are required (uses the _count search parameter). */
  _limit?: Maybe<Element>;
  /** Specifies a maximum number of results that are required (uses the _count search parameter). */
  limit?: Maybe<Scalars['positiveInt']>;
  /** Specifies the order of the results to be returned. */
  sort?: Maybe<Array<Maybe<Element>>>;
};

/**
 * Base StructureDefinition for DataRequirement Type: Describes a required data
 * item for evaluation in terms of the type of data, and optional code or
 * date-based filters of the data.
 */
export type DataRequirement_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * The type of the required data, specified as the type name of a resource. For
   * profiles, this value is set to the type of the base resource of the profile.
   */
  _type?: Maybe<Element_Input>;
  /**
   * The type of the required data, specified as the type name of a resource. For
   * profiles, this value is set to the type of the base resource of the profile.
   */
  type: Scalars['code'];
  /** The profile of the required data, specified as the uri of the profile definition. */
  _profile?: Maybe<Element_Input>;
  /** The profile of the required data, specified as the uri of the profile definition. */
  profile?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** The intended subjects of the data requirement. If this element is not provided, a Patient subject is assumed. */
  subjectCodeableConcept?: Maybe<CodeableConcept_Input>;
  /** The intended subjects of the data requirement. If this element is not provided, a Patient subject is assumed. */
  subjectReference?: Maybe<Scalars['String']>;
  /**
   * Indicates that specific elements of the type are referenced by the knowledge
   * module and must be supported by the consumer in order to obtain an effective
   * evaluation. This does not mean that a value is required for this element, only
   * that the consuming system must understand the element and be able to provide
   * values for it if they are available.   The value of mustSupport SHALL be a
   * FHIRPath resolveable on the type of the DataRequirement. The path SHALL
   * consist only of identifiers, constant indexers, and .resolve() (see the
   * [Simple FHIRPath Profile](fhirpath.html#simple) for full details).
   */
  _mustSupport?: Maybe<Element_Input>;
  /**
   * Indicates that specific elements of the type are referenced by the knowledge
   * module and must be supported by the consumer in order to obtain an effective
   * evaluation. This does not mean that a value is required for this element, only
   * that the consuming system must understand the element and be able to provide
   * values for it if they are available.   The value of mustSupport SHALL be a
   * FHIRPath resolveable on the type of the DataRequirement. The path SHALL
   * consist only of identifiers, constant indexers, and .resolve() (see the
   * [Simple FHIRPath Profile](fhirpath.html#simple) for full details).
   */
  mustSupport?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Code filters specify additional constraints on the data, specifying the value
   * set of interest for a particular element of the data. Each code filter defines
   * an additional constraint on the data, i.e. code filters are AND'ed, not OR'ed.
   */
  codeFilter?: Maybe<Array<Maybe<Element_Input>>>;
  /**
   * Date filters specify additional constraints on the data in terms of the
   * applicable date range for specific elements. Each date filter specifies an
   * additional constraint on the data, i.e. date filters are AND'ed, not OR'ed.
   */
  dateFilter?: Maybe<Array<Maybe<Element_Input>>>;
  /** Specifies a maximum number of results that are required (uses the _count search parameter). */
  _limit?: Maybe<Element_Input>;
  /** Specifies a maximum number of results that are required (uses the _count search parameter). */
  limit?: Maybe<Scalars['positiveInt']>;
  /** Specifies the order of the results to be returned. */
  sort?: Maybe<Array<Maybe<Element_Input>>>;
};

/** The intended subjects of the data requirement. If this element is not provided, a Patient subject is assumed. */
export type DataRequirementsubjectReference_SubjectReference_Union = Group;

/**
 * Indicates an actual or potential clinical issue with or between one or more
 * active or proposed clinical actions for a patient; e.g. Drug-drug interaction,
 * Ineffective treatment frequency, Procedure-condition conflict, etc.
 */
export type DetectedIssue = {
  __typename?: 'DetectedIssue';
  /** Type of resource */
  resourceType: DetectedIssue_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Business identifier associated with the detected issue record. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Indicates the status of the detected issue. */
  _status?: Maybe<Element>;
  /** Indicates the status of the detected issue. */
  status: Scalars['code'];
  /** Identifies the general type of issue identified. */
  code?: Maybe<CodeableConcept>;
  /** Indicates the degree of importance associated with the identified issue based on the potential impact on the patient. */
  _severity?: Maybe<Element>;
  /** Indicates the degree of importance associated with the identified issue based on the potential impact on the patient. */
  severity?: Maybe<Scalars['code']>;
  /** Indicates the patient whose record the detected issue is associated with. */
  patient?: Maybe<DetectedIssuepatient_Patient_Union>;
  /** The date or period when the detected issue was initially identified. */
  _identifiedDateTime?: Maybe<Element>;
  /** The date or period when the detected issue was initially identified. */
  identifiedDateTime?: Maybe<Scalars['dateTime']>;
  /** The date or period when the detected issue was initially identified. */
  identifiedPeriod?: Maybe<Period>;
  /**
   * Individual or device responsible for the issue being raised.  For example, a
   * decision support application or a pharmacist conducting a medication review.
   */
  author?: Maybe<DetectedIssueauthor_Author_Union>;
  /** Indicates the resource representing the current activity or proposed activity that is potentially problematic. */
  implicated?: Maybe<Array<Maybe<DetectedIssueimplicated_Implicated_Union>>>;
  /**
   * Supporting evidence or manifestations that provide the basis for identifying
   * the detected issue such as a GuidanceResponse or MeasureReport.
   */
  evidence?: Maybe<Array<Maybe<DetectedIssueevidence>>>;
  /** A textual explanation of the detected issue. */
  _detail?: Maybe<Element>;
  /** A textual explanation of the detected issue. */
  detail?: Maybe<Scalars['String']>;
  /** The literature, knowledge-base or similar reference that describes the propensity for the detected issue identified. */
  _reference?: Maybe<Element>;
  /** The literature, knowledge-base or similar reference that describes the propensity for the detected issue identified. */
  reference?: Maybe<Scalars['uri']>;
  /**
   * Indicates an action that has been taken or is committed to reduce or eliminate
   * the likelihood of the risk identified by the detected issue from manifesting.
   * Can also reflect an observation of known mitigating factors that may
   * reduce/eliminate the need for any action.
   */
  mitigation?: Maybe<Array<Maybe<DetectedIssuemitigation>>>;
};

export enum DetectedIssue_Enum_Schema {
  DetectedIssue = 'DetectedIssue'
}

/**
 * Individual or device responsible for the issue being raised.  For example, a
 * decision support application or a pharmacist conducting a medication review.
 */
export type DetectedIssueauthor_Author_Union = Practitioner | PractitionerRole | Device;

export type DetectedIssueevidence = {
  __typename?: 'DetectedIssueevidence';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A manifestation that led to the recording of this detected issue. */
  code?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Links to resources that constitute evidence for the detected issue such as a GuidanceResponse or MeasureReport. */
  detail?: Maybe<Array<Maybe<DetectedIssueevidencedetail_Detail_Union>>>;
};

/** Links to resources that constitute evidence for the detected issue such as a GuidanceResponse or MeasureReport. */
export type DetectedIssueevidencedetail_Detail_Union = Resource;

/** Indicates the resource representing the current activity or proposed activity that is potentially problematic. */
export type DetectedIssueimplicated_Implicated_Union = Resource;

export type DetectedIssuemitigation = {
  __typename?: 'DetectedIssuemitigation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Describes the action that was taken or the observation that was made that
   * reduces/eliminates the risk associated with the identified issue.
   */
  action: CodeableConcept;
  /** Indicates when the mitigating action was documented. */
  _date?: Maybe<Element>;
  /** Indicates when the mitigating action was documented. */
  date?: Maybe<Scalars['dateTime']>;
  /** Identifies the practitioner who determined the mitigation and takes responsibility for the mitigation step occurring. */
  author?: Maybe<DetectedIssuemitigationauthor_Author_Union>;
};

/** Identifies the practitioner who determined the mitigation and takes responsibility for the mitigation step occurring. */
export type DetectedIssuemitigationauthor_Author_Union = Practitioner | PractitionerRole;

/** Indicates the patient whose record the detected issue is associated with. */
export type DetectedIssuepatient_Patient_Union = Patient;

/**
 * A type of a manufactured item that is used in the provision of healthcare
 * without being substantially changed through that activity. The device may be a
 * medical or non-medical device.
 */
export type Device = {
  __typename?: 'Device';
  /** Type of resource */
  resourceType: Device_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique instance identifiers assigned to a device by manufacturers other organizations or owners. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The reference to the definition for the device. */
  definition?: Maybe<Devicedefinition_Definition_Union>;
  /**
   * Unique device identifier (UDI) assigned to device label or package.  Note that
   * the Device may include multiple udiCarriers as it either may include just the
   * udiCarrier for the jurisdiction it is sold, or for multiple jurisdictions it
   * could have been sold.
   */
  udiCarrier?: Maybe<Array<Maybe<DeviceudiCarrier>>>;
  /** Status of the Device availability. */
  _status?: Maybe<Element>;
  /** Status of the Device availability. */
  status?: Maybe<Scalars['code']>;
  /** Reason for the dtatus of the Device availability. */
  statusReason?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * The distinct identification string as required by regulation for a human cell,
   * tissue, or cellular and tissue-based product.
   */
  _distinctIdentifier?: Maybe<Element>;
  /**
   * The distinct identification string as required by regulation for a human cell,
   * tissue, or cellular and tissue-based product.
   */
  distinctIdentifier?: Maybe<Scalars['String']>;
  /** A name of the manufacturer. */
  _manufacturer?: Maybe<Element>;
  /** A name of the manufacturer. */
  manufacturer?: Maybe<Scalars['String']>;
  /** The date and time when the device was manufactured. */
  _manufactureDate?: Maybe<Element>;
  /** The date and time when the device was manufactured. */
  manufactureDate?: Maybe<Scalars['dateTime']>;
  /** The date and time beyond which this device is no longer valid or should not be used (if applicable). */
  _expirationDate?: Maybe<Element>;
  /** The date and time beyond which this device is no longer valid or should not be used (if applicable). */
  expirationDate?: Maybe<Scalars['dateTime']>;
  /** Lot number assigned by the manufacturer. */
  _lotNumber?: Maybe<Element>;
  /** Lot number assigned by the manufacturer. */
  lotNumber?: Maybe<Scalars['String']>;
  /** The serial number assigned by the organization when the device was manufactured. */
  _serialNumber?: Maybe<Element>;
  /** The serial number assigned by the organization when the device was manufactured. */
  serialNumber?: Maybe<Scalars['String']>;
  /**
   * This represents the manufacturer's name of the device as provided by the
   * device, from a UDI label, or by a person describing the Device.  This
   * typically would be used when a person provides the name(s) or when the device
   * represents one of the names available from DeviceDefinition.
   */
  deviceName?: Maybe<Array<Maybe<DevicedeviceName>>>;
  /** The model number for the device. */
  _modelNumber?: Maybe<Element>;
  /** The model number for the device. */
  modelNumber?: Maybe<Scalars['String']>;
  /** The part number of the device. */
  _partNumber?: Maybe<Element>;
  /** The part number of the device. */
  partNumber?: Maybe<Scalars['String']>;
  /** The kind or type of device. */
  type?: Maybe<CodeableConcept>;
  /**
   * The capabilities supported on a  device, the standards to which the device
   * conforms for a particular purpose, and used for the communication.
   */
  specialization?: Maybe<Array<Maybe<Devicespecialization>>>;
  /** The actual design of the device or software version running on the device. */
  version?: Maybe<Array<Maybe<Deviceversion>>>;
  /** The actual configuration settings of a device as it actually operates, e.g., regulation status, time properties. */
  property?: Maybe<Array<Maybe<Deviceproperty>>>;
  /** Patient information, If the device is affixed to a person. */
  patient?: Maybe<Devicepatient_Patient_Union>;
  /** An organization that is responsible for the provision and ongoing maintenance of the device. */
  owner?: Maybe<Deviceowner_Owner_Union>;
  /** Contact details for an organization or a particular human that is responsible for the device. */
  contact?: Maybe<Array<Maybe<ContactPoint>>>;
  /** The place where the device can be found. */
  location?: Maybe<Devicelocation_Location_Union>;
  /** A network address on which the device may be contacted directly. */
  _url?: Maybe<Element>;
  /** A network address on which the device may be contacted directly. */
  url?: Maybe<Scalars['uri']>;
  /** Descriptive information, usage information or implantation information that is not captured in an existing element. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Provides additional safety characteristics about a medical device.  For example devices containing latex. */
  safety?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The parent device. */
  parent?: Maybe<Deviceparent_Parent_Union>;
};

/** The characteristics, operational status and capabilities of a medical-related component of a medical device. */
export type DeviceDefinition = {
  __typename?: 'DeviceDefinition';
  /** Type of resource */
  resourceType: DeviceDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Unique instance identifiers assigned to a device by the software,
   * manufacturers, other organizations or owners. For example: handle ID.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * Unique device identifier (UDI) assigned to device label or package.  Note that
   * the Device may include multiple udiCarriers as it either may include just the
   * udiCarrier for the jurisdiction it is sold, or for multiple jurisdictions it
   * could have been sold.
   */
  udiDeviceIdentifier?: Maybe<Array<Maybe<DeviceDefinitionudiDeviceIdentifier>>>;
  /** A name of the manufacturer. */
  _manufacturerString?: Maybe<Element>;
  /** A name of the manufacturer. */
  manufacturerString?: Maybe<Scalars['String']>;
  /** A name of the manufacturer. */
  manufacturerReference?: Maybe<DeviceDefinitionmanufacturerReference_ManufacturerReference_Union>;
  /** A name given to the device to identify it. */
  deviceName?: Maybe<Array<Maybe<DeviceDefinitiondeviceName>>>;
  /** The model number for the device. */
  _modelNumber?: Maybe<Element>;
  /** The model number for the device. */
  modelNumber?: Maybe<Scalars['String']>;
  /** What kind of device or device system this is. */
  type?: Maybe<CodeableConcept>;
  /**
   * The capabilities supported on a  device, the standards to which the device
   * conforms for a particular purpose, and used for the communication.
   */
  specialization?: Maybe<Array<Maybe<DeviceDefinitionspecialization>>>;
  /** The available versions of the device, e.g., software versions. */
  _version?: Maybe<Element>;
  /** The available versions of the device, e.g., software versions. */
  version?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Safety characteristics of the device. */
  safety?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Shelf Life and storage information. */
  shelfLifeStorage?: Maybe<Array<Maybe<ProductShelfLife>>>;
  /** Dimensions, color etc. */
  physicalCharacteristics?: Maybe<ProdCharacteristic>;
  /** Language code for the human-readable text strings produced by the device (all supported). */
  languageCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Device capabilities. */
  capability?: Maybe<Array<Maybe<DeviceDefinitioncapability>>>;
  /** The actual configuration settings of a device as it actually operates, e.g., regulation status, time properties. */
  property?: Maybe<Array<Maybe<DeviceDefinitionproperty>>>;
  /** An organization that is responsible for the provision and ongoing maintenance of the device. */
  owner?: Maybe<DeviceDefinitionowner_Owner_Union>;
  /** Contact details for an organization or a particular human that is responsible for the device. */
  contact?: Maybe<Array<Maybe<ContactPoint>>>;
  /** A network address on which the device may be contacted directly. */
  _url?: Maybe<Element>;
  /** A network address on which the device may be contacted directly. */
  url?: Maybe<Scalars['uri']>;
  /** Access to on-line information about the device. */
  _onlineInformation?: Maybe<Element>;
  /** Access to on-line information about the device. */
  onlineInformation?: Maybe<Scalars['uri']>;
  /** Descriptive information, usage information or implantation information that is not captured in an existing element. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * The quantity of the device present in the packaging (e.g. the number of
   * devices present in a pack, or the number of devices in the same package of the
   * medicinal product).
   */
  quantity?: Maybe<Quantity>;
  /** The parent device it can be part of. */
  parentDevice?: Maybe<DeviceDefinitionparentDevice_ParentDevice_Union>;
  /** A substance used to create the material(s) of which the device is made. */
  material?: Maybe<Array<Maybe<DeviceDefinitionmaterial>>>;
};

export enum DeviceDefinition_Enum_Schema {
  DeviceDefinition = 'DeviceDefinition'
}

export type DeviceDefinitioncapability = {
  __typename?: 'DeviceDefinitioncapability';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of capability. */
  type: CodeableConcept;
  /** Description of capability. */
  description?: Maybe<Array<Maybe<CodeableConcept>>>;
};

export type DeviceDefinitiondeviceName = {
  __typename?: 'DeviceDefinitiondeviceName';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of the device. */
  _name?: Maybe<Element>;
  /** The name of the device. */
  name: Scalars['String'];
  /** The type of deviceName. UDILabelName | UserFriendlyName | PatientReportedName | ManufactureDeviceName | ModelName. */
  _type?: Maybe<Element>;
  /** The type of deviceName. UDILabelName | UserFriendlyName | PatientReportedName | ManufactureDeviceName | ModelName. */
  type: Scalars['code'];
};

/** A name of the manufacturer. */
export type DeviceDefinitionmanufacturerReference_ManufacturerReference_Union = Organization;

export type DeviceDefinitionmaterial = {
  __typename?: 'DeviceDefinitionmaterial';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The substance. */
  substance: CodeableConcept;
  /** Indicates an alternative material of the device. */
  _alternate?: Maybe<Element>;
  /** Indicates an alternative material of the device. */
  alternate?: Maybe<Scalars['Boolean']>;
  /** Whether the substance is a known or suspected allergen. */
  _allergenicIndicator?: Maybe<Element>;
  /** Whether the substance is a known or suspected allergen. */
  allergenicIndicator?: Maybe<Scalars['Boolean']>;
};

/** An organization that is responsible for the provision and ongoing maintenance of the device. */
export type DeviceDefinitionowner_Owner_Union = Organization;

/** The parent device it can be part of. */
export type DeviceDefinitionparentDevice_ParentDevice_Union = DeviceDefinition;

export type DeviceDefinitionproperty = {
  __typename?: 'DeviceDefinitionproperty';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Code that specifies the property DeviceDefinitionPropetyCode (Extensible). */
  type: CodeableConcept;
  /** Property value as a quantity. */
  valueQuantity?: Maybe<Array<Maybe<Quantity>>>;
  /** Property value as a code, e.g., NTP4 (synced to NTP). */
  valueCode?: Maybe<Array<Maybe<CodeableConcept>>>;
};

export type DeviceDefinitionspecialization = {
  __typename?: 'DeviceDefinitionspecialization';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The standard that is used to operate and communicate. */
  _systemType?: Maybe<Element>;
  /** The standard that is used to operate and communicate. */
  systemType: Scalars['String'];
  /** The version of the standard that is used to operate and communicate. */
  _version?: Maybe<Element>;
  /** The version of the standard that is used to operate and communicate. */
  version?: Maybe<Scalars['String']>;
};

export type DeviceDefinitionudiDeviceIdentifier = {
  __typename?: 'DeviceDefinitionudiDeviceIdentifier';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The identifier that is to be associated with every Device that references this
   * DeviceDefintiion for the issuer and jurisdication porvided in the
   * DeviceDefinition.udiDeviceIdentifier.
   */
  _deviceIdentifier?: Maybe<Element>;
  /**
   * The identifier that is to be associated with every Device that references this
   * DeviceDefintiion for the issuer and jurisdication porvided in the
   * DeviceDefinition.udiDeviceIdentifier.
   */
  deviceIdentifier: Scalars['String'];
  /** The organization that assigns the identifier algorithm. */
  _issuer?: Maybe<Element>;
  /** The organization that assigns the identifier algorithm. */
  issuer: Scalars['uri'];
  /** The jurisdiction to which the deviceIdentifier applies. */
  _jurisdiction?: Maybe<Element>;
  /** The jurisdiction to which the deviceIdentifier applies. */
  jurisdiction: Scalars['uri'];
};

/** Describes a measurement, calculation or setting capability of a medical device. */
export type DeviceMetric = {
  __typename?: 'DeviceMetric';
  /** Type of resource */
  resourceType: DeviceMetric_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Unique instance identifiers assigned to a device by the device or gateway
   * software, manufacturers, other organizations or owners. For example: handle ID.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Describes the type of the metric. For example: Heart Rate, PEEP Setting, etc. */
  type: CodeableConcept;
  /** Describes the unit that an observed value determined for this metric will have. For example: Percent, Seconds, etc. */
  unit?: Maybe<CodeableConcept>;
  /**
   * Describes the link to the  Device that this DeviceMetric belongs to and that
   * contains administrative device information such as manufacturer, serial number, etc.
   */
  source?: Maybe<DeviceMetricsource_Source_Union>;
  /**
   * Describes the link to the  Device that this DeviceMetric belongs to and that
   * provide information about the location of this DeviceMetric in the containment
   * structure of the parent Device. An example would be a Device that represents a
   * Channel. This reference can be used by a client application to distinguish
   * DeviceMetrics that have the same type, but should be interpreted based on
   * their containment location.
   */
  parent?: Maybe<DeviceMetricparent_Parent_Union>;
  /** Indicates current operational state of the device. For example: On, Off, Standby, etc. */
  _operationalStatus?: Maybe<Element>;
  /** Indicates current operational state of the device. For example: On, Off, Standby, etc. */
  operationalStatus?: Maybe<Scalars['code']>;
  /**
   * Describes the color representation for the metric. This is often used to aid
   * clinicians to track and identify parameter types by color. In practice,
   * consider a Patient Monitor that has ECG/HR and Pleth for example; the
   * parameters are displayed in different characteristic colors, such as HR-blue,
   * BP-green, and PR and SpO2- magenta.
   */
  _color?: Maybe<Element>;
  /**
   * Describes the color representation for the metric. This is often used to aid
   * clinicians to track and identify parameter types by color. In practice,
   * consider a Patient Monitor that has ECG/HR and Pleth for example; the
   * parameters are displayed in different characteristic colors, such as HR-blue,
   * BP-green, and PR and SpO2- magenta.
   */
  color?: Maybe<Scalars['code']>;
  /**
   * Indicates the category of the observation generation process. A DeviceMetric
   * can be for example a setting, measurement, or calculation.
   */
  _category?: Maybe<Element>;
  /**
   * Indicates the category of the observation generation process. A DeviceMetric
   * can be for example a setting, measurement, or calculation.
   */
  category: Scalars['code'];
  /**
   * Describes the measurement repetition time. This is not necessarily the same as
   * the update period. The measurement repetition time can range from milliseconds
   * up to hours. An example for a measurement repetition time in the range of
   * milliseconds is the sampling rate of an ECG. An example for a measurement
   * repetition time in the range of hours is a NIBP that is triggered
   * automatically every hour. The update period may be different than the
   * measurement repetition time, if the device does not update the published
   * observed value with the same frequency as it was measured.
   */
  measurementPeriod?: Maybe<Timing>;
  /** Describes the calibrations that have been performed or that are required to be performed. */
  calibration?: Maybe<Array<Maybe<DeviceMetriccalibration>>>;
};

export enum DeviceMetric_Enum_Schema {
  DeviceMetric = 'DeviceMetric'
}

export type DeviceMetriccalibration = {
  __typename?: 'DeviceMetriccalibration';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Describes the type of the calibration method. */
  _type?: Maybe<Element>;
  /** Describes the type of the calibration method. */
  type?: Maybe<Scalars['code']>;
  /** Describes the state of the calibration. */
  _state?: Maybe<Element>;
  /** Describes the state of the calibration. */
  state?: Maybe<Scalars['code']>;
  /** Describes the time last calibration has been performed. */
  _time?: Maybe<Element>;
  /** Describes the time last calibration has been performed. */
  time?: Maybe<Scalars['instant']>;
};

/**
 * Describes the link to the  Device that this DeviceMetric belongs to and that
 * provide information about the location of this DeviceMetric in the containment
 * structure of the parent Device. An example would be a Device that represents a
 * Channel. This reference can be used by a client application to distinguish
 * DeviceMetrics that have the same type, but should be interpreted based on their
 * containment location.
 */
export type DeviceMetricparent_Parent_Union = Device;

/**
 * Describes the link to the  Device that this DeviceMetric belongs to and that
 * contains administrative device information such as manufacturer, serial number, etc.
 */
export type DeviceMetricsource_Source_Union = Device;

/**
 * Represents a request for a patient to employ a medical device. The device may be
 * an implantable device, or an external assistive device, such as a walker.
 */
export type DeviceRequest = {
  __typename?: 'DeviceRequest';
  /** Type of resource */
  resourceType: DeviceRequest_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifiers assigned to this order by the orderer or by the receiver. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this DeviceRequest.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this DeviceRequest.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this DeviceRequest.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this DeviceRequest.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** Plan/proposal/order fulfilled by this request. */
  basedOn?: Maybe<Array<Maybe<DeviceRequestbasedOn_BasedOn_Union>>>;
  /** The request takes the place of the referenced completed or terminated request(s). */
  priorRequest?: Maybe<Array<Maybe<DeviceRequestpriorRequest_PriorRequest_Union>>>;
  /** Composite request this is part of. */
  groupIdentifier?: Maybe<Identifier>;
  /** The status of the request. */
  _status?: Maybe<Element>;
  /** The status of the request. */
  status?: Maybe<Scalars['code']>;
  /** Whether the request is a proposal, plan, an original order or a reflex order. */
  _intent?: Maybe<Element>;
  /** Whether the request is a proposal, plan, an original order or a reflex order. */
  intent: Scalars['code'];
  /** Indicates how quickly the {{title}} should be addressed with respect to other requests. */
  _priority?: Maybe<Element>;
  /** Indicates how quickly the {{title}} should be addressed with respect to other requests. */
  priority?: Maybe<Scalars['code']>;
  /** The details of the device to be used. */
  codeReference: DeviceRequestcodeReference_CodeReference_Union;
  /** The details of the device to be used. */
  codeCodeableConcept: CodeableConcept;
  /** Specific parameters for the ordered item.  For example, the prism value for lenses. */
  parameter?: Maybe<Array<Maybe<DeviceRequestparameter>>>;
  /** The patient who will use the device. */
  subject: DeviceRequestsubject_Subject_Union;
  /** An encounter that provides additional context in which this request is made. */
  encounter?: Maybe<DeviceRequestencounter_Encounter_Union>;
  /**
   * The timing schedule for the use of the device. The Schedule data type allows
   * many different expressions, for example. 'Every 8 hours'; 'Three times a day';
   * '1/2 an hour before breakfast for 10 days from 23-Dec 2011:'; '15 Oct 2013, 17
   * Oct 2013 and 1 Nov 2013'.
   */
  _occurrenceDateTime?: Maybe<Element>;
  /**
   * The timing schedule for the use of the device. The Schedule data type allows
   * many different expressions, for example. 'Every 8 hours'; 'Three times a day';
   * '1/2 an hour before breakfast for 10 days from 23-Dec 2011:'; '15 Oct 2013, 17
   * Oct 2013 and 1 Nov 2013'.
   */
  occurrenceDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The timing schedule for the use of the device. The Schedule data type allows
   * many different expressions, for example. 'Every 8 hours'; 'Three times a day';
   * '1/2 an hour before breakfast for 10 days from 23-Dec 2011:'; '15 Oct 2013, 17
   * Oct 2013 and 1 Nov 2013'.
   */
  occurrencePeriod?: Maybe<Period>;
  /**
   * The timing schedule for the use of the device. The Schedule data type allows
   * many different expressions, for example. 'Every 8 hours'; 'Three times a day';
   * '1/2 an hour before breakfast for 10 days from 23-Dec 2011:'; '15 Oct 2013, 17
   * Oct 2013 and 1 Nov 2013'.
   */
  occurrenceTiming?: Maybe<Timing>;
  /** When the request transitioned to being actionable. */
  _authoredOn?: Maybe<Element>;
  /** When the request transitioned to being actionable. */
  authoredOn?: Maybe<Scalars['dateTime']>;
  /** The individual who initiated the request and has responsibility for its activation. */
  requester?: Maybe<DeviceRequestrequester_Requester_Union>;
  /** Desired type of performer for doing the diagnostic testing. */
  performerType?: Maybe<CodeableConcept>;
  /** The desired performer for doing the diagnostic testing. */
  performer?: Maybe<DeviceRequestperformer_Performer_Union>;
  /** Reason or justification for the use of this device. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Reason or justification for the use of this device. */
  reasonReference?: Maybe<Array<Maybe<DeviceRequestreasonReference_ReasonReference_Union>>>;
  /**
   * Insurance plans, coverage extensions, pre-authorizations and/or
   * pre-determinations that may be required for delivering the requested service.
   */
  insurance?: Maybe<Array<Maybe<DeviceRequestinsurance_Insurance_Union>>>;
  /**
   * Additional clinical information about the patient that may influence the
   * request fulfilment.  For example, this may include where on the subject's body
   * the device will be used (i.e. the target site).
   */
  supportingInfo?: Maybe<Array<Maybe<DeviceRequestsupportingInfo_SupportingInfo_Union>>>;
  /**
   * Details about this request that were not represented at all or sufficiently in
   * one of the attributes provided in a class. These may include for example a
   * comment, an instruction, or a note associated with the statement.
   */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Key events in the history of the request. */
  relevantHistory?: Maybe<Array<Maybe<DeviceRequestrelevantHistory_RelevantHistory_Union>>>;
};

export enum DeviceRequest_Enum_Schema {
  DeviceRequest = 'DeviceRequest'
}

/** Plan/proposal/order fulfilled by this request. */
export type DeviceRequestbasedOn_BasedOn_Union = Resource;

/** The details of the device to be used. */
export type DeviceRequestcodeReference_CodeReference_Union = Device;

/** An encounter that provides additional context in which this request is made. */
export type DeviceRequestencounter_Encounter_Union = Encounter;

/**
 * Insurance plans, coverage extensions, pre-authorizations and/or
 * pre-determinations that may be required for delivering the requested service.
 */
export type DeviceRequestinsurance_Insurance_Union = Coverage | ClaimResponse;

export type DeviceRequestparameter = {
  __typename?: 'DeviceRequestparameter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A code or string that identifies the device detail being asserted. */
  code?: Maybe<CodeableConcept>;
  /** The value of the device detail. */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** The value of the device detail. */
  valueQuantity?: Maybe<Quantity>;
  /** The value of the device detail. */
  valueRange?: Maybe<Range>;
  /** The value of the device detail. */
  _valueBoolean?: Maybe<Element>;
  /** The value of the device detail. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
};

/** The desired performer for doing the diagnostic testing. */
export type DeviceRequestperformer_Performer_Union = Practitioner | PractitionerRole | Organization | CareTeam | HealthcareService | Patient | Device | RelatedPerson;

/** The request takes the place of the referenced completed or terminated request(s). */
export type DeviceRequestpriorRequest_PriorRequest_Union = Resource;

/** Reason or justification for the use of this device. */
export type DeviceRequestreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference;

/** Key events in the history of the request. */
export type DeviceRequestrelevantHistory_RelevantHistory_Union = Provenance;

/** The individual who initiated the request and has responsibility for its activation. */
export type DeviceRequestrequester_Requester_Union = Device | Practitioner | PractitionerRole | Organization;

/** The patient who will use the device. */
export type DeviceRequestsubject_Subject_Union = Patient | Group | Location | Device;

/**
 * Additional clinical information about the patient that may influence the request
 * fulfilment.  For example, this may include where on the subject's body the
 * device will be used (i.e. the target site).
 */
export type DeviceRequestsupportingInfo_SupportingInfo_Union = Resource;

/**
 * A record of a device being used by a patient where the record is the result of a
 * report from the patient or another clinician.
 */
export type DeviceUseStatement = {
  __typename?: 'DeviceUseStatement';
  /** Type of resource */
  resourceType: DeviceUseStatement_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An external identifier for this statement such as an IRI. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A plan, proposal or order that is fulfilled in whole or in part by this DeviceUseStatement. */
  basedOn?: Maybe<Array<Maybe<DeviceUseStatementbasedOn_BasedOn_Union>>>;
  /**
   * A code representing the patient or other source's judgment about the state of
   * the device used that this statement is about.  Generally this will be active or completed.
   */
  _status?: Maybe<Element>;
  /**
   * A code representing the patient or other source's judgment about the state of
   * the device used that this statement is about.  Generally this will be active or completed.
   */
  status: Scalars['code'];
  /** The patient who used the device. */
  subject: DeviceUseStatementsubject_Subject_Union;
  /**
   * Allows linking the DeviceUseStatement to the underlying Request, or to other
   * information that supports or is used to derive the DeviceUseStatement.
   */
  derivedFrom?: Maybe<Array<Maybe<DeviceUseStatementderivedFrom_DerivedFrom_Union>>>;
  /** How often the device was used. */
  timingTiming?: Maybe<Timing>;
  /** How often the device was used. */
  timingPeriod?: Maybe<Period>;
  /** How often the device was used. */
  _timingDateTime?: Maybe<Element>;
  /** How often the device was used. */
  timingDateTime?: Maybe<Scalars['dateTime']>;
  /** The time at which the statement was made/recorded. */
  _recordedOn?: Maybe<Element>;
  /** The time at which the statement was made/recorded. */
  recordedOn?: Maybe<Scalars['dateTime']>;
  /** Who reported the device was being used by the patient. */
  source?: Maybe<DeviceUseStatementsource_Source_Union>;
  /** The details of the device used. */
  device: DeviceUseStatementdevice_Device_Union;
  /** Reason or justification for the use of the device. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates another resource whose existence justifies this DeviceUseStatement. */
  reasonReference?: Maybe<Array<Maybe<DeviceUseStatementreasonReference_ReasonReference_Union>>>;
  /** Indicates the anotomic location on the subject's body where the device was used ( i.e. the target). */
  bodySite?: Maybe<CodeableConcept>;
  /**
   * Details about the device statement that were not represented at all or
   * sufficiently in one of the attributes provided in a class. These may include
   * for example a comment, an instruction, or a note associated with the statement.
   */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export enum DeviceUseStatement_Enum_Schema {
  DeviceUseStatement = 'DeviceUseStatement'
}

/** A plan, proposal or order that is fulfilled in whole or in part by this DeviceUseStatement. */
export type DeviceUseStatementbasedOn_BasedOn_Union = ServiceRequest;

/**
 * Allows linking the DeviceUseStatement to the underlying Request, or to other
 * information that supports or is used to derive the DeviceUseStatement.
 */
export type DeviceUseStatementderivedFrom_DerivedFrom_Union = ServiceRequest | Procedure | Claim | Observation | QuestionnaireResponse | DocumentReference;

/** The details of the device used. */
export type DeviceUseStatementdevice_Device_Union = Device;

/** Indicates another resource whose existence justifies this DeviceUseStatement. */
export type DeviceUseStatementreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference | Media;

/** Who reported the device was being used by the patient. */
export type DeviceUseStatementsource_Source_Union = Patient | Practitioner | PractitionerRole | RelatedPerson;

/** The patient who used the device. */
export type DeviceUseStatementsubject_Subject_Union = Patient | Group;

export enum Device_Enum_Schema {
  Device = 'Device'
}

/** The reference to the definition for the device. */
export type Devicedefinition_Definition_Union = DeviceDefinition;

export type DevicedeviceName = {
  __typename?: 'DevicedeviceName';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of the device. */
  _name?: Maybe<Element>;
  /** The name of the device. */
  name: Scalars['String'];
  /** The type of deviceName. UDILabelName | UserFriendlyName | PatientReportedName | ManufactureDeviceName | ModelName. */
  _type?: Maybe<Element>;
  /** The type of deviceName. UDILabelName | UserFriendlyName | PatientReportedName | ManufactureDeviceName | ModelName. */
  type: Scalars['code'];
};

/** The place where the device can be found. */
export type Devicelocation_Location_Union = Location;

/** An organization that is responsible for the provision and ongoing maintenance of the device. */
export type Deviceowner_Owner_Union = Organization;

/** The parent device. */
export type Deviceparent_Parent_Union = Device;

/** Patient information, If the device is affixed to a person. */
export type Devicepatient_Patient_Union = Patient;

export type Deviceproperty = {
  __typename?: 'Deviceproperty';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Code that specifies the property DeviceDefinitionPropetyCode (Extensible). */
  type: CodeableConcept;
  /** Property value as a quantity. */
  valueQuantity?: Maybe<Array<Maybe<Quantity>>>;
  /** Property value as a code, e.g., NTP4 (synced to NTP). */
  valueCode?: Maybe<Array<Maybe<CodeableConcept>>>;
};

export type Devicespecialization = {
  __typename?: 'Devicespecialization';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The standard that is used to operate and communicate. */
  systemType: CodeableConcept;
  /** The version of the standard that is used to operate and communicate. */
  _version?: Maybe<Element>;
  /** The version of the standard that is used to operate and communicate. */
  version?: Maybe<Scalars['String']>;
};

export type DeviceudiCarrier = {
  __typename?: 'DeviceudiCarrier';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The device identifier (DI) is a mandatory, fixed portion of a UDI that
   * identifies the labeler and the specific version or model of a device.
   */
  _deviceIdentifier?: Maybe<Element>;
  /**
   * The device identifier (DI) is a mandatory, fixed portion of a UDI that
   * identifies the labeler and the specific version or model of a device.
   */
  deviceIdentifier?: Maybe<Scalars['String']>;
  /**
   * Organization that is charged with issuing UDIs for devices.  For example, the
   * US FDA issuers include : 1) GS1:  http://hl7.org/fhir/NamingSystem/gs1-di,  2)
   * HIBCC: http://hl7.org/fhir/NamingSystem/hibcc-dI,  3) ICCBBA for blood
   * containers: http://hl7.org/fhir/NamingSystem/iccbba-blood-di,  4) ICCBA for
   * other devices: http://hl7.org/fhir/NamingSystem/iccbba-other-di.
   */
  _issuer?: Maybe<Element>;
  /**
   * Organization that is charged with issuing UDIs for devices.  For example, the
   * US FDA issuers include : 1) GS1:  http://hl7.org/fhir/NamingSystem/gs1-di,  2)
   * HIBCC: http://hl7.org/fhir/NamingSystem/hibcc-dI,  3) ICCBBA for blood
   * containers: http://hl7.org/fhir/NamingSystem/iccbba-blood-di,  4) ICCBA for
   * other devices: http://hl7.org/fhir/NamingSystem/iccbba-other-di.
   */
  issuer?: Maybe<Scalars['uri']>;
  /**
   * The identity of the authoritative source for UDI generation within a
   * jurisdiction.  All UDIs are globally unique within a single namespace with the
   * appropriate repository uri as the system.  For example,  UDIs of devices
   * managed in the U.S. by the FDA, the value is
   * http://hl7.org/fhir/NamingSystem/fda-udi.
   */
  _jurisdiction?: Maybe<Element>;
  /**
   * The identity of the authoritative source for UDI generation within a
   * jurisdiction.  All UDIs are globally unique within a single namespace with the
   * appropriate repository uri as the system.  For example,  UDIs of devices
   * managed in the U.S. by the FDA, the value is
   * http://hl7.org/fhir/NamingSystem/fda-udi.
   */
  jurisdiction?: Maybe<Scalars['uri']>;
  /**
   * The full UDI carrier of the Automatic Identification and Data Capture (AIDC)
   * technology representation of the barcode string as printed on the packaging of
   * the device - e.g., a barcode or RFID.   Because of limitations on character
   * sets in XML and the need to round-trip JSON data through XML, AIDC Formats
   * *SHALL* be base64 encoded.
   */
  _carrierAIDC?: Maybe<Element>;
  /**
   * The full UDI carrier of the Automatic Identification and Data Capture (AIDC)
   * technology representation of the barcode string as printed on the packaging of
   * the device - e.g., a barcode or RFID.   Because of limitations on character
   * sets in XML and the need to round-trip JSON data through XML, AIDC Formats
   * *SHALL* be base64 encoded.
   */
  carrierAIDC?: Maybe<Scalars['base64Binary']>;
  /**
   * The full UDI carrier as the human readable form (HRF) representation of the
   * barcode string as printed on the packaging of the device.
   */
  _carrierHRF?: Maybe<Element>;
  /**
   * The full UDI carrier as the human readable form (HRF) representation of the
   * barcode string as printed on the packaging of the device.
   */
  carrierHRF?: Maybe<Scalars['String']>;
  /** A coded entry to indicate how the data was entered. */
  _entryType?: Maybe<Element>;
  /** A coded entry to indicate how the data was entered. */
  entryType?: Maybe<Scalars['code']>;
};

export type Deviceversion = {
  __typename?: 'Deviceversion';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of the device version. */
  type?: Maybe<CodeableConcept>;
  /** A single component of the device version. */
  component?: Maybe<Identifier>;
  /** The version text. */
  _value?: Maybe<Element>;
  /** The version text. */
  value: Scalars['String'];
};

/**
 * The findings and interpretation of diagnostic  tests performed on patients,
 * groups of patients, devices, and locations, and/or specimens derived from these.
 * The report includes clinical context such as requesting and provider
 * information, and some mix of atomic results, images, textual and coded
 * interpretations, and formatted representation of diagnostic reports.
 */
export type DiagnosticReport = {
  __typename?: 'DiagnosticReport';
  /** Type of resource */
  resourceType: DiagnosticReport_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifiers assigned to this report by the performer or other systems. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Details concerning a service requested. */
  basedOn?: Maybe<Array<Maybe<DiagnosticReportbasedOn_BasedOn_Union>>>;
  /** The status of the diagnostic report. */
  _status?: Maybe<Element>;
  /** The status of the diagnostic report. */
  status: Scalars['code'];
  /**
   * A code that classifies the clinical discipline, department or diagnostic
   * service that created the report (e.g. cardiology, biochemistry, hematology,
   * MRI). This is used for searching, sorting and display purposes.
   */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A code or name that describes this diagnostic report. */
  code: CodeableConcept;
  /**
   * The subject of the report. Usually, but not always, this is a patient.
   * However, diagnostic services also perform analyses on specimens collected from
   * a variety of other sources.
   */
  subject?: Maybe<DiagnosticReportsubject_Subject_Union>;
  /** The healthcare event  (e.g. a patient and healthcare provider interaction) which this DiagnosticReport is about. */
  encounter?: Maybe<DiagnosticReportencounter_Encounter_Union>;
  /**
   * The time or time-period the observed values are related to. When the subject
   * of the report is a patient, this is usually either the time of the procedure
   * or of specimen collection(s), but very often the source of the date/time is
   * not known, only the date/time itself.
   */
  _effectiveDateTime?: Maybe<Element>;
  /**
   * The time or time-period the observed values are related to. When the subject
   * of the report is a patient, this is usually either the time of the procedure
   * or of specimen collection(s), but very often the source of the date/time is
   * not known, only the date/time itself.
   */
  effectiveDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The time or time-period the observed values are related to. When the subject
   * of the report is a patient, this is usually either the time of the procedure
   * or of specimen collection(s), but very often the source of the date/time is
   * not known, only the date/time itself.
   */
  effectivePeriod?: Maybe<Period>;
  /**
   * The date and time that this version of the report was made available to
   * providers, typically after the report was reviewed and verified.
   */
  _issued?: Maybe<Element>;
  /**
   * The date and time that this version of the report was made available to
   * providers, typically after the report was reviewed and verified.
   */
  issued?: Maybe<Scalars['instant']>;
  /** The diagnostic service that is responsible for issuing the report. */
  performer?: Maybe<Array<Maybe<DiagnosticReportperformer_Performer_Union>>>;
  /** The practitioner or organization that is responsible for the report's conclusions and interpretations. */
  resultsInterpreter?: Maybe<Array<Maybe<DiagnosticReportresultsInterpreter_ResultsInterpreter_Union>>>;
  /** Details about the specimens on which this diagnostic report is based. */
  specimen?: Maybe<Array<Maybe<DiagnosticReportspecimen_Specimen_Union>>>;
  /** [Observations](observation.html)  that are part of this diagnostic report. */
  result?: Maybe<Array<Maybe<DiagnosticReportresult_Result_Union>>>;
  /**
   * One or more links to full details of any imaging performed during the
   * diagnostic investigation. Typically, this is imaging performed by DICOM
   * enabled modalities, but this is not required. A fully enabled PACS viewer can
   * use this information to provide views of the source images.
   */
  imagingStudy?: Maybe<Array<Maybe<DiagnosticReportimagingStudy_ImagingStudy_Union>>>;
  /**
   * A list of key images associated with this report. The images are generally
   * created during the diagnostic process, and may be directly of the patient, or
   * of treated specimens (i.e. slides of interest).
   */
  media?: Maybe<Array<Maybe<DiagnosticReportmedia>>>;
  /** Concise and clinically contextualized summary conclusion (interpretation/impression) of the diagnostic report. */
  _conclusion?: Maybe<Element>;
  /** Concise and clinically contextualized summary conclusion (interpretation/impression) of the diagnostic report. */
  conclusion?: Maybe<Scalars['String']>;
  /** One or more codes that represent the summary conclusion (interpretation/impression) of the diagnostic report. */
  conclusionCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Rich text representation of the entire result as issued by the diagnostic
   * service. Multiple formats are allowed but they SHALL be semantically equivalent.
   */
  presentedForm?: Maybe<Array<Maybe<Attachment>>>;
};

export enum DiagnosticReport_Enum_Schema {
  DiagnosticReport = 'DiagnosticReport'
}

/** Details concerning a service requested. */
export type DiagnosticReportbasedOn_BasedOn_Union = CarePlan | ImmunizationRecommendation | MedicationRequest | NutritionOrder | ServiceRequest;

/** The healthcare event  (e.g. a patient and healthcare provider interaction) which this DiagnosticReport is about. */
export type DiagnosticReportencounter_Encounter_Union = Encounter;

/**
 * One or more links to full details of any imaging performed during the diagnostic
 * investigation. Typically, this is imaging performed by DICOM enabled modalities,
 * but this is not required. A fully enabled PACS viewer can use this information
 * to provide views of the source images.
 */
export type DiagnosticReportimagingStudy_ImagingStudy_Union = ImagingStudy;

export type DiagnosticReportmedia = {
  __typename?: 'DiagnosticReportmedia';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A comment about the image. Typically, this is used to provide an explanation
   * for why the image is included, or to draw the viewer's attention to important features.
   */
  _comment?: Maybe<Element>;
  /**
   * A comment about the image. Typically, this is used to provide an explanation
   * for why the image is included, or to draw the viewer's attention to important features.
   */
  comment?: Maybe<Scalars['String']>;
  /** Reference to the image source. */
  link: DiagnosticReportmedialink_Link_Union;
};

/** Reference to the image source. */
export type DiagnosticReportmedialink_Link_Union = Media;

/** The diagnostic service that is responsible for issuing the report. */
export type DiagnosticReportperformer_Performer_Union = Practitioner | PractitionerRole | Organization | CareTeam;

/** [Observations](observation.html)  that are part of this diagnostic report. */
export type DiagnosticReportresult_Result_Union = Observation;

/** The practitioner or organization that is responsible for the report's conclusions and interpretations. */
export type DiagnosticReportresultsInterpreter_ResultsInterpreter_Union = Practitioner | PractitionerRole | Organization | CareTeam;

/** Details about the specimens on which this diagnostic report is based. */
export type DiagnosticReportspecimen_Specimen_Union = Specimen;

/**
 * The subject of the report. Usually, but not always, this is a patient. However,
 * diagnostic services also perform analyses on specimens collected from a variety
 * of other sources.
 */
export type DiagnosticReportsubject_Subject_Union = Patient | Group | Device | Location;

export enum Disorder_Enum_Input_Schema {
  Disorder = 'Disorder'
}

export enum Disorder_Enum_Schema {
  Disorder = 'Disorder'
}

/** Disorder */
export type Disorder_Input = {
  /** Type of resource */
  resourceType: Disorder_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** disorder import file. */
  disorderFile?: Maybe<Scalars['String']>;
  /** disorder name. */
  disorderName?: Maybe<Scalars['String']>;
  /** disorder value. */
  disorderValue?: Maybe<Scalars['String']>;
  disorderStatus?: Maybe<Scalars['Int']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
};

/** Disorder */
export type Disorder_Schema = {
  __typename?: 'Disorder_Schema';
  /** Type of resource */
  resourceType: Disorder_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** disorder name. */
  disorderName?: Maybe<Scalars['String']>;
  /** disorder value. */
  disorderValue?: Maybe<Scalars['String']>;
  disorderStatus?: Maybe<Scalars['Int']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Distance Type: A length - a value with a unit that is a physical distance. */
export type Distance = {
  __typename?: 'Distance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  _value?: Maybe<Element>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  value?: Maybe<Scalars['Float']>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  _comparator?: Maybe<Element>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  comparator?: Maybe<Scalars['code']>;
  /** A human-readable form of the unit. */
  _unit?: Maybe<Element>;
  /** A human-readable form of the unit. */
  unit?: Maybe<Scalars['String']>;
  /** The identification of the system that provides the coded form of the unit. */
  _system?: Maybe<Element>;
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars['uri']>;
  /** A computer processable form of the unit in some unit representation system. */
  _code?: Maybe<Element>;
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars['code']>;
};

/** Base StructureDefinition for Distance Type: A length - a value with a unit that is a physical distance. */
export type Distance_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  _value?: Maybe<Element_Input>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  value?: Maybe<Scalars['Float']>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  _comparator?: Maybe<Element_Input>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  comparator?: Maybe<Scalars['code']>;
  /** A human-readable form of the unit. */
  _unit?: Maybe<Element_Input>;
  /** A human-readable form of the unit. */
  unit?: Maybe<Scalars['String']>;
  /** The identification of the system that provides the coded form of the unit. */
  _system?: Maybe<Element_Input>;
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars['uri']>;
  /** A computer processable form of the unit in some unit representation system. */
  _code?: Maybe<Element_Input>;
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars['code']>;
};

/** A collection of documents compiled for a purpose together with metadata that applies to the collection. */
export type DocumentManifest = {
  __typename?: 'DocumentManifest';
  /** Type of resource */
  resourceType: DocumentManifest_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A single identifier that uniquely identifies this manifest. Principally used
   * to refer to the manifest in non-FHIR contexts.
   */
  masterIdentifier?: Maybe<Identifier>;
  /** Other identifiers associated with the document manifest, including version independent  identifiers. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of this document manifest. */
  _status?: Maybe<Element>;
  /** The status of this document manifest. */
  status: Scalars['code'];
  /**
   * The code specifying the type of clinical activity that resulted in placing the
   * associated content into the DocumentManifest.
   */
  type?: Maybe<CodeableConcept>;
  /**
   * Who or what the set of documents is about. The documents can be about a
   * person, (patient or healthcare practitioner), a device (i.e. machine) or even
   * a group of subjects (such as a document about a herd of farm animals, or a set
   * of patients that share a common exposure). If the documents cross more than
   * one subject, then more than one subject is allowed here (unusual use case).
   */
  subject?: Maybe<DocumentManifestsubject_Subject_Union>;
  /**
   * When the document manifest was created for submission to the server (not
   * necessarily the same thing as the actual resource last modified time, since it
   * may be modified, replicated, etc.).
   */
  _created?: Maybe<Element>;
  /**
   * When the document manifest was created for submission to the server (not
   * necessarily the same thing as the actual resource last modified time, since it
   * may be modified, replicated, etc.).
   */
  created?: Maybe<Scalars['dateTime']>;
  /** Identifies who is the author of the manifest. Manifest author is not necessarly the author of the references included. */
  author?: Maybe<Array<Maybe<DocumentManifestauthor_Author_Union>>>;
  /** A patient, practitioner, or organization for which this set of documents is intended. */
  recipient?: Maybe<Array<Maybe<DocumentManifestrecipient_Recipient_Union>>>;
  /** Identifies the source system, application, or software that produced the document manifest. */
  _source?: Maybe<Element>;
  /** Identifies the source system, application, or software that produced the document manifest. */
  source?: Maybe<Scalars['uri']>;
  /** Human-readable description of the source document. This is sometimes known as the 'title'. */
  _description?: Maybe<Element>;
  /** Human-readable description of the source document. This is sometimes known as the 'title'. */
  description?: Maybe<Scalars['String']>;
  /** The list of Resources that consist of the parts of this manifest. */
  content?: Maybe<Array<DocumentManifestcontent_Content_Union>>;
  /** Related identifiers or resources associated with the DocumentManifest. */
  related?: Maybe<Array<Maybe<DocumentManifestrelated>>>;
};

export enum DocumentManifest_Enum_Schema {
  DocumentManifest = 'DocumentManifest'
}

/** Identifies who is the author of the manifest. Manifest author is not necessarly the author of the references included. */
export type DocumentManifestauthor_Author_Union = Practitioner | PractitionerRole | Organization | Device | Patient | RelatedPerson;

/** The list of Resources that consist of the parts of this manifest. */
export type DocumentManifestcontent_Content_Union = Resource;

/** A patient, practitioner, or organization for which this set of documents is intended. */
export type DocumentManifestrecipient_Recipient_Union = Patient | Practitioner | PractitionerRole | RelatedPerson | Organization;

export type DocumentManifestrelated = {
  __typename?: 'DocumentManifestrelated';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Related identifier to this DocumentManifest.  For example, Order numbers, accession numbers, XDW workflow numbers. */
  identifier?: Maybe<Identifier>;
  /** Related Resource to this DocumentManifest. For example, Order, ServiceRequest,  Procedure, EligibilityRequest, etc. */
  ref?: Maybe<DocumentManifestrelatedref_Ref_Union>;
};

/** Related Resource to this DocumentManifest. For example, Order, ServiceRequest,  Procedure, EligibilityRequest, etc. */
export type DocumentManifestrelatedref_Ref_Union = Resource;

/**
 * Who or what the set of documents is about. The documents can be about a person,
 * (patient or healthcare practitioner), a device (i.e. machine) or even a group of
 * subjects (such as a document about a herd of farm animals, or a set of patients
 * that share a common exposure). If the documents cross more than one subject,
 * then more than one subject is allowed here (unusual use case).
 */
export type DocumentManifestsubject_Subject_Union = Patient | Practitioner | Group | Device;

/**
 * A reference to a document of any kind for any purpose. Provides metadata about
 * the document so that the document can be discovered and managed. The scope of a
 * document is any seralized object with a mime-type, so includes formal patient
 * centric documents (CDA), cliical notes, scanned paper, and non-patient specific
 * documents like policy text.
 */
export type DocumentReference = {
  __typename?: 'DocumentReference';
  /** Type of resource */
  resourceType: DocumentReference_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Document identifier as assigned by the source of the document. This identifier
   * is specific to this version of the document. This unique identifier may be
   * used elsewhere to identify this version of the document.
   */
  masterIdentifier?: Maybe<Identifier>;
  /** Other identifiers associated with the document, including version independent identifiers. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of this document reference. */
  _status?: Maybe<Element>;
  /** The status of this document reference. */
  status: Scalars['code'];
  /** The status of the underlying document. */
  _docStatus?: Maybe<Element>;
  /** The status of the underlying document. */
  docStatus?: Maybe<Scalars['code']>;
  /**
   * Specifies the particular kind of document referenced  (e.g. History and
   * Physical, Discharge Summary, Progress Note). This usually equates to the
   * purpose of making the document referenced.
   */
  type?: Maybe<CodeableConcept>;
  /**
   * A categorization for the type of document referenced - helps for indexing and
   * searching. This may be implied by or derived from the code specified in the
   * DocumentReference.type.
   */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Who or what the document is about. The document can be about a person,
   * (patient or healthcare practitioner), a device (e.g. a machine) or even a
   * group of subjects (such as a document about a herd of farm animals, or a set
   * of patients that share a common exposure).
   */
  subject?: Maybe<DocumentReferencesubject_Subject_Union>;
  /** When the document reference was created. */
  _date?: Maybe<Element>;
  /** When the document reference was created. */
  date?: Maybe<Scalars['instant']>;
  /** Identifies who is responsible for adding the information to the document. */
  author?: Maybe<Array<Maybe<DocumentReferenceauthor_Author_Union>>>;
  /** Which person or organization authenticates that this document is valid. */
  authenticator?: Maybe<DocumentReferenceauthenticator_Authenticator_Union>;
  /** Identifies the organization or group who is responsible for ongoing maintenance of and access to the document. */
  custodian?: Maybe<DocumentReferencecustodian_Custodian_Union>;
  /** Relationships that this document has with other document references that already exist. */
  relatesTo?: Maybe<Array<Maybe<DocumentReferencerelatesTo>>>;
  /** Human-readable description of the source document. */
  _description?: Maybe<Element>;
  /** Human-readable description of the source document. */
  description?: Maybe<Scalars['String']>;
  /**
   * A set of Security-Tag codes specifying the level of privacy/security of the
   * Document. Note that DocumentReference.meta.security contains the security
   * labels of the 'reference' to the document, while
   * DocumentReference.securityLabel contains a snapshot of the security labels on
   * the document the reference refers to.
   */
  securityLabel?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The document and format referenced. There may be multiple content element repetitions, each with a different format. */
  content?: Maybe<Array<DocumentReferencecontent>>;
  /** The clinical context in which the document was prepared. */
  context?: Maybe<DocumentReferencecontext>;
};

export enum DocumentReference_Enum_Input {
  DocumentReference = 'DocumentReference'
}

export enum DocumentReference_Enum_Schema {
  DocumentReference = 'DocumentReference'
}

/**
 * A reference to a document of any kind for any purpose. Provides metadata about
 * the document so that the document can be discovered and managed. The scope of a
 * document is any seralized object with a mime-type, so includes formal patient
 * centric documents (CDA), cliical notes, scanned paper, and non-patient specific
 * documents like policy text.
 */
export type DocumentReference_Input = {
  /** Type of resource */
  resourceType: DocumentReference_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * Document identifier as assigned by the source of the document. This identifier
   * is specific to this version of the document. This unique identifier may be
   * used elsewhere to identify this version of the document.
   */
  masterIdentifier?: Maybe<Identifier_Input>;
  /** Other identifiers associated with the document, including version independent identifiers. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /** The status of this document reference. */
  _status?: Maybe<Element_Input>;
  /** The status of this document reference. */
  status: Scalars['code'];
  /** The status of the underlying document. */
  _docStatus?: Maybe<Element_Input>;
  /** The status of the underlying document. */
  docStatus?: Maybe<Scalars['code']>;
  /**
   * Specifies the particular kind of document referenced  (e.g. History and
   * Physical, Discharge Summary, Progress Note). This usually equates to the
   * purpose of making the document referenced.
   */
  type?: Maybe<CodeableConcept_Input>;
  /**
   * A categorization for the type of document referenced - helps for indexing and
   * searching. This may be implied by or derived from the code specified in the
   * DocumentReference.type.
   */
  category?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /**
   * Who or what the document is about. The document can be about a person,
   * (patient or healthcare practitioner), a device (e.g. a machine) or even a
   * group of subjects (such as a document about a herd of farm animals, or a set
   * of patients that share a common exposure).
   */
  subject?: Maybe<Scalars['String']>;
  /** When the document reference was created. */
  _date?: Maybe<Element_Input>;
  /** When the document reference was created. */
  date?: Maybe<Scalars['instant']>;
  /** Identifies who is responsible for adding the information to the document. */
  author?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Which person or organization authenticates that this document is valid. */
  authenticator?: Maybe<Scalars['String']>;
  /** Identifies the organization or group who is responsible for ongoing maintenance of and access to the document. */
  custodian?: Maybe<Scalars['String']>;
  /** Relationships that this document has with other document references that already exist. */
  relatesTo?: Maybe<Array<Maybe<DocumentReferencerelatesTo_Input>>>;
  /** Human-readable description of the source document. */
  _description?: Maybe<Element_Input>;
  /** Human-readable description of the source document. */
  description?: Maybe<Scalars['String']>;
  /**
   * A set of Security-Tag codes specifying the level of privacy/security of the
   * Document. Note that DocumentReference.meta.security contains the security
   * labels of the 'reference' to the document, while
   * DocumentReference.securityLabel contains a snapshot of the security labels on
   * the document the reference refers to.
   */
  securityLabel?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The document and format referenced. There may be multiple content element repetitions, each with a different format. */
  content?: Maybe<Array<DocumentReferencecontent_Input>>;
  /** The clinical context in which the document was prepared. */
  context?: Maybe<DocumentReferencecontext_Input>;
};

/** Which person or organization authenticates that this document is valid. */
export type DocumentReferenceauthenticator_Authenticator_Union = Practitioner | PractitionerRole | Organization;

/** Identifies who is responsible for adding the information to the document. */
export type DocumentReferenceauthor_Author_Union = Practitioner | PractitionerRole | Organization | Device | Patient | RelatedPerson;

export type DocumentReferencecontent = {
  __typename?: 'DocumentReferencecontent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The document or URL of the document along with critical metadata to prove content has integrity. */
  attachment: Attachment;
  /**
   * An identifier of the document encoding, structure, and template that the
   * document conforms to beyond the base format indicated in the mimeType.
   */
  format?: Maybe<Coding>;
};

export type DocumentReferencecontent_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The document or URL of the document along with critical metadata to prove content has integrity. */
  attachment: Attachment_Input;
  /**
   * An identifier of the document encoding, structure, and template that the
   * document conforms to beyond the base format indicated in the mimeType.
   */
  format?: Maybe<Coding_Input>;
};

export type DocumentReferencecontext = {
  __typename?: 'DocumentReferencecontext';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Describes the clinical encounter or type of care that the document content is associated with. */
  encounter?: Maybe<Array<Maybe<DocumentReferencecontextencounter_Encounter_Union>>>;
  /**
   * This list of codes represents the main clinical acts, such as a colonoscopy or
   * an appendectomy, being documented. In some cases, the event is inherent in the
   * type Code, such as a 'History and Physical Report' in which the procedure
   * being documented is necessarily a 'History and Physical' act.
   */
  event?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The time period over which the service that is described by the document was provided. */
  period?: Maybe<Period>;
  /** The kind of facility where the patient was seen. */
  facilityType?: Maybe<CodeableConcept>;
  /**
   * This property may convey specifics about the practice setting where the
   * content was created, often reflecting the clinical specialty.
   */
  practiceSetting?: Maybe<CodeableConcept>;
  /** The Patient Information as known when the document was published. May be a reference to a version specific, or contained. */
  sourcePatientInfo?: Maybe<DocumentReferencecontextsourcePatientInfo_SourcePatientInfo_Union>;
  /** Related identifiers or resources associated with the DocumentReference. */
  related?: Maybe<Array<Maybe<DocumentReferencecontextrelated_Related_Union>>>;
};

export type DocumentReferencecontext_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Describes the clinical encounter or type of care that the document content is associated with. */
  encounter?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * This list of codes represents the main clinical acts, such as a colonoscopy or
   * an appendectomy, being documented. In some cases, the event is inherent in the
   * type Code, such as a 'History and Physical Report' in which the procedure
   * being documented is necessarily a 'History and Physical' act.
   */
  event?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The time period over which the service that is described by the document was provided. */
  period?: Maybe<Period_Input>;
  /** The kind of facility where the patient was seen. */
  facilityType?: Maybe<CodeableConcept_Input>;
  /**
   * This property may convey specifics about the practice setting where the
   * content was created, often reflecting the clinical specialty.
   */
  practiceSetting?: Maybe<CodeableConcept_Input>;
  /** The Patient Information as known when the document was published. May be a reference to a version specific, or contained. */
  sourcePatientInfo?: Maybe<Scalars['String']>;
  /** Related identifiers or resources associated with the DocumentReference. */
  related?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Describes the clinical encounter or type of care that the document content is associated with. */
export type DocumentReferencecontextencounter_Encounter_Union = Encounter | EpisodeOfCare;

/** Related identifiers or resources associated with the DocumentReference. */
export type DocumentReferencecontextrelated_Related_Union = Resource;

/** The Patient Information as known when the document was published. May be a reference to a version specific, or contained. */
export type DocumentReferencecontextsourcePatientInfo_SourcePatientInfo_Union = Patient;

/** Identifies the organization or group who is responsible for ongoing maintenance of and access to the document. */
export type DocumentReferencecustodian_Custodian_Union = Organization;

export type DocumentReferencerelatesTo = {
  __typename?: 'DocumentReferencerelatesTo';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of relationship that this document has with anther document. */
  _code?: Maybe<Element>;
  /** The type of relationship that this document has with anther document. */
  code: Scalars['code'];
  /** The target document of this relationship. */
  target: DocumentReferencerelatesTotarget_Target_Union;
};

export type DocumentReferencerelatesTo_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The type of relationship that this document has with anther document. */
  _code?: Maybe<Element_Input>;
  /** The type of relationship that this document has with anther document. */
  code: Scalars['code'];
  /** The target document of this relationship. */
  target: Scalars['String'];
};

/** The target document of this relationship. */
export type DocumentReferencerelatesTotarget_Target_Union = DocumentReference;

/**
 * Who or what the document is about. The document can be about a person, (patient
 * or healthcare practitioner), a device (e.g. a machine) or even a group of
 * subjects (such as a document about a herd of farm animals, or a set of patients
 * that share a common exposure).
 */
export type DocumentReferencesubject_Subject_Union = Patient | Practitioner | Group | Device;

/** A resource that includes narrative, extensions, and contained resources. */
export type DomainResource = {
  __typename?: 'DomainResource';
  /** Type of resource */
  resourceType: DomainResource_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
};

export enum DomainResource_Enum_Schema {
  DomainResource = 'DomainResource'
}

/** Base StructureDefinition for Dosage Type: Indicates how the medication is/was taken or should be taken by the patient. */
export type Dosage = {
  __typename?: 'Dosage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates the order in which the dosage instructions should be applied or interpreted. */
  _sequence?: Maybe<Element>;
  /** Indicates the order in which the dosage instructions should be applied or interpreted. */
  sequence?: Maybe<Scalars['Int']>;
  /** Free text dosage instructions e.g. SIG. */
  _text?: Maybe<Element>;
  /** Free text dosage instructions e.g. SIG. */
  text?: Maybe<Scalars['String']>;
  /**
   * Supplemental instructions to the patient on how to take the medication  (e.g.
   * 'with meals' or'take half to one hour before food') or warnings for the
   * patient about the medication (e.g. 'may cause drowsiness' or 'avoid exposure
   * of skin to direct sunlight or sunlamps').
   */
  additionalInstruction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Instructions in terms that are understood by the patient or consumer. */
  _patientInstruction?: Maybe<Element>;
  /** Instructions in terms that are understood by the patient or consumer. */
  patientInstruction?: Maybe<Scalars['String']>;
  /** When medication should be administered. */
  timing?: Maybe<Timing>;
  /**
   * Indicates whether the Medication is only taken when needed within a specific
   * dosing schedule (Boolean option), or it indicates the precondition for taking
   * the Medication (CodeableConcept).
   */
  _asNeededBoolean?: Maybe<Element>;
  /**
   * Indicates whether the Medication is only taken when needed within a specific
   * dosing schedule (Boolean option), or it indicates the precondition for taking
   * the Medication (CodeableConcept).
   */
  asNeededBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether the Medication is only taken when needed within a specific
   * dosing schedule (Boolean option), or it indicates the precondition for taking
   * the Medication (CodeableConcept).
   */
  asNeededCodeableConcept?: Maybe<CodeableConcept>;
  /** Body site to administer to. */
  site?: Maybe<CodeableConcept>;
  /** How drug should enter body. */
  route?: Maybe<CodeableConcept>;
  /** Technique for administering medication. */
  method?: Maybe<CodeableConcept>;
  /** The amount of medication administered. */
  doseAndRate?: Maybe<Array<Maybe<Element>>>;
  /** Upper limit on medication per unit of time. */
  maxDosePerPeriod?: Maybe<Ratio>;
  /** Upper limit on medication per administration. */
  maxDosePerAdministration?: Maybe<Quantity>;
  /** Upper limit on medication per lifetime of the patient. */
  maxDosePerLifetime?: Maybe<Quantity>;
};

/** Base StructureDefinition for Dosage Type: Indicates how the medication is/was taken or should be taken by the patient. */
export type Dosage_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Indicates the order in which the dosage instructions should be applied or interpreted. */
  _sequence?: Maybe<Element_Input>;
  /** Indicates the order in which the dosage instructions should be applied or interpreted. */
  sequence?: Maybe<Scalars['Int']>;
  /** Free text dosage instructions e.g. SIG. */
  _text?: Maybe<Element_Input>;
  /** Free text dosage instructions e.g. SIG. */
  text?: Maybe<Scalars['String']>;
  /**
   * Supplemental instructions to the patient on how to take the medication  (e.g.
   * 'with meals' or'take half to one hour before food') or warnings for the
   * patient about the medication (e.g. 'may cause drowsiness' or 'avoid exposure
   * of skin to direct sunlight or sunlamps').
   */
  additionalInstruction?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Instructions in terms that are understood by the patient or consumer. */
  _patientInstruction?: Maybe<Element_Input>;
  /** Instructions in terms that are understood by the patient or consumer. */
  patientInstruction?: Maybe<Scalars['String']>;
  /** When medication should be administered. */
  timing?: Maybe<Timing_Input>;
  /**
   * Indicates whether the Medication is only taken when needed within a specific
   * dosing schedule (Boolean option), or it indicates the precondition for taking
   * the Medication (CodeableConcept).
   */
  _asNeededBoolean?: Maybe<Element_Input>;
  /**
   * Indicates whether the Medication is only taken when needed within a specific
   * dosing schedule (Boolean option), or it indicates the precondition for taking
   * the Medication (CodeableConcept).
   */
  asNeededBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether the Medication is only taken when needed within a specific
   * dosing schedule (Boolean option), or it indicates the precondition for taking
   * the Medication (CodeableConcept).
   */
  asNeededCodeableConcept?: Maybe<CodeableConcept_Input>;
  /** Body site to administer to. */
  site?: Maybe<CodeableConcept_Input>;
  /** How drug should enter body. */
  route?: Maybe<CodeableConcept_Input>;
  /** Technique for administering medication. */
  method?: Maybe<CodeableConcept_Input>;
  /** The amount of medication administered. */
  doseAndRate?: Maybe<Array<Maybe<Element_Input>>>;
  /** Upper limit on medication per unit of time. */
  maxDosePerPeriod?: Maybe<Ratio_Input>;
  /** Upper limit on medication per administration. */
  maxDosePerAdministration?: Maybe<Quantity_Input>;
  /** Upper limit on medication per lifetime of the patient. */
  maxDosePerLifetime?: Maybe<Quantity_Input>;
};

/** Base StructureDefinition for Duration Type: A length of time. */
export type Duration = {
  __typename?: 'Duration';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  _value?: Maybe<Element>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  value?: Maybe<Scalars['Float']>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  _comparator?: Maybe<Element>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  comparator?: Maybe<Scalars['code']>;
  /** A human-readable form of the unit. */
  _unit?: Maybe<Element>;
  /** A human-readable form of the unit. */
  unit?: Maybe<Scalars['String']>;
  /** The identification of the system that provides the coded form of the unit. */
  _system?: Maybe<Element>;
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars['uri']>;
  /** A computer processable form of the unit in some unit representation system. */
  _code?: Maybe<Element>;
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars['code']>;
};

/** Base StructureDefinition for Duration Type: A length of time. */
export type Duration_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  _value?: Maybe<Element_Input>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  value?: Maybe<Scalars['Float']>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  _comparator?: Maybe<Element_Input>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  comparator?: Maybe<Scalars['code']>;
  /** A human-readable form of the unit. */
  _unit?: Maybe<Element_Input>;
  /** A human-readable form of the unit. */
  unit?: Maybe<Scalars['String']>;
  /** The identification of the system that provides the coded form of the unit. */
  _system?: Maybe<Element_Input>;
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars['uri']>;
  /** A computer processable form of the unit in some unit representation system. */
  _code?: Maybe<Element_Input>;
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars['code']>;
};

/**
 * The EffectEvidenceSynthesis resource describes the difference in an outcome
 * between exposures states in a population where the effect estimate is derived
 * from a combination of research studies.
 */
export type EffectEvidenceSynthesis = {
  __typename?: 'EffectEvidenceSynthesis';
  /** Type of resource */
  resourceType: EffectEvidenceSynthesis_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this effect evidence synthesis when
   * it is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this effect
   * evidence synthesis is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the effect evidence
   * synthesis is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this effect evidence synthesis when
   * it is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this effect
   * evidence synthesis is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the effect evidence
   * synthesis is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this effect evidence synthesis
   * when it is represented in other formats, or referenced in a specification,
   * model, design or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the effect evidence
   * synthesis when it is referenced in a specification, model, design or instance.
   * This is an arbitrary value managed by the effect evidence synthesis author and
   * is not expected to be globally unique. For example, it might be a timestamp
   * (e.g. yyyymmdd) if a managed version is not available. There is also no
   * expectation that versions can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the effect evidence
   * synthesis when it is referenced in a specification, model, design or instance.
   * This is an arbitrary value managed by the effect evidence synthesis author and
   * is not expected to be globally unique. For example, it might be a timestamp
   * (e.g. yyyymmdd) if a managed version is not available. There is also no
   * expectation that versions can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the effect evidence synthesis. This name
   * should be usable as an identifier for the module by machine processing
   * applications such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the effect evidence synthesis. This name
   * should be usable as an identifier for the module by machine processing
   * applications such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the effect evidence synthesis. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the effect evidence synthesis. */
  title?: Maybe<Scalars['String']>;
  /** The status of this effect evidence synthesis. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this effect evidence synthesis. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * The date  (and optionally time) when the effect evidence synthesis was
   * published. The date must change when the business version changes and it must
   * change if the status code changes. In addition, it should change when the
   * substantive content of the effect evidence synthesis changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the effect evidence synthesis was
   * published. The date must change when the business version changes and it must
   * change if the status code changes. In addition, it should change when the
   * substantive content of the effect evidence synthesis changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the effect evidence synthesis. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the effect evidence synthesis. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the effect evidence synthesis from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the effect evidence synthesis from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate effect
   * evidence synthesis instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the effect evidence synthesis is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * A copyright statement relating to the effect evidence synthesis and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the effect evidence synthesis.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the effect evidence synthesis and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the effect evidence synthesis.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the effect evidence synthesis content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the content of the EffectEvidenceSynthesis.
   * Topics provide a high-level categorization grouping types of
   * EffectEvidenceSynthesiss that can be useful for filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related artifacts such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** Type of synthesis eg meta-analysis. */
  synthesisType?: Maybe<CodeableConcept>;
  /** Type of study eg randomized trial. */
  studyType?: Maybe<CodeableConcept>;
  /** A reference to a EvidenceVariable resource that defines the population for the research. */
  population: EffectEvidenceSynthesispopulation_Population_Union;
  /** A reference to a EvidenceVariable resource that defines the exposure for the research. */
  exposure: EffectEvidenceSynthesisexposure_Exposure_Union;
  /** A reference to a EvidenceVariable resource that defines the comparison exposure for the research. */
  exposureAlternative: EffectEvidenceSynthesisexposureAlternative_ExposureAlternative_Union;
  /** A reference to a EvidenceVariable resomece that defines the outcome for the research. */
  outcome: EffectEvidenceSynthesisoutcome_Outcome_Union;
  /** A description of the size of the sample involved in the synthesis. */
  sampleSize?: Maybe<EffectEvidenceSynthesissampleSize>;
  /** A description of the results for each exposure considered in the effect estimate. */
  resultsByExposure?: Maybe<Array<Maybe<EffectEvidenceSynthesisresultsByExposure>>>;
  /** The estimated effect of the exposure variant. */
  effectEstimate?: Maybe<Array<Maybe<EffectEvidenceSynthesiseffectEstimate>>>;
  /** A description of the certainty of the effect estimate. */
  certainty?: Maybe<Array<Maybe<EffectEvidenceSynthesiscertainty>>>;
};

export enum EffectEvidenceSynthesis_Enum_Schema {
  EffectEvidenceSynthesis = 'EffectEvidenceSynthesis'
}

export type EffectEvidenceSynthesiscertainty = {
  __typename?: 'EffectEvidenceSynthesiscertainty';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A rating of the certainty of the effect estimate. */
  rating?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** A description of a component of the overall certainty. */
  certaintySubcomponent?: Maybe<Array<Maybe<EffectEvidenceSynthesiscertaintycertaintySubcomponent>>>;
};

export type EffectEvidenceSynthesiscertaintycertaintySubcomponent = {
  __typename?: 'EffectEvidenceSynthesiscertaintycertaintySubcomponent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of subcomponent of certainty rating. */
  type?: Maybe<CodeableConcept>;
  /** A rating of a subcomponent of rating certainty. */
  rating?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export type EffectEvidenceSynthesiseffectEstimate = {
  __typename?: 'EffectEvidenceSynthesiseffectEstimate';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Human-readable summary of effect estimate. */
  _description?: Maybe<Element>;
  /** Human-readable summary of effect estimate. */
  description?: Maybe<Scalars['String']>;
  /** Examples include relative risk and mean difference. */
  type?: Maybe<CodeableConcept>;
  /** Used to define variant exposure states such as low-risk state. */
  variantState?: Maybe<CodeableConcept>;
  /** The point estimate of the effect estimate. */
  _value?: Maybe<Element>;
  /** The point estimate of the effect estimate. */
  value?: Maybe<Scalars['Float']>;
  /** Specifies the UCUM unit for the outcome. */
  unitOfMeasure?: Maybe<CodeableConcept>;
  /** A description of the precision of the estimate for the effect. */
  precisionEstimate?: Maybe<Array<Maybe<EffectEvidenceSynthesiseffectEstimateprecisionEstimate>>>;
};

export type EffectEvidenceSynthesiseffectEstimateprecisionEstimate = {
  __typename?: 'EffectEvidenceSynthesiseffectEstimateprecisionEstimate';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Examples include confidence interval and interquartile range. */
  type?: Maybe<CodeableConcept>;
  /** Use 95 for a 95% confidence interval. */
  _level?: Maybe<Element>;
  /** Use 95 for a 95% confidence interval. */
  level?: Maybe<Scalars['Float']>;
  /** Lower bound of confidence interval. */
  _from?: Maybe<Element>;
  /** Lower bound of confidence interval. */
  from?: Maybe<Scalars['Float']>;
  /** Upper bound of confidence interval. */
  _to?: Maybe<Element>;
  /** Upper bound of confidence interval. */
  to?: Maybe<Scalars['Float']>;
};

/** A reference to a EvidenceVariable resource that defines the comparison exposure for the research. */
export type EffectEvidenceSynthesisexposureAlternative_ExposureAlternative_Union = EvidenceVariable;

/** A reference to a EvidenceVariable resource that defines the exposure for the research. */
export type EffectEvidenceSynthesisexposure_Exposure_Union = EvidenceVariable;

/** A reference to a EvidenceVariable resomece that defines the outcome for the research. */
export type EffectEvidenceSynthesisoutcome_Outcome_Union = EvidenceVariable;

/** A reference to a EvidenceVariable resource that defines the population for the research. */
export type EffectEvidenceSynthesispopulation_Population_Union = EvidenceVariable;

export type EffectEvidenceSynthesisresultsByExposure = {
  __typename?: 'EffectEvidenceSynthesisresultsByExposure';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Human-readable summary of results by exposure state. */
  _description?: Maybe<Element>;
  /** Human-readable summary of results by exposure state. */
  description?: Maybe<Scalars['String']>;
  /** Whether these results are for the exposure state or alternative exposure state. */
  _exposureState?: Maybe<Element>;
  /** Whether these results are for the exposure state or alternative exposure state. */
  exposureState?: Maybe<Scalars['code']>;
  /** Used to define variant exposure states such as low-risk state. */
  variantState?: Maybe<CodeableConcept>;
  /** Reference to a RiskEvidenceSynthesis resource. */
  riskEvidenceSynthesis: EffectEvidenceSynthesisresultsByExposureriskEvidenceSynthesis_RiskEvidenceSynthesis_Union;
};

/** Reference to a RiskEvidenceSynthesis resource. */
export type EffectEvidenceSynthesisresultsByExposureriskEvidenceSynthesis_RiskEvidenceSynthesis_Union = RiskEvidenceSynthesis;

export type EffectEvidenceSynthesissampleSize = {
  __typename?: 'EffectEvidenceSynthesissampleSize';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Human-readable summary of sample size. */
  _description?: Maybe<Element>;
  /** Human-readable summary of sample size. */
  description?: Maybe<Scalars['String']>;
  /** Number of studies included in this evidence synthesis. */
  _numberOfStudies?: Maybe<Element>;
  /** Number of studies included in this evidence synthesis. */
  numberOfStudies?: Maybe<Scalars['Int']>;
  /** Number of participants included in this evidence synthesis. */
  _numberOfParticipants?: Maybe<Element>;
  /** Number of participants included in this evidence synthesis. */
  numberOfParticipants?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Element Type: Base definition for all elements in a resource. */
export type Element = {
  __typename?: 'Element';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
};

/**
 * Base StructureDefinition for ElementDefinition Type: Captures constraints on
 * each element within the resource, profile, or extension.
 */
export type ElementDefinition = {
  __typename?: 'ElementDefinition';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The path identifies the element and is expressed as a '.'-separated list of
   * ancestor elements, beginning with the name of the resource or extension.
   */
  _path?: Maybe<Element>;
  /**
   * The path identifies the element and is expressed as a '.'-separated list of
   * ancestor elements, beginning with the name of the resource or extension.
   */
  path: Scalars['String'];
  /** Codes that define how this element is represented in instances, when the deviation varies from the normal case. */
  _representation?: Maybe<Element>;
  /** Codes that define how this element is represented in instances, when the deviation varies from the normal case. */
  representation?: Maybe<Array<Maybe<Scalars['code']>>>;
  /**
   * The name of this element definition slice, when slicing is working. The name
   * must be a token with no dots or spaces. This is a unique name referring to a
   * specific set of constraints applied to this element, used to provide a name to
   * different slices of the same element.
   */
  _sliceName?: Maybe<Element>;
  /**
   * The name of this element definition slice, when slicing is working. The name
   * must be a token with no dots or spaces. This is a unique name referring to a
   * specific set of constraints applied to this element, used to provide a name to
   * different slices of the same element.
   */
  sliceName?: Maybe<Scalars['String']>;
  /**
   * If true, indicates that this slice definition is constraining a slice
   * definition with the same name in an inherited profile. If false, the slice is
   * not overriding any slice in an inherited profile. If missing, the slice might
   * or might not be overriding a slice in an inherited profile, depending on the sliceName.
   */
  _sliceIsConstraining?: Maybe<Element>;
  /**
   * If true, indicates that this slice definition is constraining a slice
   * definition with the same name in an inherited profile. If false, the slice is
   * not overriding any slice in an inherited profile. If missing, the slice might
   * or might not be overriding a slice in an inherited profile, depending on the sliceName.
   */
  sliceIsConstraining?: Maybe<Scalars['Boolean']>;
  /**
   * A single preferred label which is the text to display beside the element
   * indicating its meaning or to use to prompt for the element in a user display or form.
   */
  _label?: Maybe<Element>;
  /**
   * A single preferred label which is the text to display beside the element
   * indicating its meaning or to use to prompt for the element in a user display or form.
   */
  label?: Maybe<Scalars['String']>;
  /** A code that has the same meaning as the element in a particular terminology. */
  code?: Maybe<Array<Maybe<Coding>>>;
  /**
   * Indicates that the element is sliced into a set of alternative definitions
   * (i.e. in a structure definition, there are multiple different constraints on a
   * single element in the base resource). Slicing can be used in any resource that
   * has cardinality ..* on the base resource, or any resource with a choice of
   * types. The set of slices is any elements that come after this in the element
   * sequence that have the same path, until a shorter path occurs (the shorter
   * path terminates the set).
   */
  slicing?: Maybe<Element>;
  /** A concise description of what this element means (e.g. for use in autogenerated summaries). */
  _short?: Maybe<Element>;
  /** A concise description of what this element means (e.g. for use in autogenerated summaries). */
  short?: Maybe<Scalars['String']>;
  /**
   * Provides a complete explanation of the meaning of the data element for human
   * readability.  For the case of elements derived from existing elements (e.g.
   * constraints), the definition SHALL be consistent with the base definition, but
   * convey the meaning of the element in the particular context of use of the
   * resource. (Note: The text you are reading is specified in
   * ElementDefinition.definition).
   */
  _definition?: Maybe<Element>;
  /**
   * Provides a complete explanation of the meaning of the data element for human
   * readability.  For the case of elements derived from existing elements (e.g.
   * constraints), the definition SHALL be consistent with the base definition, but
   * convey the meaning of the element in the particular context of use of the
   * resource. (Note: The text you are reading is specified in
   * ElementDefinition.definition).
   */
  definition?: Maybe<Scalars['String']>;
  /**
   * Explanatory notes and implementation guidance about the data element,
   * including notes about how to use the data properly, exceptions to proper use,
   * etc. (Note: The text you are reading is specified in
   * ElementDefinition.comment).
   */
  _comment?: Maybe<Element>;
  /**
   * Explanatory notes and implementation guidance about the data element,
   * including notes about how to use the data properly, exceptions to proper use,
   * etc. (Note: The text you are reading is specified in
   * ElementDefinition.comment).
   */
  comment?: Maybe<Scalars['String']>;
  /**
   * This element is for traceability of why the element was created and why the
   * constraints exist as they do. This may be used to point to source materials or
   * specifications that drove the structure of this element.
   */
  _requirements?: Maybe<Element>;
  /**
   * This element is for traceability of why the element was created and why the
   * constraints exist as they do. This may be used to point to source materials or
   * specifications that drove the structure of this element.
   */
  requirements?: Maybe<Scalars['String']>;
  /** Identifies additional names by which this element might also be known. */
  _alias?: Maybe<Element>;
  /** Identifies additional names by which this element might also be known. */
  alias?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The minimum number of times this element SHALL appear in the instance. */
  _min?: Maybe<Element>;
  /** The minimum number of times this element SHALL appear in the instance. */
  min?: Maybe<Scalars['unsignedInt']>;
  /** The maximum number of times this element is permitted to appear in the instance. */
  _max?: Maybe<Element>;
  /** The maximum number of times this element is permitted to appear in the instance. */
  max?: Maybe<Scalars['String']>;
  /**
   * Information about the base definition of the element, provided to make it
   * unnecessary for tools to trace the deviation of the element through the
   * derived and related profiles. When the element definition is not the original
   * definition of an element - i.g. either in a constraint on another type, or for
   * elements from a super type in a snap shot - then the information in provided
   * in the element definition may be different to the base definition. On the
   * original definition of the element, it will be same.
   */
  base?: Maybe<Element>;
  /**
   * Identifies an element defined elsewhere in the definition whose content rules
   * should be applied to the current element. ContentReferences bring across all
   * the rules that are in the ElementDefinition for the element, including
   * definitions, cardinality constraints, bindings, invariants etc.
   */
  _contentReference?: Maybe<Element>;
  /**
   * Identifies an element defined elsewhere in the definition whose content rules
   * should be applied to the current element. ContentReferences bring across all
   * the rules that are in the ElementDefinition for the element, including
   * definitions, cardinality constraints, bindings, invariants etc.
   */
  contentReference?: Maybe<Scalars['uri']>;
  /** The data type or resource that the value of this element is permitted to be. */
  type?: Maybe<Array<Maybe<Element>>>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueBase64Binary?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueBase64Binary?: Maybe<Scalars['base64Binary']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueBoolean?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueCanonical?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueCanonical?: Maybe<Scalars['canonical']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueCode?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueCode?: Maybe<Scalars['code']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueDate?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueDate?: Maybe<Scalars['date']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueDateTime?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueDecimal?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueDecimal?: Maybe<Scalars['Float']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueId?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueId?: Maybe<Scalars['id']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueInstant?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueInstant?: Maybe<Scalars['instant']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueInteger?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueInteger?: Maybe<Scalars['Int']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueMarkdown?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueMarkdown?: Maybe<Scalars['String']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueOid?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueOid?: Maybe<Scalars['oid']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValuePositiveInt?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValuePositiveInt?: Maybe<Scalars['positiveInt']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueString?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueString?: Maybe<Scalars['String']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueTime?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueTime?: Maybe<Scalars['time']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueUnsignedInt?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueUri?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueUri?: Maybe<Scalars['uri']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueUrl?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueUrl?: Maybe<Scalars['url']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  _defaultValueUuid?: Maybe<Element>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueUuid?: Maybe<Scalars['uuid']>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueAddress?: Maybe<Address>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueAge?: Maybe<Age>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueAnnotation?: Maybe<Annotation>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueAttachment?: Maybe<Attachment>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueCodeableConcept?: Maybe<CodeableConcept>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueCoding?: Maybe<Coding>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueContactPoint?: Maybe<ContactPoint>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueCount?: Maybe<Count>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueDistance?: Maybe<Distance>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueDuration?: Maybe<Duration>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueHumanName?: Maybe<HumanName>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueIdentifier?: Maybe<Identifier>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueMoney?: Maybe<Money>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValuePeriod?: Maybe<Period>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueQuantity?: Maybe<Quantity>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueRange?: Maybe<Range>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueRatio?: Maybe<Ratio>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueReference?: Maybe<ResourceList>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueSampledData?: Maybe<SampledData>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueSignature?: Maybe<Signature>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueTiming?: Maybe<Timing>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueContactDetail?: Maybe<ContactDetail>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueContributor?: Maybe<Contributor>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueDataRequirement?: Maybe<DataRequirement>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueExpression?: Maybe<Expression>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueParameterDefinition?: Maybe<ParameterDefinition>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueRelatedArtifact?: Maybe<RelatedArtifact>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueTriggerDefinition?: Maybe<TriggerDefinition>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueUsageContext?: Maybe<UsageContext>;
  /**
   * The value that should be used if there is no value stated in the instance
   * (e.g. 'if not otherwise specified, the abstract is false').
   */
  defaultValueDosage?: Maybe<Dosage>;
  /**
   * The Implicit meaning that is to be understood when this element is missing
   * (e.g. 'when this element is missing, the period is ongoing').
   */
  _meaningWhenMissing?: Maybe<Element>;
  /**
   * The Implicit meaning that is to be understood when this element is missing
   * (e.g. 'when this element is missing, the period is ongoing').
   */
  meaningWhenMissing?: Maybe<Scalars['String']>;
  /**
   * If present, indicates that the order of the repeating element has meaning and
   * describes what that meaning is.  If absent, it means that the order of the
   * element has no meaning.
   */
  _orderMeaning?: Maybe<Element>;
  /**
   * If present, indicates that the order of the repeating element has meaning and
   * describes what that meaning is.  If absent, it means that the order of the
   * element has no meaning.
   */
  orderMeaning?: Maybe<Scalars['String']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedBase64Binary?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedBase64Binary?: Maybe<Scalars['base64Binary']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedBoolean?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedCanonical?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedCanonical?: Maybe<Scalars['canonical']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedCode?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedCode?: Maybe<Scalars['code']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedDate?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedDate?: Maybe<Scalars['date']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedDateTime?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedDecimal?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedDecimal?: Maybe<Scalars['Float']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedId?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedId?: Maybe<Scalars['id']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedInstant?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedInstant?: Maybe<Scalars['instant']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedInteger?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedInteger?: Maybe<Scalars['Int']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedMarkdown?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedMarkdown?: Maybe<Scalars['String']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedOid?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedOid?: Maybe<Scalars['oid']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedPositiveInt?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedPositiveInt?: Maybe<Scalars['positiveInt']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedString?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedString?: Maybe<Scalars['String']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedTime?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedTime?: Maybe<Scalars['time']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedUnsignedInt?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedUri?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedUri?: Maybe<Scalars['uri']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedUrl?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedUrl?: Maybe<Scalars['url']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  _fixedUuid?: Maybe<Element>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedUuid?: Maybe<Scalars['uuid']>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedAddress?: Maybe<Address>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedAge?: Maybe<Age>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedAnnotation?: Maybe<Annotation>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedAttachment?: Maybe<Attachment>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedCodeableConcept?: Maybe<CodeableConcept>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedCoding?: Maybe<Coding>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedContactPoint?: Maybe<ContactPoint>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedCount?: Maybe<Count>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedDistance?: Maybe<Distance>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedDuration?: Maybe<Duration>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedHumanName?: Maybe<HumanName>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedIdentifier?: Maybe<Identifier>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedMoney?: Maybe<Money>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedPeriod?: Maybe<Period>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedQuantity?: Maybe<Quantity>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedRange?: Maybe<Range>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedRatio?: Maybe<Ratio>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedReference?: Maybe<ResourceList>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedSampledData?: Maybe<SampledData>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedSignature?: Maybe<Signature>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedTiming?: Maybe<Timing>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedContactDetail?: Maybe<ContactDetail>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedContributor?: Maybe<Contributor>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedDataRequirement?: Maybe<DataRequirement>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedExpression?: Maybe<Expression>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedParameterDefinition?: Maybe<ParameterDefinition>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedRelatedArtifact?: Maybe<RelatedArtifact>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedTriggerDefinition?: Maybe<TriggerDefinition>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedUsageContext?: Maybe<UsageContext>;
  /**
   * Specifies a value that SHALL be exactly the value  for this element in the
   * instance. For purposes of comparison, non-significant whitespace is ignored,
   * and all values must be an exact match (case and accent sensitive). Missing
   * elements/attributes must also be missing.
   */
  fixedDosage?: Maybe<Dosage>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternBase64Binary?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternBase64Binary?: Maybe<Scalars['base64Binary']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternBoolean?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternCanonical?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternCanonical?: Maybe<Scalars['canonical']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternCode?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternCode?: Maybe<Scalars['code']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternDate?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternDate?: Maybe<Scalars['date']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternDateTime?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternDecimal?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternDecimal?: Maybe<Scalars['Float']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternId?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternId?: Maybe<Scalars['id']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternInstant?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternInstant?: Maybe<Scalars['instant']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternInteger?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternInteger?: Maybe<Scalars['Int']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternMarkdown?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternMarkdown?: Maybe<Scalars['String']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternOid?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternOid?: Maybe<Scalars['oid']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternPositiveInt?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternPositiveInt?: Maybe<Scalars['positiveInt']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternString?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternString?: Maybe<Scalars['String']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternTime?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternTime?: Maybe<Scalars['time']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternUnsignedInt?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternUri?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternUri?: Maybe<Scalars['uri']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternUrl?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternUrl?: Maybe<Scalars['url']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  _patternUuid?: Maybe<Element>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternUuid?: Maybe<Scalars['uuid']>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternAddress?: Maybe<Address>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternAge?: Maybe<Age>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternAnnotation?: Maybe<Annotation>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternAttachment?: Maybe<Attachment>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternCodeableConcept?: Maybe<CodeableConcept>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternCoding?: Maybe<Coding>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternContactPoint?: Maybe<ContactPoint>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternCount?: Maybe<Count>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternDistance?: Maybe<Distance>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternDuration?: Maybe<Duration>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternHumanName?: Maybe<HumanName>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternIdentifier?: Maybe<Identifier>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternMoney?: Maybe<Money>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternPeriod?: Maybe<Period>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternQuantity?: Maybe<Quantity>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternRange?: Maybe<Range>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternRatio?: Maybe<Ratio>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternReference?: Maybe<ResourceList>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternSampledData?: Maybe<SampledData>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternSignature?: Maybe<Signature>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternTiming?: Maybe<Timing>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternContactDetail?: Maybe<ContactDetail>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternContributor?: Maybe<Contributor>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternDataRequirement?: Maybe<DataRequirement>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternExpression?: Maybe<Expression>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternParameterDefinition?: Maybe<ParameterDefinition>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternRelatedArtifact?: Maybe<RelatedArtifact>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternTriggerDefinition?: Maybe<TriggerDefinition>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternUsageContext?: Maybe<UsageContext>;
  /**
   * Specifies a value that the value in the instance SHALL follow - that is, any
   * value in the pattern must be found in the instance. Other additional values
   * may be found too. This is effectively constraint by example.    When
   * pattern[x] is used to constrain a primitive, it means that the value provided
   * in the pattern[x] must match the instance value exactly.  When pattern[x] is
   * used to constrain an array, it means that each element provided in the
   * pattern[x] array must (recursively) match at least one element from the
   * instance array.  When pattern[x] is used to constrain a complex object, it
   * means that each property in the pattern must be present in the complex object,
   * and its value must recursively match -- i.e.,  1. If primitive: it must match
   * exactly the pattern value 2. If a complex object: it must match (recursively)
   * the pattern value 3. If an array: it must match (recursively) the pattern value.
   */
  patternDosage?: Maybe<Dosage>;
  /** A sample value for this element demonstrating the type of information that would typically be found in the element. */
  example?: Maybe<Array<Maybe<Element>>>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _minValueDate?: Maybe<Element>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  minValueDate?: Maybe<Scalars['date']>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _minValueDateTime?: Maybe<Element>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  minValueDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _minValueInstant?: Maybe<Element>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  minValueInstant?: Maybe<Scalars['instant']>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _minValueTime?: Maybe<Element>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  minValueTime?: Maybe<Scalars['time']>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _minValueDecimal?: Maybe<Element>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  minValueDecimal?: Maybe<Scalars['Float']>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _minValueInteger?: Maybe<Element>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  minValueInteger?: Maybe<Scalars['Int']>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _minValuePositiveInt?: Maybe<Element>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  minValuePositiveInt?: Maybe<Scalars['positiveInt']>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _minValueUnsignedInt?: Maybe<Element>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  minValueUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /**
   * The minimum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  minValueQuantity?: Maybe<Quantity>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _maxValueDate?: Maybe<Element>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  maxValueDate?: Maybe<Scalars['date']>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _maxValueDateTime?: Maybe<Element>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  maxValueDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _maxValueInstant?: Maybe<Element>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  maxValueInstant?: Maybe<Scalars['instant']>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _maxValueTime?: Maybe<Element>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  maxValueTime?: Maybe<Scalars['time']>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _maxValueDecimal?: Maybe<Element>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  maxValueDecimal?: Maybe<Scalars['Float']>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _maxValueInteger?: Maybe<Element>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  maxValueInteger?: Maybe<Scalars['Int']>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _maxValuePositiveInt?: Maybe<Element>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  maxValuePositiveInt?: Maybe<Scalars['positiveInt']>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  _maxValueUnsignedInt?: Maybe<Element>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  maxValueUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /**
   * The maximum allowed value for the element. The value is inclusive. This is
   * allowed for the types date, dateTime, instant, time, decimal, integer, and Quantity.
   */
  maxValueQuantity?: Maybe<Quantity>;
  /**
   * Indicates the maximum length in characters that is permitted to be present in
   * conformant instances and which is expected to be supported by conformant
   * consumers that support the element.
   */
  _maxLength?: Maybe<Element>;
  /**
   * Indicates the maximum length in characters that is permitted to be present in
   * conformant instances and which is expected to be supported by conformant
   * consumers that support the element.
   */
  maxLength?: Maybe<Scalars['Int']>;
  /** A reference to an invariant that may make additional statements about the cardinality or value in the instance. */
  _condition?: Maybe<Element>;
  /** A reference to an invariant that may make additional statements about the cardinality or value in the instance. */
  condition?: Maybe<Array<Maybe<Scalars['id']>>>;
  /**
   * Formal constraints such as co-occurrence and other constraints that can be
   * computationally evaluated within the context of the instance.
   */
  constraint?: Maybe<Array<Maybe<Element>>>;
  /**
   * If true, implementations that produce or consume resources SHALL provide
   * 'support' for the element in some meaningful way.  If false, the element may
   * be ignored and not supported. If false, whether to populate or use the data
   * element in any way is at the discretion of the implementation.
   */
  _mustSupport?: Maybe<Element>;
  /**
   * If true, implementations that produce or consume resources SHALL provide
   * 'support' for the element in some meaningful way.  If false, the element may
   * be ignored and not supported. If false, whether to populate or use the data
   * element in any way is at the discretion of the implementation.
   */
  mustSupport?: Maybe<Scalars['Boolean']>;
  /**
   * If true, the value of this element affects the interpretation of the element
   * or resource that contains it, and the value of the element cannot be ignored.
   * Typically, this is used for status, negation and qualification codes. The
   * effect of this is that the element cannot be ignored by systems: they SHALL
   * either recognize the element and process it, and/or a pre-determination has
   * been made that it is not relevant to their particular system.
   */
  _isModifier?: Maybe<Element>;
  /**
   * If true, the value of this element affects the interpretation of the element
   * or resource that contains it, and the value of the element cannot be ignored.
   * Typically, this is used for status, negation and qualification codes. The
   * effect of this is that the element cannot be ignored by systems: they SHALL
   * either recognize the element and process it, and/or a pre-determination has
   * been made that it is not relevant to their particular system.
   */
  isModifier?: Maybe<Scalars['Boolean']>;
  /** Explains how that element affects the interpretation of the resource or element that contains it. */
  _isModifierReason?: Maybe<Element>;
  /** Explains how that element affects the interpretation of the resource or element that contains it. */
  isModifierReason?: Maybe<Scalars['String']>;
  /** Whether the element should be included if a client requests a search with the parameter _summary=true. */
  _isSummary?: Maybe<Element>;
  /** Whether the element should be included if a client requests a search with the parameter _summary=true. */
  isSummary?: Maybe<Scalars['Boolean']>;
  /** Binds to a value set if this element is coded (code, Coding, CodeableConcept, Quantity), or the data types (string, uri). */
  binding?: Maybe<Element>;
  /** Identifies a concept from an external specification that roughly corresponds to this element. */
  mapping?: Maybe<Array<Maybe<Element>>>;
};

/** Base StructureDefinition for Element Type: Base definition for all elements in a resource. */
export type Element_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
};

/**
 * An interaction between a patient and healthcare provider(s) for the purpose of
 * providing healthcare service(s) or assessing the health status of a patient.
 */
export type Encounter = {
  __typename?: 'Encounter';
  /** Type of resource */
  resourceType: Encounter_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier(s) by which this encounter is known. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** planned | arrived | triaged | in-progress | onleave | finished | cancelled +. */
  _status?: Maybe<Element>;
  /** planned | arrived | triaged | in-progress | onleave | finished | cancelled +. */
  status: Scalars['code'];
  /**
   * The status history permits the encounter resource to contain the status
   * history without needing to read through the historical versions of the
   * resource, or even have the server store them.
   */
  statusHistory?: Maybe<Array<Maybe<EncounterstatusHistory>>>;
  /**
   * Concepts representing classification of patient encounter such as ambulatory
   * (outpatient), inpatient, emergency, home health or others due to local variations.
   */
  class: Coding;
  /**
   * The class history permits the tracking of the encounters transitions without
   * needing to go  through the resource history.  This would be used for a case
   * where an admission starts of as an emergency encounter, then transitions into
   * an inpatient scenario. Doing this and not restarting a new encounter ensures
   * that any lab/diagnostic results can more easily follow the patient and not
   * require re-processing and not get lost or cancelled during a kind of discharge
   * from emergency to inpatient.
   */
  classHistory?: Maybe<Array<Maybe<EncounterclassHistory>>>;
  /** Specific type of encounter (e.g. e-mail consultation, surgical day-care, skilled nursing, rehabilitation). */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Broad categorization of the service that is to be provided (e.g. cardiology). */
  serviceType?: Maybe<CodeableConcept>;
  /** Indicates the urgency of the encounter. */
  priority?: Maybe<CodeableConcept>;
  /** The patient or group present at the encounter. */
  subject?: Maybe<Encountersubject_Subject_Union>;
  /**
   * Where a specific encounter should be classified as a part of a specific
   * episode(s) of care this field should be used. This association can facilitate
   * grouping of related encounters together for a specific purpose, such as
   * government reporting, issue tracking, association via a common problem.  The
   * association is recorded on the encounter as these are typically created after
   * the episode of care and grouped on entry rather than editing the episode of
   * care to append another encounter to it (the episode of care could span years).
   */
  episodeOfCare?: Maybe<Array<Maybe<EncounterepisodeOfCare_EpisodeOfCare_Union>>>;
  /** The request this encounter satisfies (e.g. incoming referral or procedure request). */
  basedOn?: Maybe<Array<Maybe<EncounterbasedOn_BasedOn_Union>>>;
  /** The list of people responsible for providing the service. */
  participant?: Maybe<Array<Maybe<Encounterparticipant>>>;
  /** The appointment that scheduled this encounter. */
  appointment?: Maybe<Array<Maybe<Encounterappointment_Appointment_Union>>>;
  /** The start and end time of the encounter. */
  period?: Maybe<Period>;
  /** Quantity of time the encounter lasted. This excludes the time during leaves of absence. */
  length?: Maybe<Duration>;
  /** Reason the encounter takes place, expressed as a code. For admissions, this can be used for a coded admission diagnosis. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Reason the encounter takes place, expressed as a code. For admissions, this can be used for a coded admission diagnosis. */
  reasonReference?: Maybe<Array<Maybe<EncounterreasonReference_ReasonReference_Union>>>;
  /** The list of diagnosis relevant to this encounter. */
  diagnosis?: Maybe<Array<Maybe<Encounterdiagnosis>>>;
  /** The set of accounts that may be used for billing for this Encounter. */
  account?: Maybe<Array<Maybe<Encounteraccount_Account_Union>>>;
  /** Details about the admission to a healthcare service. */
  hospitalization?: Maybe<Encounterhospitalization>;
  /** List of locations where  the patient has been during this encounter. */
  location?: Maybe<Array<Maybe<Encounterlocation>>>;
  /**
   * The organization that is primarily responsible for this Encounter's services.
   * This MAY be the same as the organization on the Patient record, however it
   * could be different, such as if the actor performing the services was from an
   * external organization (which may be billed seperately) for an external
   * consultation.  Refer to the example bundle showing an abbreviated set of
   * Encounters for a colonoscopy.
   */
  serviceProvider?: Maybe<EncounterserviceProvider_ServiceProvider_Union>;
  /** Another Encounter of which this encounter is a part of (administratively or in time). */
  partOf?: Maybe<EncounterpartOf_PartOf_Union>;
};

export enum Encounter_Enum_Schema {
  Encounter = 'Encounter'
}

/** The set of accounts that may be used for billing for this Encounter. */
export type Encounteraccount_Account_Union = Account;

/** The appointment that scheduled this encounter. */
export type Encounterappointment_Appointment_Union = Appointment;

/** The request this encounter satisfies (e.g. incoming referral or procedure request). */
export type EncounterbasedOn_BasedOn_Union = ServiceRequest;

export type EncounterclassHistory = {
  __typename?: 'EncounterclassHistory';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** inpatient | outpatient | ambulatory | emergency +. */
  class: Coding;
  /** The time that the episode was in the specified class. */
  period: Period;
};

export type Encounterdiagnosis = {
  __typename?: 'Encounterdiagnosis';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Reason the encounter takes place, as specified using information from another
   * resource. For admissions, this is the admission diagnosis. The indication will
   * typically be a Condition (with other resources referenced in the
   * evidence.detail), or a Procedure.
   */
  condition: Encounterdiagnosiscondition_Condition_Union;
  /** Role that this diagnosis has within the encounter (e.g. admission, billing, discharge …). */
  use?: Maybe<CodeableConcept>;
  /** Ranking of the diagnosis (for each role type). */
  _rank?: Maybe<Element>;
  /** Ranking of the diagnosis (for each role type). */
  rank?: Maybe<Scalars['positiveInt']>;
};

/**
 * Reason the encounter takes place, as specified using information from another
 * resource. For admissions, this is the admission diagnosis. The indication will
 * typically be a Condition (with other resources referenced in the
 * evidence.detail), or a Procedure.
 */
export type Encounterdiagnosiscondition_Condition_Union = Condition | Procedure;

/**
 * Where a specific encounter should be classified as a part of a specific
 * episode(s) of care this field should be used. This association can facilitate
 * grouping of related encounters together for a specific purpose, such as
 * government reporting, issue tracking, association via a common problem.  The
 * association is recorded on the encounter as these are typically created after
 * the episode of care and grouped on entry rather than editing the episode of care
 * to append another encounter to it (the episode of care could span years).
 */
export type EncounterepisodeOfCare_EpisodeOfCare_Union = EpisodeOfCare;

export type Encounterhospitalization = {
  __typename?: 'Encounterhospitalization';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Pre-admission identifier. */
  preAdmissionIdentifier?: Maybe<Identifier>;
  /** The location/organization from which the patient came before admission. */
  origin?: Maybe<Encounterhospitalizationorigin_Origin_Union>;
  /** From where patient was admitted (physician referral, transfer). */
  admitSource?: Maybe<CodeableConcept>;
  /** Whether this hospitalization is a readmission and why if known. */
  reAdmission?: Maybe<CodeableConcept>;
  /** Diet preferences reported by the patient. */
  dietPreference?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Special courtesies (VIP, board member). */
  specialCourtesy?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Any special requests that have been made for this hospitalization encounter,
   * such as the provision of specific equipment or other things.
   */
  specialArrangement?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Location/organization to which the patient is discharged. */
  destination?: Maybe<Encounterhospitalizationdestination_Destination_Union>;
  /** Category or kind of location after discharge. */
  dischargeDisposition?: Maybe<CodeableConcept>;
};

/** Location/organization to which the patient is discharged. */
export type Encounterhospitalizationdestination_Destination_Union = Location | Organization;

/** The location/organization from which the patient came before admission. */
export type Encounterhospitalizationorigin_Origin_Union = Location | Organization;

export type Encounterlocation = {
  __typename?: 'Encounterlocation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The location where the encounter takes place. */
  location: Encounterlocationlocation_Location_Union;
  /**
   * The status of the participants' presence at the specified location during the
   * period specified. If the participant is no longer at the location, then the
   * period will have an end date/time.
   */
  _status?: Maybe<Element>;
  /**
   * The status of the participants' presence at the specified location during the
   * period specified. If the participant is no longer at the location, then the
   * period will have an end date/time.
   */
  status?: Maybe<Scalars['code']>;
  /**
   * This will be used to specify the required levels (bed/ward/room/etc.) desired
   * to be recorded to simplify either messaging or query.
   */
  physicalType?: Maybe<CodeableConcept>;
  /** Time period during which the patient was present at the location. */
  period?: Maybe<Period>;
};

/** The location where the encounter takes place. */
export type Encounterlocationlocation_Location_Union = Location;

/** Another Encounter of which this encounter is a part of (administratively or in time). */
export type EncounterpartOf_PartOf_Union = Encounter;

export type Encounterparticipant = {
  __typename?: 'Encounterparticipant';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Role of participant in encounter. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * The period of time that the specified participant participated in the
   * encounter. These can overlap or be sub-sets of the overall encounter's period.
   */
  period?: Maybe<Period>;
  /** Persons involved in the encounter other than the patient. */
  individual?: Maybe<Encounterparticipantindividual_Individual_Union>;
};

/** Persons involved in the encounter other than the patient. */
export type Encounterparticipantindividual_Individual_Union = Practitioner | PractitionerRole | RelatedPerson;

/** Reason the encounter takes place, expressed as a code. For admissions, this can be used for a coded admission diagnosis. */
export type EncounterreasonReference_ReasonReference_Union = Condition | Procedure | Observation | ImmunizationRecommendation;

/**
 * The organization that is primarily responsible for this Encounter's services.
 * This MAY be the same as the organization on the Patient record, however it could
 * be different, such as if the actor performing the services was from an external
 * organization (which may be billed seperately) for an external consultation.
 * Refer to the example bundle showing an abbreviated set of Encounters for a colonoscopy.
 */
export type EncounterserviceProvider_ServiceProvider_Union = Organization;

export type EncounterstatusHistory = {
  __typename?: 'EncounterstatusHistory';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** planned | arrived | triaged | in-progress | onleave | finished | cancelled +. */
  _status?: Maybe<Element>;
  /** planned | arrived | triaged | in-progress | onleave | finished | cancelled +. */
  status: Scalars['code'];
  /** The time that the episode was in the specified status. */
  period: Period;
};

/** The patient or group present at the encounter. */
export type Encountersubject_Subject_Union = Patient | Group;

/**
 * The technical details of an endpoint that can be used for electronic services,
 * such as for web services providing XDS.b or a REST endpoint for another FHIR
 * server. This may include any security context information.
 */
export type Endpoint = {
  __typename?: 'Endpoint';
  /** Type of resource */
  resourceType: Endpoint_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier for the organization that is used to identify the endpoint across multiple disparate systems. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** active | suspended | error | off | test. */
  _status?: Maybe<Element>;
  /** active | suspended | error | off | test. */
  status: Scalars['code'];
  /**
   * A coded value that represents the technical details of the usage of this
   * endpoint, such as what WSDLs should be used in what way. (e.g.
   * XDS.b/DICOM/cds-hook).
   */
  connectionType: Coding;
  /** A friendly name that this endpoint can be referred to with. */
  _name?: Maybe<Element>;
  /** A friendly name that this endpoint can be referred to with. */
  name?: Maybe<Scalars['String']>;
  /**
   * The organization that manages this endpoint (even if technically another
   * organization is hosting this in the cloud, it is the organization associated
   * with the data).
   */
  managingOrganization?: Maybe<EndpointmanagingOrganization_ManagingOrganization_Union>;
  /**
   * Contact details for a human to contact about the subscription. The primary use
   * of this for system administrator troubleshooting.
   */
  contact?: Maybe<Array<Maybe<ContactPoint>>>;
  /** The interval during which the endpoint is expected to be operational. */
  period?: Maybe<Period>;
  /** The payload type describes the acceptable content that can be communicated on the endpoint. */
  payloadType?: Maybe<Array<CodeableConcept>>;
  /**
   * The mime type to send the payload in - e.g. application/fhir+xml,
   * application/fhir+json. If the mime type is not specified, then the sender
   * could send any content (including no content depending on the connectionType).
   */
  _payloadMimeType?: Maybe<Element>;
  /**
   * The mime type to send the payload in - e.g. application/fhir+xml,
   * application/fhir+json. If the mime type is not specified, then the sender
   * could send any content (including no content depending on the connectionType).
   */
  payloadMimeType?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** The uri that describes the actual end-point to connect to. */
  _address?: Maybe<Element>;
  /** The uri that describes the actual end-point to connect to. */
  address: Scalars['url'];
  /** Additional headers / information to send as part of the notification. */
  _header?: Maybe<Element>;
  /** Additional headers / information to send as part of the notification. */
  header?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Endpoint_Enum_Schema {
  Endpoint = 'Endpoint'
}

/**
 * The organization that manages this endpoint (even if technically another
 * organization is hosting this in the cloud, it is the organization associated
 * with the data).
 */
export type EndpointmanagingOrganization_ManagingOrganization_Union = Organization;

/** This resource provides the insurance enrollment details to the insurer regarding a specified coverage. */
export type EnrollmentRequest = {
  __typename?: 'EnrollmentRequest';
  /** Type of resource */
  resourceType: EnrollmentRequest_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The Response business identifier. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status?: Maybe<Scalars['code']>;
  /** The date when this resource was created. */
  _created?: Maybe<Element>;
  /** The date when this resource was created. */
  created?: Maybe<Scalars['dateTime']>;
  /** The Insurer who is target  of the request. */
  insurer?: Maybe<EnrollmentRequestinsurer_Insurer_Union>;
  /** The practitioner who is responsible for the services rendered to the patient. */
  provider?: Maybe<EnrollmentRequestprovider_Provider_Union>;
  /** Patient Resource. */
  candidate?: Maybe<EnrollmentRequestcandidate_Candidate_Union>;
  /** Reference to the program or plan identification, underwriter or payor. */
  coverage?: Maybe<EnrollmentRequestcoverage_Coverage_Union>;
};

export enum EnrollmentRequest_Enum_Schema {
  EnrollmentRequest = 'EnrollmentRequest'
}

/** Patient Resource. */
export type EnrollmentRequestcandidate_Candidate_Union = Patient;

/** Reference to the program or plan identification, underwriter or payor. */
export type EnrollmentRequestcoverage_Coverage_Union = Coverage;

/** The Insurer who is target  of the request. */
export type EnrollmentRequestinsurer_Insurer_Union = Organization;

/** The practitioner who is responsible for the services rendered to the patient. */
export type EnrollmentRequestprovider_Provider_Union = Practitioner | PractitionerRole | Organization;

/** This resource provides enrollment and plan details from the processing of an EnrollmentRequest resource. */
export type EnrollmentResponse = {
  __typename?: 'EnrollmentResponse';
  /** Type of resource */
  resourceType: EnrollmentResponse_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The Response business identifier. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status?: Maybe<Scalars['code']>;
  /** Original request resource reference. */
  request?: Maybe<EnrollmentResponserequest_Request_Union>;
  /** Processing status: error, complete. */
  _outcome?: Maybe<Element>;
  /** Processing status: error, complete. */
  outcome?: Maybe<Scalars['code']>;
  /** A description of the status of the adjudication. */
  _disposition?: Maybe<Element>;
  /** A description of the status of the adjudication. */
  disposition?: Maybe<Scalars['String']>;
  /** The date when the enclosed suite of services were performed or completed. */
  _created?: Maybe<Element>;
  /** The date when the enclosed suite of services were performed or completed. */
  created?: Maybe<Scalars['dateTime']>;
  /** The Insurer who produced this adjudicated response. */
  organization?: Maybe<EnrollmentResponseorganization_Organization_Union>;
  /** The practitioner who is responsible for the services rendered to the patient. */
  requestProvider?: Maybe<EnrollmentResponserequestProvider_RequestProvider_Union>;
};

export enum EnrollmentResponse_Enum_Schema {
  EnrollmentResponse = 'EnrollmentResponse'
}

/** The Insurer who produced this adjudicated response. */
export type EnrollmentResponseorganization_Organization_Union = Organization;

/** The practitioner who is responsible for the services rendered to the patient. */
export type EnrollmentResponserequestProvider_RequestProvider_Union = Practitioner | PractitionerRole | Organization;

/** Original request resource reference. */
export type EnrollmentResponserequest_Request_Union = EnrollmentRequest;

/**
 * An association between a patient and an organization / healthcare provider(s)
 * during which time encounters may occur. The managing organization assumes a
 * level of responsibility for the patient during this time.
 */
export type EpisodeOfCare = {
  __typename?: 'EpisodeOfCare';
  /** Type of resource */
  resourceType: EpisodeOfCare_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The EpisodeOfCare may be known by different identifiers for different contexts
   * of use, such as when an external agency is tracking the Episode for funding purposes.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** planned | waitlist | active | onhold | finished | cancelled. */
  _status?: Maybe<Element>;
  /** planned | waitlist | active | onhold | finished | cancelled. */
  status: Scalars['code'];
  /**
   * The history of statuses that the EpisodeOfCare has been through (without
   * requiring processing the history of the resource).
   */
  statusHistory?: Maybe<Array<Maybe<EpisodeOfCarestatusHistory>>>;
  /** A classification of the type of episode of care; e.g. specialist referral, disease management, type of funded care. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The list of diagnosis relevant to this episode of care. */
  diagnosis?: Maybe<Array<Maybe<EpisodeOfCarediagnosis>>>;
  /** The patient who is the focus of this episode of care. */
  patient: EpisodeOfCarepatient_Patient_Union;
  /** The organization that has assumed the specific responsibilities for the specified duration. */
  managingOrganization?: Maybe<EpisodeOfCaremanagingOrganization_ManagingOrganization_Union>;
  /** The interval during which the managing organization assumes the defined responsibility. */
  period?: Maybe<Period>;
  /** Referral Request(s) that are fulfilled by this EpisodeOfCare, incoming referrals. */
  referralRequest?: Maybe<Array<Maybe<EpisodeOfCarereferralRequest_ReferralRequest_Union>>>;
  /** The practitioner that is the care manager/care coordinator for this patient. */
  careManager?: Maybe<EpisodeOfCarecareManager_CareManager_Union>;
  /** The list of practitioners that may be facilitating this episode of care for specific purposes. */
  team?: Maybe<Array<Maybe<EpisodeOfCareteam_Team_Union>>>;
  /** The set of accounts that may be used for billing for this EpisodeOfCare. */
  account?: Maybe<Array<Maybe<EpisodeOfCareaccount_Account_Union>>>;
};

export enum EpisodeOfCare_Enum_Schema {
  EpisodeOfCare = 'EpisodeOfCare'
}

/** The set of accounts that may be used for billing for this EpisodeOfCare. */
export type EpisodeOfCareaccount_Account_Union = Account;

/** The practitioner that is the care manager/care coordinator for this patient. */
export type EpisodeOfCarecareManager_CareManager_Union = Practitioner | PractitionerRole;

export type EpisodeOfCarediagnosis = {
  __typename?: 'EpisodeOfCarediagnosis';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A list of conditions/problems/diagnoses that this episode of care is intended to be providing care for. */
  condition: EpisodeOfCarediagnosiscondition_Condition_Union;
  /** Role that this diagnosis has within the episode of care (e.g. admission, billing, discharge …). */
  role?: Maybe<CodeableConcept>;
  /** Ranking of the diagnosis (for each role type). */
  _rank?: Maybe<Element>;
  /** Ranking of the diagnosis (for each role type). */
  rank?: Maybe<Scalars['positiveInt']>;
};

/** A list of conditions/problems/diagnoses that this episode of care is intended to be providing care for. */
export type EpisodeOfCarediagnosiscondition_Condition_Union = Condition;

/** The organization that has assumed the specific responsibilities for the specified duration. */
export type EpisodeOfCaremanagingOrganization_ManagingOrganization_Union = Organization;

/** The patient who is the focus of this episode of care. */
export type EpisodeOfCarepatient_Patient_Union = Patient;

/** Referral Request(s) that are fulfilled by this EpisodeOfCare, incoming referrals. */
export type EpisodeOfCarereferralRequest_ReferralRequest_Union = ServiceRequest;

export type EpisodeOfCarestatusHistory = {
  __typename?: 'EpisodeOfCarestatusHistory';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** planned | waitlist | active | onhold | finished | cancelled. */
  _status?: Maybe<Element>;
  /** planned | waitlist | active | onhold | finished | cancelled. */
  status: Scalars['code'];
  /** The period during this EpisodeOfCare that the specific status applied. */
  period: Period;
};

/** The list of practitioners that may be facilitating this episode of care for specific purposes. */
export type EpisodeOfCareteam_Team_Union = CareTeam;

/** The EventDefinition resource provides a reusable description of when a particular event can occur. */
export type EventDefinition = {
  __typename?: 'EventDefinition';
  /** Type of resource */
  resourceType: EventDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this event definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this event definition
   * is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the event definition is stored on
   * different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this event definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this event definition
   * is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the event definition is stored on
   * different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this event definition when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the event definition
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the event definition author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the event definition
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the event definition author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the event definition. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the event definition. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the event definition. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the event definition. */
  title?: Maybe<Scalars['String']>;
  /** An explanatory or alternate title for the event definition giving additional information about its content. */
  _subtitle?: Maybe<Element>;
  /** An explanatory or alternate title for the event definition giving additional information about its content. */
  subtitle?: Maybe<Scalars['String']>;
  /** The status of this event definition. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this event definition. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this event definition is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this event definition is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /** A code or group definition that describes the intended subject of the event definition. */
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  /** A code or group definition that describes the intended subject of the event definition. */
  subjectReference?: Maybe<EventDefinitionsubjectReference_SubjectReference_Union>;
  /**
   * The date  (and optionally time) when the event definition was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the event definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the event definition was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the event definition changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the event definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the event definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the event definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the event definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate event
   * definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the event definition is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this event definition is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this event definition is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /** A detailed description of how the event definition is used from a clinical perspective. */
  _usage?: Maybe<Element>;
  /** A detailed description of how the event definition is used from a clinical perspective. */
  usage?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the event definition and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the event definition.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the event definition and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the event definition.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the event definition content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the module. Topics provide a high-level
   * categorization of the module that can be useful for filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related resources such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /**
   * The trigger element defines when the event occurs. If more than one trigger
   * condition is specified, the event fires whenever any one of the trigger
   * conditions is met.
   */
  trigger?: Maybe<Array<TriggerDefinition>>;
};

export enum EventDefinition_Enum_Schema {
  EventDefinition = 'EventDefinition'
}

/** A code or group definition that describes the intended subject of the event definition. */
export type EventDefinitionsubjectReference_SubjectReference_Union = Group;

/**
 * The Evidence resource describes the conditional state (population and any
 * exposures being compared within the population) and outcome (if specified) that
 * the knowledge (evidence, assertion, recommendation) is about.
 */
export type Evidence = {
  __typename?: 'Evidence';
  /** Type of resource */
  resourceType: Evidence_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this evidence when it is referenced
   * in a specification, model, design or an instance; also called its canonical
   * identifier. This SHOULD be globally unique and SHOULD be a literal address at
   * which at which an authoritative instance of this evidence is (or will be)
   * published. This URL can be the target of a canonical reference. It SHALL
   * remain the same when the evidence is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this evidence when it is referenced
   * in a specification, model, design or an instance; also called its canonical
   * identifier. This SHOULD be globally unique and SHOULD be a literal address at
   * which at which an authoritative instance of this evidence is (or will be)
   * published. This URL can be the target of a canonical reference. It SHALL
   * remain the same when the evidence is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this evidence when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the evidence when it
   * is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the evidence author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence. To provide a version consistent
   * with the Decision Support Service specification, use the format
   * Major.Minor.Revision (e.g. 1.0.0). For more information on versioning
   * knowledge assets, refer to the Decision Support Service specification. Note
   * that a version is required for non-experimental active artifacts.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the evidence when it
   * is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the evidence author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence. To provide a version consistent
   * with the Decision Support Service specification, use the format
   * Major.Minor.Revision (e.g. 1.0.0). For more information on versioning
   * knowledge assets, refer to the Decision Support Service specification. Note
   * that a version is required for non-experimental active artifacts.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the evidence. This name should be usable
   * as an identifier for the module by machine processing applications such as
   * code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the evidence. This name should be usable
   * as an identifier for the module by machine processing applications such as
   * code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the evidence. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the evidence. */
  title?: Maybe<Scalars['String']>;
  /**
   * The short title provides an alternate title for use in informal descriptive
   * contexts where the full, formal title is not necessary.
   */
  _shortTitle?: Maybe<Element>;
  /**
   * The short title provides an alternate title for use in informal descriptive
   * contexts where the full, formal title is not necessary.
   */
  shortTitle?: Maybe<Scalars['String']>;
  /** An explanatory or alternate title for the Evidence giving additional information about its content. */
  _subtitle?: Maybe<Element>;
  /** An explanatory or alternate title for the Evidence giving additional information about its content. */
  subtitle?: Maybe<Scalars['String']>;
  /** The status of this evidence. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this evidence. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * The date  (and optionally time) when the evidence was published. The date must
   * change when the business version changes and it must change if the status code
   * changes. In addition, it should change when the substantive content of the
   * evidence changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the evidence was published. The date must
   * change when the business version changes and it must change if the status code
   * changes. In addition, it should change when the substantive content of the
   * evidence changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the evidence. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the evidence. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the evidence from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the evidence from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate evidence instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the evidence is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * A copyright statement relating to the evidence and/or its contents. Copyright
   * statements are generally legal restrictions on the use and publishing of the evidence.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the evidence and/or its contents. Copyright
   * statements are generally legal restrictions on the use and publishing of the evidence.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the evidence content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the content of the Evidence. Topics provide a
   * high-level categorization grouping types of Evidences that can be useful for
   * filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related artifacts such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** A reference to a EvidenceVariable resource that defines the population for the research. */
  exposureBackground: EvidenceexposureBackground_ExposureBackground_Union;
  /** A reference to a EvidenceVariable resource that defines the exposure for the research. */
  exposureVariant?: Maybe<Array<Maybe<EvidenceexposureVariant_ExposureVariant_Union>>>;
  /** A reference to a EvidenceVariable resomece that defines the outcome for the research. */
  outcome?: Maybe<Array<Maybe<Evidenceoutcome_Outcome_Union>>>;
};

/** The EvidenceVariable resource describes a 'PICO' element that knowledge (evidence, assertion, recommendation) is about. */
export type EvidenceVariable = {
  __typename?: 'EvidenceVariable';
  /** Type of resource */
  resourceType: EvidenceVariable_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this evidence variable when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this evidence variable
   * is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the evidence variable is stored on
   * different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this evidence variable when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this evidence variable
   * is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the evidence variable is stored on
   * different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this evidence variable when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the evidence variable
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the evidence variable author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence. To provide a version consistent
   * with the Decision Support Service specification, use the format
   * Major.Minor.Revision (e.g. 1.0.0). For more information on versioning
   * knowledge assets, refer to the Decision Support Service specification. Note
   * that a version is required for non-experimental active artifacts.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the evidence variable
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the evidence variable author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence. To provide a version consistent
   * with the Decision Support Service specification, use the format
   * Major.Minor.Revision (e.g. 1.0.0). For more information on versioning
   * knowledge assets, refer to the Decision Support Service specification. Note
   * that a version is required for non-experimental active artifacts.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the evidence variable. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the evidence variable. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the evidence variable. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the evidence variable. */
  title?: Maybe<Scalars['String']>;
  /**
   * The short title provides an alternate title for use in informal descriptive
   * contexts where the full, formal title is not necessary.
   */
  _shortTitle?: Maybe<Element>;
  /**
   * The short title provides an alternate title for use in informal descriptive
   * contexts where the full, formal title is not necessary.
   */
  shortTitle?: Maybe<Scalars['String']>;
  /** An explanatory or alternate title for the EvidenceVariable giving additional information about its content. */
  _subtitle?: Maybe<Element>;
  /** An explanatory or alternate title for the EvidenceVariable giving additional information about its content. */
  subtitle?: Maybe<Scalars['String']>;
  /** The status of this evidence variable. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this evidence variable. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * The date  (and optionally time) when the evidence variable was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the evidence variable changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the evidence variable was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the evidence variable changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the evidence variable. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the evidence variable. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the evidence variable from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the evidence variable from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate evidence
   * variable instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the evidence variable is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * A copyright statement relating to the evidence variable and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the evidence variable.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the evidence variable and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the evidence variable.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the evidence variable content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the content of the EvidenceVariable. Topics
   * provide a high-level categorization grouping types of EvidenceVariables that
   * can be useful for filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related artifacts such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** The type of evidence element, a population, an exposure, or an outcome. */
  _type?: Maybe<Element>;
  /** The type of evidence element, a population, an exposure, or an outcome. */
  type?: Maybe<Scalars['code']>;
  /**
   * A characteristic that defines the members of the evidence element. Multiple
   * characteristics are applied with 'and' semantics.
   */
  characteristic?: Maybe<Array<EvidenceVariablecharacteristic>>;
};

export enum EvidenceVariable_Enum_Schema {
  EvidenceVariable = 'EvidenceVariable'
}

export type EvidenceVariablecharacteristic = {
  __typename?: 'EvidenceVariablecharacteristic';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A short, natural language description of the characteristic that could be used to communicate the criteria to an end-user. */
  _description?: Maybe<Element>;
  /** A short, natural language description of the characteristic that could be used to communicate the criteria to an end-user. */
  description?: Maybe<Scalars['String']>;
  /**
   * Define members of the evidence element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  definitionReference: EvidenceVariablecharacteristicdefinitionReference_DefinitionReference_Union;
  /**
   * Define members of the evidence element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  _definitionCanonical?: Maybe<Element>;
  /**
   * Define members of the evidence element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  definitionCanonical: Scalars['canonical'];
  /**
   * Define members of the evidence element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  definitionCodeableConcept: CodeableConcept;
  /**
   * Define members of the evidence element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  definitionExpression: Expression;
  /**
   * Define members of the evidence element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  definitionDataRequirement: DataRequirement;
  /**
   * Define members of the evidence element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  definitionTriggerDefinition: TriggerDefinition;
  /** Use UsageContext to define the members of the population, such as Age Ranges, Genders, Settings. */
  usageContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** When true, members with this characteristic are excluded from the element. */
  _exclude?: Maybe<Element>;
  /** When true, members with this characteristic are excluded from the element. */
  exclude?: Maybe<Scalars['Boolean']>;
  /** Indicates what effective period the study covers. */
  _participantEffectiveDateTime?: Maybe<Element>;
  /** Indicates what effective period the study covers. */
  participantEffectiveDateTime?: Maybe<Scalars['dateTime']>;
  /** Indicates what effective period the study covers. */
  participantEffectivePeriod?: Maybe<Period>;
  /** Indicates what effective period the study covers. */
  participantEffectiveDuration?: Maybe<Duration>;
  /** Indicates what effective period the study covers. */
  participantEffectiveTiming?: Maybe<Timing>;
  /** Indicates duration from the participant's study entry. */
  timeFromStart?: Maybe<Duration>;
  /** Indicates how elements are aggregated within the study effective period. */
  _groupMeasure?: Maybe<Element>;
  /** Indicates how elements are aggregated within the study effective period. */
  groupMeasure?: Maybe<Scalars['code']>;
};

/**
 * Define members of the evidence element using Codes (such as condition,
 * medication, or observation), Expressions ( using an expression language such as
 * FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in the last year).
 */
export type EvidenceVariablecharacteristicdefinitionReference_DefinitionReference_Union = Group | ActivityDefinition;

export enum Evidence_Enum_Schema {
  Evidence = 'Evidence'
}

/** A reference to a EvidenceVariable resource that defines the population for the research. */
export type EvidenceexposureBackground_ExposureBackground_Union = EvidenceVariable;

/** A reference to a EvidenceVariable resource that defines the exposure for the research. */
export type EvidenceexposureVariant_ExposureVariant_Union = EvidenceVariable;

/** A reference to a EvidenceVariable resomece that defines the outcome for the research. */
export type Evidenceoutcome_Outcome_Union = EvidenceVariable;

/** Example of workflow instance. */
export type ExampleScenario = {
  __typename?: 'ExampleScenario';
  /** Type of resource */
  resourceType: ExampleScenario_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this example scenario when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this example scenario
   * is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the example scenario is stored on
   * different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this example scenario when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this example scenario
   * is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the example scenario is stored on
   * different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this example scenario when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the example scenario
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the example scenario author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the example scenario
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the example scenario author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the example scenario. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the example scenario. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** The status of this example scenario. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this example scenario. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this example scenario is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this example scenario is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the example scenario was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the example scenario changes. (e.g. the 'content logical definition').
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the example scenario was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the example scenario changes. (e.g. the 'content logical definition').
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the example scenario. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the example scenario. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate example
   * scenario instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the example scenario is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * A copyright statement relating to the example scenario and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the example scenario.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the example scenario and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the example scenario.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * What the example scenario resource is created for. This should not be used to
   * show the business purpose of the scenario itself, but the purpose of
   * documenting a scenario.
   */
  _purpose?: Maybe<Element>;
  /**
   * What the example scenario resource is created for. This should not be used to
   * show the business purpose of the scenario itself, but the purpose of
   * documenting a scenario.
   */
  purpose?: Maybe<Scalars['String']>;
  /** Actor participating in the resource. */
  actor?: Maybe<Array<Maybe<ExampleScenarioactor>>>;
  /** Each resource and each version that is present in the workflow. */
  instance?: Maybe<Array<Maybe<ExampleScenarioinstance>>>;
  /** Each major process - a group of operations. */
  process?: Maybe<Array<Maybe<ExampleScenarioprocess>>>;
  /** Another nested workflow. */
  _workflow?: Maybe<Element>;
  /** Another nested workflow. */
  workflow?: Maybe<Array<Maybe<Scalars['canonical']>>>;
};

export enum ExampleScenario_Enum_Schema {
  ExampleScenario = 'ExampleScenario'
}

export type ExampleScenarioactor = {
  __typename?: 'ExampleScenarioactor';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** ID or acronym of actor. */
  _actorId?: Maybe<Element>;
  /** ID or acronym of actor. */
  actorId: Scalars['String'];
  /** The type of actor - person or system. */
  _type?: Maybe<Element>;
  /** The type of actor - person or system. */
  type: Scalars['code'];
  /** The name of the actor as shown in the page. */
  _name?: Maybe<Element>;
  /** The name of the actor as shown in the page. */
  name?: Maybe<Scalars['String']>;
  /** The description of the actor. */
  _description?: Maybe<Element>;
  /** The description of the actor. */
  description?: Maybe<Scalars['String']>;
};

export type ExampleScenarioinstance = {
  __typename?: 'ExampleScenarioinstance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The id of the resource for referencing. */
  _resourceId?: Maybe<Element>;
  /** The id of the resource for referencing. */
  resourceId: Scalars['String'];
  /** The type of the resource. */
  _resourceType?: Maybe<Element>;
  /** The type of the resource. */
  resourceType: Scalars['code'];
  /** A short name for the resource instance. */
  _name?: Maybe<Element>;
  /** A short name for the resource instance. */
  name?: Maybe<Scalars['String']>;
  /** Human-friendly description of the resource instance. */
  _description?: Maybe<Element>;
  /** Human-friendly description of the resource instance. */
  description?: Maybe<Scalars['String']>;
  /** A specific version of the resource. */
  version?: Maybe<Array<Maybe<ExampleScenarioinstanceversion>>>;
  /** Resources contained in the instance (e.g. the observations contained in a bundle). */
  containedInstance?: Maybe<Array<Maybe<ExampleScenarioinstancecontainedInstance>>>;
};

export type ExampleScenarioinstancecontainedInstance = {
  __typename?: 'ExampleScenarioinstancecontainedInstance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Each resource contained in the instance. */
  _resourceId?: Maybe<Element>;
  /** Each resource contained in the instance. */
  resourceId: Scalars['String'];
  /** A specific version of a resource contained in the instance. */
  _versionId?: Maybe<Element>;
  /** A specific version of a resource contained in the instance. */
  versionId?: Maybe<Scalars['String']>;
};

export type ExampleScenarioinstanceversion = {
  __typename?: 'ExampleScenarioinstanceversion';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The identifier of a specific version of a resource. */
  _versionId?: Maybe<Element>;
  /** The identifier of a specific version of a resource. */
  versionId: Scalars['String'];
  /** The description of the resource version. */
  _description?: Maybe<Element>;
  /** The description of the resource version. */
  description: Scalars['String'];
};

export type ExampleScenarioprocess = {
  __typename?: 'ExampleScenarioprocess';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The diagram title of the group of operations. */
  _title?: Maybe<Element>;
  /** The diagram title of the group of operations. */
  title: Scalars['String'];
  /** A longer description of the group of operations. */
  _description?: Maybe<Element>;
  /** A longer description of the group of operations. */
  description?: Maybe<Scalars['String']>;
  /** Description of initial status before the process starts. */
  _preConditions?: Maybe<Element>;
  /** Description of initial status before the process starts. */
  preConditions?: Maybe<Scalars['String']>;
  /** Description of final status after the process ends. */
  _postConditions?: Maybe<Element>;
  /** Description of final status after the process ends. */
  postConditions?: Maybe<Scalars['String']>;
  /** Each step of the process. */
  step?: Maybe<Array<Maybe<ExampleScenarioprocessstep>>>;
};

export type ExampleScenarioprocessstep = {
  __typename?: 'ExampleScenarioprocessstep';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** If there is a pause in the flow. */
  _pause?: Maybe<Element>;
  /** If there is a pause in the flow. */
  pause?: Maybe<Scalars['Boolean']>;
  /** Each interaction or action. */
  operation?: Maybe<ExampleScenarioprocessstepoperation>;
  /**
   * Indicates an alternative step that can be taken instead of the operations on
   * the base step in exceptional/atypical circumstances.
   */
  alternative?: Maybe<Array<Maybe<ExampleScenarioprocessstepalternative>>>;
};

export type ExampleScenarioprocessstepalternative = {
  __typename?: 'ExampleScenarioprocessstepalternative';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The label to display for the alternative that gives a sense of the
   * circumstance in which the alternative should be invoked.
   */
  _title?: Maybe<Element>;
  /**
   * The label to display for the alternative that gives a sense of the
   * circumstance in which the alternative should be invoked.
   */
  title: Scalars['String'];
  /** A human-readable description of the alternative explaining when the alternative should occur rather than the base step. */
  _description?: Maybe<Element>;
  /** A human-readable description of the alternative explaining when the alternative should occur rather than the base step. */
  description?: Maybe<Scalars['String']>;
};

export type ExampleScenarioprocessstepoperation = {
  __typename?: 'ExampleScenarioprocessstepoperation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The sequential number of the interaction, e.g. 1.2.5. */
  _number?: Maybe<Element>;
  /** The sequential number of the interaction, e.g. 1.2.5. */
  number: Scalars['String'];
  /** The type of operation - CRUD. */
  _type?: Maybe<Element>;
  /** The type of operation - CRUD. */
  type?: Maybe<Scalars['String']>;
  /** The human-friendly name of the interaction. */
  _name?: Maybe<Element>;
  /** The human-friendly name of the interaction. */
  name?: Maybe<Scalars['String']>;
  /** Who starts the transaction. */
  _initiator?: Maybe<Element>;
  /** Who starts the transaction. */
  initiator?: Maybe<Scalars['String']>;
  /** Who receives the transaction. */
  _receiver?: Maybe<Element>;
  /** Who receives the transaction. */
  receiver?: Maybe<Scalars['String']>;
  /** A comment to be inserted in the diagram. */
  _description?: Maybe<Element>;
  /** A comment to be inserted in the diagram. */
  description?: Maybe<Scalars['String']>;
  /** Whether the initiator is deactivated right after the transaction. */
  _initiatorActive?: Maybe<Element>;
  /** Whether the initiator is deactivated right after the transaction. */
  initiatorActive?: Maybe<Scalars['Boolean']>;
  /** Whether the receiver is deactivated right after the transaction. */
  _receiverActive?: Maybe<Element>;
  /** Whether the receiver is deactivated right after the transaction. */
  receiverActive?: Maybe<Scalars['Boolean']>;
};

/**
 * This resource provides: the claim details; adjudication details from the
 * processing of a Claim; and optionally account balance information, for informing
 * the subscriber of the benefits provided.
 */
export type ExplanationOfBenefit = {
  __typename?: 'ExplanationOfBenefit';
  /** Type of resource */
  resourceType: ExplanationOfBenefit_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this explanation of benefit. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status: Scalars['code'];
  /** The category of claim, e.g. oral, pharmacy, vision, institutional, professional. */
  type: CodeableConcept;
  /**
   * A finer grained suite of claim type codes which may convey additional
   * information such as Inpatient vs Outpatient and/or a specialty service.
   */
  subType?: Maybe<CodeableConcept>;
  /**
   * A code to indicate whether the nature of the request is: to request
   * adjudication of products and services previously rendered; or requesting
   * authorization and adjudication for provision in the future; or requesting the
   * non-binding adjudication of the listed products and services which could be
   * provided in the future.
   */
  _use?: Maybe<Element>;
  /**
   * A code to indicate whether the nature of the request is: to request
   * adjudication of products and services previously rendered; or requesting
   * authorization and adjudication for provision in the future; or requesting the
   * non-binding adjudication of the listed products and services which could be
   * provided in the future.
   */
  use: Scalars['code'];
  /**
   * The party to whom the professional services and/or products have been supplied
   * or are being considered and for whom actual for forecast reimbursement is sought.
   */
  patient: ExplanationOfBenefitpatient_Patient_Union;
  /** The period for which charges are being submitted. */
  billablePeriod?: Maybe<Period>;
  /** The date this resource was created. */
  _created?: Maybe<Element>;
  /** The date this resource was created. */
  created: Scalars['dateTime'];
  /** Individual who created the claim, predetermination or preauthorization. */
  enterer?: Maybe<ExplanationOfBenefitenterer_Enterer_Union>;
  /** The party responsible for authorization, adjudication and reimbursement. */
  insurer: ExplanationOfBenefitinsurer_Insurer_Union;
  /** The provider which is responsible for the claim, predetermination or preauthorization. */
  provider: ExplanationOfBenefitprovider_Provider_Union;
  /** The provider-required urgency of processing the request. Typical values include: stat, routine deferred. */
  priority?: Maybe<CodeableConcept>;
  /** A code to indicate whether and for whom funds are to be reserved for future claims. */
  fundsReserveRequested?: Maybe<CodeableConcept>;
  /**
   * A code, used only on a response to a preauthorization, to indicate whether the
   * benefits payable have been reserved and for whom.
   */
  fundsReserve?: Maybe<CodeableConcept>;
  /**
   * Other claims which are related to this claim such as prior submissions or
   * claims for related services or for the same event.
   */
  related?: Maybe<Array<Maybe<ExplanationOfBenefitrelated>>>;
  /** Prescription to support the dispensing of pharmacy, device or vision products. */
  prescription?: Maybe<ExplanationOfBenefitprescription_Prescription_Union>;
  /**
   * Original prescription which has been superseded by this prescription to
   * support the dispensing of pharmacy services, medications or products.
   */
  originalPrescription?: Maybe<ExplanationOfBenefitoriginalPrescription_OriginalPrescription_Union>;
  /** The party to be reimbursed for cost of the products and services according to the terms of the policy. */
  payee?: Maybe<ExplanationOfBenefitpayee>;
  /** A reference to a referral resource. */
  referral?: Maybe<ExplanationOfBenefitreferral_Referral_Union>;
  /** Facility where the services were provided. */
  facility?: Maybe<ExplanationOfBenefitfacility_Facility_Union>;
  /** The business identifier for the instance of the adjudication request: claim predetermination or preauthorization. */
  claim?: Maybe<ExplanationOfBenefitclaim_Claim_Union>;
  /**
   * The business identifier for the instance of the adjudication response: claim,
   * predetermination or preauthorization response.
   */
  claimResponse?: Maybe<ExplanationOfBenefitclaimResponse_ClaimResponse_Union>;
  /** The outcome of the claim, predetermination, or preauthorization processing. */
  _outcome?: Maybe<Element>;
  /** The outcome of the claim, predetermination, or preauthorization processing. */
  outcome: Scalars['code'];
  /** A human readable description of the status of the adjudication. */
  _disposition?: Maybe<Element>;
  /** A human readable description of the status of the adjudication. */
  disposition?: Maybe<Scalars['String']>;
  /** Reference from the Insurer which is used in later communications which refers to this adjudication. */
  _preAuthRef?: Maybe<Element>;
  /** Reference from the Insurer which is used in later communications which refers to this adjudication. */
  preAuthRef?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The timeframe during which the supplied preauthorization reference may be
   * quoted on claims to obtain the adjudication as provided.
   */
  preAuthRefPeriod?: Maybe<Array<Maybe<Period>>>;
  /** The members of the team who provided the products and services. */
  careTeam?: Maybe<Array<Maybe<ExplanationOfBenefitcareTeam>>>;
  /**
   * Additional information codes regarding exceptions, special considerations, the
   * condition, situation, prior or concurrent issues.
   */
  supportingInfo?: Maybe<Array<Maybe<ExplanationOfBenefitsupportingInfo>>>;
  /** Information about diagnoses relevant to the claim items. */
  diagnosis?: Maybe<Array<Maybe<ExplanationOfBenefitdiagnosis>>>;
  /** Procedures performed on the patient relevant to the billing items with the claim. */
  procedure?: Maybe<Array<Maybe<ExplanationOfBenefitprocedure>>>;
  /** This indicates the relative order of a series of EOBs related to different coverages for the same suite of services. */
  _precedence?: Maybe<Element>;
  /** This indicates the relative order of a series of EOBs related to different coverages for the same suite of services. */
  precedence?: Maybe<Scalars['positiveInt']>;
  /** Financial instruments for reimbursement for the health care products and services specified on the claim. */
  insurance?: Maybe<Array<ExplanationOfBenefitinsurance>>;
  /** Details of a accident which resulted in injuries which required the products and services listed in the claim. */
  accident?: Maybe<ExplanationOfBenefitaccident>;
  /**
   * A claim line. Either a simple (a product or service) or a 'group' of details
   * which can also be a simple items or groups of sub-details.
   */
  item?: Maybe<Array<Maybe<ExplanationOfBenefititem>>>;
  /** The first-tier service adjudications for payor added product or service lines. */
  addItem?: Maybe<Array<Maybe<ExplanationOfBenefitaddItem>>>;
  /** Categorized monetary totals for the adjudication. */
  total?: Maybe<Array<Maybe<ExplanationOfBenefittotal>>>;
  /** Payment details for the adjudication of the claim. */
  payment?: Maybe<ExplanationOfBenefitpayment>;
  /** A code for the form to be used for printing the content. */
  formCode?: Maybe<CodeableConcept>;
  /** The actual form, by reference or inclusion, for printing the content or an EOB. */
  form?: Maybe<Attachment>;
  /** A note that describes or explains adjudication results in a human readable form. */
  processNote?: Maybe<Array<Maybe<ExplanationOfBenefitprocessNote>>>;
  /** The term of the benefits documented in this response. */
  benefitPeriod?: Maybe<Period>;
  /** Balance by Benefit Category. */
  benefitBalance?: Maybe<Array<Maybe<ExplanationOfBenefitbenefitBalance>>>;
};

export enum ExplanationOfBenefit_Enum_Schema {
  ExplanationOfBenefit = 'ExplanationOfBenefit'
}

export type ExplanationOfBenefitaccident = {
  __typename?: 'ExplanationOfBenefitaccident';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Date of an accident event  related to the products and services contained in the claim. */
  _date?: Maybe<Element>;
  /** Date of an accident event  related to the products and services contained in the claim. */
  date?: Maybe<Scalars['date']>;
  /**
   * The type or context of the accident event for the purposes of selection of
   * potential insurance coverages and determination of coordination between insurers.
   */
  type?: Maybe<CodeableConcept>;
  /** The physical location of the accident event. */
  locationAddress?: Maybe<Address>;
  /** The physical location of the accident event. */
  locationReference?: Maybe<ExplanationOfBenefitaccidentlocationReference_LocationReference_Union>;
};

/** The physical location of the accident event. */
export type ExplanationOfBenefitaccidentlocationReference_LocationReference_Union = Location;

export type ExplanationOfBenefitaddItem = {
  __typename?: 'ExplanationOfBenefitaddItem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Claim items which this service line is intended to replace. */
  _itemSequence?: Maybe<Element>;
  /** Claim items which this service line is intended to replace. */
  itemSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The sequence number of the details within the claim item which this line is intended to replace. */
  _detailSequence?: Maybe<Element>;
  /** The sequence number of the details within the claim item which this line is intended to replace. */
  detailSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The sequence number of the sub-details woithin the details within the claim item which this line is intended to replace. */
  _subDetailSequence?: Maybe<Element>;
  /** The sequence number of the sub-details woithin the details within the claim item which this line is intended to replace. */
  subDetailSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The providers who are authorized for the services rendered to the patient. */
  provider?: Maybe<Array<Maybe<ExplanationOfBenefitaddItemprovider_Provider_Union>>>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Identifies the program under which this may be recovered. */
  programCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  _servicedDate?: Maybe<Element>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  servicedDate?: Maybe<Scalars['date']>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  servicedPeriod?: Maybe<Period>;
  /** Where the product or service was provided. */
  locationCodeableConcept?: Maybe<CodeableConcept>;
  /** Where the product or service was provided. */
  locationAddress?: Maybe<Address>;
  /** Where the product or service was provided. */
  locationReference?: Maybe<ExplanationOfBenefitaddItemlocationReference_LocationReference_Union>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** Physical service site on the patient (limb, tooth, etc.). */
  bodySite?: Maybe<CodeableConcept>;
  /** A region or surface of the bodySite, e.g. limb region or tooth surface(s). */
  subSite?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The second-tier service adjudications for payor added services. */
  detail?: Maybe<Array<Maybe<ExplanationOfBenefitaddItemdetail>>>;
};

export type ExplanationOfBenefitaddItemdetail = {
  __typename?: 'ExplanationOfBenefitaddItemdetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The third-tier service adjudications for payor added services. */
  subDetail?: Maybe<Array<Maybe<ExplanationOfBenefitaddItemdetailsubDetail>>>;
};

export type ExplanationOfBenefitaddItemdetailsubDetail = {
  __typename?: 'ExplanationOfBenefitaddItemdetailsubDetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
};

/** Where the product or service was provided. */
export type ExplanationOfBenefitaddItemlocationReference_LocationReference_Union = Location;

/** The providers who are authorized for the services rendered to the patient. */
export type ExplanationOfBenefitaddItemprovider_Provider_Union = Practitioner | PractitionerRole | Organization;

export type ExplanationOfBenefitbenefitBalance = {
  __typename?: 'ExplanationOfBenefitbenefitBalance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Code to identify the general type of benefits under which products and services are provided. */
  category: CodeableConcept;
  /**
   * True if the indicated class of service is excluded from the plan, missing or
   * False indicates the product or service is included in the coverage.
   */
  _excluded?: Maybe<Element>;
  /**
   * True if the indicated class of service is excluded from the plan, missing or
   * False indicates the product or service is included in the coverage.
   */
  excluded?: Maybe<Scalars['Boolean']>;
  /** A short name or tag for the benefit. */
  _name?: Maybe<Element>;
  /** A short name or tag for the benefit. */
  name?: Maybe<Scalars['String']>;
  /** A richer description of the benefit or services covered. */
  _description?: Maybe<Element>;
  /** A richer description of the benefit or services covered. */
  description?: Maybe<Scalars['String']>;
  /** Is a flag to indicate whether the benefits refer to in-network providers or out-of-network providers. */
  network?: Maybe<CodeableConcept>;
  /** Indicates if the benefits apply to an individual or to the family. */
  unit?: Maybe<CodeableConcept>;
  /** The term or period of the values such as 'maximum lifetime benefit' or 'maximum annual visits'. */
  term?: Maybe<CodeableConcept>;
  /** Benefits Used to date. */
  financial?: Maybe<Array<Maybe<ExplanationOfBenefitbenefitBalancefinancial>>>;
};

export type ExplanationOfBenefitbenefitBalancefinancial = {
  __typename?: 'ExplanationOfBenefitbenefitBalancefinancial';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Classification of benefit being provided. */
  type: CodeableConcept;
  /** The quantity of the benefit which is permitted under the coverage. */
  _allowedUnsignedInt?: Maybe<Element>;
  /** The quantity of the benefit which is permitted under the coverage. */
  allowedUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /** The quantity of the benefit which is permitted under the coverage. */
  _allowedString?: Maybe<Element>;
  /** The quantity of the benefit which is permitted under the coverage. */
  allowedString?: Maybe<Scalars['String']>;
  /** The quantity of the benefit which is permitted under the coverage. */
  allowedMoney?: Maybe<Money>;
  /** The quantity of the benefit which have been consumed to date. */
  _usedUnsignedInt?: Maybe<Element>;
  /** The quantity of the benefit which have been consumed to date. */
  usedUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /** The quantity of the benefit which have been consumed to date. */
  usedMoney?: Maybe<Money>;
};

export type ExplanationOfBenefitcareTeam = {
  __typename?: 'ExplanationOfBenefitcareTeam';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify care team entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify care team entries. */
  sequence: Scalars['positiveInt'];
  /** Member of the team who provided the product or service. */
  provider: ExplanationOfBenefitcareTeamprovider_Provider_Union;
  /** The party who is billing and/or responsible for the claimed products or services. */
  _responsible?: Maybe<Element>;
  /** The party who is billing and/or responsible for the claimed products or services. */
  responsible?: Maybe<Scalars['Boolean']>;
  /** The lead, assisting or supervising practitioner and their discipline if a multidisciplinary team. */
  role?: Maybe<CodeableConcept>;
  /** The qualification of the practitioner which is applicable for this service. */
  qualification?: Maybe<CodeableConcept>;
};

/** Member of the team who provided the product or service. */
export type ExplanationOfBenefitcareTeamprovider_Provider_Union = Practitioner | PractitionerRole | Organization;

/** The business identifier for the instance of the adjudication response: claim, predetermination or preauthorization response. */
export type ExplanationOfBenefitclaimResponse_ClaimResponse_Union = ClaimResponse;

/** The business identifier for the instance of the adjudication request: claim predetermination or preauthorization. */
export type ExplanationOfBenefitclaim_Claim_Union = Claim;

export type ExplanationOfBenefitdiagnosis = {
  __typename?: 'ExplanationOfBenefitdiagnosis';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify diagnosis entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify diagnosis entries. */
  sequence: Scalars['positiveInt'];
  /** The nature of illness or problem in a coded form or as a reference to an external defined Condition. */
  diagnosisCodeableConcept: CodeableConcept;
  /** The nature of illness or problem in a coded form or as a reference to an external defined Condition. */
  diagnosisReference: ExplanationOfBenefitdiagnosisdiagnosisReference_DiagnosisReference_Union;
  /** When the condition was observed or the relative ranking. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indication of whether the diagnosis was present on admission to a facility. */
  onAdmission?: Maybe<CodeableConcept>;
  /**
   * A package billing code or bundle code used to group products and services to a
   * particular health condition (such as heart attack) which is based on a
   * predetermined grouping code system.
   */
  packageCode?: Maybe<CodeableConcept>;
};

/** The nature of illness or problem in a coded form or as a reference to an external defined Condition. */
export type ExplanationOfBenefitdiagnosisdiagnosisReference_DiagnosisReference_Union = Condition;

/** Individual who created the claim, predetermination or preauthorization. */
export type ExplanationOfBenefitenterer_Enterer_Union = Practitioner | PractitionerRole;

/** Facility where the services were provided. */
export type ExplanationOfBenefitfacility_Facility_Union = Location;

export type ExplanationOfBenefitinsurance = {
  __typename?: 'ExplanationOfBenefitinsurance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A flag to indicate that this Coverage is to be used for adjudication of this claim when set to true. */
  _focal?: Maybe<Element>;
  /** A flag to indicate that this Coverage is to be used for adjudication of this claim when set to true. */
  focal: Scalars['Boolean'];
  /**
   * Reference to the insurance card level information contained in the Coverage
   * resource. The coverage issuing insurer will use these details to locate the
   * patient's actual coverage within the insurer's information system.
   */
  coverage: ExplanationOfBenefitinsurancecoverage_Coverage_Union;
  /**
   * Reference numbers previously provided by the insurer to the provider to be
   * quoted on subsequent claims containing services or products related to the
   * prior authorization.
   */
  _preAuthRef?: Maybe<Element>;
  /**
   * Reference numbers previously provided by the insurer to the provider to be
   * quoted on subsequent claims containing services or products related to the
   * prior authorization.
   */
  preAuthRef?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * Reference to the insurance card level information contained in the Coverage
 * resource. The coverage issuing insurer will use these details to locate the
 * patient's actual coverage within the insurer's information system.
 */
export type ExplanationOfBenefitinsurancecoverage_Coverage_Union = Coverage;

/** The party responsible for authorization, adjudication and reimbursement. */
export type ExplanationOfBenefitinsurer_Insurer_Union = Organization;

export type ExplanationOfBenefititem = {
  __typename?: 'ExplanationOfBenefititem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify item entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify item entries. */
  sequence: Scalars['positiveInt'];
  /** Care team members related to this service or product. */
  _careTeamSequence?: Maybe<Element>;
  /** Care team members related to this service or product. */
  careTeamSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** Diagnoses applicable for this service or product. */
  _diagnosisSequence?: Maybe<Element>;
  /** Diagnoses applicable for this service or product. */
  diagnosisSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** Procedures applicable for this service or product. */
  _procedureSequence?: Maybe<Element>;
  /** Procedures applicable for this service or product. */
  procedureSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** Exceptions, special conditions and supporting information applicable for this service or product. */
  _informationSequence?: Maybe<Element>;
  /** Exceptions, special conditions and supporting information applicable for this service or product. */
  informationSequence?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** The type of revenue or cost center providing the product and/or service. */
  revenue?: Maybe<CodeableConcept>;
  /** Code to identify the general type of benefits under which products and services are provided. */
  category?: Maybe<CodeableConcept>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Identifies the program under which this may be recovered. */
  programCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  _servicedDate?: Maybe<Element>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  servicedDate?: Maybe<Scalars['date']>;
  /** The date or dates when the service or product was supplied, performed or completed. */
  servicedPeriod?: Maybe<Period>;
  /** Where the product or service was provided. */
  locationCodeableConcept?: Maybe<CodeableConcept>;
  /** Where the product or service was provided. */
  locationAddress?: Maybe<Address>;
  /** Where the product or service was provided. */
  locationReference?: Maybe<ExplanationOfBenefititemlocationReference_LocationReference_Union>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** Unique Device Identifiers associated with this line item. */
  udi?: Maybe<Array<Maybe<ExplanationOfBenefititemudi_Udi_Union>>>;
  /** Physical service site on the patient (limb, tooth, etc.). */
  bodySite?: Maybe<CodeableConcept>;
  /** A region or surface of the bodySite, e.g. limb region or tooth surface(s). */
  subSite?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A billed item may include goods or services provided in multiple encounters. */
  encounter?: Maybe<Array<Maybe<ExplanationOfBenefititemencounter_Encounter_Union>>>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /**
   * If this item is a group then the values here are a summary of the adjudication
   * of the detail items. If this item is a simple product or service then this is
   * the result of the adjudication of this item.
   */
  adjudication?: Maybe<Array<Maybe<ExplanationOfBenefititemadjudication>>>;
  /** Second-tier of goods and services. */
  detail?: Maybe<Array<Maybe<ExplanationOfBenefititemdetail>>>;
};

export type ExplanationOfBenefititemadjudication = {
  __typename?: 'ExplanationOfBenefititemadjudication';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A code to indicate the information type of this adjudication record.
   * Information types may include: the value submitted, maximum values or
   * percentages allowed or payable under the plan, amounts that the patient is
   * responsible for in-aggregate or pertaining to this item, amounts paid by other
   * coverages, and the benefit payable for this item.
   */
  category: CodeableConcept;
  /** A code supporting the understanding of the adjudication result and explaining variance from expected amount. */
  reason?: Maybe<CodeableConcept>;
  /** Monetary amount associated with the category. */
  amount?: Maybe<Money>;
  /** A non-monetary value associated with the category. Mutually exclusive to the amount element above. */
  _value?: Maybe<Element>;
  /** A non-monetary value associated with the category. Mutually exclusive to the amount element above. */
  value?: Maybe<Scalars['Float']>;
};

export type ExplanationOfBenefititemdetail = {
  __typename?: 'ExplanationOfBenefititemdetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A claim detail line. Either a simple (a product or service) or a 'group' of sub-details which are simple items. */
  _sequence?: Maybe<Element>;
  /** A claim detail line. Either a simple (a product or service) or a 'group' of sub-details which are simple items. */
  sequence: Scalars['positiveInt'];
  /** The type of revenue or cost center providing the product and/or service. */
  revenue?: Maybe<CodeableConcept>;
  /** Code to identify the general type of benefits under which products and services are provided. */
  category?: Maybe<CodeableConcept>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Identifies the program under which this may be recovered. */
  programCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** Unique Device Identifiers associated with this line item. */
  udi?: Maybe<Array<Maybe<ExplanationOfBenefititemdetailudi_Udi_Union>>>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
  /** Third-tier of goods and services. */
  subDetail?: Maybe<Array<Maybe<ExplanationOfBenefititemdetailsubDetail>>>;
};

export type ExplanationOfBenefititemdetailsubDetail = {
  __typename?: 'ExplanationOfBenefititemdetailsubDetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A claim detail line. Either a simple (a product or service) or a 'group' of sub-details which are simple items. */
  _sequence?: Maybe<Element>;
  /** A claim detail line. Either a simple (a product or service) or a 'group' of sub-details which are simple items. */
  sequence: Scalars['positiveInt'];
  /** The type of revenue or cost center providing the product and/or service. */
  revenue?: Maybe<CodeableConcept>;
  /** Code to identify the general type of benefits under which products and services are provided. */
  category?: Maybe<CodeableConcept>;
  /**
   * When the value is a group code then this item collects a set of related claim
   * details, otherwise this contains the product, service, drug or other billing
   * code for the item.
   */
  productOrService: CodeableConcept;
  /** Item typification or modifiers codes to convey additional context for the product or service. */
  modifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Identifies the program under which this may be recovered. */
  programCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The number of repetitions of a service or product. */
  quantity?: Maybe<Quantity>;
  /**
   * If the item is not a group then this is the fee for the product or service,
   * otherwise this is the total of the fees for the details of the group.
   */
  unitPrice?: Maybe<Money>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  _factor?: Maybe<Element>;
  /**
   * A real number that represents a multiplier used in determining the overall
   * value of services delivered and/or goods received. The concept of a Factor
   * allows for a discount or surcharge multiplier to be applied to a monetary amount.
   */
  factor?: Maybe<Scalars['Float']>;
  /** The quantity times the unit price for an additional service or product or charge. */
  net?: Maybe<Money>;
  /** Unique Device Identifiers associated with this line item. */
  udi?: Maybe<Array<Maybe<ExplanationOfBenefititemdetailsubDetailudi_Udi_Union>>>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  _noteNumber?: Maybe<Element>;
  /** The numbers associated with notes below which apply to the adjudication of this item. */
  noteNumber?: Maybe<Array<Maybe<Scalars['positiveInt']>>>;
};

/** Unique Device Identifiers associated with this line item. */
export type ExplanationOfBenefititemdetailsubDetailudi_Udi_Union = Device;

/** Unique Device Identifiers associated with this line item. */
export type ExplanationOfBenefititemdetailudi_Udi_Union = Device;

/** A billed item may include goods or services provided in multiple encounters. */
export type ExplanationOfBenefititemencounter_Encounter_Union = Encounter;

/** Where the product or service was provided. */
export type ExplanationOfBenefititemlocationReference_LocationReference_Union = Location;

/** Unique Device Identifiers associated with this line item. */
export type ExplanationOfBenefititemudi_Udi_Union = Device;

/**
 * Original prescription which has been superseded by this prescription to support
 * the dispensing of pharmacy services, medications or products.
 */
export type ExplanationOfBenefitoriginalPrescription_OriginalPrescription_Union = MedicationRequest;

/**
 * The party to whom the professional services and/or products have been supplied
 * or are being considered and for whom actual for forecast reimbursement is sought.
 */
export type ExplanationOfBenefitpatient_Patient_Union = Patient;

export type ExplanationOfBenefitpayee = {
  __typename?: 'ExplanationOfBenefitpayee';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of Party to be reimbursed: Subscriber, provider, other. */
  type?: Maybe<CodeableConcept>;
  /** Reference to the individual or organization to whom any payment will be made. */
  party?: Maybe<ExplanationOfBenefitpayeeparty_Party_Union>;
};

/** Reference to the individual or organization to whom any payment will be made. */
export type ExplanationOfBenefitpayeeparty_Party_Union = Practitioner | PractitionerRole | Organization | Patient | RelatedPerson;

export type ExplanationOfBenefitpayment = {
  __typename?: 'ExplanationOfBenefitpayment';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Whether this represents partial or complete payment of the benefits payable. */
  type?: Maybe<CodeableConcept>;
  /**
   * Total amount of all adjustments to this payment included in this transaction
   * which are not related to this claim's adjudication.
   */
  adjustment?: Maybe<Money>;
  /** Reason for the payment adjustment. */
  adjustmentReason?: Maybe<CodeableConcept>;
  /** Estimated date the payment will be issued or the actual issue date of payment. */
  _date?: Maybe<Element>;
  /** Estimated date the payment will be issued or the actual issue date of payment. */
  date?: Maybe<Scalars['date']>;
  /** Benefits payable less any payment adjustment. */
  amount?: Maybe<Money>;
  /** Issuer's unique identifier for the payment instrument. */
  identifier?: Maybe<Identifier>;
};

/** Prescription to support the dispensing of pharmacy, device or vision products. */
export type ExplanationOfBenefitprescription_Prescription_Union = MedicationRequest | VisionPrescription;

export type ExplanationOfBenefitprocedure = {
  __typename?: 'ExplanationOfBenefitprocedure';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify procedure entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify procedure entries. */
  sequence: Scalars['positiveInt'];
  /** When the condition was observed or the relative ranking. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Date and optionally time the procedure was performed. */
  _date?: Maybe<Element>;
  /** Date and optionally time the procedure was performed. */
  date?: Maybe<Scalars['dateTime']>;
  /** The code or reference to a Procedure resource which identifies the clinical intervention performed. */
  procedureCodeableConcept: CodeableConcept;
  /** The code or reference to a Procedure resource which identifies the clinical intervention performed. */
  procedureReference: ExplanationOfBenefitprocedureprocedureReference_ProcedureReference_Union;
  /** Unique Device Identifiers associated with this line item. */
  udi?: Maybe<Array<Maybe<ExplanationOfBenefitprocedureudi_Udi_Union>>>;
};

/** The code or reference to a Procedure resource which identifies the clinical intervention performed. */
export type ExplanationOfBenefitprocedureprocedureReference_ProcedureReference_Union = Procedure;

/** Unique Device Identifiers associated with this line item. */
export type ExplanationOfBenefitprocedureudi_Udi_Union = Device;

export type ExplanationOfBenefitprocessNote = {
  __typename?: 'ExplanationOfBenefitprocessNote';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify a note entry. */
  _number?: Maybe<Element>;
  /** A number to uniquely identify a note entry. */
  number?: Maybe<Scalars['positiveInt']>;
  /** The business purpose of the note text. */
  _type?: Maybe<Element>;
  /** The business purpose of the note text. */
  type?: Maybe<Scalars['code']>;
  /** The explanation or description associated with the processing. */
  _text?: Maybe<Element>;
  /** The explanation or description associated with the processing. */
  text?: Maybe<Scalars['String']>;
  /** A code to define the language used in the text of the note. */
  language?: Maybe<CodeableConcept>;
};

/** The provider which is responsible for the claim, predetermination or preauthorization. */
export type ExplanationOfBenefitprovider_Provider_Union = Practitioner | PractitionerRole | Organization;

/** A reference to a referral resource. */
export type ExplanationOfBenefitreferral_Referral_Union = ServiceRequest;

export type ExplanationOfBenefitrelated = {
  __typename?: 'ExplanationOfBenefitrelated';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Reference to a related claim. */
  claim?: Maybe<ExplanationOfBenefitrelatedclaim_Claim_Union>;
  /** A code to convey how the claims are related. */
  relationship?: Maybe<CodeableConcept>;
  /** An alternate organizational reference to the case or file to which this particular claim pertains. */
  reference?: Maybe<Identifier>;
};

/** Reference to a related claim. */
export type ExplanationOfBenefitrelatedclaim_Claim_Union = Claim;

export type ExplanationOfBenefitsupportingInfo = {
  __typename?: 'ExplanationOfBenefitsupportingInfo';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number to uniquely identify supporting information entries. */
  _sequence?: Maybe<Element>;
  /** A number to uniquely identify supporting information entries. */
  sequence: Scalars['positiveInt'];
  /** The general class of the information supplied: information; exception; accident, employment; onset, etc. */
  category: CodeableConcept;
  /**
   * System and code pertaining to the specific information regarding special
   * conditions relating to the setting, treatment or patient  for which care is sought.
   */
  code?: Maybe<CodeableConcept>;
  /** The date when or period to which this information refers. */
  _timingDate?: Maybe<Element>;
  /** The date when or period to which this information refers. */
  timingDate?: Maybe<Scalars['date']>;
  /** The date when or period to which this information refers. */
  timingPeriod?: Maybe<Period>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  _valueBoolean?: Maybe<Element>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  _valueString?: Maybe<Element>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  valueString?: Maybe<Scalars['String']>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  valueQuantity?: Maybe<Quantity>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  valueAttachment?: Maybe<Attachment>;
  /**
   * Additional data or information such as resources, documents, images etc.
   * including references to the data or the actual inclusion of the data.
   */
  valueReference?: Maybe<ExplanationOfBenefitsupportingInfovalueReference_ValueReference_Union>;
  /** Provides the reason in the situation where a reason code is required in addition to the content. */
  reason?: Maybe<Coding>;
};

/**
 * Additional data or information such as resources, documents, images etc.
 * including references to the data or the actual inclusion of the data.
 */
export type ExplanationOfBenefitsupportingInfovalueReference_ValueReference_Union = Resource;

export type ExplanationOfBenefittotal = {
  __typename?: 'ExplanationOfBenefittotal';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A code to indicate the information type of this adjudication record.
   * Information types may include: the value submitted, maximum values or
   * percentages allowed or payable under the plan, amounts that the patient is
   * responsible for in aggregate or pertaining to this item, amounts paid by other
   * coverages, and the benefit payable for this item.
   */
  category: CodeableConcept;
  /** Monetary total amount associated with the category. */
  amount: Money;
};

/**
 * Base StructureDefinition for Expression Type: A expression that is evaluated in
 * a specified context and returns a value. The context of use of the expression
 * must specify the context in which the expression is evaluated, and how the
 * result of the expression is used.
 */
export type Expression = {
  __typename?: 'Expression';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** A brief, natural language description of the condition that effectively communicates the intended semantics. */
  _description?: Maybe<Element>;
  /** A brief, natural language description of the condition that effectively communicates the intended semantics. */
  description?: Maybe<Scalars['String']>;
  /** A short name assigned to the expression to allow for multiple reuse of the expression in the context where it is defined. */
  _name?: Maybe<Element>;
  /** A short name assigned to the expression to allow for multiple reuse of the expression in the context where it is defined. */
  name?: Maybe<Scalars['id']>;
  /** The media type of the language for the expression. */
  _language?: Maybe<Element>;
  /** The media type of the language for the expression. */
  language: Scalars['code'];
  /** An expression in the specified language that returns a value. */
  _expression?: Maybe<Element>;
  /** An expression in the specified language that returns a value. */
  expression?: Maybe<Scalars['String']>;
  /** A URI that defines where the expression is found. */
  _reference?: Maybe<Element>;
  /** A URI that defines where the expression is found. */
  reference?: Maybe<Scalars['uri']>;
};

/**
 * Base StructureDefinition for Expression Type: A expression that is evaluated in
 * a specified context and returns a value. The context of use of the expression
 * must specify the context in which the expression is evaluated, and how the
 * result of the expression is used.
 */
export type Expression_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A brief, natural language description of the condition that effectively communicates the intended semantics. */
  _description?: Maybe<Element_Input>;
  /** A brief, natural language description of the condition that effectively communicates the intended semantics. */
  description?: Maybe<Scalars['String']>;
  /** A short name assigned to the expression to allow for multiple reuse of the expression in the context where it is defined. */
  _name?: Maybe<Element_Input>;
  /** A short name assigned to the expression to allow for multiple reuse of the expression in the context where it is defined. */
  name?: Maybe<Scalars['id']>;
  /** The media type of the language for the expression. */
  _language?: Maybe<Element_Input>;
  /** The media type of the language for the expression. */
  language: Scalars['code'];
  /** An expression in the specified language that returns a value. */
  _expression?: Maybe<Element_Input>;
  /** An expression in the specified language that returns a value. */
  expression?: Maybe<Scalars['String']>;
  /** A URI that defines where the expression is found. */
  _reference?: Maybe<Element_Input>;
  /** A URI that defines where the expression is found. */
  reference?: Maybe<Scalars['uri']>;
};

/** Base StructureDefinition for Extension Type: Optional Extension Element - found in all resources. */
export type Extension = {
  __typename?: 'Extension';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** Source of the definition for the extension code - a logical name or a URL. */
  _url?: Maybe<Element>;
  /** Source of the definition for the extension code - a logical name or a URL. */
  url: Scalars['String'];
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueBase64Binary?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueBase64Binary?: Maybe<Scalars['base64Binary']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueBoolean?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueCanonical?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueCanonical?: Maybe<Scalars['canonical']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueCode?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueCode?: Maybe<Scalars['code']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueDate?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDate?: Maybe<Scalars['date']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueDateTime?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueDecimal?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDecimal?: Maybe<Scalars['Float']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueId?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueId?: Maybe<Scalars['id']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueInstant?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueInstant?: Maybe<Scalars['instant']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueInteger?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueInteger?: Maybe<Scalars['Int']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueMarkdown?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueMarkdown?: Maybe<Scalars['String']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueOid?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueOid?: Maybe<Scalars['oid']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valuePositiveInt?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valuePositiveInt?: Maybe<Scalars['positiveInt']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueString?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueString?: Maybe<Scalars['String']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueTime?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueTime?: Maybe<Scalars['time']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueUnsignedInt?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueUri?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueUri?: Maybe<Scalars['uri']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueUrl?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueUrl?: Maybe<Scalars['url']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueUuid?: Maybe<Element>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueUuid?: Maybe<Scalars['uuid']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueAddress?: Maybe<Address>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueAge?: Maybe<Age>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueAnnotation?: Maybe<Annotation>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueAttachment?: Maybe<Attachment>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueCoding?: Maybe<Coding>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueContactPoint?: Maybe<ContactPoint>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueCount?: Maybe<Count>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDistance?: Maybe<Distance>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDuration?: Maybe<Duration>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueHumanName?: Maybe<HumanName>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueIdentifier?: Maybe<Identifier>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueMoney?: Maybe<Money>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valuePeriod?: Maybe<Period>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueQuantity?: Maybe<Quantity>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueRange?: Maybe<Range>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueRatio?: Maybe<Ratio>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueReference?: Maybe<ResourceList>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueSampledData?: Maybe<SampledData>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueSignature?: Maybe<Signature>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueTiming?: Maybe<Timing>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueContactDetail?: Maybe<ContactDetail>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueContributor?: Maybe<Contributor>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDataRequirement?: Maybe<DataRequirement>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueExpression?: Maybe<Expression>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueUsageContext?: Maybe<UsageContext>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDosage?: Maybe<Dosage>;
};

/** Base StructureDefinition for Extension Type: Optional Extension Element - found in all resources. */
export type Extension_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Source of the definition for the extension code - a logical name or a URL. */
  _url?: Maybe<Element_Input>;
  /** Source of the definition for the extension code - a logical name or a URL. */
  url: Scalars['String'];
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueBase64Binary?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueBase64Binary?: Maybe<Scalars['base64Binary']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueBoolean?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueCanonical?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueCanonical?: Maybe<Scalars['canonical']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueCode?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueCode?: Maybe<Scalars['code']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueDate?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDate?: Maybe<Scalars['date']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueDateTime?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueDecimal?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDecimal?: Maybe<Scalars['Float']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueId?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueId?: Maybe<Scalars['id']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueInstant?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueInstant?: Maybe<Scalars['instant']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueInteger?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueInteger?: Maybe<Scalars['Int']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueMarkdown?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueMarkdown?: Maybe<Scalars['String']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueOid?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueOid?: Maybe<Scalars['oid']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valuePositiveInt?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valuePositiveInt?: Maybe<Scalars['positiveInt']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueString?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueString?: Maybe<Scalars['String']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueTime?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueTime?: Maybe<Scalars['time']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueUnsignedInt?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueUri?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueUri?: Maybe<Scalars['uri']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueUrl?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueUrl?: Maybe<Scalars['url']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  _valueUuid?: Maybe<Element_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueUuid?: Maybe<Scalars['uuid']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueAddress?: Maybe<Address_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueAge?: Maybe<Age_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueAnnotation?: Maybe<Annotation_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueAttachment?: Maybe<Attachment_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueCodeableConcept?: Maybe<CodeableConcept_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueCoding?: Maybe<Coding_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueContactPoint?: Maybe<ContactPoint_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueCount?: Maybe<Count_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDistance?: Maybe<Distance_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDuration?: Maybe<Duration_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueHumanName?: Maybe<HumanName_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueIdentifier?: Maybe<Identifier_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueMoney?: Maybe<Money_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valuePeriod?: Maybe<Period_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueQuantity?: Maybe<Quantity_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueRange?: Maybe<Range_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueRatio?: Maybe<Ratio_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueReference?: Maybe<Scalars['String']>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueSampledData?: Maybe<SampledData_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueSignature?: Maybe<Signature_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueTiming?: Maybe<Timing_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueContactDetail?: Maybe<ContactDetail_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueContributor?: Maybe<Contributor_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDataRequirement?: Maybe<DataRequirement_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueExpression?: Maybe<Expression_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueParameterDefinition?: Maybe<ParameterDefinition_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueRelatedArtifact?: Maybe<RelatedArtifact_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueTriggerDefinition?: Maybe<TriggerDefinition_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueUsageContext?: Maybe<UsageContext_Input>;
  /**
   * Value of extension - must be one of a constrained set of the data types (see
   * [Extensibility](extensibility.html) for a list).
   */
  valueDosage?: Maybe<Dosage_Input>;
};

export enum ExternalPatientQuestionnaire_Enum {
  ExternalPatientQuestionnaire = 'ExternalPatientQuestionnaire'
}

export enum ExternalPatientQuestionnaire_Enum_Input {
  ExternalPatientQuestionnaire = 'ExternalPatientQuestionnaire'
}

/** PatientQuestionnaire_Input */
export type ExternalPatientQuestionnaire_Input = {
  /** Type of resource */
  resourceType: ExternalPatientQuestionnaire_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** patientId */
  patientId?: Maybe<Scalars['String']>;
  /** patientId */
  patientName?: Maybe<Scalars['String']>;
  /** patientId */
  assignedId?: Maybe<Scalars['String']>;
  /** patientId */
  assignedName?: Maybe<Scalars['String']>;
  /** patientId */
  assignedSpeciality?: Maybe<Scalars['String']>;
  /** patientId */
  assignedType?: Maybe<Scalars['String']>;
  /** patientId */
  status?: Maybe<Scalars['String']>;
  /** createdOn. */
  assignedOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  completedOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  questitionerId?: Maybe<Scalars['String']>;
  /** Questitioner. */
  questionnaire?: Maybe<QuestionnaireBuilder_Input>;
  /** updatedOn. */
  operationType?: Maybe<Scalars['String']>;
  /** questionnaireName. */
  questionnaireName?: Maybe<Scalars['String']>;
  /** recipientName. */
  recipientName?: Maybe<Scalars['String']>;
  /** recipientName. */
  recipientEmail?: Maybe<Scalars['String']>;
  /** emailSubject. */
  emailSubject?: Maybe<Scalars['String']>;
  /** emailSubject. */
  emailBody?: Maybe<Scalars['String']>;
};

/** PatientQuestionnaire_Schema */
export type ExternalPatientQuestionnaire_Schema = {
  __typename?: 'ExternalPatientQuestionnaire_Schema';
  /** Type of resource */
  resourceType: ExternalPatientQuestionnaire_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** patientId */
  patientId?: Maybe<Scalars['String']>;
  /** patientId */
  patientName?: Maybe<Scalars['String']>;
  /** patientId */
  assignedId?: Maybe<Scalars['String']>;
  /** patientId */
  assignedName?: Maybe<Scalars['String']>;
  /** patientId */
  assignedSpeciality?: Maybe<Scalars['String']>;
  /** patientId */
  assignedType?: Maybe<Scalars['String']>;
  /** patientId */
  status?: Maybe<Scalars['String']>;
  /** createdOn. */
  assignedOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  completedOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  questitionerId?: Maybe<Scalars['String']>;
  /** Questitioner. */
  questionnaire?: Maybe<QuestionnaireBuilder>;
  /** updatedOn. */
  operationType?: Maybe<Scalars['String']>;
  /** questionnaireName. */
  questionnaireName?: Maybe<Scalars['String']>;
  /** recipientName. */
  recipientName?: Maybe<Scalars['String']>;
  /** recipientName. */
  recipientEmail?: Maybe<Scalars['String']>;
  /** emailSubject. */
  emailSubject?: Maybe<Scalars['String']>;
  /** emailSubject. */
  emailBody?: Maybe<Scalars['String']>;
};

/** Significant health conditions for a person related to the patient relevant in the context of care for the patient. */
export type FamilyMemberHistory = {
  __typename?: 'FamilyMemberHistory';
  /** Type of resource */
  resourceType: FamilyMemberHistory_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this family member history by the performer
   * or other systems which remain constant as the resource is updated and
   * propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this FamilyMemberHistory.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this FamilyMemberHistory.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this
   * FamilyMemberHistory.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this
   * FamilyMemberHistory.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** A code specifying the status of the record of the family history of a specific family member. */
  _status?: Maybe<Element>;
  /** A code specifying the status of the record of the family history of a specific family member. */
  status: Scalars['code'];
  /** Describes why the family member's history is not available. */
  dataAbsentReason?: Maybe<CodeableConcept>;
  /** The person who this history concerns. */
  patient: FamilyMemberHistorypatient_Patient_Union;
  /** The date (and possibly time) when the family member history was recorded or last updated. */
  _date?: Maybe<Element>;
  /** The date (and possibly time) when the family member history was recorded or last updated. */
  date?: Maybe<Scalars['dateTime']>;
  /** This will either be a name or a description; e.g. 'Aunt Susan', 'my cousin with the red hair'. */
  _name?: Maybe<Element>;
  /** This will either be a name or a description; e.g. 'Aunt Susan', 'my cousin with the red hair'. */
  name?: Maybe<Scalars['String']>;
  /** The type of relationship this person has to the patient (father, mother, brother etc.). */
  relationship: CodeableConcept;
  /** The birth sex of the family member. */
  sex?: Maybe<CodeableConcept>;
  /** The actual or approximate date of birth of the relative. */
  bornPeriod?: Maybe<Period>;
  /** The actual or approximate date of birth of the relative. */
  _bornDate?: Maybe<Element>;
  /** The actual or approximate date of birth of the relative. */
  bornDate?: Maybe<Scalars['date']>;
  /** The actual or approximate date of birth of the relative. */
  _bornString?: Maybe<Element>;
  /** The actual or approximate date of birth of the relative. */
  bornString?: Maybe<Scalars['String']>;
  /** The age of the relative at the time the family member history is recorded. */
  ageAge?: Maybe<Age>;
  /** The age of the relative at the time the family member history is recorded. */
  ageRange?: Maybe<Range>;
  /** The age of the relative at the time the family member history is recorded. */
  _ageString?: Maybe<Element>;
  /** The age of the relative at the time the family member history is recorded. */
  ageString?: Maybe<Scalars['String']>;
  /** If true, indicates that the age value specified is an estimated value. */
  _estimatedAge?: Maybe<Element>;
  /** If true, indicates that the age value specified is an estimated value. */
  estimatedAge?: Maybe<Scalars['Boolean']>;
  /** Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record. */
  _deceasedBoolean?: Maybe<Element>;
  /** Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record. */
  deceasedBoolean?: Maybe<Scalars['Boolean']>;
  /** Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record. */
  deceasedAge?: Maybe<Age>;
  /** Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record. */
  deceasedRange?: Maybe<Range>;
  /** Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record. */
  _deceasedDate?: Maybe<Element>;
  /** Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record. */
  deceasedDate?: Maybe<Scalars['date']>;
  /** Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record. */
  _deceasedString?: Maybe<Element>;
  /** Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record. */
  deceasedString?: Maybe<Scalars['String']>;
  /** Describes why the family member history occurred in coded or textual form. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Indicates a Condition, Observation, AllergyIntolerance, or
   * QuestionnaireResponse that justifies this family member history event.
   */
  reasonReference?: Maybe<Array<Maybe<FamilyMemberHistoryreasonReference_ReasonReference_Union>>>;
  /**
   * This property allows a non condition-specific note to the made about the
   * related person. Ideally, the note would be in the condition property, but this
   * is not always possible.
   */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * The significant Conditions (or condition) that the family member had. This is
   * a repeating section to allow a system to represent more than one condition per
   * resource, though there is nothing stopping multiple resources - one per condition.
   */
  condition?: Maybe<Array<Maybe<FamilyMemberHistorycondition>>>;
};

export enum FamilyMemberHistory_Enum_Schema {
  FamilyMemberHistory = 'FamilyMemberHistory'
}

export type FamilyMemberHistorycondition = {
  __typename?: 'FamilyMemberHistorycondition';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The actual condition specified. Could be a coded condition (like MI or
   * Diabetes) or a less specific string like 'cancer' depending on how much is
   * known about the condition and the capabilities of the creating system.
   */
  code: CodeableConcept;
  /**
   * Indicates what happened following the condition.  If the condition resulted in
   * death, deceased date is captured on the relation.
   */
  outcome?: Maybe<CodeableConcept>;
  /**
   * This condition contributed to the cause of death of the related person. If
   * contributedToDeath is not populated, then it is unknown.
   */
  _contributedToDeath?: Maybe<Element>;
  /**
   * This condition contributed to the cause of death of the related person. If
   * contributedToDeath is not populated, then it is unknown.
   */
  contributedToDeath?: Maybe<Scalars['Boolean']>;
  /**
   * Either the age of onset, range of approximate age or descriptive string can be
   * recorded.  For conditions with multiple occurrences, this describes the first
   * known occurrence.
   */
  onsetAge?: Maybe<Age>;
  /**
   * Either the age of onset, range of approximate age or descriptive string can be
   * recorded.  For conditions with multiple occurrences, this describes the first
   * known occurrence.
   */
  onsetRange?: Maybe<Range>;
  /**
   * Either the age of onset, range of approximate age or descriptive string can be
   * recorded.  For conditions with multiple occurrences, this describes the first
   * known occurrence.
   */
  onsetPeriod?: Maybe<Period>;
  /**
   * Either the age of onset, range of approximate age or descriptive string can be
   * recorded.  For conditions with multiple occurrences, this describes the first
   * known occurrence.
   */
  _onsetString?: Maybe<Element>;
  /**
   * Either the age of onset, range of approximate age or descriptive string can be
   * recorded.  For conditions with multiple occurrences, this describes the first
   * known occurrence.
   */
  onsetString?: Maybe<Scalars['String']>;
  /** An area where general notes can be placed about this specific condition. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

/** The person who this history concerns. */
export type FamilyMemberHistorypatient_Patient_Union = Patient;

/**
 * Indicates a Condition, Observation, AllergyIntolerance, or QuestionnaireResponse
 * that justifies this family member history event.
 */
export type FamilyMemberHistoryreasonReference_ReasonReference_Union = Condition | Observation | AllergyIntolerance | QuestionnaireResponse | DiagnosticReport | DocumentReference;

/** Faq_Schema. */
export type Faq = {
  __typename?: 'Faq';
  /** Type of resource */
  resourceType: Faq_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  question?: Maybe<Scalars['String']>;
  /** patientId Id. */
  answerJson?: Maybe<Scalars['String']>;
  /** patientId Id. */
  answerHtml?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  faqType?: Maybe<Scalars['Int']>;
};

export enum Faq_Enum {
  Faq = 'Faq'
}

export enum Faq_Enum_Input {
  Faq = 'Faq'
}

/** Faq */
export type Faq_Input = {
  /** Type of resource */
  resourceType: Faq_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  question?: Maybe<Scalars['String']>;
  /** answerJson Id. */
  answerJson?: Maybe<Scalars['String']>;
  /** answerHtml Id. */
  answerHtml?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  faqType?: Maybe<Scalars['Int']>;
};

/** Feed Back. */
export type FeedBack = {
  __typename?: 'FeedBack';
  /** Type of resource */
  resourceType: FeedBack_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackType?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackAbout?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackForPatientorRelative?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackPersonTitle?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackPersonFirstName?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackPersonLastName?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackPersonSurName?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackPersonDOB?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackPersonEmail?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackPersonPhoneNumber?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackDateOfService?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackTimeOfService?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackComments?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackServiceUserName?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackServiceEmail?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackAgainstUser?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackCreatedOn?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackStatus?: Maybe<Scalars['Int']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackNumber?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackRespondStatus?: Maybe<Scalars['Int']>;
  /** feedBackDocuments */
  feedBackDocuments?: Maybe<DocumentReference>;
  /** Practitioner that is the custodian of the Preferences. */
  fromUserId?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  againstUserId?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  assignedTo?: Maybe<Scalars['String']>;
  /** feedBackDocuments */
  feedBackReplies?: Maybe<Array<Maybe<FeedBack_Reply_Schema>>>;
};

export enum FeedBackInput_Enum_Input {
  FeedBack = 'FeedBack'
}

export enum FeedBack_Enum {
  FeedBack = 'FeedBack'
}

/** FeedBack */
export type FeedBack_Input = {
  /** Type of resource */
  resourceType: FeedBackInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackType?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackAbout?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackForPatientorRelative?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackPersonTitle?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackPersonFirstName?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackPersonLastName?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackPersonSurName?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackPersonDOB?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackPersonEmail?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackPersonPhoneNumber?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackDateOfService?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackTimeOfService?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackComments?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackServiceUserName?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackServiceEmail?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackAgainstUser?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackCreatedOn?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackStatus?: Maybe<Scalars['Int']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackNumber?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  feedBackRespondStatus?: Maybe<Scalars['Int']>;
  /** feedBackDocuments */
  feedBackDocuments?: Maybe<DocumentReference_Input>;
  /** Practitioner that is the custodian of the Preferences. */
  fromUserId?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  againstUserId?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  assignedTo?: Maybe<Scalars['String']>;
  /** feedBackDocuments */
  feedBackReplies?: Maybe<Array<Maybe<FeedBack_Reply_Input>>>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type FeedBack_Reply_Input = {
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackType?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackTypeId?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackTypeName?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackComments?: Maybe<Scalars['String']>;
  /** operationType field data. */
  feedBackRepliedOn?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackCreator?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type FeedBack_Reply_Schema = {
  __typename?: 'FeedBack_Reply_Schema';
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackType?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackTypeId?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackTypeName?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackComments?: Maybe<Scalars['String']>;
  /** operationType field data. */
  feedBackRepliedOn?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  feedBackCreator?: Maybe<Scalars['Int']>;
};

/** Prospective warnings of potential issues when providing care to the patient. */
export type Flag = {
  __typename?: 'Flag';
  /** Type of resource */
  resourceType: Flag_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this flag by the performer or other systems
   * which remain constant as the resource is updated and propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Supports basic workflow. */
  _status?: Maybe<Element>;
  /** Supports basic workflow. */
  status: Scalars['code'];
  /**
   * Allows a flag to be divided into different categories like clinical,
   * administrative etc. Intended to be used as a means of filtering which flags
   * are displayed to particular user or in a given context.
   */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The coded value or textual component of the flag to display to the user. */
  code: CodeableConcept;
  /** The patient, location, group, organization, or practitioner etc. this is about record this flag is associated with. */
  subject: Flagsubject_Subject_Union;
  /**
   * The period of time from the activation of the flag to inactivation of the
   * flag. If the flag is active, the end of the period should be unspecified.
   */
  period?: Maybe<Period>;
  /** This alert is only relevant during the encounter. */
  encounter?: Maybe<Flagencounter_Encounter_Union>;
  /** The person, organization or device that created the flag. */
  author?: Maybe<Flagauthor_Author_Union>;
};

export enum Flag_Enum_Schema {
  Flag = 'Flag'
}

/** The person, organization or device that created the flag. */
export type Flagauthor_Author_Union = Device | Organization | Patient | Practitioner | PractitionerRole;

/** This alert is only relevant during the encounter. */
export type Flagencounter_Encounter_Union = Encounter;

/** The patient, location, group, organization, or practitioner etc. this is about record this flag is associated with. */
export type Flagsubject_Subject_Union = Patient | Location | Group | Organization | Practitioner | PlanDefinition | Medication | Procedure;

export enum Gp_Enum_Input_Schema {
  Gp = 'GP'
}

export enum Gp_Enum_Schema {
  Gp = 'GP'
}

/** GP */
export type Gp_Input = {
  /** Type of resource */
  resourceType: Gp_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** disorder import file. */
  gpFile?: Maybe<Scalars['String']>;
  /** disorder name. */
  organizationCode?: Maybe<Scalars['String']>;
  /** disorder value. */
  email?: Maybe<Scalars['String']>;
  practiceName?: Maybe<Scalars['String']>;
  /** address line 1. */
  addressLine1?: Maybe<Scalars['String']>;
  /** address line 2. */
  addressLine2?: Maybe<Scalars['String']>;
  /** address line 3. */
  addressLine3?: Maybe<Scalars['String']>;
  /** address line 4. */
  addressLine4?: Maybe<Scalars['String']>;
  /** address line 4. */
  postCode?: Maybe<Scalars['String']>;
  /** contact telephone. */
  contactTelephone?: Maybe<Scalars['String']>;
  gpStatus?: Maybe<Scalars['Boolean']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
};

/** GP */
export type Gp_Schema = {
  __typename?: 'GP_Schema';
  /** Type of resource */
  resourceType: Gp_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** disorder name. */
  organizationCode?: Maybe<Scalars['String']>;
  /** disorder value. */
  email?: Maybe<Scalars['String']>;
  practiceName?: Maybe<Scalars['String']>;
  /** address line 1. */
  addressLine1?: Maybe<Scalars['String']>;
  /** address line 2. */
  addressLine2?: Maybe<Scalars['String']>;
  /** address line 3. */
  addressLine3?: Maybe<Scalars['String']>;
  /** address line 4. */
  addressLine4?: Maybe<Scalars['String']>;
  /** address line 4. */
  postCode?: Maybe<Scalars['String']>;
  /** address line 4. */
  contactTelephone?: Maybe<Scalars['String']>;
  gpStatus?: Maybe<Scalars['Boolean']>;
  countAll?: Maybe<Scalars['Int']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
};

/**
 * Describes the intended objective(s) for a patient, group or organization care,
 * for example, weight loss, restoring an activity of daily living, obtaining herd
 * immunity via immunization, meeting a process improvement objective, etc.
 */
export type Goal = {
  __typename?: 'Goal';
  /** Type of resource */
  resourceType: Goal_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this goal by the performer or other systems
   * which remain constant as the resource is updated and propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The state of the goal throughout its lifecycle. */
  _lifecycleStatus?: Maybe<Element>;
  /** The state of the goal throughout its lifecycle. */
  lifecycleStatus: Scalars['code'];
  /** Describes the progression, or lack thereof, towards the goal against the target. */
  achievementStatus?: Maybe<CodeableConcept>;
  /** Indicates a category the goal falls within. */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Identifies the mutually agreed level of importance associated with reaching/sustaining the goal. */
  priority?: Maybe<CodeableConcept>;
  /**
   * Human-readable and/or coded description of a specific desired objective of
   * care, such as 'control blood pressure' or 'negotiate an obstacle course' or
   * 'dance with child at wedding'.
   */
  description: CodeableConcept;
  /** Identifies the patient, group or organization for whom the goal is being established. */
  subject: Goalsubject_Subject_Union;
  /** The date or event after which the goal should begin being pursued. */
  _startDate?: Maybe<Element>;
  /** The date or event after which the goal should begin being pursued. */
  startDate?: Maybe<Scalars['date']>;
  /** The date or event after which the goal should begin being pursued. */
  startCodeableConcept?: Maybe<CodeableConcept>;
  /** Indicates what should be done by when. */
  target?: Maybe<Array<Maybe<Goaltarget>>>;
  /** Identifies when the current status.  I.e. When initially created, when achieved, when cancelled, etc. */
  _statusDate?: Maybe<Element>;
  /** Identifies when the current status.  I.e. When initially created, when achieved, when cancelled, etc. */
  statusDate?: Maybe<Scalars['date']>;
  /** Captures the reason for the current status. */
  _statusReason?: Maybe<Element>;
  /** Captures the reason for the current status. */
  statusReason?: Maybe<Scalars['String']>;
  /** Indicates whose goal this is - patient goal, practitioner goal, etc. */
  expressedBy?: Maybe<GoalexpressedBy_ExpressedBy_Union>;
  /** The identified conditions and other health record elements that are intended to be addressed by the goal. */
  addresses?: Maybe<Array<Maybe<Goaladdresses_Addresses_Union>>>;
  /** Any comments related to the goal. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Identifies the change (or lack of change) at the point when the status of the goal is assessed. */
  outcomeCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Details of what's changed (or not changed). */
  outcomeReference?: Maybe<Array<Maybe<GoaloutcomeReference_OutcomeReference_Union>>>;
};

export enum Goal_Enum_Schema {
  Goal = 'Goal'
}

/** The identified conditions and other health record elements that are intended to be addressed by the goal. */
export type Goaladdresses_Addresses_Union = Condition | Observation | MedicationStatement | NutritionOrder | ServiceRequest | RiskAssessment;

/** Indicates whose goal this is - patient goal, practitioner goal, etc. */
export type GoalexpressedBy_ExpressedBy_Union = Patient | Practitioner | PractitionerRole | RelatedPerson;

/** Details of what's changed (or not changed). */
export type GoaloutcomeReference_OutcomeReference_Union = Observation;

/** Identifies the patient, group or organization for whom the goal is being established. */
export type Goalsubject_Subject_Union = Patient | Group | Organization;

export type Goaltarget = {
  __typename?: 'Goaltarget';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The parameter whose value is being tracked, e.g. body weight, blood pressure, or hemoglobin A1c level. */
  measure?: Maybe<CodeableConcept>;
  /**
   * The target value of the focus to be achieved to signify the fulfillment of the
   * goal, e.g. 150 pounds, 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any focus value at or below the high value. Similarly, if
   * the high value is missing, it indicates that the goal is achieved at any focus
   * value at or above the low value.
   */
  detailQuantity?: Maybe<Quantity>;
  /**
   * The target value of the focus to be achieved to signify the fulfillment of the
   * goal, e.g. 150 pounds, 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any focus value at or below the high value. Similarly, if
   * the high value is missing, it indicates that the goal is achieved at any focus
   * value at or above the low value.
   */
  detailRange?: Maybe<Range>;
  /**
   * The target value of the focus to be achieved to signify the fulfillment of the
   * goal, e.g. 150 pounds, 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any focus value at or below the high value. Similarly, if
   * the high value is missing, it indicates that the goal is achieved at any focus
   * value at or above the low value.
   */
  detailCodeableConcept?: Maybe<CodeableConcept>;
  /**
   * The target value of the focus to be achieved to signify the fulfillment of the
   * goal, e.g. 150 pounds, 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any focus value at or below the high value. Similarly, if
   * the high value is missing, it indicates that the goal is achieved at any focus
   * value at or above the low value.
   */
  _detailString?: Maybe<Element>;
  /**
   * The target value of the focus to be achieved to signify the fulfillment of the
   * goal, e.g. 150 pounds, 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any focus value at or below the high value. Similarly, if
   * the high value is missing, it indicates that the goal is achieved at any focus
   * value at or above the low value.
   */
  detailString?: Maybe<Scalars['String']>;
  /**
   * The target value of the focus to be achieved to signify the fulfillment of the
   * goal, e.g. 150 pounds, 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any focus value at or below the high value. Similarly, if
   * the high value is missing, it indicates that the goal is achieved at any focus
   * value at or above the low value.
   */
  _detailBoolean?: Maybe<Element>;
  /**
   * The target value of the focus to be achieved to signify the fulfillment of the
   * goal, e.g. 150 pounds, 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any focus value at or below the high value. Similarly, if
   * the high value is missing, it indicates that the goal is achieved at any focus
   * value at or above the low value.
   */
  detailBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * The target value of the focus to be achieved to signify the fulfillment of the
   * goal, e.g. 150 pounds, 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any focus value at or below the high value. Similarly, if
   * the high value is missing, it indicates that the goal is achieved at any focus
   * value at or above the low value.
   */
  _detailInteger?: Maybe<Element>;
  /**
   * The target value of the focus to be achieved to signify the fulfillment of the
   * goal, e.g. 150 pounds, 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any focus value at or below the high value. Similarly, if
   * the high value is missing, it indicates that the goal is achieved at any focus
   * value at or above the low value.
   */
  detailInteger?: Maybe<Scalars['Int']>;
  /**
   * The target value of the focus to be achieved to signify the fulfillment of the
   * goal, e.g. 150 pounds, 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any focus value at or below the high value. Similarly, if
   * the high value is missing, it indicates that the goal is achieved at any focus
   * value at or above the low value.
   */
  detailRatio?: Maybe<Ratio>;
  /** Indicates either the date or the duration after start by which the goal should be met. */
  _dueDate?: Maybe<Element>;
  /** Indicates either the date or the duration after start by which the goal should be met. */
  dueDate?: Maybe<Scalars['date']>;
  /** Indicates either the date or the duration after start by which the goal should be met. */
  dueDuration?: Maybe<Duration>;
};

/**
 * A formal computable definition of a graph of resources - that is, a coherent set
 * of resources that form a graph by following references. The Graph Definition
 * resource defines a set and makes rules about the set.
 */
export type GraphDefinition = {
  __typename?: 'GraphDefinition';
  /** Type of resource */
  resourceType: GraphDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this graph definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this graph definition
   * is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the graph definition is stored on
   * different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this graph definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this graph definition
   * is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the graph definition is stored on
   * different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * The identifier that is used to identify this version of the graph definition
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the graph definition author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the graph definition
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the graph definition author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the graph definition. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the graph definition. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name: Scalars['String'];
  /** The status of this graph definition. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this graph definition. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this graph definition is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this graph definition is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the graph definition was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the graph definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the graph definition was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the graph definition changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the graph definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the graph definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the graph definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the graph definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate graph
   * definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the graph definition is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this graph definition is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this graph definition is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /** The type of FHIR resource at which instances of this graph start. */
  _start?: Maybe<Element>;
  /** The type of FHIR resource at which instances of this graph start. */
  start: Scalars['code'];
  /** The profile that describes the use of the base resource. */
  _profile?: Maybe<Element>;
  /** The profile that describes the use of the base resource. */
  profile?: Maybe<Scalars['canonical']>;
  /** Links this graph makes rules about. */
  link?: Maybe<Array<Maybe<GraphDefinitionlink>>>;
};

export enum GraphDefinition_Enum_Schema {
  GraphDefinition = 'GraphDefinition'
}

export type GraphDefinitionlink = {
  __typename?: 'GraphDefinitionlink';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A FHIR expression that identifies one of FHIR References to other resources. */
  _path?: Maybe<Element>;
  /** A FHIR expression that identifies one of FHIR References to other resources. */
  path?: Maybe<Scalars['String']>;
  /** Which slice (if profiled). */
  _sliceName?: Maybe<Element>;
  /** Which slice (if profiled). */
  sliceName?: Maybe<Scalars['String']>;
  /** Minimum occurrences for this link. */
  _min?: Maybe<Element>;
  /** Minimum occurrences for this link. */
  min?: Maybe<Scalars['Int']>;
  /** Maximum occurrences for this link. */
  _max?: Maybe<Element>;
  /** Maximum occurrences for this link. */
  max?: Maybe<Scalars['String']>;
  /** Information about why this link is of interest in this graph definition. */
  _description?: Maybe<Element>;
  /** Information about why this link is of interest in this graph definition. */
  description?: Maybe<Scalars['String']>;
  /** Potential target for the link. */
  target?: Maybe<Array<Maybe<GraphDefinitionlinktarget>>>;
};

export type GraphDefinitionlinktarget = {
  __typename?: 'GraphDefinitionlinktarget';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of resource this link refers to. */
  _type?: Maybe<Element>;
  /** Type of resource this link refers to. */
  type: Scalars['code'];
  /** A set of parameters to look up. */
  _params?: Maybe<Element>;
  /** A set of parameters to look up. */
  params?: Maybe<Scalars['String']>;
  /** Profile for the target resource. */
  _profile?: Maybe<Element>;
  /** Profile for the target resource. */
  profile?: Maybe<Scalars['canonical']>;
  /** Compartment Consistency Rules. */
  compartment?: Maybe<Array<Maybe<GraphDefinitionlinktargetcompartment>>>;
};

export type GraphDefinitionlinktargetcompartment = {
  __typename?: 'GraphDefinitionlinktargetcompartment';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Defines how the compartment rule is used - whether it it is used to test
   * whether resources are subject to the rule, or whether it is a rule that must be followed.
   */
  _use?: Maybe<Element>;
  /**
   * Defines how the compartment rule is used - whether it it is used to test
   * whether resources are subject to the rule, or whether it is a rule that must be followed.
   */
  use: Scalars['code'];
  /** Identifies the compartment. */
  _code?: Maybe<Element>;
  /** Identifies the compartment. */
  code: Scalars['code'];
  /** identical | matching | different | no-rule | custom. */
  _rule?: Maybe<Element>;
  /** identical | matching | different | no-rule | custom. */
  rule: Scalars['code'];
  /** Custom rule, as a FHIRPath expression. */
  _expression?: Maybe<Element>;
  /** Custom rule, as a FHIRPath expression. */
  expression?: Maybe<Scalars['String']>;
  /** Documentation for FHIRPath expression. */
  _description?: Maybe<Element>;
  /** Documentation for FHIRPath expression. */
  description?: Maybe<Scalars['String']>;
};

/**
 * Represents a defined collection of entities that may be discussed or acted upon
 * collectively but which are not expected to act collectively, and are not
 * formally or legally recognized; i.e. a collection of entities that isn't an Organization.
 */
export type Group = {
  __typename?: 'Group';
  /** Type of resource */
  resourceType: Group_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique business identifier for this group. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Indicates whether the record for the group is available for use or is merely being retained for historical purposes. */
  _active?: Maybe<Element>;
  /** Indicates whether the record for the group is available for use or is merely being retained for historical purposes. */
  active?: Maybe<Scalars['Boolean']>;
  /** Identifies the broad classification of the kind of resources the group includes. */
  _type?: Maybe<Element>;
  /** Identifies the broad classification of the kind of resources the group includes. */
  type: Scalars['code'];
  /**
   * If true, indicates that the resource refers to a specific group of real
   * individuals.  If false, the group defines a set of intended individuals.
   */
  _actual?: Maybe<Element>;
  /**
   * If true, indicates that the resource refers to a specific group of real
   * individuals.  If false, the group defines a set of intended individuals.
   */
  actual: Scalars['Boolean'];
  /** Provides a specific type of resource the group includes; e.g. 'cow', 'syringe', etc. */
  code?: Maybe<CodeableConcept>;
  /** A label assigned to the group for human identification and communication. */
  _name?: Maybe<Element>;
  /** A label assigned to the group for human identification and communication. */
  name?: Maybe<Scalars['String']>;
  /** A count of the number of resource instances that are part of the group. */
  _quantity?: Maybe<Element>;
  /** A count of the number of resource instances that are part of the group. */
  quantity?: Maybe<Scalars['unsignedInt']>;
  /** Entity responsible for defining and maintaining Group characteristics and/or registered members. */
  managingEntity?: Maybe<GroupmanagingEntity_ManagingEntity_Union>;
  /** Identifies traits whose presence r absence is shared by members of the group. */
  characteristic?: Maybe<Array<Maybe<Groupcharacteristic>>>;
  /** Identifies the resource instances that are members of the group. */
  member?: Maybe<Array<Maybe<Groupmember>>>;
};

export enum Group_Enum_Schema {
  Group = 'Group'
}

export type Groupcharacteristic = {
  __typename?: 'Groupcharacteristic';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A code that identifies the kind of trait being asserted. */
  code: CodeableConcept;
  /** The value of the trait that holds (or does not hold - see 'exclude') for members of the group. */
  valueCodeableConcept: CodeableConcept;
  /** The value of the trait that holds (or does not hold - see 'exclude') for members of the group. */
  _valueBoolean?: Maybe<Element>;
  /** The value of the trait that holds (or does not hold - see 'exclude') for members of the group. */
  valueBoolean: Scalars['Boolean'];
  /** The value of the trait that holds (or does not hold - see 'exclude') for members of the group. */
  valueQuantity: Quantity;
  /** The value of the trait that holds (or does not hold - see 'exclude') for members of the group. */
  valueRange: Range;
  /** The value of the trait that holds (or does not hold - see 'exclude') for members of the group. */
  valueReference: ResourceList;
  /** If true, indicates the characteristic is one that is NOT held by members of the group. */
  _exclude?: Maybe<Element>;
  /** If true, indicates the characteristic is one that is NOT held by members of the group. */
  exclude: Scalars['Boolean'];
  /** The period over which the characteristic is tested; e.g. the patient had an operation during the month of June. */
  period?: Maybe<Period>;
};

/** Entity responsible for defining and maintaining Group characteristics and/or registered members. */
export type GroupmanagingEntity_ManagingEntity_Union = Organization | RelatedPerson | Practitioner | PractitionerRole;

export type Groupmember = {
  __typename?: 'Groupmember';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A reference to the entity that is a member of the group. Must be consistent
   * with Group.type. If the entity is another group, then the type must be the same.
   */
  entity: Groupmemberentity_Entity_Union;
  /** The period that the member was in the group, if known. */
  period?: Maybe<Period>;
  /** A flag to indicate that the member is no longer in the group, but previously may have been a member. */
  _inactive?: Maybe<Element>;
  /** A flag to indicate that the member is no longer in the group, but previously may have been a member. */
  inactive?: Maybe<Scalars['Boolean']>;
};

/**
 * A reference to the entity that is a member of the group. Must be consistent with
 * Group.type. If the entity is another group, then the type must be the same.
 */
export type Groupmemberentity_Entity_Union = Patient | Practitioner | PractitionerRole | Device | Medication | Substance | Group;

/**
 * A guidance response is the formal response to a guidance request, including any
 * output parameters returned by the evaluation, as well as the description of any
 * proposed actions to be taken.
 */
export type GuidanceResponse = {
  __typename?: 'GuidanceResponse';
  /** Type of resource */
  resourceType: GuidanceResponse_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The identifier of the request associated with this response. If an identifier
   * was given as part of the request, it will be reproduced here to enable the
   * requester to more easily identify the response in a multi-request scenario.
   */
  requestIdentifier?: Maybe<Identifier>;
  /** Allows a service to provide  unique, business identifiers for the response. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** An identifier, CodeableConcept or canonical reference to the guidance that was requested. */
  _moduleUri?: Maybe<Element>;
  /** An identifier, CodeableConcept or canonical reference to the guidance that was requested. */
  moduleUri: Scalars['uri'];
  /** An identifier, CodeableConcept or canonical reference to the guidance that was requested. */
  _moduleCanonical?: Maybe<Element>;
  /** An identifier, CodeableConcept or canonical reference to the guidance that was requested. */
  moduleCanonical: Scalars['canonical'];
  /** An identifier, CodeableConcept or canonical reference to the guidance that was requested. */
  moduleCodeableConcept: CodeableConcept;
  /**
   * The status of the response. If the evaluation is completed successfully, the
   * status will indicate success. However, in order to complete the evaluation,
   * the engine may require more information. In this case, the status will be
   * data-required, and the response will contain a description of the additional
   * required information. If the evaluation completed successfully, but the engine
   * determines that a potentially more accurate response could be provided if more
   * data was available, the status will be data-requested, and the response will
   * contain a description of the additional requested information.
   */
  _status?: Maybe<Element>;
  /**
   * The status of the response. If the evaluation is completed successfully, the
   * status will indicate success. However, in order to complete the evaluation,
   * the engine may require more information. In this case, the status will be
   * data-required, and the response will contain a description of the additional
   * required information. If the evaluation completed successfully, but the engine
   * determines that a potentially more accurate response could be provided if more
   * data was available, the status will be data-requested, and the response will
   * contain a description of the additional requested information.
   */
  status: Scalars['code'];
  /** The patient for which the request was processed. */
  subject?: Maybe<GuidanceResponsesubject_Subject_Union>;
  /** The encounter during which this response was created or to which the creation of this record is tightly associated. */
  encounter?: Maybe<GuidanceResponseencounter_Encounter_Union>;
  /** Indicates when the guidance response was processed. */
  _occurrenceDateTime?: Maybe<Element>;
  /** Indicates when the guidance response was processed. */
  occurrenceDateTime?: Maybe<Scalars['dateTime']>;
  /** Provides a reference to the device that performed the guidance. */
  performer?: Maybe<GuidanceResponseperformer_Performer_Union>;
  /** Describes the reason for the guidance response in coded or textual form. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Indicates the reason the request was initiated. This is typically provided as
   * a parameter to the evaluation and echoed by the service, although for some use
   * cases, such as subscription- or event-based scenarios, it may provide an
   * indication of the cause for the response.
   */
  reasonReference?: Maybe<Array<Maybe<GuidanceResponsereasonReference_ReasonReference_Union>>>;
  /** Provides a mechanism to communicate additional information about the response. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * Messages resulting from the evaluation of the artifact or artifacts. As part
   * of evaluating the request, the engine may produce informational or warning
   * messages. These messages will be provided by this element.
   */
  evaluationMessage?: Maybe<Array<Maybe<GuidanceResponseevaluationMessage_EvaluationMessage_Union>>>;
  /**
   * The output parameters of the evaluation, if any. Many modules will result in
   * the return of specific resources such as procedure or communication requests
   * that are returned as part of the operation result. However, modules may define
   * specific outputs that would be returned as the result of the evaluation, and
   * these would be returned in this element.
   */
  outputParameters?: Maybe<GuidanceResponseoutputParameters_OutputParameters_Union>;
  /** The actions, if any, produced by the evaluation of the artifact. */
  result?: Maybe<GuidanceResponseresult_Result_Union>;
  /**
   * If the evaluation could not be completed due to lack of information, or
   * additional information would potentially result in a more accurate response,
   * this element will a description of the data required in order to proceed with
   * the evaluation. A subsequent request to the service should include this data.
   */
  dataRequirement?: Maybe<Array<Maybe<DataRequirement>>>;
};

export enum GuidanceResponse_Enum_Schema {
  GuidanceResponse = 'GuidanceResponse'
}

/** The encounter during which this response was created or to which the creation of this record is tightly associated. */
export type GuidanceResponseencounter_Encounter_Union = Encounter;

/**
 * Messages resulting from the evaluation of the artifact or artifacts. As part of
 * evaluating the request, the engine may produce informational or warning
 * messages. These messages will be provided by this element.
 */
export type GuidanceResponseevaluationMessage_EvaluationMessage_Union = OperationOutcome;

/**
 * The output parameters of the evaluation, if any. Many modules will result in the
 * return of specific resources such as procedure or communication requests that
 * are returned as part of the operation result. However, modules may define
 * specific outputs that would be returned as the result of the evaluation, and
 * these would be returned in this element.
 */
export type GuidanceResponseoutputParameters_OutputParameters_Union = Parameters;

/** Provides a reference to the device that performed the guidance. */
export type GuidanceResponseperformer_Performer_Union = Device;

/**
 * Indicates the reason the request was initiated. This is typically provided as a
 * parameter to the evaluation and echoed by the service, although for some use
 * cases, such as subscription- or event-based scenarios, it may provide an
 * indication of the cause for the response.
 */
export type GuidanceResponsereasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference;

/** The actions, if any, produced by the evaluation of the artifact. */
export type GuidanceResponseresult_Result_Union = CarePlan | RequestGroup;

/** The patient for which the request was processed. */
export type GuidanceResponsesubject_Subject_Union = Patient | Group;

/**
 * A formally or informally recognized grouping of people or organizations formed
 * for the purpose of achieving some form of collective action.  Includes
 * companies, institutions, corporations, departments, community groups, healthcare
 * practice groups, payer/insurer, etc.
 */
export type Handbook = {
  __typename?: 'Handbook';
  /** Type of resource */
  resourceType: Handbook_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** A name associated with the organization. */
  name?: Maybe<Scalars['String']>;
  /** A name associated with the organization. */
  filePath?: Maybe<Scalars['String']>;
};

export enum Handbook_Enum_Input {
  Handbook = 'Handbook'
}

export enum Handbook_Enum_Schema {
  Handbook = 'Handbook'
}

/**
 * A formally or informally recognized grouping of people or organizations formed
 * for the purpose of achieving some form of collective action.  Includes
 * companies, institutions, corporations, departments, community groups, healthcare
 * practice groups, payer/insurer, etc.
 */
export type Handbook_Input = {
  /** Type of resource */
  resourceType: Handbook_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** A name associated with the organization. */
  name?: Maybe<Scalars['String']>;
  /** A name associated with the organization. */
  filePath?: Maybe<Scalars['String']>;
};

/** The details of a healthcare service available at a location. */
export type HealthcareService = {
  __typename?: 'HealthcareService';
  /** Type of resource */
  resourceType: HealthcareService_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** External identifiers for this item. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * This flag is used to mark the record to not be used. This is not used when a
   * center is closed for maintenance, or for holidays, the notAvailable period is
   * to be used for this.
   */
  _active?: Maybe<Element>;
  /**
   * This flag is used to mark the record to not be used. This is not used when a
   * center is closed for maintenance, or for holidays, the notAvailable period is
   * to be used for this.
   */
  active?: Maybe<Scalars['Boolean']>;
  /** The organization that provides this healthcare service. */
  providedBy?: Maybe<HealthcareServiceprovidedBy_ProvidedBy_Union>;
  /** Identifies the broad category of service being performed or delivered. */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The specific type of service that may be delivered or performed. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Collection of specialties handled by the service site. This is more of a medical term. */
  specialty?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The location(s) where this healthcare service may be provided. */
  location?: Maybe<Array<Maybe<HealthcareServicelocation_Location_Union>>>;
  /** Further description of the service as it would be presented to a consumer while searching. */
  _name?: Maybe<Element>;
  /** Further description of the service as it would be presented to a consumer while searching. */
  name?: Maybe<Scalars['String']>;
  /**
   * Any additional description of the service and/or any specific issues not
   * covered by the other attributes, which can be displayed as further detail
   * under the serviceName.
   */
  _comment?: Maybe<Element>;
  /**
   * Any additional description of the service and/or any specific issues not
   * covered by the other attributes, which can be displayed as further detail
   * under the serviceName.
   */
  comment?: Maybe<Scalars['String']>;
  /** Extra details about the service that can't be placed in the other fields. */
  _extraDetails?: Maybe<Element>;
  /** Extra details about the service that can't be placed in the other fields. */
  extraDetails?: Maybe<Scalars['String']>;
  /**
   * If there is a photo/symbol associated with this HealthcareService, it may be
   * included here to facilitate quick identification of the service in a list.
   */
  photo?: Maybe<Attachment>;
  /** List of contacts related to this specific healthcare service. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** The location(s) that this service is available to (not where the service is provided). */
  coverageArea?: Maybe<Array<Maybe<HealthcareServicecoverageArea_CoverageArea_Union>>>;
  /** The code(s) that detail the conditions under which the healthcare service is available/offered. */
  serviceProvisionCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Does this service have specific eligibility requirements that need to be met in order to use the service? */
  eligibility?: Maybe<Array<Maybe<HealthcareServiceeligibility>>>;
  /** Programs that this service is applicable to. */
  program?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Collection of characteristics (attributes). */
  characteristic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Some services are specifically made available in multiple languages, this
   * property permits a directory to declare the languages this is offered in.
   * Typically this is only provided where a service operates in communities with
   * mixed languages used.
   */
  communication?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Ways that the service accepts referrals, if this is not provided then it is implied that no referral is required. */
  referralMethod?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Indicates whether or not a prospective consumer will require an appointment
   * for a particular service at a site to be provided by the Organization.
   * Indicates if an appointment is required for access to this service.
   */
  _appointmentRequired?: Maybe<Element>;
  /**
   * Indicates whether or not a prospective consumer will require an appointment
   * for a particular service at a site to be provided by the Organization.
   * Indicates if an appointment is required for access to this service.
   */
  appointmentRequired?: Maybe<Scalars['Boolean']>;
  /** A collection of times that the Service Site is available. */
  availableTime?: Maybe<Array<Maybe<HealthcareServiceavailableTime>>>;
  /** The HealthcareService is not available during this period of time due to the provided reason. */
  notAvailable?: Maybe<Array<Maybe<HealthcareServicenotAvailable>>>;
  /**
   * A description of site availability exceptions, e.g. public holiday
   * availability. Succinctly describing all possible exceptions to normal site
   * availability as details in the available Times and not available Times.
   */
  _availabilityExceptions?: Maybe<Element>;
  /**
   * A description of site availability exceptions, e.g. public holiday
   * availability. Succinctly describing all possible exceptions to normal site
   * availability as details in the available Times and not available Times.
   */
  availabilityExceptions?: Maybe<Scalars['String']>;
  /** Technical endpoints providing access to services operated for the specific healthcare services defined at this resource. */
  endpoint?: Maybe<Array<Maybe<HealthcareServiceendpoint_Endpoint_Union>>>;
};

export enum HealthcareService_Enum_Schema {
  HealthcareService = 'HealthcareService'
}

export type HealthcareServiceavailableTime = {
  __typename?: 'HealthcareServiceavailableTime';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates which days of the week are available between the start and end Times. */
  _daysOfWeek?: Maybe<Element>;
  /** Indicates which days of the week are available between the start and end Times. */
  daysOfWeek?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** Is this always available? (hence times are irrelevant) e.g. 24 hour service. */
  _allDay?: Maybe<Element>;
  /** Is this always available? (hence times are irrelevant) e.g. 24 hour service. */
  allDay?: Maybe<Scalars['Boolean']>;
  /** The opening time of day. Note: If the AllDay flag is set, then this time is ignored. */
  _availableStartTime?: Maybe<Element>;
  /** The opening time of day. Note: If the AllDay flag is set, then this time is ignored. */
  availableStartTime?: Maybe<Scalars['time']>;
  /** The closing time of day. Note: If the AllDay flag is set, then this time is ignored. */
  _availableEndTime?: Maybe<Element>;
  /** The closing time of day. Note: If the AllDay flag is set, then this time is ignored. */
  availableEndTime?: Maybe<Scalars['time']>;
};

/** The location(s) that this service is available to (not where the service is provided). */
export type HealthcareServicecoverageArea_CoverageArea_Union = Location;

export type HealthcareServiceeligibility = {
  __typename?: 'HealthcareServiceeligibility';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Coded value for the eligibility. */
  code?: Maybe<CodeableConcept>;
  /** Describes the eligibility conditions for the service. */
  _comment?: Maybe<Element>;
  /** Describes the eligibility conditions for the service. */
  comment?: Maybe<Scalars['String']>;
};

/** Technical endpoints providing access to services operated for the specific healthcare services defined at this resource. */
export type HealthcareServiceendpoint_Endpoint_Union = Endpoint;

/** The location(s) where this healthcare service may be provided. */
export type HealthcareServicelocation_Location_Union = Location;

export type HealthcareServicenotAvailable = {
  __typename?: 'HealthcareServicenotAvailable';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The reason that can be presented to the user as to why this time is not available. */
  _description?: Maybe<Element>;
  /** The reason that can be presented to the user as to why this time is not available. */
  description: Scalars['String'];
  /** Service is not available (seasonally or for a public holiday) from this date. */
  during?: Maybe<Period>;
};

/** The organization that provides this healthcare service. */
export type HealthcareServiceprovidedBy_ProvidedBy_Union = Organization;

/** Base StructureDefinition for HumanName Type: A human's name with the ability to identify parts and usage. */
export type HumanName = {
  __typename?: 'HumanName';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifies the purpose for this name. */
  _use?: Maybe<Element>;
  /** Identifies the purpose for this name. */
  use?: Maybe<Scalars['code']>;
  /**
   * Specifies the entire name as it should be displayed e.g. on an application UI.
   * This may be provided instead of or as well as the specific parts.
   */
  _text?: Maybe<Element>;
  /**
   * Specifies the entire name as it should be displayed e.g. on an application UI.
   * This may be provided instead of or as well as the specific parts.
   */
  text?: Maybe<Scalars['String']>;
  /**
   * The part of a name that links to the genealogy. In some cultures (e.g.
   * Eritrea) the family name of a son is the first name of his father.
   */
  _family?: Maybe<Element>;
  /**
   * The part of a name that links to the genealogy. In some cultures (e.g.
   * Eritrea) the family name of a son is the first name of his father.
   */
  family?: Maybe<Scalars['String']>;
  /** Given name. */
  _given?: Maybe<Element>;
  /** Given name. */
  given?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Part of the name that is acquired as a title due to academic, legal,
   * employment or nobility status, etc. and that appears at the start of the name.
   */
  _prefix?: Maybe<Element>;
  /**
   * Part of the name that is acquired as a title due to academic, legal,
   * employment or nobility status, etc. and that appears at the start of the name.
   */
  prefix?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Part of the name that is acquired as a title due to academic, legal,
   * employment or nobility status, etc. and that appears at the end of the name.
   */
  _suffix?: Maybe<Element>;
  /**
   * Part of the name that is acquired as a title due to academic, legal,
   * employment or nobility status, etc. and that appears at the end of the name.
   */
  suffix?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Indicates the period of time when this name was valid for the named person. */
  period?: Maybe<Period>;
};

/** Base StructureDefinition for HumanName Type: A human's name with the ability to identify parts and usage. */
export type HumanName_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Identifies the purpose for this name. */
  _use?: Maybe<Element_Input>;
  /** Identifies the purpose for this name. */
  use?: Maybe<Scalars['code']>;
  /**
   * Specifies the entire name as it should be displayed e.g. on an application UI.
   * This may be provided instead of or as well as the specific parts.
   */
  _text?: Maybe<Element_Input>;
  /**
   * Specifies the entire name as it should be displayed e.g. on an application UI.
   * This may be provided instead of or as well as the specific parts.
   */
  text?: Maybe<Scalars['String']>;
  /**
   * The part of a name that links to the genealogy. In some cultures (e.g.
   * Eritrea) the family name of a son is the first name of his father.
   */
  _family?: Maybe<Element_Input>;
  /**
   * The part of a name that links to the genealogy. In some cultures (e.g.
   * Eritrea) the family name of a son is the first name of his father.
   */
  family?: Maybe<Scalars['String']>;
  /** Given name. */
  _given?: Maybe<Element_Input>;
  /** Given name. */
  given?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Part of the name that is acquired as a title due to academic, legal,
   * employment or nobility status, etc. and that appears at the start of the name.
   */
  _prefix?: Maybe<Element_Input>;
  /**
   * Part of the name that is acquired as a title due to academic, legal,
   * employment or nobility status, etc. and that appears at the start of the name.
   */
  prefix?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Part of the name that is acquired as a title due to academic, legal,
   * employment or nobility status, etc. and that appears at the end of the name.
   */
  _suffix?: Maybe<Element_Input>;
  /**
   * Part of the name that is acquired as a title due to academic, legal,
   * employment or nobility status, etc. and that appears at the end of the name.
   */
  suffix?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Indicates the period of time when this name was valid for the named person. */
  period?: Maybe<Period_Input>;
};

/**
 * Base StructureDefinition for Identifier Type: An identifier - identifies some
 * entity uniquely and unambiguously. Typically this is used for business identifiers.
 */
export type Identifier = {
  __typename?: 'Identifier';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The purpose of this identifier. */
  _use?: Maybe<Element>;
  /** The purpose of this identifier. */
  use?: Maybe<Scalars['code']>;
  /** A coded type for the identifier that can be used to determine which identifier to use for a specific purpose. */
  type?: Maybe<CodeableConcept>;
  /** Establishes the namespace for the value - that is, a URL that describes a set values that are unique. */
  _system?: Maybe<Element>;
  /** Establishes the namespace for the value - that is, a URL that describes a set values that are unique. */
  system?: Maybe<Scalars['uri']>;
  /** The portion of the identifier typically relevant to the user and which is unique within the context of the system. */
  _value?: Maybe<Element>;
  /** The portion of the identifier typically relevant to the user and which is unique within the context of the system. */
  value?: Maybe<Scalars['String']>;
  /** Time period during which identifier is/was valid for use. */
  period?: Maybe<Period>;
  /**
   * The portion of the identifier extension typically relevant to the user issuing
   * authority,country,signature details and which is unique within the context of the system.
   */
  identifierExtension?: Maybe<IdentifierExtension>;
  /** The purpose of this identifier. */
  issuingAuthority?: Maybe<Scalars['code']>;
  /** The purpose of this identifier. */
  country?: Maybe<Scalars['code']>;
  /** The purpose of this identifier. */
  identifierType?: Maybe<Scalars['code']>;
  /** The purpose of this identifier. */
  identifierNumber?: Maybe<Scalars['code']>;
  /** The purpose of this identifier. */
  sectionType?: Maybe<Scalars['code']>;
  /** The purpose of this identifier. */
  identifierUrl?: Maybe<Scalars['code']>;
  /** Organization that issued/manages the identifier. */
  assigner?: Maybe<Identifierassigner_Assigner_Union>;
};

/** Base StructureDefinition for IdentifierExtension Type: Custom Fields . */
export type IdentifierExtension = {
  __typename?: 'IdentifierExtension';
  /** issuingAuthority field data. */
  issuingAuthority?: Maybe<Scalars['String']>;
  /** custom2 field data. */
  country?: Maybe<Scalars['String']>;
  /** signatureUrl field data. */
  signatureUrl?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for IdentifierExtension Input Type: Custom Fields . */
export type IdentifierExtension_Input = {
  /** custom1 field data. */
  issuingAuthority?: Maybe<Scalars['String']>;
  /** custom2 field data. */
  country?: Maybe<Scalars['String']>;
  /** operationType field data. */
  signatureUrl?: Maybe<Scalars['String']>;
};

/**
 * Base StructureDefinition for Identifier Type: An identifier - identifies some
 * entity uniquely and unambiguously. Typically this is used for business identifiers.
 */
export type Identifier_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The purpose of this identifier. */
  _use?: Maybe<Element_Input>;
  /** The purpose of this identifier. */
  use?: Maybe<Scalars['code']>;
  /** A coded type for the identifier that can be used to determine which identifier to use for a specific purpose. */
  type?: Maybe<CodeableConcept_Input>;
  /** Establishes the namespace for the value - that is, a URL that describes a set values that are unique. */
  _system?: Maybe<Element_Input>;
  /** Establishes the namespace for the value - that is, a URL that describes a set values that are unique. */
  system?: Maybe<Scalars['uri']>;
  /** The portion of the identifier typically relevant to the user and which is unique within the context of the system. */
  _value?: Maybe<Element_Input>;
  /** The portion of the identifier typically relevant to the user and which is unique within the context of the system. */
  value?: Maybe<Scalars['String']>;
  /** Time period during which identifier is/was valid for use. */
  period?: Maybe<Period_Input>;
  /** Organization that issued/manages the identifier. */
  assigner?: Maybe<Scalars['String']>;
  /** Establishes the namespace for the value - that is, a URL that describes a set values that are unique. */
  identifierExtension?: Maybe<IdentifierExtension_Input>;
  /** The purpose of this identifier. */
  issuingAuthority?: Maybe<Scalars['code']>;
  /** The purpose of this identifier. */
  country?: Maybe<Scalars['code']>;
  /** The purpose of this identifier. */
  identifierType?: Maybe<Scalars['code']>;
  /** The purpose of this identifier. */
  identifierNumber?: Maybe<Scalars['code']>;
  /** The purpose of this identifier. */
  sectionType?: Maybe<Scalars['code']>;
  /** The purpose of this identifier. */
  identifierUrl?: Maybe<Scalars['code']>;
};

/** Organization that issued/manages the identifier. */
export type Identifierassigner_Assigner_Union = Organization;

/**
 * Representation of the content produced in a DICOM imaging study. A study
 * comprises a set of series, each of which includes a set of Service-Object Pair
 * Instances (SOP Instances - images or other data) acquired or produced in a
 * common context.  A series is of only one modality (e.g. X-ray, CT, MR,
 * ultrasound), but a study may have multiple series of different modalities.
 */
export type ImagingStudy = {
  __typename?: 'ImagingStudy';
  /** Type of resource */
  resourceType: ImagingStudy_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifiers for the ImagingStudy such as DICOM Study Instance UID, and Accession Number. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The current state of the ImagingStudy. */
  _status?: Maybe<Element>;
  /** The current state of the ImagingStudy. */
  status: Scalars['code'];
  /**
   * A list of all the series.modality values that are actual acquisition
   * modalities, i.e. those in the DICOM Context Group 29 (value set OID
   * 1.2.840.10008.6.1.19).
   */
  modality?: Maybe<Array<Maybe<Coding>>>;
  /** The subject, typically a patient, of the imaging study. */
  subject: ImagingStudysubject_Subject_Union;
  /** The healthcare event (e.g. a patient and healthcare provider interaction) during which this ImagingStudy is made. */
  encounter?: Maybe<ImagingStudyencounter_Encounter_Union>;
  /** Date and time the study started. */
  _started?: Maybe<Element>;
  /** Date and time the study started. */
  started?: Maybe<Scalars['dateTime']>;
  /** A list of the diagnostic requests that resulted in this imaging study being performed. */
  basedOn?: Maybe<Array<Maybe<ImagingStudybasedOn_BasedOn_Union>>>;
  /** The requesting/referring physician. */
  referrer?: Maybe<ImagingStudyreferrer_Referrer_Union>;
  /** Who read the study and interpreted the images or other content. */
  interpreter?: Maybe<Array<Maybe<ImagingStudyinterpreter_Interpreter_Union>>>;
  /**
   * The network service providing access (e.g., query, view, or retrieval) for the
   * study. See implementation notes for information about using DICOM endpoints. A
   * study-level endpoint applies to each series in the study, unless overridden by
   * a series-level endpoint with the same Endpoint.connectionType.
   */
  endpoint?: Maybe<Array<Maybe<ImagingStudyendpoint_Endpoint_Union>>>;
  /**
   * Number of Series in the Study. This value given may be larger than the number
   * of series elements this Resource contains due to resource availability,
   * security, or other factors. This element should be present if any series
   * elements are present.
   */
  _numberOfSeries?: Maybe<Element>;
  /**
   * Number of Series in the Study. This value given may be larger than the number
   * of series elements this Resource contains due to resource availability,
   * security, or other factors. This element should be present if any series
   * elements are present.
   */
  numberOfSeries?: Maybe<Scalars['unsignedInt']>;
  /**
   * Number of SOP Instances in Study. This value given may be larger than the
   * number of instance elements this resource contains due to resource
   * availability, security, or other factors. This element should be present if
   * any instance elements are present.
   */
  _numberOfInstances?: Maybe<Element>;
  /**
   * Number of SOP Instances in Study. This value given may be larger than the
   * number of instance elements this resource contains due to resource
   * availability, security, or other factors. This element should be present if
   * any instance elements are present.
   */
  numberOfInstances?: Maybe<Scalars['unsignedInt']>;
  /** The procedure which this ImagingStudy was part of. */
  procedureReference?: Maybe<ImagingStudyprocedureReference_ProcedureReference_Union>;
  /** The code for the performed procedure type. */
  procedureCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The principal physical location where the ImagingStudy was performed. */
  location?: Maybe<ImagingStudylocation_Location_Union>;
  /** Description of clinical condition indicating why the ImagingStudy was requested. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates another resource whose existence justifies this Study. */
  reasonReference?: Maybe<Array<Maybe<ImagingStudyreasonReference_ReasonReference_Union>>>;
  /**
   * Per the recommended DICOM mapping, this element is derived from the Study
   * Description attribute (0008,1030). Observations or findings about the imaging
   * study should be recorded in another resource, e.g. Observation, and not in this element.
   */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * The Imaging Manager description of the study. Institution-generated
   * description or classification of the Study (component) performed.
   */
  _description?: Maybe<Element>;
  /**
   * The Imaging Manager description of the study. Institution-generated
   * description or classification of the Study (component) performed.
   */
  description?: Maybe<Scalars['String']>;
  /** Each study has one or more series of images or other content. */
  series?: Maybe<Array<Maybe<ImagingStudyseries>>>;
};

export enum ImagingStudy_Enum_Schema {
  ImagingStudy = 'ImagingStudy'
}

/** A list of the diagnostic requests that resulted in this imaging study being performed. */
export type ImagingStudybasedOn_BasedOn_Union = CarePlan | ServiceRequest | Appointment | AppointmentResponse | Task;

/** The healthcare event (e.g. a patient and healthcare provider interaction) during which this ImagingStudy is made. */
export type ImagingStudyencounter_Encounter_Union = Encounter;

/**
 * The network service providing access (e.g., query, view, or retrieval) for the
 * study. See implementation notes for information about using DICOM endpoints. A
 * study-level endpoint applies to each series in the study, unless overridden by a
 * series-level endpoint with the same Endpoint.connectionType.
 */
export type ImagingStudyendpoint_Endpoint_Union = Endpoint;

/** Who read the study and interpreted the images or other content. */
export type ImagingStudyinterpreter_Interpreter_Union = Practitioner | PractitionerRole;

/** The principal physical location where the ImagingStudy was performed. */
export type ImagingStudylocation_Location_Union = Location;

/** The procedure which this ImagingStudy was part of. */
export type ImagingStudyprocedureReference_ProcedureReference_Union = Procedure;

/** Indicates another resource whose existence justifies this Study. */
export type ImagingStudyreasonReference_ReasonReference_Union = Condition | Observation | Media | DiagnosticReport | DocumentReference;

/** The requesting/referring physician. */
export type ImagingStudyreferrer_Referrer_Union = Practitioner | PractitionerRole;

export type ImagingStudyseries = {
  __typename?: 'ImagingStudyseries';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The DICOM Series Instance UID for the series. */
  _uid?: Maybe<Element>;
  /** The DICOM Series Instance UID for the series. */
  uid: Scalars['id'];
  /** The numeric identifier of this series in the study. */
  _number?: Maybe<Element>;
  /** The numeric identifier of this series in the study. */
  number?: Maybe<Scalars['unsignedInt']>;
  /** The modality of this series sequence. */
  modality: Coding;
  /** A description of the series. */
  _description?: Maybe<Element>;
  /** A description of the series. */
  description?: Maybe<Scalars['String']>;
  /**
   * Number of SOP Instances in the Study. The value given may be larger than the
   * number of instance elements this resource contains due to resource
   * availability, security, or other factors. This element should be present if
   * any instance elements are present.
   */
  _numberOfInstances?: Maybe<Element>;
  /**
   * Number of SOP Instances in the Study. The value given may be larger than the
   * number of instance elements this resource contains due to resource
   * availability, security, or other factors. This element should be present if
   * any instance elements are present.
   */
  numberOfInstances?: Maybe<Scalars['unsignedInt']>;
  /**
   * The network service providing access (e.g., query, view, or retrieval) for
   * this series. See implementation notes for information about using DICOM
   * endpoints. A series-level endpoint, if present, has precedence over a
   * study-level endpoint with the same Endpoint.connectionType.
   */
  endpoint?: Maybe<Array<Maybe<ImagingStudyseriesendpoint_Endpoint_Union>>>;
  /**
   * The anatomic structures examined. See DICOM Part 16 Annex L (http://dicom.nema.org/medical/dicom/current/output/chtml/part16/chapter_L.html)
   * for DICOM to SNOMED-CT mappings. The bodySite may indicate the laterality of
   * body part imaged; if so, it shall be consistent with any content of
   * ImagingStudy.series.laterality.
   */
  bodySite?: Maybe<Coding>;
  /**
   * The laterality of the (possibly paired) anatomic structures examined. E.g.,
   * the left knee, both lungs, or unpaired abdomen. If present, shall be
   * consistent with any laterality information indicated in
   * ImagingStudy.series.bodySite.
   */
  laterality?: Maybe<Coding>;
  /** The specimen imaged, e.g., for whole slide imaging of a biopsy. */
  specimen?: Maybe<Array<Maybe<ImagingStudyseriesspecimen_Specimen_Union>>>;
  /** The date and time the series was started. */
  _started?: Maybe<Element>;
  /** The date and time the series was started. */
  started?: Maybe<Scalars['dateTime']>;
  /** Indicates who or what performed the series and how they were involved. */
  performer?: Maybe<Array<Maybe<ImagingStudyseriesperformer>>>;
  /** A single SOP instance within the series, e.g. an image, or presentation state. */
  instance?: Maybe<Array<Maybe<ImagingStudyseriesinstance>>>;
};

/**
 * The network service providing access (e.g., query, view, or retrieval) for this
 * series. See implementation notes for information about using DICOM endpoints. A
 * series-level endpoint, if present, has precedence over a study-level endpoint
 * with the same Endpoint.connectionType.
 */
export type ImagingStudyseriesendpoint_Endpoint_Union = Endpoint;

export type ImagingStudyseriesinstance = {
  __typename?: 'ImagingStudyseriesinstance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The DICOM SOP Instance UID for this image or other DICOM content. */
  _uid?: Maybe<Element>;
  /** The DICOM SOP Instance UID for this image or other DICOM content. */
  uid: Scalars['id'];
  /** DICOM instance  type. */
  sopClass: Coding;
  /** The number of instance in the series. */
  _number?: Maybe<Element>;
  /** The number of instance in the series. */
  number?: Maybe<Scalars['unsignedInt']>;
  /** The description of the instance. */
  _title?: Maybe<Element>;
  /** The description of the instance. */
  title?: Maybe<Scalars['String']>;
};

export type ImagingStudyseriesperformer = {
  __typename?: 'ImagingStudyseriesperformer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Distinguishes the type of involvement of the performer in the series. */
  function?: Maybe<CodeableConcept>;
  /** Indicates who or what performed the series. */
  actor: ImagingStudyseriesperformeractor_Actor_Union;
};

/** Indicates who or what performed the series. */
export type ImagingStudyseriesperformeractor_Actor_Union = Practitioner | PractitionerRole | Organization | CareTeam | Patient | Device | RelatedPerson;

/** The specimen imaged, e.g., for whole slide imaging of a biopsy. */
export type ImagingStudyseriesspecimen_Specimen_Union = Specimen;

/** The subject, typically a patient, of the imaging study. */
export type ImagingStudysubject_Subject_Union = Patient | Device | Group;

/**
 * Describes the event of a patient being administered a vaccine or a record of an
 * immunization as reported by a patient, a clinician or another party.
 */
export type Immunization = {
  __typename?: 'Immunization';
  /** Type of resource */
  resourceType: Immunization_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this immunization record. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Indicates the current status of the immunization event. */
  _status?: Maybe<Element>;
  /** Indicates the current status of the immunization event. */
  status: Scalars['code'];
  /** Indicates the reason the immunization event was not performed. */
  statusReason?: Maybe<CodeableConcept>;
  /** Vaccine that was administered or was to be administered. */
  vaccineCode: CodeableConcept;
  /** The patient who either received or did not receive the immunization. */
  patient: Immunizationpatient_Patient_Union;
  /**
   * The visit or admission or other contact between patient and health care
   * provider the immunization was performed as part of.
   */
  encounter?: Maybe<Immunizationencounter_Encounter_Union>;
  /** Date vaccine administered or was to be administered. */
  _occurrenceDateTime?: Maybe<Element>;
  /** Date vaccine administered or was to be administered. */
  occurrenceDateTime: Scalars['dateTime'];
  /** Date vaccine administered or was to be administered. */
  _occurrenceString?: Maybe<Element>;
  /** Date vaccine administered or was to be administered. */
  occurrenceString: Scalars['String'];
  /**
   * The date the occurrence of the immunization was first captured in the record -
   * potentially significantly after the occurrence of the event.
   */
  _recorded?: Maybe<Element>;
  /**
   * The date the occurrence of the immunization was first captured in the record -
   * potentially significantly after the occurrence of the event.
   */
  recorded?: Maybe<Scalars['dateTime']>;
  /**
   * An indication that the content of the record is based on information from the
   * person who administered the vaccine. This reflects the context under which the
   * data was originally recorded.
   */
  _primarySource?: Maybe<Element>;
  /**
   * An indication that the content of the record is based on information from the
   * person who administered the vaccine. This reflects the context under which the
   * data was originally recorded.
   */
  primarySource?: Maybe<Scalars['Boolean']>;
  /**
   * The source of the data when the report of the immunization event is not based
   * on information from the person who administered the vaccine.
   */
  reportOrigin?: Maybe<CodeableConcept>;
  /** The service delivery location where the vaccine administration occurred. */
  location?: Maybe<Immunizationlocation_Location_Union>;
  /** Name of vaccine manufacturer. */
  manufacturer?: Maybe<Immunizationmanufacturer_Manufacturer_Union>;
  /** Lot number of the  vaccine product. */
  _lotNumber?: Maybe<Element>;
  /** Lot number of the  vaccine product. */
  lotNumber?: Maybe<Scalars['String']>;
  /** Date vaccine batch expires. */
  _expirationDate?: Maybe<Element>;
  /** Date vaccine batch expires. */
  expirationDate?: Maybe<Scalars['date']>;
  /** Body site where vaccine was administered. */
  site?: Maybe<CodeableConcept>;
  /** The path by which the vaccine product is taken into the body. */
  route?: Maybe<CodeableConcept>;
  /** The quantity of vaccine product that was administered. */
  doseQuantity?: Maybe<Quantity>;
  /** Indicates who performed the immunization event. */
  performer?: Maybe<Array<Maybe<Immunizationperformer>>>;
  /** Extra information about the immunization that is not conveyed by the other attributes. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Reasons why the vaccine was administered. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Condition, Observation or DiagnosticReport that supports why the immunization was administered. */
  reasonReference?: Maybe<Array<Maybe<ImmunizationreasonReference_ReasonReference_Union>>>;
  /** Indication if a dose is considered to be subpotent. By default, a dose should be considered to be potent. */
  _isSubpotent?: Maybe<Element>;
  /** Indication if a dose is considered to be subpotent. By default, a dose should be considered to be potent. */
  isSubpotent?: Maybe<Scalars['Boolean']>;
  /** Reason why a dose is considered to be subpotent. */
  subpotentReason?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Educational material presented to the patient (or guardian) at the time of vaccine administration. */
  education?: Maybe<Array<Maybe<Immunizationeducation>>>;
  /** Indicates a patient's eligibility for a funding program. */
  programEligibility?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Indicates the source of the vaccine actually administered. This may be
   * different than the patient eligibility (e.g. the patient may be eligible for a
   * publically purchased vaccine but due to inventory issues, vaccine purchased
   * with private funds was actually administered).
   */
  fundingSource?: Maybe<CodeableConcept>;
  /** Categorical data indicating that an adverse event is associated in time to an immunization. */
  reaction?: Maybe<Array<Maybe<Immunizationreaction>>>;
  /** The protocol (set of recommendations) being followed by the provider who administered the dose. */
  protocolApplied?: Maybe<Array<Maybe<ImmunizationprotocolApplied>>>;
};

/**
 * Describes a comparison of an immunization event against published
 * recommendations to determine if the administration is 'valid' in relation to
 * those  recommendations.
 */
export type ImmunizationEvaluation = {
  __typename?: 'ImmunizationEvaluation';
  /** Type of resource */
  resourceType: ImmunizationEvaluation_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this immunization evaluation record. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Indicates the current status of the evaluation of the vaccination administration event. */
  _status?: Maybe<Element>;
  /** Indicates the current status of the evaluation of the vaccination administration event. */
  status: Scalars['code'];
  /** The individual for whom the evaluation is being done. */
  patient: ImmunizationEvaluationpatient_Patient_Union;
  /** The date the evaluation of the vaccine administration event was performed. */
  _date?: Maybe<Element>;
  /** The date the evaluation of the vaccine administration event was performed. */
  date?: Maybe<Scalars['dateTime']>;
  /** Indicates the authority who published the protocol (e.g. ACIP). */
  authority?: Maybe<ImmunizationEvaluationauthority_Authority_Union>;
  /** The vaccine preventable disease the dose is being evaluated against. */
  targetDisease: CodeableConcept;
  /** The vaccine administration event being evaluated. */
  immunizationEvent: ImmunizationEvaluationimmunizationEvent_ImmunizationEvent_Union;
  /** Indicates if the dose is valid or not valid with respect to the published recommendations. */
  doseStatus: CodeableConcept;
  /**
   * Provides an explanation as to why the vaccine administration event is valid or
   * not relative to the published recommendations.
   */
  doseStatusReason?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Additional information about the evaluation. */
  _description?: Maybe<Element>;
  /** Additional information about the evaluation. */
  description?: Maybe<Scalars['String']>;
  /** One possible path to achieve presumed immunity against a disease - within the context of an authority. */
  _series?: Maybe<Element>;
  /** One possible path to achieve presumed immunity against a disease - within the context of an authority. */
  series?: Maybe<Scalars['String']>;
  /** Nominal position in a series. */
  _doseNumberPositiveInt?: Maybe<Element>;
  /** Nominal position in a series. */
  doseNumberPositiveInt?: Maybe<Scalars['positiveInt']>;
  /** Nominal position in a series. */
  _doseNumberString?: Maybe<Element>;
  /** Nominal position in a series. */
  doseNumberString?: Maybe<Scalars['String']>;
  /** The recommended number of doses to achieve immunity. */
  _seriesDosesPositiveInt?: Maybe<Element>;
  /** The recommended number of doses to achieve immunity. */
  seriesDosesPositiveInt?: Maybe<Scalars['positiveInt']>;
  /** The recommended number of doses to achieve immunity. */
  _seriesDosesString?: Maybe<Element>;
  /** The recommended number of doses to achieve immunity. */
  seriesDosesString?: Maybe<Scalars['String']>;
};

export enum ImmunizationEvaluation_Enum_Schema {
  ImmunizationEvaluation = 'ImmunizationEvaluation'
}

/** Indicates the authority who published the protocol (e.g. ACIP). */
export type ImmunizationEvaluationauthority_Authority_Union = Organization;

/** The vaccine administration event being evaluated. */
export type ImmunizationEvaluationimmunizationEvent_ImmunizationEvent_Union = Immunization;

/** The individual for whom the evaluation is being done. */
export type ImmunizationEvaluationpatient_Patient_Union = Patient;

/**
 * A patient's point-in-time set of recommendations (i.e. forecasting) according to
 * a published schedule with optional supporting justification.
 */
export type ImmunizationRecommendation = {
  __typename?: 'ImmunizationRecommendation';
  /** Type of resource */
  resourceType: ImmunizationRecommendation_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this particular recommendation record. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The patient the recommendation(s) are for. */
  patient: ImmunizationRecommendationpatient_Patient_Union;
  /** The date the immunization recommendation(s) were created. */
  _date?: Maybe<Element>;
  /** The date the immunization recommendation(s) were created. */
  date: Scalars['dateTime'];
  /** Indicates the authority who published the protocol (e.g. ACIP). */
  authority?: Maybe<ImmunizationRecommendationauthority_Authority_Union>;
  /** Vaccine administration recommendations. */
  recommendation?: Maybe<Array<ImmunizationRecommendationrecommendation>>;
};

export enum ImmunizationRecommendation_Enum_Schema {
  ImmunizationRecommendation = 'ImmunizationRecommendation'
}

/** Indicates the authority who published the protocol (e.g. ACIP). */
export type ImmunizationRecommendationauthority_Authority_Union = Organization;

/** The patient the recommendation(s) are for. */
export type ImmunizationRecommendationpatient_Patient_Union = Patient;

export type ImmunizationRecommendationrecommendation = {
  __typename?: 'ImmunizationRecommendationrecommendation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Vaccine(s) or vaccine group that pertain to the recommendation. */
  vaccineCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The targeted disease for the recommendation. */
  targetDisease?: Maybe<CodeableConcept>;
  /** Vaccine(s) which should not be used to fulfill the recommendation. */
  contraindicatedVaccineCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates the patient status with respect to the path to immunity for the target disease. */
  forecastStatus: CodeableConcept;
  /** The reason for the assigned forecast status. */
  forecastReason?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Vaccine date recommendations.  For example, earliest date to administer, latest date to administer, etc. */
  dateCriterion?: Maybe<Array<Maybe<ImmunizationRecommendationrecommendationdateCriterion>>>;
  /** Contains the description about the protocol under which the vaccine was administered. */
  _description?: Maybe<Element>;
  /** Contains the description about the protocol under which the vaccine was administered. */
  description?: Maybe<Scalars['String']>;
  /** One possible path to achieve presumed immunity against a disease - within the context of an authority. */
  _series?: Maybe<Element>;
  /** One possible path to achieve presumed immunity against a disease - within the context of an authority. */
  series?: Maybe<Scalars['String']>;
  /** Nominal position of the recommended dose in a series (e.g. dose 2 is the next recommended dose). */
  _doseNumberPositiveInt?: Maybe<Element>;
  /** Nominal position of the recommended dose in a series (e.g. dose 2 is the next recommended dose). */
  doseNumberPositiveInt?: Maybe<Scalars['positiveInt']>;
  /** Nominal position of the recommended dose in a series (e.g. dose 2 is the next recommended dose). */
  _doseNumberString?: Maybe<Element>;
  /** Nominal position of the recommended dose in a series (e.g. dose 2 is the next recommended dose). */
  doseNumberString?: Maybe<Scalars['String']>;
  /** The recommended number of doses to achieve immunity. */
  _seriesDosesPositiveInt?: Maybe<Element>;
  /** The recommended number of doses to achieve immunity. */
  seriesDosesPositiveInt?: Maybe<Scalars['positiveInt']>;
  /** The recommended number of doses to achieve immunity. */
  _seriesDosesString?: Maybe<Element>;
  /** The recommended number of doses to achieve immunity. */
  seriesDosesString?: Maybe<Scalars['String']>;
  /** Immunization event history and/or evaluation that supports the status and recommendation. */
  supportingImmunization?: Maybe<Array<Maybe<ImmunizationRecommendationrecommendationsupportingImmunization_SupportingImmunization_Union>>>;
  /**
   * Patient Information that supports the status and recommendation.  This
   * includes patient observations, adverse reactions and allergy/intolerance information.
   */
  supportingPatientInformation?: Maybe<Array<Maybe<ImmunizationRecommendationrecommendationsupportingPatientInformation_SupportingPatientInformation_Union>>>;
};

export type ImmunizationRecommendationrecommendationdateCriterion = {
  __typename?: 'ImmunizationRecommendationrecommendationdateCriterion';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Date classification of recommendation.  For example, earliest date to give, latest date to give, etc. */
  code: CodeableConcept;
  /** The date whose meaning is specified by dateCriterion.code. */
  _value?: Maybe<Element>;
  /** The date whose meaning is specified by dateCriterion.code. */
  value: Scalars['dateTime'];
};

/** Immunization event history and/or evaluation that supports the status and recommendation. */
export type ImmunizationRecommendationrecommendationsupportingImmunization_SupportingImmunization_Union = Immunization | ImmunizationEvaluation;

/**
 * Patient Information that supports the status and recommendation.  This includes
 * patient observations, adverse reactions and allergy/intolerance information.
 */
export type ImmunizationRecommendationrecommendationsupportingPatientInformation_SupportingPatientInformation_Union = Resource;

export enum Immunization_Enum_Input {
  Immunization = 'Immunization'
}

export enum Immunization_Enum_Schema {
  Immunization = 'Immunization'
}

/**
 * Describes the event of a patient being administered a vaccine or a record of an
 * immunization as reported by a patient, a clinician or another party.
 */
export type Immunization_Input = {
  /** Type of resource */
  resourceType: Immunization_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A unique identifier assigned to this immunization record. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /** Indicates the current status of the immunization event. */
  _status?: Maybe<Element_Input>;
  /** Indicates the current status of the immunization event. */
  status: Scalars['code'];
  /** Indicates the reason the immunization event was not performed. */
  statusReason?: Maybe<CodeableConcept_Input>;
  /** Vaccine that was administered or was to be administered. */
  vaccineCode: CodeableConcept_Input;
  /** The patient who either received or did not receive the immunization. */
  patient: Scalars['String'];
  /**
   * The visit or admission or other contact between patient and health care
   * provider the immunization was performed as part of.
   */
  encounter?: Maybe<Scalars['String']>;
  /** Date vaccine administered or was to be administered. */
  _occurrenceDateTime?: Maybe<Element_Input>;
  /** Date vaccine administered or was to be administered. */
  occurrenceDateTime: Scalars['dateTime'];
  /** Date vaccine administered or was to be administered. */
  _occurrenceString?: Maybe<Element_Input>;
  /** Date vaccine administered or was to be administered. */
  occurrenceString: Scalars['String'];
  /**
   * The date the occurrence of the immunization was first captured in the record -
   * potentially significantly after the occurrence of the event.
   */
  _recorded?: Maybe<Element_Input>;
  /**
   * The date the occurrence of the immunization was first captured in the record -
   * potentially significantly after the occurrence of the event.
   */
  recorded?: Maybe<Scalars['dateTime']>;
  /**
   * An indication that the content of the record is based on information from the
   * person who administered the vaccine. This reflects the context under which the
   * data was originally recorded.
   */
  _primarySource?: Maybe<Element_Input>;
  /**
   * An indication that the content of the record is based on information from the
   * person who administered the vaccine. This reflects the context under which the
   * data was originally recorded.
   */
  primarySource?: Maybe<Scalars['Boolean']>;
  /**
   * The source of the data when the report of the immunization event is not based
   * on information from the person who administered the vaccine.
   */
  reportOrigin?: Maybe<CodeableConcept_Input>;
  /** The service delivery location where the vaccine administration occurred. */
  location?: Maybe<Scalars['String']>;
  /** Name of vaccine manufacturer. */
  manufacturer?: Maybe<Scalars['String']>;
  /** Lot number of the  vaccine product. */
  _lotNumber?: Maybe<Element_Input>;
  /** Lot number of the  vaccine product. */
  lotNumber?: Maybe<Scalars['String']>;
  /** Date vaccine batch expires. */
  _expirationDate?: Maybe<Element_Input>;
  /** Date vaccine batch expires. */
  expirationDate?: Maybe<Scalars['date']>;
  /** Body site where vaccine was administered. */
  site?: Maybe<CodeableConcept_Input>;
  /** The path by which the vaccine product is taken into the body. */
  route?: Maybe<CodeableConcept_Input>;
  /** The quantity of vaccine product that was administered. */
  doseQuantity?: Maybe<Quantity_Input>;
  /** Indicates who performed the immunization event. */
  performer?: Maybe<Array<Maybe<Immunizationperformer_Input>>>;
  /** Extra information about the immunization that is not conveyed by the other attributes. */
  note?: Maybe<Array<Maybe<Annotation_Input>>>;
  /** Reasons why the vaccine was administered. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Condition, Observation or DiagnosticReport that supports why the immunization was administered. */
  reasonReference?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Indication if a dose is considered to be subpotent. By default, a dose should be considered to be potent. */
  _isSubpotent?: Maybe<Element_Input>;
  /** Indication if a dose is considered to be subpotent. By default, a dose should be considered to be potent. */
  isSubpotent?: Maybe<Scalars['Boolean']>;
  /** Reason why a dose is considered to be subpotent. */
  subpotentReason?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Educational material presented to the patient (or guardian) at the time of vaccine administration. */
  education?: Maybe<Array<Maybe<Immunizationeducation_Input>>>;
  /** Indicates a patient's eligibility for a funding program. */
  programEligibility?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /**
   * Indicates the source of the vaccine actually administered. This may be
   * different than the patient eligibility (e.g. the patient may be eligible for a
   * publically purchased vaccine but due to inventory issues, vaccine purchased
   * with private funds was actually administered).
   */
  fundingSource?: Maybe<CodeableConcept_Input>;
  /** Categorical data indicating that an adverse event is associated in time to an immunization. */
  reaction?: Maybe<Array<Maybe<Immunizationreaction_Input>>>;
  /** The protocol (set of recommendations) being followed by the provider who administered the dose. */
  protocolApplied?: Maybe<Array<Maybe<ImmunizationprotocolApplied_Input>>>;
};

export type Immunizationeducation = {
  __typename?: 'Immunizationeducation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier of the material presented to the patient. */
  _documentType?: Maybe<Element>;
  /** Identifier of the material presented to the patient. */
  documentType?: Maybe<Scalars['String']>;
  /** Reference pointer to the educational material given to the patient if the information was on line. */
  _reference?: Maybe<Element>;
  /** Reference pointer to the educational material given to the patient if the information was on line. */
  reference?: Maybe<Scalars['uri']>;
  /** Date the educational material was published. */
  _publicationDate?: Maybe<Element>;
  /** Date the educational material was published. */
  publicationDate?: Maybe<Scalars['dateTime']>;
  /** Date the educational material was given to the patient. */
  _presentationDate?: Maybe<Element>;
  /** Date the educational material was given to the patient. */
  presentationDate?: Maybe<Scalars['dateTime']>;
};

export type Immunizationeducation_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Identifier of the material presented to the patient. */
  _documentType?: Maybe<Element_Input>;
  /** Identifier of the material presented to the patient. */
  documentType?: Maybe<Scalars['String']>;
  /** Reference pointer to the educational material given to the patient if the information was on line. */
  _reference?: Maybe<Element_Input>;
  /** Reference pointer to the educational material given to the patient if the information was on line. */
  reference?: Maybe<Scalars['uri']>;
  /** Date the educational material was published. */
  _publicationDate?: Maybe<Element_Input>;
  /** Date the educational material was published. */
  publicationDate?: Maybe<Scalars['dateTime']>;
  /** Date the educational material was given to the patient. */
  _presentationDate?: Maybe<Element_Input>;
  /** Date the educational material was given to the patient. */
  presentationDate?: Maybe<Scalars['dateTime']>;
};

/** The visit or admission or other contact between patient and health care provider the immunization was performed as part of. */
export type Immunizationencounter_Encounter_Union = Encounter;

/** The service delivery location where the vaccine administration occurred. */
export type Immunizationlocation_Location_Union = Location;

/** Name of vaccine manufacturer. */
export type Immunizationmanufacturer_Manufacturer_Union = Organization;

/** The patient who either received or did not receive the immunization. */
export type Immunizationpatient_Patient_Union = Patient;

export type Immunizationperformer = {
  __typename?: 'Immunizationperformer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Describes the type of performance (e.g. ordering provider, administering provider, etc.). */
  function?: Maybe<CodeableConcept>;
  /** The practitioner or organization who performed the action. */
  actor: Immunizationperformeractor_Actor_Union;
};

export type Immunizationperformer_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Describes the type of performance (e.g. ordering provider, administering provider, etc.). */
  function?: Maybe<CodeableConcept_Input>;
  /** The practitioner or organization who performed the action. */
  actor: Scalars['String'];
};

/** The practitioner or organization who performed the action. */
export type Immunizationperformeractor_Actor_Union = Practitioner | PractitionerRole | Organization;

export type ImmunizationprotocolApplied = {
  __typename?: 'ImmunizationprotocolApplied';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** One possible path to achieve presumed immunity against a disease - within the context of an authority. */
  _series?: Maybe<Element>;
  /** One possible path to achieve presumed immunity against a disease - within the context of an authority. */
  series?: Maybe<Scalars['String']>;
  /** Indicates the authority who published the protocol (e.g. ACIP) that is being followed. */
  authority?: Maybe<ImmunizationprotocolAppliedauthority_Authority_Union>;
  /** The vaccine preventable disease the dose is being administered against. */
  targetDisease?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Nominal position in a series. */
  _doseNumberPositiveInt?: Maybe<Element>;
  /** Nominal position in a series. */
  doseNumberPositiveInt: Scalars['positiveInt'];
  /** Nominal position in a series. */
  _doseNumberString?: Maybe<Element>;
  /** Nominal position in a series. */
  doseNumberString: Scalars['String'];
  /** The recommended number of doses to achieve immunity. */
  _seriesDosesPositiveInt?: Maybe<Element>;
  /** The recommended number of doses to achieve immunity. */
  seriesDosesPositiveInt?: Maybe<Scalars['positiveInt']>;
  /** The recommended number of doses to achieve immunity. */
  _seriesDosesString?: Maybe<Element>;
  /** The recommended number of doses to achieve immunity. */
  seriesDosesString?: Maybe<Scalars['String']>;
};

export type ImmunizationprotocolApplied_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** One possible path to achieve presumed immunity against a disease - within the context of an authority. */
  _series?: Maybe<Element_Input>;
  /** One possible path to achieve presumed immunity against a disease - within the context of an authority. */
  series?: Maybe<Scalars['String']>;
  /** Indicates the authority who published the protocol (e.g. ACIP) that is being followed. */
  authority?: Maybe<Scalars['String']>;
  /** The vaccine preventable disease the dose is being administered against. */
  targetDisease?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Nominal position in a series. */
  _doseNumberPositiveInt?: Maybe<Element_Input>;
  /** Nominal position in a series. */
  doseNumberPositiveInt: Scalars['positiveInt'];
  /** Nominal position in a series. */
  _doseNumberString?: Maybe<Element_Input>;
  /** Nominal position in a series. */
  doseNumberString: Scalars['String'];
  /** The recommended number of doses to achieve immunity. */
  _seriesDosesPositiveInt?: Maybe<Element_Input>;
  /** The recommended number of doses to achieve immunity. */
  seriesDosesPositiveInt?: Maybe<Scalars['positiveInt']>;
  /** The recommended number of doses to achieve immunity. */
  _seriesDosesString?: Maybe<Element_Input>;
  /** The recommended number of doses to achieve immunity. */
  seriesDosesString?: Maybe<Scalars['String']>;
};

/** Indicates the authority who published the protocol (e.g. ACIP) that is being followed. */
export type ImmunizationprotocolAppliedauthority_Authority_Union = Organization;

export type Immunizationreaction = {
  __typename?: 'Immunizationreaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Date of reaction to the immunization. */
  _date?: Maybe<Element>;
  /** Date of reaction to the immunization. */
  date?: Maybe<Scalars['dateTime']>;
  /** Details of the reaction. */
  detail?: Maybe<Immunizationreactiondetail_Detail_Union>;
  /** Self-reported indicator. */
  _reported?: Maybe<Element>;
  /** Self-reported indicator. */
  reported?: Maybe<Scalars['Boolean']>;
};

export type Immunizationreaction_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Date of reaction to the immunization. */
  _date?: Maybe<Element_Input>;
  /** Date of reaction to the immunization. */
  date?: Maybe<Scalars['dateTime']>;
  /** Details of the reaction. */
  detail?: Maybe<Scalars['String']>;
  /** Self-reported indicator. */
  _reported?: Maybe<Element_Input>;
  /** Self-reported indicator. */
  reported?: Maybe<Scalars['Boolean']>;
};

/** Details of the reaction. */
export type Immunizationreactiondetail_Detail_Union = Observation;

/** Condition, Observation or DiagnosticReport that supports why the immunization was administered. */
export type ImmunizationreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport;

/**
 * A set of rules of how a particular interoperability or standards problem is
 * solved - typically through the use of FHIR resources. This resource is used to
 * gather all the parts of an implementation guide into a logical whole and to
 * publish a computable definition of all the parts.
 */
export type ImplementationGuide = {
  __typename?: 'ImplementationGuide';
  /** Type of resource */
  resourceType: ImplementationGuide_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this implementation guide when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this implementation
   * guide is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the implementation guide is stored on
   * different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this implementation guide when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this implementation
   * guide is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the implementation guide is stored on
   * different servers.
   */
  url: Scalars['uri'];
  /**
   * The identifier that is used to identify this version of the implementation
   * guide when it is referenced in a specification, model, design or instance.
   * This is an arbitrary value managed by the implementation guide author and is
   * not expected to be globally unique. For example, it might be a timestamp (e.g.
   * yyyymmdd) if a managed version is not available. There is also no expectation
   * that versions can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the implementation
   * guide when it is referenced in a specification, model, design or instance.
   * This is an arbitrary value managed by the implementation guide author and is
   * not expected to be globally unique. For example, it might be a timestamp (e.g.
   * yyyymmdd) if a managed version is not available. There is also no expectation
   * that versions can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the implementation guide. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the implementation guide. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  name: Scalars['String'];
  /** A short, descriptive, user-friendly title for the implementation guide. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the implementation guide. */
  title?: Maybe<Scalars['String']>;
  /** The status of this implementation guide. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this implementation guide. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this implementation guide is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this implementation guide is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the implementation guide was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the implementation guide changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the implementation guide was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the implementation guide changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the implementation guide. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the implementation guide. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the implementation guide from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the implementation guide from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate
   * implementation guide instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the implementation guide is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * A copyright statement relating to the implementation guide and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the implementation guide.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the implementation guide and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the implementation guide.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The NPM package name for this Implementation Guide, used in the NPM package
   * distribution, which is the primary mechanism by which FHIR based tooling
   * manages IG dependencies. This value must be globally unique, and should be
   * assigned with care.
   */
  _packageId?: Maybe<Element>;
  /**
   * The NPM package name for this Implementation Guide, used in the NPM package
   * distribution, which is the primary mechanism by which FHIR based tooling
   * manages IG dependencies. This value must be globally unique, and should be
   * assigned with care.
   */
  packageId: Scalars['id'];
  /** The license that applies to this Implementation Guide, using an SPDX license code, or 'not-open-source'. */
  _license?: Maybe<Element>;
  /** The license that applies to this Implementation Guide, using an SPDX license code, or 'not-open-source'. */
  license?: Maybe<Scalars['code']>;
  /**
   * The version(s) of the FHIR specification that this ImplementationGuide targets
   * - e.g. describes how to use. The value of this element is the formal version
   * of the specification, without the revision number, e.g.
   * [publication].[major].[minor], which is 4.0.0. for this version.
   */
  _fhirVersion?: Maybe<Element>;
  /**
   * The version(s) of the FHIR specification that this ImplementationGuide targets
   * - e.g. describes how to use. The value of this element is the formal version
   * of the specification, without the revision number, e.g.
   * [publication].[major].[minor], which is 4.0.0. for this version.
   */
  fhirVersion?: Maybe<Array<Scalars['code']>>;
  /**
   * Another implementation guide that this implementation depends on. Typically,
   * an implementation guide uses value sets, profiles etc.defined in other
   * implementation guides.
   */
  dependsOn?: Maybe<Array<Maybe<ImplementationGuidedependsOn>>>;
  /** A set of profiles that all resources covered by this implementation guide must conform to. */
  global?: Maybe<Array<Maybe<ImplementationGuideglobal>>>;
  /** The information needed by an IG publisher tool to publish the whole implementation guide. */
  definition?: Maybe<ImplementationGuidedefinition>;
  /** Information about an assembled implementation guide, created by the publication tooling. */
  manifest?: Maybe<ImplementationGuidemanifest>;
};

export enum ImplementationGuide_Enum_Schema {
  ImplementationGuide = 'ImplementationGuide'
}

export type ImplementationGuidedefinition = {
  __typename?: 'ImplementationGuidedefinition';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A logical group of resources. Logical groups can be used when building pages. */
  grouping?: Maybe<Array<Maybe<ImplementationGuidedefinitiongrouping>>>;
  /**
   * A resource that is part of the implementation guide. Conformance resources
   * (value set, structure definition, capability statements etc.) are obvious
   * candidates for inclusion, but any kind of resource can be included as an
   * example resource.
   */
  resource?: Maybe<Array<ImplementationGuidedefinitionresource>>;
  /** A page / section in the implementation guide. The root page is the implementation guide home page. */
  page?: Maybe<ImplementationGuidedefinitionpage>;
  /** Defines how IG is built by tools. */
  parameter?: Maybe<Array<Maybe<ImplementationGuidedefinitionparameter>>>;
  /** A template for building resources. */
  template?: Maybe<Array<Maybe<ImplementationGuidedefinitiontemplate>>>;
};

export type ImplementationGuidedefinitiongrouping = {
  __typename?: 'ImplementationGuidedefinitiongrouping';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The human-readable title to display for the package of resources when rendering the implementation guide. */
  _name?: Maybe<Element>;
  /** The human-readable title to display for the package of resources when rendering the implementation guide. */
  name: Scalars['String'];
  /** Human readable text describing the package. */
  _description?: Maybe<Element>;
  /** Human readable text describing the package. */
  description?: Maybe<Scalars['String']>;
};

export type ImplementationGuidedefinitionpage = {
  __typename?: 'ImplementationGuidedefinitionpage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The source address for the page. */
  _nameUrl?: Maybe<Element>;
  /** The source address for the page. */
  nameUrl: Scalars['url'];
  /** The source address for the page. */
  nameReference: ImplementationGuidedefinitionpagenameReference_NameReference_Union;
  /** A short title used to represent this page in navigational structures such as table of contents, bread crumbs, etc. */
  _title?: Maybe<Element>;
  /** A short title used to represent this page in navigational structures such as table of contents, bread crumbs, etc. */
  title: Scalars['String'];
  /** A code that indicates how the page is generated. */
  _generation?: Maybe<Element>;
  /** A code that indicates how the page is generated. */
  generation: Scalars['code'];
};

/** The source address for the page. */
export type ImplementationGuidedefinitionpagenameReference_NameReference_Union = Binary;

export type ImplementationGuidedefinitionparameter = {
  __typename?: 'ImplementationGuidedefinitionparameter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * apply | path-resource | path-pages | path-tx-cache | expansion-parameter |
   * rule-broken-links | generate-xml | generate-json | generate-turtle | html-template.
   */
  _code?: Maybe<Element>;
  /**
   * apply | path-resource | path-pages | path-tx-cache | expansion-parameter |
   * rule-broken-links | generate-xml | generate-json | generate-turtle | html-template.
   */
  code: Scalars['code'];
  /** Value for named type. */
  _value?: Maybe<Element>;
  /** Value for named type. */
  value: Scalars['String'];
};

export type ImplementationGuidedefinitionresource = {
  __typename?: 'ImplementationGuidedefinitionresource';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Where this resource is found. */
  reference: ImplementationGuidedefinitionresourcereference_Reference_Union;
  /**
   * Indicates the FHIR Version(s) this artifact is intended to apply to. If no
   * versions are specified, the resource is assumed to apply to all the versions
   * stated in ImplementationGuide.fhirVersion.
   */
  _fhirVersion?: Maybe<Element>;
  /**
   * Indicates the FHIR Version(s) this artifact is intended to apply to. If no
   * versions are specified, the resource is assumed to apply to all the versions
   * stated in ImplementationGuide.fhirVersion.
   */
  fhirVersion?: Maybe<Array<Maybe<Scalars['code']>>>;
  /**
   * A human assigned name for the resource. All resources SHOULD have a name, but
   * the name may be extracted from the resource (e.g. ValueSet.name).
   */
  _name?: Maybe<Element>;
  /**
   * A human assigned name for the resource. All resources SHOULD have a name, but
   * the name may be extracted from the resource (e.g. ValueSet.name).
   */
  name?: Maybe<Scalars['String']>;
  /** A description of the reason that a resource has been included in the implementation guide. */
  _description?: Maybe<Element>;
  /** A description of the reason that a resource has been included in the implementation guide. */
  description?: Maybe<Scalars['String']>;
  /**
   * If true or a reference, indicates the resource is an example instance.  If a
   * reference is present, indicates that the example is an example of the
   * specified profile.
   */
  _exampleBoolean?: Maybe<Element>;
  /**
   * If true or a reference, indicates the resource is an example instance.  If a
   * reference is present, indicates that the example is an example of the
   * specified profile.
   */
  exampleBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * If true or a reference, indicates the resource is an example instance.  If a
   * reference is present, indicates that the example is an example of the
   * specified profile.
   */
  _exampleCanonical?: Maybe<Element>;
  /**
   * If true or a reference, indicates the resource is an example instance.  If a
   * reference is present, indicates that the example is an example of the
   * specified profile.
   */
  exampleCanonical?: Maybe<Scalars['canonical']>;
  /** Reference to the id of the grouping this resource appears in. */
  _groupingId?: Maybe<Element>;
  /** Reference to the id of the grouping this resource appears in. */
  groupingId?: Maybe<Scalars['id']>;
};

/** Where this resource is found. */
export type ImplementationGuidedefinitionresourcereference_Reference_Union = Resource;

export type ImplementationGuidedefinitiontemplate = {
  __typename?: 'ImplementationGuidedefinitiontemplate';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of template specified. */
  _code?: Maybe<Element>;
  /** Type of template specified. */
  code: Scalars['code'];
  /** The source location for the template. */
  _source?: Maybe<Element>;
  /** The source location for the template. */
  source: Scalars['String'];
  /** The scope in which the template applies. */
  _scope?: Maybe<Element>;
  /** The scope in which the template applies. */
  scope?: Maybe<Scalars['String']>;
};

export type ImplementationGuidedependsOn = {
  __typename?: 'ImplementationGuidedependsOn';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A canonical reference to the Implementation guide for the dependency. */
  _uri?: Maybe<Element>;
  /** A canonical reference to the Implementation guide for the dependency. */
  uri: Scalars['canonical'];
  /** The NPM package name for the Implementation Guide that this IG depends on. */
  _packageId?: Maybe<Element>;
  /** The NPM package name for the Implementation Guide that this IG depends on. */
  packageId?: Maybe<Scalars['id']>;
  /** The version of the IG that is depended on, when the correct version is required to understand the IG correctly. */
  _version?: Maybe<Element>;
  /** The version of the IG that is depended on, when the correct version is required to understand the IG correctly. */
  version?: Maybe<Scalars['String']>;
};

export type ImplementationGuideglobal = {
  __typename?: 'ImplementationGuideglobal';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of resource that all instances must conform to. */
  _type?: Maybe<Element>;
  /** The type of resource that all instances must conform to. */
  type: Scalars['code'];
  /** A reference to the profile that all instances must conform to. */
  _profile?: Maybe<Element>;
  /** A reference to the profile that all instances must conform to. */
  profile: Scalars['canonical'];
};

export type ImplementationGuidemanifest = {
  __typename?: 'ImplementationGuidemanifest';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A pointer to official web page, PDF or other rendering of the implementation guide. */
  _rendering?: Maybe<Element>;
  /** A pointer to official web page, PDF or other rendering of the implementation guide. */
  rendering?: Maybe<Scalars['url']>;
  /**
   * A resource that is part of the implementation guide. Conformance resources
   * (value set, structure definition, capability statements etc.) are obvious
   * candidates for inclusion, but any kind of resource can be included as an
   * example resource.
   */
  resource?: Maybe<Array<ImplementationGuidemanifestresource>>;
  /** Information about a page within the IG. */
  page?: Maybe<Array<Maybe<ImplementationGuidemanifestpage>>>;
  /** Indicates a relative path to an image that exists within the IG. */
  _image?: Maybe<Element>;
  /** Indicates a relative path to an image that exists within the IG. */
  image?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Indicates the relative path of an additional non-page, non-image file that is
   * part of the IG - e.g. zip, jar and similar files that could be the target of a
   * hyperlink in a derived IG.
   */
  _other?: Maybe<Element>;
  /**
   * Indicates the relative path of an additional non-page, non-image file that is
   * part of the IG - e.g. zip, jar and similar files that could be the target of a
   * hyperlink in a derived IG.
   */
  other?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ImplementationGuidemanifestpage = {
  __typename?: 'ImplementationGuidemanifestpage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Relative path to the page. */
  _name?: Maybe<Element>;
  /** Relative path to the page. */
  name: Scalars['String'];
  /** Label for the page intended for human display. */
  _title?: Maybe<Element>;
  /** Label for the page intended for human display. */
  title?: Maybe<Scalars['String']>;
  /** The name of an anchor available on the page. */
  _anchor?: Maybe<Element>;
  /** The name of an anchor available on the page. */
  anchor?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ImplementationGuidemanifestresource = {
  __typename?: 'ImplementationGuidemanifestresource';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Where this resource is found. */
  reference: ImplementationGuidemanifestresourcereference_Reference_Union;
  /**
   * If true or a reference, indicates the resource is an example instance.  If a
   * reference is present, indicates that the example is an example of the
   * specified profile.
   */
  _exampleBoolean?: Maybe<Element>;
  /**
   * If true or a reference, indicates the resource is an example instance.  If a
   * reference is present, indicates that the example is an example of the
   * specified profile.
   */
  exampleBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * If true or a reference, indicates the resource is an example instance.  If a
   * reference is present, indicates that the example is an example of the
   * specified profile.
   */
  _exampleCanonical?: Maybe<Element>;
  /**
   * If true or a reference, indicates the resource is an example instance.  If a
   * reference is present, indicates that the example is an example of the
   * specified profile.
   */
  exampleCanonical?: Maybe<Scalars['canonical']>;
  /** The relative path for primary page for this resource within the IG. */
  _relativePath?: Maybe<Element>;
  /** The relative path for primary page for this resource within the IG. */
  relativePath?: Maybe<Scalars['url']>;
};

/** Where this resource is found. */
export type ImplementationGuidemanifestresourcereference_Reference_Union = Resource;

/** Details of a Health Insurance product/plan provided by an organization. */
export type InsurancePlan = {
  __typename?: 'InsurancePlan';
  /** Type of resource */
  resourceType: InsurancePlan_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this health insurance product which remain
   * constant as the resource is updated and propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The current state of the health insurance product. */
  _status?: Maybe<Element>;
  /** The current state of the health insurance product. */
  status?: Maybe<Scalars['code']>;
  /** The kind of health insurance product. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Official name of the health insurance product as designated by the owner. */
  _name?: Maybe<Element>;
  /** Official name of the health insurance product as designated by the owner. */
  name?: Maybe<Scalars['String']>;
  /** A list of alternate names that the product is known as, or was known as in the past. */
  _alias?: Maybe<Element>;
  /** A list of alternate names that the product is known as, or was known as in the past. */
  alias?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The period of time that the health insurance product is available. */
  period?: Maybe<Period>;
  /**
   * The entity that is providing  the health insurance product and underwriting
   * the risk.  This is typically an insurance carriers, other third-party payers,
   * or health plan sponsors comonly referred to as 'payers'.
   */
  ownedBy?: Maybe<InsurancePlanownedBy_OwnedBy_Union>;
  /**
   * An organization which administer other services such as underwriting, customer
   * service and/or claims processing on behalf of the health insurance product owner.
   */
  administeredBy?: Maybe<InsurancePlanadministeredBy_AdministeredBy_Union>;
  /** The geographic region in which a health insurance product's benefits apply. */
  coverageArea?: Maybe<Array<Maybe<InsurancePlancoverageArea_CoverageArea_Union>>>;
  /** The contact for the health insurance product for a certain purpose. */
  contact?: Maybe<Array<Maybe<InsurancePlancontact>>>;
  /** The technical endpoints providing access to services operated for the health insurance product. */
  endpoint?: Maybe<Array<Maybe<InsurancePlanendpoint_Endpoint_Union>>>;
  /** Reference to the network included in the health insurance product. */
  network?: Maybe<Array<Maybe<InsurancePlannetwork_Network_Union>>>;
  /** Details about the coverage offered by the insurance product. */
  coverage?: Maybe<Array<Maybe<InsurancePlancoverage>>>;
  /** Details about an insurance plan. */
  plan?: Maybe<Array<Maybe<InsurancePlanplan>>>;
};

export enum InsurancePlan_Enum_Schema {
  InsurancePlan = 'InsurancePlan'
}

/**
 * An organization which administer other services such as underwriting, customer
 * service and/or claims processing on behalf of the health insurance product owner.
 */
export type InsurancePlanadministeredBy_AdministeredBy_Union = Organization;

export type InsurancePlancontact = {
  __typename?: 'InsurancePlancontact';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates a purpose for which the contact can be reached. */
  purpose?: Maybe<CodeableConcept>;
  /** A name associated with the contact. */
  name?: Maybe<HumanName>;
  /** A contact detail (e.g. a telephone number or an email address) by which the party may be contacted. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** Visiting or postal addresses for the contact. */
  address?: Maybe<Address>;
};

export type InsurancePlancoverage = {
  __typename?: 'InsurancePlancoverage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Type of coverage  (Medical; Dental; Mental Health; Substance Abuse; Vision;
   * Drug; Short Term; Long Term Care; Hospice; Home Health).
   */
  type: CodeableConcept;
  /** Reference to the network that providing the type of coverage. */
  network?: Maybe<Array<Maybe<InsurancePlancoveragenetwork_Network_Union>>>;
  /** Specific benefits under this type of coverage. */
  benefit?: Maybe<Array<InsurancePlancoveragebenefit>>;
};

/** The geographic region in which a health insurance product's benefits apply. */
export type InsurancePlancoverageArea_CoverageArea_Union = Location;

export type InsurancePlancoveragebenefit = {
  __typename?: 'InsurancePlancoveragebenefit';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of benefit (primary care; speciality care; inpatient; outpatient). */
  type: CodeableConcept;
  /** The referral requirements to have access/coverage for this benefit. */
  _requirement?: Maybe<Element>;
  /** The referral requirements to have access/coverage for this benefit. */
  requirement?: Maybe<Scalars['String']>;
  /** The specific limits on the benefit. */
  limit?: Maybe<Array<Maybe<InsurancePlancoveragebenefitlimit>>>;
};

export type InsurancePlancoveragebenefitlimit = {
  __typename?: 'InsurancePlancoveragebenefitlimit';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The maximum amount of a service item a plan will pay for a covered benefit.  For examples. wellness visits, or eyeglasses. */
  value?: Maybe<Quantity>;
  /** The specific limit on the benefit. */
  code?: Maybe<CodeableConcept>;
};

/** Reference to the network that providing the type of coverage. */
export type InsurancePlancoveragenetwork_Network_Union = Organization;

/** The technical endpoints providing access to services operated for the health insurance product. */
export type InsurancePlanendpoint_Endpoint_Union = Endpoint;

/** Reference to the network included in the health insurance product. */
export type InsurancePlannetwork_Network_Union = Organization;

/**
 * The entity that is providing  the health insurance product and underwriting the
 * risk.  This is typically an insurance carriers, other third-party payers, or
 * health plan sponsors comonly referred to as 'payers'.
 */
export type InsurancePlanownedBy_OwnedBy_Union = Organization;

export type InsurancePlanplan = {
  __typename?: 'InsurancePlanplan';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this health insurance plan which remain
   * constant as the resource is updated and propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Type of plan. For example, 'Platinum' or 'High Deductable'. */
  type?: Maybe<CodeableConcept>;
  /** The geographic region in which a health insurance plan's benefits apply. */
  coverageArea?: Maybe<Array<Maybe<InsurancePlanplancoverageArea_CoverageArea_Union>>>;
  /** Reference to the network that providing the type of coverage. */
  network?: Maybe<Array<Maybe<InsurancePlanplannetwork_Network_Union>>>;
  /** Overall costs associated with the plan. */
  generalCost?: Maybe<Array<Maybe<InsurancePlanplangeneralCost>>>;
  /** Costs associated with the coverage provided by the product. */
  specificCost?: Maybe<Array<Maybe<InsurancePlanplanspecificCost>>>;
};

/** The geographic region in which a health insurance plan's benefits apply. */
export type InsurancePlanplancoverageArea_CoverageArea_Union = Location;

export type InsurancePlanplangeneralCost = {
  __typename?: 'InsurancePlanplangeneralCost';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of cost. */
  type?: Maybe<CodeableConcept>;
  /** Number of participants enrolled in the plan. */
  _groupSize?: Maybe<Element>;
  /** Number of participants enrolled in the plan. */
  groupSize?: Maybe<Scalars['positiveInt']>;
  /** Value of the cost. */
  cost?: Maybe<Money>;
  /** Additional information about the general costs associated with this plan. */
  _comment?: Maybe<Element>;
  /** Additional information about the general costs associated with this plan. */
  comment?: Maybe<Scalars['String']>;
};

/** Reference to the network that providing the type of coverage. */
export type InsurancePlanplannetwork_Network_Union = Organization;

export type InsurancePlanplanspecificCost = {
  __typename?: 'InsurancePlanplanspecificCost';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** General category of benefit (Medical; Dental; Vision; Drug; Mental Health; Substance Abuse; Hospice, Home Health). */
  category: CodeableConcept;
  /** List of the specific benefits under this category of benefit. */
  benefit?: Maybe<Array<Maybe<InsurancePlanplanspecificCostbenefit>>>;
};

export type InsurancePlanplanspecificCostbenefit = {
  __typename?: 'InsurancePlanplanspecificCostbenefit';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Type of specific benefit (preventative; primary care office visit; speciality
   * office visit; hospitalization; emergency room; urgent care).
   */
  type: CodeableConcept;
  /** List of the costs associated with a specific benefit. */
  cost?: Maybe<Array<Maybe<InsurancePlanplanspecificCostbenefitcost>>>;
};

export type InsurancePlanplanspecificCostbenefitcost = {
  __typename?: 'InsurancePlanplanspecificCostbenefitcost';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of cost (copay; individual cap; family cap; coinsurance; deductible). */
  type: CodeableConcept;
  /** Whether the cost applies to in-network or out-of-network providers (in-network; out-of-network; other). */
  applicability?: Maybe<CodeableConcept>;
  /** Additional information about the cost, such as information about funding sources (e.g. HSA, HRA, FSA, RRA). */
  qualifiers?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The actual cost value. (some of the costs may be represented as percentages rather than currency, e.g. 10% coinsurance). */
  value?: Maybe<Quantity>;
};

/** Invoice containing collected ChargeItems from an Account with calculated individual and total price for Billing purpose. */
export type Invoice = {
  __typename?: 'Invoice';
  /** Type of resource */
  resourceType: Invoice_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier of this Invoice, often used for reference in correspondence about this invoice or for tracking of payments. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The current state of the Invoice. */
  _status?: Maybe<Element>;
  /** The current state of the Invoice. */
  status: Scalars['code'];
  /** In case of Invoice cancellation a reason must be given (entered in error, superseded by corrected invoice etc.). */
  _cancelledReason?: Maybe<Element>;
  /** In case of Invoice cancellation a reason must be given (entered in error, superseded by corrected invoice etc.). */
  cancelledReason?: Maybe<Scalars['String']>;
  /** Type of Invoice depending on domain, realm an usage (e.g. internal/external, dental, preliminary). */
  type?: Maybe<CodeableConcept>;
  /** The individual or set of individuals receiving the goods and services billed in this invoice. */
  subject?: Maybe<Invoicesubject_Subject_Union>;
  /** The individual or Organization responsible for balancing of this invoice. */
  recipient?: Maybe<Invoicerecipient_Recipient_Union>;
  /** Date/time(s) of when this Invoice was posted. */
  _date?: Maybe<Element>;
  /** Date/time(s) of when this Invoice was posted. */
  date?: Maybe<Scalars['dateTime']>;
  /** Indicates who or what performed or participated in the charged service. */
  participant?: Maybe<Array<Maybe<Invoiceparticipant>>>;
  /** The organizationissuing the Invoice. */
  issuer?: Maybe<Invoiceissuer_Issuer_Union>;
  /** Account which is supposed to be balanced with this Invoice. */
  account?: Maybe<Invoiceaccount_Account_Union>;
  /**
   * Each line item represents one charge for goods and services rendered. Details
   * such as date, code and amount are found in the referenced ChargeItem resource.
   */
  lineItem?: Maybe<Array<Maybe<InvoicelineItem>>>;
  /** Invoice total , taxes excluded. */
  totalNet?: Maybe<Money>;
  /** Invoice total, tax included. */
  totalGross?: Maybe<Money>;
  /** Payment details such as banking details, period of payment, deductibles, methods of payment. */
  _paymentTerms?: Maybe<Element>;
  /** Payment details such as banking details, period of payment, deductibles, methods of payment. */
  paymentTerms?: Maybe<Scalars['String']>;
  /** Comments made about the invoice by the issuer, subject, or other participants. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export enum Invoice_Enum_Schema {
  Invoice = 'Invoice'
}

/** Account which is supposed to be balanced with this Invoice. */
export type Invoiceaccount_Account_Union = Account;

/** The organizationissuing the Invoice. */
export type Invoiceissuer_Issuer_Union = Organization;

export type InvoicelineItem = {
  __typename?: 'InvoicelineItem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Sequence in which the items appear on the invoice. */
  _sequence?: Maybe<Element>;
  /** Sequence in which the items appear on the invoice. */
  sequence?: Maybe<Scalars['positiveInt']>;
  /**
   * The ChargeItem contains information such as the billing code, date, amount
   * etc. If no further details are required for the lineItem, inline billing codes
   * can be added using the CodeableConcept data type instead of the Reference.
   */
  chargeItemReference: InvoicelineItemchargeItemReference_ChargeItemReference_Union;
  /**
   * The ChargeItem contains information such as the billing code, date, amount
   * etc. If no further details are required for the lineItem, inline billing codes
   * can be added using the CodeableConcept data type instead of the Reference.
   */
  chargeItemCodeableConcept: CodeableConcept;
  /**
   * The price for a ChargeItem may be calculated as a base price with
   * surcharges/deductions that apply in certain conditions. A ChargeItemDefinition
   * resource that defines the prices, factors and conditions that apply to a
   * billing code is currently under development. The priceComponent element can be
   * used to offer transparency to the recipient of the Invoice as to how the
   * prices have been calculated.
   */
  priceComponent?: Maybe<Array<Maybe<InvoicelineItempriceComponent>>>;
};

/**
 * The ChargeItem contains information such as the billing code, date, amount etc.
 * If no further details are required for the lineItem, inline billing codes can be
 * added using the CodeableConcept data type instead of the Reference.
 */
export type InvoicelineItemchargeItemReference_ChargeItemReference_Union = ChargeItem;

export type InvoicelineItempriceComponent = {
  __typename?: 'InvoicelineItempriceComponent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** This code identifies the type of the component. */
  _type?: Maybe<Element>;
  /** This code identifies the type of the component. */
  type: Scalars['code'];
  /**
   * A code that identifies the component. Codes may be used to differentiate
   * between kinds of taxes, surcharges, discounts etc.
   */
  code?: Maybe<CodeableConcept>;
  /** The factor that has been applied on the base price for calculating this component. */
  _factor?: Maybe<Element>;
  /** The factor that has been applied on the base price for calculating this component. */
  factor?: Maybe<Scalars['Float']>;
  /** The amount calculated for this component. */
  amount?: Maybe<Money>;
};

export type Invoiceparticipant = {
  __typename?: 'Invoiceparticipant';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Describes the type of involvement (e.g. transcriptionist, creator etc.). If
   * the invoice has been created automatically, the Participant may be a billing
   * engine or another kind of device.
   */
  role?: Maybe<CodeableConcept>;
  /** The device, practitioner, etc. who performed or participated in the service. */
  actor: Invoiceparticipantactor_Actor_Union;
};

/** The device, practitioner, etc. who performed or participated in the service. */
export type Invoiceparticipantactor_Actor_Union = Practitioner | Organization | Patient | PractitionerRole | Device | RelatedPerson;

/** The individual or Organization responsible for balancing of this invoice. */
export type Invoicerecipient_Recipient_Union = Organization | Patient | RelatedPerson;

/** The individual or set of individuals receiving the goods and services billed in this invoice. */
export type Invoicesubject_Subject_Union = Patient | Group;

export enum Jobs_Enum_Input_Schema {
  Jobs = 'Jobs'
}

export enum Jobs_Enum_Schema {
  Jobs = 'Jobs'
}

/** Jobs */
export type Jobs_Input = {
  /** Type of resource */
  resourceType: Jobs_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  jobDescription?: Maybe<Scalars['String']>;
  /** firstName. */
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  aboutDescription?: Maybe<Scalars['String']>;
  resumeUrl?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
};

/** Jobs */
export type Jobs_Schema = {
  __typename?: 'Jobs_Schema';
  /** Type of resource */
  resourceType: Jobs_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  jobDescription?: Maybe<Scalars['String']>;
  /** firstName. */
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  aboutDescription?: Maybe<Scalars['String']>;
  resumeUrl?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
};

export enum Leaflet_Enum_Input_Schema {
  Leaflet = 'Leaflet'
}

export enum Leaflet_Enum_Schema {
  Leaflet = 'Leaflet'
}

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type Leaflet_Input = {
  /** Type of resource */
  resourceType: Leaflet_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** leaflet Created */
  leafletName?: Maybe<Scalars['String']>;
  /** leaflet Created */
  leafletDescription?: Maybe<Scalars['String']>;
  /** leaflet Created */
  lefaletDocumentUrl?: Maybe<Scalars['String']>;
  /** leaflet Created */
  uploadedBy?: Maybe<Scalars['String']>;
  /** leaflet Created */
  uploadedDate?: Maybe<Scalars['String']>;
  /** leaflet Created */
  leafletSearchtag?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** leaflet Created */
  uploadedUserName?: Maybe<Scalars['String']>;
  /** Shared Leaflet count */
  documentSharedCount?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Type: Custom Fields . */
export type Leaflet_Schema = {
  __typename?: 'Leaflet_Schema';
  /** Type of resource */
  resourceType: Leaflet_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** leaflet Created */
  leafletName?: Maybe<Scalars['String']>;
  /** leaflet Created */
  leafletDescription?: Maybe<Scalars['String']>;
  /** leaflet Created */
  lefaletDocumentUrl?: Maybe<Scalars['String']>;
  /** leaflet Created */
  uploadedBy?: Maybe<Scalars['String']>;
  /** leaflet Created */
  uploadedDate?: Maybe<Scalars['String']>;
  /** leaflet Created */
  leafletSearchtag?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** leaflet count */
  count?: Maybe<Scalars['Int']>;
  /** leaflet Created */
  uploadedUserName?: Maybe<Scalars['String']>;
  /** Leaflet shared */
  sendById?: Maybe<Scalars['String']>;
  /** Leaflet shared */
  sendByName?: Maybe<Scalars['String']>;
  /** Leaflet shared */
  sendDate?: Maybe<Scalars['String']>;
  /** Leaflet shared */
  patientId?: Maybe<Scalars['String']>;
  /** Shared Leaflet count */
  documentSharedCount?: Maybe<Scalars['Int']>;
  /** Shared Leaflet Details */
  documentSharedDetails?: Maybe<Scalars['String']>;
  /** Sort by most shared */
  orderByMostShare?: Maybe<Scalars['Boolean']>;
};

/**
 * The Library resource is a general-purpose container for knowledge asset
 * definitions. It can be used to describe and expose existing knowledge assets
 * such as logic libraries and information model descriptions, as well as to
 * describe a collection of knowledge assets.
 */
export type Library = {
  __typename?: 'Library';
  /** Type of resource */
  resourceType: Library_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this library when it is referenced in
   * a specification, model, design or an instance; also called its canonical
   * identifier. This SHOULD be globally unique and SHOULD be a literal address at
   * which at which an authoritative instance of this library is (or will be)
   * published. This URL can be the target of a canonical reference. It SHALL
   * remain the same when the library is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this library when it is referenced in
   * a specification, model, design or an instance; also called its canonical
   * identifier. This SHOULD be globally unique and SHOULD be a literal address at
   * which at which an authoritative instance of this library is (or will be)
   * published. This URL can be the target of a canonical reference. It SHALL
   * remain the same when the library is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this library when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance. e.g. CMS or NQF identifiers for a measure artifact. Note that
   * at least one identifier is required for non-experimental active artifacts.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the library when it is
   * referenced in a specification, model, design or instance. This is an arbitrary
   * value managed by the library author and is not expected to be globally unique.
   * For example, it might be a timestamp (e.g. yyyymmdd) if a managed version is
   * not available. There is also no expectation that versions can be placed in a
   * lexicographical sequence. To provide a version consistent with the Decision
   * Support Service specification, use the format Major.Minor.Revision (e.g.
   * 1.0.0). For more information on versioning knowledge assets, refer to the
   * Decision Support Service specification. Note that a version is required for
   * non-experimental active artifacts.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the library when it is
   * referenced in a specification, model, design or instance. This is an arbitrary
   * value managed by the library author and is not expected to be globally unique.
   * For example, it might be a timestamp (e.g. yyyymmdd) if a managed version is
   * not available. There is also no expectation that versions can be placed in a
   * lexicographical sequence. To provide a version consistent with the Decision
   * Support Service specification, use the format Major.Minor.Revision (e.g.
   * 1.0.0). For more information on versioning knowledge assets, refer to the
   * Decision Support Service specification. Note that a version is required for
   * non-experimental active artifacts.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the library. This name should be usable as
   * an identifier for the module by machine processing applications such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the library. This name should be usable as
   * an identifier for the module by machine processing applications such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the library. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the library. */
  title?: Maybe<Scalars['String']>;
  /** An explanatory or alternate title for the library giving additional information about its content. */
  _subtitle?: Maybe<Element>;
  /** An explanatory or alternate title for the library giving additional information about its content. */
  subtitle?: Maybe<Scalars['String']>;
  /** The status of this library. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this library. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this library is authored for testing purposes
   * (or education/evaluation/marketing) and is not intended to be used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this library is authored for testing purposes
   * (or education/evaluation/marketing) and is not intended to be used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /** Identifies the type of library such as a Logic Library, Model Definition, Asset Collection, or Module Definition. */
  type: CodeableConcept;
  /** A code or group definition that describes the intended subject of the contents of the library. */
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  /** A code or group definition that describes the intended subject of the contents of the library. */
  subjectReference?: Maybe<LibrarysubjectReference_SubjectReference_Union>;
  /**
   * The date  (and optionally time) when the library was published. The date must
   * change when the business version changes and it must change if the status code
   * changes. In addition, it should change when the substantive content of the
   * library changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the library was published. The date must
   * change when the business version changes and it must change if the status code
   * changes. In addition, it should change when the substantive content of the
   * library changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the library. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the library. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the library from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the library from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate library instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the library is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this library is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this library is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /** A detailed description of how the library is used from a clinical perspective. */
  _usage?: Maybe<Element>;
  /** A detailed description of how the library is used from a clinical perspective. */
  usage?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the library and/or its contents. Copyright
   * statements are generally legal restrictions on the use and publishing of the library.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the library and/or its contents. Copyright
   * statements are generally legal restrictions on the use and publishing of the library.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the library content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the content of the library. Topics provide a
   * high-level categorization of the library that can be useful for filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related artifacts such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** The parameter element defines parameters used by the library. */
  parameter?: Maybe<Array<Maybe<ParameterDefinition>>>;
  /**
   * Describes a set of data that must be provided in order to be able to
   * successfully perform the computations defined by the library.
   */
  dataRequirement?: Maybe<Array<Maybe<DataRequirement>>>;
  /**
   * The content of the library as an Attachment. The content may be a reference to
   * a url, or may be directly embedded as a base-64 string. Either way, the
   * contentType of the attachment determines how to interpret the content.
   */
  content?: Maybe<Array<Maybe<Attachment>>>;
};

export enum Library_Enum_Schema {
  Library = 'Library'
}

/** A code or group definition that describes the intended subject of the contents of the library. */
export type LibrarysubjectReference_SubjectReference_Union = Group;

/** Identifies two or more records (resource instances) that refer to the same real-world 'occurrence'. */
export type Linkage = {
  __typename?: 'Linkage';
  /** Type of resource */
  resourceType: Linkage_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates whether the asserted set of linkages are considered to be 'in effect'. */
  _active?: Maybe<Element>;
  /** Indicates whether the asserted set of linkages are considered to be 'in effect'. */
  active?: Maybe<Scalars['Boolean']>;
  /**
   * Identifies the user or organization responsible for asserting the linkages as
   * well as the user or organization who establishes the context in which the
   * nature of each linkage is evaluated.
   */
  author?: Maybe<Linkageauthor_Author_Union>;
  /**
   * Identifies which record considered as the reference to the same real-world
   * occurrence as well as how the items should be evaluated within the collection
   * of linked items.
   */
  item?: Maybe<Array<Linkageitem>>;
};

export enum Linkage_Enum_Schema {
  Linkage = 'Linkage'
}

/**
 * Identifies the user or organization responsible for asserting the linkages as
 * well as the user or organization who establishes the context in which the nature
 * of each linkage is evaluated.
 */
export type Linkageauthor_Author_Union = Practitioner | PractitionerRole | Organization;

export type Linkageitem = {
  __typename?: 'Linkageitem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Distinguishes which item is 'source of truth' (if any) and which items are no
   * longer considered to be current representations.
   */
  _type?: Maybe<Element>;
  /**
   * Distinguishes which item is 'source of truth' (if any) and which items are no
   * longer considered to be current representations.
   */
  type: Scalars['code'];
  /** The resource instance being linked as part of the group. */
  resource: Linkageitemresource_Resource_Union;
};

/** The resource instance being linked as part of the group. */
export type Linkageitemresource_Resource_Union = Resource;

/** A list is a curated collection of resources. */
export type List = {
  __typename?: 'List';
  /** Type of resource */
  resourceType: List_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier for the List assigned for business purposes outside the context of FHIR. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Indicates the current state of this list. */
  _status?: Maybe<Element>;
  /** Indicates the current state of this list. */
  status: Scalars['code'];
  /**
   * How this list was prepared - whether it is a working list that is suitable for
   * being maintained on an ongoing basis, or if it represents a snapshot of a list
   * of items from another source, or whether it is a prepared list where items may
   * be marked as added, modified or deleted.
   */
  _mode?: Maybe<Element>;
  /**
   * How this list was prepared - whether it is a working list that is suitable for
   * being maintained on an ongoing basis, or if it represents a snapshot of a list
   * of items from another source, or whether it is a prepared list where items may
   * be marked as added, modified or deleted.
   */
  mode: Scalars['code'];
  /** A label for the list assigned by the author. */
  _title?: Maybe<Element>;
  /** A label for the list assigned by the author. */
  title?: Maybe<Scalars['String']>;
  /** This code defines the purpose of the list - why it was created. */
  code?: Maybe<CodeableConcept>;
  /** The common subject (or patient) of the resources that are in the list if there is one. */
  subject?: Maybe<Listsubject_Subject_Union>;
  /** The encounter that is the context in which this list was created. */
  encounter?: Maybe<Listencounter_Encounter_Union>;
  /** The date that the list was prepared. */
  _date?: Maybe<Element>;
  /** The date that the list was prepared. */
  date?: Maybe<Scalars['dateTime']>;
  /**
   * The entity responsible for deciding what the contents of the list were. Where
   * the list was created by a human, this is the same as the author of the list.
   */
  source?: Maybe<Listsource_Source_Union>;
  /** What order applies to the items in the list. */
  orderedBy?: Maybe<CodeableConcept>;
  /** Comments that apply to the overall list. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Entries in this list. */
  entry?: Maybe<Array<Maybe<Listentry>>>;
  /** If the list is empty, why the list is empty. */
  emptyReason?: Maybe<CodeableConcept>;
};

export enum List_Enum_Schema {
  List = 'List'
}

/** The encounter that is the context in which this list was created. */
export type Listencounter_Encounter_Union = Encounter;

export type Listentry = {
  __typename?: 'Listentry';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The flag allows the system constructing the list to indicate the role and significance of the item in the list. */
  flag?: Maybe<CodeableConcept>;
  /** True if this item is marked as deleted in the list. */
  _deleted?: Maybe<Element>;
  /** True if this item is marked as deleted in the list. */
  deleted?: Maybe<Scalars['Boolean']>;
  /** When this item was added to the list. */
  _date?: Maybe<Element>;
  /** When this item was added to the list. */
  date?: Maybe<Scalars['dateTime']>;
  /** A reference to the actual resource from which data was derived. */
  item: Listentryitem_Item_Union;
};

/** A reference to the actual resource from which data was derived. */
export type Listentryitem_Item_Union = Resource;

/**
 * The entity responsible for deciding what the contents of the list were. Where
 * the list was created by a human, this is the same as the author of the list.
 */
export type Listsource_Source_Union = Practitioner | PractitionerRole | Patient | Device;

/** The common subject (or patient) of the resources that are in the list if there is one. */
export type Listsubject_Subject_Union = Patient | Group | Device | Location;

/**
 * Details and position information for a physical place where services are
 * provided and resources and participants may be stored, found, contained, or accommodated.
 */
export type Location = {
  __typename?: 'Location';
  /** Type of resource */
  resourceType: Location_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /** location Extension. */
  locationExtension?: Maybe<LocationExtension_Schema>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique code or number identifying the location to its users. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The status property covers the general availability of the resource, not the
   * current value which may be covered by the operationStatus, or by a
   * schedule/slots if they are configured for the location.
   */
  _status?: Maybe<Element>;
  /**
   * The status property covers the general availability of the resource, not the
   * current value which may be covered by the operationStatus, or by a
   * schedule/slots if they are configured for the location.
   */
  status?: Maybe<Scalars['code']>;
  /**
   * The operational status covers operation values most relevant to beds (but can
   * also apply to rooms/units/chairs/etc. such as an isolation unit/dialysis
   * chair). This typically covers concepts such as contamination, housekeeping,
   * and other activities like maintenance.
   */
  operationalStatus?: Maybe<Coding>;
  /** Name of the location as used by humans. Does not need to be unique. */
  _name?: Maybe<Element>;
  /** Name of the location as used by humans. Does not need to be unique. */
  name?: Maybe<Scalars['String']>;
  /** A list of alternate names that the location is known as, or was known as, in the past. */
  _alias?: Maybe<Element>;
  /** A list of alternate names that the location is known as, or was known as, in the past. */
  alias?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Description of the Location, which helps in finding or referencing the place. */
  _description?: Maybe<Element>;
  /** Description of the Location, which helps in finding or referencing the place. */
  description?: Maybe<Scalars['String']>;
  /** Indicates whether a resource instance represents a specific location or a class of locations. */
  _mode?: Maybe<Element>;
  /** Indicates whether a resource instance represents a specific location or a class of locations. */
  mode?: Maybe<Scalars['code']>;
  /** Indicates the type of function performed at the location. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * The contact details of communication devices available at the location. This
   * can include phone numbers, fax numbers, mobile numbers, email addresses and web sites.
   */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** Physical location. */
  address?: Maybe<Address>;
  /** Physical form of the location, e.g. building, room, vehicle, road. */
  physicalType?: Maybe<CodeableConcept>;
  /**
   * The absolute geographic location of the Location, expressed using the WGS84
   * datum (This is the same co-ordinate system used in KML).
   */
  position?: Maybe<Locationposition>;
  /** The organization responsible for the provisioning and upkeep of the location. */
  managingOrganization?: Maybe<LocationmanagingOrganization_ManagingOrganization_Union>;
  /** Another Location of which this Location is physically a part of. */
  partOf?: Maybe<LocationpartOf_PartOf_Union>;
  /** What days/times during a week is this location usually open. */
  hoursOfOperation?: Maybe<Array<Maybe<LocationhoursOfOperation>>>;
  /**
   * A description of when the locations opening ours are different to normal, e.g.
   * public holiday availability. Succinctly describing all possible exceptions to
   * normal site availability as detailed in the opening hours Times.
   */
  _availabilityExceptions?: Maybe<Element>;
  /**
   * A description of when the locations opening ours are different to normal, e.g.
   * public holiday availability. Succinctly describing all possible exceptions to
   * normal site availability as detailed in the opening hours Times.
   */
  availabilityExceptions?: Maybe<Scalars['String']>;
  /** Technical endpoints providing access to services operated for the location. */
  endpoint?: Maybe<Array<Maybe<Locationendpoint_Endpoint_Union>>>;
};

/** Base StructureDefinition for Location Extension */
export type LocationExtension_Input = {
  /** practitioner Reference data. */
  practitionerReference?: Maybe<Scalars['String']>;
  /** COCID field data. */
  COCID?: Maybe<Scalars['String']>;
  /** GTNID field data. */
  GTNID?: Maybe<Scalars['String']>;
  /** locationRank data. */
  locationRank?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Location Extension Schema */
export type LocationExtension_Schema = {
  __typename?: 'LocationExtension_Schema';
  /** practitioner Reference data. */
  practitionerReference?: Maybe<Scalars['String']>;
  /** COCID field data. */
  COCID?: Maybe<Scalars['String']>;
  /** GTNID field data. */
  GTNID?: Maybe<Scalars['String']>;
  /** locationRank data. */
  locationRank?: Maybe<Scalars['Int']>;
};

export enum Location_Enum_Input {
  Location = 'Location'
}

export enum Location_Enum_Schema {
  Location = 'Location'
}

/**
 * Details and position information for a physical place where services are
 * provided and resources and participants may be stored, found, contained, or accommodated.
 */
export type Location_Input = {
  /** Type of resource */
  resourceType: Location_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** location Extension. */
  locationExtension?: Maybe<LocationExtension_Input>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Unique code or number identifying the location to its users. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /**
   * The status property covers the general availability of the resource, not the
   * current value which may be covered by the operationStatus, or by a
   * schedule/slots if they are configured for the location.
   */
  _status?: Maybe<Element_Input>;
  /**
   * The status property covers the general availability of the resource, not the
   * current value which may be covered by the operationStatus, or by a
   * schedule/slots if they are configured for the location.
   */
  status?: Maybe<Scalars['code']>;
  /**
   * The operational status covers operation values most relevant to beds (but can
   * also apply to rooms/units/chairs/etc. such as an isolation unit/dialysis
   * chair). This typically covers concepts such as contamination, housekeeping,
   * and other activities like maintenance.
   */
  operationalStatus?: Maybe<Coding_Input>;
  /** Name of the location as used by humans. Does not need to be unique. */
  _name?: Maybe<Element_Input>;
  /** Name of the location as used by humans. Does not need to be unique. */
  name?: Maybe<Scalars['String']>;
  /** A list of alternate names that the location is known as, or was known as, in the past. */
  _alias?: Maybe<Element_Input>;
  /** A list of alternate names that the location is known as, or was known as, in the past. */
  alias?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Description of the Location, which helps in finding or referencing the place. */
  _description?: Maybe<Element_Input>;
  /** Description of the Location, which helps in finding or referencing the place. */
  description?: Maybe<Scalars['String']>;
  /** Indicates whether a resource instance represents a specific location or a class of locations. */
  _mode?: Maybe<Element_Input>;
  /** Indicates whether a resource instance represents a specific location or a class of locations. */
  mode?: Maybe<Scalars['code']>;
  /** Indicates the type of function performed at the location. */
  type?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /**
   * The contact details of communication devices available at the location. This
   * can include phone numbers, fax numbers, mobile numbers, email addresses and web sites.
   */
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>>>;
  /** Physical location. */
  address?: Maybe<Address_Input>;
  /** Physical form of the location, e.g. building, room, vehicle, road. */
  physicalType?: Maybe<CodeableConcept_Input>;
  /**
   * The absolute geographic location of the Location, expressed using the WGS84
   * datum (This is the same co-ordinate system used in KML).
   */
  position?: Maybe<Locationposition_Input>;
  /** The organization responsible for the provisioning and upkeep of the location. */
  managingOrganization?: Maybe<Scalars['String']>;
  /** Another Location of which this Location is physically a part of. */
  partOf?: Maybe<Scalars['String']>;
  /** What days/times during a week is this location usually open. */
  hoursOfOperation?: Maybe<Array<Maybe<LocationhoursOfOperation_Input>>>;
  /**
   * A description of when the locations opening ours are different to normal, e.g.
   * public holiday availability. Succinctly describing all possible exceptions to
   * normal site availability as detailed in the opening hours Times.
   */
  _availabilityExceptions?: Maybe<Element_Input>;
  /**
   * A description of when the locations opening ours are different to normal, e.g.
   * public holiday availability. Succinctly describing all possible exceptions to
   * normal site availability as detailed in the opening hours Times.
   */
  availabilityExceptions?: Maybe<Scalars['String']>;
  /** Technical endpoints providing access to services operated for the location. */
  endpoint?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Technical endpoints providing access to services operated for the location. */
export type Locationendpoint_Endpoint_Union = Endpoint;

export type LocationhoursOfOperation = {
  __typename?: 'LocationhoursOfOperation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates which days of the week are available between the start and end Times. */
  _daysOfWeek?: Maybe<Element>;
  /** Indicates which days of the week are available between the start and end Times. */
  daysOfWeek?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** The Location is open all day. */
  _allDay?: Maybe<Element>;
  /** The Location is open all day. */
  allDay?: Maybe<Scalars['Boolean']>;
  /** Time that the Location opens. */
  _openingTime?: Maybe<Element>;
  /** Time that the Location opens. */
  openingTime?: Maybe<Scalars['time']>;
  /** Time that the Location closes. */
  _closingTime?: Maybe<Element>;
  /** Time that the Location closes. */
  closingTime?: Maybe<Scalars['time']>;
};

export type LocationhoursOfOperation_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Indicates which days of the week are available between the start and end Times. */
  _daysOfWeek?: Maybe<Element_Input>;
  /** Indicates which days of the week are available between the start and end Times. */
  daysOfWeek?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** The Location is open all day. */
  _allDay?: Maybe<Element_Input>;
  /** The Location is open all day. */
  allDay?: Maybe<Scalars['Boolean']>;
  /** Time that the Location opens. */
  _openingTime?: Maybe<Element_Input>;
  /** Time that the Location opens. */
  openingTime?: Maybe<Scalars['time']>;
  /** Time that the Location closes. */
  _closingTime?: Maybe<Element_Input>;
  /** Time that the Location closes. */
  closingTime?: Maybe<Scalars['time']>;
};

/** The organization responsible for the provisioning and upkeep of the location. */
export type LocationmanagingOrganization_ManagingOrganization_Union = Organization;

/** Another Location of which this Location is physically a part of. */
export type LocationpartOf_PartOf_Union = Location;

export type Locationposition = {
  __typename?: 'Locationposition';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Longitude. The value domain and the interpretation are the same as for the
   * text of the longitude element in KML (see notes below).
   */
  _longitude?: Maybe<Element>;
  /**
   * Longitude. The value domain and the interpretation are the same as for the
   * text of the longitude element in KML (see notes below).
   */
  longitude: Scalars['Float'];
  /**
   * Latitude. The value domain and the interpretation are the same as for the text
   * of the latitude element in KML (see notes below).
   */
  _latitude?: Maybe<Element>;
  /**
   * Latitude. The value domain and the interpretation are the same as for the text
   * of the latitude element in KML (see notes below).
   */
  latitude: Scalars['Float'];
  /**
   * Altitude. The value domain and the interpretation are the same as for the text
   * of the altitude element in KML (see notes below).
   */
  _altitude?: Maybe<Element>;
  /**
   * Altitude. The value domain and the interpretation are the same as for the text
   * of the altitude element in KML (see notes below).
   */
  altitude?: Maybe<Scalars['Float']>;
};

export type Locationposition_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * Longitude. The value domain and the interpretation are the same as for the
   * text of the longitude element in KML (see notes below).
   */
  _longitude?: Maybe<Element_Input>;
  /**
   * Longitude. The value domain and the interpretation are the same as for the
   * text of the longitude element in KML (see notes below).
   */
  longitude: Scalars['Float'];
  /**
   * Latitude. The value domain and the interpretation are the same as for the text
   * of the latitude element in KML (see notes below).
   */
  _latitude?: Maybe<Element_Input>;
  /**
   * Latitude. The value domain and the interpretation are the same as for the text
   * of the latitude element in KML (see notes below).
   */
  latitude: Scalars['Float'];
  /**
   * Altitude. The value domain and the interpretation are the same as for the text
   * of the altitude element in KML (see notes below).
   */
  _altitude?: Maybe<Element_Input>;
  /**
   * Altitude. The value domain and the interpretation are the same as for the text
   * of the altitude element in KML (see notes below).
   */
  altitude?: Maybe<Scalars['Float']>;
};

/**
 * Base StructureDefinition for MarketingStatus Type: The marketing status
 * describes the date when a medicinal product is actually put on the market or the
 * date as of which it is no longer available.
 */
export type MarketingStatus = {
  __typename?: 'MarketingStatus';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The country in which the marketing authorisation has been granted shall be
   * specified It should be specified using the ISO 3166 ‑ 1 alpha-2 code elements.
   */
  country: CodeableConcept;
  /**
   * Where a Medicines Regulatory Agency has granted a marketing authorisation for
   * which specific provisions within a jurisdiction apply, the jurisdiction can be
   * specified using an appropriate controlled terminology The controlled term and
   * the controlled term identifier shall be specified.
   */
  jurisdiction?: Maybe<CodeableConcept>;
  /**
   * This attribute provides information on the status of the marketing of the
   * medicinal product See ISO/TS 20443 for more information and examples.
   */
  status: CodeableConcept;
  /**
   * The date when the Medicinal Product is placed on the market by the Marketing
   * Authorisation Holder (or where applicable, the manufacturer/distributor) in a
   * country and/or jurisdiction shall be provided A complete date consisting of
   * day, month and year shall be specified using the ISO 8601 date format NOTE
   * “Placed on the market” refers to the release of the Medicinal Product into the
   * distribution chain.
   */
  dateRange: Period;
  /**
   * The date when the Medicinal Product is placed on the market by the Marketing
   * Authorisation Holder (or where applicable, the manufacturer/distributor) in a
   * country and/or jurisdiction shall be provided A complete date consisting of
   * day, month and year shall be specified using the ISO 8601 date format NOTE
   * “Placed on the market” refers to the release of the Medicinal Product into the
   * distribution chain.
   */
  _restoreDate?: Maybe<Element>;
  /**
   * The date when the Medicinal Product is placed on the market by the Marketing
   * Authorisation Holder (or where applicable, the manufacturer/distributor) in a
   * country and/or jurisdiction shall be provided A complete date consisting of
   * day, month and year shall be specified using the ISO 8601 date format NOTE
   * “Placed on the market” refers to the release of the Medicinal Product into the
   * distribution chain.
   */
  restoreDate?: Maybe<Scalars['dateTime']>;
};

/** The Measure resource provides the definition of a quality measure. */
export type Measure = {
  __typename?: 'Measure';
  /** Type of resource */
  resourceType: Measure_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this measure when it is referenced in
   * a specification, model, design or an instance; also called its canonical
   * identifier. This SHOULD be globally unique and SHOULD be a literal address at
   * which at which an authoritative instance of this measure is (or will be)
   * published. This URL can be the target of a canonical reference. It SHALL
   * remain the same when the measure is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this measure when it is referenced in
   * a specification, model, design or an instance; also called its canonical
   * identifier. This SHOULD be globally unique and SHOULD be a literal address at
   * which at which an authoritative instance of this measure is (or will be)
   * published. This URL can be the target of a canonical reference. It SHALL
   * remain the same when the measure is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this measure when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the measure when it is
   * referenced in a specification, model, design or instance. This is an arbitrary
   * value managed by the measure author and is not expected to be globally unique.
   * For example, it might be a timestamp (e.g. yyyymmdd) if a managed version is
   * not available. There is also no expectation that versions can be placed in a
   * lexicographical sequence. To provide a version consistent with the Decision
   * Support Service specification, use the format Major.Minor.Revision (e.g.
   * 1.0.0). For more information on versioning knowledge assets, refer to the
   * Decision Support Service specification. Note that a version is required for
   * non-experimental active artifacts.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the measure when it is
   * referenced in a specification, model, design or instance. This is an arbitrary
   * value managed by the measure author and is not expected to be globally unique.
   * For example, it might be a timestamp (e.g. yyyymmdd) if a managed version is
   * not available. There is also no expectation that versions can be placed in a
   * lexicographical sequence. To provide a version consistent with the Decision
   * Support Service specification, use the format Major.Minor.Revision (e.g.
   * 1.0.0). For more information on versioning knowledge assets, refer to the
   * Decision Support Service specification. Note that a version is required for
   * non-experimental active artifacts.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the measure. This name should be usable as
   * an identifier for the module by machine processing applications such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the measure. This name should be usable as
   * an identifier for the module by machine processing applications such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the measure. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the measure. */
  title?: Maybe<Scalars['String']>;
  /** An explanatory or alternate title for the measure giving additional information about its content. */
  _subtitle?: Maybe<Element>;
  /** An explanatory or alternate title for the measure giving additional information about its content. */
  subtitle?: Maybe<Scalars['String']>;
  /** The status of this measure. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this measure. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this measure is authored for testing purposes
   * (or education/evaluation/marketing) and is not intended to be used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this measure is authored for testing purposes
   * (or education/evaluation/marketing) and is not intended to be used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The intended subjects for the measure. If this element is not provided, a
   * Patient subject is assumed, but the subject of the measure can be anything.
   */
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  /**
   * The intended subjects for the measure. If this element is not provided, a
   * Patient subject is assumed, but the subject of the measure can be anything.
   */
  subjectReference?: Maybe<MeasuresubjectReference_SubjectReference_Union>;
  /**
   * The date  (and optionally time) when the measure was published. The date must
   * change when the business version changes and it must change if the status code
   * changes. In addition, it should change when the substantive content of the
   * measure changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the measure was published. The date must
   * change when the business version changes and it must change if the status code
   * changes. In addition, it should change when the substantive content of the
   * measure changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the measure. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the measure. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the measure from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the measure from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate measure instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the measure is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this measure is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this measure is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /** A detailed description, from a clinical perspective, of how the measure is used. */
  _usage?: Maybe<Element>;
  /** A detailed description, from a clinical perspective, of how the measure is used. */
  usage?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the measure and/or its contents. Copyright
   * statements are generally legal restrictions on the use and publishing of the measure.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the measure and/or its contents. Copyright
   * statements are generally legal restrictions on the use and publishing of the measure.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the measure content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the content of the measure. Topics provide a
   * high-level categorization grouping types of measures that can be useful for
   * filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related artifacts such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** A reference to a Library resource containing the formal logic used by the measure. */
  _library?: Maybe<Element>;
  /** A reference to a Library resource containing the formal logic used by the measure. */
  library?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * Notices and disclaimers regarding the use of the measure or related to
   * intellectual property (such as code systems) referenced by the measure.
   */
  _disclaimer?: Maybe<Element>;
  /**
   * Notices and disclaimers regarding the use of the measure or related to
   * intellectual property (such as code systems) referenced by the measure.
   */
  disclaimer?: Maybe<Scalars['String']>;
  /**
   * Indicates how the calculation is performed for the measure, including
   * proportion, ratio, continuous-variable, and cohort. The value set is
   * extensible, allowing additional measure scoring types to be represented.
   */
  scoring?: Maybe<CodeableConcept>;
  /**
   * If this is a composite measure, the scoring method used to combine the
   * component measures to determine the composite score.
   */
  compositeScoring?: Maybe<CodeableConcept>;
  /**
   * Indicates whether the measure is used to examine a process, an outcome over
   * time, a patient-reported outcome, or a structure measure such as utilization.
   */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * A description of the risk adjustment factors that may impact the resulting
   * score for the measure and how they may be accounted for when computing and
   * reporting measure results.
   */
  _riskAdjustment?: Maybe<Element>;
  /**
   * A description of the risk adjustment factors that may impact the resulting
   * score for the measure and how they may be accounted for when computing and
   * reporting measure results.
   */
  riskAdjustment?: Maybe<Scalars['String']>;
  /**
   * Describes how to combine the information calculated, based on logic in each of
   * several populations, into one summarized result.
   */
  _rateAggregation?: Maybe<Element>;
  /**
   * Describes how to combine the information calculated, based on logic in each of
   * several populations, into one summarized result.
   */
  rateAggregation?: Maybe<Scalars['String']>;
  /**
   * Provides a succinct statement of the need for the measure. Usually includes
   * statements pertaining to importance criterion: impact, gap in care, and evidence.
   */
  _rationale?: Maybe<Element>;
  /**
   * Provides a succinct statement of the need for the measure. Usually includes
   * statements pertaining to importance criterion: impact, gap in care, and evidence.
   */
  rationale?: Maybe<Scalars['String']>;
  /** Provides a summary of relevant clinical guidelines or other clinical recommendations supporting the measure. */
  _clinicalRecommendationStatement?: Maybe<Element>;
  /** Provides a summary of relevant clinical guidelines or other clinical recommendations supporting the measure. */
  clinicalRecommendationStatement?: Maybe<Scalars['String']>;
  /**
   * Information on whether an increase or decrease in score is the preferred
   * result (e.g., a higher score indicates better quality OR a lower score
   * indicates better quality OR quality is within a range).
   */
  improvementNotation?: Maybe<CodeableConcept>;
  /** Provides a description of an individual term used within the measure. */
  _definition?: Maybe<Element>;
  /** Provides a description of an individual term used within the measure. */
  definition?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Additional guidance for the measure including how it can be used in a clinical context, and the intent of the measure. */
  _guidance?: Maybe<Element>;
  /** Additional guidance for the measure including how it can be used in a clinical context, and the intent of the measure. */
  guidance?: Maybe<Scalars['String']>;
  /** A group of population criteria for the measure. */
  group?: Maybe<Array<Maybe<Measuregroup>>>;
  /**
   * The supplemental data criteria for the measure report, specified as either the
   * name of a valid CQL expression within a referenced library, or a valid FHIR Resource Path.
   */
  supplementalData?: Maybe<Array<Maybe<MeasuresupplementalData>>>;
};

/**
 * The MeasureReport resource contains the results of the calculation of a measure;
 * and optionally a reference to the resources involved in that calculation.
 */
export type MeasureReport = {
  __typename?: 'MeasureReport';
  /** Type of resource */
  resourceType: MeasureReport_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A formal identifier that is used to identify this MeasureReport when it is
   * represented in other formats or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The MeasureReport status. No data will be available until the MeasureReport status is complete. */
  _status?: Maybe<Element>;
  /** The MeasureReport status. No data will be available until the MeasureReport status is complete. */
  status: Scalars['code'];
  /**
   * The type of measure report. This may be an individual report, which provides
   * the score for the measure for an individual member of the population; a
   * subject-listing, which returns the list of members that meet the various
   * criteria in the measure; a summary report, which returns a population count
   * for each of the criteria in the measure; or a data-collection, which enables
   * the MeasureReport to be used to exchange the data-of-interest for a quality measure.
   */
  _type?: Maybe<Element>;
  /**
   * The type of measure report. This may be an individual report, which provides
   * the score for the measure for an individual member of the population; a
   * subject-listing, which returns the list of members that meet the various
   * criteria in the measure; a summary report, which returns a population count
   * for each of the criteria in the measure; or a data-collection, which enables
   * the MeasureReport to be used to exchange the data-of-interest for a quality measure.
   */
  type: Scalars['code'];
  /** A reference to the Measure that was calculated to produce this report. */
  _measure?: Maybe<Element>;
  /** A reference to the Measure that was calculated to produce this report. */
  measure: Scalars['canonical'];
  /** Optional subject identifying the individual or individuals the report is for. */
  subject?: Maybe<MeasureReportsubject_Subject_Union>;
  /** The date this measure report was generated. */
  _date?: Maybe<Element>;
  /** The date this measure report was generated. */
  date?: Maybe<Scalars['dateTime']>;
  /** The individual, location, or organization that is reporting the data. */
  reporter?: Maybe<MeasureReportreporter_Reporter_Union>;
  /** The reporting period for which the report was calculated. */
  period: Period;
  /** Whether improvement in the measure is noted by an increase or decrease in the measure score. */
  improvementNotation?: Maybe<CodeableConcept>;
  /** The results of the calculation, one for each population group in the measure. */
  group?: Maybe<Array<Maybe<MeasureReportgroup>>>;
  /** A reference to a Bundle containing the Resources that were used in the calculation of this measure. */
  evaluatedResource?: Maybe<Array<Maybe<MeasureReportevaluatedResource_EvaluatedResource_Union>>>;
};

export enum MeasureReport_Enum_Schema {
  MeasureReport = 'MeasureReport'
}

/** A reference to a Bundle containing the Resources that were used in the calculation of this measure. */
export type MeasureReportevaluatedResource_EvaluatedResource_Union = Resource;

export type MeasureReportgroup = {
  __typename?: 'MeasureReportgroup';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The meaning of the population group as defined in the measure definition. */
  code?: Maybe<CodeableConcept>;
  /** The populations that make up the population group, one for each type of population appropriate for the measure. */
  population?: Maybe<Array<Maybe<MeasureReportgrouppopulation>>>;
  /**
   * The measure score for this population group, calculated as appropriate for the
   * measure type and scoring method, and based on the contents of the populations
   * defined in the group.
   */
  measureScore?: Maybe<Quantity>;
  /** When a measure includes multiple stratifiers, there will be a stratifier group for each stratifier defined by the measure. */
  stratifier?: Maybe<Array<Maybe<MeasureReportgroupstratifier>>>;
};

export type MeasureReportgrouppopulation = {
  __typename?: 'MeasureReportgrouppopulation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of the population. */
  code?: Maybe<CodeableConcept>;
  /** The number of members of the population. */
  _count?: Maybe<Element>;
  /** The number of members of the population. */
  count?: Maybe<Scalars['Int']>;
  /** This element refers to a List of subject level MeasureReport resources, one for each subject in this population. */
  subjectResults?: Maybe<MeasureReportgrouppopulationsubjectResults_SubjectResults_Union>;
};

/** This element refers to a List of subject level MeasureReport resources, one for each subject in this population. */
export type MeasureReportgrouppopulationsubjectResults_SubjectResults_Union = List;

export type MeasureReportgroupstratifier = {
  __typename?: 'MeasureReportgroupstratifier';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The meaning of this stratifier, as defined in the measure definition. */
  code?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * This element contains the results for a single stratum within the stratifier.
   * For example, when stratifying on administrative gender, there will be four
   * strata, one for each possible gender value.
   */
  stratum?: Maybe<Array<Maybe<MeasureReportgroupstratifierstratum>>>;
};

export type MeasureReportgroupstratifierstratum = {
  __typename?: 'MeasureReportgroupstratifierstratum';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The value for this stratum, expressed as a CodeableConcept. When defining
   * stratifiers on complex values, the value must be rendered such that the value
   * for each stratum within the stratifier is unique.
   */
  value?: Maybe<CodeableConcept>;
  /** A stratifier component value. */
  component?: Maybe<Array<Maybe<MeasureReportgroupstratifierstratumcomponent>>>;
  /** The populations that make up the stratum, one for each type of population appropriate to the measure. */
  population?: Maybe<Array<Maybe<MeasureReportgroupstratifierstratumpopulation>>>;
  /**
   * The measure score for this stratum, calculated as appropriate for the measure
   * type and scoring method, and based on only the members of this stratum.
   */
  measureScore?: Maybe<Quantity>;
};

export type MeasureReportgroupstratifierstratumcomponent = {
  __typename?: 'MeasureReportgroupstratifierstratumcomponent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The code for the stratum component value. */
  code: CodeableConcept;
  /** The stratum component value. */
  value: CodeableConcept;
};

export type MeasureReportgroupstratifierstratumpopulation = {
  __typename?: 'MeasureReportgroupstratifierstratumpopulation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of the population. */
  code?: Maybe<CodeableConcept>;
  /** The number of members of the population in this stratum. */
  _count?: Maybe<Element>;
  /** The number of members of the population in this stratum. */
  count?: Maybe<Scalars['Int']>;
  /**
   * This element refers to a List of subject level MeasureReport resources, one
   * for each subject in this population in this stratum.
   */
  subjectResults?: Maybe<MeasureReportgroupstratifierstratumpopulationsubjectResults_SubjectResults_Union>;
};

/**
 * This element refers to a List of subject level MeasureReport resources, one for
 * each subject in this population in this stratum.
 */
export type MeasureReportgroupstratifierstratumpopulationsubjectResults_SubjectResults_Union = List;

/** The individual, location, or organization that is reporting the data. */
export type MeasureReportreporter_Reporter_Union = Practitioner | PractitionerRole | Location | Organization;

/** Optional subject identifying the individual or individuals the report is for. */
export type MeasureReportsubject_Subject_Union = Patient | Practitioner | PractitionerRole | Location | Device | RelatedPerson | Group;

export enum Measure_Enum_Schema {
  Measure = 'Measure'
}

export type Measuregroup = {
  __typename?: 'Measuregroup';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Indicates a meaning for the group. This can be as simple as a unique
   * identifier, or it can establish meaning in a broader context by drawing from a
   * terminology, allowing groups to be correlated across measures.
   */
  code?: Maybe<CodeableConcept>;
  /** The human readable description of this population group. */
  _description?: Maybe<Element>;
  /** The human readable description of this population group. */
  description?: Maybe<Scalars['String']>;
  /** A population criteria for the measure. */
  population?: Maybe<Array<Maybe<Measuregrouppopulation>>>;
  /**
   * The stratifier criteria for the measure report, specified as either the name
   * of a valid CQL expression defined within a referenced library or a valid FHIR Resource Path.
   */
  stratifier?: Maybe<Array<Maybe<Measuregroupstratifier>>>;
};

export type Measuregrouppopulation = {
  __typename?: 'Measuregrouppopulation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of population criteria. */
  code?: Maybe<CodeableConcept>;
  /** The human readable description of this population criteria. */
  _description?: Maybe<Element>;
  /** The human readable description of this population criteria. */
  description?: Maybe<Scalars['String']>;
  /** An expression that specifies the criteria for the population, typically the name of an expression in a library. */
  criteria: Expression;
};

export type Measuregroupstratifier = {
  __typename?: 'Measuregroupstratifier';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Indicates a meaning for the stratifier. This can be as simple as a unique
   * identifier, or it can establish meaning in a broader context by drawing from a
   * terminology, allowing stratifiers to be correlated across measures.
   */
  code?: Maybe<CodeableConcept>;
  /** The human readable description of this stratifier criteria. */
  _description?: Maybe<Element>;
  /** The human readable description of this stratifier criteria. */
  description?: Maybe<Scalars['String']>;
  /**
   * An expression that specifies the criteria for the stratifier. This is
   * typically the name of an expression defined within a referenced library, but
   * it may also be a path to a stratifier element.
   */
  criteria?: Maybe<Expression>;
  /**
   * A component of the stratifier criteria for the measure report, specified as
   * either the name of a valid CQL expression defined within a referenced library
   * or a valid FHIR Resource Path.
   */
  component?: Maybe<Array<Maybe<Measuregroupstratifiercomponent>>>;
};

export type Measuregroupstratifiercomponent = {
  __typename?: 'Measuregroupstratifiercomponent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Indicates a meaning for the stratifier component. This can be as simple as a
   * unique identifier, or it can establish meaning in a broader context by drawing
   * from a terminology, allowing stratifiers to be correlated across measures.
   */
  code?: Maybe<CodeableConcept>;
  /** The human readable description of this stratifier criteria component. */
  _description?: Maybe<Element>;
  /** The human readable description of this stratifier criteria component. */
  description?: Maybe<Scalars['String']>;
  /**
   * An expression that specifies the criteria for this component of the
   * stratifier. This is typically the name of an expression defined within a
   * referenced library, but it may also be a path to a stratifier element.
   */
  criteria: Expression;
};

/**
 * The intended subjects for the measure. If this element is not provided, a
 * Patient subject is assumed, but the subject of the measure can be anything.
 */
export type MeasuresubjectReference_SubjectReference_Union = Group;

export type MeasuresupplementalData = {
  __typename?: 'MeasuresupplementalData';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Indicates a meaning for the supplemental data. This can be as simple as a
   * unique identifier, or it can establish meaning in a broader context by drawing
   * from a terminology, allowing supplemental data to be correlated across measures.
   */
  code?: Maybe<CodeableConcept>;
  /**
   * An indicator of the intended usage for the supplemental data element.
   * Supplemental data indicates the data is additional information requested to
   * augment the measure information. Risk adjustment factor indicates the data is
   * additional information used to calculate risk adjustment factors when applying
   * a risk model to the measure calculation.
   */
  usage?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The human readable description of this supplemental data. */
  _description?: Maybe<Element>;
  /** The human readable description of this supplemental data. */
  description?: Maybe<Scalars['String']>;
  /**
   * The criteria for the supplemental data. This is typically the name of a valid
   * expression defined within a referenced library, but it may also be a path to a
   * specific data element. The criteria defines the data to be returned for this element.
   */
  criteria: Expression;
};

/**
 * A photo, video, or audio recording acquired or used in healthcare. The actual
 * content may be inline or provided by direct reference.
 */
export type Media = {
  __typename?: 'Media';
  /** Type of resource */
  resourceType: Media_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Identifiers associated with the image - these may include identifiers for the
   * image itself, identifiers for the context of its collection (e.g. series ids)
   * and context ids such as accession numbers or other workflow identifiers.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A procedure that is fulfilled in whole or in part by the creation of this media. */
  basedOn?: Maybe<Array<Maybe<MediabasedOn_BasedOn_Union>>>;
  /** A larger event of which this particular event is a component or step. */
  partOf?: Maybe<Array<Maybe<MediapartOf_PartOf_Union>>>;
  /** The current state of the {{title}}. */
  _status?: Maybe<Element>;
  /** The current state of the {{title}}. */
  status: Scalars['code'];
  /** A code that classifies whether the media is an image, video or audio recording or some other media category. */
  type?: Maybe<CodeableConcept>;
  /**
   * Details of the type of the media - usually, how it was acquired (what type of
   * device). If images sourced from a DICOM system, are wrapped in a Media
   * resource, then this is the modality.
   */
  modality?: Maybe<CodeableConcept>;
  /** The name of the imaging view e.g. Lateral or Antero-posterior (AP). */
  view?: Maybe<CodeableConcept>;
  /** Who/What this Media is a record of. */
  subject?: Maybe<Mediasubject_Subject_Union>;
  /** The encounter that establishes the context for this media. */
  encounter?: Maybe<Mediaencounter_Encounter_Union>;
  /** The date and time(s) at which the media was collected. */
  _createdDateTime?: Maybe<Element>;
  /** The date and time(s) at which the media was collected. */
  createdDateTime?: Maybe<Scalars['dateTime']>;
  /** The date and time(s) at which the media was collected. */
  createdPeriod?: Maybe<Period>;
  /** The date and time this version of the media was made available to providers, typically after having been reviewed. */
  _issued?: Maybe<Element>;
  /** The date and time this version of the media was made available to providers, typically after having been reviewed. */
  issued?: Maybe<Scalars['instant']>;
  /** The person who administered the collection of the image. */
  operator?: Maybe<Mediaoperator_Operator_Union>;
  /** Describes why the event occurred in coded or textual form. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates the site on the subject's body where the observation was made (i.e. the target site). */
  bodySite?: Maybe<CodeableConcept>;
  /** The name of the device / manufacturer of the device  that was used to make the recording. */
  _deviceName?: Maybe<Element>;
  /** The name of the device / manufacturer of the device  that was used to make the recording. */
  deviceName?: Maybe<Scalars['String']>;
  /** The device used to collect the media. */
  device?: Maybe<Mediadevice_Device_Union>;
  /** Height of the image in pixels (photo/video). */
  _height?: Maybe<Element>;
  /** Height of the image in pixels (photo/video). */
  height?: Maybe<Scalars['positiveInt']>;
  /** Width of the image in pixels (photo/video). */
  _width?: Maybe<Element>;
  /** Width of the image in pixels (photo/video). */
  width?: Maybe<Scalars['positiveInt']>;
  /**
   * The number of frames in a photo. This is used with a multi-page fax, or an
   * imaging acquisition context that takes multiple slices in a single image, or
   * an animated gif. If there is more than one frame, this SHALL have a value in
   * order to alert interface software that a multi-frame capable rendering widget is required.
   */
  _frames?: Maybe<Element>;
  /**
   * The number of frames in a photo. This is used with a multi-page fax, or an
   * imaging acquisition context that takes multiple slices in a single image, or
   * an animated gif. If there is more than one frame, this SHALL have a value in
   * order to alert interface software that a multi-frame capable rendering widget is required.
   */
  frames?: Maybe<Scalars['positiveInt']>;
  /** The duration of the recording in seconds - for audio and video. */
  _duration?: Maybe<Element>;
  /** The duration of the recording in seconds - for audio and video. */
  duration?: Maybe<Scalars['Float']>;
  /** The actual content of the media - inline or by direct reference to the media source file. */
  content: Attachment;
  /** Comments made about the media by the performer, subject or other participants. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export enum Media_Enum_Schema {
  Media = 'Media'
}

/** A procedure that is fulfilled in whole or in part by the creation of this media. */
export type MediabasedOn_BasedOn_Union = ServiceRequest | CarePlan;

/** The device used to collect the media. */
export type Mediadevice_Device_Union = Device | DeviceMetric;

/** The encounter that establishes the context for this media. */
export type Mediaencounter_Encounter_Union = Encounter;

/** The person who administered the collection of the image. */
export type Mediaoperator_Operator_Union = Practitioner | PractitionerRole | Organization | CareTeam | Patient | Device | RelatedPerson;

/** A larger event of which this particular event is a component or step. */
export type MediapartOf_PartOf_Union = Resource;

/** Who/What this Media is a record of. */
export type Mediasubject_Subject_Union = Patient | Practitioner | PractitionerRole | Group | Device | Specimen | Location;

/**
 * This resource is primarily used for the identification and definition of a
 * medication for the purposes of prescribing, dispensing, and administering a
 * medication as well as for making statements about medication use.
 */
export type Medication = {
  __typename?: 'Medication';
  /** Type of resource */
  resourceType: Medication_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Business identifier for this medication. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * A code (or set of codes) that specify this medication, or a textual
   * description if no code is available. Usage note: This could be a standard
   * medication code such as a code from RxNorm, SNOMED CT, IDMP etc. It could also
   * be a national or local formulary code, optionally with translations to other code systems.
   */
  code?: Maybe<CodeableConcept>;
  /** A code to indicate if the medication is in active use. */
  _status?: Maybe<Element>;
  /** A code to indicate if the medication is in active use. */
  status?: Maybe<Scalars['code']>;
  /**
   * Describes the details of the manufacturer of the medication product.  This is
   * not intended to represent the distributor of a medication product.
   */
  manufacturer?: Maybe<Medicationmanufacturer_Manufacturer_Union>;
  /** Describes the form of the item.  Powder; tablets; capsule. */
  form?: Maybe<CodeableConcept>;
  /**
   * Specific amount of the drug in the packaged product.  For example, when
   * specifying a product that has the same strength (For example, Insulin glargine
   * 100 unit per mL solution for injection), this attribute provides additional
   * clarification of the package amount (For example, 3 mL, 10mL, etc.).
   */
  amount?: Maybe<Ratio>;
  /** Identifies a particular constituent of interest in the product. */
  ingredient?: Maybe<Array<Maybe<Medicationingredient>>>;
  /** Information that only applies to packages (not products). */
  batch?: Maybe<Medicationbatch>;
};

/**
 * Describes the event of a patient consuming or otherwise being administered a
 * medication.  This may be as simple as swallowing a tablet or it may be a long
 * running infusion.  Related resources tie this event to the authorizing
 * prescription, and the specific encounter between patient and health care practitioner.
 */
export type MedicationAdministration = {
  __typename?: 'MedicationAdministration';
  /** Type of resource */
  resourceType: MedicationAdministration_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Identifiers associated with this Medication Administration that are defined by
   * business processes and/or used to refer to it when a direct URL reference to
   * the resource itself is not appropriate. They are business identifiers assigned
   * to this resource by the performer or other systems and remain constant as the
   * resource is updated and propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A protocol, guideline, orderset, or other definition that was adhered to in whole or in part by this event. */
  _instantiates?: Maybe<Element>;
  /** A protocol, guideline, orderset, or other definition that was adhered to in whole or in part by this event. */
  instantiates?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** A larger event of which this particular event is a component or step. */
  partOf?: Maybe<Array<Maybe<MedicationAdministrationpartOf_PartOf_Union>>>;
  /**
   * Will generally be set to show that the administration has been completed.  For
   * some long running administrations such as infusions, it is possible for an
   * administration to be started but not completed or it may be paused while some
   * other process is under way.
   */
  _status?: Maybe<Element>;
  /**
   * Will generally be set to show that the administration has been completed.  For
   * some long running administrations such as infusions, it is possible for an
   * administration to be started but not completed or it may be paused while some
   * other process is under way.
   */
  status: Scalars['code'];
  /** A code indicating why the administration was not performed. */
  statusReason?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates where the medication is expected to be consumed or administered. */
  category?: Maybe<CodeableConcept>;
  /**
   * Identifies the medication that was administered. This is either a link to a
   * resource representing the details of the medication or a simple attribute
   * carrying a code that identifies the medication from a known list of medications.
   */
  medicationCodeableConcept: CodeableConcept;
  /**
   * Identifies the medication that was administered. This is either a link to a
   * resource representing the details of the medication or a simple attribute
   * carrying a code that identifies the medication from a known list of medications.
   */
  medicationReference: MedicationAdministrationmedicationReference_MedicationReference_Union;
  /** The person or animal or group receiving the medication. */
  subject: MedicationAdministrationsubject_Subject_Union;
  /**
   * The visit, admission, or other contact between patient and health care
   * provider during which the medication administration was performed.
   */
  context?: Maybe<MedicationAdministrationcontext_Context_Union>;
  /** Additional information (for example, patient height and weight) that supports the administration of the medication. */
  supportingInformation?: Maybe<Array<Maybe<MedicationAdministrationsupportingInformation_SupportingInformation_Union>>>;
  /**
   * A specific date/time or interval of time during which the administration took
   * place (or did not take place, when the 'notGiven' attribute is true). For many
   * administrations, such as swallowing a tablet the use of dateTime is more appropriate.
   */
  _effectiveDateTime?: Maybe<Element>;
  /**
   * A specific date/time or interval of time during which the administration took
   * place (or did not take place, when the 'notGiven' attribute is true). For many
   * administrations, such as swallowing a tablet the use of dateTime is more appropriate.
   */
  effectiveDateTime: Scalars['dateTime'];
  /**
   * A specific date/time or interval of time during which the administration took
   * place (or did not take place, when the 'notGiven' attribute is true). For many
   * administrations, such as swallowing a tablet the use of dateTime is more appropriate.
   */
  effectivePeriod: Period;
  /** Indicates who or what performed the medication administration and how they were involved. */
  performer?: Maybe<Array<Maybe<MedicationAdministrationperformer>>>;
  /** A code indicating why the medication was given. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Condition or observation that supports why the medication was administered. */
  reasonReference?: Maybe<Array<Maybe<MedicationAdministrationreasonReference_ReasonReference_Union>>>;
  /** The original request, instruction or authority to perform the administration. */
  request?: Maybe<MedicationAdministrationrequest_Request_Union>;
  /** The device used in administering the medication to the patient.  For example, a particular infusion pump. */
  device?: Maybe<Array<Maybe<MedicationAdministrationdevice_Device_Union>>>;
  /** Extra information about the medication administration that is not conveyed by the other attributes. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Describes the medication dosage information details e.g. dose, rate, site, route, etc. */
  dosage?: Maybe<MedicationAdministrationdosage>;
  /** A summary of the events of interest that have occurred, such as when the administration was verified. */
  eventHistory?: Maybe<Array<Maybe<MedicationAdministrationeventHistory_EventHistory_Union>>>;
};

export enum MedicationAdministration_Enum_Schema {
  MedicationAdministration = 'MedicationAdministration'
}

/**
 * The visit, admission, or other contact between patient and health care provider
 * during which the medication administration was performed.
 */
export type MedicationAdministrationcontext_Context_Union = Encounter | EpisodeOfCare;

/** The device used in administering the medication to the patient.  For example, a particular infusion pump. */
export type MedicationAdministrationdevice_Device_Union = Device;

export type MedicationAdministrationdosage = {
  __typename?: 'MedicationAdministrationdosage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Free text dosage can be used for cases where the dosage administered is too
   * complex to code. When coded dosage is present, the free text dosage may still
   * be present for display to humans.  The dosage instructions should reflect the
   * dosage of the medication that was administered.
   */
  _text?: Maybe<Element>;
  /**
   * Free text dosage can be used for cases where the dosage administered is too
   * complex to code. When coded dosage is present, the free text dosage may still
   * be present for display to humans.  The dosage instructions should reflect the
   * dosage of the medication that was administered.
   */
  text?: Maybe<Scalars['String']>;
  /** A coded specification of the anatomic site where the medication first entered the body.  For example, 'left arm'. */
  site?: Maybe<CodeableConcept>;
  /**
   * A code specifying the route or physiological path of administration of a
   * therapeutic agent into or onto the patient.  For example, topical,
   * intravenous, etc.
   */
  route?: Maybe<CodeableConcept>;
  /**
   * A coded value indicating the method by which the medication is intended to be
   * or was introduced into or on the body.  This attribute will most often NOT be
   * populated.  It is most commonly used for injections.  For example, Slow Push, Deep IV.
   */
  method?: Maybe<CodeableConcept>;
  /**
   * The amount of the medication given at one administration event.   Use this
   * value when the administration is essentially an instantaneous event such as a
   * swallowing a tablet or giving an injection.
   */
  dose?: Maybe<Quantity>;
  /**
   * Identifies the speed with which the medication was or will be introduced into
   * the patient.  Typically, the rate for an infusion e.g. 100 ml per 1 hour or
   * 100 ml/hr.  May also be expressed as a rate per unit of time, e.g. 500 ml per
   * 2 hours.  Other examples:  200 mcg/min or 200 mcg/1 minute; 1 liter/8 hours.
   */
  rateRatio?: Maybe<Ratio>;
  /**
   * Identifies the speed with which the medication was or will be introduced into
   * the patient.  Typically, the rate for an infusion e.g. 100 ml per 1 hour or
   * 100 ml/hr.  May also be expressed as a rate per unit of time, e.g. 500 ml per
   * 2 hours.  Other examples:  200 mcg/min or 200 mcg/1 minute; 1 liter/8 hours.
   */
  rateQuantity?: Maybe<Quantity>;
};

/** A summary of the events of interest that have occurred, such as when the administration was verified. */
export type MedicationAdministrationeventHistory_EventHistory_Union = Provenance;

/**
 * Identifies the medication that was administered. This is either a link to a
 * resource representing the details of the medication or a simple attribute
 * carrying a code that identifies the medication from a known list of medications.
 */
export type MedicationAdministrationmedicationReference_MedicationReference_Union = Medication;

/** A larger event of which this particular event is a component or step. */
export type MedicationAdministrationpartOf_PartOf_Union = MedicationAdministration | Procedure;

export type MedicationAdministrationperformer = {
  __typename?: 'MedicationAdministrationperformer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Distinguishes the type of involvement of the performer in the medication administration. */
  function?: Maybe<CodeableConcept>;
  /** Indicates who or what performed the medication administration. */
  actor: MedicationAdministrationperformeractor_Actor_Union;
};

/** Indicates who or what performed the medication administration. */
export type MedicationAdministrationperformeractor_Actor_Union = Practitioner | PractitionerRole | Patient | RelatedPerson | Device;

/** Condition or observation that supports why the medication was administered. */
export type MedicationAdministrationreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport;

/** The original request, instruction or authority to perform the administration. */
export type MedicationAdministrationrequest_Request_Union = MedicationRequest;

/** The person or animal or group receiving the medication. */
export type MedicationAdministrationsubject_Subject_Union = Patient | Group;

/** Additional information (for example, patient height and weight) that supports the administration of the medication. */
export type MedicationAdministrationsupportingInformation_SupportingInformation_Union = Resource;

/**
 * Indicates that a medication product is to be or has been dispensed for a named
 * person/patient.  This includes a description of the medication product (supply)
 * provided and the instructions for administering the medication.  The medication
 * dispense is the result of a pharmacy system responding to a medication order.
 */
export type MedicationDispense = {
  __typename?: 'MedicationDispense';
  /** Type of resource */
  resourceType: MedicationDispense_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Identifiers associated with this Medication Dispense that are defined by
   * business processes and/or used to refer to it when a direct URL reference to
   * the resource itself is not appropriate. They are business identifiers assigned
   * to this resource by the performer or other systems and remain constant as the
   * resource is updated and propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The procedure that trigger the dispense. */
  partOf?: Maybe<Array<Maybe<MedicationDispensepartOf_PartOf_Union>>>;
  /** A code specifying the state of the set of dispense events. */
  _status?: Maybe<Element>;
  /** A code specifying the state of the set of dispense events. */
  status: Scalars['code'];
  /** Indicates the reason why a dispense was not performed. */
  statusReasonCodeableConcept?: Maybe<CodeableConcept>;
  /** Indicates the reason why a dispense was not performed. */
  statusReasonReference?: Maybe<MedicationDispensestatusReasonReference_StatusReasonReference_Union>;
  /**
   * Indicates the type of medication dispense (for example, where the medication
   * is expected to be consumed or administered (i.e. inpatient or outpatient)).
   */
  category?: Maybe<CodeableConcept>;
  /**
   * Identifies the medication being administered. This is either a link to a
   * resource representing the details of the medication or a simple attribute
   * carrying a code that identifies the medication from a known list of medications.
   */
  medicationCodeableConcept: CodeableConcept;
  /**
   * Identifies the medication being administered. This is either a link to a
   * resource representing the details of the medication or a simple attribute
   * carrying a code that identifies the medication from a known list of medications.
   */
  medicationReference: MedicationDispensemedicationReference_MedicationReference_Union;
  /** A link to a resource representing the person or the group to whom the medication will be given. */
  subject?: Maybe<MedicationDispensesubject_Subject_Union>;
  /** The encounter or episode of care that establishes the context for this event. */
  context?: Maybe<MedicationDispensecontext_Context_Union>;
  /** Additional information that supports the medication being dispensed. */
  supportingInformation?: Maybe<Array<Maybe<MedicationDispensesupportingInformation_SupportingInformation_Union>>>;
  /** Indicates who or what performed the event. */
  performer?: Maybe<Array<Maybe<MedicationDispenseperformer>>>;
  /** The principal physical location where the dispense was performed. */
  location?: Maybe<MedicationDispenselocation_Location_Union>;
  /** Indicates the medication order that is being dispensed against. */
  authorizingPrescription?: Maybe<Array<Maybe<MedicationDispenseauthorizingPrescription_AuthorizingPrescription_Union>>>;
  /**
   * Indicates the type of dispensing event that is performed. For example, Trial
   * Fill, Completion of Trial, Partial Fill, Emergency Fill, Samples, etc.
   */
  type?: Maybe<CodeableConcept>;
  /** The amount of medication that has been dispensed. Includes unit of measure. */
  quantity?: Maybe<Quantity>;
  /** The amount of medication expressed as a timing amount. */
  daysSupply?: Maybe<Quantity>;
  /** The time when the dispensed product was packaged and reviewed. */
  _whenPrepared?: Maybe<Element>;
  /** The time when the dispensed product was packaged and reviewed. */
  whenPrepared?: Maybe<Scalars['dateTime']>;
  /** The time the dispensed product was provided to the patient or their representative. */
  _whenHandedOver?: Maybe<Element>;
  /** The time the dispensed product was provided to the patient or their representative. */
  whenHandedOver?: Maybe<Scalars['dateTime']>;
  /** Identification of the facility/location where the medication was shipped to, as part of the dispense event. */
  destination?: Maybe<MedicationDispensedestination_Destination_Union>;
  /**
   * Identifies the person who picked up the medication.  This will usually be a
   * patient or their caregiver, but some cases exist where it can be a healthcare professional.
   */
  receiver?: Maybe<Array<Maybe<MedicationDispensereceiver_Receiver_Union>>>;
  /** Extra information about the dispense that could not be conveyed in the other attributes. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Indicates how the medication is to be used by the patient. */
  dosageInstruction?: Maybe<Array<Maybe<Dosage>>>;
  /**
   * Indicates whether or not substitution was made as part of the dispense.  In
   * some cases, substitution will be expected but does not happen, in other cases
   * substitution is not expected but does happen.  This block explains what
   * substitution did or did not happen and why.  If nothing is specified,
   * substitution was not done.
   */
  substitution?: Maybe<MedicationDispensesubstitution>;
  /**
   * Indicates an actual or potential clinical issue with or between one or more
   * active or proposed clinical actions for a patient; e.g. drug-drug interaction,
   * duplicate therapy, dosage alert etc.
   */
  detectedIssue?: Maybe<Array<Maybe<MedicationDispensedetectedIssue_DetectedIssue_Union>>>;
  /** A summary of the events of interest that have occurred, such as when the dispense was verified. */
  eventHistory?: Maybe<Array<Maybe<MedicationDispenseeventHistory_EventHistory_Union>>>;
};

export enum MedicationDispense_Enum_Schema {
  MedicationDispense = 'MedicationDispense'
}

/** Indicates the medication order that is being dispensed against. */
export type MedicationDispenseauthorizingPrescription_AuthorizingPrescription_Union = MedicationRequest;

/** The encounter or episode of care that establishes the context for this event. */
export type MedicationDispensecontext_Context_Union = Encounter | EpisodeOfCare;

/** Identification of the facility/location where the medication was shipped to, as part of the dispense event. */
export type MedicationDispensedestination_Destination_Union = Location;

/**
 * Indicates an actual or potential clinical issue with or between one or more
 * active or proposed clinical actions for a patient; e.g. drug-drug interaction,
 * duplicate therapy, dosage alert etc.
 */
export type MedicationDispensedetectedIssue_DetectedIssue_Union = DetectedIssue;

/** A summary of the events of interest that have occurred, such as when the dispense was verified. */
export type MedicationDispenseeventHistory_EventHistory_Union = Provenance;

/** The principal physical location where the dispense was performed. */
export type MedicationDispenselocation_Location_Union = Location;

/**
 * Identifies the medication being administered. This is either a link to a
 * resource representing the details of the medication or a simple attribute
 * carrying a code that identifies the medication from a known list of medications.
 */
export type MedicationDispensemedicationReference_MedicationReference_Union = Medication;

/** The procedure that trigger the dispense. */
export type MedicationDispensepartOf_PartOf_Union = Procedure;

export type MedicationDispenseperformer = {
  __typename?: 'MedicationDispenseperformer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Distinguishes the type of performer in the dispense.  For example, date enterer, packager, final checker. */
  function?: Maybe<CodeableConcept>;
  /**
   * The device, practitioner, etc. who performed the action.  It should be assumed
   * that the actor is the dispenser of the medication.
   */
  actor: MedicationDispenseperformeractor_Actor_Union;
};

/**
 * The device, practitioner, etc. who performed the action.  It should be assumed
 * that the actor is the dispenser of the medication.
 */
export type MedicationDispenseperformeractor_Actor_Union = Practitioner | PractitionerRole | Organization | Patient | Device | RelatedPerson;

/**
 * Identifies the person who picked up the medication.  This will usually be a
 * patient or their caregiver, but some cases exist where it can be a healthcare professional.
 */
export type MedicationDispensereceiver_Receiver_Union = Patient | Practitioner;

/** Indicates the reason why a dispense was not performed. */
export type MedicationDispensestatusReasonReference_StatusReasonReference_Union = DetectedIssue;

/** A link to a resource representing the person or the group to whom the medication will be given. */
export type MedicationDispensesubject_Subject_Union = Patient | Group;

export type MedicationDispensesubstitution = {
  __typename?: 'MedicationDispensesubstitution';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** True if the dispenser dispensed a different drug or product from what was prescribed. */
  _wasSubstituted?: Maybe<Element>;
  /** True if the dispenser dispensed a different drug or product from what was prescribed. */
  wasSubstituted: Scalars['Boolean'];
  /** A code signifying whether a different drug was dispensed from what was prescribed. */
  type?: Maybe<CodeableConcept>;
  /** Indicates the reason for the substitution (or lack of substitution) from what was prescribed. */
  reason?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The person or organization that has primary responsibility for the substitution. */
  responsibleParty?: Maybe<Array<Maybe<MedicationDispensesubstitutionresponsibleParty_ResponsibleParty_Union>>>;
};

/** The person or organization that has primary responsibility for the substitution. */
export type MedicationDispensesubstitutionresponsibleParty_ResponsibleParty_Union = Practitioner | PractitionerRole;

/** Additional information that supports the medication being dispensed. */
export type MedicationDispensesupportingInformation_SupportingInformation_Union = Resource;

/** Information about a medication that is used to support knowledge. */
export type MedicationKnowledge = {
  __typename?: 'MedicationKnowledge';
  /** Type of resource */
  resourceType: MedicationKnowledge_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A code that specifies this medication, or a textual description if no code is
   * available. Usage note: This could be a standard medication code such as a code
   * from RxNorm, SNOMED CT, IDMP etc. It could also be a national or local
   * formulary code, optionally with translations to other code systems.
   */
  code?: Maybe<CodeableConcept>;
  /**
   * A code to indicate if the medication is in active use.  The status refers to
   * the validity about the information of the medication and not to its medicinal properties.
   */
  _status?: Maybe<Element>;
  /**
   * A code to indicate if the medication is in active use.  The status refers to
   * the validity about the information of the medication and not to its medicinal properties.
   */
  status?: Maybe<Scalars['code']>;
  /**
   * Describes the details of the manufacturer of the medication product.  This is
   * not intended to represent the distributor of a medication product.
   */
  manufacturer?: Maybe<MedicationKnowledgemanufacturer_Manufacturer_Union>;
  /** Describes the form of the item.  Powder; tablets; capsule. */
  doseForm?: Maybe<CodeableConcept>;
  /**
   * Specific amount of the drug in the packaged product.  For example, when
   * specifying a product that has the same strength (For example, Insulin glargine
   * 100 unit per mL solution for injection), this attribute provides additional
   * clarification of the package amount (For example, 3 mL, 10mL, etc.).
   */
  amount?: Maybe<Quantity>;
  /**
   * Additional names for a medication, for example, the name(s) given to a
   * medication in different countries.  For example, acetaminophen and paracetamol
   * or salbutamol and albuterol.
   */
  _synonym?: Maybe<Element>;
  /**
   * Additional names for a medication, for example, the name(s) given to a
   * medication in different countries.  For example, acetaminophen and paracetamol
   * or salbutamol and albuterol.
   */
  synonym?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Associated or related knowledge about a medication. */
  relatedMedicationKnowledge?: Maybe<Array<Maybe<MedicationKnowledgerelatedMedicationKnowledge>>>;
  /**
   * Associated or related medications.  For example, if the medication is a
   * branded product (e.g. Crestor), this is the Therapeutic Moeity (e.g.
   * Rosuvastatin) or if this is a generic medication (e.g. Rosuvastatin), this
   * would link to a branded product (e.g. Crestor).
   */
  associatedMedication?: Maybe<Array<Maybe<MedicationKnowledgeassociatedMedication_AssociatedMedication_Union>>>;
  /**
   * Category of the medication or product (e.g. branded product, therapeutic
   * moeity, generic product, innovator product, etc.).
   */
  productType?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Associated documentation about the medication. */
  monograph?: Maybe<Array<Maybe<MedicationKnowledgemonograph>>>;
  /** Identifies a particular constituent of interest in the product. */
  ingredient?: Maybe<Array<Maybe<MedicationKnowledgeingredient>>>;
  /** The instructions for preparing the medication. */
  _preparationInstruction?: Maybe<Element>;
  /** The instructions for preparing the medication. */
  preparationInstruction?: Maybe<Scalars['String']>;
  /** The intended or approved route of administration. */
  intendedRoute?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The price of the medication. */
  cost?: Maybe<Array<Maybe<MedicationKnowledgecost>>>;
  /** The program under which the medication is reviewed. */
  monitoringProgram?: Maybe<Array<Maybe<MedicationKnowledgemonitoringProgram>>>;
  /** Guidelines for the administration of the medication. */
  administrationGuidelines?: Maybe<Array<Maybe<MedicationKnowledgeadministrationGuidelines>>>;
  /** Categorization of the medication within a formulary or classification system. */
  medicineClassification?: Maybe<Array<Maybe<MedicationKnowledgemedicineClassification>>>;
  /** Information that only applies to packages (not products). */
  packaging?: Maybe<MedicationKnowledgepackaging>;
  /** Specifies descriptive properties of the medicine, such as color, shape, imprints, etc. */
  drugCharacteristic?: Maybe<Array<Maybe<MedicationKnowledgedrugCharacteristic>>>;
  /**
   * Potential clinical issue with or between medication(s) (for example, drug-drug
   * interaction, drug-disease contraindication, drug-allergy interaction, etc.).
   */
  contraindication?: Maybe<Array<Maybe<MedicationKnowledgecontraindication_Contraindication_Union>>>;
  /** Regulatory information about a medication. */
  regulatory?: Maybe<Array<Maybe<MedicationKnowledgeregulatory>>>;
  /** The time course of drug absorption, distribution, metabolism and excretion of a medication from the body. */
  kinetics?: Maybe<Array<Maybe<MedicationKnowledgekinetics>>>;
};

export enum MedicationKnowledge_Enum_Schema {
  MedicationKnowledge = 'MedicationKnowledge'
}

export type MedicationKnowledgeadministrationGuidelines = {
  __typename?: 'MedicationKnowledgeadministrationGuidelines';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Dosage for the medication for the specific guidelines. */
  dosage?: Maybe<Array<Maybe<MedicationKnowledgeadministrationGuidelinesdosage>>>;
  /** Indication for use that apply to the specific administration guidelines. */
  indicationCodeableConcept?: Maybe<CodeableConcept>;
  /** Indication for use that apply to the specific administration guidelines. */
  indicationReference?: Maybe<MedicationKnowledgeadministrationGuidelinesindicationReference_IndicationReference_Union>;
  /**
   * Characteristics of the patient that are relevant to the administration
   * guidelines (for example, height, weight, gender, etc.).
   */
  patientCharacteristics?: Maybe<Array<Maybe<MedicationKnowledgeadministrationGuidelinespatientCharacteristics>>>;
};

export type MedicationKnowledgeadministrationGuidelinesdosage = {
  __typename?: 'MedicationKnowledgeadministrationGuidelinesdosage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of dosage (for example, prophylaxis, maintenance, therapeutic, etc.). */
  type: CodeableConcept;
  /** Dosage for the medication for the specific guidelines. */
  dosage?: Maybe<Array<Dosage>>;
};

/** Indication for use that apply to the specific administration guidelines. */
export type MedicationKnowledgeadministrationGuidelinesindicationReference_IndicationReference_Union = ObservationDefinition;

export type MedicationKnowledgeadministrationGuidelinespatientCharacteristics = {
  __typename?: 'MedicationKnowledgeadministrationGuidelinespatientCharacteristics';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Specific characteristic that is relevant to the administration guideline (e.g. height, weight, gender). */
  characteristicCodeableConcept: CodeableConcept;
  /** Specific characteristic that is relevant to the administration guideline (e.g. height, weight, gender). */
  characteristicQuantity: Quantity;
  /** The specific characteristic (e.g. height, weight, gender, etc.). */
  _value?: Maybe<Element>;
  /** The specific characteristic (e.g. height, weight, gender, etc.). */
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * Associated or related medications.  For example, if the medication is a branded
 * product (e.g. Crestor), this is the Therapeutic Moeity (e.g. Rosuvastatin) or if
 * this is a generic medication (e.g. Rosuvastatin), this would link to a branded
 * product (e.g. Crestor).
 */
export type MedicationKnowledgeassociatedMedication_AssociatedMedication_Union = Medication;

/**
 * Potential clinical issue with or between medication(s) (for example, drug-drug
 * interaction, drug-disease contraindication, drug-allergy interaction, etc.).
 */
export type MedicationKnowledgecontraindication_Contraindication_Union = DetectedIssue;

export type MedicationKnowledgecost = {
  __typename?: 'MedicationKnowledgecost';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The category of the cost information.  For example, manufacturers' cost,
   * patient cost, claim reimbursement cost, actual acquisition cost.
   */
  type: CodeableConcept;
  /** The source or owner that assigns the price to the medication. */
  _source?: Maybe<Element>;
  /** The source or owner that assigns the price to the medication. */
  source?: Maybe<Scalars['String']>;
  /** The price of the medication. */
  cost: Money;
};

export type MedicationKnowledgedrugCharacteristic = {
  __typename?: 'MedicationKnowledgedrugCharacteristic';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A code specifying which characteristic of the medicine is being described (for example, colour, shape, imprint). */
  type?: Maybe<CodeableConcept>;
  /** Description of the characteristic. */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** Description of the characteristic. */
  _valueString?: Maybe<Element>;
  /** Description of the characteristic. */
  valueString?: Maybe<Scalars['String']>;
  /** Description of the characteristic. */
  valueQuantity?: Maybe<Quantity>;
  /** Description of the characteristic. */
  _valueBase64Binary?: Maybe<Element>;
  /** Description of the characteristic. */
  valueBase64Binary?: Maybe<Scalars['base64Binary']>;
};

export type MedicationKnowledgeingredient = {
  __typename?: 'MedicationKnowledgeingredient';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The actual ingredient - either a substance (simple ingredient) or another medication. */
  itemCodeableConcept: CodeableConcept;
  /** The actual ingredient - either a substance (simple ingredient) or another medication. */
  itemReference: MedicationKnowledgeingredientitemReference_ItemReference_Union;
  /** Indication of whether this ingredient affects the therapeutic action of the drug. */
  _isActive?: Maybe<Element>;
  /** Indication of whether this ingredient affects the therapeutic action of the drug. */
  isActive?: Maybe<Scalars['Boolean']>;
  /**
   * Specifies how many (or how much) of the items there are in this Medication.
   * For example, 250 mg per tablet.  This is expressed as a ratio where the
   * numerator is 250mg and the denominator is 1 tablet.
   */
  strength?: Maybe<Ratio>;
};

/** The actual ingredient - either a substance (simple ingredient) or another medication. */
export type MedicationKnowledgeingredientitemReference_ItemReference_Union = Substance;

export type MedicationKnowledgekinetics = {
  __typename?: 'MedicationKnowledgekinetics';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The drug concentration measured at certain discrete points in time. */
  areaUnderCurve?: Maybe<Array<Maybe<Quantity>>>;
  /** The median lethal dose of a drug. */
  lethalDose50?: Maybe<Array<Maybe<Quantity>>>;
  /** The time required for any specified property (e.g., the concentration of a substance in the body) to decrease by half. */
  halfLifePeriod?: Maybe<Duration>;
};

/**
 * Describes the details of the manufacturer of the medication product.  This is
 * not intended to represent the distributor of a medication product.
 */
export type MedicationKnowledgemanufacturer_Manufacturer_Union = Organization;

export type MedicationKnowledgemedicineClassification = {
  __typename?: 'MedicationKnowledgemedicineClassification';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of category for the medication (for example, therapeutic classification, therapeutic sub-classification). */
  type: CodeableConcept;
  /** Specific category assigned to the medication (e.g. anti-infective, anti-hypertensive, antibiotic, etc.). */
  classification?: Maybe<Array<Maybe<CodeableConcept>>>;
};

export type MedicationKnowledgemonitoringProgram = {
  __typename?: 'MedicationKnowledgemonitoringProgram';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of program under which the medication is monitored. */
  type?: Maybe<CodeableConcept>;
  /** Name of the reviewing program. */
  _name?: Maybe<Element>;
  /** Name of the reviewing program. */
  name?: Maybe<Scalars['String']>;
};

export type MedicationKnowledgemonograph = {
  __typename?: 'MedicationKnowledgemonograph';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The category of documentation about the medication. (e.g. professional monograph, patient education monograph). */
  type?: Maybe<CodeableConcept>;
  /** Associated documentation about the medication. */
  source?: Maybe<MedicationKnowledgemonographsource_Source_Union>;
};

/** Associated documentation about the medication. */
export type MedicationKnowledgemonographsource_Source_Union = DocumentReference | Media;

export type MedicationKnowledgepackaging = {
  __typename?: 'MedicationKnowledgepackaging';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A code that defines the specific type of packaging that the medication can be
   * found in (e.g. blister sleeve, tube, bottle).
   */
  type?: Maybe<CodeableConcept>;
  /** The number of product units the package would contain if fully loaded. */
  quantity?: Maybe<Quantity>;
};

export type MedicationKnowledgeregulatory = {
  __typename?: 'MedicationKnowledgeregulatory';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The authority that is specifying the regulations. */
  regulatoryAuthority: MedicationKnowledgeregulatoryregulatoryAuthority_RegulatoryAuthority_Union;
  /** Specifies if changes are allowed when dispensing a medication from a regulatory perspective. */
  substitution?: Maybe<Array<Maybe<MedicationKnowledgeregulatorysubstitution>>>;
  /** Specifies the schedule of a medication in jurisdiction. */
  schedule?: Maybe<Array<Maybe<MedicationKnowledgeregulatoryschedule>>>;
  /** The maximum number of units of the medication that can be dispensed in a period. */
  maxDispense?: Maybe<MedicationKnowledgeregulatorymaxDispense>;
};

export type MedicationKnowledgeregulatorymaxDispense = {
  __typename?: 'MedicationKnowledgeregulatorymaxDispense';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The maximum number of units of the medication that can be dispensed. */
  quantity: Quantity;
  /** The period that applies to the maximum number of units. */
  period?: Maybe<Duration>;
};

/** The authority that is specifying the regulations. */
export type MedicationKnowledgeregulatoryregulatoryAuthority_RegulatoryAuthority_Union = Organization;

export type MedicationKnowledgeregulatoryschedule = {
  __typename?: 'MedicationKnowledgeregulatoryschedule';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Specifies the specific drug schedule. */
  schedule: CodeableConcept;
};

export type MedicationKnowledgeregulatorysubstitution = {
  __typename?: 'MedicationKnowledgeregulatorysubstitution';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Specifies the type of substitution allowed. */
  type: CodeableConcept;
  /** Specifies if regulation allows for changes in the medication when dispensing. */
  _allowed?: Maybe<Element>;
  /** Specifies if regulation allows for changes in the medication when dispensing. */
  allowed: Scalars['Boolean'];
};

export type MedicationKnowledgerelatedMedicationKnowledge = {
  __typename?: 'MedicationKnowledgerelatedMedicationKnowledge';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The category of the associated medication knowledge reference. */
  type: CodeableConcept;
  /** Associated documentation about the associated medication knowledge. */
  reference?: Maybe<Array<MedicationKnowledgerelatedMedicationKnowledgereference_Reference_Union>>;
};

/** Associated documentation about the associated medication knowledge. */
export type MedicationKnowledgerelatedMedicationKnowledgereference_Reference_Union = MedicationKnowledge;

/** MedicationMasterDocument_Input. */
export type MedicationMasterDocument = {
  __typename?: 'MedicationMasterDocument';
  /** Type of resource */
  resourceType: MedicationMasterDocument_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** practitioner Name. */
  drugName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  dosage?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** practitioner Id. */
  route?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** practitioner Id. */
  frequency?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** controlledDrug. */
  controlledDrug?: Maybe<Scalars['String']>;
};

export enum MedicationMasterDocument_Enum {
  MedicationMaster = 'MedicationMaster'
}

export enum MedicationMaster_Enum_Input {
  MedicationMaster = 'MedicationMaster'
}

/** PatientDocuments */
export type MedicationMaster_Input = {
  /** Type of resource */
  resourceType: MedicationMaster_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** practitioner Name. */
  drugName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  dosage?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** practitioner Id. */
  route?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** practitioner Id. */
  frequency?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * An order or request for both supply of the medication and the instructions for
 * administration of the medication to a patient. The resource is called
 * 'MedicationRequest' rather than 'MedicationPrescription' or 'MedicationOrder' to
 * generalize the use across inpatient and outpatient settings, including care
 * plans, etc., and to harmonize with workflow patterns.
 */
export type MedicationRequest = {
  __typename?: 'MedicationRequest';
  /** Type of resource */
  resourceType: MedicationRequest_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Identifiers associated with this medication request that are defined by
   * business processes and/or used to refer to it when a direct URL reference to
   * the resource itself is not appropriate. They are business identifiers assigned
   * to this resource by the performer or other systems and remain constant as the
   * resource is updated and propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A code specifying the current state of the order.  Generally, this will be active or completed state. */
  _status?: Maybe<Element>;
  /** A code specifying the current state of the order.  Generally, this will be active or completed state. */
  status: Scalars['code'];
  /** Captures the reason for the current state of the MedicationRequest. */
  statusReason?: Maybe<CodeableConcept>;
  /** Whether the request is a proposal, plan, or an original order. */
  _intent?: Maybe<Element>;
  /** Whether the request is a proposal, plan, or an original order. */
  intent: Scalars['code'];
  /**
   * Indicates the type of medication request (for example, where the medication is
   * expected to be consumed or administered (i.e. inpatient or outpatient)).
   */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates how quickly the Medication Request should be addressed with respect to other requests. */
  _priority?: Maybe<Element>;
  /** Indicates how quickly the Medication Request should be addressed with respect to other requests. */
  priority?: Maybe<Scalars['code']>;
  /** If true indicates that the provider is asking for the medication request not to occur. */
  _doNotPerform?: Maybe<Element>;
  /** If true indicates that the provider is asking for the medication request not to occur. */
  doNotPerform?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates if this record was captured as a secondary 'reported' record rather
   * than as an original primary source-of-truth record.  It may also indicate the
   * source of the report.
   */
  _reportedBoolean?: Maybe<Element>;
  /**
   * Indicates if this record was captured as a secondary 'reported' record rather
   * than as an original primary source-of-truth record.  It may also indicate the
   * source of the report.
   */
  reportedBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates if this record was captured as a secondary 'reported' record rather
   * than as an original primary source-of-truth record.  It may also indicate the
   * source of the report.
   */
  reportedReference?: Maybe<MedicationRequestreportedReference_ReportedReference_Union>;
  /**
   * Identifies the medication being requested. This is a link to a resource that
   * represents the medication which may be the details of the medication or simply
   * an attribute carrying a code that identifies the medication from a known list
   * of medications.
   */
  medicationCodeableConcept: CodeableConcept;
  /**
   * Identifies the medication being requested. This is a link to a resource that
   * represents the medication which may be the details of the medication or simply
   * an attribute carrying a code that identifies the medication from a known list
   * of medications.
   */
  medicationReference: MedicationRequestmedicationReference_MedicationReference_Union;
  /** A link to a resource representing the person or set of individuals to whom the medication will be given. */
  subject: MedicationRequestsubject_Subject_Union;
  /** The Encounter during which this [x] was created or to which the creation of this record is tightly associated. */
  encounter?: Maybe<MedicationRequestencounter_Encounter_Union>;
  /** Include additional information (for example, patient height and weight) that supports the ordering of the medication. */
  supportingInformation?: Maybe<Array<Maybe<MedicationRequestsupportingInformation_SupportingInformation_Union>>>;
  /** The date (and perhaps time) when the prescription was initially written or authored on. */
  _authoredOn?: Maybe<Element>;
  /** The date (and perhaps time) when the prescription was initially written or authored on. */
  authoredOn?: Maybe<Scalars['dateTime']>;
  /** The individual, organization, or device that initiated the request and has responsibility for its activation. */
  requester?: Maybe<MedicationRequestrequester_Requester_Union>;
  /** The specified desired performer of the medication treatment (e.g. the performer of the medication administration). */
  performer?: Maybe<MedicationRequestperformer_Performer_Union>;
  /** Indicates the type of performer of the administration of the medication. */
  performerType?: Maybe<CodeableConcept>;
  /** The person who entered the order on behalf of another individual for example in the case of a verbal or a telephone order. */
  recorder?: Maybe<MedicationRequestrecorder_Recorder_Union>;
  /** The reason or the indication for ordering or not ordering the medication. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Condition or observation that supports why the medication was ordered. */
  reasonReference?: Maybe<Array<Maybe<MedicationRequestreasonReference_ReasonReference_Union>>>;
  /**
   * The URL pointing to a protocol, guideline, orderset, or other definition that
   * is adhered to in whole or in part by this MedicationRequest.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * The URL pointing to a protocol, guideline, orderset, or other definition that
   * is adhered to in whole or in part by this MedicationRequest.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this
   * MedicationRequest.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this
   * MedicationRequest.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** A plan or request that is fulfilled in whole or in part by this medication request. */
  basedOn?: Maybe<Array<Maybe<MedicationRequestbasedOn_BasedOn_Union>>>;
  /**
   * A shared identifier common to all requests that were authorized more or less
   * simultaneously by a single author, representing the identifier of the
   * requisition or prescription.
   */
  groupIdentifier?: Maybe<Identifier>;
  /** The description of the overall patte3rn of the administration of the medication to the patient. */
  courseOfTherapyType?: Maybe<CodeableConcept>;
  /**
   * Insurance plans, coverage extensions, pre-authorizations and/or
   * pre-determinations that may be required for delivering the requested service.
   */
  insurance?: Maybe<Array<Maybe<MedicationRequestinsurance_Insurance_Union>>>;
  /** Extra information about the prescription that could not be conveyed by the other attributes. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Indicates how the medication is to be used by the patient. */
  dosageInstruction?: Maybe<Array<Maybe<Dosage>>>;
  /**
   * Indicates the specific details for the dispense or medication supply part of a
   * medication request (also known as a Medication Prescription or Medication
   * Order).  Note that this information is not always sent with the order.  There
   * may be in some settings (e.g. hospitals) institutional or system support for
   * completing the dispense details in the pharmacy department.
   */
  dispenseRequest?: Maybe<MedicationRequestdispenseRequest>;
  /**
   * Indicates whether or not substitution can or should be part of the dispense.
   * In some cases, substitution must happen, in other cases substitution must not
   * happen. This block explains the prescriber's intent. If nothing is specified
   * substitution may be done.
   */
  substitution?: Maybe<MedicationRequestsubstitution>;
  /** A link to a resource representing an earlier order related order or prescription. */
  priorPrescription?: Maybe<MedicationRequestpriorPrescription_PriorPrescription_Union>;
  /**
   * Indicates an actual or potential clinical issue with or between one or more
   * active or proposed clinical actions for a patient; e.g. Drug-drug interaction,
   * duplicate therapy, dosage alert etc.
   */
  detectedIssue?: Maybe<Array<Maybe<MedicationRequestdetectedIssue_DetectedIssue_Union>>>;
  /**
   * Links to Provenance records for past versions of this resource or fulfilling
   * request or event resources that identify key state transitions or updates that
   * are likely to be relevant to a user looking at the current version of the resource.
   */
  eventHistory?: Maybe<Array<Maybe<MedicationRequesteventHistory_EventHistory_Union>>>;
};

export enum MedicationRequest_Enum_Schema {
  MedicationRequest = 'MedicationRequest'
}

/** A plan or request that is fulfilled in whole or in part by this medication request. */
export type MedicationRequestbasedOn_BasedOn_Union = CarePlan | MedicationRequest | ServiceRequest | ImmunizationRecommendation;

/**
 * Indicates an actual or potential clinical issue with or between one or more
 * active or proposed clinical actions for a patient; e.g. Drug-drug interaction,
 * duplicate therapy, dosage alert etc.
 */
export type MedicationRequestdetectedIssue_DetectedIssue_Union = DetectedIssue;

export type MedicationRequestdispenseRequest = {
  __typename?: 'MedicationRequestdispenseRequest';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates the quantity or duration for the first dispense of the medication. */
  initialFill?: Maybe<MedicationRequestdispenseRequestinitialFill>;
  /** The minimum period of time that must occur between dispenses of the medication. */
  dispenseInterval?: Maybe<Duration>;
  /** This indicates the validity period of a prescription (stale dating the Prescription). */
  validityPeriod?: Maybe<Period>;
  /**
   * An integer indicating the number of times, in addition to the original
   * dispense, (aka refills or repeats) that the patient can receive the prescribed
   * medication. Usage Notes: This integer does not include the original order
   * dispense. This means that if an order indicates dispense 30 tablets plus '3
   * repeats', then the order can be dispensed a total of 4 times and the patient
   * can receive a total of 120 tablets.  A prescriber may explicitly say that zero
   * refills are permitted after the initial dispense.
   */
  _numberOfRepeatsAllowed?: Maybe<Element>;
  /**
   * An integer indicating the number of times, in addition to the original
   * dispense, (aka refills or repeats) that the patient can receive the prescribed
   * medication. Usage Notes: This integer does not include the original order
   * dispense. This means that if an order indicates dispense 30 tablets plus '3
   * repeats', then the order can be dispensed a total of 4 times and the patient
   * can receive a total of 120 tablets.  A prescriber may explicitly say that zero
   * refills are permitted after the initial dispense.
   */
  numberOfRepeatsAllowed?: Maybe<Scalars['unsignedInt']>;
  /** The amount that is to be dispensed for one fill. */
  quantity?: Maybe<Quantity>;
  /**
   * Identifies the period time over which the supplied product is expected to be
   * used, or the length of time the dispense is expected to last.
   */
  expectedSupplyDuration?: Maybe<Duration>;
  /** Indicates the intended dispensing Organization specified by the prescriber. */
  performer?: Maybe<MedicationRequestdispenseRequestperformer_Performer_Union>;
};

export type MedicationRequestdispenseRequestinitialFill = {
  __typename?: 'MedicationRequestdispenseRequestinitialFill';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The amount or quantity to provide as part of the first dispense. */
  quantity?: Maybe<Quantity>;
  /** The length of time that the first dispense is expected to last. */
  duration?: Maybe<Duration>;
};

/** Indicates the intended dispensing Organization specified by the prescriber. */
export type MedicationRequestdispenseRequestperformer_Performer_Union = Organization;

/** The Encounter during which this [x] was created or to which the creation of this record is tightly associated. */
export type MedicationRequestencounter_Encounter_Union = Encounter;

/**
 * Links to Provenance records for past versions of this resource or fulfilling
 * request or event resources that identify key state transitions or updates that
 * are likely to be relevant to a user looking at the current version of the resource.
 */
export type MedicationRequesteventHistory_EventHistory_Union = Provenance;

/**
 * Insurance plans, coverage extensions, pre-authorizations and/or
 * pre-determinations that may be required for delivering the requested service.
 */
export type MedicationRequestinsurance_Insurance_Union = Coverage | ClaimResponse;

/**
 * Identifies the medication being requested. This is a link to a resource that
 * represents the medication which may be the details of the medication or simply
 * an attribute carrying a code that identifies the medication from a known list of medications.
 */
export type MedicationRequestmedicationReference_MedicationReference_Union = Medication;

/** The specified desired performer of the medication treatment (e.g. the performer of the medication administration). */
export type MedicationRequestperformer_Performer_Union = Practitioner | PractitionerRole | Organization | Patient | Device | RelatedPerson | CareTeam;

/** A link to a resource representing an earlier order related order or prescription. */
export type MedicationRequestpriorPrescription_PriorPrescription_Union = MedicationRequest;

/** Condition or observation that supports why the medication was ordered. */
export type MedicationRequestreasonReference_ReasonReference_Union = Condition | Observation;

/** The person who entered the order on behalf of another individual for example in the case of a verbal or a telephone order. */
export type MedicationRequestrecorder_Recorder_Union = Practitioner | PractitionerRole;

/**
 * Indicates if this record was captured as a secondary 'reported' record rather
 * than as an original primary source-of-truth record.  It may also indicate the
 * source of the report.
 */
export type MedicationRequestreportedReference_ReportedReference_Union = Patient | Practitioner | PractitionerRole | RelatedPerson | Organization;

/** The individual, organization, or device that initiated the request and has responsibility for its activation. */
export type MedicationRequestrequester_Requester_Union = Practitioner | PractitionerRole | Organization | Patient | RelatedPerson | Device;

/** A link to a resource representing the person or set of individuals to whom the medication will be given. */
export type MedicationRequestsubject_Subject_Union = Patient | Group;

export type MedicationRequestsubstitution = {
  __typename?: 'MedicationRequestsubstitution';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** True if the prescriber allows a different drug to be dispensed from what was prescribed. */
  _allowedBoolean?: Maybe<Element>;
  /** True if the prescriber allows a different drug to be dispensed from what was prescribed. */
  allowedBoolean: Scalars['Boolean'];
  /** True if the prescriber allows a different drug to be dispensed from what was prescribed. */
  allowedCodeableConcept: CodeableConcept;
  /** Indicates the reason for the substitution, or why substitution must or must not be performed. */
  reason?: Maybe<CodeableConcept>;
};

/** Include additional information (for example, patient height and weight) that supports the ordering of the medication. */
export type MedicationRequestsupportingInformation_SupportingInformation_Union = Resource;

/**
 * A record of a medication that is being consumed by a patient.   A
 * MedicationStatement may indicate that the patient may be taking the medication
 * now or has taken the medication in the past or will be taking the medication in
 * the future.  The source of this information can be the patient, significant
 * other (such as a family member or spouse), or a clinician.  A common scenario
 * where this information is captured is during the history taking process during a
 * patient visit or stay.   The medication information may come from sources such
 * as the patient's memory, from a prescription bottle,  or from a list of
 * medications the patient, clinician or other party maintains.   The primary
 * difference between a medication statement and a medication administration is
 * that the medication administration has complete administration information and
 * is based on actual administration information from the person who administered
 * the medication.  A medication statement is often, if not always, less specific.
 * There is no required date/time when the medication was administered, in fact we
 * only know that a source has reported the patient is taking this medication,
 * where details such as time, quantity, or rate or even medication product may be
 * incomplete or missing or less precise.  As stated earlier, the medication
 * statement information may come from the patient's memory, from a prescription
 * bottle or from a list of medications the patient, clinician or other party
 * maintains.  Medication administration is more formal and is not missing detailed information.
 */
export type MedicationStatement = {
  __typename?: 'MedicationStatement';
  /** Type of resource */
  resourceType: MedicationStatement_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Identifiers associated with this Medication Statement that are defined by
   * business processes and/or used to refer to it when a direct URL reference to
   * the resource itself is not appropriate. They are business identifiers assigned
   * to this resource by the performer or other systems and remain constant as the
   * resource is updated and propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A plan, proposal or order that is fulfilled in whole or in part by this event. */
  basedOn?: Maybe<Array<Maybe<MedicationStatementbasedOn_BasedOn_Union>>>;
  /** A larger event of which this particular event is a component or step. */
  partOf?: Maybe<Array<Maybe<MedicationStatementpartOf_PartOf_Union>>>;
  /**
   * A code representing the patient or other source's judgment about the state of
   * the medication used that this statement is about.  Generally, this will be
   * active or completed.
   */
  _status?: Maybe<Element>;
  /**
   * A code representing the patient or other source's judgment about the state of
   * the medication used that this statement is about.  Generally, this will be
   * active or completed.
   */
  status: Scalars['code'];
  /** Captures the reason for the current state of the MedicationStatement. */
  statusReason?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates where the medication is expected to be consumed or administered. */
  category?: Maybe<CodeableConcept>;
  /**
   * Identifies the medication being administered. This is either a link to a
   * resource representing the details of the medication or a simple attribute
   * carrying a code that identifies the medication from a known list of medications.
   */
  medicationCodeableConcept: CodeableConcept;
  /**
   * Identifies the medication being administered. This is either a link to a
   * resource representing the details of the medication or a simple attribute
   * carrying a code that identifies the medication from a known list of medications.
   */
  medicationReference: MedicationStatementmedicationReference_MedicationReference_Union;
  /** The person, animal or group who is/was taking the medication. */
  subject: MedicationStatementsubject_Subject_Union;
  /** The encounter or episode of care that establishes the context for this MedicationStatement. */
  context?: Maybe<MedicationStatementcontext_Context_Union>;
  /**
   * The interval of time during which it is being asserted that the patient
   * is/was/will be taking the medication (or was not taking, when the
   * MedicationStatement.taken element is No).
   */
  _effectiveDateTime?: Maybe<Element>;
  /**
   * The interval of time during which it is being asserted that the patient
   * is/was/will be taking the medication (or was not taking, when the
   * MedicationStatement.taken element is No).
   */
  effectiveDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The interval of time during which it is being asserted that the patient
   * is/was/will be taking the medication (or was not taking, when the
   * MedicationStatement.taken element is No).
   */
  effectivePeriod?: Maybe<Period>;
  /** The date when the medication statement was asserted by the information source. */
  _dateAsserted?: Maybe<Element>;
  /** The date when the medication statement was asserted by the information source. */
  dateAsserted?: Maybe<Scalars['dateTime']>;
  /**
   * The person or organization that provided the information about the taking of
   * this medication. Note: Use derivedFrom when a MedicationStatement is derived
   * from other resources, e.g. Claim or MedicationRequest.
   */
  informationSource?: Maybe<MedicationStatementinformationSource_InformationSource_Union>;
  /**
   * Allows linking the MedicationStatement to the underlying MedicationRequest, or
   * to other information that supports or is used to derive the
   * MedicationStatement.
   */
  derivedFrom?: Maybe<Array<Maybe<MedicationStatementderivedFrom_DerivedFrom_Union>>>;
  /** A reason for why the medication is being/was taken. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Condition or observation that supports why the medication is being/was taken. */
  reasonReference?: Maybe<Array<Maybe<MedicationStatementreasonReference_ReasonReference_Union>>>;
  /** Provides extra information about the medication statement that is not conveyed by the other attributes. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Indicates how the medication is/was or should be taken by the patient. */
  dosage?: Maybe<Array<Maybe<Dosage>>>;
};

export enum MedicationStatement_Enum_Schema {
  MedicationStatement = 'MedicationStatement'
}

/** A plan, proposal or order that is fulfilled in whole or in part by this event. */
export type MedicationStatementbasedOn_BasedOn_Union = MedicationRequest | CarePlan | ServiceRequest;

/** The encounter or episode of care that establishes the context for this MedicationStatement. */
export type MedicationStatementcontext_Context_Union = Encounter | EpisodeOfCare;

/**
 * Allows linking the MedicationStatement to the underlying MedicationRequest, or
 * to other information that supports or is used to derive the MedicationStatement.
 */
export type MedicationStatementderivedFrom_DerivedFrom_Union = Resource;

/**
 * The person or organization that provided the information about the taking of
 * this medication. Note: Use derivedFrom when a MedicationStatement is derived
 * from other resources, e.g. Claim or MedicationRequest.
 */
export type MedicationStatementinformationSource_InformationSource_Union = Patient | Practitioner | PractitionerRole | RelatedPerson | Organization;

/**
 * Identifies the medication being administered. This is either a link to a
 * resource representing the details of the medication or a simple attribute
 * carrying a code that identifies the medication from a known list of medications.
 */
export type MedicationStatementmedicationReference_MedicationReference_Union = Medication;

/** A larger event of which this particular event is a component or step. */
export type MedicationStatementpartOf_PartOf_Union = MedicationAdministration | MedicationDispense | MedicationStatement | Procedure | Observation;

/** Condition or observation that supports why the medication is being/was taken. */
export type MedicationStatementreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport;

/** The person, animal or group who is/was taking the medication. */
export type MedicationStatementsubject_Subject_Union = Patient | Group;

export enum Medication_Enum_Input {
  Medication = 'Medication'
}

export enum Medication_Enum_Schema {
  Medication = 'Medication'
}

/**
 * This resource is primarily used for the identification and definition of a
 * medication for the purposes of prescribing, dispensing, and administering a
 * medication as well as for making statements about medication use.
 */
export type Medication_Input = {
  /** Type of resource */
  resourceType: Medication_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Business identifier for this medication. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /**
   * A code (or set of codes) that specify this medication, or a textual
   * description if no code is available. Usage note: This could be a standard
   * medication code such as a code from RxNorm, SNOMED CT, IDMP etc. It could also
   * be a national or local formulary code, optionally with translations to other code systems.
   */
  code?: Maybe<CodeableConcept_Input>;
  /** A code to indicate if the medication is in active use. */
  _status?: Maybe<Element_Input>;
  /** A code to indicate if the medication is in active use. */
  status?: Maybe<Scalars['code']>;
  /**
   * Describes the details of the manufacturer of the medication product.  This is
   * not intended to represent the distributor of a medication product.
   */
  manufacturer?: Maybe<Scalars['String']>;
  /** Describes the form of the item.  Powder; tablets; capsule. */
  form?: Maybe<CodeableConcept_Input>;
  /**
   * Specific amount of the drug in the packaged product.  For example, when
   * specifying a product that has the same strength (For example, Insulin glargine
   * 100 unit per mL solution for injection), this attribute provides additional
   * clarification of the package amount (For example, 3 mL, 10mL, etc.).
   */
  amount?: Maybe<Ratio_Input>;
  /** Identifies a particular constituent of interest in the product. */
  ingredient?: Maybe<Array<Maybe<Medicationingredient_Input>>>;
  /** Information that only applies to packages (not products). */
  batch?: Maybe<Medicationbatch_Input>;
};

export type Medicationbatch = {
  __typename?: 'Medicationbatch';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The assigned lot number of a batch of the specified product. */
  _lotNumber?: Maybe<Element>;
  /** The assigned lot number of a batch of the specified product. */
  lotNumber?: Maybe<Scalars['String']>;
  /** When this specific batch of product will expire. */
  _expirationDate?: Maybe<Element>;
  /** When this specific batch of product will expire. */
  expirationDate?: Maybe<Scalars['dateTime']>;
};

export type Medicationbatch_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The assigned lot number of a batch of the specified product. */
  _lotNumber?: Maybe<Element_Input>;
  /** The assigned lot number of a batch of the specified product. */
  lotNumber?: Maybe<Scalars['String']>;
  /** When this specific batch of product will expire. */
  _expirationDate?: Maybe<Element_Input>;
  /** When this specific batch of product will expire. */
  expirationDate?: Maybe<Scalars['dateTime']>;
};

export type Medicationingredient = {
  __typename?: 'Medicationingredient';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The actual ingredient - either a substance (simple ingredient) or another medication of a medication. */
  itemCodeableConcept: CodeableConcept;
  /** The actual ingredient - either a substance (simple ingredient) or another medication of a medication. */
  itemReference: MedicationingredientitemReference_ItemReference_Union;
  /** Indication of whether this ingredient affects the therapeutic action of the drug. */
  _isActive?: Maybe<Element>;
  /** Indication of whether this ingredient affects the therapeutic action of the drug. */
  isActive?: Maybe<Scalars['Boolean']>;
  /**
   * Specifies how many (or how much) of the items there are in this Medication.
   * For example, 250 mg per tablet.  This is expressed as a ratio where the
   * numerator is 250mg and the denominator is 1 tablet.
   */
  strength?: Maybe<Ratio>;
};

export type Medicationingredient_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The actual ingredient - either a substance (simple ingredient) or another medication of a medication. */
  itemCodeableConcept: CodeableConcept_Input;
  /** The actual ingredient - either a substance (simple ingredient) or another medication of a medication. */
  itemReference: Scalars['String'];
  /** Indication of whether this ingredient affects the therapeutic action of the drug. */
  _isActive?: Maybe<Element_Input>;
  /** Indication of whether this ingredient affects the therapeutic action of the drug. */
  isActive?: Maybe<Scalars['Boolean']>;
  /**
   * Specifies how many (or how much) of the items there are in this Medication.
   * For example, 250 mg per tablet.  This is expressed as a ratio where the
   * numerator is 250mg and the denominator is 1 tablet.
   */
  strength?: Maybe<Ratio_Input>;
};

/** The actual ingredient - either a substance (simple ingredient) or another medication of a medication. */
export type MedicationingredientitemReference_ItemReference_Union = Substance | Medication;

/**
 * Describes the details of the manufacturer of the medication product.  This is
 * not intended to represent the distributor of a medication product.
 */
export type Medicationmanufacturer_Manufacturer_Union = Organization;

/** Detailed definition of a medicinal product, typically for uses other than direct patient care (e.g. regulatory use). */
export type MedicinalProduct = {
  __typename?: 'MedicinalProduct';
  /** Type of resource */
  resourceType: MedicinalProduct_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Business identifier for this product. Could be an MPID. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Regulatory type, e.g. Investigational or Authorized. */
  type?: Maybe<CodeableConcept>;
  /** If this medicine applies to human or veterinary uses. */
  domain?: Maybe<Coding>;
  /** The dose form for a single part product, or combined form of a multiple part product. */
  combinedPharmaceuticalDoseForm?: Maybe<CodeableConcept>;
  /** The legal status of supply of the medicinal product as classified by the regulator. */
  legalStatusOfSupply?: Maybe<CodeableConcept>;
  /** Whether the Medicinal Product is subject to additional monitoring for regulatory reasons. */
  additionalMonitoringIndicator?: Maybe<CodeableConcept>;
  /** Whether the Medicinal Product is subject to special measures for regulatory reasons. */
  _specialMeasures?: Maybe<Element>;
  /** Whether the Medicinal Product is subject to special measures for regulatory reasons. */
  specialMeasures?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** If authorised for use in children. */
  paediatricUseIndicator?: Maybe<CodeableConcept>;
  /** Allows the product to be classified by various systems. */
  productClassification?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Marketing status of the medicinal product, in contrast to marketing authorizaton. */
  marketingStatus?: Maybe<Array<Maybe<MarketingStatus>>>;
  /** Pharmaceutical aspects of product. */
  pharmaceuticalProduct?: Maybe<Array<Maybe<MedicinalProductpharmaceuticalProduct_PharmaceuticalProduct_Union>>>;
  /** Package representation for the product. */
  packagedMedicinalProduct?: Maybe<Array<Maybe<MedicinalProductpackagedMedicinalProduct_PackagedMedicinalProduct_Union>>>;
  /** Supporting documentation, typically for regulatory submission. */
  attachedDocument?: Maybe<Array<Maybe<MedicinalProductattachedDocument_AttachedDocument_Union>>>;
  /** A master file for to the medicinal product (e.g. Pharmacovigilance System Master File). */
  masterFile?: Maybe<Array<Maybe<MedicinalProductmasterFile_MasterFile_Union>>>;
  /** A product specific contact, person (in a role), or an organization. */
  contact?: Maybe<Array<Maybe<MedicinalProductcontact_Contact_Union>>>;
  /** Clinical trials or studies that this product is involved in. */
  clinicalTrial?: Maybe<Array<Maybe<MedicinalProductclinicalTrial_ClinicalTrial_Union>>>;
  /** The product's name, including full name and possibly coded parts. */
  name?: Maybe<Array<MedicinalProductname>>;
  /** Reference to another product, e.g. for linking authorised to investigational product. */
  crossReference?: Maybe<Array<Maybe<Identifier>>>;
  /** An operation applied to the product, for manufacturing or adminsitrative purpose. */
  manufacturingBusinessOperation?: Maybe<Array<Maybe<MedicinalProductmanufacturingBusinessOperation>>>;
  /** Indicates if the medicinal product has an orphan designation for the treatment of a rare disease. */
  specialDesignation?: Maybe<Array<Maybe<MedicinalProductspecialDesignation>>>;
};

/** The regulatory authorization of a medicinal product. */
export type MedicinalProductAuthorization = {
  __typename?: 'MedicinalProductAuthorization';
  /** Type of resource */
  resourceType: MedicinalProductAuthorization_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Business identifier for the marketing authorization, as assigned by a regulator. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The medicinal product that is being authorized. */
  subject?: Maybe<MedicinalProductAuthorizationsubject_Subject_Union>;
  /** The country in which the marketing authorization has been granted. */
  country?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Jurisdiction within a country. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The status of the marketing authorization. */
  status?: Maybe<CodeableConcept>;
  /** The date at which the given status has become applicable. */
  _statusDate?: Maybe<Element>;
  /** The date at which the given status has become applicable. */
  statusDate?: Maybe<Scalars['dateTime']>;
  /** The date when a suspended the marketing or the marketing authorization of the product is anticipated to be restored. */
  _restoreDate?: Maybe<Element>;
  /** The date when a suspended the marketing or the marketing authorization of the product is anticipated to be restored. */
  restoreDate?: Maybe<Scalars['dateTime']>;
  /**
   * The beginning of the time period in which the marketing authorization is in
   * the specific status shall be specified A complete date consisting of day,
   * month and year shall be specified using the ISO 8601 date format.
   */
  validityPeriod?: Maybe<Period>;
  /** A period of time after authorization before generic product applicatiosn can be submitted. */
  dataExclusivityPeriod?: Maybe<Period>;
  /** The date when the first authorization was granted by a Medicines Regulatory Agency. */
  _dateOfFirstAuthorization?: Maybe<Element>;
  /** The date when the first authorization was granted by a Medicines Regulatory Agency. */
  dateOfFirstAuthorization?: Maybe<Scalars['dateTime']>;
  /** Date of first marketing authorization for a company's new medicinal product in any country in the World. */
  _internationalBirthDate?: Maybe<Element>;
  /** Date of first marketing authorization for a company's new medicinal product in any country in the World. */
  internationalBirthDate?: Maybe<Scalars['dateTime']>;
  /** The legal framework against which this authorization is granted. */
  legalBasis?: Maybe<CodeableConcept>;
  /** Authorization in areas within a country. */
  jurisdictionalAuthorization?: Maybe<Array<Maybe<MedicinalProductAuthorizationjurisdictionalAuthorization>>>;
  /** Marketing Authorization Holder. */
  holder?: Maybe<MedicinalProductAuthorizationholder_Holder_Union>;
  /** Medicines Regulatory Agency. */
  regulator?: Maybe<MedicinalProductAuthorizationregulator_Regulator_Union>;
  /** The regulatory procedure for granting or amending a marketing authorization. */
  procedure?: Maybe<MedicinalProductAuthorizationprocedure>;
};

export enum MedicinalProductAuthorization_Enum_Schema {
  MedicinalProductAuthorization = 'MedicinalProductAuthorization'
}

/** Marketing Authorization Holder. */
export type MedicinalProductAuthorizationholder_Holder_Union = Organization;

export type MedicinalProductAuthorizationjurisdictionalAuthorization = {
  __typename?: 'MedicinalProductAuthorizationjurisdictionalAuthorization';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The assigned number for the marketing authorization. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Country of authorization. */
  country?: Maybe<CodeableConcept>;
  /** Jurisdiction within a country. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The legal status of supply in a jurisdiction or region. */
  legalStatusOfSupply?: Maybe<CodeableConcept>;
  /** The start and expected end date of the authorization. */
  validityPeriod?: Maybe<Period>;
};

export type MedicinalProductAuthorizationprocedure = {
  __typename?: 'MedicinalProductAuthorizationprocedure';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier for this procedure. */
  identifier?: Maybe<Identifier>;
  /** Type of procedure. */
  type: CodeableConcept;
  /** Date of procedure. */
  datePeriod?: Maybe<Period>;
  /** Date of procedure. */
  _dateDateTime?: Maybe<Element>;
  /** Date of procedure. */
  dateDateTime?: Maybe<Scalars['dateTime']>;
};

/** Medicines Regulatory Agency. */
export type MedicinalProductAuthorizationregulator_Regulator_Union = Organization;

/** The medicinal product that is being authorized. */
export type MedicinalProductAuthorizationsubject_Subject_Union = MedicinalProduct | MedicinalProductPackaged;

/** The clinical particulars - indications, contraindications etc. of a medicinal product, including for regulatory purposes. */
export type MedicinalProductContraindication = {
  __typename?: 'MedicinalProductContraindication';
  /** Type of resource */
  resourceType: MedicinalProductContraindication_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The medication for which this is an indication. */
  subject?: Maybe<Array<Maybe<MedicinalProductContraindicationsubject_Subject_Union>>>;
  /** The disease, symptom or procedure for the contraindication. */
  disease?: Maybe<CodeableConcept>;
  /** The status of the disease or symptom for the contraindication. */
  diseaseStatus?: Maybe<CodeableConcept>;
  /** A comorbidity (concurrent condition) or coinfection. */
  comorbidity?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Information about the use of the medicinal product in relation to other therapies as part of the indication. */
  therapeuticIndication?: Maybe<Array<Maybe<MedicinalProductContraindicationtherapeuticIndication_TherapeuticIndication_Union>>>;
  /** Information about the use of the medicinal product in relation to other therapies described as part of the indication. */
  otherTherapy?: Maybe<Array<Maybe<MedicinalProductContraindicationotherTherapy>>>;
  /** The population group to which this applies. */
  population?: Maybe<Array<Maybe<Population>>>;
};

export enum MedicinalProductContraindication_Enum_Schema {
  MedicinalProductContraindication = 'MedicinalProductContraindication'
}

export type MedicinalProductContraindicationotherTherapy = {
  __typename?: 'MedicinalProductContraindicationotherTherapy';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of relationship between the medicinal product indication or contraindication and another therapy. */
  therapyRelationshipType: CodeableConcept;
  /**
   * Reference to a specific medication (active substance, medicinal product or
   * class of products) as part of an indication or contraindication.
   */
  medicationCodeableConcept: CodeableConcept;
  /**
   * Reference to a specific medication (active substance, medicinal product or
   * class of products) as part of an indication or contraindication.
   */
  medicationReference: MedicinalProductContraindicationotherTherapymedicationReference_MedicationReference_Union;
};

/**
 * Reference to a specific medication (active substance, medicinal product or class
 * of products) as part of an indication or contraindication.
 */
export type MedicinalProductContraindicationotherTherapymedicationReference_MedicationReference_Union = MedicinalProduct | Medication | Substance | SubstanceSpecification;

/** The medication for which this is an indication. */
export type MedicinalProductContraindicationsubject_Subject_Union = MedicinalProduct | Medication;

/** Information about the use of the medicinal product in relation to other therapies as part of the indication. */
export type MedicinalProductContraindicationtherapeuticIndication_TherapeuticIndication_Union = MedicinalProductIndication;

/** Indication for the Medicinal Product. */
export type MedicinalProductIndication = {
  __typename?: 'MedicinalProductIndication';
  /** Type of resource */
  resourceType: MedicinalProductIndication_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The medication for which this is an indication. */
  subject?: Maybe<Array<Maybe<MedicinalProductIndicationsubject_Subject_Union>>>;
  /** The disease, symptom or procedure that is the indication for treatment. */
  diseaseSymptomProcedure?: Maybe<CodeableConcept>;
  /** The status of the disease or symptom for which the indication applies. */
  diseaseStatus?: Maybe<CodeableConcept>;
  /** Comorbidity (concurrent condition) or co-infection as part of the indication. */
  comorbidity?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The intended effect, aim or strategy to be achieved by the indication. */
  intendedEffect?: Maybe<CodeableConcept>;
  /** Timing or duration information as part of the indication. */
  duration?: Maybe<Quantity>;
  /** Information about the use of the medicinal product in relation to other therapies described as part of the indication. */
  otherTherapy?: Maybe<Array<Maybe<MedicinalProductIndicationotherTherapy>>>;
  /** Describe the undesirable effects of the medicinal product. */
  undesirableEffect?: Maybe<Array<Maybe<MedicinalProductIndicationundesirableEffect_UndesirableEffect_Union>>>;
  /** The population group to which this applies. */
  population?: Maybe<Array<Maybe<Population>>>;
};

export enum MedicinalProductIndication_Enum_Schema {
  MedicinalProductIndication = 'MedicinalProductIndication'
}

export type MedicinalProductIndicationotherTherapy = {
  __typename?: 'MedicinalProductIndicationotherTherapy';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of relationship between the medicinal product indication or contraindication and another therapy. */
  therapyRelationshipType: CodeableConcept;
  /**
   * Reference to a specific medication (active substance, medicinal product or
   * class of products) as part of an indication or contraindication.
   */
  medicationCodeableConcept: CodeableConcept;
  /**
   * Reference to a specific medication (active substance, medicinal product or
   * class of products) as part of an indication or contraindication.
   */
  medicationReference: MedicinalProductIndicationotherTherapymedicationReference_MedicationReference_Union;
};

/**
 * Reference to a specific medication (active substance, medicinal product or class
 * of products) as part of an indication or contraindication.
 */
export type MedicinalProductIndicationotherTherapymedicationReference_MedicationReference_Union = MedicinalProduct | Medication | Substance | SubstanceSpecification;

/** The medication for which this is an indication. */
export type MedicinalProductIndicationsubject_Subject_Union = MedicinalProduct | Medication;

/** Describe the undesirable effects of the medicinal product. */
export type MedicinalProductIndicationundesirableEffect_UndesirableEffect_Union = MedicinalProductUndesirableEffect;

/** An ingredient of a manufactured item or pharmaceutical product. */
export type MedicinalProductIngredient = {
  __typename?: 'MedicinalProductIngredient';
  /** Type of resource */
  resourceType: MedicinalProductIngredient_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The identifier(s) of this Ingredient that are assigned by business processes
   * and/or used to refer to it when a direct URL reference to the resource itself
   * is not appropriate.
   */
  identifier?: Maybe<Identifier>;
  /** Ingredient role e.g. Active ingredient, excipient. */
  role: CodeableConcept;
  /** If the ingredient is a known or suspected allergen. */
  _allergenicIndicator?: Maybe<Element>;
  /** If the ingredient is a known or suspected allergen. */
  allergenicIndicator?: Maybe<Scalars['Boolean']>;
  /** Manufacturer of this Ingredient. */
  manufacturer?: Maybe<Array<Maybe<MedicinalProductIngredientmanufacturer_Manufacturer_Union>>>;
  /** A specified substance that comprises this ingredient. */
  specifiedSubstance?: Maybe<Array<Maybe<MedicinalProductIngredientspecifiedSubstance>>>;
  /** The ingredient substance. */
  substance?: Maybe<MedicinalProductIngredientsubstance>;
};

export enum MedicinalProductIngredient_Enum_Schema {
  MedicinalProductIngredient = 'MedicinalProductIngredient'
}

/** Manufacturer of this Ingredient. */
export type MedicinalProductIngredientmanufacturer_Manufacturer_Union = Organization;

export type MedicinalProductIngredientspecifiedSubstance = {
  __typename?: 'MedicinalProductIngredientspecifiedSubstance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The specified substance. */
  code: CodeableConcept;
  /** The group of specified substance, e.g. group 1 to 4. */
  group: CodeableConcept;
  /** Confidentiality level of the specified substance as the ingredient. */
  confidentiality?: Maybe<CodeableConcept>;
  /** Quantity of the substance or specified substance present in the manufactured item or pharmaceutical product. */
  strength?: Maybe<Array<Maybe<MedicinalProductIngredientspecifiedSubstancestrength>>>;
};

export type MedicinalProductIngredientspecifiedSubstancestrength = {
  __typename?: 'MedicinalProductIngredientspecifiedSubstancestrength';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The quantity of substance in the unit of presentation, or in the volume (or
   * mass) of the single pharmaceutical product or manufactured item.
   */
  presentation: Ratio;
  /**
   * A lower limit for the quantity of substance in the unit of presentation. For
   * use when there is a range of strengths, this is the lower limit, with the
   * presentation attribute becoming the upper limit.
   */
  presentationLowLimit?: Maybe<Ratio>;
  /** The strength per unitary volume (or mass). */
  concentration?: Maybe<Ratio>;
  /**
   * A lower limit for the strength per unitary volume (or mass), for when there is
   * a range. The concentration attribute then becomes the upper limit.
   */
  concentrationLowLimit?: Maybe<Ratio>;
  /** For when strength is measured at a particular point or distance. */
  _measurementPoint?: Maybe<Element>;
  /** For when strength is measured at a particular point or distance. */
  measurementPoint?: Maybe<Scalars['String']>;
  /** The country or countries for which the strength range applies. */
  country?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Strength expressed in terms of a reference substance. */
  referenceStrength?: Maybe<Array<Maybe<MedicinalProductIngredientspecifiedSubstancestrengthreferenceStrength>>>;
};

export type MedicinalProductIngredientspecifiedSubstancestrengthreferenceStrength = {
  __typename?: 'MedicinalProductIngredientspecifiedSubstancestrengthreferenceStrength';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Relevant reference substance. */
  substance?: Maybe<CodeableConcept>;
  /** Strength expressed in terms of a reference substance. */
  strength: Ratio;
  /** Strength expressed in terms of a reference substance. */
  strengthLowLimit?: Maybe<Ratio>;
  /** For when strength is measured at a particular point or distance. */
  _measurementPoint?: Maybe<Element>;
  /** For when strength is measured at a particular point or distance. */
  measurementPoint?: Maybe<Scalars['String']>;
  /** The country or countries for which the strength range applies. */
  country?: Maybe<Array<Maybe<CodeableConcept>>>;
};

export type MedicinalProductIngredientsubstance = {
  __typename?: 'MedicinalProductIngredientsubstance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The ingredient substance. */
  code: CodeableConcept;
};

/** The interactions of the medicinal product with other medicinal products, or other forms of interactions. */
export type MedicinalProductInteraction = {
  __typename?: 'MedicinalProductInteraction';
  /** Type of resource */
  resourceType: MedicinalProductInteraction_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The medication for which this is a described interaction. */
  subject?: Maybe<Array<Maybe<MedicinalProductInteractionsubject_Subject_Union>>>;
  /** The interaction described. */
  _description?: Maybe<Element>;
  /** The interaction described. */
  description?: Maybe<Scalars['String']>;
  /** The specific medication, food or laboratory test that interacts. */
  interactant?: Maybe<Array<Maybe<MedicinalProductInteractioninteractant>>>;
  /** The type of the interaction e.g. drug-drug interaction, drug-food interaction, drug-lab test interaction. */
  type?: Maybe<CodeableConcept>;
  /** The effect of the interaction, for example 'reduced gastric absorption of primary medication'. */
  effect?: Maybe<CodeableConcept>;
  /** The incidence of the interaction, e.g. theoretical, observed. */
  incidence?: Maybe<CodeableConcept>;
  /** Actions for managing the interaction. */
  management?: Maybe<CodeableConcept>;
};

export enum MedicinalProductInteraction_Enum_Schema {
  MedicinalProductInteraction = 'MedicinalProductInteraction'
}

export type MedicinalProductInteractioninteractant = {
  __typename?: 'MedicinalProductInteractioninteractant';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The specific medication, food or laboratory test that interacts. */
  itemReference: MedicinalProductInteractioninteractantitemReference_ItemReference_Union;
  /** The specific medication, food or laboratory test that interacts. */
  itemCodeableConcept: CodeableConcept;
};

/** The specific medication, food or laboratory test that interacts. */
export type MedicinalProductInteractioninteractantitemReference_ItemReference_Union = MedicinalProduct | Medication | Substance | ObservationDefinition;

/** The medication for which this is a described interaction. */
export type MedicinalProductInteractionsubject_Subject_Union = MedicinalProduct | Medication | Substance;

/** The manufactured item as contained in the packaged medicinal product. */
export type MedicinalProductManufactured = {
  __typename?: 'MedicinalProductManufactured';
  /** Type of resource */
  resourceType: MedicinalProductManufactured_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Dose form as manufactured and before any transformation into the pharmaceutical product. */
  manufacturedDoseForm: CodeableConcept;
  /** The “real world” units in which the quantity of the manufactured item is described. */
  unitOfPresentation?: Maybe<CodeableConcept>;
  /** The quantity or 'count number' of the manufactured item. */
  quantity: Quantity;
  /** Manufacturer of the item (Note that this should be named 'manufacturer' but it currently causes technical issues). */
  manufacturer?: Maybe<Array<Maybe<MedicinalProductManufacturedmanufacturer_Manufacturer_Union>>>;
  /** Ingredient. */
  ingredient?: Maybe<Array<Maybe<MedicinalProductManufacturedingredient_Ingredient_Union>>>;
  /** Dimensions, color etc. */
  physicalCharacteristics?: Maybe<ProdCharacteristic>;
  /** Other codeable characteristics. */
  otherCharacteristics?: Maybe<Array<Maybe<CodeableConcept>>>;
};

export enum MedicinalProductManufactured_Enum_Schema {
  MedicinalProductManufactured = 'MedicinalProductManufactured'
}

/** Ingredient. */
export type MedicinalProductManufacturedingredient_Ingredient_Union = MedicinalProductIngredient;

/** Manufacturer of the item (Note that this should be named 'manufacturer' but it currently causes technical issues). */
export type MedicinalProductManufacturedmanufacturer_Manufacturer_Union = Organization;

/** A medicinal product in a container or package. */
export type MedicinalProductPackaged = {
  __typename?: 'MedicinalProductPackaged';
  /** Type of resource */
  resourceType: MedicinalProductPackaged_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique identifier. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The product with this is a pack for. */
  subject?: Maybe<Array<Maybe<MedicinalProductPackagedsubject_Subject_Union>>>;
  /** Textual description. */
  _description?: Maybe<Element>;
  /** Textual description. */
  description?: Maybe<Scalars['String']>;
  /** The legal status of supply of the medicinal product as classified by the regulator. */
  legalStatusOfSupply?: Maybe<CodeableConcept>;
  /** Marketing information. */
  marketingStatus?: Maybe<Array<Maybe<MarketingStatus>>>;
  /** Manufacturer of this Package Item. */
  marketingAuthorization?: Maybe<MedicinalProductPackagedmarketingAuthorization_MarketingAuthorization_Union>;
  /** Manufacturer of this Package Item. */
  manufacturer?: Maybe<Array<Maybe<MedicinalProductPackagedmanufacturer_Manufacturer_Union>>>;
  /** Batch numbering. */
  batchIdentifier?: Maybe<Array<Maybe<MedicinalProductPackagedbatchIdentifier>>>;
  /** A packaging item, as a contained for medicine, possibly with other packaging items within. */
  packageItem?: Maybe<Array<MedicinalProductPackagedpackageItem>>;
};

export enum MedicinalProductPackaged_Enum_Schema {
  MedicinalProductPackaged = 'MedicinalProductPackaged'
}

export type MedicinalProductPackagedbatchIdentifier = {
  __typename?: 'MedicinalProductPackagedbatchIdentifier';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A number appearing on the outer packaging of a specific batch. */
  outerPackaging: Identifier;
  /** A number appearing on the immediate packaging (and not the outer packaging). */
  immediatePackaging?: Maybe<Identifier>;
};

/** Manufacturer of this Package Item. */
export type MedicinalProductPackagedmanufacturer_Manufacturer_Union = Organization;

/** Manufacturer of this Package Item. */
export type MedicinalProductPackagedmarketingAuthorization_MarketingAuthorization_Union = MedicinalProductAuthorization;

export type MedicinalProductPackagedpackageItem = {
  __typename?: 'MedicinalProductPackagedpackageItem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Including possibly Data Carrier Identifier. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The physical type of the container of the medicine. */
  type: CodeableConcept;
  /** The quantity of this package in the medicinal product, at the current level of packaging. The outermost is always 1. */
  quantity: Quantity;
  /** Material type of the package item. */
  material?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A possible alternate material for the packaging. */
  alternateMaterial?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A device accompanying a medicinal product. */
  device?: Maybe<Array<Maybe<MedicinalProductPackagedpackageItemdevice_Device_Union>>>;
  /** The manufactured item as contained in the packaged medicinal product. */
  manufacturedItem?: Maybe<Array<Maybe<MedicinalProductPackagedpackageItemmanufacturedItem_ManufacturedItem_Union>>>;
  /** Dimensions, color etc. */
  physicalCharacteristics?: Maybe<ProdCharacteristic>;
  /** Other codeable characteristics. */
  otherCharacteristics?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Shelf Life and storage information. */
  shelfLifeStorage?: Maybe<Array<Maybe<ProductShelfLife>>>;
  /** Manufacturer of this Package Item. */
  manufacturer?: Maybe<Array<Maybe<MedicinalProductPackagedpackageItemmanufacturer_Manufacturer_Union>>>;
};

/** A device accompanying a medicinal product. */
export type MedicinalProductPackagedpackageItemdevice_Device_Union = DeviceDefinition;

/** The manufactured item as contained in the packaged medicinal product. */
export type MedicinalProductPackagedpackageItemmanufacturedItem_ManufacturedItem_Union = MedicinalProductManufactured;

/** Manufacturer of this Package Item. */
export type MedicinalProductPackagedpackageItemmanufacturer_Manufacturer_Union = Organization;

/** The product with this is a pack for. */
export type MedicinalProductPackagedsubject_Subject_Union = MedicinalProduct;

/** A pharmaceutical product described in terms of its composition and dose form. */
export type MedicinalProductPharmaceutical = {
  __typename?: 'MedicinalProductPharmaceutical';
  /** Type of resource */
  resourceType: MedicinalProductPharmaceutical_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An identifier for the pharmaceutical medicinal product. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The administrable dose form, after necessary reconstitution. */
  administrableDoseForm: CodeableConcept;
  /** Todo. */
  unitOfPresentation?: Maybe<CodeableConcept>;
  /** Ingredient. */
  ingredient?: Maybe<Array<Maybe<MedicinalProductPharmaceuticalingredient_Ingredient_Union>>>;
  /** Accompanying device. */
  device?: Maybe<Array<Maybe<MedicinalProductPharmaceuticaldevice_Device_Union>>>;
  /** Characteristics e.g. a products onset of action. */
  characteristics?: Maybe<Array<Maybe<MedicinalProductPharmaceuticalcharacteristics>>>;
  /** The path by which the pharmaceutical product is taken into or makes contact with the body. */
  routeOfAdministration?: Maybe<Array<MedicinalProductPharmaceuticalrouteOfAdministration>>;
};

export enum MedicinalProductPharmaceutical_Enum_Schema {
  MedicinalProductPharmaceutical = 'MedicinalProductPharmaceutical'
}

export type MedicinalProductPharmaceuticalcharacteristics = {
  __typename?: 'MedicinalProductPharmaceuticalcharacteristics';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A coded characteristic. */
  code: CodeableConcept;
  /** The status of characteristic e.g. assigned or pending. */
  status?: Maybe<CodeableConcept>;
};

/** Accompanying device. */
export type MedicinalProductPharmaceuticaldevice_Device_Union = DeviceDefinition;

/** Ingredient. */
export type MedicinalProductPharmaceuticalingredient_Ingredient_Union = MedicinalProductIngredient;

export type MedicinalProductPharmaceuticalrouteOfAdministration = {
  __typename?: 'MedicinalProductPharmaceuticalrouteOfAdministration';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Coded expression for the route. */
  code: CodeableConcept;
  /**
   * The first dose (dose quantity) administered in humans can be specified, for a
   * product under investigation, using a numerical value and its unit of measurement.
   */
  firstDose?: Maybe<Quantity>;
  /**
   * The maximum single dose that can be administered as per the protocol of a
   * clinical trial can be specified using a numerical value and its unit of measurement.
   */
  maxSingleDose?: Maybe<Quantity>;
  /**
   * The maximum dose per day (maximum dose quantity to be administered in any one
   * 24-h period) that can be administered as per the protocol referenced in the
   * clinical trial authorisation.
   */
  maxDosePerDay?: Maybe<Quantity>;
  /**
   * The maximum dose per treatment period that can be administered as per the
   * protocol referenced in the clinical trial authorisation.
   */
  maxDosePerTreatmentPeriod?: Maybe<Ratio>;
  /**
   * The maximum treatment period during which an Investigational Medicinal Product
   * can be administered as per the protocol referenced in the clinical trial authorisation.
   */
  maxTreatmentPeriod?: Maybe<Duration>;
  /** A species for which this route applies. */
  targetSpecies?: Maybe<Array<Maybe<MedicinalProductPharmaceuticalrouteOfAdministrationtargetSpecies>>>;
};

export type MedicinalProductPharmaceuticalrouteOfAdministrationtargetSpecies = {
  __typename?: 'MedicinalProductPharmaceuticalrouteOfAdministrationtargetSpecies';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Coded expression for the species. */
  code: CodeableConcept;
  /** A species specific time during which consumption of animal product is not appropriate. */
  withdrawalPeriod?: Maybe<Array<Maybe<MedicinalProductPharmaceuticalrouteOfAdministrationtargetSpecieswithdrawalPeriod>>>;
};

export type MedicinalProductPharmaceuticalrouteOfAdministrationtargetSpecieswithdrawalPeriod = {
  __typename?: 'MedicinalProductPharmaceuticalrouteOfAdministrationtargetSpecieswithdrawalPeriod';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Coded expression for the type of tissue for which the withdrawal period applues, e.g. meat, milk. */
  tissue: CodeableConcept;
  /** A value for the time. */
  value: Quantity;
  /** Extra information about the withdrawal period. */
  _supportingInformation?: Maybe<Element>;
  /** Extra information about the withdrawal period. */
  supportingInformation?: Maybe<Scalars['String']>;
};

/** Describe the undesirable effects of the medicinal product. */
export type MedicinalProductUndesirableEffect = {
  __typename?: 'MedicinalProductUndesirableEffect';
  /** Type of resource */
  resourceType: MedicinalProductUndesirableEffect_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The medication for which this is an indication. */
  subject?: Maybe<Array<Maybe<MedicinalProductUndesirableEffectsubject_Subject_Union>>>;
  /** The symptom, condition or undesirable effect. */
  symptomConditionEffect?: Maybe<CodeableConcept>;
  /** Classification of the effect. */
  classification?: Maybe<CodeableConcept>;
  /** The frequency of occurrence of the effect. */
  frequencyOfOccurrence?: Maybe<CodeableConcept>;
  /** The population group to which this applies. */
  population?: Maybe<Array<Maybe<Population>>>;
};

export enum MedicinalProductUndesirableEffect_Enum_Schema {
  MedicinalProductUndesirableEffect = 'MedicinalProductUndesirableEffect'
}

/** The medication for which this is an indication. */
export type MedicinalProductUndesirableEffectsubject_Subject_Union = MedicinalProduct | Medication;

export enum MedicinalProduct_Enum_Schema {
  MedicinalProduct = 'MedicinalProduct'
}

/** Supporting documentation, typically for regulatory submission. */
export type MedicinalProductattachedDocument_AttachedDocument_Union = DocumentReference;

/** Clinical trials or studies that this product is involved in. */
export type MedicinalProductclinicalTrial_ClinicalTrial_Union = ResearchStudy;

/** A product specific contact, person (in a role), or an organization. */
export type MedicinalProductcontact_Contact_Union = Organization | PractitionerRole;

export type MedicinalProductmanufacturingBusinessOperation = {
  __typename?: 'MedicinalProductmanufacturingBusinessOperation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of manufacturing operation. */
  operationType?: Maybe<CodeableConcept>;
  /** Regulatory authorization reference number. */
  authorisationReferenceNumber?: Maybe<Identifier>;
  /** Regulatory authorization date. */
  _effectiveDate?: Maybe<Element>;
  /** Regulatory authorization date. */
  effectiveDate?: Maybe<Scalars['dateTime']>;
  /** To indicate if this proces is commercially confidential. */
  confidentialityIndicator?: Maybe<CodeableConcept>;
  /** The manufacturer or establishment associated with the process. */
  manufacturer?: Maybe<Array<Maybe<MedicinalProductmanufacturingBusinessOperationmanufacturer_Manufacturer_Union>>>;
  /** A regulator which oversees the operation. */
  regulator?: Maybe<MedicinalProductmanufacturingBusinessOperationregulator_Regulator_Union>;
};

/** The manufacturer or establishment associated with the process. */
export type MedicinalProductmanufacturingBusinessOperationmanufacturer_Manufacturer_Union = Organization;

/** A regulator which oversees the operation. */
export type MedicinalProductmanufacturingBusinessOperationregulator_Regulator_Union = Organization;

/** A master file for to the medicinal product (e.g. Pharmacovigilance System Master File). */
export type MedicinalProductmasterFile_MasterFile_Union = DocumentReference;

export type MedicinalProductname = {
  __typename?: 'MedicinalProductname';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The full product name. */
  _productName?: Maybe<Element>;
  /** The full product name. */
  productName: Scalars['String'];
  /** Coding words or phrases of the name. */
  namePart?: Maybe<Array<Maybe<MedicinalProductnamenamePart>>>;
  /** Country where the name applies. */
  countryLanguage?: Maybe<Array<Maybe<MedicinalProductnamecountryLanguage>>>;
};

export type MedicinalProductnamecountryLanguage = {
  __typename?: 'MedicinalProductnamecountryLanguage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Country code for where this name applies. */
  country: CodeableConcept;
  /** Jurisdiction code for where this name applies. */
  jurisdiction?: Maybe<CodeableConcept>;
  /** Language code for this name. */
  language: CodeableConcept;
};

export type MedicinalProductnamenamePart = {
  __typename?: 'MedicinalProductnamenamePart';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A fragment of a product name. */
  _part?: Maybe<Element>;
  /** A fragment of a product name. */
  part: Scalars['String'];
  /** Idenifying type for this part of the name (e.g. strength part). */
  type: Coding;
};

/** Package representation for the product. */
export type MedicinalProductpackagedMedicinalProduct_PackagedMedicinalProduct_Union = MedicinalProductPackaged;

/** Pharmaceutical aspects of product. */
export type MedicinalProductpharmaceuticalProduct_PharmaceuticalProduct_Union = MedicinalProductPharmaceutical;

export type MedicinalProductspecialDesignation = {
  __typename?: 'MedicinalProductspecialDesignation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier for the designation, or procedure number. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The type of special designation, e.g. orphan drug, minor use. */
  type?: Maybe<CodeableConcept>;
  /** The intended use of the product, e.g. prevention, treatment. */
  intendedUse?: Maybe<CodeableConcept>;
  /** Condition for which the medicinal use applies. */
  indicationCodeableConcept?: Maybe<CodeableConcept>;
  /** Condition for which the medicinal use applies. */
  indicationReference?: Maybe<MedicinalProductspecialDesignationindicationReference_IndicationReference_Union>;
  /** For example granted, pending, expired or withdrawn. */
  status?: Maybe<CodeableConcept>;
  /** Date when the designation was granted. */
  _date?: Maybe<Element>;
  /** Date when the designation was granted. */
  date?: Maybe<Scalars['dateTime']>;
  /** Animal species for which this applies. */
  species?: Maybe<CodeableConcept>;
};

/** Condition for which the medicinal use applies. */
export type MedicinalProductspecialDesignationindicationReference_IndicationReference_Union = MedicinalProductIndication;

/**
 * Defines the characteristics of a message that can be shared between systems,
 * including the type of event that initiates the message, the content to be
 * transmitted and what response(s), if any, are permitted.
 */
export type MessageDefinition = {
  __typename?: 'MessageDefinition';
  /** Type of resource */
  resourceType: MessageDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The business identifier that is used to reference the MessageDefinition and
   * *is* expected to be consistent from server to server.
   */
  _url?: Maybe<Element>;
  /**
   * The business identifier that is used to reference the MessageDefinition and
   * *is* expected to be consistent from server to server.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this message definition when it
   * is represented in other formats, or referenced in a specification, model,
   * design or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the message definition
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the message definition author and is not
   * expected to be globally unique. For example, it might be a timestamp (e.g.
   * yyyymmdd) if a managed version is not available. There is also no expectation
   * that versions can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the message definition
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the message definition author and is not
   * expected to be globally unique. For example, it might be a timestamp (e.g.
   * yyyymmdd) if a managed version is not available. There is also no expectation
   * that versions can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the message definition. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the message definition. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the message definition. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the message definition. */
  title?: Maybe<Scalars['String']>;
  /** A MessageDefinition that is superseded by this definition. */
  _replaces?: Maybe<Element>;
  /** A MessageDefinition that is superseded by this definition. */
  replaces?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** The status of this message definition. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this message definition. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this message definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this message definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the message definition was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the message definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the message definition was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the message definition changes.
   */
  date: Scalars['dateTime'];
  /** The name of the organization or individual that published the message definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the message definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the message definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the message definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate message
   * definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the message definition is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this message definition is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this message definition is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the message definition and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the message definition.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the message definition and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the message definition.
   */
  copyright?: Maybe<Scalars['String']>;
  /** The MessageDefinition that is the basis for the contents of this resource. */
  _base?: Maybe<Element>;
  /** The MessageDefinition that is the basis for the contents of this resource. */
  base?: Maybe<Scalars['canonical']>;
  /** Identifies a protocol or workflow that this MessageDefinition represents a step in. */
  _parent?: Maybe<Element>;
  /** Identifies a protocol or workflow that this MessageDefinition represents a step in. */
  parent?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** Event code or link to the EventDefinition. */
  eventCoding: Coding;
  /** Event code or link to the EventDefinition. */
  _eventUri?: Maybe<Element>;
  /** Event code or link to the EventDefinition. */
  eventUri: Scalars['uri'];
  /** The impact of the content of the message. */
  _category?: Maybe<Element>;
  /** The impact of the content of the message. */
  category?: Maybe<Scalars['code']>;
  /**
   * Identifies the resource (or resources) that are being addressed by the event.
   * For example, the Encounter for an admit message or two Account records for a merge.
   */
  focus?: Maybe<Array<Maybe<MessageDefinitionfocus>>>;
  /** Declare at a message definition level whether a response is required or only upon error or success, or never. */
  _responseRequired?: Maybe<Element>;
  /** Declare at a message definition level whether a response is required or only upon error or success, or never. */
  responseRequired?: Maybe<Scalars['code']>;
  /** Indicates what types of messages may be sent as an application-level response to this message. */
  allowedResponse?: Maybe<Array<Maybe<MessageDefinitionallowedResponse>>>;
  /**
   * Canonical reference to a GraphDefinition. If a URL is provided, it is the
   * canonical reference to a [GraphDefinition](graphdefinition.html) that it
   * controls what resources are to be added to the bundle when building the
   * document. The GraphDefinition can also specify profiles that apply to the
   * various resources.
   */
  _graph?: Maybe<Element>;
  /**
   * Canonical reference to a GraphDefinition. If a URL is provided, it is the
   * canonical reference to a [GraphDefinition](graphdefinition.html) that it
   * controls what resources are to be added to the bundle when building the
   * document. The GraphDefinition can also specify profiles that apply to the
   * various resources.
   */
  graph?: Maybe<Array<Maybe<Scalars['canonical']>>>;
};

export enum MessageDefinition_Enum_Schema {
  MessageDefinition = 'MessageDefinition'
}

export type MessageDefinitionallowedResponse = {
  __typename?: 'MessageDefinitionallowedResponse';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A reference to the message definition that must be adhered to by this supported response. */
  _message?: Maybe<Element>;
  /** A reference to the message definition that must be adhered to by this supported response. */
  message: Scalars['canonical'];
  /**
   * Provides a description of the circumstances in which this response should be
   * used (as opposed to one of the alternative responses).
   */
  _situation?: Maybe<Element>;
  /**
   * Provides a description of the circumstances in which this response should be
   * used (as opposed to one of the alternative responses).
   */
  situation?: Maybe<Scalars['String']>;
};

export type MessageDefinitionfocus = {
  __typename?: 'MessageDefinitionfocus';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The kind of resource that must be the focus for this message. */
  _code?: Maybe<Element>;
  /** The kind of resource that must be the focus for this message. */
  code: Scalars['code'];
  /** A profile that reflects constraints for the focal resource (and potentially for related resources). */
  _profile?: Maybe<Element>;
  /** A profile that reflects constraints for the focal resource (and potentially for related resources). */
  profile?: Maybe<Scalars['canonical']>;
  /**
   * Identifies the minimum number of resources of this type that must be pointed
   * to by a message in order for it to be valid against this MessageDefinition.
   */
  _min?: Maybe<Element>;
  /**
   * Identifies the minimum number of resources of this type that must be pointed
   * to by a message in order for it to be valid against this MessageDefinition.
   */
  min: Scalars['unsignedInt'];
  /**
   * Identifies the maximum number of resources of this type that must be pointed
   * to by a message in order for it to be valid against this MessageDefinition.
   */
  _max?: Maybe<Element>;
  /**
   * Identifies the maximum number of resources of this type that must be pointed
   * to by a message in order for it to be valid against this MessageDefinition.
   */
  max?: Maybe<Scalars['String']>;
};

/**
 * The header for a message exchange that is either requesting or responding to an
 * action.  The reference(s) that are the subject of the action as well as other
 * information related to the action are typically transmitted in a bundle in which
 * the MessageHeader resource instance is the first resource in the bundle.
 */
export type MessageHeader = {
  __typename?: 'MessageHeader';
  /** Type of resource */
  resourceType: MessageHeader_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Code that identifies the event this message represents and connects it with
   * its definition. Events defined as part of the FHIR specification have the
   * system value 'http://terminology.hl7.org/CodeSystem/message-events'.
   * Alternatively uri to the EventDefinition.
   */
  eventCoding: Coding;
  /**
   * Code that identifies the event this message represents and connects it with
   * its definition. Events defined as part of the FHIR specification have the
   * system value 'http://terminology.hl7.org/CodeSystem/message-events'.
   * Alternatively uri to the EventDefinition.
   */
  _eventUri?: Maybe<Element>;
  /**
   * Code that identifies the event this message represents and connects it with
   * its definition. Events defined as part of the FHIR specification have the
   * system value 'http://terminology.hl7.org/CodeSystem/message-events'.
   * Alternatively uri to the EventDefinition.
   */
  eventUri: Scalars['uri'];
  /** The destination application which the message is intended for. */
  destination?: Maybe<Array<Maybe<MessageHeaderdestination>>>;
  /** Identifies the sending system to allow the use of a trust relationship. */
  sender?: Maybe<MessageHeadersender_Sender_Union>;
  /**
   * The person or device that performed the data entry leading to this message.
   * When there is more than one candidate, pick the most proximal to the message.
   * Can provide other enterers in extensions.
   */
  enterer?: Maybe<MessageHeaderenterer_Enterer_Union>;
  /**
   * The logical author of the message - the person or device that decided the
   * described event should happen. When there is more than one candidate, pick the
   * most proximal to the MessageHeader. Can provide other authors in extensions.
   */
  author?: Maybe<MessageHeaderauthor_Author_Union>;
  /** The source application from which this message originated. */
  source: MessageHeadersource;
  /**
   * The person or organization that accepts overall responsibility for the
   * contents of the message. The implication is that the message event happened
   * under the policies of the responsible party.
   */
  responsible?: Maybe<MessageHeaderresponsible_Responsible_Union>;
  /**
   * Coded indication of the cause for the event - indicates  a reason for the
   * occurrence of the event that is a focus of this message.
   */
  reason?: Maybe<CodeableConcept>;
  /** Information about the message that this message is a response to.  Only present if this message is a response. */
  response?: Maybe<MessageHeaderresponse>;
  /** The actual data of the message - a reference to the root/focus class of the event. */
  focus?: Maybe<Array<Maybe<MessageHeaderfocus_Focus_Union>>>;
  /** Permanent link to the MessageDefinition for this message. */
  _definition?: Maybe<Element>;
  /** Permanent link to the MessageDefinition for this message. */
  definition?: Maybe<Scalars['canonical']>;
};

export enum MessageHeader_Enum_Schema {
  MessageHeader = 'MessageHeader'
}

/**
 * The logical author of the message - the person or device that decided the
 * described event should happen. When there is more than one candidate, pick the
 * most proximal to the MessageHeader. Can provide other authors in extensions.
 */
export type MessageHeaderauthor_Author_Union = Practitioner | PractitionerRole;

export type MessageHeaderdestination = {
  __typename?: 'MessageHeaderdestination';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Human-readable name for the target system. */
  _name?: Maybe<Element>;
  /** Human-readable name for the target system. */
  name?: Maybe<Scalars['String']>;
  /** Identifies the target end system in situations where the initial message transmission is to an intermediary system. */
  target?: Maybe<MessageHeaderdestinationtarget_Target_Union>;
  /** Indicates where the message should be routed to. */
  _endpoint?: Maybe<Element>;
  /** Indicates where the message should be routed to. */
  endpoint: Scalars['url'];
  /**
   * Allows data conveyed by a message to be addressed to a particular person or
   * department when routing to a specific application isn't sufficient.
   */
  receiver?: Maybe<MessageHeaderdestinationreceiver_Receiver_Union>;
};

/**
 * Allows data conveyed by a message to be addressed to a particular person or
 * department when routing to a specific application isn't sufficient.
 */
export type MessageHeaderdestinationreceiver_Receiver_Union = Practitioner | PractitionerRole | Organization;

/** Identifies the target end system in situations where the initial message transmission is to an intermediary system. */
export type MessageHeaderdestinationtarget_Target_Union = Device;

/**
 * The person or device that performed the data entry leading to this message. When
 * there is more than one candidate, pick the most proximal to the message. Can
 * provide other enterers in extensions.
 */
export type MessageHeaderenterer_Enterer_Union = Practitioner | PractitionerRole;

/** The actual data of the message - a reference to the root/focus class of the event. */
export type MessageHeaderfocus_Focus_Union = Resource;

export type MessageHeaderresponse = {
  __typename?: 'MessageHeaderresponse';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The MessageHeader.id of the message to which this message is a response. */
  _identifier?: Maybe<Element>;
  /** The MessageHeader.id of the message to which this message is a response. */
  identifier: Scalars['id'];
  /**
   * Code that identifies the type of response to the message - whether it was
   * successful or not, and whether it should be resent or not.
   */
  _code?: Maybe<Element>;
  /**
   * Code that identifies the type of response to the message - whether it was
   * successful or not, and whether it should be resent or not.
   */
  code: Scalars['code'];
  /** Full details of any issues found in the message. */
  details?: Maybe<MessageHeaderresponsedetails_Details_Union>;
};

/** Full details of any issues found in the message. */
export type MessageHeaderresponsedetails_Details_Union = OperationOutcome;

/**
 * The person or organization that accepts overall responsibility for the contents
 * of the message. The implication is that the message event happened under the
 * policies of the responsible party.
 */
export type MessageHeaderresponsible_Responsible_Union = Practitioner | PractitionerRole | Organization;

/** Identifies the sending system to allow the use of a trust relationship. */
export type MessageHeadersender_Sender_Union = Practitioner | PractitionerRole | Organization;

export type MessageHeadersource = {
  __typename?: 'MessageHeadersource';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Human-readable name for the source system. */
  _name?: Maybe<Element>;
  /** Human-readable name for the source system. */
  name?: Maybe<Scalars['String']>;
  /** May include configuration or other information useful in debugging. */
  _software?: Maybe<Element>;
  /** May include configuration or other information useful in debugging. */
  software?: Maybe<Scalars['String']>;
  /** Can convey versions of multiple systems in situations where a message passes through multiple hands. */
  _version?: Maybe<Element>;
  /** Can convey versions of multiple systems in situations where a message passes through multiple hands. */
  version?: Maybe<Scalars['String']>;
  /** An e-mail, phone, website or other contact point to use to resolve issues with message communications. */
  contact?: Maybe<ContactPoint>;
  /** Identifies the routing target to send acknowledgements to. */
  _endpoint?: Maybe<Element>;
  /** Identifies the routing target to send acknowledgements to. */
  endpoint: Scalars['url'];
};

/**
 * Base StructureDefinition for Meta Type: The metadata about a resource. This is
 * content in the resource that is maintained by the infrastructure. Changes to the
 * content might not always be associated with version changes to the resource.
 */
export type Meta = {
  __typename?: 'Meta';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The version specific identifier, as it appears in the version portion of the
   * URL. This value changes when the resource is created, updated, or deleted.
   */
  _versionId?: Maybe<Element>;
  /**
   * The version specific identifier, as it appears in the version portion of the
   * URL. This value changes when the resource is created, updated, or deleted.
   */
  versionId?: Maybe<Scalars['id']>;
  /** When the resource last changed - e.g. when the version changed. */
  _lastUpdated?: Maybe<Element>;
  /** When the resource last changed - e.g. when the version changed. */
  lastUpdated?: Maybe<Scalars['instant']>;
  /**
   * A uri that identifies the source system of the resource. This provides a
   * minimal amount of [Provenance](provenance.html#) information that can be used
   * to track or differentiate the source of information in the resource. The
   * source may identify another FHIR server, document, message, database, etc.
   */
  _source?: Maybe<Element>;
  /**
   * A uri that identifies the source system of the resource. This provides a
   * minimal amount of [Provenance](provenance.html#) information that can be used
   * to track or differentiate the source of information in the resource. The
   * source may identify another FHIR server, document, message, database, etc.
   */
  source?: Maybe<Scalars['uri']>;
  /**
   * A list of profiles (references to
   * [StructureDefinition](structuredefinition.html#) resources) that this resource
   * claims to conform to. The URL is a reference to [StructureDefinition.url](structuredefinition-definitions.html#StructureDefinition.url).
   */
  _profile?: Maybe<Element>;
  /**
   * A list of profiles (references to
   * [StructureDefinition](structuredefinition.html#) resources) that this resource
   * claims to conform to. The URL is a reference to [StructureDefinition.url](structuredefinition-definitions.html#StructureDefinition.url).
   */
  profile?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * Security labels applied to this resource. These tags connect specific
   * resources to the overall security policy and infrastructure.
   */
  security?: Maybe<Array<Maybe<Coding>>>;
  /**
   * Tags applied to this resource. Tags are intended to be used to identify and
   * relate resources to process and workflow, and applications are not required to
   * consider the tags when interpreting the meaning of a resource.
   */
  tag?: Maybe<Array<Maybe<Coding>>>;
};

/**
 * Base StructureDefinition for Meta Type: The metadata about a resource. This is
 * content in the resource that is maintained by the infrastructure. Changes to the
 * content might not always be associated with version changes to the resource.
 */
export type MetaData = {
  __typename?: 'MetaData';
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  practitionerName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  practitionerId?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  professionalId?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentDate?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentTime?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  slotId?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentFor?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentNumber?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedBy?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedId?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedDOB?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentType?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentMode?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentDuration?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentPrice?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  discountType?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  discountValue?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  commissionType?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  commissionValue?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentOriginalPrice?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedByTitle?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedByFirstName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedBySurName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedByGender?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedByEmail?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedByPhoneNumber?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForTitle?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForFirstName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForSurName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForGender?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForEmail?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForPhoneNumber?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForRelationship?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentNeedLanguageSupport?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentSpecialNotes?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentPatientConsent?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentPatientTechAbility?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentPatientMentalAbility?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentPayType?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentThirdPartyName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentThirdPartyComments?: Maybe<Scalars['String']>;
  /** appointmentDocuments */
  appointmentDocuments?: Maybe<DocumentReference>;
  /** appointmentPMIDocuments */
  appointmentPMIDocuments?: Maybe<DocumentReference>;
  /** appointmentDocuments */
  multipleAppointmentDetails?: Maybe<AppointmentExtension_Schema>;
};

/**
 * Base StructureDefinition for Meta Type: The metadata about a resource. This is
 * content in the resource that is maintained by the infrastructure. Changes to the
 * content might not always be associated with version changes to the resource.
 */
export type Meta_Data_Input = {
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  practitionerName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  practitionerId?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  professionalId?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentDate?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentTime?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  slotId?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentFor?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentNumber?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedBy?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedId?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedDOB?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentType?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentMode?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentDuration?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentPrice?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  discountType?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  discountValue?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  commissionType?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  commissionValue?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentOriginalPrice?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedByTitle?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedByFirstName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedBySurName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedByGender?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedByEmail?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedByPhoneNumber?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForTitle?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForFirstName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForSurName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForGender?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForEmail?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForPhoneNumber?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentBookedForRelationship?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentNeedLanguageSupport?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentSpecialNotes?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentPatientConsent?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentPatientTechAbility?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentPatientMentalAbility?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentPayType?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentThirdPartyName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentThirdPartyComments?: Maybe<Scalars['String']>;
  /** appointmentDocuments */
  appointmentDocuments?: Maybe<DocumentReference_Input>;
  /** appointmentPMIDocuments */
  appointmentPMIDocuments?: Maybe<DocumentReference_Input>;
  /** Multiple Appiontment Details. */
  multipleAppointmentDetails?: Maybe<Array<Maybe<AppointmentExtension_Input>>>;
};

/**
 * Base StructureDefinition for Meta Type: The metadata about a resource. This is
 * content in the resource that is maintained by the infrastructure. Changes to the
 * content might not always be associated with version changes to the resource.
 */
export type Meta_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * The version specific identifier, as it appears in the version portion of the
   * URL. This value changes when the resource is created, updated, or deleted.
   */
  _versionId?: Maybe<Element_Input>;
  /**
   * The version specific identifier, as it appears in the version portion of the
   * URL. This value changes when the resource is created, updated, or deleted.
   */
  versionId?: Maybe<Scalars['id']>;
  /** When the resource last changed - e.g. when the version changed. */
  _lastUpdated?: Maybe<Element_Input>;
  /** When the resource last changed - e.g. when the version changed. */
  lastUpdated?: Maybe<Scalars['instant']>;
  /**
   * A uri that identifies the source system of the resource. This provides a
   * minimal amount of [Provenance](provenance.html#) information that can be used
   * to track or differentiate the source of information in the resource. The
   * source may identify another FHIR server, document, message, database, etc.
   */
  _source?: Maybe<Element_Input>;
  /**
   * A uri that identifies the source system of the resource. This provides a
   * minimal amount of [Provenance](provenance.html#) information that can be used
   * to track or differentiate the source of information in the resource. The
   * source may identify another FHIR server, document, message, database, etc.
   */
  source?: Maybe<Scalars['uri']>;
  /**
   * A list of profiles (references to
   * [StructureDefinition](structuredefinition.html#) resources) that this resource
   * claims to conform to. The URL is a reference to [StructureDefinition.url](structuredefinition-definitions.html#StructureDefinition.url).
   */
  _profile?: Maybe<Element_Input>;
  /**
   * A list of profiles (references to
   * [StructureDefinition](structuredefinition.html#) resources) that this resource
   * claims to conform to. The URL is a reference to [StructureDefinition.url](structuredefinition-definitions.html#StructureDefinition.url).
   */
  profile?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * Security labels applied to this resource. These tags connect specific
   * resources to the overall security policy and infrastructure.
   */
  security?: Maybe<Array<Maybe<Coding_Input>>>;
  /**
   * Tags applied to this resource. Tags are intended to be used to identify and
   * relate resources to process and workflow, and applications are not required to
   * consider the tags when interpreting the meaning of a resource.
   */
  tag?: Maybe<Array<Maybe<Coding_Input>>>;
};

/** Raw data describing a biological sequence. */
export type MolecularSequence = {
  __typename?: 'MolecularSequence';
  /** Type of resource */
  resourceType: MolecularSequence_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier for this particular sequence instance. This is a FHIR-defined id. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Amino Acid Sequence/ DNA Sequence / RNA Sequence. */
  _type?: Maybe<Element>;
  /** Amino Acid Sequence/ DNA Sequence / RNA Sequence. */
  type?: Maybe<Scalars['code']>;
  /**
   * Whether the sequence is numbered starting at 0 (0-based numbering or
   * coordinates, inclusive start, exclusive end) or starting at 1 (1-based
   * numbering, inclusive start and inclusive end).
   */
  _coordinateSystem?: Maybe<Element>;
  /**
   * Whether the sequence is numbered starting at 0 (0-based numbering or
   * coordinates, inclusive start, exclusive end) or starting at 1 (1-based
   * numbering, inclusive start and inclusive end).
   */
  coordinateSystem: Scalars['Int'];
  /** The patient whose sequencing results are described by this resource. */
  patient?: Maybe<MolecularSequencepatient_Patient_Union>;
  /** Specimen used for sequencing. */
  specimen?: Maybe<MolecularSequencespecimen_Specimen_Union>;
  /** The method for sequencing, for example, chip information. */
  device?: Maybe<MolecularSequencedevice_Device_Union>;
  /** The organization or lab that should be responsible for this result. */
  performer?: Maybe<MolecularSequenceperformer_Performer_Union>;
  /** The number of copies of the sequence of interest. (RNASeq). */
  quantity?: Maybe<Quantity>;
  /** A sequence that is used as a reference to describe variants that are present in a sequence analyzed. */
  referenceSeq?: Maybe<MolecularSequencereferenceSeq>;
  /**
   * The definition of variant here originates from Sequence ontology ([variant_of](http://www.sequenceontology.org/browser/current_svn/term/variant_of)).
   * This element can represent amino acid or nucleic sequence change(including
   * insertion,deletion,SNP,etc.)  It can represent some complex mutation or
   * segment variation with the assist of CIGAR string.
   */
  variant?: Maybe<Array<Maybe<MolecularSequencevariant>>>;
  /**
   * Sequence that was observed. It is the result marked by referenceSeq along with
   * variant records on referenceSeq. This shall start from
   * referenceSeq.windowStart and end by referenceSeq.windowEnd.
   */
  _observedSeq?: Maybe<Element>;
  /**
   * Sequence that was observed. It is the result marked by referenceSeq along with
   * variant records on referenceSeq. This shall start from
   * referenceSeq.windowStart and end by referenceSeq.windowEnd.
   */
  observedSeq?: Maybe<Scalars['String']>;
  /**
   * An experimental feature attribute that defines the quality of the feature in a
   * quantitative way, such as a phred quality score ([SO:0001686](http://www.sequenceontology.org/browser/current_svn/term/SO:0001686)).
   */
  quality?: Maybe<Array<Maybe<MolecularSequencequality>>>;
  /**
   * Coverage (read depth or depth) is the average number of reads representing a
   * given nucleotide in the reconstructed sequence.
   */
  _readCoverage?: Maybe<Element>;
  /**
   * Coverage (read depth or depth) is the average number of reads representing a
   * given nucleotide in the reconstructed sequence.
   */
  readCoverage?: Maybe<Scalars['Int']>;
  /**
   * Configurations of the external repository. The repository shall store target's
   * observedSeq or records related with target's observedSeq.
   */
  repository?: Maybe<Array<Maybe<MolecularSequencerepository>>>;
  /** Pointer to next atomic sequence which at most contains one variant. */
  pointer?: Maybe<Array<Maybe<MolecularSequencepointer_Pointer_Union>>>;
  /** Information about chromosome structure variation. */
  structureVariant?: Maybe<Array<Maybe<MolecularSequencestructureVariant>>>;
};

export enum MolecularSequence_Enum_Schema {
  MolecularSequence = 'MolecularSequence'
}

/** The method for sequencing, for example, chip information. */
export type MolecularSequencedevice_Device_Union = Device;

/** The patient whose sequencing results are described by this resource. */
export type MolecularSequencepatient_Patient_Union = Patient;

/** The organization or lab that should be responsible for this result. */
export type MolecularSequenceperformer_Performer_Union = Organization;

/** Pointer to next atomic sequence which at most contains one variant. */
export type MolecularSequencepointer_Pointer_Union = MolecularSequence;

export type MolecularSequencequality = {
  __typename?: 'MolecularSequencequality';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** INDEL / SNP / Undefined variant. */
  _type?: Maybe<Element>;
  /** INDEL / SNP / Undefined variant. */
  type: Scalars['code'];
  /** Gold standard sequence used for comparing against. */
  standardSequence?: Maybe<CodeableConcept>;
  /** Start position of the sequence. If the coordinate system is either 0-based or 1-based, then start position is inclusive. */
  _start?: Maybe<Element>;
  /** Start position of the sequence. If the coordinate system is either 0-based or 1-based, then start position is inclusive. */
  start?: Maybe<Scalars['Int']>;
  /**
   * End position of the sequence. If the coordinate system is 0-based then end is
   * exclusive and does not include the last position. If the coordinate system is
   * 1-base, then end is inclusive and includes the last position.
   */
  _end?: Maybe<Element>;
  /**
   * End position of the sequence. If the coordinate system is 0-based then end is
   * exclusive and does not include the last position. If the coordinate system is
   * 1-base, then end is inclusive and includes the last position.
   */
  end?: Maybe<Scalars['Int']>;
  /** The score of an experimentally derived feature such as a p-value ([SO:0001685](http://www.sequenceontology.org/browser/current_svn/term/SO:0001685)). */
  score?: Maybe<Quantity>;
  /** Which method is used to get sequence quality. */
  method?: Maybe<CodeableConcept>;
  /**
   * True positives, from the perspective of the truth data, i.e. the number of
   * sites in the Truth Call Set for which there are paths through the Query Call
   * Set that are consistent with all of the alleles at this site, and for which
   * there is an accurate genotype call for the event.
   */
  _truthTP?: Maybe<Element>;
  /**
   * True positives, from the perspective of the truth data, i.e. the number of
   * sites in the Truth Call Set for which there are paths through the Query Call
   * Set that are consistent with all of the alleles at this site, and for which
   * there is an accurate genotype call for the event.
   */
  truthTP?: Maybe<Scalars['Float']>;
  /**
   * True positives, from the perspective of the query data, i.e. the number of
   * sites in the Query Call Set for which there are paths through the Truth Call
   * Set that are consistent with all of the alleles at this site, and for which
   * there is an accurate genotype call for the event.
   */
  _queryTP?: Maybe<Element>;
  /**
   * True positives, from the perspective of the query data, i.e. the number of
   * sites in the Query Call Set for which there are paths through the Truth Call
   * Set that are consistent with all of the alleles at this site, and for which
   * there is an accurate genotype call for the event.
   */
  queryTP?: Maybe<Scalars['Float']>;
  /**
   * False negatives, i.e. the number of sites in the Truth Call Set for which
   * there is no path through the Query Call Set that is consistent with all of the
   * alleles at this site, or sites for which there is an inaccurate genotype call
   * for the event. Sites with correct variant but incorrect genotype are counted here.
   */
  _truthFN?: Maybe<Element>;
  /**
   * False negatives, i.e. the number of sites in the Truth Call Set for which
   * there is no path through the Query Call Set that is consistent with all of the
   * alleles at this site, or sites for which there is an inaccurate genotype call
   * for the event. Sites with correct variant but incorrect genotype are counted here.
   */
  truthFN?: Maybe<Scalars['Float']>;
  /**
   * False positives, i.e. the number of sites in the Query Call Set for which
   * there is no path through the Truth Call Set that is consistent with this site.
   * Sites with correct variant but incorrect genotype are counted here.
   */
  _queryFP?: Maybe<Element>;
  /**
   * False positives, i.e. the number of sites in the Query Call Set for which
   * there is no path through the Truth Call Set that is consistent with this site.
   * Sites with correct variant but incorrect genotype are counted here.
   */
  queryFP?: Maybe<Scalars['Float']>;
  /**
   * The number of false positives where the non-REF alleles in the Truth and Query
   * Call Sets match (i.e. cases where the truth is 1/1 and the query is 0/1 or similar).
   */
  _gtFP?: Maybe<Element>;
  /**
   * The number of false positives where the non-REF alleles in the Truth and Query
   * Call Sets match (i.e. cases where the truth is 1/1 and the query is 0/1 or similar).
   */
  gtFP?: Maybe<Scalars['Float']>;
  /** QUERY.TP / (QUERY.TP + QUERY.FP). */
  _precision?: Maybe<Element>;
  /** QUERY.TP / (QUERY.TP + QUERY.FP). */
  precision?: Maybe<Scalars['Float']>;
  /** TRUTH.TP / (TRUTH.TP + TRUTH.FN). */
  _recall?: Maybe<Element>;
  /** TRUTH.TP / (TRUTH.TP + TRUTH.FN). */
  recall?: Maybe<Scalars['Float']>;
  /** Harmonic mean of Recall and Precision, computed as: 2 * precision * recall / (precision + recall). */
  _fScore?: Maybe<Element>;
  /** Harmonic mean of Recall and Precision, computed as: 2 * precision * recall / (precision + recall). */
  fScore?: Maybe<Scalars['Float']>;
  /** Receiver Operator Characteristic (ROC) Curve  to give sensitivity/specificity tradeoff. */
  roc?: Maybe<MolecularSequencequalityroc>;
};

export type MolecularSequencequalityroc = {
  __typename?: 'MolecularSequencequalityroc';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Invidual data point representing the GQ (genotype quality) score threshold. */
  _score?: Maybe<Element>;
  /** Invidual data point representing the GQ (genotype quality) score threshold. */
  score?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The number of true positives if the GQ score threshold was set to 'score' field value. */
  _numTP?: Maybe<Element>;
  /** The number of true positives if the GQ score threshold was set to 'score' field value. */
  numTP?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The number of false positives if the GQ score threshold was set to 'score' field value. */
  _numFP?: Maybe<Element>;
  /** The number of false positives if the GQ score threshold was set to 'score' field value. */
  numFP?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The number of false negatives if the GQ score threshold was set to 'score' field value. */
  _numFN?: Maybe<Element>;
  /** The number of false negatives if the GQ score threshold was set to 'score' field value. */
  numFN?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Calculated precision if the GQ score threshold was set to 'score' field value. */
  _precision?: Maybe<Element>;
  /** Calculated precision if the GQ score threshold was set to 'score' field value. */
  precision?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Calculated sensitivity if the GQ score threshold was set to 'score' field value. */
  _sensitivity?: Maybe<Element>;
  /** Calculated sensitivity if the GQ score threshold was set to 'score' field value. */
  sensitivity?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Calculated fScore if the GQ score threshold was set to 'score' field value. */
  _fMeasure?: Maybe<Element>;
  /** Calculated fScore if the GQ score threshold was set to 'score' field value. */
  fMeasure?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type MolecularSequencereferenceSeq = {
  __typename?: 'MolecularSequencereferenceSeq';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Structural unit composed of a nucleic acid molecule which controls its own
   * replication through the interaction of specific proteins at one or more
   * origins of replication ([SO:0000340](http://www.sequenceontology.org/browser/current_svn/term/SO:0000340)).
   */
  chromosome?: Maybe<CodeableConcept>;
  /**
   * The Genome Build used for reference, following GRCh build versions e.g. 'GRCh
   * 37'.  Version number must be included if a versioned release of a primary
   * build was used.
   */
  _genomeBuild?: Maybe<Element>;
  /**
   * The Genome Build used for reference, following GRCh build versions e.g. 'GRCh
   * 37'.  Version number must be included if a versioned release of a primary
   * build was used.
   */
  genomeBuild?: Maybe<Scalars['String']>;
  /**
   * A relative reference to a DNA strand based on gene orientation. The strand
   * that contains the open reading frame of the gene is the 'sense' strand, and
   * the opposite complementary strand is the 'antisense' strand.
   */
  _orientation?: Maybe<Element>;
  /**
   * A relative reference to a DNA strand based on gene orientation. The strand
   * that contains the open reading frame of the gene is the 'sense' strand, and
   * the opposite complementary strand is the 'antisense' strand.
   */
  orientation?: Maybe<Scalars['code']>;
  /**
   * Reference identifier of reference sequence submitted to NCBI. It must match
   * the type in the MolecularSequence.type field. For example, the prefix, “NG_”
   * identifies reference sequence for genes, “NM_” for messenger RNA transcripts,
   * and “NP_” for amino acid sequences.
   */
  referenceSeqId?: Maybe<CodeableConcept>;
  /** A pointer to another MolecularSequence entity as reference sequence. */
  referenceSeqPointer?: Maybe<MolecularSequencereferenceSeqreferenceSeqPointer_ReferenceSeqPointer_Union>;
  /** A string like 'ACGT'. */
  _referenceSeqString?: Maybe<Element>;
  /** A string like 'ACGT'. */
  referenceSeqString?: Maybe<Scalars['String']>;
  /**
   * An absolute reference to a strand. The Watson strand is the strand whose
   * 5'-end is on the short arm of the chromosome, and the Crick strand as the one
   * whose 5'-end is on the long arm.
   */
  _strand?: Maybe<Element>;
  /**
   * An absolute reference to a strand. The Watson strand is the strand whose
   * 5'-end is on the short arm of the chromosome, and the Crick strand as the one
   * whose 5'-end is on the long arm.
   */
  strand?: Maybe<Scalars['code']>;
  /**
   * Start position of the window on the reference sequence. If the coordinate
   * system is either 0-based or 1-based, then start position is inclusive.
   */
  _windowStart?: Maybe<Element>;
  /**
   * Start position of the window on the reference sequence. If the coordinate
   * system is either 0-based or 1-based, then start position is inclusive.
   */
  windowStart?: Maybe<Scalars['Int']>;
  /**
   * End position of the window on the reference sequence. If the coordinate system
   * is 0-based then end is exclusive and does not include the last position. If
   * the coordinate system is 1-base, then end is inclusive and includes the last position.
   */
  _windowEnd?: Maybe<Element>;
  /**
   * End position of the window on the reference sequence. If the coordinate system
   * is 0-based then end is exclusive and does not include the last position. If
   * the coordinate system is 1-base, then end is inclusive and includes the last position.
   */
  windowEnd?: Maybe<Scalars['Int']>;
};

/** A pointer to another MolecularSequence entity as reference sequence. */
export type MolecularSequencereferenceSeqreferenceSeqPointer_ReferenceSeqPointer_Union = MolecularSequence;

export type MolecularSequencerepository = {
  __typename?: 'MolecularSequencerepository';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Click and see / RESTful API / Need login to see / RESTful API with authentication / Other ways to see resource. */
  _type?: Maybe<Element>;
  /** Click and see / RESTful API / Need login to see / RESTful API with authentication / Other ways to see resource. */
  type: Scalars['code'];
  /** URI of an external repository which contains further details about the genetics data. */
  _url?: Maybe<Element>;
  /** URI of an external repository which contains further details about the genetics data. */
  url?: Maybe<Scalars['uri']>;
  /** URI of an external repository which contains further details about the genetics data. */
  _name?: Maybe<Element>;
  /** URI of an external repository which contains further details about the genetics data. */
  name?: Maybe<Scalars['String']>;
  /**
   * Id of the variant in this external repository. The server will understand how
   * to use this id to call for more info about datasets in external repository.
   */
  _datasetId?: Maybe<Element>;
  /**
   * Id of the variant in this external repository. The server will understand how
   * to use this id to call for more info about datasets in external repository.
   */
  datasetId?: Maybe<Scalars['String']>;
  /**
   * Id of the variantset in this external repository. The server will understand
   * how to use this id to call for more info about variantsets in external repository.
   */
  _variantsetId?: Maybe<Element>;
  /**
   * Id of the variantset in this external repository. The server will understand
   * how to use this id to call for more info about variantsets in external repository.
   */
  variantsetId?: Maybe<Scalars['String']>;
  /** Id of the read in this external repository. */
  _readsetId?: Maybe<Element>;
  /** Id of the read in this external repository. */
  readsetId?: Maybe<Scalars['String']>;
};

/** Specimen used for sequencing. */
export type MolecularSequencespecimen_Specimen_Union = Specimen;

export type MolecularSequencestructureVariant = {
  __typename?: 'MolecularSequencestructureVariant';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Information about chromosome structure variation DNA change type. */
  variantType?: Maybe<CodeableConcept>;
  /** Used to indicate if the outer and inner start-end values have the same meaning. */
  _exact?: Maybe<Element>;
  /** Used to indicate if the outer and inner start-end values have the same meaning. */
  exact?: Maybe<Scalars['Boolean']>;
  /** Length of the variant chromosome. */
  _length?: Maybe<Element>;
  /** Length of the variant chromosome. */
  length?: Maybe<Scalars['Int']>;
  /** Structural variant outer. */
  outer?: Maybe<MolecularSequencestructureVariantouter>;
  /** Structural variant inner. */
  inner?: Maybe<MolecularSequencestructureVariantinner>;
};

export type MolecularSequencestructureVariantinner = {
  __typename?: 'MolecularSequencestructureVariantinner';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Structural variant inner start. If the coordinate system is either 0-based or 1-based, then start position is inclusive. */
  _start?: Maybe<Element>;
  /** Structural variant inner start. If the coordinate system is either 0-based or 1-based, then start position is inclusive. */
  start?: Maybe<Scalars['Int']>;
  /**
   * Structural variant inner end. If the coordinate system is 0-based then end is
   * exclusive and does not include the last position. If the coordinate system is
   * 1-base, then end is inclusive and includes the last position.
   */
  _end?: Maybe<Element>;
  /**
   * Structural variant inner end. If the coordinate system is 0-based then end is
   * exclusive and does not include the last position. If the coordinate system is
   * 1-base, then end is inclusive and includes the last position.
   */
  end?: Maybe<Scalars['Int']>;
};

export type MolecularSequencestructureVariantouter = {
  __typename?: 'MolecularSequencestructureVariantouter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Structural variant outer start. If the coordinate system is either 0-based or 1-based, then start position is inclusive. */
  _start?: Maybe<Element>;
  /** Structural variant outer start. If the coordinate system is either 0-based or 1-based, then start position is inclusive. */
  start?: Maybe<Scalars['Int']>;
  /**
   * Structural variant outer end. If the coordinate system is 0-based then end is
   * exclusive and does not include the last position. If the coordinate system is
   * 1-base, then end is inclusive and includes the last position.
   */
  _end?: Maybe<Element>;
  /**
   * Structural variant outer end. If the coordinate system is 0-based then end is
   * exclusive and does not include the last position. If the coordinate system is
   * 1-base, then end is inclusive and includes the last position.
   */
  end?: Maybe<Scalars['Int']>;
};

export type MolecularSequencevariant = {
  __typename?: 'MolecularSequencevariant';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Start position of the variant on the  reference sequence. If the coordinate
   * system is either 0-based or 1-based, then start position is inclusive.
   */
  _start?: Maybe<Element>;
  /**
   * Start position of the variant on the  reference sequence. If the coordinate
   * system is either 0-based or 1-based, then start position is inclusive.
   */
  start?: Maybe<Scalars['Int']>;
  /**
   * End position of the variant on the reference sequence. If the coordinate
   * system is 0-based then end is exclusive and does not include the last
   * position. If the coordinate system is 1-base, then end is inclusive and
   * includes the last position.
   */
  _end?: Maybe<Element>;
  /**
   * End position of the variant on the reference sequence. If the coordinate
   * system is 0-based then end is exclusive and does not include the last
   * position. If the coordinate system is 1-base, then end is inclusive and
   * includes the last position.
   */
  end?: Maybe<Scalars['Int']>;
  /**
   * An allele is one of a set of coexisting sequence variants of a gene ([SO:0001023](http://www.sequenceontology.org/browser/current_svn/term/SO:0001023)).
   *  Nucleotide(s)/amino acids from start position of sequence to stop position of
   * sequence on the positive (+) strand of the observed  sequence. When the
   * sequence  type is DNA, it should be the sequence on the positive (+) strand.
   * This will lay in the range between variant.start and variant.end.
   */
  _observedAllele?: Maybe<Element>;
  /**
   * An allele is one of a set of coexisting sequence variants of a gene ([SO:0001023](http://www.sequenceontology.org/browser/current_svn/term/SO:0001023)).
   *  Nucleotide(s)/amino acids from start position of sequence to stop position of
   * sequence on the positive (+) strand of the observed  sequence. When the
   * sequence  type is DNA, it should be the sequence on the positive (+) strand.
   * This will lay in the range between variant.start and variant.end.
   */
  observedAllele?: Maybe<Scalars['String']>;
  /**
   * An allele is one of a set of coexisting sequence variants of a gene ([SO:0001023](http://www.sequenceontology.org/browser/current_svn/term/SO:0001023)).
   * Nucleotide(s)/amino acids from start position of sequence to stop position of
   * sequence on the positive (+) strand of the reference sequence. When the
   * sequence  type is DNA, it should be the sequence on the positive (+) strand.
   * This will lay in the range between variant.start and variant.end.
   */
  _referenceAllele?: Maybe<Element>;
  /**
   * An allele is one of a set of coexisting sequence variants of a gene ([SO:0001023](http://www.sequenceontology.org/browser/current_svn/term/SO:0001023)).
   * Nucleotide(s)/amino acids from start position of sequence to stop position of
   * sequence on the positive (+) strand of the reference sequence. When the
   * sequence  type is DNA, it should be the sequence on the positive (+) strand.
   * This will lay in the range between variant.start and variant.end.
   */
  referenceAllele?: Maybe<Scalars['String']>;
  /**
   * Extended CIGAR string for aligning the sequence with reference bases. See
   * detailed documentation [here](http://support.illumina.com/help/SequencingAnalysisWorkflow/Content/Vault/Informatics/Sequencing_Analysis/CASAVA/swSEQ_mCA_ExtendedCIGARFormat.htm).
   */
  _cigar?: Maybe<Element>;
  /**
   * Extended CIGAR string for aligning the sequence with reference bases. See
   * detailed documentation [here](http://support.illumina.com/help/SequencingAnalysisWorkflow/Content/Vault/Informatics/Sequencing_Analysis/CASAVA/swSEQ_mCA_ExtendedCIGARFormat.htm).
   */
  cigar?: Maybe<Scalars['String']>;
  /** A pointer to an Observation containing variant information. */
  variantPointer?: Maybe<MolecularSequencevariantvariantPointer_VariantPointer_Union>;
};

/** A pointer to an Observation containing variant information. */
export type MolecularSequencevariantvariantPointer_VariantPointer_Union = Observation;

/** Base StructureDefinition for Money Type: An amount of economic utility in some recognized currency. */
export type Money = {
  __typename?: 'Money';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** Numerical value (with implicit precision). */
  _value?: Maybe<Element>;
  /** Numerical value (with implicit precision). */
  value?: Maybe<Scalars['Float']>;
  /** ISO 4217 Currency Code. */
  _currency?: Maybe<Element>;
  /** ISO 4217 Currency Code. */
  currency?: Maybe<Scalars['code']>;
};

/** Base StructureDefinition for Money Type: An amount of economic utility in some recognized currency. */
export type Money_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Numerical value (with implicit precision). */
  _value?: Maybe<Element_Input>;
  /** Numerical value (with implicit precision). */
  value?: Maybe<Scalars['Float']>;
  /** ISO 4217 Currency Code. */
  _currency?: Maybe<Element_Input>;
  /** ISO 4217 Currency Code. */
  currency?: Maybe<Scalars['code']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a PatientAgreement record */
  AdminNotificationCreate?: Maybe<AdminNotifications>;
  /** Update a AdminNotification record */
  AdminNotificationUpdate?: Maybe<AdminNotifications>;
  /** Remove a AdminNotification record */
  AdminNotificationRemove?: Maybe<AdminNotifications>;
  /** Create a PatientAgreement record */
  AdminTaskCreate?: Maybe<AdminTasks>;
  /** Update a PatientNotification record */
  AdminTaskUpdate?: Maybe<AdminTasks>;
  /** Remove a PatientNotification record */
  AdminTaskRemove?: Maybe<AdminTasks>;
  /** Create a TasksMessages record */
  APPNotificationsCreate?: Maybe<AppNotifications>;
  /** Update a TasksMessages record */
  APPNotificationsUpdate?: Maybe<AppNotifications>;
  /** Remove a TasksMessages record */
  APPNotificationsRemove?: Maybe<AppNotifications>;
  /** Create a Appointment Type Master record */
  AppointmentTypeMasterCreate?: Maybe<AppointmentTypeMaster_Schema>;
  /** Create a TasksMessages record */
  APPTasksCreate?: Maybe<AppTasks>;
  /** Update a TasksMessages record */
  APPTasksUpdate?: Maybe<AppTasks>;
  /** Remove a TasksMessages record */
  APPTasksRemove?: Maybe<AppTasks>;
  /** Create a BlogCategory record */
  BlogCategoryCreate?: Maybe<BlogCategory_Schema>;
  /** Update a BlogCategory record */
  BlogCategoryUpdate?: Maybe<BlogCategory_Schema>;
  /** Remove a BlogCategory record */
  BlogCategoryRemove?: Maybe<BlogCategory_Schema>;
  /** Create a Job record */
  BlogCreate?: Maybe<Blogs_Schema>;
  /** Update a Pricing record */
  BlogUpdate?: Maybe<Blogs_Schema>;
  /** Remove a Pricing record */
  BlogRemove?: Maybe<Blogs_Schema>;
  /** Create a ProfessionalType record */
  ChatTrackerCreate?: Maybe<ChatTrackerType_Schema>;
  /** Create a Faq record */
  FaqCreate?: Maybe<Faq>;
  /** Update a Faq record */
  FaqUpdate?: Maybe<Faq>;
  /** Remove a PatientRecordsLog record */
  FaqRemove?: Maybe<Faq>;
  /** Create a Job record */
  GeneralPractitionerCreate?: Maybe<Gp_Schema>;
  /** Update a Pricing record */
  GeneralPractitionerUpdate?: Maybe<Gp_Schema>;
  /** Remove a Pricing record */
  GeneralPractitionerRemove?: Maybe<Gp_Schema>;
  /** Create a Job record */
  GeneralPractitionerImport?: Maybe<Gp_Schema>;
  /** Create a Handbook record */
  HandbookCreate?: Maybe<Handbook>;
  /** Update a Handbook record */
  HandbookUpdate?: Maybe<Handbook>;
  /** Remove a Handbook record */
  HandbookRemove?: Maybe<Handbook>;
  /** Create a Job record */
  JobCreate?: Maybe<Jobs_Schema>;
  /** Update a Pricing record */
  JobUpdate?: Maybe<Jobs_Schema>;
  /** Remove a Pricing record */
  JobRemove?: Maybe<Jobs_Schema>;
  /** Create a MedicationMaster record */
  MedicationMasterCreate?: Maybe<MedicationMasterDocument>;
  /** Update a MedicationMaster record */
  MedicationMasterUpdate?: Maybe<MedicationMasterDocument>;
  /** Remove a MedicationMaster record */
  MedicationMasterRemove?: Maybe<MedicationMasterDocument>;
  /** Create a PatientAgreement record */
  OrganisationActivityCreate?: Maybe<OrganisationActivity>;
  /** Update a PatientPrivacy record */
  OrganisationActivityUpdate?: Maybe<OrganisationActivity>;
  /** Remove a PatientPrivacy record */
  OrganisationActivityRemove?: Maybe<OrganisationActivity>;
  /** Create a PractitionerAgreement record */
  OrganisationAgreementCreate?: Maybe<OrganisationAgreements>;
  /** Update a PractitionerAgreement record */
  OrganisationAgreementUpdate?: Maybe<OrganisationAgreements>;
  /** Remove a OrganisationAgreement record */
  OrganisationAgreementRemove?: Maybe<OrganisationAgreements>;
  /** Create a Organisation record */
  OrganisationPreferenceCreate?: Maybe<OrganisationPreferences>;
  /** Update a OrganisationPreference record */
  OrganisationPreferenceUpdate?: Maybe<OrganisationPreferences>;
  /** Remove a OrganisationPreference record */
  OrganisationPreferenceRemove?: Maybe<OrganisationPreferences>;
  /** Create a PractitionerAgreement record */
  OrganisationPrivacyCreate?: Maybe<OrganisationPrivacy>;
  /** Update a OrganisationPrivacy record */
  OrganisationPrivacyUpdate?: Maybe<OrganisationPrivacy>;
  /** Remove a OrganisationPrivacy record */
  OrganisationPrivacyRemove?: Maybe<OrganisationPrivacy>;
  /** Create a Organization record */
  OrganizationCreate?: Maybe<Organization>;
  /** Update a Organization record */
  OrganizationUpdate?: Maybe<Organization>;
  /** Remove a Organization record */
  OrganizationRemove?: Maybe<Organization>;
  /** Create a OrganizationAffiliation record */
  OrganizationAffiliationCreate?: Maybe<OrganizationAffiliation>;
  /** Update a OrganizationAffiliation record */
  OrganizationAffiliationUpdate?: Maybe<OrganizationAffiliation>;
  /** Remove a OrganizationAffiliation record */
  OrganizationAffiliationRemove?: Maybe<OrganizationAffiliation>;
  /** Create a PharmaZone record */
  PharmaZoneCreate?: Maybe<PharmaZone>;
  /** Update a PharmaZone record */
  PharmaZoneUpdate?: Maybe<PharmaZone>;
  /** Remove a PharmaZone record */
  PharmaZoneRemove?: Maybe<PharmaZone>;
  /** Create a PomsMasterTemplate record */
  PomsMasterTemplateCreate?: Maybe<PomsMasterTemplate>;
  /** Update a PomsMasterTemplate record */
  PomsMasterTemplateUpdate?: Maybe<PomsMasterTemplate>;
  /** Remove a MasterTemplate record */
  PomsMasterTemplateRemove?: Maybe<PomsMasterTemplate>;
  /** Create a PomsReferral record */
  PomsReferralCreate?: Maybe<PomsReferral>;
  /** Update a PomsReferral record */
  PomsReferralUpdate?: Maybe<PomsReferral>;
  /** Remove a PomsReferral record */
  PomsReferralRemove?: Maybe<PomsReferral>;
  /** Create a Pricing record */
  PricingCreate?: Maybe<Pricing_Schema>;
  /** Update a Pricing record */
  PricingUpdate?: Maybe<Pricing_Schema>;
  /** Remove a Pricing record */
  PricingRemove?: Maybe<Pricing_Schema>;
  /** Create a ProfessionalType record */
  ProfessionalTypeCreate?: Maybe<ProfessionalType_Schema>;
  /** Update a ProfessionalType record */
  ProfessionalTypeUpdate?: Maybe<ProfessionalType_Schema>;
  /** Remove a ProfessionalType record */
  ProfessionalTypeRemove?: Maybe<ProfessionalType_Schema>;
  /** Create a Questionnaire record */
  QuestionnaireCreate?: Maybe<Questionnaire>;
  /** Update a Questionnaire record */
  QuestionnaireUpdate?: Maybe<Questionnaire>;
  /** Remove a Questionnaire record */
  QuestionnaireRemove?: Maybe<Questionnaire>;
  /** Create a InternalReferral record */
  QuestionnaireAssign?: Maybe<QuestionnaireAssign>;
  /** Create a InternalReferral record */
  QuestionnaireAssignCreate?: Maybe<QuestionnaireAssign>;
  /** Update a PomsInternalReferral record */
  QuestionnaireAssignUpdate?: Maybe<QuestionnaireAssign>;
  /** Remove a PatientDocument record */
  QuestionnaireAssignRemove?: Maybe<QuestionnaireAssign>;
  /** Create a InternalReferral record */
  QuestionnaireBuilderCreate?: Maybe<QuestionnaireBuilder>;
  /** Update a PomsInternalReferral record */
  QuestionnaireBuilderUpdate?: Maybe<QuestionnaireBuilder>;
  /** Remove a PatientDocument record */
  QuestionnaireBuilderRemove?: Maybe<QuestionnaireBuilder>;
  /** Create a QuestionnaireResponse record */
  QuestionnaireResponseCreate?: Maybe<QuestionnaireResponse>;
  /** Update a QuestionnaireResponse record */
  QuestionnaireResponseUpdate?: Maybe<QuestionnaireResponse>;
  /** Remove a QuestionnaireResponse record */
  QuestionnaireResponseRemove?: Maybe<QuestionnaireResponse>;
  /** Create a quote record */
  QuoteCreate?: Maybe<Quotes_Schema>;
  /** Update a quote record */
  QuoteUpdate?: Maybe<Quotes_Schema>;
  /** Remove a quote record */
  QuoteRemove?: Maybe<Quotes_Schema>;
  /** Create a Appointment Type Master record */
  SubSpecialtyMasterCreate?: Maybe<SubSpecialtyMaster_Schema>;
  /** Create a Task record */
  TaskCreate?: Maybe<Task>;
  /** Update a Task record */
  TaskUpdate?: Maybe<Task>;
  /** Remove a Task record */
  TaskRemove?: Maybe<Task>;
  /** Create a Task Manager record */
  TaskManagerCreate?: Maybe<TaskManager>;
  /** Remove a Task manager record */
  TaskManagerRemove?: Maybe<TaskManager>;
  /** Update a Task manager record */
  TaskManagerUpdate?: Maybe<TaskManager>;
  /** Assign a Task manager record */
  TaskAssign?: Maybe<TaskManager>;
  /** Complete a Task manager record */
  CompleteAssignTask?: Maybe<TaskManager>;
  /** Update an assigned Task manager record */
  UpdateAssignTask?: Maybe<TaskManager>;
  /** Add a comment to a task */
  AddTaskComment?: Maybe<TaskComment>;
  /** Mark all comments for a task as read by a user */
  MarkCommentsAsRead?: Maybe<TaskManager>;
  /** Reassign a Task manager record */
  ReassignTask?: Maybe<TaskManager>;
  /** Create a TasksMessages record */
  TasksMessagesCreate?: Maybe<TasksMessages>;
  /** Update a TasksMessages record */
  TasksMessagesUpdate?: Maybe<TasksMessages>;
  /** Remove a TasksMessages record */
  TasksMessagesRemove?: Maybe<TasksMessages>;
  /** Create a ValueSet record */
  ValueSetCreate?: Maybe<ValueSet>;
  /** Update a ValueSet record */
  ValueSetUpdate?: Maybe<ValueSet>;
  /** Remove a ValueSet record */
  ValueSetRemove?: Maybe<ValueSet>;
  /** Create a WebContact record */
  WebContactCreate?: Maybe<WebContact>;
  /** Update a WebContact record */
  WebContactUpdate?: Maybe<WebContact>;
  /** Remove a PatientRecordsLog record */
  WebContactRemove?: Maybe<WebContact>;
  /** Create a PatientInvoice record */
  PatientInvoiceCreate?: Maybe<PatientInvoices>;
  /** Update a PatientInvoiceSchema record */
  PatientInvoiceUpdate?: Maybe<PatientInvoices>;
  /** Remove a PatientRecordsLog record */
  PatientInvoiceRemove?: Maybe<PatientInvoices>;
  /** Create a BillingInvoice record */
  PomsInvoiceBillingCreate?: Maybe<PomsBillingInvoice>;
  /** Update a BillingInvoice record */
  PomsInvoiceBillingUpdate?: Maybe<PomsBillingInvoice>;
  /** Remove a BillingInvoice record */
  PomsInvoiceBillingRemove?: Maybe<PomsBillingInvoice>;
  /** Create a PractitionerStatement record */
  PractitionerStatementCreate?: Maybe<PractitionerStatement>;
  /** Update a PractitionerStatementSchema record */
  PractitionerStatementUpdate?: Maybe<PractitionerStatement>;
  /** Remove a PractitionerStatement record */
  PractitionerStatementRemove?: Maybe<PractitionerStatement>;
  /** Create a RolePermission record */
  RolePermissionCreate?: Maybe<RolesPermission_Schema>;
  /** Update a RolePermission record */
  RolePermissionUpdate?: Maybe<RolesPermission_Schema>;
  /** Remove a RolePermission record */
  RolePermissionRemove?: Maybe<RolesPermission_Schema>;
  /** Create a User record */
  UserCreate?: Maybe<User>;
  /** Update a User record */
  UserUpdate?: Maybe<User>;
  /** Remove a User record */
  UserRemove?: Maybe<User>;
  /** Clinician Basic Signup record */
  ClinicianBasicSignUp?: Maybe<User>;
  /** confirmUser record */
  ConfirmUser?: Maybe<User>;
  /** confirmUser record */
  CreateClinicianFromAdmin?: Maybe<User>;
  /** confirmUser record */
  CreateOrganizationUser?: Maybe<User>;
  /** CreatePractitionerFromAdmin record */
  CreatePractitionerFromAdmin?: Maybe<User>;
  /** CreatePractitionerFromAdmin record */
  ForgotPassword?: Maybe<User>;
  /** CreatePractitionerFromAdmin record */
  GetBasicSignedPractitionerList?: Maybe<User>;
  /** CreatePractitionerFromAdmin record */
  UserLogin?: Maybe<User>;
  /** CreatePractitionerFromAdmin record */
  UserRegistration?: Maybe<User>;
  /** CreatePractitionerFromAdmin record */
  ResetPassword?: Maybe<User>;
  /** CreatePractitionerFromAdmin record */
  ResendConfirmation?: Maybe<User>;
  /** CreatePractitionerFromAdmin record */
  UpdatePassword?: Maybe<User>;
  /** createAdmin record */
  createAdmin?: Maybe<User>;
  /** createLinkedUser record */
  createLinkedUser?: Maybe<User>;
  /** refreshToken */
  refreshToken?: Maybe<User>;
  /** updateAdminProfile */
  updateAdminProfile?: Maybe<User>;
  /** Update a User record */
  PasswordSync?: Maybe<User>;
  /** CreatePractitionerFromAdmin record */
  UserGuestRegistration?: Maybe<User>;
  /** Create a WebContact record */
  PatientContactCreate?: Maybe<WebContact>;
  /** Create a PatientLetter record */
  CrisisSafeguardCreate?: Maybe<CrisisSafeguard>;
  /** Update a CrisisSafeguard record */
  CrisisSafeguardUpdate?: Maybe<CrisisSafeguard>;
  /** Remove a PatientLetter record */
  CrisisSafeguardvRemove?: Maybe<CrisisSafeguard>;
  /** Create a Patient record */
  PatientCreate?: Maybe<Patient>;
  /** Update a Patient record */
  PatientUpdate?: Maybe<Patient>;
  /** Update a Patient record */
  PatientDisorderUpdate?: Maybe<Patient>;
  /** Update a Patient record */
  PatientBlockUpdate?: Maybe<Patient>;
  /** Remove a Patient record */
  PatientRemove?: Maybe<Patient>;
  /** Share Document */
  ShareDocument?: Maybe<Patient>;
  /** Create a InternalReferral record */
  PatientFinancialInfoCreate?: Maybe<PatientFinancialInfo>;
  /** Update a PomsInternalReferral record */
  PatientFinancialInfoUpdate?: Maybe<PatientFinancialInfo>;
  /** Remove a PatientDocument record */
  PatientFinancialInfoRemove?: Maybe<PatientFinancialInfo>;
  /** Create a PatientAgreement record */
  PatientNotificationCreate?: Maybe<PatientNotifications>;
  /** Update a PatientNotification record */
  PatientNotificationUpdate?: Maybe<PatientNotifications>;
  /** Remove a PatientNotification record */
  PatientNotificationRemove?: Maybe<PatientNotifications>;
  /** Create a PatientPrescription record */
  PatientPrescriptionCreate?: Maybe<PatientPrescriptionDocument>;
  /** Update a PatientPrescription record */
  PatientPrescriptionUpdate?: Maybe<PatientPrescriptionDocument>;
  /** Remove a MedicationMaster record */
  PatientPrescriptionRemove?: Maybe<PatientPrescriptionDocument>;
  /** Create a InternalReferral record */
  ExternalPatientQuestionnaireCreate?: Maybe<ExternalPatientQuestionnaire_Schema>;
  /** Update a PomsInternalReferral record */
  ExternalPatientQuestionnaireUpdate?: Maybe<ExternalPatientQuestionnaire_Schema>;
  /** Create a InternalReferral record */
  PatientQuestionnaireCreate?: Maybe<PatientQuestionnaire_Schema>;
  /** Update a PomsInternalReferral record */
  PatientQuestionnaireUpdate?: Maybe<PatientQuestionnaire_Schema>;
  /** Remove a PatientDocument record */
  PatientQuestionnaireRemove?: Maybe<PatientQuestionnaire_Schema>;
  /** Create a PatientRecordsLog record */
  PatientRecordsLogCreate?: Maybe<PatientRecordsLog>;
  /** Update a PatientRecordsLog record */
  PatientRecordsLogUpdate?: Maybe<PatientRecordsLog>;
  /** Remove a PatientRecordsLog record */
  PatientRecordsLogRemove?: Maybe<PatientRecordsLog>;
  /** Create a PatientAgreement record */
  PatientTaskCreate?: Maybe<PatientTasks>;
  /** Update a PatientNotification record */
  PatientTaskUpdate?: Maybe<PatientTasks>;
  /** Update a PatientToDoNotification record */
  PatientToDoTaskUpdate?: Maybe<PatientToDoTasks>;
  /** Remove a PatientNotification record */
  PatientTaskRemove?: Maybe<PatientTasks>;
  /** Create a PatientAgreement record */
  PomsPatientActivityCreate?: Maybe<PomsPatientActivity>;
  /** Update a PatientPrivacy record */
  PomsPatientActivityUpdate?: Maybe<PomsPatientActivity>;
  /** Remove a PatientPrivacy record */
  PomsPatientActivityRemove?: Maybe<PomsPatientActivity>;
  /** Create a PatientLetter record */
  PomsPatientDocumentCreate?: Maybe<PomsPatientDocument>;
  /** Update a PomsPatientDocument record */
  PomsPatientDocumentUpdate?: Maybe<PomsPatientDocument>;
  /** Remove a PatientDocument record */
  PomsPatientDocumentRemove?: Maybe<PomsPatientDocument>;
  /** Create a PatientLetter record */
  PomsPatientLetterCreate?: Maybe<PomsPatientLetter>;
  /** Update a PomsPatientLetter record */
  PomsPatientLetterUpdate?: Maybe<PomsPatientLetter>;
  /** Remove a PatientLetter record */
  PomsPatientLettervRemove?: Maybe<PomsPatientLetter>;
  /** Create a PatientAgreement record */
  PomsPatientPreferenceCreate?: Maybe<PomsPatientPreferences>;
  /** Update a PatientPreference record */
  PomsPatientPreferenceUpdate?: Maybe<PomsPatientPreferences>;
  /** Remove a PatientPreference record */
  PomsPatientPreferenceRemove?: Maybe<PomsPatientPreferences>;
  /** Create a PatientAgreement record */
  PomsPatientPrivacyCreate?: Maybe<PomsPatientPrivacy>;
  /** Update a PatientPrivacy record */
  PomsPatientPrivacyUpdate?: Maybe<PomsPatientPrivacy>;
  /** Remove a PatientPrivacy record */
  PomsPatientPrivacyRemove?: Maybe<PomsPatientPrivacy>;
  /** Create a PatientAgreement record */
  SignPostingCreate?: Maybe<SignPosting_Schema>;
  /** Create a Leaflet record */
  LeafletCreate?: Maybe<Leaflet_Schema>;
  /** Update a SignPosting record */
  SignPostingUpdate?: Maybe<SignPosting_Schema>;
  /** Update a Leaflet record */
  LeafletUpdate?: Maybe<Leaflet_Schema>;
  /** Remove a SignPosting record */
  SignPostingRemove?: Maybe<SignPosting_Schema>;
  /** Remove a Leaflet record */
  LeafletRemove?: Maybe<Leaflet_Schema>;
  /** Create a PatientAgreement record */
  SignPostingCategoryCreate?: Maybe<SignPostingCategory_Schema>;
  /** Update a SignPostingCategory record */
  SignPostingCategoryUpdate?: Maybe<SignPostingCategory_Schema>;
  /** Remove a SignPostingCategory record */
  SignPostingCategoryRemove?: Maybe<SignPostingCategory_Schema>;
  /** Create a WebContact record */
  PractitionerContactCreate?: Maybe<WebContact>;
  /** Create a DocumentReference record */
  DocumentReferenceCreate?: Maybe<DocumentReference>;
  /** Update a DocumentReference record */
  DocumentReferenceUpdate?: Maybe<DocumentReference>;
  /** Remove a DocumentReference record */
  DocumentReferenceRemove?: Maybe<DocumentReference>;
  /** Create a Location record */
  LocationCreate?: Maybe<Location>;
  /** Update a Location record */
  LocationUpdate?: Maybe<Location>;
  /** Remove a Location record */
  LocationRemove?: Maybe<Location>;
  /** Create a PatientAgreement record */
  PomsPractitionerActivityCreate?: Maybe<PomsPractitionerActivity>;
  /** Update a PatientPrivacy record */
  PomsPractitionerActivityUpdate?: Maybe<PomsPractitionerActivity>;
  /** Remove a PatientPrivacy record */
  PomsPractitionerActivityRemove?: Maybe<PomsPractitionerActivity>;
  /** Create a PractitionerAgreement record */
  PomsPractitionerAgreementCreate?: Maybe<PomsPractitionerAgreements>;
  /** Update a PractitionerAgreement record */
  PomsPractitionerAgreementUpdate?: Maybe<PomsPractitionerAgreements>;
  /** Update a PractitionerAgreement record */
  PomsPractitionerContractFile?: Maybe<PomsPractitionerAgreements>;
  /** Remove a PractitionerAgreement record */
  PomsPractitionerAgreementRemove?: Maybe<PomsPractitionerAgreements>;
  /** Create a PractitionerAgreement record */
  PomsPractitionerPreferenceCreate?: Maybe<PomsPractitionerPreferences>;
  /** Update a PractitionerPreference record */
  PomsPractitionerPreferenceUpdate?: Maybe<PomsPractitionerPreferences>;
  /** Remove a PractitionerPreference record */
  PomsPractitionerPreferenceRemove?: Maybe<PomsPractitionerPreferences>;
  /** Create a PractitionerAgreement record */
  PomsPractitionerPrivacyCreate?: Maybe<PomsPractitionerPrivacy>;
  /** Update a PractitionerPrivacy record */
  PomsPractitionerPrivacyUpdate?: Maybe<PomsPractitionerPrivacy>;
  /** Remove a PractitionerPrivacy record */
  PomsPractitionertPrivacyRemove?: Maybe<PomsPractitionerPrivacy>;
  /** Create a Practitioner record */
  PractitionerCreate?: Maybe<Practitioner>;
  /** Update a Practitioner record */
  PractitionerUpdate?: Maybe<Practitioner>;
  /** Update a Practitioner web record */
  PractitionerWebUpdate?: Maybe<Practitioner>;
  /** Remove a Practitioner record */
  PractitionerRemove?: Maybe<Practitioner>;
  /** Create a PatientAgreement record */
  PractitionerNotificationCreate?: Maybe<PractitionerNotifications>;
  /** Update a PractitionerNotification record */
  PractitionerNotificationUpdate?: Maybe<PractitionerNotifications>;
  /** Remove a PractitionerNotification record */
  PractitionerNotificationRemove?: Maybe<PractitionerNotifications>;
  /** Create a PractitionerRole record */
  PractitionerRoleCreate?: Maybe<PractitionerRole>;
  /** Update a PractitionerRole record */
  PractitionerRoleUpdate?: Maybe<PractitionerRole>;
  /** Remove a PractitionerRole record */
  PractitionerRoleRemove?: Maybe<PractitionerRole>;
  /** Create a PatientAgreement record */
  PractitionerTaskCreate?: Maybe<PractitionerTasks>;
  /** Update a PatientNotification record */
  PractitionerTaskUpdate?: Maybe<PractitionerTasks>;
  /** Remove a PatientNotification record */
  PractitionerTaskRemove?: Maybe<PractitionerTasks>;
  /** Create a Procedure record */
  ProcedureCreate?: Maybe<Procedure>;
  /** Update a Procedure record */
  ProcedureUpdate?: Maybe<Procedure>;
  /** Remove a Procedure record */
  ProcedureRemove?: Maybe<Procedure>;
  /** Create a Provenance record */
  ProvenanceCreate?: Maybe<Provenance>;
  /** Update a Provenance record */
  ProvenanceUpdate?: Maybe<Provenance>;
  /** Remove a Provenance record */
  ProvenanceRemove?: Maybe<Provenance>;
  /** Create a PatientLetter record */
  PractitionerPatientCommunicationCreate?: Maybe<PractitionerPatientCommunication>;
  /** Update a PomsPatientLetter record */
  PractitionerPatientCommunicationUpdate?: Maybe<PractitionerPatientCommunication>;
  /** Update a PomsPatientLetter record */
  UpdateCommunicationReadStatus?: Maybe<PractitionerPatientCommunication>;
  /** Remove a PatientLetter record */
  PractitionerPatientCommunicationRemove?: Maybe<PractitionerPatientCommunication>;
  /** Create a FeedBack record */
  FeedBackCreate?: Maybe<FeedBack>;
  /** Update a FeedBack record */
  FeedBackUpdate?: Maybe<FeedBack>;
  /** Remove a FeedBack record */
  FeedBackRemove?: Maybe<FeedBack>;
  /** Remove a Reminder record */
  DisorderImport?: Maybe<Disorder_Schema>;
  /** Create a Reminder record */
  DisorderCreate?: Maybe<Disorder_Schema>;
  /** Update a Reminder record */
  DisorderUpdate?: Maybe<Disorder_Schema>;
  /** Remove a Reminder record */
  DisorderRemove?: Maybe<Disorder_Schema>;
  /** Create a PomsAppointment record */
  OtherAppointmentCreate?: Maybe<OtherAppointment>;
  /** Update a PomsAppointment record */
  OtherAppointmentUpdate?: Maybe<OtherAppointment>;
  /** Create a PomsAppointment record */
  PomsAppointmentCreate?: Maybe<PomsAppointment>;
  /** Update a PomsAppointment record */
  PomsAppointmentUpdate?: Maybe<PomsAppointment>;
  /** Remove a PomsAppointment record */
  PomsAppointmentRemove?: Maybe<PomsAppointment>;
  /** Get Payment */
  PomsAppointmentGetPaymentMutation?: Maybe<PomsAppointment>;
  /** Get Payment */
  PomsAppointmentSetUpPaymentIntentMutation?: Maybe<PomsAppointment>;
  /** Block Slot */
  PomsAppointmentBlockSlotMutation?: Maybe<PomsAppointment>;
  /** Block Slot */
  PomsAppointmentBookSlotMutation?: Maybe<PomsAppointment>;
  /** Update a PomsAppointment record */
  AppointmentInProgressNotification?: Maybe<PomsAppointment>;
  /** Create a PractitionerSchedule record */
  PomsSlotCreate?: Maybe<PomsPractitionerSchedule>;
  /** Create a PractitionerSchedule record */
  PomsPractitionerScheduleCreate?: Maybe<PomsPractitionerSchedule>;
  /** Update a PractitionerSchedule record */
  PomsPractitionerScheduleUpdate?: Maybe<PomsPractitionerSchedule>;
  /** Remove a PractitionerSchedule record */
  PomsPractitionerScheduleRemove?: Maybe<PomsPractitionerSchedule>;
  /** Create a Reminder record */
  ReminderCreate?: Maybe<Reminder_Schema>;
  /** Update a Reminder record */
  ReminderUpdate?: Maybe<Reminder_Schema>;
  /** Remove a Reminder record */
  ReminderRemove?: Maybe<Reminder_Schema>;
  /** Create a Schedule record */
  ScheduleCreate?: Maybe<Schedule>;
  /** Update a Schedule record */
  ScheduleUpdate?: Maybe<Schedule>;
  /** Remove a Schedule record */
  ScheduleRemove?: Maybe<Schedule>;
  /** Create a Slot record */
  SlotCreate?: Maybe<Slot>;
  /** Update a Slot record */
  SlotUpdate?: Maybe<Slot>;
  /** Remove a Slot record */
  SlotRemove?: Maybe<Slot>;
  /** Create a Slot record */
  StripePaymentSecret?: Maybe<StripePayment>;
};


export type MutationAdminNotificationCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: AdminNotifications_Input;
};


export type MutationAdminNotificationUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: AdminNotifications_Input;
};


export type MutationAdminNotificationRemoveArgs = {
  id: Scalars['id'];
};


export type MutationAdminTaskCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: AdminTask_Input;
};


export type MutationAdminTaskUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: AdminTask_Input;
};


export type MutationAdminTaskRemoveArgs = {
  id: Scalars['id'];
};


export type MutationAppNotificationsCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: AppNotifications_Input;
};


export type MutationAppNotificationsUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: AppNotifications_Input;
};


export type MutationAppNotificationsRemoveArgs = {
  id: Scalars['id'];
};


export type MutationAppointmentTypeMasterCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: AppointmentTypeMaster_Input;
};


export type MutationAppTasksCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: AppTasks_Input;
};


export type MutationAppTasksUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: AppTasks_Input;
};


export type MutationAppTasksRemoveArgs = {
  id: Scalars['id'];
};


export type MutationBlogCategoryCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: BlogCategory_Input;
};


export type MutationBlogCategoryUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: BlogCategory_Input;
};


export type MutationBlogCategoryRemoveArgs = {
  id: Scalars['id'];
};


export type MutationBlogCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Blogs_Input;
};


export type MutationBlogUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Blogs_Input;
};


export type MutationBlogRemoveArgs = {
  id: Scalars['id'];
};


export type MutationChatTrackerCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: ChatTracker_Input;
};


export type MutationFaqCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Faq_Input;
};


export type MutationFaqUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Faq_Input;
};


export type MutationFaqRemoveArgs = {
  id: Scalars['id'];
};


export type MutationGeneralPractitionerCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Gp_Input;
};


export type MutationGeneralPractitionerUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Gp_Input;
};


export type MutationGeneralPractitionerRemoveArgs = {
  id: Scalars['id'];
};


export type MutationGeneralPractitionerImportArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Gp_Input;
};


export type MutationHandbookCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Handbook_Input;
};


export type MutationHandbookUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Handbook_Input;
};


export type MutationHandbookRemoveArgs = {
  id: Scalars['id'];
};


export type MutationJobCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Jobs_Input;
};


export type MutationJobUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Jobs_Input;
};


export type MutationJobRemoveArgs = {
  id: Scalars['id'];
};


export type MutationMedicationMasterCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: MedicationMaster_Input;
};


export type MutationMedicationMasterUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: MedicationMaster_Input;
};


export type MutationMedicationMasterRemoveArgs = {
  id: Scalars['id'];
};


export type MutationOrganisationActivityCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OrganisationActivity_Input;
};


export type MutationOrganisationActivityUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OrganisationActivity_Input;
};


export type MutationOrganisationActivityRemoveArgs = {
  id: Scalars['id'];
};


export type MutationOrganisationAgreementCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OrganizationAgreements_Input;
};


export type MutationOrganisationAgreementUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OrganizationAgreements_Input;
};


export type MutationOrganisationAgreementRemoveArgs = {
  id: Scalars['id'];
};


export type MutationOrganisationPreferenceCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OrganisationPreferences_Input;
};


export type MutationOrganisationPreferenceUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OrganisationPreferences_Input;
};


export type MutationOrganisationPreferenceRemoveArgs = {
  id: Scalars['id'];
};


export type MutationOrganisationPrivacyCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OrganisationPrivacy_Input;
};


export type MutationOrganisationPrivacyUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OrganisationPrivacy_Input;
};


export type MutationOrganisationPrivacyRemoveArgs = {
  id: Scalars['id'];
};


export type MutationOrganizationCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Organization_Input;
};


export type MutationOrganizationUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Organization_Input;
};


export type MutationOrganizationRemoveArgs = {
  id: Scalars['id'];
};


export type MutationOrganizationAffiliationCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OrganizationAffiliation_Input;
};


export type MutationOrganizationAffiliationUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OrganizationAffiliation_Input;
};


export type MutationOrganizationAffiliationRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPharmaZoneCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PharmaZone_Input;
};


export type MutationPharmaZoneUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PharmaZone_Input;
};


export type MutationPharmaZoneRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsMasterTemplateCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsMasterTemplate_Input;
};


export type MutationPomsMasterTemplateUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsMasterTemplate_Input;
};


export type MutationPomsMasterTemplateRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsReferralCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsReferral_Input;
};


export type MutationPomsReferralUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsReferral_Input;
};


export type MutationPomsReferralRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPricingCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Pricing_Input;
};


export type MutationPricingUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Pricing_Input;
};


export type MutationPricingRemoveArgs = {
  id: Scalars['id'];
};


export type MutationProfessionalTypeCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: ProfessionalType_Input;
};


export type MutationProfessionalTypeUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: ProfessionalType_Input;
};


export type MutationProfessionalTypeRemoveArgs = {
  id: Scalars['id'];
};


export type MutationQuestionnaireCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Questionnaire_Input;
};


export type MutationQuestionnaireUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Questionnaire_Input;
};


export type MutationQuestionnaireRemoveArgs = {
  id: Scalars['id'];
};


export type MutationQuestionnaireAssignArgs = {
  id?: Maybe<Scalars['id']>;
  resource: QuestionnaireAssign_Input;
};


export type MutationQuestionnaireAssignCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: QuestionnaireAssign_Input;
};


export type MutationQuestionnaireAssignUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: QuestionnaireAssign_Input;
};


export type MutationQuestionnaireAssignRemoveArgs = {
  id: Scalars['id'];
};


export type MutationQuestionnaireBuilderCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: QuestionnaireBuilder_Input;
};


export type MutationQuestionnaireBuilderUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: QuestionnaireBuilder_Input;
};


export type MutationQuestionnaireBuilderRemoveArgs = {
  id: Scalars['id'];
};


export type MutationQuestionnaireResponseCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: QuestionnaireResponse_Input;
};


export type MutationQuestionnaireResponseUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: QuestionnaireResponse_Input;
};


export type MutationQuestionnaireResponseRemoveArgs = {
  id: Scalars['id'];
};


export type MutationQuoteCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Quotes_Input;
};


export type MutationQuoteUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Quotes_Input;
};


export type MutationQuoteRemoveArgs = {
  id: Scalars['id'];
};


export type MutationSubSpecialtyMasterCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: SubSpecialtyMaster_Input;
};


export type MutationTaskCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Task_Input;
};


export type MutationTaskUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Task_Input;
};


export type MutationTaskRemoveArgs = {
  id: Scalars['id'];
};


export type MutationTaskManagerCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: TaskManager_Input;
};


export type MutationTaskManagerRemoveArgs = {
  id: Scalars['id'];
  admin_id?: Maybe<Scalars['id']>;
};


export type MutationTaskManagerUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: TaskManager_Input;
};


export type MutationTaskAssignArgs = {
  id?: Maybe<Scalars['id']>;
  resource: TaskManager_Input;
};


export type MutationCompleteAssignTaskArgs = {
  id?: Maybe<Scalars['id']>;
  resource: TaskManager_Input;
};


export type MutationUpdateAssignTaskArgs = {
  id?: Maybe<Scalars['id']>;
  resource: TaskManager_Input;
};


export type MutationAddTaskCommentArgs = {
  resource: TaskComment_Input;
};


export type MutationMarkCommentsAsReadArgs = {
  task_id: Scalars['String'];
  user_id: Scalars['String'];
};


export type MutationReassignTaskArgs = {
  id?: Maybe<Scalars['id']>;
  resource: TaskManager_Input;
};


export type MutationTasksMessagesCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: TasksMessages_Input;
};


export type MutationTasksMessagesUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: TasksMessages_Input;
};


export type MutationTasksMessagesRemoveArgs = {
  id: Scalars['id'];
};


export type MutationValueSetCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: ValueSet_Input;
};


export type MutationValueSetUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: ValueSet_Input;
};


export type MutationValueSetRemoveArgs = {
  id: Scalars['id'];
};


export type MutationWebContactCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: WebContact_Input;
};


export type MutationWebContactUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: WebContact_Input;
};


export type MutationWebContactRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPatientInvoiceCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientInvoices_Input;
};


export type MutationPatientInvoiceUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientInvoices_Input;
};


export type MutationPatientInvoiceRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsInvoiceBillingCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsBillingInvoice_Input;
};


export type MutationPomsInvoiceBillingUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsBillingInvoice_Input;
};


export type MutationPomsInvoiceBillingRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPractitionerStatementCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerStatement_Input;
};


export type MutationPractitionerStatementUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerStatement_Input;
};


export type MutationPractitionerStatementRemoveArgs = {
  id: Scalars['id'];
};


export type MutationRolePermissionCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: RolesPermission_Input;
};


export type MutationRolePermissionUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: RolesPermission_Input;
};


export type MutationRolePermissionRemoveArgs = {
  id: Scalars['id'];
};


export type MutationUserCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationUserUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationUserRemoveArgs = {
  id: Scalars['id'];
};


export type MutationClinicianBasicSignUpArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationConfirmUserArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationCreateClinicianFromAdminArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationCreateOrganizationUserArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationCreatePractitionerFromAdminArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationForgotPasswordArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationGetBasicSignedPractitionerListArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationUserLoginArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationUserRegistrationArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationResetPasswordArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationResendConfirmationArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationUpdatePasswordArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationCreateAdminArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationCreateLinkedUserArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationRefreshTokenArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationUpdateAdminProfileArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationPasswordSyncArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationUserGuestRegistrationArgs = {
  id?: Maybe<Scalars['id']>;
  resource: User_Input;
};


export type MutationPatientContactCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: WebContact_Input;
};


export type MutationCrisisSafeguardCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: CrisisSafeguard_Input;
};


export type MutationCrisisSafeguardUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: CrisisSafeguard_Input;
};


export type MutationCrisisSafeguardvRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPatientCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Patient_Input;
};


export type MutationPatientUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Patient_Input;
};


export type MutationPatientDisorderUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Patient_Input;
};


export type MutationPatientBlockUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Patient_Input;
};


export type MutationPatientRemoveArgs = {
  id: Scalars['id'];
};


export type MutationShareDocumentArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Patient_Documents_Input;
};


export type MutationPatientFinancialInfoCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientFinancialInfo_Input;
};


export type MutationPatientFinancialInfoUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientFinancialInfo_Input;
};


export type MutationPatientFinancialInfoRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPatientNotificationCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientNotifications_Input;
};


export type MutationPatientNotificationUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientNotifications_Input;
};


export type MutationPatientNotificationRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPatientPrescriptionCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientPrescriptionDocument_Input;
};


export type MutationPatientPrescriptionUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientPrescriptionDocument_Input;
};


export type MutationPatientPrescriptionRemoveArgs = {
  id: Scalars['id'];
};


export type MutationExternalPatientQuestionnaireCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: ExternalPatientQuestionnaire_Input;
};


export type MutationExternalPatientQuestionnaireUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: ExternalPatientQuestionnaire_Input;
};


export type MutationPatientQuestionnaireCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientQuestionnaire_Input;
};


export type MutationPatientQuestionnaireUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientQuestionnaire_Input;
};


export type MutationPatientQuestionnaireRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPatientRecordsLogCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientRecordsLog_Input;
};


export type MutationPatientRecordsLogUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientRecordsLog_Input;
};


export type MutationPatientRecordsLogRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPatientTaskCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientTask_Input;
};


export type MutationPatientTaskUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PatientTask_Input;
};


export type MutationPatientToDoTaskUpdateArgs = {
  id?: Maybe<Scalars['id']>;
};


export type MutationPatientTaskRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsPatientActivityCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPatientActivity_Input;
};


export type MutationPomsPatientActivityUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPatientActivity_Input;
};


export type MutationPomsPatientActivityRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsPatientDocumentCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPatientDocuments_Input;
};


export type MutationPomsPatientDocumentUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPatientDocuments_Input;
};


export type MutationPomsPatientDocumentRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsPatientLetterCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPatientLetter_Input;
};


export type MutationPomsPatientLetterUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPatientLetter_Input;
};


export type MutationPomsPatientLettervRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsPatientPreferenceCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPatientPreferences_Input;
};


export type MutationPomsPatientPreferenceUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPatientPreferences_Input;
};


export type MutationPomsPatientPreferenceRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsPatientPrivacyCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPatientPrivacy_Input;
};


export type MutationPomsPatientPrivacyUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPatientPrivacy_Input;
};


export type MutationPomsPatientPrivacyRemoveArgs = {
  id: Scalars['id'];
};


export type MutationSignPostingCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: SignPosting_Input;
};


export type MutationLeafletCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Leaflet_Input;
};


export type MutationSignPostingUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: SignPosting_Input;
};


export type MutationLeafletUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Leaflet_Input;
};


export type MutationSignPostingRemoveArgs = {
  id: Scalars['id'];
};


export type MutationLeafletRemoveArgs = {
  id: Scalars['id'];
};


export type MutationSignPostingCategoryCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: SignPostingCategory_Input;
};


export type MutationSignPostingCategoryUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: SignPostingCategory_Input;
};


export type MutationSignPostingCategoryRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPractitionerContactCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: WebContact_Input;
};


export type MutationDocumentReferenceCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: DocumentReference_Input;
};


export type MutationDocumentReferenceUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: DocumentReference_Input;
};


export type MutationDocumentReferenceRemoveArgs = {
  id: Scalars['id'];
};


export type MutationLocationCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Location_Input;
};


export type MutationLocationUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Location_Input;
};


export type MutationLocationRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsPractitionerActivityCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerActivity_Input;
};


export type MutationPomsPractitionerActivityUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerActivity_Input;
};


export type MutationPomsPractitionerActivityRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsPractitionerAgreementCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerAgreements_Input;
};


export type MutationPomsPractitionerAgreementUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerAgreements_Input;
};


export type MutationPomsPractitionerContractFileArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerAgreements_Input;
};


export type MutationPomsPractitionerAgreementRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsPractitionerPreferenceCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerPreferences_Input;
};


export type MutationPomsPractitionerPreferenceUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerPreferences_Input;
};


export type MutationPomsPractitionerPreferenceRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsPractitionerPrivacyCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerPrivacy_Input;
};


export type MutationPomsPractitionerPrivacyUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerPrivacy_Input;
};


export type MutationPomsPractitionertPrivacyRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPractitionerCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Practitioner_Input;
};


export type MutationPractitionerUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Practitioner_Input;
};


export type MutationPractitionerWebUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Practitioner_Input;
};


export type MutationPractitionerRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPractitionerNotificationCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerNotifications_Input;
};


export type MutationPractitionerNotificationUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerNotifications_Input;
};


export type MutationPractitionerNotificationRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPractitionerRoleCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerRole_Input;
};


export type MutationPractitionerRoleUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerRole_Input;
};


export type MutationPractitionerRoleRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPractitionerTaskCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerTask_Input;
};


export type MutationPractitionerTaskUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerTask_Input;
};


export type MutationPractitionerTaskRemoveArgs = {
  id: Scalars['id'];
};


export type MutationProcedureCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Procedure_Input;
};


export type MutationProcedureUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Procedure_Input;
};


export type MutationProcedureRemoveArgs = {
  id: Scalars['id'];
};


export type MutationProvenanceCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Provenance_Input;
};


export type MutationProvenanceUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Provenance_Input;
};


export type MutationProvenanceRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPractitionerPatientCommunicationCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerPatientCommunication_Input;
};


export type MutationPractitionerPatientCommunicationUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerPatientCommunication_Input;
};


export type MutationUpdateCommunicationReadStatusArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PractitionerPatientCommunication_Input;
};


export type MutationPractitionerPatientCommunicationRemoveArgs = {
  id: Scalars['id'];
};


export type MutationFeedBackCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: FeedBack_Input;
};


export type MutationFeedBackUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: FeedBack_Input;
};


export type MutationFeedBackRemoveArgs = {
  id: Scalars['id'];
};


export type MutationDisorderImportArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Disorder_Input;
};


export type MutationDisorderCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Disorder_Input;
};


export type MutationDisorderUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Disorder_Input;
};


export type MutationDisorderRemoveArgs = {
  id: Scalars['id'];
};


export type MutationOtherAppointmentCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OtherAppointment_Input;
};


export type MutationOtherAppointmentUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: OtherAppointment_Input;
};


export type MutationPomsAppointmentCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsAppointment_Input;
};


export type MutationPomsAppointmentUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsAppointment_Input;
};


export type MutationPomsAppointmentRemoveArgs = {
  id: Scalars['id'];
};


export type MutationPomsAppointmentGetPaymentMutationArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsAppointment_Input;
};


export type MutationPomsAppointmentSetUpPaymentIntentMutationArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsAppointment_Input;
};


export type MutationPomsAppointmentBlockSlotMutationArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsAppointment_Input;
};


export type MutationPomsAppointmentBookSlotMutationArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsAppointment_Input;
};


export type MutationAppointmentInProgressNotificationArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsAppointment_Input;
};


export type MutationPomsSlotCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerSchedule_Input;
};


export type MutationPomsPractitionerScheduleCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerSchedule_Input;
};


export type MutationPomsPractitionerScheduleUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: PomsPractitionerSchedule_Input;
};


export type MutationPomsPractitionerScheduleRemoveArgs = {
  id: Scalars['id'];
};


export type MutationReminderCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Reminder_Input;
};


export type MutationReminderUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Reminder_Input;
};


export type MutationReminderRemoveArgs = {
  id: Scalars['id'];
};


export type MutationScheduleCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Schedule_Input;
};


export type MutationScheduleUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Schedule_Input;
};


export type MutationScheduleRemoveArgs = {
  id: Scalars['id'];
};


export type MutationSlotCreateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Slot_Input;
};


export type MutationSlotUpdateArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Slot_Input;
};


export type MutationSlotRemoveArgs = {
  id: Scalars['id'];
  slotIds?: Maybe<Array<Maybe<Scalars['id']>>>;
  slotDate?: Maybe<Scalars['String']>;
  deleteType?: Maybe<Scalars['String']>;
};


export type MutationStripePaymentSecretArgs = {
  id?: Maybe<Scalars['id']>;
  resource: Stripe_Payment_Input;
};

/**
 * A curated namespace that issues unique symbols within that namespace for the
 * identification of concepts, people, devices, etc.  Represents a 'System' used
 * within the Identifier and Coding data types.
 */
export type NamingSystem = {
  __typename?: 'NamingSystem';
  /** Type of resource */
  resourceType: NamingSystem_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * A natural language name identifying the naming system. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the naming system. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name: Scalars['String'];
  /** The status of this naming system. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this naming system. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /** Indicates the purpose for the naming system - what kinds of things does it make unique? */
  _kind?: Maybe<Element>;
  /** Indicates the purpose for the naming system - what kinds of things does it make unique? */
  kind: Scalars['code'];
  /**
   * The date  (and optionally time) when the naming system was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the naming system changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the naming system was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the naming system changes.
   */
  date: Scalars['dateTime'];
  /** The name of the organization or individual that published the naming system. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the naming system. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /**
   * The name of the organization that is responsible for issuing identifiers or
   * codes for this namespace and ensuring their non-collision.
   */
  _responsible?: Maybe<Element>;
  /**
   * The name of the organization that is responsible for issuing identifiers or
   * codes for this namespace and ensuring their non-collision.
   */
  responsible?: Maybe<Scalars['String']>;
  /** Categorizes a naming system for easier search by grouping related naming systems. */
  type?: Maybe<CodeableConcept>;
  /**
   * A free text natural language description of the naming system from a
   * consumer's perspective. Details about what the namespace identifies including
   * scope, granularity, version labeling, etc.
   */
  _description?: Maybe<Element>;
  /**
   * A free text natural language description of the naming system from a
   * consumer's perspective. Details about what the namespace identifies including
   * scope, granularity, version labeling, etc.
   */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate naming
   * system instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the naming system is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Provides guidance on the use of the namespace, including the handling of
   * formatting characters, use of upper vs. lower case, etc.
   */
  _usage?: Maybe<Element>;
  /**
   * Provides guidance on the use of the namespace, including the handling of
   * formatting characters, use of upper vs. lower case, etc.
   */
  usage?: Maybe<Scalars['String']>;
  /** Indicates how the system may be identified when referenced in electronic exchange. */
  uniqueId?: Maybe<Array<NamingSystemuniqueId>>;
};

export enum NamingSystem_Enum_Schema {
  NamingSystem = 'NamingSystem'
}

export type NamingSystemuniqueId = {
  __typename?: 'NamingSystemuniqueId';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifies the unique identifier scheme used for this particular identifier. */
  _type?: Maybe<Element>;
  /** Identifies the unique identifier scheme used for this particular identifier. */
  type: Scalars['code'];
  /** The string that should be sent over the wire to identify the code system or identifier system. */
  _value?: Maybe<Element>;
  /** The string that should be sent over the wire to identify the code system or identifier system. */
  value: Scalars['String'];
  /** Indicates whether this identifier is the 'preferred' identifier of this type. */
  _preferred?: Maybe<Element>;
  /** Indicates whether this identifier is the 'preferred' identifier of this type. */
  preferred?: Maybe<Scalars['Boolean']>;
  /** Notes about the past or intended usage of this identifier. */
  _comment?: Maybe<Element>;
  /** Notes about the past or intended usage of this identifier. */
  comment?: Maybe<Scalars['String']>;
  /**
   * Identifies the period of time over which this identifier is considered
   * appropriate to refer to the naming system.  Outside of this window, the
   * identifier might be non-deterministic.
   */
  period?: Maybe<Period>;
};

/**
 * Base StructureDefinition for Narrative Type: A human-readable summary of the
 * resource conveying the essential clinical and business information for the resource.
 */
export type Narrative = {
  __typename?: 'Narrative';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The status of the narrative - whether it's entirely generated (from just the
   * defined data or the extensions too), or whether a human authored it and it may
   * contain additional data.
   */
  _status?: Maybe<Element>;
  /**
   * The status of the narrative - whether it's entirely generated (from just the
   * defined data or the extensions too), or whether a human authored it and it may
   * contain additional data.
   */
  status: Scalars['code'];
  /** The actual narrative content, a stripped down version of XHTML. */
  _div?: Maybe<Element>;
  /** The actual narrative content, a stripped down version of XHTML. */
  div: Scalars['xhtml'];
};

/**
 * Base StructureDefinition for Narrative Type: A human-readable summary of the
 * resource conveying the essential clinical and business information for the resource.
 */
export type Narrative_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * The status of the narrative - whether it's entirely generated (from just the
   * defined data or the extensions too), or whether a human authored it and it may
   * contain additional data.
   */
  _status?: Maybe<Element_Input>;
  /**
   * The status of the narrative - whether it's entirely generated (from just the
   * defined data or the extensions too), or whether a human authored it and it may
   * contain additional data.
   */
  status: Scalars['code'];
  /** The actual narrative content, a stripped down version of XHTML. */
  _div?: Maybe<Element_Input>;
  /** The actual narrative content, a stripped down version of XHTML. */
  div: Scalars['xhtml'];
};

/** A request to supply a diet, formula feeding (enteral) or oral nutritional supplement to a patient/resident. */
export type NutritionOrder = {
  __typename?: 'NutritionOrder';
  /** Type of resource */
  resourceType: NutritionOrder_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifiers assigned to this order by the order sender or by the order receiver. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this NutritionOrder.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this NutritionOrder.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this
   * NutritionOrder.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this
   * NutritionOrder.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /**
   * The URL pointing to a protocol, guideline, orderset or other definition that
   * is adhered to in whole or in part by this NutritionOrder.
   */
  _instantiates?: Maybe<Element>;
  /**
   * The URL pointing to a protocol, guideline, orderset or other definition that
   * is adhered to in whole or in part by this NutritionOrder.
   */
  instantiates?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** The workflow status of the nutrition order/request. */
  _status?: Maybe<Element>;
  /** The workflow status of the nutrition order/request. */
  status: Scalars['code'];
  /**
   * Indicates the level of authority/intentionality associated with the
   * NutrionOrder and where the request fits into the workflow chain.
   */
  _intent?: Maybe<Element>;
  /**
   * Indicates the level of authority/intentionality associated with the
   * NutrionOrder and where the request fits into the workflow chain.
   */
  intent: Scalars['code'];
  /**
   * The person (patient) who needs the nutrition order for an oral diet,
   * nutritional supplement and/or enteral or formula feeding.
   */
  patient: NutritionOrderpatient_Patient_Union;
  /** An encounter that provides additional information about the healthcare context in which this request is made. */
  encounter?: Maybe<NutritionOrderencounter_Encounter_Union>;
  /** The date and time that this nutrition order was requested. */
  _dateTime?: Maybe<Element>;
  /** The date and time that this nutrition order was requested. */
  dateTime: Scalars['dateTime'];
  /** The practitioner that holds legal responsibility for ordering the diet, nutritional supplement, or formula feedings. */
  orderer?: Maybe<NutritionOrderorderer_Orderer_Union>;
  /** A link to a record of allergies or intolerances  which should be included in the nutrition order. */
  allergyIntolerance?: Maybe<Array<Maybe<NutritionOrderallergyIntolerance_AllergyIntolerance_Union>>>;
  /**
   * This modifier is used to convey order-specific modifiers about the type of
   * food that should be given. These can be derived from patient allergies,
   * intolerances, or preferences such as Halal, Vegan or Kosher. This modifier
   * applies to the entire nutrition order inclusive of the oral diet, nutritional
   * supplements and enteral formula feedings.
   */
  foodPreferenceModifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * This modifier is used to convey Order-specific modifier about the type of oral
   * food or oral fluids that should not be given. These can be derived from
   * patient allergies, intolerances, or preferences such as No Red Meat, No Soy or
   * No Wheat or  Gluten-Free.  While it should not be necessary to repeat allergy
   * or intolerance information captured in the referenced AllergyIntolerance
   * resource in the excludeFoodModifier, this element may be used to convey
   * additional specificity related to foods that should be eliminated from the
   * patient’s diet for any reason.  This modifier applies to the entire nutrition
   * order inclusive of the oral diet, nutritional supplements and enteral formula feedings.
   */
  excludeFoodModifier?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Diet given orally in contrast to enteral (tube) feeding. */
  oralDiet?: Maybe<NutritionOrderoralDiet>;
  /** Oral nutritional products given in order to add further nutritional value to the patient's diet. */
  supplement?: Maybe<Array<Maybe<NutritionOrdersupplement>>>;
  /**
   * Feeding provided through the gastrointestinal tract via a tube, catheter, or
   * stoma that delivers nutrition distal to the oral cavity.
   */
  enteralFormula?: Maybe<NutritionOrderenteralFormula>;
  /** Comments made about the {{title}} by the requester, performer, subject or other participants. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export enum NutritionOrder_Enum_Schema {
  NutritionOrder = 'NutritionOrder'
}

/** A link to a record of allergies or intolerances  which should be included in the nutrition order. */
export type NutritionOrderallergyIntolerance_AllergyIntolerance_Union = AllergyIntolerance;

/** An encounter that provides additional information about the healthcare context in which this request is made. */
export type NutritionOrderencounter_Encounter_Union = Encounter;

export type NutritionOrderenteralFormula = {
  __typename?: 'NutritionOrderenteralFormula';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of enteral or infant formula such as an adult standard formula with fiber or a soy-based infant formula. */
  baseFormulaType?: Maybe<CodeableConcept>;
  /** The product or brand name of the enteral or infant formula product such as 'ACME Adult Standard Formula'. */
  _baseFormulaProductName?: Maybe<Element>;
  /** The product or brand name of the enteral or infant formula product such as 'ACME Adult Standard Formula'. */
  baseFormulaProductName?: Maybe<Scalars['String']>;
  /**
   * Indicates the type of modular component such as protein, carbohydrate, fat or
   * fiber to be provided in addition to or mixed with the base formula.
   */
  additiveType?: Maybe<CodeableConcept>;
  /** The product or brand name of the type of modular component to be added to the formula. */
  _additiveProductName?: Maybe<Element>;
  /** The product or brand name of the type of modular component to be added to the formula. */
  additiveProductName?: Maybe<Scalars['String']>;
  /**
   * The amount of energy (calories) that the formula should provide per specified
   * volume, typically per mL or fluid oz.  For example, an infant may require a
   * formula that provides 24 calories per fluid ounce or an adult may require an
   * enteral formula that provides 1.5 calorie/mL.
   */
  caloricDensity?: Maybe<Quantity>;
  /**
   * The route or physiological path of administration into the patient's
   * gastrointestinal  tract for purposes of providing the formula feeding, e.g.
   * nasogastric tube.
   */
  routeofAdministration?: Maybe<CodeableConcept>;
  /**
   * Formula administration instructions as structured data.  This repeating
   * structure allows for changing the administration rate or volume over time for
   * both bolus and continuous feeding.  An example of this would be an instruction
   * to increase the rate of continuous feeding every 2 hours.
   */
  administration?: Maybe<Array<Maybe<NutritionOrderenteralFormulaadministration>>>;
  /**
   * The maximum total quantity of formula that may be administered to a subject
   * over the period of time, e.g. 1440 mL over 24 hours.
   */
  maxVolumeToDeliver?: Maybe<Quantity>;
  /** Free text formula administration, feeding instructions or additional instructions or information. */
  _administrationInstruction?: Maybe<Element>;
  /** Free text formula administration, feeding instructions or additional instructions or information. */
  administrationInstruction?: Maybe<Scalars['String']>;
};

export type NutritionOrderenteralFormulaadministration = {
  __typename?: 'NutritionOrderenteralFormulaadministration';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The time period and frequency at which the enteral formula should be delivered to the patient. */
  schedule?: Maybe<Timing>;
  /** The volume of formula to provide to the patient per the specified administration schedule. */
  quantity?: Maybe<Quantity>;
  /** The rate of administration of formula via a feeding pump, e.g. 60 mL per hour, according to the specified schedule. */
  rateQuantity?: Maybe<Quantity>;
  /** The rate of administration of formula via a feeding pump, e.g. 60 mL per hour, according to the specified schedule. */
  rateRatio?: Maybe<Ratio>;
};

export type NutritionOrderoralDiet = {
  __typename?: 'NutritionOrderoralDiet';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The kind of diet or dietary restriction such as fiber restricted diet or diabetic diet. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * The time period and frequency at which the diet should be given.  The diet
   * should be given for the combination of all schedules if more than one schedule is present.
   */
  schedule?: Maybe<Array<Maybe<Timing>>>;
  /**
   * Class that defines the quantity and type of nutrient modifications (for
   * example carbohydrate, fiber or sodium) required for the oral diet.
   */
  nutrient?: Maybe<Array<Maybe<NutritionOrderoralDietnutrient>>>;
  /** Class that describes any texture modifications required for the patient to safely consume various types of solid foods. */
  texture?: Maybe<Array<Maybe<NutritionOrderoralDiettexture>>>;
  /** The required consistency (e.g. honey-thick, nectar-thick, thin, thickened.) of liquids or fluids served to the patient. */
  fluidConsistencyType?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Free text or additional instructions or information pertaining to the oral diet. */
  _instruction?: Maybe<Element>;
  /** Free text or additional instructions or information pertaining to the oral diet. */
  instruction?: Maybe<Scalars['String']>;
};

export type NutritionOrderoralDietnutrient = {
  __typename?: 'NutritionOrderoralDietnutrient';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The nutrient that is being modified such as carbohydrate or sodium. */
  modifier?: Maybe<CodeableConcept>;
  /** The quantity of the specified nutrient to include in diet. */
  amount?: Maybe<Quantity>;
};

export type NutritionOrderoralDiettexture = {
  __typename?: 'NutritionOrderoralDiettexture';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Any texture modifications (for solid foods) that should be made, e.g. easy to chew, chopped, ground, and pureed. */
  modifier?: Maybe<CodeableConcept>;
  /** The food type(s) (e.g. meats, all foods)  that the texture modification applies to.  This could be all foods types. */
  foodType?: Maybe<CodeableConcept>;
};

/** The practitioner that holds legal responsibility for ordering the diet, nutritional supplement, or formula feedings. */
export type NutritionOrderorderer_Orderer_Union = Practitioner | PractitionerRole;

/**
 * The person (patient) who needs the nutrition order for an oral diet, nutritional
 * supplement and/or enteral or formula feeding.
 */
export type NutritionOrderpatient_Patient_Union = Patient;

export type NutritionOrdersupplement = {
  __typename?: 'NutritionOrdersupplement';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The kind of nutritional supplement product required such as a high protein or pediatric clear liquid supplement. */
  type?: Maybe<CodeableConcept>;
  /** The product or brand name of the nutritional supplement such as 'Acme Protein Shake'. */
  _productName?: Maybe<Element>;
  /** The product or brand name of the nutritional supplement such as 'Acme Protein Shake'. */
  productName?: Maybe<Scalars['String']>;
  /**
   * The time period and frequency at which the supplement(s) should be given.  The
   * supplement should be given for the combination of all schedules if more than
   * one schedule is present.
   */
  schedule?: Maybe<Array<Maybe<Timing>>>;
  /** The amount of the nutritional supplement to be given. */
  quantity?: Maybe<Quantity>;
  /** Free text or additional instructions or information pertaining to the oral supplement. */
  _instruction?: Maybe<Element>;
  /** Free text or additional instructions or information pertaining to the oral supplement. */
  instruction?: Maybe<Scalars['String']>;
};

/** Measurements and simple assertions made about a patient, device or other subject. */
export type Observation = {
  __typename?: 'Observation';
  /** Type of resource */
  resourceType: Observation_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this observation. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * A plan, proposal or order that is fulfilled in whole or in part by this event.
   *  For example, a MedicationRequest may require a patient to have laboratory
   * test performed before  it is dispensed.
   */
  basedOn?: Maybe<Array<Maybe<ObservationbasedOn_BasedOn_Union>>>;
  /**
   * A larger event of which this particular Observation is a component or step.
   * For example,  an observation as part of a procedure.
   */
  partOf?: Maybe<Array<Maybe<ObservationpartOf_PartOf_Union>>>;
  /** The status of the result value. */
  _status?: Maybe<Element>;
  /** The status of the result value. */
  status: Scalars['code'];
  /** A code that classifies the general type of observation being made. */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Describes what was observed. Sometimes this is called the observation 'name'. */
  code: CodeableConcept;
  /**
   * The patient, or group of patients, location, or device this observation is
   * about and into whose record the observation is placed. If the actual focus of
   * the observation is different from the subject (or a sample of, part, or region
   * of the subject), the `focus` element or the `code` itself specifies the actual
   * focus of the observation.
   */
  subject?: Maybe<Observationsubject_Subject_Union>;
  /**
   * The actual focus of an observation when it is not the patient of record
   * representing something or someone associated with the patient such as a
   * spouse, parent, fetus, or donor. For example, fetus observations in a mother's
   * record.  The focus of an observation could also be an existing condition,  an
   * intervention, the subject's diet,  another observation of the subject,  or a
   * body structure such as tumor or implanted device.   An example use case would
   * be using the Observation resource to capture whether the mother is trained to
   * change her child's tracheostomy tube. In this example, the child is the
   * patient of record and the mother is the focus.
   */
  focus?: Maybe<Array<Maybe<Observationfocus_Focus_Union>>>;
  /** The healthcare event  (e.g. a patient and healthcare provider interaction) during which this observation is made. */
  encounter?: Maybe<Observationencounter_Encounter_Union>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  _effectiveDateTime?: Maybe<Element>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  effectiveDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  effectivePeriod?: Maybe<Period>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  effectiveTiming?: Maybe<Timing>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  _effectiveInstant?: Maybe<Element>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  effectiveInstant?: Maybe<Scalars['instant']>;
  /**
   * The date and time this version of the observation was made available to
   * providers, typically after the results have been reviewed and verified.
   */
  _issued?: Maybe<Element>;
  /**
   * The date and time this version of the observation was made available to
   * providers, typically after the results have been reviewed and verified.
   */
  issued?: Maybe<Scalars['instant']>;
  /** Who was responsible for asserting the observed value as 'true'. */
  performer?: Maybe<Array<Maybe<Observationperformer_Performer_Union>>>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueQuantity?: Maybe<Quantity>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueString?: Maybe<Element>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueString?: Maybe<Scalars['String']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueBoolean?: Maybe<Element>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueInteger?: Maybe<Element>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueRange?: Maybe<Range>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueRatio?: Maybe<Ratio>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueSampledData?: Maybe<SampledData>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueTime?: Maybe<Element>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueTime?: Maybe<Scalars['time']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueDateTime?: Maybe<Element>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueDateTime?: Maybe<Scalars['dateTime']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valuePeriod?: Maybe<Period>;
  /** Provides a reason why the expected value in the element Observation.value[x] is missing. */
  dataAbsentReason?: Maybe<CodeableConcept>;
  /** A categorical assessment of an observation value.  For example, high, low, normal. */
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Comments about the observation or the results. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Indicates the site on the subject's body where the observation was made (i.e. the target site). */
  bodySite?: Maybe<CodeableConcept>;
  /** Indicates the mechanism used to perform the observation. */
  method?: Maybe<CodeableConcept>;
  /** The specimen that was used when this observation was made. */
  specimen?: Maybe<Observationspecimen_Specimen_Union>;
  /** The device used to generate the observation data. */
  device?: Maybe<Observationdevice_Device_Union>;
  /**
   * Guidance on how to interpret the value by comparison to a normal or
   * recommended range.  Multiple reference ranges are interpreted as an 'OR'.   In
   * other words, to represent two distinct target populations, two
   * `referenceRange` elements would be used.
   */
  referenceRange?: Maybe<Array<Maybe<ObservationreferenceRange>>>;
  /**
   * This observation is a group observation (e.g. a battery, a panel of tests, a
   * set of vital sign measurements) that includes the target as a member of the group.
   */
  hasMember?: Maybe<Array<Maybe<ObservationhasMember_HasMember_Union>>>;
  /**
   * The target resource that represents a measurement from which this observation
   * value is derived. For example, a calculated anion gap or a fetal measurement
   * based on an ultrasound image.
   */
  derivedFrom?: Maybe<Array<Maybe<ObservationderivedFrom_DerivedFrom_Union>>>;
  /**
   * Some observations have multiple component observations.  These component
   * observations are expressed as separate code value pairs that share the same
   * attributes.  Examples include systolic and diastolic component observations
   * for blood pressure measurement and multiple component observations for
   * genetics observations.
   */
  component?: Maybe<Array<Maybe<Observationcomponent>>>;
};

/**
 * Set of definitional characteristics for a kind of observation or measurement
 * produced or consumed by an orderable health care service.
 */
export type ObservationDefinition = {
  __typename?: 'ObservationDefinition';
  /** Type of resource */
  resourceType: ObservationDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A code that classifies the general type of observation. */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Describes what will be observed. Sometimes this is called the observation 'name'. */
  code: CodeableConcept;
  /** A unique identifier assigned to this ObservationDefinition artifact. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The data types allowed for the value element of the instance observations conforming to this ObservationDefinition. */
  _permittedDataType?: Maybe<Element>;
  /** The data types allowed for the value element of the instance observations conforming to this ObservationDefinition. */
  permittedDataType?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** Multiple results allowed for observations conforming to this ObservationDefinition. */
  _multipleResultsAllowed?: Maybe<Element>;
  /** Multiple results allowed for observations conforming to this ObservationDefinition. */
  multipleResultsAllowed?: Maybe<Scalars['Boolean']>;
  /** The method or technique used to perform the observation. */
  method?: Maybe<CodeableConcept>;
  /** The preferred name to be used when reporting the results of observations conforming to this ObservationDefinition. */
  _preferredReportName?: Maybe<Element>;
  /** The preferred name to be used when reporting the results of observations conforming to this ObservationDefinition. */
  preferredReportName?: Maybe<Scalars['String']>;
  /** Characteristics for quantitative results of this observation. */
  quantitativeDetails?: Maybe<ObservationDefinitionquantitativeDetails>;
  /**
   * Multiple  ranges of results qualified by different contexts for ordinal or
   * continuous observations conforming to this ObservationDefinition.
   */
  qualifiedInterval?: Maybe<Array<Maybe<ObservationDefinitionqualifiedInterval>>>;
  /** The set of valid coded results for the observations  conforming to this ObservationDefinition. */
  validCodedValueSet?: Maybe<ObservationDefinitionvalidCodedValueSet_ValidCodedValueSet_Union>;
  /** The set of normal coded results for the observations conforming to this ObservationDefinition. */
  normalCodedValueSet?: Maybe<ObservationDefinitionnormalCodedValueSet_NormalCodedValueSet_Union>;
  /** The set of abnormal coded results for the observation conforming to this ObservationDefinition. */
  abnormalCodedValueSet?: Maybe<ObservationDefinitionabnormalCodedValueSet_AbnormalCodedValueSet_Union>;
  /** The set of critical coded results for the observation conforming to this ObservationDefinition. */
  criticalCodedValueSet?: Maybe<ObservationDefinitioncriticalCodedValueSet_CriticalCodedValueSet_Union>;
};

export enum ObservationDefinition_Enum_Schema {
  ObservationDefinition = 'ObservationDefinition'
}

/** The set of abnormal coded results for the observation conforming to this ObservationDefinition. */
export type ObservationDefinitionabnormalCodedValueSet_AbnormalCodedValueSet_Union = ValueSet;

/** The set of critical coded results for the observation conforming to this ObservationDefinition. */
export type ObservationDefinitioncriticalCodedValueSet_CriticalCodedValueSet_Union = ValueSet;

/** The set of normal coded results for the observations conforming to this ObservationDefinition. */
export type ObservationDefinitionnormalCodedValueSet_NormalCodedValueSet_Union = ValueSet;

export type ObservationDefinitionqualifiedInterval = {
  __typename?: 'ObservationDefinitionqualifiedInterval';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The category of interval of values for continuous or ordinal observations conforming to this ObservationDefinition. */
  _category?: Maybe<Element>;
  /** The category of interval of values for continuous or ordinal observations conforming to this ObservationDefinition. */
  category?: Maybe<Scalars['code']>;
  /** The low and high values determining the interval. There may be only one of the two. */
  range?: Maybe<Range>;
  /** Codes to indicate the health context the range applies to. For example, the normal or therapeutic range. */
  context?: Maybe<CodeableConcept>;
  /** Codes to indicate the target population this reference range applies to. */
  appliesTo?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Sex of the population the range applies to. */
  _gender?: Maybe<Element>;
  /** Sex of the population the range applies to. */
  gender?: Maybe<Scalars['code']>;
  /**
   * The age at which this reference range is applicable. This is a neonatal age
   * (e.g. number of weeks at term) if the meaning says so.
   */
  age?: Maybe<Range>;
  /** The gestational age to which this reference range is applicable, in the context of pregnancy. */
  gestationalAge?: Maybe<Range>;
  /** Text based condition for which the reference range is valid. */
  _condition?: Maybe<Element>;
  /** Text based condition for which the reference range is valid. */
  condition?: Maybe<Scalars['String']>;
};

export type ObservationDefinitionquantitativeDetails = {
  __typename?: 'ObservationDefinitionquantitativeDetails';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Customary unit used to report quantitative results of observations conforming to this ObservationDefinition. */
  customaryUnit?: Maybe<CodeableConcept>;
  /** SI unit used to report quantitative results of observations conforming to this ObservationDefinition. */
  unit?: Maybe<CodeableConcept>;
  /** Factor for converting value expressed with SI unit to value expressed with customary unit. */
  _conversionFactor?: Maybe<Element>;
  /** Factor for converting value expressed with SI unit to value expressed with customary unit. */
  conversionFactor?: Maybe<Scalars['Float']>;
  /** Number of digits after decimal separator when the results of such observations are of type Quantity. */
  _decimalPrecision?: Maybe<Element>;
  /** Number of digits after decimal separator when the results of such observations are of type Quantity. */
  decimalPrecision?: Maybe<Scalars['Int']>;
};

/** The set of valid coded results for the observations  conforming to this ObservationDefinition. */
export type ObservationDefinitionvalidCodedValueSet_ValidCodedValueSet_Union = ValueSet;

export enum Observation_Enum_Input {
  Observation = 'Observation'
}

export enum Observation_Enum_Schema {
  Observation = 'Observation'
}

/** Measurements and simple assertions made about a patient, device or other subject. */
export type Observation_Input = {
  /** Type of resource */
  resourceType: Observation_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A unique identifier assigned to this observation. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /**
   * A plan, proposal or order that is fulfilled in whole or in part by this event.
   *  For example, a MedicationRequest may require a patient to have laboratory
   * test performed before  it is dispensed.
   */
  basedOn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A larger event of which this particular Observation is a component or step.
   * For example,  an observation as part of a procedure.
   */
  partOf?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The status of the result value. */
  _status?: Maybe<Element_Input>;
  /** The status of the result value. */
  status: Scalars['code'];
  /** A code that classifies the general type of observation being made. */
  category?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Describes what was observed. Sometimes this is called the observation 'name'. */
  code: CodeableConcept_Input;
  /**
   * The patient, or group of patients, location, or device this observation is
   * about and into whose record the observation is placed. If the actual focus of
   * the observation is different from the subject (or a sample of, part, or region
   * of the subject), the `focus` element or the `code` itself specifies the actual
   * focus of the observation.
   */
  subject?: Maybe<Scalars['String']>;
  /**
   * The actual focus of an observation when it is not the patient of record
   * representing something or someone associated with the patient such as a
   * spouse, parent, fetus, or donor. For example, fetus observations in a mother's
   * record.  The focus of an observation could also be an existing condition,  an
   * intervention, the subject's diet,  another observation of the subject,  or a
   * body structure such as tumor or implanted device.   An example use case would
   * be using the Observation resource to capture whether the mother is trained to
   * change her child's tracheostomy tube. In this example, the child is the
   * patient of record and the mother is the focus.
   */
  focus?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The healthcare event  (e.g. a patient and healthcare provider interaction) during which this observation is made. */
  encounter?: Maybe<Scalars['String']>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  _effectiveDateTime?: Maybe<Element_Input>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  effectiveDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  effectivePeriod?: Maybe<Period_Input>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  effectiveTiming?: Maybe<Timing_Input>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  _effectiveInstant?: Maybe<Element_Input>;
  /**
   * The time or time-period the observed value is asserted as being true. For
   * biological subjects - e.g. human patients - this is usually called the
   * 'physiologically relevant time'. This is usually either the time of the
   * procedure or of specimen collection, but very often the source of the
   * date/time is not known, only the date/time itself.
   */
  effectiveInstant?: Maybe<Scalars['instant']>;
  /**
   * The date and time this version of the observation was made available to
   * providers, typically after the results have been reviewed and verified.
   */
  _issued?: Maybe<Element_Input>;
  /**
   * The date and time this version of the observation was made available to
   * providers, typically after the results have been reviewed and verified.
   */
  issued?: Maybe<Scalars['instant']>;
  /** Who was responsible for asserting the observed value as 'true'. */
  performer?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueQuantity?: Maybe<Quantity_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueCodeableConcept?: Maybe<CodeableConcept_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueString?: Maybe<Element_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueString?: Maybe<Scalars['String']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueBoolean?: Maybe<Element_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueInteger?: Maybe<Element_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueRange?: Maybe<Range_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueRatio?: Maybe<Ratio_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueSampledData?: Maybe<SampledData_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueTime?: Maybe<Element_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueTime?: Maybe<Scalars['time']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueDateTime?: Maybe<Element_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueDateTime?: Maybe<Scalars['dateTime']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valuePeriod?: Maybe<Period_Input>;
  /** Provides a reason why the expected value in the element Observation.value[x] is missing. */
  dataAbsentReason?: Maybe<CodeableConcept_Input>;
  /** A categorical assessment of an observation value.  For example, high, low, normal. */
  interpretation?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Comments about the observation or the results. */
  note?: Maybe<Array<Maybe<Annotation_Input>>>;
  /** Indicates the site on the subject's body where the observation was made (i.e. the target site). */
  bodySite?: Maybe<CodeableConcept_Input>;
  /** Indicates the mechanism used to perform the observation. */
  method?: Maybe<CodeableConcept_Input>;
  /** The specimen that was used when this observation was made. */
  specimen?: Maybe<Scalars['String']>;
  /** The device used to generate the observation data. */
  device?: Maybe<Scalars['String']>;
  /**
   * Guidance on how to interpret the value by comparison to a normal or
   * recommended range.  Multiple reference ranges are interpreted as an 'OR'.   In
   * other words, to represent two distinct target populations, two
   * `referenceRange` elements would be used.
   */
  referenceRange?: Maybe<Array<Maybe<ObservationreferenceRange_Input>>>;
  /**
   * This observation is a group observation (e.g. a battery, a panel of tests, a
   * set of vital sign measurements) that includes the target as a member of the group.
   */
  hasMember?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The target resource that represents a measurement from which this observation
   * value is derived. For example, a calculated anion gap or a fetal measurement
   * based on an ultrasound image.
   */
  derivedFrom?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Some observations have multiple component observations.  These component
   * observations are expressed as separate code value pairs that share the same
   * attributes.  Examples include systolic and diastolic component observations
   * for blood pressure measurement and multiple component observations for
   * genetics observations.
   */
  component?: Maybe<Array<Maybe<Observationcomponent_Input>>>;
};

/**
 * A plan, proposal or order that is fulfilled in whole or in part by this event.
 * For example, a MedicationRequest may require a patient to have laboratory test
 * performed before  it is dispensed.
 */
export type ObservationbasedOn_BasedOn_Union = CarePlan | DeviceRequest | ImmunizationRecommendation | MedicationRequest | NutritionOrder | ServiceRequest;

export type Observationcomponent = {
  __typename?: 'Observationcomponent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Describes what was observed. Sometimes this is called the observation 'code'. */
  code: CodeableConcept;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueQuantity?: Maybe<Quantity>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueString?: Maybe<Element>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueString?: Maybe<Scalars['String']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueBoolean?: Maybe<Element>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueInteger?: Maybe<Element>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueRange?: Maybe<Range>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueRatio?: Maybe<Ratio>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueSampledData?: Maybe<SampledData>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueTime?: Maybe<Element>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueTime?: Maybe<Scalars['time']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueDateTime?: Maybe<Element>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueDateTime?: Maybe<Scalars['dateTime']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valuePeriod?: Maybe<Period>;
  /** Provides a reason why the expected value in the element Observation.component.value[x] is missing. */
  dataAbsentReason?: Maybe<CodeableConcept>;
  /** A categorical assessment of an observation value.  For example, high, low, normal. */
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
};

export type Observationcomponent_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Describes what was observed. Sometimes this is called the observation 'code'. */
  code: CodeableConcept_Input;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueQuantity?: Maybe<Quantity_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueCodeableConcept?: Maybe<CodeableConcept_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueString?: Maybe<Element_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueString?: Maybe<Scalars['String']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueBoolean?: Maybe<Element_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueInteger?: Maybe<Element_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueRange?: Maybe<Range_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueRatio?: Maybe<Ratio_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueSampledData?: Maybe<SampledData_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueTime?: Maybe<Element_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueTime?: Maybe<Scalars['time']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  _valueDateTime?: Maybe<Element_Input>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valueDateTime?: Maybe<Scalars['dateTime']>;
  /** The information determined as a result of making the observation, if the information has a simple value. */
  valuePeriod?: Maybe<Period_Input>;
  /** Provides a reason why the expected value in the element Observation.component.value[x] is missing. */
  dataAbsentReason?: Maybe<CodeableConcept_Input>;
  /** A categorical assessment of an observation value.  For example, high, low, normal. */
  interpretation?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
};

/**
 * The target resource that represents a measurement from which this observation
 * value is derived. For example, a calculated anion gap or a fetal measurement
 * based on an ultrasound image.
 */
export type ObservationderivedFrom_DerivedFrom_Union = DocumentReference | ImagingStudy | Media | QuestionnaireResponse | Observation | MolecularSequence;

/** The device used to generate the observation data. */
export type Observationdevice_Device_Union = Device | DeviceMetric;

/** The healthcare event  (e.g. a patient and healthcare provider interaction) during which this observation is made. */
export type Observationencounter_Encounter_Union = Encounter;

/**
 * The actual focus of an observation when it is not the patient of record
 * representing something or someone associated with the patient such as a spouse,
 * parent, fetus, or donor. For example, fetus observations in a mother's record.
 * The focus of an observation could also be an existing condition,  an
 * intervention, the subject's diet,  another observation of the subject,  or a
 * body structure such as tumor or implanted device.   An example use case would be
 * using the Observation resource to capture whether the mother is trained to
 * change her child's tracheostomy tube. In this example, the child is the patient
 * of record and the mother is the focus.
 */
export type Observationfocus_Focus_Union = Resource;

/**
 * This observation is a group observation (e.g. a battery, a panel of tests, a set
 * of vital sign measurements) that includes the target as a member of the group.
 */
export type ObservationhasMember_HasMember_Union = Observation | QuestionnaireResponse | MolecularSequence;

/**
 * A larger event of which this particular Observation is a component or step.  For
 * example,  an observation as part of a procedure.
 */
export type ObservationpartOf_PartOf_Union = MedicationAdministration | MedicationDispense | MedicationStatement | Procedure | Immunization | ImagingStudy;

/** Who was responsible for asserting the observed value as 'true'. */
export type Observationperformer_Performer_Union = Practitioner | PractitionerRole | Organization | CareTeam | Patient | RelatedPerson;

export type ObservationreferenceRange = {
  __typename?: 'ObservationreferenceRange';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The value of the low bound of the reference range.  The low bound of the
   * reference range endpoint is inclusive of the value (e.g.  reference range is
   * >=5 - <=9). If the low bound is omitted,  it is assumed to be meaningless
   * (e.g. reference range is <=2.3).
   */
  low?: Maybe<Quantity>;
  /**
   * The value of the high bound of the reference range.  The high bound of the
   * reference range endpoint is inclusive of the value (e.g.  reference range is
   * >=5 - <=9). If the high bound is omitted,  it is assumed to be meaningless
   * (e.g. reference range is >= 2.3).
   */
  high?: Maybe<Quantity>;
  /**
   * Codes to indicate the what part of the targeted reference population it
   * applies to. For example, the normal or therapeutic range.
   */
  type?: Maybe<CodeableConcept>;
  /**
   * Codes to indicate the target population this reference range applies to.  For
   * example, a reference range may be based on the normal population or a
   * particular sex or race.  Multiple `appliesTo`  are interpreted as an 'AND' of
   * the target populations.  For example, to represent a target population of
   * African American females, both a code of female and a code for African
   * American would be used.
   */
  appliesTo?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * The age at which this reference range is applicable. This is a neonatal age
   * (e.g. number of weeks at term) if the meaning says so.
   */
  age?: Maybe<Range>;
  /**
   * Text based reference range in an observation which may be used when a
   * quantitative range is not appropriate for an observation.  An example would be
   * a reference value of 'Negative' or a list or table of 'normals'.
   */
  _text?: Maybe<Element>;
  /**
   * Text based reference range in an observation which may be used when a
   * quantitative range is not appropriate for an observation.  An example would be
   * a reference value of 'Negative' or a list or table of 'normals'.
   */
  text?: Maybe<Scalars['String']>;
};

export type ObservationreferenceRange_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * The value of the low bound of the reference range.  The low bound of the
   * reference range endpoint is inclusive of the value (e.g.  reference range is
   * >=5 - <=9). If the low bound is omitted,  it is assumed to be meaningless
   * (e.g. reference range is <=2.3).
   */
  low?: Maybe<Quantity_Input>;
  /**
   * The value of the high bound of the reference range.  The high bound of the
   * reference range endpoint is inclusive of the value (e.g.  reference range is
   * >=5 - <=9). If the high bound is omitted,  it is assumed to be meaningless
   * (e.g. reference range is >= 2.3).
   */
  high?: Maybe<Quantity_Input>;
  /**
   * Codes to indicate the what part of the targeted reference population it
   * applies to. For example, the normal or therapeutic range.
   */
  type?: Maybe<CodeableConcept_Input>;
  /**
   * Codes to indicate the target population this reference range applies to.  For
   * example, a reference range may be based on the normal population or a
   * particular sex or race.  Multiple `appliesTo`  are interpreted as an 'AND' of
   * the target populations.  For example, to represent a target population of
   * African American females, both a code of female and a code for African
   * American would be used.
   */
  appliesTo?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /**
   * The age at which this reference range is applicable. This is a neonatal age
   * (e.g. number of weeks at term) if the meaning says so.
   */
  age?: Maybe<Range_Input>;
  /**
   * Text based reference range in an observation which may be used when a
   * quantitative range is not appropriate for an observation.  An example would be
   * a reference value of 'Negative' or a list or table of 'normals'.
   */
  _text?: Maybe<Element_Input>;
  /**
   * Text based reference range in an observation which may be used when a
   * quantitative range is not appropriate for an observation.  An example would be
   * a reference value of 'Negative' or a list or table of 'normals'.
   */
  text?: Maybe<Scalars['String']>;
};

/** The specimen that was used when this observation was made. */
export type Observationspecimen_Specimen_Union = Specimen;

/**
 * The patient, or group of patients, location, or device this observation is about
 * and into whose record the observation is placed. If the actual focus of the
 * observation is different from the subject (or a sample of, part, or region of
 * the subject), the `focus` element or the `code` itself specifies the actual
 * focus of the observation.
 */
export type Observationsubject_Subject_Union = Patient | Group | Device | Location;

/** A formal computable definition of an operation (on the RESTful interface) or a named query (using the search interaction). */
export type OperationDefinition = {
  __typename?: 'OperationDefinition';
  /** Type of resource */
  resourceType: OperationDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this operation definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this operation
   * definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the operation definition is
   * stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this operation definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this operation
   * definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the operation definition is
   * stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * The identifier that is used to identify this version of the operation
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the operation definition
   * author and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the operation
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the operation definition
   * author and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the operation definition. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the operation definition. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  name: Scalars['String'];
  /** A short, descriptive, user-friendly title for the operation definition. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the operation definition. */
  title?: Maybe<Scalars['String']>;
  /** The status of this operation definition. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this operation definition. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /** Whether this is an operation or a named query. */
  _kind?: Maybe<Element>;
  /** Whether this is an operation or a named query. */
  kind: Scalars['code'];
  /**
   * A Boolean value to indicate that this operation definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this operation definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the operation definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the operation definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the operation definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the operation definition changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the operation definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the operation definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the operation definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the operation definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate operation
   * definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the operation definition is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this operation definition is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this operation definition is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * Whether the operation affects state. Side effects such as producing audit
   * trail entries do not count as 'affecting  state'.
   */
  _affectsState?: Maybe<Element>;
  /**
   * Whether the operation affects state. Side effects such as producing audit
   * trail entries do not count as 'affecting  state'.
   */
  affectsState?: Maybe<Scalars['Boolean']>;
  /** The name used to invoke the operation. */
  _code?: Maybe<Element>;
  /** The name used to invoke the operation. */
  code: Scalars['code'];
  /** Additional information about how to use this operation or named query. */
  _comment?: Maybe<Element>;
  /** Additional information about how to use this operation or named query. */
  comment?: Maybe<Scalars['String']>;
  /** Indicates that this operation definition is a constraining profile on the base. */
  _base?: Maybe<Element>;
  /** Indicates that this operation definition is a constraining profile on the base. */
  base?: Maybe<Scalars['canonical']>;
  /** The types on which this operation can be executed. */
  _resource?: Maybe<Element>;
  /** The types on which this operation can be executed. */
  resource?: Maybe<Array<Maybe<Scalars['code']>>>;
  /**
   * Indicates whether this operation or named query can be invoked at the system
   * level (e.g. without needing to choose a resource type for the context).
   */
  _system?: Maybe<Element>;
  /**
   * Indicates whether this operation or named query can be invoked at the system
   * level (e.g. without needing to choose a resource type for the context).
   */
  system: Scalars['Boolean'];
  /**
   * Indicates whether this operation or named query can be invoked at the resource
   * type level for any given resource type level (e.g. without needing to choose a
   * specific resource id for the context).
   */
  _type?: Maybe<Element>;
  /**
   * Indicates whether this operation or named query can be invoked at the resource
   * type level for any given resource type level (e.g. without needing to choose a
   * specific resource id for the context).
   */
  type: Scalars['Boolean'];
  /** Indicates whether this operation can be invoked on a particular instance of one of the given types. */
  _instance?: Maybe<Element>;
  /** Indicates whether this operation can be invoked on a particular instance of one of the given types. */
  instance: Scalars['Boolean'];
  /**
   * Additional validation information for the in parameters - a single profile
   * that covers all the parameters. The profile is a constraint on the parameters
   * resource as a whole.
   */
  _inputProfile?: Maybe<Element>;
  /**
   * Additional validation information for the in parameters - a single profile
   * that covers all the parameters. The profile is a constraint on the parameters
   * resource as a whole.
   */
  inputProfile?: Maybe<Scalars['canonical']>;
  /**
   * Additional validation information for the out parameters - a single profile
   * that covers all the parameters. The profile is a constraint on the parameters resource.
   */
  _outputProfile?: Maybe<Element>;
  /**
   * Additional validation information for the out parameters - a single profile
   * that covers all the parameters. The profile is a constraint on the parameters resource.
   */
  outputProfile?: Maybe<Scalars['canonical']>;
  /** The parameters for the operation/query. */
  parameter?: Maybe<Array<Maybe<OperationDefinitionparameter>>>;
  /**
   * Defines an appropriate combination of parameters to use when invoking this
   * operation, to help code generators when generating overloaded parameter sets
   * for this operation.
   */
  overload?: Maybe<Array<Maybe<OperationDefinitionoverload>>>;
};

export enum OperationDefinition_Enum_Schema {
  OperationDefinition = 'OperationDefinition'
}

export type OperationDefinitionoverload = {
  __typename?: 'OperationDefinitionoverload';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Name of parameter to include in overload. */
  _parameterName?: Maybe<Element>;
  /** Name of parameter to include in overload. */
  parameterName?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Comments to go on overload. */
  _comment?: Maybe<Element>;
  /** Comments to go on overload. */
  comment?: Maybe<Scalars['String']>;
};

export type OperationDefinitionparameter = {
  __typename?: 'OperationDefinitionparameter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of used to identify the parameter. */
  _name?: Maybe<Element>;
  /** The name of used to identify the parameter. */
  name: Scalars['code'];
  /** Whether this is an input or an output parameter. */
  _use?: Maybe<Element>;
  /** Whether this is an input or an output parameter. */
  use: Scalars['code'];
  /** The minimum number of times this parameter SHALL appear in the request or response. */
  _min?: Maybe<Element>;
  /** The minimum number of times this parameter SHALL appear in the request or response. */
  min: Scalars['Int'];
  /** The maximum number of times this element is permitted to appear in the request or response. */
  _max?: Maybe<Element>;
  /** The maximum number of times this element is permitted to appear in the request or response. */
  max: Scalars['String'];
  /** Describes the meaning or use of this parameter. */
  _documentation?: Maybe<Element>;
  /** Describes the meaning or use of this parameter. */
  documentation?: Maybe<Scalars['String']>;
  /** The type for this parameter. */
  _type?: Maybe<Element>;
  /** The type for this parameter. */
  type?: Maybe<Scalars['code']>;
  /**
   * Used when the type is 'Reference' or 'canonical', and identifies a profile
   * structure or implementation Guide that applies to the target of the reference
   * this parameter refers to. If any profiles are specified, then the content must
   * conform to at least one of them. The URL can be a local reference - to a
   * contained StructureDefinition, or a reference to another StructureDefinition
   * or Implementation Guide by a canonical URL. When an implementation guide is
   * specified, the target resource SHALL conform to at least one profile defined
   * in the implementation guide.
   */
  _targetProfile?: Maybe<Element>;
  /**
   * Used when the type is 'Reference' or 'canonical', and identifies a profile
   * structure or implementation Guide that applies to the target of the reference
   * this parameter refers to. If any profiles are specified, then the content must
   * conform to at least one of them. The URL can be a local reference - to a
   * contained StructureDefinition, or a reference to another StructureDefinition
   * or Implementation Guide by a canonical URL. When an implementation guide is
   * specified, the target resource SHALL conform to at least one profile defined
   * in the implementation guide.
   */
  targetProfile?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** How the parameter is understood as a search parameter. This is only used if the parameter type is 'string'. */
  _searchType?: Maybe<Element>;
  /** How the parameter is understood as a search parameter. This is only used if the parameter type is 'string'. */
  searchType?: Maybe<Scalars['code']>;
  /** Binds to a value set if this parameter is coded (code, Coding, CodeableConcept). */
  binding?: Maybe<OperationDefinitionparameterbinding>;
  /** Identifies other resource parameters within the operation invocation that are expected to resolve to this resource. */
  referencedFrom?: Maybe<Array<Maybe<OperationDefinitionparameterreferencedFrom>>>;
};

export type OperationDefinitionparameterbinding = {
  __typename?: 'OperationDefinitionparameterbinding';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Indicates the degree of conformance expectations associated with this binding
   * - that is, the degree to which the provided value set must be adhered to in the instances.
   */
  _strength?: Maybe<Element>;
  /**
   * Indicates the degree of conformance expectations associated with this binding
   * - that is, the degree to which the provided value set must be adhered to in the instances.
   */
  strength: Scalars['code'];
  /** Points to the value set or external definition (e.g. implicit value set) that identifies the set of codes to be used. */
  _valueSet?: Maybe<Element>;
  /** Points to the value set or external definition (e.g. implicit value set) that identifies the set of codes to be used. */
  valueSet: Scalars['canonical'];
};

export type OperationDefinitionparameterreferencedFrom = {
  __typename?: 'OperationDefinitionparameterreferencedFrom';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The name of the parameter or dot-separated path of parameter names pointing to
   * the resource parameter that is expected to contain a reference to this resource.
   */
  _source?: Maybe<Element>;
  /**
   * The name of the parameter or dot-separated path of parameter names pointing to
   * the resource parameter that is expected to contain a reference to this resource.
   */
  source: Scalars['String'];
  /** The id of the element in the referencing resource that is expected to resolve to this resource. */
  _sourceId?: Maybe<Element>;
  /** The id of the element in the referencing resource that is expected to resolve to this resource. */
  sourceId?: Maybe<Scalars['String']>;
};

/** A collection of error, warning, or information messages that result from a system action. */
export type OperationOutcome = {
  __typename?: 'OperationOutcome';
  /** Type of resource */
  resourceType: OperationOutcome_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An error, warning, or information message that results from a system action. */
  issue?: Maybe<Array<OperationOutcomeissue>>;
};

export enum OperationOutcome_Enum_Schema {
  OperationOutcome = 'OperationOutcome'
}

export type OperationOutcomeissue = {
  __typename?: 'OperationOutcomeissue';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates whether the issue indicates a variation from successful processing. */
  _severity?: Maybe<Element>;
  /** Indicates whether the issue indicates a variation from successful processing. */
  severity: Scalars['code'];
  /**
   * Describes the type of the issue. The system that creates an OperationOutcome
   * SHALL choose the most applicable code from the IssueType value set, and may
   * additional provide its own code for the error in the details element.
   */
  _code?: Maybe<Element>;
  /**
   * Describes the type of the issue. The system that creates an OperationOutcome
   * SHALL choose the most applicable code from the IssueType value set, and may
   * additional provide its own code for the error in the details element.
   */
  code: Scalars['code'];
  /**
   * Additional details about the error. This may be a text description of the
   * error or a system code that identifies the error.
   */
  details?: Maybe<CodeableConcept>;
  /** Additional diagnostic information about the issue. */
  _diagnostics?: Maybe<Element>;
  /** Additional diagnostic information about the issue. */
  diagnostics?: Maybe<Scalars['String']>;
  /**
   * This element is deprecated because it is XML specific. It is replaced by
   * issue.expression, which is format independent, and simpler to parse.   For
   * resource issues, this will be a simple XPath limited to element names,
   * repetition indicators and the default child accessor that identifies one of
   * the elements in the resource that caused this issue to be raised.  For HTTP
   * errors, will be 'http.' + the parameter name.
   */
  _location?: Maybe<Element>;
  /**
   * This element is deprecated because it is XML specific. It is replaced by
   * issue.expression, which is format independent, and simpler to parse.   For
   * resource issues, this will be a simple XPath limited to element names,
   * repetition indicators and the default child accessor that identifies one of
   * the elements in the resource that caused this issue to be raised.  For HTTP
   * errors, will be 'http.' + the parameter name.
   */
  location?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A [simple subset of FHIRPath](fhirpath.html#simple) limited to element names,
   * repetition indicators and the default child accessor that identifies one of
   * the elements in the resource that caused this issue to be raised.
   */
  _expression?: Maybe<Element>;
  /**
   * A [simple subset of FHIRPath](fhirpath.html#simple) limited to element names,
   * repetition indicators and the default child accessor that identifies one of
   * the elements in the resource that caused this issue to be raised.
   */
  expression?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Organisation Activity. */
export type OrganisationActivity = {
  __typename?: 'OrganisationActivity';
  /** Type of resource */
  resourceType: OrganisationActivity_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  device?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  accessedOn?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  ipaddress?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  country?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingOrganisation?: Maybe<Scalars['String']>;
};

export enum OrganisationActivityInput_Enum_Input {
  OrganisationActivity = 'OrganisationActivity'
}

export enum OrganisationActivity_Enum {
  OrganisationActivity = 'OrganisationActivity'
}

/** Organisation Activity */
export type OrganisationActivity_Input = {
  /** Type of resource */
  resourceType: OrganisationActivityInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  device?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  accessedOn?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  ipaddress?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  country?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingOrganisation?: Maybe<Scalars['String']>;
};

/** Practitioner Agreements . */
export type OrganisationAgreements = {
  __typename?: 'OrganisationAgreements';
  /** Type of resource */
  resourceType: OrganisationAgreements_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Documents Reference. */
  documents?: Maybe<DocumentReference>;
  /** POMS Contract field data. */
  contract?: Maybe<Scalars['Int']>;
  /** Terms Of Use field data. */
  termsOfUse?: Maybe<Scalars['Int']>;
  /** POMS Hand Book field data. */
  handBook?: Maybe<Scalars['Int']>;
  /** Organisation that is the custodian of the insurance billing record. */
  managingOrganization?: Maybe<Scalars['String']>;
};

export enum OrganisationAgreements_Enum {
  OrganisationAgreement = 'OrganisationAgreement'
}

export enum OrganisationAgreements_Enum_Input {
  OrganisationAgreement = 'OrganisationAgreement'
}

/** Organisation Preferences. */
export type OrganisationPreferences = {
  __typename?: 'OrganisationPreferences';
  /** Type of resource */
  resourceType: OrganisationPreferences_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  country?: Maybe<CodeableConcept>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  language?: Maybe<CodeableConcept>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  currency?: Maybe<CodeableConcept>;
  /** Timezone Preferences. */
  timezone?: Maybe<CodeableConcept>;
  /** Practitioner that is the custodian of the Preferences. */
  managingOrganization?: Maybe<Scalars['String']>;
};

export enum OrganisationPreferencesInput_Enum_Input {
  OrganisationPreferences = 'OrganisationPreferences'
}

export enum OrganisationPreferences_Enum {
  OrganisationPreferences = 'OrganisationPreferences'
}

/** Practitioner Preferences */
export type OrganisationPreferences_Input = {
  /** Type of resource */
  resourceType: OrganisationPreferencesInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  country?: Maybe<CodeableConcept_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  language?: Maybe<CodeableConcept_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  currency?: Maybe<CodeableConcept_Input>;
  /** Timezone Preferences. */
  timezone?: Maybe<CodeableConcept_Input>;
  /** Practitioner that is the custodian of the Preferences. */
  managingOrganization?: Maybe<Scalars['String']>;
};

/** Organisation Privacy. */
export type OrganisationPrivacy = {
  __typename?: 'OrganisationPrivacy';
  /** Type of resource */
  resourceType: OrganisationPrivacy_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactSMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactEmail?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifySMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyEmail?: Maybe<Scalars['Int']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingOrganisation?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  gdprConsent?: Maybe<Scalars['Int']>;
};

export enum OrganisationPrivacyInput_Enum_Input {
  OrganisationPrivacy = 'OrganisationPrivacy'
}

export enum OrganisationPrivacy_Enum {
  OrganisationPrivacy = 'OrganisationPrivacy'
}

/** Organisation Privacy */
export type OrganisationPrivacy_Input = {
  /** Type of resource */
  resourceType: OrganisationPrivacyInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactSMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactEmail?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifySMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyEmail?: Maybe<Scalars['Int']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingOrganisation?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  gdprConsent?: Maybe<Scalars['Int']>;
};

/**
 * A formally or informally recognized grouping of people or organizations formed
 * for the purpose of achieving some form of collective action.  Includes
 * companies, institutions, corporations, departments, community groups, healthcare
 * practice groups, payer/insurer, etc.
 */
export type Organization = {
  __typename?: 'Organization';
  /** Type of resource */
  resourceType: Organization_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier for the organization that is used to identify the organization across multiple disparate systems. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Whether the organization's record is still in active use. */
  _active?: Maybe<Element>;
  /** Whether the organization's record is still in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The kind(s) of organization that this is. */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A name associated with the organization. */
  _name?: Maybe<Element>;
  /** A name associated with the organization. */
  name?: Maybe<Scalars['String']>;
  /** A list of alternate names that the organization is known as, or was known as in the past. */
  _alias?: Maybe<Element>;
  /** A list of alternate names that the organization is known as, or was known as in the past. */
  alias?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A contact detail for the organization. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** An address for the organization. */
  address?: Maybe<Array<Maybe<Address>>>;
  /** The organization of which this organization forms a part. */
  partOf?: Maybe<OrganizationpartOf_PartOf_Union>;
  /** Contact for the organization for a certain purpose. */
  contact?: Maybe<Array<Maybe<Organizationcontact>>>;
  /** Technical endpoints providing access to services operated for the organization. */
  endpoint?: Maybe<Array<Maybe<Organizationendpoint_Endpoint_Union>>>;
  /** Organization Extra  Info. */
  organizationExtension?: Maybe<OrganizationExtension_Schema>;
};

/**
 * Defines an affiliation/assotiation/relationship between 2 distinct oganizations,
 * that is not a part-of relationship/sub-division relationship.
 */
export type OrganizationAffiliation = {
  __typename?: 'OrganizationAffiliation';
  /** Type of resource */
  resourceType: OrganizationAffiliation_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Business identifiers that are specific to this role. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Whether this organization affiliation record is in active use. */
  _active?: Maybe<Element>;
  /** Whether this organization affiliation record is in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The period during which the participatingOrganization is affiliated with the primary organization. */
  period?: Maybe<Period>;
  /** Organization where the role is available (primary organization/has members). */
  organization?: Maybe<OrganizationAffiliationorganization_Organization_Union>;
  /**
   * The Participating Organization provides/performs the role(s) defined by the
   * code to the Primary Organization (e.g. providing services or is a member of).
   */
  participatingOrganization?: Maybe<OrganizationAffiliationparticipatingOrganization_ParticipatingOrganization_Union>;
  /**
   * Health insurance provider network in which the participatingOrganization
   * provides the role's services (if defined) at the indicated locations (if defined).
   */
  network?: Maybe<Array<Maybe<OrganizationAffiliationnetwork_Network_Union>>>;
  /** Definition of the role the participatingOrganization plays in the association. */
  code?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Specific specialty of the participatingOrganization in the context of the role. */
  specialty?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The location(s) at which the role occurs. */
  location?: Maybe<Array<Maybe<OrganizationAffiliationlocation_Location_Union>>>;
  /** Healthcare services provided through the role. */
  healthcareService?: Maybe<Array<Maybe<OrganizationAffiliationhealthcareService_HealthcareService_Union>>>;
  /** Contact details at the participatingOrganization relevant to this Affiliation. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** Technical endpoints providing access to services operated for this role. */
  endpoint?: Maybe<Array<Maybe<OrganizationAffiliationendpoint_Endpoint_Union>>>;
};

export enum OrganizationAffiliation_Enum_Input {
  OrganizationAffiliation = 'OrganizationAffiliation'
}

export enum OrganizationAffiliation_Enum_Schema {
  OrganizationAffiliation = 'OrganizationAffiliation'
}

/**
 * Defines an affiliation/assotiation/relationship between 2 distinct oganizations,
 * that is not a part-of relationship/sub-division relationship.
 */
export type OrganizationAffiliation_Input = {
  /** Type of resource */
  resourceType: OrganizationAffiliation_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Business identifiers that are specific to this role. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /** Whether this organization affiliation record is in active use. */
  _active?: Maybe<Element_Input>;
  /** Whether this organization affiliation record is in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The period during which the participatingOrganization is affiliated with the primary organization. */
  period?: Maybe<Period_Input>;
  /** Organization where the role is available (primary organization/has members). */
  organization?: Maybe<Scalars['String']>;
  /**
   * The Participating Organization provides/performs the role(s) defined by the
   * code to the Primary Organization (e.g. providing services or is a member of).
   */
  participatingOrganization?: Maybe<Scalars['String']>;
  /**
   * Health insurance provider network in which the participatingOrganization
   * provides the role's services (if defined) at the indicated locations (if defined).
   */
  network?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Definition of the role the participatingOrganization plays in the association. */
  code?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Specific specialty of the participatingOrganization in the context of the role. */
  specialty?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The location(s) at which the role occurs. */
  location?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Healthcare services provided through the role. */
  healthcareService?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Contact details at the participatingOrganization relevant to this Affiliation. */
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>>>;
  /** Technical endpoints providing access to services operated for this role. */
  endpoint?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Technical endpoints providing access to services operated for this role. */
export type OrganizationAffiliationendpoint_Endpoint_Union = Endpoint;

/** Healthcare services provided through the role. */
export type OrganizationAffiliationhealthcareService_HealthcareService_Union = HealthcareService;

/** The location(s) at which the role occurs. */
export type OrganizationAffiliationlocation_Location_Union = Location;

/**
 * Health insurance provider network in which the participatingOrganization
 * provides the role's services (if defined) at the indicated locations (if defined).
 */
export type OrganizationAffiliationnetwork_Network_Union = Organization;

/** Organization where the role is available (primary organization/has members). */
export type OrganizationAffiliationorganization_Organization_Union = Organization;

/**
 * The Participating Organization provides/performs the role(s) defined by the code
 * to the Primary Organization (e.g. providing services or is a member of).
 */
export type OrganizationAffiliationparticipatingOrganization_ParticipatingOrganization_Union = Organization;

/** Organisation Agreements . */
export type OrganizationAgreements_Input = {
  /** Type of resource */
  resourceType: OrganisationAgreements_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** POMS Contract field data. */
  contract?: Maybe<Scalars['Int']>;
  /** Terms Of Use field data. */
  termsOfUse?: Maybe<Scalars['Int']>;
  /** POMS Hand Book field data. */
  handBook?: Maybe<Scalars['Int']>;
  /** Practitioner that is the custodian of the insurance billing record. */
  managingOrganization?: Maybe<Scalars['String']>;
  /** Documents Reference. */
  documents?: Maybe<DocumentReference_Input>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type OrganizationEmergencyExtension_Input = {
  /** accreditationBody field data. */
  fullName?: Maybe<Scalars['String']>;
  /** accrediationNumber field data. */
  relationship?: Maybe<Scalars['String']>;
  /** accrediationNumber field data. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** accrediationNumber field data. */
  email?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Type: Custom Fields . */
export type OrganizationEmergencyExtension_Schema = {
  __typename?: 'OrganizationEmergencyExtension_Schema';
  /** accreditationBody field data. */
  fullName?: Maybe<Scalars['String']>;
  /** accrediationNumber field data. */
  relationship?: Maybe<Scalars['String']>;
  /** accrediationNumber field data. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** accrediationNumber field data. */
  email?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type OrganizationExtension_Input = {
  /** operationType. */
  operationType?: Maybe<Scalars['String']>;
  /** logoUrl field data. */
  logoUrl?: Maybe<Scalars['String']>;
  /** tradingAs field data. */
  tradingAs?: Maybe<Scalars['String']>;
  /** tradingAs field data. */
  orgDescription?: Maybe<Scalars['String']>;
  /** sector field data. */
  sector?: Maybe<Scalars['String']>;
  /** subSector field data. */
  subSector?: Maybe<Scalars['String']>;
  /** registrationNumber field data. */
  registrationNumber?: Maybe<Scalars['String']>;
  /** VATRegistrationNumber field data. */
  VATRegistrationNumber?: Maybe<Scalars['String']>;
  /** GTIN field data. */
  GTIN?: Maybe<Scalars['String']>;
  /** accreditationBody field data. */
  accreditationBody?: Maybe<Scalars['String']>;
  /** accrediationNumber field data. */
  accrediationNumber?: Maybe<Scalars['String']>;
  /** creditRiskScore field data. */
  creditRiskScore?: Maybe<Scalars['String']>;
  /** technicalRiskScore field data. */
  technicalRiskScore?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  securityRiskScore?: Maybe<Scalars['String']>;
  /** creditRiskScore field data. */
  POMSRelationship?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  sanctions?: Maybe<Scalars['String']>;
  /** technicalRiskScore field data. */
  servicesProvided?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  contractId?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  contractUpload?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  portalAccess?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  APIAccess?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  ccgValue?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  ccgName?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  healthcode?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  healthcodeIdentifier?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  providerNo?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminTitle?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminId?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminFirstName?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminMiddleName?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminSurName?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminGender?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminEmail?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminPhoneNumber?: Maybe<Scalars['String']>;
  /** description1. */
  description1?: Maybe<Scalars['String']>;
  /** description2. */
  description2?: Maybe<Scalars['String']>;
  /** Image of the patient. */
  photo?: Maybe<Array<Maybe<Attachment_Input>>>;
  /** Image of the patient. */
  regulatoryBody?: Maybe<Array<Maybe<OrganizationRegExtension_Input>>>;
  /** Contact for the organization for a certain purpose. */
  emergencyContact?: Maybe<Array<Maybe<OrganizationEmergencyExtension_Input>>>;
  /** description2. */
  mondayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  mondayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  tuesdayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  tuesdayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  wednesdayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  wednesdayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  thrusdayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  thrusdayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  fridayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  fridayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  saturdayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  saturdayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  sundayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  sundayToHours?: Maybe<Scalars['String']>;
  /** Tags. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** description2. */
  videoUrl?: Maybe<Scalars['String']>;
  /** description2. */
  contactName?: Maybe<Scalars['String']>;
  /** description2. */
  contactEmail?: Maybe<Scalars['String']>;
  /** description2. */
  contactMobile?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Type: Custom Fields . */
export type OrganizationExtension_Schema = {
  __typename?: 'OrganizationExtension_Schema';
  /** operationType. */
  operationType?: Maybe<Scalars['String']>;
  /** logoUrl field data. */
  logoUrl?: Maybe<Scalars['String']>;
  /** tradingAs field data. */
  tradingAs?: Maybe<Scalars['String']>;
  /** tradingAs field data. */
  orgDescription?: Maybe<Scalars['String']>;
  /** sector field data. */
  sector?: Maybe<Scalars['String']>;
  /** subSector field data. */
  subSector?: Maybe<Scalars['String']>;
  /** registrationNumber field data. */
  registrationNumber?: Maybe<Scalars['String']>;
  /** VATRegistrationNumber field data. */
  VATRegistrationNumber?: Maybe<Scalars['String']>;
  /** GTIN field data. */
  GTIN?: Maybe<Scalars['String']>;
  /** accreditationBody field data. */
  accreditationBody?: Maybe<Scalars['String']>;
  /** accrediationNumber field data. */
  accrediationNumber?: Maybe<Scalars['String']>;
  /** creditRiskScore field data. */
  creditRiskScore?: Maybe<Scalars['String']>;
  /** technicalRiskScore field data. */
  technicalRiskScore?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  securityRiskScore?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  sanctions?: Maybe<Scalars['String']>;
  /** creditRiskScore field data. */
  POMSRelationship?: Maybe<Scalars['String']>;
  /** technicalRiskScore field data. */
  servicesProvided?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  contractId?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  contractUpload?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  portalAccess?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  APIAccess?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  ccgValue?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  ccgName?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  healthcode?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  healthcodeIdentifier?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  providerNo?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminTitle?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminId?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminFirstName?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminMiddleName?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminSurName?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminGender?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminEmail?: Maybe<Scalars['String']>;
  /** securityRiskScore field data. */
  adminPhoneNumber?: Maybe<Scalars['String']>;
  /** description1. */
  description1?: Maybe<Scalars['String']>;
  /** description2. */
  description2?: Maybe<Scalars['String']>;
  /** Image of the patient. */
  photo?: Maybe<Array<Maybe<Attachment>>>;
  /** Image of the patient. */
  regulatoryBody?: Maybe<Array<Maybe<OrganizationRegulatoryExtension_Schema>>>;
  /** Contact for the organization for a certain purpose. */
  emergencyContact?: Maybe<Array<Maybe<OrganizationEmergencyExtension_Schema>>>;
  /** description2. */
  mondayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  mondayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  tuesdayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  tuesdayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  wednesdayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  wednesdayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  thrusdayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  thrusdayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  fridayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  fridayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  saturdayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  saturdayToHours?: Maybe<Scalars['String']>;
  /** description2. */
  sundayFromHours?: Maybe<Scalars['String']>;
  /** description2. */
  sundayToHours?: Maybe<Scalars['String']>;
  /** Tags. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** description2. */
  videoUrl?: Maybe<Scalars['String']>;
  /** description2. */
  contactName?: Maybe<Scalars['String']>;
  /** description2. */
  contactEmail?: Maybe<Scalars['String']>;
  /** description2. */
  contactMobile?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type OrganizationRegExtension_Input = {
  /** accreditationBody field data. */
  accreditationBody?: Maybe<Scalars['String']>;
  /** accrediationNumber field data. */
  accrediationNumber?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Type: Custom Fields . */
export type OrganizationRegulatoryExtension_Schema = {
  __typename?: 'OrganizationRegulatoryExtension_Schema';
  /** accreditationBody field data. */
  accreditationBody?: Maybe<Scalars['String']>;
  /** accrediationNumber field data. */
  accrediationNumber?: Maybe<Scalars['String']>;
};

export enum Organization_Enum_Input {
  Organization = 'Organization'
}

export enum Organization_Enum_Schema {
  Organization = 'Organization'
}

/**
 * A formally or informally recognized grouping of people or organizations formed
 * for the purpose of achieving some form of collective action.  Includes
 * companies, institutions, corporations, departments, community groups, healthcare
 * practice groups, payer/insurer, etc.
 */
export type Organization_Input = {
  /** Type of resource */
  resourceType: Organization_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Identifier for the organization that is used to identify the organization across multiple disparate systems. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /** Whether the organization's record is still in active use. */
  _active?: Maybe<Element_Input>;
  /** Whether the organization's record is still in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The kind(s) of organization that this is. */
  type?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** A name associated with the organization. */
  _name?: Maybe<Element_Input>;
  /** A name associated with the organization. */
  name?: Maybe<Scalars['String']>;
  /** A list of alternate names that the organization is known as, or was known as in the past. */
  _alias?: Maybe<Element_Input>;
  /** A list of alternate names that the organization is known as, or was known as in the past. */
  alias?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A contact detail for the organization. */
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>>>;
  /** An address for the organization. */
  address?: Maybe<Array<Maybe<Address_Input>>>;
  /** The organization of which this organization forms a part. */
  partOf?: Maybe<Scalars['String']>;
  /** Contact for the organization for a certain purpose. */
  contact?: Maybe<Array<Maybe<Organizationcontact_Input>>>;
  /** Technical endpoints providing access to services operated for the organization. */
  endpoint?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Organization Extra  Info. */
  organizationExtension?: Maybe<OrganizationExtension_Input>;
};

export type Organizationcontact = {
  __typename?: 'Organizationcontact';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates a purpose for which the contact can be reached. */
  purpose?: Maybe<CodeableConcept>;
  /** A name associated with the contact. */
  name?: Maybe<HumanName>;
  /** A contact detail (e.g. a telephone number or an email address) by which the party may be contacted. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** Visiting or postal addresses for the contact. */
  address1?: Maybe<Address>;
  /** A name associated with the organization. */
  address?: Maybe<Scalars['String']>;
  /** A name associated with the organization. */
  rolename?: Maybe<Scalars['String']>;
  /** A name associated with the organization. */
  permission?: Maybe<Scalars['String']>;
};

export type Organizationcontact_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Indicates a purpose for which the contact can be reached. */
  purpose?: Maybe<CodeableConcept_Input>;
  /** A name associated with the contact. */
  name?: Maybe<HumanName_Input>;
  /** A contact detail (e.g. a telephone number or an email address) by which the party may be contacted. */
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>>>;
  /** Visiting or postal addresses for the contact. */
  address1?: Maybe<Address_Input>;
  /** A name associated with the organization. */
  address?: Maybe<Scalars['String']>;
  /** A name associated with the organization. */
  rolename?: Maybe<Scalars['String']>;
  /** A name associated with the organization. */
  permission?: Maybe<Scalars['String']>;
};

/** Technical endpoints providing access to services operated for the organization. */
export type Organizationendpoint_Endpoint_Union = Endpoint;

/** The organization of which this organization forms a part. */
export type OrganizationpartOf_PartOf_Union = Organization;

/** OtherAppointment_Schema. */
export type OtherAppointment = {
  __typename?: 'OtherAppointment';
  /** Type of resource */
  resourceType: OtherAppointment_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  professionalId?: Maybe<Scalars['String']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerEmail?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  appointmentDate?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  appointmentTime?: Maybe<Scalars['String']>;
  /** Reschedule AppointmentDate. */
  rescheduleAppointmentDate?: Maybe<Scalars['String']>;
  /** Reschedule AppointmentTime. */
  rescheduleAppointmentTime?: Maybe<Scalars['String']>;
  /** oldSlotId. */
  oldSlotId?: Maybe<Scalars['String']>;
  /** oldAppointmentDuration. */
  oldAppointmentDuration?: Maybe<Scalars['String']>;
  /** slotId. */
  slotId?: Maybe<Scalars['String']>;
  /** appointmentFor. */
  appointmentFor?: Maybe<Scalars['String']>;
  /** appointmentNumber. */
  appointmentNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedBy. */
  appointmentBookedBy?: Maybe<Scalars['String']>;
  /** appointmentBookedId. */
  appointmentBookedId?: Maybe<Scalars['String']>;
  /** appointmentBookedDOB. */
  appointmentBookedDOB?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointmentMode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** appointmentDuration. */
  appointmentDuration?: Maybe<Scalars['String']>;
  /** appointmentBookedByTitle. */
  appointmentBookedByTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedByFirstName. */
  appointmentBookedByFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedBySurName. */
  appointmentBookedBySurName?: Maybe<Scalars['String']>;
  /** appointmentBookedByGender. */
  appointmentBookedByGender?: Maybe<Scalars['String']>;
  /** appointmentBookedByEmail. */
  appointmentBookedByEmail?: Maybe<Scalars['String']>;
  /** appointmentBookedByPhoneNumber. */
  appointmentBookedByPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedForTitle. */
  appointmentBookedForTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedForFirstName. */
  appointmentBookedForFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedForSurName. */
  appointmentBookedForSurName?: Maybe<Scalars['String']>;
  /** appointmentBookedForGender. */
  appointmentBookedForGender?: Maybe<Scalars['String']>;
  /** appointmentBookedForEmail. */
  appointmentBookedForEmail?: Maybe<Scalars['String']>;
  /** appointmentBookedForPhoneNumber. */
  appointmentBookedForPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedForRelationship. */
  appointmentBookedForRelationship?: Maybe<Scalars['String']>;
  /** appointmentNeedLanguageSupport. */
  appointmentNeedLanguageSupport?: Maybe<Scalars['String']>;
  /** appointmentSpecialNotes. */
  appointmentSpecialNotes?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  appointmentPrice?: Maybe<Scalars['String']>;
  /** appointmentPayType. */
  appointmentPayType?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCustomerId. */
  appointmentSelfPayCustomerId?: Maybe<Scalars['String']>;
  /** appointmentSelfPayPaidCardId. */
  appointmentSelfPayPaidCardId?: Maybe<Scalars['String']>;
  /** appointmentPMICustomerId. */
  appointmentPMICustomerId?: Maybe<Scalars['String']>;
  /** appointmentPMIName. */
  appointmentPMIName?: Maybe<Scalars['String']>;
  /** appointmentPMIOtherName. */
  appointmentPMIOtherName?: Maybe<Scalars['String']>;
  /** appointmentPMIName. */
  appointmentPMIEmail?: Maybe<Scalars['String']>;
  /** appointmentPMIResponsibleParty. */
  appointmentPMIResponsibleParty?: Maybe<Scalars['String']>;
  /** appointmentPMIFirstName. */
  appointmentPMIFirstName?: Maybe<Scalars['String']>;
  /** appointmentPMISurName. */
  appointmentPMISurName?: Maybe<Scalars['String']>;
  /** appointmentGroupId. */
  appointmentGroupId?: Maybe<Scalars['String']>;
  /** appointmentMemberPolicyNumber. */
  appointmentMemberPolicyNumber?: Maybe<Scalars['String']>;
  /** appointmentExpiresOn. */
  appointmentExpiresOn?: Maybe<Scalars['String']>;
  /** appointmentPMIAuthorisationCode. */
  appointmentPMIAuthorisationCode?: Maybe<Scalars['String']>;
  /** appointmentPMIAuthorisationSession. */
  appointmentPMIAuthorisationSession?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyName. */
  appointmentThirdPartyName?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyId. */
  appointmentThirdPartyId?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyComments. */
  appointmentThirdPartyComments?: Maybe<Scalars['String']>;
  /** appointmentPMIDocuments */
  appointmentPMIDocuments?: Maybe<DocumentReference>;
  /** appointmentStatus. */
  appointmentStatus?: Maybe<Scalars['String']>;
  /** appointmentPatientTechAbility. */
  appointmentPatientTechAbility?: Maybe<Scalars['String']>;
  /** appointmentPatientMentalAbility. */
  appointmentPatientMentalAbility?: Maybe<Scalars['String']>;
  /** appointmentPatientConsent */
  appointmentPatientConsent?: Maybe<Scalars['String']>;
  /** appointmentCreatedOn */
  appointmentCreatedOn?: Maybe<Scalars['String']>;
  /** appointmentStatusUpdatedOn */
  appointmentStatusUpdatedOn?: Maybe<Scalars['String']>;
  /** appointmentCancelledOn */
  appointmentCancelledOn?: Maybe<Scalars['String']>;
  /** appointmentCancelledReson */
  appointmentCancelledReason?: Maybe<Scalars['String']>;
  /** appointmentCancelledBy */
  appointmentCancelledBy?: Maybe<Scalars['Int']>;
  /** appointmentApprovedOn */
  appointmentApprovedOn?: Maybe<Scalars['String']>;
  /** appointmentCompletedOn */
  appointmentCompletedOn?: Maybe<Scalars['String']>;
  /** appointmentUpdatedBy */
  appointmentUpdatedBy?: Maybe<Scalars['Int']>;
  /** appointmentStatusType */
  appointmentStatusType?: Maybe<Scalars['Int']>;
  /** appointmentPaymentSecret */
  appointmentPaymentSecret?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCardBrand?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayExpMonth?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayExpYear?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayCardType?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayLast4?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayPostalcode?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress1?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress2?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress3?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCity?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCounty?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCountry?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayTransactionId?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardName */
  appointmentSelfPayCardName?: Maybe<Scalars['String']>;
  /** appointmentPMIPaymntIntent */
  appointmentPMIPaymentIntent?: Maybe<Scalars['String']>;
  /** appointmentRelationShipCode */
  appointmentRelationShipCode?: Maybe<Scalars['String']>;
  /** appointmentRelationShipCode */
  appointmentForSomeOneId?: Maybe<Scalars['String']>;
  /** appointmentRelationShipCode */
  practitionerInformed?: Maybe<Scalars['Boolean']>;
  /** appointmentRelationShipCode */
  appointmentsBookedIfApplicable?: Maybe<Scalars['Boolean']>;
  /** appointmentRelationShipCode */
  paymentReceived?: Maybe<Scalars['Boolean']>;
  /** status */
  status?: Maybe<Scalars['Int']>;
  /** message */
  message?: Maybe<Scalars['String']>;
  /** message */
  videoSessionId?: Maybe<Scalars['String']>;
  /** message */
  videoSessionToken?: Maybe<Scalars['String']>;
  /** message */
  videoAPIKey?: Maybe<Scalars['String']>;
  /** message */
  videoAPISecret?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  cancellationPrice?: Maybe<Scalars['String']>;
  /** cancellationType. */
  cancellationType?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  refundPrice?: Maybe<Scalars['String']>;
  /** diagnosis. */
  diagnosis?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Contacted Patient. */
  patientContacted?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  appointmentPMIExcessStatus?: Maybe<Scalars['String']>;
  /** appointmentStatus. */
  isStartVideoClicked?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  currentVideoTime?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  videoStartTime?: Maybe<Scalars['String']>;
  /** appointmentStatus. */
  videoEndTime?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  disorderDetails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** disorderDetails. */
  rescheduledOn?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  discountType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  discountValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  commissionType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  commissionValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  appointmentOriginalPrice?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  selfPayPaymentType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  selfPayInstallmentCount?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  appointmentSingleMulitple?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  mulitpleAppointmentCount?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  installmentDate?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  installmentPaidStatus?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  installmentPaidOn?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  stripeCustomerId?: Maybe<Scalars['String']>;
  /** countAll. */
  countAll?: Maybe<Scalars['Int']>;
  /** lastUpdatedBy. */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** lastUpdatedDateTime. */
  lastUpdatedDateTime?: Maybe<Scalars['String']>;
  /** lastUpdatedByEmailId. */
  lastUpdatedByEmailId?: Maybe<Scalars['String']>;
};

export enum OtherAppointmentInput_Enum_Input {
  OtherAppointment = 'OtherAppointment'
}

export enum OtherAppointment_Enum {
  OtherAppointment = 'OtherAppointment'
}

/** Practitioner Appointment */
export type OtherAppointment_Input = {
  /** Type of resource */
  resourceType: OtherAppointmentInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  professionalId?: Maybe<Scalars['String']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerEmail?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  appointmentDate?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  appointmentTime?: Maybe<Scalars['String']>;
  /** Reschedule AppointmentDate. */
  rescheduleAppointmentDate?: Maybe<Scalars['String']>;
  /** Reschedule AppointmentTime. */
  rescheduleAppointmentTime?: Maybe<Scalars['String']>;
  /** oldSlotId. */
  oldSlotId?: Maybe<Scalars['String']>;
  /** oldAppointmentDuration. */
  oldAppointmentDuration?: Maybe<Scalars['String']>;
  /** slotId. */
  slotId?: Maybe<Scalars['String']>;
  /** appointmentFor. */
  appointmentFor?: Maybe<Scalars['String']>;
  /** appointmentNumber. */
  appointmentNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedBy. */
  appointmentBookedBy?: Maybe<Scalars['String']>;
  /** appointmentBookedId. */
  appointmentBookedId?: Maybe<Scalars['String']>;
  /** appointmentBookedDOB. */
  appointmentBookedDOB?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointmentMode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** appointmentDuration. */
  appointmentDuration?: Maybe<Scalars['String']>;
  /** appointmentBookedByTitle. */
  appointmentBookedByTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedByFirstName. */
  appointmentBookedByFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedBySurName. */
  appointmentBookedBySurName?: Maybe<Scalars['String']>;
  /** appointmentBookedByGender. */
  appointmentBookedByGender?: Maybe<Scalars['String']>;
  /** appointmentBookedByEmail. */
  appointmentBookedByEmail?: Maybe<Scalars['String']>;
  /** appointmentBookedByPhoneNumber. */
  appointmentBookedByPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedForTitle. */
  appointmentBookedForTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedForFirstName. */
  appointmentBookedForFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedForSurName. */
  appointmentBookedForSurName?: Maybe<Scalars['String']>;
  /** appointmentBookedForGender. */
  appointmentBookedForGender?: Maybe<Scalars['String']>;
  /** appointmentBookedForEmail. */
  appointmentBookedForEmail?: Maybe<Scalars['String']>;
  /** appointmentBookedForPhoneNumber. */
  appointmentBookedForPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedForRelationship. */
  appointmentBookedForRelationship?: Maybe<Scalars['String']>;
  /** appointmentNeedLanguageSupport. */
  appointmentNeedLanguageSupport?: Maybe<Scalars['String']>;
  /** appointmentSpecialNotes. */
  appointmentSpecialNotes?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  appointmentPrice?: Maybe<Scalars['String']>;
  /** appointmentPayType. */
  appointmentPayType?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCustomerId. */
  appointmentSelfPayCustomerId?: Maybe<Scalars['String']>;
  /** appointmentSelfPayPaidCardId. */
  appointmentSelfPayPaidCardId?: Maybe<Scalars['String']>;
  /** appointmentPMICustomerId. */
  appointmentPMICustomerId?: Maybe<Scalars['String']>;
  /** appointmentPMIName. */
  appointmentPMIName?: Maybe<Scalars['String']>;
  /** appointmentPMIOtherName. */
  appointmentPMIOtherName?: Maybe<Scalars['String']>;
  /** appointmentPMIName. */
  appointmentPMIEmail?: Maybe<Scalars['String']>;
  /** appointmentPMIResponsibleParty. */
  appointmentPMIResponsibleParty?: Maybe<Scalars['String']>;
  /** appointmentPMIFirstName. */
  appointmentPMIFirstName?: Maybe<Scalars['String']>;
  /** appointmentPMISurName. */
  appointmentPMISurName?: Maybe<Scalars['String']>;
  /** appointmentGroupId. */
  appointmentGroupId?: Maybe<Scalars['String']>;
  /** appointmentMemberPolicyNumber. */
  appointmentMemberPolicyNumber?: Maybe<Scalars['String']>;
  /** appointmentExpiresOn. */
  appointmentExpiresOn?: Maybe<Scalars['String']>;
  /** appointmentPMIAuthorisationCode. */
  appointmentPMIAuthorisationCode?: Maybe<Scalars['String']>;
  /** appointmentPMIAuthorisationSession. */
  appointmentPMIAuthorisationSession?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyName. */
  appointmentThirdPartyName?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyId. */
  appointmentThirdPartyId?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyComments. */
  appointmentThirdPartyComments?: Maybe<Scalars['String']>;
  /** appointmentDocuments */
  appointmentDocuments?: Maybe<DocumentReference_Input>;
  /** appointmentPMIDocuments */
  appointmentPMIDocuments?: Maybe<DocumentReference_Input>;
  /** appointmentStatus. */
  appointmentStatus?: Maybe<Scalars['String']>;
  /** appointmentPatientTechAbility. */
  appointmentPatientTechAbility?: Maybe<Scalars['String']>;
  /** appointmentPatientMentalAbility. */
  appointmentPatientMentalAbility?: Maybe<Scalars['String']>;
  /** appointmentPatientConsent */
  appointmentPatientConsent?: Maybe<Scalars['String']>;
  /** appointmentCreatedOn */
  appointmentCreatedOn?: Maybe<Scalars['String']>;
  /** appointmentStatusUpdatedOn */
  appointmentStatusUpdatedOn?: Maybe<Scalars['String']>;
  /** appointmentCancelledOn */
  appointmentCancelledOn?: Maybe<Scalars['String']>;
  /** appointmentCancelledReson */
  appointmentCancelledReason?: Maybe<Scalars['String']>;
  /** appointmentCancelledBy */
  appointmentCancelledBy?: Maybe<Scalars['Int']>;
  /** appointmentApprovedOn */
  appointmentApprovedOn?: Maybe<Scalars['String']>;
  /** appointmentUpdatedBy */
  appointmentUpdatedBy?: Maybe<Scalars['Int']>;
  /** appointmentStatusType */
  appointmentStatusType?: Maybe<Scalars['Int']>;
  /** appointmentPaymentSecret */
  appointmentPaymentSecret?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCardBrand?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayExpMonth?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayExpYear?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayCardType?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayLast4?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayPostalcode?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress1?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress2?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress3?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCity?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCounty?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCountry?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayTransactionId?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardName */
  appointmentSelfPayCardName?: Maybe<Scalars['String']>;
  /** appointmentPMIPaymntIntent */
  appointmentPMIPaymentIntent?: Maybe<Scalars['String']>;
  /** appointmentRelationShipCode */
  appointmentRelationShipCode?: Maybe<Scalars['String']>;
  /** appointmentRelationShipCode */
  appointmentForSomeOneId?: Maybe<Scalars['String']>;
  /** appointmentRelationShipCode */
  practitionerInformed?: Maybe<Scalars['Boolean']>;
  /** appointmentRelationShipCode */
  appointmentsBookedIfApplicable?: Maybe<Scalars['Boolean']>;
  /** appointmentRelationShipCode */
  paymentReceived?: Maybe<Scalars['Boolean']>;
  /** status */
  status?: Maybe<Scalars['Int']>;
  /** message */
  message?: Maybe<Scalars['String']>;
  /** message */
  videoSessionId?: Maybe<Scalars['String']>;
  /** message */
  videoSessionToken?: Maybe<Scalars['String']>;
  /** message */
  videoAPIKey?: Maybe<Scalars['String']>;
  /** message */
  videoAPISecret?: Maybe<Scalars['String']>;
  /** appointmentPMIDocuments */
  prescriptions?: Maybe<PatientPrescriptionDocument_Input>;
  /** appointmentPMIDocuments */
  letters?: Maybe<PomsPatientLetter_Input>;
  /** referral */
  referral?: Maybe<PomsReferral_Input>;
  /** appointmentPrice. */
  cancellationPrice?: Maybe<Scalars['String']>;
  /** cancellationType. */
  cancellationType?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  refundPrice?: Maybe<Scalars['String']>;
  /** diagnosis. */
  diagnosis?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Contacted Patient. */
  patientContacted?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  appointmentPMIExcessStatus?: Maybe<Scalars['String']>;
  /** appointmentStatus. */
  isStartVideoClicked?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  currentVideoTime?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  videoStartTime?: Maybe<Scalars['String']>;
  /** appointmentStatus. */
  videoEndTime?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  disorderDetails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** disorderDetails. */
  discountType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  discountValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  commissionType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  commissionValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  appointmentOriginalPrice?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  selfPayPaymentType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  selfPayInstallmentCount?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  appointmentSingleMulitple?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  mulitpleAppointmentCount?: Maybe<Scalars['Int']>;
  /** Multiple Appiontment Details. */
  multipleAppointmentDetails?: Maybe<Array<Maybe<AppointmentExtension_Input>>>;
  /** disorderDetails. */
  installmentDate?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  installmentPaidStatus?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  installmentPaidOn?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  stripeCustomerId?: Maybe<Scalars['String']>;
  /** firstName */
  firstName?: Maybe<Scalars['String']>;
  /** lastName */
  lastName?: Maybe<Scalars['String']>;
  /** email */
  email?: Maybe<Scalars['String']>;
};

/**
 * Identifies the entity which incurs the expenses. While the immediate recipients
 * of services or goods might be entities related to the subject, the expenses were
 * ultimately incurred by the subject of the Account.
 */
export type Pp_Subject_Union = Practitioner;

/**
 * Base StructureDefinition for ParameterDefinition Type: The parameters to the
 * module. This collection specifies both the input and output parameters. Input
 * parameters are provided by the caller as part of the $evaluate operation. Output
 * parameters are included in the GuidanceResponse.
 */
export type ParameterDefinition = {
  __typename?: 'ParameterDefinition';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of the parameter used to allow access to the value of the parameter in evaluation contexts. */
  _name?: Maybe<Element>;
  /** The name of the parameter used to allow access to the value of the parameter in evaluation contexts. */
  name?: Maybe<Scalars['code']>;
  /** Whether the parameter is input or output for the module. */
  _use?: Maybe<Element>;
  /** Whether the parameter is input or output for the module. */
  use: Scalars['code'];
  /** The minimum number of times this parameter SHALL appear in the request or response. */
  _min?: Maybe<Element>;
  /** The minimum number of times this parameter SHALL appear in the request or response. */
  min?: Maybe<Scalars['Int']>;
  /** The maximum number of times this element is permitted to appear in the request or response. */
  _max?: Maybe<Element>;
  /** The maximum number of times this element is permitted to appear in the request or response. */
  max?: Maybe<Scalars['String']>;
  /** A brief discussion of what the parameter is for and how it is used by the module. */
  _documentation?: Maybe<Element>;
  /** A brief discussion of what the parameter is for and how it is used by the module. */
  documentation?: Maybe<Scalars['String']>;
  /** The type of the parameter. */
  _type?: Maybe<Element>;
  /** The type of the parameter. */
  type: Scalars['code'];
  /** If specified, this indicates a profile that the input data must conform to, or that the output data will conform to. */
  _profile?: Maybe<Element>;
  /** If specified, this indicates a profile that the input data must conform to, or that the output data will conform to. */
  profile?: Maybe<Scalars['canonical']>;
};

/**
 * Base StructureDefinition for ParameterDefinition Type: The parameters to the
 * module. This collection specifies both the input and output parameters. Input
 * parameters are provided by the caller as part of the $evaluate operation. Output
 * parameters are included in the GuidanceResponse.
 */
export type ParameterDefinition_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The name of the parameter used to allow access to the value of the parameter in evaluation contexts. */
  _name?: Maybe<Element_Input>;
  /** The name of the parameter used to allow access to the value of the parameter in evaluation contexts. */
  name?: Maybe<Scalars['code']>;
  /** Whether the parameter is input or output for the module. */
  _use?: Maybe<Element_Input>;
  /** Whether the parameter is input or output for the module. */
  use: Scalars['code'];
  /** The minimum number of times this parameter SHALL appear in the request or response. */
  _min?: Maybe<Element_Input>;
  /** The minimum number of times this parameter SHALL appear in the request or response. */
  min?: Maybe<Scalars['Int']>;
  /** The maximum number of times this element is permitted to appear in the request or response. */
  _max?: Maybe<Element_Input>;
  /** The maximum number of times this element is permitted to appear in the request or response. */
  max?: Maybe<Scalars['String']>;
  /** A brief discussion of what the parameter is for and how it is used by the module. */
  _documentation?: Maybe<Element_Input>;
  /** A brief discussion of what the parameter is for and how it is used by the module. */
  documentation?: Maybe<Scalars['String']>;
  /** The type of the parameter. */
  _type?: Maybe<Element_Input>;
  /** The type of the parameter. */
  type: Scalars['code'];
  /** If specified, this indicates a profile that the input data must conform to, or that the output data will conform to. */
  _profile?: Maybe<Element_Input>;
  /** If specified, this indicates a profile that the input data must conform to, or that the output data will conform to. */
  profile?: Maybe<Scalars['canonical']>;
};

/**
 * This resource is a non-persisted resource used to pass information into and back
 * from an [operation](operations.html). It has no other use, and there is no
 * RESTful endpoint associated with it.
 */
export type Parameters = {
  __typename?: 'Parameters';
  /** Type of resource */
  resourceType: Parameters_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /** A parameter passed to or received from the operation. */
  parameter?: Maybe<Array<Maybe<Parametersparameter>>>;
};

export enum Parameters_Enum_Schema {
  Parameters = 'Parameters'
}

export type Parametersparameter = {
  __typename?: 'Parametersparameter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of the parameter (reference to the operation definition). */
  _name?: Maybe<Element>;
  /** The name of the parameter (reference to the operation definition). */
  name: Scalars['String'];
  /** If the parameter is a data type. */
  _valueBase64Binary?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueBase64Binary?: Maybe<Scalars['base64Binary']>;
  /** If the parameter is a data type. */
  _valueBoolean?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /** If the parameter is a data type. */
  _valueCanonical?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueCanonical?: Maybe<Scalars['canonical']>;
  /** If the parameter is a data type. */
  _valueCode?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueCode?: Maybe<Scalars['code']>;
  /** If the parameter is a data type. */
  _valueDate?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueDate?: Maybe<Scalars['date']>;
  /** If the parameter is a data type. */
  _valueDateTime?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueDateTime?: Maybe<Scalars['dateTime']>;
  /** If the parameter is a data type. */
  _valueDecimal?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueDecimal?: Maybe<Scalars['Float']>;
  /** If the parameter is a data type. */
  _valueId?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueId?: Maybe<Scalars['id']>;
  /** If the parameter is a data type. */
  _valueInstant?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueInstant?: Maybe<Scalars['instant']>;
  /** If the parameter is a data type. */
  _valueInteger?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** If the parameter is a data type. */
  _valueMarkdown?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueMarkdown?: Maybe<Scalars['String']>;
  /** If the parameter is a data type. */
  _valueOid?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueOid?: Maybe<Scalars['oid']>;
  /** If the parameter is a data type. */
  _valuePositiveInt?: Maybe<Element>;
  /** If the parameter is a data type. */
  valuePositiveInt?: Maybe<Scalars['positiveInt']>;
  /** If the parameter is a data type. */
  _valueString?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueString?: Maybe<Scalars['String']>;
  /** If the parameter is a data type. */
  _valueTime?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueTime?: Maybe<Scalars['time']>;
  /** If the parameter is a data type. */
  _valueUnsignedInt?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /** If the parameter is a data type. */
  _valueUri?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueUri?: Maybe<Scalars['uri']>;
  /** If the parameter is a data type. */
  _valueUrl?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueUrl?: Maybe<Scalars['url']>;
  /** If the parameter is a data type. */
  _valueUuid?: Maybe<Element>;
  /** If the parameter is a data type. */
  valueUuid?: Maybe<Scalars['uuid']>;
  /** If the parameter is a data type. */
  valueAddress?: Maybe<Address>;
  /** If the parameter is a data type. */
  valueAge?: Maybe<Age>;
  /** If the parameter is a data type. */
  valueAnnotation?: Maybe<Annotation>;
  /** If the parameter is a data type. */
  valueAttachment?: Maybe<Attachment>;
  /** If the parameter is a data type. */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** If the parameter is a data type. */
  valueCoding?: Maybe<Coding>;
  /** If the parameter is a data type. */
  valueContactPoint?: Maybe<ContactPoint>;
  /** If the parameter is a data type. */
  valueCount?: Maybe<Count>;
  /** If the parameter is a data type. */
  valueDistance?: Maybe<Distance>;
  /** If the parameter is a data type. */
  valueDuration?: Maybe<Duration>;
  /** If the parameter is a data type. */
  valueHumanName?: Maybe<HumanName>;
  /** If the parameter is a data type. */
  valueIdentifier?: Maybe<Identifier>;
  /** If the parameter is a data type. */
  valueMoney?: Maybe<Money>;
  /** If the parameter is a data type. */
  valuePeriod?: Maybe<Period>;
  /** If the parameter is a data type. */
  valueQuantity?: Maybe<Quantity>;
  /** If the parameter is a data type. */
  valueRange?: Maybe<Range>;
  /** If the parameter is a data type. */
  valueRatio?: Maybe<Ratio>;
  /** If the parameter is a data type. */
  valueReference?: Maybe<ResourceList>;
  /** If the parameter is a data type. */
  valueSampledData?: Maybe<SampledData>;
  /** If the parameter is a data type. */
  valueSignature?: Maybe<Signature>;
  /** If the parameter is a data type. */
  valueTiming?: Maybe<Timing>;
  /** If the parameter is a data type. */
  valueContactDetail?: Maybe<ContactDetail>;
  /** If the parameter is a data type. */
  valueContributor?: Maybe<Contributor>;
  /** If the parameter is a data type. */
  valueDataRequirement?: Maybe<DataRequirement>;
  /** If the parameter is a data type. */
  valueExpression?: Maybe<Expression>;
  /** If the parameter is a data type. */
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  /** If the parameter is a data type. */
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  /** If the parameter is a data type. */
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  /** If the parameter is a data type. */
  valueUsageContext?: Maybe<UsageContext>;
  /** If the parameter is a data type. */
  valueDosage?: Maybe<Dosage>;
  /** If the parameter is a whole resource. */
  resource?: Maybe<ResourceList>;
};

/**
 * Demographics and other administrative information about an individual or animal
 * receiving care or other health-related services.
 */
export type Patient = {
  __typename?: 'Patient';
  /** Type of resource */
  resourceType: Patient_Enum_Schema;
  /** Rescue Animal  */
  rescueAnimal?: Maybe<Rescue_Enum_Schema>;
  /** Birth Order */
  birthOrder?: Maybe<Scalars['Int']>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  patientExtension?: Maybe<PatientExtension_Schema>;
  /** A language the practitioner can use in patient communication. */
  healthProfile?: Maybe<PatientHealthProfile_Extension>;
  /** A language the practitioner can use in patient communication. */
  patientSecondaryDisorder?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A language the practitioner can use in patient communication. */
  patientDisorder?: Maybe<Array<Maybe<PatientDisorder_Extension>>>;
  /** A language the practitioner can use in patient communication. */
  patientBlock?: Maybe<Array<Maybe<PatientBlock_Extension>>>;
  /** patientMisc. */
  patientMisc?: Maybe<PatientMiscExtension_Schema>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  patientProfileExtension?: Maybe<PatientProfileExtension_Schema>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An identifier for this patient. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * Whether this patient record is in active use.  Many systems use this property
   * to mark as non-current patients, such as those that have not been seen for a
   * period of time based on an organization's business rules.  It is often used to
   * filter patient lists to exclude inactive patients  Deceased patients may also
   * be marked as inactive for the same reasons, but may be active for some time after death.
   */
  _active?: Maybe<Element>;
  /**
   * Whether this patient record is in active use.  Many systems use this property
   * to mark as non-current patients, such as those that have not been seen for a
   * period of time based on an organization's business rules.  It is often used to
   * filter patient lists to exclude inactive patients  Deceased patients may also
   * be marked as inactive for the same reasons, but may be active for some time after death.
   */
  active?: Maybe<Scalars['Boolean']>;
  /** A name associated with the individual. */
  name?: Maybe<Array<Maybe<HumanName>>>;
  /** A contact detail (e.g. a telephone number or an email address) by which the individual may be contacted. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** Administrative Gender - the gender that the patient is considered to have for administration and record keeping purposes. */
  _gender?: Maybe<Element>;
  /** Administrative Gender - the gender that the patient is considered to have for administration and record keeping purposes. */
  gender?: Maybe<Scalars['code']>;
  /** The date of birth for the individual. */
  _birthDate?: Maybe<Element>;
  /** The date of birth for the individual. */
  birthDate?: Maybe<Scalars['date']>;
  /** operationType field data. */
  nationality?: Maybe<Scalars['String']>;
  /** operationType field data. */
  occupation?: Maybe<Scalars['String']>;
  /** Indicates if the individual is deceased or not. */
  _deceasedBoolean?: Maybe<Element>;
  /** Indicates if the individual is deceased or not. */
  deceasedBoolean?: Maybe<Scalars['Boolean']>;
  /** Indicates if the individual is deceased or not. */
  _deceasedDateTime?: Maybe<Element>;
  /** Indicates if the individual is deceased or not. */
  deceasedDateTime?: Maybe<Scalars['dateTime']>;
  /** An address for the individual. */
  address?: Maybe<Array<Maybe<Address>>>;
  /** This field contains a patient's most recent marital (civil) status. */
  maritalStatus?: Maybe<CodeableConcept>;
  /** Indicates whether the patient is part of a multiple (boolean) or indicates the actual birth order (integer). */
  _multipleBirthBoolean?: Maybe<Element>;
  /** Indicates whether the patient is part of a multiple (boolean) or indicates the actual birth order (integer). */
  multipleBirthBoolean?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the patient is part of a multiple (boolean) or indicates the actual birth order (integer). */
  _multipleBirthInteger?: Maybe<Element>;
  /** Indicates whether the patient is part of a multiple (boolean) or indicates the actual birth order (integer). */
  multipleBirthInteger?: Maybe<Scalars['Int']>;
  /** Image of the patient. */
  photo?: Maybe<Array<Maybe<Attachment>>>;
  /** A contact party (e.g. guardian, partner, friend) for the patient. */
  contact?: Maybe<Array<Maybe<Patientcontact>>>;
  /** A language which may be used to communicate with the patient about his or her health. */
  communication?: Maybe<Array<Maybe<Patientcommunication>>>;
  /** A contact party (e.g. guardian, partner, friend) for the patient. */
  comments?: Maybe<Array<Maybe<PatientCommentsExtension>>>;
  /** Tags. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Image of the patient. */
  signPostingList?: Maybe<Array<Maybe<PatientSignPostingExtension_Schema>>>;
  /** Patient's nominated care provider. */
  generalPractitioner?: Maybe<Array<Maybe<PatientgeneralPractitioner_GeneralPractitioner_Union>>>;
  /** Organization that is the custodian of the patient record. */
  managingOrganization?: Maybe<PatientmanagingOrganization_ManagingOrganization_Union>;
  /** Link to another patient resource that concerns the same actual patient. */
  link?: Maybe<Array<Maybe<Patientlink>>>;
  /** operationType field data. */
  dob?: Maybe<Scalars['String']>;
  /** fullName. */
  fullName?: Maybe<Scalars['String']>;
  /** accountStatus. */
  accountStatus?: Maybe<Scalars['Int']>;
  /** accountStatus. */
  count?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for PatientAllergiesExtension. */
export type PatientAllergiesExtension = {
  __typename?: 'PatientAllergiesExtension';
  /** allergyType data. */
  allergyType?: Maybe<Scalars['String']>;
  /** allergyType Values data. */
  allergyTypeValues?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Base StructureDefinition for PatientAllergiesExtension Type: Custom Fields . */
export type PatientAllergiesExtension_Input = {
  /** allergyType data. */
  allergyType?: Maybe<Scalars['String']>;
  /** allergyType Values data. */
  allergyTypeValues?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Base StructureDefinition for PatientHealthProfile */
export type PatientBlock_Extension = {
  __typename?: 'PatientBlock_Extension';
  /** about data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  blockStatus?: Maybe<Scalars['Boolean']>;
};

/** Base StructureDefinition for PractionerExtension Type: Custom Fields . */
export type PatientBlock_Input = {
  /** about data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  blockStatus?: Maybe<Scalars['Boolean']>;
};

/** Base StructureDefinition for PatientAllergiesExtension. */
export type PatientCommentsExtension = {
  __typename?: 'PatientCommentsExtension';
  /** commentedOn data. */
  commentedOn?: Maybe<Scalars['String']>;
  /** comments data. */
  comments?: Maybe<Scalars['String']>;
  /** practitionerId data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitionerName data. */
  practitionerName?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PatientAllergiesExtension Type: Custom Fields . */
export type PatientCommentsExtension_Input = {
  /** commentedOn data. */
  commentedOn?: Maybe<Scalars['String']>;
  /** comments data. */
  comments?: Maybe<Scalars['String']>;
  /** practitionerId data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitionerName data. */
  practitionerName?: Maybe<Scalars['String']>;
};

/**
 * Demographics and other administrative information about an individual or animal
 * receiving care or other health-related services.
 */
export type PatientCount = {
  __typename?: 'PatientCount';
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  patientTotalCount?: Maybe<Scalars['Int']>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  patientTotalCountByMonth?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for PatientHealthProfile */
export type PatientDisorder_Extension = {
  __typename?: 'PatientDisorder_Extension';
  /** about data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  practitionerName?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  appointmentId?: Maybe<Scalars['String']>;
  /** profileTags field data. */
  disorderName?: Maybe<Scalars['String']>;
  /** insert or updated date */
  createdOn?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerExtension Type: Custom Fields . */
export type PatientDisorder_Input = {
  /** about data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  practitionerName?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  appointmentId?: Maybe<Scalars['String']>;
  /** profileTags field data. */
  disorderName?: Maybe<Scalars['String']>;
  /** insert or updated date */
  createdOn?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type PatientExtension_Input = {
  /** operationType field data. */
  operationType?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Type: Custom Fields . */
export type PatientExtension_Schema = {
  __typename?: 'PatientExtension_Schema';
  /** operationType field data. */
  operationType?: Maybe<Scalars['String']>;
};

/** PatientFinancialInfo_Input */
export type PatientFinancialInfo = {
  __typename?: 'PatientFinancialInfo';
  /** Type of resource */
  resourceType: PatientFinancialInfo_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** patientId */
  patientId?: Maybe<Scalars['String']>;
  /** financialType. */
  financialType?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** selfPayExpYear. */
  selfPayExpYear?: Maybe<Scalars['String']>;
  /** selfPayCardType. */
  selfPayCardType?: Maybe<Scalars['String']>;
  /** selfPayLast4. */
  selfPayLast4?: Maybe<Scalars['String']>;
  /** selfPayPostalcode */
  selfPayPostalcode?: Maybe<Scalars['String']>;
  /** selfPayAddress1 */
  selfPayAddress1?: Maybe<Scalars['String']>;
  /** selfPayAddress2. */
  selfPayAddress2?: Maybe<Scalars['String']>;
  /** selfPayAddress3. */
  selfPayAddress3?: Maybe<Scalars['String']>;
  /** selfPayCity */
  selfPayCity?: Maybe<Scalars['String']>;
  /** selfPayCounty. */
  selfPayCounty?: Maybe<Scalars['String']>;
  /** selfPayCountry. */
  selfPayCountry?: Maybe<Scalars['String']>;
  /** selfPayCardName. */
  selfPayCardName?: Maybe<Scalars['String']>;
  /** selfPayCardBrand. */
  selfPayCardBrand?: Maybe<Scalars['String']>;
  /** selfPayExpMonth. */
  selfPayExpMonth?: Maybe<Scalars['String']>;
  /** selfPayDefault. */
  selfPayDefault?: Maybe<Scalars['Int']>;
  /** pmiName. */
  pmiName?: Maybe<Scalars['String']>;
  /** pmiNameOther. */
  pmiNameOther?: Maybe<Scalars['String']>;
  /** pmiEmail. */
  pmiEmail?: Maybe<Scalars['String']>;
  /** pmiResponsibleParty. */
  pmiResponsibleParty?: Maybe<Scalars['String']>;
  /** pmiFirstName. */
  pmiFirstName?: Maybe<Scalars['String']>;
  /** pmiSurName. */
  pmiSurName?: Maybe<Scalars['String']>;
  /** pmiGroupId. */
  pmiGroupId?: Maybe<Scalars['String']>;
  /** pmiPolicyNumber. */
  pmiPolicyNumber?: Maybe<Scalars['String']>;
  /** pmiExpiresOn. */
  pmiExpiresOn?: Maybe<Scalars['String']>;
  /** pmiAuthorizationCode. */
  pmiAuthorizationCode?: Maybe<Scalars['String']>;
  /** pmiAuthorizationSession. */
  pmiAuthorizationSession?: Maybe<Scalars['String']>;
  /** pmiDefault. */
  pmiDefault?: Maybe<Scalars['Int']>;
  /** appointmentPMIDocuments */
  pmiDocuments?: Maybe<DocumentReference>;
  /** thirdPartyName. */
  thirdPartyName?: Maybe<Scalars['String']>;
  /** thirdPartyId. */
  thirdPartyId?: Maybe<Scalars['String']>;
  /** thirdPartyComments. */
  thirdPartyComments?: Maybe<Scalars['String']>;
  /** thirdPartyContactPerson. */
  thirdPartyContactPerson?: Maybe<Scalars['String']>;
  /** thirdPartyRoleOfPerson. */
  thirdPartyRoleOfPerson?: Maybe<Scalars['String']>;
  /** thirdPartyPhoneNumber. */
  thirdPartyPhoneNumber?: Maybe<Scalars['String']>;
  /** thirdPartyEmail. */
  thirdPartyEmail?: Maybe<Scalars['String']>;
  /** thirdPartyDefault. */
  thirdPartyDefault?: Maybe<Scalars['Int']>;
};

export enum PatientFinancialInfo_Enum {
  PatientFinancialInfo = 'PatientFinancialInfo'
}

export enum PatientFinancialInfo_Enum_Input {
  PatientFinancialInfo = 'PatientFinancialInfo'
}

/** PatientFinancialInfo_Input */
export type PatientFinancialInfo_Input = {
  /** Type of resource */
  resourceType: PatientFinancialInfo_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** patientId */
  patientId?: Maybe<Scalars['String']>;
  /** financialType. */
  financialType?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** selfPayExpYear. */
  selfPayExpYear?: Maybe<Scalars['String']>;
  /** selfPayCardType. */
  selfPayCardType?: Maybe<Scalars['String']>;
  /** selfPayLast4. */
  selfPayLast4?: Maybe<Scalars['String']>;
  /** selfPayPostalcode */
  selfPayPostalcode?: Maybe<Scalars['String']>;
  /** selfPayAddress1 */
  selfPayAddress1?: Maybe<Scalars['String']>;
  /** selfPayAddress2. */
  selfPayAddress2?: Maybe<Scalars['String']>;
  /** selfPayAddress3. */
  selfPayAddress3?: Maybe<Scalars['String']>;
  /** selfPayCity */
  selfPayCity?: Maybe<Scalars['String']>;
  /** selfPayCounty. */
  selfPayCounty?: Maybe<Scalars['String']>;
  /** selfPayCountry. */
  selfPayCountry?: Maybe<Scalars['String']>;
  /** selfPayCardName. */
  selfPayCardName?: Maybe<Scalars['String']>;
  /** selfPayCardBrand. */
  selfPayCardBrand?: Maybe<Scalars['String']>;
  /** selfPayExpMonth. */
  selfPayExpMonth?: Maybe<Scalars['String']>;
  /** selfPayDefault. */
  selfPayDefault?: Maybe<Scalars['Int']>;
  /** pmiName. */
  pmiName?: Maybe<Scalars['String']>;
  /** pmiNameOther. */
  pmiNameOther?: Maybe<Scalars['String']>;
  /** pmiEmail. */
  pmiEmail?: Maybe<Scalars['String']>;
  /** pmiResponsibleParty. */
  pmiResponsibleParty?: Maybe<Scalars['String']>;
  /** pmiFirstName. */
  pmiFirstName?: Maybe<Scalars['String']>;
  /** pmiSurName. */
  pmiSurName?: Maybe<Scalars['String']>;
  /** pmiGroupId. */
  pmiGroupId?: Maybe<Scalars['String']>;
  /** pmiPolicyNumber. */
  pmiPolicyNumber?: Maybe<Scalars['String']>;
  /** pmiExpiresOn. */
  pmiExpiresOn?: Maybe<Scalars['String']>;
  /** pmiAuthorizationCode. */
  pmiAuthorizationCode?: Maybe<Scalars['String']>;
  /** pmiAuthorizationSession. */
  pmiAuthorizationSession?: Maybe<Scalars['String']>;
  /** pmiDefault. */
  pmiDefault?: Maybe<Scalars['Int']>;
  /** thirdPartyName. */
  thirdPartyName?: Maybe<Scalars['String']>;
  /** thirdPartyId. */
  thirdPartyId?: Maybe<Scalars['String']>;
  /** thirdPartyComments. */
  thirdPartyComments?: Maybe<Scalars['String']>;
  /** thirdPartyContactPerson. */
  thirdPartyContactPerson?: Maybe<Scalars['String']>;
  /** thirdPartyRoleOfPerson. */
  thirdPartyRoleOfPerson?: Maybe<Scalars['String']>;
  /** thirdPartyPhoneNumber. */
  thirdPartyPhoneNumber?: Maybe<Scalars['String']>;
  /** thirdPartyEmail. */
  thirdPartyEmail?: Maybe<Scalars['String']>;
  /** thirdPartyDefault. */
  thirdPartyDefault?: Maybe<Scalars['Int']>;
  /** appointmentPMIDocuments */
  pmiDocuments?: Maybe<DocumentReference_Input>;
};

/** Base StructureDefinition for PatientHealthProfile */
export type PatientHealthProfile_Extension = {
  __typename?: 'PatientHealthProfile_Extension';
  /** about data. */
  gpName?: Maybe<Scalars['String']>;
  /** about data. */
  nhsNumber?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  nhsPracticeName?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  nhsCity?: Maybe<Scalars['String']>;
  /** profileTags field data. */
  canWeContactYourGP?: Maybe<Scalars['Int']>;
  /** videourl field data. */
  nhsPhone?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  nhsPracticeEmail?: Maybe<Scalars['String']>;
  /** disabilities field data. */
  disabilities?: Maybe<Scalars['String']>;
  /** risk field data. */
  risk?: Maybe<Scalars['String']>;
  /** deviceImplant field data. */
  deviceImplant?: Maybe<Scalars['String']>;
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  medication?: Maybe<Medication>;
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  diagnosis?: Maybe<Condition>;
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  immunization?: Maybe<Array<Maybe<Immunization>>>;
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  vitals?: Maybe<Array<Maybe<Observation>>>;
  /** allergies. */
  allergies?: Maybe<Array<Maybe<PatientAllergiesExtension>>>;
};

/** Base StructureDefinition for PractionerExtension Type: Custom Fields . */
export type PatientHealthProfile_Extension_Input = {
  /** about data. */
  gpName?: Maybe<Scalars['String']>;
  /** about data. */
  nhsNumber?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  nhsPracticeName?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  nhsCity?: Maybe<Scalars['String']>;
  /** profileTags field data. */
  canWeContactYourGP?: Maybe<Scalars['Int']>;
  /** videourl field data. */
  nhsPhone?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  nhsPracticeEmail?: Maybe<Scalars['String']>;
  /** disabilities field data. */
  disabilities?: Maybe<Scalars['String']>;
  /** risk field data. */
  risk?: Maybe<Scalars['String']>;
  /** deviceImplant field data. */
  deviceImplant?: Maybe<Scalars['String']>;
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  medication?: Maybe<Medication_Input>;
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  diagnosis?: Maybe<Condition_Input>;
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  immunization?: Maybe<Array<Maybe<Immunization_Input>>>;
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  vitals?: Maybe<Array<Maybe<Observation_Input>>>;
  /** allergies. */
  allergies?: Maybe<Array<Maybe<PatientAllergiesExtension_Input>>>;
};

export enum PatientInvoice_Enum {
  PatientInvoice = 'PatientInvoice'
}

export enum PatientInvoice_Enum_Input {
  PatientInvoice = 'PatientInvoice'
}

/** PatientInvoices_Schema. */
export type PatientInvoices = {
  __typename?: 'PatientInvoices';
  /** Type of resource */
  resourceType: PatientInvoice_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** invoiceDate. */
  invoiceDate?: Maybe<Scalars['String']>;
  /** invoiceNumber */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  practitionerEmail?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  appointmentDate?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  appointmentTime?: Maybe<Scalars['String']>;
  /** appointmentNumber. */
  appointmentBookedForTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedBy. */
  appointmentBookedForFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedId. */
  appointmentBookedForSurName?: Maybe<Scalars['String']>;
  /** appointmentBookedDOB. */
  appointmentBookedForEmail?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentBookedForPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentId. */
  appointmentId?: Maybe<Scalars['String']>;
  /** appointmentDuration. */
  appointmentDuration?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  appointmentPrice?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointmentMode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** appointmentPayType. */
  appointmentPayType?: Maybe<Scalars['String']>;
  /** patientId. */
  patientId?: Maybe<Scalars['String']>;
  /** appointmentCreatedOn */
  createdOn?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  invoiceUrl?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  invoiceStatus?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  thirdPartyPayer?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiName?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiGroupId?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiPolicyNumber?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiAuthCode?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiAuthSession?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  adminPMIThirdPartyUrl?: Maybe<Scalars['String']>;
};

/** PatientInvoices */
export type PatientInvoices_Input = {
  /** Type of resource */
  resourceType: PatientInvoice_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** invoiceDate. */
  invoiceDate?: Maybe<Scalars['String']>;
  /** invoiceNumber */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  practitionerEmail?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  appointmentDate?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  appointmentTime?: Maybe<Scalars['String']>;
  /** appointmentNumber. */
  appointmentBookedForTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedBy. */
  appointmentBookedForFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedId. */
  appointmentBookedForSurName?: Maybe<Scalars['String']>;
  /** appointmentBookedDOB. */
  appointmentBookedForEmail?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentBookedForPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentId. */
  appointmentId?: Maybe<Scalars['String']>;
  /** appointmentDuration. */
  appointmentDuration?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  appointmentPrice?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointmentMode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** appointmentPayType. */
  appointmentPayType?: Maybe<Scalars['String']>;
  /** patientId. */
  patientId?: Maybe<Scalars['String']>;
  /** appointmentCreatedOn */
  createdOn?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  invoiceUrl?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  invoiceStatus?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  thirdPartyPayer?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiName?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiGroupId?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiPolicyNumber?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiAuthCode?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiAuthSession?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  adminPMIThirdPartyUrl?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type PatientMiscExtension_Input = {
  /** operationType field data. */
  gilikCompleted?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  gilikStatus?: Maybe<Scalars['String']>;
  /** operationType field data. */
  patCompleted?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentCreated?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentCreatedForOthers?: Maybe<Scalars['Int']>;
  /** appointment Created */
  MRNNumber?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Type: Custom Fields . */
export type PatientMiscExtension_Schema = {
  __typename?: 'PatientMiscExtension_Schema';
  /** operationType field data. */
  gilikCompleted?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  gilikStatus?: Maybe<Scalars['String']>;
  /** operationType field data. */
  patCompleted?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentCreated?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentCreatedForOthers?: Maybe<Scalars['Int']>;
  /** appointment Created */
  MRNNumber?: Maybe<Scalars['String']>;
  /** appointment Created */
  createdOn?: Maybe<Scalars['String']>;
};

export enum PatientNotification_Enum_Input {
  PatientNotification = 'PatientNotification'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PatientNotifications = {
  __typename?: 'PatientNotifications';
  /** Type of resource */
  resourceType: PatientNotification_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  notificationMessage?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  createdOn?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  patientId?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  notificationUrl?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** buildingSocietyName field data. */
  isRead?: Maybe<Scalars['Boolean']>;
};

export enum PatientNotifications_Enum_Input {
  PatientNotification = 'PatientNotification'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PatientNotifications_Input = {
  /** Type of resource */
  resourceType: PatientNotifications_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  notificationMessage?: Maybe<Scalars['Int']>;
  /** buildingSocietyName field data. */
  createdOn?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  patientId?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  isRead?: Maybe<Scalars['Boolean']>;
  /** buildingSocietyName field data. */
  isActive?: Maybe<Scalars['Boolean']>;
};

/** PatientPrescriptionDocument_Input. */
export type PatientPrescriptionDocument = {
  __typename?: 'PatientPrescriptionDocument';
  /** Type of resource */
  resourceType: PatientPrescriptionDocument_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** prescriptionDate. */
  prescriptionDate?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  prescriptionId?: Maybe<Scalars['String']>;
  /** practitionerName. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientId?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitionerSpeciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** comments. */
  comments?: Maybe<Scalars['String']>;
  /** medications. */
  medications?: Maybe<Array<Maybe<PatientPrescriptionExtension>>>;
  /** comments. */
  createdOn?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientAddress?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerSignUrl?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  gmcNumber?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  dateofbirth?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  prescriptionType?: Maybe<Scalars['Int']>;
  /** practitioner Id. */
  prescriptionUploadUrl?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerEmail?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerAddress?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientEmail?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientPhoneNumber?: Maybe<Scalars['String']>;
  /** prescriptionStatus. */
  prescriptionStatus?: Maybe<Scalars['Int']>;
  /** comments. */
  updatedOn?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  prescriptionFileUrl?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  prescriptionFileUrlName?: Maybe<Scalars['String']>;
  /** Sentt Status. */
  prescriptionSentStatus?: Maybe<Scalars['Int']>;
};

export enum PatientPrescriptionDocument_Enum {
  PatientPrescription = 'PatientPrescription'
}

/** PatientPrescriptionDocument_Input */
export type PatientPrescriptionDocument_Input = {
  /** Type of resource */
  resourceType: PatientPrescriptionInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** prescriptionDate. */
  prescriptionDate?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  prescriptionId?: Maybe<Scalars['String']>;
  /** practitionerName. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientId?: Maybe<Scalars['String']>;
  /** practitionerSpeciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** comments. */
  comments?: Maybe<Scalars['String']>;
  /** medications. */
  medications?: Maybe<Array<Maybe<PatientPrescriptionExtension_Input>>>;
  /** comments. */
  createdOn?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientAddress?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerSignUrl?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  gmcNumber?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  dateofbirth?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  prescriptionType?: Maybe<Scalars['Int']>;
  /** practitioner Id. */
  prescriptionUploadUrl?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerEmail?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerAddress?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientEmail?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientPhoneNumber?: Maybe<Scalars['String']>;
  /** prescriptionStatus. */
  prescriptionStatus?: Maybe<Scalars['Int']>;
  /** comments. */
  updatedOn?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  prescriptionFileUrl?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  prescriptionFileUrlName?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PatientPrescriptionExtension. */
export type PatientPrescriptionExtension = {
  __typename?: 'PatientPrescriptionExtension';
  /** sNo. */
  sNo?: Maybe<Scalars['Int']>;
  /** drugName. */
  drugName?: Maybe<Scalars['String']>;
  /** dosage. */
  dosage?: Maybe<Scalars['String']>;
  /** frequency. */
  frequency?: Maybe<Scalars['String']>;
  /** route. */
  route?: Maybe<Scalars['String']>;
  /** durationOfPrescription. */
  durationOfPrescription?: Maybe<Scalars['String']>;
  /** neededToIncrease. */
  neededToIncrease?: Maybe<Scalars['String']>;
  /** neededToDecrease. */
  neededToDecrease?: Maybe<Scalars['String']>;
  /** status. */
  status?: Maybe<Scalars['String']>;
  /** status. */
  furtherInstructions?: Maybe<Scalars['String']>;
  /** status. */
  anyChanges?: Maybe<Scalars['String']>;
  /** status. */
  drugType?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PatientPrescriptionExtension Type: Custom Fields . */
export type PatientPrescriptionExtension_Input = {
  /** sNo. */
  sNo?: Maybe<Scalars['Int']>;
  /** drugName. */
  drugName?: Maybe<Scalars['String']>;
  /** dosage. */
  dosage?: Maybe<Scalars['String']>;
  /** frequency. */
  frequency?: Maybe<Scalars['String']>;
  /** route. */
  route?: Maybe<Scalars['String']>;
  /** durationOfPrescription. */
  durationOfPrescription?: Maybe<Scalars['String']>;
  /** neededToIncrease. */
  neededToIncrease?: Maybe<Scalars['String']>;
  /** neededToDecrease. */
  neededToDecrease?: Maybe<Scalars['String']>;
  /** status. */
  furtherInstructions?: Maybe<Scalars['String']>;
  /** status. */
  anyChanges?: Maybe<Scalars['String']>;
  /** status. */
  drugType?: Maybe<Scalars['String']>;
};

export enum PatientPrescriptionInput_Enum_Input {
  PatientPrescription = 'PatientPrescription'
}

/** Base StructureDefinition for Patient Profile Extension. */
export type PatientProfileExtension_Input = {
  /** operationType field data. */
  whereDidYouHearFrom?: Maybe<Scalars['String']>;
  /** operationType field data. */
  aboutYourSelf?: Maybe<Scalars['String']>;
  /** operationType field data. */
  profileTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A language the practitioner can use in patient communication. */
  genderIdentity?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** A language the practitioner can use in patient communication. */
  sexualOrientation?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** A language the practitioner can use in patient communication. */
  race?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** A language the practitioner can use in patient communication. */
  ethnicity?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
};

/** Base StructureDefinition for Patient Profile Extension Type: Custom Fields . */
export type PatientProfileExtension_Schema = {
  __typename?: 'PatientProfileExtension_Schema';
  /** operationType field data. */
  whereDidYouHearFrom?: Maybe<Scalars['String']>;
  /** operationType field data. */
  aboutYourSelf?: Maybe<Scalars['String']>;
  /** operationType field data. */
  nationality?: Maybe<Scalars['String']>;
  /** operationType field data. */
  occupation?: Maybe<Scalars['String']>;
  /** operationType field data. */
  profileTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A language the practitioner can use in patient communication. */
  genderIdentity?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A language the practitioner can use in patient communication. */
  sexualOrientation?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A language the practitioner can use in patient communication. */
  race?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A language the practitioner can use in patient communication. */
  ethnicity?: Maybe<Array<Maybe<CodeableConcept>>>;
};

export enum PatientQuestionnaire_Enum {
  PatientQuestionnaire = 'PatientQuestionnaire'
}

export enum PatientQuestionnaire_Enum_Input {
  PatientQuestionnaire = 'PatientQuestionnaire'
}

/** PatientQuestionnaire_Input */
export type PatientQuestionnaire_Input = {
  /** Type of resource */
  resourceType: PatientQuestionnaire_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** patientId */
  patientId?: Maybe<Scalars['String']>;
  /** patientId */
  patientName?: Maybe<Scalars['String']>;
  /** patientId */
  assignedId?: Maybe<Scalars['String']>;
  /** patientId */
  assignedName?: Maybe<Scalars['String']>;
  /** patientId */
  assignedSpeciality?: Maybe<Scalars['String']>;
  /** patientId */
  assignedType?: Maybe<Scalars['String']>;
  /** patientId */
  status?: Maybe<Scalars['String']>;
  /** createdOn. */
  assignedOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  completedOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  questitionerId?: Maybe<Scalars['String']>;
  /** Questitioner. */
  questionnaire?: Maybe<QuestionnaireBuilder_Input>;
  /** updatedOn. */
  operationType?: Maybe<Scalars['String']>;
};

/** PatientQuestionnaire_Schema */
export type PatientQuestionnaire_Schema = {
  __typename?: 'PatientQuestionnaire_Schema';
  /** Type of resource */
  resourceType: PatientQuestionnaire_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** patientId */
  patientId?: Maybe<Scalars['String']>;
  /** patientId */
  patientName?: Maybe<Scalars['String']>;
  /** patientId */
  assignedId?: Maybe<Scalars['String']>;
  /** patientId */
  assignedName?: Maybe<Scalars['String']>;
  /** patientId */
  assignedSpeciality?: Maybe<Scalars['String']>;
  /** patientId */
  assignedType?: Maybe<Scalars['String']>;
  /** patientId */
  status?: Maybe<Scalars['String']>;
  /** createdOn. */
  assignedOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  completedOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  questitionerId?: Maybe<Scalars['String']>;
  /** Questitioner. */
  questionnaire?: Maybe<QuestionnaireBuilder>;
  /** updatedOn. */
  operationType?: Maybe<Scalars['String']>;
};

/** PatientRecordsLog_Input. */
export type PatientRecordsLog = {
  __typename?: 'PatientRecordsLog';
  /** Type of resource */
  resourceType: PatientRecordsLog_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  logDescription?: Maybe<Scalars['String']>;
  /** patientId Id. */
  patientId?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
};

export enum PatientRecordsLog_Enum {
  PatientRecordsLog = 'PatientRecordsLog'
}

export enum PatientRecordsLog_Enum_Input {
  PatientRecordsLog = 'PatientRecordsLog'
}

/** PatientRecordsLog */
export type PatientRecordsLog_Input = {
  /** Type of resource */
  resourceType: PatientRecordsLog_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** practitioner Name. */
  logDescription?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  patientId?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type PatientSignPostingExtension_Input = {
  /** operationType field data. */
  sentOn?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerName?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** operationType field data. */
  organizationName?: Maybe<Scalars['String']>;
  /** appointment Created */
  services?: Maybe<Scalars['String']>;
  /** operationType field data. */
  organizationEmail?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationPhoneNo?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationWebsite?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationLogoUrl?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationId?: Maybe<Scalars['String']>;
  /** appointment Created */
  reason?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Type: Custom Fields . */
export type PatientSignPostingExtension_Schema = {
  __typename?: 'PatientSignPostingExtension_Schema';
  /** operationType field data. */
  sentOn?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerName?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** operationType field data. */
  organizationName?: Maybe<Scalars['String']>;
  /** appointment Created */
  services?: Maybe<Scalars['String']>;
  /** operationType field data. */
  organizationEmail?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationPhoneNo?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationWebsite?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationLogoUrl?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationId?: Maybe<Scalars['String']>;
  /** appointment Created */
  reason?: Maybe<Scalars['String']>;
};

export enum PatientTaskInput_Enum_Input {
  PatientTask = 'PatientTask'
}

export enum PatientTask_Enum_Input {
  PatientTask = 'PatientTask'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PatientTask_Input = {
  /** Type of resource */
  resourceType: PatientTaskInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  taskCount?: Maybe<Scalars['Int']>;
  /** nationalInsuranceNumber field data. */
  taskType?: Maybe<Scalars['Int']>;
  /** buildingSocietyName field data. */
  taskUrl?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  taskMessage?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  patientId?: Maybe<Scalars['String']>;
};

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PatientTasks = {
  __typename?: 'PatientTasks';
  /** Type of resource */
  resourceType: PatientTask_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  taskCount?: Maybe<Scalars['Int']>;
  /** nationalInsuranceNumber field data. */
  taskType?: Maybe<Scalars['Int']>;
  /** buildingSocietyName field data. */
  taskUrl?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  taskMessage?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  patientId?: Maybe<Scalars['String']>;
};

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PatientToDoTaskListCount = {
  __typename?: 'PatientToDoTaskListCount';
  /** Type of resource */
  resourceType: PatientToDoTaskListCount_Enum_Input;
  /** toId field data. */
  taskCount?: Maybe<Scalars['String']>;
  /** createdOn field data. */
  taskList?: Maybe<Array<Maybe<PatientToDoTasks>>>;
};

export enum PatientToDoTaskListCount_Enum_Input {
  PatientToDoTasks = 'PatientToDoTasks'
}

export enum PatientToDoTask_Enum_Input {
  PatientToDoTasks = 'PatientToDoTasks'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PatientToDoTasks = {
  __typename?: 'PatientToDoTasks';
  /** Type of resource */
  resourceType: PatientToDoTask_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** toId field data. */
  toId?: Maybe<Scalars['String']>;
  /** fromId field data. */
  fromId?: Maybe<Scalars['String']>;
  /** taskId field data. */
  taskId?: Maybe<Scalars['String']>;
  /** taskType field data. */
  taskType?: Maybe<Scalars['String']>;
  /** actionType field data. */
  actionType?: Maybe<Scalars['String']>;
  /** message field data. */
  message?: Maybe<Scalars['String']>;
  /** status field data. */
  status?: Maybe<Scalars['String']>;
  /** createdOn field data. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn field data. */
  updatedOn?: Maybe<Scalars['String']>;
  /** createdOn field data. */
  MRNNumber?: Maybe<Scalars['String']>;
  /** createdOn field data. */
  dob?: Maybe<Scalars['String']>;
  /** createdOn field data. */
  email?: Maybe<Scalars['String']>;
  /** createdOn field data. */
  fullName?: Maybe<Scalars['String']>;
  /** createdOn field data. */
  phonenumber?: Maybe<Scalars['String']>;
};

/**
 * Demographics and other administrative information about an individual or animal
 * receiving care or other health-related services.
 */
export type Patient_Documents_Input = {
  /** selected signposting documens. */
  selectedDocuments?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The patient document will be shared. */
  patientId?: Maybe<Scalars['String']>;
  /** The patient document will be shared. */
  sendById?: Maybe<Scalars['String']>;
  /** The patient document will be shared. */
  sendByName?: Maybe<Scalars['String']>;
  /** The date documents are sent */
  sendDate?: Maybe<Scalars['date']>;
  /** Message */
  message?: Maybe<Scalars['String']>;
  /** recipient Emails */
  recipientEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Seding User Type. */
  sendByUserType?: Maybe<Scalars['String']>;
  /** Patient Name. */
  patientName?: Maybe<Scalars['String']>;
};

export enum Patient_Enum_Input {
  Patient = 'Patient'
}

export enum Patient_Enum_Schema {
  Patient = 'Patient'
}

/** Query for export active whatsApp enabled patient list */
export type Patient_Export = {
  __typename?: 'Patient_Export';
  /** fullName. */
  fullName?: Maybe<Scalars['String']>;
  /** export active whatsApp enabled patient list. */
  phonenumber?: Maybe<Scalars['String']>;
};

/**
 * Demographics and other administrative information about an individual or animal
 * receiving care or other health-related services.
 */
export type Patient_Input = {
  /** Type of resource */
  resourceType: Patient_Enum_Input;
  /** Rescue Animal  */
  rescueAnimal?: Maybe<Rescue_Enum_Input>;
  /** Indicates the Birth Order */
  birthOrder?: Maybe<Scalars['Int']>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A language the practitioner can use in patient communication. */
  healthProfile?: Maybe<PatientHealthProfile_Extension_Input>;
  /** A language the practitioner can use in patient communication. */
  patientSecondaryDisorder?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A language the practitioner can use in patient communication. */
  patientDisorder?: Maybe<PatientDisorder_Input>;
  /** A language the practitioner can use in patient communication. */
  patientBlock?: Maybe<PatientBlock_Input>;
  /** patientMisc. */
  patientMisc?: Maybe<PatientMiscExtension_Input>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  patientExtension?: Maybe<PatientExtension_Input>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  patientProfileExtension?: Maybe<PatientProfileExtension_Input>;
  /** An identifier for this patient. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /**
   * Whether this patient record is in active use.  Many systems use this property
   * to mark as non-current patients, such as those that have not been seen for a
   * period of time based on an organization's business rules.  It is often used to
   * filter patient lists to exclude inactive patients  Deceased patients may also
   * be marked as inactive for the same reasons, but may be active for some time after death.
   */
  _active?: Maybe<Element_Input>;
  /**
   * Whether this patient record is in active use.  Many systems use this property
   * to mark as non-current patients, such as those that have not been seen for a
   * period of time based on an organization's business rules.  It is often used to
   * filter patient lists to exclude inactive patients  Deceased patients may also
   * be marked as inactive for the same reasons, but may be active for some time after death.
   */
  active?: Maybe<Scalars['Boolean']>;
  /** A name associated with the individual. */
  name?: Maybe<Array<Maybe<HumanName_Input>>>;
  /** A contact detail (e.g. a telephone number or an email address) by which the individual may be contacted. */
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>>>;
  /** Administrative Gender - the gender that the patient is considered to have for administration and record keeping purposes. */
  _gender?: Maybe<Element_Input>;
  /** Administrative Gender - the gender that the patient is considered to have for administration and record keeping purposes. */
  gender?: Maybe<Scalars['code']>;
  /** The date of birth for the individual. */
  _birthDate?: Maybe<Element_Input>;
  /** The date of birth for the individual. */
  birthDate?: Maybe<Scalars['date']>;
  /** operationType field data. */
  nationality?: Maybe<Scalars['String']>;
  /** operationType field data. */
  occupation?: Maybe<Scalars['String']>;
  /** Indicates if the individual is deceased or not. */
  _deceasedBoolean?: Maybe<Element_Input>;
  /** Indicates if the individual is deceased or not. */
  deceasedBoolean?: Maybe<Scalars['Boolean']>;
  /** Indicates if the individual is deceased or not. */
  _deceasedDateTime?: Maybe<Element_Input>;
  /** Indicates if the individual is deceased or not. */
  deceasedDateTime?: Maybe<Scalars['dateTime']>;
  /** An address for the individual. */
  address?: Maybe<Array<Maybe<Address_Input>>>;
  /** This field contains a patient's most recent marital (civil) status. */
  maritalStatus?: Maybe<CodeableConcept_Input>;
  /** Indicates whether the patient is part of a multiple (boolean) or indicates the actual birth order (integer). */
  _multipleBirthBoolean?: Maybe<Element_Input>;
  /** Indicates whether the patient is part of a multiple (boolean) or indicates the actual birth order (integer). */
  multipleBirthBoolean?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the patient is part of a multiple (boolean) or indicates the actual birth order (integer). */
  _multipleBirthInteger?: Maybe<Element_Input>;
  /** Indicates whether the patient is part of a multiple (boolean) or indicates the actual birth order (integer). */
  multipleBirthInteger?: Maybe<Scalars['Int']>;
  /** Image of the patient. */
  photo?: Maybe<Array<Maybe<Attachment_Input>>>;
  /** patient sign posting. */
  signPostingList?: Maybe<Array<Maybe<PatientSignPostingExtension_Input>>>;
  /** A contact party (e.g. guardian, partner, friend) for the patient. */
  contact?: Maybe<Array<Maybe<Patientcontact_Input>>>;
  /** Tags. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A contact party (e.g. guardian, partner, friend) for the patient. */
  comments?: Maybe<PatientCommentsExtension_Input>;
  /** A language which may be used to communicate with the patient about his or her health. */
  communication?: Maybe<Array<Maybe<Patientcommunication_Input>>>;
  /** Patient's nominated care provider. */
  generalPractitioner?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Organization that is the custodian of the patient record. */
  managingOrganization?: Maybe<Scalars['String']>;
  /** Link to another patient resource that concerns the same actual patient. */
  link?: Maybe<Array<Maybe<Patientlink_Input>>>;
  /** fullName. */
  fullName?: Maybe<Scalars['String']>;
  /** accountStatus. */
  accountStatus?: Maybe<Scalars['Int']>;
  /** accountStatus. */
  count?: Maybe<Scalars['Int']>;
  /** fetching From.] app or website. */
  fetchingFrom?: Maybe<Scalars['String']>;
};

export type Patientcommunication = {
  __typename?: 'Patientcommunication';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The ISO-639-1 alpha 2 code in lower case for the language, optionally followed
   * by a hyphen and the ISO-3166-1 alpha 2 code for the region in upper case; e.g.
   * 'en' for English, or 'en-US' for American English versus 'en-EN' for England English.
   */
  language: CodeableConcept;
  /** Indicates whether or not the patient prefers this language (over other languages he masters up a certain level). */
  _preferred?: Maybe<Element>;
  /** Indicates whether or not the patient prefers this language (over other languages he masters up a certain level). */
  preferred?: Maybe<Scalars['Boolean']>;
};

export type Patientcommunication_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * The ISO-639-1 alpha 2 code in lower case for the language, optionally followed
   * by a hyphen and the ISO-3166-1 alpha 2 code for the region in upper case; e.g.
   * 'en' for English, or 'en-US' for American English versus 'en-EN' for England English.
   */
  language: CodeableConcept_Input;
  /** Indicates whether or not the patient prefers this language (over other languages he masters up a certain level). */
  _preferred?: Maybe<Element_Input>;
  /** Indicates whether or not the patient prefers this language (over other languages he masters up a certain level). */
  preferred?: Maybe<Scalars['Boolean']>;
};

export type Patientcontact = {
  __typename?: 'Patientcontact';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The nature of the relationship between the patient and the contact person. */
  relationship?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A name associated with the contact person. */
  name?: Maybe<HumanName>;
  /** A contact detail for the person, e.g. a telephone number or an email address. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** Address for the contact person. */
  address?: Maybe<Address>;
  /**
   * Administrative Gender - the gender that the contact person is considered to
   * have for administration and record keeping purposes.
   */
  _gender?: Maybe<Element>;
  /** Contact Preference. */
  gender?: Maybe<Scalars['code']>;
  /** Organization on behalf of which the contact is acting or for which the contact is working. */
  organization?: Maybe<Patientcontactorganization_Organization_Union>;
  /** The period during which this contact person or organization is valid to be contacted relating to this patient. */
  period?: Maybe<Period>;
  /** Contact Preference. */
  contactPreference?: Maybe<Scalars['code']>;
  /** The date of birth for the person. */
  birthDate?: Maybe<Scalars['String']>;
  /** preferredEmail. */
  preferredEmail?: Maybe<Scalars['Boolean']>;
  /** preferredSMS. */
  preferredSMS?: Maybe<Scalars['Boolean']>;
  /** preferredPhone. */
  preferredPhone?: Maybe<Scalars['Boolean']>;
  /** appointment Created */
  appointmentCreated?: Maybe<Scalars['Int']>;
  /** appointment Created */
  MRNNumber?: Maybe<Scalars['String']>;
};

export type Patientcontact_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The nature of the relationship between the patient and the contact person. */
  relationship?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** A name associated with the contact person. */
  name?: Maybe<HumanName_Input>;
  /** A contact detail for the person, e.g. a telephone number or an email address. */
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>>>;
  /** Address for the contact person. */
  address?: Maybe<Address_Input>;
  /**
   * Administrative Gender - the gender that the contact person is considered to
   * have for administration and record keeping purposes.
   */
  _gender?: Maybe<Element_Input>;
  /** Contact Preference. */
  gender?: Maybe<Scalars['code']>;
  /** Organization on behalf of which the contact is acting or for which the contact is working. */
  organization?: Maybe<Scalars['String']>;
  /** The period during which this contact person or organization is valid to be contacted relating to this patient. */
  period?: Maybe<Period_Input>;
  /** Contact Preference. */
  contactPreference?: Maybe<Scalars['code']>;
  /** The date of birth for the person. */
  birthDate?: Maybe<Scalars['String']>;
  /** preferredEmail. */
  preferredEmail?: Maybe<Scalars['Boolean']>;
  /** preferredSMS. */
  preferredSMS?: Maybe<Scalars['Boolean']>;
  /** preferredPhone. */
  preferredPhone?: Maybe<Scalars['Boolean']>;
  /** preferredPhone. */
  appointmentCreated?: Maybe<Scalars['Boolean']>;
  /** appointment Created */
  MRNNumber?: Maybe<Scalars['String']>;
};

/** Organization on behalf of which the contact is acting or for which the contact is working. */
export type Patientcontactorganization_Organization_Union = Organization;

/** Patient's nominated care provider. */
export type PatientgeneralPractitioner_GeneralPractitioner_Union = Organization | Practitioner | PractitionerRole;

export type Patientlink = {
  __typename?: 'Patientlink';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The other patient resource that the link refers to. */
  other: Patientlinkother_Other_Union;
  /** The type of link between this patient resource and another patient resource. */
  _type?: Maybe<Element>;
  /** The type of link between this patient resource and another patient resource. */
  type: Scalars['code'];
};

export type Patientlink_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The other patient resource that the link refers to. */
  other: Scalars['String'];
  /** The type of link between this patient resource and another patient resource. */
  _type?: Maybe<Element_Input>;
  /** The type of link between this patient resource and another patient resource. */
  type: Scalars['code'];
};

/** The other patient resource that the link refers to. */
export type Patientlinkother_Other_Union = Patient | RelatedPerson;

/** Organization that is the custodian of the patient record. */
export type PatientmanagingOrganization_ManagingOrganization_Union = Organization;

/**
 * This resource provides the status of the payment for goods and services
 * rendered, and the request and response resource references.
 */
export type PaymentNotice = {
  __typename?: 'PaymentNotice';
  /** Type of resource */
  resourceType: PaymentNotice_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this payment notice. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status: Scalars['code'];
  /** Reference of resource for which payment is being made. */
  request?: Maybe<PaymentNoticerequest_Request_Union>;
  /** Reference of response to resource for which payment is being made. */
  response?: Maybe<PaymentNoticeresponse_Response_Union>;
  /** The date when this resource was created. */
  _created?: Maybe<Element>;
  /** The date when this resource was created. */
  created: Scalars['dateTime'];
  /** The practitioner who is responsible for the services rendered to the patient. */
  provider?: Maybe<PaymentNoticeprovider_Provider_Union>;
  /** A reference to the payment which is the subject of this notice. */
  payment: PaymentNoticepayment_Payment_Union;
  /** The date when the above payment action occurred. */
  _paymentDate?: Maybe<Element>;
  /** The date when the above payment action occurred. */
  paymentDate?: Maybe<Scalars['date']>;
  /** The party who will receive or has received payment that is the subject of this notification. */
  payee?: Maybe<PaymentNoticepayee_Payee_Union>;
  /** The party who is notified of the payment status. */
  recipient: PaymentNoticerecipient_Recipient_Union;
  /** The amount sent to the payee. */
  amount: Money;
  /** A code indicating whether payment has been sent or cleared. */
  paymentStatus?: Maybe<CodeableConcept>;
};

export enum PaymentNotice_Enum_Schema {
  PaymentNotice = 'PaymentNotice'
}

/** The party who will receive or has received payment that is the subject of this notification. */
export type PaymentNoticepayee_Payee_Union = Practitioner | PractitionerRole | Organization;

/** A reference to the payment which is the subject of this notice. */
export type PaymentNoticepayment_Payment_Union = PaymentReconciliation;

/** The practitioner who is responsible for the services rendered to the patient. */
export type PaymentNoticeprovider_Provider_Union = Practitioner | PractitionerRole | Organization;

/** The party who is notified of the payment status. */
export type PaymentNoticerecipient_Recipient_Union = Organization;

/** Reference of resource for which payment is being made. */
export type PaymentNoticerequest_Request_Union = Resource;

/** Reference of response to resource for which payment is being made. */
export type PaymentNoticeresponse_Response_Union = Resource;

/** This resource provides the details including amount of a payment and allocates the payment items being paid. */
export type PaymentReconciliation = {
  __typename?: 'PaymentReconciliation';
  /** Type of resource */
  resourceType: PaymentReconciliation_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this payment reconciliation. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status: Scalars['code'];
  /** The period of time for which payments have been gathered into this bulk payment for settlement. */
  period?: Maybe<Period>;
  /** The date when the resource was created. */
  _created?: Maybe<Element>;
  /** The date when the resource was created. */
  created: Scalars['dateTime'];
  /** The party who generated the payment. */
  paymentIssuer?: Maybe<PaymentReconciliationpaymentIssuer_PaymentIssuer_Union>;
  /** Original request resource reference. */
  request?: Maybe<PaymentReconciliationrequest_Request_Union>;
  /** The practitioner who is responsible for the services rendered to the patient. */
  requestor?: Maybe<PaymentReconciliationrequestor_Requestor_Union>;
  /** The outcome of a request for a reconciliation. */
  _outcome?: Maybe<Element>;
  /** The outcome of a request for a reconciliation. */
  outcome?: Maybe<Scalars['code']>;
  /** A human readable description of the status of the request for the reconciliation. */
  _disposition?: Maybe<Element>;
  /** A human readable description of the status of the request for the reconciliation. */
  disposition?: Maybe<Scalars['String']>;
  /** The date of payment as indicated on the financial instrument. */
  _paymentDate?: Maybe<Element>;
  /** The date of payment as indicated on the financial instrument. */
  paymentDate: Scalars['date'];
  /** Total payment amount as indicated on the financial instrument. */
  paymentAmount: Money;
  /** Issuer's unique identifier for the payment instrument. */
  paymentIdentifier?: Maybe<Identifier>;
  /** Distribution of the payment amount for a previously acknowledged payable. */
  detail?: Maybe<Array<Maybe<PaymentReconciliationdetail>>>;
  /** A code for the form to be used for printing the content. */
  formCode?: Maybe<CodeableConcept>;
  /** A note that describes or explains the processing in a human readable form. */
  processNote?: Maybe<Array<Maybe<PaymentReconciliationprocessNote>>>;
};

export enum PaymentReconciliation_Enum_Schema {
  PaymentReconciliation = 'PaymentReconciliation'
}

export type PaymentReconciliationdetail = {
  __typename?: 'PaymentReconciliationdetail';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique identifier for the current payment item for the referenced payable. */
  identifier?: Maybe<Identifier>;
  /** Unique identifier for the prior payment item for the referenced payable. */
  predecessor?: Maybe<Identifier>;
  /** Code to indicate the nature of the payment. */
  type: CodeableConcept;
  /** A resource, such as a Claim, the evaluation of which could lead to payment. */
  request?: Maybe<PaymentReconciliationdetailrequest_Request_Union>;
  /** The party which submitted the claim or financial transaction. */
  submitter?: Maybe<PaymentReconciliationdetailsubmitter_Submitter_Union>;
  /** A resource, such as a ClaimResponse, which contains a commitment to payment. */
  response?: Maybe<PaymentReconciliationdetailresponse_Response_Union>;
  /** The date from the response resource containing a commitment to pay. */
  _date?: Maybe<Element>;
  /** The date from the response resource containing a commitment to pay. */
  date?: Maybe<Scalars['date']>;
  /** A reference to the individual who is responsible for inquiries regarding the response and its payment. */
  responsible?: Maybe<PaymentReconciliationdetailresponsible_Responsible_Union>;
  /** The party which is receiving the payment. */
  payee?: Maybe<PaymentReconciliationdetailpayee_Payee_Union>;
  /** The monetary amount allocated from the total payment to the payable. */
  amount?: Maybe<Money>;
};

/** The party which is receiving the payment. */
export type PaymentReconciliationdetailpayee_Payee_Union = Practitioner | PractitionerRole | Organization;

/** A resource, such as a Claim, the evaluation of which could lead to payment. */
export type PaymentReconciliationdetailrequest_Request_Union = Resource;

/** A resource, such as a ClaimResponse, which contains a commitment to payment. */
export type PaymentReconciliationdetailresponse_Response_Union = Resource;

/** A reference to the individual who is responsible for inquiries regarding the response and its payment. */
export type PaymentReconciliationdetailresponsible_Responsible_Union = PractitionerRole;

/** The party which submitted the claim or financial transaction. */
export type PaymentReconciliationdetailsubmitter_Submitter_Union = Practitioner | PractitionerRole | Organization;

/** The party who generated the payment. */
export type PaymentReconciliationpaymentIssuer_PaymentIssuer_Union = Organization;

export type PaymentReconciliationprocessNote = {
  __typename?: 'PaymentReconciliationprocessNote';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The business purpose of the note text. */
  _type?: Maybe<Element>;
  /** The business purpose of the note text. */
  type?: Maybe<Scalars['code']>;
  /** The explanation or description associated with the processing. */
  _text?: Maybe<Element>;
  /** The explanation or description associated with the processing. */
  text?: Maybe<Scalars['String']>;
};

/** Original request resource reference. */
export type PaymentReconciliationrequest_Request_Union = Task;

/** The practitioner who is responsible for the services rendered to the patient. */
export type PaymentReconciliationrequestor_Requestor_Union = Practitioner | PractitionerRole | Organization;

/** A task manager is a type of resource that is used to manage tasks and resources. */
export type PaymentValidation = {
  __typename?: 'PaymentValidation';
  /** The unique identifier for the TaskManager. */
  id?: Maybe<Scalars['String']>;
  /** Indicates if the Payment Intent ID is valid. */
  valid?: Maybe<Scalars['Boolean']>;
  /** The status of the Payment Intent (e.g., succeeded, pending, failed). */
  status?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Period Type: A time period defined by a start and end date and optionally time. */
export type Period = {
  __typename?: 'Period';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The start of the period. The boundary is inclusive. */
  _start?: Maybe<Element>;
  /** The start of the period. The boundary is inclusive. */
  start?: Maybe<Scalars['dateTime']>;
  /**
   * The end of the period. If the end of the period is missing, it means no end
   * was known or planned at the time the instance was created. The start may be in
   * the past, and the end date in the future, which means that period is
   * expected/planned to end at that time.
   */
  _end?: Maybe<Element>;
  /**
   * The end of the period. If the end of the period is missing, it means no end
   * was known or planned at the time the instance was created. The start may be in
   * the past, and the end date in the future, which means that period is
   * expected/planned to end at that time.
   */
  end?: Maybe<Scalars['dateTime']>;
};

/** Base StructureDefinition for Period Type: A time period defined by a start and end date and optionally time. */
export type Period_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The start of the period. The boundary is inclusive. */
  _start?: Maybe<Element_Input>;
  /** The start of the period. The boundary is inclusive. */
  start?: Maybe<Scalars['dateTime']>;
  /**
   * The end of the period. If the end of the period is missing, it means no end
   * was known or planned at the time the instance was created. The start may be in
   * the past, and the end date in the future, which means that period is
   * expected/planned to end at that time.
   */
  _end?: Maybe<Element_Input>;
  /**
   * The end of the period. If the end of the period is missing, it means no end
   * was known or planned at the time the instance was created. The start may be in
   * the past, and the end date in the future, which means that period is
   * expected/planned to end at that time.
   */
  end?: Maybe<Scalars['dateTime']>;
};

/** Demographics and administrative information about a person independent of a specific health-related context. */
export type Person = {
  __typename?: 'Person';
  /** Type of resource */
  resourceType: Person_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier for a person within a particular scope. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A name associated with the person. */
  name?: Maybe<Array<Maybe<HumanName>>>;
  /** A contact detail for the person, e.g. a telephone number or an email address. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** Administrative Gender. */
  _gender?: Maybe<Element>;
  /** Administrative Gender. */
  gender?: Maybe<Scalars['code']>;
  /** The birth date for the person. */
  _birthDate?: Maybe<Element>;
  /** The birth date for the person. */
  birthDate?: Maybe<Scalars['date']>;
  /** One or more addresses for the person. */
  address?: Maybe<Array<Maybe<Address>>>;
  /** An image that can be displayed as a thumbnail of the person to enhance the identification of the individual. */
  photo?: Maybe<Attachment>;
  /** The organization that is the custodian of the person record. */
  managingOrganization?: Maybe<PersonmanagingOrganization_ManagingOrganization_Union>;
  /** Whether this person's record is in active use. */
  _active?: Maybe<Element>;
  /** Whether this person's record is in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /** Link to a resource that concerns the same actual person. */
  link?: Maybe<Array<Maybe<Personlink>>>;
};

export enum Person_Enum_Schema {
  Person = 'Person'
}

export type Personlink = {
  __typename?: 'Personlink';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The resource to which this actual person is associated. */
  target: Personlinktarget_Target_Union;
  /** Level of assurance that this link is associated with the target resource. */
  _assurance?: Maybe<Element>;
  /** Level of assurance that this link is associated with the target resource. */
  assurance?: Maybe<Scalars['code']>;
};

/** The resource to which this actual person is associated. */
export type Personlinktarget_Target_Union = Patient | Practitioner | RelatedPerson | Person;

/** The organization that is the custodian of the person record. */
export type PersonmanagingOrganization_ManagingOrganization_Union = Organization;

export type PharmaZone = {
  __typename?: 'PharmaZone';
  /** Type of resource */
  resourceType: PharmaZone_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** email settings. */
  email?: Maybe<Scalars['String']>;
};

export enum PharmaZone_Enum_Schema {
  PharmaZone = 'PharmaZone'
}

export enum PharmaZone_Enum_Input {
  PharmaZone = 'PharmaZone'
}

/** About Pharma Zone Settings */
export type PharmaZone_Input = {
  /** Type of resource */
  resourceType: PharmaZone_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** id. */
  id?: Maybe<Scalars['id']>;
  /** email settings. */
  email?: Maybe<Scalars['String']>;
};

/**
 * This resource allows for the definition of various types of plans as a sharable,
 * consumable, and executable artifact. The resource is general enough to support
 * the description of a broad range of clinical artifacts such as clinical decision
 * support rules, order sets and protocols.
 */
export type PlanDefinition = {
  __typename?: 'PlanDefinition';
  /** Type of resource */
  resourceType: PlanDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this plan definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this plan definition is
   * (or will be) published. This URL can be the target of a canonical reference.
   * It SHALL remain the same when the plan definition is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this plan definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this plan definition is
   * (or will be) published. This URL can be the target of a canonical reference.
   * It SHALL remain the same when the plan definition is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this plan definition when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the plan definition
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the plan definition author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence. To provide a version consistent
   * with the Decision Support Service specification, use the format
   * Major.Minor.Revision (e.g. 1.0.0). For more information on versioning
   * knowledge assets, refer to the Decision Support Service specification. Note
   * that a version is required for non-experimental active artifacts.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the plan definition
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the plan definition author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence. To provide a version consistent
   * with the Decision Support Service specification, use the format
   * Major.Minor.Revision (e.g. 1.0.0). For more information on versioning
   * knowledge assets, refer to the Decision Support Service specification. Note
   * that a version is required for non-experimental active artifacts.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the plan definition. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the plan definition. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the plan definition. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the plan definition. */
  title?: Maybe<Scalars['String']>;
  /** An explanatory or alternate title for the plan definition giving additional information about its content. */
  _subtitle?: Maybe<Element>;
  /** An explanatory or alternate title for the plan definition giving additional information about its content. */
  subtitle?: Maybe<Scalars['String']>;
  /**
   * A high-level category for the plan definition that distinguishes the kinds of
   * systems that would be interested in the plan definition.
   */
  type?: Maybe<CodeableConcept>;
  /** The status of this plan definition. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this plan definition. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this plan definition is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this plan definition is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /** A code or group definition that describes the intended subject of the plan definition. */
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  /** A code or group definition that describes the intended subject of the plan definition. */
  subjectReference?: Maybe<PlanDefinitionsubjectReference_SubjectReference_Union>;
  /**
   * The date  (and optionally time) when the plan definition was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the plan definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the plan definition was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the plan definition changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the plan definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the plan definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the plan definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the plan definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate plan
   * definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the plan definition is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this plan definition is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this plan definition is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /** A detailed description of how the plan definition is used from a clinical perspective. */
  _usage?: Maybe<Element>;
  /** A detailed description of how the plan definition is used from a clinical perspective. */
  usage?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the plan definition and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the plan definition.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the plan definition and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the plan definition.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the plan definition content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the content of the plan definition. Topics
   * provide a high-level categorization of the definition that can be useful for
   * filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related artifacts such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** A reference to a Library resource containing any formal logic used by the plan definition. */
  _library?: Maybe<Element>;
  /** A reference to a Library resource containing any formal logic used by the plan definition. */
  library?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * Goals that describe what the activities within the plan are intended to
   * achieve. For example, weight loss, restoring an activity of daily living,
   * obtaining herd immunity via immunization, meeting a process improvement
   * objective, etc.
   */
  goal?: Maybe<Array<Maybe<PlanDefinitiongoal>>>;
  /** An action or group of actions to be taken as part of the plan. */
  action?: Maybe<Array<Maybe<PlanDefinitionaction>>>;
};

export enum PlanDefinition_Enum_Schema {
  PlanDefinition = 'PlanDefinition'
}

export type PlanDefinitionaction = {
  __typename?: 'PlanDefinitionaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A user-visible prefix for the action. */
  _prefix?: Maybe<Element>;
  /** A user-visible prefix for the action. */
  prefix?: Maybe<Scalars['String']>;
  /** The title of the action displayed to a user. */
  _title?: Maybe<Element>;
  /** The title of the action displayed to a user. */
  title?: Maybe<Scalars['String']>;
  /** A brief description of the action used to provide a summary to display to the user. */
  _description?: Maybe<Element>;
  /** A brief description of the action used to provide a summary to display to the user. */
  description?: Maybe<Scalars['String']>;
  /**
   * A text equivalent of the action to be performed. This provides a
   * human-interpretable description of the action when the definition is consumed
   * by a system that might not be capable of interpreting it dynamically.
   */
  _textEquivalent?: Maybe<Element>;
  /**
   * A text equivalent of the action to be performed. This provides a
   * human-interpretable description of the action when the definition is consumed
   * by a system that might not be capable of interpreting it dynamically.
   */
  textEquivalent?: Maybe<Scalars['String']>;
  /** Indicates how quickly the action should be addressed with respect to other actions. */
  _priority?: Maybe<Element>;
  /** Indicates how quickly the action should be addressed with respect to other actions. */
  priority?: Maybe<Scalars['code']>;
  /**
   * A code that provides meaning for the action or action group. For example, a
   * section may have a LOINC code for the section of a documentation template.
   */
  code?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A description of why this action is necessary or appropriate. */
  reason?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Didactic or other informational resources associated with the action that can
   * be provided to the CDS recipient. Information resources can include inline
   * text commentary and links to web resources.
   */
  documentation?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** Identifies goals that this action supports. The reference must be to a goal element defined within this plan definition. */
  _goalId?: Maybe<Element>;
  /** Identifies goals that this action supports. The reference must be to a goal element defined within this plan definition. */
  goalId?: Maybe<Array<Maybe<Scalars['id']>>>;
  /** A code or group definition that describes the intended subject of the action and its children, if any. */
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  /** A code or group definition that describes the intended subject of the action and its children, if any. */
  subjectReference?: Maybe<PlanDefinitionactionsubjectReference_SubjectReference_Union>;
  /** A description of when the action should be triggered. */
  trigger?: Maybe<Array<Maybe<TriggerDefinition>>>;
  /** An expression that describes applicability criteria or start/stop conditions for the action. */
  condition?: Maybe<Array<Maybe<PlanDefinitionactioncondition>>>;
  /** Defines input data requirements for the action. */
  input?: Maybe<Array<Maybe<DataRequirement>>>;
  /** Defines the outputs of the action, if any. */
  output?: Maybe<Array<Maybe<DataRequirement>>>;
  /** A relationship to another action such as 'before' or '30-60 minutes after start of'. */
  relatedAction?: Maybe<Array<Maybe<PlanDefinitionactionrelatedAction>>>;
  /** An optional value describing when the action should be performed. */
  _timingDateTime?: Maybe<Element>;
  /** An optional value describing when the action should be performed. */
  timingDateTime?: Maybe<Scalars['dateTime']>;
  /** An optional value describing when the action should be performed. */
  timingAge?: Maybe<Age>;
  /** An optional value describing when the action should be performed. */
  timingPeriod?: Maybe<Period>;
  /** An optional value describing when the action should be performed. */
  timingDuration?: Maybe<Duration>;
  /** An optional value describing when the action should be performed. */
  timingRange?: Maybe<Range>;
  /** An optional value describing when the action should be performed. */
  timingTiming?: Maybe<Timing>;
  /** Indicates who should participate in performing the action described. */
  participant?: Maybe<Array<Maybe<PlanDefinitionactionparticipant>>>;
  /** The type of action to perform (create, update, remove). */
  type?: Maybe<CodeableConcept>;
  /** Defines the grouping behavior for the action and its children. */
  _groupingBehavior?: Maybe<Element>;
  /** Defines the grouping behavior for the action and its children. */
  groupingBehavior?: Maybe<Scalars['code']>;
  /** Defines the selection behavior for the action and its children. */
  _selectionBehavior?: Maybe<Element>;
  /** Defines the selection behavior for the action and its children. */
  selectionBehavior?: Maybe<Scalars['code']>;
  /** Defines the required behavior for the action. */
  _requiredBehavior?: Maybe<Element>;
  /** Defines the required behavior for the action. */
  requiredBehavior?: Maybe<Scalars['code']>;
  /** Defines whether the action should usually be preselected. */
  _precheckBehavior?: Maybe<Element>;
  /** Defines whether the action should usually be preselected. */
  precheckBehavior?: Maybe<Scalars['code']>;
  /** Defines whether the action can be selected multiple times. */
  _cardinalityBehavior?: Maybe<Element>;
  /** Defines whether the action can be selected multiple times. */
  cardinalityBehavior?: Maybe<Scalars['code']>;
  /**
   * A reference to an ActivityDefinition that describes the action to be taken in
   * detail, or a PlanDefinition that describes a series of actions to be taken.
   */
  _definitionCanonical?: Maybe<Element>;
  /**
   * A reference to an ActivityDefinition that describes the action to be taken in
   * detail, or a PlanDefinition that describes a series of actions to be taken.
   */
  definitionCanonical?: Maybe<Scalars['canonical']>;
  /**
   * A reference to an ActivityDefinition that describes the action to be taken in
   * detail, or a PlanDefinition that describes a series of actions to be taken.
   */
  _definitionUri?: Maybe<Element>;
  /**
   * A reference to an ActivityDefinition that describes the action to be taken in
   * detail, or a PlanDefinition that describes a series of actions to be taken.
   */
  definitionUri?: Maybe<Scalars['uri']>;
  /**
   * A reference to a StructureMap resource that defines a transform that can be
   * executed to produce the intent resource using the ActivityDefinition instance as the input.
   */
  _transform?: Maybe<Element>;
  /**
   * A reference to a StructureMap resource that defines a transform that can be
   * executed to produce the intent resource using the ActivityDefinition instance as the input.
   */
  transform?: Maybe<Scalars['canonical']>;
  /**
   * Customizations that should be applied to the statically defined resource. For
   * example, if the dosage of a medication must be computed based on the patient's
   * weight, a customization would be used to specify an expression that calculated
   * the weight, and the path on the resource that would contain the result.
   */
  dynamicValue?: Maybe<Array<Maybe<PlanDefinitionactiondynamicValue>>>;
};

export type PlanDefinitionactioncondition = {
  __typename?: 'PlanDefinitionactioncondition';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The kind of condition. */
  _kind?: Maybe<Element>;
  /** The kind of condition. */
  kind: Scalars['code'];
  /** An expression that returns true or false, indicating whether the condition is satisfied. */
  expression?: Maybe<Expression>;
};

export type PlanDefinitionactiondynamicValue = {
  __typename?: 'PlanDefinitionactiondynamicValue';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The path to the element to be customized. This is the path on the resource
   * that will hold the result of the calculation defined by the expression. The
   * specified path SHALL be a FHIRPath resolveable on the specified target type of
   * the ActivityDefinition, and SHALL consist only of identifiers, constant
   * indexers, and a restricted subset of functions. The path is allowed to contain
   * qualifiers (.) to traverse sub-elements, as well as indexers ([x]) to traverse
   * multiple-cardinality sub-elements (see the [Simple FHIRPath
   * Profile](fhirpath.html#simple) for full details).
   */
  _path?: Maybe<Element>;
  /**
   * The path to the element to be customized. This is the path on the resource
   * that will hold the result of the calculation defined by the expression. The
   * specified path SHALL be a FHIRPath resolveable on the specified target type of
   * the ActivityDefinition, and SHALL consist only of identifiers, constant
   * indexers, and a restricted subset of functions. The path is allowed to contain
   * qualifiers (.) to traverse sub-elements, as well as indexers ([x]) to traverse
   * multiple-cardinality sub-elements (see the [Simple FHIRPath
   * Profile](fhirpath.html#simple) for full details).
   */
  path?: Maybe<Scalars['String']>;
  /** An expression specifying the value of the customized element. */
  expression?: Maybe<Expression>;
};

export type PlanDefinitionactionparticipant = {
  __typename?: 'PlanDefinitionactionparticipant';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of participant in the action. */
  _type?: Maybe<Element>;
  /** The type of participant in the action. */
  type: Scalars['code'];
  /** The role the participant should play in performing the described action. */
  role?: Maybe<CodeableConcept>;
};

export type PlanDefinitionactionrelatedAction = {
  __typename?: 'PlanDefinitionactionrelatedAction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The element id of the related action. */
  _actionId?: Maybe<Element>;
  /** The element id of the related action. */
  actionId: Scalars['id'];
  /** The relationship of this action to the related action. */
  _relationship?: Maybe<Element>;
  /** The relationship of this action to the related action. */
  relationship: Scalars['code'];
  /** A duration or range of durations to apply to the relationship. For example, 30-60 minutes before. */
  offsetDuration?: Maybe<Duration>;
  /** A duration or range of durations to apply to the relationship. For example, 30-60 minutes before. */
  offsetRange?: Maybe<Range>;
};

/** A code or group definition that describes the intended subject of the action and its children, if any. */
export type PlanDefinitionactionsubjectReference_SubjectReference_Union = Group;

export type PlanDefinitiongoal = {
  __typename?: 'PlanDefinitiongoal';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates a category the goal falls within. */
  category?: Maybe<CodeableConcept>;
  /**
   * Human-readable and/or coded description of a specific desired objective of
   * care, such as 'control blood pressure' or 'negotiate an obstacle course' or
   * 'dance with child at wedding'.
   */
  description: CodeableConcept;
  /** Identifies the expected level of importance associated with reaching/sustaining the defined goal. */
  priority?: Maybe<CodeableConcept>;
  /** The event after which the goal should begin being pursued. */
  start?: Maybe<CodeableConcept>;
  /** Identifies problems, conditions, issues, or concerns the goal is intended to address. */
  addresses?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Didactic or other informational resources associated with the goal that
   * provide further supporting information about the goal. Information resources
   * can include inline text commentary and links to web resources.
   */
  documentation?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** Indicates what should be done and within what timeframe. */
  target?: Maybe<Array<Maybe<PlanDefinitiongoaltarget>>>;
};

export type PlanDefinitiongoaltarget = {
  __typename?: 'PlanDefinitiongoaltarget';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The parameter whose value is to be tracked, e.g. body weight, blood pressure, or hemoglobin A1c level. */
  measure?: Maybe<CodeableConcept>;
  /**
   * The target value of the measure to be achieved to signify fulfillment of the
   * goal, e.g. 150 pounds or 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any value at or below the high value. Similarly, if the
   * high value is missing, it indicates that the goal is achieved at any value at
   * or above the low value.
   */
  detailQuantity?: Maybe<Quantity>;
  /**
   * The target value of the measure to be achieved to signify fulfillment of the
   * goal, e.g. 150 pounds or 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any value at or below the high value. Similarly, if the
   * high value is missing, it indicates that the goal is achieved at any value at
   * or above the low value.
   */
  detailRange?: Maybe<Range>;
  /**
   * The target value of the measure to be achieved to signify fulfillment of the
   * goal, e.g. 150 pounds or 7.0%. Either the high or low or both values of the
   * range can be specified. When a low value is missing, it indicates that the
   * goal is achieved at any value at or below the high value. Similarly, if the
   * high value is missing, it indicates that the goal is achieved at any value at
   * or above the low value.
   */
  detailCodeableConcept?: Maybe<CodeableConcept>;
  /** Indicates the timeframe after the start of the goal in which the goal should be met. */
  due?: Maybe<Duration>;
};

/** A code or group definition that describes the intended subject of the plan definition. */
export type PlanDefinitionsubjectReference_SubjectReference_Union = Group;

/** PomsAppointment_Input. */
export type PomsAppointment = {
  __typename?: 'PomsAppointment';
  /** Type of resource */
  resourceType: PomsAppointment_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  professionalId?: Maybe<Scalars['String']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerEmail?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  appointmentDate?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  appointmentTime?: Maybe<Scalars['String']>;
  /** Reschedule AppointmentDate. */
  rescheduleAppointmentDate?: Maybe<Scalars['String']>;
  /** Reschedule AppointmentTime. */
  rescheduleAppointmentTime?: Maybe<Scalars['String']>;
  /** oldSlotId. */
  oldSlotId?: Maybe<Scalars['String']>;
  /** oldAppointmentDuration. */
  oldAppointmentDuration?: Maybe<Scalars['String']>;
  /** slotId. */
  slotId?: Maybe<Scalars['String']>;
  /** appointmentFor. */
  appointmentFor?: Maybe<Scalars['String']>;
  /** appointmentNumber. */
  appointmentNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedBy. */
  appointmentBookedBy?: Maybe<Scalars['String']>;
  /** appointmentBookedId. */
  appointmentBookedId?: Maybe<Scalars['String']>;
  /** appointmentBookedDOB. */
  appointmentBookedDOB?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointmentMode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** appointmentDuration. */
  appointmentDuration?: Maybe<Scalars['String']>;
  /** appointmentBookedByTitle. */
  appointmentBookedByTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedByFirstName. */
  appointmentBookedByFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedBySurName. */
  appointmentBookedBySurName?: Maybe<Scalars['String']>;
  /** appointmentBookedByGender. */
  appointmentBookedByGender?: Maybe<Scalars['String']>;
  /** appointmentBookedByEmail. */
  appointmentBookedByEmail?: Maybe<Scalars['String']>;
  /** appointmentBookedByPhoneNumber. */
  appointmentBookedByPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedForTitle. */
  appointmentBookedForTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedForFirstName. */
  appointmentBookedForFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedForSurName. */
  appointmentBookedForSurName?: Maybe<Scalars['String']>;
  /** appointmentBookedForGender. */
  appointmentBookedForGender?: Maybe<Scalars['String']>;
  /** appointmentBookedForEmail. */
  appointmentBookedForEmail?: Maybe<Scalars['String']>;
  /** appointmentBookedForPhoneNumber. */
  appointmentBookedForPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedForRelationship. */
  appointmentBookedForRelationship?: Maybe<Scalars['String']>;
  /** appointmentNeedLanguageSupport. */
  appointmentNeedLanguageSupport?: Maybe<Scalars['String']>;
  /** appointmentSpecialNotes. */
  appointmentSpecialNotes?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  appointmentPrice?: Maybe<Scalars['String']>;
  /** appointmentPayType. */
  appointmentPayType?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCustomerId. */
  appointmentSelfPayCustomerId?: Maybe<Scalars['String']>;
  /** appointmentSelfPayPaidCardId. */
  appointmentSelfPayPaidCardId?: Maybe<Scalars['String']>;
  /** appointmentPMICustomerId. */
  appointmentPMICustomerId?: Maybe<Scalars['String']>;
  /** appointmentPMIName. */
  appointmentPMIName?: Maybe<Scalars['String']>;
  /** appointmentPMIOtherName. */
  appointmentPMIOtherName?: Maybe<Scalars['String']>;
  /** appointmentPMIName. */
  appointmentPMIEmail?: Maybe<Scalars['String']>;
  /** appointmentPMIResponsibleParty. */
  appointmentPMIResponsibleParty?: Maybe<Scalars['String']>;
  /** appointmentPMIFirstName. */
  appointmentPMIFirstName?: Maybe<Scalars['String']>;
  /** appointmentPMISurName. */
  appointmentPMISurName?: Maybe<Scalars['String']>;
  /** appointmentGroupId. */
  appointmentGroupId?: Maybe<Scalars['String']>;
  /** appointmentMemberPolicyNumber. */
  appointmentMemberPolicyNumber?: Maybe<Scalars['String']>;
  /** appointmentExpiresOn. */
  appointmentExpiresOn?: Maybe<Scalars['String']>;
  /** appointmentPMIAuthorisationCode. */
  appointmentPMIAuthorisationCode?: Maybe<Scalars['String']>;
  /** appointmentPMIAuthorisationSession. */
  appointmentPMIAuthorisationSession?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyName. */
  appointmentThirdPartyName?: Maybe<Scalars['String']>;
  /** appointmentWebsitePaymentReferenceNumber */
  appointmentWebsitePaymentReferenceNumber?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyId. */
  appointmentThirdPartyId?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyComments. */
  appointmentThirdPartyComments?: Maybe<Scalars['String']>;
  /** appointmentDocuments */
  appointmentDocuments?: Maybe<DocumentReference>;
  /** appointmentPMIDocuments */
  appointmentPMIDocuments?: Maybe<DocumentReference>;
  /** appointmentStatus. */
  appointmentStatus?: Maybe<Scalars['String']>;
  /** appointmentPatientTechAbility. */
  appointmentPatientTechAbility?: Maybe<Scalars['String']>;
  /** appointmentPatientMentalAbility. */
  appointmentPatientMentalAbility?: Maybe<Scalars['String']>;
  /** appointmentPatientConsent */
  appointmentPatientConsent?: Maybe<Scalars['String']>;
  /** appointmentCreatedOn */
  appointmentCreatedOn?: Maybe<Scalars['String']>;
  /** appointmentStatusUpdatedOn */
  appointmentStatusUpdatedOn?: Maybe<Scalars['String']>;
  /** appointmentCancelledOn */
  appointmentCancelledOn?: Maybe<Scalars['String']>;
  /** appointmentCancelledReson */
  appointmentCancelledReason?: Maybe<Scalars['String']>;
  /** appointmentCancelledBy */
  appointmentCancelledBy?: Maybe<Scalars['Int']>;
  /** appointmentApprovedOn */
  appointmentApprovedOn?: Maybe<Scalars['String']>;
  /** appointmentCompletedOn */
  appointmentCompletedOn?: Maybe<Scalars['String']>;
  /** appointmentUpdatedBy */
  appointmentUpdatedBy?: Maybe<Scalars['Int']>;
  /** appointmentStatusType */
  appointmentStatusType?: Maybe<Scalars['Int']>;
  /** appointmentPaymentSecret */
  appointmentPaymentSecret?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCardBrand?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayExpMonth?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayExpYear?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayCardType?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayLast4?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayPostalcode?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress1?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress2?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress3?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCity?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCounty?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentDateTiming?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCountry?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayTransactionId?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardName */
  appointmentSelfPayCardName?: Maybe<Scalars['String']>;
  /** appointmentPMIPaymntIntent */
  appointmentPMIPaymentIntent?: Maybe<Scalars['String']>;
  /** appointmentRelationShipCode */
  appointmentRelationShipCode?: Maybe<Scalars['String']>;
  /** appointmentRelationShipCode */
  appointmentForSomeOneId?: Maybe<Scalars['String']>;
  /** status */
  status?: Maybe<Scalars['Int']>;
  /** message */
  message?: Maybe<Scalars['String']>;
  /** message */
  videoSessionId?: Maybe<Scalars['String']>;
  /** message */
  videoSessionToken?: Maybe<Scalars['String']>;
  /** message */
  videoAPIKey?: Maybe<Scalars['String']>;
  /** message */
  videoAPISecret?: Maybe<Scalars['String']>;
  /** appointmentPMIDocuments */
  prescriptions?: Maybe<PatientPrescriptionDocument>;
  /** appointmentPMIDocuments */
  letters?: Maybe<PomsPatientLetter>;
  /** referral */
  referral?: Maybe<PomsReferral>;
  /** appointmentPrice. */
  cancellationPrice?: Maybe<Scalars['String']>;
  /** cancellationType. */
  cancellationType?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  refundPrice?: Maybe<Scalars['String']>;
  /** diagnosis. */
  diagnosis?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** finalDisorder. */
  finalDisorder?: Maybe<Scalars['String']>;
  /** Contacted Patient. */
  patientContacted?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  appointmentPMIExcessStatus?: Maybe<Scalars['String']>;
  /** appointmentStatus. */
  isStartVideoClicked?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  currentVideoTime?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  videoStartTime?: Maybe<Scalars['String']>;
  /** appointmentStatus. */
  videoEndTime?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  disorderDetails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** disorderDetails. */
  rescheduledOn?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  discountType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  discountValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  commissionType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  commissionValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  appointmentOriginalPrice?: Maybe<Scalars['Float']>;
  /**
   * Identifies the entity which incurs the expenses. While the immediate
   * recipients of services or goods might be entities related to the subject, the
   * expenses were ultimately incurred by the subject of the Account.
   */
  subject?: Maybe<Pp_Subject_Union>;
  /** disorderDetails. */
  selfPayPaymentType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  selfPayInstallmentCount?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  appointmentSingleMulitple?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  mulitpleAppointmentCount?: Maybe<Scalars['Int']>;
  /** Multiple Appiontment Details. */
  multipleAppointmentDetails?: Maybe<Array<Maybe<AppointmentExtension_Schema>>>;
  /** disorderDetails. */
  installmentDate?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  installmentPaidStatus?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  installmentPaidOn?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  stripeCustomerId?: Maybe<Scalars['String']>;
  /** countAll. */
  countAll?: Maybe<Scalars['Int']>;
  /** lastUpdatedBy. */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** lastUpdatedDateTime. */
  lastUpdatedDateTime?: Maybe<Scalars['String']>;
  /** lastUpdatedByEmailId. */
  lastUpdatedByEmailId?: Maybe<Scalars['String']>;
  /** videoEnded */
  videoEnded?: Maybe<Scalars['Boolean']>;
};

export enum PomsAppointmentInput_Enum_Input {
  PomsAppointment = 'PomsAppointment'
}

/** PomsAppointmentSummery_Input. */
export type PomsAppointmentSummery = {
  __typename?: 'PomsAppointmentSummery';
  /** Type of resource */
  resourceType: PomsAppointmentSummery_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  professionalId?: Maybe<Scalars['String']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** totalCompleteCount. */
  totalCompleteCount?: Maybe<Scalars['String']>;
  /** lastMonthCompleteCount. */
  lastMonthCompleteCount?: Maybe<Scalars['String']>;
  /** currentMonthCompleteCount. */
  currentMonthCompleteCount?: Maybe<Scalars['String']>;
  /** currentMonthCompleteCount. */
  increaseCompleteStatus?: Maybe<Scalars['String']>;
  /** totalCancelCount. */
  totalCancelCount?: Maybe<Scalars['String']>;
  /** lastMonthCancelCount. */
  lastMonthCancelCount?: Maybe<Scalars['String']>;
  /** currentMonthCancelCount. */
  currentMonthCancelCount?: Maybe<Scalars['String']>;
  /** increaseCancelStatus. */
  increaseCancelStatus?: Maybe<Scalars['String']>;
  /** increaseCancelStatus. */
  totalPatientCount?: Maybe<Scalars['String']>;
  /** increaseCancelStatus. */
  lastMonthPatientCount?: Maybe<Scalars['String']>;
  /** increaseCancelStatus. */
  currentMonthPatientCount?: Maybe<Scalars['String']>;
  /** increaseCancelStatus. */
  increasePatientStatus?: Maybe<Scalars['String']>;
};

export enum PomsAppointmentSummery_Enum {
  PomsAppointment = 'PomsAppointment'
}

export enum PomsAppointment_Enum {
  PomsAppointment = 'PomsAppointment'
}

/** Practitioner Appointment */
export type PomsAppointment_Input = {
  /** Type of resource */
  resourceType: PomsAppointmentInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  professionalId?: Maybe<Scalars['String']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerEmail?: Maybe<Scalars['String']>;
  /** practitioner Name. */
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  appointmentDate?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  appointmentTime?: Maybe<Scalars['String']>;
  /** Reschedule AppointmentDate. */
  rescheduleAppointmentDate?: Maybe<Scalars['String']>;
  /** Reschedule AppointmentTime. */
  rescheduleAppointmentTime?: Maybe<Scalars['String']>;
  /** oldSlotId. */
  oldSlotId?: Maybe<Scalars['String']>;
  /** oldAppointmentDuration. */
  oldAppointmentDuration?: Maybe<Scalars['String']>;
  /** slotId. */
  slotId?: Maybe<Scalars['String']>;
  /** appointmentFor. */
  appointmentFor?: Maybe<Scalars['String']>;
  /** appointmentNumber. */
  appointmentNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedBy. */
  appointmentBookedBy?: Maybe<Scalars['String']>;
  /** appointmentBookedId. */
  appointmentBookedId?: Maybe<Scalars['String']>;
  /** appointmentBookedDOB. */
  appointmentBookedDOB?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointmentMode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** appointmentDuration. */
  appointmentDuration?: Maybe<Scalars['String']>;
  /** appointmentBookedByTitle. */
  appointmentBookedByTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedByFirstName. */
  appointmentBookedByFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedBySurName. */
  appointmentBookedBySurName?: Maybe<Scalars['String']>;
  /** appointmentBookedByGender. */
  appointmentBookedByGender?: Maybe<Scalars['String']>;
  /** appointmentBookedByEmail. */
  appointmentBookedByEmail?: Maybe<Scalars['String']>;
  /** appointmentBookedByPhoneNumber. */
  appointmentBookedByPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedForTitle. */
  appointmentBookedForTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedForFirstName. */
  appointmentBookedForFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedForSurName. */
  appointmentBookedForSurName?: Maybe<Scalars['String']>;
  /** appointmentBookedForGender. */
  appointmentBookedForGender?: Maybe<Scalars['String']>;
  /** appointmentBookedForEmail. */
  appointmentBookedForEmail?: Maybe<Scalars['String']>;
  /** appointmentBookedForPhoneNumber. */
  appointmentBookedForPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentBookedForRelationship. */
  appointmentBookedForRelationship?: Maybe<Scalars['String']>;
  /** appointmentNeedLanguageSupport. */
  appointmentNeedLanguageSupport?: Maybe<Scalars['String']>;
  /** appointmentSpecialNotes. */
  appointmentSpecialNotes?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  appointmentPrice?: Maybe<Scalars['String']>;
  /** appointmentPayType. */
  appointmentPayType?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCustomerId. */
  appointmentSelfPayCustomerId?: Maybe<Scalars['String']>;
  /** appointmentSelfPayPaidCardId. */
  appointmentSelfPayPaidCardId?: Maybe<Scalars['String']>;
  /** appointmentPMICustomerId. */
  appointmentPMICustomerId?: Maybe<Scalars['String']>;
  /** appointmentPMIName. */
  appointmentPMIName?: Maybe<Scalars['String']>;
  /** appointmentPMIOtherName. */
  appointmentPMIOtherName?: Maybe<Scalars['String']>;
  /** appointmentPMIName. */
  appointmentPMIEmail?: Maybe<Scalars['String']>;
  /** appointmentPMIResponsibleParty. */
  appointmentPMIResponsibleParty?: Maybe<Scalars['String']>;
  /** appointmentPMIFirstName. */
  appointmentPMIFirstName?: Maybe<Scalars['String']>;
  /** appointmentPMISurName. */
  appointmentPMISurName?: Maybe<Scalars['String']>;
  /** appointmentGroupId. */
  appointmentGroupId?: Maybe<Scalars['String']>;
  /** appointmentMemberPolicyNumber. */
  appointmentMemberPolicyNumber?: Maybe<Scalars['String']>;
  /** appointmentExpiresOn. */
  appointmentExpiresOn?: Maybe<Scalars['String']>;
  /** appointmentPMIAuthorisationCode. */
  appointmentPMIAuthorisationCode?: Maybe<Scalars['String']>;
  /** appointmentPMIAuthorisationSession. */
  appointmentPMIAuthorisationSession?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyName. */
  appointmentThirdPartyName?: Maybe<Scalars['String']>;
  /** appointmentWebsitePaymentReferenceNumber. */
  appointmentWebsitePaymentReferenceNumber?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyId. */
  appointmentThirdPartyId?: Maybe<Scalars['String']>;
  /** appointmentThirdPartyComments. */
  appointmentThirdPartyComments?: Maybe<Scalars['String']>;
  /** appointmentDocuments */
  appointmentDocuments?: Maybe<DocumentReference_Input>;
  /** appointmentPMIDocuments */
  appointmentPMIDocuments?: Maybe<DocumentReference_Input>;
  /** appointmentStatus. */
  appointmentStatus?: Maybe<Scalars['String']>;
  /** appointmentPatientTechAbility. */
  appointmentPatientTechAbility?: Maybe<Scalars['String']>;
  /** appointmentPatientMentalAbility. */
  appointmentPatientMentalAbility?: Maybe<Scalars['String']>;
  /** appointmentPatientConsent */
  appointmentPatientConsent?: Maybe<Scalars['String']>;
  /** appointmentCreatedOn */
  appointmentCreatedOn?: Maybe<Scalars['String']>;
  /** appointmentStatusUpdatedOn */
  appointmentStatusUpdatedOn?: Maybe<Scalars['String']>;
  /** appointmentCancelledOn */
  appointmentCancelledOn?: Maybe<Scalars['String']>;
  /** appointmentCancelledReson */
  appointmentCancelledReason?: Maybe<Scalars['String']>;
  /** appointmentCancelledBy */
  appointmentCancelledBy?: Maybe<Scalars['Int']>;
  /** appointmentApprovedOn */
  appointmentApprovedOn?: Maybe<Scalars['String']>;
  /** appointmentUpdatedBy */
  appointmentUpdatedBy?: Maybe<Scalars['Int']>;
  /** appointmentStatusType */
  appointmentStatusType?: Maybe<Scalars['Int']>;
  /** appointmentPaymentSecret */
  appointmentPaymentSecret?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCardBrand?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayExpMonth?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayExpYear?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfpayCardType?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayLast4?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayPostalcode?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress1?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress2?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayAddress3?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCity?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCounty?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayCountry?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardBrand */
  appointmentSelfPayTransactionId?: Maybe<Scalars['String']>;
  /** appointmentSelfPayCardName */
  appointmentSelfPayCardName?: Maybe<Scalars['String']>;
  /** appointmentPMIPaymntIntent */
  appointmentPMIPaymentIntent?: Maybe<Scalars['String']>;
  /** appointmentRelationShipCode */
  appointmentRelationShipCode?: Maybe<Scalars['String']>;
  /** appointmentRelationShipCode */
  appointmentForSomeOneId?: Maybe<Scalars['String']>;
  /** status */
  status?: Maybe<Scalars['Int']>;
  /** message */
  message?: Maybe<Scalars['String']>;
  /** message */
  videoSessionId?: Maybe<Scalars['String']>;
  /** message */
  videoSessionToken?: Maybe<Scalars['String']>;
  /** message */
  videoAPIKey?: Maybe<Scalars['String']>;
  /** message */
  videoAPISecret?: Maybe<Scalars['String']>;
  /** appointmentPMIDocuments */
  prescriptions?: Maybe<PatientPrescriptionDocument_Input>;
  /** appointmentPMIDocuments */
  letters?: Maybe<PomsPatientLetter_Input>;
  /** referral */
  referral?: Maybe<PomsReferral_Input>;
  /** appointmentPrice. */
  cancellationPrice?: Maybe<Scalars['String']>;
  /** cancellationType. */
  cancellationType?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  refundPrice?: Maybe<Scalars['String']>;
  /** diagnosis. */
  diagnosis?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** finalDisorder. */
  finalDisorder?: Maybe<Scalars['String']>;
  /** Contacted Patient. */
  patientContacted?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  appointmentPMIExcessStatus?: Maybe<Scalars['String']>;
  /** appointmentStatus. */
  isStartVideoClicked?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  currentVideoTime?: Maybe<Scalars['Int']>;
  /** appointmentStatus. */
  videoStartTime?: Maybe<Scalars['String']>;
  /** appointmentStatus. */
  videoEndTime?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  disorderDetails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** disorderDetails. */
  discountType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  discountValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  commissionType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  commissionValue?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  appointmentOriginalPrice?: Maybe<Scalars['Float']>;
  /** disorderDetails. */
  selfPayPaymentType?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  selfPayInstallmentCount?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  appointmentSingleMulitple?: Maybe<Scalars['Int']>;
  /** disorderDetails. */
  mulitpleAppointmentCount?: Maybe<Scalars['Int']>;
  /** Multiple Appiontment Details. */
  multipleAppointmentDetails?: Maybe<Array<Maybe<AppointmentExtension_Input>>>;
  /** disorderDetails. */
  installmentDate?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  installmentPaidStatus?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  installmentPaidOn?: Maybe<Scalars['String']>;
  /** disorderDetails. */
  stripeCustomerId?: Maybe<Scalars['String']>;
  /** firstName */
  firstName?: Maybe<Scalars['String']>;
  /** lastName */
  lastName?: Maybe<Scalars['String']>;
  /** email */
  email?: Maybe<Scalars['String']>;
  /** videoEnded */
  videoEnded?: Maybe<Scalars['Boolean']>;
};

export enum PomsBillingInput_Enum_Input {
  PomsBillingInvoice = 'PomsBillingInvoice'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PomsBillingInvoice = {
  __typename?: 'PomsBillingInvoice';
  /** Type of resource */
  resourceType: PomsBilling_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Documents Reference. */
  documents?: Maybe<DocumentReference>;
  /** entityType field data. */
  entityType?: Maybe<Scalars['String']>;
  /** nationalInsuranceNumber field data. */
  nationalInsuranceNumber?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  buildingSocietyName?: Maybe<Scalars['String']>;
  /** accountHolderName field data. */
  accountHolderName?: Maybe<Scalars['String']>;
  /** sortCode field data. */
  sortCode?: Maybe<Scalars['String']>;
  /** accountNo field data. */
  accountNo?: Maybe<Scalars['String']>;
  /** companyName field data. */
  companyName?: Maybe<Scalars['String']>;
  /** companyNumber field data. */
  companyNumber?: Maybe<Scalars['String']>;
  /** vatNumber field data. */
  vatNumber?: Maybe<Scalars['String']>;
  /** utrNo field data. */
  utrNo?: Maybe<Scalars['String']>;
  /** Practitioner. */
  managingPractitioner?: Maybe<Scalars['String']>;
};

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PomsBillingInvoice_Input = {
  /** Type of resource */
  resourceType: PomsBillingInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** entityType field data. */
  entityType?: Maybe<Scalars['String']>;
  /** nationalInsuranceNumber field data. */
  nationalInsuranceNumber?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  buildingSocietyName?: Maybe<Scalars['String']>;
  /** accountHolderName field data. */
  accountHolderName?: Maybe<Scalars['String']>;
  /** sortCode field data. */
  sortCode?: Maybe<Scalars['String']>;
  /** accountNo field data. */
  accountNo?: Maybe<Scalars['String']>;
  /** companyName field data. */
  companyName?: Maybe<Scalars['String']>;
  /** companyNumber field data. */
  companyNumber?: Maybe<Scalars['String']>;
  /** vatNumber field data. */
  vatNumber?: Maybe<Scalars['String']>;
  /** utrNo field data. */
  utrNo?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the insurance billing record. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** Documents Reference. */
  documents?: Maybe<DocumentReference_Input>;
};

export enum PomsBilling_Enum_Input {
  PomsBillingInvoice = 'PomsBillingInvoice'
}

/** PomsMasterTemplate_Input. */
export type PomsMasterTemplate = {
  __typename?: 'PomsMasterTemplate';
  /** Type of resource */
  resourceType: PomsMasterTemplate_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** templateName. */
  templateName?: Maybe<Scalars['String']>;
  /** templateMode. */
  templateMode?: Maybe<Scalars['String']>;
  /** templateType. */
  templateType?: Maybe<Scalars['String']>;
  /** templateData. */
  templateData?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** createdBy */
  createdBy?: Maybe<Scalars['String']>;
  /** updatedBy. */
  updatedBy?: Maybe<Scalars['String']>;
  /** status */
  status?: Maybe<Scalars['Int']>;
  /** templateAdditionalDesc */
  templateAdditionalDesc?: Maybe<Scalars['String']>;
  /** message */
  practitionerId?: Maybe<Scalars['String']>;
  /** message */
  practitionerName?: Maybe<Scalars['String']>;
};

export enum PomsMasterTemplateInput_Enum_Input {
  PomsMasterTemplate = 'PomsMasterTemplate'
}

export enum PomsMasterTemplate_Enum {
  PomsMasterTemplate = 'PomsMasterTemplate'
}

/** Master Tempaltes */
export type PomsMasterTemplate_Input = {
  /** Type of resource */
  resourceType: PomsMasterTemplateInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** practitioner Name. */
  templateName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  templateMode?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  templateType?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  templateData?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  createdOn?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  updatedOn?: Maybe<Scalars['String']>;
  /** slotId. */
  createdBy?: Maybe<Scalars['String']>;
  /** appointmentFor. */
  updatedBy?: Maybe<Scalars['String']>;
  /** status */
  status?: Maybe<Scalars['Int']>;
  /** message */
  templateAdditionalDesc?: Maybe<Scalars['String']>;
  /** message */
  practitionerId?: Maybe<Scalars['String']>;
  /** message */
  practitionerName?: Maybe<Scalars['String']>;
};

/** Patient Activity. */
export type PomsPatientActivity = {
  __typename?: 'PomsPatientActivity';
  /** Type of resource */
  resourceType: PomsPatientActivity_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  device?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  accessedOn?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  ipaddress?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  country?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingPatient?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  logInTime?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  logOutTime?: Maybe<Scalars['String']>;
};

export enum PomsPatientActivityInput_Enum_Input {
  PomsPatientActivity = 'PomsPatientActivity'
}

export enum PomsPatientActivity_Enum {
  PomsPatientActivity = 'PomsPatientActivity'
}

/** Patient Activity */
export type PomsPatientActivity_Input = {
  /** Type of resource */
  resourceType: PomsPatientActivityInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  device?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  accessedOn?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  ipaddress?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  country?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingPatient?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  logInTime?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  logOutTime?: Maybe<Scalars['String']>;
};

/** PomsPatientDocument_Input. */
export type PomsPatientDocument = {
  __typename?: 'PomsPatientDocument';
  /** Type of resource */
  resourceType: PomsPatientDocument_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** practitioner Name. */
  documentName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  documentType?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  documentUrl?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  author?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** practitioner Id. */
  organizationName?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  patientId?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  createdOn?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  updatedOn?: Maybe<Scalars['String']>;
  /** slotId. */
  practitionerId?: Maybe<Scalars['String']>;
  /** appointmentFor. */
  practitionerName?: Maybe<Scalars['String']>;
  /** status */
  practitionerSpeciality?: Maybe<Scalars['Int']>;
  /** fetchingFrom app or website. */
  fetchingFrom?: Maybe<Scalars['String']>;
  /** Multidocuments within array */
  documents?: Maybe<Scalars['String']>;
  /** The date when the document was created or reported. */
  report_date?: Maybe<Scalars['String']>;
  /** The entity the document is related to, e.g., Thirdparty, Other, Investigations, GovtId. */
  documentFor?: Maybe<Scalars['String']>;
};

export enum PomsPatientDocument_Enum {
  PomsPatientDocument = 'PomsPatientDocument'
}

export enum PomsPatientDocumentsInput_Enum_Input {
  PomsPatientDocuments = 'PomsPatientDocuments'
}

/** PatientDocuments */
export type PomsPatientDocuments_Input = {
  /** Type of resource */
  resourceType: PomsPatientDocumentsInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** practitioner Name. */
  documentName?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  documentType?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  documentUrl?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  author?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** practitioner Id. */
  organizationName?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  patientId?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  createdOn?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  updatedOn?: Maybe<Scalars['String']>;
  /** slotId. */
  practitionerId?: Maybe<Scalars['String']>;
  /** appointmentFor. */
  practitionerName?: Maybe<Scalars['String']>;
  /** status */
  practitionerSpeciality?: Maybe<Scalars['Int']>;
  /** fetchingFrom app or website. */
  fetchingFrom?: Maybe<Scalars['String']>;
  /** Multidocuments within array */
  documents?: Maybe<Scalars['String']>;
  /** The date when the document was created or reported. */
  report_date?: Maybe<Scalars['String']>;
};

/** PomsPatientLetter_Input. */
export type PomsPatientLetter = {
  __typename?: 'PomsPatientLetter';
  /** Type of resource */
  resourceType: PomsPatientLetter_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** templateName. */
  templateName?: Maybe<Scalars['String']>;
  /** templateMode. */
  templateMode?: Maybe<Scalars['String']>;
  /** templateType. */
  templateType?: Maybe<Scalars['String']>;
  /** templateData. */
  templateData?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** practitionerId. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitionerName. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitionerSpeciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** status */
  patientId?: Maybe<Scalars['String']>;
  /** message */
  status?: Maybe<Scalars['String']>;
  /** message */
  name?: Maybe<Scalars['String']>;
  /** templateData. */
  templateJsonData?: Maybe<Scalars['String']>;
  /** status */
  patientName?: Maybe<Scalars['String']>;
  /** status */
  gpName?: Maybe<Scalars['String']>;
  /** status */
  gpEmail?: Maybe<Scalars['String']>;
  /** status */
  gpPractitionerName?: Maybe<Scalars['String']>;
  /** notificationMessage */
  notificationMessage?: Maybe<Scalars['String']>;
  /** adminName */
  adminName?: Maybe<Scalars['String']>;
  /** adminEmail */
  adminEmail?: Maybe<Scalars['String']>;
  /** GraphQLBoolean */
  adminLetter?: Maybe<Scalars['Boolean']>;
  /** status */
  letterType?: Maybe<Scalars['Int']>;
  /** practitioner Id. */
  letterUploadUrl?: Maybe<Scalars['String']>;
};

export enum PomsPatientLetterInput_Enum_Input {
  PomsPatientLetter = 'PomsPatientLetter'
}

export enum PomsPatientLetter_Enum {
  PomsPatientLetter = 'PomsPatientLetter'
}

/** Letter Tempaltes */
export type PomsPatientLetter_Input = {
  /** Type of resource */
  resourceType: PomsPatientLetterInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** templateName. */
  templateName?: Maybe<Scalars['String']>;
  /** templateMode. */
  templateMode?: Maybe<Scalars['String']>;
  /** templateType. */
  templateType?: Maybe<Scalars['String']>;
  /** templateData. */
  templateData?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /** practitionerId. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitionerName. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitionerSpeciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** status */
  patientId?: Maybe<Scalars['String']>;
  /** message */
  status?: Maybe<Scalars['String']>;
  /** message */
  name?: Maybe<Scalars['String']>;
  /** templateData. */
  templateJsonData?: Maybe<Scalars['String']>;
  /** status */
  patientName?: Maybe<Scalars['String']>;
  /** status */
  gpName?: Maybe<Scalars['String']>;
  /** status */
  gpEmail?: Maybe<Scalars['String']>;
  /** status */
  gpPractitionerName?: Maybe<Scalars['String']>;
  /** notificationMessage */
  notificationMessage?: Maybe<Scalars['String']>;
  /** adminName */
  adminName?: Maybe<Scalars['String']>;
  /** adminEmail */
  adminEmail?: Maybe<Scalars['String']>;
  /** GraphQLBoolean */
  adminLetter?: Maybe<Scalars['Boolean']>;
  /** status */
  letterType?: Maybe<Scalars['Int']>;
  /** practitioner Id. */
  letterUploadUrl?: Maybe<Scalars['String']>;
};

/** Patient Preferences. */
export type PomsPatientPreferences = {
  __typename?: 'PomsPatientPreferences';
  /** Type of resource */
  resourceType: PomsPatientPreferences_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  gender?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  language?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  currency?: Maybe<CodeableConcept>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  timezone?: Maybe<CodeableConcept>;
  /** Patient that is the custodian of the Preferences. */
  managingPatient?: Maybe<Scalars['String']>;
  /** Instructions. */
  instructions?: Maybe<Scalars['String']>;
};

export enum PomsPatientPreferencesInput_Enum_Input {
  PomsPatientPreferences = 'PomsPatientPreferences'
}

export enum PomsPatientPreferences_Enum {
  PomsPatientPreferences = 'PomsPatientPreferences'
}

/** Patient Preferences */
export type PomsPatientPreferences_Input = {
  /** Type of resource */
  resourceType: PomsPatientPreferencesInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  gender?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  language?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  currency?: Maybe<CodeableConcept_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  timezone?: Maybe<CodeableConcept_Input>;
  /** Patient that is the custodian of the Preferences. */
  managingPatient?: Maybe<Scalars['String']>;
  /** Instructions. */
  instructions?: Maybe<Scalars['String']>;
};

/** Patient Privacy. */
export type PomsPatientPrivacy = {
  __typename?: 'PomsPatientPrivacy';
  /** Type of resource */
  resourceType: PomsPatientPrivacy_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactSMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactEmail?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifySMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyEmail?: Maybe<Scalars['Int']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingPatient?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  gdprConsent?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  consentDisclosure?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  prescriptionPolicy?: Maybe<Scalars['Int']>;
  /** specialOfferPolicy. */
  specialOfferPolicy?: Maybe<Scalars['Int']>;
  /** patientName */
  patientName?: Maybe<Scalars['String']>;
  /** patientAddress */
  patientAddress?: Maybe<Scalars['String']>;
  /** gpName */
  gpName?: Maybe<Scalars['String']>;
  /** gpPracticeName */
  gpPracticeName?: Maybe<Scalars['String']>;
  /** gpPracticeAddress */
  gpPracticeAddress?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  informationPolicy?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  okatreeContract?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  cancellationPolicy?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  patientorGuardianName?: Maybe<Scalars['String']>;
  /** Guardian First Name used for the account when displaying it to humans in reports, etc. */
  guardianFirstName?: Maybe<Scalars['String']>;
  /** Guardian Surname is used for the account when displaying it to humans in reports, etc. */
  guardianSurname?: Maybe<Scalars['String']>;
  /** Relation to Patient is  used for the account when displaying it to humans in reports, etc. */
  relationtoPatient?: Maybe<Scalars['String']>;
  /** Patient Privacy Include Whatsapp. */
  whatsappOfferPolicy?: Maybe<Scalars['Int']>;
  /** To handel update from waliner. */
  callingFrom?: Maybe<Scalars['String']>;
  /** To handel update from waliner. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** To handel update from waliner. */
  email?: Maybe<Scalars['String']>;
};

export enum PomsPatientPrivacyInput_Enum_Input {
  PomsPatientPrivacy = 'PomsPatientPrivacy'
}

export enum PomsPatientPrivacy_Enum {
  PomsPatientPrivacy = 'PomsPatientPrivacy'
}

/** Patient Privacy */
export type PomsPatientPrivacy_Input = {
  /** Type of resource */
  resourceType: PomsPatientPrivacyInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactSMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactEmail?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifySMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyEmail?: Maybe<Scalars['Int']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingPatient?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  gdprConsent?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  consentDisclosure?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  prescriptionPolicy?: Maybe<Scalars['Int']>;
  /** specialOfferPolicy. */
  specialOfferPolicy?: Maybe<Scalars['Int']>;
  /** patientName */
  patientName?: Maybe<Scalars['String']>;
  /** patientAddress */
  patientAddress?: Maybe<Scalars['String']>;
  /** gpName */
  gpName?: Maybe<Scalars['String']>;
  /** gpPracticeName */
  gpPracticeName?: Maybe<Scalars['String']>;
  /** gpPracticeAddress */
  gpPracticeAddress?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  informationPolicy?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  okatreeContract?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  cancellationPolicy?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  patientorGuardianName?: Maybe<Scalars['String']>;
  /** Patient Privacy Include Whatsapp. */
  whatsappOfferPolicy?: Maybe<Scalars['Int']>;
  /** To handel update from waliner. */
  callingFrom?: Maybe<Scalars['String']>;
  /** To handel update from waliner. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** To handel update from waliner. */
  email?: Maybe<Scalars['String']>;
};

/** Practitioner Activity. */
export type PomsPractitionerActivity = {
  __typename?: 'PomsPractitionerActivity';
  /** Type of resource */
  resourceType: PomsPractitionerActivity_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  device?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  accessedOn?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  ipaddress?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  country?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  logInTime?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  logOutTime?: Maybe<Scalars['String']>;
};

export enum PomsPractitionerActivityInput_Enum_Input {
  PomsPractitionerActivity = 'PomsPractitionerActivity'
}

export enum PomsPractitionerActivity_Enum {
  PomsPractitionerActivity = 'PomsPractitionerActivity'
}

/** Practitioner Activity */
export type PomsPractitionerActivity_Input = {
  /** Type of resource */
  resourceType: PomsPractitionerActivityInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  device?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  accessedOn?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  ipaddress?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  country?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingPractitioner?: Maybe<Scalars['String']>;
};

/** Practitioner Agreements . */
export type PomsPractitionerAgreements = {
  __typename?: 'PomsPractitionerAgreements';
  /** Type of resource */
  resourceType: PomsPractitionerAgreements_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Documents Reference. */
  documents?: Maybe<DocumentReference>;
  /** POMS Contract field data. */
  pomsContract?: Maybe<Scalars['Int']>;
  /** POMS Contract field data. */
  contractFilePath?: Maybe<Scalars['String']>;
  /** Terms Of Use field data. */
  termsOfUse?: Maybe<Scalars['Int']>;
  /** POMS Hand Book field data. */
  pomsHandBook?: Maybe<Scalars['Int']>;
  /** Practitioner. */
  managingPractitioner?: Maybe<Scalars['String']>;
};

export enum PomsPractitionerAgreements_Enum {
  PomsPractitionerAgreement = 'PomsPractitionerAgreement'
}

export enum PomsPractitionerAgreements_Enum_Input {
  PomsPractitionerAgreement = 'PomsPractitionerAgreement'
}

/** Practitioner Agreements . */
export type PomsPractitionerAgreements_Input = {
  /** Type of resource */
  resourceType: PomsPractitionerAgreements_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** POMS Contract field data. */
  pomsContract?: Maybe<Scalars['Int']>;
  /** POMS Contract field data. */
  contractFilePath?: Maybe<Scalars['String']>;
  /** Terms Of Use field data. */
  termsOfUse?: Maybe<Scalars['Int']>;
  /** POMS Hand Book field data. */
  pomsHandBook?: Maybe<Scalars['Int']>;
  /** Practitioner that is the custodian of the insurance billing record. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** Documents Reference. */
  documents?: Maybe<DocumentReference_Input>;
};

/** Practitioner Preferences. */
export type PomsPractitionerPreferences = {
  __typename?: 'PomsPractitionerPreferences';
  /** Type of resource */
  resourceType: PomsPractitionerPreferences_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  country?: Maybe<CodeableConcept>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  language?: Maybe<CodeableConcept>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  currency?: Maybe<CodeableConcept>;
  /** Timezone Preferences. */
  timezone?: Maybe<CodeableConcept>;
  /** Practitioner that is the custodian of the Preferences. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  sendCommunicationMessage?: Maybe<Scalars['Boolean']>;
};

export enum PomsPractitionerPreferencesInput_Enum_Input {
  PomsPractitionerPreferences = 'PomsPractitionerPreferences'
}

export enum PomsPractitionerPreferences_Enum {
  PomsPractitionerPreferences = 'PomsPractitionerPreferences'
}

/** Practitioner Preferences */
export type PomsPractitionerPreferences_Input = {
  /** Type of resource */
  resourceType: PomsPractitionerPreferencesInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  country?: Maybe<CodeableConcept_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  language?: Maybe<CodeableConcept_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  currency?: Maybe<CodeableConcept_Input>;
  /** Timezone Preferences. */
  timezone?: Maybe<CodeableConcept_Input>;
  /** Practitioner that is the custodian of the Preferences. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  sendCommunicationMessage?: Maybe<Scalars['Boolean']>;
};

/** Practitioner Privacy. */
export type PomsPractitionerPrivacy = {
  __typename?: 'PomsPractitionerPrivacy';
  /** Type of resource */
  resourceType: PomsPractitionerPrivacy_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactSMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactEmail?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifySMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyEmail?: Maybe<Scalars['Int']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  gdprConsent?: Maybe<Scalars['Int']>;
};

export enum PomsPractitionerPrivacyInput_Enum_Input {
  PomsPractitionerPrivacy = 'PomsPractitionerPrivacy'
}

export enum PomsPractitionerPrivacy_Enum {
  PomsPractitionerPrivacy = 'PomsPractitionerPrivacy'
}

/** Practitioner Privacy */
export type PomsPractitionerPrivacy_Input = {
  /** Type of resource */
  resourceType: PomsPractitionerPrivacyInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content may not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactSMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  contactEmail?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPost?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyPhone?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifySMS?: Maybe<Scalars['Int']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  notifyEmail?: Maybe<Scalars['Int']>;
  /** Practitioner that is the custodian of the Preferences. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** Practitioner that is the custodian of the Preferences. */
  gdprConsent?: Maybe<Scalars['Int']>;
};

/** Poms Practitioner Schedule. */
export type PomsPractitionerSchedule = {
  __typename?: 'PomsPractitionerSchedule';
  /** Type of resource */
  resourceType: PomsPractitionerScheduleInput_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Location Id. */
  locationId?: Maybe<Scalars['String']>;
  /** Location Name. */
  locationName?: Maybe<Scalars['String']>;
  /** Color. */
  color?: Maybe<Scalars['String']>;
  /** defaultVisibility. */
  defaultVisibility?: Maybe<Scalars['Int']>;
  /** breakRequired. */
  breakRequiredType?: Maybe<Scalars['String']>;
  /** breakRequired. */
  breakRequired?: Maybe<Scalars['Int']>;
  /** breakRequiredTime. */
  breakRequiredTime?: Maybe<Scalars['Int']>;
  /** breakRequiredTimeType. */
  breakRequiredTimeType?: Maybe<Scalars['Int']>;
  /** breakRequiredTime. */
  breakRequiredFinalTime?: Maybe<Scalars['Int']>;
  /** From Date. */
  fromDate?: Maybe<Scalars['String']>;
  /** To Date. */
  toDate?: Maybe<Scalars['String']>;
  /** Is Repeat. */
  isRepeat?: Maybe<Scalars['Int']>;
  /** Is Repeat. */
  repeatType?: Maybe<Scalars['String']>;
  /** Repeat Every Number. */
  repeatEveryNumber?: Maybe<Scalars['Int']>;
  /** Week Timings */
  weekTimings?: Maybe<Array<Maybe<PomsPractitionerScheduleWeekTimings>>>;
  /** Practitioner that is the custodian of the Schedule. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** Repeat Every Number. */
  endOnType?: Maybe<Scalars['Int']>;
  /** Repeat Every Number. */
  endOnDate?: Maybe<Scalars['String']>;
  /** Repeat Every Number. */
  endOnAfterNoOfOccurences?: Maybe<Scalars['Int']>;
  /** Repeat repeatSelectType. */
  repeatSelectType?: Maybe<Scalars['Int']>;
  /** message */
  message?: Maybe<Scalars['String']>;
};

export enum PomsPractitionerScheduleInput_Enum {
  PomsPractitionerSchedule = 'PomsPractitionerSchedule'
}

export enum PomsPractitionerScheduleInput_Enum_Input {
  PomsPractitionerSchedule = 'PomsPractitionerSchedule'
}

/** Base StructureDefinition for PomsPractitionerScheduleWeekDayTimings. */
export type PomsPractitionerScheduleWeekDayTimings = {
  __typename?: 'PomsPractitionerScheduleWeekDayTimings';
  /** startTime data. */
  startTime?: Maybe<Scalars['String']>;
  /** endTime  data. */
  endTime?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerExtension Type: Custom Fields . */
export type PomsPractitionerScheduleWeekDayTimings_Input = {
  /** Professional Type Id. */
  professionalId?: Maybe<Scalars['String']>;
  /** Appointment Type Master ID. */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** Appointment Duration. */
  appointmentDuration?: Maybe<Scalars['Int']>;
  /** Appointment Mode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** custom1 field data. */
  startTime?: Maybe<Scalars['String']>;
  /** custom2 field data. */
  endTime?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PomsPractitionerScheduleWeekDayTimings. */
export type PomsPractitionerScheduleWeekTimings = {
  __typename?: 'PomsPractitionerScheduleWeekTimings';
  /** Professional Type Id. */
  professionalId?: Maybe<Scalars['String']>;
  /** Appointment Type Master ID. */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** Appointment Type Master ID. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** Appointment Duration. */
  appointmentDuration?: Maybe<Scalars['Int']>;
  /** Week Day Number. */
  weekDayNumber?: Maybe<Scalars['Int']>;
  /** Week Day Name. */
  weekDayName?: Maybe<Scalars['String']>;
  /** Week Timings */
  weekDayTimings?: Maybe<Array<Maybe<PomsPractitionerScheduleWeekDayTimings>>>;
};

/** Practitioner Week Timings Schedule */
export type PomsPractitionerScheduleWeekTimings_Input = {
  /** Week Day Number. */
  weekDayNumber?: Maybe<Scalars['Int']>;
  /** Week Day Name. */
  weekDayName?: Maybe<Scalars['String']>;
  /** Week Timings */
  weekDayTimings?: Maybe<Array<Maybe<PomsPractitionerScheduleWeekDayTimings_Input>>>;
};

/** Practitioner Schedule */
export type PomsPractitionerSchedule_Input = {
  /** Type of resource */
  resourceType: PomsPractitionerScheduleInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Location Id. */
  locationId?: Maybe<Scalars['String']>;
  /** Location Name. */
  locationName?: Maybe<Scalars['String']>;
  /** Color. */
  color?: Maybe<Scalars['String']>;
  /** defaultVisibility. */
  defaultVisibility?: Maybe<Scalars['Int']>;
  /** breakRequired. */
  breakRequiredType?: Maybe<Scalars['String']>;
  /** breakRequired. */
  breakRequired?: Maybe<Scalars['Int']>;
  /** breakRequiredTime. */
  breakRequiredTime?: Maybe<Scalars['Int']>;
  /** breakRequiredTimeType. */
  breakRequiredTimeType?: Maybe<Scalars['Int']>;
  /** breakRequiredTime. */
  breakRequiredFinalTime?: Maybe<Scalars['Int']>;
  /** From Date. */
  fromDate?: Maybe<Scalars['String']>;
  /** To Date. */
  toDate?: Maybe<Scalars['String']>;
  /** Is Repeat. */
  isRepeat?: Maybe<Scalars['Int']>;
  /** Is Repeat. */
  repeatType?: Maybe<Scalars['String']>;
  /** Repeat Every Number. */
  repeatEveryNumber?: Maybe<Scalars['Int']>;
  /** Week Timings */
  weekTimings?: Maybe<Array<Maybe<PomsPractitionerScheduleWeekTimings_Input>>>;
  /** Practitioner that is the custodian of the Schedule. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** Repeat Every Number. */
  endOnType?: Maybe<Scalars['Int']>;
  /** Repeat Every Number. */
  endOnDate?: Maybe<Scalars['String']>;
  /** Repeat Every Number. */
  endOnAfterNoOfOccurences?: Maybe<Scalars['Int']>;
  /** Repeat repeatSelectType. */
  repeatSelectType?: Maybe<Scalars['Int']>;
};

/** PomsReferral_Schema */
export type PomsReferral = {
  __typename?: 'PomsReferral';
  /** Type of resource */
  resourceType: PomsReferral_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Referral_Type. */
  referral_Type?: Maybe<Scalars['String']>;
  /** Referrer_Title. */
  referrer_Title?: Maybe<Scalars['String']>;
  /** Referrer_FirstName. */
  referrer_FirstName?: Maybe<Scalars['String']>;
  /** Referrer_SurName. */
  referrer_SurName?: Maybe<Scalars['String']>;
  /** referrer_OrganizationName. */
  referrer_OrganizationName?: Maybe<Scalars['String']>;
  /** referrer_Role. */
  referrer_Role?: Maybe<Scalars['String']>;
  /** referrer_Other. */
  referrer_Other?: Maybe<Scalars['String']>;
  /** referrer_PostCode. */
  referrer_PostCode?: Maybe<Scalars['String']>;
  /** referrer_Address1. */
  referrer_Address1?: Maybe<Scalars['String']>;
  /** referrer_Address2. */
  referrer_Address2?: Maybe<Scalars['String']>;
  /** referrer_Address3. */
  referrer_Address3?: Maybe<Scalars['String']>;
  /** referrer_City. */
  referrer_City?: Maybe<Scalars['String']>;
  /** referrer_County. */
  referrer_County?: Maybe<Scalars['String']>;
  /** referrer_Country. */
  referrer_Country?: Maybe<Scalars['String']>;
  /** referrer_PhoneNumber. */
  referrer_PhoneNumber?: Maybe<Scalars['String']>;
  /** referrer_FaxNumber. */
  referrer_FaxNumber?: Maybe<Scalars['String']>;
  /** referrer_Email. */
  referrer_Email?: Maybe<Scalars['String']>;
  /** referrer_Website. */
  referrer_Website?: Maybe<Scalars['String']>;
  /** referral_Title. */
  referral_Title?: Maybe<Scalars['String']>;
  /** referral_FirstName. */
  referral_FirstName?: Maybe<Scalars['String']>;
  /** referral_SurName. */
  referral_SurName?: Maybe<Scalars['String']>;
  /** referral_Dob. */
  referral_Dob?: Maybe<Scalars['String']>;
  /** referral_ReferenceNumber. */
  referral_ReferenceNumber?: Maybe<Scalars['String']>;
  /** referral_PhoneNumber. */
  referral_PhoneNumber?: Maybe<Scalars['String']>;
  /** referral_Email. */
  referral_Email?: Maybe<Scalars['String']>;
  /** referral_PostCode. */
  referral_PostCode?: Maybe<Scalars['String']>;
  /** referral_Address1. */
  referral_Address1?: Maybe<Scalars['String']>;
  /** referral_Address2. */
  referral_Address2?: Maybe<Scalars['String']>;
  /** referral_Address3. */
  referral_Address3?: Maybe<Scalars['String']>;
  /** referral_City. */
  referral_City?: Maybe<Scalars['String']>;
  /** referral_County. */
  referral_County?: Maybe<Scalars['String']>;
  /** referral_Country. */
  referral_Country?: Maybe<Scalars['String']>;
  /** referral_AssessmentFunded. */
  referral_AssessmentFunded?: Maybe<Scalars['String']>;
  /** referral_KindOfCase. */
  referral_KindOfCase?: Maybe<Scalars['String']>;
  /** referral_CaseInfo. */
  referral_CaseInfo?: Maybe<Scalars['String']>;
  /** referral_CaseInfoOthers. */
  referral_CaseInfoOthers?: Maybe<Scalars['String']>;
  /** referral_Other. */
  referral_Other?: Maybe<Scalars['String']>;
  /** typeOfReferral_Assessments. */
  typeOfReferral_Assessments?: Maybe<Scalars['String']>;
  /** typeOfReferral_RecommendationTreatments. */
  typeOfReferral_RecommendationTreatments?: Maybe<Scalars['String']>;
  /** typeOfReferral_OccupationalHealthReport. */
  typeOfReferral_OccupationalHealthReport?: Maybe<Scalars['String']>;
  /** typeOfReferral_OngoingTreatmentCare. */
  typeOfReferral_OngoingTreatmentCare?: Maybe<Scalars['String']>;
  /** typeOfReferral_Other. */
  typeOfReferral_Other?: Maybe<Scalars['String']>;
  /** referral_Urgent. */
  referral_Urgent?: Maybe<Scalars['String']>;
  /** referral_RiskToSelfOrOthers. */
  referral_RiskToSelfOrOthers?: Maybe<Scalars['String']>;
  /** referral_SocialCare. */
  referral_SocialCare?: Maybe<Scalars['String']>;
  /** referral_Reason. */
  referral_Reason?: Maybe<Scalars['String']>;
  /** appointmentDocuments */
  referral_UploadDocuments?: Maybe<DocumentReference>;
  /** referral_Comments. */
  referral_Comments?: Maybe<Scalars['String']>;
  /** expectationFromReferral. */
  expectationFromReferral?: Maybe<Scalars['String']>;
  /** referral_VerbalConsentCheck. */
  referral_VerbalConsentCheck?: Maybe<Scalars['String']>;
  /** referral_TermsAndConditions */
  referral_TermsAndConditions?: Maybe<Scalars['String']>;
  /** referral_createdOn */
  referral_createdOn?: Maybe<Scalars['String']>;
  /** typeOfReferral */
  typeOfReferral?: Maybe<Scalars['Int']>;
  /** referredPractitionerId. */
  referredPractitionerId?: Maybe<Scalars['String']>;
  /** referredPractitionerName. */
  referredPractitionerName?: Maybe<Scalars['String']>;
  /** referredPractitionerName. */
  referredPractitionerSpecialization?: Maybe<Scalars['String']>;
  /** patientId. */
  patientId?: Maybe<Scalars['String']>;
  /** practitionerName. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitionerId. */
  practitionerId?: Maybe<Scalars['String']>;
  /** patientName. */
  patientName?: Maybe<Scalars['String']>;
  /** practitionerSpeciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** status. */
  status?: Maybe<Scalars['Int']>;
  /** Specialisation. */
  referrer_Specialisation?: Maybe<Scalars['String']>;
  /** Specialisation. */
  referrer_Location?: Maybe<Scalars['String']>;
  /** patientName. */
  patientAddress?: Maybe<Scalars['String']>;
  /** patientName. */
  patientEmail?: Maybe<Scalars['String']>;
  /** patientName. */
  patientPhone?: Maybe<Scalars['String']>;
  /** Contacted Patient. */
  patientContacted?: Maybe<Scalars['Int']>;
  /** Contacted Patient. */
  thirdPartyContacted?: Maybe<Scalars['Int']>;
  /** Contacted Patient. */
  sentTermsConditions?: Maybe<Scalars['Int']>;
  /** Contacted Patient. */
  referralUpdateType?: Maybe<Scalars['String']>;
};

export enum PomsReferralInput_Enum_Input {
  PomsReferral = 'PomsReferral'
}

export enum PomsReferral_Enum {
  PomsReferral = 'PomsReferral'
}

/** PomsReferral */
export type PomsReferral_Input = {
  /** Type of resource */
  resourceType: PomsReferralInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Referral_Type. */
  referral_Type?: Maybe<Scalars['String']>;
  /** Referrer_Title. */
  referrer_Title?: Maybe<Scalars['String']>;
  /** Referrer_FirstName. */
  referrer_FirstName?: Maybe<Scalars['String']>;
  /** Referrer_SurName. */
  referrer_SurName?: Maybe<Scalars['String']>;
  /** referrer_OrganizationName. */
  referrer_OrganizationName?: Maybe<Scalars['String']>;
  /** referrer_Role. */
  referrer_Role?: Maybe<Scalars['String']>;
  /** referrer_Other. */
  referrer_Other?: Maybe<Scalars['String']>;
  /** referrer_PostCode. */
  referrer_PostCode?: Maybe<Scalars['String']>;
  /** referrer_Address1. */
  referrer_Address1?: Maybe<Scalars['String']>;
  /** referrer_Address2. */
  referrer_Address2?: Maybe<Scalars['String']>;
  /** referrer_Address3. */
  referrer_Address3?: Maybe<Scalars['String']>;
  /** referrer_City. */
  referrer_City?: Maybe<Scalars['String']>;
  /** referrer_County. */
  referrer_County?: Maybe<Scalars['String']>;
  /** referrer_Country. */
  referrer_Country?: Maybe<Scalars['String']>;
  /** referrer_PhoneNumber. */
  referrer_PhoneNumber?: Maybe<Scalars['String']>;
  /** referrer_FaxNumber. */
  referrer_FaxNumber?: Maybe<Scalars['String']>;
  /** referrer_Email. */
  referrer_Email?: Maybe<Scalars['String']>;
  /** referrer_Website. */
  referrer_Website?: Maybe<Scalars['String']>;
  /** referral_Title. */
  referral_Title?: Maybe<Scalars['String']>;
  /** referral_FirstName. */
  referral_FirstName?: Maybe<Scalars['String']>;
  /** referral_SurName. */
  referral_SurName?: Maybe<Scalars['String']>;
  /** referral_Dob. */
  referral_Dob?: Maybe<Scalars['String']>;
  /** referral_ReferenceNumber. */
  referral_ReferenceNumber?: Maybe<Scalars['String']>;
  /** referral_PhoneNumber. */
  referral_PhoneNumber?: Maybe<Scalars['String']>;
  /** referral_Email. */
  referral_Email?: Maybe<Scalars['String']>;
  /** referral_PostCode. */
  referral_PostCode?: Maybe<Scalars['String']>;
  /** referral_Address1. */
  referral_Address1?: Maybe<Scalars['String']>;
  /** referral_Address2. */
  referral_Address2?: Maybe<Scalars['String']>;
  /** referral_Address3. */
  referral_Address3?: Maybe<Scalars['String']>;
  /** referral_City. */
  referral_City?: Maybe<Scalars['String']>;
  /** referral_County. */
  referral_County?: Maybe<Scalars['String']>;
  /** referral_Country. */
  referral_Country?: Maybe<Scalars['String']>;
  /** referral_AssessmentFunded. */
  referral_AssessmentFunded?: Maybe<Scalars['String']>;
  /** referral_KindOfCase. */
  referral_KindOfCase?: Maybe<Scalars['String']>;
  /** referral_CaseInfo. */
  referral_CaseInfo?: Maybe<Scalars['String']>;
  /** referral_CaseInfoOthers. */
  referral_CaseInfoOthers?: Maybe<Scalars['String']>;
  /** referral_Other. */
  referral_Other?: Maybe<Scalars['String']>;
  /** typeOfReferral_Assessments. */
  typeOfReferral_Assessments?: Maybe<Scalars['String']>;
  /** typeOfReferral_RecommendationTreatments. */
  typeOfReferral_RecommendationTreatments?: Maybe<Scalars['String']>;
  /** typeOfReferral_OccupationalHealthReport. */
  typeOfReferral_OccupationalHealthReport?: Maybe<Scalars['String']>;
  /** typeOfReferral_OngoingTreatmentCare. */
  typeOfReferral_OngoingTreatmentCare?: Maybe<Scalars['String']>;
  /** typeOfReferral_Other. */
  typeOfReferral_Other?: Maybe<Scalars['String']>;
  /** referral_Urgent. */
  referral_Urgent?: Maybe<Scalars['String']>;
  /** referral_RiskToSelfOrOthers. */
  referral_RiskToSelfOrOthers?: Maybe<Scalars['String']>;
  /** referral_SocialCare. */
  referral_SocialCare?: Maybe<Scalars['String']>;
  /** referral_Reason. */
  referral_Reason?: Maybe<Scalars['String']>;
  /** appointmentDocuments */
  referral_UploadDocuments?: Maybe<DocumentReference_Input>;
  /** referral_Comments. */
  referral_Comments?: Maybe<Scalars['String']>;
  /** expectationFromReferral. */
  expectationFromReferral?: Maybe<Scalars['String']>;
  /** referral_VerbalConsentCheck. */
  referral_VerbalConsentCheck?: Maybe<Scalars['String']>;
  /** referral_TermsAndConditions */
  referral_TermsAndConditions?: Maybe<Scalars['String']>;
  /** referral_createdOn */
  referral_createdOn?: Maybe<Scalars['String']>;
  /** typeOfReferral */
  typeOfReferral?: Maybe<Scalars['Int']>;
  /** referredPractitionerId. */
  referredPractitionerId?: Maybe<Scalars['String']>;
  /** referredPractitionerName. */
  referredPractitionerName?: Maybe<Scalars['String']>;
  /** referredPractitionerName. */
  referredPractitionerSpecialization?: Maybe<Scalars['String']>;
  /** patientId. */
  patientId?: Maybe<Scalars['String']>;
  /** practitionerName. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitionerId. */
  practitionerId?: Maybe<Scalars['String']>;
  /** patientName. */
  patientName?: Maybe<Scalars['String']>;
  /** practitionerSpeciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** status. */
  status?: Maybe<Scalars['String']>;
  /** Specialisation. */
  referrer_Specialisation?: Maybe<Scalars['String']>;
  /** Specialisation. */
  referrer_Location?: Maybe<Scalars['String']>;
  /** patientName. */
  patientEmail?: Maybe<Scalars['String']>;
  /** patientName. */
  patientPhone?: Maybe<Scalars['String']>;
  /** patientName. */
  patientAddress?: Maybe<Scalars['String']>;
  /** Contacted Patient. */
  patientContacted?: Maybe<Scalars['Int']>;
  /** Contacted Patient. */
  thirdPartyContacted?: Maybe<Scalars['Int']>;
  /** Contacted Patient. */
  sentTermsConditions?: Maybe<Scalars['Int']>;
  /** Contacted Patient. */
  referralUpdateType?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Population Type: A populatioof people with some set of grouping criteria. */
export type Population = {
  __typename?: 'Population';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The age of the specific population. */
  ageRange?: Maybe<Range>;
  /** The age of the specific population. */
  ageCodeableConcept?: Maybe<CodeableConcept>;
  /** The gender of the specific population. */
  gender?: Maybe<CodeableConcept>;
  /** Race of the specific population. */
  race?: Maybe<CodeableConcept>;
  /** The existing physiological conditions of the specific population to which this applies. */
  physiologicalCondition?: Maybe<CodeableConcept>;
};

/** Base StructureDefinition for PractionerExtension Type: About us . */
export type PractionerAboutUs_Extension = {
  __typename?: 'PractionerAboutUs_Extension';
  /** about data. */
  about?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  personalStatement?: Maybe<Scalars['String']>;
  /** profileTags field data. */
  profileTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** videourl field data. */
  videourl?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerExtension Type: Custom Fields . */
export type PractionerAboutUs_Input = {
  /** about data. */
  about?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  personalStatement?: Maybe<Scalars['String']>;
  /** profileTags field data. */
  profileTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** videourl field data. */
  videourl?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerAccreditationExtension Type: Custom Fields . */
export type PractionerAccreditationExtension = {
  __typename?: 'PractionerAccreditationExtension';
  /** Health Code Identifierfield data. */
  healthcodeIdentifier?: Maybe<Scalars['String']>;
  /** Provider Number field data. */
  providerNo?: Maybe<Scalars['String']>;
  /** Insurance Company Name field data. */
  insuranceCompanyName?: Maybe<Scalars['String']>;
  /** Registration Date field data. */
  registrationDate?: Maybe<Scalars['String']>;
  /** imageUrl field data. */
  imageUrl?: Maybe<Scalars['String']>;
  /** shareData field data. */
  shareData?: Maybe<Scalars['Boolean']>;
};

/** Base StructureDefinition for PractionerAccreditationExtension_Input Type: Custom Fields . */
export type PractionerAccreditationExtension_Input = {
  /** Health Code Identifierfield data. */
  healthcodeIdentifier?: Maybe<Scalars['String']>;
  /** Provider Number field data. */
  providerNo?: Maybe<Scalars['String']>;
  /** Insurance Company Name field data. */
  insuranceCompanyName?: Maybe<Scalars['String']>;
  /** Registration Date field data. */
  registrationDate?: Maybe<Scalars['String']>;
  /** imageUrl field data. */
  imageUrl?: Maybe<Scalars['String']>;
  /** shareData field data. */
  shareData?: Maybe<Scalars['Boolean']>;
};

/** Base StructureDefinition for PractionerAffiliationExtension Type: Custom Fields . */
export type PractionerAffiliationExtension = {
  __typename?: 'PractionerAffiliationExtension';
  /** Institution Name field data. */
  institutionName?: Maybe<Scalars['String']>;
  /** Relationship With Organization field data. */
  relationshipWithOrganization?: Maybe<Scalars['String']>;
  /** FromDate field data. */
  fromDate?: Maybe<Scalars['String']>;
  /** To Date field data. */
  toDate?: Maybe<Scalars['String']>;
  /** Country field data. */
  country?: Maybe<Scalars['String']>;
  /** Title field data. */
  title?: Maybe<Scalars['String']>;
  /** Supervisors First Name field data. */
  supervisorsFirstName?: Maybe<Scalars['String']>;
  /** Supervisors Last Name field data. */
  supervisorsLastName?: Maybe<Scalars['String']>;
  /** Mobile field data. */
  mobile?: Maybe<Scalars['String']>;
  /** Email field data. */
  email?: Maybe<Scalars['String']>;
  /** AlternateEmail field data. */
  alternateEmail?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerAffiliationExtension_Input Type: Custom Fields . */
export type PractionerAffiliationExtension_Input = {
  /** Institution Name field data. */
  institutionName?: Maybe<Scalars['String']>;
  /** Relationship With Organization field data. */
  relationshipWithOrganization?: Maybe<Scalars['String']>;
  /** FromDate field data. */
  fromDate?: Maybe<Scalars['String']>;
  /** To Date field data. */
  toDate?: Maybe<Scalars['String']>;
  /** Country field data. */
  country?: Maybe<Scalars['String']>;
  /** Title field data. */
  title?: Maybe<Scalars['String']>;
  /** Supervisors First Name field data. */
  supervisorsFirstName?: Maybe<Scalars['String']>;
  /** Supervisors Last Name field data. */
  supervisorsLastName?: Maybe<Scalars['String']>;
  /** Mobile field data. */
  mobile?: Maybe<Scalars['String']>;
  /** Email field data. */
  email?: Maybe<Scalars['String']>;
  /** AlternateEmail field data. */
  alternateEmail?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerAwardsExtension Type: Custom Fields . */
export type PractionerAwardsExtension = {
  __typename?: 'PractionerAwardsExtension';
  /** Award Name field data. */
  awardName?: Maybe<Scalars['String']>;
  /** Awarded On field data. */
  awardedOn?: Maybe<Scalars['String']>;
  /** Institution Name field data. */
  institutionName?: Maybe<Scalars['String']>;
  /** Country field data. */
  country?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerAwardsExtension_Input Type: Custom Fields . */
export type PractionerAwardsExtension_Input = {
  /** Award Name field data. */
  awardName?: Maybe<Scalars['String']>;
  /** Awarded On field data. */
  awardedOn?: Maybe<Scalars['String']>;
  /** Institution Name field data. */
  institutionName?: Maybe<Scalars['String']>;
  /** Country field data. */
  country?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerExtension Type: Emergency . */
export type PractionerEmergency_Extension = {
  __typename?: 'PractionerEmergency_Extension';
  /** full name. */
  fullname?: Maybe<Scalars['String']>;
  /** realtionship data. */
  realtionship?: Maybe<Scalars['String']>;
  /** mobile data. */
  mobile?: Maybe<Scalars['String']>;
  /** email data. */
  email?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerExtension Type: Custom Fields . */
export type PractionerEmergency_Extension_Input = {
  /** full name. */
  fullname?: Maybe<Scalars['String']>;
  /** realtionship data. */
  realtionship?: Maybe<Scalars['String']>;
  /** mobile data. */
  mobile?: Maybe<Scalars['String']>;
  /** email data. */
  email?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerExpertiseExtension Type: Custom Fields . */
export type PractionerExpertiseExtension = {
  __typename?: 'PractionerExpertiseExtension';
  /** expertiseType data. */
  expertiseType?: Maybe<Scalars['String']>;
  /** expertiseType Values data. */
  expertiseTypeValues?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Base StructureDefinition for PractionerExpertiseExtension_Input Type: Custom Fields . */
export type PractionerExpertiseExtension_Input = {
  /** expertiseType field data. */
  expertiseType?: Maybe<Scalars['String']>;
  /** expertiseTypeValues field data. */
  expertiseTypeValues?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Base StructureDefinition for PractionerExtension Type: Custom Fields . */
export type PractionerExtension = {
  /** custom1 field data. */
  custom1?: Maybe<Scalars['String']>;
  /** custom2 field data. */
  custom2?: Maybe<Scalars['String']>;
  /** operationType field data. */
  operationType?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerExtension Type: Custom Fields . */
export type PractionerExtension_Input = {
  __typename?: 'PractionerExtension_Input';
  /** custom1 field data. */
  custom1?: Maybe<Scalars['String']>;
  /** custom2 field data. */
  custom2?: Maybe<Scalars['String']>;
  /** operationType field data. */
  operationType?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerAwardsExtension Type: Custom Fields . */
export type PractionerMediaExtension = {
  __typename?: 'PractionerMediaExtension';
  /** mediaOulet field data. */
  mediaOulet?: Maybe<Scalars['String']>;
  /** typeOfMedium field data. */
  typeOfMedium?: Maybe<Scalars['String']>;
  /** mentinedIn  field data. */
  mentinedIn?: Maybe<Scalars['String']>;
  /** url field data. */
  url?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerAwardsExtension_Input Type: Custom Fields . */
export type PractionerMediaExtension_Input = {
  /** mediaOulet field data. */
  mediaOulet?: Maybe<Scalars['String']>;
  /** typeOfMedium field data. */
  typeOfMedium?: Maybe<Scalars['String']>;
  /** mentinedIn  field data. */
  mentinedIn?: Maybe<Scalars['String']>;
  /** url field data. */
  url?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerPublicationsExtension Type: Custom Fields . */
export type PractionerPublicationsExtension = {
  __typename?: 'PractionerPublicationsExtension';
  /** Publication Name field data. */
  publicationName?: Maybe<Scalars['String']>;
  /** Publication Type field data. */
  publicationType?: Maybe<Scalars['String']>;
  /** Published Date field data. */
  publishedOn?: Maybe<Scalars['String']>;
  /** url field data. */
  url?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerPublicationsExtension_Input Type: Custom Fields . */
export type PractionerPublicationsExtension_Input = {
  /** Publication Name field data. */
  publicationName?: Maybe<Scalars['String']>;
  /** Publication Type field data. */
  publicationType?: Maybe<Scalars['String']>;
  /** Published Date field data. */
  publishedOn?: Maybe<Scalars['String']>;
  /** url field data. */
  url?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Practioner Recommendation */
export type PractionerRecommendation_Extension = {
  __typename?: 'PractionerRecommendation_Extension';
  /** recommendationId */
  recommendationId?: Maybe<Scalars['String']>;
  /** fromPractitionerId */
  fromPractitionerId?: Maybe<Scalars['id']>;
  /** fromPractitionerName */
  fromPractitionerName?: Maybe<Scalars['String']>;
  /** fromPractitionerEmail. */
  fromPractitionerEmail?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  roleName?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  toPractitionerId?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  toPractitionerName?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  toPractitionerEmail?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** recommendationText data. */
  recommendationText?: Maybe<Scalars['String']>;
  /** recommendationSentFrom data. */
  recommendationSentFrom?: Maybe<Scalars['Int']>;
  /** recommendationStatus data. */
  recommendationStatus?: Maybe<Scalars['Int']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerRecommendation_Extension_Input. */
export type PractionerRecommendation_Extension_Input = {
  /** recommendationId */
  recommendationId?: Maybe<Scalars['String']>;
  /** fromPractitionerId */
  fromPractitionerId?: Maybe<Scalars['id']>;
  /** fromPractitionerName */
  fromPractitionerName?: Maybe<Scalars['String']>;
  /** fromPractitionerEmail. */
  fromPractitionerEmail?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  roleName?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  toPractitionerId?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  toPractitionerName?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  toPractitionerEmail?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** recommendationText data. */
  recommendationText?: Maybe<Scalars['String']>;
  /** recommendationSentFrom data. */
  recommendationSentFrom?: Maybe<Scalars['Int']>;
  /** recommendationStatus data. */
  recommendationStatus?: Maybe<Scalars['Int']>;
  /** publishedOn. */
  updatedOn?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerReview_Extension Type: Reviews . */
export type PractionerReview_Extension = {
  __typename?: 'PractionerReview_Extension';
  /** ratings */
  reviewId?: Maybe<Scalars['String']>;
  /** ratings */
  rating?: Maybe<Scalars['Float']>;
  /** personalStatement data. */
  review?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  patientId?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  patientName?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  appointmentId?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  reviewStatus?: Maybe<Scalars['Int']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  reviewType?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  isBookingAppointmentEasy?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  isVideoQualityGood?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  questionnarieFillingFor?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  isDoctorPolite?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  isDoctorListenedToYou?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  isAssessmentFeltComplete?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  isInvolvedInDecisions?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  isAbleToProvideTreatment?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  happyToSeeDoctorAgain?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  recommendThisDoctor?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerReview_Extension_Input. */
export type PractionerReview_Extension_Input = {
  /** ratings */
  reviewId?: Maybe<Scalars['String']>;
  /** ratings */
  rating?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  review?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  patientId?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  patientName?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  appointmentId?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  reviewStatus?: Maybe<Scalars['Int']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  reviewType?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  isBookingAppointmentEasy?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  isVideoQualityGood?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  questionnarieFillingFor?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  isDoctorPolite?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  isDoctorListenedToYou?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  isAssessmentFeltComplete?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  isInvolvedInDecisions?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  isAbleToProvideTreatment?: Maybe<Scalars['Int']>;
  /** personalStatement data. */
  happyToSeeDoctorAgain?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  recommendThisDoctor?: Maybe<Scalars['String']>;
};

/** A person who is directly or indirectly involved in the provisioning of healthcare. */
export type Practitioner = {
  __typename?: 'Practitioner';
  /** Type of resource */
  resourceType: Practitioner_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** Practioner Extension to add custom fields. */
  practionerExtension?: Maybe<PractionerExtension_Input>;
  /** Practioner Extension to add custom fields. */
  practionerAbout?: Maybe<PractionerAboutUs_Extension>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An identifier that applies to this person in this role. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Whether this practitioner's record is in active use. */
  _active?: Maybe<Element>;
  /** Whether this practitioner's record is in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The name(s) associated with the practitioner. */
  name?: Maybe<Array<Maybe<HumanName>>>;
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /**
   * Address(es) of the practitioner that are not role specific (typically home
   * address).  Work addresses are not typically entered in this property as they
   * are usually role dependent.
   */
  address?: Maybe<Array<Maybe<Address>>>;
  /** Administrative Gender - the gender that the person is considered to have for administration and record keeping purposes. */
  _gender?: Maybe<Element>;
  /** Administrative Gender - the gender that the person is considered to have for administration and record keeping purposes. */
  gender?: Maybe<Scalars['code']>;
  /** Practitioner nationality. */
  nationality?: Maybe<Scalars['code']>;
  /** The date of birth for the practitioner. */
  _birthDate?: Maybe<Element>;
  /** The date of birth for the practitioner. */
  birthDate?: Maybe<Scalars['date']>;
  /** Image of the person. */
  photo?: Maybe<Array<Maybe<Attachment>>>;
  /** Practitioner Awards. */
  awards?: Maybe<Array<Maybe<PractionerAwardsExtension>>>;
  /** Practitioner Media. */
  media?: Maybe<Array<Maybe<PractionerMediaExtension>>>;
  /** Practitioner Awards. */
  publications?: Maybe<Array<Maybe<PractionerPublicationsExtension>>>;
  /** Practitioner Awards. */
  affiliations?: Maybe<Array<Maybe<PractionerAffiliationExtension>>>;
  /** Practitioner Accreditations. */
  accreditations?: Maybe<Array<Maybe<PractionerAccreditationExtension>>>;
  /**
   * The official certifications, training, and licenses that authorize or
   * otherwise pertain to the provision of care by the practitioner.  For example,
   * a medical license issued by a medical board authorizing the practitioner to
   * practice medicine within a certian locality.
   */
  qualification?: Maybe<Array<Maybe<Practitionerqualification>>>;
  /** A language the practitioner can use in patient communication. */
  communication?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The band in which the resource is written. */
  band?: Maybe<Scalars['code']>;
  /** The years Of Exp in which the resource is written. */
  yearsOfExp?: Maybe<Scalars['code']>;
  /** The over All Ratings in which the resource is written. */
  overAllRatings?: Maybe<Scalars['code']>;
  /** The ratings in which the resource is written. */
  ratings?: Maybe<Scalars['code']>;
  /** The ratings in which the resource is written. */
  speciality?: Maybe<Scalars['String']>;
  /** A language the practitioner can use in patient communication. */
  subSpecialtyMaster?: Maybe<Scalars['String']>;
  /** The ratings in which the resource is written. */
  conditions?: Maybe<Scalars['String']>;
  /** Emergency Contact. */
  emergencyContact?: Maybe<Array<Maybe<PractionerEmergency_Extension>>>;
  /** The ratings in which the resource is written. */
  subspeciality?: Maybe<Scalars['String']>;
  /** Reviews. */
  reviews?: Maybe<Array<Maybe<PractionerReview_Extension>>>;
  /** Practitioner Accreditations. */
  recommendations?: Maybe<Array<Maybe<PractionerRecommendation_Extension>>>;
  /** The ratings in which the resource is written. */
  status?: Maybe<Scalars['Int']>;
  /** The ratings in which the resource is written. */
  message?: Maybe<Scalars['String']>;
  /** fullName. */
  fullName?: Maybe<Scalars['String']>;
  /** accountStatus. */
  accountStatus?: Maybe<Scalars['Int']>;
  /** communicationStatus. */
  communicationStatus?: Maybe<Scalars['Int']>;
  /** communicationStatus. */
  communicationUpdated?: Maybe<Scalars['Int']>;
  /** communicationStatus. */
  isPublished?: Maybe<Scalars['Int']>;
  /** isPublished. */
  createdOn?: Maybe<Scalars['String']>;
};

export enum PractitionerNotification_Enum_Input {
  PractitionerNotification = 'PractitionerNotification'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PractitionerNotifications = {
  __typename?: 'PractitionerNotifications';
  /** Type of resource */
  resourceType: PractitionerNotification_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  notificationMessage?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  createdOn?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  notificationUrl?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  type?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  isRead?: Maybe<Scalars['Boolean']>;
  /** buildingSocietyName field data. */
  limit?: Maybe<Scalars['Int']>;
  /** buildingSocietyName field data. */
  skip?: Maybe<Scalars['Int']>;
};

export enum PractitionerNotifications_Enum_Input {
  PractitionerNotification = 'PractitionerNotification'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PractitionerNotifications_Input = {
  /** Type of resource */
  resourceType: PractitionerNotifications_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  notificationMessage?: Maybe<Scalars['Int']>;
  /** buildingSocietyName field data. */
  createdOn?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  isRead?: Maybe<Scalars['Boolean']>;
  /** buildingSocietyName field data. */
  isNotificationAll?: Maybe<Scalars['Boolean']>;
};

/** PractitionerPatientCommunication. */
export type PractitionerPatientCommunication = {
  __typename?: 'PractitionerPatientCommunication';
  /** Type of resource */
  resourceType: PractitionerPatientCommunication_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** fromEmail. */
  commFromType?: Maybe<Scalars['Int']>;
  /** fromEmail. */
  commToType?: Maybe<Scalars['Int']>;
  /** fromEmail. */
  fromId?: Maybe<Scalars['String']>;
  /** fromEmail. */
  fromEmail?: Maybe<Scalars['String']>;
  /** fromEmail. */
  fromName?: Maybe<Scalars['String']>;
  /** toEmail. */
  toEmail?: Maybe<Scalars['String']>;
  /** toEmail. */
  toName?: Maybe<Scalars['String']>;
  /** fromEmail. */
  toId?: Maybe<Scalars['String']>;
  /** ccEmail. */
  ccEmail?: Maybe<Scalars['String']>;
  /** bccEmail. */
  bccEmail?: Maybe<Scalars['String']>;
  /** channel */
  channel?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  status?: Maybe<Scalars['String']>;
  /** readStatus Id. */
  readStatus?: Maybe<Scalars['String']>;
  /** subject. */
  subject?: Maybe<Scalars['String']>;
  /** messageContent. */
  messageContent?: Maybe<Scalars['String']>;
  /** patientId. */
  patientId?: Maybe<Scalars['String']>;
  /** practitionerId. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitionerName. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitionerSpeciality */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** createdOn */
  createdOn?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  replies?: Maybe<Array<Maybe<PractitionerPatientCommunication>>>;
  /** createdOn */
  documentUrl?: Maybe<Scalars['String']>;
  /** createdOn */
  commFrom?: Maybe<Scalars['Int']>;
};

export enum PractitionerPatientCommunicationInput_Enum_Input {
  PractitionerPatientCommunication = 'PractitionerPatientCommunication'
}

export enum PractitionerPatientCommunication_Enum {
  PractitionerPatientCommunication = 'PractitionerPatientCommunication'
}

/** PractitionerPatientCommunication */
export type PractitionerPatientCommunication_Input = {
  /** Type of resource */
  resourceType: PractitionerPatientCommunicationInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** fromEmail. */
  commFromType?: Maybe<Scalars['Int']>;
  /** fromEmail. */
  commToType?: Maybe<Scalars['Int']>;
  /** fromEmail. */
  fromId?: Maybe<Scalars['String']>;
  /** fromEmail. */
  fromEmail?: Maybe<Scalars['String']>;
  /** fromEmail. */
  fromName?: Maybe<Scalars['String']>;
  /** toEmail. */
  toEmail?: Maybe<Scalars['String']>;
  /** toEmail. */
  toName?: Maybe<Scalars['String']>;
  /** fromEmail. */
  toId?: Maybe<Scalars['String']>;
  /** ccEmail. */
  ccEmail?: Maybe<Scalars['String']>;
  /** bccEmail. */
  bccEmail?: Maybe<Scalars['String']>;
  /** channel */
  channel?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  status?: Maybe<Scalars['String']>;
  /** readStatus Id. */
  readStatus?: Maybe<Scalars['String']>;
  /** subject. */
  subject?: Maybe<Scalars['String']>;
  /** messageContent. */
  messageContent?: Maybe<Scalars['String']>;
  /** patientId. */
  patientId?: Maybe<Scalars['String']>;
  /** practitionerId. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitionerName. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitionerSpeciality */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** createdOn */
  createdOn?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  replies?: Maybe<Array<Maybe<PractitionerPatientCommunication_Input>>>;
  /** createdOn */
  documentUrl?: Maybe<Scalars['String']>;
  /** createdOn */
  commFrom?: Maybe<Scalars['Int']>;
};

/** A person who is directly or indirectly involved in the provisioning of healthcare. */
export type PractitionerReviewCount = {
  __typename?: 'PractitionerReviewCount';
  /** Type of resource */
  resourceType: PractitionerReviewCount_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** isPublished. */
  reviewCount?: Maybe<Scalars['String']>;
  /** isPublished. */
  recommendationCount?: Maybe<Scalars['String']>;
};

export enum PractitionerReviewCount_Enum_Schema {
  Practitioner = 'Practitioner'
}

/**
 * A specific set of Roles/Locations/specialties/services that a practitioner may
 * perform at an organization for a period of time.
 */
export type PractitionerRole = {
  __typename?: 'PractitionerRole';
  /** Type of resource */
  resourceType: PractitionerRole_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** Practioner Extension to add custom fields. */
  practionerExtension?: Maybe<PractionerExtension_Input>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Business Identifiers that are specific to a role/location. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Whether this practitioner role record is in active use. */
  _active?: Maybe<Element>;
  /** Whether this practitioner role record is in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The period during which the person is authorized to act as a practitioner in these role(s) for the organization. */
  period?: Maybe<Period>;
  /**
   * The practioner expertise extension during which the person is expertise at act
   * as a practitioner in these role(s) for the organization.
   */
  expertise?: Maybe<Array<Maybe<PractionerExpertiseExtension>>>;
  /** Practitioner that is able to provide the defined services for the organization. */
  practitioner?: Maybe<PractitionerRolepractitioner_Practitioner_Union>;
  /** The organization where the Practitioner performs the roles associated. */
  organization?: Maybe<PractitionerRoleorganization_Organization_Union>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  code?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Specific specialty of the practitioner. */
  specialty?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Specific Sub specialty of the practitioner. */
  subSpecialty?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Specific specialty of the practitioner. */
  subSpecialtyMaster?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The base language in which the resource is written. */
  band?: Maybe<Scalars['code']>;
  /** The base language in which the resource is written. */
  yearsOfExp?: Maybe<Scalars['code']>;
  /** The location(s) at which this practitioner provides care. */
  location?: Maybe<Array<Maybe<PractitionerRolelocation_Location_Union>>>;
  /** The list of healthcare services that this worker provides for this role's Organization/Location(s). */
  healthcareService?: Maybe<Array<Maybe<PractitionerRolehealthcareService_HealthcareService_Union>>>;
  /** Contact details that are specific to the role/location/service. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** A collection of times the practitioner is available or performing this role at the location and/or healthcareservice. */
  availableTime?: Maybe<Array<Maybe<PractitionerRoleavailableTime>>>;
  /** The practitioner is not available or performing this role during this period of time due to the provided reason. */
  notAvailable?: Maybe<Array<Maybe<PractitionerRolenotAvailable>>>;
  /**
   * A description of site availability exceptions, e.g. public holiday
   * availability. Succinctly describing all possible exceptions to normal site
   * availability as details in the available Times and not available Times.
   */
  _availabilityExceptions?: Maybe<Element>;
  /**
   * A description of site availability exceptions, e.g. public holiday
   * availability. Succinctly describing all possible exceptions to normal site
   * availability as details in the available Times and not available Times.
   */
  availabilityExceptions?: Maybe<Scalars['String']>;
  /** Technical endpoints providing access to services operated for the practitioner with this role. */
  endpoint?: Maybe<Array<Maybe<PractitionerRoleendpoint_Endpoint_Union>>>;
};

export enum PractitionerRole_Enum_Input {
  PractitionerRole = 'PractitionerRole'
}

export enum PractitionerRole_Enum_Schema {
  PractitionerRole = 'PractitionerRole'
}

/**
 * A specific set of Roles/Locations/specialties/services that a practitioner may
 * perform at an organization for a period of time.
 */
export type PractitionerRole_Input = {
  /** Type of resource */
  resourceType: PractitionerRole_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Practioner Extension to add custom fields. */
  practionerExtension?: Maybe<PractionerExtension>;
  /** The base language in which the resource is written. */
  band?: Maybe<Scalars['code']>;
  /** The base language in which the resource is written. */
  yearsOfExp?: Maybe<Scalars['code']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Business Identifiers that are specific to a role/location. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /** Whether this practitioner role record is in active use. */
  _active?: Maybe<Element_Input>;
  /** Whether this practitioner role record is in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The period during which the person is authorized to act as a practitioner in these role(s) for the organization. */
  period?: Maybe<Period_Input>;
  /**
   * The practioner expertise extension during which the person is expertise at act
   * as a practitioner in these role(s) for the organization.
   */
  expertise?: Maybe<Array<Maybe<PractionerExpertiseExtension_Input>>>;
  /** Practitioner that is able to provide the defined services for the organization. */
  practitioner?: Maybe<Scalars['String']>;
  /** The organization where the Practitioner performs the roles associated. */
  organization?: Maybe<Scalars['String']>;
  /** Roles which this practitioner is authorized to perform for the organization. */
  code?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Specific specialty of the practitioner. */
  specialty?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Specific specialty of the practitioner. */
  subSpecialty?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Specific specialty of the practitioner. */
  subSpecialtyMaster?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The location(s) at which this practitioner provides care. */
  location?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The list of healthcare services that this worker provides for this role's Organization/Location(s). */
  healthcareService?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Contact details that are specific to the role/location/service. */
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>>>;
  /** A collection of times the practitioner is available or performing this role at the location and/or healthcareservice. */
  availableTime?: Maybe<Array<Maybe<PractitionerRoleavailableTime_Input>>>;
  /** The practitioner is not available or performing this role during this period of time due to the provided reason. */
  notAvailable?: Maybe<Array<Maybe<PractitionerRolenotAvailable_Input>>>;
  /**
   * A description of site availability exceptions, e.g. public holiday
   * availability. Succinctly describing all possible exceptions to normal site
   * availability as details in the available Times and not available Times.
   */
  _availabilityExceptions?: Maybe<Element_Input>;
  /**
   * A description of site availability exceptions, e.g. public holiday
   * availability. Succinctly describing all possible exceptions to normal site
   * availability as details in the available Times and not available Times.
   */
  availabilityExceptions?: Maybe<Scalars['String']>;
  /** Technical endpoints providing access to services operated for the practitioner with this role. */
  endpoint?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PractitionerRoleavailableTime = {
  __typename?: 'PractitionerRoleavailableTime';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates which days of the week are available between the start and end Times. */
  _daysOfWeek?: Maybe<Element>;
  /** Indicates which days of the week are available between the start and end Times. */
  daysOfWeek?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** Is this always available? (hence times are irrelevant) e.g. 24 hour service. */
  _allDay?: Maybe<Element>;
  /** Is this always available? (hence times are irrelevant) e.g. 24 hour service. */
  allDay?: Maybe<Scalars['Boolean']>;
  /** The opening time of day. Note: If the AllDay flag is set, then this time is ignored. */
  _availableStartTime?: Maybe<Element>;
  /** The opening time of day. Note: If the AllDay flag is set, then this time is ignored. */
  availableStartTime?: Maybe<Scalars['time']>;
  /** The closing time of day. Note: If the AllDay flag is set, then this time is ignored. */
  _availableEndTime?: Maybe<Element>;
  /** The closing time of day. Note: If the AllDay flag is set, then this time is ignored. */
  availableEndTime?: Maybe<Scalars['time']>;
};

export type PractitionerRoleavailableTime_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Indicates which days of the week are available between the start and end Times. */
  _daysOfWeek?: Maybe<Element_Input>;
  /** Indicates which days of the week are available between the start and end Times. */
  daysOfWeek?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** Is this always available? (hence times are irrelevant) e.g. 24 hour service. */
  _allDay?: Maybe<Element_Input>;
  /** Is this always available? (hence times are irrelevant) e.g. 24 hour service. */
  allDay?: Maybe<Scalars['Boolean']>;
  /** The opening time of day. Note: If the AllDay flag is set, then this time is ignored. */
  _availableStartTime?: Maybe<Element_Input>;
  /** The opening time of day. Note: If the AllDay flag is set, then this time is ignored. */
  availableStartTime?: Maybe<Scalars['time']>;
  /** The closing time of day. Note: If the AllDay flag is set, then this time is ignored. */
  _availableEndTime?: Maybe<Element_Input>;
  /** The closing time of day. Note: If the AllDay flag is set, then this time is ignored. */
  availableEndTime?: Maybe<Scalars['time']>;
};

/** Technical endpoints providing access to services operated for the practitioner with this role. */
export type PractitionerRoleendpoint_Endpoint_Union = Endpoint;

/** The list of healthcare services that this worker provides for this role's Organization/Location(s). */
export type PractitionerRolehealthcareService_HealthcareService_Union = HealthcareService;

/** The location(s) at which this practitioner provides care. */
export type PractitionerRolelocation_Location_Union = Location;

export type PractitionerRolenotAvailable = {
  __typename?: 'PractitionerRolenotAvailable';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The reason that can be presented to the user as to why this time is not available. */
  _description?: Maybe<Element>;
  /** The reason that can be presented to the user as to why this time is not available. */
  description: Scalars['String'];
  /** Service is not available (seasonally or for a public holiday) from this date. */
  during?: Maybe<Period>;
};

export type PractitionerRolenotAvailable_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The reason that can be presented to the user as to why this time is not available. */
  _description?: Maybe<Element_Input>;
  /** The reason that can be presented to the user as to why this time is not available. */
  description: Scalars['String'];
  /** Service is not available (seasonally or for a public holiday) from this date. */
  during?: Maybe<Period_Input>;
};

/** The organization where the Practitioner performs the roles associated. */
export type PractitionerRoleorganization_Organization_Union = Organization;

/** Practitioner that is able to provide the defined services for the organization. */
export type PractitionerRolepractitioner_Practitioner_Union = Practitioner;

/** PractitionerStatement_Schema. */
export type PractitionerStatement = {
  __typename?: 'PractitionerStatement';
  /** Type of resource */
  resourceType: PractitionerStatement_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** statementNo. */
  statementNo?: Maybe<Scalars['String']>;
  /** statementFromDate */
  statementFromDate?: Maybe<Scalars['String']>;
  /** statementToDate. */
  statementToDate?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** practitionerEmail. */
  practitionerEmail?: Maybe<Scalars['String']>;
  /** practitionerEmail. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitionerPhoneNumber. */
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  /** totalPaymentStatus. */
  totalPaymentStatus?: Maybe<Scalars['String']>;
  /** totalInvoiceAmount. */
  totalInvoiceAmount?: Maybe<Scalars['String']>;
  /** totalAmountPaid. */
  totalAmountPaid?: Maybe<Scalars['String']>;
  /** totalPendingAmount. */
  totalPendingAmount?: Maybe<Scalars['String']>;
  /** statementMonth. */
  statementMonth?: Maybe<Scalars['String']>;
  /** statementYear. */
  statementYear?: Maybe<Scalars['String']>;
  /** practitionerAddress. */
  practitionerAddress?: Maybe<Scalars['String']>;
  /** paymentDueDate. */
  paymentDueDate?: Maybe<Scalars['String']>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  statementItems?: Maybe<Array<Maybe<PractitionerStatementItem>>>;
};

/** PractitionerStatementItem_Schema. */
export type PractitionerStatementItem = {
  __typename?: 'PractitionerStatementItem';
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  /** invoiceDate. */
  statementNo?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  appointmentDate?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  appointmentTime?: Maybe<Scalars['String']>;
  /** appointmentNumber. */
  appointmentBookedForTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedBy. */
  appointmentBookedForFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedId. */
  appointmentBookedForSurName?: Maybe<Scalars['String']>;
  /** appointmentBookedDOB. */
  appointmentBookedForEmail?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentBookedForPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentId. */
  appointmentId?: Maybe<Scalars['String']>;
  /** appointmentDuration. */
  appointmentDuration?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  appointmentPrice?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointmentMode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** appointmentPayType. */
  appointmentPayType?: Maybe<Scalars['String']>;
  /** patientId. */
  patientId?: Maybe<Scalars['String']>;
  /** appointmentCreatedOn */
  createdOn?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  thirdPartyPayer?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiName?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiGroupId?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiPolicyNumber?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiAuthCode?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiAuthSession?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  paymentStatus?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  paymentToOkatree?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  paymentFromOkatree?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  statementPaidOn?: Maybe<Scalars['String']>;
  /** invoiceAmount. */
  statementAmount?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for PractionerExpertiseExtension_Input Type: Custom Fields . */
export type PractitionerStatementItem_Input = {
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  /** invoiceDate. */
  statementNo?: Maybe<Scalars['String']>;
  /** appointmentDate. */
  appointmentDate?: Maybe<Scalars['String']>;
  /** appointmentTime. */
  appointmentTime?: Maybe<Scalars['String']>;
  /** appointmentNumber. */
  appointmentBookedForTitle?: Maybe<Scalars['String']>;
  /** appointmentBookedBy. */
  appointmentBookedForFirstName?: Maybe<Scalars['String']>;
  /** appointmentBookedId. */
  appointmentBookedForSurName?: Maybe<Scalars['String']>;
  /** appointmentBookedDOB. */
  appointmentBookedForEmail?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentBookedForPhoneNumber?: Maybe<Scalars['String']>;
  /** appointmentId. */
  appointmentId?: Maybe<Scalars['String']>;
  /** appointmentDuration. */
  appointmentDuration?: Maybe<Scalars['String']>;
  /** appointmentPrice. */
  appointmentPrice?: Maybe<Scalars['String']>;
  /** appointmentType. */
  appointmentType?: Maybe<Scalars['String']>;
  /** appointmentMode. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** appointmentPayType. */
  appointmentPayType?: Maybe<Scalars['String']>;
  /** patientId. */
  patientId?: Maybe<Scalars['String']>;
  /** appointmentCreatedOn */
  createdOn?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  thirdPartyPayer?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiName?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiGroupId?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiPolicyNumber?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiAuthCode?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  pmiAuthSession?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  paymentStatus?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  paymentToOkatree?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  paymentFromOkatree?: Maybe<Scalars['String']>;
  /** invoiceUrl */
  statementPaidOn?: Maybe<Scalars['String']>;
  /** invoiceAmount. */
  statementAmount?: Maybe<Scalars['String']>;
};

export enum PractitionerStatement_Enum {
  PractitionerStatement = 'PractitionerStatement'
}

export enum PractitionerStatement_Enum_Input {
  PractitionerStatement = 'PractitionerStatement'
}

/** PractitionerStatement */
export type PractitionerStatement_Input = {
  /** Type of resource */
  resourceType: PractitionerStatement_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** statementNo. */
  statementNo?: Maybe<Scalars['String']>;
  /** statementFromDate */
  statementFromDate?: Maybe<Scalars['String']>;
  /** statementToDate. */
  statementToDate?: Maybe<Scalars['String']>;
  /** practitioner Id. */
  practitionerId?: Maybe<Scalars['String']>;
  /** practitioner Speciality. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** practitionerEmail. */
  practitionerEmail?: Maybe<Scalars['String']>;
  /** practitionerEmail. */
  practitionerName?: Maybe<Scalars['String']>;
  /** practitionerPhoneNumber. */
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  /** totalPaymentStatus. */
  totalPaymentStatus?: Maybe<Scalars['String']>;
  /** totalInvoiceAmount. */
  totalInvoiceAmount?: Maybe<Scalars['String']>;
  /** totalAmountPaid. */
  totalAmountPaid?: Maybe<Scalars['String']>;
  /** totalPendingAmount. */
  totalPendingAmount?: Maybe<Scalars['String']>;
  /** statementMonth. */
  statementMonth?: Maybe<Scalars['String']>;
  /** statementYear. */
  statementYear?: Maybe<Scalars['String']>;
  /** practitionerAddress. */
  practitionerAddress?: Maybe<Scalars['String']>;
  /** paymentDueDate. */
  paymentDueDate?: Maybe<Scalars['String']>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  statementItems?: Maybe<Array<Maybe<PractitionerStatementItem_Input>>>;
};

export enum PractitionerTaskInput_Enum_Input {
  PractitionerTask = 'PractitionerTask'
}

export enum PractitionerTask_Enum_Input {
  PractitionerTask = 'PractitionerTask'
}

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PractitionerTask_Input = {
  /** Type of resource */
  resourceType: PractitionerTaskInput_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  taskCount?: Maybe<Scalars['Int']>;
  /** nationalInsuranceNumber field data. */
  taskType?: Maybe<Scalars['Int']>;
  /** buildingSocietyName field data. */
  taskUrl?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  practitionerId?: Maybe<Scalars['String']>;
};

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track invoice and billings  of practitioner, etc.
 */
export type PractitionerTasks = {
  __typename?: 'PractitionerTasks';
  /** Type of resource */
  resourceType: PractitionerTask_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** entityType field data. */
  taskCount?: Maybe<Scalars['Int']>;
  /** nationalInsuranceNumber field data. */
  taskType?: Maybe<Scalars['Int']>;
  /** buildingSocietyName field data. */
  taskUrl?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  taskMessage?: Maybe<Scalars['String']>;
  /** buildingSocietyName field data. */
  practitionerId?: Maybe<Scalars['String']>;
};

export enum Practitioner_Enum_Input {
  Practitioner = 'Practitioner'
}

export enum Practitioner_Enum_Schema {
  Practitioner = 'Practitioner'
}

/** A person who is directly or indirectly involved in the provisioning of healthcare. */
export type Practitioner_Input = {
  /** Type of resource */
  resourceType: Practitioner_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Practioner Extension to add custom fields. */
  practionerExtension?: Maybe<PractionerExtension>;
  /** Practioner Extension to add custom fields. */
  practionerAbout?: Maybe<PractionerAboutUs_Input>;
  /** An identifier that applies to this person in this role. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /** Whether this practitioner's record is in active use. */
  _active?: Maybe<Element_Input>;
  /** Whether this practitioner's record is in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The name(s) associated with the practitioner. */
  name?: Maybe<Array<Maybe<HumanName_Input>>>;
  /** A contact detail for the practitioner, e.g. a telephone number or an email address. */
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>>>;
  /**
   * Address(es) of the practitioner that are not role specific (typically home
   * address).  Work addresses are not typically entered in this property as they
   * are usually role dependent.
   */
  address?: Maybe<Array<Maybe<Address_Input>>>;
  /** Administrative Gender - the gender that the person is considered to have for administration and record keeping purposes. */
  _gender?: Maybe<Element_Input>;
  /** Administrative Gender - the gender that the person is considered to have for administration and record keeping purposes. */
  gender?: Maybe<Scalars['code']>;
  /** Practitioner nationality.. */
  nationality?: Maybe<Scalars['code']>;
  /** The date of birth for the practitioner. */
  _birthDate?: Maybe<Element_Input>;
  /** The date of birth for the practitioner. */
  birthDate?: Maybe<Scalars['date']>;
  /** Image of the person. */
  photo?: Maybe<Array<Maybe<Attachment_Input>>>;
  /** Practitioner Awards. */
  awards?: Maybe<Array<Maybe<PractionerAwardsExtension_Input>>>;
  /** Practitioner Media. */
  media?: Maybe<Array<Maybe<PractionerMediaExtension_Input>>>;
  /** Practitioner Awards. */
  publications?: Maybe<Array<Maybe<PractionerPublicationsExtension_Input>>>;
  /** Practitioner Awards. */
  affiliations?: Maybe<Array<Maybe<PractionerAffiliationExtension_Input>>>;
  /** Practitioner Accreditations. */
  accreditations?: Maybe<Array<Maybe<PractionerAccreditationExtension_Input>>>;
  /**
   * The official certifications, training, and licenses that authorize or
   * otherwise pertain to the provision of care by the practitioner.  For example,
   * a medical license issued by a medical board authorizing the practitioner to
   * practice medicine within a certian locality.
   */
  qualification?: Maybe<Array<Maybe<Practitionerqualification_Input>>>;
  /** A language the practitioner can use in patient communication. */
  communication?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The band in which the resource is written. */
  band?: Maybe<Scalars['code']>;
  /** The years Of Exp in which the resource is written. */
  yearsOfExp?: Maybe<Scalars['code']>;
  /** The over All Ratings in which the resource is written. */
  overAllRatings?: Maybe<Scalars['code']>;
  /** The ratings in which the resource is written. */
  ratings?: Maybe<Scalars['code']>;
  /** Emergency Contact. */
  emergencyContact?: Maybe<Array<Maybe<PractionerEmergency_Extension_Input>>>;
  /** The ratings in which the resource is written. */
  speciality?: Maybe<Scalars['String']>;
  /** The ratings in which the resource is written. */
  conditions?: Maybe<Scalars['String']>;
  /** The ratings in which the resource is written. */
  subspeciality?: Maybe<Scalars['String']>;
  /** Reviews. */
  reviews?: Maybe<Array<Maybe<PractionerReview_Extension_Input>>>;
  /** Practitioner Accreditations. */
  recommendations?: Maybe<Array<Maybe<PractionerRecommendation_Extension_Input>>>;
  /** The ratings in which the resource is written. */
  status?: Maybe<Scalars['Int']>;
  /** The ratings in which the resource is written. */
  message?: Maybe<Scalars['String']>;
  /** fullName. */
  fullName?: Maybe<Scalars['String']>;
  /** accountStatus. */
  accountStatus?: Maybe<Scalars['Int']>;
  /** communicationStatus. */
  communicationStatus?: Maybe<Scalars['Int']>;
  /** communicationStatus. */
  communicationUpdated?: Maybe<Scalars['Int']>;
  /** isPublished. */
  isPublished?: Maybe<Scalars['Int']>;
  /** isPublished. */
  createdOn?: Maybe<Scalars['String']>;
};

export type Practitionerqualification = {
  __typename?: 'Practitionerqualification';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An identifier that applies to this person's qualification in this role. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Coded representation of the qualification. */
  code: CodeableConcept;
  /** Period during which the qualification is valid. */
  period?: Maybe<Period>;
  /** Field of Study. */
  fieldOfStudy?: Maybe<Scalars['String']>;
  /** country. */
  country?: Maybe<Scalars['String']>;
  /** university. */
  university?: Maybe<Scalars['String']>;
  /** Organization that regulates and issues the qualification. */
  issuer?: Maybe<Practitionerqualificationissuer_Issuer_Union>;
};

export type Practitionerqualification_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** An identifier that applies to this person's qualification in this role. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /** Coded representation of the qualification. */
  code: CodeableConcept_Input;
  /** Period during which the qualification is valid. */
  period?: Maybe<Period_Input>;
  /** Organization that regulates and issues the qualification. */
  issuer?: Maybe<Scalars['String']>;
  /** Field of Study. */
  fieldOfStudy?: Maybe<Scalars['String']>;
  /** country. */
  country?: Maybe<Scalars['String']>;
  /** university. */
  university?: Maybe<Scalars['String']>;
};

/** Organization that regulates and issues the qualification. */
export type Practitionerqualificationissuer_Issuer_Union = Organization;

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type PricingType_Schema = {
  __typename?: 'PricingType_Schema';
  /** operationType field data. */
  professionalId?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentType?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentTypeName?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentAgeFrom?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentAgeTo?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentName?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentDescription?: Maybe<Scalars['String']>;
  /** operationType field data. */
  appointmentDuration?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentPrice?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentf2fPrice?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentDiscountType?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentDiscountValue?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentVAT?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentCommission?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentCommissionType?: Maybe<Scalars['Float']>;
  /** operationType field data. */
  appointmentOnlineAvailable?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  appointmentf2fAvailable?: Maybe<Scalars['Int']>;
};

export enum Pricing_Enum_Input_Schema {
  Pricing = 'Pricing'
}

/** Pricing */
export type Pricing_Input = {
  /** Type of resource */
  resourceType: Pricing_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Referral_Type. */
  name?: Maybe<Scalars['String']>;
  psychiatristCamhsDocAssistInitialAssessmentPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristCamhsAdhdTitrationPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristGeneralAdultAdhdTitrationPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristOlderAdultAdhdTitrationPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristCamhsAdhdTreatmentInitiationPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristGeneralAdultAdhdTreatmentInitiationPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristOlderAdultAdhdTreatmentInitiationPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristCamhsAdhdFollowUpTitrationPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristGeneralAdultAdhdFollowUpTitrationPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristOlderAdultAdhdFollowUpTitrationPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristCamhsAdhdFollowUpNonPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristGeneralAdultAdhdFollowUpNonPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristOlderAdultAdhdFollowUpNonPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristCamhsOther1Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristCamhsOther2Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristCamhsAdhdFollowUpPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristGeneralAdultDocAssistInitialAssessmentPricing?: Maybe<AppointmentTypePricing_Input>;
  generalAdultPsychiatryOther1Pricing?: Maybe<AppointmentTypePricing_Input>;
  generalAdultPsychiatryOther2Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatristOlderAdultDocAssistInitialAssessmentPricing?: Maybe<AppointmentTypePricing_Input>;
  olderAdultPsychiatryOther1Pricing?: Maybe<AppointmentTypePricing_Input>;
  olderAdultPsychiatryOther2Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyCamhsOther1Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyCamhsOther2Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyGeneralAdultOther1Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyGeneralAdultOther2Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyDocAssistInitialAssessmentPricing?: Maybe<AppointmentTypePricing_Input>;
  olderAdultPsychologyOther1Pricing?: Maybe<AppointmentTypePricing_Input>;
  olderAdultPsychologyOther2Pricing?: Maybe<AppointmentTypePricing_Input>;
  therapyDocAssistInitialAssessmentPricing?: Maybe<AppointmentTypePricing_Input>;
  therapyCbtSessionPricing?: Maybe<AppointmentTypePricing_Input>;
  yogaTherapyPricing?: Maybe<AppointmentTypePricing_Input>;
  therapyCoachingSessionPricing?: Maybe<AppointmentTypePricing_Input>;
  therapyMentoringSessionPricing?: Maybe<AppointmentTypePricing_Input>;
  therapyCounsellingSessionPricing?: Maybe<AppointmentTypePricing_Input>;
  therapyOther1Pricing?: Maybe<AppointmentTypePricing_Input>;
  therapyOther2Pricing?: Maybe<AppointmentTypePricing_Input>;
  gpLifestyle1Pricing?: Maybe<AppointmentTypePricing_Input>;
  gpLifestyle2Pricing?: Maybe<AppointmentTypePricing_Input>;
  gpOther1Pricing?: Maybe<AppointmentTypePricing_Input>;
  gpOther2Pricing?: Maybe<AppointmentTypePricing_Input>;
  generalPractitionerFollowUpPricing?: Maybe<AppointmentTypePricing_Input>;
  generalPractitionerInitialPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryCAMHSInitialPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryCAMHSFollowUpPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryCAMHSAutismPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryCAMHSADHDPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultInitialPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultFollowUpPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultADHDPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultAutismPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryOlderAdultInitialPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryOlderAdultFollowUpPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryOlderAdultMemoryAssessPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryOlderAdultAutismPricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyIndividualPricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyTherapySessionPricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyCouplesPricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyFamilyPricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyGroupPricing?: Maybe<AppointmentTypePricing_Input>;
  psychologyEMDRPricing?: Maybe<AppointmentTypePricing_Input>;
  therapyIndividualPricing?: Maybe<AppointmentTypePricing_Input>;
  therapyCouplesPricing?: Maybe<AppointmentTypePricing_Input>;
  therapyFamilyPricing?: Maybe<AppointmentTypePricing_Input>;
  therapyGroupPricing?: Maybe<AppointmentTypePricing_Input>;
  therapyTherapySessionPricing?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageSupportLetter?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageAdhdPackage?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageGeneralInitialPackage?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageInvestigationPackage1?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageInvestigationPackage2?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageADHDTitrationPackage?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageAdhdFollowUpNonPackage?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageRTMSInitialAssessmentGeneralAdult?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageRTMSInitialAssessmentOlderAdult?: Maybe<AppointmentTypePricing_Input>;
  letterNPackagePrescriptionCharges?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageADHDPvtSharedCarePackageCharges?: Maybe<AppointmentTypePricing_Input>;
  letterNPackagerTMS5sessionsPackCharges?: Maybe<AppointmentTypePricing_Input>;
  letterNPackagerTMS20SessionsFullTreatmentCharges?: Maybe<AppointmentTypePricing_Input>;
  letterNPackagerTMS25SessionsExtendedTreatmentCharges?: Maybe<AppointmentTypePricing_Input>;
  letterNPackagerTMS20Initialand5MaintenancesessionsCharges?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageAutismPackageCAMHSCharges?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultComplexPresentationGeneralPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryrTMSInitialAssessmentGeneralAdultPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryrTMSInitialAssessmentOlderAdultPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultFollowUpTitrationPackageAppt2Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultFollowUpTitrationPackageAppt3Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultFollowUpPvtSCAPackageAppt1Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultFollowUp2PvtSCAPackagePricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultFollowUpADHDMedicationInitiationPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryCAMHSAutism2Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryCAMHSAutism3Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryCAMHSFollowUpTitrationPackageAppt1Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryCAMHSFollowUpTitrationPackageAppt2Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryCAMHSFollowUpTitrationPackageAppt3Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryASDCAMHSAppointment1Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryASDCAMHSAppointment2Pricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryASDCAMHSAppointment3Pricing?: Maybe<AppointmentTypePricing_Input>;
  letterNPackageADHDTitrationPackageCAMHSCharges?: Maybe<AppointmentTypePricing_Input>;
  onlineAppointmentExtensionPricing?: Maybe<AppointmentTypePricing_Input>;
  appointmentCancellationPricing1?: Maybe<AppointmentCancellationPricing_Input>;
  appointmentCancellationPricing2?: Maybe<AppointmentCancellationPricing_Input>;
  appointmentCancellationPricing3?: Maybe<AppointmentCancellationPricing_Input>;
  tier1?: Maybe<AppointmentOccupationalPricing_Input>;
  tier2?: Maybe<AppointmentOccupationalPricing_Input>;
  tier3?: Maybe<AppointmentOccupationalPricing_Input>;
  custom?: Maybe<AppointmentOccupationalPricing_Input>;
  psychiatryGeneralAdultFollowUpShortPricing?: Maybe<AppointmentTypePricing_Input>;
  psychiatryGeneralAdultFollowUpLongPricing?: Maybe<AppointmentTypePricing_Input>;
};

/** Pricing */
export type Pricing_Schema = {
  __typename?: 'Pricing_Schema';
  resourceType?: Maybe<Scalars['String']>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Referral_Type. */
  name?: Maybe<Scalars['String']>;
  generalPractitionerFollowUpPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristCamhsAdhdTitrationPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristGeneralAdultAdhdTitrationPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristOlderAdultAdhdTitrationPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristCamhsAdhdTreatmentInitiationPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristGeneralAdultAdhdTreatmentInitiationPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristOlderAdultAdhdTreatmentInitiationPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristCamhsAdhdFollowUpTitrationPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristGeneralAdultAdhdFollowUpTitrationPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristOlderAdultAdhdFollowUpTitrationPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristCamhsAdhdFollowUpNonPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristGeneralAdultAdhdFollowUpNonPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristOlderAdultAdhdFollowUpNonPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  generalPractitionerInitialPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristCamhsDocAssistInitialAssessmentPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristCamhsOther2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristCamhsAdhdFollowUpPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristGeneralAdultDocAssistInitialAssessmentPricing?: Maybe<AppointmentTypePricing_Schema>;
  generalAdultPsychiatryOther1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  generalAdultPsychiatryOther2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristOlderAdultDocAssistInitialAssessmentPricing?: Maybe<AppointmentTypePricing_Schema>;
  olderAdultPsychiatryOther1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  olderAdultPsychiatryOther2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyCamhsOther1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyCamhsOther2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyGeneralAdultOther1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyGeneralAdultOther2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyDocAssistInitialAssessmentPricing?: Maybe<AppointmentTypePricing_Schema>;
  olderAdultPsychologyOther1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  olderAdultPsychologyOther2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyDocAssistInitialAssessmentPricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyCbtSessionPricing?: Maybe<AppointmentTypePricing_Schema>;
  yogaTherapyPricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyCoachingSessionPricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyMentoringSessionPricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyCounsellingSessionPricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyOther1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyOther2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  gpLifestyle1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  gpLifestyle2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  gpOther1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  gpOther2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatristCamhsOther1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryCAMHSInitialPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryCAMHSFollowUpPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryCAMHSAutismPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryCAMHSADHDPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultInitialPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultFollowUpPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultADHDPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultAutismPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryOlderAdultInitialPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryOlderAdultFollowUpPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryOlderAdultMemoryAssessPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryOlderAdultADHDPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryOlderAdultAutismPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyIndividualPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyTherapySessionPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyCouplesPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyFamilyPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyGroupPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychologyEMDRPricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyIndividualPricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyCouplesPricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyFamilyPricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyGroupPricing?: Maybe<AppointmentTypePricing_Schema>;
  therapyTherapySessionPricing?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageAdhdFollowUpNonPackage?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageRTMSInitialAssessmentGeneralAdult?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageRTMSInitialAssessmentOlderAdult?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackagePrescriptionCharges?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageSupportLetter?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageAdhdPackage?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageGeneralInitialPackage?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageInvestigationPackage1?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageInvestigationPackage2?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageADHDTitrationPackage?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageADHDPvtSharedCarePackageCharges?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackagerTMS5sessionsPackCharges?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackagerTMS20SessionsFullTreatmentCharges?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackagerTMS25SessionsExtendedTreatmentCharges?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackagerTMS20Initialand5MaintenancesessionsCharges?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageAutismPackageCAMHSCharges?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultComplexPresentationGeneralPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryrTMSInitialAssessmentGeneralAdultPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryrTMSInitialAssessmentOlderAdultPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultFollowUpTitrationPackageAppt2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultFollowUpTitrationPackageAppt3Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultFollowUpPvtSCAPackageAppt1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultFollowUp2PvtSCAPackagePricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultFollowUpADHDMedicationInitiationPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryCAMHSAutism2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryCAMHSAutism3Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryCAMHSFollowUpTitrationPackageAppt1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryCAMHSFollowUpTitrationPackageAppt2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryCAMHSFollowUpTitrationPackageAppt3Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryASDCAMHSAppointment1Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryASDCAMHSAppointment2Pricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryASDCAMHSAppointment3Pricing?: Maybe<AppointmentTypePricing_Schema>;
  letterNPackageADHDTitrationPackageCAMHSCharges?: Maybe<AppointmentTypePricing_Schema>;
  onlineAppointmentExtensionPricing?: Maybe<AppointmentTypePricing_Schema>;
  appointmentCancellationPricing1?: Maybe<AppointmentCancellationPricing_Schema>;
  appointmentCancellationPricing2?: Maybe<AppointmentCancellationPricing_Schema>;
  appointmentCancellationPricing3?: Maybe<AppointmentCancellationPricing_Schema>;
  tier1?: Maybe<AppointmentOccupationalPricing_Schema>;
  tier2?: Maybe<AppointmentOccupationalPricing_Schema>;
  tier3?: Maybe<AppointmentOccupationalPricing_Schema>;
  custom?: Maybe<AppointmentOccupationalPricing_Schema>;
  psychiatryGeneralAdultFollowUpShortPricing?: Maybe<AppointmentTypePricing_Schema>;
  psychiatryGeneralAdultFollowUpLongPricing?: Maybe<AppointmentTypePricing_Schema>;
  resource?: Maybe<Scalars['String']>;
  resource_template_name?: Maybe<Scalars['String']>;
};

/**
 * An action that is or was performed on or for a patient. This can be a physical
 * intervention like an operation, or less invasive like long term services,
 * counseling, or hypnotherapy.
 */
export type Procedure = {
  __typename?: 'Procedure';
  /** Type of resource */
  resourceType: Procedure_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this procedure by the performer or other
   * systems which remain constant as the resource is updated and is propagated
   * from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, order set or other
   * definition that is adhered to in whole or in part by this Procedure.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, order set or other
   * definition that is adhered to in whole or in part by this Procedure.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, order set or
   * other definition that is adhered to in whole or in part by this Procedure.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, order set or
   * other definition that is adhered to in whole or in part by this Procedure.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** A reference to a resource that contains details of the request for this procedure. */
  basedOn?: Maybe<Array<Maybe<ProcedurebasedOn_BasedOn_Union>>>;
  /** A larger event of which this particular procedure is a component or step. */
  partOf?: Maybe<Array<Maybe<ProcedurepartOf_PartOf_Union>>>;
  /** A code specifying the state of the procedure. Generally, this will be the in-progress or completed state. */
  _status?: Maybe<Element>;
  /** A code specifying the state of the procedure. Generally, this will be the in-progress or completed state. */
  status: Scalars['code'];
  /** Captures the reason for the current state of the procedure. */
  statusReason?: Maybe<CodeableConcept>;
  /** A code that classifies the procedure for searching, sorting and display purposes (e.g. 'Surgical Procedure'). */
  category?: Maybe<CodeableConcept>;
  /**
   * The specific procedure that is performed. Use text if the exact nature of the
   * procedure cannot be coded (e.g. 'Laparoscopic Appendectomy').
   */
  code?: Maybe<CodeableConcept>;
  /** The person, animal or group on which the procedure was performed. */
  subject: Proceduresubject_Subject_Union;
  /**
   * The Encounter during which this Procedure was created or performed or to which
   * the creation of this record is tightly associated.
   */
  encounter?: Maybe<Procedureencounter_Encounter_Union>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  _performedDateTime?: Maybe<Element>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  performedDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  performedPeriod?: Maybe<Period>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  _performedString?: Maybe<Element>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  performedString?: Maybe<Scalars['String']>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  performedAge?: Maybe<Age>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  performedRange?: Maybe<Range>;
  /** Individual who recorded the record and takes responsibility for its content. */
  recorder?: Maybe<Procedurerecorder_Recorder_Union>;
  /** Individual who is making the procedure statement. */
  asserter?: Maybe<Procedureasserter_Asserter_Union>;
  /** Limited to 'real' people rather than equipment. */
  performer?: Maybe<Array<Maybe<Procedureperformer>>>;
  /** The location where the procedure actually happened.  E.g. a newborn at home, a tracheostomy at a restaurant. */
  location?: Maybe<Procedurelocation_Location_Union>;
  /**
   * The coded reason why the procedure was performed. This may be a coded entity
   * of some type, or may simply be present as text.
   */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The justification of why the procedure was performed. */
  reasonReference?: Maybe<Array<Maybe<ProcedurereasonReference_ReasonReference_Union>>>;
  /**
   * Detailed and structured anatomical location information. Multiple locations
   * are allowed - e.g. multiple punch biopsies of a lesion.
   */
  bodySite?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The outcome of the procedure - did it resolve the reasons for the procedure being performed? */
  outcome?: Maybe<CodeableConcept>;
  /** This could be a histology result, pathology report, surgical report, etc. */
  report?: Maybe<Array<Maybe<Procedurereport_Report_Union>>>;
  /**
   * Any complications that occurred during the procedure, or in the immediate
   * post-performance period. These are generally tracked separately from the
   * notes, which will typically describe the procedure itself rather than any
   * 'post procedure' issues.
   */
  complication?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Any complications that occurred during the procedure, or in the immediate post-performance period. */
  complicationDetail?: Maybe<Array<Maybe<ProcedurecomplicationDetail_ComplicationDetail_Union>>>;
  /**
   * If the procedure required specific follow up - e.g. removal of sutures. The
   * follow up may be represented as a simple note or could potentially be more
   * complex, in which case the CarePlan resource can be used.
   */
  followUp?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Any other notes and comments about the procedure. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * A device that is implanted, removed or otherwise manipulated (calibration,
   * battery replacement, fitting a prosthesis, attaching a wound-vac, etc.) as a
   * focal portion of the Procedure.
   */
  focalDevice?: Maybe<Array<Maybe<ProcedurefocalDevice>>>;
  /** Identifies medications, devices and any other substance used as part of the procedure. */
  usedReference?: Maybe<Array<Maybe<ProcedureusedReference_UsedReference_Union>>>;
  /** Identifies coded items that were used as part of the procedure. */
  usedCode?: Maybe<Array<Maybe<CodeableConcept>>>;
};

export enum Procedure_Enum_Input {
  Procedure = 'Procedure'
}

export enum Procedure_Enum_Schema {
  Procedure = 'Procedure'
}

/**
 * An action that is or was performed on or for a patient. This can be a physical
 * intervention like an operation, or less invasive like long term services,
 * counseling, or hypnotherapy.
 */
export type Procedure_Input = {
  /** Type of resource */
  resourceType: Procedure_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * Business identifiers assigned to this procedure by the performer or other
   * systems which remain constant as the resource is updated and is propagated
   * from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, order set or other
   * definition that is adhered to in whole or in part by this Procedure.
   */
  _instantiatesCanonical?: Maybe<Element_Input>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, order set or other
   * definition that is adhered to in whole or in part by this Procedure.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, order set or
   * other definition that is adhered to in whole or in part by this Procedure.
   */
  _instantiatesUri?: Maybe<Element_Input>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, order set or
   * other definition that is adhered to in whole or in part by this Procedure.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** A reference to a resource that contains details of the request for this procedure. */
  basedOn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A larger event of which this particular procedure is a component or step. */
  partOf?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A code specifying the state of the procedure. Generally, this will be the in-progress or completed state. */
  _status?: Maybe<Element_Input>;
  /** A code specifying the state of the procedure. Generally, this will be the in-progress or completed state. */
  status: Scalars['code'];
  /** Captures the reason for the current state of the procedure. */
  statusReason?: Maybe<CodeableConcept_Input>;
  /** A code that classifies the procedure for searching, sorting and display purposes (e.g. 'Surgical Procedure'). */
  category?: Maybe<CodeableConcept_Input>;
  /**
   * The specific procedure that is performed. Use text if the exact nature of the
   * procedure cannot be coded (e.g. 'Laparoscopic Appendectomy').
   */
  code?: Maybe<CodeableConcept_Input>;
  /** The person, animal or group on which the procedure was performed. */
  subject: Scalars['String'];
  /**
   * The Encounter during which this Procedure was created or performed or to which
   * the creation of this record is tightly associated.
   */
  encounter?: Maybe<Scalars['String']>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  _performedDateTime?: Maybe<Element_Input>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  performedDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  performedPeriod?: Maybe<Period_Input>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  _performedString?: Maybe<Element_Input>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  performedString?: Maybe<Scalars['String']>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  performedAge?: Maybe<Age_Input>;
  /**
   * Estimated or actual date, date-time, period, or age when the procedure was
   * performed.  Allows a period to support complex procedures that span more than
   * one date, and also allows for the length of the procedure to be captured.
   */
  performedRange?: Maybe<Range_Input>;
  /** Individual who recorded the record and takes responsibility for its content. */
  recorder?: Maybe<Scalars['String']>;
  /** Individual who is making the procedure statement. */
  asserter?: Maybe<Scalars['String']>;
  /** Limited to 'real' people rather than equipment. */
  performer?: Maybe<Array<Maybe<Procedureperformer_Input>>>;
  /** The location where the procedure actually happened.  E.g. a newborn at home, a tracheostomy at a restaurant. */
  location?: Maybe<Scalars['String']>;
  /**
   * The coded reason why the procedure was performed. This may be a coded entity
   * of some type, or may simply be present as text.
   */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The justification of why the procedure was performed. */
  reasonReference?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Detailed and structured anatomical location information. Multiple locations
   * are allowed - e.g. multiple punch biopsies of a lesion.
   */
  bodySite?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The outcome of the procedure - did it resolve the reasons for the procedure being performed? */
  outcome?: Maybe<CodeableConcept_Input>;
  /** This could be a histology result, pathology report, surgical report, etc. */
  report?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Any complications that occurred during the procedure, or in the immediate
   * post-performance period. These are generally tracked separately from the
   * notes, which will typically describe the procedure itself rather than any
   * 'post procedure' issues.
   */
  complication?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Any complications that occurred during the procedure, or in the immediate post-performance period. */
  complicationDetail?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * If the procedure required specific follow up - e.g. removal of sutures. The
   * follow up may be represented as a simple note or could potentially be more
   * complex, in which case the CarePlan resource can be used.
   */
  followUp?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Any other notes and comments about the procedure. */
  note?: Maybe<Array<Maybe<Annotation_Input>>>;
  /**
   * A device that is implanted, removed or otherwise manipulated (calibration,
   * battery replacement, fitting a prosthesis, attaching a wound-vac, etc.) as a
   * focal portion of the Procedure.
   */
  focalDevice?: Maybe<Array<Maybe<ProcedurefocalDevice_Input>>>;
  /** Identifies medications, devices and any other substance used as part of the procedure. */
  usedReference?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Identifies coded items that were used as part of the procedure. */
  usedCode?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
};

/** Individual who is making the procedure statement. */
export type Procedureasserter_Asserter_Union = Patient | RelatedPerson | Practitioner | PractitionerRole;

/** A reference to a resource that contains details of the request for this procedure. */
export type ProcedurebasedOn_BasedOn_Union = CarePlan | ServiceRequest;

/** Any complications that occurred during the procedure, or in the immediate post-performance period. */
export type ProcedurecomplicationDetail_ComplicationDetail_Union = Condition;

/**
 * The Encounter during which this Procedure was created or performed or to which
 * the creation of this record is tightly associated.
 */
export type Procedureencounter_Encounter_Union = Encounter;

export type ProcedurefocalDevice = {
  __typename?: 'ProcedurefocalDevice';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The kind of change that happened to the device during the procedure. */
  action?: Maybe<CodeableConcept>;
  /** The device that was manipulated (changed) during the procedure. */
  manipulated: ProcedurefocalDevicemanipulated_Manipulated_Union;
};

export type ProcedurefocalDevice_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The kind of change that happened to the device during the procedure. */
  action?: Maybe<CodeableConcept_Input>;
  /** The device that was manipulated (changed) during the procedure. */
  manipulated: Scalars['String'];
};

/** The device that was manipulated (changed) during the procedure. */
export type ProcedurefocalDevicemanipulated_Manipulated_Union = Device;

/** The location where the procedure actually happened.  E.g. a newborn at home, a tracheostomy at a restaurant. */
export type Procedurelocation_Location_Union = Location;

/** A larger event of which this particular procedure is a component or step. */
export type ProcedurepartOf_PartOf_Union = Procedure | Observation | MedicationAdministration;

export type Procedureperformer = {
  __typename?: 'Procedureperformer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Distinguishes the type of involvement of the performer in the procedure. For example, surgeon, anaesthetist, endoscopist. */
  function?: Maybe<CodeableConcept>;
  /** The practitioner who was involved in the procedure. */
  actor: Procedureperformeractor_Actor_Union;
  /** The organization the device or practitioner was acting on behalf of. */
  onBehalfOf?: Maybe<ProcedureperformeronBehalfOf_OnBehalfOf_Union>;
};

export type Procedureperformer_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Distinguishes the type of involvement of the performer in the procedure. For example, surgeon, anaesthetist, endoscopist. */
  function?: Maybe<CodeableConcept_Input>;
  /** The practitioner who was involved in the procedure. */
  actor: Scalars['String'];
  /** The organization the device or practitioner was acting on behalf of. */
  onBehalfOf?: Maybe<Scalars['String']>;
};

/** The practitioner who was involved in the procedure. */
export type Procedureperformeractor_Actor_Union = Practitioner | PractitionerRole | Organization | Patient | RelatedPerson | Device;

/** The organization the device or practitioner was acting on behalf of. */
export type ProcedureperformeronBehalfOf_OnBehalfOf_Union = Organization;

/** The justification of why the procedure was performed. */
export type ProcedurereasonReference_ReasonReference_Union = Condition | Observation | Procedure | DiagnosticReport | DocumentReference;

/** Individual who recorded the record and takes responsibility for its content. */
export type Procedurerecorder_Recorder_Union = Patient | RelatedPerson | Practitioner | PractitionerRole;

/** This could be a histology result, pathology report, surgical report, etc. */
export type Procedurereport_Report_Union = DiagnosticReport | DocumentReference | Composition;

/** The person, animal or group on which the procedure was performed. */
export type Proceduresubject_Subject_Union = Patient | Group;

/** Identifies medications, devices and any other substance used as part of the procedure. */
export type ProcedureusedReference_UsedReference_Union = Device | Medication | Substance;

/**
 * Base StructureDefinition for ProdCharacteristic Type: The marketing status
 * describes the date when a medicinal product is actually put on the market or the
 * date as of which it is no longer available.
 */
export type ProdCharacteristic = {
  __typename?: 'ProdCharacteristic';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Where applicable, the height can be specified using a numerical value and its
   * unit of measurement The unit of measurement shall be specified in accordance
   * with ISO 11240 and the resulting terminology The symbol and the symbol
   * identifier shall be used.
   */
  height?: Maybe<Quantity>;
  /**
   * Where applicable, the width can be specified using a numerical value and its
   * unit of measurement The unit of measurement shall be specified in accordance
   * with ISO 11240 and the resulting terminology The symbol and the symbol
   * identifier shall be used.
   */
  width?: Maybe<Quantity>;
  /**
   * Where applicable, the depth can be specified using a numerical value and its
   * unit of measurement The unit of measurement shall be specified in accordance
   * with ISO 11240 and the resulting terminology The symbol and the symbol
   * identifier shall be used.
   */
  depth?: Maybe<Quantity>;
  /**
   * Where applicable, the weight can be specified using a numerical value and its
   * unit of measurement The unit of measurement shall be specified in accordance
   * with ISO 11240 and the resulting terminology The symbol and the symbol
   * identifier shall be used.
   */
  weight?: Maybe<Quantity>;
  /**
   * Where applicable, the nominal volume can be specified using a numerical value
   * and its unit of measurement The unit of measurement shall be specified in
   * accordance with ISO 11240 and the resulting terminology The symbol and the
   * symbol identifier shall be used.
   */
  nominalVolume?: Maybe<Quantity>;
  /**
   * Where applicable, the external diameter can be specified using a numerical
   * value and its unit of measurement The unit of measurement shall be specified
   * in accordance with ISO 11240 and the resulting terminology The symbol and the
   * symbol identifier shall be used.
   */
  externalDiameter?: Maybe<Quantity>;
  /**
   * Where applicable, the shape can be specified An appropriate controlled
   * vocabulary shall be used The term and the term identifier shall be used.
   */
  _shape?: Maybe<Element>;
  /**
   * Where applicable, the shape can be specified An appropriate controlled
   * vocabulary shall be used The term and the term identifier shall be used.
   */
  shape?: Maybe<Scalars['String']>;
  /**
   * Where applicable, the color can be specified An appropriate controlled
   * vocabulary shall be used The term and the term identifier shall be used.
   */
  _color?: Maybe<Element>;
  /**
   * Where applicable, the color can be specified An appropriate controlled
   * vocabulary shall be used The term and the term identifier shall be used.
   */
  color?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Where applicable, the imprint can be specified as text. */
  _imprint?: Maybe<Element>;
  /** Where applicable, the imprint can be specified as text. */
  imprint?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Where applicable, the image can be provided The format of the image attachment
   * shall be specified by regional implementations.
   */
  image?: Maybe<Array<Maybe<Attachment>>>;
  /**
   * Where applicable, the scoring can be specified An appropriate controlled
   * vocabulary shall be used The term and the term identifier shall be used.
   */
  scoring?: Maybe<CodeableConcept>;
};

/**
 * Base StructureDefinition for ProductShelfLife Type: The shelf-life and storage
 * information for a medicinal product item or container can be described using this class.
 */
export type ProductShelfLife = {
  __typename?: 'ProductShelfLife';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique identifier for the packaged Medicinal Product. */
  identifier?: Maybe<Identifier>;
  /**
   * This describes the shelf life, taking into account various scenarios such as
   * shelf life of the packaged Medicinal Product itself, shelf life after
   * transformation where necessary and shelf life after the first opening of a
   * bottle, etc. The shelf life type shall be specified using an appropriate
   * controlled vocabulary The controlled term and the controlled term identifier
   * shall be specified.
   */
  type: CodeableConcept;
  /**
   * The shelf life time period can be specified using a numerical value for the
   * period of time and its unit of time measurement The unit of measurement shall
   * be specified in accordance with ISO 11240 and the resulting terminology The
   * symbol and the symbol identifier shall be used.
   */
  period: Quantity;
  /**
   * Special precautions for storage, if any, can be specified using an appropriate
   * controlled vocabulary The controlled term and the controlled term identifier
   * shall be specified.
   */
  specialPrecautionsForStorage?: Maybe<Array<Maybe<CodeableConcept>>>;
};

/** Professional Type Relation Input */
export type ProfessionalTypeRelation_Input = {
  professionalTypeId?: Maybe<Scalars['String']>;
};

/** professional Type Relation Schema */
export type ProfessionalTypeRelation_Schema = {
  __typename?: 'ProfessionalTypeRelation_Schema';
  /** professional type Id */
  professionalTypeId?: Maybe<Scalars['String']>;
};

export enum ProfessionalType_Enum_Input_Schema {
  ProfessionalType = 'ProfessionalType'
}

export enum ProfessionalType_Enum_Schema {
  ProfessionalType = 'ProfessionalType'
}

/** ProfessionalType */
export type ProfessionalType_Input = {
  /** Type of resource */
  resourceType: ProfessionalType_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  /** Referral_Type. */
  name?: Maybe<Scalars['String']>;
  /** Referral_Type. */
  status?: Maybe<Scalars['Boolean']>;
};

/** ProfessionalType */
export type ProfessionalType_Schema = {
  __typename?: 'ProfessionalType_Schema';
  /** Type of resource */
  resourceType: ProfessionalType_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  /** Professional name. */
  name?: Maybe<Scalars['String']>;
  /** status. */
  status?: Maybe<Scalars['Boolean']>;
};

/**
 * Provenance of a resource is a record that describes entities and processes
 * involved in producing and delivering or otherwise influencing that resource.
 * Provenance provides a critical foundation for assessing authenticity, enabling
 * trust, and allowing reproducibility. Provenance assertions are a form of
 * contextual metadata and can themselves become important records with their own
 * provenance. Provenance statement indicates clinical significance in terms of
 * confidence in authenticity, reliability, and trustworthiness, integrity, and
 * stage in lifecycle (e.g. Document Completion - has the artifact been legally
 * authenticated), all of which may impact security, privacy, and trust policies.
 */
export type Provenance = {
  __typename?: 'Provenance';
  /** Type of resource */
  resourceType: Provenance_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The Reference(s) that were generated or updated by  the activity described in
   * this resource. A provenance can point to more than one target if multiple
   * resources were created/updated by the same activity.
   */
  target?: Maybe<Array<Provenancetarget_Target_Union>>;
  /** The period during which the activity occurred. */
  occurredPeriod?: Maybe<Period>;
  /** The period during which the activity occurred. */
  _occurredDateTime?: Maybe<Element>;
  /** The period during which the activity occurred. */
  occurredDateTime?: Maybe<Scalars['dateTime']>;
  /** The instant of time at which the activity was recorded. */
  _recorded?: Maybe<Element>;
  /** The instant of time at which the activity was recorded. */
  recorded: Scalars['instant'];
  /**
   * Policy or plan the activity was defined by. Typically, a single activity may
   * have multiple applicable policy documents, such as patient consent, guarantor funding, etc.
   */
  _policy?: Maybe<Element>;
  /**
   * Policy or plan the activity was defined by. Typically, a single activity may
   * have multiple applicable policy documents, such as patient consent, guarantor funding, etc.
   */
  policy?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** Where the activity occurred, if relevant. */
  location?: Maybe<Provenancelocation_Location_Union>;
  /** The reason that the activity was taking place. */
  reason?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * An activity is something that occurs over a period of time and acts upon or
   * with entities; it may include consuming, processing, transforming, modifying,
   * relocating, using, or generating entities.
   */
  activity?: Maybe<CodeableConcept>;
  /**
   * An actor taking a role in an activity  for which it can be assigned some
   * degree of responsibility for the activity taking place.
   */
  agent?: Maybe<Array<Provenanceagent>>;
  /** An entity used in this activity. */
  entity?: Maybe<Array<Maybe<Provenanceentity>>>;
  /**
   * A digital signature on the target Reference(s). The signer should match a
   * Provenance.agent. The purpose of the signature is indicated.
   */
  signature?: Maybe<Array<Maybe<Signature>>>;
};

export enum Provenance_Enum_Input {
  Provenance = 'Provenance'
}

export enum Provenance_Enum_Schema {
  Provenance = 'Provenance'
}

/**
 * Provenance of a resource is a record that describes entities and processes
 * involved in producing and delivering or otherwise influencing that resource.
 * Provenance provides a critical foundation for assessing authenticity, enabling
 * trust, and allowing reproducibility. Provenance assertions are a form of
 * contextual metadata and can themselves become important records with their own
 * provenance. Provenance statement indicates clinical significance in terms of
 * confidence in authenticity, reliability, and trustworthiness, integrity, and
 * stage in lifecycle (e.g. Document Completion - has the artifact been legally
 * authenticated), all of which may impact security, privacy, and trust policies.
 */
export type Provenance_Input = {
  /** Type of resource */
  resourceType: Provenance_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * The Reference(s) that were generated or updated by  the activity described in
   * this resource. A provenance can point to more than one target if multiple
   * resources were created/updated by the same activity.
   */
  target?: Maybe<Array<Scalars['String']>>;
  /** The period during which the activity occurred. */
  occurredPeriod?: Maybe<Period_Input>;
  /** The period during which the activity occurred. */
  _occurredDateTime?: Maybe<Element_Input>;
  /** The period during which the activity occurred. */
  occurredDateTime?: Maybe<Scalars['dateTime']>;
  /** The instant of time at which the activity was recorded. */
  _recorded?: Maybe<Element_Input>;
  /** The instant of time at which the activity was recorded. */
  recorded: Scalars['instant'];
  /**
   * Policy or plan the activity was defined by. Typically, a single activity may
   * have multiple applicable policy documents, such as patient consent, guarantor funding, etc.
   */
  _policy?: Maybe<Element_Input>;
  /**
   * Policy or plan the activity was defined by. Typically, a single activity may
   * have multiple applicable policy documents, such as patient consent, guarantor funding, etc.
   */
  policy?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** Where the activity occurred, if relevant. */
  location?: Maybe<Scalars['String']>;
  /** The reason that the activity was taking place. */
  reason?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /**
   * An activity is something that occurs over a period of time and acts upon or
   * with entities; it may include consuming, processing, transforming, modifying,
   * relocating, using, or generating entities.
   */
  activity?: Maybe<CodeableConcept_Input>;
  /**
   * An actor taking a role in an activity  for which it can be assigned some
   * degree of responsibility for the activity taking place.
   */
  agent?: Maybe<Array<Provenanceagent_Input>>;
  /** An entity used in this activity. */
  entity?: Maybe<Array<Maybe<Provenanceentity_Input>>>;
  /**
   * A digital signature on the target Reference(s). The signer should match a
   * Provenance.agent. The purpose of the signature is indicated.
   */
  signature?: Maybe<Array<Maybe<Signature_Input>>>;
};

export type Provenanceagent = {
  __typename?: 'Provenanceagent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The participation the agent had with respect to the activity. */
  type?: Maybe<CodeableConcept>;
  /** The function of the agent with respect to the activity. The security role enabling the agent with respect to the activity. */
  role?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The individual, device or organization that participated in the event. */
  who: Provenanceagentwho_Who_Union;
  /** The individual, device, or organization for whom the change was made. */
  onBehalfOf?: Maybe<ProvenanceagentonBehalfOf_OnBehalfOf_Union>;
};

export type Provenanceagent_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The participation the agent had with respect to the activity. */
  type?: Maybe<CodeableConcept_Input>;
  /** The function of the agent with respect to the activity. The security role enabling the agent with respect to the activity. */
  role?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The individual, device or organization that participated in the event. */
  who: Scalars['String'];
  /** The individual, device, or organization for whom the change was made. */
  onBehalfOf?: Maybe<Scalars['String']>;
};

/** The individual, device, or organization for whom the change was made. */
export type ProvenanceagentonBehalfOf_OnBehalfOf_Union = Practitioner | PractitionerRole | RelatedPerson | Patient | Device | Organization;

/** The individual, device or organization that participated in the event. */
export type Provenanceagentwho_Who_Union = Practitioner | PractitionerRole | RelatedPerson | Patient | Device | Organization;

export type Provenanceentity = {
  __typename?: 'Provenanceentity';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** How the entity was used during the activity. */
  _role?: Maybe<Element>;
  /** How the entity was used during the activity. */
  role: Scalars['code'];
  /** Identity of the  Entity used. May be a logical or physical uri and maybe absolute or relative. */
  what: Provenanceentitywhat_What_Union;
};

export type Provenanceentity_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** How the entity was used during the activity. */
  _role?: Maybe<Element_Input>;
  /** How the entity was used during the activity. */
  role: Scalars['code'];
  /** Identity of the  Entity used. May be a logical or physical uri and maybe absolute or relative. */
  what: Scalars['String'];
};

/** Identity of the  Entity used. May be a logical or physical uri and maybe absolute or relative. */
export type Provenanceentitywhat_What_Union = Resource;

/** Where the activity occurred, if relevant. */
export type Provenancelocation_Location_Union = Location;

/**
 * The Reference(s) that were generated or updated by  the activity described in
 * this resource. A provenance can point to more than one target if multiple
 * resources were created/updated by the same activity.
 */
export type Provenancetarget_Target_Union = Resource;

/**
 * Base StructureDefinition for Quantity Type: A measured amount (or an amount that
 * can potentially be measured). Note that measured amounts include amounts that
 * are not precisely quantified, including amounts involving arbitrary units and
 * floating currencies.
 */
export type Quantity = {
  __typename?: 'Quantity';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  _value?: Maybe<Element>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  value?: Maybe<Scalars['Float']>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  _comparator?: Maybe<Element>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  comparator?: Maybe<Scalars['code']>;
  /** A human-readable form of the unit. */
  _unit?: Maybe<Element>;
  /** A human-readable form of the unit. */
  unit?: Maybe<Scalars['String']>;
  /** The identification of the system that provides the coded form of the unit. */
  _system?: Maybe<Element>;
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars['uri']>;
  /** A computer processable form of the unit in some unit representation system. */
  _code?: Maybe<Element>;
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars['code']>;
};

/**
 * Base StructureDefinition for Quantity Type: A measured amount (or an amount that
 * can potentially be measured). Note that measured amounts include amounts that
 * are not precisely quantified, including amounts involving arbitrary units and
 * floating currencies.
 */
export type Quantity_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  _value?: Maybe<Element_Input>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value. */
  value?: Maybe<Scalars['Float']>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  _comparator?: Maybe<Element_Input>;
  /**
   * How the value should be understood and represented - whether the actual value
   * is greater or less than the stated value due to measurement issues; e.g. if
   * the comparator is '<' , then the real value is < stated value.
   */
  comparator?: Maybe<Scalars['code']>;
  /** A human-readable form of the unit. */
  _unit?: Maybe<Element_Input>;
  /** A human-readable form of the unit. */
  unit?: Maybe<Scalars['String']>;
  /** The identification of the system that provides the coded form of the unit. */
  _system?: Maybe<Element_Input>;
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars['uri']>;
  /** A computer processable form of the unit in some unit representation system. */
  _code?: Maybe<Element_Input>;
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars['code']>;
};

export type Query = {
  __typename?: 'Query';
  /** Query for a single AdminNotification */
  AdminNotification?: Maybe<AdminNotifications>;
  /** Query for a more than or just one AdminNotification */
  AdminNotificationList?: Maybe<Array<Maybe<AdminNotifications>>>;
  /** Query for a single AdminTask */
  AdminTask?: Maybe<AdminTasks>;
  /** Query for a more than or just one AdminTask */
  AdminTaskList?: Maybe<Array<Maybe<AdminTasks>>>;
  /** Query for a single TasksMessages */
  APPNotifications?: Maybe<Array<Maybe<AppTasks>>>;
  /** Query for a more than or just one Faq */
  APPNotificationsList?: Maybe<Array<Maybe<AppTasks>>>;
  /** Query for a single Pricing */
  AppointmentTypeMaster?: Maybe<Array<Maybe<AppointmentTypeMaster_Schema>>>;
  /** Query for a more than or just one Pricing */
  AppointmentTypeMasterList?: Maybe<Array<Maybe<AppointmentTypeMaster_Schema>>>;
  /** Query for a single TasksMessages */
  APPTasks?: Maybe<Array<Maybe<AppTasks>>>;
  /** Query for a more than or just one Faq */
  APPTasksList?: Maybe<Array<Maybe<AppTasks>>>;
  /** Query for a single Pricing */
  BlogCategory?: Maybe<BlogCategory_Schema>;
  /** Query for a more than or just one Pricing */
  BlogCategoryList?: Maybe<Array<Maybe<BlogCategory_Schema>>>;
  /** Query for a single Blog */
  Blog?: Maybe<Blogs_Schema>;
  /** Query for a more than or just one Blog */
  BlogList?: Maybe<Array<Maybe<Blogs_Schema>>>;
  /** Query for a single ProfessionalType */
  ChatTrackerCount?: Maybe<ChatTrackerType_Schema>;
  /** Query for a more than or just one ProfessionalType */
  ChatTrackerList?: Maybe<Array<Maybe<ChatTrackerType_Schema>>>;
  /** Query for a single Faq */
  Faq?: Maybe<Faq>;
  /** Query for a more than or just one Faq */
  FaqList?: Maybe<Array<Maybe<Faq>>>;
  /** Query for a single GP */
  GeneralPractitioner?: Maybe<Gp_Schema>;
  /** Query for a more than or just one GP */
  GeneralPractitionerList?: Maybe<Array<Maybe<Gp_Schema>>>;
  /** Query for a single Handbook */
  Handbook?: Maybe<Handbook>;
  /** Query for a more than or just one Handbook */
  HandbookList?: Maybe<Array<Maybe<Handbook>>>;
  /** Query for a single Pricing */
  Job?: Maybe<Jobs_Schema>;
  /** Query for a more than or just one Pricing */
  JobList?: Maybe<Array<Maybe<Jobs_Schema>>>;
  /** Query for a single PatientLetter */
  MedicationMaster?: Maybe<MedicationMasterDocument>;
  /** Query for a more than or just one PomsPatientLetter */
  MedicationMasterList?: Maybe<Array<Maybe<MedicationMasterDocument>>>;
  /** Query for a single PatientPreferences */
  OrganisationActivity?: Maybe<OrganisationActivity>;
  /** Query for a more than or just one PatientPractitioner */
  OrganisationActivityList?: Maybe<Array<Maybe<OrganisationActivity>>>;
  /** Query for a single PractitionerAggrements */
  OrganisationAgreement?: Maybe<OrganisationAgreements>;
  /** Query for a more than or just one PractitionerAggrements */
  OrganisationAgreementList?: Maybe<Bundle>;
  /** Query for a single PractitionerAggrements */
  OrganisationPreference?: Maybe<OrganisationPreferences>;
  /** Query for a more than or just one PractitionerPreferences */
  OrganisationPreferenceList?: Maybe<Bundle>;
  /** Query for a single PractitionerPreferences */
  OrganisationPrivacy?: Maybe<OrganisationPrivacy>;
  /** Query for a more than or just one PractitionerPrivacy */
  OrganisationPrivacyList?: Maybe<Bundle>;
  /** Query for a single Organization */
  Organization?: Maybe<Organization>;
  /** Query for a more than or just one Organization */
  OrganizationList?: Maybe<Array<Maybe<Organization>>>;
  /** Query for a single OrganizationAffiliation */
  OrganizationAffiliation?: Maybe<OrganizationAffiliation>;
  /** Query for a more than or just one OrganizationAffiliation */
  OrganizationAffiliationList?: Maybe<Bundle>;
  /** Query for a single FeedBack */
  PharmaZone?: Maybe<PharmaZone>;
  /** Query for a more than or just one PractitionerPrivacy */
  PharmaZoneList?: Maybe<Array<Maybe<PharmaZone>>>;
  /** Query for a single PomsMasterTemplate */
  PomsMasterTemplate?: Maybe<PomsMasterTemplate>;
  /** Query for a more than or just one PomsMasterTemplate */
  PomsMasterTemplateList?: Maybe<Array<Maybe<PomsMasterTemplate>>>;
  /** Query for a single PomsReferral */
  PomsReferral?: Maybe<PomsReferral>;
  /** Query for a more than or just one PomsReferral */
  PomsReferralList?: Maybe<Array<Maybe<PomsReferral>>>;
  /** Query for a more than or just one PomsReferral */
  ThirdPartyReferralList?: Maybe<Array<Maybe<PomsReferral>>>;
  /** Query for a single Pricing */
  Pricing?: Maybe<Pricing_Schema>;
  /** Query for get Whatsapp resources. */
  ResourceTemplateName?: Maybe<Pricing_Schema>;
  /** Query for a more than or just one Pricing */
  PricingList?: Maybe<Array<Maybe<Pricing_Schema>>>;
  /** Query for a more than or just one Pricing */
  PricingTypeList?: Maybe<Array<Maybe<PricingType_Schema>>>;
  /** Query for a more than or just one Pricing */
  PricingListByName?: Maybe<Array<Maybe<PricingType_Schema>>>;
  /** Query for a single ProfessionalType */
  ProfessionalType?: Maybe<ProfessionalType_Schema>;
  /** Query for a more than or just one ProfessionalType */
  ProfessionalTypeList?: Maybe<Array<Maybe<ProfessionalType_Schema>>>;
  /** Query for a single Questionnaire */
  Questionnaire?: Maybe<Questionnaire>;
  /** Query for a more than or just one Questionnaire */
  QuestionnaireList?: Maybe<Bundle>;
  /** Query for a single InternalReferral */
  QuestionnaireAssign?: Maybe<QuestionnaireAssign>;
  /** Query for a more than or just one QuestionnaireAssign */
  QuestionnaireAssignList?: Maybe<Array<Maybe<QuestionnaireAssign>>>;
  /** Query for a single InternalReferral */
  QuestionnaireBuilder?: Maybe<QuestionnaireBuilder>;
  /** Query for a more than or just one QuestionnaireBuilder */
  QuestionnaireBuilderList?: Maybe<Array<Maybe<QuestionnaireBuilder>>>;
  /** Query for a single QuestionnaireResponse */
  QuestionnaireResponse?: Maybe<QuestionnaireResponse>;
  /** Query for a more than or just one QuestionnaireResponse */
  QuestionnaireResponseList?: Maybe<Bundle>;
  /** Query for a single Blog */
  Quote?: Maybe<Quotes_Schema>;
  /** Query for a more than or just one Blog */
  QuoteList?: Maybe<Array<Maybe<Quotes_Schema>>>;
  /** Query for a single Pricing */
  SubSpecialtyMaster?: Maybe<Array<Maybe<SubSpecialtyMaster_Schema>>>;
  /** Query for a more than or just one Pricing */
  SubSpecialtyMasterList?: Maybe<Array<Maybe<SubSpecialtyMaster_Schema>>>;
  /** Query for a single Task */
  Task?: Maybe<Task>;
  /** Query for a more than or just one Task */
  TaskList?: Maybe<Bundle>;
  /** Query for a more than or just one TaskManager */
  TaskManagerList?: Maybe<Array<Maybe<TaskManager>>>;
  /** Get Task List */
  GetTaskList?: Maybe<TaskManager>;
  /** Get Task Count Summary for tabs and filters */
  GetTaskCountSummary?: Maybe<TaskManager>;
  /** Get comments and metadata for a specific task */
  GetTaskComments?: Maybe<TaskManager>;
  /** Get count of unread comments for a task and user */
  GetUnreadCommentCount?: Maybe<UnreadCommentCountResponse>;
  /** Query for a single TasksMessages */
  TasksMessages?: Maybe<Array<Maybe<TasksMessages>>>;
  /** Query for a more than or just one Faq */
  TasksMessagesList?: Maybe<Array<Maybe<TasksMessages>>>;
  /** Query for a single ValueSet */
  ValueSet?: Maybe<ValueSet>;
  /** Query for a more than or just one ValueSet */
  ValueSetList?: Maybe<Bundle>;
  /** Query for a single Faq */
  WebContact?: Maybe<WebContact>;
  /** Query for a more than or just one Faq */
  WebContactList?: Maybe<Array<Maybe<WebContact>>>;
  /** Query for a single Faq */
  PatientInvoice?: Maybe<PatientInvoices>;
  /** Query for a more than or just one Faq */
  PatientInvoiceList?: Maybe<Array<Maybe<PatientInvoices>>>;
  /** Query for a single PomsInvoiceBilling */
  PomsInvoiceBilling?: Maybe<PomsBillingInvoice>;
  /** Query for a more than or just one PomsInvoiceBilling */
  PomsInvoiceBillingList?: Maybe<Bundle>;
  /** Query for a single Faq */
  PractitionerStatement?: Maybe<PractitionerStatement>;
  /** Query for a more than or just one Faq */
  PractitionerStatementList?: Maybe<Array<Maybe<PractitionerStatement>>>;
  /** Query for a single FeedBack */
  RolePermission?: Maybe<RolesPermission_Schema>;
  /** Query for a more than or just one PractitionerPrivacy */
  RolePermissionList?: Maybe<Array<Maybe<RolesPermission_Schema>>>;
  /** Query for a single User */
  User?: Maybe<User>;
  /** Query for a more than or just one User */
  UserList?: Maybe<Array<Maybe<User>>>;
  /** Query for a more than or just one User */
  AdminList?: Maybe<User>;
  /** Query for a more than or just one User */
  BasicSignedList?: Maybe<User>;
  /** Query for a more than or just one User */
  RunScriptToInsert?: Maybe<User>;
  /** Query for a more than or just one User */
  getUserStatus?: Maybe<User>;
  /** Query for a more than or just one User */
  getAdminDetails?: Maybe<User>;
  AppNotificationsSimple?: Maybe<AppNotifications>;
  AppTasksSimple?: Maybe<AppTasks>;
  /** Query for a single PatientLetter */
  CrisisSafeguard?: Maybe<CrisisSafeguard>;
  /** Query for a more than or just one CrisisSafeguard */
  CrisisSafeguardList?: Maybe<Array<Maybe<CrisisSafeguard>>>;
  /** Query for a single Patient */
  Patient?: Maybe<Patient>;
  /** Query for a more than or just one Patient */
  PatientList?: Maybe<Array<Maybe<Patient>>>;
  /** Query for a more than or just one Patient */
  PatientImageList?: Maybe<Array<Maybe<Patient>>>;
  /** Query for a single Patient */
  PatientCountByMonth?: Maybe<PatientCount>;
  /** Query for a single Patient */
  GetPatientListCount?: Maybe<Patient>;
  /** Query for a more than or just one Patient */
  GetPatientReportList?: Maybe<Array<Maybe<Patient>>>;
  /** Query for a more than or just one Patient */
  GetPatientDataByList?: Maybe<Array<Maybe<Patient>>>;
  /** Query for export active whatsApp enabled patient list */
  ExportActiveWhatsAppEnabledPatientList?: Maybe<Array<Maybe<Patient_Export>>>;
  /** Query for all admin list */
  AppAllAdminList?: Maybe<Array<Maybe<All_Admin_List>>>;
  /** Query for a single InternalReferral */
  PatientFinancialInfo?: Maybe<PatientFinancialInfo>;
  /** Query for a more than or just one PatientFinancialInfo */
  PatientFinancialInfoList?: Maybe<Array<Maybe<PatientFinancialInfo>>>;
  /** Query for a single PatientNotification */
  PatientNotification?: Maybe<PatientNotifications>;
  /** Query for a more than or just one PatientNotification */
  PatientNotificationList?: Maybe<Array<Maybe<PatientNotifications>>>;
  /** Query for a single PatientLetter */
  PatientPrescription?: Maybe<PatientPrescriptionDocument>;
  /** Query for a more than or just one PatientPrescription */
  PatientPrescriptionList?: Maybe<Array<Maybe<PatientPrescriptionDocument>>>;
  /** Query for a single PatientQuestionnaire */
  PatientQuestionnaire?: Maybe<PatientQuestionnaire_Schema>;
  /** Query for a more than or just one PatientQuestionnaire */
  PatientQuestionnaireList?: Maybe<Array<Maybe<PatientQuestionnaire_Schema>>>;
  /** Query for a single PatientQuestionnaire */
  ExternalPatientQuestionnaire?: Maybe<ExternalPatientQuestionnaire_Schema>;
  /** Query for a more than or just one PatientQuestionnaire */
  ExternalPatientQuestionnaireList?: Maybe<Array<Maybe<ExternalPatientQuestionnaire_Schema>>>;
  /** Query for a single PatientRecordsLog */
  PatientRecordsLog?: Maybe<PatientRecordsLog>;
  /** Query for a more than or just one PatientRecordsLog */
  PatientRecordsLogList?: Maybe<Array<Maybe<PatientRecordsLog>>>;
  /** Query for a single PatientTask */
  PatientTask?: Maybe<PatientTasks>;
  /** Query for a more than or just one PatientTask */
  PatientTaskList?: Maybe<Array<Maybe<PatientTasks>>>;
  /** Query for a more than or just one PatientTask */
  PatientToDoTaskList?: Maybe<Array<Maybe<PatientToDoTasks>>>;
  /** Query for a more than or just one PatientTask */
  PractitionerToDoTaskList?: Maybe<Array<Maybe<PatientToDoTasks>>>;
  /** Query for a more than or just one PatientTask */
  PractitionerToDoTaskListCount?: Maybe<PatientToDoTaskListCount>;
  /** Query for a more than or just one PatientTask */
  PatientToDoTaskListCount?: Maybe<PatientToDoTaskListCount>;
  /** Query for a single PatientPreferences */
  PomsPatientActivity?: Maybe<PomsPatientActivity>;
  /** Query for a more than or just one PatientActivity */
  PomsPatientActivityList?: Maybe<Array<Maybe<PomsPatientActivity>>>;
  /** Query for a single PatientDocument */
  PomsPatientDocument?: Maybe<PomsPatientDocument>;
  /** Query for a more than or just one PomsPatientDocument */
  PomsPatientDocumentList?: Maybe<Array<Maybe<PomsPatientDocument>>>;
  /** Query for a single PatientLetter */
  PomsPatientLetter?: Maybe<PomsPatientLetter>;
  /** Query for a more than or just one PomsPatientLetter */
  PomsPatientLetterList?: Maybe<Array<Maybe<PomsPatientLetter>>>;
  /** Query for a single PatientPreferences */
  PomsPatientPreference?: Maybe<PomsPatientPreferences>;
  /** Query for a more than or just one PatientPreferences */
  PomsPatientPreferenceList?: Maybe<Bundle>;
  /** Query for a single PatientPreferences */
  PomsPatientPrivacy?: Maybe<PomsPatientPrivacy>;
  /** Query for a more than or just one PatientPrivacy */
  PomsPatientPrivacyList?: Maybe<Bundle>;
  /** Query for a single PatientPreferences */
  SignPosting?: Maybe<SignPosting_Schema>;
  /** Query for a single Leaflet */
  Leaflet?: Maybe<Leaflet_Schema>;
  /** Query for a more than or just one SignPosting */
  SignPostingList?: Maybe<Array<Maybe<SignPosting_Schema>>>;
  /** Query for a more than or just one SignPosting */
  LeafletList?: Maybe<Array<Maybe<Leaflet_Schema>>>;
  /** Leaflet count */
  LeafletCount?: Maybe<Leaflet_Schema>;
  /** Signposting count */
  SignPostingCount?: Maybe<SignPosting_Schema>;
  /** Query for a more than or just one SignPosting */
  SignPostingOrganizationList?: Maybe<Array<Maybe<SignPosting_Schema>>>;
  /** Query for a single PatientPreferences */
  SignPostingCategory?: Maybe<SignPostingCategory_Schema>;
  /** Query for a more than or just one SignPostingCategory */
  SignPostingCategoryList?: Maybe<Array<Maybe<SignPostingCategory_Schema>>>;
  /** Query for a single DocumentReference */
  DocumentReference?: Maybe<DocumentReference>;
  /** Query for a more than or just one DocumentReference */
  DocumentReferenceList?: Maybe<Bundle>;
  /** Query for a single Location */
  Location?: Maybe<Location>;
  /** Query for a more than or just one Location */
  LocationList?: Maybe<Array<Maybe<Location>>>;
  /** Query for a more than or just one Location */
  LocationListWeb?: Maybe<Array<Maybe<Location>>>;
  /** Query for a single PatientPreferences */
  PomsPractitionerActivity?: Maybe<PomsPractitionerActivity>;
  /** Query for a more than or just one PatientPractitioner */
  PomsPractitionerActivityList?: Maybe<Array<Maybe<PomsPractitionerActivity>>>;
  /** Query for a single PractitionerAggrements */
  PomsPractitionerAgreement?: Maybe<PomsPractitionerAgreements>;
  /** Query for a more than or just one PractitionerAggrements */
  PomsPractitionerAgreementList?: Maybe<Bundle>;
  /** Query for a single PractitionerAggrements */
  PomsPractitionerPreference?: Maybe<PomsPractitionerPreferences>;
  /** Query for a more than or just one PractitionerPreferences */
  PomsPractitionerPreferenceList?: Maybe<Bundle>;
  /** Query for a single PractitionerPreferences */
  PomsPractitionerPrivacy?: Maybe<PomsPractitionerPrivacy>;
  /** Query for a more than or just one PractitionerPrivacy */
  PomsPractitionerPrivacyList?: Maybe<Bundle>;
  /** Query for a single Practitioner */
  Practitioner?: Maybe<Practitioner>;
  /** Query for a single Practitioner */
  PractitionerReviewCount?: Maybe<PractitionerReviewCount>;
  /** Query for a single Practitioner */
  PractitionerWeb?: Maybe<Practitioner>;
  /** Query for a more than or just one Practitioner */
  PractitionerList?: Maybe<Array<Maybe<Practitioner>>>;
  /** Query for a more than or just one Practitioner */
  PractitionerWebListQuery?: Maybe<Array<Maybe<Practitioner>>>;
  /** Access information about a  Practitioner recommendations */
  PractitionerRecommendationsForReports?: Maybe<Array<Maybe<PractionerRecommendation_Extension>>>;
  /** Access information about a Practitioner reviews */
  PractitionerReviewsForReports?: Maybe<Array<Maybe<PractionerReview_Extension>>>;
  /** Access information about a  Practitioner recommendations */
  PractitionerListForReports?: Maybe<Array<Maybe<Practitioner>>>;
  /** Query for a single PractitionerNotification */
  PractitionerNotification?: Maybe<PractitionerNotifications>;
  /** Query for a more than or just one PractitionerNotification */
  PractitionerNotificationList?: Maybe<Array<Maybe<PractitionerNotifications>>>;
  /** Query for a single PractitionerRole */
  PractitionerRole?: Maybe<PractitionerRole>;
  /** Query for a more than or just one PractitionerRole */
  PractitionerRoleList?: Maybe<Bundle>;
  /** Query for a single PractitionerRole */
  PractitionerRoleWeb?: Maybe<PractitionerRole>;
  /** Query for a single PractitionerTask */
  PractitionerTask?: Maybe<PractitionerTasks>;
  /** Query for a more than or just one PractitionerTask */
  PractitionerTaskList?: Maybe<Array<Maybe<PractitionerTasks>>>;
  /** Query for a single Procedure */
  Procedure?: Maybe<Procedure>;
  /** Query for a more than or just one Procedure */
  ProcedureList?: Maybe<Bundle>;
  /** Query for a single Provenance */
  Provenance?: Maybe<Provenance>;
  /** Query for a more than or just one Provenance */
  ProvenanceList?: Maybe<Bundle>;
  /** Query for a single PractitionerPatientCommunication */
  PractitionerPatientCommunication?: Maybe<PractitionerPatientCommunication>;
  /** Query for a more than or just one PractitionerPatientCommunication */
  PractitionerPatientCommunicationList?: Maybe<Array<Maybe<PractitionerPatientCommunication>>>;
  /** Query for a single FeedBack */
  FeedBack?: Maybe<FeedBack>;
  /** Query for a more than or just one PractitionerPrivacy */
  FeedBackList?: Maybe<Array<Maybe<FeedBack>>>;
  /** Query for a single Reminder */
  Disorder?: Maybe<Disorder_Schema>;
  /** Query for a more than or just one Reminder */
  DisorderList?: Maybe<Array<Maybe<Disorder_Schema>>>;
  /** Query for a more than or just one Reminder */
  DisorderActiveList?: Maybe<Array<Maybe<Disorder_Schema>>>;
  /** Query for a single PomsAppointment */
  OtherAppointment?: Maybe<OtherAppointment>;
  /** Query for a more than or just one PomsAppointment */
  OtherAppointmentList?: Maybe<Array<Maybe<OtherAppointment>>>;
  /** Query for a single PomsAppointment */
  PomsAppointment?: Maybe<PomsAppointment>;
  /** Query for a single PomsAppointment */
  PomsAppointmentWeb?: Maybe<PomsAppointment>;
  /** Query for a more than or just one PomsAppointment */
  PomsAppointmentList?: Maybe<Array<Maybe<PomsAppointment>>>;
  /** Query for a more than or just one PomsAppointment */
  PomsAppointmentListByDisorder?: Maybe<Array<Maybe<PomsAppointment>>>;
  /** Query for a more than or just one PomsAppointment */
  PomsAppointmentSummery?: Maybe<PomsAppointmentSummery>;
  /** Query for a more than or just one PomsAppointment */
  ReportsAppointmentList?: Maybe<Array<Maybe<PomsAppointment>>>;
  /** Query for a more than or just one PomsAppointment */
  PerticulerPomsAppointmentList?: Maybe<Array<Maybe<PomsAppointment>>>;
  /** Query for a single Practitioner Schedule */
  PomsPractitionerSchedule?: Maybe<PomsPractitionerSchedule>;
  /** Query for a more than or just one PractitionerSchedule */
  PomsPractitionerScheduleList?: Maybe<Array<Maybe<PomsPractitionerSchedule>>>;
  /** Query for a single Reminder */
  Reminder?: Maybe<Reminder_Schema>;
  /** Query for a more than or just one Reminder */
  ReminderList?: Maybe<Array<Maybe<Reminder_Schema>>>;
  /** Query for a single Schedule */
  Schedule?: Maybe<Schedule>;
  /** Query for a more than or just one Schedule */
  ScheduleList?: Maybe<Bundle>;
  /** Query for a single Slot */
  Slot?: Maybe<Slot>;
  /** Query for a more than or just one Slot */
  SlotList?: Maybe<Array<Maybe<Slot>>>;
  /** Query for a more than or just one Slot */
  SlotListWeb?: Maybe<Array<Maybe<Slot>>>;
  /** Query to get full slots by month */
  SlotListByMonth?: Maybe<Array<Maybe<Slot>>>;
  /** Query to get full slots by month */
  SlotListByMonthWeb?: Maybe<Array<Maybe<Slot>>>;
  /** Validate if Stripe Payment Intent is valid and return status */
  ValidateStripePaymentIntent?: Maybe<PaymentValidation>;
};


export type QueryAdminNotificationArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  isNotification?: Maybe<Scalars['Boolean']>;
};


export type QueryAdminNotificationListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  isNotification?: Maybe<Scalars['Boolean']>;
};


export type QueryAdminTaskArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryAdminTaskListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryAppNotificationsArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  typeOfMessage?: Maybe<Scalars['Int']>;
  typeOfMessageForType?: Maybe<Scalars['Int']>;
  typeOfMessageForTypeId?: Maybe<Scalars['String']>;
};


export type QueryAppNotificationsListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  typeOfMessage?: Maybe<Scalars['Int']>;
  typeOfMessageForType?: Maybe<Scalars['Int']>;
  typeOfMessageForTypeId?: Maybe<Scalars['String']>;
};


export type QueryAppointmentTypeMasterArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  professionalTypeName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryAppointmentTypeMasterListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  professionalTypeName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryAppTasksArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  typeOfMessage?: Maybe<Scalars['Int']>;
  typeOfMessageForType?: Maybe<Scalars['Int']>;
  typeOfMessageForTypeId?: Maybe<Scalars['String']>;
};


export type QueryAppTasksListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  typeOfMessage?: Maybe<Scalars['Int']>;
  typeOfMessageForType?: Maybe<Scalars['Int']>;
  typeOfMessageForTypeId?: Maybe<Scalars['String']>;
};


export type QueryBlogCategoryArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Int']>;
};


export type QueryBlogCategoryListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Int']>;
};


export type QueryBlogArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['String']>;
  subCategoryName?: Maybe<Scalars['String']>;
  authorTypeId?: Maybe<Scalars['String']>;
};


export type QueryBlogListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['String']>;
  subCategoryName?: Maybe<Scalars['String']>;
  authorTypeId?: Maybe<Scalars['String']>;
};


export type QueryChatTrackerCountArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
};


export type QueryChatTrackerListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
};


export type QueryFaqArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  faqType?: Maybe<Scalars['Int']>;
};


export type QueryFaqListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  faqType?: Maybe<Scalars['Int']>;
};


export type QueryGeneralPractitionerArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  gpStatus?: Maybe<Scalars['Boolean']>;
};


export type QueryGeneralPractitionerListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  gpStatus?: Maybe<Scalars['Boolean']>;
};


export type QueryHandbookArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryHandbookListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryJobArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryJobListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryMedicationMasterArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  drugName?: Maybe<Scalars['String']>;
};


export type QueryMedicationMasterListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  drugName?: Maybe<Scalars['String']>;
};


export type QueryOrganisationActivityArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  organisation?: Maybe<Scalars['String']>;
};


export type QueryOrganisationActivityListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  organisation?: Maybe<Scalars['String']>;
};


export type QueryOrganisationAgreementArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  organisation?: Maybe<Scalars['String']>;
};


export type QueryOrganisationAgreementListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  organisation?: Maybe<Scalars['String']>;
};


export type QueryOrganisationPreferenceArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  organisation?: Maybe<Scalars['String']>;
};


export type QueryOrganisationPreferenceListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  organisation?: Maybe<Scalars['String']>;
};


export type QueryOrganisationPrivacyArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  organization?: Maybe<Scalars['String']>;
};


export type QueryOrganisationPrivacyListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  organization?: Maybe<Scalars['String']>;
};


export type QueryOrganizationArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  endpoint?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  partof?: Maybe<Scalars['String']>;
  phonetic?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['token']>;
};


export type QueryOrganizationListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  endpoint?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  partof?: Maybe<Scalars['String']>;
  phonetic?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['token']>;
};


export type QueryOrganizationAffiliationArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['token']>;
  endpoint?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  location?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['String']>;
  participating_organization?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  primary_organization?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['token']>;
  service?: Maybe<Scalars['String']>;
  specialty?: Maybe<Scalars['token']>;
  telecom?: Maybe<Scalars['token']>;
};


export type QueryOrganizationAffiliationListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['token']>;
  endpoint?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  location?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['String']>;
  participating_organization?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  primary_organization?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['token']>;
  service?: Maybe<Scalars['String']>;
  specialty?: Maybe<Scalars['token']>;
  telecom?: Maybe<Scalars['token']>;
};


export type QueryPharmaZoneArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['String']>;
};


export type QueryPharmaZoneListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['String']>;
};


export type QueryPomsMasterTemplateArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  templateName?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
  templateMode?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
};


export type QueryPomsMasterTemplateListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  templateName?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
  templateMode?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
};


export type QueryPomsReferralArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  referral_Type?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};


export type QueryPomsReferralListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  referral_Type?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};


export type QueryThirdPartyReferralListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  referral_Type?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};


export type QueryPricingArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  age?: Maybe<Scalars['Int']>;
  professionalId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  specialistType?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  appointmentName?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  resourceType?: Maybe<Scalars['String']>;
  resource_template_name?: Maybe<Scalars['String']>;
};


export type QueryResourceTemplateNameArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  age?: Maybe<Scalars['Int']>;
  professionalId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  specialistType?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  appointmentName?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  resourceType?: Maybe<Scalars['String']>;
  resource_template_name?: Maybe<Scalars['String']>;
};


export type QueryPricingListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  age?: Maybe<Scalars['Int']>;
  professionalId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  specialistType?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  appointmentName?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  resourceType?: Maybe<Scalars['String']>;
  resource_template_name?: Maybe<Scalars['String']>;
};


export type QueryPricingTypeListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  age?: Maybe<Scalars['Int']>;
  professionalId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  specialistType?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  appointmentName?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  resourceType?: Maybe<Scalars['String']>;
  resource_template_name?: Maybe<Scalars['String']>;
};


export type QueryPricingListByNameArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  age?: Maybe<Scalars['Int']>;
  professionalId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  specialistType?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  appointmentName?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  resourceType?: Maybe<Scalars['String']>;
  resource_template_name?: Maybe<Scalars['String']>;
};


export type QueryProfessionalTypeArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  roleName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryProfessionalTypeListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  roleName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryQuestionnaireArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  code?: Maybe<Scalars['token']>;
  context?: Maybe<Scalars['token']>;
  context_quantity?: Maybe<Scalars['String']>;
  context_type?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  definition?: Maybe<Scalars['uri']>;
  description?: Maybe<Scalars['String']>;
  effective?: Maybe<Scalars['date']>;
  identifier?: Maybe<Scalars['token']>;
  jurisdiction?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  subject_type?: Maybe<Scalars['token']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['uri']>;
  version?: Maybe<Scalars['token']>;
  context_type_quantity?: Maybe<Scalars['String']>;
  context_type_value?: Maybe<Scalars['String']>;
};


export type QueryQuestionnaireListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  code?: Maybe<Scalars['token']>;
  context?: Maybe<Scalars['token']>;
  context_quantity?: Maybe<Scalars['String']>;
  context_type?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  definition?: Maybe<Scalars['uri']>;
  description?: Maybe<Scalars['String']>;
  effective?: Maybe<Scalars['date']>;
  identifier?: Maybe<Scalars['token']>;
  jurisdiction?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  subject_type?: Maybe<Scalars['token']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['uri']>;
  version?: Maybe<Scalars['token']>;
  context_type_quantity?: Maybe<Scalars['String']>;
  context_type_value?: Maybe<Scalars['String']>;
};


export type QueryQuestionnaireAssignArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  questionnaireId?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
  appointmentTypeList?: Maybe<Scalars['String']>;
};


export type QueryQuestionnaireAssignListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  questionnaireId?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
  appointmentTypeList?: Maybe<Scalars['String']>;
};


export type QueryQuestionnaireBuilderArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  financialType?: Maybe<Scalars['String']>;
};


export type QueryQuestionnaireBuilderListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  financialType?: Maybe<Scalars['String']>;
};


export type QueryQuestionnaireResponseArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  author?: Maybe<Scalars['String']>;
  authored?: Maybe<Scalars['date']>;
  based_on?: Maybe<Scalars['String']>;
  encounter?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  part_of?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['String']>;
  questionnaire?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  subject?: Maybe<Scalars['String']>;
};


export type QueryQuestionnaireResponseListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  author?: Maybe<Scalars['String']>;
  authored?: Maybe<Scalars['date']>;
  based_on?: Maybe<Scalars['String']>;
  encounter?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  part_of?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['String']>;
  questionnaire?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  subject?: Maybe<Scalars['String']>;
};


export type QueryQuoteArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['String']>;
  subCategoryName?: Maybe<Scalars['String']>;
  authorTypeId?: Maybe<Scalars['String']>;
};


export type QueryQuoteListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['String']>;
  subCategoryName?: Maybe<Scalars['String']>;
  authorTypeId?: Maybe<Scalars['String']>;
};


export type QuerySubSpecialtyMasterArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  professionalTypeName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};


export type QuerySubSpecialtyMasterListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  professionalTypeName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryTaskArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  authored_on?: Maybe<Scalars['date']>;
  based_on?: Maybe<Scalars['String']>;
  business_status?: Maybe<Scalars['token']>;
  code?: Maybe<Scalars['token']>;
  encounter?: Maybe<Scalars['String']>;
  focus?: Maybe<Scalars['String']>;
  group_identifier?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  intent?: Maybe<Scalars['token']>;
  modified?: Maybe<Scalars['date']>;
  owner?: Maybe<Scalars['String']>;
  part_of?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['String']>;
  performer?: Maybe<Scalars['token']>;
  period?: Maybe<Scalars['date']>;
  priority?: Maybe<Scalars['token']>;
  requester?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  subject?: Maybe<Scalars['String']>;
};


export type QueryTaskListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  authored_on?: Maybe<Scalars['date']>;
  based_on?: Maybe<Scalars['String']>;
  business_status?: Maybe<Scalars['token']>;
  code?: Maybe<Scalars['token']>;
  encounter?: Maybe<Scalars['String']>;
  focus?: Maybe<Scalars['String']>;
  group_identifier?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  intent?: Maybe<Scalars['token']>;
  modified?: Maybe<Scalars['date']>;
  owner?: Maybe<Scalars['String']>;
  part_of?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['String']>;
  performer?: Maybe<Scalars['token']>;
  period?: Maybe<Scalars['date']>;
  priority?: Maybe<Scalars['token']>;
  requester?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  subject?: Maybe<Scalars['String']>;
};


export type QueryTaskManagerListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  task_type?: Maybe<Scalars['String']>;
  task_name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['id']>;
  status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  filterType?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  order_by?: Maybe<Scalars['String']>;
  task_from?: Maybe<Scalars['String']>;
  task_to?: Maybe<Scalars['String']>;
  assignee_id?: Maybe<Scalars['String']>;
  who_can_assign?: Maybe<Scalars['String']>;
  rightFilter?: Maybe<Scalars['String']>;
  todayDate?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
};


export type QueryGetTaskListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  task_type?: Maybe<Scalars['String']>;
  task_name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['id']>;
  status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  filterType?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  order_by?: Maybe<Scalars['String']>;
  task_from?: Maybe<Scalars['String']>;
  task_to?: Maybe<Scalars['String']>;
  assignee_id?: Maybe<Scalars['String']>;
  who_can_assign?: Maybe<Scalars['String']>;
  rightFilter?: Maybe<Scalars['String']>;
  todayDate?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
};


export type QueryGetTaskCountSummaryArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  task_type?: Maybe<Scalars['String']>;
  task_name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['id']>;
  status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  filterType?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  order_by?: Maybe<Scalars['String']>;
  task_from?: Maybe<Scalars['String']>;
  task_to?: Maybe<Scalars['String']>;
  assignee_id?: Maybe<Scalars['String']>;
  who_can_assign?: Maybe<Scalars['String']>;
  rightFilter?: Maybe<Scalars['String']>;
  todayDate?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
};


export type QueryGetTaskCommentsArgs = {
  task_id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetUnreadCommentCountArgs = {
  task_id: Scalars['String'];
  user_id: Scalars['String'];
};


export type QueryTasksMessagesArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  typeOfMessage?: Maybe<Scalars['Int']>;
  typeOfMessageForType?: Maybe<Scalars['Int']>;
  typeOfMessageForTypeId?: Maybe<Scalars['String']>;
};


export type QueryTasksMessagesListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  typeOfMessage?: Maybe<Scalars['Int']>;
  typeOfMessageForType?: Maybe<Scalars['Int']>;
  typeOfMessageForTypeId?: Maybe<Scalars['String']>;
};


export type QueryValueSetArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  context?: Maybe<Scalars['token']>;
  context_quantity?: Maybe<Scalars['String']>;
  context_type?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  jurisdiction?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['uri']>;
  version?: Maybe<Scalars['token']>;
  context_type_quantity?: Maybe<Scalars['String']>;
  context_type_value?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  code?: Maybe<Scalars['token']>;
  expansion?: Maybe<Scalars['uri']>;
  reference?: Maybe<Scalars['uri']>;
};


export type QueryValueSetListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  context?: Maybe<Scalars['token']>;
  context_quantity?: Maybe<Scalars['String']>;
  context_type?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  jurisdiction?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['uri']>;
  version?: Maybe<Scalars['token']>;
  context_type_quantity?: Maybe<Scalars['String']>;
  context_type_value?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  code?: Maybe<Scalars['token']>;
  expansion?: Maybe<Scalars['uri']>;
  reference?: Maybe<Scalars['uri']>;
};


export type QueryWebContactArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  contactType?: Maybe<Scalars['Int']>;
};


export type QueryWebContactListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  contactType?: Maybe<Scalars['Int']>;
};


export type QueryPatientInvoiceArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
};


export type QueryPatientInvoiceListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
};


export type QueryPomsInvoiceBillingArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  entityType?: Maybe<Scalars['String']>;
  nationalInsuranceNumber?: Maybe<Scalars['String']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsInvoiceBillingListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  entityType?: Maybe<Scalars['String']>;
  nationalInsuranceNumber?: Maybe<Scalars['String']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPractitionerStatementArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
};


export type QueryPractitionerStatementListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
};


export type QueryRolePermissionArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  roleName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryRolePermissionListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  roleName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryUserArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  userType?: Maybe<Scalars['String']>;
};


export type QueryUserListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  userType?: Maybe<Scalars['String']>;
};


export type QueryAdminListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  userType?: Maybe<Scalars['String']>;
};


export type QueryBasicSignedListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  userType?: Maybe<Scalars['String']>;
};


export type QueryRunScriptToInsertArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  userType?: Maybe<Scalars['String']>;
};


export type QueryGetUserStatusArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  userType?: Maybe<Scalars['String']>;
};


export type QueryGetAdminDetailsArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  userType?: Maybe<Scalars['String']>;
};


export type QueryAppNotificationsSimpleArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryAppTasksSimpleArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryCrisisSafeguardArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  countAll?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};


export type QueryCrisisSafeguardListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  countAll?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};


export type QueryPatientArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  birthdate?: Maybe<Scalars['date']>;
  death_date?: Maybe<Scalars['date']>;
  deceased?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  general_practitioner?: Maybe<Scalars['String']>;
  given?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  language?: Maybe<Scalars['token']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageNo?: Maybe<Scalars['Int']>;
  searchType?: Maybe<Scalars['Int']>;
  searchParam?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  patientList?: Maybe<Array<Maybe<Scalars['String']>>>;
  year?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
};


export type QueryPatientListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  birthdate?: Maybe<Scalars['date']>;
  death_date?: Maybe<Scalars['date']>;
  deceased?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  general_practitioner?: Maybe<Scalars['String']>;
  given?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  language?: Maybe<Scalars['token']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageNo?: Maybe<Scalars['Int']>;
  searchType?: Maybe<Scalars['Int']>;
  searchParam?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  patientList?: Maybe<Array<Maybe<Scalars['String']>>>;
  year?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
};


export type QueryPatientImageListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  birthdate?: Maybe<Scalars['date']>;
  death_date?: Maybe<Scalars['date']>;
  deceased?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  general_practitioner?: Maybe<Scalars['String']>;
  given?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  language?: Maybe<Scalars['token']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageNo?: Maybe<Scalars['Int']>;
  searchType?: Maybe<Scalars['Int']>;
  searchParam?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  patientList?: Maybe<Array<Maybe<Scalars['String']>>>;
  year?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
};


export type QueryPatientCountByMonthArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  birthdate?: Maybe<Scalars['date']>;
  death_date?: Maybe<Scalars['date']>;
  deceased?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  general_practitioner?: Maybe<Scalars['String']>;
  given?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  language?: Maybe<Scalars['token']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageNo?: Maybe<Scalars['Int']>;
  searchType?: Maybe<Scalars['Int']>;
  searchParam?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  patientList?: Maybe<Array<Maybe<Scalars['String']>>>;
  year?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
};


export type QueryGetPatientListCountArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  birthdate?: Maybe<Scalars['date']>;
  death_date?: Maybe<Scalars['date']>;
  deceased?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  general_practitioner?: Maybe<Scalars['String']>;
  given?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  language?: Maybe<Scalars['token']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageNo?: Maybe<Scalars['Int']>;
  searchType?: Maybe<Scalars['Int']>;
  searchParam?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  patientList?: Maybe<Array<Maybe<Scalars['String']>>>;
  year?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
};


export type QueryGetPatientReportListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  birthdate?: Maybe<Scalars['date']>;
  death_date?: Maybe<Scalars['date']>;
  deceased?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  general_practitioner?: Maybe<Scalars['String']>;
  given?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  language?: Maybe<Scalars['token']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageNo?: Maybe<Scalars['Int']>;
  searchType?: Maybe<Scalars['Int']>;
  searchParam?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  patientList?: Maybe<Array<Maybe<Scalars['String']>>>;
  year?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
};


export type QueryGetPatientDataByListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  birthdate?: Maybe<Scalars['date']>;
  death_date?: Maybe<Scalars['date']>;
  deceased?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  general_practitioner?: Maybe<Scalars['String']>;
  given?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  language?: Maybe<Scalars['token']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageNo?: Maybe<Scalars['Int']>;
  searchType?: Maybe<Scalars['Int']>;
  searchParam?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  patientList?: Maybe<Array<Maybe<Scalars['String']>>>;
  year?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
};


export type QueryExportActiveWhatsAppEnabledPatientListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  whatsappActive?: Maybe<Scalars['Boolean']>;
};


export type QueryAppAllAdminListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  whatsappActive?: Maybe<Scalars['Boolean']>;
};


export type QueryPatientFinancialInfoArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  financialType?: Maybe<Scalars['String']>;
};


export type QueryPatientFinancialInfoListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  financialType?: Maybe<Scalars['String']>;
};


export type QueryPatientNotificationArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  isNotification?: Maybe<Scalars['Boolean']>;
};


export type QueryPatientNotificationListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  isNotification?: Maybe<Scalars['Boolean']>;
};


export type QueryPatientPrescriptionArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  prescriptionStatus?: Maybe<Scalars['Int']>;
};


export type QueryPatientPrescriptionListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  prescriptionStatus?: Maybe<Scalars['Int']>;
};


export type QueryPatientQuestionnaireArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  timeline?: Maybe<Scalars['String']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  assignedBy?: Maybe<Scalars['String']>;
  questionnaireName?: Maybe<Scalars['String']>;
};


export type QueryPatientQuestionnaireListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  timeline?: Maybe<Scalars['String']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  assignedBy?: Maybe<Scalars['String']>;
  questionnaireName?: Maybe<Scalars['String']>;
};


export type QueryExternalPatientQuestionnaireArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  timeline?: Maybe<Scalars['String']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  assignedBy?: Maybe<Scalars['String']>;
  questionnaireName?: Maybe<Scalars['String']>;
};


export type QueryExternalPatientQuestionnaireListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  timeline?: Maybe<Scalars['String']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  assignedBy?: Maybe<Scalars['String']>;
  questionnaireName?: Maybe<Scalars['String']>;
};


export type QueryPatientRecordsLogArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};


export type QueryPatientRecordsLogListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};


export type QueryPatientTaskArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryPatientTaskListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryPatientToDoTaskListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryPractitionerToDoTaskListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryPractitionerToDoTaskListCountArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryPatientToDoTaskListCountArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryPomsPatientActivityArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  patient?: Maybe<Scalars['String']>;
};


export type QueryPomsPatientActivityListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  patient?: Maybe<Scalars['String']>;
};


export type QueryPomsPatientDocumentArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  patientId?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  timeline?: Maybe<Scalars['String']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  documentFor?: Maybe<Scalars['String']>;
};


export type QueryPomsPatientDocumentListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  patientId?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  timeline?: Maybe<Scalars['String']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  documentFor?: Maybe<Scalars['String']>;
};


export type QueryPomsPatientLetterArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  templateName?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};


export type QueryPomsPatientLetterListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  templateName?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};


export type QueryPomsPatientPreferenceArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsPatientPreferenceListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsPatientPrivacyArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsPatientPrivacyListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QuerySignPostingArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
  organizationCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  search?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  orderByMostShare?: Maybe<Scalars['Boolean']>;
  interval?: Maybe<Scalars['String']>;
};


export type QueryLeafletArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  search?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  leafletSearchtag?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  orderByMostShare?: Maybe<Scalars['Boolean']>;
  interval?: Maybe<Scalars['String']>;
};


export type QuerySignPostingListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
  organizationCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  search?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  orderByMostShare?: Maybe<Scalars['Boolean']>;
  interval?: Maybe<Scalars['String']>;
};


export type QueryLeafletListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  search?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  leafletSearchtag?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  orderByMostShare?: Maybe<Scalars['Boolean']>;
  interval?: Maybe<Scalars['String']>;
};


export type QueryLeafletCountArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  search?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  leafletSearchtag?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  orderByMostShare?: Maybe<Scalars['Boolean']>;
  interval?: Maybe<Scalars['String']>;
};


export type QuerySignPostingCountArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
  organizationCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  search?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  orderByMostShare?: Maybe<Scalars['Boolean']>;
  interval?: Maybe<Scalars['String']>;
};


export type QuerySignPostingOrganizationListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
  organizationCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  search?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  fetchingFrom?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  orderByMostShare?: Maybe<Scalars['Boolean']>;
  interval?: Maybe<Scalars['String']>;
};


export type QuerySignPostingCategoryArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  categoryName?: Maybe<Scalars['String']>;
};


export type QuerySignPostingCategoryListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  categoryName?: Maybe<Scalars['String']>;
};


export type QueryDocumentReferenceArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  patient?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['token']>;
  encounter?: Maybe<Scalars['String']>;
  authenticator?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['token']>;
  contenttype?: Maybe<Scalars['token']>;
  custodian?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['token']>;
  facility?: Maybe<Scalars['token']>;
  format?: Maybe<Scalars['token']>;
  language?: Maybe<Scalars['token']>;
  location?: Maybe<Scalars['uri']>;
  period?: Maybe<Scalars['date']>;
  related?: Maybe<Scalars['String']>;
  relatesto?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['token']>;
  security_label?: Maybe<Scalars['token']>;
  setting?: Maybe<Scalars['token']>;
  status?: Maybe<Scalars['token']>;
  subject?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};


export type QueryDocumentReferenceListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  patient?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['token']>;
  encounter?: Maybe<Scalars['String']>;
  authenticator?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['token']>;
  contenttype?: Maybe<Scalars['token']>;
  custodian?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['token']>;
  facility?: Maybe<Scalars['token']>;
  format?: Maybe<Scalars['token']>;
  language?: Maybe<Scalars['token']>;
  location?: Maybe<Scalars['uri']>;
  period?: Maybe<Scalars['date']>;
  related?: Maybe<Scalars['String']>;
  relatesto?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['token']>;
  security_label?: Maybe<Scalars['token']>;
  setting?: Maybe<Scalars['token']>;
  status?: Maybe<Scalars['token']>;
  subject?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};


export type QueryLocationArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  endpoint?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  near?: Maybe<Scalars['String']>;
  operational_status?: Maybe<Scalars['token']>;
  organization?: Maybe<Scalars['String']>;
  partof?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  type?: Maybe<Scalars['token']>;
};


export type QueryLocationListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  endpoint?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  near?: Maybe<Scalars['String']>;
  operational_status?: Maybe<Scalars['token']>;
  organization?: Maybe<Scalars['String']>;
  partof?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  type?: Maybe<Scalars['token']>;
};


export type QueryLocationListWebArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  endpoint?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  near?: Maybe<Scalars['String']>;
  operational_status?: Maybe<Scalars['token']>;
  organization?: Maybe<Scalars['String']>;
  partof?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  type?: Maybe<Scalars['token']>;
};


export type QueryPomsPractitionerActivityArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsPractitionerActivityListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsPractitionerAgreementArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsPractitionerAgreementListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsPractitionerPreferenceArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsPractitionerPreferenceListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsPractitionerPrivacyArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPomsPractitionerPrivacyListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitioner?: Maybe<Scalars['String']>;
};


export type QueryPractitionerArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  resourceType?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  nationality?: Maybe<Scalars['token']>;
  given?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  practionerAbout?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  communication?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
};


export type QueryPractitionerReviewCountArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  resourceType?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  nationality?: Maybe<Scalars['token']>;
  given?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  practionerAbout?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  communication?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
};


export type QueryPractitionerWebArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  resourceType?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  nationality?: Maybe<Scalars['token']>;
  given?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  practionerAbout?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  communication?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
};


export type QueryPractitionerListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  resourceType?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  nationality?: Maybe<Scalars['token']>;
  given?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  practionerAbout?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  communication?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
};


export type QueryPractitionerWebListQueryArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  resourceType?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  nationality?: Maybe<Scalars['token']>;
  given?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  practionerAbout?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  communication?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
};


export type QueryPractitionerRecommendationsForReportsArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  resourceType?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  nationality?: Maybe<Scalars['token']>;
  given?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  practionerAbout?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  communication?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
};


export type QueryPractitionerReviewsForReportsArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  resourceType?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  nationality?: Maybe<Scalars['token']>;
  given?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  practionerAbout?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  communication?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
};


export type QueryPractitionerListForReportsArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  resourceType?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postalcode?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_use?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  family?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['token']>;
  nationality?: Maybe<Scalars['token']>;
  given?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['token']>;
  phonetic?: Maybe<Scalars['String']>;
  telecom?: Maybe<Scalars['token']>;
  practionerAbout?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  communication?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  name?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
};


export type QueryPractitionerNotificationArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  isNotification?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryPractitionerNotificationListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
  isNotification?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryPractitionerRoleArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  phone?: Maybe<Scalars['token']>;
  telecom?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  endpoint?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  location?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  practitioner?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['token']>;
  service?: Maybe<Scalars['String']>;
  specialty?: Maybe<Scalars['token']>;
};


export type QueryPractitionerRoleListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  phone?: Maybe<Scalars['token']>;
  telecom?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  endpoint?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  location?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  practitioner?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['token']>;
  service?: Maybe<Scalars['String']>;
  specialty?: Maybe<Scalars['token']>;
};


export type QueryPractitionerRoleWebArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  email?: Maybe<Scalars['token']>;
  phone?: Maybe<Scalars['token']>;
  telecom?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  endpoint?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['token']>;
  location?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  practitioner?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['token']>;
  service?: Maybe<Scalars['String']>;
  specialty?: Maybe<Scalars['token']>;
};


export type QueryPractitionerTaskArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryPractitionerTaskListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryProcedureArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  code?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  identifier?: Maybe<Scalars['token']>;
  patient?: Maybe<Scalars['String']>;
  encounter?: Maybe<Scalars['String']>;
  based_on?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['token']>;
  instantiates_canonical?: Maybe<Scalars['String']>;
  instantiates_uri?: Maybe<Scalars['uri']>;
  location?: Maybe<Scalars['String']>;
  part_of?: Maybe<Scalars['String']>;
  performer?: Maybe<Scalars['String']>;
  reason_code?: Maybe<Scalars['token']>;
  reason_reference?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  subject?: Maybe<Scalars['String']>;
};


export type QueryProcedureListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  code?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
  identifier?: Maybe<Scalars['token']>;
  patient?: Maybe<Scalars['String']>;
  encounter?: Maybe<Scalars['String']>;
  based_on?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['token']>;
  instantiates_canonical?: Maybe<Scalars['String']>;
  instantiates_uri?: Maybe<Scalars['uri']>;
  location?: Maybe<Scalars['String']>;
  part_of?: Maybe<Scalars['String']>;
  performer?: Maybe<Scalars['String']>;
  reason_code?: Maybe<Scalars['token']>;
  reason_reference?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['token']>;
  subject?: Maybe<Scalars['String']>;
};


export type QueryProvenanceArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  agent?: Maybe<Scalars['String']>;
  agent_role?: Maybe<Scalars['token']>;
  agent_type?: Maybe<Scalars['token']>;
  entity?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['String']>;
  recorded?: Maybe<Scalars['date']>;
  signature_type?: Maybe<Scalars['token']>;
  target?: Maybe<Scalars['String']>;
  when?: Maybe<Scalars['date']>;
};


export type QueryProvenanceListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  agent?: Maybe<Scalars['String']>;
  agent_role?: Maybe<Scalars['token']>;
  agent_type?: Maybe<Scalars['token']>;
  entity?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['String']>;
  recorded?: Maybe<Scalars['date']>;
  signature_type?: Maybe<Scalars['token']>;
  target?: Maybe<Scalars['String']>;
  when?: Maybe<Scalars['date']>;
};


export type QueryPractitionerPatientCommunicationArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  patientId?: Maybe<Scalars['String']>;
  commFromType?: Maybe<Scalars['Int']>;
  commToType?: Maybe<Scalars['Int']>;
  fromId?: Maybe<Scalars['String']>;
  toId?: Maybe<Scalars['String']>;
  requiredFrom?: Maybe<Scalars['Int']>;
  listType?: Maybe<Scalars['String']>;
  searchText?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryPractitionerPatientCommunicationListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  patientId?: Maybe<Scalars['String']>;
  commFromType?: Maybe<Scalars['Int']>;
  commToType?: Maybe<Scalars['Int']>;
  fromId?: Maybe<Scalars['String']>;
  toId?: Maybe<Scalars['String']>;
  requiredFrom?: Maybe<Scalars['Int']>;
  listType?: Maybe<Scalars['String']>;
  searchText?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryFeedBackArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  feedBackType?: Maybe<Scalars['Int']>;
  feedBackGetFrom?: Maybe<Scalars['Int']>;
  fromUserId?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  againstUserId?: Maybe<Scalars['String']>;
};


export type QueryFeedBackListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  feedBackType?: Maybe<Scalars['Int']>;
  feedBackGetFrom?: Maybe<Scalars['Int']>;
  fromUserId?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  againstUserId?: Maybe<Scalars['String']>;
};


export type QueryDisorderArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryDisorderListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryDisorderActiveListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryOtherAppointmentArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  appointmentListType?: Maybe<Scalars['String']>;
  appointmentStatus?: Maybe<Scalars['String']>;
  appointmentPayType?: Maybe<Scalars['String']>;
  selectedFrom?: Maybe<Scalars['String']>;
  selectedEnd?: Maybe<Scalars['String']>;
  searchfilter?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};


export type QueryOtherAppointmentListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  appointmentListType?: Maybe<Scalars['String']>;
  appointmentStatus?: Maybe<Scalars['String']>;
  appointmentPayType?: Maybe<Scalars['String']>;
  selectedFrom?: Maybe<Scalars['String']>;
  selectedEnd?: Maybe<Scalars['String']>;
  searchfilter?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};


export type QueryPomsAppointmentArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  disorderName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  appointmentListType?: Maybe<Scalars['String']>;
  appointmentStatus?: Maybe<Scalars['String']>;
  appointmentPayType?: Maybe<Scalars['String']>;
  selectedFrom?: Maybe<Scalars['String']>;
  selectedEnd?: Maybe<Scalars['String']>;
  searchfilter?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};


export type QueryPomsAppointmentWebArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  disorderName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  appointmentListType?: Maybe<Scalars['String']>;
  appointmentStatus?: Maybe<Scalars['String']>;
  appointmentPayType?: Maybe<Scalars['String']>;
  selectedFrom?: Maybe<Scalars['String']>;
  selectedEnd?: Maybe<Scalars['String']>;
  searchfilter?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};


export type QueryPomsAppointmentListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  disorderName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  appointmentListType?: Maybe<Scalars['String']>;
  appointmentStatus?: Maybe<Scalars['String']>;
  appointmentPayType?: Maybe<Scalars['String']>;
  selectedFrom?: Maybe<Scalars['String']>;
  selectedEnd?: Maybe<Scalars['String']>;
  searchfilter?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};


export type QueryPomsAppointmentListByDisorderArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  disorderName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  appointmentListType?: Maybe<Scalars['String']>;
  appointmentStatus?: Maybe<Scalars['String']>;
  appointmentPayType?: Maybe<Scalars['String']>;
  selectedFrom?: Maybe<Scalars['String']>;
  selectedEnd?: Maybe<Scalars['String']>;
  searchfilter?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};


export type QueryPomsAppointmentSummeryArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  disorderName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  appointmentListType?: Maybe<Scalars['String']>;
  appointmentStatus?: Maybe<Scalars['String']>;
  appointmentPayType?: Maybe<Scalars['String']>;
  selectedFrom?: Maybe<Scalars['String']>;
  selectedEnd?: Maybe<Scalars['String']>;
  searchfilter?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};


export type QueryReportsAppointmentListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  disorderName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  appointmentListType?: Maybe<Scalars['String']>;
  appointmentStatus?: Maybe<Scalars['String']>;
  appointmentPayType?: Maybe<Scalars['String']>;
  selectedFrom?: Maybe<Scalars['String']>;
  selectedEnd?: Maybe<Scalars['String']>;
  searchfilter?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};


export type QueryPerticulerPomsAppointmentListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  disorderName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  practitionerType?: Maybe<Scalars['String']>;
  _page?: Maybe<Scalars['Int']>;
  _limit?: Maybe<Scalars['Int']>;
  appointmentListType?: Maybe<Scalars['String']>;
  appointmentStatus?: Maybe<Scalars['String']>;
  appointmentPayType?: Maybe<Scalars['String']>;
  selectedFrom?: Maybe<Scalars['String']>;
  selectedEnd?: Maybe<Scalars['String']>;
  searchfilter?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};


export type QueryPomsPractitionerScheduleArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  patient?: Maybe<Scalars['String']>;
};


export type QueryPomsPractitionerScheduleListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  patient?: Maybe<Scalars['String']>;
};


export type QueryReminderArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryReminderListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryScheduleArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  actor?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  identifier?: Maybe<Scalars['token']>;
  service_category?: Maybe<Scalars['token']>;
  service_type?: Maybe<Scalars['token']>;
  specialty?: Maybe<Scalars['token']>;
};


export type QueryScheduleListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  active?: Maybe<Scalars['token']>;
  actor?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  identifier?: Maybe<Scalars['token']>;
  service_category?: Maybe<Scalars['token']>;
  service_type?: Maybe<Scalars['token']>;
  specialty?: Maybe<Scalars['token']>;
};


export type QuerySlotArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  appointment_type?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  schedule?: Maybe<Scalars['String']>;
  service_category?: Maybe<Scalars['token']>;
  service_type?: Maybe<Scalars['token']>;
  specialty?: Maybe<Scalars['token']>;
  start?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['token']>;
  professionalId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
};


export type QuerySlotListArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  appointment_type?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  schedule?: Maybe<Scalars['String']>;
  service_category?: Maybe<Scalars['token']>;
  service_type?: Maybe<Scalars['token']>;
  specialty?: Maybe<Scalars['token']>;
  start?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['token']>;
  professionalId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
};


export type QuerySlotListWebArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  appointment_type?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  schedule?: Maybe<Scalars['String']>;
  service_category?: Maybe<Scalars['token']>;
  service_type?: Maybe<Scalars['token']>;
  specialty?: Maybe<Scalars['token']>;
  start?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['token']>;
  professionalId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
};


export type QuerySlotListByMonthArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  appointment_type?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  schedule?: Maybe<Scalars['String']>;
  service_category?: Maybe<Scalars['token']>;
  service_type?: Maybe<Scalars['token']>;
  specialty?: Maybe<Scalars['token']>;
  start?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['token']>;
  professionalId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
};


export type QuerySlotListByMonthWebArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  appointment_type?: Maybe<Scalars['token']>;
  identifier?: Maybe<Scalars['token']>;
  schedule?: Maybe<Scalars['String']>;
  service_category?: Maybe<Scalars['token']>;
  service_type?: Maybe<Scalars['token']>;
  specialty?: Maybe<Scalars['token']>;
  start?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['token']>;
  professionalId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
};


export type QueryValidateStripePaymentIntentArgs = {
  _text?: Maybe<Scalars['String']>;
  _content?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['token']>;
  _lastUpdated?: Maybe<Scalars['date']>;
  _profile?: Maybe<Scalars['String']>;
  _query?: Maybe<Scalars['token']>;
  _security?: Maybe<Scalars['token']>;
  _source?: Maybe<Scalars['uri']>;
  _tag?: Maybe<Scalars['token']>;
  payment_id?: Maybe<Scalars['String']>;
};

export type QuestionaryAppointmentTypeList_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /** Text that is displayed above the contents of the group or as the text of the question being answered. */
  name?: Maybe<Scalars['String']>;
};

/** QuestionaryAppointmentTypeList_Schema */
export type QuestionaryAppointmentTypeList_Schema = {
  __typename?: 'QuestionaryAppointmentTypeList_Schema';
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  /** Referral_Type. */
  name?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Questionere Response Extension Type: Custom Fields . */
export type QuestionereResponseExtension = {
  /** custom1 field data. */
  useremail?: Maybe<Scalars['String']>;
  /** custom2 field data. */
  username?: Maybe<Scalars['String']>;
  /** operationType field data. */
  patScore?: Maybe<Scalars['String']>;
  /** ipadress field data. */
  ipadress?: Maybe<Scalars['String']>;
  /** operationType field data. */
  resultType?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  suggestedSpecalisti?: Maybe<Scalars['String']>;
  /** ipadress field data. */
  age?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Questionere Response Extension Type: Custom Fields . */
export type QuestionereResponseExtension_Input = {
  __typename?: 'QuestionereResponseExtension_Input';
  /** custom1 field data. */
  useremail?: Maybe<Scalars['String']>;
  /** custom2 field data. */
  username?: Maybe<Scalars['String']>;
  /** operationType field data. */
  patScore?: Maybe<Scalars['String']>;
  /** ipadress field data. */
  ipadress?: Maybe<Scalars['String']>;
  /** operationType field data. */
  resultType?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  suggestedSpecalisti?: Maybe<Scalars['String']>;
  /** ipadress field data. */
  age?: Maybe<Scalars['String']>;
};

/**
 * A structured set of questions intended to guide the collection of answers from
 * end-users. Questionnaires provide detailed control over order, presentation,
 * phraseology and grouping to allow coherent, consistent data collection.
 */
export type Questionnaire = {
  __typename?: 'Questionnaire';
  /** Type of resource */
  resourceType: Questionnaire_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this questionnaire when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this questionnaire is
   * (or will be) published. This URL can be the target of a canonical reference.
   * It SHALL remain the same when the questionnaire is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this questionnaire when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this questionnaire is
   * (or will be) published. This URL can be the target of a canonical reference.
   * It SHALL remain the same when the questionnaire is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this questionnaire when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the questionnaire when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the questionnaire author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the questionnaire when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the questionnaire author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the questionnaire. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the questionnaire. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the questionnaire. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the questionnaire. */
  title?: Maybe<Scalars['String']>;
  /** The URL of a Questionnaire that this Questionnaire is based on. */
  _derivedFrom?: Maybe<Element>;
  /** The URL of a Questionnaire that this Questionnaire is based on. */
  derivedFrom?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** The status of this questionnaire. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this questionnaire. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this questionnaire is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this questionnaire is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /** The types of subjects that can be the subject of responses created for the questionnaire. */
  _subjectType?: Maybe<Element>;
  /** The types of subjects that can be the subject of responses created for the questionnaire. */
  subjectType?: Maybe<Array<Maybe<Scalars['code']>>>;
  /**
   * The date  (and optionally time) when the questionnaire was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the questionnaire changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the questionnaire was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the questionnaire changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the questionnaire. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the questionnaire. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the questionnaire from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the questionnaire from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate
   * questionnaire instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the questionnaire is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this questionnaire is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this questionnaire is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the questionnaire and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the questionnaire.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the questionnaire and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the questionnaire.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the questionnaire content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /** An identifier for this question or group of questions in a particular terminology such as LOINC. */
  code?: Maybe<Array<Maybe<Coding>>>;
  /** A particular question, question grouping or display text that is part of the questionnaire. */
  item?: Maybe<Array<Maybe<Questionnaireitem>>>;
};

/** QuestionnaireAssign_Input */
export type QuestionnaireAssign = {
  __typename?: 'QuestionnaireAssign';
  /** Type of resource */
  resourceType: QuestionnaireAssign_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** patientId */
  updatedOn?: Maybe<Scalars['String']>;
  /** patientId */
  createdOn?: Maybe<Scalars['String']>;
  /** patientId */
  questionnaireId?: Maybe<Scalars['String']>;
  /** financialType. */
  practitionerId?: Maybe<Scalars['String']>;
  /** financialType. */
  practitionerName?: Maybe<Scalars['String']>;
  /** financialType. */
  professionalId?: Maybe<Scalars['String']>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  appointmentTypeList?: Maybe<Array<Maybe<QuestionaryAppointmentTypeList_Schema>>>;
};

export enum QuestionnaireAssign_Enum {
  QuestionnaireAssign = 'QuestionnaireAssign'
}

export enum QuestionnaireAssign_Enum_Input {
  QuestionnaireAssign = 'QuestionnaireAssign'
}

/** QuestionnaireAssign_Input */
export type QuestionnaireAssign_Input = {
  /** Type of resource */
  resourceType: QuestionnaireAssign_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** patientId */
  questionnaireId?: Maybe<Scalars['String']>;
  /** financialType. */
  practitionerId?: Maybe<Scalars['String']>;
  /** financialType. */
  practitionerName?: Maybe<Scalars['String']>;
  /** financialType. */
  professionalId?: Maybe<Scalars['String']>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  appointmentTypeList?: Maybe<Array<Maybe<QuestionaryAppointmentTypeList_Input>>>;
};

/** QuestionnaireBuilder_Input */
export type QuestionnaireBuilder = {
  __typename?: 'QuestionnaireBuilder';
  /** Type of resource */
  resourceType: QuestionnaireBuilder_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** patientId */
  administeredType?: Maybe<Scalars['Int']>;
  /** patientId */
  totalScore?: Maybe<Scalars['Int']>;
  /** patientId */
  questionnaireName?: Maybe<Scalars['String']>;
  /** financialType. */
  questionnaireDescription?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  questions?: Maybe<Array<Maybe<QuestionnaireBuilderQuestion_Schema>>>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  practitionersList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  appointmentTypeList?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type QuestionnaireBuilderQuestionOption_Input = {
  /** operationType field data. */
  option?: Maybe<Scalars['String']>;
  /** operationType field data. */
  optionId?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  optionScore?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for QuestionnaireBuilderQuestion */
export type QuestionnaireBuilderQuestionOption_Schema = {
  __typename?: 'QuestionnaireBuilderQuestionOption_Schema';
  /** operationType field data. */
  option?: Maybe<Scalars['String']>;
  /** operationType field data. */
  optionId?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  optionScore?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type QuestionnaireBuilderQuestion_Input = {
  /** operationType field data. */
  question?: Maybe<Scalars['String']>;
  /** operationType field data. */
  optionType?: Maybe<Scalars['String']>;
  /** operationType field data. */
  showCommentBox?: Maybe<Scalars['String']>;
  /** operationType field data. */
  isCommentBoxRequired?: Maybe<Scalars['String']>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  options?: Maybe<Array<Maybe<QuestionnaireBuilderQuestionOption_Input>>>;
  /** operationType field data. */
  selectedOptionId?: Maybe<Scalars['String']>;
  /** operationType field data. */
  selectedOptionText?: Maybe<Scalars['String']>;
  /** operationType field data. */
  comments?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for QuestionnaireBuilderQuestion */
export type QuestionnaireBuilderQuestion_Schema = {
  __typename?: 'QuestionnaireBuilderQuestion_Schema';
  /** operationType field data. */
  question?: Maybe<Scalars['String']>;
  /** operationType field data. */
  optionType?: Maybe<Scalars['String']>;
  /** operationType field data. */
  showCommentBox?: Maybe<Scalars['String']>;
  /** operationType field data. */
  isCommentBoxRequired?: Maybe<Scalars['String']>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  options?: Maybe<Array<Maybe<QuestionnaireBuilderQuestionOption_Schema>>>;
  /** operationType field data. */
  selectedOptionId?: Maybe<Scalars['String']>;
  /** operationType field data. */
  selectedOptionText?: Maybe<Scalars['String']>;
  /** operationType field data. */
  comments?: Maybe<Scalars['String']>;
};

export enum QuestionnaireBuilder_Enum {
  QuestionnaireBuilder = 'QuestionnaireBuilder'
}

export enum QuestionnaireBuilder_Enum_Input {
  QuestionnaireBuilder = 'QuestionnaireBuilder'
}

/** QuestionnaireBuilder_Input */
export type QuestionnaireBuilder_Input = {
  /** Type of resource */
  resourceType: QuestionnaireBuilder_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** patientId */
  administeredType?: Maybe<Scalars['Int']>;
  /** patientId */
  totalScore?: Maybe<Scalars['Int']>;
  /** patientId */
  questionnaireName?: Maybe<Scalars['String']>;
  /** financialType. */
  questionnaireDescription?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** updatedOn. */
  updatedOn?: Maybe<Scalars['String']>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  questions?: Maybe<Array<Maybe<QuestionnaireBuilderQuestion_Input>>>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  practitionersList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  appointmentTypeList?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * A structured set of questions and their answers. The questions are ordered and
 * grouped into coherent subsets, corresponding to the structure of the grouping of
 * the questionnaire being responded to.
 */
export type QuestionnaireResponse = {
  __typename?: 'QuestionnaireResponse';
  /** Type of resource */
  resourceType: QuestionnaireResponse_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A business identifier assigned to a particular completed (or partially completed) questionnaire. */
  identifier?: Maybe<Identifier>;
  /** A business identifier assigned to a particular completed (or partially completed) questionnaire. */
  questionereResult?: Maybe<QuestionereResponseExtension_Input>;
  /**
   * The order, proposal or plan that is fulfilled in whole or in part by this
   * QuestionnaireResponse.  For example, a ServiceRequest seeking an intake
   * assessment or a decision support recommendation to assess for post-partum depression.
   */
  basedOn?: Maybe<Array<Maybe<QuestionnaireResponsebasedOn_BasedOn_Union>>>;
  /**
   * A procedure or observation that this questionnaire was performed as part of
   * the execution of.  For example, the surgery a checklist was executed as part of.
   */
  partOf?: Maybe<Array<Maybe<QuestionnaireResponsepartOf_PartOf_Union>>>;
  /** The Questionnaire that defines and organizes the questions for which answers are being provided. */
  _questionnaire?: Maybe<Element>;
  /** The Questionnaire that defines and organizes the questions for which answers are being provided. */
  questionnaire?: Maybe<Scalars['canonical']>;
  /** The position of the questionnaire response within its overall lifecycle. */
  _status?: Maybe<Element>;
  /** The position of the questionnaire response within its overall lifecycle. */
  status: Scalars['code'];
  /**
   * The subject of the questionnaire response.  This could be a patient,
   * organization, practitioner, device, etc.  This is who/what the answers apply
   * to, but is not necessarily the source of information.
   */
  subject?: Maybe<QuestionnaireResponsesubject_Subject_Union>;
  /**
   * The Encounter during which this questionnaire response was created or to which
   * the creation of this record is tightly associated.
   */
  encounter?: Maybe<QuestionnaireResponseencounter_Encounter_Union>;
  /** The date and/or time that this set of answers were last changed. */
  _authored?: Maybe<Element>;
  /** The date and/or time that this set of answers were last changed. */
  authored?: Maybe<Scalars['dateTime']>;
  /** Person who received the answers to the questions in the QuestionnaireResponse and recorded them in the system. */
  author?: Maybe<QuestionnaireResponseauthor_Author_Union>;
  /** The person who answered the questions about the subject. */
  source?: Maybe<QuestionnaireResponsesource_Source_Union>;
  /** A group or question item from the original questionnaire for which answers are provided. */
  item?: Maybe<Array<Maybe<QuestionnaireResponseitem>>>;
};

export enum QuestionnaireResponse_Enum_Input {
  QuestionnaireResponse = 'QuestionnaireResponse'
}

export enum QuestionnaireResponse_Enum_Schema {
  QuestionnaireResponse = 'QuestionnaireResponse'
}

/**
 * A structured set of questions and their answers. The questions are ordered and
 * grouped into coherent subsets, corresponding to the structure of the grouping of
 * the questionnaire being responded to.
 */
export type QuestionnaireResponse_Input = {
  /** Type of resource */
  resourceType: QuestionnaireResponse_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A business identifier assigned to a particular completed (or partially completed) questionnaire. */
  identifier?: Maybe<Identifier_Input>;
  /** A questionere Result. */
  questionereResult?: Maybe<QuestionereResponseExtension>;
  /**
   * The order, proposal or plan that is fulfilled in whole or in part by this
   * QuestionnaireResponse.  For example, a ServiceRequest seeking an intake
   * assessment or a decision support recommendation to assess for post-partum depression.
   */
  basedOn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A procedure or observation that this questionnaire was performed as part of
   * the execution of.  For example, the surgery a checklist was executed as part of.
   */
  partOf?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The Questionnaire that defines and organizes the questions for which answers are being provided. */
  _questionnaire?: Maybe<Element_Input>;
  /** The Questionnaire that defines and organizes the questions for which answers are being provided. */
  questionnaire?: Maybe<Scalars['canonical']>;
  /** The position of the questionnaire response within its overall lifecycle. */
  _status?: Maybe<Element_Input>;
  /** The position of the questionnaire response within its overall lifecycle. */
  status: Scalars['code'];
  /**
   * The subject of the questionnaire response.  This could be a patient,
   * organization, practitioner, device, etc.  This is who/what the answers apply
   * to, but is not necessarily the source of information.
   */
  subject?: Maybe<Scalars['String']>;
  /**
   * The Encounter during which this questionnaire response was created or to which
   * the creation of this record is tightly associated.
   */
  encounter?: Maybe<Scalars['String']>;
  /** The date and/or time that this set of answers were last changed. */
  _authored?: Maybe<Element_Input>;
  /** The date and/or time that this set of answers were last changed. */
  authored?: Maybe<Scalars['dateTime']>;
  /** Person who received the answers to the questions in the QuestionnaireResponse and recorded them in the system. */
  author?: Maybe<Scalars['String']>;
  /** The person who answered the questions about the subject. */
  source?: Maybe<Scalars['String']>;
  /** A group or question item from the original questionnaire for which answers are provided. */
  item?: Maybe<Array<Maybe<QuestionnaireResponseitem_Input>>>;
};

/** Person who received the answers to the questions in the QuestionnaireResponse and recorded them in the system. */
export type QuestionnaireResponseauthor_Author_Union = Device | Practitioner | PractitionerRole | Patient | RelatedPerson | Organization;

/**
 * The order, proposal or plan that is fulfilled in whole or in part by this
 * QuestionnaireResponse.  For example, a ServiceRequest seeking an intake
 * assessment or a decision support recommendation to assess for post-partum depression.
 */
export type QuestionnaireResponsebasedOn_BasedOn_Union = CarePlan | ServiceRequest;

/**
 * The Encounter during which this questionnaire response was created or to which
 * the creation of this record is tightly associated.
 */
export type QuestionnaireResponseencounter_Encounter_Union = Encounter;

export type QuestionnaireResponseitem = {
  __typename?: 'QuestionnaireResponseitem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The item from the Questionnaire that corresponds to this item in the QuestionnaireResponse resource. */
  _linkId?: Maybe<Element>;
  /** The item from the Questionnaire that corresponds to this item in the QuestionnaireResponse resource. */
  linkId: Scalars['String'];
  /** A reference to an [ElementDefinition](elementdefinition.html) that provides the details for the item. */
  _definition?: Maybe<Element>;
  /** A reference to an [ElementDefinition](elementdefinition.html) that provides the details for the item. */
  definition?: Maybe<Scalars['uri']>;
  /** Text that is displayed above the contents of the group or as the text of the question being answered. */
  _text?: Maybe<Element>;
  /** Text that is displayed above the contents of the group or as the text of the question being answered. */
  text?: Maybe<Scalars['String']>;
  /** The respondent's answer(s) to the question. */
  answer?: Maybe<Array<Maybe<QuestionnaireResponseitemanswer>>>;
};

export type QuestionnaireResponseitem_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The item from the Questionnaire that corresponds to this item in the QuestionnaireResponse resource. */
  _linkId?: Maybe<Element_Input>;
  /** The item from the Questionnaire that corresponds to this item in the QuestionnaireResponse resource. */
  linkId: Scalars['String'];
  /** A reference to an [ElementDefinition](elementdefinition.html) that provides the details for the item. */
  _definition?: Maybe<Element_Input>;
  /** A reference to an [ElementDefinition](elementdefinition.html) that provides the details for the item. */
  definition?: Maybe<Scalars['uri']>;
  /** Text that is displayed above the contents of the group or as the text of the question being answered. */
  _text?: Maybe<Element_Input>;
  /** Text that is displayed above the contents of the group or as the text of the question being answered. */
  text?: Maybe<Scalars['String']>;
  /** The respondent's answer(s) to the question. */
  answer?: Maybe<Array<Maybe<QuestionnaireResponseitemanswer_Input>>>;
};

export type QuestionnaireResponseitemanswer = {
  __typename?: 'QuestionnaireResponseitemanswer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueBoolean?: Maybe<Element>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueDecimal?: Maybe<Element>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueDecimal?: Maybe<Scalars['Float']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueInteger?: Maybe<Element>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueDate?: Maybe<Element>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueDate?: Maybe<Scalars['date']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueDateTime?: Maybe<Element>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueDateTime?: Maybe<Scalars['dateTime']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueTime?: Maybe<Element>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueTime?: Maybe<Scalars['time']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueString?: Maybe<Element>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueString?: Maybe<Scalars['String']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueUri?: Maybe<Element>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueUri?: Maybe<Scalars['uri']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueAttachment?: Maybe<Attachment>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueCoding?: Maybe<Coding>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueQuantity?: Maybe<Quantity>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueReference?: Maybe<QuestionnaireResponseitemanswervalueReference_ValueReference_Union>;
};

export type QuestionnaireResponseitemanswer_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueBoolean?: Maybe<Element_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueDecimal?: Maybe<Element_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueDecimal?: Maybe<Scalars['Float']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueInteger?: Maybe<Element_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueDate?: Maybe<Element_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueDate?: Maybe<Scalars['date']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueDateTime?: Maybe<Element_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueDateTime?: Maybe<Scalars['dateTime']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueTime?: Maybe<Element_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueTime?: Maybe<Scalars['time']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueString?: Maybe<Element_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueString?: Maybe<Scalars['String']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  _valueUri?: Maybe<Element_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueUri?: Maybe<Scalars['uri']>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueAttachment?: Maybe<Attachment_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueCoding?: Maybe<Coding_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueQuantity?: Maybe<Quantity_Input>;
  /** The answer (or one of the answers) provided by the respondent to the question. */
  valueReference?: Maybe<Scalars['String']>;
};

/** The answer (or one of the answers) provided by the respondent to the question. */
export type QuestionnaireResponseitemanswervalueReference_ValueReference_Union = Resource;

/**
 * A procedure or observation that this questionnaire was performed as part of the
 * execution of.  For example, the surgery a checklist was executed as part of.
 */
export type QuestionnaireResponsepartOf_PartOf_Union = Observation | Procedure;

/** The person who answered the questions about the subject. */
export type QuestionnaireResponsesource_Source_Union = Patient | Practitioner | PractitionerRole | RelatedPerson;

/**
 * The subject of the questionnaire response.  This could be a patient,
 * organization, practitioner, device, etc.  This is who/what the answers apply to,
 * but is not necessarily the source of information.
 */
export type QuestionnaireResponsesubject_Subject_Union = Resource;

export enum Questionnaire_Enum_Input {
  Questionnaire = 'Questionnaire'
}

export enum Questionnaire_Enum_Schema {
  Questionnaire = 'Questionnaire'
}

/**
 * A structured set of questions intended to guide the collection of answers from
 * end-users. Questionnaires provide detailed control over order, presentation,
 * phraseology and grouping to allow coherent, consistent data collection.
 */
export type Questionnaire_Input = {
  /** Type of resource */
  resourceType: Questionnaire_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * An absolute URI that is used to identify this questionnaire when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this questionnaire is
   * (or will be) published. This URL can be the target of a canonical reference.
   * It SHALL remain the same when the questionnaire is stored on different servers.
   */
  _url?: Maybe<Element_Input>;
  /**
   * An absolute URI that is used to identify this questionnaire when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this questionnaire is
   * (or will be) published. This URL can be the target of a canonical reference.
   * It SHALL remain the same when the questionnaire is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this questionnaire when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /**
   * The identifier that is used to identify this version of the questionnaire when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the questionnaire author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element_Input>;
  /**
   * The identifier that is used to identify this version of the questionnaire when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the questionnaire author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the questionnaire. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element_Input>;
  /**
   * A natural language name identifying the questionnaire. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the questionnaire. */
  _title?: Maybe<Element_Input>;
  /** A short, descriptive, user-friendly title for the questionnaire. */
  title?: Maybe<Scalars['String']>;
  /** The URL of a Questionnaire that this Questionnaire is based on. */
  _derivedFrom?: Maybe<Element_Input>;
  /** The URL of a Questionnaire that this Questionnaire is based on. */
  derivedFrom?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** The status of this questionnaire. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element_Input>;
  /** The status of this questionnaire. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this questionnaire is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element_Input>;
  /**
   * A Boolean value to indicate that this questionnaire is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /** The types of subjects that can be the subject of responses created for the questionnaire. */
  _subjectType?: Maybe<Element_Input>;
  /** The types of subjects that can be the subject of responses created for the questionnaire. */
  subjectType?: Maybe<Array<Maybe<Scalars['code']>>>;
  /**
   * The date  (and optionally time) when the questionnaire was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the questionnaire changes.
   */
  _date?: Maybe<Element_Input>;
  /**
   * The date  (and optionally time) when the questionnaire was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the questionnaire changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the questionnaire. */
  _publisher?: Maybe<Element_Input>;
  /** The name of the organization or individual that published the questionnaire. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail_Input>>>;
  /** A free text natural language description of the questionnaire from a consumer's perspective. */
  _description?: Maybe<Element_Input>;
  /** A free text natural language description of the questionnaire from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate
   * questionnaire instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext_Input>>>;
  /** A legal or geographic region in which the questionnaire is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Explanation of why this questionnaire is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element_Input>;
  /** Explanation of why this questionnaire is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the questionnaire and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the questionnaire.
   */
  _copyright?: Maybe<Element_Input>;
  /**
   * A copyright statement relating to the questionnaire and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the questionnaire.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element_Input>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element_Input>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the questionnaire content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period_Input>;
  /** An identifier for this question or group of questions in a particular terminology such as LOINC. */
  code?: Maybe<Array<Maybe<Coding_Input>>>;
  /** A particular question, question grouping or display text that is part of the questionnaire. */
  item?: Maybe<Array<Maybe<Questionnaireitem_Input>>>;
};

export type Questionnaireitem = {
  __typename?: 'Questionnaireitem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An identifier that is unique within the Questionnaire allowing linkage to the
   * equivalent item in a QuestionnaireResponse resource.
   */
  _linkId?: Maybe<Element>;
  /**
   * An identifier that is unique within the Questionnaire allowing linkage to the
   * equivalent item in a QuestionnaireResponse resource.
   */
  linkId: Scalars['String'];
  /**
   * This element is a URI that refers to an
   * [ElementDefinition](elementdefinition.html) that provides information about
   * this item, including information that might otherwise be included in the
   * instance of the Questionnaire resource. A detailed description of the
   * construction of the URI is shown in Comments, below. If this element is
   * present then the following element values MAY be derived from the Element
   * Definition if the corresponding elements of this Questionnaire resource
   * instance have no value:  * code (ElementDefinition.code)  * type
   * (ElementDefinition.type)  * required (ElementDefinition.min)  * repeats
   * (ElementDefinition.max)  * maxLength (ElementDefinition.maxLength)  *
   * answerValueSet (ElementDefinition.binding) * options
   * (ElementDefinition.binding).
   */
  _definition?: Maybe<Element>;
  /**
   * This element is a URI that refers to an
   * [ElementDefinition](elementdefinition.html) that provides information about
   * this item, including information that might otherwise be included in the
   * instance of the Questionnaire resource. A detailed description of the
   * construction of the URI is shown in Comments, below. If this element is
   * present then the following element values MAY be derived from the Element
   * Definition if the corresponding elements of this Questionnaire resource
   * instance have no value:  * code (ElementDefinition.code)  * type
   * (ElementDefinition.type)  * required (ElementDefinition.min)  * repeats
   * (ElementDefinition.max)  * maxLength (ElementDefinition.maxLength)  *
   * answerValueSet (ElementDefinition.binding) * options
   * (ElementDefinition.binding).
   */
  definition?: Maybe<Scalars['uri']>;
  /**
   * A terminology code that corresponds to this group or question (e.g. a code
   * from LOINC, which defines many questions and answers).
   */
  code?: Maybe<Array<Maybe<Coding>>>;
  /**
   * A short label for a particular group, question or set of display text within
   * the questionnaire used for reference by the individual completing the questionnaire.
   */
  _prefix?: Maybe<Element>;
  /**
   * A short label for a particular group, question or set of display text within
   * the questionnaire used for reference by the individual completing the questionnaire.
   */
  prefix?: Maybe<Scalars['String']>;
  /** The name of a section, the text of a question or text content for a display item. */
  _text?: Maybe<Element>;
  /** The name of a section, the text of a question or text content for a display item. */
  text?: Maybe<Scalars['String']>;
  /**
   * The type of questionnaire item this is - whether text for display, a grouping
   * of other items or a particular type of data to be captured (string, integer,
   * coded choice, etc.).
   */
  _type?: Maybe<Element>;
  /**
   * The type of questionnaire item this is - whether text for display, a grouping
   * of other items or a particular type of data to be captured (string, integer,
   * coded choice, etc.).
   */
  type: Scalars['code'];
  /**
   * A constraint indicating that this item should only be enabled (displayed/allow
   * answers to be captured) when the specified condition is true.
   */
  enableWhen?: Maybe<Array<Maybe<QuestionnaireitemenableWhen>>>;
  /** Controls how multiple enableWhen values are interpreted -  whether all or any must be true. */
  _enableBehavior?: Maybe<Element>;
  /** Controls how multiple enableWhen values are interpreted -  whether all or any must be true. */
  enableBehavior?: Maybe<Scalars['code']>;
  /**
   * An indication, if true, that the item must be present in a 'completed'
   * QuestionnaireResponse.  If false, the item may be skipped when answering the questionnaire.
   */
  _required?: Maybe<Element>;
  /**
   * An indication, if true, that the item must be present in a 'completed'
   * QuestionnaireResponse.  If false, the item may be skipped when answering the questionnaire.
   */
  required?: Maybe<Scalars['Boolean']>;
  /**
   * An indication, if true, that the item may occur multiple times in the
   * response, collecting multiple answers for questions or multiple sets of
   * answers for groups.
   */
  _repeats?: Maybe<Element>;
  /**
   * An indication, if true, that the item may occur multiple times in the
   * response, collecting multiple answers for questions or multiple sets of
   * answers for groups.
   */
  repeats?: Maybe<Scalars['Boolean']>;
  /** An indication, when true, that the value cannot be changed by a human respondent to the Questionnaire. */
  _readOnly?: Maybe<Element>;
  /** An indication, when true, that the value cannot be changed by a human respondent to the Questionnaire. */
  readOnly?: Maybe<Scalars['Boolean']>;
  /** The maximum number of characters that are permitted in the answer to be considered a 'valid' QuestionnaireResponse. */
  _maxLength?: Maybe<Element>;
  /** The maximum number of characters that are permitted in the answer to be considered a 'valid' QuestionnaireResponse. */
  maxLength?: Maybe<Scalars['Int']>;
  /**
   * A reference to a value set containing a list of codes representing permitted
   * answers for a 'choice' or 'open-choice' question.
   */
  _answerValueSet?: Maybe<Element>;
  /**
   * A reference to a value set containing a list of codes representing permitted
   * answers for a 'choice' or 'open-choice' question.
   */
  answerValueSet?: Maybe<Scalars['canonical']>;
  /** One of the permitted answers for a 'choice' or 'open-choice' question. */
  answerOption?: Maybe<Array<Maybe<QuestionnaireitemanswerOption>>>;
  /** One or more values that should be pre-populated in the answer when initially rendering the questionnaire for user input. */
  initial?: Maybe<Array<Maybe<Questionnaireiteminitial>>>;
};

export type Questionnaireitem_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * An identifier that is unique within the Questionnaire allowing linkage to the
   * equivalent item in a QuestionnaireResponse resource.
   */
  _linkId?: Maybe<Element_Input>;
  /**
   * An identifier that is unique within the Questionnaire allowing linkage to the
   * equivalent item in a QuestionnaireResponse resource.
   */
  linkId: Scalars['String'];
  /**
   * This element is a URI that refers to an
   * [ElementDefinition](elementdefinition.html) that provides information about
   * this item, including information that might otherwise be included in the
   * instance of the Questionnaire resource. A detailed description of the
   * construction of the URI is shown in Comments, below. If this element is
   * present then the following element values MAY be derived from the Element
   * Definition if the corresponding elements of this Questionnaire resource
   * instance have no value:  * code (ElementDefinition.code)  * type
   * (ElementDefinition.type)  * required (ElementDefinition.min)  * repeats
   * (ElementDefinition.max)  * maxLength (ElementDefinition.maxLength)  *
   * answerValueSet (ElementDefinition.binding) * options
   * (ElementDefinition.binding).
   */
  _definition?: Maybe<Element_Input>;
  /**
   * This element is a URI that refers to an
   * [ElementDefinition](elementdefinition.html) that provides information about
   * this item, including information that might otherwise be included in the
   * instance of the Questionnaire resource. A detailed description of the
   * construction of the URI is shown in Comments, below. If this element is
   * present then the following element values MAY be derived from the Element
   * Definition if the corresponding elements of this Questionnaire resource
   * instance have no value:  * code (ElementDefinition.code)  * type
   * (ElementDefinition.type)  * required (ElementDefinition.min)  * repeats
   * (ElementDefinition.max)  * maxLength (ElementDefinition.maxLength)  *
   * answerValueSet (ElementDefinition.binding) * options
   * (ElementDefinition.binding).
   */
  definition?: Maybe<Scalars['uri']>;
  /**
   * A terminology code that corresponds to this group or question (e.g. a code
   * from LOINC, which defines many questions and answers).
   */
  code?: Maybe<Array<Maybe<Coding_Input>>>;
  /**
   * A short label for a particular group, question or set of display text within
   * the questionnaire used for reference by the individual completing the questionnaire.
   */
  _prefix?: Maybe<Element_Input>;
  /**
   * A short label for a particular group, question or set of display text within
   * the questionnaire used for reference by the individual completing the questionnaire.
   */
  prefix?: Maybe<Scalars['String']>;
  /** The name of a section, the text of a question or text content for a display item. */
  _text?: Maybe<Element_Input>;
  /** The name of a section, the text of a question or text content for a display item. */
  text?: Maybe<Scalars['String']>;
  /**
   * The type of questionnaire item this is - whether text for display, a grouping
   * of other items or a particular type of data to be captured (string, integer,
   * coded choice, etc.).
   */
  _type?: Maybe<Element_Input>;
  /**
   * The type of questionnaire item this is - whether text for display, a grouping
   * of other items or a particular type of data to be captured (string, integer,
   * coded choice, etc.).
   */
  type: Scalars['code'];
  /**
   * A constraint indicating that this item should only be enabled (displayed/allow
   * answers to be captured) when the specified condition is true.
   */
  enableWhen?: Maybe<Array<Maybe<QuestionnaireitemenableWhen_Input>>>;
  /** Controls how multiple enableWhen values are interpreted -  whether all or any must be true. */
  _enableBehavior?: Maybe<Element_Input>;
  /** Controls how multiple enableWhen values are interpreted -  whether all or any must be true. */
  enableBehavior?: Maybe<Scalars['code']>;
  /**
   * An indication, if true, that the item must be present in a 'completed'
   * QuestionnaireResponse.  If false, the item may be skipped when answering the questionnaire.
   */
  _required?: Maybe<Element_Input>;
  /**
   * An indication, if true, that the item must be present in a 'completed'
   * QuestionnaireResponse.  If false, the item may be skipped when answering the questionnaire.
   */
  required?: Maybe<Scalars['Boolean']>;
  /**
   * An indication, if true, that the item may occur multiple times in the
   * response, collecting multiple answers for questions or multiple sets of
   * answers for groups.
   */
  _repeats?: Maybe<Element_Input>;
  /**
   * An indication, if true, that the item may occur multiple times in the
   * response, collecting multiple answers for questions or multiple sets of
   * answers for groups.
   */
  repeats?: Maybe<Scalars['Boolean']>;
  /** An indication, when true, that the value cannot be changed by a human respondent to the Questionnaire. */
  _readOnly?: Maybe<Element_Input>;
  /** An indication, when true, that the value cannot be changed by a human respondent to the Questionnaire. */
  readOnly?: Maybe<Scalars['Boolean']>;
  /** The maximum number of characters that are permitted in the answer to be considered a 'valid' QuestionnaireResponse. */
  _maxLength?: Maybe<Element_Input>;
  /** The maximum number of characters that are permitted in the answer to be considered a 'valid' QuestionnaireResponse. */
  maxLength?: Maybe<Scalars['Int']>;
  /**
   * A reference to a value set containing a list of codes representing permitted
   * answers for a 'choice' or 'open-choice' question.
   */
  _answerValueSet?: Maybe<Element_Input>;
  /**
   * A reference to a value set containing a list of codes representing permitted
   * answers for a 'choice' or 'open-choice' question.
   */
  answerValueSet?: Maybe<Scalars['canonical']>;
  /** One of the permitted answers for a 'choice' or 'open-choice' question. */
  answerOption?: Maybe<Array<Maybe<QuestionnaireitemanswerOption_Input>>>;
  /** One or more values that should be pre-populated in the answer when initially rendering the questionnaire for user input. */
  initial?: Maybe<Array<Maybe<Questionnaireiteminitial_Input>>>;
};

export type QuestionnaireitemanswerOption = {
  __typename?: 'QuestionnaireitemanswerOption';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A potential answer that's allowed as the answer to this question. */
  _valueInteger?: Maybe<Element>;
  /** A potential answer that's allowed as the answer to this question. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** A potential answer that's allowed as the answer to this question. */
  _valueDate?: Maybe<Element>;
  /** A potential answer that's allowed as the answer to this question. */
  valueDate?: Maybe<Scalars['date']>;
  /** A potential answer that's allowed as the answer to this question. */
  _valueTime?: Maybe<Element>;
  /** A potential answer that's allowed as the answer to this question. */
  valueTime?: Maybe<Scalars['time']>;
  /** A potential answer that's allowed as the answer to this question. */
  _valueString?: Maybe<Element>;
  /** A potential answer that's allowed as the answer to this question. */
  valueString?: Maybe<Scalars['String']>;
  /** A potential answer that's allowed as the answer to this question. */
  valueCoding?: Maybe<Coding>;
  /** A potential answer that's allowed as the answer to this question. */
  valueReference?: Maybe<QuestionnaireitemanswerOptionvalueReference_ValueReference_Union>;
  /** Indicates whether the answer value is selected when the list of possible answers is initially shown. */
  _initialSelected?: Maybe<Element>;
  /** Indicates whether the answer value is selected when the list of possible answers is initially shown. */
  initialSelected?: Maybe<Scalars['Boolean']>;
};

export type QuestionnaireitemanswerOption_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A potential answer that's allowed as the answer to this question. */
  _valueInteger?: Maybe<Element_Input>;
  /** A potential answer that's allowed as the answer to this question. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** A potential answer that's allowed as the answer to this question. */
  _valueDate?: Maybe<Element_Input>;
  /** A potential answer that's allowed as the answer to this question. */
  valueDate?: Maybe<Scalars['date']>;
  /** A potential answer that's allowed as the answer to this question. */
  _valueTime?: Maybe<Element_Input>;
  /** A potential answer that's allowed as the answer to this question. */
  valueTime?: Maybe<Scalars['time']>;
  /** A potential answer that's allowed as the answer to this question. */
  _valueString?: Maybe<Element_Input>;
  /** A potential answer that's allowed as the answer to this question. */
  valueString?: Maybe<Scalars['String']>;
  /** A potential answer that's allowed as the answer to this question. */
  valueCoding?: Maybe<Coding_Input>;
  /** A potential answer that's allowed as the answer to this question. */
  valueReference?: Maybe<Scalars['String']>;
  /** Indicates whether the answer value is selected when the list of possible answers is initially shown. */
  _initialSelected?: Maybe<Element_Input>;
  /** Indicates whether the answer value is selected when the list of possible answers is initially shown. */
  initialSelected?: Maybe<Scalars['Boolean']>;
};

/** A potential answer that's allowed as the answer to this question. */
export type QuestionnaireitemanswerOptionvalueReference_ValueReference_Union = Resource;

export type QuestionnaireitemenableWhen = {
  __typename?: 'QuestionnaireitemenableWhen';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The linkId for the question whose answer (or lack of answer) governs whether this item is enabled. */
  _question?: Maybe<Element>;
  /** The linkId for the question whose answer (or lack of answer) governs whether this item is enabled. */
  question: Scalars['String'];
  /** Specifies the criteria by which the question is enabled. */
  _operator?: Maybe<Element>;
  /** Specifies the criteria by which the question is enabled. */
  operator: Scalars['code'];
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerBoolean?: Maybe<Element>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerBoolean: Scalars['Boolean'];
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerDecimal?: Maybe<Element>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerDecimal?: Maybe<Scalars['Float']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerInteger?: Maybe<Element>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerInteger?: Maybe<Scalars['Int']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerDate?: Maybe<Element>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerDate?: Maybe<Scalars['date']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerDateTime?: Maybe<Element>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerDateTime?: Maybe<Scalars['dateTime']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerTime?: Maybe<Element>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerTime?: Maybe<Scalars['time']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerString?: Maybe<Element>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerString?: Maybe<Scalars['String']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerCoding?: Maybe<Coding>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerQuantity?: Maybe<Quantity>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerReference?: Maybe<QuestionnaireitemenableWhenanswerReference_AnswerReference_Union>;
};

export type QuestionnaireitemenableWhen_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The linkId for the question whose answer (or lack of answer) governs whether this item is enabled. */
  _question?: Maybe<Element_Input>;
  /** The linkId for the question whose answer (or lack of answer) governs whether this item is enabled. */
  question: Scalars['String'];
  /** Specifies the criteria by which the question is enabled. */
  _operator?: Maybe<Element_Input>;
  /** Specifies the criteria by which the question is enabled. */
  operator: Scalars['code'];
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerBoolean?: Maybe<Element_Input>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerBoolean: Scalars['Boolean'];
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerDecimal?: Maybe<Element_Input>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerDecimal?: Maybe<Scalars['Float']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerInteger?: Maybe<Element_Input>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerInteger?: Maybe<Scalars['Int']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerDate?: Maybe<Element_Input>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerDate?: Maybe<Scalars['date']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerDateTime?: Maybe<Element_Input>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerDateTime?: Maybe<Scalars['dateTime']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerTime?: Maybe<Element_Input>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerTime?: Maybe<Scalars['time']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  _answerString?: Maybe<Element_Input>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerString?: Maybe<Scalars['String']>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerCoding?: Maybe<Coding_Input>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerQuantity?: Maybe<Quantity_Input>;
  /** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
  answerReference?: Maybe<Scalars['String']>;
};

/** A value that the referenced question is tested using the specified operator in order for the item to be enabled. */
export type QuestionnaireitemenableWhenanswerReference_AnswerReference_Union = Resource;

export type Questionnaireiteminitial = {
  __typename?: 'Questionnaireiteminitial';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The actual value to for an initial answer. */
  _valueBoolean?: Maybe<Element>;
  /** The actual value to for an initial answer. */
  valueBoolean: Scalars['Boolean'];
  /** The actual value to for an initial answer. */
  _valueDecimal?: Maybe<Element>;
  /** The actual value to for an initial answer. */
  valueDecimal: Scalars['Float'];
  /** The actual value to for an initial answer. */
  _valueInteger?: Maybe<Element>;
  /** The actual value to for an initial answer. */
  valueInteger: Scalars['Int'];
  /** The actual value to for an initial answer. */
  _valueDate?: Maybe<Element>;
  /** The actual value to for an initial answer. */
  valueDate: Scalars['date'];
  /** The actual value to for an initial answer. */
  _valueDateTime?: Maybe<Element>;
  /** The actual value to for an initial answer. */
  valueDateTime: Scalars['dateTime'];
  /** The actual value to for an initial answer. */
  _valueTime?: Maybe<Element>;
  /** The actual value to for an initial answer. */
  valueTime: Scalars['time'];
  /** The actual value to for an initial answer. */
  _valueString?: Maybe<Element>;
  /** The actual value to for an initial answer. */
  valueString: Scalars['String'];
  /** The actual value to for an initial answer. */
  _valueUri?: Maybe<Element>;
  /** The actual value to for an initial answer. */
  valueUri: Scalars['uri'];
  /** The actual value to for an initial answer. */
  valueAttachment: Attachment;
  /** The actual value to for an initial answer. */
  valueCoding: Coding;
  /** The actual value to for an initial answer. */
  valueQuantity: Quantity;
  /** The actual value to for an initial answer. */
  valueReference: QuestionnaireiteminitialvalueReference_ValueReference_Union;
};

export type Questionnaireiteminitial_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The actual value to for an initial answer. */
  _valueBoolean?: Maybe<Element_Input>;
  /** The actual value to for an initial answer. */
  valueBoolean: Scalars['Boolean'];
  /** The actual value to for an initial answer. */
  _valueDecimal?: Maybe<Element_Input>;
  /** The actual value to for an initial answer. */
  valueDecimal: Scalars['Float'];
  /** The actual value to for an initial answer. */
  _valueInteger?: Maybe<Element_Input>;
  /** The actual value to for an initial answer. */
  valueInteger: Scalars['Int'];
  /** The actual value to for an initial answer. */
  _valueDate?: Maybe<Element_Input>;
  /** The actual value to for an initial answer. */
  valueDate: Scalars['date'];
  /** The actual value to for an initial answer. */
  _valueDateTime?: Maybe<Element_Input>;
  /** The actual value to for an initial answer. */
  valueDateTime: Scalars['dateTime'];
  /** The actual value to for an initial answer. */
  _valueTime?: Maybe<Element_Input>;
  /** The actual value to for an initial answer. */
  valueTime: Scalars['time'];
  /** The actual value to for an initial answer. */
  _valueString?: Maybe<Element_Input>;
  /** The actual value to for an initial answer. */
  valueString: Scalars['String'];
  /** The actual value to for an initial answer. */
  _valueUri?: Maybe<Element_Input>;
  /** The actual value to for an initial answer. */
  valueUri: Scalars['uri'];
  /** The actual value to for an initial answer. */
  valueAttachment: Attachment_Input;
  /** The actual value to for an initial answer. */
  valueCoding: Coding_Input;
  /** The actual value to for an initial answer. */
  valueQuantity: Quantity_Input;
  /** The actual value to for an initial answer. */
  valueReference: Scalars['String'];
};

/** The actual value to for an initial answer. */
export type QuestionnaireiteminitialvalueReference_ValueReference_Union = Resource;

export enum Quotes_Enum_Input_Schema {
  Quotes = 'Quotes'
}

export enum Quotes_Enum_Schema {
  Quotes = 'Quotes'
}

/** Quotes */
export type Quotes_Input = {
  /** Type of resource */
  resourceType: Quotes_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** firstName. */
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  subCategoryName?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['String']>;
  blogTitle?: Maybe<Scalars['String']>;
  blogDescription?: Maybe<Scalars['String']>;
  blogDescriptionHtml?: Maybe<Scalars['String']>;
  blogBannerImage?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  authorTypeId?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  authorDescription?: Maybe<Scalars['String']>;
  authorImage?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
  blogStatus?: Maybe<Scalars['Int']>;
  blogDescriptionPlainText?: Maybe<Scalars['String']>;
};

/** Quotes */
export type Quotes_Schema = {
  __typename?: 'Quotes_Schema';
  /** Type of resource */
  resourceType: Quotes_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** firstName. */
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  subCategoryName?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['String']>;
  blogTitle?: Maybe<Scalars['String']>;
  blogDescription?: Maybe<Scalars['String']>;
  blogDescriptionHtml?: Maybe<Scalars['String']>;
  blogBannerImage?: Maybe<Scalars['String']>;
  authorType?: Maybe<Scalars['String']>;
  authorTypeId?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  authorDescription?: Maybe<Scalars['String']>;
  authorImage?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
  blogStatus?: Maybe<Scalars['Int']>;
  blogDescriptionPlainText?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Range Type: A set of ordered Quantities defined by a low and high limit. */
export type Range = {
  __typename?: 'Range';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The low limit. The boundary is inclusive. */
  low?: Maybe<Quantity>;
  /** The high limit. The boundary is inclusive. */
  high?: Maybe<Quantity>;
};

/** Base StructureDefinition for Range Type: A set of ordered Quantities defined by a low and high limit. */
export type Range_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The low limit. The boundary is inclusive. */
  low?: Maybe<Quantity_Input>;
  /** The high limit. The boundary is inclusive. */
  high?: Maybe<Quantity_Input>;
};

/** Base StructureDefinition for Ratio Type: A relationship of two Quantity values - expressed as a numerator and a denominator. */
export type Ratio = {
  __typename?: 'Ratio';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The value of the numerator. */
  numerator?: Maybe<Quantity>;
  /** The value of the denominator. */
  denominator?: Maybe<Quantity>;
};

/** Base StructureDefinition for Ratio Type: A relationship of two Quantity values - expressed as a numerator and a denominator. */
export type Ratio_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The value of the numerator. */
  numerator?: Maybe<Quantity_Input>;
  /** The value of the denominator. */
  denominator?: Maybe<Quantity_Input>;
};

/**
 * Base StructureDefinition for RelatedArtifact Type: Related artifacts such as
 * additional documentation, justification, or bibliographic references.
 */
export type RelatedArtifact = {
  __typename?: 'RelatedArtifact';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of relationship to the related artifact. */
  _type?: Maybe<Element>;
  /** The type of relationship to the related artifact. */
  type: Scalars['code'];
  /**
   * A short label that can be used to reference the citation from elsewhere in the
   * containing artifact, such as a footnote index.
   */
  _label?: Maybe<Element>;
  /**
   * A short label that can be used to reference the citation from elsewhere in the
   * containing artifact, such as a footnote index.
   */
  label?: Maybe<Scalars['String']>;
  /** A brief description of the document or knowledge resource being referenced, suitable for display to a consumer. */
  _display?: Maybe<Element>;
  /** A brief description of the document or knowledge resource being referenced, suitable for display to a consumer. */
  display?: Maybe<Scalars['String']>;
  /** A bibliographic citation for the related artifact. This text SHOULD be formatted according to an accepted citation format. */
  _citation?: Maybe<Element>;
  /** A bibliographic citation for the related artifact. This text SHOULD be formatted according to an accepted citation format. */
  citation?: Maybe<Scalars['String']>;
  /** A url for the artifact that can be followed to access the actual content. */
  _url?: Maybe<Element>;
  /** A url for the artifact that can be followed to access the actual content. */
  url?: Maybe<Scalars['url']>;
  /** The document being referenced, represented as an attachment. This is exclusive with the resource element. */
  document?: Maybe<Attachment>;
  /** The related resource, such as a library, value set, profile, or other knowledge resource. */
  _resource?: Maybe<Element>;
  /** The related resource, such as a library, value set, profile, or other knowledge resource. */
  resource?: Maybe<Scalars['canonical']>;
};

/**
 * Base StructureDefinition for RelatedArtifact Type: Related artifacts such as
 * additional documentation, justification, or bibliographic references.
 */
export type RelatedArtifact_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The type of relationship to the related artifact. */
  _type?: Maybe<Element_Input>;
  /** The type of relationship to the related artifact. */
  type: Scalars['code'];
  /**
   * A short label that can be used to reference the citation from elsewhere in the
   * containing artifact, such as a footnote index.
   */
  _label?: Maybe<Element_Input>;
  /**
   * A short label that can be used to reference the citation from elsewhere in the
   * containing artifact, such as a footnote index.
   */
  label?: Maybe<Scalars['String']>;
  /** A brief description of the document or knowledge resource being referenced, suitable for display to a consumer. */
  _display?: Maybe<Element_Input>;
  /** A brief description of the document or knowledge resource being referenced, suitable for display to a consumer. */
  display?: Maybe<Scalars['String']>;
  /** A bibliographic citation for the related artifact. This text SHOULD be formatted according to an accepted citation format. */
  _citation?: Maybe<Element_Input>;
  /** A bibliographic citation for the related artifact. This text SHOULD be formatted according to an accepted citation format. */
  citation?: Maybe<Scalars['String']>;
  /** A url for the artifact that can be followed to access the actual content. */
  _url?: Maybe<Element_Input>;
  /** A url for the artifact that can be followed to access the actual content. */
  url?: Maybe<Scalars['url']>;
  /** The document being referenced, represented as an attachment. This is exclusive with the resource element. */
  document?: Maybe<Attachment_Input>;
  /** The related resource, such as a library, value set, profile, or other knowledge resource. */
  _resource?: Maybe<Element_Input>;
  /** The related resource, such as a library, value set, profile, or other knowledge resource. */
  resource?: Maybe<Scalars['canonical']>;
};

/**
 * Information about a person that is involved in the care for a patient, but who
 * is not the target of healthcare, nor has a formal responsibility in the care process.
 */
export type RelatedPerson = {
  __typename?: 'RelatedPerson';
  /** Type of resource */
  resourceType: RelatedPerson_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier for a person within a particular scope. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Whether this related person record is in active use. */
  _active?: Maybe<Element>;
  /** Whether this related person record is in active use. */
  active?: Maybe<Scalars['Boolean']>;
  /** The patient this person is related to. */
  patient: RelatedPersonpatient_Patient_Union;
  /** The nature of the relationship between a patient and the related person. */
  relationship?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A name associated with the person. */
  name?: Maybe<Array<Maybe<HumanName>>>;
  /** A contact detail for the person, e.g. a telephone number or an email address. */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** Administrative Gender - the gender that the person is considered to have for administration and record keeping purposes. */
  _gender?: Maybe<Element>;
  /** Administrative Gender - the gender that the person is considered to have for administration and record keeping purposes. */
  gender?: Maybe<Scalars['code']>;
  /** The date on which the related person was born. */
  _birthDate?: Maybe<Element>;
  /** The date on which the related person was born. */
  birthDate?: Maybe<Scalars['date']>;
  /** Address where the related person can be contacted or visited. */
  address?: Maybe<Array<Maybe<Address>>>;
  /** Image of the person. */
  photo?: Maybe<Array<Maybe<Attachment>>>;
  /**
   * The period of time during which this relationship is or was active. If there
   * are no dates defined, then the interval is unknown.
   */
  period?: Maybe<Period>;
  /** A language which may be used to communicate with about the patient's health. */
  communication?: Maybe<Array<Maybe<RelatedPersoncommunication>>>;
};

export enum RelatedPerson_Enum_Schema {
  RelatedPerson = 'RelatedPerson'
}

export type RelatedPersoncommunication = {
  __typename?: 'RelatedPersoncommunication';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The ISO-639-1 alpha 2 code in lower case for the language, optionally followed
   * by a hyphen and the ISO-3166-1 alpha 2 code for the region in upper case; e.g.
   * 'en' for English, or 'en-US' for American English versus 'en-EN' for England English.
   */
  language: CodeableConcept;
  /** Indicates whether or not the patient prefers this language (over other languages he masters up a certain level). */
  _preferred?: Maybe<Element>;
  /** Indicates whether or not the patient prefers this language (over other languages he masters up a certain level). */
  preferred?: Maybe<Scalars['Boolean']>;
};

/** The patient this person is related to. */
export type RelatedPersonpatient_Patient_Union = Patient;

export enum Reminder_Enum_Input_Schema {
  Reminder = 'Reminder'
}

export enum Reminder_Enum_Schema {
  Reminder = 'Reminder'
}

/** Reminder */
export type Reminder_Input = {
  /** Type of resource */
  resourceType: Reminder_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** firstName. */
  reminderName?: Maybe<Scalars['String']>;
  /** firstName. */
  reminderStartDate?: Maybe<Scalars['String']>;
  reminderEndtDate?: Maybe<Scalars['String']>;
  reminaderDaysBefore?: Maybe<Scalars['Int']>;
  reminderStatus?: Maybe<Scalars['Int']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
};

/** Reminder */
export type Reminder_Schema = {
  __typename?: 'Reminder_Schema';
  /** Type of resource */
  resourceType: Reminder_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** firstName. */
  reminderName?: Maybe<Scalars['String']>;
  /** firstName. */
  reminderStartDate?: Maybe<Scalars['String']>;
  reminderEndtDate?: Maybe<Scalars['String']>;
  reminaderDaysBefore?: Maybe<Scalars['Int']>;
  reminderStatus?: Maybe<Scalars['Int']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
};

/**
 * A group of related requests that can be used to capture intended activities that
 * have inter-dependencies such as 'give this medication after that one'.
 */
export type RequestGroup = {
  __typename?: 'RequestGroup';
  /** Type of resource */
  resourceType: RequestGroup_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Allows a service to provide a unique, business identifier for the request. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * A canonical URL referencing a FHIR-defined protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this request.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * A canonical URL referencing a FHIR-defined protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this request.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * A URL referencing an externally defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this request.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * A URL referencing an externally defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this request.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** A plan, proposal or order that is fulfilled in whole or in part by this request. */
  basedOn?: Maybe<Array<Maybe<RequestGroupbasedOn_BasedOn_Union>>>;
  /** Completed or terminated request(s) whose function is taken by this new request. */
  replaces?: Maybe<Array<Maybe<RequestGroupreplaces_Replaces_Union>>>;
  /**
   * A shared identifier common to all requests that were authorized more or less
   * simultaneously by a single author, representing the identifier of the
   * requisition, prescription or similar form.
   */
  groupIdentifier?: Maybe<Identifier>;
  /** The current state of the request. For request groups, the status reflects the status of all the requests in the group. */
  _status?: Maybe<Element>;
  /** The current state of the request. For request groups, the status reflects the status of all the requests in the group. */
  status: Scalars['code'];
  /**
   * Indicates the level of authority/intentionality associated with the request
   * and where the request fits into the workflow chain.
   */
  _intent?: Maybe<Element>;
  /**
   * Indicates the level of authority/intentionality associated with the request
   * and where the request fits into the workflow chain.
   */
  intent: Scalars['code'];
  /** Indicates how quickly the request should be addressed with respect to other requests. */
  _priority?: Maybe<Element>;
  /** Indicates how quickly the request should be addressed with respect to other requests. */
  priority?: Maybe<Scalars['code']>;
  /** A code that identifies what the overall request group is. */
  code?: Maybe<CodeableConcept>;
  /** The subject for which the request group was created. */
  subject?: Maybe<RequestGroupsubject_Subject_Union>;
  /** Describes the context of the request group, if any. */
  encounter?: Maybe<RequestGroupencounter_Encounter_Union>;
  /** Indicates when the request group was created. */
  _authoredOn?: Maybe<Element>;
  /** Indicates when the request group was created. */
  authoredOn?: Maybe<Scalars['dateTime']>;
  /** Provides a reference to the author of the request group. */
  author?: Maybe<RequestGroupauthor_Author_Union>;
  /** Describes the reason for the request group in coded or textual form. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates another resource whose existence justifies this request group. */
  reasonReference?: Maybe<Array<Maybe<RequestGroupreasonReference_ReasonReference_Union>>>;
  /** Provides a mechanism to communicate additional information about the response. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** The actions, if any, produced by the evaluation of the artifact. */
  action?: Maybe<Array<Maybe<RequestGroupaction>>>;
};

export enum RequestGroup_Enum_Schema {
  RequestGroup = 'RequestGroup'
}

export type RequestGroupaction = {
  __typename?: 'RequestGroupaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A user-visible prefix for the action. */
  _prefix?: Maybe<Element>;
  /** A user-visible prefix for the action. */
  prefix?: Maybe<Scalars['String']>;
  /** The title of the action displayed to a user. */
  _title?: Maybe<Element>;
  /** The title of the action displayed to a user. */
  title?: Maybe<Scalars['String']>;
  /** A short description of the action used to provide a summary to display to the user. */
  _description?: Maybe<Element>;
  /** A short description of the action used to provide a summary to display to the user. */
  description?: Maybe<Scalars['String']>;
  /**
   * A text equivalent of the action to be performed. This provides a
   * human-interpretable description of the action when the definition is consumed
   * by a system that might not be capable of interpreting it dynamically.
   */
  _textEquivalent?: Maybe<Element>;
  /**
   * A text equivalent of the action to be performed. This provides a
   * human-interpretable description of the action when the definition is consumed
   * by a system that might not be capable of interpreting it dynamically.
   */
  textEquivalent?: Maybe<Scalars['String']>;
  /** Indicates how quickly the action should be addressed with respect to other actions. */
  _priority?: Maybe<Element>;
  /** Indicates how quickly the action should be addressed with respect to other actions. */
  priority?: Maybe<Scalars['code']>;
  /**
   * A code that provides meaning for the action or action group. For example, a
   * section may have a LOINC code for a section of a documentation template.
   */
  code?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Didactic or other informational resources associated with the action that can
   * be provided to the CDS recipient. Information resources can include inline
   * text commentary and links to web resources.
   */
  documentation?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** An expression that describes applicability criteria, or start/stop conditions for the action. */
  condition?: Maybe<Array<Maybe<RequestGroupactioncondition>>>;
  /** A relationship to another action such as 'before' or '30-60 minutes after start of'. */
  relatedAction?: Maybe<Array<Maybe<RequestGroupactionrelatedAction>>>;
  /** An optional value describing when the action should be performed. */
  _timingDateTime?: Maybe<Element>;
  /** An optional value describing when the action should be performed. */
  timingDateTime?: Maybe<Scalars['dateTime']>;
  /** An optional value describing when the action should be performed. */
  timingAge?: Maybe<Age>;
  /** An optional value describing when the action should be performed. */
  timingPeriod?: Maybe<Period>;
  /** An optional value describing when the action should be performed. */
  timingDuration?: Maybe<Duration>;
  /** An optional value describing when the action should be performed. */
  timingRange?: Maybe<Range>;
  /** An optional value describing when the action should be performed. */
  timingTiming?: Maybe<Timing>;
  /** The participant that should perform or be responsible for this action. */
  participant?: Maybe<Array<Maybe<RequestGroupactionparticipant_Participant_Union>>>;
  /** The type of action to perform (create, update, remove). */
  type?: Maybe<CodeableConcept>;
  /** Defines the grouping behavior for the action and its children. */
  _groupingBehavior?: Maybe<Element>;
  /** Defines the grouping behavior for the action and its children. */
  groupingBehavior?: Maybe<Scalars['code']>;
  /** Defines the selection behavior for the action and its children. */
  _selectionBehavior?: Maybe<Element>;
  /** Defines the selection behavior for the action and its children. */
  selectionBehavior?: Maybe<Scalars['code']>;
  /** Defines expectations around whether an action is required. */
  _requiredBehavior?: Maybe<Element>;
  /** Defines expectations around whether an action is required. */
  requiredBehavior?: Maybe<Scalars['code']>;
  /** Defines whether the action should usually be preselected. */
  _precheckBehavior?: Maybe<Element>;
  /** Defines whether the action should usually be preselected. */
  precheckBehavior?: Maybe<Scalars['code']>;
  /** Defines whether the action can be selected multiple times. */
  _cardinalityBehavior?: Maybe<Element>;
  /** Defines whether the action can be selected multiple times. */
  cardinalityBehavior?: Maybe<Scalars['code']>;
  /** The resource that is the target of the action (e.g. CommunicationRequest). */
  resource?: Maybe<RequestGroupactionresource_Resource_Union>;
};

export type RequestGroupactioncondition = {
  __typename?: 'RequestGroupactioncondition';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The kind of condition. */
  _kind?: Maybe<Element>;
  /** The kind of condition. */
  kind: Scalars['code'];
  /** An expression that returns true or false, indicating whether or not the condition is satisfied. */
  expression?: Maybe<Expression>;
};

/** The participant that should perform or be responsible for this action. */
export type RequestGroupactionparticipant_Participant_Union = Patient | Practitioner | PractitionerRole | RelatedPerson | Device;

export type RequestGroupactionrelatedAction = {
  __typename?: 'RequestGroupactionrelatedAction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The element id of the action this is related to. */
  _actionId?: Maybe<Element>;
  /** The element id of the action this is related to. */
  actionId: Scalars['id'];
  /** The relationship of this action to the related action. */
  _relationship?: Maybe<Element>;
  /** The relationship of this action to the related action. */
  relationship: Scalars['code'];
  /** A duration or range of durations to apply to the relationship. For example, 30-60 minutes before. */
  offsetDuration?: Maybe<Duration>;
  /** A duration or range of durations to apply to the relationship. For example, 30-60 minutes before. */
  offsetRange?: Maybe<Range>;
};

/** The resource that is the target of the action (e.g. CommunicationRequest). */
export type RequestGroupactionresource_Resource_Union = Resource;

/** Provides a reference to the author of the request group. */
export type RequestGroupauthor_Author_Union = Device | Practitioner | PractitionerRole;

/** A plan, proposal or order that is fulfilled in whole or in part by this request. */
export type RequestGroupbasedOn_BasedOn_Union = Resource;

/** Describes the context of the request group, if any. */
export type RequestGroupencounter_Encounter_Union = Encounter;

/** Indicates another resource whose existence justifies this request group. */
export type RequestGroupreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference;

/** Completed or terminated request(s) whose function is taken by this new request. */
export type RequestGroupreplaces_Replaces_Union = Resource;

/** The subject for which the request group was created. */
export type RequestGroupsubject_Subject_Union = Patient | Group;

export enum Rescue_Enum_Input {
  Human = 'Human',
  Animal = 'Animal'
}

export enum Rescue_Enum_Schema {
  Human = 'Human',
  Animal = 'Animal'
}

/**
 * The ResearchDefinition resource describes the conditional state (population and
 * any exposures being compared within the population) and outcome (if specified)
 * that the knowledge (evidence, assertion, recommendation) is about.
 */
export type ResearchDefinition = {
  __typename?: 'ResearchDefinition';
  /** Type of resource */
  resourceType: ResearchDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this research definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this research
   * definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the research definition is
   * stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this research definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this research
   * definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the research definition is
   * stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this research definition when it
   * is represented in other formats, or referenced in a specification, model,
   * design or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the research
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the research definition author
   * and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence. To
   * provide a version consistent with the Decision Support Service specification,
   * use the format Major.Minor.Revision (e.g. 1.0.0). For more information on
   * versioning knowledge assets, refer to the Decision Support Service
   * specification. Note that a version is required for non-experimental active artifacts.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the research
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the research definition author
   * and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence. To
   * provide a version consistent with the Decision Support Service specification,
   * use the format Major.Minor.Revision (e.g. 1.0.0). For more information on
   * versioning knowledge assets, refer to the Decision Support Service
   * specification. Note that a version is required for non-experimental active artifacts.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the research definition. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the research definition. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the research definition. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the research definition. */
  title?: Maybe<Scalars['String']>;
  /**
   * The short title provides an alternate title for use in informal descriptive
   * contexts where the full, formal title is not necessary.
   */
  _shortTitle?: Maybe<Element>;
  /**
   * The short title provides an alternate title for use in informal descriptive
   * contexts where the full, formal title is not necessary.
   */
  shortTitle?: Maybe<Scalars['String']>;
  /** An explanatory or alternate title for the ResearchDefinition giving additional information about its content. */
  _subtitle?: Maybe<Element>;
  /** An explanatory or alternate title for the ResearchDefinition giving additional information about its content. */
  subtitle?: Maybe<Scalars['String']>;
  /** The status of this research definition. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this research definition. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this research definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this research definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The intended subjects for the ResearchDefinition. If this element is not
   * provided, a Patient subject is assumed, but the subject of the
   * ResearchDefinition can be anything.
   */
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  /**
   * The intended subjects for the ResearchDefinition. If this element is not
   * provided, a Patient subject is assumed, but the subject of the
   * ResearchDefinition can be anything.
   */
  subjectReference?: Maybe<ResearchDefinitionsubjectReference_SubjectReference_Union>;
  /**
   * The date  (and optionally time) when the research definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the research definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the research definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the research definition changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the research definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the research definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the research definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the research definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  _comment?: Maybe<Element>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  comment?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate research
   * definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the research definition is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this research definition is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this research definition is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /** A detailed description, from a clinical perspective, of how the ResearchDefinition is used. */
  _usage?: Maybe<Element>;
  /** A detailed description, from a clinical perspective, of how the ResearchDefinition is used. */
  usage?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the research definition and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the research definition.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the research definition and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the research definition.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the research definition content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the content of the ResearchDefinition. Topics
   * provide a high-level categorization grouping types of ResearchDefinitions that
   * can be useful for filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related artifacts such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** A reference to a Library resource containing the formal logic used by the ResearchDefinition. */
  _library?: Maybe<Element>;
  /** A reference to a Library resource containing the formal logic used by the ResearchDefinition. */
  library?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** A reference to a ResearchElementDefinition resource that defines the population for the research. */
  population: ResearchDefinitionpopulation_Population_Union;
  /** A reference to a ResearchElementDefinition resource that defines the exposure for the research. */
  exposure?: Maybe<ResearchDefinitionexposure_Exposure_Union>;
  /** A reference to a ResearchElementDefinition resource that defines the exposureAlternative for the research. */
  exposureAlternative?: Maybe<ResearchDefinitionexposureAlternative_ExposureAlternative_Union>;
  /** A reference to a ResearchElementDefinition resomece that defines the outcome for the research. */
  outcome?: Maybe<ResearchDefinitionoutcome_Outcome_Union>;
};

export enum ResearchDefinition_Enum_Schema {
  ResearchDefinition = 'ResearchDefinition'
}

/** A reference to a ResearchElementDefinition resource that defines the exposureAlternative for the research. */
export type ResearchDefinitionexposureAlternative_ExposureAlternative_Union = ResearchElementDefinition;

/** A reference to a ResearchElementDefinition resource that defines the exposure for the research. */
export type ResearchDefinitionexposure_Exposure_Union = ResearchElementDefinition;

/** A reference to a ResearchElementDefinition resomece that defines the outcome for the research. */
export type ResearchDefinitionoutcome_Outcome_Union = ResearchElementDefinition;

/** A reference to a ResearchElementDefinition resource that defines the population for the research. */
export type ResearchDefinitionpopulation_Population_Union = ResearchElementDefinition;

/**
 * The intended subjects for the ResearchDefinition. If this element is not
 * provided, a Patient subject is assumed, but the subject of the
 * ResearchDefinition can be anything.
 */
export type ResearchDefinitionsubjectReference_SubjectReference_Union = Group;

/**
 * The ResearchElementDefinition resource describes a 'PICO' element that knowledge
 * (evidence, assertion, recommendation) is about.
 */
export type ResearchElementDefinition = {
  __typename?: 'ResearchElementDefinition';
  /** Type of resource */
  resourceType: ResearchElementDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this research element definition when
   * it is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this research
   * element definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the research element
   * definition is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this research element definition when
   * it is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this research
   * element definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the research element
   * definition is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this research element definition
   * when it is represented in other formats, or referenced in a specification,
   * model, design or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the research element
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the research element
   * definition author and is not expected to be globally unique. For example, it
   * might be a timestamp (e.g. yyyymmdd) if a managed version is not available.
   * There is also no expectation that versions can be placed in a lexicographical
   * sequence. To provide a version consistent with the Decision Support Service
   * specification, use the format Major.Minor.Revision (e.g. 1.0.0). For more
   * information on versioning knowledge assets, refer to the Decision Support
   * Service specification. Note that a version is required for non-experimental
   * active artifacts.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the research element
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the research element
   * definition author and is not expected to be globally unique. For example, it
   * might be a timestamp (e.g. yyyymmdd) if a managed version is not available.
   * There is also no expectation that versions can be placed in a lexicographical
   * sequence. To provide a version consistent with the Decision Support Service
   * specification, use the format Major.Minor.Revision (e.g. 1.0.0). For more
   * information on versioning knowledge assets, refer to the Decision Support
   * Service specification. Note that a version is required for non-experimental
   * active artifacts.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the research element definition. This name
   * should be usable as an identifier for the module by machine processing
   * applications such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the research element definition. This name
   * should be usable as an identifier for the module by machine processing
   * applications such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the research element definition. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the research element definition. */
  title?: Maybe<Scalars['String']>;
  /**
   * The short title provides an alternate title for use in informal descriptive
   * contexts where the full, formal title is not necessary.
   */
  _shortTitle?: Maybe<Element>;
  /**
   * The short title provides an alternate title for use in informal descriptive
   * contexts where the full, formal title is not necessary.
   */
  shortTitle?: Maybe<Scalars['String']>;
  /** An explanatory or alternate title for the ResearchElementDefinition giving additional information about its content. */
  _subtitle?: Maybe<Element>;
  /** An explanatory or alternate title for the ResearchElementDefinition giving additional information about its content. */
  subtitle?: Maybe<Scalars['String']>;
  /** The status of this research element definition. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this research element definition. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this research element definition is authored
   * for testing purposes (or education/evaluation/marketing) and is not intended
   * to be used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this research element definition is authored
   * for testing purposes (or education/evaluation/marketing) and is not intended
   * to be used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The intended subjects for the ResearchElementDefinition. If this element is
   * not provided, a Patient subject is assumed, but the subject of the
   * ResearchElementDefinition can be anything.
   */
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  /**
   * The intended subjects for the ResearchElementDefinition. If this element is
   * not provided, a Patient subject is assumed, but the subject of the
   * ResearchElementDefinition can be anything.
   */
  subjectReference?: Maybe<ResearchElementDefinitionsubjectReference_SubjectReference_Union>;
  /**
   * The date  (and optionally time) when the research element definition was
   * published. The date must change when the business version changes and it must
   * change if the status code changes. In addition, it should change when the
   * substantive content of the research element definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the research element definition was
   * published. The date must change when the business version changes and it must
   * change if the status code changes. In addition, it should change when the
   * substantive content of the research element definition changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the research element definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the research element definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the research element definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the research element definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  _comment?: Maybe<Element>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  comment?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate research
   * element definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the research element definition is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this research element definition is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this research element definition is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /** A detailed description, from a clinical perspective, of how the ResearchElementDefinition is used. */
  _usage?: Maybe<Element>;
  /** A detailed description, from a clinical perspective, of how the ResearchElementDefinition is used. */
  usage?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the research element definition and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the research element definition.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the research element definition and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the research element definition.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the research element definition content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the content of the ResearchElementDefinition.
   * Topics provide a high-level categorization grouping types of
   * ResearchElementDefinitions that can be useful for filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related artifacts such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** A reference to a Library resource containing the formal logic used by the ResearchElementDefinition. */
  _library?: Maybe<Element>;
  /** A reference to a Library resource containing the formal logic used by the ResearchElementDefinition. */
  library?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** The type of research element, a population, an exposure, or an outcome. */
  _type?: Maybe<Element>;
  /** The type of research element, a population, an exposure, or an outcome. */
  type: Scalars['code'];
  /** The type of the outcome (e.g. Dichotomous, Continuous, or Descriptive). */
  _variableType?: Maybe<Element>;
  /** The type of the outcome (e.g. Dichotomous, Continuous, or Descriptive). */
  variableType?: Maybe<Scalars['code']>;
  /**
   * A characteristic that defines the members of the research element. Multiple
   * characteristics are applied with 'and' semantics.
   */
  characteristic?: Maybe<Array<ResearchElementDefinitioncharacteristic>>;
};

export enum ResearchElementDefinition_Enum_Schema {
  ResearchElementDefinition = 'ResearchElementDefinition'
}

export type ResearchElementDefinitioncharacteristic = {
  __typename?: 'ResearchElementDefinitioncharacteristic';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Define members of the research element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  definitionCodeableConcept: CodeableConcept;
  /**
   * Define members of the research element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  _definitionCanonical?: Maybe<Element>;
  /**
   * Define members of the research element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  definitionCanonical: Scalars['canonical'];
  /**
   * Define members of the research element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  definitionExpression: Expression;
  /**
   * Define members of the research element using Codes (such as condition,
   * medication, or observation), Expressions ( using an expression language such
   * as FHIRPath or CQL) or DataRequirements (such as Diabetes diagnosis onset in
   * the last year).
   */
  definitionDataRequirement: DataRequirement;
  /** Use UsageContext to define the members of the population, such as Age Ranges, Genders, Settings. */
  usageContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** When true, members with this characteristic are excluded from the element. */
  _exclude?: Maybe<Element>;
  /** When true, members with this characteristic are excluded from the element. */
  exclude?: Maybe<Scalars['Boolean']>;
  /** Specifies the UCUM unit for the outcome. */
  unitOfMeasure?: Maybe<CodeableConcept>;
  /** A narrative description of the time period the study covers. */
  _studyEffectiveDescription?: Maybe<Element>;
  /** A narrative description of the time period the study covers. */
  studyEffectiveDescription?: Maybe<Scalars['String']>;
  /** Indicates what effective period the study covers. */
  _studyEffectiveDateTime?: Maybe<Element>;
  /** Indicates what effective period the study covers. */
  studyEffectiveDateTime?: Maybe<Scalars['dateTime']>;
  /** Indicates what effective period the study covers. */
  studyEffectivePeriod?: Maybe<Period>;
  /** Indicates what effective period the study covers. */
  studyEffectiveDuration?: Maybe<Duration>;
  /** Indicates what effective period the study covers. */
  studyEffectiveTiming?: Maybe<Timing>;
  /** Indicates duration from the study initiation. */
  studyEffectiveTimeFromStart?: Maybe<Duration>;
  /** Indicates how elements are aggregated within the study effective period. */
  _studyEffectiveGroupMeasure?: Maybe<Element>;
  /** Indicates how elements are aggregated within the study effective period. */
  studyEffectiveGroupMeasure?: Maybe<Scalars['code']>;
  /** A narrative description of the time period the study covers. */
  _participantEffectiveDescription?: Maybe<Element>;
  /** A narrative description of the time period the study covers. */
  participantEffectiveDescription?: Maybe<Scalars['String']>;
  /** Indicates what effective period the study covers. */
  _participantEffectiveDateTime?: Maybe<Element>;
  /** Indicates what effective period the study covers. */
  participantEffectiveDateTime?: Maybe<Scalars['dateTime']>;
  /** Indicates what effective period the study covers. */
  participantEffectivePeriod?: Maybe<Period>;
  /** Indicates what effective period the study covers. */
  participantEffectiveDuration?: Maybe<Duration>;
  /** Indicates what effective period the study covers. */
  participantEffectiveTiming?: Maybe<Timing>;
  /** Indicates duration from the participant's study entry. */
  participantEffectiveTimeFromStart?: Maybe<Duration>;
  /** Indicates how elements are aggregated within the study effective period. */
  _participantEffectiveGroupMeasure?: Maybe<Element>;
  /** Indicates how elements are aggregated within the study effective period. */
  participantEffectiveGroupMeasure?: Maybe<Scalars['code']>;
};

/**
 * The intended subjects for the ResearchElementDefinition. If this element is not
 * provided, a Patient subject is assumed, but the subject of the
 * ResearchElementDefinition can be anything.
 */
export type ResearchElementDefinitionsubjectReference_SubjectReference_Union = Group;

/**
 * A process where a researcher or organization plans and then executes a series of
 * steps intended to increase the field of healthcare-related knowledge.  This
 * includes studies of safety, efficacy, comparative effectiveness and other
 * information about medications, devices, therapies and other interventional and
 * investigative techniques.  A ResearchStudy involves the gathering of information
 * about human or animal subjects.
 */
export type ResearchStudy = {
  __typename?: 'ResearchStudy';
  /** Type of resource */
  resourceType: ResearchStudy_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifiers assigned to this research study by the sponsor or other systems. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A short, descriptive user-friendly label for the study. */
  _title?: Maybe<Element>;
  /** A short, descriptive user-friendly label for the study. */
  title?: Maybe<Scalars['String']>;
  /** The set of steps expected to be performed as part of the execution of the study. */
  protocol?: Maybe<Array<Maybe<ResearchStudyprotocol_Protocol_Union>>>;
  /** A larger research study of which this particular study is a component or step. */
  partOf?: Maybe<Array<Maybe<ResearchStudypartOf_PartOf_Union>>>;
  /** The current state of the study. */
  _status?: Maybe<Element>;
  /** The current state of the study. */
  status: Scalars['code'];
  /** The type of study based upon the intent of the study's activities. A classification of the intent of the study. */
  primaryPurposeType?: Maybe<CodeableConcept>;
  /**
   * The stage in the progression of a therapy from initial experimental use in
   * humans in clinical trials to post-market evaluation.
   */
  phase?: Maybe<CodeableConcept>;
  /**
   * Codes categorizing the type of study such as investigational vs.
   * observational, type of blinding, type of randomization, safety vs. efficacy, etc.
   */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * The medication(s), food(s), therapy(ies), device(s) or other concerns or
   * interventions that the study is seeking to gain more information about.
   */
  focus?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * The condition that is the focus of the study.  For example, In a study to
   * examine risk factors for Lupus, might have as an inclusion criterion 'healthy
   * volunteer', but the target condition code would be a Lupus SNOMED code.
   */
  condition?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Contact details to assist a user in learning more about or engaging with the study. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Citations, references and other related documents. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** Key terms to aid in searching for or filtering the study. */
  keyword?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates a country, state or other region where the study is taking place. */
  location?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A full description of how the study is being conducted. */
  _description?: Maybe<Element>;
  /** A full description of how the study is being conducted. */
  description?: Maybe<Scalars['String']>;
  /**
   * Reference to a Group that defines the criteria for and quantity of subjects
   * participating in the study.  E.g. ' 200 female Europeans between the ages of
   * 20 and 45 with early onset diabetes'.
   */
  enrollment?: Maybe<Array<Maybe<ResearchStudyenrollment_Enrollment_Union>>>;
  /** Identifies the start date and the expected (or actual, depending on status) end date for the study. */
  period?: Maybe<Period>;
  /** An organization that initiates the investigation and is legally responsible for the study. */
  sponsor?: Maybe<ResearchStudysponsor_Sponsor_Union>;
  /**
   * A researcher in a study who oversees multiple aspects of the study, such as
   * concept development, protocol writing, protocol submission for IRB approval,
   * participant recruitment, informed consent, data collection, analysis,
   * interpretation and presentation.
   */
  principalInvestigator?: Maybe<ResearchStudyprincipalInvestigator_PrincipalInvestigator_Union>;
  /** A facility in which study activities are conducted. */
  site?: Maybe<Array<Maybe<ResearchStudysite_Site_Union>>>;
  /** A description and/or code explaining the premature termination of the study. */
  reasonStopped?: Maybe<CodeableConcept>;
  /** Comments made about the study by the performer, subject or other participants. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * Describes an expected sequence of events for one of the participants of a
   * study.  E.g. Exposure to drug A, wash-out, exposure to drug B, wash-out, follow-up.
   */
  arm?: Maybe<Array<Maybe<ResearchStudyarm>>>;
  /**
   * A goal that the study is aiming to achieve in terms of a scientific question
   * to be answered by the analysis of data collected during the study.
   */
  objective?: Maybe<Array<Maybe<ResearchStudyobjective>>>;
};

export enum ResearchStudy_Enum_Schema {
  ResearchStudy = 'ResearchStudy'
}

export type ResearchStudyarm = {
  __typename?: 'ResearchStudyarm';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique, human-readable label for this arm of the study. */
  _name?: Maybe<Element>;
  /** Unique, human-readable label for this arm of the study. */
  name: Scalars['String'];
  /** Categorization of study arm, e.g. experimental, active comparator, placebo comparater. */
  type?: Maybe<CodeableConcept>;
  /** A succinct description of the path through the study that would be followed by a subject adhering to this arm. */
  _description?: Maybe<Element>;
  /** A succinct description of the path through the study that would be followed by a subject adhering to this arm. */
  description?: Maybe<Scalars['String']>;
};

/**
 * Reference to a Group that defines the criteria for and quantity of subjects
 * participating in the study.  E.g. ' 200 female Europeans between the ages of 20
 * and 45 with early onset diabetes'.
 */
export type ResearchStudyenrollment_Enrollment_Union = Group;

export type ResearchStudyobjective = {
  __typename?: 'ResearchStudyobjective';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique, human-readable label for this objective of the study. */
  _name?: Maybe<Element>;
  /** Unique, human-readable label for this objective of the study. */
  name?: Maybe<Scalars['String']>;
  /** The kind of study objective. */
  type?: Maybe<CodeableConcept>;
};

/** A larger research study of which this particular study is a component or step. */
export type ResearchStudypartOf_PartOf_Union = ResearchStudy;

/**
 * A researcher in a study who oversees multiple aspects of the study, such as
 * concept development, protocol writing, protocol submission for IRB approval,
 * participant recruitment, informed consent, data collection, analysis,
 * interpretation and presentation.
 */
export type ResearchStudyprincipalInvestigator_PrincipalInvestigator_Union = Practitioner | PractitionerRole;

/** The set of steps expected to be performed as part of the execution of the study. */
export type ResearchStudyprotocol_Protocol_Union = PlanDefinition;

/** A facility in which study activities are conducted. */
export type ResearchStudysite_Site_Union = Location;

/** An organization that initiates the investigation and is legally responsible for the study. */
export type ResearchStudysponsor_Sponsor_Union = Organization;

/** A physical entity which is the primary unit of operational and/or administrative interest in a study. */
export type ResearchSubject = {
  __typename?: 'ResearchSubject';
  /** Type of resource */
  resourceType: ResearchSubject_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifiers assigned to this research subject for a study. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The current state of the subject. */
  _status?: Maybe<Element>;
  /** The current state of the subject. */
  status: Scalars['code'];
  /** The dates the subject began and ended their participation in the study. */
  period?: Maybe<Period>;
  /** Reference to the study the subject is participating in. */
  study: ResearchSubjectstudy_Study_Union;
  /** The record of the person or animal who is involved in the study. */
  individual: ResearchSubjectindividual_Individual_Union;
  /** The name of the arm in the study the subject is expected to follow as part of this study. */
  _assignedArm?: Maybe<Element>;
  /** The name of the arm in the study the subject is expected to follow as part of this study. */
  assignedArm?: Maybe<Scalars['String']>;
  /** The name of the arm in the study the subject actually followed as part of this study. */
  _actualArm?: Maybe<Element>;
  /** The name of the arm in the study the subject actually followed as part of this study. */
  actualArm?: Maybe<Scalars['String']>;
  /** A record of the patient's informed agreement to participate in the study. */
  consent?: Maybe<ResearchSubjectconsent_Consent_Union>;
};

export enum ResearchSubject_Enum_Schema {
  ResearchSubject = 'ResearchSubject'
}

/** A record of the patient's informed agreement to participate in the study. */
export type ResearchSubjectconsent_Consent_Union = Consent;

/** The record of the person or animal who is involved in the study. */
export type ResearchSubjectindividual_Individual_Union = Patient;

/** Reference to the study the subject is participating in. */
export type ResearchSubjectstudy_Study_Union = ResearchStudy;

/** This is the base resource type for everything. */
export type Resource = {
  __typename?: 'Resource';
  /** Type of resource */
  resourceType: Resource_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
};

/** Union of all available resources */
export type ResourceList = Resource | Account | ActivityDefinition | AdverseEvent | AllergyIntolerance | Appointment | AppointmentResponse | AuditEvent | Basic | Binary | BiologicallyDerivedProduct | BodyStructure | Bundle | CapabilityStatement | CarePlan | CareTeam | CatalogEntry | ChargeItem | ChargeItemDefinition | Claim | ClaimResponse | ClinicalImpression | CodeSystem | Communication | CommunicationRequest | CompartmentDefinition | Composition | ConceptMap | Condition | Consent | Contract | Coverage | CoverageEligibilityRequest | CoverageEligibilityResponse | DetectedIssue | Device | DeviceDefinition | DeviceMetric | DeviceRequest | DeviceUseStatement | DiagnosticReport | DocumentManifest | DocumentReference | DomainResource | EffectEvidenceSynthesis | Encounter | Endpoint | EnrollmentRequest | EnrollmentResponse | EpisodeOfCare | EventDefinition | Evidence | EvidenceVariable | ExampleScenario | ExplanationOfBenefit | FamilyMemberHistory | Flag | Goal | GraphDefinition | Group | GuidanceResponse | HealthcareService | ImagingStudy | Immunization | ImmunizationEvaluation | ImmunizationRecommendation | ImplementationGuide | InsurancePlan | Invoice | Library | Linkage | List | Location | Measure | MeasureReport | Media | Medication | MedicationAdministration | MedicationDispense | MedicationKnowledge | MedicationRequest | MedicationStatement | MedicinalProduct | MedicinalProductAuthorization | MedicinalProductContraindication | MedicinalProductIndication | MedicinalProductIngredient | MedicinalProductInteraction | MedicinalProductManufactured | MedicinalProductPackaged | MedicinalProductPharmaceutical | MedicinalProductUndesirableEffect | MessageDefinition | MessageHeader | MolecularSequence | NamingSystem | NutritionOrder | Observation | ObservationDefinition | OperationDefinition | OperationOutcome | Organization | OrganizationAffiliation | Parameters | Patient | PaymentNotice | PaymentReconciliation | Person | PlanDefinition | Practitioner | PractitionerRole | Procedure | Provenance | Questionnaire | QuestionnaireResponse | RelatedPerson | RequestGroup | ResearchDefinition | ResearchElementDefinition | ResearchStudy | ResearchSubject | RiskAssessment | RiskEvidenceSynthesis | Schedule | SearchParameter | ServiceRequest | Slot | Specimen | SpecimenDefinition | StructureDefinition | StructureMap | Subscription | Substance | SubstanceNucleicAcid | SubstancePolymer | SubstanceProtein | SubstanceReferenceInformation | SubstanceSourceMaterial | SubstanceSpecification | SupplyDelivery | SupplyRequest | Task | TerminologyCapabilities | TestReport | TestScript | ValueSet | VerificationResult | VisionPrescription;

export enum Resource_Enum_Schema {
  Resource = 'Resource'
}

/** An assessment of the likely outcome(s) for a patient or other subject as well as the likelihood of each outcome. */
export type RiskAssessment = {
  __typename?: 'RiskAssessment';
  /** Type of resource */
  resourceType: RiskAssessment_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Business identifier assigned to the risk assessment. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A reference to the request that is fulfilled by this risk assessment. */
  basedOn?: Maybe<RiskAssessmentbasedOn_BasedOn_Union>;
  /** A reference to a resource that this risk assessment is part of, such as a Procedure. */
  parent?: Maybe<RiskAssessmentparent_Parent_Union>;
  /** The status of the RiskAssessment, using the same statuses as an Observation. */
  _status?: Maybe<Element>;
  /** The status of the RiskAssessment, using the same statuses as an Observation. */
  status: Scalars['code'];
  /** The algorithm, process or mechanism used to evaluate the risk. */
  method?: Maybe<CodeableConcept>;
  /** The type of the risk assessment performed. */
  code?: Maybe<CodeableConcept>;
  /** The patient or group the risk assessment applies to. */
  subject: RiskAssessmentsubject_Subject_Union;
  /** The encounter where the assessment was performed. */
  encounter?: Maybe<RiskAssessmentencounter_Encounter_Union>;
  /** The date (and possibly time) the risk assessment was performed. */
  _occurrenceDateTime?: Maybe<Element>;
  /** The date (and possibly time) the risk assessment was performed. */
  occurrenceDateTime?: Maybe<Scalars['dateTime']>;
  /** The date (and possibly time) the risk assessment was performed. */
  occurrencePeriod?: Maybe<Period>;
  /** For assessments or prognosis specific to a particular condition, indicates the condition being assessed. */
  condition?: Maybe<RiskAssessmentcondition_Condition_Union>;
  /** The provider or software application that performed the assessment. */
  performer?: Maybe<RiskAssessmentperformer_Performer_Union>;
  /** The reason the risk assessment was performed. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Resources supporting the reason the risk assessment was performed. */
  reasonReference?: Maybe<Array<Maybe<RiskAssessmentreasonReference_ReasonReference_Union>>>;
  /**
   * Indicates the source data considered as part of the assessment (for example,
   * FamilyHistory, Observations, Procedures, Conditions, etc.).
   */
  basis?: Maybe<Array<Maybe<RiskAssessmentbasis_Basis_Union>>>;
  /** Describes the expected outcome for the subject. */
  prediction?: Maybe<Array<Maybe<RiskAssessmentprediction>>>;
  /** A description of the steps that might be taken to reduce the identified risk(s). */
  _mitigation?: Maybe<Element>;
  /** A description of the steps that might be taken to reduce the identified risk(s). */
  mitigation?: Maybe<Scalars['String']>;
  /** Additional comments about the risk assessment. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export enum RiskAssessment_Enum_Schema {
  RiskAssessment = 'RiskAssessment'
}

/** A reference to the request that is fulfilled by this risk assessment. */
export type RiskAssessmentbasedOn_BasedOn_Union = Resource;

/**
 * Indicates the source data considered as part of the assessment (for example,
 * FamilyHistory, Observations, Procedures, Conditions, etc.).
 */
export type RiskAssessmentbasis_Basis_Union = Resource;

/** For assessments or prognosis specific to a particular condition, indicates the condition being assessed. */
export type RiskAssessmentcondition_Condition_Union = Condition;

/** The encounter where the assessment was performed. */
export type RiskAssessmentencounter_Encounter_Union = Encounter;

/** A reference to a resource that this risk assessment is part of, such as a Procedure. */
export type RiskAssessmentparent_Parent_Union = Resource;

/** The provider or software application that performed the assessment. */
export type RiskAssessmentperformer_Performer_Union = Practitioner | PractitionerRole | Device;

export type RiskAssessmentprediction = {
  __typename?: 'RiskAssessmentprediction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** One of the potential outcomes for the patient (e.g. remission, death,  a particular condition). */
  outcome?: Maybe<CodeableConcept>;
  /** Indicates how likely the outcome is (in the specified timeframe). */
  _probabilityDecimal?: Maybe<Element>;
  /** Indicates how likely the outcome is (in the specified timeframe). */
  probabilityDecimal?: Maybe<Scalars['Float']>;
  /** Indicates how likely the outcome is (in the specified timeframe). */
  probabilityRange?: Maybe<Range>;
  /**
   * Indicates how likely the outcome is (in the specified timeframe), expressed as
   * a qualitative value (e.g. low, medium, or high).
   */
  qualitativeRisk?: Maybe<CodeableConcept>;
  /**
   * Indicates the risk for this particular subject (with their specific
   * characteristics) divided by the risk of the population in general.  (Numbers
   * greater than 1 = higher risk than the population, numbers less than 1 = lower risk.).
   */
  _relativeRisk?: Maybe<Element>;
  /**
   * Indicates the risk for this particular subject (with their specific
   * characteristics) divided by the risk of the population in general.  (Numbers
   * greater than 1 = higher risk than the population, numbers less than 1 = lower risk.).
   */
  relativeRisk?: Maybe<Scalars['Float']>;
  /** Indicates the period of time or age range of the subject to which the specified probability applies. */
  whenPeriod?: Maybe<Period>;
  /** Indicates the period of time or age range of the subject to which the specified probability applies. */
  whenRange?: Maybe<Range>;
  /** Additional information explaining the basis for the prediction. */
  _rationale?: Maybe<Element>;
  /** Additional information explaining the basis for the prediction. */
  rationale?: Maybe<Scalars['String']>;
};

/** Resources supporting the reason the risk assessment was performed. */
export type RiskAssessmentreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference;

/** The patient or group the risk assessment applies to. */
export type RiskAssessmentsubject_Subject_Union = Patient | Group;

/**
 * The RiskEvidenceSynthesis resource describes the likelihood of an outcome in a
 * population plus exposure state where the risk estimate is derived from a
 * combination of research studies.
 */
export type RiskEvidenceSynthesis = {
  __typename?: 'RiskEvidenceSynthesis';
  /** Type of resource */
  resourceType: RiskEvidenceSynthesis_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this risk evidence synthesis when it
   * is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this risk
   * evidence synthesis is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the risk evidence synthesis
   * is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this risk evidence synthesis when it
   * is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this risk
   * evidence synthesis is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the risk evidence synthesis
   * is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this risk evidence synthesis when
   * it is represented in other formats, or referenced in a specification, model,
   * design or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the risk evidence
   * synthesis when it is referenced in a specification, model, design or instance.
   * This is an arbitrary value managed by the risk evidence synthesis author and
   * is not expected to be globally unique. For example, it might be a timestamp
   * (e.g. yyyymmdd) if a managed version is not available. There is also no
   * expectation that versions can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the risk evidence
   * synthesis when it is referenced in a specification, model, design or instance.
   * This is an arbitrary value managed by the risk evidence synthesis author and
   * is not expected to be globally unique. For example, it might be a timestamp
   * (e.g. yyyymmdd) if a managed version is not available. There is also no
   * expectation that versions can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the risk evidence synthesis. This name
   * should be usable as an identifier for the module by machine processing
   * applications such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the risk evidence synthesis. This name
   * should be usable as an identifier for the module by machine processing
   * applications such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the risk evidence synthesis. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the risk evidence synthesis. */
  title?: Maybe<Scalars['String']>;
  /** The status of this risk evidence synthesis. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this risk evidence synthesis. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * The date  (and optionally time) when the risk evidence synthesis was
   * published. The date must change when the business version changes and it must
   * change if the status code changes. In addition, it should change when the
   * substantive content of the risk evidence synthesis changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the risk evidence synthesis was
   * published. The date must change when the business version changes and it must
   * change if the status code changes. In addition, it should change when the
   * substantive content of the risk evidence synthesis changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the risk evidence synthesis. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the risk evidence synthesis. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the risk evidence synthesis from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the risk evidence synthesis from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate risk
   * evidence synthesis instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the risk evidence synthesis is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * A copyright statement relating to the risk evidence synthesis and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the risk evidence synthesis.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the risk evidence synthesis and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the risk evidence synthesis.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  _approvalDate?: Maybe<Element>;
  /**
   * The date on which the resource content was approved by the publisher. Approval
   * happens once when the content is officially approved for usage.
   */
  approvalDate?: Maybe<Scalars['date']>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  _lastReviewDate?: Maybe<Element>;
  /**
   * The date on which the resource content was last reviewed. Review happens
   * periodically after approval but does not change the original approval date.
   */
  lastReviewDate?: Maybe<Scalars['date']>;
  /** The period during which the risk evidence synthesis content was or is planned to be in active use. */
  effectivePeriod?: Maybe<Period>;
  /**
   * Descriptive topics related to the content of the RiskEvidenceSynthesis. Topics
   * provide a high-level categorization grouping types of EffectEvidenceSynthesiss
   * that can be useful for filtering and searching.
   */
  topic?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An individiual or organization primarily involved in the creation and maintenance of the content. */
  author?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for internal coherence of the content. */
  editor?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization primarily responsible for review of some aspect of the content. */
  reviewer?: Maybe<Array<Maybe<ContactDetail>>>;
  /** An individual or organization responsible for officially endorsing the content for use in some setting. */
  endorser?: Maybe<Array<Maybe<ContactDetail>>>;
  /** Related artifacts such as additional documentation, justification, or bibliographic references. */
  relatedArtifact?: Maybe<Array<Maybe<RelatedArtifact>>>;
  /** Type of synthesis eg meta-analysis. */
  synthesisType?: Maybe<CodeableConcept>;
  /** Type of study eg randomized trial. */
  studyType?: Maybe<CodeableConcept>;
  /** A reference to a EvidenceVariable resource that defines the population for the research. */
  population: RiskEvidenceSynthesispopulation_Population_Union;
  /** A reference to a EvidenceVariable resource that defines the exposure for the research. */
  exposure?: Maybe<RiskEvidenceSynthesisexposure_Exposure_Union>;
  /** A reference to a EvidenceVariable resomece that defines the outcome for the research. */
  outcome: RiskEvidenceSynthesisoutcome_Outcome_Union;
  /** A description of the size of the sample involved in the synthesis. */
  sampleSize?: Maybe<RiskEvidenceSynthesissampleSize>;
  /** The estimated risk of the outcome. */
  riskEstimate?: Maybe<RiskEvidenceSynthesisriskEstimate>;
  /** A description of the certainty of the risk estimate. */
  certainty?: Maybe<Array<Maybe<RiskEvidenceSynthesiscertainty>>>;
};

export enum RiskEvidenceSynthesis_Enum_Schema {
  RiskEvidenceSynthesis = 'RiskEvidenceSynthesis'
}

export type RiskEvidenceSynthesiscertainty = {
  __typename?: 'RiskEvidenceSynthesiscertainty';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A rating of the certainty of the effect estimate. */
  rating?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** A description of a component of the overall certainty. */
  certaintySubcomponent?: Maybe<Array<Maybe<RiskEvidenceSynthesiscertaintycertaintySubcomponent>>>;
};

export type RiskEvidenceSynthesiscertaintycertaintySubcomponent = {
  __typename?: 'RiskEvidenceSynthesiscertaintycertaintySubcomponent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type of subcomponent of certainty rating. */
  type?: Maybe<CodeableConcept>;
  /** A rating of a subcomponent of rating certainty. */
  rating?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A human-readable string to clarify or explain concepts about the resource. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

/** A reference to a EvidenceVariable resource that defines the exposure for the research. */
export type RiskEvidenceSynthesisexposure_Exposure_Union = EvidenceVariable;

/** A reference to a EvidenceVariable resomece that defines the outcome for the research. */
export type RiskEvidenceSynthesisoutcome_Outcome_Union = EvidenceVariable;

/** A reference to a EvidenceVariable resource that defines the population for the research. */
export type RiskEvidenceSynthesispopulation_Population_Union = EvidenceVariable;

export type RiskEvidenceSynthesisriskEstimate = {
  __typename?: 'RiskEvidenceSynthesisriskEstimate';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Human-readable summary of risk estimate. */
  _description?: Maybe<Element>;
  /** Human-readable summary of risk estimate. */
  description?: Maybe<Scalars['String']>;
  /** Examples include proportion and mean. */
  type?: Maybe<CodeableConcept>;
  /** The point estimate of the risk estimate. */
  _value?: Maybe<Element>;
  /** The point estimate of the risk estimate. */
  value?: Maybe<Scalars['Float']>;
  /** Specifies the UCUM unit for the outcome. */
  unitOfMeasure?: Maybe<CodeableConcept>;
  /** The sample size for the group that was measured for this risk estimate. */
  _denominatorCount?: Maybe<Element>;
  /** The sample size for the group that was measured for this risk estimate. */
  denominatorCount?: Maybe<Scalars['Int']>;
  /** The number of group members with the outcome of interest. */
  _numeratorCount?: Maybe<Element>;
  /** The number of group members with the outcome of interest. */
  numeratorCount?: Maybe<Scalars['Int']>;
  /** A description of the precision of the estimate for the effect. */
  precisionEstimate?: Maybe<Array<Maybe<RiskEvidenceSynthesisriskEstimateprecisionEstimate>>>;
};

export type RiskEvidenceSynthesisriskEstimateprecisionEstimate = {
  __typename?: 'RiskEvidenceSynthesisriskEstimateprecisionEstimate';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Examples include confidence interval and interquartile range. */
  type?: Maybe<CodeableConcept>;
  /** Use 95 for a 95% confidence interval. */
  _level?: Maybe<Element>;
  /** Use 95 for a 95% confidence interval. */
  level?: Maybe<Scalars['Float']>;
  /** Lower bound of confidence interval. */
  _from?: Maybe<Element>;
  /** Lower bound of confidence interval. */
  from?: Maybe<Scalars['Float']>;
  /** Upper bound of confidence interval. */
  _to?: Maybe<Element>;
  /** Upper bound of confidence interval. */
  to?: Maybe<Scalars['Float']>;
};

export type RiskEvidenceSynthesissampleSize = {
  __typename?: 'RiskEvidenceSynthesissampleSize';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Human-readable summary of sample size. */
  _description?: Maybe<Element>;
  /** Human-readable summary of sample size. */
  description?: Maybe<Scalars['String']>;
  /** Number of studies included in this evidence synthesis. */
  _numberOfStudies?: Maybe<Element>;
  /** Number of studies included in this evidence synthesis. */
  numberOfStudies?: Maybe<Scalars['Int']>;
  /** Number of participants included in this evidence synthesis. */
  _numberOfParticipants?: Maybe<Element>;
  /** Number of participants included in this evidence synthesis. */
  numberOfParticipants?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleAdminUsersManagement_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleAdminUsersManagement_Schema = {
  __typename?: 'RoleAdminUsersManagement_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

export type RoleAppointmentReminder_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  delete?: Maybe<Scalars['Int']>;
};

export type RoleAppointmentReminder_Schema = {
  __typename?: 'RoleAppointmentReminder_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  delete?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleAppointments_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  approve?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancel?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  practitionerCancel?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  patientCancel?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleAppointments_Schema = {
  __typename?: 'RoleAppointments_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  approve?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancel?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  practitionerCancel?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  patientCancel?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleFaqs_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleFaqs_Schema = {
  __typename?: 'RoleFaqs_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleFeedbackComm_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  reply?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleFeedbackComm_Schema = {
  __typename?: 'RoleFeedbackComm_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  reply?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleLetter_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleLetter_Schema = {
  __typename?: 'RoleLetter_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleOakTreeReferral_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleOakTreeReferral_Schema = {
  __typename?: 'RoleOakTreeReferral_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleOrgComm_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  reply?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleOrgComm_Schema = {
  __typename?: 'RoleOrgComm_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  reply?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleOrganisationManagement_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleOrganisationManagement_Schema = {
  __typename?: 'RoleOrganisationManagement_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleOtherAppointments_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  approve?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancel?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  practitionerCancel?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  patientCancel?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleOtherAppointments_Schema = {
  __typename?: 'RoleOtherAppointments_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  approve?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancel?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  practitionerCancel?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  patientCancel?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientComm_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  reply?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientComm_Schema = {
  __typename?: 'RolePatientComm_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  reply?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientHealthParameters_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientHealthParameters_Schema = {
  __typename?: 'RolePatientHealthParameters_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientInvoice_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientInvoice_Schema = {
  __typename?: 'RolePatientInvoice_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientPendingInvoice_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientPendingInvoice_Schema = {
  __typename?: 'RolePatientPendingInvoice_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientQuestitionere_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  submit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientQuestitionere_Schema = {
  __typename?: 'RolePatientQuestitionere_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  submit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordAppointment_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordAppointment_Schema = {
  __typename?: 'RolePatientRecordAppointment_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordCommunicatoin_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordCommunicatoin_Schema = {
  __typename?: 'RolePatientRecordCommunicatoin_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordFinancial_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  delete?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordFinancial_Schema = {
  __typename?: 'RolePatientRecordFinancial_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  delete?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordLetter_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordLetter_Schema = {
  __typename?: 'RolePatientRecordLetter_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordMedication_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordMedication_Schema = {
  __typename?: 'RolePatientRecordMedication_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordOtherAppointment_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordOtherAppointment_Schema = {
  __typename?: 'RolePatientRecordOtherAppointment_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordThirdParty_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecordThirdParty_Schema = {
  __typename?: 'RolePatientRecordThirdParty_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecords_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientRecords_Schema = {
  __typename?: 'RolePatientRecords_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientSelfhelp_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancel?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientSelfhelp_Schema = {
  __typename?: 'RolePatientSelfhelp_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  cancel?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientSignPosting_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientSignPosting_Schema = {
  __typename?: 'RolePatientSignPosting_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientTreatmentTherapy_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePatientTreatmentTherapy_Schema = {
  __typename?: 'RolePatientTreatmentTherapy_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePermissionsActions_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  delete?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePermissionsActions_Schema = {
  __typename?: 'RolePermissionsActions_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  delete?: Maybe<Scalars['Int']>;
};

export enum RolePermissions_Enum_Input {
  RolePermission = 'RolePermission'
}

export enum RolePermissions_Enum_Schema {
  RolePermission = 'RolePermission'
}

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePractComm_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  reply?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePractComm_Schema = {
  __typename?: 'RolePractComm_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  reply?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePractitionerApproval_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  approve?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePractitionerApproval_Schema = {
  __typename?: 'RolePractitionerApproval_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  approve?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePractitionerStatements_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  authorize?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RolePractitionerStatements_Schema = {
  __typename?: 'RolePractitionerStatements_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  authorize?: Maybe<Scalars['Int']>;
};

export type RolePricing_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

export type RolePricing_Schema = {
  __typename?: 'RolePricing_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleQuestitioner_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleQuestitioner_Schema = {
  __typename?: 'RoleQuestitioner_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleReportsAnalytics_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleReportsAnalytics_Schema = {
  __typename?: 'RoleReportsAnalytics_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleSelfReferral_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  validate?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  contactPatient?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleSelfReferral_Schema = {
  __typename?: 'RoleSelfReferral_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  validate?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  contactPatient?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleThirdParty_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  contactThirdParty?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  sendTermsConditions?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  contactPatient?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleThirdParty_Schema = {
  __typename?: 'RoleThirdParty_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  contactThirdParty?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  sendTermsConditions?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  contactPatient?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleUserManagementLinkedUser_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleUserManagementLinkedUser_Schema = {
  __typename?: 'RoleUserManagementLinkedUser_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleUserManagementPatient_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  activateDeactivate?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleUserManagementPatient_Schema = {
  __typename?: 'RoleUserManagementPatient_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  activateDeactivate?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleUserManagementPractitioner_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  activateDeactivate?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleUserManagementPractitioner_Schema = {
  __typename?: 'RoleUserManagementPractitioner_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  activateDeactivate?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleUserManagementUser_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  activateDeactivate?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  transfer?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleUserManagementUser_Schema = {
  __typename?: 'RoleUserManagementUser_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  add?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  edit?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  activateDeactivate?: Maybe<Scalars['Int']>;
  /** operationType field data. */
  transfer?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleWebsiteComm_Input = {
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type RoleWebsiteComm_Schema = {
  __typename?: 'RoleWebsiteComm_Schema';
  /** operationType field data. */
  viewList?: Maybe<Scalars['Int']>;
};

/** RolePermission */
export type RolesPermission_Input = {
  /** Type of resource */
  resourceType: RolePermissions_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Referral_Type. */
  name?: Maybe<Scalars['String']>;
  /** type. */
  roletype?: Maybe<Scalars['String']>;
  /** type. */
  roletypevalue?: Maybe<Scalars['String']>;
  /** type. */
  roletyperank?: Maybe<Scalars['Int']>;
  /** Referrer_Title. */
  description?: Maybe<Scalars['String']>;
  /** referral_createdOn */
  createdOn?: Maybe<Scalars['String']>;
  /** status. */
  status?: Maybe<Scalars['String']>;
  practitionerApproval?: Maybe<RolePractitionerApproval_Input>;
  templateLetterNotes?: Maybe<RoleLetter_Input>;
  templateQuestionnaire?: Maybe<RoleQuestitioner_Input>;
  templateFaqs?: Maybe<RoleFaqs_Input>;
  appointments?: Maybe<RoleAppointments_Input>;
  otherAppointments?: Maybe<RoleOtherAppointments_Input>;
  oaktreeReferrals?: Maybe<RoleOakTreeReferral_Input>;
  selfReferrals?: Maybe<RoleSelfReferral_Input>;
  thirdPartyReferrals?: Maybe<RoleThirdParty_Input>;
  patientRecords?: Maybe<RolePatientRecords_Input>;
  patientRecordAppointments?: Maybe<RolePatientRecordAppointment_Input>;
  patientRecordOtherAppointments?: Maybe<RolePatientRecordOtherAppointment_Input>;
  patientRecordLetters?: Maybe<RolePatientRecordLetter_Input>;
  patientRecordFinancial?: Maybe<RolePatientRecordFinancial_Input>;
  patientRecordMedications?: Maybe<RolePatientRecordMedication_Input>;
  patientRecordTreatmentTherapy?: Maybe<RolePatientTreatmentTherapy_Input>;
  patientRecordSelfHelp?: Maybe<RolePatientSelfhelp_Input>;
  patientRecordQuestitionere?: Maybe<RolePatientQuestitionere_Input>;
  patientRecordSignPosting?: Maybe<RolePatientSignPosting_Input>;
  patientRecordThirdParty?: Maybe<RolePatientRecordThirdParty_Input>;
  patientRecordHealthParameters?: Maybe<RolePatientHealthParameters_Input>;
  patientCommunication?: Maybe<RolePatientComm_Input>;
  practitionerCommunication?: Maybe<RolePractComm_Input>;
  patientRecordCommunication?: Maybe<RolePatientRecordCommunicatoin_Input>;
  websiteCommunication?: Maybe<RoleWebsiteComm_Input>;
  organisationCommunication?: Maybe<RoleOrgComm_Input>;
  feedbackCommunication?: Maybe<RoleFeedbackComm_Input>;
  rolesPermissionsActions?: Maybe<RolePermissionsActions_Input>;
  reportsAnalytics?: Maybe<RoleReportsAnalytics_Input>;
  patientInvoices?: Maybe<RolePatientInvoice_Input>;
  practitionerStatements?: Maybe<RolePractitionerStatements_Input>;
  patientPendingInvoices?: Maybe<RolePatientPendingInvoice_Input>;
  userManagementPatient?: Maybe<RoleUserManagementPatient_Input>;
  userManagementPractitioner?: Maybe<RoleUserManagementPractitioner_Input>;
  userManagementUsers?: Maybe<RoleUserManagementUser_Input>;
  userManagementOrganisation?: Maybe<RoleOrganisationManagement_Input>;
  userManagementLinkedUsers?: Maybe<RoleUserManagementLinkedUser_Input>;
  userManagementAdminUsers?: Maybe<RoleAdminUsersManagement_Input>;
  pricing?: Maybe<RolePricing_Input>;
  appointmentReminder?: Maybe<RoleAppointmentReminder_Input>;
};

/** RolePermission */
export type RolesPermission_Schema = {
  __typename?: 'RolesPermission_Schema';
  /** Type of resource */
  resourceType: RolePermissions_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** Referral_Type. */
  name?: Maybe<Scalars['String']>;
  /** type. */
  roletype?: Maybe<Scalars['String']>;
  /** type. */
  roletypevalue?: Maybe<Scalars['String']>;
  /** type. */
  roletyperank?: Maybe<Scalars['Int']>;
  /** Referrer_Title. */
  description?: Maybe<Scalars['String']>;
  /** referral_createdOn */
  createdOn?: Maybe<Scalars['String']>;
  /** status. */
  status?: Maybe<Scalars['String']>;
  practitionerApproval?: Maybe<RolePractitionerApproval_Schema>;
  templateLetterNotes?: Maybe<RoleLetter_Schema>;
  templateQuestionnaire?: Maybe<RoleQuestitioner_Schema>;
  templateFaqs?: Maybe<RoleFaqs_Schema>;
  appointments?: Maybe<RoleAppointments_Schema>;
  otherAppointments?: Maybe<RoleOtherAppointments_Schema>;
  oaktreeReferrals?: Maybe<RoleOakTreeReferral_Schema>;
  selfReferrals?: Maybe<RoleSelfReferral_Schema>;
  thirdPartyReferrals?: Maybe<RoleThirdParty_Schema>;
  patientRecords?: Maybe<RolePatientRecords_Schema>;
  patientRecordAppointments?: Maybe<RolePatientRecordAppointment_Schema>;
  patientRecordOtherAppointments?: Maybe<RolePatientRecordOtherAppointment_Schema>;
  patientRecordLetters?: Maybe<RolePatientRecordLetter_Schema>;
  patientRecordFinancial?: Maybe<RolePatientRecordFinancial_Schema>;
  patientRecordMedications?: Maybe<RolePatientRecordMedication_Schema>;
  patientRecordTreatmentTherapy?: Maybe<RolePatientTreatmentTherapy_Schema>;
  patientRecordSelfHelp?: Maybe<RolePatientSelfhelp_Schema>;
  patientRecordQuestitionere?: Maybe<RolePatientQuestitionere_Schema>;
  patientRecordSignPosting?: Maybe<RolePatientSignPosting_Schema>;
  patientRecordThirdParty?: Maybe<RolePatientRecordThirdParty_Schema>;
  patientRecordHealthParameters?: Maybe<RolePatientHealthParameters_Schema>;
  patientRecordCommunication?: Maybe<RolePatientRecordCommunicatoin_Schema>;
  patientCommunication?: Maybe<RolePatientComm_Schema>;
  practitionerCommunication?: Maybe<RolePractComm_Schema>;
  websiteCommunication?: Maybe<RoleWebsiteComm_Schema>;
  organisationCommunication?: Maybe<RoleOrgComm_Schema>;
  feedbackCommunication?: Maybe<RoleFeedbackComm_Schema>;
  rolesPermissionsActions?: Maybe<RolePermissionsActions_Schema>;
  reportsAnalytics?: Maybe<RoleReportsAnalytics_Schema>;
  patientInvoices?: Maybe<RolePatientInvoice_Schema>;
  practitionerStatements?: Maybe<RolePractitionerStatements_Schema>;
  patientPendingInvoices?: Maybe<RolePatientPendingInvoice_Schema>;
  userManagementPatient?: Maybe<RoleUserManagementPatient_Schema>;
  userManagementPractitioner?: Maybe<RoleUserManagementPractitioner_Schema>;
  userManagementUsers?: Maybe<RoleUserManagementUser_Schema>;
  userManagementOrganisation?: Maybe<RoleOrganisationManagement_Schema>;
  userManagementLinkedUsers?: Maybe<RoleUserManagementLinkedUser_Schema>;
  userManagementAdminUsers?: Maybe<RoleAdminUsersManagement_Schema>;
  pricing?: Maybe<RolePricing_Schema>;
  appointmentReminder?: Maybe<RoleAppointmentReminder_Schema>;
};

/**
 * Base StructureDefinition for SampledData Type: A series of measurements taken by
 * a device, with upper and lower limits. There may be more than one dimension in the data.
 */
export type SampledData = {
  __typename?: 'SampledData';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The base quantity that a measured value of zero represents. In addition, this
   * provides the units of the entire measurement series.
   */
  origin: Quantity;
  /** The length of time between sampling times, measured in milliseconds. */
  _period?: Maybe<Element>;
  /** The length of time between sampling times, measured in milliseconds. */
  period: Scalars['Float'];
  /** A correction factor that is applied to the sampled data points before they are added to the origin. */
  _factor?: Maybe<Element>;
  /** A correction factor that is applied to the sampled data points before they are added to the origin. */
  factor?: Maybe<Scalars['Float']>;
  /**
   * The lower limit of detection of the measured points. This is needed if any of
   * the data points have the value 'L' (lower than detection limit).
   */
  _lowerLimit?: Maybe<Element>;
  /**
   * The lower limit of detection of the measured points. This is needed if any of
   * the data points have the value 'L' (lower than detection limit).
   */
  lowerLimit?: Maybe<Scalars['Float']>;
  /**
   * The upper limit of detection of the measured points. This is needed if any of
   * the data points have the value 'U' (higher than detection limit).
   */
  _upperLimit?: Maybe<Element>;
  /**
   * The upper limit of detection of the measured points. This is needed if any of
   * the data points have the value 'U' (higher than detection limit).
   */
  upperLimit?: Maybe<Scalars['Float']>;
  /**
   * The number of sample points at each time point. If this value is greater than
   * one, then the dimensions will be interlaced - all the sample points for a
   * point in time will be recorded at once.
   */
  _dimensions?: Maybe<Element>;
  /**
   * The number of sample points at each time point. If this value is greater than
   * one, then the dimensions will be interlaced - all the sample points for a
   * point in time will be recorded at once.
   */
  dimensions: Scalars['positiveInt'];
  /**
   * A series of data points which are decimal values separated by a single space
   * (character u20). The special values 'E' (error), 'L' (below detection limit)
   * and 'U' (above detection limit) can also be used in place of a decimal value.
   */
  _data?: Maybe<Element>;
  /**
   * A series of data points which are decimal values separated by a single space
   * (character u20). The special values 'E' (error), 'L' (below detection limit)
   * and 'U' (above detection limit) can also be used in place of a decimal value.
   */
  data?: Maybe<Scalars['String']>;
};

/**
 * Base StructureDefinition for SampledData Type: A series of measurements taken by
 * a device, with upper and lower limits. There may be more than one dimension in the data.
 */
export type SampledData_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * The base quantity that a measured value of zero represents. In addition, this
   * provides the units of the entire measurement series.
   */
  origin: Quantity_Input;
  /** The length of time between sampling times, measured in milliseconds. */
  _period?: Maybe<Element_Input>;
  /** The length of time between sampling times, measured in milliseconds. */
  period: Scalars['Float'];
  /** A correction factor that is applied to the sampled data points before they are added to the origin. */
  _factor?: Maybe<Element_Input>;
  /** A correction factor that is applied to the sampled data points before they are added to the origin. */
  factor?: Maybe<Scalars['Float']>;
  /**
   * The lower limit of detection of the measured points. This is needed if any of
   * the data points have the value 'L' (lower than detection limit).
   */
  _lowerLimit?: Maybe<Element_Input>;
  /**
   * The lower limit of detection of the measured points. This is needed if any of
   * the data points have the value 'L' (lower than detection limit).
   */
  lowerLimit?: Maybe<Scalars['Float']>;
  /**
   * The upper limit of detection of the measured points. This is needed if any of
   * the data points have the value 'U' (higher than detection limit).
   */
  _upperLimit?: Maybe<Element_Input>;
  /**
   * The upper limit of detection of the measured points. This is needed if any of
   * the data points have the value 'U' (higher than detection limit).
   */
  upperLimit?: Maybe<Scalars['Float']>;
  /**
   * The number of sample points at each time point. If this value is greater than
   * one, then the dimensions will be interlaced - all the sample points for a
   * point in time will be recorded at once.
   */
  _dimensions?: Maybe<Element_Input>;
  /**
   * The number of sample points at each time point. If this value is greater than
   * one, then the dimensions will be interlaced - all the sample points for a
   * point in time will be recorded at once.
   */
  dimensions: Scalars['positiveInt'];
  /**
   * A series of data points which are decimal values separated by a single space
   * (character u20). The special values 'E' (error), 'L' (below detection limit)
   * and 'U' (above detection limit) can also be used in place of a decimal value.
   */
  _data?: Maybe<Element_Input>;
  /**
   * A series of data points which are decimal values separated by a single space
   * (character u20). The special values 'E' (error), 'L' (below detection limit)
   * and 'U' (above detection limit) can also be used in place of a decimal value.
   */
  data?: Maybe<Scalars['String']>;
};

/** A container for slots of time that may be available for booking appointments. */
export type Schedule = {
  __typename?: 'Schedule';
  /** Type of resource */
  resourceType: Schedule_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** External Ids for this item. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Whether this schedule record is in active use or should not be used (such as was entered in error). */
  _active?: Maybe<Element>;
  /** Whether this schedule record is in active use or should not be used (such as was entered in error). */
  active?: Maybe<Scalars['Boolean']>;
  /** A broad categorization of the service that is to be performed during this appointment. */
  serviceCategory?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The specific service that is to be performed during this appointment. */
  serviceType?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The specialty of a practitioner that would be required to perform the service requested in this appointment. */
  specialty?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Slots that reference this schedule resource provide the availability details to these referenced resource(s). */
  actor?: Maybe<Array<Scheduleactor_Actor_Union>>;
  /**
   * The period of time that the slots that reference this Schedule resource cover
   * (even if none exist). These  cover the amount of time that an organization's
   * planning horizon; the interval for which they are currently accepting
   * appointments. This does not define a 'template' for planning outside these dates.
   */
  planningHorizon?: Maybe<Period>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  _comment?: Maybe<Element>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  comment?: Maybe<Scalars['String']>;
};

export enum Schedule_Enum_Input {
  Schedule = 'Schedule'
}

export enum Schedule_Enum_Schema {
  Schedule = 'Schedule'
}

/** A container for slots of time that may be available for booking appointments. */
export type Schedule_Input = {
  /** Type of resource */
  resourceType: Schedule_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** External Ids for this item. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /** Whether this schedule record is in active use or should not be used (such as was entered in error). */
  _active?: Maybe<Element_Input>;
  /** Whether this schedule record is in active use or should not be used (such as was entered in error). */
  active?: Maybe<Scalars['Boolean']>;
  /** A broad categorization of the service that is to be performed during this appointment. */
  serviceCategory?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The specific service that is to be performed during this appointment. */
  serviceType?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The specialty of a practitioner that would be required to perform the service requested in this appointment. */
  specialty?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Slots that reference this schedule resource provide the availability details to these referenced resource(s). */
  actor?: Maybe<Array<Scalars['String']>>;
  /**
   * The period of time that the slots that reference this Schedule resource cover
   * (even if none exist). These  cover the amount of time that an organization's
   * planning horizon; the interval for which they are currently accepting
   * appointments. This does not define a 'template' for planning outside these dates.
   */
  planningHorizon?: Maybe<Period_Input>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  _comment?: Maybe<Element_Input>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  comment?: Maybe<Scalars['String']>;
};

/** Slots that reference this schedule resource provide the availability details to these referenced resource(s). */
export type Scheduleactor_Actor_Union = Patient | Practitioner | PractitionerRole | RelatedPerson | Device | HealthcareService | Location;

/** A search parameter that defines a named search item that can be used to search/filter on a resource. */
export type SearchParameter = {
  __typename?: 'SearchParameter';
  /** Type of resource */
  resourceType: SearchParameter_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this search parameter when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this search parameter
   * is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the search parameter is stored on
   * different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this search parameter when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this search parameter
   * is (or will be) published. This URL can be the target of a canonical
   * reference. It SHALL remain the same when the search parameter is stored on
   * different servers.
   */
  url: Scalars['uri'];
  /**
   * The identifier that is used to identify this version of the search parameter
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the search parameter author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the search parameter
   * when it is referenced in a specification, model, design or instance. This is
   * an arbitrary value managed by the search parameter author and is not expected
   * to be globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if
   * a managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the search parameter. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the search parameter. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name: Scalars['String'];
  /**
   * Where this search parameter is originally defined. If a derivedFrom is
   * provided, then the details in the search parameter must be consistent with the
   * definition from which it is defined. i.e. the parameter should have the same
   * meaning, and (usually) the functionality should be a proper subset of the
   * underlying search parameter.
   */
  _derivedFrom?: Maybe<Element>;
  /**
   * Where this search parameter is originally defined. If a derivedFrom is
   * provided, then the details in the search parameter must be consistent with the
   * definition from which it is defined. i.e. the parameter should have the same
   * meaning, and (usually) the functionality should be a proper subset of the
   * underlying search parameter.
   */
  derivedFrom?: Maybe<Scalars['canonical']>;
  /** The status of this search parameter. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this search parameter. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this search parameter is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this search parameter is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the search parameter was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the search parameter changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the search parameter was published. The
   * date must change when the business version changes and it must change if the
   * status code changes. In addition, it should change when the substantive
   * content of the search parameter changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the search parameter. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the search parameter. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** And how it used. */
  _description?: Maybe<Element>;
  /** And how it used. */
  description: Scalars['String'];
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate search
   * parameter instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the search parameter is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this search parameter is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this search parameter is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /** The code used in the URL or the parameter name in a parameters resource for this search parameter. */
  _code?: Maybe<Element>;
  /** The code used in the URL or the parameter name in a parameters resource for this search parameter. */
  code: Scalars['code'];
  /** The base resource type(s) that this search parameter can be used against. */
  _base?: Maybe<Element>;
  /** The base resource type(s) that this search parameter can be used against. */
  base?: Maybe<Array<Scalars['code']>>;
  /** The type of value that a search parameter may contain, and how the content is interpreted. */
  _type?: Maybe<Element>;
  /** The type of value that a search parameter may contain, and how the content is interpreted. */
  type: Scalars['code'];
  /** A FHIRPath expression that returns a set of elements for the search parameter. */
  _expression?: Maybe<Element>;
  /** A FHIRPath expression that returns a set of elements for the search parameter. */
  expression?: Maybe<Scalars['String']>;
  /** An XPath expression that returns a set of elements for the search parameter. */
  _xpath?: Maybe<Element>;
  /** An XPath expression that returns a set of elements for the search parameter. */
  xpath?: Maybe<Scalars['String']>;
  /** How the search parameter relates to the set of elements returned by evaluating the xpath query. */
  _xpathUsage?: Maybe<Element>;
  /** How the search parameter relates to the set of elements returned by evaluating the xpath query. */
  xpathUsage?: Maybe<Scalars['code']>;
  /** Types of resource (if a resource is referenced). */
  _target?: Maybe<Element>;
  /** Types of resource (if a resource is referenced). */
  target?: Maybe<Array<Maybe<Scalars['code']>>>;
  /**
   * Whether multiple values are allowed for each time the parameter exists. Values
   * are separated by commas, and the parameter matches if any of the values match.
   */
  _multipleOr?: Maybe<Element>;
  /**
   * Whether multiple values are allowed for each time the parameter exists. Values
   * are separated by commas, and the parameter matches if any of the values match.
   */
  multipleOr?: Maybe<Scalars['Boolean']>;
  /**
   * Whether multiple parameters are allowed - e.g. more than one parameter with
   * the same name. The search matches if all the parameters match.
   */
  _multipleAnd?: Maybe<Element>;
  /**
   * Whether multiple parameters are allowed - e.g. more than one parameter with
   * the same name. The search matches if all the parameters match.
   */
  multipleAnd?: Maybe<Scalars['Boolean']>;
  /** Comparators supported for the search parameter. */
  _comparator?: Maybe<Element>;
  /** Comparators supported for the search parameter. */
  comparator?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** A modifier supported for the search parameter. */
  _modifier?: Maybe<Element>;
  /** A modifier supported for the search parameter. */
  modifier?: Maybe<Array<Maybe<Scalars['code']>>>;
  /**
   * Contains the names of any search parameters which may be chained to the
   * containing search parameter. Chained parameters may be added to search
   * parameters of type reference and specify that resources will only be returned
   * if they contain a reference to a resource which matches the chained parameter
   * value. Values for this field should be drawn from SearchParameter.code for a
   * parameter on the target resource type.
   */
  _chain?: Maybe<Element>;
  /**
   * Contains the names of any search parameters which may be chained to the
   * containing search parameter. Chained parameters may be added to search
   * parameters of type reference and specify that resources will only be returned
   * if they contain a reference to a resource which matches the chained parameter
   * value. Values for this field should be drawn from SearchParameter.code for a
   * parameter on the target resource type.
   */
  chain?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Used to define the parts of a composite search parameter. */
  component?: Maybe<Array<Maybe<SearchParametercomponent>>>;
};

export enum SearchParameter_Enum_Schema {
  SearchParameter = 'SearchParameter'
}

export type SearchParametercomponent = {
  __typename?: 'SearchParametercomponent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The definition of the search parameter that describes this part. */
  _definition?: Maybe<Element>;
  /** The definition of the search parameter that describes this part. */
  definition: Scalars['canonical'];
  /**
   * A sub-expression that defines how to extract values for this component from
   * the output of the main SearchParameter.expression.
   */
  _expression?: Maybe<Element>;
  /**
   * A sub-expression that defines how to extract values for this component from
   * the output of the main SearchParameter.expression.
   */
  expression: Scalars['String'];
};

/** A record of a request for service such as diagnostic investigations, treatments, or operations to be performed. */
export type ServiceRequest = {
  __typename?: 'ServiceRequest';
  /** Type of resource */
  resourceType: ServiceRequest_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifiers assigned to this order instance by the orderer and/or the receiver and/or order fulfiller. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this ServiceRequest.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this ServiceRequest.
   */
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this
   * ServiceRequest.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * The URL pointing to an externally maintained protocol, guideline, orderset or
   * other definition that is adhered to in whole or in part by this
   * ServiceRequest.
   */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /** Plan/proposal/order fulfilled by this request. */
  basedOn?: Maybe<Array<Maybe<ServiceRequestbasedOn_BasedOn_Union>>>;
  /** The request takes the place of the referenced completed or terminated request(s). */
  replaces?: Maybe<Array<Maybe<ServiceRequestreplaces_Replaces_Union>>>;
  /**
   * A shared identifier common to all service requests that were authorized more
   * or less simultaneously by a single author, representing the composite or group identifier.
   */
  requisition?: Maybe<Identifier>;
  /** The status of the order. */
  _status?: Maybe<Element>;
  /** The status of the order. */
  status: Scalars['code'];
  /** Whether the request is a proposal, plan, an original order or a reflex order. */
  _intent?: Maybe<Element>;
  /** Whether the request is a proposal, plan, an original order or a reflex order. */
  intent: Scalars['code'];
  /** A code that classifies the service for searching, sorting and display purposes (e.g. 'Surgical Procedure'). */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Indicates how quickly the ServiceRequest should be addressed with respect to other requests. */
  _priority?: Maybe<Element>;
  /** Indicates how quickly the ServiceRequest should be addressed with respect to other requests. */
  priority?: Maybe<Scalars['code']>;
  /** Set this to true if the record is saying that the service/procedure should NOT be performed. */
  _doNotPerform?: Maybe<Element>;
  /** Set this to true if the record is saying that the service/procedure should NOT be performed. */
  doNotPerform?: Maybe<Scalars['Boolean']>;
  /**
   * A code that identifies a particular service (i.e., procedure, diagnostic
   * investigation, or panel of investigations) that have been requested.
   */
  code?: Maybe<CodeableConcept>;
  /**
   * Additional details and instructions about the how the services are to be
   * delivered.   For example, and order for a urinary catheter may have an order
   * detail for an external or indwelling catheter, or an order for a bandage may
   * require additional instructions specifying how the bandage should be applied.
   */
  orderDetail?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * An amount of service being requested which can be a quantity ( for example
   * $1,500 home modification), a ratio ( for example, 20 half day visits per
   * month), or a range (2.0 to 1.8 Gy per fraction).
   */
  quantityQuantity?: Maybe<Quantity>;
  /**
   * An amount of service being requested which can be a quantity ( for example
   * $1,500 home modification), a ratio ( for example, 20 half day visits per
   * month), or a range (2.0 to 1.8 Gy per fraction).
   */
  quantityRatio?: Maybe<Ratio>;
  /**
   * An amount of service being requested which can be a quantity ( for example
   * $1,500 home modification), a ratio ( for example, 20 half day visits per
   * month), or a range (2.0 to 1.8 Gy per fraction).
   */
  quantityRange?: Maybe<Range>;
  /**
   * On whom or what the service is to be performed. This is usually a human
   * patient, but can also be requested on animals, groups of humans or animals,
   * devices such as dialysis machines, or even locations (typically for
   * environmental scans).
   */
  subject: ServiceRequestsubject_Subject_Union;
  /** An encounter that provides additional information about the healthcare context in which this request is made. */
  encounter?: Maybe<ServiceRequestencounter_Encounter_Union>;
  /** The date/time at which the requested service should occur. */
  _occurrenceDateTime?: Maybe<Element>;
  /** The date/time at which the requested service should occur. */
  occurrenceDateTime?: Maybe<Scalars['dateTime']>;
  /** The date/time at which the requested service should occur. */
  occurrencePeriod?: Maybe<Period>;
  /** The date/time at which the requested service should occur. */
  occurrenceTiming?: Maybe<Timing>;
  /**
   * If a CodeableConcept is present, it indicates the pre-condition for performing
   * the service.  For example 'pain', 'on flare-up', etc.
   */
  _asNeededBoolean?: Maybe<Element>;
  /**
   * If a CodeableConcept is present, it indicates the pre-condition for performing
   * the service.  For example 'pain', 'on flare-up', etc.
   */
  asNeededBoolean?: Maybe<Scalars['Boolean']>;
  /**
   * If a CodeableConcept is present, it indicates the pre-condition for performing
   * the service.  For example 'pain', 'on flare-up', etc.
   */
  asNeededCodeableConcept?: Maybe<CodeableConcept>;
  /** When the request transitioned to being actionable. */
  _authoredOn?: Maybe<Element>;
  /** When the request transitioned to being actionable. */
  authoredOn?: Maybe<Scalars['dateTime']>;
  /** The individual who initiated the request and has responsibility for its activation. */
  requester?: Maybe<ServiceRequestrequester_Requester_Union>;
  /** Desired type of performer for doing the requested service. */
  performerType?: Maybe<CodeableConcept>;
  /** The desired performer for doing the requested service.  For example, the surgeon, dermatopathologist, endoscopist, etc. */
  performer?: Maybe<Array<Maybe<ServiceRequestperformer_Performer_Union>>>;
  /**
   * The preferred location(s) where the procedure should actually happen in coded
   * or free text form. E.g. at home or nursing day care center.
   */
  locationCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * A reference to the the preferred location(s) where the procedure should
   * actually happen. E.g. at home or nursing day care center.
   */
  locationReference?: Maybe<Array<Maybe<ServiceRequestlocationReference_LocationReference_Union>>>;
  /**
   * An explanation or justification for why this service is being requested in
   * coded or textual form.   This is often for billing purposes.  May relate to
   * the resources referred to in `supportingInfo`.
   */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Indicates another resource that provides a justification for why this service
   * is being requested.   May relate to the resources referred to in
   * `supportingInfo`.
   */
  reasonReference?: Maybe<Array<Maybe<ServiceRequestreasonReference_ReasonReference_Union>>>;
  /**
   * Insurance plans, coverage extensions, pre-authorizations and/or
   * pre-determinations that may be needed for delivering the requested service.
   */
  insurance?: Maybe<Array<Maybe<ServiceRequestinsurance_Insurance_Union>>>;
  /**
   * Additional clinical information about the patient or specimen that may
   * influence the services or their interpretations.     This information includes
   * diagnosis, clinical findings and other observations.  In laboratory ordering
   * these are typically referred to as 'ask at order entry questions (AOEs)'.
   * This includes observations explicitly requested by the producer (filler) to
   * provide context or supporting information needed to complete the order. For
   * example,  reporting the amount of inspired oxygen for blood gas measurements.
   */
  supportingInfo?: Maybe<Array<Maybe<ServiceRequestsupportingInfo_SupportingInfo_Union>>>;
  /** One or more specimens that the laboratory procedure will use. */
  specimen?: Maybe<Array<Maybe<ServiceRequestspecimen_Specimen_Union>>>;
  /** Anatomic location where the procedure should be performed. This is the target site. */
  bodySite?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Any other notes and comments made about the service request. For example, internal billing notes. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Instructions in terms that are understood by the patient or consumer. */
  _patientInstruction?: Maybe<Element>;
  /** Instructions in terms that are understood by the patient or consumer. */
  patientInstruction?: Maybe<Scalars['String']>;
  /** Key events in the history of the request. */
  relevantHistory?: Maybe<Array<Maybe<ServiceRequestrelevantHistory_RelevantHistory_Union>>>;
};

export enum ServiceRequest_Enum_Schema {
  ServiceRequest = 'ServiceRequest'
}

/** Plan/proposal/order fulfilled by this request. */
export type ServiceRequestbasedOn_BasedOn_Union = CarePlan | ServiceRequest | MedicationRequest;

/** An encounter that provides additional information about the healthcare context in which this request is made. */
export type ServiceRequestencounter_Encounter_Union = Encounter;

/**
 * Insurance plans, coverage extensions, pre-authorizations and/or
 * pre-determinations that may be needed for delivering the requested service.
 */
export type ServiceRequestinsurance_Insurance_Union = Coverage | ClaimResponse;

/**
 * A reference to the the preferred location(s) where the procedure should actually
 * happen. E.g. at home or nursing day care center.
 */
export type ServiceRequestlocationReference_LocationReference_Union = Location;

/** The desired performer for doing the requested service.  For example, the surgeon, dermatopathologist, endoscopist, etc. */
export type ServiceRequestperformer_Performer_Union = Practitioner | PractitionerRole | Organization | CareTeam | HealthcareService | Patient | Device | RelatedPerson;

/**
 * Indicates another resource that provides a justification for why this service is
 * being requested.   May relate to the resources referred to in `supportingInfo`.
 */
export type ServiceRequestreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference;

/** Key events in the history of the request. */
export type ServiceRequestrelevantHistory_RelevantHistory_Union = Provenance;

/** The request takes the place of the referenced completed or terminated request(s). */
export type ServiceRequestreplaces_Replaces_Union = ServiceRequest;

/** The individual who initiated the request and has responsibility for its activation. */
export type ServiceRequestrequester_Requester_Union = Practitioner | PractitionerRole | Organization | Patient | RelatedPerson | Device;

/** One or more specimens that the laboratory procedure will use. */
export type ServiceRequestspecimen_Specimen_Union = Specimen;

/**
 * On whom or what the service is to be performed. This is usually a human patient,
 * but can also be requested on animals, groups of humans or animals, devices such
 * as dialysis machines, or even locations (typically for environmental scans).
 */
export type ServiceRequestsubject_Subject_Union = Patient | Group | Location | Device;

/**
 * Additional clinical information about the patient or specimen that may influence
 * the services or their interpretations.     This information includes diagnosis,
 * clinical findings and other observations.  In laboratory ordering these are
 * typically referred to as 'ask at order entry questions (AOEs)'.  This includes
 * observations explicitly requested by the producer (filler) to provide context or
 * supporting information needed to complete the order. For example,  reporting the
 * amount of inspired oxygen for blood gas measurements.
 */
export type ServiceRequestsupportingInfo_SupportingInfo_Union = Resource;

export enum SignPostingCategory_Enum_Input_Schema {
  SignPostingCategory = 'SignPostingCategory'
}

export enum SignPostingCategory_Enum_Schema {
  SignPostingCategory = 'SignPostingCategory'
}

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type SignPostingCategory_Input = {
  /** Type of resource */
  resourceType: SignPostingCategory_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** operationType field data. */
  categoryName?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Patient Extension Type: Custom Fields . */
export type SignPostingCategory_Schema = {
  __typename?: 'SignPostingCategory_Schema';
  /** Type of resource */
  resourceType: SignPostingCategory_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** operationType field data. */
  categoryName?: Maybe<Scalars['String']>;
};

export enum SignPosting_Enum_Input_Schema {
  SignPosting = 'SignPosting'
}

export enum SignPosting_Enum_Schema {
  SignPosting = 'SignPosting'
}

/** Base StructureDefinition for Patient Extension Input Type: Custom Fields . */
export type SignPosting_Input = {
  /** Type of resource */
  resourceType: SignPosting_Enum_Input_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** operationType field data. */
  sentOn?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerName?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** operationType field data. */
  organizationName?: Maybe<Scalars['String']>;
  /** appointment Created */
  services?: Maybe<Scalars['String']>;
  /** operationType field data. */
  organizationEmail?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationPhoneNo?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationWebsite?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationLogoUrl?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationImageUrl?: Maybe<Scalars['String']>;
  /** organizationCategory Created */
  organizationCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** organizationCategory Created */
  organizationSearchtag?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** organizationCategory Created */
  organizationDescription?: Maybe<Scalars['String']>;
  /** organizationCategory Created */
  uploadedBy?: Maybe<Scalars['String']>;
  /** organizationCategory Created */
  uploadedDate?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationId?: Maybe<Scalars['String']>;
  /** appointment Created */
  reason?: Maybe<Scalars['String']>;
  /** Signposting Created */
  uploadedUserName?: Maybe<Scalars['String']>;
  /** Shared Leaflet count */
  documentSharedCount?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for Patient Extension Type: Custom Fields . */
export type SignPosting_Schema = {
  __typename?: 'SignPosting_Schema';
  /** Type of resource */
  resourceType: SignPosting_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** operationType field data. */
  sentOn?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerName?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerId?: Maybe<Scalars['String']>;
  /** operationType field data. */
  practitionerSpeciality?: Maybe<Scalars['String']>;
  /** operationType field data. */
  organizationName?: Maybe<Scalars['String']>;
  /** appointment Created */
  services?: Maybe<Scalars['String']>;
  /** operationType field data. */
  organizationEmail?: Maybe<Scalars['String']>;
  /** appointment Created */
  organizationPhoneNo?: Maybe<Scalars['String']>;
  /** organizationWebsite Created */
  organizationWebsite?: Maybe<Scalars['String']>;
  /** organizationLogoUrl Created */
  organizationLogoUrl?: Maybe<Scalars['String']>;
  /** organizationImageUrl Created */
  organizationImageUrl?: Maybe<Scalars['String']>;
  /** organizationCategory Created */
  organizationCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** organizationCategory Created */
  organizationSearchtag?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** organizationCategory Created */
  organizationDescription?: Maybe<Scalars['String']>;
  /** organizationCategory Created */
  uploadedBy?: Maybe<Scalars['String']>;
  /** organizationCategory Created */
  uploadedDate?: Maybe<Scalars['String']>;
  /** organizationId Created */
  organizationId?: Maybe<Scalars['String']>;
  /** Signposting count */
  count?: Maybe<Scalars['Int']>;
  /** Signposting Created */
  uploadedUserName?: Maybe<Scalars['String']>;
  /** Signposting shared */
  sendById?: Maybe<Scalars['String']>;
  /** Signposting shared */
  sendByName?: Maybe<Scalars['String']>;
  /** Signposting shared */
  sendDate?: Maybe<Scalars['String']>;
  /** Signposting shared */
  patientId?: Maybe<Scalars['String']>;
  /** Shared Signposting count */
  documentSharedCount?: Maybe<Scalars['Int']>;
  /** Shared Signposting Details */
  documentSharedDetails?: Maybe<Scalars['String']>;
  /** Sort by most shared */
  orderByMostShare?: Maybe<Scalars['Boolean']>;
};

/**
 * Base StructureDefinition for Signature Type: A signature along with supporting
 * context. The signature may be a digital signature that is cryptographic in
 * nature, or some other signature acceptable to the domain. This other signature
 * may be as simple as a graphical image representing a hand-written signature, or
 * a signature ceremony Different signature approaches have different utilities.
 */
export type Signature = {
  __typename?: 'Signature';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An indication of the reason that the entity signed this document. This may be
   * explicitly included as part of the signature information and can be used when
   * determining accountability for various actions concerning the document.
   */
  type?: Maybe<Array<Coding>>;
  /** When the digital signature was signed. */
  _when?: Maybe<Element>;
  /** When the digital signature was signed. */
  when: Scalars['instant'];
  /** A reference to an application-usable description of the identity that signed  (e.g. the signature used their private key). */
  who: Signaturewho_Who_Union;
  /** A reference to an application-usable description of the identity that is represented by the signature. */
  onBehalfOf?: Maybe<SignatureonBehalfOf_OnBehalfOf_Union>;
  /** A mime type that indicates the technical format of the target resources signed by the signature. */
  _targetFormat?: Maybe<Element>;
  /** A mime type that indicates the technical format of the target resources signed by the signature. */
  targetFormat?: Maybe<Scalars['code']>;
  /**
   * A mime type that indicates the technical format of the signature. Important
   * mime types are application/signature+xml for X ML DigSig, application/jose for
   * JWS, and image/* for a graphical image of a signature, etc.
   */
  _sigFormat?: Maybe<Element>;
  /**
   * A mime type that indicates the technical format of the signature. Important
   * mime types are application/signature+xml for X ML DigSig, application/jose for
   * JWS, and image/* for a graphical image of a signature, etc.
   */
  sigFormat?: Maybe<Scalars['code']>;
  /** The base64 encoding of the Signature content. When signature is not recorded electronically this element would be empty. */
  _data?: Maybe<Element>;
  /** The base64 encoding of the Signature content. When signature is not recorded electronically this element would be empty. */
  data?: Maybe<Scalars['base64Binary']>;
};

/**
 * Base StructureDefinition for Signature Type: A signature along with supporting
 * context. The signature may be a digital signature that is cryptographic in
 * nature, or some other signature acceptable to the domain. This other signature
 * may be as simple as a graphical image representing a hand-written signature, or
 * a signature ceremony Different signature approaches have different utilities.
 */
export type Signature_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * An indication of the reason that the entity signed this document. This may be
   * explicitly included as part of the signature information and can be used when
   * determining accountability for various actions concerning the document.
   */
  type?: Maybe<Array<Coding_Input>>;
  /** When the digital signature was signed. */
  _when?: Maybe<Element_Input>;
  /** When the digital signature was signed. */
  when: Scalars['instant'];
  /** A reference to an application-usable description of the identity that signed  (e.g. the signature used their private key). */
  who: Scalars['String'];
  /** A reference to an application-usable description of the identity that is represented by the signature. */
  onBehalfOf?: Maybe<Scalars['String']>;
  /** A mime type that indicates the technical format of the target resources signed by the signature. */
  _targetFormat?: Maybe<Element_Input>;
  /** A mime type that indicates the technical format of the target resources signed by the signature. */
  targetFormat?: Maybe<Scalars['code']>;
  /**
   * A mime type that indicates the technical format of the signature. Important
   * mime types are application/signature+xml for X ML DigSig, application/jose for
   * JWS, and image/* for a graphical image of a signature, etc.
   */
  _sigFormat?: Maybe<Element_Input>;
  /**
   * A mime type that indicates the technical format of the signature. Important
   * mime types are application/signature+xml for X ML DigSig, application/jose for
   * JWS, and image/* for a graphical image of a signature, etc.
   */
  sigFormat?: Maybe<Scalars['code']>;
  /** The base64 encoding of the Signature content. When signature is not recorded electronically this element would be empty. */
  _data?: Maybe<Element_Input>;
  /** The base64 encoding of the Signature content. When signature is not recorded electronically this element would be empty. */
  data?: Maybe<Scalars['base64Binary']>;
};

/** A reference to an application-usable description of the identity that is represented by the signature. */
export type SignatureonBehalfOf_OnBehalfOf_Union = Practitioner | PractitionerRole | RelatedPerson | Patient | Device | Organization;

/** A reference to an application-usable description of the identity that signed  (e.g. the signature used their private key). */
export type Signaturewho_Who_Union = Practitioner | PractitionerRole | RelatedPerson | Patient | Device | Organization;

/** A slot of time on a schedule that may be available for booking appointments. */
export type Slot = {
  __typename?: 'Slot';
  /** Type of resource */
  resourceType: Slot_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** slotExtension. */
  slotExtension?: Maybe<Slot_Extension>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** External Ids for this item. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A broad categorization of the service that is to be performed during this appointment. */
  serviceCategory?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * The type of appointments that can be booked into this slot (ideally this would
   * be an identifiable service - which is at a location, rather than the location
   * itself). If provided then this overrides the value provided on the
   * availability resource.
   */
  serviceType?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The specialty of a practitioner that would be required to perform the service requested in this appointment. */
  specialty?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The style of appointment or patient that may be booked in the slot (not service type). */
  appointmentType?: Maybe<CodeableConcept>;
  /** The schedule resource that this slot defines an interval of status information. */
  schedule: Slotschedule_Schedule_Union;
  /** busy | free | busy-unavailable | busy-tentative | entered-in-error. */
  _status?: Maybe<Element>;
  /** busy | free | busy-unavailable | busy-tentative | entered-in-error. */
  status: Scalars['code'];
  /** Date/Time that the slot is to begin. */
  _start?: Maybe<Element>;
  /** Date/Time that the slot is to begin. */
  start: Scalars['instant'];
  /** Date/Time that the slot is to conclude. */
  _end?: Maybe<Element>;
  /** Date/Time that the slot is to conclude. */
  end: Scalars['instant'];
  /** This slot has already been overbooked, appointments are unlikely to be accepted for this time. */
  _overbooked?: Maybe<Element>;
  /** This slot has already been overbooked, appointments are unlikely to be accepted for this time. */
  overbooked?: Maybe<Scalars['Boolean']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  _comment?: Maybe<Element>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  comment?: Maybe<Scalars['String']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  slotDate?: Maybe<Scalars['String']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  professionalId?: Maybe<Scalars['String']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  appointmentDuration?: Maybe<Scalars['Int']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  appointmentMode?: Maybe<Scalars['String']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** Base StructureDefinition for SlotExtension_Input */
export type SlotExtension_Input = {
  /** managingPractitioner. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** managingPatient data. */
  managingPatient?: Maybe<Scalars['String']>;
  /** practitionerName field data. */
  practitionerName?: Maybe<Scalars['String']>;
  /** patientName field data. */
  patientName?: Maybe<Scalars['String']>;
  /** bookedOn field data. */
  bookedOn?: Maybe<Scalars['String']>;
};

export enum Slot_Enum_Input {
  Slot = 'Slot'
}

export enum Slot_Enum_Schema {
  Slot = 'Slot'
}

/** Base StructureDefinition for Slot Extension */
export type Slot_Extension = {
  __typename?: 'Slot_Extension';
  /** about data. */
  managingPractitioner?: Maybe<Scalars['String']>;
  /** personalStatement data. */
  managingPatient?: Maybe<Scalars['String']>;
  /** practitionerName field data. */
  practitionerName?: Maybe<Scalars['String']>;
  /** patientName field data. */
  patientName?: Maybe<Scalars['String']>;
  /** bookedOn field data. */
  bookedOn?: Maybe<Scalars['String']>;
};

/** A slot of time on a schedule that may be available for booking appointments. */
export type Slot_Input = {
  /** Type of resource */
  resourceType: Slot_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** slotExtension. */
  slotExtension?: Maybe<SlotExtension_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** External Ids for this item. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /** A broad categorization of the service that is to be performed during this appointment. */
  serviceCategory?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /**
   * The type of appointments that can be booked into this slot (ideally this would
   * be an identifiable service - which is at a location, rather than the location
   * itself). If provided then this overrides the value provided on the
   * availability resource.
   */
  serviceType?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The specialty of a practitioner that would be required to perform the service requested in this appointment. */
  specialty?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** The style of appointment or patient that may be booked in the slot (not service type). */
  appointmentType?: Maybe<CodeableConcept_Input>;
  /** The schedule resource that this slot defines an interval of status information. */
  schedule: Scalars['String'];
  /** busy | free | busy-unavailable | busy-tentative | entered-in-error. */
  _status?: Maybe<Element_Input>;
  /** busy | free | busy-unavailable | busy-tentative | entered-in-error. */
  status: Scalars['code'];
  /** Date/Time that the slot is to begin. */
  _start?: Maybe<Element_Input>;
  /** Date/Time that the slot is to begin. */
  start: Scalars['instant'];
  /** Date/Time that the slot is to conclude. */
  _end?: Maybe<Element_Input>;
  /** Date/Time that the slot is to conclude. */
  end: Scalars['instant'];
  /** This slot has already been overbooked, appointments are unlikely to be accepted for this time. */
  _overbooked?: Maybe<Element_Input>;
  /** This slot has already been overbooked, appointments are unlikely to be accepted for this time. */
  overbooked?: Maybe<Scalars['Boolean']>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  _comment?: Maybe<Element_Input>;
  /** Comments on the slot to describe any extended information. Such as custom constraints on the slot. */
  comment?: Maybe<Scalars['String']>;
};

/** The schedule resource that this slot defines an interval of status information. */
export type Slotschedule_Schedule_Union = Schedule;

/** A sample to be used for analysis. */
export type Specimen = {
  __typename?: 'Specimen';
  /** Type of resource */
  resourceType: Specimen_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Id for specimen. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier assigned by the lab when accessioning specimen(s). This is not
   * necessarily the same as the specimen identifier, depending on local lab procedures.
   */
  accessionIdentifier?: Maybe<Identifier>;
  /** The availability of the specimen. */
  _status?: Maybe<Element>;
  /** The availability of the specimen. */
  status?: Maybe<Scalars['code']>;
  /** The kind of material that forms the specimen. */
  type?: Maybe<CodeableConcept>;
  /**
   * Where the specimen came from. This may be from patient(s), from a location
   * (e.g., the source of an environmental sample), or a sampling of a substance or a device.
   */
  subject?: Maybe<Specimensubject_Subject_Union>;
  /** Time when specimen was received for processing or testing. */
  _receivedTime?: Maybe<Element>;
  /** Time when specimen was received for processing or testing. */
  receivedTime?: Maybe<Scalars['dateTime']>;
  /**
   * Reference to the parent (source) specimen which is used when the specimen was
   * either derived from or a component of another specimen.
   */
  parent?: Maybe<Array<Maybe<Specimenparent_Parent_Union>>>;
  /** Details concerning a service request that required a specimen to be collected. */
  request?: Maybe<Array<Maybe<Specimenrequest_Request_Union>>>;
  /** Details concerning the specimen collection. */
  collection?: Maybe<Specimencollection>;
  /** Details concerning processing and processing steps for the specimen. */
  processing?: Maybe<Array<Maybe<Specimenprocessing>>>;
  /**
   * The container holding the specimen.  The recursive nature of containers; i.e.
   * blood in tube in tray in rack is not addressed here.
   */
  container?: Maybe<Array<Maybe<Specimencontainer>>>;
  /** A mode or state of being that describes the nature of the specimen. */
  condition?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * To communicate any details or issues about the specimen or during the specimen
   * collection. (for example: broken vial, sent with patient, frozen).
   */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

/** A kind of specimen with associated set of requirements. */
export type SpecimenDefinition = {
  __typename?: 'SpecimenDefinition';
  /** Type of resource */
  resourceType: SpecimenDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A business identifier associated with the kind of specimen. */
  identifier?: Maybe<Identifier>;
  /** The kind of material to be collected. */
  typeCollected?: Maybe<CodeableConcept>;
  /** Preparation of the patient for specimen collection. */
  patientPreparation?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Time aspect of specimen collection (duration or offset). */
  _timeAspect?: Maybe<Element>;
  /** Time aspect of specimen collection (duration or offset). */
  timeAspect?: Maybe<Scalars['String']>;
  /** The action to be performed for collecting the specimen. */
  collection?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Specimen conditioned in a container as expected by the testing laboratory. */
  typeTested?: Maybe<Array<Maybe<SpecimenDefinitiontypeTested>>>;
};

export enum SpecimenDefinition_Enum_Schema {
  SpecimenDefinition = 'SpecimenDefinition'
}

export type SpecimenDefinitiontypeTested = {
  __typename?: 'SpecimenDefinitiontypeTested';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Primary of secondary specimen. */
  _isDerived?: Maybe<Element>;
  /** Primary of secondary specimen. */
  isDerived?: Maybe<Scalars['Boolean']>;
  /** The kind of specimen conditioned for testing expected by lab. */
  type?: Maybe<CodeableConcept>;
  /** The preference for this type of conditioned specimen. */
  _preference?: Maybe<Element>;
  /** The preference for this type of conditioned specimen. */
  preference: Scalars['code'];
  /** The specimen's container. */
  container?: Maybe<SpecimenDefinitiontypeTestedcontainer>;
  /** Requirements for delivery and special handling of this kind of conditioned specimen. */
  _requirement?: Maybe<Element>;
  /** Requirements for delivery and special handling of this kind of conditioned specimen. */
  requirement?: Maybe<Scalars['String']>;
  /**
   * The usual time that a specimen of this kind is retained after the ordered
   * tests are completed, for the purpose of additional testing.
   */
  retentionTime?: Maybe<Duration>;
  /** Criterion for rejection of the specimen in its container by the laboratory. */
  rejectionCriterion?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * Set of instructions for preservation/transport of the specimen at a defined
   * temperature interval, prior the testing process.
   */
  handling?: Maybe<Array<Maybe<SpecimenDefinitiontypeTestedhandling>>>;
};

export type SpecimenDefinitiontypeTestedcontainer = {
  __typename?: 'SpecimenDefinitiontypeTestedcontainer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of material of the container. */
  material?: Maybe<CodeableConcept>;
  /** The type of container used to contain this kind of specimen. */
  type?: Maybe<CodeableConcept>;
  /** Color of container cap. */
  cap?: Maybe<CodeableConcept>;
  /** The textual description of the kind of container. */
  _description?: Maybe<Element>;
  /** The textual description of the kind of container. */
  description?: Maybe<Scalars['String']>;
  /** The capacity (volume or other measure) of this kind of container. */
  capacity?: Maybe<Quantity>;
  /** The minimum volume to be conditioned in the container. */
  minimumVolumeQuantity?: Maybe<Quantity>;
  /** The minimum volume to be conditioned in the container. */
  _minimumVolumeString?: Maybe<Element>;
  /** The minimum volume to be conditioned in the container. */
  minimumVolumeString?: Maybe<Scalars['String']>;
  /**
   * Substance introduced in the kind of container to preserve, maintain or enhance
   * the specimen. Examples: Formalin, Citrate, EDTA.
   */
  additive?: Maybe<Array<Maybe<SpecimenDefinitiontypeTestedcontaineradditive>>>;
  /** Special processing that should be applied to the container for this kind of specimen. */
  _preparation?: Maybe<Element>;
  /** Special processing that should be applied to the container for this kind of specimen. */
  preparation?: Maybe<Scalars['String']>;
};

export type SpecimenDefinitiontypeTestedcontaineradditive = {
  __typename?: 'SpecimenDefinitiontypeTestedcontaineradditive';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Substance introduced in the kind of container to preserve, maintain or enhance
   * the specimen. Examples: Formalin, Citrate, EDTA.
   */
  additiveCodeableConcept: CodeableConcept;
  /**
   * Substance introduced in the kind of container to preserve, maintain or enhance
   * the specimen. Examples: Formalin, Citrate, EDTA.
   */
  additiveReference: SpecimenDefinitiontypeTestedcontaineradditiveadditiveReference_AdditiveReference_Union;
};

/**
 * Substance introduced in the kind of container to preserve, maintain or enhance
 * the specimen. Examples: Formalin, Citrate, EDTA.
 */
export type SpecimenDefinitiontypeTestedcontaineradditiveadditiveReference_AdditiveReference_Union = Substance;

export type SpecimenDefinitiontypeTestedhandling = {
  __typename?: 'SpecimenDefinitiontypeTestedhandling';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * It qualifies the interval of temperature, which characterizes an occurrence of
   * handling. Conditions that are not related to temperature may be handled in the
   * instruction element.
   */
  temperatureQualifier?: Maybe<CodeableConcept>;
  /** The temperature interval for this set of handling instructions. */
  temperatureRange?: Maybe<Range>;
  /** The maximum time interval of preservation of the specimen with these conditions. */
  maxDuration?: Maybe<Duration>;
  /**
   * Additional textual instructions for the preservation or transport of the
   * specimen. For instance, 'Protect from light exposure'.
   */
  _instruction?: Maybe<Element>;
  /**
   * Additional textual instructions for the preservation or transport of the
   * specimen. For instance, 'Protect from light exposure'.
   */
  instruction?: Maybe<Scalars['String']>;
};

export enum Specimen_Enum_Schema {
  Specimen = 'Specimen'
}

export type Specimencollection = {
  __typename?: 'Specimencollection';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Person who collected the specimen. */
  collector?: Maybe<Specimencollectioncollector_Collector_Union>;
  /** Time when specimen was collected from subject - the physiologically relevant time. */
  _collectedDateTime?: Maybe<Element>;
  /** Time when specimen was collected from subject - the physiologically relevant time. */
  collectedDateTime?: Maybe<Scalars['dateTime']>;
  /** Time when specimen was collected from subject - the physiologically relevant time. */
  collectedPeriod?: Maybe<Period>;
  /** The span of time over which the collection of a specimen occurred. */
  duration?: Maybe<Duration>;
  /**
   * The quantity of specimen collected; for instance the volume of a blood sample,
   * or the physical measurement of an anatomic pathology sample.
   */
  quantity?: Maybe<Quantity>;
  /** A coded value specifying the technique that is used to perform the procedure. */
  method?: Maybe<CodeableConcept>;
  /**
   * Anatomical location from which the specimen was collected (if subject is a
   * patient). This is the target site.  This element is not used for environmental specimens.
   */
  bodySite?: Maybe<CodeableConcept>;
  /** Abstinence or reduction from some or all food, drink, or both, for a period of time prior to sample collection. */
  fastingStatusCodeableConcept?: Maybe<CodeableConcept>;
  /** Abstinence or reduction from some or all food, drink, or both, for a period of time prior to sample collection. */
  fastingStatusDuration?: Maybe<Duration>;
};

/** Person who collected the specimen. */
export type Specimencollectioncollector_Collector_Union = Practitioner | PractitionerRole;

export type Specimencontainer = {
  __typename?: 'Specimencontainer';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Id for container. There may be multiple; a manufacturer's bar code, lab
   * assigned identifier, etc. The container ID may differ from the specimen id in
   * some circumstances.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Textual description of the container. */
  _description?: Maybe<Element>;
  /** Textual description of the container. */
  description?: Maybe<Scalars['String']>;
  /** The type of container associated with the specimen (e.g. slide, aliquot, etc.). */
  type?: Maybe<CodeableConcept>;
  /** The capacity (volume or other measure) the container may contain. */
  capacity?: Maybe<Quantity>;
  /**
   * The quantity of specimen in the container; may be volume, dimensions, or other
   * appropriate measurements, depending on the specimen type.
   */
  specimenQuantity?: Maybe<Quantity>;
  /** Introduced substance to preserve, maintain or enhance the specimen. Examples: Formalin, Citrate, EDTA. */
  additiveCodeableConcept?: Maybe<CodeableConcept>;
  /** Introduced substance to preserve, maintain or enhance the specimen. Examples: Formalin, Citrate, EDTA. */
  additiveReference?: Maybe<SpecimencontaineradditiveReference_AdditiveReference_Union>;
};

/** Introduced substance to preserve, maintain or enhance the specimen. Examples: Formalin, Citrate, EDTA. */
export type SpecimencontaineradditiveReference_AdditiveReference_Union = Substance;

/**
 * Reference to the parent (source) specimen which is used when the specimen was
 * either derived from or a component of another specimen.
 */
export type Specimenparent_Parent_Union = Specimen;

export type Specimenprocessing = {
  __typename?: 'Specimenprocessing';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Textual description of procedure. */
  _description?: Maybe<Element>;
  /** Textual description of procedure. */
  description?: Maybe<Scalars['String']>;
  /** A coded value specifying the procedure used to process the specimen. */
  procedure?: Maybe<CodeableConcept>;
  /** Material used in the processing step. */
  additive?: Maybe<Array<Maybe<Specimenprocessingadditive_Additive_Union>>>;
  /**
   * A record of the time or period when the specimen processing occurred.  For
   * example the time of sample fixation or the period of time the sample was in formalin.
   */
  _timeDateTime?: Maybe<Element>;
  /**
   * A record of the time or period when the specimen processing occurred.  For
   * example the time of sample fixation or the period of time the sample was in formalin.
   */
  timeDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * A record of the time or period when the specimen processing occurred.  For
   * example the time of sample fixation or the period of time the sample was in formalin.
   */
  timePeriod?: Maybe<Period>;
};

/** Material used in the processing step. */
export type Specimenprocessingadditive_Additive_Union = Substance;

/** Details concerning a service request that required a specimen to be collected. */
export type Specimenrequest_Request_Union = ServiceRequest;

/**
 * Where the specimen came from. This may be from patient(s), from a location
 * (e.g., the source of an environmental sample), or a sampling of a substance or a device.
 */
export type Specimensubject_Subject_Union = Patient | Group | Device | Substance | Location;

/** A container for slots of time that may be available for booking appointments. */
export type StripePayment = {
  __typename?: 'StripePayment';
  /** Type of resource */
  resourceType: Stripe_Payment_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  metaData?: Maybe<MetaData>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  status?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  customer_email?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  client_secret?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  sessionStatus?: Maybe<Scalars['Boolean']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  session_id?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  amount?: Maybe<Scalars['Int']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  customerEmail?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentDescription?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentImages?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  baseUrl?: Maybe<Scalars['String']>;
};

export enum Stripe_Payment_Enum_Input {
  StripePayment = 'StripePayment'
}

export enum Stripe_Payment_Enum_Schema {
  Schedule = 'Schedule'
}

/** A container for slots of time that may be available for booking appointments. */
export type Stripe_Payment_Input = {
  /** Type of resource */
  resourceType: Stripe_Payment_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  metaData?: Maybe<Meta_Data_Input>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  amount?: Maybe<Scalars['Int']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  status?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  customer_email?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  sessionStatus?: Maybe<Scalars['Boolean']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  session_id?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentName?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  customerEmail?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentDescription?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  appointmentImages?: Maybe<Scalars['String']>;
  /**
   * Comments on the availability to describe any extended information. Such as
   * custom constraints on the slots that may be associated.
   */
  baseUrl?: Maybe<Scalars['String']>;
};

/**
 * A definition of a FHIR structure. This resource is used to describe the
 * underlying resources, data types defined in FHIR, and also for describing
 * extensions and constraints on resources and data types.
 */
export type StructureDefinition = {
  __typename?: 'StructureDefinition';
  /** Type of resource */
  resourceType: StructureDefinition_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this structure definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this structure
   * definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the structure definition is
   * stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this structure definition when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this structure
   * definition is (or will be) published. This URL can be the target of a
   * canonical reference. It SHALL remain the same when the structure definition is
   * stored on different servers.
   */
  url: Scalars['uri'];
  /**
   * A formal identifier that is used to identify this structure definition when it
   * is represented in other formats, or referenced in a specification, model,
   * design or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the structure
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the structure definition
   * author and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the structure
   * definition when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the structure definition
   * author and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the structure definition. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the structure definition. This name should
   * be usable as an identifier for the module by machine processing applications
   * such as code generation.
   */
  name: Scalars['String'];
  /** A short, descriptive, user-friendly title for the structure definition. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the structure definition. */
  title?: Maybe<Scalars['String']>;
  /** The status of this structure definition. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this structure definition. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this structure definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this structure definition is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the structure definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the structure definition changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the structure definition was published.
   * The date must change when the business version changes and it must change if
   * the status code changes. In addition, it should change when the substantive
   * content of the structure definition changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the structure definition. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the structure definition. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the structure definition from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the structure definition from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate structure
   * definition instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the structure definition is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this structure definition is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this structure definition is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the structure definition and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the structure definition.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the structure definition and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the structure definition.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * A set of key words or terms from external terminologies that may be used to
   * assist with indexing and searching of templates nby describing the use of this
   * structure definition, or the content it describes.
   */
  keyword?: Maybe<Array<Maybe<Coding>>>;
  /**
   * The version of the FHIR specification on which this StructureDefinition is
   * based - this is the formal version of the specification, without the revision
   * number, e.g. [publication].[major].[minor], which is 4.0.0. for this version.
   */
  _fhirVersion?: Maybe<Element>;
  /**
   * The version of the FHIR specification on which this StructureDefinition is
   * based - this is the formal version of the specification, without the revision
   * number, e.g. [publication].[major].[minor], which is 4.0.0. for this version.
   */
  fhirVersion?: Maybe<Scalars['code']>;
  /** An external specification that the content is mapped to. */
  mapping?: Maybe<Array<Maybe<StructureDefinitionmapping>>>;
  /** Defines the kind of structure that this definition is describing. */
  _kind?: Maybe<Element>;
  /** Defines the kind of structure that this definition is describing. */
  kind: Scalars['code'];
  /**
   * Whether structure this definition describes is abstract or not  - that is,
   * whether the structure is not intended to be instantiated. For Resources and
   * Data types, abstract types will never be exchanged  between systems.
   */
  _abstract?: Maybe<Element>;
  /**
   * Whether structure this definition describes is abstract or not  - that is,
   * whether the structure is not intended to be instantiated. For Resources and
   * Data types, abstract types will never be exchanged  between systems.
   */
  abstract: Scalars['Boolean'];
  /** Identifies the types of resource or data type elements to which the extension can be applied. */
  context?: Maybe<Array<Maybe<StructureDefinitioncontext>>>;
  /**
   * A set of rules as FHIRPath Invariants about when the extension can be used
   * (e.g. co-occurrence variants for the extension). All the rules must be true.
   */
  _contextInvariant?: Maybe<Element>;
  /**
   * A set of rules as FHIRPath Invariants about when the extension can be used
   * (e.g. co-occurrence variants for the extension). All the rules must be true.
   */
  contextInvariant?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The type this structure describes. If the derivation kind is 'specialization'
   * then this is the master definition for a type, and there is always one of
   * these (a data type, an extension, a resource, including abstract ones).
   * Otherwise the structure definition is a constraint on the stated type (and in
   * this case, the type cannot be an abstract type).  References are URLs that are
   * relative to http://hl7.org/fhir/StructureDefinition e.g. 'string' is a
   * reference to http://hl7.org/fhir/StructureDefinition/string. Absolute URLs are
   * only allowed in logical models.
   */
  _type?: Maybe<Element>;
  /**
   * The type this structure describes. If the derivation kind is 'specialization'
   * then this is the master definition for a type, and there is always one of
   * these (a data type, an extension, a resource, including abstract ones).
   * Otherwise the structure definition is a constraint on the stated type (and in
   * this case, the type cannot be an abstract type).  References are URLs that are
   * relative to http://hl7.org/fhir/StructureDefinition e.g. 'string' is a
   * reference to http://hl7.org/fhir/StructureDefinition/string. Absolute URLs are
   * only allowed in logical models.
   */
  type: Scalars['uri'];
  /** An absolute URI that is the base structure from which this type is derived, either by specialization or constraint. */
  _baseDefinition?: Maybe<Element>;
  /** An absolute URI that is the base structure from which this type is derived, either by specialization or constraint. */
  baseDefinition?: Maybe<Scalars['canonical']>;
  /** How the type relates to the baseDefinition. */
  _derivation?: Maybe<Element>;
  /** How the type relates to the baseDefinition. */
  derivation?: Maybe<Scalars['code']>;
  /**
   * A snapshot view is expressed in a standalone form that can be used and
   * interpreted without considering the base StructureDefinition.
   */
  snapshot?: Maybe<StructureDefinitionsnapshot>;
  /** A differential view is expressed relative to the base StructureDefinition - a statement of differences that it applies. */
  differential?: Maybe<StructureDefinitiondifferential>;
};

export enum StructureDefinition_Enum_Schema {
  StructureDefinition = 'StructureDefinition'
}

export type StructureDefinitioncontext = {
  __typename?: 'StructureDefinitioncontext';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Defines how to interpret the expression that defines what the context of the extension is. */
  _type?: Maybe<Element>;
  /** Defines how to interpret the expression that defines what the context of the extension is. */
  type: Scalars['code'];
  /** An expression that defines where an extension can be used in resources. */
  _expression?: Maybe<Element>;
  /** An expression that defines where an extension can be used in resources. */
  expression: Scalars['String'];
};

export type StructureDefinitiondifferential = {
  __typename?: 'StructureDefinitiondifferential';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Captures constraints on each element within the resource. */
  element?: Maybe<Array<ElementDefinition>>;
};

export type StructureDefinitionmapping = {
  __typename?: 'StructureDefinitionmapping';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An Internal id that is used to identify this mapping set when specific mappings are made. */
  _identity?: Maybe<Element>;
  /** An Internal id that is used to identify this mapping set when specific mappings are made. */
  identity: Scalars['id'];
  /** An absolute URI that identifies the specification that this mapping is expressed to. */
  _uri?: Maybe<Element>;
  /** An absolute URI that identifies the specification that this mapping is expressed to. */
  uri?: Maybe<Scalars['uri']>;
  /** A name for the specification that is being mapped to. */
  _name?: Maybe<Element>;
  /** A name for the specification that is being mapped to. */
  name?: Maybe<Scalars['String']>;
  /** Comments about this mapping, including version notes, issues, scope limitations, and other important notes for usage. */
  _comment?: Maybe<Element>;
  /** Comments about this mapping, including version notes, issues, scope limitations, and other important notes for usage. */
  comment?: Maybe<Scalars['String']>;
};

export type StructureDefinitionsnapshot = {
  __typename?: 'StructureDefinitionsnapshot';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Captures constraints on each element within the resource. */
  element?: Maybe<Array<ElementDefinition>>;
};

/** A Map of relationships between 2 structures that can be used to transform data. */
export type StructureMap = {
  __typename?: 'StructureMap';
  /** Type of resource */
  resourceType: StructureMap_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this structure map when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this structure map is
   * (or will be) published. This URL can be the target of a canonical reference.
   * It SHALL remain the same when the structure map is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this structure map when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this structure map is
   * (or will be) published. This URL can be the target of a canonical reference.
   * It SHALL remain the same when the structure map is stored on different servers.
   */
  url: Scalars['uri'];
  /**
   * A formal identifier that is used to identify this structure map when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the structure map when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the structure map author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the structure map when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the structure map author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the structure map. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the structure map. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name: Scalars['String'];
  /** A short, descriptive, user-friendly title for the structure map. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the structure map. */
  title?: Maybe<Scalars['String']>;
  /** The status of this structure map. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this structure map. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this structure map is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this structure map is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the structure map was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the structure map changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the structure map was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the structure map changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the structure map. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the structure map. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the structure map from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the structure map from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate structure map instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the structure map is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this structure map is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this structure map is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the structure map and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the structure map.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the structure map and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the structure map.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * A structure definition used by this map. The structure definition may describe
   * instances that are converted, or the instances that are produced.
   */
  structure?: Maybe<Array<Maybe<StructureMapstructure>>>;
  /** Other maps used by this map (canonical URLs). */
  _import?: Maybe<Element>;
  /** Other maps used by this map (canonical URLs). */
  import?: Maybe<Array<Maybe<Scalars['canonical']>>>;
  /** Organizes the mapping into manageable chunks for human review/ease of maintenance. */
  group?: Maybe<Array<StructureMapgroup>>;
};

export enum StructureMap_Enum_Schema {
  StructureMap = 'StructureMap'
}

export type StructureMapgroup = {
  __typename?: 'StructureMapgroup';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique name for the group for the convenience of human readers. */
  _name?: Maybe<Element>;
  /** A unique name for the group for the convenience of human readers. */
  name: Scalars['id'];
  /** Another group that this group adds rules to. */
  _extends?: Maybe<Element>;
  /** Another group that this group adds rules to. */
  extends?: Maybe<Scalars['id']>;
  /** If this is the default rule set to apply for the source type or this combination of types. */
  _typeMode?: Maybe<Element>;
  /** If this is the default rule set to apply for the source type or this combination of types. */
  typeMode: Scalars['code'];
  /** Additional supporting documentation that explains the purpose of the group and the types of mappings within it. */
  _documentation?: Maybe<Element>;
  /** Additional supporting documentation that explains the purpose of the group and the types of mappings within it. */
  documentation?: Maybe<Scalars['String']>;
  /** A name assigned to an instance of data. The instance must be provided when the mapping is invoked. */
  input?: Maybe<Array<StructureMapgroupinput>>;
  /** Transform Rule from source to target. */
  rule?: Maybe<Array<StructureMapgrouprule>>;
};

export type StructureMapgroupinput = {
  __typename?: 'StructureMapgroupinput';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Name for this instance of data. */
  _name?: Maybe<Element>;
  /** Name for this instance of data. */
  name: Scalars['id'];
  /** Type for this instance of data. */
  _type?: Maybe<Element>;
  /** Type for this instance of data. */
  type?: Maybe<Scalars['String']>;
  /** Mode for this instance of data. */
  _mode?: Maybe<Element>;
  /** Mode for this instance of data. */
  mode: Scalars['code'];
  /** Documentation for this instance of data. */
  _documentation?: Maybe<Element>;
  /** Documentation for this instance of data. */
  documentation?: Maybe<Scalars['String']>;
};

export type StructureMapgrouprule = {
  __typename?: 'StructureMapgrouprule';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Name of the rule for internal references. */
  _name?: Maybe<Element>;
  /** Name of the rule for internal references. */
  name: Scalars['id'];
  /** Source inputs to the mapping. */
  source?: Maybe<Array<StructureMapgrouprulesource>>;
  /** Content to create because of this mapping rule. */
  target?: Maybe<Array<Maybe<StructureMapgroupruletarget>>>;
  /** Which other rules to apply in the context of this rule. */
  dependent?: Maybe<Array<Maybe<StructureMapgroupruledependent>>>;
  /** Documentation for this instance of data. */
  _documentation?: Maybe<Element>;
  /** Documentation for this instance of data. */
  documentation?: Maybe<Scalars['String']>;
};

export type StructureMapgroupruledependent = {
  __typename?: 'StructureMapgroupruledependent';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Name of a rule or group to apply. */
  _name?: Maybe<Element>;
  /** Name of a rule or group to apply. */
  name: Scalars['id'];
  /** Variable to pass to the rule or group. */
  _variable?: Maybe<Element>;
  /** Variable to pass to the rule or group. */
  variable?: Maybe<Array<Scalars['String']>>;
};

export type StructureMapgrouprulesource = {
  __typename?: 'StructureMapgrouprulesource';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type or variable this rule applies to. */
  _context?: Maybe<Element>;
  /** Type or variable this rule applies to. */
  context: Scalars['id'];
  /**
   * Specified minimum cardinality for the element. This is optional; if present,
   * it acts an implicit check on the input content.
   */
  _min?: Maybe<Element>;
  /**
   * Specified minimum cardinality for the element. This is optional; if present,
   * it acts an implicit check on the input content.
   */
  min?: Maybe<Scalars['Int']>;
  /**
   * Specified maximum cardinality for the element - a number or a '*'. This is
   * optional; if present, it acts an implicit check on the input content (* just
   * serves as documentation; it's the default value).
   */
  _max?: Maybe<Element>;
  /**
   * Specified maximum cardinality for the element - a number or a '*'. This is
   * optional; if present, it acts an implicit check on the input content (* just
   * serves as documentation; it's the default value).
   */
  max?: Maybe<Scalars['String']>;
  /** Specified type for the element. This works as a condition on the mapping - use for polymorphic elements. */
  _type?: Maybe<Element>;
  /** Specified type for the element. This works as a condition on the mapping - use for polymorphic elements. */
  type?: Maybe<Scalars['String']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueBase64Binary?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueBase64Binary?: Maybe<Scalars['base64Binary']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueBoolean?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueBoolean?: Maybe<Scalars['Boolean']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueCanonical?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueCanonical?: Maybe<Scalars['canonical']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueCode?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueCode?: Maybe<Scalars['code']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueDate?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueDate?: Maybe<Scalars['date']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueDateTime?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueDateTime?: Maybe<Scalars['dateTime']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueDecimal?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueDecimal?: Maybe<Scalars['Float']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueId?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueId?: Maybe<Scalars['id']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueInstant?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueInstant?: Maybe<Scalars['instant']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueInteger?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueInteger?: Maybe<Scalars['Int']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueMarkdown?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueMarkdown?: Maybe<Scalars['String']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueOid?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueOid?: Maybe<Scalars['oid']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValuePositiveInt?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValuePositiveInt?: Maybe<Scalars['positiveInt']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueString?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueString?: Maybe<Scalars['String']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueTime?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueTime?: Maybe<Scalars['time']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueUnsignedInt?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueUnsignedInt?: Maybe<Scalars['unsignedInt']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueUri?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueUri?: Maybe<Scalars['uri']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueUrl?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueUrl?: Maybe<Scalars['url']>;
  /** A value to use if there is no existing value in the source object. */
  _defaultValueUuid?: Maybe<Element>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueUuid?: Maybe<Scalars['uuid']>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueAddress?: Maybe<Address>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueAge?: Maybe<Age>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueAnnotation?: Maybe<Annotation>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueAttachment?: Maybe<Attachment>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueCodeableConcept?: Maybe<CodeableConcept>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueCoding?: Maybe<Coding>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueContactPoint?: Maybe<ContactPoint>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueCount?: Maybe<Count>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueDistance?: Maybe<Distance>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueDuration?: Maybe<Duration>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueHumanName?: Maybe<HumanName>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueIdentifier?: Maybe<Identifier>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueMoney?: Maybe<Money>;
  /** A value to use if there is no existing value in the source object. */
  defaultValuePeriod?: Maybe<Period>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueQuantity?: Maybe<Quantity>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueRange?: Maybe<Range>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueRatio?: Maybe<Ratio>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueReference?: Maybe<ResourceList>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueSampledData?: Maybe<SampledData>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueSignature?: Maybe<Signature>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueTiming?: Maybe<Timing>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueContactDetail?: Maybe<ContactDetail>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueContributor?: Maybe<Contributor>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueDataRequirement?: Maybe<DataRequirement>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueExpression?: Maybe<Expression>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueParameterDefinition?: Maybe<ParameterDefinition>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueRelatedArtifact?: Maybe<RelatedArtifact>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueTriggerDefinition?: Maybe<TriggerDefinition>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueUsageContext?: Maybe<UsageContext>;
  /** A value to use if there is no existing value in the source object. */
  defaultValueDosage?: Maybe<Dosage>;
  /** Optional field for this source. */
  _element?: Maybe<Element>;
  /** Optional field for this source. */
  element?: Maybe<Scalars['String']>;
  /** How to handle the list mode for this element. */
  _listMode?: Maybe<Element>;
  /** How to handle the list mode for this element. */
  listMode?: Maybe<Scalars['code']>;
  /** Named context for field, if a field is specified. */
  _variable?: Maybe<Element>;
  /** Named context for field, if a field is specified. */
  variable?: Maybe<Scalars['id']>;
  /** FHIRPath expression  - must be true or the rule does not apply. */
  _condition?: Maybe<Element>;
  /** FHIRPath expression  - must be true or the rule does not apply. */
  condition?: Maybe<Scalars['String']>;
  /** FHIRPath expression  - must be true or the mapping engine throws an error instead of completing. */
  _check?: Maybe<Element>;
  /** FHIRPath expression  - must be true or the mapping engine throws an error instead of completing. */
  check?: Maybe<Scalars['String']>;
  /**
   * A FHIRPath expression which specifies a message to put in the transform log
   * when content matching the source rule is found.
   */
  _logMessage?: Maybe<Element>;
  /**
   * A FHIRPath expression which specifies a message to put in the transform log
   * when content matching the source rule is found.
   */
  logMessage?: Maybe<Scalars['String']>;
};

export type StructureMapgroupruletarget = {
  __typename?: 'StructureMapgroupruletarget';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Type or variable this rule applies to. */
  _context?: Maybe<Element>;
  /** Type or variable this rule applies to. */
  context?: Maybe<Scalars['id']>;
  /** How to interpret the context. */
  _contextType?: Maybe<Element>;
  /** How to interpret the context. */
  contextType?: Maybe<Scalars['code']>;
  /** Field to create in the context. */
  _element?: Maybe<Element>;
  /** Field to create in the context. */
  element?: Maybe<Scalars['String']>;
  /** Named context for field, if desired, and a field is specified. */
  _variable?: Maybe<Element>;
  /** Named context for field, if desired, and a field is specified. */
  variable?: Maybe<Scalars['id']>;
  /** If field is a list, how to manage the list. */
  _listMode?: Maybe<Element>;
  /** If field is a list, how to manage the list. */
  listMode?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** Internal rule reference for shared list items. */
  _listRuleId?: Maybe<Element>;
  /** Internal rule reference for shared list items. */
  listRuleId?: Maybe<Scalars['id']>;
  /** How the data is copied / created. */
  _transform?: Maybe<Element>;
  /** How the data is copied / created. */
  transform?: Maybe<Scalars['code']>;
  /** Parameters to the transform. */
  parameter?: Maybe<Array<Maybe<StructureMapgroupruletargetparameter>>>;
};

export type StructureMapgroupruletargetparameter = {
  __typename?: 'StructureMapgroupruletargetparameter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Parameter value - variable or literal. */
  _valueId?: Maybe<Element>;
  /** Parameter value - variable or literal. */
  valueId: Scalars['id'];
  /** Parameter value - variable or literal. */
  _valueString?: Maybe<Element>;
  /** Parameter value - variable or literal. */
  valueString: Scalars['String'];
  /** Parameter value - variable or literal. */
  _valueBoolean?: Maybe<Element>;
  /** Parameter value - variable or literal. */
  valueBoolean: Scalars['Boolean'];
  /** Parameter value - variable or literal. */
  _valueInteger?: Maybe<Element>;
  /** Parameter value - variable or literal. */
  valueInteger: Scalars['Int'];
  /** Parameter value - variable or literal. */
  _valueDecimal?: Maybe<Element>;
  /** Parameter value - variable or literal. */
  valueDecimal: Scalars['Float'];
};

export type StructureMapstructure = {
  __typename?: 'StructureMapstructure';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The canonical reference to the structure. */
  _url?: Maybe<Element>;
  /** The canonical reference to the structure. */
  url: Scalars['canonical'];
  /** How the referenced structure is used in this mapping. */
  _mode?: Maybe<Element>;
  /** How the referenced structure is used in this mapping. */
  mode: Scalars['code'];
  /** The name used for this type in the map. */
  _alias?: Maybe<Element>;
  /** The name used for this type in the map. */
  alias?: Maybe<Scalars['String']>;
  /** Documentation that describes how the structure is used in the mapping. */
  _documentation?: Maybe<Element>;
  /** Documentation that describes how the structure is used in the mapping. */
  documentation?: Maybe<Scalars['String']>;
};

export enum SubSpecialtyMaster_Enum_Input {
  SpecialtyMaster = 'SpecialtyMaster'
}

export enum SubSpecialtyMaster_Enum_Schema {
  SpecialtyMaster = 'SpecialtyMaster'
}

/** SubSpecialtyMaster */
export type SubSpecialtyMaster_Input = {
  /** Type of resource */
  resourceType: SubSpecialtyMaster_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  professionalTypeRelation?: Maybe<Array<Maybe<ProfessionalTypeRelation_Input>>>;
  /** name. */
  name?: Maybe<Scalars['String']>;
  /** status. */
  status?: Maybe<Scalars['Boolean']>;
};

/** SubSpecialtyMaster */
export type SubSpecialtyMaster_Schema = {
  __typename?: 'SubSpecialtyMaster_Schema';
  /** Type of resource */
  resourceType: SubSpecialtyMaster_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['String']>;
  /** Referral_Type. */
  name?: Maybe<Scalars['String']>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  professionalTypeRelation?: Maybe<Array<Maybe<ProfessionalTypeRelation_Schema>>>;
  /** status. */
  status?: Maybe<Scalars['Boolean']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Type of resource */
  resourceType: Subscription_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The status of the subscription, which marks the server state for managing the subscription. */
  _status?: Maybe<Element>;
  /** The status of the subscription, which marks the server state for managing the subscription. */
  status: Scalars['code'];
  /**
   * Contact details for a human to contact about the subscription. The primary use
   * of this for system administrator troubleshooting.
   */
  contact?: Maybe<Array<Maybe<ContactPoint>>>;
  /** The time for the server to turn the subscription off. */
  _end?: Maybe<Element>;
  /** The time for the server to turn the subscription off. */
  end?: Maybe<Scalars['instant']>;
  /** A description of why this subscription is defined. */
  _reason?: Maybe<Element>;
  /** A description of why this subscription is defined. */
  reason: Scalars['String'];
  /** The rules that the server should use to determine when to generate notifications for this subscription. */
  _criteria?: Maybe<Element>;
  /** The rules that the server should use to determine when to generate notifications for this subscription. */
  criteria: Scalars['String'];
  /** A record of the last error that occurred when the server processed a notification. */
  _error?: Maybe<Element>;
  /** A record of the last error that occurred when the server processed a notification. */
  error?: Maybe<Scalars['String']>;
  /** Details where to send notifications when resources are received that meet the criteria. */
  channel: Subscriptionchannel;
};

export enum Subscription_Enum_Schema {
  Subscription = 'Subscription'
}

export type Subscriptionchannel = {
  __typename?: 'Subscriptionchannel';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of channel to send notifications on. */
  _type?: Maybe<Element>;
  /** The type of channel to send notifications on. */
  type: Scalars['code'];
  /** The url that describes the actual end-point to send messages to. */
  _endpoint?: Maybe<Element>;
  /** The url that describes the actual end-point to send messages to. */
  endpoint?: Maybe<Scalars['url']>;
  /**
   * The mime type to send the payload in - either application/fhir+xml, or
   * application/fhir+json. If the payload is not present, then there is no payload
   * in the notification, just a notification. The mime type 'text/plain' may also
   * be used for Email and SMS subscriptions.
   */
  _payload?: Maybe<Element>;
  /**
   * The mime type to send the payload in - either application/fhir+xml, or
   * application/fhir+json. If the payload is not present, then there is no payload
   * in the notification, just a notification. The mime type 'text/plain' may also
   * be used for Email and SMS subscriptions.
   */
  payload?: Maybe<Scalars['code']>;
  /** Additional headers / information to send as part of the notification. */
  _header?: Maybe<Element>;
  /** Additional headers / information to send as part of the notification. */
  header?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** A homogeneous material with a definite composition. */
export type Substance = {
  __typename?: 'Substance';
  /** Type of resource */
  resourceType: Substance_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Unique identifier for the substance. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A code to indicate if the substance is actively used. */
  _status?: Maybe<Element>;
  /** A code to indicate if the substance is actively used. */
  status?: Maybe<Scalars['code']>;
  /** A code that classifies the general type of substance.  This is used  for searching, sorting and display purposes. */
  category?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A code (or set of codes) that identify this substance. */
  code: CodeableConcept;
  /** A description of the substance - its appearance, handling requirements, and other usage notes. */
  _description?: Maybe<Element>;
  /** A description of the substance - its appearance, handling requirements, and other usage notes. */
  description?: Maybe<Scalars['String']>;
  /** Substance may be used to describe a kind of substance, or a specific package/container of the substance: an instance. */
  instance?: Maybe<Array<Maybe<Substanceinstance>>>;
  /** A substance can be composed of other substances. */
  ingredient?: Maybe<Array<Maybe<Substanceingredient>>>;
};

/**
 * Base StructureDefinition for SubstanceAmount Type: Chemical substances are a
 * single substance type whose primary defining element is the molecular structure.
 * Chemical substances shall be defined on the basis of their complete covalent
 * molecular structure; the presence of a salt (counter-ion) and/or solvates
 * (water, alcohols) is also captured. Purity, grade, physical form or particle
 * size are not taken into account in the definition of a chemical substance or in
 * the assignment of a Substance ID.
 */
export type SubstanceAmount = {
  __typename?: 'SubstanceAmount';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Used to capture quantitative values for a variety of elements. If only limits
   * are given, the arithmetic mean would be the average. If only a single definite
   * value for a given element is given, it would be captured in this field.
   */
  amountQuantity?: Maybe<Quantity>;
  /**
   * Used to capture quantitative values for a variety of elements. If only limits
   * are given, the arithmetic mean would be the average. If only a single definite
   * value for a given element is given, it would be captured in this field.
   */
  amountRange?: Maybe<Range>;
  /**
   * Used to capture quantitative values for a variety of elements. If only limits
   * are given, the arithmetic mean would be the average. If only a single definite
   * value for a given element is given, it would be captured in this field.
   */
  _amountString?: Maybe<Element>;
  /**
   * Used to capture quantitative values for a variety of elements. If only limits
   * are given, the arithmetic mean would be the average. If only a single definite
   * value for a given element is given, it would be captured in this field.
   */
  amountString?: Maybe<Scalars['String']>;
  /**
   * Most elements that require a quantitative value will also have a field called
   * amount type. Amount type should always be specified because the actual value
   * of the amount is often dependent on it. EXAMPLE: In capturing the actual
   * relative amounts of substances or molecular fragments it is essential to
   * indicate whether the amount refers to a mole ratio or weight ratio. For any
   * given element an effort should be made to use same the amount type for all
   * related definitional elements.
   */
  amountType?: Maybe<CodeableConcept>;
  /** A textual comment on a numeric value. */
  _amountText?: Maybe<Element>;
  /** A textual comment on a numeric value. */
  amountText?: Maybe<Scalars['String']>;
  /** Reference range of possible or expected values. */
  referenceRange?: Maybe<Element>;
};

/**
 * Nucleic acids are defined by three distinct elements: the base, sugar and
 * linkage. Individual substance/moiety IDs will be created for each of these
 * elements. The nucleotide sequence will be always entered in the 5’-3’ direction.
 */
export type SubstanceNucleicAcid = {
  __typename?: 'SubstanceNucleicAcid';
  /** Type of resource */
  resourceType: SubstanceNucleicAcid_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of the sequence shall be specified based on a controlled vocabulary. */
  sequenceType?: Maybe<CodeableConcept>;
  /**
   * The number of linear sequences of nucleotides linked through phosphodiester
   * bonds shall be described. Subunits would be strands of nucleic acids that are
   * tightly associated typically through Watson-Crick base pairing. NOTE: If not
   * specified in the reference source, the assumption is that there is 1 subunit.
   */
  _numberOfSubunits?: Maybe<Element>;
  /**
   * The number of linear sequences of nucleotides linked through phosphodiester
   * bonds shall be described. Subunits would be strands of nucleic acids that are
   * tightly associated typically through Watson-Crick base pairing. NOTE: If not
   * specified in the reference source, the assumption is that there is 1 subunit.
   */
  numberOfSubunits?: Maybe<Scalars['Int']>;
  /**
   * The area of hybridisation shall be described if applicable for double stranded
   * RNA or DNA. The number associated with the subunit followed by the number
   * associated to the residue shall be specified in increasing order. The
   * underscore “” shall be used as separator as follows: “Subunitnumber Residue”.
   */
  _areaOfHybridisation?: Maybe<Element>;
  /**
   * The area of hybridisation shall be described if applicable for double stranded
   * RNA or DNA. The number associated with the subunit followed by the number
   * associated to the residue shall be specified in increasing order. The
   * underscore “” shall be used as separator as follows: “Subunitnumber Residue”.
   */
  areaOfHybridisation?: Maybe<Scalars['String']>;
  /** (TBC). */
  oligoNucleotideType?: Maybe<CodeableConcept>;
  /**
   * Subunits are listed in order of decreasing length; sequences of the same
   * length will be ordered by molecular weight; subunits that have identical
   * sequences will be repeated multiple times.
   */
  subunit?: Maybe<Array<Maybe<SubstanceNucleicAcidsubunit>>>;
};

export enum SubstanceNucleicAcid_Enum_Schema {
  SubstanceNucleicAcid = 'SubstanceNucleicAcid'
}

export type SubstanceNucleicAcidsubunit = {
  __typename?: 'SubstanceNucleicAcidsubunit';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Index of linear sequences of nucleic acids in order of decreasing length.
   * Sequences of the same length will be ordered by molecular weight. Subunits
   * that have identical sequences will be repeated and have sequential subscripts.
   */
  _subunit?: Maybe<Element>;
  /**
   * Index of linear sequences of nucleic acids in order of decreasing length.
   * Sequences of the same length will be ordered by molecular weight. Subunits
   * that have identical sequences will be repeated and have sequential subscripts.
   */
  subunit?: Maybe<Scalars['Int']>;
  /**
   * Actual nucleotide sequence notation from 5' to 3' end using standard single
   * letter codes. In addition to the base sequence, sugar and type of phosphate or
   * non-phosphate linkage should also be captured.
   */
  _sequence?: Maybe<Element>;
  /**
   * Actual nucleotide sequence notation from 5' to 3' end using standard single
   * letter codes. In addition to the base sequence, sugar and type of phosphate or
   * non-phosphate linkage should also be captured.
   */
  sequence?: Maybe<Scalars['String']>;
  /** The length of the sequence shall be captured. */
  _length?: Maybe<Element>;
  /** The length of the sequence shall be captured. */
  length?: Maybe<Scalars['Int']>;
  /** (TBC). */
  sequenceAttachment?: Maybe<Attachment>;
  /**
   * The nucleotide present at the 5’ terminal shall be specified based on a
   * controlled vocabulary. Since the sequence is represented from the 5' to the 3'
   * end, the 5’ prime nucleotide is the letter at the first position in the
   * sequence. A separate representation would be redundant.
   */
  fivePrime?: Maybe<CodeableConcept>;
  /**
   * The nucleotide present at the 3’ terminal shall be specified based on a
   * controlled vocabulary. Since the sequence is represented from the 5' to the 3'
   * end, the 5’ prime nucleotide is the letter at the last position in the
   * sequence. A separate representation would be redundant.
   */
  threePrime?: Maybe<CodeableConcept>;
  /** The linkages between sugar residues will also be captured. */
  linkage?: Maybe<Array<Maybe<SubstanceNucleicAcidsubunitlinkage>>>;
  /** 5.3.6.8.1 Sugar ID (Mandatory). */
  sugar?: Maybe<Array<Maybe<SubstanceNucleicAcidsubunitsugar>>>;
};

export type SubstanceNucleicAcidsubunitlinkage = {
  __typename?: 'SubstanceNucleicAcidsubunitlinkage';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The entity that links the sugar residues together should also be captured for
   * nearly all naturally occurring nucleic acid the linkage is a phosphate group.
   * For many synthetic oligonucleotides phosphorothioate linkages are often seen.
   * Linkage connectivity is assumed to be 3’-5’. If the linkage is either 3’-3’ or
   * 5’-5’ this should be specified.
   */
  _connectivity?: Maybe<Element>;
  /**
   * The entity that links the sugar residues together should also be captured for
   * nearly all naturally occurring nucleic acid the linkage is a phosphate group.
   * For many synthetic oligonucleotides phosphorothioate linkages are often seen.
   * Linkage connectivity is assumed to be 3’-5’. If the linkage is either 3’-3’ or
   * 5’-5’ this should be specified.
   */
  connectivity?: Maybe<Scalars['String']>;
  /** Each linkage will be registered as a fragment and have an ID. */
  identifier?: Maybe<Identifier>;
  /** Each linkage will be registered as a fragment and have at least one name. A single name shall be assigned to each linkage. */
  _name?: Maybe<Element>;
  /** Each linkage will be registered as a fragment and have at least one name. A single name shall be assigned to each linkage. */
  name?: Maybe<Scalars['String']>;
  /** Residues shall be captured as described in 5.3.6.8.3. */
  _residueSite?: Maybe<Element>;
  /** Residues shall be captured as described in 5.3.6.8.3. */
  residueSite?: Maybe<Scalars['String']>;
};

export type SubstanceNucleicAcidsubunitsugar = {
  __typename?: 'SubstanceNucleicAcidsubunitsugar';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The Substance ID of the sugar or sugar-like component that make up the nucleotide. */
  identifier?: Maybe<Identifier>;
  /** The name of the sugar or sugar-like component that make up the nucleotide. */
  _name?: Maybe<Element>;
  /** The name of the sugar or sugar-like component that make up the nucleotide. */
  name?: Maybe<Scalars['String']>;
  /**
   * The residues that contain a given sugar will be captured. The order of given
   * residues will be captured in the 5‘-3‘direction consistent with the base
   * sequences listed above.
   */
  _residueSite?: Maybe<Element>;
  /**
   * The residues that contain a given sugar will be captured. The order of given
   * residues will be captured in the 5‘-3‘direction consistent with the base
   * sequences listed above.
   */
  residueSite?: Maybe<Scalars['String']>;
};

/** Todo. */
export type SubstancePolymer = {
  __typename?: 'SubstancePolymer';
  /** Type of resource */
  resourceType: SubstancePolymer_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  class?: Maybe<CodeableConcept>;
  /** Todo. */
  geometry?: Maybe<CodeableConcept>;
  /** Todo. */
  copolymerConnectivity?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Todo. */
  _modification?: Maybe<Element>;
  /** Todo. */
  modification?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Todo. */
  monomerSet?: Maybe<Array<Maybe<SubstancePolymermonomerSet>>>;
  /** Todo. */
  repeat?: Maybe<Array<Maybe<SubstancePolymerrepeat>>>;
};

export enum SubstancePolymer_Enum_Schema {
  SubstancePolymer = 'SubstancePolymer'
}

export type SubstancePolymermonomerSet = {
  __typename?: 'SubstancePolymermonomerSet';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  ratioType?: Maybe<CodeableConcept>;
  /** Todo. */
  startingMaterial?: Maybe<Array<Maybe<SubstancePolymermonomerSetstartingMaterial>>>;
};

export type SubstancePolymermonomerSetstartingMaterial = {
  __typename?: 'SubstancePolymermonomerSetstartingMaterial';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  material?: Maybe<CodeableConcept>;
  /** Todo. */
  type?: Maybe<CodeableConcept>;
  /** Todo. */
  _isDefining?: Maybe<Element>;
  /** Todo. */
  isDefining?: Maybe<Scalars['Boolean']>;
  /** Todo. */
  amount?: Maybe<SubstanceAmount>;
};

export type SubstancePolymerrepeat = {
  __typename?: 'SubstancePolymerrepeat';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  _numberOfUnits?: Maybe<Element>;
  /** Todo. */
  numberOfUnits?: Maybe<Scalars['Int']>;
  /** Todo. */
  _averageMolecularFormula?: Maybe<Element>;
  /** Todo. */
  averageMolecularFormula?: Maybe<Scalars['String']>;
  /** Todo. */
  repeatUnitAmountType?: Maybe<CodeableConcept>;
  /** Todo. */
  repeatUnit?: Maybe<Array<Maybe<SubstancePolymerrepeatrepeatUnit>>>;
};

export type SubstancePolymerrepeatrepeatUnit = {
  __typename?: 'SubstancePolymerrepeatrepeatUnit';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  orientationOfPolymerisation?: Maybe<CodeableConcept>;
  /** Todo. */
  _repeatUnit?: Maybe<Element>;
  /** Todo. */
  repeatUnit?: Maybe<Scalars['String']>;
  /** Todo. */
  amount?: Maybe<SubstanceAmount>;
  /** Todo. */
  degreeOfPolymerisation?: Maybe<Array<Maybe<SubstancePolymerrepeatrepeatUnitdegreeOfPolymerisation>>>;
  /** Todo. */
  structuralRepresentation?: Maybe<Array<Maybe<SubstancePolymerrepeatrepeatUnitstructuralRepresentation>>>;
};

export type SubstancePolymerrepeatrepeatUnitdegreeOfPolymerisation = {
  __typename?: 'SubstancePolymerrepeatrepeatUnitdegreeOfPolymerisation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  degree?: Maybe<CodeableConcept>;
  /** Todo. */
  amount?: Maybe<SubstanceAmount>;
};

export type SubstancePolymerrepeatrepeatUnitstructuralRepresentation = {
  __typename?: 'SubstancePolymerrepeatrepeatUnitstructuralRepresentation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  type?: Maybe<CodeableConcept>;
  /** Todo. */
  _representation?: Maybe<Element>;
  /** Todo. */
  representation?: Maybe<Scalars['String']>;
  /** Todo. */
  attachment?: Maybe<Attachment>;
};

/**
 * A SubstanceProtein is defined as a single unit of a linear amino acid sequence,
 * or a combination of subunits that are either covalently linked or have a defined
 * invariant stoichiometric relationship. This includes all synthetic, recombinant
 * and purified SubstanceProteins of defined sequence, whether the use is
 * therapeutic or prophylactic. This set of elements will be used to describe
 * albumins, coagulation factors, cytokines, growth factors,
 * peptide/SubstanceProtein hormones, enzymes, toxins, toxoids, recombinant
 * vaccines, and immunomodulators.
 */
export type SubstanceProtein = {
  __typename?: 'SubstanceProtein';
  /** Type of resource */
  resourceType: SubstanceProtein_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The SubstanceProtein descriptive elements will only be used when a complete or
   * partial amino acid sequence is available or derivable from a nucleic acid sequence.
   */
  sequenceType?: Maybe<CodeableConcept>;
  /**
   * Number of linear sequences of amino acids linked through peptide bonds. The
   * number of subunits constituting the SubstanceProtein shall be described. It is
   * possible that the number of subunits can be variable.
   */
  _numberOfSubunits?: Maybe<Element>;
  /**
   * Number of linear sequences of amino acids linked through peptide bonds. The
   * number of subunits constituting the SubstanceProtein shall be described. It is
   * possible that the number of subunits can be variable.
   */
  numberOfSubunits?: Maybe<Scalars['Int']>;
  /**
   * The disulphide bond between two cysteine residues either on the same subunit
   * or on two different subunits shall be described. The position of the disulfide
   * bonds in the SubstanceProtein shall be listed in increasing order of subunit
   * number and position within subunit followed by the abbreviation of the amino
   * acids involved. The disulfide linkage positions shall actually contain the
   * amino acid Cysteine at the respective positions.
   */
  _disulfideLinkage?: Maybe<Element>;
  /**
   * The disulphide bond between two cysteine residues either on the same subunit
   * or on two different subunits shall be described. The position of the disulfide
   * bonds in the SubstanceProtein shall be listed in increasing order of subunit
   * number and position within subunit followed by the abbreviation of the amino
   * acids involved. The disulfide linkage positions shall actually contain the
   * amino acid Cysteine at the respective positions.
   */
  disulfideLinkage?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * This subclause refers to the description of each subunit constituting the
   * SubstanceProtein. A subunit is a linear sequence of amino acids linked through
   * peptide bonds. The Subunit information shall be provided when the finished
   * SubstanceProtein is a complex of multiple sequences; subunits are not used to
   * delineate domains within a single sequence. Subunits are listed in order of
   * decreasing length; sequences of the same length will be ordered by decreasing
   * molecular weight; subunits that have identical sequences will be repeated
   * multiple times.
   */
  subunit?: Maybe<Array<Maybe<SubstanceProteinsubunit>>>;
};

export enum SubstanceProtein_Enum_Schema {
  SubstanceProtein = 'SubstanceProtein'
}

export type SubstanceProteinsubunit = {
  __typename?: 'SubstanceProteinsubunit';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Index of primary sequences of amino acids linked through peptide bonds in
   * order of decreasing length. Sequences of the same length will be ordered by
   * molecular weight. Subunits that have identical sequences will be repeated and
   * have sequential subscripts.
   */
  _subunit?: Maybe<Element>;
  /**
   * Index of primary sequences of amino acids linked through peptide bonds in
   * order of decreasing length. Sequences of the same length will be ordered by
   * molecular weight. Subunits that have identical sequences will be repeated and
   * have sequential subscripts.
   */
  subunit?: Maybe<Scalars['Int']>;
  /**
   * The sequence information shall be provided enumerating the amino acids from N-
   * to C-terminal end using standard single-letter amino acid codes. Uppercase
   * shall be used for L-amino acids and lowercase for D-amino acids. Transcribed
   * SubstanceProteins will always be described using the translated sequence; for
   * synthetic peptide containing amino acids that are not represented with a
   * single letter code an X should be used within the sequence. The modified amino
   * acids will be distinguished by their position in the sequence.
   */
  _sequence?: Maybe<Element>;
  /**
   * The sequence information shall be provided enumerating the amino acids from N-
   * to C-terminal end using standard single-letter amino acid codes. Uppercase
   * shall be used for L-amino acids and lowercase for D-amino acids. Transcribed
   * SubstanceProteins will always be described using the translated sequence; for
   * synthetic peptide containing amino acids that are not represented with a
   * single letter code an X should be used within the sequence. The modified amino
   * acids will be distinguished by their position in the sequence.
   */
  sequence?: Maybe<Scalars['String']>;
  /** Length of linear sequences of amino acids contained in the subunit. */
  _length?: Maybe<Element>;
  /** Length of linear sequences of amino acids contained in the subunit. */
  length?: Maybe<Scalars['Int']>;
  /**
   * The sequence information shall be provided enumerating the amino acids from N-
   * to C-terminal end using standard single-letter amino acid codes. Uppercase
   * shall be used for L-amino acids and lowercase for D-amino acids. Transcribed
   * SubstanceProteins will always be described using the translated sequence; for
   * synthetic peptide containing amino acids that are not represented with a
   * single letter code an X should be used within the sequence. The modified amino
   * acids will be distinguished by their position in the sequence.
   */
  sequenceAttachment?: Maybe<Attachment>;
  /** Unique identifier for molecular fragment modification based on the ISO 11238 Substance ID. */
  nTerminalModificationId?: Maybe<Identifier>;
  /** The name of the fragment modified at the N-terminal of the SubstanceProtein shall be specified. */
  _nTerminalModification?: Maybe<Element>;
  /** The name of the fragment modified at the N-terminal of the SubstanceProtein shall be specified. */
  nTerminalModification?: Maybe<Scalars['String']>;
  /** Unique identifier for molecular fragment modification based on the ISO 11238 Substance ID. */
  cTerminalModificationId?: Maybe<Identifier>;
  /** The modification at the C-terminal shall be specified. */
  _cTerminalModification?: Maybe<Element>;
  /** The modification at the C-terminal shall be specified. */
  cTerminalModification?: Maybe<Scalars['String']>;
};

/** Todo. */
export type SubstanceReferenceInformation = {
  __typename?: 'SubstanceReferenceInformation';
  /** Type of resource */
  resourceType: SubstanceReferenceInformation_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  _comment?: Maybe<Element>;
  /** Todo. */
  comment?: Maybe<Scalars['String']>;
  /** Todo. */
  gene?: Maybe<Array<Maybe<SubstanceReferenceInformationgene>>>;
  /** Todo. */
  geneElement?: Maybe<Array<Maybe<SubstanceReferenceInformationgeneElement>>>;
  /** Todo. */
  classification?: Maybe<Array<Maybe<SubstanceReferenceInformationclassification>>>;
  /** Todo. */
  target?: Maybe<Array<Maybe<SubstanceReferenceInformationtarget>>>;
};

export enum SubstanceReferenceInformation_Enum_Schema {
  SubstanceReferenceInformation = 'SubstanceReferenceInformation'
}

export type SubstanceReferenceInformationclassification = {
  __typename?: 'SubstanceReferenceInformationclassification';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  domain?: Maybe<CodeableConcept>;
  /** Todo. */
  classification?: Maybe<CodeableConcept>;
  /** Todo. */
  subtype?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Todo. */
  source?: Maybe<Array<Maybe<SubstanceReferenceInformationclassificationsource_Source_Union>>>;
};

/** Todo. */
export type SubstanceReferenceInformationclassificationsource_Source_Union = DocumentReference;

export type SubstanceReferenceInformationgene = {
  __typename?: 'SubstanceReferenceInformationgene';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  geneSequenceOrigin?: Maybe<CodeableConcept>;
  /** Todo. */
  gene?: Maybe<CodeableConcept>;
  /** Todo. */
  source?: Maybe<Array<Maybe<SubstanceReferenceInformationgenesource_Source_Union>>>;
};

export type SubstanceReferenceInformationgeneElement = {
  __typename?: 'SubstanceReferenceInformationgeneElement';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  type?: Maybe<CodeableConcept>;
  /** Todo. */
  element?: Maybe<Identifier>;
  /** Todo. */
  source?: Maybe<Array<Maybe<SubstanceReferenceInformationgeneElementsource_Source_Union>>>;
};

/** Todo. */
export type SubstanceReferenceInformationgeneElementsource_Source_Union = DocumentReference;

/** Todo. */
export type SubstanceReferenceInformationgenesource_Source_Union = DocumentReference;

export type SubstanceReferenceInformationtarget = {
  __typename?: 'SubstanceReferenceInformationtarget';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Todo. */
  target?: Maybe<Identifier>;
  /** Todo. */
  type?: Maybe<CodeableConcept>;
  /** Todo. */
  interaction?: Maybe<CodeableConcept>;
  /** Todo. */
  organism?: Maybe<CodeableConcept>;
  /** Todo. */
  organismType?: Maybe<CodeableConcept>;
  /** Todo. */
  amountQuantity?: Maybe<Quantity>;
  /** Todo. */
  amountRange?: Maybe<Range>;
  /** Todo. */
  _amountString?: Maybe<Element>;
  /** Todo. */
  amountString?: Maybe<Scalars['String']>;
  /** Todo. */
  amountType?: Maybe<CodeableConcept>;
  /** Todo. */
  source?: Maybe<Array<Maybe<SubstanceReferenceInformationtargetsource_Source_Union>>>;
};

/** Todo. */
export type SubstanceReferenceInformationtargetsource_Source_Union = DocumentReference;

/**
 * Source material shall capture information on the taxonomic and anatomical
 * origins as well as the fraction of a material that can result in or can be
 * modified to form a substance. This set of data elements shall be used to define
 * polymer substances isolated from biological matrices. Taxonomic and anatomical
 * origins shall be described using a controlled vocabulary as required. This
 * information is captured for naturally derived polymers ( . starch) and
 * structurally diverse substances. For Organisms belonging to the Kingdom Plantae
 * the Substance level defines the fresh material of a single species or
 * infraspecies, the Herbal Drug and the Herbal preparation. For Herbal
 * preparations, the fraction information will be captured at the Substance
 * information level and additional information for herbal extracts will be
 * captured at the Specified Substance Group 1 information level. See for further
 * explanation the Substance Class: Structurally Diverse and the herbal annex.
 */
export type SubstanceSourceMaterial = {
  __typename?: 'SubstanceSourceMaterial';
  /** Type of resource */
  resourceType: SubstanceSourceMaterial_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** General high level classification of the source material specific to the origin of the material. */
  sourceMaterialClass?: Maybe<CodeableConcept>;
  /**
   * The type of the source material shall be specified based on a controlled
   * vocabulary. For vaccines, this subclause refers to the class of infectious agent.
   */
  sourceMaterialType?: Maybe<CodeableConcept>;
  /** The state of the source material when extracted. */
  sourceMaterialState?: Maybe<CodeableConcept>;
  /** The unique identifier associated with the source material parent organism shall be specified. */
  organismId?: Maybe<Identifier>;
  /** The organism accepted Scientific name shall be provided based on the organism taxonomy. */
  _organismName?: Maybe<Element>;
  /** The organism accepted Scientific name shall be provided based on the organism taxonomy. */
  organismName?: Maybe<Scalars['String']>;
  /**
   * The parent of the herbal drug Ginkgo biloba, Leaf is the substance ID of the
   * substance (fresh) of Ginkgo biloba L. or Ginkgo biloba L. (Whole plant).
   */
  parentSubstanceId?: Maybe<Array<Maybe<Identifier>>>;
  /** The parent substance of the Herbal Drug, or Herbal preparation. */
  _parentSubstanceName?: Maybe<Element>;
  /** The parent substance of the Herbal Drug, or Herbal preparation. */
  parentSubstanceName?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The country where the plant material is harvested or the countries where the
   * plasma is sourced from as laid down in accordance with the Plasma Master File.
   * For “Plasma-derived substances” the attribute country of origin provides
   * information about the countries used for the manufacturing of the Cryopoor
   * plama or Crioprecipitate.
   */
  countryOfOrigin?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The place/region where the plant is harvested or the places/regions where the animal source material has its habitat. */
  _geographicalLocation?: Maybe<Element>;
  /** The place/region where the plant is harvested or the places/regions where the animal source material has its habitat. */
  geographicalLocation?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Stage of life for animals, plants, insects and microorganisms. This
   * information shall be provided only when the substance is significantly
   * different in these stages (e.g. foetal bovine serum).
   */
  developmentStage?: Maybe<CodeableConcept>;
  /**
   * Many complex materials are fractions of parts of plants, animals, or minerals.
   * Fraction elements are often necessary to define both Substances and Specified
   * Group 1 Substances. For substances derived from Plants, fraction information
   * will be captured at the Substance information level ( . Oils, Juices and
   * Exudates). Additional information for Extracts, such as extraction solvent
   * composition, will be captured at the Specified Substance Group 1 information
   * level. For plasma-derived products fraction information will be captured at
   * the Substance and the Specified Substance Group 1 levels.
   */
  fractionDescription?: Maybe<Array<Maybe<SubstanceSourceMaterialfractionDescription>>>;
  /**
   * This subclause describes the organism which the substance is derived from. For
   * vaccines, the parent organism shall be specified based on these subclause
   * elements. As an example, full taxonomy will be described for the Substance Name: ., Leaf.
   */
  organism?: Maybe<SubstanceSourceMaterialorganism>;
  /** To do. */
  partDescription?: Maybe<Array<Maybe<SubstanceSourceMaterialpartDescription>>>;
};

export enum SubstanceSourceMaterial_Enum_Schema {
  SubstanceSourceMaterial = 'SubstanceSourceMaterial'
}

export type SubstanceSourceMaterialfractionDescription = {
  __typename?: 'SubstanceSourceMaterialfractionDescription';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** This element is capturing information about the fraction of a plant part, or human plasma for fractionation. */
  _fraction?: Maybe<Element>;
  /** This element is capturing information about the fraction of a plant part, or human plasma for fractionation. */
  fraction?: Maybe<Scalars['String']>;
  /**
   * The specific type of the material constituting the component. For Herbal
   * preparations the particulars of the extracts (liquid/dry) is described in
   * Specified Substance Group 1.
   */
  materialType?: Maybe<CodeableConcept>;
};

export type SubstanceSourceMaterialorganism = {
  __typename?: 'SubstanceSourceMaterialorganism';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The family of an organism shall be specified. */
  family?: Maybe<CodeableConcept>;
  /**
   * The genus of an organism shall be specified; refers to the Latin epithet of
   * the genus element of the plant/animal scientific name; it is present in names
   * for genera, species and infraspecies.
   */
  genus?: Maybe<CodeableConcept>;
  /**
   * The species of an organism shall be specified; refers to the Latin epithet of
   * the species of the plant/animal; it is present in names for species and infraspecies.
   */
  species?: Maybe<CodeableConcept>;
  /** The Intraspecific type of an organism shall be specified. */
  intraspecificType?: Maybe<CodeableConcept>;
  /**
   * The intraspecific description of an organism shall be specified based on a
   * controlled vocabulary. For Influenza Vaccine, the intraspecific description
   * shall contain the syntax of the antigen in line with the WHO convention.
   */
  _intraspecificDescription?: Maybe<Element>;
  /**
   * The intraspecific description of an organism shall be specified based on a
   * controlled vocabulary. For Influenza Vaccine, the intraspecific description
   * shall contain the syntax of the antigen in line with the WHO convention.
   */
  intraspecificDescription?: Maybe<Scalars['String']>;
  /** 4.9.13.6.1 Author type (Conditional). */
  author?: Maybe<Array<Maybe<SubstanceSourceMaterialorganismauthor>>>;
  /** 4.9.13.8.1 Hybrid species maternal organism ID (Optional). */
  hybrid?: Maybe<SubstanceSourceMaterialorganismhybrid>;
  /** 4.9.13.7.1 Kingdom (Conditional). */
  organismGeneral?: Maybe<SubstanceSourceMaterialorganismorganismGeneral>;
};

export type SubstanceSourceMaterialorganismauthor = {
  __typename?: 'SubstanceSourceMaterialorganismauthor';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The type of author of an organism species shall be specified. The
   * parenthetical author of an organism species refers to the first author who
   * published the plant/animal name (of any rank). The primary author of an
   * organism species refers to the first author(s), who validly published the
   * plant/animal name.
   */
  authorType?: Maybe<CodeableConcept>;
  /**
   * The author of an organism species shall be specified. The author year of an
   * organism shall also be specified when applicable; refers to the year in which
   * the first author(s) published the infraspecific plant/animal name (of any rank).
   */
  _authorDescription?: Maybe<Element>;
  /**
   * The author of an organism species shall be specified. The author year of an
   * organism shall also be specified when applicable; refers to the year in which
   * the first author(s) published the infraspecific plant/animal name (of any rank).
   */
  authorDescription?: Maybe<Scalars['String']>;
};

export type SubstanceSourceMaterialorganismhybrid = {
  __typename?: 'SubstanceSourceMaterialorganismhybrid';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The identifier of the maternal species constituting the hybrid organism shall
   * be specified based on a controlled vocabulary. For plants, the parents aren’t
   * always known, and it is unlikely that it will be known which is maternal and
   * which is paternal.
   */
  _maternalOrganismId?: Maybe<Element>;
  /**
   * The identifier of the maternal species constituting the hybrid organism shall
   * be specified based on a controlled vocabulary. For plants, the parents aren’t
   * always known, and it is unlikely that it will be known which is maternal and
   * which is paternal.
   */
  maternalOrganismId?: Maybe<Scalars['String']>;
  /**
   * The name of the maternal species constituting the hybrid organism shall be
   * specified. For plants, the parents aren’t always known, and it is unlikely
   * that it will be known which is maternal and which is paternal.
   */
  _maternalOrganismName?: Maybe<Element>;
  /**
   * The name of the maternal species constituting the hybrid organism shall be
   * specified. For plants, the parents aren’t always known, and it is unlikely
   * that it will be known which is maternal and which is paternal.
   */
  maternalOrganismName?: Maybe<Scalars['String']>;
  /**
   * The identifier of the paternal species constituting the hybrid organism shall
   * be specified based on a controlled vocabulary.
   */
  _paternalOrganismId?: Maybe<Element>;
  /**
   * The identifier of the paternal species constituting the hybrid organism shall
   * be specified based on a controlled vocabulary.
   */
  paternalOrganismId?: Maybe<Scalars['String']>;
  /** The name of the paternal species constituting the hybrid organism shall be specified. */
  _paternalOrganismName?: Maybe<Element>;
  /** The name of the paternal species constituting the hybrid organism shall be specified. */
  paternalOrganismName?: Maybe<Scalars['String']>;
  /** The hybrid type of an organism shall be specified. */
  hybridType?: Maybe<CodeableConcept>;
};

export type SubstanceSourceMaterialorganismorganismGeneral = {
  __typename?: 'SubstanceSourceMaterialorganismorganismGeneral';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The kingdom of an organism shall be specified. */
  kingdom?: Maybe<CodeableConcept>;
  /** The phylum of an organism shall be specified. */
  phylum?: Maybe<CodeableConcept>;
  /** The class of an organism shall be specified. */
  class?: Maybe<CodeableConcept>;
  /** The order of an organism shall be specified,. */
  order?: Maybe<CodeableConcept>;
};

export type SubstanceSourceMaterialpartDescription = {
  __typename?: 'SubstanceSourceMaterialpartDescription';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Entity of anatomical origin of source material within an organism. */
  part?: Maybe<CodeableConcept>;
  /**
   * The detailed anatomic location when the part can be extracted from different
   * anatomical locations of the organism. Multiple alternative locations may apply.
   */
  partLocation?: Maybe<CodeableConcept>;
};

/** The detailed description of a substance, typically at a level beyond what is used for prescribing. */
export type SubstanceSpecification = {
  __typename?: 'SubstanceSpecification';
  /** Type of resource */
  resourceType: SubstanceSpecification_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier by which this substance is known. */
  identifier?: Maybe<Identifier>;
  /** High level categorization, e.g. polymer or nucleic acid. */
  type?: Maybe<CodeableConcept>;
  /** Status of substance within the catalogue e.g. approved. */
  status?: Maybe<CodeableConcept>;
  /** If the substance applies to only human or veterinary use. */
  domain?: Maybe<CodeableConcept>;
  /** Textual description of the substance. */
  _description?: Maybe<Element>;
  /** Textual description of the substance. */
  description?: Maybe<Scalars['String']>;
  /** Supporting literature. */
  source?: Maybe<Array<Maybe<SubstanceSpecificationsource_Source_Union>>>;
  /** Textual comment about this record of a substance. */
  _comment?: Maybe<Element>;
  /** Textual comment about this record of a substance. */
  comment?: Maybe<Scalars['String']>;
  /** Moiety, for structural modifications. */
  moiety?: Maybe<Array<Maybe<SubstanceSpecificationmoiety>>>;
  /** General specifications for this substance, including how it is related to other substances. */
  property?: Maybe<Array<Maybe<SubstanceSpecificationproperty>>>;
  /** General information detailing this substance. */
  referenceInformation?: Maybe<SubstanceSpecificationreferenceInformation_ReferenceInformation_Union>;
  /** Structural information. */
  structure?: Maybe<SubstanceSpecificationstructure>;
  /** Codes associated with the substance. */
  code?: Maybe<Array<Maybe<SubstanceSpecificationcode>>>;
  /** Names applicable to this substance. */
  name?: Maybe<Array<Maybe<SubstanceSpecificationname>>>;
  /** A link between this substance and another, with details of the relationship. */
  relationship?: Maybe<Array<Maybe<SubstanceSpecificationrelationship>>>;
  /** Data items specific to nucleic acids. */
  nucleicAcid?: Maybe<SubstanceSpecificationnucleicAcid_NucleicAcid_Union>;
  /** Data items specific to polymers. */
  polymer?: Maybe<SubstanceSpecificationpolymer_Polymer_Union>;
  /** Data items specific to proteins. */
  protein?: Maybe<SubstanceSpecificationprotein_Protein_Union>;
  /** Material or taxonomic/anatomical source for the substance. */
  sourceMaterial?: Maybe<SubstanceSpecificationsourceMaterial_SourceMaterial_Union>;
};

export enum SubstanceSpecification_Enum_Schema {
  SubstanceSpecification = 'SubstanceSpecification'
}

export type SubstanceSpecificationcode = {
  __typename?: 'SubstanceSpecificationcode';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The specific code. */
  code?: Maybe<CodeableConcept>;
  /** Status of the code assignment. */
  status?: Maybe<CodeableConcept>;
  /** The date at which the code status is changed as part of the terminology maintenance. */
  _statusDate?: Maybe<Element>;
  /** The date at which the code status is changed as part of the terminology maintenance. */
  statusDate?: Maybe<Scalars['dateTime']>;
  /** Any comment can be provided in this field, if necessary. */
  _comment?: Maybe<Element>;
  /** Any comment can be provided in this field, if necessary. */
  comment?: Maybe<Scalars['String']>;
  /** Supporting literature. */
  source?: Maybe<Array<Maybe<SubstanceSpecificationcodesource_Source_Union>>>;
};

/** Supporting literature. */
export type SubstanceSpecificationcodesource_Source_Union = DocumentReference;

export type SubstanceSpecificationmoiety = {
  __typename?: 'SubstanceSpecificationmoiety';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Role that the moiety is playing. */
  role?: Maybe<CodeableConcept>;
  /** Identifier by which this moiety substance is known. */
  identifier?: Maybe<Identifier>;
  /** Textual name for this moiety substance. */
  _name?: Maybe<Element>;
  /** Textual name for this moiety substance. */
  name?: Maybe<Scalars['String']>;
  /** Stereochemistry type. */
  stereochemistry?: Maybe<CodeableConcept>;
  /** Optical activity type. */
  opticalActivity?: Maybe<CodeableConcept>;
  /** Molecular formula. */
  _molecularFormula?: Maybe<Element>;
  /** Molecular formula. */
  molecularFormula?: Maybe<Scalars['String']>;
  /** Quantitative value for this moiety. */
  amountQuantity?: Maybe<Quantity>;
  /** Quantitative value for this moiety. */
  _amountString?: Maybe<Element>;
  /** Quantitative value for this moiety. */
  amountString?: Maybe<Scalars['String']>;
};

export type SubstanceSpecificationname = {
  __typename?: 'SubstanceSpecificationname';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The actual name. */
  _name?: Maybe<Element>;
  /** The actual name. */
  name: Scalars['String'];
  /** Name type. */
  type?: Maybe<CodeableConcept>;
  /** The status of the name. */
  status?: Maybe<CodeableConcept>;
  /** If this is the preferred name for this substance. */
  _preferred?: Maybe<Element>;
  /** If this is the preferred name for this substance. */
  preferred?: Maybe<Scalars['Boolean']>;
  /** Language of the name. */
  language?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * The use context of this name for example if there is a different name a drug
   * active ingredient as opposed to a food colour additive.
   */
  domain?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The jurisdiction where this name applies. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Details of the official nature of this name. */
  official?: Maybe<Array<Maybe<SubstanceSpecificationnameofficial>>>;
  /** Supporting literature. */
  source?: Maybe<Array<Maybe<SubstanceSpecificationnamesource_Source_Union>>>;
};

export type SubstanceSpecificationnameofficial = {
  __typename?: 'SubstanceSpecificationnameofficial';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Which authority uses this official name. */
  authority?: Maybe<CodeableConcept>;
  /** The status of the official name. */
  status?: Maybe<CodeableConcept>;
  /** Date of official name change. */
  _date?: Maybe<Element>;
  /** Date of official name change. */
  date?: Maybe<Scalars['dateTime']>;
};

/** Supporting literature. */
export type SubstanceSpecificationnamesource_Source_Union = DocumentReference;

/** Data items specific to nucleic acids. */
export type SubstanceSpecificationnucleicAcid_NucleicAcid_Union = SubstanceNucleicAcid;

/** Data items specific to polymers. */
export type SubstanceSpecificationpolymer_Polymer_Union = SubstancePolymer;

export type SubstanceSpecificationproperty = {
  __typename?: 'SubstanceSpecificationproperty';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A category for this property, e.g. Physical, Chemical, Enzymatic. */
  category?: Maybe<CodeableConcept>;
  /** Property type e.g. viscosity, pH, isoelectric point. */
  code?: Maybe<CodeableConcept>;
  /** Parameters that were used in the measurement of a property (e.g. for viscosity: measured at 20C with a pH of 7.1). */
  _parameters?: Maybe<Element>;
  /** Parameters that were used in the measurement of a property (e.g. for viscosity: measured at 20C with a pH of 7.1). */
  parameters?: Maybe<Scalars['String']>;
  /** A substance upon which a defining property depends (e.g. for solubility: in water, in alcohol). */
  definingSubstanceReference?: Maybe<SubstanceSpecificationpropertydefiningSubstanceReference_DefiningSubstanceReference_Union>;
  /** A substance upon which a defining property depends (e.g. for solubility: in water, in alcohol). */
  definingSubstanceCodeableConcept?: Maybe<CodeableConcept>;
  /** Quantitative value for this property. */
  amountQuantity?: Maybe<Quantity>;
  /** Quantitative value for this property. */
  _amountString?: Maybe<Element>;
  /** Quantitative value for this property. */
  amountString?: Maybe<Scalars['String']>;
};

/** A substance upon which a defining property depends (e.g. for solubility: in water, in alcohol). */
export type SubstanceSpecificationpropertydefiningSubstanceReference_DefiningSubstanceReference_Union = SubstanceSpecification | Substance;

/** Data items specific to proteins. */
export type SubstanceSpecificationprotein_Protein_Union = SubstanceProtein;

/** General information detailing this substance. */
export type SubstanceSpecificationreferenceInformation_ReferenceInformation_Union = SubstanceReferenceInformation;

export type SubstanceSpecificationrelationship = {
  __typename?: 'SubstanceSpecificationrelationship';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A pointer to another substance, as a resource or just a representational code. */
  substanceReference?: Maybe<SubstanceSpecificationrelationshipsubstanceReference_SubstanceReference_Union>;
  /** A pointer to another substance, as a resource or just a representational code. */
  substanceCodeableConcept?: Maybe<CodeableConcept>;
  /** For example 'salt to parent', 'active moiety', 'starting material'. */
  relationship?: Maybe<CodeableConcept>;
  /**
   * For example where an enzyme strongly bonds with a particular substance, this
   * is a defining relationship for that enzyme, out of several possible substance relationships.
   */
  _isDefining?: Maybe<Element>;
  /**
   * For example where an enzyme strongly bonds with a particular substance, this
   * is a defining relationship for that enzyme, out of several possible substance relationships.
   */
  isDefining?: Maybe<Scalars['Boolean']>;
  /**
   * A numeric factor for the relationship, for instance to express that the salt
   * of a substance has some percentage of the active substance in relation to some other.
   */
  amountQuantity?: Maybe<Quantity>;
  /**
   * A numeric factor for the relationship, for instance to express that the salt
   * of a substance has some percentage of the active substance in relation to some other.
   */
  amountRange?: Maybe<Range>;
  /**
   * A numeric factor for the relationship, for instance to express that the salt
   * of a substance has some percentage of the active substance in relation to some other.
   */
  amountRatio?: Maybe<Ratio>;
  /**
   * A numeric factor for the relationship, for instance to express that the salt
   * of a substance has some percentage of the active substance in relation to some other.
   */
  _amountString?: Maybe<Element>;
  /**
   * A numeric factor for the relationship, for instance to express that the salt
   * of a substance has some percentage of the active substance in relation to some other.
   */
  amountString?: Maybe<Scalars['String']>;
  /** For use when the numeric. */
  amountRatioLowLimit?: Maybe<Ratio>;
  /** An operator for the amount, for example 'average', 'approximately', 'less than'. */
  amountType?: Maybe<CodeableConcept>;
  /** Supporting literature. */
  source?: Maybe<Array<Maybe<SubstanceSpecificationrelationshipsource_Source_Union>>>;
};

/** Supporting literature. */
export type SubstanceSpecificationrelationshipsource_Source_Union = DocumentReference;

/** A pointer to another substance, as a resource or just a representational code. */
export type SubstanceSpecificationrelationshipsubstanceReference_SubstanceReference_Union = SubstanceSpecification;

/** Material or taxonomic/anatomical source for the substance. */
export type SubstanceSpecificationsourceMaterial_SourceMaterial_Union = SubstanceSourceMaterial;

/** Supporting literature. */
export type SubstanceSpecificationsource_Source_Union = DocumentReference;

export type SubstanceSpecificationstructure = {
  __typename?: 'SubstanceSpecificationstructure';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Stereochemistry type. */
  stereochemistry?: Maybe<CodeableConcept>;
  /** Optical activity type. */
  opticalActivity?: Maybe<CodeableConcept>;
  /** Molecular formula. */
  _molecularFormula?: Maybe<Element>;
  /** Molecular formula. */
  molecularFormula?: Maybe<Scalars['String']>;
  /**
   * Specified per moiety according to the Hill system, i.e. first C, then H, then
   * alphabetical, each moiety separated by a dot.
   */
  _molecularFormulaByMoiety?: Maybe<Element>;
  /**
   * Specified per moiety according to the Hill system, i.e. first C, then H, then
   * alphabetical, each moiety separated by a dot.
   */
  molecularFormulaByMoiety?: Maybe<Scalars['String']>;
  /** Applicable for single substances that contain a radionuclide or a non-natural isotopic ratio. */
  isotope?: Maybe<Array<Maybe<SubstanceSpecificationstructureisotope>>>;
  /** Supporting literature. */
  source?: Maybe<Array<Maybe<SubstanceSpecificationstructuresource_Source_Union>>>;
  /** Molecular structural representation. */
  representation?: Maybe<Array<Maybe<SubstanceSpecificationstructurerepresentation>>>;
};

export type SubstanceSpecificationstructureisotope = {
  __typename?: 'SubstanceSpecificationstructureisotope';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Substance identifier for each non-natural or radioisotope. */
  identifier?: Maybe<Identifier>;
  /** Substance name for each non-natural or radioisotope. */
  name?: Maybe<CodeableConcept>;
  /** The type of isotopic substitution present in a single substance. */
  substitution?: Maybe<CodeableConcept>;
  /** Half life - for a non-natural nuclide. */
  halfLife?: Maybe<Quantity>;
  /** The molecular weight or weight range (for proteins, polymers or nucleic acids). */
  molecularWeight?: Maybe<SubstanceSpecificationstructureisotopemolecularWeight>;
};

export type SubstanceSpecificationstructureisotopemolecularWeight = {
  __typename?: 'SubstanceSpecificationstructureisotopemolecularWeight';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The method by which the molecular weight was determined. */
  method?: Maybe<CodeableConcept>;
  /** Type of molecular weight such as exact, average (also known as. number average), weight average. */
  type?: Maybe<CodeableConcept>;
  /**
   * Used to capture quantitative values for a variety of elements. If only limits
   * are given, the arithmetic mean would be the average. If only a single definite
   * value for a given element is given, it would be captured in this field.
   */
  amount?: Maybe<Quantity>;
};

export type SubstanceSpecificationstructurerepresentation = {
  __typename?: 'SubstanceSpecificationstructurerepresentation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of structure (e.g. Full, Partial, Representative). */
  type?: Maybe<CodeableConcept>;
  /** The structural representation as text string in a format e.g. InChI, SMILES, MOLFILE, CDX. */
  _representation?: Maybe<Element>;
  /** The structural representation as text string in a format e.g. InChI, SMILES, MOLFILE, CDX. */
  representation?: Maybe<Scalars['String']>;
  /** An attached file with the structural representation. */
  attachment?: Maybe<Attachment>;
};

/** Supporting literature. */
export type SubstanceSpecificationstructuresource_Source_Union = DocumentReference;

export enum Substance_Enum_Schema {
  Substance = 'Substance'
}

export type Substanceingredient = {
  __typename?: 'Substanceingredient';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The amount of the ingredient in the substance - a concentration ratio. */
  quantity?: Maybe<Ratio>;
  /** Another substance that is a component of this substance. */
  substanceCodeableConcept: CodeableConcept;
  /** Another substance that is a component of this substance. */
  substanceReference: SubstanceingredientsubstanceReference_SubstanceReference_Union;
};

/** Another substance that is a component of this substance. */
export type SubstanceingredientsubstanceReference_SubstanceReference_Union = Substance;

export type Substanceinstance = {
  __typename?: 'Substanceinstance';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier associated with the package/container (usually a label affixed directly). */
  identifier?: Maybe<Identifier>;
  /** When the substance is no longer valid to use. For some substances, a single arbitrary date is used for expiry. */
  _expiry?: Maybe<Element>;
  /** When the substance is no longer valid to use. For some substances, a single arbitrary date is used for expiry. */
  expiry?: Maybe<Scalars['dateTime']>;
  /** The amount of the substance. */
  quantity?: Maybe<Quantity>;
};

/** Record of delivery of what is supplied. */
export type SupplyDelivery = {
  __typename?: 'SupplyDelivery';
  /** Type of resource */
  resourceType: SupplyDelivery_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier for the supply delivery event that is used to identify it across multiple disparate systems. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A plan, proposal or order that is fulfilled in whole or in part by this event. */
  basedOn?: Maybe<Array<Maybe<SupplyDeliverybasedOn_BasedOn_Union>>>;
  /** A larger event of which this particular event is a component or step. */
  partOf?: Maybe<Array<Maybe<SupplyDeliverypartOf_PartOf_Union>>>;
  /** A code specifying the state of the dispense event. */
  _status?: Maybe<Element>;
  /** A code specifying the state of the dispense event. */
  status?: Maybe<Scalars['code']>;
  /** A link to a resource representing the person whom the delivered item is for. */
  patient?: Maybe<SupplyDeliverypatient_Patient_Union>;
  /**
   * Indicates the type of dispensing event that is performed. Examples include:
   * Trial Fill, Completion of Trial, Partial Fill, Emergency Fill, Samples, etc.
   */
  type?: Maybe<CodeableConcept>;
  /** The item that is being delivered or has been supplied. */
  suppliedItem?: Maybe<SupplyDeliverysuppliedItem>;
  /** The date or time(s) the activity occurred. */
  _occurrenceDateTime?: Maybe<Element>;
  /** The date or time(s) the activity occurred. */
  occurrenceDateTime?: Maybe<Scalars['dateTime']>;
  /** The date or time(s) the activity occurred. */
  occurrencePeriod?: Maybe<Period>;
  /** The date or time(s) the activity occurred. */
  occurrenceTiming?: Maybe<Timing>;
  /** The individual responsible for dispensing the medication, supplier or device. */
  supplier?: Maybe<SupplyDeliverysupplier_Supplier_Union>;
  /** Identification of the facility/location where the Supply was shipped to, as part of the dispense event. */
  destination?: Maybe<SupplyDeliverydestination_Destination_Union>;
  /** Identifies the person who picked up the Supply. */
  receiver?: Maybe<Array<Maybe<SupplyDeliveryreceiver_Receiver_Union>>>;
};

export enum SupplyDelivery_Enum_Schema {
  SupplyDelivery = 'SupplyDelivery'
}

/** A plan, proposal or order that is fulfilled in whole or in part by this event. */
export type SupplyDeliverybasedOn_BasedOn_Union = SupplyRequest;

/** Identification of the facility/location where the Supply was shipped to, as part of the dispense event. */
export type SupplyDeliverydestination_Destination_Union = Location;

/** A larger event of which this particular event is a component or step. */
export type SupplyDeliverypartOf_PartOf_Union = SupplyDelivery | Contract;

/** A link to a resource representing the person whom the delivered item is for. */
export type SupplyDeliverypatient_Patient_Union = Patient;

/** Identifies the person who picked up the Supply. */
export type SupplyDeliveryreceiver_Receiver_Union = Practitioner | PractitionerRole;

export type SupplyDeliverysuppliedItem = {
  __typename?: 'SupplyDeliverysuppliedItem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The amount of supply that has been dispensed. Includes unit of measure. */
  quantity?: Maybe<Quantity>;
  /**
   * Identifies the medication, substance or device being dispensed. This is either
   * a link to a resource representing the details of the item or a code that
   * identifies the item from a known list.
   */
  itemCodeableConcept?: Maybe<CodeableConcept>;
  /**
   * Identifies the medication, substance or device being dispensed. This is either
   * a link to a resource representing the details of the item or a code that
   * identifies the item from a known list.
   */
  itemReference?: Maybe<SupplyDeliverysuppliedItemitemReference_ItemReference_Union>;
};

/**
 * Identifies the medication, substance or device being dispensed. This is either a
 * link to a resource representing the details of the item or a code that
 * identifies the item from a known list.
 */
export type SupplyDeliverysuppliedItemitemReference_ItemReference_Union = Medication | Substance | Device;

/** The individual responsible for dispensing the medication, supplier or device. */
export type SupplyDeliverysupplier_Supplier_Union = Practitioner | PractitionerRole | Organization;

/** A record of a request for a medication, substance or device used in the healthcare setting. */
export type SupplyRequest = {
  __typename?: 'SupplyRequest';
  /** Type of resource */
  resourceType: SupplyRequest_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Business identifiers assigned to this SupplyRequest by the author and/or other
   * systems. These identifiers remain constant as the resource is updated and
   * propagates from server to server.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Status of the supply request. */
  _status?: Maybe<Element>;
  /** Status of the supply request. */
  status?: Maybe<Scalars['code']>;
  /** Category of supply, e.g.  central, non-stock, etc. This is used to support work flows associated with the supply process. */
  category?: Maybe<CodeableConcept>;
  /** Indicates how quickly this SupplyRequest should be addressed with respect to other requests. */
  _priority?: Maybe<Element>;
  /** Indicates how quickly this SupplyRequest should be addressed with respect to other requests. */
  priority?: Maybe<Scalars['code']>;
  /**
   * The item that is requested to be supplied. This is either a link to a resource
   * representing the details of the item or a code that identifies the item from a known list.
   */
  itemCodeableConcept: CodeableConcept;
  /**
   * The item that is requested to be supplied. This is either a link to a resource
   * representing the details of the item or a code that identifies the item from a known list.
   */
  itemReference: SupplyRequestitemReference_ItemReference_Union;
  /** The amount that is being ordered of the indicated item. */
  quantity: Quantity;
  /** Specific parameters for the ordered item.  For example, the size of the indicated item. */
  parameter?: Maybe<Array<Maybe<SupplyRequestparameter>>>;
  /** When the request should be fulfilled. */
  _occurrenceDateTime?: Maybe<Element>;
  /** When the request should be fulfilled. */
  occurrenceDateTime?: Maybe<Scalars['dateTime']>;
  /** When the request should be fulfilled. */
  occurrencePeriod?: Maybe<Period>;
  /** When the request should be fulfilled. */
  occurrenceTiming?: Maybe<Timing>;
  /** When the request was made. */
  _authoredOn?: Maybe<Element>;
  /** When the request was made. */
  authoredOn?: Maybe<Scalars['dateTime']>;
  /** The device, practitioner, etc. who initiated the request. */
  requester?: Maybe<SupplyRequestrequester_Requester_Union>;
  /** Who is intended to fulfill the request. */
  supplier?: Maybe<Array<Maybe<SupplyRequestsupplier_Supplier_Union>>>;
  /** The reason why the supply item was requested. */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** The reason why the supply item was requested. */
  reasonReference?: Maybe<Array<Maybe<SupplyRequestreasonReference_ReasonReference_Union>>>;
  /** Where the supply is expected to come from. */
  deliverFrom?: Maybe<SupplyRequestdeliverFrom_DeliverFrom_Union>;
  /** Where the supply is destined to go. */
  deliverTo?: Maybe<SupplyRequestdeliverTo_DeliverTo_Union>;
};

export enum SupplyRequest_Enum_Schema {
  SupplyRequest = 'SupplyRequest'
}

/** Where the supply is expected to come from. */
export type SupplyRequestdeliverFrom_DeliverFrom_Union = Organization | Location;

/** Where the supply is destined to go. */
export type SupplyRequestdeliverTo_DeliverTo_Union = Organization | Location | Patient;

/**
 * The item that is requested to be supplied. This is either a link to a resource
 * representing the details of the item or a code that identifies the item from a known list.
 */
export type SupplyRequestitemReference_ItemReference_Union = Medication | Substance | Device;

export type SupplyRequestparameter = {
  __typename?: 'SupplyRequestparameter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A code or string that identifies the device detail being asserted. */
  code?: Maybe<CodeableConcept>;
  /** The value of the device detail. */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** The value of the device detail. */
  valueQuantity?: Maybe<Quantity>;
  /** The value of the device detail. */
  valueRange?: Maybe<Range>;
  /** The value of the device detail. */
  _valueBoolean?: Maybe<Element>;
  /** The value of the device detail. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
};

/** The reason why the supply item was requested. */
export type SupplyRequestreasonReference_ReasonReference_Union = Condition | Observation | DiagnosticReport | DocumentReference;

/** The device, practitioner, etc. who initiated the request. */
export type SupplyRequestrequester_Requester_Union = Practitioner | PractitionerRole | Organization | Patient | RelatedPerson | Device;

/** Who is intended to fulfill the request. */
export type SupplyRequestsupplier_Supplier_Union = Organization | HealthcareService;

/** A task to be performed. */
export type Task = {
  __typename?: 'Task';
  /** Type of resource */
  resourceType: Task_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The business identifier for this task. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The URL pointing to a *FHIR*-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this Task.
   */
  _instantiatesCanonical?: Maybe<Element>;
  /**
   * The URL pointing to a *FHIR*-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this Task.
   */
  instantiatesCanonical?: Maybe<Scalars['canonical']>;
  /**
   * The URL pointing to an *externally* maintained  protocol, guideline, orderset
   * or other definition that is adhered to in whole or in part by this Task.
   */
  _instantiatesUri?: Maybe<Element>;
  /**
   * The URL pointing to an *externally* maintained  protocol, guideline, orderset
   * or other definition that is adhered to in whole or in part by this Task.
   */
  instantiatesUri?: Maybe<Scalars['uri']>;
  /**
   * BasedOn refers to a higher-level authorization that triggered the creation of
   * the task.  It references a 'request' resource such as a ServiceRequest,
   * MedicationRequest, ServiceRequest, CarePlan, etc. which is distinct from the
   * 'request' resource the task is seeking to fulfill.  This latter resource is
   * referenced by FocusOn.  For example, based on a ServiceRequest (= BasedOn), a
   * task is created to fulfill a procedureRequest ( = FocusOn ) to collect a
   * specimen from a patient.
   */
  basedOn?: Maybe<Array<Maybe<TaskbasedOn_BasedOn_Union>>>;
  /** An identifier that links together multiple tasks and other requests that were created in the same context. */
  groupIdentifier?: Maybe<Identifier>;
  /** Task that this particular task is part of. */
  partOf?: Maybe<Array<Maybe<TaskpartOf_PartOf_Union>>>;
  /** The current status of the task. */
  _status?: Maybe<Element>;
  /** The current status of the task. */
  status: Scalars['code'];
  /** An explanation as to why this task is held, failed, was refused, etc. */
  statusReason?: Maybe<CodeableConcept>;
  /** Contains business-specific nuances of the business state. */
  businessStatus?: Maybe<CodeableConcept>;
  /**
   * Indicates the 'level' of actionability associated with the Task, i.e. i+R[9]Cs
   * this a proposed task, a planned task, an actionable task, etc.
   */
  _intent?: Maybe<Element>;
  /**
   * Indicates the 'level' of actionability associated with the Task, i.e. i+R[9]Cs
   * this a proposed task, a planned task, an actionable task, etc.
   */
  intent: Scalars['code'];
  /** Indicates how quickly the Task should be addressed with respect to other requests. */
  _priority?: Maybe<Element>;
  /** Indicates how quickly the Task should be addressed with respect to other requests. */
  priority?: Maybe<Scalars['code']>;
  /** A name or code (or both) briefly describing what the task involves. */
  code?: Maybe<CodeableConcept>;
  /** A free-text description of what is to be performed. */
  _description?: Maybe<Element>;
  /** A free-text description of what is to be performed. */
  description?: Maybe<Scalars['String']>;
  /** The request being actioned or the resource being manipulated by this task. */
  focus?: Maybe<Taskfocus_Focus_Union>;
  /** The entity who benefits from the performance of the service specified in the task (e.g., the patient). */
  for?: Maybe<Taskfor_For_Union>;
  /** The healthcare event  (e.g. a patient and healthcare provider interaction) during which this task was created. */
  encounter?: Maybe<Taskencounter_Encounter_Union>;
  /**
   * Identifies the time action was first taken against the task (start) and/or the
   * time final action was taken against the task prior to marking it as completed (end).
   */
  executionPeriod?: Maybe<Period>;
  /** The date and time this task was created. */
  _authoredOn?: Maybe<Element>;
  /** The date and time this task was created. */
  authoredOn?: Maybe<Scalars['dateTime']>;
  /** The date and time of last modification to this task. */
  _lastModified?: Maybe<Element>;
  /** The date and time of last modification to this task. */
  lastModified?: Maybe<Scalars['dateTime']>;
  /** The creator of the task. */
  requester?: Maybe<Taskrequester_Requester_Union>;
  /** The kind of participant that should perform the task. */
  performerType?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Individual organization or Device currently responsible for task execution. */
  owner?: Maybe<Taskowner_Owner_Union>;
  /** Principal physical location where the this task is performed. */
  location?: Maybe<Tasklocation_Location_Union>;
  /** A description or code indicating why this task needs to be performed. */
  reasonCode?: Maybe<CodeableConcept>;
  /** A resource reference indicating why this task needs to be performed. */
  reasonReference?: Maybe<TaskreasonReference_ReasonReference_Union>;
  /** Insurance plans, coverage extensions, pre-authorizations and/or pre-determinations that may be relevant to the Task. */
  insurance?: Maybe<Array<Maybe<Taskinsurance_Insurance_Union>>>;
  /** Free-text information captured about the task as it progresses. */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /**
   * Links to Provenance records for past versions of this Task that identify key
   * state transitions or updates that are likely to be relevant to a user looking
   * at the current version of the task.
   */
  relevantHistory?: Maybe<Array<Maybe<TaskrelevantHistory_RelevantHistory_Union>>>;
  /**
   * If the Task.focus is a request resource and the task is seeking fulfillment
   * (i.e. is asking for the request to be actioned), this element identifies any
   * limitations on what parts of the referenced request should be actioned.
   */
  restriction?: Maybe<Taskrestriction>;
  /** Additional information that may be needed in the execution of the task. */
  input?: Maybe<Array<Maybe<Taskinput>>>;
  /** Outputs produced by the Task. */
  output?: Maybe<Array<Maybe<Taskoutput>>>;
};

/** A comment associated with a task. */
export type TaskComment = {
  __typename?: 'TaskComment';
  /** Unique identifier for the comment. */
  id: Scalars['id'];
  /** The ID of the task this comment belongs to. */
  task_id: Scalars['String'];
  /** The ID of the person who wrote the comment. */
  author_id: Scalars['String'];
  /** The name of the person who wrote the comment. */
  author_name: Scalars['String'];
  /** The type of the person who wrote the comment (admin/practitioner). */
  author_type: Scalars['String'];
  /** The content of the comment. */
  message: Scalars['String'];
  /** The timestamp when the comment was created. */
  created_at: Scalars['String'];
  /** Array of user IDs who have read this comment. */
  read_by?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether this comment is internal to admins. */
  is_admin?: Maybe<Scalars['Boolean']>;
};

/** Input schema for creating a task comment. */
export type TaskComment_Input = {
  /** The ID of the task this comment belongs to. */
  task_id: Scalars['String'];
  /** The ID of the person who wrote the comment. */
  author_id: Scalars['String'];
  /** The name of the person who wrote the comment. */
  author_name: Scalars['String'];
  /** The type of the person who wrote the comment (admin/practitioner). */
  author_type: Scalars['String'];
  /** The content of the comment. */
  message: Scalars['String'];
  /** Whether this comment is internal to admins. */
  is_admin?: Maybe<Scalars['Boolean']>;
};

/** A task manager is a type of resource that is used to manage tasks and resources. */
export type TaskManager = {
  __typename?: 'TaskManager';
  /** Type of resource */
  resourceType: TaskManager_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** The name of the task manager, which is used in the task manager URL. */
  task_name?: Maybe<Scalars['String']>;
  /** The type of task that the task manager is responsible for. */
  task_type?: Maybe<Scalars['String']>;
  /** The user who created the task manager, which is used in the task manager URL. */
  created_by?: Maybe<Scalars['String']>;
  /** A list of the assignment history for the task manager. */
  assignment_history?: Maybe<Scalars['String']>;
  /** A list of the comments for the task manager. */
  comments?: Maybe<Scalars['String']>;
  /** The date and time that the task manager was created. */
  created_at?: Maybe<Scalars['dateTime']>;
  /** The date and time that the task manager was updated. */
  updated_at?: Maybe<Scalars['dateTime']>;
  /** The date and time that the task manager was deleted. */
  deleted_at?: Maybe<Scalars['dateTime']>;
  /** The user who last updated the task. */
  last_updated_by?: Maybe<Scalars['String']>;
  /** A flag to indicate if the task manager is deleted. */
  is_deleted?: Maybe<Scalars['Boolean']>;
  /** The result of the task manager. */
  result?: Maybe<Scalars['String']>;
  /** The message of the task manager. */
  message?: Maybe<Scalars['String']>;
  /** Status code for return type. */
  status_code?: Maybe<Scalars['Int']>;
  /** Display assigner or assignee name. */
  assigner_or_assignee_name?: Maybe<Scalars['String']>;
  /** Total pending low tasks. */
  total_pending_low?: Maybe<Scalars['Int']>;
  /** Total urgent high tasks. */
  total_urgent_high?: Maybe<Scalars['Int']>;
  /** Total overdue tasks. */
  total_overdue?: Maybe<Scalars['Int']>;
  /** Name of the user type that the task can be assigned. */
  who_can_assign?: Maybe<Scalars['String']>;
  /** Unique identifier for the patient associated with the task. */
  patient_id?: Maybe<Scalars['String']>;
  /** Name of the patient associated with the task. */
  patient_name?: Maybe<Scalars['String']>;
  /** The due date for the task. */
  due_date?: Maybe<Scalars['String']>;
  /** Total number of matching tasks across all pages. */
  total_count?: Maybe<Scalars['Int']>;
  /** Current page number. */
  current_page?: Maybe<Scalars['Int']>;
  /** Total number of pages available. */
  total_pages?: Maybe<Scalars['Int']>;
  /** Indicates if there are more pages available. */
  has_more?: Maybe<Scalars['Boolean']>;
  /** JSON string containing task counts for different tabs and filters. */
  tab_counts?: Maybe<Scalars['String']>;
};

export enum TaskManager_Enum_Input {
  TaskManager = 'TaskManager'
}

export enum TaskManager_Enum_Schema {
  TaskManager = 'TaskManager'
}

/** A task manager is a type of resource that is used to manage tasks and resources. */
export type TaskManager_Input = {
  /** Type of resource */
  resourceType: TaskManager_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** The name of the task manager, which is used in the task manager URL. */
  task_name?: Maybe<Scalars['String']>;
  /** The type of task that the task manager is responsible for. */
  task_type?: Maybe<Scalars['String']>;
  /** The user who created the task manager, which is used in the task manager URL. */
  created_by?: Maybe<Scalars['String']>;
  /** The type of the assigner, which is assigining the task manager. */
  assigner_type?: Maybe<Scalars['String']>;
  /** The id of the assigner, which is assigining the task manager. */
  assigner_id?: Maybe<Scalars['String']>;
  /** The type of the assignee, which is assigned the task manager. */
  assignee_type?: Maybe<Scalars['String']>;
  /** The id of the assignee, which is assigned the task manager. */
  assignee_id?: Maybe<Scalars['String']>;
  /** The priority of the task manager. */
  priority?: Maybe<Scalars['String']>;
  /** Additional notes for the task manager. */
  additional_notes?: Maybe<Scalars['String']>;
  /** Comments provided when reassigning a task. */
  assign_comments?: Maybe<Scalars['String']>;
  /** The list of assignment ids. */
  assignment_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The attachment of the task manager. */
  attachment?: Maybe<Scalars['String']>;
  /** Name of the user type that the task can be assigned. */
  who_can_assign?: Maybe<Scalars['String']>;
  /** Unique identifier for the patient associated with the task. */
  patient_id?: Maybe<Scalars['String']>;
  /** The note for the completion of task manager. */
  completion_note?: Maybe<Scalars['String']>;
  /** The due date for the task. */
  due_date?: Maybe<Scalars['String']>;
  /** JSON string of assignment history */
  assignment_history?: Maybe<Scalars['String']>;
  /** The user who last updated the task. */
  last_updated_by?: Maybe<Scalars['String']>;
  /** The ID of the task template/category being assigned. */
  task_category_id?: Maybe<Scalars['id']>;
  /** Indicates if the task is for a patient or practitioner (values: "patient" or "practitioner"). */
  task_for?: Maybe<Scalars['String']>;
  /** Indicates if the patient is registered (1) or unregistered (0). */
  is_patient?: Maybe<Scalars['Int']>;
  /** Email of the assignee for notifications. */
  assignee_email?: Maybe<Scalars['String']>;
};

export enum Task_Enum_Input {
  Task = 'Task'
}

export enum Task_Enum_Schema {
  Task = 'Task'
}

/** A task to be performed. */
export type Task_Input = {
  /** Type of resource */
  resourceType: Task_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The business identifier for this task. */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /**
   * The URL pointing to a *FHIR*-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this Task.
   */
  _instantiatesCanonical?: Maybe<Element_Input>;
  /**
   * The URL pointing to a *FHIR*-defined protocol, guideline, orderset or other
   * definition that is adhered to in whole or in part by this Task.
   */
  instantiatesCanonical?: Maybe<Scalars['canonical']>;
  /**
   * The URL pointing to an *externally* maintained  protocol, guideline, orderset
   * or other definition that is adhered to in whole or in part by this Task.
   */
  _instantiatesUri?: Maybe<Element_Input>;
  /**
   * The URL pointing to an *externally* maintained  protocol, guideline, orderset
   * or other definition that is adhered to in whole or in part by this Task.
   */
  instantiatesUri?: Maybe<Scalars['uri']>;
  /**
   * BasedOn refers to a higher-level authorization that triggered the creation of
   * the task.  It references a 'request' resource such as a ServiceRequest,
   * MedicationRequest, ServiceRequest, CarePlan, etc. which is distinct from the
   * 'request' resource the task is seeking to fulfill.  This latter resource is
   * referenced by FocusOn.  For example, based on a ServiceRequest (= BasedOn), a
   * task is created to fulfill a procedureRequest ( = FocusOn ) to collect a
   * specimen from a patient.
   */
  basedOn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** An identifier that links together multiple tasks and other requests that were created in the same context. */
  groupIdentifier?: Maybe<Identifier_Input>;
  /** Task that this particular task is part of. */
  partOf?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The current status of the task. */
  _status?: Maybe<Element_Input>;
  /** The current status of the task. */
  status: Scalars['code'];
  /** An explanation as to why this task is held, failed, was refused, etc. */
  statusReason?: Maybe<CodeableConcept_Input>;
  /** Contains business-specific nuances of the business state. */
  businessStatus?: Maybe<CodeableConcept_Input>;
  /**
   * Indicates the 'level' of actionability associated with the Task, i.e. i+R[9]Cs
   * this a proposed task, a planned task, an actionable task, etc.
   */
  _intent?: Maybe<Element_Input>;
  /**
   * Indicates the 'level' of actionability associated with the Task, i.e. i+R[9]Cs
   * this a proposed task, a planned task, an actionable task, etc.
   */
  intent: Scalars['code'];
  /** Indicates how quickly the Task should be addressed with respect to other requests. */
  _priority?: Maybe<Element_Input>;
  /** Indicates how quickly the Task should be addressed with respect to other requests. */
  priority?: Maybe<Scalars['code']>;
  /** A name or code (or both) briefly describing what the task involves. */
  code?: Maybe<CodeableConcept_Input>;
  /** A free-text description of what is to be performed. */
  _description?: Maybe<Element_Input>;
  /** A free-text description of what is to be performed. */
  description?: Maybe<Scalars['String']>;
  /** The request being actioned or the resource being manipulated by this task. */
  focus?: Maybe<Scalars['String']>;
  /** The entity who benefits from the performance of the service specified in the task (e.g., the patient). */
  for?: Maybe<Scalars['String']>;
  /** The healthcare event  (e.g. a patient and healthcare provider interaction) during which this task was created. */
  encounter?: Maybe<Scalars['String']>;
  /**
   * Identifies the time action was first taken against the task (start) and/or the
   * time final action was taken against the task prior to marking it as completed (end).
   */
  executionPeriod?: Maybe<Period_Input>;
  /** The date and time this task was created. */
  _authoredOn?: Maybe<Element_Input>;
  /** The date and time this task was created. */
  authoredOn?: Maybe<Scalars['dateTime']>;
  /** The date and time of last modification to this task. */
  _lastModified?: Maybe<Element_Input>;
  /** The date and time of last modification to this task. */
  lastModified?: Maybe<Scalars['dateTime']>;
  /** The creator of the task. */
  requester?: Maybe<Scalars['String']>;
  /** The kind of participant that should perform the task. */
  performerType?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Individual organization or Device currently responsible for task execution. */
  owner?: Maybe<Scalars['String']>;
  /** Principal physical location where the this task is performed. */
  location?: Maybe<Scalars['String']>;
  /** A description or code indicating why this task needs to be performed. */
  reasonCode?: Maybe<CodeableConcept_Input>;
  /** A resource reference indicating why this task needs to be performed. */
  reasonReference?: Maybe<Scalars['String']>;
  /** Insurance plans, coverage extensions, pre-authorizations and/or pre-determinations that may be relevant to the Task. */
  insurance?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Free-text information captured about the task as it progresses. */
  note?: Maybe<Array<Maybe<Annotation_Input>>>;
  /**
   * Links to Provenance records for past versions of this Task that identify key
   * state transitions or updates that are likely to be relevant to a user looking
   * at the current version of the task.
   */
  relevantHistory?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * If the Task.focus is a request resource and the task is seeking fulfillment
   * (i.e. is asking for the request to be actioned), this element identifies any
   * limitations on what parts of the referenced request should be actioned.
   */
  restriction?: Maybe<Taskrestriction_Input>;
  /** Additional information that may be needed in the execution of the task. */
  input?: Maybe<Array<Maybe<Taskinput_Input>>>;
  /** Outputs produced by the Task. */
  output?: Maybe<Array<Maybe<Taskoutput_Input>>>;
};

/**
 * BasedOn refers to a higher-level authorization that triggered the creation of
 * the task.  It references a 'request' resource such as a ServiceRequest,
 * MedicationRequest, ServiceRequest, CarePlan, etc. which is distinct from the
 * 'request' resource the task is seeking to fulfill.  This latter resource is
 * referenced by FocusOn.  For example, based on a ServiceRequest (= BasedOn), a
 * task is created to fulfill a procedureRequest ( = FocusOn ) to collect a
 * specimen from a patient.
 */
export type TaskbasedOn_BasedOn_Union = Resource;

/** The healthcare event  (e.g. a patient and healthcare provider interaction) during which this task was created. */
export type Taskencounter_Encounter_Union = Encounter;

/** The request being actioned or the resource being manipulated by this task. */
export type Taskfocus_Focus_Union = Resource;

/** The entity who benefits from the performance of the service specified in the task (e.g., the patient). */
export type Taskfor_For_Union = Resource;

export type Taskinput = {
  __typename?: 'Taskinput';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A code or description indicating how the input is intended to be used as part of the task execution. */
  type: CodeableConcept;
  /** The value of the input parameter as a basic type. */
  _valueBase64Binary?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueBase64Binary: Scalars['base64Binary'];
  /** The value of the input parameter as a basic type. */
  _valueBoolean?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueBoolean: Scalars['Boolean'];
  /** The value of the input parameter as a basic type. */
  _valueCanonical?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueCanonical: Scalars['canonical'];
  /** The value of the input parameter as a basic type. */
  _valueCode?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueCode: Scalars['code'];
  /** The value of the input parameter as a basic type. */
  _valueDate?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueDate: Scalars['date'];
  /** The value of the input parameter as a basic type. */
  _valueDateTime?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueDateTime: Scalars['dateTime'];
  /** The value of the input parameter as a basic type. */
  _valueDecimal?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueDecimal: Scalars['Float'];
  /** The value of the input parameter as a basic type. */
  _valueId?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueId: Scalars['id'];
  /** The value of the input parameter as a basic type. */
  _valueInstant?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueInstant: Scalars['instant'];
  /** The value of the input parameter as a basic type. */
  _valueInteger?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueInteger: Scalars['Int'];
  /** The value of the input parameter as a basic type. */
  _valueMarkdown?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueMarkdown: Scalars['String'];
  /** The value of the input parameter as a basic type. */
  _valueOid?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueOid: Scalars['oid'];
  /** The value of the input parameter as a basic type. */
  _valuePositiveInt?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valuePositiveInt: Scalars['positiveInt'];
  /** The value of the input parameter as a basic type. */
  _valueString?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueString: Scalars['String'];
  /** The value of the input parameter as a basic type. */
  _valueTime?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueTime: Scalars['time'];
  /** The value of the input parameter as a basic type. */
  _valueUnsignedInt?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueUnsignedInt: Scalars['unsignedInt'];
  /** The value of the input parameter as a basic type. */
  _valueUri?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueUri: Scalars['uri'];
  /** The value of the input parameter as a basic type. */
  _valueUrl?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueUrl: Scalars['url'];
  /** The value of the input parameter as a basic type. */
  _valueUuid?: Maybe<Element>;
  /** The value of the input parameter as a basic type. */
  valueUuid: Scalars['uuid'];
  /** The value of the input parameter as a basic type. */
  valueAddress: Address;
  /** The value of the input parameter as a basic type. */
  valueAge: Age;
  /** The value of the input parameter as a basic type. */
  valueAnnotation: Annotation;
  /** The value of the input parameter as a basic type. */
  valueAttachment: Attachment;
  /** The value of the input parameter as a basic type. */
  valueCodeableConcept: CodeableConcept;
  /** The value of the input parameter as a basic type. */
  valueCoding: Coding;
  /** The value of the input parameter as a basic type. */
  valueContactPoint: ContactPoint;
  /** The value of the input parameter as a basic type. */
  valueCount: Count;
  /** The value of the input parameter as a basic type. */
  valueDistance: Distance;
  /** The value of the input parameter as a basic type. */
  valueDuration: Duration;
  /** The value of the input parameter as a basic type. */
  valueHumanName: HumanName;
  /** The value of the input parameter as a basic type. */
  valueIdentifier: Identifier;
  /** The value of the input parameter as a basic type. */
  valueMoney: Money;
  /** The value of the input parameter as a basic type. */
  valuePeriod: Period;
  /** The value of the input parameter as a basic type. */
  valueQuantity: Quantity;
  /** The value of the input parameter as a basic type. */
  valueRange: Range;
  /** The value of the input parameter as a basic type. */
  valueRatio: Ratio;
  /** The value of the input parameter as a basic type. */
  valueReference: ResourceList;
  /** The value of the input parameter as a basic type. */
  valueSampledData: SampledData;
  /** The value of the input parameter as a basic type. */
  valueSignature: Signature;
  /** The value of the input parameter as a basic type. */
  valueTiming: Timing;
  /** The value of the input parameter as a basic type. */
  valueContactDetail: ContactDetail;
  /** The value of the input parameter as a basic type. */
  valueContributor: Contributor;
  /** The value of the input parameter as a basic type. */
  valueDataRequirement: DataRequirement;
  /** The value of the input parameter as a basic type. */
  valueExpression: Expression;
  /** The value of the input parameter as a basic type. */
  valueParameterDefinition: ParameterDefinition;
  /** The value of the input parameter as a basic type. */
  valueRelatedArtifact: RelatedArtifact;
  /** The value of the input parameter as a basic type. */
  valueTriggerDefinition: TriggerDefinition;
  /** The value of the input parameter as a basic type. */
  valueUsageContext: UsageContext;
  /** The value of the input parameter as a basic type. */
  valueDosage: Dosage;
};

export type Taskinput_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A code or description indicating how the input is intended to be used as part of the task execution. */
  type: CodeableConcept_Input;
  /** The value of the input parameter as a basic type. */
  _valueBase64Binary?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueBase64Binary: Scalars['base64Binary'];
  /** The value of the input parameter as a basic type. */
  _valueBoolean?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueBoolean: Scalars['Boolean'];
  /** The value of the input parameter as a basic type. */
  _valueCanonical?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueCanonical: Scalars['canonical'];
  /** The value of the input parameter as a basic type. */
  _valueCode?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueCode: Scalars['code'];
  /** The value of the input parameter as a basic type. */
  _valueDate?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueDate: Scalars['date'];
  /** The value of the input parameter as a basic type. */
  _valueDateTime?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueDateTime: Scalars['dateTime'];
  /** The value of the input parameter as a basic type. */
  _valueDecimal?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueDecimal: Scalars['Float'];
  /** The value of the input parameter as a basic type. */
  _valueId?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueId: Scalars['id'];
  /** The value of the input parameter as a basic type. */
  _valueInstant?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueInstant: Scalars['instant'];
  /** The value of the input parameter as a basic type. */
  _valueInteger?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueInteger: Scalars['Int'];
  /** The value of the input parameter as a basic type. */
  _valueMarkdown?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueMarkdown: Scalars['String'];
  /** The value of the input parameter as a basic type. */
  _valueOid?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueOid: Scalars['oid'];
  /** The value of the input parameter as a basic type. */
  _valuePositiveInt?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valuePositiveInt: Scalars['positiveInt'];
  /** The value of the input parameter as a basic type. */
  _valueString?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueString: Scalars['String'];
  /** The value of the input parameter as a basic type. */
  _valueTime?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueTime: Scalars['time'];
  /** The value of the input parameter as a basic type. */
  _valueUnsignedInt?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueUnsignedInt: Scalars['unsignedInt'];
  /** The value of the input parameter as a basic type. */
  _valueUri?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueUri: Scalars['uri'];
  /** The value of the input parameter as a basic type. */
  _valueUrl?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueUrl: Scalars['url'];
  /** The value of the input parameter as a basic type. */
  _valueUuid?: Maybe<Element_Input>;
  /** The value of the input parameter as a basic type. */
  valueUuid: Scalars['uuid'];
  /** The value of the input parameter as a basic type. */
  valueAddress: Address_Input;
  /** The value of the input parameter as a basic type. */
  valueAge: Age_Input;
  /** The value of the input parameter as a basic type. */
  valueAnnotation: Annotation_Input;
  /** The value of the input parameter as a basic type. */
  valueAttachment: Attachment_Input;
  /** The value of the input parameter as a basic type. */
  valueCodeableConcept: CodeableConcept_Input;
  /** The value of the input parameter as a basic type. */
  valueCoding: Coding_Input;
  /** The value of the input parameter as a basic type. */
  valueContactPoint: ContactPoint_Input;
  /** The value of the input parameter as a basic type. */
  valueCount: Count_Input;
  /** The value of the input parameter as a basic type. */
  valueDistance: Distance_Input;
  /** The value of the input parameter as a basic type. */
  valueDuration: Duration_Input;
  /** The value of the input parameter as a basic type. */
  valueHumanName: HumanName_Input;
  /** The value of the input parameter as a basic type. */
  valueIdentifier: Identifier_Input;
  /** The value of the input parameter as a basic type. */
  valueMoney: Money_Input;
  /** The value of the input parameter as a basic type. */
  valuePeriod: Period_Input;
  /** The value of the input parameter as a basic type. */
  valueQuantity: Quantity_Input;
  /** The value of the input parameter as a basic type. */
  valueRange: Range_Input;
  /** The value of the input parameter as a basic type. */
  valueRatio: Ratio_Input;
  /** The value of the input parameter as a basic type. */
  valueReference: Scalars['String'];
  /** The value of the input parameter as a basic type. */
  valueSampledData: SampledData_Input;
  /** The value of the input parameter as a basic type. */
  valueSignature: Signature_Input;
  /** The value of the input parameter as a basic type. */
  valueTiming: Timing_Input;
  /** The value of the input parameter as a basic type. */
  valueContactDetail: ContactDetail_Input;
  /** The value of the input parameter as a basic type. */
  valueContributor: Contributor_Input;
  /** The value of the input parameter as a basic type. */
  valueDataRequirement: DataRequirement_Input;
  /** The value of the input parameter as a basic type. */
  valueExpression: Expression_Input;
  /** The value of the input parameter as a basic type. */
  valueParameterDefinition: ParameterDefinition_Input;
  /** The value of the input parameter as a basic type. */
  valueRelatedArtifact: RelatedArtifact_Input;
  /** The value of the input parameter as a basic type. */
  valueTriggerDefinition: TriggerDefinition_Input;
  /** The value of the input parameter as a basic type. */
  valueUsageContext: UsageContext_Input;
  /** The value of the input parameter as a basic type. */
  valueDosage: Dosage_Input;
};

/** Insurance plans, coverage extensions, pre-authorizations and/or pre-determinations that may be relevant to the Task. */
export type Taskinsurance_Insurance_Union = Coverage | ClaimResponse;

/** Principal physical location where the this task is performed. */
export type Tasklocation_Location_Union = Location;

export type Taskoutput = {
  __typename?: 'Taskoutput';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of the Output parameter. */
  type: CodeableConcept;
  /** The value of the Output parameter as a basic type. */
  _valueBase64Binary?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueBase64Binary: Scalars['base64Binary'];
  /** The value of the Output parameter as a basic type. */
  _valueBoolean?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueBoolean: Scalars['Boolean'];
  /** The value of the Output parameter as a basic type. */
  _valueCanonical?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueCanonical: Scalars['canonical'];
  /** The value of the Output parameter as a basic type. */
  _valueCode?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueCode: Scalars['code'];
  /** The value of the Output parameter as a basic type. */
  _valueDate?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueDate: Scalars['date'];
  /** The value of the Output parameter as a basic type. */
  _valueDateTime?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueDateTime: Scalars['dateTime'];
  /** The value of the Output parameter as a basic type. */
  _valueDecimal?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueDecimal: Scalars['Float'];
  /** The value of the Output parameter as a basic type. */
  _valueId?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueId: Scalars['id'];
  /** The value of the Output parameter as a basic type. */
  _valueInstant?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueInstant: Scalars['instant'];
  /** The value of the Output parameter as a basic type. */
  _valueInteger?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueInteger: Scalars['Int'];
  /** The value of the Output parameter as a basic type. */
  _valueMarkdown?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueMarkdown: Scalars['String'];
  /** The value of the Output parameter as a basic type. */
  _valueOid?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueOid: Scalars['oid'];
  /** The value of the Output parameter as a basic type. */
  _valuePositiveInt?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valuePositiveInt: Scalars['positiveInt'];
  /** The value of the Output parameter as a basic type. */
  _valueString?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueString: Scalars['String'];
  /** The value of the Output parameter as a basic type. */
  _valueTime?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueTime: Scalars['time'];
  /** The value of the Output parameter as a basic type. */
  _valueUnsignedInt?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueUnsignedInt: Scalars['unsignedInt'];
  /** The value of the Output parameter as a basic type. */
  _valueUri?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueUri: Scalars['uri'];
  /** The value of the Output parameter as a basic type. */
  _valueUrl?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueUrl: Scalars['url'];
  /** The value of the Output parameter as a basic type. */
  _valueUuid?: Maybe<Element>;
  /** The value of the Output parameter as a basic type. */
  valueUuid: Scalars['uuid'];
  /** The value of the Output parameter as a basic type. */
  valueAddress: Address;
  /** The value of the Output parameter as a basic type. */
  valueAge: Age;
  /** The value of the Output parameter as a basic type. */
  valueAnnotation: Annotation;
  /** The value of the Output parameter as a basic type. */
  valueAttachment: Attachment;
  /** The value of the Output parameter as a basic type. */
  valueCodeableConcept: CodeableConcept;
  /** The value of the Output parameter as a basic type. */
  valueCoding: Coding;
  /** The value of the Output parameter as a basic type. */
  valueContactPoint: ContactPoint;
  /** The value of the Output parameter as a basic type. */
  valueCount: Count;
  /** The value of the Output parameter as a basic type. */
  valueDistance: Distance;
  /** The value of the Output parameter as a basic type. */
  valueDuration: Duration;
  /** The value of the Output parameter as a basic type. */
  valueHumanName: HumanName;
  /** The value of the Output parameter as a basic type. */
  valueIdentifier: Identifier;
  /** The value of the Output parameter as a basic type. */
  valueMoney: Money;
  /** The value of the Output parameter as a basic type. */
  valuePeriod: Period;
  /** The value of the Output parameter as a basic type. */
  valueQuantity: Quantity;
  /** The value of the Output parameter as a basic type. */
  valueRange: Range;
  /** The value of the Output parameter as a basic type. */
  valueRatio: Ratio;
  /** The value of the Output parameter as a basic type. */
  valueReference: ResourceList;
  /** The value of the Output parameter as a basic type. */
  valueSampledData: SampledData;
  /** The value of the Output parameter as a basic type. */
  valueSignature: Signature;
  /** The value of the Output parameter as a basic type. */
  valueTiming: Timing;
  /** The value of the Output parameter as a basic type. */
  valueContactDetail: ContactDetail;
  /** The value of the Output parameter as a basic type. */
  valueContributor: Contributor;
  /** The value of the Output parameter as a basic type. */
  valueDataRequirement: DataRequirement;
  /** The value of the Output parameter as a basic type. */
  valueExpression: Expression;
  /** The value of the Output parameter as a basic type. */
  valueParameterDefinition: ParameterDefinition;
  /** The value of the Output parameter as a basic type. */
  valueRelatedArtifact: RelatedArtifact;
  /** The value of the Output parameter as a basic type. */
  valueTriggerDefinition: TriggerDefinition;
  /** The value of the Output parameter as a basic type. */
  valueUsageContext: UsageContext;
  /** The value of the Output parameter as a basic type. */
  valueDosage: Dosage;
};

export type Taskoutput_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The name of the Output parameter. */
  type: CodeableConcept_Input;
  /** The value of the Output parameter as a basic type. */
  _valueBase64Binary?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueBase64Binary: Scalars['base64Binary'];
  /** The value of the Output parameter as a basic type. */
  _valueBoolean?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueBoolean: Scalars['Boolean'];
  /** The value of the Output parameter as a basic type. */
  _valueCanonical?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueCanonical: Scalars['canonical'];
  /** The value of the Output parameter as a basic type. */
  _valueCode?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueCode: Scalars['code'];
  /** The value of the Output parameter as a basic type. */
  _valueDate?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueDate: Scalars['date'];
  /** The value of the Output parameter as a basic type. */
  _valueDateTime?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueDateTime: Scalars['dateTime'];
  /** The value of the Output parameter as a basic type. */
  _valueDecimal?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueDecimal: Scalars['Float'];
  /** The value of the Output parameter as a basic type. */
  _valueId?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueId: Scalars['id'];
  /** The value of the Output parameter as a basic type. */
  _valueInstant?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueInstant: Scalars['instant'];
  /** The value of the Output parameter as a basic type. */
  _valueInteger?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueInteger: Scalars['Int'];
  /** The value of the Output parameter as a basic type. */
  _valueMarkdown?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueMarkdown: Scalars['String'];
  /** The value of the Output parameter as a basic type. */
  _valueOid?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueOid: Scalars['oid'];
  /** The value of the Output parameter as a basic type. */
  _valuePositiveInt?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valuePositiveInt: Scalars['positiveInt'];
  /** The value of the Output parameter as a basic type. */
  _valueString?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueString: Scalars['String'];
  /** The value of the Output parameter as a basic type. */
  _valueTime?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueTime: Scalars['time'];
  /** The value of the Output parameter as a basic type. */
  _valueUnsignedInt?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueUnsignedInt: Scalars['unsignedInt'];
  /** The value of the Output parameter as a basic type. */
  _valueUri?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueUri: Scalars['uri'];
  /** The value of the Output parameter as a basic type. */
  _valueUrl?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueUrl: Scalars['url'];
  /** The value of the Output parameter as a basic type. */
  _valueUuid?: Maybe<Element_Input>;
  /** The value of the Output parameter as a basic type. */
  valueUuid: Scalars['uuid'];
  /** The value of the Output parameter as a basic type. */
  valueAddress: Address_Input;
  /** The value of the Output parameter as a basic type. */
  valueAge: Age_Input;
  /** The value of the Output parameter as a basic type. */
  valueAnnotation: Annotation_Input;
  /** The value of the Output parameter as a basic type. */
  valueAttachment: Attachment_Input;
  /** The value of the Output parameter as a basic type. */
  valueCodeableConcept: CodeableConcept_Input;
  /** The value of the Output parameter as a basic type. */
  valueCoding: Coding_Input;
  /** The value of the Output parameter as a basic type. */
  valueContactPoint: ContactPoint_Input;
  /** The value of the Output parameter as a basic type. */
  valueCount: Count_Input;
  /** The value of the Output parameter as a basic type. */
  valueDistance: Distance_Input;
  /** The value of the Output parameter as a basic type. */
  valueDuration: Duration_Input;
  /** The value of the Output parameter as a basic type. */
  valueHumanName: HumanName_Input;
  /** The value of the Output parameter as a basic type. */
  valueIdentifier: Identifier_Input;
  /** The value of the Output parameter as a basic type. */
  valueMoney: Money_Input;
  /** The value of the Output parameter as a basic type. */
  valuePeriod: Period_Input;
  /** The value of the Output parameter as a basic type. */
  valueQuantity: Quantity_Input;
  /** The value of the Output parameter as a basic type. */
  valueRange: Range_Input;
  /** The value of the Output parameter as a basic type. */
  valueRatio: Ratio_Input;
  /** The value of the Output parameter as a basic type. */
  valueReference: Scalars['String'];
  /** The value of the Output parameter as a basic type. */
  valueSampledData: SampledData_Input;
  /** The value of the Output parameter as a basic type. */
  valueSignature: Signature_Input;
  /** The value of the Output parameter as a basic type. */
  valueTiming: Timing_Input;
  /** The value of the Output parameter as a basic type. */
  valueContactDetail: ContactDetail_Input;
  /** The value of the Output parameter as a basic type. */
  valueContributor: Contributor_Input;
  /** The value of the Output parameter as a basic type. */
  valueDataRequirement: DataRequirement_Input;
  /** The value of the Output parameter as a basic type. */
  valueExpression: Expression_Input;
  /** The value of the Output parameter as a basic type. */
  valueParameterDefinition: ParameterDefinition_Input;
  /** The value of the Output parameter as a basic type. */
  valueRelatedArtifact: RelatedArtifact_Input;
  /** The value of the Output parameter as a basic type. */
  valueTriggerDefinition: TriggerDefinition_Input;
  /** The value of the Output parameter as a basic type. */
  valueUsageContext: UsageContext_Input;
  /** The value of the Output parameter as a basic type. */
  valueDosage: Dosage_Input;
};

/** Individual organization or Device currently responsible for task execution. */
export type Taskowner_Owner_Union = Practitioner | PractitionerRole | Organization | CareTeam | HealthcareService | Patient | Device | RelatedPerson;

/** Task that this particular task is part of. */
export type TaskpartOf_PartOf_Union = Task;

/** A resource reference indicating why this task needs to be performed. */
export type TaskreasonReference_ReasonReference_Union = Resource;

/**
 * Links to Provenance records for past versions of this Task that identify key
 * state transitions or updates that are likely to be relevant to a user looking at
 * the current version of the task.
 */
export type TaskrelevantHistory_RelevantHistory_Union = Provenance;

/** The creator of the task. */
export type Taskrequester_Requester_Union = Device | Organization | Patient | Practitioner | PractitionerRole | RelatedPerson;

export type Taskrestriction = {
  __typename?: 'Taskrestriction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates the number of times the requested action should occur. */
  _repetitions?: Maybe<Element>;
  /** Indicates the number of times the requested action should occur. */
  repetitions?: Maybe<Scalars['positiveInt']>;
  /** Over what time-period is fulfillment sought. */
  period?: Maybe<Period>;
  /** For requests that are targeted to more than on potential recipient/target, for whom is fulfillment sought? */
  recipient?: Maybe<Array<Maybe<Taskrestrictionrecipient_Recipient_Union>>>;
};

export type Taskrestriction_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Indicates the number of times the requested action should occur. */
  _repetitions?: Maybe<Element_Input>;
  /** Indicates the number of times the requested action should occur. */
  repetitions?: Maybe<Scalars['positiveInt']>;
  /** Over what time-period is fulfillment sought. */
  period?: Maybe<Period_Input>;
  /** For requests that are targeted to more than on potential recipient/target, for whom is fulfillment sought? */
  recipient?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** For requests that are targeted to more than on potential recipient/target, for whom is fulfillment sought? */
export type Taskrestrictionrecipient_Recipient_Union = Patient | Practitioner | PractitionerRole | RelatedPerson | Group | Organization;

/** TasksMessages_Schema. */
export type TasksMessages = {
  __typename?: 'TasksMessages';
  /** Type of resource */
  resourceType: TasksMessages_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  taskmessage?: Maybe<Scalars['String']>;
  /** patientId Id. */
  typeOfMessage?: Maybe<Scalars['Int']>;
  /** patientId Id. */
  typeOfMessageForType?: Maybe<Scalars['Int']>;
  /** patientId Id. */
  typeOfMessageForTypeId?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
};

export enum TasksMessages_Enum {
  TasksMessages = 'TasksMessages'
}

export enum TasksMessages_Enum_Input {
  TasksMessages = 'TasksMessages'
}

/** TasksMessages */
export type TasksMessages_Input = {
  /** Type of resource */
  resourceType: TasksMessages_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  taskmessage?: Maybe<Scalars['String']>;
  /** patientId Id. */
  typeOfMessage?: Maybe<Scalars['Int']>;
  /** patientId Id. */
  typeOfMessageForType?: Maybe<Scalars['Int']>;
  /** patientId Id. */
  typeOfMessageForTypeId?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
};

/**
 * A TerminologyCapabilities resource documents a set of capabilities (behaviors)
 * of a FHIR Terminology Server that may be used as a statement of actual server
 * functionality or a statement of required or desired server implementation.
 */
export type TerminologyCapabilities = {
  __typename?: 'TerminologyCapabilities';
  /** Type of resource */
  resourceType: TerminologyCapabilities_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this terminology capabilities when it
   * is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this
   * terminology capabilities is (or will be) published. This URL can be the target
   * of a canonical reference. It SHALL remain the same when the terminology
   * capabilities is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this terminology capabilities when it
   * is referenced in a specification, model, design or an instance; also called
   * its canonical identifier. This SHOULD be globally unique and SHOULD be a
   * literal address at which at which an authoritative instance of this
   * terminology capabilities is (or will be) published. This URL can be the target
   * of a canonical reference. It SHALL remain the same when the terminology
   * capabilities is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * The identifier that is used to identify this version of the terminology
   * capabilities when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the terminology capabilities
   * author and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the terminology
   * capabilities when it is referenced in a specification, model, design or
   * instance. This is an arbitrary value managed by the terminology capabilities
   * author and is not expected to be globally unique. For example, it might be a
   * timestamp (e.g. yyyymmdd) if a managed version is not available. There is also
   * no expectation that versions can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the terminology capabilities. This name
   * should be usable as an identifier for the module by machine processing
   * applications such as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the terminology capabilities. This name
   * should be usable as an identifier for the module by machine processing
   * applications such as code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the terminology capabilities. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the terminology capabilities. */
  title?: Maybe<Scalars['String']>;
  /** The status of this terminology capabilities. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this terminology capabilities. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this terminology capabilities is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this terminology capabilities is authored for
   * testing purposes (or education/evaluation/marketing) and is not intended to be
   * used for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the terminology capabilities was
   * published. The date must change when the business version changes and it must
   * change if the status code changes. In addition, it should change when the
   * substantive content of the terminology capabilities changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the terminology capabilities was
   * published. The date must change when the business version changes and it must
   * change if the status code changes. In addition, it should change when the
   * substantive content of the terminology capabilities changes.
   */
  date: Scalars['dateTime'];
  /** The name of the organization or individual that published the terminology capabilities. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the terminology capabilities. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /**
   * A free text natural language description of the terminology capabilities from
   * a consumer's perspective. Typically, this is used when the capability
   * statement describes a desired rather than an actual solution, for example as a
   * formal expression of requirements as part of an RFP.
   */
  _description?: Maybe<Element>;
  /**
   * A free text natural language description of the terminology capabilities from
   * a consumer's perspective. Typically, this is used when the capability
   * statement describes a desired rather than an actual solution, for example as a
   * formal expression of requirements as part of an RFP.
   */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate terminology
   * capabilities instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the terminology capabilities is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this terminology capabilities is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this terminology capabilities is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the terminology capabilities and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the terminology capabilities.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the terminology capabilities and/or its
   * contents. Copyright statements are generally legal restrictions on the use and
   * publishing of the terminology capabilities.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * The way that this statement is intended to be used, to describe an actual
   * running instance of software, a particular product (kind, not instance of
   * software) or a class of implementation (e.g. a desired purchase).
   */
  _kind?: Maybe<Element>;
  /**
   * The way that this statement is intended to be used, to describe an actual
   * running instance of software, a particular product (kind, not instance of
   * software) or a class of implementation (e.g. a desired purchase).
   */
  kind: Scalars['code'];
  /**
   * Software that is covered by this terminology capability statement.  It is used
   * when the statement describes the capabilities of a particular software
   * version, independent of an installation.
   */
  software?: Maybe<TerminologyCapabilitiessoftware>;
  /**
   * Identifies a specific implementation instance that is described by the
   * terminology capability statement - i.e. a particular installation, rather than
   * the capabilities of a software program.
   */
  implementation?: Maybe<TerminologyCapabilitiesimplementation>;
  /** Whether the server supports lockedDate. */
  _lockedDate?: Maybe<Element>;
  /** Whether the server supports lockedDate. */
  lockedDate?: Maybe<Scalars['Boolean']>;
  /**
   * Identifies a code system that is supported by the server. If there is a no
   * code system URL, then this declares the general assumptions a client can make
   * about support for any CodeSystem resource.
   */
  codeSystem?: Maybe<Array<Maybe<TerminologyCapabilitiescodeSystem>>>;
  /** Information about the [ValueSet/$expand](valueset-operation-expand.html) operation. */
  expansion?: Maybe<TerminologyCapabilitiesexpansion>;
  /** The degree to which the server supports the code search parameter on ValueSet, if it is supported. */
  _codeSearch?: Maybe<Element>;
  /** The degree to which the server supports the code search parameter on ValueSet, if it is supported. */
  codeSearch?: Maybe<Scalars['code']>;
  /** Information about the [ValueSet/$validate-code](valueset-operation-validate-code.html) operation. */
  validateCode?: Maybe<TerminologyCapabilitiesvalidateCode>;
  /** Information about the [ConceptMap/$translate](conceptmap-operation-translate.html) operation. */
  translation?: Maybe<TerminologyCapabilitiestranslation>;
  /** Whether the $closure operation is supported. */
  closure?: Maybe<TerminologyCapabilitiesclosure>;
};

export enum TerminologyCapabilities_Enum_Schema {
  TerminologyCapabilities = 'TerminologyCapabilities'
}

export type TerminologyCapabilitiesclosure = {
  __typename?: 'TerminologyCapabilitiesclosure';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** If cross-system closure is supported. */
  _translation?: Maybe<Element>;
  /** If cross-system closure is supported. */
  translation?: Maybe<Scalars['Boolean']>;
};

export type TerminologyCapabilitiescodeSystem = {
  __typename?: 'TerminologyCapabilitiescodeSystem';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** URI for the Code System. */
  _uri?: Maybe<Element>;
  /** URI for the Code System. */
  uri?: Maybe<Scalars['canonical']>;
  /** For the code system, a list of versions that are supported by the server. */
  version?: Maybe<Array<Maybe<TerminologyCapabilitiescodeSystemversion>>>;
  /** True if subsumption is supported for this version of the code system. */
  _subsumption?: Maybe<Element>;
  /** True if subsumption is supported for this version of the code system. */
  subsumption?: Maybe<Scalars['Boolean']>;
};

export type TerminologyCapabilitiescodeSystemversion = {
  __typename?: 'TerminologyCapabilitiescodeSystemversion';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** For version-less code systems, there should be a single version with no identifier. */
  _code?: Maybe<Element>;
  /** For version-less code systems, there should be a single version with no identifier. */
  code?: Maybe<Scalars['String']>;
  /** If this is the default version for this code system. */
  _isDefault?: Maybe<Element>;
  /** If this is the default version for this code system. */
  isDefault?: Maybe<Scalars['Boolean']>;
  /** If the compositional grammar defined by the code system is supported. */
  _compositional?: Maybe<Element>;
  /** If the compositional grammar defined by the code system is supported. */
  compositional?: Maybe<Scalars['Boolean']>;
  /** Language Displays supported. */
  _language?: Maybe<Element>;
  /** Language Displays supported. */
  language?: Maybe<Array<Maybe<Scalars['code']>>>;
  /** Filter Properties supported. */
  filter?: Maybe<Array<Maybe<TerminologyCapabilitiescodeSystemversionfilter>>>;
  /** Properties supported for $lookup. */
  _property?: Maybe<Element>;
  /** Properties supported for $lookup. */
  property?: Maybe<Array<Maybe<Scalars['code']>>>;
};

export type TerminologyCapabilitiescodeSystemversionfilter = {
  __typename?: 'TerminologyCapabilitiescodeSystemversionfilter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Code of the property supported. */
  _code?: Maybe<Element>;
  /** Code of the property supported. */
  code: Scalars['code'];
  /** Operations supported for the property. */
  _op?: Maybe<Element>;
  /** Operations supported for the property. */
  op?: Maybe<Array<Scalars['code']>>;
};

export type TerminologyCapabilitiesexpansion = {
  __typename?: 'TerminologyCapabilitiesexpansion';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Whether the server can return nested value sets. */
  _hierarchical?: Maybe<Element>;
  /** Whether the server can return nested value sets. */
  hierarchical?: Maybe<Scalars['Boolean']>;
  /** Whether the server supports paging on expansion. */
  _paging?: Maybe<Element>;
  /** Whether the server supports paging on expansion. */
  paging?: Maybe<Scalars['Boolean']>;
  /** Allow request for incomplete expansions? */
  _incomplete?: Maybe<Element>;
  /** Allow request for incomplete expansions? */
  incomplete?: Maybe<Scalars['Boolean']>;
  /** Supported expansion parameter. */
  parameter?: Maybe<Array<Maybe<TerminologyCapabilitiesexpansionparameter>>>;
  /** Documentation about text searching works. */
  _textFilter?: Maybe<Element>;
  /** Documentation about text searching works. */
  textFilter?: Maybe<Scalars['String']>;
};

export type TerminologyCapabilitiesexpansionparameter = {
  __typename?: 'TerminologyCapabilitiesexpansionparameter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Expansion Parameter name. */
  _name?: Maybe<Element>;
  /** Expansion Parameter name. */
  name: Scalars['code'];
  /** Description of support for parameter. */
  _documentation?: Maybe<Element>;
  /** Description of support for parameter. */
  documentation?: Maybe<Scalars['String']>;
};

export type TerminologyCapabilitiesimplementation = {
  __typename?: 'TerminologyCapabilitiesimplementation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Information about the specific installation that this terminology capability statement relates to. */
  _description?: Maybe<Element>;
  /** Information about the specific installation that this terminology capability statement relates to. */
  description: Scalars['String'];
  /** An absolute base URL for the implementation. */
  _url?: Maybe<Element>;
  /** An absolute base URL for the implementation. */
  url?: Maybe<Scalars['url']>;
};

export type TerminologyCapabilitiessoftware = {
  __typename?: 'TerminologyCapabilitiessoftware';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Name the software is known by. */
  _name?: Maybe<Element>;
  /** Name the software is known by. */
  name: Scalars['String'];
  /** The version identifier for the software covered by this statement. */
  _version?: Maybe<Element>;
  /** The version identifier for the software covered by this statement. */
  version?: Maybe<Scalars['String']>;
};

export type TerminologyCapabilitiestranslation = {
  __typename?: 'TerminologyCapabilitiestranslation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Whether the client must identify the map. */
  _needsMap?: Maybe<Element>;
  /** Whether the client must identify the map. */
  needsMap: Scalars['Boolean'];
};

export type TerminologyCapabilitiesvalidateCode = {
  __typename?: 'TerminologyCapabilitiesvalidateCode';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Whether translations are validated. */
  _translations?: Maybe<Element>;
  /** Whether translations are validated. */
  translations: Scalars['Boolean'];
};

/** A summary of information based on the results of executing a TestScript. */
export type TestReport = {
  __typename?: 'TestReport';
  /** Type of resource */
  resourceType: TestReport_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifier for the TestScript assigned for external purposes outside the context of FHIR. */
  identifier?: Maybe<Identifier>;
  /** A free text natural language name identifying the executed TestScript. */
  _name?: Maybe<Element>;
  /** A free text natural language name identifying the executed TestScript. */
  name?: Maybe<Scalars['String']>;
  /** The current state of this test report. */
  _status?: Maybe<Element>;
  /** The current state of this test report. */
  status: Scalars['code'];
  /**
   * Ideally this is an absolute URL that is used to identify the version-specific
   * TestScript that was executed, matching the `TestScript.url`.
   */
  testScript: TestReporttestScript_TestScript_Union;
  /** The overall result from the execution of the TestScript. */
  _result?: Maybe<Element>;
  /** The overall result from the execution of the TestScript. */
  result: Scalars['code'];
  /** The final score (percentage of tests passed) resulting from the execution of the TestScript. */
  _score?: Maybe<Element>;
  /** The final score (percentage of tests passed) resulting from the execution of the TestScript. */
  score?: Maybe<Scalars['Float']>;
  /** Name of the tester producing this report (Organization or individual). */
  _tester?: Maybe<Element>;
  /** Name of the tester producing this report (Organization or individual). */
  tester?: Maybe<Scalars['String']>;
  /** When the TestScript was executed and this TestReport was generated. */
  _issued?: Maybe<Element>;
  /** When the TestScript was executed and this TestReport was generated. */
  issued?: Maybe<Scalars['dateTime']>;
  /** A participant in the test execution, either the execution engine, a client, or a server. */
  participant?: Maybe<Array<Maybe<TestReportparticipant>>>;
  /** The results of the series of required setup operations before the tests were executed. */
  setup?: Maybe<TestReportsetup>;
  /** A test executed from the test script. */
  test?: Maybe<Array<Maybe<TestReporttest>>>;
  /**
   * The results of the series of operations required to clean up after all the
   * tests were executed (successfully or otherwise).
   */
  teardown?: Maybe<TestReportteardown>;
};

export enum TestReport_Enum_Schema {
  TestReport = 'TestReport'
}

export type TestReportparticipant = {
  __typename?: 'TestReportparticipant';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of participant. */
  _type?: Maybe<Element>;
  /** The type of participant. */
  type: Scalars['code'];
  /** The uri of the participant. An absolute URL is preferred. */
  _uri?: Maybe<Element>;
  /** The uri of the participant. An absolute URL is preferred. */
  uri: Scalars['uri'];
  /** The display name of the participant. */
  _display?: Maybe<Element>;
  /** The display name of the participant. */
  display?: Maybe<Scalars['String']>;
};

export type TestReportsetup = {
  __typename?: 'TestReportsetup';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Action would contain either an operation or an assertion. */
  action?: Maybe<Array<TestReportsetupaction>>;
};

export type TestReportsetupaction = {
  __typename?: 'TestReportsetupaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The operation performed. */
  operation?: Maybe<TestReportsetupactionoperation>;
  /** The results of the assertion performed on the previous operations. */
  assert?: Maybe<TestReportsetupactionassert>;
};

export type TestReportsetupactionassert = {
  __typename?: 'TestReportsetupactionassert';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The result of this assertion. */
  _result?: Maybe<Element>;
  /** The result of this assertion. */
  result: Scalars['code'];
  /** An explanatory message associated with the result. */
  _message?: Maybe<Element>;
  /** An explanatory message associated with the result. */
  message?: Maybe<Scalars['String']>;
  /** A link to further details on the result. */
  _detail?: Maybe<Element>;
  /** A link to further details on the result. */
  detail?: Maybe<Scalars['String']>;
};

export type TestReportsetupactionoperation = {
  __typename?: 'TestReportsetupactionoperation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The result of this operation. */
  _result?: Maybe<Element>;
  /** The result of this operation. */
  result: Scalars['code'];
  /** An explanatory message associated with the result. */
  _message?: Maybe<Element>;
  /** An explanatory message associated with the result. */
  message?: Maybe<Scalars['String']>;
  /** A link to further details on the result. */
  _detail?: Maybe<Element>;
  /** A link to further details on the result. */
  detail?: Maybe<Scalars['uri']>;
};

export type TestReportteardown = {
  __typename?: 'TestReportteardown';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The teardown action will only contain an operation. */
  action?: Maybe<Array<TestReportteardownaction>>;
};

export type TestReportteardownaction = {
  __typename?: 'TestReportteardownaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
};

export type TestReporttest = {
  __typename?: 'TestReporttest';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of this test used for tracking/logging purposes by test engines. */
  _name?: Maybe<Element>;
  /** The name of this test used for tracking/logging purposes by test engines. */
  name?: Maybe<Scalars['String']>;
  /** A short description of the test used by test engines for tracking and reporting purposes. */
  _description?: Maybe<Element>;
  /** A short description of the test used by test engines for tracking and reporting purposes. */
  description?: Maybe<Scalars['String']>;
  /** Action would contain either an operation or an assertion. */
  action?: Maybe<Array<TestReporttestaction>>;
};

/**
 * Ideally this is an absolute URL that is used to identify the version-specific
 * TestScript that was executed, matching the `TestScript.url`.
 */
export type TestReporttestScript_TestScript_Union = TestScript;

export type TestReporttestaction = {
  __typename?: 'TestReporttestaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
};

/**
 * A structured set of tests against a FHIR server or client implementation to
 * determine compliance against the FHIR specification.
 */
export type TestScript = {
  __typename?: 'TestScript';
  /** Type of resource */
  resourceType: TestScript_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this test script when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this test script is (or
   * will be) published. This URL can be the target of a canonical reference. It
   * SHALL remain the same when the test script is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this test script when it is
   * referenced in a specification, model, design or an instance; also called its
   * canonical identifier. This SHOULD be globally unique and SHOULD be a literal
   * address at which at which an authoritative instance of this test script is (or
   * will be) published. This URL can be the target of a canonical reference. It
   * SHALL remain the same when the test script is stored on different servers.
   */
  url: Scalars['uri'];
  /**
   * A formal identifier that is used to identify this test script when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Identifier>;
  /**
   * The identifier that is used to identify this version of the test script when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the test script author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the test script when
   * it is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the test script author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the test script. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the test script. This name should be
   * usable as an identifier for the module by machine processing applications such
   * as code generation.
   */
  name: Scalars['String'];
  /** A short, descriptive, user-friendly title for the test script. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the test script. */
  title?: Maybe<Scalars['String']>;
  /** The status of this test script. Enables tracking the life-cycle of the content. */
  _status?: Maybe<Element>;
  /** The status of this test script. Enables tracking the life-cycle of the content. */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this test script is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this test script is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /**
   * The date  (and optionally time) when the test script was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the test script changes.
   */
  _date?: Maybe<Element>;
  /**
   * The date  (and optionally time) when the test script was published. The date
   * must change when the business version changes and it must change if the status
   * code changes. In addition, it should change when the substantive content of
   * the test script changes.
   */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the test script. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the test script. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /** A free text natural language description of the test script from a consumer's perspective. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the test script from a consumer's perspective. */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate test script instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the test script is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Explanation of why this test script is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this test script is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the test script and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the test script.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the test script and/or its contents.
   * Copyright statements are generally legal restrictions on the use and
   * publishing of the test script.
   */
  copyright?: Maybe<Scalars['String']>;
  /** An abstract server used in operations within this test script in the origin element. */
  origin?: Maybe<Array<Maybe<TestScriptorigin>>>;
  /** An abstract server used in operations within this test script in the destination element. */
  destination?: Maybe<Array<Maybe<TestScriptdestination>>>;
  /** The required capability must exist and are assumed to function correctly on the FHIR server being tested. */
  metadata?: Maybe<TestScriptmetadata>;
  /** Fixture in the test script - by reference (uri). All fixtures are required for the test script to execute. */
  fixture?: Maybe<Array<Maybe<TestScriptfixture>>>;
  /** Reference to the profile to be used for validation. */
  profile?: Maybe<Array<Maybe<TestScriptprofile_Profile_Union>>>;
  /** Variable is set based either on element value in response body or on header field value in the response headers. */
  variable?: Maybe<Array<Maybe<TestScriptvariable>>>;
  /** A series of required setup operations before tests are executed. */
  setup?: Maybe<TestScriptsetup>;
  /** A test in this script. */
  test?: Maybe<Array<Maybe<TestScripttest>>>;
  /** A series of operations required to clean up after all the tests are executed (successfully or otherwise). */
  teardown?: Maybe<TestScriptteardown>;
};

export enum TestScript_Enum_Schema {
  TestScript = 'TestScript'
}

export type TestScriptdestination = {
  __typename?: 'TestScriptdestination';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Abstract name given to a destination server in this test script.  The name is provided as a number starting at 1. */
  _index?: Maybe<Element>;
  /** Abstract name given to a destination server in this test script.  The name is provided as a number starting at 1. */
  index: Scalars['Int'];
  /** The type of destination profile the test system supports. */
  profile: Coding;
};

export type TestScriptfixture = {
  __typename?: 'TestScriptfixture';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Whether or not to implicitly create the fixture during setup. If true, the
   * fixture is automatically created on each server being tested during setup,
   * therefore no create operation is required for this fixture in the
   * TestScript.setup section.
   */
  _autocreate?: Maybe<Element>;
  /**
   * Whether or not to implicitly create the fixture during setup. If true, the
   * fixture is automatically created on each server being tested during setup,
   * therefore no create operation is required for this fixture in the
   * TestScript.setup section.
   */
  autocreate: Scalars['Boolean'];
  /**
   * Whether or not to implicitly delete the fixture during teardown. If true, the
   * fixture is automatically deleted on each server being tested during teardown,
   * therefore no delete operation is required for this fixture in the
   * TestScript.teardown section.
   */
  _autodelete?: Maybe<Element>;
  /**
   * Whether or not to implicitly delete the fixture during teardown. If true, the
   * fixture is automatically deleted on each server being tested during teardown,
   * therefore no delete operation is required for this fixture in the
   * TestScript.teardown section.
   */
  autodelete: Scalars['Boolean'];
  /** Reference to the resource (containing the contents of the resource needed for operations). */
  resource?: Maybe<TestScriptfixtureresource_Resource_Union>;
};

/** Reference to the resource (containing the contents of the resource needed for operations). */
export type TestScriptfixtureresource_Resource_Union = Resource;

export type TestScriptmetadata = {
  __typename?: 'TestScriptmetadata';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A link to the FHIR specification that this test is covering. */
  link?: Maybe<Array<Maybe<TestScriptmetadatalink>>>;
  /** Capabilities that must exist and are assumed to function correctly on the FHIR server being tested. */
  capability?: Maybe<Array<TestScriptmetadatacapability>>;
};

export type TestScriptmetadatacapability = {
  __typename?: 'TestScriptmetadatacapability';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Whether or not the test execution will require the given capabilities of the
   * server in order for this test script to execute.
   */
  _required?: Maybe<Element>;
  /**
   * Whether or not the test execution will require the given capabilities of the
   * server in order for this test script to execute.
   */
  required: Scalars['Boolean'];
  /**
   * Whether or not the test execution will validate the given capabilities of the
   * server in order for this test script to execute.
   */
  _validated?: Maybe<Element>;
  /**
   * Whether or not the test execution will validate the given capabilities of the
   * server in order for this test script to execute.
   */
  validated: Scalars['Boolean'];
  /** Description of the capabilities that this test script is requiring the server to support. */
  _description?: Maybe<Element>;
  /** Description of the capabilities that this test script is requiring the server to support. */
  description?: Maybe<Scalars['String']>;
  /** Which origin server these requirements apply to. */
  _origin?: Maybe<Element>;
  /** Which origin server these requirements apply to. */
  origin?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Which server these requirements apply to. */
  _destination?: Maybe<Element>;
  /** Which server these requirements apply to. */
  destination?: Maybe<Scalars['Int']>;
  /** Links to the FHIR specification that describes this interaction and the resources involved in more detail. */
  _link?: Maybe<Element>;
  /** Links to the FHIR specification that describes this interaction and the resources involved in more detail. */
  link?: Maybe<Array<Maybe<Scalars['uri']>>>;
  /**
   * Minimum capabilities required of server for test script to execute
   * successfully.   If server does not meet at a minimum the referenced capability
   * statement, then all tests in this script are skipped.
   */
  _capabilities?: Maybe<Element>;
  /**
   * Minimum capabilities required of server for test script to execute
   * successfully.   If server does not meet at a minimum the referenced capability
   * statement, then all tests in this script are skipped.
   */
  capabilities: Scalars['canonical'];
};

export type TestScriptmetadatalink = {
  __typename?: 'TestScriptmetadatalink';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** URL to a particular requirement or feature within the FHIR specification. */
  _url?: Maybe<Element>;
  /** URL to a particular requirement or feature within the FHIR specification. */
  url: Scalars['uri'];
  /** Short description of the link. */
  _description?: Maybe<Element>;
  /** Short description of the link. */
  description?: Maybe<Scalars['String']>;
};

export type TestScriptorigin = {
  __typename?: 'TestScriptorigin';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Abstract name given to an origin server in this test script.  The name is provided as a number starting at 1. */
  _index?: Maybe<Element>;
  /** Abstract name given to an origin server in this test script.  The name is provided as a number starting at 1. */
  index: Scalars['Int'];
  /** The type of origin profile the test system supports. */
  profile: Coding;
};

/** Reference to the profile to be used for validation. */
export type TestScriptprofile_Profile_Union = Resource;

export type TestScriptsetup = {
  __typename?: 'TestScriptsetup';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Action would contain either an operation or an assertion. */
  action?: Maybe<Array<TestScriptsetupaction>>;
};

export type TestScriptsetupaction = {
  __typename?: 'TestScriptsetupaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The operation to perform. */
  operation?: Maybe<TestScriptsetupactionoperation>;
  /** Evaluates the results of previous operations to determine if the server under test behaves appropriately. */
  assert?: Maybe<TestScriptsetupactionassert>;
};

export type TestScriptsetupactionassert = {
  __typename?: 'TestScriptsetupactionassert';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The label would be used for tracking/logging purposes by test engines. */
  _label?: Maybe<Element>;
  /** The label would be used for tracking/logging purposes by test engines. */
  label?: Maybe<Scalars['String']>;
  /** The description would be used by test engines for tracking and reporting purposes. */
  _description?: Maybe<Element>;
  /** The description would be used by test engines for tracking and reporting purposes. */
  description?: Maybe<Scalars['String']>;
  /** The direction to use for the assertion. */
  _direction?: Maybe<Element>;
  /** The direction to use for the assertion. */
  direction?: Maybe<Scalars['code']>;
  /**
   * Id of the source fixture used as the contents to be evaluated by either the
   * 'source/expression' or 'sourceId/path' definition.
   */
  _compareToSourceId?: Maybe<Element>;
  /**
   * Id of the source fixture used as the contents to be evaluated by either the
   * 'source/expression' or 'sourceId/path' definition.
   */
  compareToSourceId?: Maybe<Scalars['String']>;
  /**
   * The FHIRPath expression to evaluate against the source fixture. When
   * compareToSourceId is defined, either compareToSourceExpression or
   * compareToSourcePath must be defined, but not both.
   */
  _compareToSourceExpression?: Maybe<Element>;
  /**
   * The FHIRPath expression to evaluate against the source fixture. When
   * compareToSourceId is defined, either compareToSourceExpression or
   * compareToSourcePath must be defined, but not both.
   */
  compareToSourceExpression?: Maybe<Scalars['String']>;
  /**
   * XPath or JSONPath expression to evaluate against the source fixture. When
   * compareToSourceId is defined, either compareToSourceExpression or
   * compareToSourcePath must be defined, but not both.
   */
  _compareToSourcePath?: Maybe<Element>;
  /**
   * XPath or JSONPath expression to evaluate against the source fixture. When
   * compareToSourceId is defined, either compareToSourceExpression or
   * compareToSourcePath must be defined, but not both.
   */
  compareToSourcePath?: Maybe<Scalars['String']>;
  /** The mime-type contents to compare against the request or response message 'Content-Type' header. */
  _contentType?: Maybe<Element>;
  /** The mime-type contents to compare against the request or response message 'Content-Type' header. */
  contentType?: Maybe<Scalars['code']>;
  /** The FHIRPath expression to be evaluated against the request or response message contents - HTTP headers and payload. */
  _expression?: Maybe<Element>;
  /** The FHIRPath expression to be evaluated against the request or response message contents - HTTP headers and payload. */
  expression?: Maybe<Scalars['String']>;
  /** The HTTP header field name e.g. 'Location'. */
  _headerField?: Maybe<Element>;
  /** The HTTP header field name e.g. 'Location'. */
  headerField?: Maybe<Scalars['String']>;
  /** The ID of a fixture.  Asserts that the response contains at a minimum the fixture specified by minimumId. */
  _minimumId?: Maybe<Element>;
  /** The ID of a fixture.  Asserts that the response contains at a minimum the fixture specified by minimumId. */
  minimumId?: Maybe<Scalars['String']>;
  /** Whether or not the test execution performs validation on the bundle navigation links. */
  _navigationLinks?: Maybe<Element>;
  /** Whether or not the test execution performs validation on the bundle navigation links. */
  navigationLinks?: Maybe<Scalars['Boolean']>;
  /** The operator type defines the conditional behavior of the assert. If not defined, the default is equals. */
  _operator?: Maybe<Element>;
  /** The operator type defines the conditional behavior of the assert. If not defined, the default is equals. */
  operator?: Maybe<Scalars['code']>;
  /** The XPath or JSONPath expression to be evaluated against the fixture representing the response received from server. */
  _path?: Maybe<Element>;
  /** The XPath or JSONPath expression to be evaluated against the fixture representing the response received from server. */
  path?: Maybe<Scalars['String']>;
  /** The request method or HTTP operation code to compare against that used by the client system under test. */
  _requestMethod?: Maybe<Element>;
  /** The request method or HTTP operation code to compare against that used by the client system under test. */
  requestMethod?: Maybe<Scalars['code']>;
  /** The value to use in a comparison against the request URL path string. */
  _requestURL?: Maybe<Element>;
  /** The value to use in a comparison against the request URL path string. */
  requestURL?: Maybe<Scalars['String']>;
  /** The type of the resource.  See http://build.fhir.org/resourcelist.html. */
  _resource?: Maybe<Element>;
  /** The type of the resource.  See http://build.fhir.org/resourcelist.html. */
  resource?: Maybe<Scalars['code']>;
  /**
   * okay | created | noContent | notModified | bad | forbidden | notFound |
   * methodNotAllowed | conflict | gone | preconditionFailed | unprocessable.
   */
  _response?: Maybe<Element>;
  /**
   * okay | created | noContent | notModified | bad | forbidden | notFound |
   * methodNotAllowed | conflict | gone | preconditionFailed | unprocessable.
   */
  response?: Maybe<Scalars['code']>;
  /** The value of the HTTP response code to be tested. */
  _responseCode?: Maybe<Element>;
  /** The value of the HTTP response code to be tested. */
  responseCode?: Maybe<Scalars['String']>;
  /** Fixture to evaluate the XPath/JSONPath expression or the headerField  against. */
  _sourceId?: Maybe<Element>;
  /** Fixture to evaluate the XPath/JSONPath expression or the headerField  against. */
  sourceId?: Maybe<Scalars['id']>;
  /** The ID of the Profile to validate against. */
  _validateProfileId?: Maybe<Element>;
  /** The ID of the Profile to validate against. */
  validateProfileId?: Maybe<Scalars['id']>;
  /** The value to compare to. */
  _value?: Maybe<Element>;
  /** The value to compare to. */
  value?: Maybe<Scalars['String']>;
  /** Whether or not the test execution will produce a warning only on error for this assert. */
  _warningOnly?: Maybe<Element>;
  /** Whether or not the test execution will produce a warning only on error for this assert. */
  warningOnly: Scalars['Boolean'];
};

export type TestScriptsetupactionoperation = {
  __typename?: 'TestScriptsetupactionoperation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Server interaction or operation type. */
  type?: Maybe<Coding>;
  /** The type of the resource.  See http://build.fhir.org/resourcelist.html. */
  _resource?: Maybe<Element>;
  /** The type of the resource.  See http://build.fhir.org/resourcelist.html. */
  resource?: Maybe<Scalars['code']>;
  /** The label would be used for tracking/logging purposes by test engines. */
  _label?: Maybe<Element>;
  /** The label would be used for tracking/logging purposes by test engines. */
  label?: Maybe<Scalars['String']>;
  /** The description would be used by test engines for tracking and reporting purposes. */
  _description?: Maybe<Element>;
  /** The description would be used by test engines for tracking and reporting purposes. */
  description?: Maybe<Scalars['String']>;
  /** The mime-type to use for RESTful operation in the 'Accept' header. */
  _accept?: Maybe<Element>;
  /** The mime-type to use for RESTful operation in the 'Accept' header. */
  accept?: Maybe<Scalars['code']>;
  /** The mime-type to use for RESTful operation in the 'Content-Type' header. */
  _contentType?: Maybe<Element>;
  /** The mime-type to use for RESTful operation in the 'Content-Type' header. */
  contentType?: Maybe<Scalars['code']>;
  /**
   * The server where the request message is destined for.  Must be one of the
   * server numbers listed in TestScript.destination section.
   */
  _destination?: Maybe<Element>;
  /**
   * The server where the request message is destined for.  Must be one of the
   * server numbers listed in TestScript.destination section.
   */
  destination?: Maybe<Scalars['Int']>;
  /**
   * Whether or not to implicitly send the request url in encoded format. The
   * default is true to match the standard RESTful client behavior. Set to false
   * when communicating with a server that does not support encoded url paths.
   */
  _encodeRequestUrl?: Maybe<Element>;
  /**
   * Whether or not to implicitly send the request url in encoded format. The
   * default is true to match the standard RESTful client behavior. Set to false
   * when communicating with a server that does not support encoded url paths.
   */
  encodeRequestUrl: Scalars['Boolean'];
  /** The HTTP method the test engine MUST use for this operation regardless of any other operation details. */
  _method?: Maybe<Element>;
  /** The HTTP method the test engine MUST use for this operation regardless of any other operation details. */
  method?: Maybe<Scalars['code']>;
  /**
   * The server where the request message originates from.  Must be one of the
   * server numbers listed in TestScript.origin section.
   */
  _origin?: Maybe<Element>;
  /**
   * The server where the request message originates from.  Must be one of the
   * server numbers listed in TestScript.origin section.
   */
  origin?: Maybe<Scalars['Int']>;
  /** Path plus parameters after [type].  Used to set parts of the request URL explicitly. */
  _params?: Maybe<Element>;
  /** Path plus parameters after [type].  Used to set parts of the request URL explicitly. */
  params?: Maybe<Scalars['String']>;
  /** Header elements would be used to set HTTP headers. */
  requestHeader?: Maybe<Array<Maybe<TestScriptsetupactionoperationrequestHeader>>>;
  /** The fixture id (maybe new) to map to the request. */
  _requestId?: Maybe<Element>;
  /** The fixture id (maybe new) to map to the request. */
  requestId?: Maybe<Scalars['id']>;
  /** The fixture id (maybe new) to map to the response. */
  _responseId?: Maybe<Element>;
  /** The fixture id (maybe new) to map to the response. */
  responseId?: Maybe<Scalars['id']>;
  /** The id of the fixture used as the body of a PUT or POST request. */
  _sourceId?: Maybe<Element>;
  /** The id of the fixture used as the body of a PUT or POST request. */
  sourceId?: Maybe<Scalars['id']>;
  /** Id of fixture used for extracting the [id],  [type], and [vid] for GET requests. */
  _targetId?: Maybe<Element>;
  /** Id of fixture used for extracting the [id],  [type], and [vid] for GET requests. */
  targetId?: Maybe<Scalars['id']>;
  /** Complete request URL. */
  _url?: Maybe<Element>;
  /** Complete request URL. */
  url?: Maybe<Scalars['String']>;
};

export type TestScriptsetupactionoperationrequestHeader = {
  __typename?: 'TestScriptsetupactionoperationrequestHeader';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The HTTP header field e.g. 'Accept'. */
  _field?: Maybe<Element>;
  /** The HTTP header field e.g. 'Accept'. */
  field: Scalars['String'];
  /** The value of the header e.g. 'application/fhir+xml'. */
  _value?: Maybe<Element>;
  /** The value of the header e.g. 'application/fhir+xml'. */
  value: Scalars['String'];
};

export type TestScriptteardown = {
  __typename?: 'TestScriptteardown';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The teardown action will only contain an operation. */
  action?: Maybe<Array<TestScriptteardownaction>>;
};

export type TestScriptteardownaction = {
  __typename?: 'TestScriptteardownaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
};

export type TestScripttest = {
  __typename?: 'TestScripttest';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The name of this test used for tracking/logging purposes by test engines. */
  _name?: Maybe<Element>;
  /** The name of this test used for tracking/logging purposes by test engines. */
  name?: Maybe<Scalars['String']>;
  /** A short description of the test used by test engines for tracking and reporting purposes. */
  _description?: Maybe<Element>;
  /** A short description of the test used by test engines for tracking and reporting purposes. */
  description?: Maybe<Scalars['String']>;
  /** Action would contain either an operation or an assertion. */
  action?: Maybe<Array<TestScripttestaction>>;
};

export type TestScripttestaction = {
  __typename?: 'TestScripttestaction';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
};

export type TestScriptvariable = {
  __typename?: 'TestScriptvariable';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Descriptive name for this variable. */
  _name?: Maybe<Element>;
  /** Descriptive name for this variable. */
  name: Scalars['String'];
  /** A default, hard-coded, or user-defined value for this variable. */
  _defaultValue?: Maybe<Element>;
  /** A default, hard-coded, or user-defined value for this variable. */
  defaultValue?: Maybe<Scalars['String']>;
  /** A free text natural language description of the variable and its purpose. */
  _description?: Maybe<Element>;
  /** A free text natural language description of the variable and its purpose. */
  description?: Maybe<Scalars['String']>;
  /**
   * The FHIRPath expression to evaluate against the fixture body. When variables
   * are defined, only one of either expression, headerField or path must be specified.
   */
  _expression?: Maybe<Element>;
  /**
   * The FHIRPath expression to evaluate against the fixture body. When variables
   * are defined, only one of either expression, headerField or path must be specified.
   */
  expression?: Maybe<Scalars['String']>;
  /** Will be used to grab the HTTP header field value from the headers that sourceId is pointing to. */
  _headerField?: Maybe<Element>;
  /** Will be used to grab the HTTP header field value from the headers that sourceId is pointing to. */
  headerField?: Maybe<Scalars['String']>;
  /** Displayable text string with hint help information to the user when entering a default value. */
  _hint?: Maybe<Element>;
  /** Displayable text string with hint help information to the user when entering a default value. */
  hint?: Maybe<Scalars['String']>;
  /**
   * XPath or JSONPath to evaluate against the fixture body.  When variables are
   * defined, only one of either expression, headerField or path must be specified.
   */
  _path?: Maybe<Element>;
  /**
   * XPath or JSONPath to evaluate against the fixture body.  When variables are
   * defined, only one of either expression, headerField or path must be specified.
   */
  path?: Maybe<Scalars['String']>;
  /** Fixture to evaluate the XPath/JSONPath expression or the headerField  against within this variable. */
  _sourceId?: Maybe<Element>;
  /** Fixture to evaluate the XPath/JSONPath expression or the headerField  against within this variable. */
  sourceId?: Maybe<Scalars['id']>;
};

/**
 * Base StructureDefinition for Timing Type: Specifies an event that may occur
 * multiple times. Timing schedules are used to record when things are planned,
 * expected or requested to occur. The most common usage is in dosage instructions
 * for medications. They are also used when planning care of various kinds, and may
 * be used for reporting the schedule to which past regular activities were carried out.
 */
export type Timing = {
  __typename?: 'Timing';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifies specific times when the event occurs. */
  _event?: Maybe<Element>;
  /** Identifies specific times when the event occurs. */
  event?: Maybe<Array<Maybe<Scalars['dateTime']>>>;
  /** A set of rules that describe when the event is scheduled. */
  repeat?: Maybe<Element>;
  /**
   * A code for the timing schedule (or just text in code.text). Some codes such as
   * BID are ubiquitous, but many institutions define their own additional codes.
   * If a code is provided, the code is understood to be a complete statement of
   * whatever is specified in the structured timing data, and either the code or
   * the data may be used to interpret the Timing, with the exception that
   * .repeat.bounds still applies over the code (and is not contained in the code).
   */
  code?: Maybe<CodeableConcept>;
};

/**
 * Base StructureDefinition for Timing Type: Specifies an event that may occur
 * multiple times. Timing schedules are used to record when things are planned,
 * expected or requested to occur. The most common usage is in dosage instructions
 * for medications. They are also used when planning care of various kinds, and may
 * be used for reporting the schedule to which past regular activities were carried out.
 */
export type Timing_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Identifies specific times when the event occurs. */
  _event?: Maybe<Element_Input>;
  /** Identifies specific times when the event occurs. */
  event?: Maybe<Array<Maybe<Scalars['dateTime']>>>;
  /** A set of rules that describe when the event is scheduled. */
  repeat?: Maybe<Element_Input>;
  /**
   * A code for the timing schedule (or just text in code.text). Some codes such as
   * BID are ubiquitous, but many institutions define their own additional codes.
   * If a code is provided, the code is understood to be a complete statement of
   * whatever is specified in the structured timing data, and either the code or
   * the data may be used to interpret the Timing, with the exception that
   * .repeat.bounds still applies over the code (and is not contained in the code).
   */
  code?: Maybe<CodeableConcept_Input>;
};

/**
 * Base StructureDefinition for TriggerDefinition Type: A description of a
 * triggering event. Triggering events can be named events, data events, or
 * periodic, as determined by the type element.
 */
export type TriggerDefinition = {
  __typename?: 'TriggerDefinition';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** The type of triggering event. */
  _type?: Maybe<Element>;
  /** The type of triggering event. */
  type: Scalars['code'];
  /**
   * A formal name for the event. This may be an absolute URI that identifies the
   * event formally (e.g. from a trigger registry), or a simple relative URI that
   * identifies the event in a local context.
   */
  _name?: Maybe<Element>;
  /**
   * A formal name for the event. This may be an absolute URI that identifies the
   * event formally (e.g. from a trigger registry), or a simple relative URI that
   * identifies the event in a local context.
   */
  name?: Maybe<Scalars['String']>;
  /** The timing of the event (if this is a periodic trigger). */
  timingTiming?: Maybe<Timing>;
  /** The timing of the event (if this is a periodic trigger). */
  timingReference?: Maybe<TriggerDefinitiontimingReference_TimingReference_Union>;
  /** The timing of the event (if this is a periodic trigger). */
  _timingDate?: Maybe<Element>;
  /** The timing of the event (if this is a periodic trigger). */
  timingDate?: Maybe<Scalars['date']>;
  /** The timing of the event (if this is a periodic trigger). */
  _timingDateTime?: Maybe<Element>;
  /** The timing of the event (if this is a periodic trigger). */
  timingDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The triggering data of the event (if this is a data trigger). If more than one
   * data is requirement is specified, then all the data requirements must be true.
   */
  data?: Maybe<Array<Maybe<DataRequirement>>>;
  /**
   * A boolean-valued expression that is evaluated in the context of the container
   * of the trigger definition and returns whether or not the trigger fires.
   */
  condition?: Maybe<Expression>;
};

/**
 * Base StructureDefinition for TriggerDefinition Type: A description of a
 * triggering event. Triggering events can be named events, data events, or
 * periodic, as determined by the type element.
 */
export type TriggerDefinition_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The type of triggering event. */
  _type?: Maybe<Element_Input>;
  /** The type of triggering event. */
  type: Scalars['code'];
  /**
   * A formal name for the event. This may be an absolute URI that identifies the
   * event formally (e.g. from a trigger registry), or a simple relative URI that
   * identifies the event in a local context.
   */
  _name?: Maybe<Element_Input>;
  /**
   * A formal name for the event. This may be an absolute URI that identifies the
   * event formally (e.g. from a trigger registry), or a simple relative URI that
   * identifies the event in a local context.
   */
  name?: Maybe<Scalars['String']>;
  /** The timing of the event (if this is a periodic trigger). */
  timingTiming?: Maybe<Timing_Input>;
  /** The timing of the event (if this is a periodic trigger). */
  timingReference?: Maybe<Scalars['String']>;
  /** The timing of the event (if this is a periodic trigger). */
  _timingDate?: Maybe<Element_Input>;
  /** The timing of the event (if this is a periodic trigger). */
  timingDate?: Maybe<Scalars['date']>;
  /** The timing of the event (if this is a periodic trigger). */
  _timingDateTime?: Maybe<Element_Input>;
  /** The timing of the event (if this is a periodic trigger). */
  timingDateTime?: Maybe<Scalars['dateTime']>;
  /**
   * The triggering data of the event (if this is a data trigger). If more than one
   * data is requirement is specified, then all the data requirements must be true.
   */
  data?: Maybe<Array<Maybe<DataRequirement_Input>>>;
  /**
   * A boolean-valued expression that is evaluated in the context of the container
   * of the trigger definition and returns whether or not the trigger fires.
   */
  condition?: Maybe<Expression_Input>;
};

/** The timing of the event (if this is a periodic trigger). */
export type TriggerDefinitiontimingReference_TimingReference_Union = Schedule;

export type UnreadCommentCountResponse = {
  __typename?: 'UnreadCommentCountResponse';
  /** Number of unread comments */
  count?: Maybe<Scalars['Int']>;
  /** Response message */
  message?: Maybe<Scalars['String']>;
};

/**
 * Base StructureDefinition for UsageContext Type: Specifies clinical/business/etc.
 * metadata that can be used to retrieve, index and/or categorize an artifact. This
 * metadata can either be specific to the applicable population (e.g., age
 * category, DRG) or the specific context of care (e.g., venue, care setting,
 * provider of care).
 */
export type UsageContext = {
  __typename?: 'UsageContext';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** A code that identifies the type of context being specified by this usage context. */
  code: Coding;
  /** A value that defines the context specified in this context of use. The interpretation of the value is defined by the code. */
  valueCodeableConcept: CodeableConcept;
  /** A value that defines the context specified in this context of use. The interpretation of the value is defined by the code. */
  valueQuantity: Quantity;
  /** A value that defines the context specified in this context of use. The interpretation of the value is defined by the code. */
  valueRange: Range;
  /** A value that defines the context specified in this context of use. The interpretation of the value is defined by the code. */
  valueReference: UsageContextvalueReference_ValueReference_Union;
};

/**
 * Base StructureDefinition for UsageContext Type: Specifies clinical/business/etc.
 * metadata that can be used to retrieve, index and/or categorize an artifact. This
 * metadata can either be specific to the applicable population (e.g., age
 * category, DRG) or the specific context of care (e.g., venue, care setting,
 * provider of care).
 */
export type UsageContext_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A code that identifies the type of context being specified by this usage context. */
  code: Coding_Input;
  /** A value that defines the context specified in this context of use. The interpretation of the value is defined by the code. */
  valueCodeableConcept: CodeableConcept_Input;
  /** A value that defines the context specified in this context of use. The interpretation of the value is defined by the code. */
  valueQuantity: Quantity_Input;
  /** A value that defines the context specified in this context of use. The interpretation of the value is defined by the code. */
  valueRange: Range_Input;
  /** A value that defines the context specified in this context of use. The interpretation of the value is defined by the code. */
  valueReference: Scalars['String'];
};

/** A value that defines the context specified in this context of use. The interpretation of the value is defined by the code. */
export type UsageContextvalueReference_ValueReference_Union = PlanDefinition | ResearchStudy | InsurancePlan | HealthcareService | Group | Location | Organization;

/**
 * A financial tool for tracking value accrued for a particular purpose.  In the
 * healthcare field, used to track charges for a patient, cost centers, etc.
 */
export type User = {
  __typename?: 'User';
  /** Type of resource */
  resourceType: User_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /** First Name used for the account when displaying it to humans in reports, etc. */
  title?: Maybe<Scalars['String']>;
  /** First Name used for the account when displaying it to humans in reports, etc. */
  firstName?: Maybe<Scalars['String']>;
  /** Last Name used for the account when displaying it to humans in reports, etc. */
  familyName?: Maybe<Scalars['String']>;
  /** Last Name used for the account when displaying it to humans in reports, etc. */
  lastName?: Maybe<Scalars['String']>;
  /** Last Name used for the account when displaying it to humans in reports, etc. */
  middleName?: Maybe<Scalars['String']>;
  /** Email used for the account when displaying it to humans in reports, etc. */
  email?: Maybe<Scalars['String']>;
  /** Email used for the account when displaying it to humans in reports, etc. */
  password?: Maybe<Scalars['String']>;
  /** Phone Number used for the account when displaying it to humans in reports, etc. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** IdentificationKey for the account when displaying it to humans in reports, etc. */
  identificationKey?: Maybe<Scalars['String']>;
  /** User Type used for the account when displaying it to humans in reports, etc. */
  userType?: Maybe<Scalars['String']>;
  /** year_of_birth used for the account when displaying it to humans in reports, etc. */
  year_of_birth?: Maybe<Scalars['String']>;
  /** year_of_birth used for the account when displaying it to humans in reports, etc. */
  accountStatus?: Maybe<Scalars['Int']>;
  /** IdentificationKey for the account when displaying it to humans in reports, etc. */
  uploadCVUrl?: Maybe<Scalars['String']>;
  /** IdentificationKey for the account when displaying it to humans in reports, etc. */
  orgId?: Maybe<Scalars['String']>;
  /** IdentificationKey for the account when displaying it to humans in reports, etc. */
  gender?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  confirmationCode?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  status?: Maybe<Scalars['Int']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  message?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  preferredTimeOfContact?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  messageText?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  approved?: Maybe<Scalars['Int']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  confirmation_code?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  details?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  loginType?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  code?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  verificationCode?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  newPassword?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  userId?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  oldpassword?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  roleId?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  tokenresult?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  roleTypeName?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  roleName?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  roleRank?: Maybe<Scalars['Int']>;
  /** A language the practitioner can use in patient communication. */
  communication?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Image of the person. */
  photo?: Maybe<Array<Maybe<Attachment>>>;
  /** Guardian First Name used for the account when displaying it to humans in reports, etc. */
  guardianFirstName?: Maybe<Scalars['String']>;
  /** Guardian Surname is used for the account when displaying it to humans in reports, etc. */
  guardianSurname?: Maybe<Scalars['String']>;
  /** Relation to Patient is  used for the account when displaying it to humans in reports, etc. */
  relationtoPatient?: Maybe<Scalars['String']>;
};

export enum User_Enum_Input {
  User = 'User'
}

export enum User_Enum_Schema {
  User = 'User'
}

/** About User Details */
export type User_Input = {
  /** Type of resource */
  resourceType: User_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /** First Name used for the account when displaying it to humans in reports, etc. */
  title?: Maybe<Scalars['String']>;
  /** First Name used for the account when displaying it to humans in reports, etc. */
  firstName?: Maybe<Scalars['String']>;
  /** Last Name used for the account when displaying it to humans in reports, etc. */
  familyName?: Maybe<Scalars['String']>;
  /** Last Name used for the account when displaying it to humans in reports, etc. */
  lastName?: Maybe<Scalars['String']>;
  /** Last Name used for the account when displaying it to humans in reports, etc. */
  middleName?: Maybe<Scalars['String']>;
  /** Email used for the account when displaying it to humans in reports, etc. */
  email?: Maybe<Scalars['String']>;
  /** Email used for the account when displaying it to humans in reports, etc. */
  password?: Maybe<Scalars['String']>;
  /** Phone Number used for the account when displaying it to humans in reports, etc. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** IdentificationKey for the account when displaying it to humans in reports, etc. */
  identificationKey?: Maybe<Scalars['String']>;
  /** User Type used for the account when displaying it to humans in reports, etc. */
  userType?: Maybe<Scalars['String']>;
  /** year_of_birth used for the account when displaying it to humans in reports, etc. */
  year_of_birth?: Maybe<Scalars['String']>;
  /** year_of_birth used for the account when displaying it to humans in reports, etc. */
  accountStatus?: Maybe<Scalars['Int']>;
  /** IdentificationKey for the account when displaying it to humans in reports, etc. */
  uploadCVUrl?: Maybe<Scalars['String']>;
  /** IdentificationKey for the account when displaying it to humans in reports, etc. */
  orgId?: Maybe<Scalars['String']>;
  /** IdentificationKey for the account when displaying it to humans in reports, etc. */
  gender?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  confirmationCode?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  status?: Maybe<Scalars['Int']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  message?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  preferredTimeOfContact?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  messageText?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  approved?: Maybe<Scalars['Int']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  confirmation_code?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  details?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  loginType?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  code?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  verificationCode?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  newPassword?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  userId?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  oldpassword?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  roleId?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  roleTypeName?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  roleName?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  roleRank?: Maybe<Scalars['Int']>;
  /** A language the practitioner can use in patient communication. */
  communication?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /** Image of the person. */
  photo?: Maybe<Array<Maybe<Attachment_Input>>>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  fromAdmin?: Maybe<Scalars['Int']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  fromAdminEmail?: Maybe<Scalars['String']>;
  /** confirmationCode for the account when displaying it to humans in reports, etc. */
  refreshToken?: Maybe<Scalars['String']>;
  /** Guardian First Name used for the account when displaying it to humans in reports, etc. */
  guardianFirstName?: Maybe<Scalars['String']>;
  /** Guardian Surname is used for the account when displaying it to humans in reports, etc. */
  guardianSurname?: Maybe<Scalars['String']>;
  /** Relation to Patient is  used for the account when displaying it to humans in reports, etc. */
  relationtoPatient?: Maybe<Scalars['String']>;
};

/**
 * A ValueSet resource instance specifies a set of codes drawn from one or more
 * code systems, intended for use in a particular context. Value sets link between
 * [[[CodeSystem]]] definitions and their use in [coded
 * elements](terminologies.html).
 */
export type ValueSet = {
  __typename?: 'ValueSet';
  /** Type of resource */
  resourceType: ValueSet_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /** Value Set Parent to get Sub Types. */
  parent?: Maybe<ValueSetParentExtension_Input>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An absolute URI that is used to identify this value set when it is referenced
   * in a specification, model, design or an instance; also called its canonical
   * identifier. This SHOULD be globally unique and SHOULD be a literal address at
   * which at which an authoritative instance of this value set is (or will be)
   * published. This URL can be the target of a canonical reference. It SHALL
   * remain the same when the value set is stored on different servers.
   */
  _url?: Maybe<Element>;
  /**
   * An absolute URI that is used to identify this value set when it is referenced
   * in a specification, model, design or an instance; also called its canonical
   * identifier. This SHOULD be globally unique and SHOULD be a literal address at
   * which at which an authoritative instance of this value set is (or will be)
   * published. This URL can be the target of a canonical reference. It SHALL
   * remain the same when the value set is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this value set when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /**
   * The identifier that is used to identify this version of the value set when it
   * is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the value set author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element>;
  /**
   * The identifier that is used to identify this version of the value set when it
   * is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the value set author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the value set. This name should be usable
   * as an identifier for the module by machine processing applications such as
   * code generation.
   */
  _name?: Maybe<Element>;
  /**
   * A natural language name identifying the value set. This name should be usable
   * as an identifier for the module by machine processing applications such as
   * code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the value set. */
  _title?: Maybe<Element>;
  /** A short, descriptive, user-friendly title for the value set. */
  title?: Maybe<Scalars['String']>;
  /**
   * The status of this value set. Enables tracking the life-cycle of the content.
   * The status of the value set applies to the value set definition
   * (ValueSet.compose) and the associated ValueSet metadata. Expansions do not have a state.
   */
  _status?: Maybe<Element>;
  /**
   * The status of this value set. Enables tracking the life-cycle of the content.
   * The status of the value set applies to the value set definition
   * (ValueSet.compose) and the associated ValueSet metadata. Expansions do not have a state.
   */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this value set is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element>;
  /**
   * A Boolean value to indicate that this value set is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /** The date (and optionally time) when the value set was created or revised (e.g. the 'content logical definition'). */
  _date?: Maybe<Element>;
  /** The date (and optionally time) when the value set was created or revised (e.g. the 'content logical definition'). */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the value set. */
  _publisher?: Maybe<Element>;
  /** The name of the organization or individual that published the value set. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail>>>;
  /**
   * A free text natural language description of the value set from a consumer's
   * perspective. The textual description specifies the span of meanings for
   * concepts to be included within the Value Set Expansion, and also may specify
   * the intended use and limitations of the Value Set.
   */
  _description?: Maybe<Element>;
  /**
   * A free text natural language description of the value set from a consumer's
   * perspective. The textual description specifies the span of meanings for
   * concepts to be included within the Value Set Expansion, and also may specify
   * the intended use and limitations of the Value Set.
   */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate value set instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext>>>;
  /** A legal or geographic region in which the value set is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept>>>;
  /**
   * If this is set to 'true', then no new versions of the content logical
   * definition can be created.  Note: Other metadata might still change.
   */
  _immutable?: Maybe<Element>;
  /**
   * If this is set to 'true', then no new versions of the content logical
   * definition can be created.  Note: Other metadata might still change.
   */
  immutable?: Maybe<Scalars['Boolean']>;
  /** Explanation of why this value set is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element>;
  /** Explanation of why this value set is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the value set and/or its contents. Copyright
   * statements are generally legal restrictions on the use and publishing of the value set.
   */
  _copyright?: Maybe<Element>;
  /**
   * A copyright statement relating to the value set and/or its contents. Copyright
   * statements are generally legal restrictions on the use and publishing of the value set.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * A set of criteria that define the contents of the value set by including or
   * excluding codes selected from the specified code system(s) that the value set
   * draws from. This is also known as the Content Logical Definition (CLD).
   */
  compose?: Maybe<ValueSetcompose>;
  /**
   * A value set can also be 'expanded', where the value set is turned into a
   * simple collection of enumerated codes. This element holds the expansion, if it
   * has been performed.
   */
  expansion?: Maybe<ValueSetexpansion>;
};

/** Base StructureDefinition for Value Set Parent Extension: Custom Fields . */
export type ValueSetParentExtension = {
  /** custom1 field data. */
  parent?: Maybe<Scalars['String']>;
};

/** Base StructureDefinition for Value Set Parent: Custom Fields . */
export type ValueSetParentExtension_Input = {
  __typename?: 'ValueSetParentExtension_Input';
  /** custom1 field data. */
  parent?: Maybe<Scalars['String']>;
};

export enum ValueSet_Enum_Input {
  ValueSet = 'ValueSet'
}

export enum ValueSet_Enum_Schema {
  ValueSet = 'ValueSet'
}

/**
 * A ValueSet resource instance specifies a set of codes drawn from one or more
 * code systems, intended for use in a particular context. Value sets link between
 * [[[CodeSystem]]] definitions and their use in [coded
 * elements](terminologies.html).
 */
export type ValueSet_Input = {
  /** Type of resource */
  resourceType: ValueSet_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta_Input>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  parent?: Maybe<ValueSetParentExtension>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element_Input>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element_Input>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative_Input>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * An absolute URI that is used to identify this value set when it is referenced
   * in a specification, model, design or an instance; also called its canonical
   * identifier. This SHOULD be globally unique and SHOULD be a literal address at
   * which at which an authoritative instance of this value set is (or will be)
   * published. This URL can be the target of a canonical reference. It SHALL
   * remain the same when the value set is stored on different servers.
   */
  _url?: Maybe<Element_Input>;
  /**
   * An absolute URI that is used to identify this value set when it is referenced
   * in a specification, model, design or an instance; also called its canonical
   * identifier. This SHOULD be globally unique and SHOULD be a literal address at
   * which at which an authoritative instance of this value set is (or will be)
   * published. This URL can be the target of a canonical reference. It SHALL
   * remain the same when the value set is stored on different servers.
   */
  url?: Maybe<Scalars['uri']>;
  /**
   * A formal identifier that is used to identify this value set when it is
   * represented in other formats, or referenced in a specification, model, design
   * or an instance.
   */
  identifier?: Maybe<Array<Maybe<Identifier_Input>>>;
  /**
   * The identifier that is used to identify this version of the value set when it
   * is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the value set author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  _version?: Maybe<Element_Input>;
  /**
   * The identifier that is used to identify this version of the value set when it
   * is referenced in a specification, model, design or instance. This is an
   * arbitrary value managed by the value set author and is not expected to be
   * globally unique. For example, it might be a timestamp (e.g. yyyymmdd) if a
   * managed version is not available. There is also no expectation that versions
   * can be placed in a lexicographical sequence.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * A natural language name identifying the value set. This name should be usable
   * as an identifier for the module by machine processing applications such as
   * code generation.
   */
  _name?: Maybe<Element_Input>;
  /**
   * A natural language name identifying the value set. This name should be usable
   * as an identifier for the module by machine processing applications such as
   * code generation.
   */
  name?: Maybe<Scalars['String']>;
  /** A short, descriptive, user-friendly title for the value set. */
  _title?: Maybe<Element_Input>;
  /** A short, descriptive, user-friendly title for the value set. */
  title?: Maybe<Scalars['String']>;
  /**
   * The status of this value set. Enables tracking the life-cycle of the content.
   * The status of the value set applies to the value set definition
   * (ValueSet.compose) and the associated ValueSet metadata. Expansions do not have a state.
   */
  _status?: Maybe<Element_Input>;
  /**
   * The status of this value set. Enables tracking the life-cycle of the content.
   * The status of the value set applies to the value set definition
   * (ValueSet.compose) and the associated ValueSet metadata. Expansions do not have a state.
   */
  status: Scalars['code'];
  /**
   * A Boolean value to indicate that this value set is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  _experimental?: Maybe<Element_Input>;
  /**
   * A Boolean value to indicate that this value set is authored for testing
   * purposes (or education/evaluation/marketing) and is not intended to be used
   * for genuine usage.
   */
  experimental?: Maybe<Scalars['Boolean']>;
  /** The date (and optionally time) when the value set was created or revised (e.g. the 'content logical definition'). */
  _date?: Maybe<Element_Input>;
  /** The date (and optionally time) when the value set was created or revised (e.g. the 'content logical definition'). */
  date?: Maybe<Scalars['dateTime']>;
  /** The name of the organization or individual that published the value set. */
  _publisher?: Maybe<Element_Input>;
  /** The name of the organization or individual that published the value set. */
  publisher?: Maybe<Scalars['String']>;
  /** Contact details to assist a user in finding and communicating with the publisher. */
  contact?: Maybe<Array<Maybe<ContactDetail_Input>>>;
  /**
   * A free text natural language description of the value set from a consumer's
   * perspective. The textual description specifies the span of meanings for
   * concepts to be included within the Value Set Expansion, and also may specify
   * the intended use and limitations of the Value Set.
   */
  _description?: Maybe<Element_Input>;
  /**
   * A free text natural language description of the value set from a consumer's
   * perspective. The textual description specifies the span of meanings for
   * concepts to be included within the Value Set Expansion, and also may specify
   * the intended use and limitations of the Value Set.
   */
  description?: Maybe<Scalars['String']>;
  /**
   * The content was developed with a focus and intent of supporting the contexts
   * that are listed. These contexts may be general categories (gender, age, ...)
   * or may be references to specific programs (insurance plans, studies, ...) and
   * may be used to assist with indexing and searching for appropriate value set instances.
   */
  useContext?: Maybe<Array<Maybe<UsageContext_Input>>>;
  /** A legal or geographic region in which the value set is intended to be used. */
  jurisdiction?: Maybe<Array<Maybe<CodeableConcept_Input>>>;
  /**
   * If this is set to 'true', then no new versions of the content logical
   * definition can be created.  Note: Other metadata might still change.
   */
  _immutable?: Maybe<Element_Input>;
  /**
   * If this is set to 'true', then no new versions of the content logical
   * definition can be created.  Note: Other metadata might still change.
   */
  immutable?: Maybe<Scalars['Boolean']>;
  /** Explanation of why this value set is needed and why it has been designed as it has. */
  _purpose?: Maybe<Element_Input>;
  /** Explanation of why this value set is needed and why it has been designed as it has. */
  purpose?: Maybe<Scalars['String']>;
  /**
   * A copyright statement relating to the value set and/or its contents. Copyright
   * statements are generally legal restrictions on the use and publishing of the value set.
   */
  _copyright?: Maybe<Element_Input>;
  /**
   * A copyright statement relating to the value set and/or its contents. Copyright
   * statements are generally legal restrictions on the use and publishing of the value set.
   */
  copyright?: Maybe<Scalars['String']>;
  /**
   * A set of criteria that define the contents of the value set by including or
   * excluding codes selected from the specified code system(s) that the value set
   * draws from. This is also known as the Content Logical Definition (CLD).
   */
  compose?: Maybe<ValueSetcompose_Input>;
  /**
   * A value set can also be 'expanded', where the value set is turned into a
   * simple collection of enumerated codes. This element holds the expansion, if it
   * has been performed.
   */
  expansion?: Maybe<ValueSetexpansion_Input>;
};

export type ValueSetcompose = {
  __typename?: 'ValueSetcompose';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * The Locked Date is  the effective date that is used to determine the version
   * of all referenced Code Systems and Value Set Definitions included in the
   * compose that are not already tied to a specific version.
   */
  _lockedDate?: Maybe<Element>;
  /**
   * The Locked Date is  the effective date that is used to determine the version
   * of all referenced Code Systems and Value Set Definitions included in the
   * compose that are not already tied to a specific version.
   */
  lockedDate?: Maybe<Scalars['date']>;
  /**
   * Whether inactive codes - codes that are not approved for current use - are in
   * the value set. If inactive = true, inactive codes are to be included in the
   * expansion, if inactive = false, the inactive codes will not be included in the
   * expansion. If absent, the behavior is determined by the implementation, or by
   * the applicable $expand parameters (but generally, inactive codes would be
   * expected to be included).
   */
  _inactive?: Maybe<Element>;
  /**
   * Whether inactive codes - codes that are not approved for current use - are in
   * the value set. If inactive = true, inactive codes are to be included in the
   * expansion, if inactive = false, the inactive codes will not be included in the
   * expansion. If absent, the behavior is determined by the implementation, or by
   * the applicable $expand parameters (but generally, inactive codes would be
   * expected to be included).
   */
  inactive?: Maybe<Scalars['Boolean']>;
  /** Include one or more codes from a code system or other value set(s). */
  include?: Maybe<Array<ValueSetcomposeinclude>>;
};

export type ValueSetcompose_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * The Locked Date is  the effective date that is used to determine the version
   * of all referenced Code Systems and Value Set Definitions included in the
   * compose that are not already tied to a specific version.
   */
  _lockedDate?: Maybe<Element_Input>;
  /**
   * The Locked Date is  the effective date that is used to determine the version
   * of all referenced Code Systems and Value Set Definitions included in the
   * compose that are not already tied to a specific version.
   */
  lockedDate?: Maybe<Scalars['date']>;
  /**
   * Whether inactive codes - codes that are not approved for current use - are in
   * the value set. If inactive = true, inactive codes are to be included in the
   * expansion, if inactive = false, the inactive codes will not be included in the
   * expansion. If absent, the behavior is determined by the implementation, or by
   * the applicable $expand parameters (but generally, inactive codes would be
   * expected to be included).
   */
  _inactive?: Maybe<Element_Input>;
  /**
   * Whether inactive codes - codes that are not approved for current use - are in
   * the value set. If inactive = true, inactive codes are to be included in the
   * expansion, if inactive = false, the inactive codes will not be included in the
   * expansion. If absent, the behavior is determined by the implementation, or by
   * the applicable $expand parameters (but generally, inactive codes would be
   * expected to be included).
   */
  inactive?: Maybe<Scalars['Boolean']>;
  /** Include one or more codes from a code system or other value set(s). */
  include?: Maybe<Array<ValueSetcomposeinclude_Input>>;
};

export type ValueSetcomposeinclude = {
  __typename?: 'ValueSetcomposeinclude';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An absolute URI which is the code system from which the selected codes come from. */
  _system?: Maybe<Element>;
  /** An absolute URI which is the code system from which the selected codes come from. */
  system?: Maybe<Scalars['uri']>;
  /** The version of the code system that the codes are selected from, or the special version '*' for all versions. */
  _version?: Maybe<Element>;
  /** The version of the code system that the codes are selected from, or the special version '*' for all versions. */
  version?: Maybe<Scalars['String']>;
  /** Specifies a concept to be included or excluded. */
  concept?: Maybe<Array<Maybe<ValueSetcomposeincludeconcept>>>;
  /**
   * Select concepts by specify a matching criterion based on the properties
   * (including relationships) defined by the system, or on filters defined by the
   * system. If multiple filters are specified, they SHALL all be true.
   */
  filter?: Maybe<Array<Maybe<ValueSetcomposeincludefilter>>>;
  /**
   * Selects the concepts found in this value set (based on its value set
   * definition). This is an absolute URI that is a reference to ValueSet.url.  If
   * multiple value sets are specified this includes the union of the contents of
   * all of the referenced value sets.
   */
  _valueSet?: Maybe<Element>;
  /**
   * Selects the concepts found in this value set (based on its value set
   * definition). This is an absolute URI that is a reference to ValueSet.url.  If
   * multiple value sets are specified this includes the union of the contents of
   * all of the referenced value sets.
   */
  valueSet?: Maybe<Array<Maybe<Scalars['canonical']>>>;
};

export type ValueSetcomposeinclude_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** An absolute URI which is the code system from which the selected codes come from. */
  _system?: Maybe<Element_Input>;
  /** An absolute URI which is the code system from which the selected codes come from. */
  system?: Maybe<Scalars['uri']>;
  /** The version of the code system that the codes are selected from, or the special version '*' for all versions. */
  _version?: Maybe<Element_Input>;
  /** The version of the code system that the codes are selected from, or the special version '*' for all versions. */
  version?: Maybe<Scalars['String']>;
  /** Specifies a concept to be included or excluded. */
  concept?: Maybe<Array<Maybe<ValueSetcomposeincludeconcept_Input>>>;
  /**
   * Select concepts by specify a matching criterion based on the properties
   * (including relationships) defined by the system, or on filters defined by the
   * system. If multiple filters are specified, they SHALL all be true.
   */
  filter?: Maybe<Array<Maybe<ValueSetcomposeincludefilter_Input>>>;
  /**
   * Selects the concepts found in this value set (based on its value set
   * definition). This is an absolute URI that is a reference to ValueSet.url.  If
   * multiple value sets are specified this includes the union of the contents of
   * all of the referenced value sets.
   */
  _valueSet?: Maybe<Element_Input>;
  /**
   * Selects the concepts found in this value set (based on its value set
   * definition). This is an absolute URI that is a reference to ValueSet.url.  If
   * multiple value sets are specified this includes the union of the contents of
   * all of the referenced value sets.
   */
  valueSet?: Maybe<Array<Maybe<Scalars['canonical']>>>;
};

export type ValueSetcomposeincludeconcept = {
  __typename?: 'ValueSetcomposeincludeconcept';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Specifies a code for the concept to be included or excluded. */
  _code?: Maybe<Element>;
  /** Specifies a code for the concept to be included or excluded. */
  code: Scalars['code'];
  /** Specifies a code for the concept to be included or excluded. */
  subspecialty: Scalars['code'];
  /**
   * The text to display to the user for this concept in the context of this
   * valueset. If no display is provided, then applications using the value set use
   * the display specified for the code by the system.
   */
  _display?: Maybe<Element>;
  /**
   * The text to display to the user for this concept in the context of this
   * valueset. If no display is provided, then applications using the value set use
   * the display specified for the code by the system.
   */
  display?: Maybe<Scalars['String']>;
  /** speciality image */
  img?: Maybe<Scalars['String']>;
  /** specification */
  disorder?: Maybe<Scalars['Boolean']>;
  /**
   * Additional representations for this concept when used in this value set -
   * other languages, aliases, specialized purposes, used for particular purposes, etc.
   */
  designation?: Maybe<Array<Maybe<ValueSetcomposeincludeconceptdesignation>>>;
};

export type ValueSetcomposeincludeconcept_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** Specifies a code for the concept to be included or excluded. */
  _code?: Maybe<Element_Input>;
  /** Specifies a code for the concept to be included or excluded. */
  code: Scalars['code'];
  /**
   * The text to display to the user for this concept in the context of this
   * valueset. If no display is provided, then applications using the value set use
   * the display specified for the code by the system.
   */
  _display?: Maybe<Element_Input>;
  /**
   * The text to display to the user for this concept in the context of this
   * valueset. If no display is provided, then applications using the value set use
   * the display specified for the code by the system.
   */
  display?: Maybe<Scalars['String']>;
  /**
   * Additional representations for this concept when used in this value set -
   * other languages, aliases, specialized purposes, used for particular purposes, etc.
   */
  designation?: Maybe<Array<Maybe<ValueSetcomposeincludeconceptdesignation_Input>>>;
};

export type ValueSetcomposeincludeconceptdesignation = {
  __typename?: 'ValueSetcomposeincludeconceptdesignation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The language this designation is defined for. */
  _language?: Maybe<Element>;
  /** The language this designation is defined for. */
  language?: Maybe<Scalars['code']>;
  /** A code that represents types of uses of designations. */
  use?: Maybe<Coding>;
  /** The text value for this designation. */
  _value?: Maybe<Element>;
  /** The text value for this designation. */
  value: Scalars['String'];
};

export type ValueSetcomposeincludeconceptdesignation_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** The language this designation is defined for. */
  _language?: Maybe<Element_Input>;
  /** The language this designation is defined for. */
  language?: Maybe<Scalars['code']>;
  /** A code that represents types of uses of designations. */
  use?: Maybe<Coding_Input>;
  /** The text value for this designation. */
  _value?: Maybe<Element_Input>;
  /** The text value for this designation. */
  value: Scalars['String'];
};

export type ValueSetcomposeincludefilter = {
  __typename?: 'ValueSetcomposeincludefilter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A code that identifies a property or a filter defined in the code system. */
  _property?: Maybe<Element>;
  /** A code that identifies a property or a filter defined in the code system. */
  property: Scalars['code'];
  /** The kind of operation to perform as a part of the filter criteria. */
  _op?: Maybe<Element>;
  /** The kind of operation to perform as a part of the filter criteria. */
  op: Scalars['code'];
  /**
   * The match value may be either a code defined by the system, or a string value,
   * which is a regex match on the literal string of the property value  (if the
   * filter represents a property defined in CodeSystem) or of the system filter
   * value (if the filter represents a filter defined in CodeSystem) when the
   * operation is 'regex', or one of the values (true and false), when the
   * operation is 'exists'.
   */
  _value?: Maybe<Element>;
  /**
   * The match value may be either a code defined by the system, or a string value,
   * which is a regex match on the literal string of the property value  (if the
   * filter represents a property defined in CodeSystem) or of the system filter
   * value (if the filter represents a filter defined in CodeSystem) when the
   * operation is 'regex', or one of the values (true and false), when the
   * operation is 'exists'.
   */
  value: Scalars['String'];
};

export type ValueSetcomposeincludefilter_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** A code that identifies a property or a filter defined in the code system. */
  _property?: Maybe<Element_Input>;
  /** A code that identifies a property or a filter defined in the code system. */
  property: Scalars['code'];
  /** The kind of operation to perform as a part of the filter criteria. */
  _op?: Maybe<Element_Input>;
  /** The kind of operation to perform as a part of the filter criteria. */
  op: Scalars['code'];
  /**
   * The match value may be either a code defined by the system, or a string value,
   * which is a regex match on the literal string of the property value  (if the
   * filter represents a property defined in CodeSystem) or of the system filter
   * value (if the filter represents a filter defined in CodeSystem) when the
   * operation is 'regex', or one of the values (true and false), when the
   * operation is 'exists'.
   */
  _value?: Maybe<Element_Input>;
  /**
   * The match value may be either a code defined by the system, or a string value,
   * which is a regex match on the literal string of the property value  (if the
   * filter represents a property defined in CodeSystem) or of the system filter
   * value (if the filter represents a filter defined in CodeSystem) when the
   * operation is 'regex', or one of the values (true and false), when the
   * operation is 'exists'.
   */
  value: Scalars['String'];
};

export type ValueSetexpansion = {
  __typename?: 'ValueSetexpansion';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * An identifier that uniquely identifies this expansion of the valueset, based
   * on a unique combination of the provided parameters, the system default
   * parameters, and the underlying system code system versions etc. Systems may
   * re-use the same identifier as long as those factors remain the same, and the
   * expansion is the same, but are not required to do so. This is a business identifier.
   */
  _identifier?: Maybe<Element>;
  /**
   * An identifier that uniquely identifies this expansion of the valueset, based
   * on a unique combination of the provided parameters, the system default
   * parameters, and the underlying system code system versions etc. Systems may
   * re-use the same identifier as long as those factors remain the same, and the
   * expansion is the same, but are not required to do so. This is a business identifier.
   */
  identifier?: Maybe<Scalars['uri']>;
  /** The time at which the expansion was produced by the expanding system. */
  _timestamp?: Maybe<Element>;
  /** The time at which the expansion was produced by the expanding system. */
  timestamp: Scalars['dateTime'];
  /**
   * The total number of concepts in the expansion. If the number of concept nodes
   * in this resource is less than the stated number, then the server can return
   * more using the offset parameter.
   */
  _total?: Maybe<Element>;
  /**
   * The total number of concepts in the expansion. If the number of concept nodes
   * in this resource is less than the stated number, then the server can return
   * more using the offset parameter.
   */
  total?: Maybe<Scalars['Int']>;
  /**
   * If paging is being used, the offset at which this resource starts.  I.e. this
   * resource is a partial view into the expansion. If paging is not being used,
   * this element SHALL NOT be present.
   */
  _offset?: Maybe<Element>;
  /**
   * If paging is being used, the offset at which this resource starts.  I.e. this
   * resource is a partial view into the expansion. If paging is not being used,
   * this element SHALL NOT be present.
   */
  offset?: Maybe<Scalars['Int']>;
  /**
   * A parameter that controlled the expansion process. These parameters may be
   * used by users of expanded value sets to check whether the expansion is
   * suitable for a particular purpose, or to pick the correct expansion.
   */
  parameter?: Maybe<Array<Maybe<ValueSetexpansionparameter>>>;
  /** The codes that are contained in the value set expansion. */
  contains?: Maybe<Array<Maybe<ValueSetexpansioncontains>>>;
};

export type ValueSetexpansion_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * An identifier that uniquely identifies this expansion of the valueset, based
   * on a unique combination of the provided parameters, the system default
   * parameters, and the underlying system code system versions etc. Systems may
   * re-use the same identifier as long as those factors remain the same, and the
   * expansion is the same, but are not required to do so. This is a business identifier.
   */
  _identifier?: Maybe<Element_Input>;
  /**
   * An identifier that uniquely identifies this expansion of the valueset, based
   * on a unique combination of the provided parameters, the system default
   * parameters, and the underlying system code system versions etc. Systems may
   * re-use the same identifier as long as those factors remain the same, and the
   * expansion is the same, but are not required to do so. This is a business identifier.
   */
  identifier?: Maybe<Scalars['uri']>;
  /** The time at which the expansion was produced by the expanding system. */
  _timestamp?: Maybe<Element_Input>;
  /** The time at which the expansion was produced by the expanding system. */
  timestamp: Scalars['dateTime'];
  /**
   * The total number of concepts in the expansion. If the number of concept nodes
   * in this resource is less than the stated number, then the server can return
   * more using the offset parameter.
   */
  _total?: Maybe<Element_Input>;
  /**
   * The total number of concepts in the expansion. If the number of concept nodes
   * in this resource is less than the stated number, then the server can return
   * more using the offset parameter.
   */
  total?: Maybe<Scalars['Int']>;
  /**
   * If paging is being used, the offset at which this resource starts.  I.e. this
   * resource is a partial view into the expansion. If paging is not being used,
   * this element SHALL NOT be present.
   */
  _offset?: Maybe<Element_Input>;
  /**
   * If paging is being used, the offset at which this resource starts.  I.e. this
   * resource is a partial view into the expansion. If paging is not being used,
   * this element SHALL NOT be present.
   */
  offset?: Maybe<Scalars['Int']>;
  /**
   * A parameter that controlled the expansion process. These parameters may be
   * used by users of expanded value sets to check whether the expansion is
   * suitable for a particular purpose, or to pick the correct expansion.
   */
  parameter?: Maybe<Array<Maybe<ValueSetexpansionparameter_Input>>>;
  /** The codes that are contained in the value set expansion. */
  contains?: Maybe<Array<Maybe<ValueSetexpansioncontains_Input>>>;
};

export type ValueSetexpansioncontains = {
  __typename?: 'ValueSetexpansioncontains';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** An absolute URI which is the code system in which the code for this item in the expansion is defined. */
  _system?: Maybe<Element>;
  /** An absolute URI which is the code system in which the code for this item in the expansion is defined. */
  system?: Maybe<Scalars['uri']>;
  /**
   * If true, this entry is included in the expansion for navigational purposes,
   * and the user cannot select the code directly as a proper value.
   */
  _abstract?: Maybe<Element>;
  /**
   * If true, this entry is included in the expansion for navigational purposes,
   * and the user cannot select the code directly as a proper value.
   */
  abstract?: Maybe<Scalars['Boolean']>;
  /**
   * If the concept is inactive in the code system that defines it. Inactive codes
   * are those that are no longer to be used, but are maintained by the code system
   * for understanding legacy data. It might not be known or specified whether an
   * concept is inactive (and it may depend on the context of use).
   */
  _inactive?: Maybe<Element>;
  /**
   * If the concept is inactive in the code system that defines it. Inactive codes
   * are those that are no longer to be used, but are maintained by the code system
   * for understanding legacy data. It might not be known or specified whether an
   * concept is inactive (and it may depend on the context of use).
   */
  inactive?: Maybe<Scalars['Boolean']>;
  /**
   * The version of the code system from this code was taken. Note that a
   * well-maintained code system does not need the version reported, because the
   * meaning of codes is consistent across versions. However this cannot
   * consistently be assured, and when the meaning is not guaranteed to be
   * consistent, the version SHOULD be exchanged.
   */
  _version?: Maybe<Element>;
  /**
   * The version of the code system from this code was taken. Note that a
   * well-maintained code system does not need the version reported, because the
   * meaning of codes is consistent across versions. However this cannot
   * consistently be assured, and when the meaning is not guaranteed to be
   * consistent, the version SHOULD be exchanged.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * The code for this item in the expansion hierarchy. If this code is missing the
   * entry in the hierarchy is a place holder (abstract) and does not represent a
   * valid code in the value set.
   */
  _code?: Maybe<Element>;
  /**
   * The code for this item in the expansion hierarchy. If this code is missing the
   * entry in the hierarchy is a place holder (abstract) and does not represent a
   * valid code in the value set.
   */
  code?: Maybe<Scalars['code']>;
  /** The recommended display for this item in the expansion. */
  _display?: Maybe<Element>;
  /** The recommended display for this item in the expansion. */
  display?: Maybe<Scalars['String']>;
};

export type ValueSetexpansioncontains_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /** An absolute URI which is the code system in which the code for this item in the expansion is defined. */
  _system?: Maybe<Element_Input>;
  /** An absolute URI which is the code system in which the code for this item in the expansion is defined. */
  system?: Maybe<Scalars['uri']>;
  /**
   * If true, this entry is included in the expansion for navigational purposes,
   * and the user cannot select the code directly as a proper value.
   */
  _abstract?: Maybe<Element_Input>;
  /**
   * If true, this entry is included in the expansion for navigational purposes,
   * and the user cannot select the code directly as a proper value.
   */
  abstract?: Maybe<Scalars['Boolean']>;
  /**
   * If the concept is inactive in the code system that defines it. Inactive codes
   * are those that are no longer to be used, but are maintained by the code system
   * for understanding legacy data. It might not be known or specified whether an
   * concept is inactive (and it may depend on the context of use).
   */
  _inactive?: Maybe<Element_Input>;
  /**
   * If the concept is inactive in the code system that defines it. Inactive codes
   * are those that are no longer to be used, but are maintained by the code system
   * for understanding legacy data. It might not be known or specified whether an
   * concept is inactive (and it may depend on the context of use).
   */
  inactive?: Maybe<Scalars['Boolean']>;
  /**
   * The version of the code system from this code was taken. Note that a
   * well-maintained code system does not need the version reported, because the
   * meaning of codes is consistent across versions. However this cannot
   * consistently be assured, and when the meaning is not guaranteed to be
   * consistent, the version SHOULD be exchanged.
   */
  _version?: Maybe<Element_Input>;
  /**
   * The version of the code system from this code was taken. Note that a
   * well-maintained code system does not need the version reported, because the
   * meaning of codes is consistent across versions. However this cannot
   * consistently be assured, and when the meaning is not guaranteed to be
   * consistent, the version SHOULD be exchanged.
   */
  version?: Maybe<Scalars['String']>;
  /**
   * The code for this item in the expansion hierarchy. If this code is missing the
   * entry in the hierarchy is a place holder (abstract) and does not represent a
   * valid code in the value set.
   */
  _code?: Maybe<Element_Input>;
  /**
   * The code for this item in the expansion hierarchy. If this code is missing the
   * entry in the hierarchy is a place holder (abstract) and does not represent a
   * valid code in the value set.
   */
  code?: Maybe<Scalars['code']>;
  /** The recommended display for this item in the expansion. */
  _display?: Maybe<Element_Input>;
  /** The recommended display for this item in the expansion. */
  display?: Maybe<Scalars['String']>;
};

export type ValueSetexpansionparameter = {
  __typename?: 'ValueSetexpansionparameter';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * Name of the input parameter to the $expand operation; may be a server-assigned
   * name for additional default or other server-supplied parameters used to
   * control the expansion process.
   */
  _name?: Maybe<Element>;
  /**
   * Name of the input parameter to the $expand operation; may be a server-assigned
   * name for additional default or other server-supplied parameters used to
   * control the expansion process.
   */
  name: Scalars['String'];
  /** The value of the parameter. */
  _valueString?: Maybe<Element>;
  /** The value of the parameter. */
  valueString?: Maybe<Scalars['String']>;
  /** The value of the parameter. */
  _valueBoolean?: Maybe<Element>;
  /** The value of the parameter. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /** The value of the parameter. */
  _valueInteger?: Maybe<Element>;
  /** The value of the parameter. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** The value of the parameter. */
  _valueDecimal?: Maybe<Element>;
  /** The value of the parameter. */
  valueDecimal?: Maybe<Scalars['Float']>;
  /** The value of the parameter. */
  _valueUri?: Maybe<Element>;
  /** The value of the parameter. */
  valueUri?: Maybe<Scalars['uri']>;
  /** The value of the parameter. */
  _valueCode?: Maybe<Element>;
  /** The value of the parameter. */
  valueCode?: Maybe<Scalars['code']>;
  /** The value of the parameter. */
  _valueDateTime?: Maybe<Element>;
  /** The value of the parameter. */
  valueDateTime?: Maybe<Scalars['dateTime']>;
};

export type ValueSetexpansionparameter_Input = {
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element_Input>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension_Input>>>;
  /**
   * Name of the input parameter to the $expand operation; may be a server-assigned
   * name for additional default or other server-supplied parameters used to
   * control the expansion process.
   */
  _name?: Maybe<Element_Input>;
  /**
   * Name of the input parameter to the $expand operation; may be a server-assigned
   * name for additional default or other server-supplied parameters used to
   * control the expansion process.
   */
  name: Scalars['String'];
  /** The value of the parameter. */
  _valueString?: Maybe<Element_Input>;
  /** The value of the parameter. */
  valueString?: Maybe<Scalars['String']>;
  /** The value of the parameter. */
  _valueBoolean?: Maybe<Element_Input>;
  /** The value of the parameter. */
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /** The value of the parameter. */
  _valueInteger?: Maybe<Element_Input>;
  /** The value of the parameter. */
  valueInteger?: Maybe<Scalars['Int']>;
  /** The value of the parameter. */
  _valueDecimal?: Maybe<Element_Input>;
  /** The value of the parameter. */
  valueDecimal?: Maybe<Scalars['Float']>;
  /** The value of the parameter. */
  _valueUri?: Maybe<Element_Input>;
  /** The value of the parameter. */
  valueUri?: Maybe<Scalars['uri']>;
  /** The value of the parameter. */
  _valueCode?: Maybe<Element_Input>;
  /** The value of the parameter. */
  valueCode?: Maybe<Scalars['code']>;
  /** The value of the parameter. */
  _valueDateTime?: Maybe<Element_Input>;
  /** The value of the parameter. */
  valueDateTime?: Maybe<Scalars['dateTime']>;
};

/** Describes validation requirements, source(s), status and dates for one or more elements. */
export type VerificationResult = {
  __typename?: 'VerificationResult';
  /** Type of resource */
  resourceType: VerificationResult_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A resource that was validated. */
  target?: Maybe<Array<Maybe<VerificationResulttarget_Target_Union>>>;
  /** The fhirpath location(s) within the resource that was validated. */
  _targetLocation?: Maybe<Element>;
  /** The fhirpath location(s) within the resource that was validated. */
  targetLocation?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The frequency with which the target must be validated (none; initial; periodic). */
  need?: Maybe<CodeableConcept>;
  /**
   * The validation status of the target (attested; validated; in process; requires
   * revalidation; validation failed; revalidation failed).
   */
  _status?: Maybe<Element>;
  /**
   * The validation status of the target (attested; validated; in process; requires
   * revalidation; validation failed; revalidation failed).
   */
  status: Scalars['code'];
  /** When the validation status was updated. */
  _statusDate?: Maybe<Element>;
  /** When the validation status was updated. */
  statusDate?: Maybe<Scalars['dateTime']>;
  /** What the target is validated against (nothing; primary source; multiple sources). */
  validationType?: Maybe<CodeableConcept>;
  /**
   * The primary process by which the target is validated (edit check; value set;
   * primary source; multiple sources; standalone; in context).
   */
  validationProcess?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Frequency of revalidation. */
  frequency?: Maybe<Timing>;
  /** The date/time validation was last completed (including failed validations). */
  _lastPerformed?: Maybe<Element>;
  /** The date/time validation was last completed (including failed validations). */
  lastPerformed?: Maybe<Scalars['dateTime']>;
  /** The date when target is next validated, if appropriate. */
  _nextScheduled?: Maybe<Element>;
  /** The date when target is next validated, if appropriate. */
  nextScheduled?: Maybe<Scalars['date']>;
  /** The result if validation fails (fatal; warning; record only; none). */
  failureAction?: Maybe<CodeableConcept>;
  /** Information about the primary source(s) involved in validation. */
  primarySource?: Maybe<Array<Maybe<VerificationResultprimarySource>>>;
  /** Information about the entity attesting to information. */
  attestation?: Maybe<VerificationResultattestation>;
  /** Information about the entity validating information. */
  validator?: Maybe<Array<Maybe<VerificationResultvalidator>>>;
};

export enum VerificationResult_Enum_Schema {
  VerificationResult = 'VerificationResult'
}

export type VerificationResultattestation = {
  __typename?: 'VerificationResultattestation';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** The individual or organization attesting to information. */
  who?: Maybe<VerificationResultattestationwho_Who_Union>;
  /** When the who is asserting on behalf of another (organization or individual). */
  onBehalfOf?: Maybe<VerificationResultattestationonBehalfOf_OnBehalfOf_Union>;
  /** The method by which attested information was submitted/retrieved (manual; API; Push). */
  communicationMethod?: Maybe<CodeableConcept>;
  /** The date the information was attested to. */
  _date?: Maybe<Element>;
  /** The date the information was attested to. */
  date?: Maybe<Scalars['date']>;
  /** A digital identity certificate associated with the attestation source. */
  _sourceIdentityCertificate?: Maybe<Element>;
  /** A digital identity certificate associated with the attestation source. */
  sourceIdentityCertificate?: Maybe<Scalars['String']>;
  /**
   * A digital identity certificate associated with the proxy entity submitting
   * attested information on behalf of the attestation source.
   */
  _proxyIdentityCertificate?: Maybe<Element>;
  /**
   * A digital identity certificate associated with the proxy entity submitting
   * attested information on behalf of the attestation source.
   */
  proxyIdentityCertificate?: Maybe<Scalars['String']>;
  /**
   * Signed assertion by the proxy entity indicating that they have the right to
   * submit attested information on behalf of the attestation source.
   */
  proxySignature?: Maybe<Signature>;
  /** Signed assertion by the attestation source that they have attested to the information. */
  sourceSignature?: Maybe<Signature>;
};

/** When the who is asserting on behalf of another (organization or individual). */
export type VerificationResultattestationonBehalfOf_OnBehalfOf_Union = Organization | Practitioner | PractitionerRole;

/** The individual or organization attesting to information. */
export type VerificationResultattestationwho_Who_Union = Practitioner | PractitionerRole | Organization;

export type VerificationResultprimarySource = {
  __typename?: 'VerificationResultprimarySource';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Reference to the primary source. */
  who?: Maybe<VerificationResultprimarySourcewho_Who_Union>;
  /**
   * Type of primary source (License Board; Primary Education; Continuing
   * Education; Postal Service; Relationship owner; Registration Authority; legal
   * source; issuing source; authoritative source).
   */
  type?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Method for communicating with the primary source (manual; API; Push). */
  communicationMethod?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Status of the validation of the target against the primary source (successful; failed; unknown). */
  validationStatus?: Maybe<CodeableConcept>;
  /** When the target was validated against the primary source. */
  _validationDate?: Maybe<Element>;
  /** When the target was validated against the primary source. */
  validationDate?: Maybe<Scalars['dateTime']>;
  /** Ability of the primary source to push updates/alerts (yes; no; undetermined). */
  canPushUpdates?: Maybe<CodeableConcept>;
  /** Type of alerts/updates the primary source can send (specific requested changes; any changes; as defined by source). */
  pushTypeAvailable?: Maybe<Array<Maybe<CodeableConcept>>>;
};

/** Reference to the primary source. */
export type VerificationResultprimarySourcewho_Who_Union = Organization | Practitioner | PractitionerRole;

/** A resource that was validated. */
export type VerificationResulttarget_Target_Union = Resource;

export type VerificationResultvalidator = {
  __typename?: 'VerificationResultvalidator';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Reference to the organization validating information. */
  organization: VerificationResultvalidatororganization_Organization_Union;
  /** A digital identity certificate associated with the validator. */
  _identityCertificate?: Maybe<Element>;
  /** A digital identity certificate associated with the validator. */
  identityCertificate?: Maybe<Scalars['String']>;
  /** Signed assertion by the validator that they have validated the information. */
  attestationSignature?: Maybe<Signature>;
};

/** Reference to the organization validating information. */
export type VerificationResultvalidatororganization_Organization_Union = Organization;

/** An authorization for the provision of glasses and/or contact lenses to a patient. */
export type VisionPrescription = {
  __typename?: 'VisionPrescription';
  /** Type of resource */
  resourceType: VisionPrescription_Enum_Schema;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /**
   * The metadata about the resource. This is content that is maintained by the
   * infrastructure. Changes to the content might not always be associated with
   * version changes to the resource.
   */
  meta?: Maybe<Meta>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  _implicitRules?: Maybe<Element>;
  /**
   * A reference to a set of rules that were followed when the resource was
   * constructed, and which must be understood when processing the content. Often,
   * this is a reference to an implementation guide that defines the special rules
   * along with other profiles etc.
   */
  implicitRules?: Maybe<Scalars['uri']>;
  /** The base language in which the resource is written. */
  _language?: Maybe<Element>;
  /** The base language in which the resource is written. */
  language?: Maybe<Scalars['code']>;
  /**
   * A human-readable narrative that contains a summary of the resource and can be
   * used to represent the content of the resource to a human. The narrative need
   * not encode all the structured data, but is required to contain sufficient
   * detail to make it 'clinically safe' for a human to just read the narrative.
   * Resource definitions may define what content should be represented in the
   * narrative to ensure clinical safety.
   */
  text?: Maybe<Narrative>;
  /**
   * These resources do not have an independent existence apart from the resource
   * that contains them - they cannot be identified independently, and nor can they
   * have their own independent transaction scope.
   */
  contained?: Maybe<Array<Maybe<ResourceList>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the resource and that modifies the understanding of the element
   * that contains it and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer is allowed to define an extension, there is a set of requirements
   * that SHALL be met as part of the definition of the extension. Applications
   * processing a resource are required to check for modifier extensions.  Modifier
   * extensions SHALL NOT change the meaning of any elements on Resource or
   * DomainResource (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** A unique identifier assigned to this vision prescription. */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** The status of the resource instance. */
  _status?: Maybe<Element>;
  /** The status of the resource instance. */
  status: Scalars['code'];
  /** The date this resource was created. */
  _created?: Maybe<Element>;
  /** The date this resource was created. */
  created: Scalars['dateTime'];
  /** A resource reference to the person to whom the vision prescription applies. */
  patient: VisionPrescriptionpatient_Patient_Union;
  /**
   * A reference to a resource that identifies the particular occurrence of contact
   * between patient and health care provider during which the prescription was issued.
   */
  encounter?: Maybe<VisionPrescriptionencounter_Encounter_Union>;
  /** The date (and perhaps time) when the prescription was written. */
  _dateWritten?: Maybe<Element>;
  /** The date (and perhaps time) when the prescription was written. */
  dateWritten: Scalars['dateTime'];
  /** The healthcare professional responsible for authorizing the prescription. */
  prescriber: VisionPrescriptionprescriber_Prescriber_Union;
  /**
   * Contain the details of  the individual lens specifications and serves as the
   * authorization for the fullfillment by certified professionals.
   */
  lensSpecification?: Maybe<Array<VisionPrescriptionlensSpecification>>;
};

export enum VisionPrescription_Enum_Schema {
  VisionPrescription = 'VisionPrescription'
}

/**
 * A reference to a resource that identifies the particular occurrence of contact
 * between patient and health care provider during which the prescription was issued.
 */
export type VisionPrescriptionencounter_Encounter_Union = Encounter;

export type VisionPrescriptionlensSpecification = {
  __typename?: 'VisionPrescriptionlensSpecification';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Identifies the type of vision correction product which is required for the patient. */
  product: CodeableConcept;
  /** The eye for which the lens specification applies. */
  _eye?: Maybe<Element>;
  /** The eye for which the lens specification applies. */
  eye: Scalars['code'];
  /** Lens power measured in dioptres (0.25 units). */
  _sphere?: Maybe<Element>;
  /** Lens power measured in dioptres (0.25 units). */
  sphere?: Maybe<Scalars['Float']>;
  /** Power adjustment for astigmatism measured in dioptres (0.25 units). */
  _cylinder?: Maybe<Element>;
  /** Power adjustment for astigmatism measured in dioptres (0.25 units). */
  cylinder?: Maybe<Scalars['Float']>;
  /** Adjustment for astigmatism measured in integer degrees. */
  _axis?: Maybe<Element>;
  /** Adjustment for astigmatism measured in integer degrees. */
  axis?: Maybe<Scalars['Int']>;
  /** Allows for adjustment on two axis. */
  prism?: Maybe<Array<Maybe<VisionPrescriptionlensSpecificationprism>>>;
  /** Power adjustment for multifocal lenses measured in dioptres (0.25 units). */
  _add?: Maybe<Element>;
  /** Power adjustment for multifocal lenses measured in dioptres (0.25 units). */
  add?: Maybe<Scalars['Float']>;
  /** Contact lens power measured in dioptres (0.25 units). */
  _power?: Maybe<Element>;
  /** Contact lens power measured in dioptres (0.25 units). */
  power?: Maybe<Scalars['Float']>;
  /** Back curvature measured in millimetres. */
  _backCurve?: Maybe<Element>;
  /** Back curvature measured in millimetres. */
  backCurve?: Maybe<Scalars['Float']>;
  /** Contact lens diameter measured in millimetres. */
  _diameter?: Maybe<Element>;
  /** Contact lens diameter measured in millimetres. */
  diameter?: Maybe<Scalars['Float']>;
  /** The recommended maximum wear period for the lens. */
  duration?: Maybe<Quantity>;
  /** Special color or pattern. */
  _color?: Maybe<Element>;
  /** Special color or pattern. */
  color?: Maybe<Scalars['String']>;
  /** Brand recommendations or restrictions. */
  _brand?: Maybe<Element>;
  /** Brand recommendations or restrictions. */
  brand?: Maybe<Scalars['String']>;
  /** Notes for special requirements such as coatings and lens materials. */
  note?: Maybe<Array<Maybe<Annotation>>>;
};

export type VisionPrescriptionlensSpecificationprism = {
  __typename?: 'VisionPrescriptionlensSpecificationprism';
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  _id?: Maybe<Element>;
  /**
   * Unique id for the element within a resource (for internal references). This
   * may be any string value that does not contain spaces.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element. To make the use of extensions safe and manageable,
   * there is a strict set of governance  applied to the definition and use of
   * extensions. Though any implementer can define an extension, there is a set of
   * requirements that SHALL be met as part of the definition of the extension.
   */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /**
   * May be used to represent additional information that is not part of the basic
   * definition of the element and that modifies the understanding of the element
   * in which it is contained and/or the understanding of the containing element's
   * descendants. Usually modifier elements provide negation or qualification. To
   * make the use of extensions safe and manageable, there is a strict set of
   * governance applied to the definition and use of extensions. Though any
   * implementer can define an extension, there is a set of requirements that SHALL
   * be met as part of the definition of the extension. Applications processing a
   * resource are required to check for modifier extensions.  Modifier extensions
   * SHALL NOT change the meaning of any elements on Resource or DomainResource
   * (including cannot change the meaning of modifierExtension itself).
   */
  modifierExtension?: Maybe<Array<Maybe<Extension>>>;
  /** Amount of prism to compensate for eye alignment in fractional units. */
  _amount?: Maybe<Element>;
  /** Amount of prism to compensate for eye alignment in fractional units. */
  amount: Scalars['Float'];
  /** The relative base, or reference lens edge, for the prism. */
  _base?: Maybe<Element>;
  /** The relative base, or reference lens edge, for the prism. */
  base: Scalars['code'];
};

/** A resource reference to the person to whom the vision prescription applies. */
export type VisionPrescriptionpatient_Patient_Union = Patient;

/** The healthcare professional responsible for authorizing the prescription. */
export type VisionPrescriptionprescriber_Prescriber_Union = Practitioner | PractitionerRole;

/** WebContact_Schema. */
export type WebContact = {
  __typename?: 'WebContact';
  /** Type of resource */
  resourceType: WebContact_Enum;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  contactName?: Maybe<Scalars['String']>;
  /** patientId Id. */
  contactEmail?: Maybe<Scalars['String']>;
  /** patientId Id. */
  prEmail?: Maybe<Scalars['String']>;
  /** patient phone number. */
  countryCode?: Maybe<Scalars['String']>;
  /** patient phone number. */
  contactPhoneNumber?: Maybe<Scalars['String']>;
  /** patientId Id. */
  contactType?: Maybe<Scalars['Int']>;
  /** patientId Id. */
  contactSubject?: Maybe<Scalars['String']>;
  /** patientId Id. */
  contactMessage?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
};

export enum WebContact_Enum {
  WebContact = 'WebContact'
}

export enum WebContact_Enum_Input {
  WebContact = 'WebContact'
}

/** WebContact */
export type WebContact_Input = {
  /** Type of resource */
  resourceType: WebContact_Enum_Input;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  _id?: Maybe<Element_Input>;
  /** The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes. */
  id?: Maybe<Scalars['id']>;
  /** logDescription Name. */
  contactName?: Maybe<Scalars['String']>;
  /** patientId Id. */
  contactEmail?: Maybe<Scalars['String']>;
  /** patient phone number. */
  countryCode?: Maybe<Scalars['String']>;
  /** patient phone number. */
  contactPhoneNumber?: Maybe<Scalars['String']>;
  /** patientId Id. */
  contactType?: Maybe<Scalars['Int']>;
  /** patientId Id. */
  prEmail?: Maybe<Scalars['String']>;
  /** patientId Id. */
  contactSubject?: Maybe<Scalars['String']>;
  /** patientId Id. */
  contactMessage?: Maybe<Scalars['String']>;
  /** createdOn. */
  createdOn?: Maybe<Scalars['String']>;
  /** createdOn. */
  updatedOn?: Maybe<Scalars['String']>;
};

















export type UpdatePractitionerPersonalDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  name?: Maybe<Array<Maybe<HumanName_Input>> | Maybe<HumanName_Input>>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['code']>;
  birthdDate?: Maybe<Scalars['date']>;
  nationality?: Maybe<Scalars['code']>;
  communication?: Maybe<Array<Maybe<CodeableConcept_Input>> | Maybe<CodeableConcept_Input>>;
}>;


export type UpdatePractitionerPersonalDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id'>
  )> }
);

export type UpdatePractitionerAboutDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  practionerAbout?: Maybe<PractionerAboutUs_Input>;
  photo?: Maybe<Array<Maybe<Attachment_Input>> | Maybe<Attachment_Input>>;
}>;


export type UpdatePractitionerAboutDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id'>
  )> }
);

export type UpdatePractitionerAgreementDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  handbook?: Maybe<Scalars['Int']>;
  terms?: Maybe<Scalars['Int']>;
  contract?: Maybe<Scalars['Int']>;
  document?: Maybe<Array<DocumentReferencecontent_Input> | DocumentReferencecontent_Input>;
}>;


export type UpdatePractitionerAgreementDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PomsPractitionerAgreementUpdate?: Maybe<(
    { __typename?: 'PomsPractitionerAgreements' }
    & Pick<PomsPractitionerAgreements, 'id'>
  )> }
);

export type UpdatePractitionerPrivacyDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  contactPost?: Maybe<Scalars['Int']>;
  contactSMS?: Maybe<Scalars['Int']>;
  contactPhone?: Maybe<Scalars['Int']>;
  contactEmail?: Maybe<Scalars['Int']>;
  notifyPost?: Maybe<Scalars['Int']>;
  notifySMS?: Maybe<Scalars['Int']>;
  notifyPhone?: Maybe<Scalars['Int']>;
  notifyEmail?: Maybe<Scalars['Int']>;
  gdprConsent?: Maybe<Scalars['Int']>;
}>;


export type UpdatePractitionerPrivacyDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PomsPractitionerPrivacyUpdate?: Maybe<(
    { __typename?: 'PomsPractitionerPrivacy' }
    & Pick<PomsPractitionerPrivacy, 'id'>
  )> }
);

export type UpdatePractitionerPreferenceDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Array<Maybe<Coding_Input>> | Maybe<Coding_Input>>;
  languageCode?: Maybe<Array<Maybe<Coding_Input>> | Maybe<Coding_Input>>;
  currencyCode?: Maybe<Array<Maybe<Coding_Input>> | Maybe<Coding_Input>>;
  timezone?: Maybe<Array<Maybe<Coding_Input>> | Maybe<Coding_Input>>;
  sendCommunicationMessage?: Maybe<Scalars['Boolean']>;
}>;


export type UpdatePractitionerPreferenceDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PomsPractitionerPreferenceUpdate?: Maybe<(
    { __typename?: 'PomsPractitionerPreferences' }
    & Pick<PomsPractitionerPreferences, 'id'>
  )> }
);

export type UpdatePractitionerContactDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>> | Maybe<ContactPoint_Input>>;
  address?: Maybe<Array<Maybe<Address_Input>> | Maybe<Address_Input>>;
  emergency?: Maybe<Array<Maybe<PractionerEmergency_Extension_Input>> | Maybe<PractionerEmergency_Extension_Input>>;
}>;


export type UpdatePractitionerContactDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id'>
  )> }
);

export type UpdatePractitionerQualificationDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  qualification?: Maybe<Array<Maybe<Practitionerqualification_Input>> | Maybe<Practitionerqualification_Input>>;
}>;


export type UpdatePractitionerQualificationDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id'>
  )> }
);

export type UpdatePractitionerExpertiseDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  expertise?: Maybe<Array<Maybe<PractionerExpertiseExtension_Input>> | Maybe<PractionerExpertiseExtension_Input>>;
}>;


export type UpdatePractitionerExpertiseDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerRoleUpdate?: Maybe<(
    { __typename?: 'PractitionerRole' }
    & Pick<PractitionerRole, 'id'>
  )> }
);

export type UpdatePractitionerProfessionalDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  band?: Maybe<Scalars['code']>;
  years?: Maybe<Scalars['code']>;
  identifier?: Maybe<Array<Maybe<Identifier_Input>> | Maybe<Identifier_Input>>;
  code?: Maybe<Array<Maybe<CodeableConcept_Input>> | Maybe<CodeableConcept_Input>>;
  speciality?: Maybe<Array<Maybe<CodeableConcept_Input>> | Maybe<CodeableConcept_Input>>;
  subspeciality?: Maybe<Array<Maybe<CodeableConcept_Input>> | Maybe<CodeableConcept_Input>>;
  subspecialitymaster?: Maybe<Array<Maybe<CodeableConcept_Input>> | Maybe<CodeableConcept_Input>>;
}>;


export type UpdatePractitionerProfessionalDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id'>
  )>, PractitionerRoleUpdate?: Maybe<(
    { __typename?: 'PractitionerRole' }
    & Pick<PractitionerRole, 'id'>
  )> }
);

export type UpdatePractitionerAwardsMediaDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  awards?: Maybe<Array<Maybe<PractionerAwardsExtension_Input>> | Maybe<PractionerAwardsExtension_Input>>;
  media?: Maybe<Array<Maybe<PractionerMediaExtension_Input>> | Maybe<PractionerMediaExtension_Input>>;
}>;


export type UpdatePractitionerAwardsMediaDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id'>
  )> }
);

export type UpdatePractitionerPublicationDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  publications?: Maybe<Array<Maybe<PractionerPublicationsExtension_Input>> | Maybe<PractionerPublicationsExtension_Input>>;
}>;


export type UpdatePractitionerPublicationDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id'>
  )> }
);

export type UpdatePractitionerAffiliationDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  affiliations?: Maybe<Array<Maybe<PractionerAffiliationExtension_Input>> | Maybe<PractionerAffiliationExtension_Input>>;
}>;


export type UpdatePractitionerAffiliationDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id'>
  )> }
);

export type UpdatePractitionerAccrediationDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  accreditations?: Maybe<Array<Maybe<PractionerAccreditationExtension_Input>> | Maybe<PractionerAccreditationExtension_Input>>;
}>;


export type UpdatePractitionerAccrediationDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id'>
  )> }
);

export type AddPractitionerPracticeLocationMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  gtnid?: Maybe<Scalars['String']>;
  cocid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Address_Input>;
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>> | Maybe<ContactPoint_Input>>;
  rank?: Maybe<Scalars['Int']>;
}>;


export type AddPractitionerPracticeLocationMutation = (
  { __typename?: 'Mutation' }
  & { LocationCreate?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id'>
  )> }
);

export type UpdatePractitionerPracticeLocationMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  gtnid?: Maybe<Scalars['String']>;
  cocid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Address_Input>;
  telecom?: Maybe<Array<Maybe<ContactPoint_Input>> | Maybe<ContactPoint_Input>>;
  locationId?: Maybe<Scalars['id']>;
  rank?: Maybe<Scalars['Int']>;
}>;


export type UpdatePractitionerPracticeLocationMutation = (
  { __typename?: 'Mutation' }
  & { LocationUpdate?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id'>
  )> }
);

export type DeletePractitionerPracticeLocationMutationVariables = Exact<{
  id: Scalars['id'];
}>;


export type DeletePractitionerPracticeLocationMutation = (
  { __typename?: 'Mutation' }
  & { LocationRemove?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id'>
  )> }
);

export type UpdatePractitionerPayeInvoiceMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  nin?: Maybe<Scalars['String']>;
  societyName?: Maybe<Scalars['String']>;
  accountHolder?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  accountNO?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<DocumentReferencecontent_Input> | DocumentReferencecontent_Input>;
}>;


export type UpdatePractitionerPayeInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { PomsInvoiceBillingUpdate?: Maybe<(
    { __typename?: 'PomsBillingInvoice' }
    & Pick<PomsBillingInvoice, 'id'>
  )> }
);

export type UpdatePractitionerLtdInvoiceMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyNumber?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  accountHolderName?: Maybe<Scalars['String']>;
  accountNO?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<DocumentReferencecontent_Input> | DocumentReferencecontent_Input>;
}>;


export type UpdatePractitionerLtdInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { PomsInvoiceBillingUpdate?: Maybe<(
    { __typename?: 'PomsBillingInvoice' }
    & Pick<PomsBillingInvoice, 'id'>
  )> }
);

export type UpdatePractitionerSelfInvoiceMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  utrNo?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<DocumentReferencecontent_Input> | DocumentReferencecontent_Input>;
}>;


export type UpdatePractitionerSelfInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { PomsInvoiceBillingUpdate?: Maybe<(
    { __typename?: 'PomsBillingInvoice' }
    & Pick<PomsBillingInvoice, 'id'>
  )> }
);

export type CreatePractitionerScheduleMutationVariables = Exact<{
  locationName?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  managingPractitioner?: Maybe<Scalars['String']>;
  breakRequired?: Maybe<Scalars['Int']>;
  fromDate?: Maybe<Scalars['String']>;
  toDate?: Maybe<Scalars['String']>;
  endType?: Maybe<Scalars['Int']>;
  endOnDate?: Maybe<Scalars['String']>;
  endOnAfterNoOfOccurences?: Maybe<Scalars['Int']>;
  weekTimings?: Maybe<Array<Maybe<PomsPractitionerScheduleWeekTimings_Input>> | Maybe<PomsPractitionerScheduleWeekTimings_Input>>;
  isRepeat?: Maybe<Scalars['Int']>;
  repeatSelectType?: Maybe<Scalars['Int']>;
}>;


export type CreatePractitionerScheduleMutation = (
  { __typename?: 'Mutation' }
  & { PomsPractitionerScheduleCreate?: Maybe<(
    { __typename?: 'PomsPractitionerSchedule' }
    & Pick<PomsPractitionerSchedule, 'id'>
  )> }
);

export type UpdatePractitionerScheduleMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  locationName?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  managingPractitioner?: Maybe<Scalars['String']>;
  breakRequired?: Maybe<Scalars['Int']>;
  fromDate?: Maybe<Scalars['String']>;
  toDate?: Maybe<Scalars['String']>;
  endType?: Maybe<Scalars['Int']>;
  endOnDate?: Maybe<Scalars['String']>;
  endOnAfterNoOfOccurences?: Maybe<Scalars['Int']>;
  weekTimings?: Maybe<Array<Maybe<PomsPractitionerScheduleWeekTimings_Input>> | Maybe<PomsPractitionerScheduleWeekTimings_Input>>;
  isRepeat?: Maybe<Scalars['Int']>;
  repeatSelectType?: Maybe<Scalars['Int']>;
}>;


export type UpdatePractitionerScheduleMutation = (
  { __typename?: 'Mutation' }
  & { PomsPractitionerScheduleUpdate?: Maybe<(
    { __typename?: 'PomsPractitionerSchedule' }
    & Pick<PomsPractitionerSchedule, 'id'>
  )> }
);

export type UpdatePractitionerDocumentsMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<DocumentReferencecontent_Input> | DocumentReferencecontent_Input>;
}>;


export type UpdatePractitionerDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { DocumentReferenceUpdate?: Maybe<(
    { __typename?: 'DocumentReference' }
    & Pick<DocumentReference, 'id'>
  )> }
);

export type SavePatientTagsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  practitionerId?: Maybe<Scalars['String']>;
  practitionerName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
}>;


export type SavePatientTagsMutation = (
  { __typename?: 'Mutation' }
  & { PatientUpdate?: Maybe<(
    { __typename?: 'Patient' }
    & Pick<Patient, 'id'>
  )> }
);

export type SavePatientDocumentsMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  documentUrl?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  documentName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  practitionerName?: Maybe<Scalars['String']>;
  report_date?: Maybe<Scalars['String']>;
}>;


export type SavePatientDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { PomsPatientDocumentCreate?: Maybe<(
    { __typename?: 'PomsPatientDocument' }
    & Pick<PomsPatientDocument, 'id'>
  )> }
);

export type SavePractitionerPatientCommunicationMutationVariables = Exact<{
  patientId?: Maybe<Scalars['String']>;
  toEmail?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  ccEmail?: Maybe<Scalars['String']>;
  bccEmail?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  messageContent?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  practitionerName?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
}>;


export type SavePractitionerPatientCommunicationMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerPatientCommunicationCreate?: Maybe<(
    { __typename?: 'PractitionerPatientCommunication' }
    & Pick<PractitionerPatientCommunication, 'id'>
  )> }
);

export type UpdatePatientVitalsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  vitals?: Maybe<Array<Maybe<Observation_Input>> | Maybe<Observation_Input>>;
}>;


export type UpdatePatientVitalsMutation = (
  { __typename?: 'Mutation' }
  & { PatientUpdate?: Maybe<(
    { __typename?: 'Patient' }
    & Pick<Patient, 'id'>
  )> }
);

export type CreatePatientPrescriptionMutationVariables = Exact<{
  comments?: Maybe<Scalars['String']>;
  practitionerName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  practitionerSpeciality?: Maybe<Scalars['String']>;
  medications?: Maybe<Array<Maybe<PatientPrescriptionExtension_Input>> | Maybe<PatientPrescriptionExtension_Input>>;
  patientName?: Maybe<Scalars['String']>;
  patientAddress?: Maybe<Scalars['String']>;
  practitionerSignUrl?: Maybe<Scalars['String']>;
  gmcNumber?: Maybe<Scalars['String']>;
  dateofbirth?: Maybe<Scalars['String']>;
  practitionerEmail?: Maybe<Scalars['String']>;
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  practitionerAddress?: Maybe<Scalars['String']>;
  patientEmail?: Maybe<Scalars['String']>;
  patientPhoneNumber?: Maybe<Scalars['String']>;
  prescriptionType?: Maybe<Scalars['Int']>;
  prescriptionUploadUrl?: Maybe<Scalars['String']>;
  prescriptionFileUrl?: Maybe<Scalars['String']>;
  prescriptionFileUrlName?: Maybe<Scalars['String']>;
}>;


export type CreatePatientPrescriptionMutation = (
  { __typename?: 'Mutation' }
  & { PatientPrescriptionCreate?: Maybe<(
    { __typename?: 'PatientPrescriptionDocument' }
    & Pick<PatientPrescriptionDocument, 'id'>
  )> }
);

export type CreatePatientReferralMutationVariables = Exact<{
  referrer_Title?: Maybe<Scalars['String']>;
  referrer_FirstName?: Maybe<Scalars['String']>;
  referrer_SurName?: Maybe<Scalars['String']>;
  referrer_Specialisation?: Maybe<Scalars['String']>;
  referrer_Role?: Maybe<Scalars['String']>;
  referrer_Location?: Maybe<Scalars['String']>;
  referrer_PhoneNumber?: Maybe<Scalars['String']>;
  referrer_Email?: Maybe<Scalars['String']>;
  referral_Title?: Maybe<Scalars['String']>;
  referral_FirstName?: Maybe<Scalars['String']>;
  referral_SurName?: Maybe<Scalars['String']>;
  referral_Dob?: Maybe<Scalars['String']>;
  referral_Email?: Maybe<Scalars['String']>;
  referral_PhoneNumber?: Maybe<Scalars['String']>;
  referral_ReferenceNumber?: Maybe<Scalars['String']>;
  referral_PostCode?: Maybe<Scalars['String']>;
  referral_Address1?: Maybe<Scalars['String']>;
  referral_Address2?: Maybe<Scalars['String']>;
  referral_Address3?: Maybe<Scalars['String']>;
  referral_City?: Maybe<Scalars['String']>;
  referral_County?: Maybe<Scalars['String']>;
  referral_Country?: Maybe<Scalars['String']>;
  typeOfReferral_Assessments?: Maybe<Scalars['String']>;
  typeOfReferral_RecommendationTreatments?: Maybe<Scalars['String']>;
  referral_Urgent?: Maybe<Scalars['String']>;
  referral_RiskToSelfOrOthers?: Maybe<Scalars['String']>;
  referral_Reason?: Maybe<Scalars['String']>;
  expectationFromReferral?: Maybe<Scalars['String']>;
  referral_VerbalConsentCheck?: Maybe<Scalars['String']>;
  referral_TermsAndConditions?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  patientName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  practitionerName?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<DocumentReferencecontent_Input> | DocumentReferencecontent_Input>;
  practitionerSpeciality?: Maybe<Scalars['String']>;
  typeOfReferral?: Maybe<Scalars['Int']>;
}>;


export type CreatePatientReferralMutation = (
  { __typename?: 'Mutation' }
  & { PomsReferralCreate?: Maybe<(
    { __typename?: 'PomsReferral' }
    & Pick<PomsReferral, 'id'>
  )> }
);

export type CreatePatientInternalReferralMutationVariables = Exact<{
  patientId?: Maybe<Scalars['String']>;
  patientName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  practitionerName?: Maybe<Scalars['String']>;
  referrer_Specialisation?: Maybe<Scalars['String']>;
  referredPractitionerId?: Maybe<Scalars['String']>;
  referredPractitionerName?: Maybe<Scalars['String']>;
  referredPractitionerSpecialization?: Maybe<Scalars['String']>;
  patientEmail?: Maybe<Scalars['String']>;
  patientPhone?: Maybe<Scalars['String']>;
  patientAddress?: Maybe<Scalars['String']>;
  referral_Dob?: Maybe<Scalars['String']>;
  referrer_PostCode?: Maybe<Scalars['String']>;
  referrer_Address1?: Maybe<Scalars['String']>;
  referrer_Address2?: Maybe<Scalars['String']>;
  referrer_Address3?: Maybe<Scalars['String']>;
  referrer_City?: Maybe<Scalars['String']>;
  referrer_County?: Maybe<Scalars['String']>;
  referrer_Country?: Maybe<Scalars['String']>;
  typeOfReferral_Assessments?: Maybe<Scalars['String']>;
  typeOfReferral_RecommendationTreatments?: Maybe<Scalars['String']>;
  referral_Urgent?: Maybe<Scalars['String']>;
  referral_VerbalConsentCheck?: Maybe<Scalars['String']>;
  referral_TermsAndConditions?: Maybe<Scalars['String']>;
}>;


export type CreatePatientInternalReferralMutation = (
  { __typename?: 'Mutation' }
  & { PomsReferralCreate?: Maybe<(
    { __typename?: 'PomsReferral' }
    & Pick<PomsReferral, 'id'>
  )> }
);

export type CreatePatientFinancialInfoMutationVariables = Exact<{
  patientId?: Maybe<Scalars['String']>;
  financialType?: Maybe<Scalars['String']>;
  selfPayCardName?: Maybe<Scalars['String']>;
  selfPayCardBrand?: Maybe<Scalars['String']>;
  selfPayExpMonth?: Maybe<Scalars['String']>;
  selfPayExpYear?: Maybe<Scalars['String']>;
  selfPayCardType?: Maybe<Scalars['String']>;
  selfPayLast4?: Maybe<Scalars['String']>;
  selfPayPostalcode?: Maybe<Scalars['String']>;
  selfPayAddress1?: Maybe<Scalars['String']>;
  selfPayAddress2?: Maybe<Scalars['String']>;
  selfPayAddress3?: Maybe<Scalars['String']>;
  selfPayCity?: Maybe<Scalars['String']>;
  selfPayCounty?: Maybe<Scalars['String']>;
  selfPayCountry?: Maybe<Scalars['String']>;
  selfPayDefault?: Maybe<Scalars['Int']>;
  pmiName?: Maybe<Scalars['String']>;
  pmiResponsibleParty?: Maybe<Scalars['String']>;
  pmiFirstName?: Maybe<Scalars['String']>;
  pmiSurName?: Maybe<Scalars['String']>;
  pmiGroupId?: Maybe<Scalars['String']>;
  pmiPolicyNumber?: Maybe<Scalars['String']>;
  pmiExpiresOn?: Maybe<Scalars['String']>;
  pmiAuthorizationCode?: Maybe<Scalars['String']>;
  pmiAuthorizationSession?: Maybe<Scalars['String']>;
  pmiDocuments?: Maybe<Array<DocumentReferencecontent_Input> | DocumentReferencecontent_Input>;
  pmiDefault?: Maybe<Scalars['Int']>;
  thirdPartyName?: Maybe<Scalars['String']>;
  thirdPartyId?: Maybe<Scalars['String']>;
  thirdPartyComments?: Maybe<Scalars['String']>;
  thirdPartyContactPerson?: Maybe<Scalars['String']>;
  thirdPartyRoleOfPerson?: Maybe<Scalars['String']>;
  thirdPartyPhoneNumber?: Maybe<Scalars['String']>;
  thirdPartyEmail?: Maybe<Scalars['String']>;
}>;


export type CreatePatientFinancialInfoMutation = (
  { __typename?: 'Mutation' }
  & { PatientFinancialInfoCreate?: Maybe<(
    { __typename?: 'PatientFinancialInfo' }
    & Pick<PatientFinancialInfo, 'id'>
  )> }
);

export type UpdatePatientFinancialInfoMutationVariables = Exact<{
  patientId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['id']>;
  financialType?: Maybe<Scalars['String']>;
  selfPayCardName?: Maybe<Scalars['String']>;
  selfPayCardBrand?: Maybe<Scalars['String']>;
  selfPayExpMonth?: Maybe<Scalars['String']>;
  selfPayExpYear?: Maybe<Scalars['String']>;
  selfPayCardType?: Maybe<Scalars['String']>;
  selfPayLast4?: Maybe<Scalars['String']>;
  selfPayPostalcode?: Maybe<Scalars['String']>;
  selfPayAddress1?: Maybe<Scalars['String']>;
  selfPayAddress2?: Maybe<Scalars['String']>;
  selfPayAddress3?: Maybe<Scalars['String']>;
  selfPayCity?: Maybe<Scalars['String']>;
  selfPayCounty?: Maybe<Scalars['String']>;
  selfPayCountry?: Maybe<Scalars['String']>;
  selfPayDefault?: Maybe<Scalars['Int']>;
  pmiName?: Maybe<Scalars['String']>;
  pmiResponsibleParty?: Maybe<Scalars['String']>;
  pmiFirstName?: Maybe<Scalars['String']>;
  pmiSurName?: Maybe<Scalars['String']>;
  pmiGroupId?: Maybe<Scalars['String']>;
  pmiPolicyNumber?: Maybe<Scalars['String']>;
  pmiExpiresOn?: Maybe<Scalars['String']>;
  pmiAuthorizationCode?: Maybe<Scalars['String']>;
  pmiAuthorizationSession?: Maybe<Scalars['String']>;
  pmiDocuments?: Maybe<Array<DocumentReferencecontent_Input> | DocumentReferencecontent_Input>;
  pmiDefault?: Maybe<Scalars['Int']>;
  thirdPartyName?: Maybe<Scalars['String']>;
  thirdPartyId?: Maybe<Scalars['String']>;
  thirdPartyComments?: Maybe<Scalars['String']>;
  thirdPartyContactPerson?: Maybe<Scalars['String']>;
  thirdPartyRoleOfPerson?: Maybe<Scalars['String']>;
  thirdPartyPhoneNumber?: Maybe<Scalars['String']>;
  thirdPartyEmail?: Maybe<Scalars['String']>;
}>;


export type UpdatePatientFinancialInfoMutation = (
  { __typename?: 'Mutation' }
  & { PatientFinancialInfoUpdate?: Maybe<(
    { __typename?: 'PatientFinancialInfo' }
    & Pick<PatientFinancialInfo, 'id'>
  )> }
);

export type DeletePatientFinancialInfoMutationVariables = Exact<{
  id: Scalars['id'];
}>;


export type DeletePatientFinancialInfoMutation = (
  { __typename?: 'Mutation' }
  & { PatientFinancialInfoRemove?: Maybe<(
    { __typename?: 'PatientFinancialInfo' }
    & Pick<PatientFinancialInfo, 'id'>
  )> }
);

export type AssignQuestionnaireBuilderMutationVariables = Exact<{
  patientId?: Maybe<Scalars['String']>;
  assignedId?: Maybe<Scalars['String']>;
  assignedName?: Maybe<Scalars['String']>;
  assignedType?: Maybe<Scalars['String']>;
  assignedSpeciality?: Maybe<Scalars['String']>;
  questionnaire?: Maybe<QuestionnaireBuilder_Input>;
  questitionerId?: Maybe<Scalars['String']>;
  patientName?: Maybe<Scalars['String']>;
}>;


export type AssignQuestionnaireBuilderMutation = (
  { __typename?: 'Mutation' }
  & { PatientQuestionnaireCreate?: Maybe<(
    { __typename?: 'PatientQuestionnaire_Schema' }
    & Pick<PatientQuestionnaire_Schema, 'id'>
  )> }
);

export type CompleteQuestionnaireBuilderMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  questionnaire?: Maybe<QuestionnaireBuilder_Input>;
  status?: Maybe<Scalars['String']>;
}>;


export type CompleteQuestionnaireBuilderMutation = (
  { __typename?: 'Mutation' }
  & { PatientQuestionnaireUpdate?: Maybe<(
    { __typename?: 'PatientQuestionnaire_Schema' }
    & Pick<PatientQuestionnaire_Schema, 'id'>
  )> }
);

export type UpdateAppointmentMedicationsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  practitionerName?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  practitionerSpeciality?: Maybe<Scalars['String']>;
  medications?: Maybe<Array<Maybe<PatientPrescriptionExtension_Input>> | Maybe<PatientPrescriptionExtension_Input>>;
  patientName?: Maybe<Scalars['String']>;
  patientAddress?: Maybe<Scalars['String']>;
  practitionerSignUrl?: Maybe<Scalars['String']>;
  gmcNumber?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  dateofbirth?: Maybe<Scalars['String']>;
  practitionerEmail?: Maybe<Scalars['String']>;
  practitionerPhoneNumber?: Maybe<Scalars['String']>;
  practitionerAddress?: Maybe<Scalars['String']>;
  patientEmail?: Maybe<Scalars['String']>;
  patientPhoneNumber?: Maybe<Scalars['String']>;
  diagnosis?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  disorderDetails?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  prescriptionFileUrl?: Maybe<Scalars['String']>;
  prescriptionFileUrlName?: Maybe<Scalars['String']>;
}>;


export type UpdateAppointmentMedicationsMutation = (
  { __typename?: 'Mutation' }
  & { PomsAppointmentUpdate?: Maybe<(
    { __typename?: 'PomsAppointment' }
    & Pick<PomsAppointment, 'id'>
  )> }
);

export type UpdateAppointmentNotesMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  practName?: Maybe<Scalars['String']>;
  practID?: Maybe<Scalars['String']>;
  patID?: Maybe<Scalars['String']>;
  practitionerSpeciality?: Maybe<Scalars['String']>;
  templateName: Scalars['String'];
  tempMode: Scalars['String'];
  tempType: Scalars['String'];
  tempData: Scalars['String'];
  patientName?: Maybe<Scalars['String']>;
  gpName?: Maybe<Scalars['String']>;
  gpEmail?: Maybe<Scalars['String']>;
  gpPractitionerName?: Maybe<Scalars['String']>;
  templateJsonData?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  diagnosis?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  disorderDetails?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type UpdateAppointmentNotesMutation = (
  { __typename?: 'Mutation' }
  & { PomsAppointmentUpdate?: Maybe<(
    { __typename?: 'PomsAppointment' }
    & Pick<PomsAppointment, 'id'>
  )> }
);

export type SavePractitionerPatientCommunicationV1MutationVariables = Exact<{
  patientId?: Maybe<Scalars['String']>;
  toEmail?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  ccEmail?: Maybe<Scalars['String']>;
  bccEmail?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  messageContent?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  practitionerName?: Maybe<Scalars['String']>;
  commFromType?: Maybe<Scalars['Int']>;
  commToType?: Maybe<Scalars['Int']>;
  fromId?: Maybe<Scalars['String']>;
  toId?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  toName?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
}>;


export type SavePractitionerPatientCommunicationV1Mutation = (
  { __typename?: 'Mutation' }
  & { PractitionerPatientCommunicationCreate?: Maybe<(
    { __typename?: 'PractitionerPatientCommunication' }
    & Pick<PractitionerPatientCommunication, 'id'>
  )> }
);

export type SendPractitionerReplyMutationVariables = Exact<{
  patientId?: Maybe<Scalars['String']>;
  toEmail?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  ccEmail?: Maybe<Scalars['String']>;
  bccEmail?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  messageContent?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  practitionerName?: Maybe<Scalars['String']>;
  commFromType?: Maybe<Scalars['Int']>;
  commToType?: Maybe<Scalars['Int']>;
  fromId?: Maybe<Scalars['String']>;
  toId?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  toName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['id']>;
  documentUrl?: Maybe<Scalars['String']>;
}>;


export type SendPractitionerReplyMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerPatientCommunicationUpdate?: Maybe<(
    { __typename?: 'PractitionerPatientCommunication' }
    & Pick<PractitionerPatientCommunication, 'id'>
  )> }
);

export type AddRecommendationMutationVariables = Exact<{
  forPractitionerId?: Maybe<Scalars['id']>;
  forPractitionerName?: Maybe<Scalars['String']>;
  forPractitionerEmail?: Maybe<Scalars['String']>;
  toPractitionerId?: Maybe<Scalars['String']>;
  toPractitionerName?: Maybe<Scalars['String']>;
  toPractitionerEmail?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
}>;


export type AddRecommendationMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id' | 'status'>
  )> }
);

export type UpdatePractStatusMutationVariables = Exact<{
  practId?: Maybe<Scalars['id']>;
  communicationStatus?: Maybe<Scalars['Int']>;
}>;


export type UpdatePractStatusMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerUpdate?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'id' | 'status'>
  )> }
);

export type CreatePatientFeedbackMutationVariables = Exact<{
  feedBackPersonTitle?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<DocumentReferencecontent_Input> | DocumentReferencecontent_Input>;
  feedBackPersonFirstName?: Maybe<Scalars['String']>;
  feedbackType?: Maybe<Scalars['Int']>;
  feedBackAbout?: Maybe<Scalars['Int']>;
  feedBackForPatientorRelative?: Maybe<Scalars['Int']>;
  feedBackPersonLastName?: Maybe<Scalars['String']>;
  feedBackPersonSurName?: Maybe<Scalars['String']>;
  feedBackPersonEmail?: Maybe<Scalars['String']>;
  feedBackPersonPhoneNumber?: Maybe<Scalars['String']>;
  feedBackComments?: Maybe<Scalars['String']>;
  feedBackServiceEmail?: Maybe<Scalars['String']>;
  feedBackAgainstUser?: Maybe<Scalars['String']>;
  feedBackServiceUserName?: Maybe<Scalars['String']>;
  fromUserId?: Maybe<Scalars['String']>;
  againstUserId?: Maybe<Scalars['String']>;
}>;


export type CreatePatientFeedbackMutation = (
  { __typename?: 'Mutation' }
  & { FeedBackCreate?: Maybe<(
    { __typename?: 'FeedBack' }
    & Pick<FeedBack, 'id'>
  )> }
);

export type DeleteSlotMutationVariables = Exact<{
  slotIds?: Maybe<Array<Maybe<Scalars['id']>> | Maybe<Scalars['id']>>;
}>;


export type DeleteSlotMutation = (
  { __typename?: 'Mutation' }
  & { SlotRemove?: Maybe<(
    { __typename?: 'Slot' }
    & Pick<Slot, 'id'>
  )> }
);

export type ArchiveCommMutationVariables = Exact<{
  id: Scalars['id'];
}>;


export type ArchiveCommMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerPatientCommunicationRemove?: Maybe<(
    { __typename?: 'PractitionerPatientCommunication' }
    & Pick<PractitionerPatientCommunication, 'id'>
  )> }
);

export type UpdateFeedbackMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  feedBackType?: Maybe<Scalars['Int']>;
  feedBackTypeId?: Maybe<Scalars['String']>;
  feedBackComments?: Maybe<Scalars['String']>;
  feedBackTypeName?: Maybe<Scalars['String']>;
}>;


export type UpdateFeedbackMutation = (
  { __typename?: 'Mutation' }
  & { FeedBackUpdate?: Maybe<(
    { __typename?: 'FeedBack' }
    & Pick<FeedBack, 'id'>
  )> }
);

export type UpdateLetterMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  tempData?: Maybe<Scalars['String']>;
  templateJsonData?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  gpName?: Maybe<Scalars['String']>;
  gpEmail?: Maybe<Scalars['String']>;
  adminName?: Maybe<Scalars['String']>;
  adminEmail?: Maybe<Scalars['String']>;
  adminLetter?: Maybe<Scalars['Boolean']>;
  notificationMessage?: Maybe<Scalars['String']>;
  patientName?: Maybe<Scalars['String']>;
  patID?: Maybe<Scalars['String']>;
  practID?: Maybe<Scalars['String']>;
  practName?: Maybe<Scalars['String']>;
  gpPractitionerName?: Maybe<Scalars['String']>;
}>;


export type UpdateLetterMutation = (
  { __typename?: 'Mutation' }
  & { PomsPatientLetterUpdate?: Maybe<(
    { __typename?: 'PomsPatientLetter' }
    & Pick<PomsPatientLetter, 'id'>
  )> }
);

export type UpdatePractitionerNotificationFlagMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  isNotificationAll?: Maybe<Scalars['Boolean']>;
}>;


export type UpdatePractitionerNotificationFlagMutation = (
  { __typename?: 'Mutation' }
  & { PractitionerNotificationUpdate?: Maybe<(
    { __typename?: 'PractitionerNotifications' }
    & Pick<PractitionerNotifications, 'id'>
  )> }
);

export type CreatePractitionerSlotMutationVariables = Exact<{
  locationName?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  managingPractitioner?: Maybe<Scalars['String']>;
  breakRequired?: Maybe<Scalars['Int']>;
  fromDate?: Maybe<Scalars['String']>;
  toDate?: Maybe<Scalars['String']>;
  endType?: Maybe<Scalars['Int']>;
  endOnDate?: Maybe<Scalars['String']>;
  endOnAfterNoOfOccurences?: Maybe<Scalars['Int']>;
  weekTimings?: Maybe<Array<Maybe<PomsPractitionerScheduleWeekTimings_Input>> | Maybe<PomsPractitionerScheduleWeekTimings_Input>>;
  isRepeat?: Maybe<Scalars['Int']>;
  repeatSelectType?: Maybe<Scalars['Int']>;
}>;


export type CreatePractitionerSlotMutation = (
  { __typename?: 'Mutation' }
  & { PomsSlotCreate?: Maybe<(
    { __typename?: 'PomsPractitionerSchedule' }
    & Pick<PomsPractitionerSchedule, 'id' | 'message'>
  )> }
);

export type AssignExternalQuestionnaireBuilderMutationVariables = Exact<{
  patientId?: Maybe<Scalars['String']>;
  assignedId?: Maybe<Scalars['String']>;
  assignedName?: Maybe<Scalars['String']>;
  assignedType?: Maybe<Scalars['String']>;
  assignedSpeciality?: Maybe<Scalars['String']>;
  questionnaire?: Maybe<QuestionnaireBuilder_Input>;
  questitionerId?: Maybe<Scalars['String']>;
  patientName?: Maybe<Scalars['String']>;
  questionnaireName?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  emailBody?: Maybe<Scalars['String']>;
}>;


export type AssignExternalQuestionnaireBuilderMutation = (
  { __typename?: 'Mutation' }
  & { ExternalPatientQuestionnaireCreate?: Maybe<(
    { __typename?: 'ExternalPatientQuestionnaire_Schema' }
    & Pick<ExternalPatientQuestionnaire_Schema, 'id'>
  )> }
);

export type UpdatePatientContactDetailsMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  patientBlock?: Maybe<PatientBlock_Input>;
}>;


export type UpdatePatientContactDetailsMutation = (
  { __typename?: 'Mutation' }
  & { PatientBlockUpdate?: Maybe<(
    { __typename?: 'Patient' }
    & Pick<Patient, 'id'>
  )> }
);

export type UpdatePomsAppointmentUpdateVideoTokenMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
}>;


export type UpdatePomsAppointmentUpdateVideoTokenMutation = (
  { __typename?: 'Mutation' }
  & { PomsAppointmentUpdate?: Maybe<(
    { __typename?: 'PomsAppointment' }
    & Pick<PomsAppointment, 'id'>
  )> }
);

export type UpdatePatientContactDetailsSecondaryMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  patientDisorder?: Maybe<PatientDisorder_Input>;
  patientSecondaryDisorder?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type UpdatePatientContactDetailsSecondaryMutation = (
  { __typename?: 'Mutation' }
  & { PatientDisorderUpdate?: Maybe<(
    { __typename?: 'Patient' }
    & Pick<Patient, 'id'>
  )> }
);

export type UpdatePractitionerCongtractFilePathMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  contractFilePath?: Maybe<Scalars['String']>;
}>;


export type UpdatePractitionerCongtractFilePathMutation = (
  { __typename?: 'Mutation' }
  & { PomsPractitionerContractFile?: Maybe<(
    { __typename?: 'PomsPractitionerAgreements' }
    & Pick<PomsPractitionerAgreements, 'id'>
  )> }
);

export type CrisisSafeguardCreateMutationVariables = Exact<{
  patID: Scalars['String'];
  practID: Scalars['String'];
  practName: Scalars['String'];
  templateName: Scalars['String'];
  tempMode: Scalars['String'];
  tempType: Scalars['String'];
  tempData: Scalars['String'];
  patientName?: Maybe<Scalars['String']>;
  templateJsonData?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  notificationMessage?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gpName?: Maybe<Scalars['String']>;
  gpEmail?: Maybe<Scalars['String']>;
}>;


export type CrisisSafeguardCreateMutation = (
  { __typename?: 'Mutation' }
  & { CrisisSafeguardCreate?: Maybe<(
    { __typename?: 'CrisisSafeguard' }
    & Pick<CrisisSafeguard, 'id'>
  )> }
);

export type CrisisSafeguardvRemoveMutationVariables = Exact<{
  id: Scalars['id'];
}>;


export type CrisisSafeguardvRemoveMutation = (
  { __typename?: 'Mutation' }
  & { CrisisSafeguardvRemove?: Maybe<(
    { __typename?: 'CrisisSafeguard' }
    & Pick<CrisisSafeguard, 'id'>
  )> }
);

export type CrisisSafeguardUpdateMutationVariables = Exact<{
  id?: Maybe<Scalars['id']>;
  patID: Scalars['String'];
  practID: Scalars['String'];
  practName: Scalars['String'];
  templateName: Scalars['String'];
  tempMode: Scalars['String'];
  tempType: Scalars['String'];
  tempData: Scalars['String'];
  patientName?: Maybe<Scalars['String']>;
  templateJsonData?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  notificationMessage?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gpName?: Maybe<Scalars['String']>;
  gpEmail?: Maybe<Scalars['String']>;
}>;


export type CrisisSafeguardUpdateMutation = (
  { __typename?: 'Mutation' }
  & { CrisisSafeguardUpdate?: Maybe<(
    { __typename?: 'CrisisSafeguard' }
    & Pick<CrisisSafeguard, 'id'>
  )> }
);

export type CreateSignPostingMutationVariables = Exact<{
  organizationName?: Maybe<Scalars['String']>;
  organizationEmail?: Maybe<Scalars['String']>;
  organizationPhoneNo?: Maybe<Scalars['String']>;
  organizationWebsite?: Maybe<Scalars['String']>;
  organizationImageUrl?: Maybe<Scalars['String']>;
  organizationCategory?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  organizationSearchtag?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  organizationDescription?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  uploadedDate?: Maybe<Scalars['String']>;
  uploadedUserName?: Maybe<Scalars['String']>;
}>;


export type CreateSignPostingMutation = (
  { __typename?: 'Mutation' }
  & { SignPostingCreate?: Maybe<(
    { __typename?: 'SignPosting_Schema' }
    & Pick<SignPosting_Schema, 'id'>
  )> }
);

export type CreateLeafletMutationVariables = Exact<{
  leafletName?: Maybe<Scalars['String']>;
  leafletDescription?: Maybe<Scalars['String']>;
  lefaletDocumentUrl?: Maybe<Scalars['String']>;
  leafletSearchtag?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  uploadedBy?: Maybe<Scalars['String']>;
  uploadedDate?: Maybe<Scalars['String']>;
  uploadedUserName?: Maybe<Scalars['String']>;
}>;


export type CreateLeafletMutation = (
  { __typename?: 'Mutation' }
  & { LeafletCreate?: Maybe<(
    { __typename?: 'Leaflet_Schema' }
    & Pick<Leaflet_Schema, 'id'>
  )> }
);

export type UpdateLeafletMutationVariables = Exact<{
  leafletName?: Maybe<Scalars['String']>;
  leafletDescription?: Maybe<Scalars['String']>;
  lefaletDocumentUrl?: Maybe<Scalars['String']>;
  leafletSearchtag?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  uploadedBy?: Maybe<Scalars['String']>;
  uploadedDate?: Maybe<Scalars['String']>;
  uploadedUserName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['id']>;
}>;


export type UpdateLeafletMutation = (
  { __typename?: 'Mutation' }
  & { LeafletUpdate?: Maybe<(
    { __typename?: 'Leaflet_Schema' }
    & Pick<Leaflet_Schema, 'id'>
  )> }
);

export type LeafletRemoveMutationVariables = Exact<{
  id: Scalars['id'];
}>;


export type LeafletRemoveMutation = (
  { __typename?: 'Mutation' }
  & { LeafletRemove?: Maybe<(
    { __typename?: 'Leaflet_Schema' }
    & Pick<Leaflet_Schema, 'id'>
  )> }
);

export type UpdateSignPostingMutationVariables = Exact<{
  organizationWebsite?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  organizationCategory?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  organizationSearchtag?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  organizationDescription?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  uploadedDate?: Maybe<Scalars['String']>;
  uploadedUserName?: Maybe<Scalars['String']>;
  organizationImageUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['id']>;
}>;


export type UpdateSignPostingMutation = (
  { __typename?: 'Mutation' }
  & { SignPostingUpdate?: Maybe<(
    { __typename?: 'SignPosting_Schema' }
    & Pick<SignPosting_Schema, 'id'>
  )> }
);

export type SignPostingRemoveMutationVariables = Exact<{
  id: Scalars['id'];
}>;


export type SignPostingRemoveMutation = (
  { __typename?: 'Mutation' }
  & { SignPostingRemove?: Maybe<(
    { __typename?: 'SignPosting_Schema' }
    & Pick<SignPosting_Schema, 'id'>
  )> }
);

export type ShareDocumentMutationVariables = Exact<{
  selectedDocuments?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  recipientEmails?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  patientId?: Maybe<Scalars['String']>;
  sendById?: Maybe<Scalars['String']>;
  sendByName?: Maybe<Scalars['String']>;
  sendByUserType?: Maybe<Scalars['String']>;
  patientName?: Maybe<Scalars['String']>;
}>;


export type ShareDocumentMutation = (
  { __typename?: 'Mutation' }
  & { ShareDocument?: Maybe<(
    { __typename?: 'Patient' }
    & Pick<Patient, 'id'>
  )> }
);

export type TaskManagerCreateMutationVariables = Exact<{
  task_name?: Maybe<Scalars['String']>;
  task_type?: Maybe<Scalars['String']>;
}>;


export type TaskManagerCreateMutation = (
  { __typename?: 'Mutation' }
  & { TaskManagerCreate?: Maybe<(
    { __typename?: 'TaskManager' }
    & Pick<TaskManager, 'id'>
  )> }
);

export type TaskManagerUpdateMutationVariables = Exact<{
  task_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['id']>;
}>;


export type TaskManagerUpdateMutation = (
  { __typename?: 'Mutation' }
  & { TaskManagerUpdate?: Maybe<(
    { __typename?: 'TaskManager' }
    & Pick<TaskManager, 'message'>
  )> }
);

export type TaskManagerRemoveMutationVariables = Exact<{
  id: Scalars['id'];
}>;


export type TaskManagerRemoveMutation = (
  { __typename?: 'Mutation' }
  & { TaskManagerRemove?: Maybe<(
    { __typename?: 'TaskManager' }
    & Pick<TaskManager, 'message'>
  )> }
);

export type TaskAssignMutationVariables = Exact<{
  assigner_type?: Maybe<Scalars['String']>;
  assigner_id?: Maybe<Scalars['String']>;
  assignee_type?: Maybe<Scalars['String']>;
  assignee_id?: Maybe<Scalars['String']>;
  task_category_id?: Maybe<Scalars['id']>;
  additional_notes?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  assignee_email?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['String']>;
  patient_id?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['String']>;
  task_for?: Maybe<Scalars['String']>;
}>;


export type TaskAssignMutation = (
  { __typename?: 'Mutation' }
  & { TaskAssign?: Maybe<(
    { __typename?: 'TaskManager' }
    & Pick<TaskManager, 'message'>
  )> }
);

export type CompleteAssignTaskMutationVariables = Exact<{
  assignment_ids?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  completion_note?: Maybe<Scalars['String']>;
}>;


export type CompleteAssignTaskMutation = (
  { __typename?: 'Mutation' }
  & { CompleteAssignTask?: Maybe<(
    { __typename?: 'TaskManager' }
    & Pick<TaskManager, 'message'>
  )> }
);

export type GetPractitionerPersonalDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerPersonalDetailsQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & Pick<Practitioner, 'fullName' | 'gender' | 'nationality' | 'birthDate' | 'communicationUpdated' | 'communicationStatus'>
    & { name?: Maybe<Array<Maybe<(
      { __typename?: 'HumanName' }
      & Pick<HumanName, 'use' | 'family' | 'given' | 'prefix'>
    )>>>, communication?: Maybe<Array<Maybe<(
      { __typename?: 'CodeableConcept' }
      & { coding?: Maybe<Array<Maybe<(
        { __typename?: 'Coding' }
        & Pick<Coding, 'system' | 'code' | 'display'>
      )>>> }
    )>>> }
  )> }
);

export type GetPractitionerAboutQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerAboutQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { practionerAbout?: Maybe<(
      { __typename?: 'PractionerAboutUs_Extension' }
      & Pick<PractionerAboutUs_Extension, 'about' | 'personalStatement' | 'videourl' | 'profileTags'>
    )>, photo?: Maybe<Array<Maybe<(
      { __typename?: 'Attachment' }
      & Pick<Attachment, 'title' | 'url'>
    )>>> }
  )> }
);

export type GetPractitionerContactDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerContactDetailsQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { address?: Maybe<Array<Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'line' | 'city' | 'state' | 'country' | 'postalCode'>
    )>>>, telecom?: Maybe<Array<Maybe<(
      { __typename?: 'ContactPoint' }
      & Pick<ContactPoint, 'system' | 'value' | 'use' | 'rank'>
    )>>>, emergencyContact?: Maybe<Array<Maybe<(
      { __typename?: 'PractionerEmergency_Extension' }
      & Pick<PractionerEmergency_Extension, 'fullname' | 'realtionship' | 'email' | 'mobile'>
    )>>> }
  )> }
);

export type GetPractitonerQualificationDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitonerQualificationDetailsQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { qualification?: Maybe<Array<Maybe<(
      { __typename?: 'Practitionerqualification' }
      & Pick<Practitionerqualification, 'university' | 'fieldOfStudy' | 'country'>
      & { code: (
        { __typename?: 'CodeableConcept' }
        & Pick<CodeableConcept, 'text'>
        & { coding?: Maybe<Array<Maybe<(
          { __typename?: 'Coding' }
          & Pick<Coding, 'system' | 'display' | 'code'>
        )>>> }
      ), period?: Maybe<(
        { __typename?: 'Period' }
        & Pick<Period, 'start'>
      )> }
    )>>> }
  )> }
);

export type GetPractitonerProfessionalDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitonerProfessionalDetailsQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { identifier?: Maybe<Array<Maybe<(
      { __typename?: 'Identifier' }
      & Pick<Identifier, 'sectionType' | 'system' | 'value' | 'identifierUrl' | 'identifierNumber' | 'identifierType' | 'country'>
      & { period?: Maybe<(
        { __typename?: 'Period' }
        & Pick<Period, 'start' | 'end'>
      )> }
    )>>> }
  )>, PractitionerRole?: Maybe<(
    { __typename?: 'PractitionerRole' }
    & Pick<PractitionerRole, 'band' | 'yearsOfExp'>
    & { code?: Maybe<Array<Maybe<(
      { __typename?: 'CodeableConcept' }
      & { coding?: Maybe<Array<Maybe<(
        { __typename?: 'Coding' }
        & Pick<Coding, 'system' | 'display' | 'code'>
      )>>> }
    )>>>, specialty?: Maybe<Array<Maybe<(
      { __typename?: 'CodeableConcept' }
      & { coding?: Maybe<Array<Maybe<(
        { __typename?: 'Coding' }
        & Pick<Coding, 'system' | 'display' | 'code'>
      )>>> }
    )>>>, subSpecialty?: Maybe<Array<Maybe<(
      { __typename?: 'CodeableConcept' }
      & { coding?: Maybe<Array<Maybe<(
        { __typename?: 'Coding' }
        & Pick<Coding, 'system' | 'display' | 'code'>
      )>>> }
    )>>>, subSpecialtyMaster?: Maybe<Array<Maybe<(
      { __typename?: 'CodeableConcept' }
      & { coding?: Maybe<Array<Maybe<(
        { __typename?: 'Coding' }
        & Pick<Coding, 'display' | 'code'>
      )>>> }
    )>>> }
  )> }
);

export type GetPractitonerExpertiseQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitonerExpertiseQuery = (
  { __typename?: 'Query' }
  & { PractitionerRole?: Maybe<(
    { __typename?: 'PractitionerRole' }
    & { expertise?: Maybe<Array<Maybe<(
      { __typename?: 'PractionerExpertiseExtension' }
      & Pick<PractionerExpertiseExtension, 'expertiseType' | 'expertiseTypeValues'>
    )>>> }
  )> }
);

export type GetPractitonerAwardsAndMediaMentionsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitonerAwardsAndMediaMentionsQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { awards?: Maybe<Array<Maybe<(
      { __typename?: 'PractionerAwardsExtension' }
      & Pick<PractionerAwardsExtension, 'awardName' | 'awardedOn' | 'institutionName' | 'country'>
    )>>>, media?: Maybe<Array<Maybe<(
      { __typename?: 'PractionerMediaExtension' }
      & Pick<PractionerMediaExtension, 'mediaOulet' | 'mentinedIn' | 'typeOfMedium' | 'url'>
    )>>> }
  )> }
);

export type GetPractitonerPublicationsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitonerPublicationsQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { publications?: Maybe<Array<Maybe<(
      { __typename?: 'PractionerPublicationsExtension' }
      & Pick<PractionerPublicationsExtension, 'publishedOn' | 'publicationName' | 'publicationType' | 'url'>
    )>>> }
  )> }
);

export type GetPractitonerAffiliationsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitonerAffiliationsQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { affiliations?: Maybe<Array<Maybe<(
      { __typename?: 'PractionerAffiliationExtension' }
      & Pick<PractionerAffiliationExtension, 'institutionName' | 'relationshipWithOrganization' | 'fromDate' | 'toDate' | 'country' | 'title' | 'supervisorsLastName' | 'supervisorsFirstName' | 'mobile' | 'email' | 'alternateEmail'>
    )>>> }
  )> }
);

export type GetPractitonerAccredationsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitonerAccredationsQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { accreditations?: Maybe<Array<Maybe<(
      { __typename?: 'PractionerAccreditationExtension' }
      & Pick<PractionerAccreditationExtension, 'insuranceCompanyName' | 'providerNo' | 'healthcodeIdentifier' | 'registrationDate' | 'imageUrl' | 'shareData'>
    )>>> }
  )> }
);

export type GetPractitionerInvoiceBillingQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerInvoiceBillingQuery = (
  { __typename?: 'Query' }
  & { PomsInvoiceBilling?: Maybe<(
    { __typename?: 'PomsBillingInvoice' }
    & Pick<PomsBillingInvoice, 'entityType' | 'nationalInsuranceNumber' | 'buildingSocietyName' | 'accountHolderName' | 'sortCode' | 'accountNo' | 'managingPractitioner' | 'companyName' | 'companyNumber' | 'vatNumber' | 'utrNo'>
    & { documents?: Maybe<(
      { __typename?: 'DocumentReference' }
      & { content?: Maybe<Array<(
        { __typename?: 'DocumentReferencecontent' }
        & { attachment: (
          { __typename?: 'Attachment' }
          & Pick<Attachment, 'title' | 'url' | 'creation' | 'documentType'>
        ) }
      )>> }
    )> }
  )> }
);

export type GetPractitionerAgreementsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerAgreementsQuery = (
  { __typename?: 'Query' }
  & { PomsPractitionerAgreement?: Maybe<(
    { __typename?: 'PomsPractitionerAgreements' }
    & Pick<PomsPractitionerAgreements, 'pomsHandBook' | 'termsOfUse' | 'pomsContract' | 'managingPractitioner' | 'contractFilePath'>
    & { documents?: Maybe<(
      { __typename?: 'DocumentReference' }
      & { content?: Maybe<Array<(
        { __typename?: 'DocumentReferencecontent' }
        & { attachment: (
          { __typename?: 'Attachment' }
          & Pick<Attachment, 'title' | 'url' | 'creation' | 'documentType'>
        ) }
      )>> }
    )> }
  )> }
);

export type GetPractitinerDocumentsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitinerDocumentsQuery = (
  { __typename?: 'Query' }
  & { DocumentReference?: Maybe<(
    { __typename?: 'DocumentReference' }
    & Pick<DocumentReference, 'id' | 'resourceType'>
    & { content?: Maybe<Array<(
      { __typename?: 'DocumentReferencecontent' }
      & { attachment: (
        { __typename?: 'Attachment' }
        & Pick<Attachment, 'title' | 'url' | 'creation' | 'documentType'>
      ) }
    )>> }
  )> }
);

export type GetPractitionerLocationsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerLocationsQuery = (
  { __typename?: 'Query' }
  & { LocationList?: Maybe<Array<Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id' | 'name'>
    & { locationExtension?: Maybe<(
      { __typename?: 'LocationExtension_Schema' }
      & Pick<LocationExtension_Schema, 'practitionerReference' | 'GTNID' | 'COCID' | 'locationRank'>
    )>, address?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'line' | 'city' | 'state' | 'country' | 'postalCode'>
    )>, telecom?: Maybe<Array<Maybe<(
      { __typename?: 'ContactPoint' }
      & Pick<ContactPoint, 'system' | 'value' | 'use' | 'rank'>
    )>>> }
  )>>> }
);

export type GetPractitionerPreferencesQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerPreferencesQuery = (
  { __typename?: 'Query' }
  & { PomsPractitionerPreference?: Maybe<(
    { __typename?: 'PomsPractitionerPreferences' }
    & Pick<PomsPractitionerPreferences, 'managingPractitioner' | 'sendCommunicationMessage'>
    & { country?: Maybe<(
      { __typename?: 'CodeableConcept' }
      & { coding?: Maybe<Array<Maybe<(
        { __typename?: 'Coding' }
        & Pick<Coding, 'system' | 'code' | 'display'>
      )>>> }
    )>, language?: Maybe<(
      { __typename?: 'CodeableConcept' }
      & { coding?: Maybe<Array<Maybe<(
        { __typename?: 'Coding' }
        & Pick<Coding, 'system' | 'code' | 'display'>
      )>>> }
    )>, timezone?: Maybe<(
      { __typename?: 'CodeableConcept' }
      & { coding?: Maybe<Array<Maybe<(
        { __typename?: 'Coding' }
        & Pick<Coding, 'system' | 'code' | 'display'>
      )>>> }
    )>, currency?: Maybe<(
      { __typename?: 'CodeableConcept' }
      & { coding?: Maybe<Array<Maybe<(
        { __typename?: 'Coding' }
        & Pick<Coding, 'system' | 'code' | 'display'>
      )>>> }
    )> }
  )> }
);

export type GetPractitionerPrivacyQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerPrivacyQuery = (
  { __typename?: 'Query' }
  & { PomsPractitionerPrivacy?: Maybe<(
    { __typename?: 'PomsPractitionerPrivacy' }
    & Pick<PomsPractitionerPrivacy, 'contactSMS' | 'contactPost' | 'contactPhone' | 'contactEmail' | 'notifySMS' | 'notifyPost' | 'notifyPhone' | 'notifyEmail' | 'gdprConsent'>
  )> }
);

export type GetPractitionerActivityQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerActivityQuery = (
  { __typename?: 'Query' }
  & { PomsPractitionerActivityList?: Maybe<Array<Maybe<(
    { __typename?: 'PomsPractitionerActivity' }
    & Pick<PomsPractitionerActivity, 'id' | 'ipaddress' | 'device' | 'accessedOn' | 'country' | 'logInTime' | 'logOutTime'>
  )>>> }
);

export type GetPractitionerEmergencyDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerEmergencyDetailsQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { emergencyContact?: Maybe<Array<Maybe<(
      { __typename?: 'PractionerEmergency_Extension' }
      & Pick<PractionerEmergency_Extension, 'fullname' | 'mobile' | 'email' | 'realtionship'>
    )>>> }
  )> }
);

export type GetMasterDataQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetMasterDataQuery = (
  { __typename?: 'Query' }
  & { ValueSet?: Maybe<(
    { __typename?: 'ValueSet' }
    & { compose?: Maybe<(
      { __typename?: 'ValueSetcompose' }
      & { include?: Maybe<Array<(
        { __typename?: 'ValueSetcomposeinclude' }
        & Pick<ValueSetcomposeinclude, 'system'>
        & { concept?: Maybe<Array<Maybe<(
          { __typename?: 'ValueSetcomposeincludeconcept' }
          & Pick<ValueSetcomposeincludeconcept, 'code' | 'display' | 'disorder' | 'img'>
        )>>> }
      )>> }
    )> }
  )> }
);

export type GetLanguagesDataQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetLanguagesDataQuery = (
  { __typename?: 'Query' }
  & { ValueSet?: Maybe<(
    { __typename?: 'ValueSet' }
    & { compose?: Maybe<(
      { __typename?: 'ValueSetcompose' }
      & { include?: Maybe<Array<(
        { __typename?: 'ValueSetcomposeinclude' }
        & Pick<ValueSetcomposeinclude, 'system'>
        & { concept?: Maybe<Array<Maybe<(
          { __typename?: 'ValueSetcomposeincludeconcept' }
          & Pick<ValueSetcomposeincludeconcept, 'code' | 'display'>
        )>>> }
      )>> }
    )> }
  )> }
);

export type GetPractitionerScheduleQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerScheduleQuery = (
  { __typename?: 'Query' }
  & { PomsPractitionerSchedule?: Maybe<(
    { __typename?: 'PomsPractitionerSchedule' }
    & Pick<PomsPractitionerSchedule, 'id' | 'locationId' | 'locationName' | 'color' | 'managingPractitioner' | 'breakRequired' | 'fromDate' | 'toDate' | 'endOnType' | 'endOnDate' | 'isRepeat' | 'endOnAfterNoOfOccurences' | 'repeatSelectType'>
    & { weekTimings?: Maybe<Array<Maybe<(
      { __typename?: 'PomsPractitionerScheduleWeekTimings' }
      & Pick<PomsPractitionerScheduleWeekTimings, 'weekDayName' | 'weekDayNumber'>
      & { weekDayTimings?: Maybe<Array<Maybe<(
        { __typename?: 'PomsPractitionerScheduleWeekDayTimings' }
        & Pick<PomsPractitionerScheduleWeekDayTimings, 'endTime' | 'startTime'>
      )>>> }
    )>>> }
  )> }
);

export type GetPractitionerSlotsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
  date?: Maybe<Scalars['date']>;
}>;


export type GetPractitionerSlotsQuery = (
  { __typename?: 'Query' }
  & { SlotList?: Maybe<Array<Maybe<(
    { __typename?: 'Slot' }
    & Pick<Slot, 'id' | 'start' | 'end' | 'appointmentTypeId' | 'professionalId' | 'status' | 'appointmentMode'>
    & { slotExtension?: Maybe<(
      { __typename?: 'Slot_Extension' }
      & Pick<Slot_Extension, 'managingPractitioner'>
    )> }
  )>>> }
);

export type GetPatientProfileDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPatientProfileDetailsQuery = (
  { __typename?: 'Query' }
  & { Patient?: Maybe<(
    { __typename?: 'Patient' }
    & Pick<Patient, 'gender' | 'birthDate' | 'nationality' | 'occupation' | 'tags' | 'patientSecondaryDisorder'>
    & { name?: Maybe<Array<Maybe<(
      { __typename?: 'HumanName' }
      & Pick<HumanName, 'use' | 'family' | 'given' | 'prefix'>
    )>>>, patientProfileExtension?: Maybe<(
      { __typename?: 'PatientProfileExtension_Schema' }
      & Pick<PatientProfileExtension_Schema, 'whereDidYouHearFrom' | 'aboutYourSelf' | 'profileTags'>
      & { genderIdentity?: Maybe<Array<Maybe<(
        { __typename?: 'CodeableConcept' }
        & { coding?: Maybe<Array<Maybe<(
          { __typename?: 'Coding' }
          & Pick<Coding, 'system' | 'code' | 'display'>
        )>>> }
      )>>>, sexualOrientation?: Maybe<Array<Maybe<(
        { __typename?: 'CodeableConcept' }
        & { coding?: Maybe<Array<Maybe<(
          { __typename?: 'Coding' }
          & Pick<Coding, 'system' | 'code' | 'display'>
        )>>> }
      )>>>, race?: Maybe<Array<Maybe<(
        { __typename?: 'CodeableConcept' }
        & { coding?: Maybe<Array<Maybe<(
          { __typename?: 'Coding' }
          & Pick<Coding, 'system' | 'code' | 'display'>
        )>>> }
      )>>>, ethnicity?: Maybe<Array<Maybe<(
        { __typename?: 'CodeableConcept' }
        & { coding?: Maybe<Array<Maybe<(
          { __typename?: 'Coding' }
          & Pick<Coding, 'system' | 'code' | 'display'>
        )>>> }
      )>>> }
    )>, maritalStatus?: Maybe<(
      { __typename?: 'CodeableConcept' }
      & { coding?: Maybe<Array<Maybe<(
        { __typename?: 'Coding' }
        & Pick<Coding, 'system' | 'code' | 'display'>
      )>>> }
    )>, photo?: Maybe<Array<Maybe<(
      { __typename?: 'Attachment' }
      & Pick<Attachment, 'url' | 'title'>
    )>>>, comments?: Maybe<Array<Maybe<(
      { __typename?: 'PatientCommentsExtension' }
      & Pick<PatientCommentsExtension, 'practitionerId' | 'practitionerName' | 'commentedOn' | 'comments'>
    )>>>, communication?: Maybe<Array<Maybe<(
      { __typename?: 'Patientcommunication' }
      & { language: (
        { __typename?: 'CodeableConcept' }
        & { coding?: Maybe<Array<Maybe<(
          { __typename?: 'Coding' }
          & Pick<Coding, 'system' | 'code' | 'display'>
        )>>> }
      ) }
    )>>>, patientDisorder?: Maybe<Array<Maybe<(
      { __typename?: 'PatientDisorder_Extension' }
      & Pick<PatientDisorder_Extension, 'disorderName' | 'createdOn'>
    )>>> }
  )> }
);

export type GetPatientContactDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPatientContactDetailsQuery = (
  { __typename?: 'Query' }
  & { Patient?: Maybe<(
    { __typename?: 'Patient' }
    & Pick<Patient, 'dob'>
    & { address?: Maybe<Array<Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'line' | 'city' | 'state' | 'country' | 'postalCode'>
    )>>>, telecom?: Maybe<Array<Maybe<(
      { __typename?: 'ContactPoint' }
      & Pick<ContactPoint, 'system' | 'value' | 'use' | 'rank'>
    )>>> }
  )> }
);

export type GetFamilyDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetFamilyDetailsQuery = (
  { __typename?: 'Query' }
  & { Patient?: Maybe<(
    { __typename?: 'Patient' }
    & { contact?: Maybe<Array<Maybe<(
      { __typename?: 'Patientcontact' }
      & Pick<Patientcontact, 'contactPreference' | 'preferredSMS' | 'preferredEmail' | 'gender' | 'birthDate'>
      & { relationship?: Maybe<Array<Maybe<(
        { __typename?: 'CodeableConcept' }
        & { coding?: Maybe<Array<Maybe<(
          { __typename?: 'Coding' }
          & Pick<Coding, 'system' | 'code' | 'display'>
        )>>> }
      )>>>, address?: Maybe<(
        { __typename?: 'Address' }
        & Pick<Address, 'line' | 'city' | 'state' | 'country' | 'postalCode'>
      )>, telecom?: Maybe<Array<Maybe<(
        { __typename?: 'ContactPoint' }
        & Pick<ContactPoint, 'system' | 'value' | 'use' | 'rank'>
      )>>>, name?: Maybe<(
        { __typename?: 'HumanName' }
        & Pick<HumanName, 'use' | 'given' | 'family' | 'prefix'>
      )> }
    )>>> }
  )> }
);

export type GetPatientHealthProfileQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPatientHealthProfileQuery = (
  { __typename?: 'Query' }
  & { Patient?: Maybe<(
    { __typename?: 'Patient' }
    & Pick<Patient, 'id'>
    & { healthProfile?: Maybe<(
      { __typename?: 'PatientHealthProfile_Extension' }
      & Pick<PatientHealthProfile_Extension, 'nhsCity' | 'nhsNumber' | 'nhsPracticeName' | 'nhsPracticeEmail' | 'nhsPhone' | 'disabilities' | 'risk' | 'deviceImplant' | 'gpName' | 'canWeContactYourGP'>
      & { medication?: Maybe<(
        { __typename?: 'Medication' }
        & { code?: Maybe<(
          { __typename?: 'CodeableConcept' }
          & { coding?: Maybe<Array<Maybe<(
            { __typename?: 'Coding' }
            & Pick<Coding, 'display'>
          )>>> }
        )> }
      )>, diagnosis?: Maybe<(
        { __typename?: 'Condition' }
        & { code?: Maybe<(
          { __typename?: 'CodeableConcept' }
          & { coding?: Maybe<Array<Maybe<(
            { __typename?: 'Coding' }
            & Pick<Coding, 'display'>
          )>>> }
        )> }
      )>, immunization?: Maybe<Array<Maybe<(
        { __typename?: 'Immunization' }
        & Pick<Immunization, 'occurrenceDateTime'>
        & { vaccineCode: (
          { __typename?: 'CodeableConcept' }
          & Pick<CodeableConcept, 'text'>
        ) }
      )>>>, allergies?: Maybe<Array<Maybe<(
        { __typename?: 'PatientAllergiesExtension' }
        & Pick<PatientAllergiesExtension, 'allergyType' | 'allergyTypeValues'>
      )>>>, vitals?: Maybe<Array<Maybe<(
        { __typename?: 'Observation' }
        & Pick<Observation, 'valueString' | 'valueInteger' | 'effectiveDateTime' | 'id'>
      )>>> }
    )> }
  )> }
);

export type GetPomsPatientDocumentListQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
  documentType?: Maybe<Scalars['String']>;
}>;


export type GetPomsPatientDocumentListQuery = (
  { __typename?: 'Query' }
  & { PomsPatientDocumentList?: Maybe<Array<Maybe<(
    { __typename?: 'PomsPatientDocument' }
    & Pick<PomsPatientDocument, 'documentUrl' | 'documentName' | 'practitionerId' | 'practitionerName' | 'documentType' | 'author' | 'organizationName' | 'createdOn' | 'id' | 'report_date'>
  )>>> }
);

export type GetPractitionerPatientCommListQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerPatientCommListQuery = (
  { __typename?: 'Query' }
  & { PractitionerPatientCommunicationList?: Maybe<Array<Maybe<(
    { __typename?: 'PractitionerPatientCommunication' }
    & Pick<PractitionerPatientCommunication, 'createdOn' | 'toEmail' | 'fromEmail' | 'ccEmail' | 'bccEmail' | 'subject' | 'channel' | 'status' | 'messageContent' | 'id' | 'practitionerId' | 'practitionerName' | 'practitionerSpeciality' | 'commFrom'>
  )>>> }
);

export type GetMedicationMasterListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMedicationMasterListQuery = (
  { __typename?: 'Query' }
  & { MedicationMasterList?: Maybe<Array<Maybe<(
    { __typename?: 'MedicationMasterDocument' }
    & Pick<MedicationMasterDocument, 'drugName' | 'controlledDrug' | 'dosage' | 'frequency' | 'route' | 'id'>
  )>>> }
);

export type GetPatientPrescriptionsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetPatientPrescriptionsQuery = (
  { __typename?: 'Query' }
  & { PatientPrescriptionList?: Maybe<Array<Maybe<(
    { __typename?: 'PatientPrescriptionDocument' }
    & Pick<PatientPrescriptionDocument, 'id' | 'comments' | 'practitionerName' | 'practitionerId' | 'patientId' | 'practitionerSpeciality' | 'patientName' | 'patientAddress' | 'practitionerSignUrl' | 'gmcNumber' | 'dateofbirth' | 'prescriptionStatus' | 'prescriptionSentStatus' | 'prescriptionId' | 'prescriptionDate' | 'prescriptionType' | 'prescriptionUploadUrl' | 'practitionerEmail' | 'practitionerPhoneNumber' | 'practitionerAddress' | 'patientEmail' | 'patientPhoneNumber' | 'prescriptionFileUrl' | 'prescriptionFileUrlName'>
    & { medications?: Maybe<Array<Maybe<(
      { __typename?: 'PatientPrescriptionExtension' }
      & Pick<PatientPrescriptionExtension, 'drugName' | 'drugType' | 'dosage' | 'frequency' | 'route' | 'durationOfPrescription' | 'neededToIncrease' | 'neededToDecrease' | 'furtherInstructions' | 'anyChanges'>
    )>>> }
  )>>> }
);

export type GetPatientReferralsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetPatientReferralsQuery = (
  { __typename?: 'Query' }
  & { PomsReferralList?: Maybe<Array<Maybe<(
    { __typename?: 'PomsReferral' }
    & Pick<PomsReferral, 'id' | 'typeOfReferral' | 'referrer_Title' | 'referrer_FirstName' | 'referrer_SurName' | 'referrer_Specialisation' | 'referrer_Role' | 'referrer_Location' | 'referrer_PhoneNumber' | 'referrer_Email' | 'patientAddress' | 'referrer_PostCode' | 'referrer_Address1' | 'referrer_Address2' | 'referrer_Address3' | 'referrer_City' | 'referrer_County' | 'referrer_Country' | 'referral_Title' | 'referral_FirstName' | 'referral_SurName' | 'referral_Dob' | 'referral_Email' | 'referral_PhoneNumber' | 'referral_ReferenceNumber' | 'referral_PostCode' | 'referral_Address1' | 'referral_Address2' | 'referral_Address3' | 'referral_City' | 'referral_County' | 'referral_Country' | 'typeOfReferral_Assessments' | 'typeOfReferral_RecommendationTreatments' | 'referral_Urgent' | 'referral_RiskToSelfOrOthers' | 'referral_Reason' | 'expectationFromReferral' | 'referral_VerbalConsentCheck' | 'referral_TermsAndConditions' | 'patientId' | 'patientName' | 'practitionerId' | 'practitionerName' | 'practitionerSpeciality' | 'referredPractitionerId' | 'referredPractitionerName' | 'referredPractitionerSpecialization' | 'referral_createdOn' | 'patientEmail' | 'patientPhone'>
    & { referral_UploadDocuments?: Maybe<(
      { __typename?: 'DocumentReference' }
      & { content?: Maybe<Array<(
        { __typename?: 'DocumentReferencecontent' }
        & { attachment: (
          { __typename?: 'Attachment' }
          & Pick<Attachment, 'title' | 'url' | 'creation' | 'documentType'>
        ) }
      )>> }
    )> }
  )>>> }
);

export type GetOaktreeReferralsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetOaktreeReferralsQuery = (
  { __typename?: 'Query' }
  & { PomsReferralList?: Maybe<Array<Maybe<(
    { __typename?: 'PomsReferral' }
    & Pick<PomsReferral, 'id' | 'typeOfReferral' | 'referrer_Title' | 'referrer_FirstName' | 'referrer_SurName' | 'referrer_Specialisation' | 'referrer_Role' | 'referrer_Location' | 'referrer_PhoneNumber' | 'referrer_Email' | 'patientAddress' | 'referrer_PostCode' | 'referrer_Address1' | 'referrer_Address2' | 'referrer_Address3' | 'referrer_City' | 'referrer_County' | 'referrer_Country' | 'referral_Title' | 'referral_FirstName' | 'referral_SurName' | 'referral_Dob' | 'referral_Email' | 'referral_PhoneNumber' | 'referral_ReferenceNumber' | 'referral_PostCode' | 'referral_Address1' | 'referral_Address2' | 'referral_Address3' | 'referral_City' | 'referral_County' | 'referral_Country' | 'typeOfReferral_Assessments' | 'typeOfReferral_RecommendationTreatments' | 'referral_Urgent' | 'referral_RiskToSelfOrOthers' | 'referral_Reason' | 'expectationFromReferral' | 'referral_VerbalConsentCheck' | 'referral_TermsAndConditions' | 'patientId' | 'patientName' | 'practitionerId' | 'practitionerName' | 'practitionerSpeciality' | 'referredPractitionerId' | 'referredPractitionerName' | 'referredPractitionerSpecialization' | 'referral_createdOn' | 'patientEmail' | 'patientPhone'>
    & { referral_UploadDocuments?: Maybe<(
      { __typename?: 'DocumentReference' }
      & { content?: Maybe<Array<(
        { __typename?: 'DocumentReferencecontent' }
        & { attachment: (
          { __typename?: 'Attachment' }
          & Pick<Attachment, 'title' | 'url' | 'creation' | 'documentType'>
        ) }
      )>> }
    )> }
  )>>> }
);

export type GetPatientFinancialInfoQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetPatientFinancialInfoQuery = (
  { __typename?: 'Query' }
  & { PatientFinancialInfoList?: Maybe<Array<Maybe<(
    { __typename?: 'PatientFinancialInfo' }
    & Pick<PatientFinancialInfo, 'id' | 'financialType' | 'patientId' | 'selfPayCardName' | 'selfPayCardBrand' | 'selfPayExpMonth' | 'selfPayExpYear' | 'selfPayCardType' | 'selfPayLast4' | 'selfPayPostalcode' | 'selfPayAddress1' | 'selfPayAddress2' | 'selfPayAddress3' | 'selfPayCity' | 'selfPayCounty' | 'selfPayCountry' | 'selfPayDefault' | 'pmiName' | 'pmiResponsibleParty' | 'pmiFirstName' | 'pmiSurName' | 'pmiGroupId' | 'pmiPolicyNumber' | 'pmiExpiresOn' | 'pmiAuthorizationCode' | 'pmiAuthorizationSession' | 'pmiDefault' | 'thirdPartyName' | 'thirdPartyId' | 'thirdPartyComments' | 'thirdPartyContactPerson' | 'thirdPartyRoleOfPerson' | 'thirdPartyPhoneNumber' | 'thirdPartyEmail'>
    & { pmiDocuments?: Maybe<(
      { __typename?: 'DocumentReference' }
      & { content?: Maybe<Array<(
        { __typename?: 'DocumentReferencecontent' }
        & { attachment: (
          { __typename?: 'Attachment' }
          & Pick<Attachment, 'title' | 'url' | 'creation' | 'documentType'>
        ) }
      )>> }
    )> }
  )>>> }
);

export type GetQuestionnaireBuilderListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionnaireBuilderListQuery = (
  { __typename?: 'Query' }
  & { QuestionnaireBuilderList?: Maybe<Array<Maybe<(
    { __typename?: 'QuestionnaireBuilder' }
    & Pick<QuestionnaireBuilder, 'id' | 'resourceType' | 'questionnaireName' | 'questionnaireDescription' | 'administeredType' | 'totalScore'>
    & { questions?: Maybe<Array<Maybe<(
      { __typename?: 'QuestionnaireBuilderQuestion_Schema' }
      & Pick<QuestionnaireBuilderQuestion_Schema, 'question' | 'optionType' | 'showCommentBox' | 'isCommentBoxRequired'>
      & { options?: Maybe<Array<Maybe<(
        { __typename?: 'QuestionnaireBuilderQuestionOption_Schema' }
        & Pick<QuestionnaireBuilderQuestionOption_Schema, 'option' | 'optionId' | 'optionScore'>
      )>>> }
    )>>> }
  )>>> }
);

export type GetPatientQuestionnaireQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetPatientQuestionnaireQuery = (
  { __typename?: 'Query' }
  & { PatientQuestionnaireList?: Maybe<Array<Maybe<(
    { __typename?: 'PatientQuestionnaire_Schema' }
    & Pick<PatientQuestionnaire_Schema, 'id' | 'resourceType' | 'patientId' | 'patientName' | 'assignedId' | 'assignedName' | 'assignedType' | 'assignedSpeciality' | 'questitionerId' | 'status' | 'assignedOn'>
    & { questionnaire?: Maybe<(
      { __typename?: 'QuestionnaireBuilder' }
      & Pick<QuestionnaireBuilder, 'id' | 'questionnaireName' | 'questionnaireDescription' | 'administeredType' | 'totalScore'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'QuestionnaireBuilderQuestion_Schema' }
        & Pick<QuestionnaireBuilderQuestion_Schema, 'question' | 'selectedOptionId' | 'selectedOptionText' | 'comments' | 'optionType' | 'showCommentBox' | 'isCommentBoxRequired'>
        & { options?: Maybe<Array<Maybe<(
          { __typename?: 'QuestionnaireBuilderQuestionOption_Schema' }
          & Pick<QuestionnaireBuilderQuestionOption_Schema, 'option' | 'optionId' | 'optionScore'>
        )>>> }
      )>>> }
    )> }
  )>>> }
);

export type GetPractitionerTasksQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetPractitionerTasksQuery = (
  { __typename?: 'Query' }
  & { TasksMessages?: Maybe<Array<Maybe<(
    { __typename?: 'TasksMessages' }
    & Pick<TasksMessages, 'id' | 'taskmessage' | 'createdOn'>
  )>>> }
);

export type GetPractitionerNotificationsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetPractitionerNotificationsQuery = (
  { __typename?: 'Query' }
  & { TasksMessages?: Maybe<Array<Maybe<(
    { __typename?: 'TasksMessages' }
    & Pick<TasksMessages, 'id' | 'taskmessage' | 'createdOn'>
  )>>> }
);

export type GetPractitionerStatementsQueryVariables = Exact<{
  practitionerId?: Maybe<Scalars['String']>;
}>;


export type GetPractitionerStatementsQuery = (
  { __typename?: 'Query' }
  & { PractitionerStatementList?: Maybe<Array<Maybe<(
    { __typename?: 'PractitionerStatement' }
    & Pick<PractitionerStatement, 'id' | 'statementNo' | 'statementFromDate' | 'statementToDate' | 'practitionerId' | 'practitionerSpeciality' | 'practitionerEmail' | 'practitionerName' | 'practitionerPhoneNumber' | 'totalPaymentStatus' | 'totalInvoiceAmount' | 'totalAmountPaid' | 'totalPendingAmount' | 'statementMonth' | 'statementYear' | 'practitionerAddress' | 'paymentDueDate'>
    & { statementItems?: Maybe<Array<Maybe<(
      { __typename?: 'PractitionerStatementItem' }
      & Pick<PractitionerStatementItem, 'id' | 'statementNo' | 'statementPaidOn' | 'appointmentDate' | 'appointmentTime' | 'createdOn' | 'appointmentId' | 'appointmentPayType' | 'appointmentBookedForTitle' | 'appointmentBookedForFirstName' | 'appointmentBookedForSurName' | 'appointmentBookedForEmail' | 'appointmentBookedForPhoneNumber' | 'appointmentDuration' | 'appointmentPrice' | 'appointmentType' | 'appointmentMode' | 'thirdPartyPayer' | 'pmiName' | 'pmiGroupId' | 'pmiPolicyNumber' | 'pmiAuthSession' | 'paymentStatus' | 'paymentToOkatree' | 'paymentFromOkatree' | 'statementAmount'>
    )>>> }
  )>>> }
);

export type GetPractitionerCommV1QueryVariables = Exact<{
  fromId?: Maybe<Scalars['String']>;
  listType?: Maybe<Scalars['String']>;
}>;


export type GetPractitionerCommV1Query = (
  { __typename?: 'Query' }
  & { PractitionerPatientCommunicationList?: Maybe<Array<Maybe<(
    { __typename?: 'PractitionerPatientCommunication' }
    & Pick<PractitionerPatientCommunication, 'id' | 'subject' | 'fromId' | 'toId' | 'fromEmail' | 'toEmail' | 'commFromType' | 'commToType' | 'bccEmail' | 'ccEmail' | 'createdOn' | 'fromName' | 'toName' | 'messageContent' | 'documentUrl' | 'commFrom' | 'readStatus'>
    & { replies?: Maybe<Array<Maybe<(
      { __typename?: 'PractitionerPatientCommunication' }
      & Pick<PractitionerPatientCommunication, 'subject' | 'fromId' | 'toId' | 'fromEmail' | 'toEmail' | 'commFromType' | 'commToType' | 'bccEmail' | 'ccEmail' | 'createdOn' | 'fromName' | 'toName' | 'messageContent' | 'documentUrl' | 'commFrom'>
    )>>> }
  )>>> }
);

export type GetPractitionerPatientCommV1QueryVariables = Exact<{
  fromId?: Maybe<Scalars['String']>;
  toId?: Maybe<Scalars['String']>;
}>;


export type GetPractitionerPatientCommV1Query = (
  { __typename?: 'Query' }
  & { PractitionerPatientCommunicationList?: Maybe<Array<Maybe<(
    { __typename?: 'PractitionerPatientCommunication' }
    & Pick<PractitionerPatientCommunication, 'id' | 'subject' | 'fromId' | 'toId' | 'fromEmail' | 'toEmail' | 'commFromType' | 'commToType' | 'bccEmail' | 'ccEmail' | 'createdOn' | 'fromName' | 'toName' | 'messageContent' | 'documentUrl' | 'commFrom'>
    & { replies?: Maybe<Array<Maybe<(
      { __typename?: 'PractitionerPatientCommunication' }
      & Pick<PractitionerPatientCommunication, 'subject' | 'fromId' | 'toId' | 'fromEmail' | 'toEmail' | 'commFromType' | 'commToType' | 'bccEmail' | 'ccEmail' | 'createdOn' | 'fromName' | 'toName' | 'messageContent' | 'documentUrl' | 'commFrom'>
    )>>> }
  )>>> }
);

export type GetPractitionerReviewsQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerReviewsQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { reviews?: Maybe<Array<Maybe<(
      { __typename?: 'PractionerReview_Extension' }
      & Pick<PractionerReview_Extension, 'reviewType' | 'reviewStatus' | 'isBookingAppointmentEasy' | 'isVideoQualityGood' | 'questionnarieFillingFor' | 'isDoctorPolite' | 'isDoctorListenedToYou' | 'isAssessmentFeltComplete' | 'isInvolvedInDecisions' | 'isAbleToProvideTreatment' | 'happyToSeeDoctorAgain' | 'recommendThisDoctor' | 'patientId' | 'appointmentId' | 'patientName' | 'review' | 'createdOn' | 'rating'>
    )>>> }
  )> }
);

export type GetPractitionerRecommendationQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPractitionerRecommendationQuery = (
  { __typename?: 'Query' }
  & { Practitioner?: Maybe<(
    { __typename?: 'Practitioner' }
    & { recommendations?: Maybe<Array<Maybe<(
      { __typename?: 'PractionerRecommendation_Extension' }
      & Pick<PractionerRecommendation_Extension, 'recommendationId' | 'recommendationText' | 'recommendationStatus' | 'recommendationSentFrom' | 'roleName' | 'fromPractitionerName' | 'toPractitionerName' | 'createdOn' | 'fromPractitionerEmail' | 'toPractitionerEmail'>
    )>>> }
  )> }
);

export type GetAppointmentListQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetAppointmentListQuery = (
  { __typename?: 'Query' }
  & { PomsAppointmentList?: Maybe<Array<Maybe<(
    { __typename?: 'PomsAppointment' }
    & Pick<PomsAppointment, 'id' | 'practitionerName' | 'practitionerId' | 'practitionerSpeciality' | 'appointmentDate' | 'appointmentTime' | 'slotId' | 'countAll' | 'appointmentCreatedOn' | 'appointmentFor' | 'appointmentNumber' | 'appointmentBookedBy' | 'appointmentBookedId' | 'appointmentBookedDOB' | 'appointmentType' | 'appointmentMode' | 'appointmentDuration' | 'appointmentBookedByTitle' | 'appointmentBookedByFirstName' | 'appointmentBookedBySurName' | 'appointmentBookedByGender' | 'appointmentBookedByEmail' | 'appointmentBookedByPhoneNumber' | 'appointmentBookedForTitle' | 'appointmentBookedForFirstName' | 'appointmentBookedForSurName' | 'appointmentBookedForGender' | 'appointmentBookedForEmail' | 'appointmentBookedForPhoneNumber' | 'appointmentBookedForRelationship' | 'appointmentNeedLanguageSupport' | 'appointmentSpecialNotes' | 'appointmentPrice' | 'appointmentPayType' | 'appointmentPMIName' | 'appointmentPMIResponsibleParty' | 'appointmentPMIFirstName' | 'appointmentPMISurName' | 'appointmentGroupId' | 'appointmentMemberPolicyNumber' | 'appointmentExpiresOn' | 'appointmentPMIAuthorisationCode' | 'appointmentPMIAuthorisationSession' | 'appointmentThirdPartyName' | 'appointmentThirdPartyId' | 'appointmentThirdPartyComments' | 'appointmentPatientTechAbility' | 'appointmentPatientMentalAbility' | 'appointmentPatientConsent' | 'appointmentStatus' | 'videoSessionId' | 'videoSessionToken' | 'videoAPIKey' | 'videoAPISecret' | 'diagnosis' | 'disorderDetails' | 'videoStartTime' | 'videoEndTime' | 'currentVideoTime' | 'isStartVideoClicked'>
    & { prescriptions?: Maybe<(
      { __typename?: 'PatientPrescriptionDocument' }
      & Pick<PatientPrescriptionDocument, 'id' | 'comments' | 'practitionerName' | 'practitionerId' | 'patientId' | 'practitionerSpeciality' | 'patientName' | 'patientAddress' | 'practitionerSignUrl' | 'gmcNumber' | 'dateofbirth' | 'prescriptionFileUrl' | 'prescriptionFileUrlName' | 'prescriptionId' | 'prescriptionDate'>
      & { medications?: Maybe<Array<Maybe<(
        { __typename?: 'PatientPrescriptionExtension' }
        & Pick<PatientPrescriptionExtension, 'drugName' | 'drugType' | 'dosage' | 'frequency' | 'route' | 'durationOfPrescription' | 'neededToIncrease' | 'neededToDecrease' | 'furtherInstructions' | 'anyChanges'>
      )>>> }
    )>, letters?: Maybe<(
      { __typename?: 'PomsPatientLetter' }
      & Pick<PomsPatientLetter, 'id' | 'templateName' | 'templateMode' | 'templateType' | 'templateData' | 'patientId' | 'practitionerName' | 'practitionerSpeciality' | 'practitionerId' | 'templateJsonData'>
    )> }
  )>>> }
);

export type GetFeedBackListQueryVariables = Exact<{
  feedBackType?: Maybe<Scalars['Int']>;
  fromUserId?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
}>;


export type GetFeedBackListQuery = (
  { __typename?: 'Query' }
  & { FeedBackList?: Maybe<Array<Maybe<(
    { __typename?: 'FeedBack' }
    & Pick<FeedBack, 'id' | 'feedBackType' | 'feedBackAbout' | 'feedBackForPatientorRelative' | 'feedBackPersonTitle' | 'feedBackPersonFirstName' | 'feedBackPersonLastName' | 'feedBackPersonSurName' | 'feedBackPersonDOB' | 'feedBackPersonEmail' | 'feedBackPersonPhoneNumber' | 'feedBackDateOfService' | 'feedBackTimeOfService' | 'feedBackComments' | 'feedBackServiceUserName' | 'feedBackAgainstUser' | 'feedBackCreatedOn' | 'feedBackStatus' | 'feedBackServiceEmail' | 'feedBackNumber' | 'feedBackRespondStatus' | 'fromUserId'>
    & { feedBackReplies?: Maybe<Array<Maybe<(
      { __typename?: 'FeedBack_Reply_Schema' }
      & Pick<FeedBack_Reply_Schema, 'feedBackType' | 'feedBackTypeId' | 'feedBackTypeName' | 'feedBackComments' | 'feedBackRepliedOn' | 'feedBackCreator'>
    )>>>, feedBackDocuments?: Maybe<(
      { __typename?: 'DocumentReference' }
      & { content?: Maybe<Array<(
        { __typename?: 'DocumentReferencecontent' }
        & { attachment: (
          { __typename?: 'Attachment' }
          & Pick<Attachment, 'title' | 'url' | 'creation' | 'documentType'>
        ) }
      )>> }
    )> }
  )>>> }
);

export type GetTasksListQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetTasksListQuery = (
  { __typename?: 'Query' }
  & { PractitionerTaskList?: Maybe<Array<Maybe<(
    { __typename?: 'PractitionerTasks' }
    & Pick<PractitionerTasks, 'id' | 'taskUrl' | 'taskType' | 'taskMessage' | 'taskCount'>
  )>>> }
);

export type GetNotfnListQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  isNotification?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetNotfnListQuery = (
  { __typename?: 'Query' }
  & { PractitionerNotificationList?: Maybe<Array<Maybe<(
    { __typename?: 'PractitionerNotifications' }
    & Pick<PractitionerNotifications, 'id' | 'notificationMessage' | 'notificationUrl' | 'createdOn' | 'isRead'>
  )>>> }
);

export type GetPatientCommV1QueryVariables = Exact<{
  fromId?: Maybe<Scalars['String']>;
}>;


export type GetPatientCommV1Query = (
  { __typename?: 'Query' }
  & { PractitionerPatientCommunicationList?: Maybe<Array<Maybe<(
    { __typename?: 'PractitionerPatientCommunication' }
    & Pick<PractitionerPatientCommunication, 'id' | 'subject' | 'fromId' | 'toId' | 'fromEmail' | 'toEmail' | 'commFromType' | 'commToType' | 'bccEmail' | 'ccEmail' | 'createdOn' | 'fromName' | 'toName' | 'messageContent' | 'documentUrl' | 'commFrom'>
    & { replies?: Maybe<Array<Maybe<(
      { __typename?: 'PractitionerPatientCommunication' }
      & Pick<PractitionerPatientCommunication, 'subject' | 'fromId' | 'toId' | 'fromEmail' | 'toEmail' | 'commFromType' | 'commToType' | 'bccEmail' | 'ccEmail' | 'createdOn' | 'fromName' | 'toName' | 'messageContent' | 'documentUrl' | 'commFrom'>
    )>>> }
  )>>> }
);

export type GetBlogListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBlogListQuery = (
  { __typename?: 'Query' }
  & { BlogList?: Maybe<Array<Maybe<(
    { __typename?: 'Blogs_Schema' }
    & Pick<Blogs_Schema, 'id' | 'categoryName' | 'categoryId' | 'subCategoryName' | 'subCategoryId' | 'blogTitle' | 'blogDescription' | 'blogDescriptionHtml' | 'blogBannerImage' | 'authorType' | 'authorTypeId' | 'authorName' | 'authorDescription' | 'authorImage' | 'createdOn' | 'blogDescriptionPlainText'>
  )>>> }
);

export type GetSignpostingListQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetSignpostingListQuery = (
  { __typename?: 'Query' }
  & { Patient?: Maybe<(
    { __typename?: 'Patient' }
    & { signPostingList?: Maybe<Array<Maybe<(
      { __typename?: 'PatientSignPostingExtension_Schema' }
      & Pick<PatientSignPostingExtension_Schema, 'organizationName' | 'organizationEmail' | 'organizationPhoneNo' | 'organizationWebsite' | 'organizationLogoUrl' | 'practitionerId' | 'practitionerName' | 'practitionerSpeciality' | 'sentOn' | 'services' | 'organizationId' | 'reason'>
    )>>> }
  )> }
);

export type GetPractitionerProfessionalTypeListQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetPractitionerProfessionalTypeListQuery = (
  { __typename?: 'Query' }
  & { ProfessionalTypeList?: Maybe<Array<Maybe<(
    { __typename?: 'ProfessionalType_Schema' }
    & Pick<ProfessionalType_Schema, 'resourceType' | 'id' | 'name' | 'status'>
  )>>> }
);

export type GetAppointmentTypeMasterListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentTypeMasterListQuery = (
  { __typename?: 'Query' }
  & { AppointmentTypeMasterList?: Maybe<Array<Maybe<(
    { __typename?: 'AppointmentTypeMaster_Schema' }
    & Pick<AppointmentTypeMaster_Schema, 'resourceType' | 'id' | 'name' | 'status'>
    & { professionalTypeRelation?: Maybe<Array<Maybe<(
      { __typename?: 'ProfessionalTypeRelation_Schema' }
      & Pick<ProfessionalTypeRelation_Schema, 'professionalTypeId'>
    )>>> }
  )>>> }
);

export type AppointmentTypeQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type AppointmentTypeQuery = (
  { __typename?: 'Query' }
  & { AppointmentTypeMaster?: Maybe<Array<Maybe<(
    { __typename?: 'AppointmentTypeMaster_Schema' }
    & Pick<AppointmentTypeMaster_Schema, 'resourceType' | 'id' | 'name' | 'status'>
    & { professionalTypeRelation?: Maybe<Array<Maybe<(
      { __typename?: 'ProfessionalTypeRelation_Schema' }
      & Pick<ProfessionalTypeRelation_Schema, 'professionalTypeId'>
    )>>> }
  )>>> }
);

export type SubSpecialtyMasterDataQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type SubSpecialtyMasterDataQuery = (
  { __typename?: 'Query' }
  & { SubSpecialtyMaster?: Maybe<Array<Maybe<(
    { __typename?: 'SubSpecialtyMaster_Schema' }
    & Pick<SubSpecialtyMaster_Schema, 'resourceType' | 'id' | 'name' | 'status'>
    & { professionalTypeRelation?: Maybe<Array<Maybe<(
      { __typename?: 'ProfessionalTypeRelation_Schema' }
      & Pick<ProfessionalTypeRelation_Schema, 'professionalTypeId'>
    )>>> }
  )>>> }
);

export type PomsAppointmentSummeryQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type PomsAppointmentSummeryQuery = (
  { __typename?: 'Query' }
  & { PomsAppointmentSummery?: Maybe<(
    { __typename?: 'PomsAppointmentSummery' }
    & Pick<PomsAppointmentSummery, 'totalCompleteCount' | 'lastMonthCompleteCount' | 'currentMonthCompleteCount' | 'increaseCompleteStatus' | 'totalCancelCount' | 'lastMonthCancelCount' | 'currentMonthCancelCount' | 'increaseCancelStatus' | 'totalPatientCount' | 'lastMonthPatientCount' | 'currentMonthPatientCount' | 'increasePatientStatus'>
  )> }
);

export type PatientCountByMonthQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type PatientCountByMonthQuery = (
  { __typename?: 'Query' }
  & { PatientCountByMonth?: Maybe<(
    { __typename?: 'PatientCount' }
    & Pick<PatientCount, 'patientTotalCount' | 'patientTotalCountByMonth'>
  )> }
);

export type PractitionerReviewsCountQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type PractitionerReviewsCountQuery = (
  { __typename?: 'Query' }
  & { PractitionerReviewCount?: Maybe<(
    { __typename?: 'PractitionerReviewCount' }
    & Pick<PractitionerReviewCount, 'reviewCount' | 'recommendationCount'>
  )> }
);

export type PractitionerToDoTaskListQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type PractitionerToDoTaskListQuery = (
  { __typename?: 'Query' }
  & { PractitionerToDoTaskList?: Maybe<Array<Maybe<(
    { __typename?: 'PatientToDoTasks' }
    & Pick<PatientToDoTasks, 'toId' | 'taskType' | 'message' | 'status' | 'createdOn' | 'updatedOn' | 'fullName' | 'phonenumber' | 'email' | 'dob' | 'MRNNumber'>
  )>>> }
);

export type PatientToDoTaskListCountQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type PatientToDoTaskListCountQuery = (
  { __typename?: 'Query' }
  & { PatientToDoTaskListCount?: Maybe<(
    { __typename?: 'PatientToDoTaskListCount' }
    & Pick<PatientToDoTaskListCount, 'taskCount'>
    & { taskList?: Maybe<Array<Maybe<(
      { __typename?: 'PatientToDoTasks' }
      & Pick<PatientToDoTasks, 'toId' | 'fromId' | 'taskId' | 'taskType' | 'message' | 'actionType' | 'status' | 'createdOn' | 'id'>
    )>>> }
  )> }
);

export type PractitionerToDoTaskListCountQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type PractitionerToDoTaskListCountQuery = (
  { __typename?: 'Query' }
  & { PractitionerToDoTaskListCount?: Maybe<(
    { __typename?: 'PatientToDoTaskListCount' }
    & Pick<PatientToDoTaskListCount, 'taskCount'>
    & { taskList?: Maybe<Array<Maybe<(
      { __typename?: 'PatientToDoTasks' }
      & Pick<PatientToDoTasks, 'toId' | 'taskType' | 'message' | 'status' | 'createdOn' | 'updatedOn' | 'fullName' | 'phonenumber' | 'email' | 'dob' | 'MRNNumber'>
    )>>> }
  )> }
);

export type GetExternalPatientQuestionnaireListQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
}>;


export type GetExternalPatientQuestionnaireListQuery = (
  { __typename?: 'Query' }
  & { ExternalPatientQuestionnaireList?: Maybe<Array<Maybe<(
    { __typename?: 'ExternalPatientQuestionnaire_Schema' }
    & Pick<ExternalPatientQuestionnaire_Schema, 'id' | 'resourceType' | 'patientId' | 'patientName' | 'assignedId' | 'assignedName' | 'assignedType' | 'assignedSpeciality' | 'questitionerId' | 'questionnaireName' | 'recipientName' | 'recipientEmail' | 'emailSubject' | 'emailBody' | 'status' | 'assignedOn'>
    & { questionnaire?: Maybe<(
      { __typename?: 'QuestionnaireBuilder' }
      & Pick<QuestionnaireBuilder, 'id' | 'questionnaireName' | 'questionnaireDescription' | 'administeredType' | 'totalScore'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'QuestionnaireBuilderQuestion_Schema' }
        & Pick<QuestionnaireBuilderQuestion_Schema, 'question' | 'selectedOptionId' | 'selectedOptionText' | 'comments' | 'optionType' | 'showCommentBox' | 'isCommentBoxRequired'>
        & { options?: Maybe<Array<Maybe<(
          { __typename?: 'QuestionnaireBuilderQuestionOption_Schema' }
          & Pick<QuestionnaireBuilderQuestionOption_Schema, 'option' | 'optionId' | 'optionScore'>
        )>>> }
      )>>> }
    )> }
  )>>> }
);

export type GetExternalPatientQuestionnaireQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type GetExternalPatientQuestionnaireQuery = (
  { __typename?: 'Query' }
  & { ExternalPatientQuestionnaire?: Maybe<(
    { __typename?: 'ExternalPatientQuestionnaire_Schema' }
    & Pick<ExternalPatientQuestionnaire_Schema, 'id' | 'resourceType' | 'patientId' | 'patientName' | 'assignedId' | 'assignedName' | 'assignedType' | 'assignedSpeciality' | 'questitionerId' | 'questionnaireName' | 'recipientName' | 'recipientEmail' | 'emailSubject' | 'emailBody' | 'status' | 'assignedOn'>
    & { questionnaire?: Maybe<(
      { __typename?: 'QuestionnaireBuilder' }
      & Pick<QuestionnaireBuilder, 'id' | 'questionnaireName' | 'questionnaireDescription' | 'administeredType' | 'totalScore'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'QuestionnaireBuilderQuestion_Schema' }
        & Pick<QuestionnaireBuilderQuestion_Schema, 'question' | 'selectedOptionId' | 'selectedOptionText' | 'comments' | 'optionType' | 'showCommentBox' | 'isCommentBoxRequired'>
        & { options?: Maybe<Array<Maybe<(
          { __typename?: 'QuestionnaireBuilderQuestionOption_Schema' }
          & Pick<QuestionnaireBuilderQuestionOption_Schema, 'option' | 'optionId' | 'optionScore'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type GetDisorderActiveListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDisorderActiveListQuery = (
  { __typename?: 'Query' }
  & { DisorderActiveList?: Maybe<Array<Maybe<(
    { __typename?: 'Disorder_Schema' }
    & Pick<Disorder_Schema, 'id' | 'disorderName' | 'disorderValue' | 'disorderStatus' | 'createdOn'>
  )>>> }
);

export type HandbookListQueryVariables = Exact<{ [key: string]: never; }>;


export type HandbookListQuery = (
  { __typename?: 'Query' }
  & { HandbookList?: Maybe<Array<Maybe<(
    { __typename?: 'Handbook' }
    & Pick<Handbook, 'id' | 'name' | 'filePath'>
  )>>> }
);

export type GetCrisisSafeguardListQueryVariables = Exact<{
  patID: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}>;


export type GetCrisisSafeguardListQuery = (
  { __typename?: 'Query' }
  & { CrisisSafeguardList?: Maybe<Array<Maybe<(
    { __typename?: 'CrisisSafeguard' }
    & Pick<CrisisSafeguard, 'id' | 'countAll' | 'templateName' | 'templateMode' | 'templateType' | 'templateData' | 'patientId' | 'practitionerName' | 'practitionerSpeciality' | 'practitionerId' | 'templateJsonData' | 'patientName' | 'gpName' | 'gpPractitionerName' | 'gpEmail' | 'name' | 'email' | 'letterType' | 'letterUploadUrl' | 'createdOn'>
  )>>> }
);

export type GetPatientPrivacyQueryVariables = Exact<{
  id?: Maybe<Scalars['token']>;
}>;


export type GetPatientPrivacyQuery = (
  { __typename?: 'Query' }
  & { PomsPatientPrivacy?: Maybe<(
    { __typename?: 'PomsPatientPrivacy' }
    & Pick<PomsPatientPrivacy, 'contactSMS' | 'contactPost' | 'contactPhone' | 'contactEmail' | 'notifySMS' | 'notifyPost' | 'notifyPhone' | 'notifyEmail' | 'gdprConsent' | 'consentDisclosure' | 'prescriptionPolicy' | 'informationPolicy' | 'okatreeContract' | 'cancellationPolicy' | 'patientorGuardianName' | 'guardianFirstName' | 'guardianSurname' | 'relationtoPatient' | 'specialOfferPolicy' | 'whatsappOfferPolicy' | 'patientName' | 'patientAddress' | 'gpName' | 'gpPracticeName' | 'gpPracticeAddress'>
  )> }
);


export const UpdatePractitionerPersonalDetailsDocument = gql`
    mutation updatePractitionerPersonalDetails($id: id, $name: [HumanName_Input], $fullName: String, $gender: code, $birthdDate: date, $nationality: code, $communication: [CodeableConcept_Input]) {
  PractitionerUpdate(
    resource: {resourceType: Practitioner, practionerExtension: {operationType: "PERSONAL_DETAILS"}, id: $id, name: $name, fullName: $fullName, gender: $gender, birthDate: $birthdDate, nationality: $nationality, communication: $communication}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerPersonalDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerPersonalDetailsMutation, UpdatePractitionerPersonalDetailsMutationVariables>;

/**
 * __useUpdatePractitionerPersonalDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerPersonalDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerPersonalDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerPersonalDetailsMutation, { data, loading, error }] = useUpdatePractitionerPersonalDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      fullName: // value for 'fullName'
 *      gender: // value for 'gender'
 *      birthdDate: // value for 'birthdDate'
 *      nationality: // value for 'nationality'
 *      communication: // value for 'communication'
 *   },
 * });
 */
export function useUpdatePractitionerPersonalDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerPersonalDetailsMutation, UpdatePractitionerPersonalDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerPersonalDetailsMutation, UpdatePractitionerPersonalDetailsMutationVariables>(UpdatePractitionerPersonalDetailsDocument, baseOptions);
      }
export type UpdatePractitionerPersonalDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerPersonalDetailsMutation>;
export type UpdatePractitionerPersonalDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerPersonalDetailsMutation>;
export type UpdatePractitionerPersonalDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerPersonalDetailsMutation, UpdatePractitionerPersonalDetailsMutationVariables>;
export const UpdatePractitionerAboutDetailsDocument = gql`
    mutation updatePractitionerAboutDetails($id: id, $practionerAbout: PractionerAboutUs_Input, $photo: [Attachment_Input]) {
  PractitionerUpdate(
    resource: {resourceType: Practitioner, practionerExtension: {operationType: "ABOUTUS_DETAILS"}, id: $id, practionerAbout: $practionerAbout, photo: $photo}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerAboutDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerAboutDetailsMutation, UpdatePractitionerAboutDetailsMutationVariables>;

/**
 * __useUpdatePractitionerAboutDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerAboutDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerAboutDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerAboutDetailsMutation, { data, loading, error }] = useUpdatePractitionerAboutDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      practionerAbout: // value for 'practionerAbout'
 *      photo: // value for 'photo'
 *   },
 * });
 */
export function useUpdatePractitionerAboutDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerAboutDetailsMutation, UpdatePractitionerAboutDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerAboutDetailsMutation, UpdatePractitionerAboutDetailsMutationVariables>(UpdatePractitionerAboutDetailsDocument, baseOptions);
      }
export type UpdatePractitionerAboutDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerAboutDetailsMutation>;
export type UpdatePractitionerAboutDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerAboutDetailsMutation>;
export type UpdatePractitionerAboutDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerAboutDetailsMutation, UpdatePractitionerAboutDetailsMutationVariables>;
export const UpdatePractitionerAgreementDetailsDocument = gql`
    mutation updatePractitionerAgreementDetails($id: String, $handbook: Int, $terms: Int, $contract: Int, $document: [DocumentReferencecontent_Input!]) {
  PomsPractitionerAgreementUpdate(
    resource: {resourceType: PomsPractitionerAgreement, managingPractitioner: $id, pomsHandBook: $handbook, termsOfUse: $terms, pomsContract: $contract, documents: {resourceType: DocumentReference, status: "1", content: $document}}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerAgreementDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerAgreementDetailsMutation, UpdatePractitionerAgreementDetailsMutationVariables>;

/**
 * __useUpdatePractitionerAgreementDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerAgreementDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerAgreementDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerAgreementDetailsMutation, { data, loading, error }] = useUpdatePractitionerAgreementDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      handbook: // value for 'handbook'
 *      terms: // value for 'terms'
 *      contract: // value for 'contract'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useUpdatePractitionerAgreementDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerAgreementDetailsMutation, UpdatePractitionerAgreementDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerAgreementDetailsMutation, UpdatePractitionerAgreementDetailsMutationVariables>(UpdatePractitionerAgreementDetailsDocument, baseOptions);
      }
export type UpdatePractitionerAgreementDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerAgreementDetailsMutation>;
export type UpdatePractitionerAgreementDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerAgreementDetailsMutation>;
export type UpdatePractitionerAgreementDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerAgreementDetailsMutation, UpdatePractitionerAgreementDetailsMutationVariables>;
export const UpdatePractitionerPrivacyDetailsDocument = gql`
    mutation updatePractitionerPrivacyDetails($id: String, $contactPost: Int, $contactSMS: Int, $contactPhone: Int, $contactEmail: Int, $notifyPost: Int, $notifySMS: Int, $notifyPhone: Int, $notifyEmail: Int, $gdprConsent: Int) {
  PomsPractitionerPrivacyUpdate(
    resource: {resourceType: PomsPractitionerPrivacy, managingPractitioner: $id, contactPost: $contactPost, contactSMS: $contactSMS, contactPhone: $contactPhone, contactEmail: $contactEmail, notifyPost: $notifyPost, notifySMS: $notifySMS, notifyPhone: $notifyPhone, notifyEmail: $notifyEmail, gdprConsent: $gdprConsent}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerPrivacyDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerPrivacyDetailsMutation, UpdatePractitionerPrivacyDetailsMutationVariables>;

/**
 * __useUpdatePractitionerPrivacyDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerPrivacyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerPrivacyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerPrivacyDetailsMutation, { data, loading, error }] = useUpdatePractitionerPrivacyDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contactPost: // value for 'contactPost'
 *      contactSMS: // value for 'contactSMS'
 *      contactPhone: // value for 'contactPhone'
 *      contactEmail: // value for 'contactEmail'
 *      notifyPost: // value for 'notifyPost'
 *      notifySMS: // value for 'notifySMS'
 *      notifyPhone: // value for 'notifyPhone'
 *      notifyEmail: // value for 'notifyEmail'
 *      gdprConsent: // value for 'gdprConsent'
 *   },
 * });
 */
export function useUpdatePractitionerPrivacyDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerPrivacyDetailsMutation, UpdatePractitionerPrivacyDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerPrivacyDetailsMutation, UpdatePractitionerPrivacyDetailsMutationVariables>(UpdatePractitionerPrivacyDetailsDocument, baseOptions);
      }
export type UpdatePractitionerPrivacyDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerPrivacyDetailsMutation>;
export type UpdatePractitionerPrivacyDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerPrivacyDetailsMutation>;
export type UpdatePractitionerPrivacyDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerPrivacyDetailsMutation, UpdatePractitionerPrivacyDetailsMutationVariables>;
export const UpdatePractitionerPreferenceDetailsDocument = gql`
    mutation updatePractitionerPreferenceDetails($id: String, $countryCode: [Coding_Input], $languageCode: [Coding_Input], $currencyCode: [Coding_Input], $timezone: [Coding_Input], $sendCommunicationMessage: Boolean) {
  PomsPractitionerPreferenceUpdate(
    resource: {resourceType: PomsPractitionerPreferences, managingPractitioner: $id, country: {coding: $countryCode}, language: {coding: $languageCode}, currency: {coding: $currencyCode}, timezone: {coding: $timezone}, sendCommunicationMessage: $sendCommunicationMessage}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerPreferenceDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerPreferenceDetailsMutation, UpdatePractitionerPreferenceDetailsMutationVariables>;

/**
 * __useUpdatePractitionerPreferenceDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerPreferenceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerPreferenceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerPreferenceDetailsMutation, { data, loading, error }] = useUpdatePractitionerPreferenceDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      countryCode: // value for 'countryCode'
 *      languageCode: // value for 'languageCode'
 *      currencyCode: // value for 'currencyCode'
 *      timezone: // value for 'timezone'
 *      sendCommunicationMessage: // value for 'sendCommunicationMessage'
 *   },
 * });
 */
export function useUpdatePractitionerPreferenceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerPreferenceDetailsMutation, UpdatePractitionerPreferenceDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerPreferenceDetailsMutation, UpdatePractitionerPreferenceDetailsMutationVariables>(UpdatePractitionerPreferenceDetailsDocument, baseOptions);
      }
export type UpdatePractitionerPreferenceDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerPreferenceDetailsMutation>;
export type UpdatePractitionerPreferenceDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerPreferenceDetailsMutation>;
export type UpdatePractitionerPreferenceDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerPreferenceDetailsMutation, UpdatePractitionerPreferenceDetailsMutationVariables>;
export const UpdatePractitionerContactDetailsDocument = gql`
    mutation updatePractitionerContactDetails($id: id, $telecom: [ContactPoint_Input], $address: [Address_Input], $emergency: [PractionerEmergency_Extension_Input]) {
  PractitionerUpdate(
    resource: {resourceType: Practitioner, practionerExtension: {operationType: "CONTACT_DETAILS"}, id: $id, address: $address, telecom: $telecom, emergencyContact: $emergency}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerContactDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerContactDetailsMutation, UpdatePractitionerContactDetailsMutationVariables>;

/**
 * __useUpdatePractitionerContactDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerContactDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerContactDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerContactDetailsMutation, { data, loading, error }] = useUpdatePractitionerContactDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      telecom: // value for 'telecom'
 *      address: // value for 'address'
 *      emergency: // value for 'emergency'
 *   },
 * });
 */
export function useUpdatePractitionerContactDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerContactDetailsMutation, UpdatePractitionerContactDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerContactDetailsMutation, UpdatePractitionerContactDetailsMutationVariables>(UpdatePractitionerContactDetailsDocument, baseOptions);
      }
export type UpdatePractitionerContactDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerContactDetailsMutation>;
export type UpdatePractitionerContactDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerContactDetailsMutation>;
export type UpdatePractitionerContactDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerContactDetailsMutation, UpdatePractitionerContactDetailsMutationVariables>;
export const UpdatePractitionerQualificationDetailsDocument = gql`
    mutation updatePractitionerQualificationDetails($id: id, $qualification: [Practitionerqualification_Input]) {
  PractitionerUpdate(
    resource: {resourceType: Practitioner, practionerExtension: {operationType: "QUALIFICATION_DETAILS"}, id: $id, qualification: $qualification}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerQualificationDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerQualificationDetailsMutation, UpdatePractitionerQualificationDetailsMutationVariables>;

/**
 * __useUpdatePractitionerQualificationDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerQualificationDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerQualificationDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerQualificationDetailsMutation, { data, loading, error }] = useUpdatePractitionerQualificationDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      qualification: // value for 'qualification'
 *   },
 * });
 */
export function useUpdatePractitionerQualificationDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerQualificationDetailsMutation, UpdatePractitionerQualificationDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerQualificationDetailsMutation, UpdatePractitionerQualificationDetailsMutationVariables>(UpdatePractitionerQualificationDetailsDocument, baseOptions);
      }
export type UpdatePractitionerQualificationDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerQualificationDetailsMutation>;
export type UpdatePractitionerQualificationDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerQualificationDetailsMutation>;
export type UpdatePractitionerQualificationDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerQualificationDetailsMutation, UpdatePractitionerQualificationDetailsMutationVariables>;
export const UpdatePractitionerExpertiseDetailsDocument = gql`
    mutation updatePractitionerExpertiseDetails($id: id, $expertise: [PractionerExpertiseExtension_Input]) {
  PractitionerRoleUpdate(
    resource: {resourceType: PractitionerRole, practionerExtension: {operationType: "EXPERTISE_DETAILS"}, id: $id, expertise: $expertise}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerExpertiseDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerExpertiseDetailsMutation, UpdatePractitionerExpertiseDetailsMutationVariables>;

/**
 * __useUpdatePractitionerExpertiseDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerExpertiseDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerExpertiseDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerExpertiseDetailsMutation, { data, loading, error }] = useUpdatePractitionerExpertiseDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      expertise: // value for 'expertise'
 *   },
 * });
 */
export function useUpdatePractitionerExpertiseDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerExpertiseDetailsMutation, UpdatePractitionerExpertiseDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerExpertiseDetailsMutation, UpdatePractitionerExpertiseDetailsMutationVariables>(UpdatePractitionerExpertiseDetailsDocument, baseOptions);
      }
export type UpdatePractitionerExpertiseDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerExpertiseDetailsMutation>;
export type UpdatePractitionerExpertiseDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerExpertiseDetailsMutation>;
export type UpdatePractitionerExpertiseDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerExpertiseDetailsMutation, UpdatePractitionerExpertiseDetailsMutationVariables>;
export const UpdatePractitionerProfessionalDetailsDocument = gql`
    mutation updatePractitionerProfessionalDetails($id: id, $band: code, $years: code, $identifier: [Identifier_Input], $code: [CodeableConcept_Input], $speciality: [CodeableConcept_Input], $subspeciality: [CodeableConcept_Input], $subspecialitymaster: [CodeableConcept_Input]) {
  PractitionerUpdate(
    resource: {resourceType: Practitioner, practionerExtension: {operationType: "PROFESSION_DETAILS"}, id: $id, band: $band, yearsOfExp: $years, identifier: $identifier}
  ) {
    id
  }
  PractitionerRoleUpdate(
    resource: {resourceType: PractitionerRole, practionerExtension: {operationType: "PROFESSION_DETAILS"}, id: $id, code: $code, specialty: $speciality, subSpecialty: $subspeciality, subSpecialtyMaster: $subspecialitymaster, band: $band, yearsOfExp: $years}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerProfessionalDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerProfessionalDetailsMutation, UpdatePractitionerProfessionalDetailsMutationVariables>;

/**
 * __useUpdatePractitionerProfessionalDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerProfessionalDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerProfessionalDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerProfessionalDetailsMutation, { data, loading, error }] = useUpdatePractitionerProfessionalDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      band: // value for 'band'
 *      years: // value for 'years'
 *      identifier: // value for 'identifier'
 *      code: // value for 'code'
 *      speciality: // value for 'speciality'
 *      subspeciality: // value for 'subspeciality'
 *      subspecialitymaster: // value for 'subspecialitymaster'
 *   },
 * });
 */
export function useUpdatePractitionerProfessionalDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerProfessionalDetailsMutation, UpdatePractitionerProfessionalDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerProfessionalDetailsMutation, UpdatePractitionerProfessionalDetailsMutationVariables>(UpdatePractitionerProfessionalDetailsDocument, baseOptions);
      }
export type UpdatePractitionerProfessionalDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerProfessionalDetailsMutation>;
export type UpdatePractitionerProfessionalDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerProfessionalDetailsMutation>;
export type UpdatePractitionerProfessionalDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerProfessionalDetailsMutation, UpdatePractitionerProfessionalDetailsMutationVariables>;
export const UpdatePractitionerAwardsMediaDetailsDocument = gql`
    mutation updatePractitionerAwardsMediaDetails($id: id, $awards: [PractionerAwardsExtension_Input], $media: [PractionerMediaExtension_Input]) {
  PractitionerUpdate(
    resource: {resourceType: Practitioner, practionerExtension: {operationType: "AWARDS_DETAILS"}, id: $id, awards: $awards, media: $media}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerAwardsMediaDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerAwardsMediaDetailsMutation, UpdatePractitionerAwardsMediaDetailsMutationVariables>;

/**
 * __useUpdatePractitionerAwardsMediaDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerAwardsMediaDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerAwardsMediaDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerAwardsMediaDetailsMutation, { data, loading, error }] = useUpdatePractitionerAwardsMediaDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      awards: // value for 'awards'
 *      media: // value for 'media'
 *   },
 * });
 */
export function useUpdatePractitionerAwardsMediaDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerAwardsMediaDetailsMutation, UpdatePractitionerAwardsMediaDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerAwardsMediaDetailsMutation, UpdatePractitionerAwardsMediaDetailsMutationVariables>(UpdatePractitionerAwardsMediaDetailsDocument, baseOptions);
      }
export type UpdatePractitionerAwardsMediaDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerAwardsMediaDetailsMutation>;
export type UpdatePractitionerAwardsMediaDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerAwardsMediaDetailsMutation>;
export type UpdatePractitionerAwardsMediaDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerAwardsMediaDetailsMutation, UpdatePractitionerAwardsMediaDetailsMutationVariables>;
export const UpdatePractitionerPublicationDetailsDocument = gql`
    mutation updatePractitionerPublicationDetails($id: id, $publications: [PractionerPublicationsExtension_Input]) {
  PractitionerUpdate(
    resource: {resourceType: Practitioner, practionerExtension: {operationType: "PUBLICATION_DETAILS"}, id: $id, publications: $publications}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerPublicationDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerPublicationDetailsMutation, UpdatePractitionerPublicationDetailsMutationVariables>;

/**
 * __useUpdatePractitionerPublicationDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerPublicationDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerPublicationDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerPublicationDetailsMutation, { data, loading, error }] = useUpdatePractitionerPublicationDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      publications: // value for 'publications'
 *   },
 * });
 */
export function useUpdatePractitionerPublicationDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerPublicationDetailsMutation, UpdatePractitionerPublicationDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerPublicationDetailsMutation, UpdatePractitionerPublicationDetailsMutationVariables>(UpdatePractitionerPublicationDetailsDocument, baseOptions);
      }
export type UpdatePractitionerPublicationDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerPublicationDetailsMutation>;
export type UpdatePractitionerPublicationDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerPublicationDetailsMutation>;
export type UpdatePractitionerPublicationDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerPublicationDetailsMutation, UpdatePractitionerPublicationDetailsMutationVariables>;
export const UpdatePractitionerAffiliationDetailsDocument = gql`
    mutation updatePractitionerAffiliationDetails($id: id, $affiliations: [PractionerAffiliationExtension_Input]) {
  PractitionerUpdate(
    resource: {resourceType: Practitioner, practionerExtension: {operationType: "AFFILIATION_DETAILS"}, id: $id, affiliations: $affiliations}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerAffiliationDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerAffiliationDetailsMutation, UpdatePractitionerAffiliationDetailsMutationVariables>;

/**
 * __useUpdatePractitionerAffiliationDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerAffiliationDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerAffiliationDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerAffiliationDetailsMutation, { data, loading, error }] = useUpdatePractitionerAffiliationDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      affiliations: // value for 'affiliations'
 *   },
 * });
 */
export function useUpdatePractitionerAffiliationDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerAffiliationDetailsMutation, UpdatePractitionerAffiliationDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerAffiliationDetailsMutation, UpdatePractitionerAffiliationDetailsMutationVariables>(UpdatePractitionerAffiliationDetailsDocument, baseOptions);
      }
export type UpdatePractitionerAffiliationDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerAffiliationDetailsMutation>;
export type UpdatePractitionerAffiliationDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerAffiliationDetailsMutation>;
export type UpdatePractitionerAffiliationDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerAffiliationDetailsMutation, UpdatePractitionerAffiliationDetailsMutationVariables>;
export const UpdatePractitionerAccrediationDetailsDocument = gql`
    mutation updatePractitionerAccrediationDetails($id: id, $accreditations: [PractionerAccreditationExtension_Input]) {
  PractitionerUpdate(
    resource: {resourceType: Practitioner, practionerExtension: {operationType: "ACCREDIATIONS_DETAILS"}, id: $id, accreditations: $accreditations}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerAccrediationDetailsMutationFn = Apollo.MutationFunction<UpdatePractitionerAccrediationDetailsMutation, UpdatePractitionerAccrediationDetailsMutationVariables>;

/**
 * __useUpdatePractitionerAccrediationDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerAccrediationDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerAccrediationDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerAccrediationDetailsMutation, { data, loading, error }] = useUpdatePractitionerAccrediationDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accreditations: // value for 'accreditations'
 *   },
 * });
 */
export function useUpdatePractitionerAccrediationDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerAccrediationDetailsMutation, UpdatePractitionerAccrediationDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerAccrediationDetailsMutation, UpdatePractitionerAccrediationDetailsMutationVariables>(UpdatePractitionerAccrediationDetailsDocument, baseOptions);
      }
export type UpdatePractitionerAccrediationDetailsMutationHookResult = ReturnType<typeof useUpdatePractitionerAccrediationDetailsMutation>;
export type UpdatePractitionerAccrediationDetailsMutationResult = Apollo.MutationResult<UpdatePractitionerAccrediationDetailsMutation>;
export type UpdatePractitionerAccrediationDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerAccrediationDetailsMutation, UpdatePractitionerAccrediationDetailsMutationVariables>;
export const AddPractitionerPracticeLocationDocument = gql`
    mutation addPractitionerPracticeLocation($id: String, $gtnid: String, $cocid: String, $name: String, $address: Address_Input, $telecom: [ContactPoint_Input], $rank: Int) {
  LocationCreate(
    resource: {resourceType: Location, locationExtension: {practitionerReference: $id, GTNID: $gtnid, COCID: $cocid, locationRank: $rank}, name: $name, address: $address, telecom: $telecom}
  ) {
    id
  }
}
    `;
export type AddPractitionerPracticeLocationMutationFn = Apollo.MutationFunction<AddPractitionerPracticeLocationMutation, AddPractitionerPracticeLocationMutationVariables>;

/**
 * __useAddPractitionerPracticeLocationMutation__
 *
 * To run a mutation, you first call `useAddPractitionerPracticeLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPractitionerPracticeLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPractitionerPracticeLocationMutation, { data, loading, error }] = useAddPractitionerPracticeLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      gtnid: // value for 'gtnid'
 *      cocid: // value for 'cocid'
 *      name: // value for 'name'
 *      address: // value for 'address'
 *      telecom: // value for 'telecom'
 *      rank: // value for 'rank'
 *   },
 * });
 */
export function useAddPractitionerPracticeLocationMutation(baseOptions?: Apollo.MutationHookOptions<AddPractitionerPracticeLocationMutation, AddPractitionerPracticeLocationMutationVariables>) {
        return Apollo.useMutation<AddPractitionerPracticeLocationMutation, AddPractitionerPracticeLocationMutationVariables>(AddPractitionerPracticeLocationDocument, baseOptions);
      }
export type AddPractitionerPracticeLocationMutationHookResult = ReturnType<typeof useAddPractitionerPracticeLocationMutation>;
export type AddPractitionerPracticeLocationMutationResult = Apollo.MutationResult<AddPractitionerPracticeLocationMutation>;
export type AddPractitionerPracticeLocationMutationOptions = Apollo.BaseMutationOptions<AddPractitionerPracticeLocationMutation, AddPractitionerPracticeLocationMutationVariables>;
export const UpdatePractitionerPracticeLocationDocument = gql`
    mutation updatePractitionerPracticeLocation($id: String, $gtnid: String, $cocid: String, $name: String, $address: Address_Input, $telecom: [ContactPoint_Input], $locationId: id, $rank: Int) {
  LocationUpdate(
    id: $locationId
    resource: {id: $locationId, resourceType: Location, locationExtension: {practitionerReference: $id, GTNID: $gtnid, COCID: $cocid, locationRank: $rank}, name: $name, address: $address, telecom: $telecom}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerPracticeLocationMutationFn = Apollo.MutationFunction<UpdatePractitionerPracticeLocationMutation, UpdatePractitionerPracticeLocationMutationVariables>;

/**
 * __useUpdatePractitionerPracticeLocationMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerPracticeLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerPracticeLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerPracticeLocationMutation, { data, loading, error }] = useUpdatePractitionerPracticeLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      gtnid: // value for 'gtnid'
 *      cocid: // value for 'cocid'
 *      name: // value for 'name'
 *      address: // value for 'address'
 *      telecom: // value for 'telecom'
 *      locationId: // value for 'locationId'
 *      rank: // value for 'rank'
 *   },
 * });
 */
export function useUpdatePractitionerPracticeLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerPracticeLocationMutation, UpdatePractitionerPracticeLocationMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerPracticeLocationMutation, UpdatePractitionerPracticeLocationMutationVariables>(UpdatePractitionerPracticeLocationDocument, baseOptions);
      }
export type UpdatePractitionerPracticeLocationMutationHookResult = ReturnType<typeof useUpdatePractitionerPracticeLocationMutation>;
export type UpdatePractitionerPracticeLocationMutationResult = Apollo.MutationResult<UpdatePractitionerPracticeLocationMutation>;
export type UpdatePractitionerPracticeLocationMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerPracticeLocationMutation, UpdatePractitionerPracticeLocationMutationVariables>;
export const DeletePractitionerPracticeLocationDocument = gql`
    mutation deletePractitionerPracticeLocation($id: id!) {
  LocationRemove(id: $id) {
    id
  }
}
    `;
export type DeletePractitionerPracticeLocationMutationFn = Apollo.MutationFunction<DeletePractitionerPracticeLocationMutation, DeletePractitionerPracticeLocationMutationVariables>;

/**
 * __useDeletePractitionerPracticeLocationMutation__
 *
 * To run a mutation, you first call `useDeletePractitionerPracticeLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePractitionerPracticeLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePractitionerPracticeLocationMutation, { data, loading, error }] = useDeletePractitionerPracticeLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePractitionerPracticeLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeletePractitionerPracticeLocationMutation, DeletePractitionerPracticeLocationMutationVariables>) {
        return Apollo.useMutation<DeletePractitionerPracticeLocationMutation, DeletePractitionerPracticeLocationMutationVariables>(DeletePractitionerPracticeLocationDocument, baseOptions);
      }
export type DeletePractitionerPracticeLocationMutationHookResult = ReturnType<typeof useDeletePractitionerPracticeLocationMutation>;
export type DeletePractitionerPracticeLocationMutationResult = Apollo.MutationResult<DeletePractitionerPracticeLocationMutation>;
export type DeletePractitionerPracticeLocationMutationOptions = Apollo.BaseMutationOptions<DeletePractitionerPracticeLocationMutation, DeletePractitionerPracticeLocationMutationVariables>;
export const UpdatePractitionerPayeInvoiceDocument = gql`
    mutation updatePractitionerPAYEInvoice($id: String, $nin: String, $societyName: String, $accountHolder: String, $sortCode: String, $accountNO: String, $documents: [DocumentReferencecontent_Input!]) {
  PomsInvoiceBillingUpdate(
    resource: {resourceType: PomsBillingInvoice, entityType: "1", nationalInsuranceNumber: $nin, buildingSocietyName: $societyName, accountHolderName: $accountHolder, sortCode: $sortCode, accountNo: $accountNO, managingPractitioner: $id, documents: {resourceType: DocumentReference, status: "1", content: $documents}}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerPayeInvoiceMutationFn = Apollo.MutationFunction<UpdatePractitionerPayeInvoiceMutation, UpdatePractitionerPayeInvoiceMutationVariables>;

/**
 * __useUpdatePractitionerPayeInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerPayeInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerPayeInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerPayeInvoiceMutation, { data, loading, error }] = useUpdatePractitionerPayeInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nin: // value for 'nin'
 *      societyName: // value for 'societyName'
 *      accountHolder: // value for 'accountHolder'
 *      sortCode: // value for 'sortCode'
 *      accountNO: // value for 'accountNO'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useUpdatePractitionerPayeInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerPayeInvoiceMutation, UpdatePractitionerPayeInvoiceMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerPayeInvoiceMutation, UpdatePractitionerPayeInvoiceMutationVariables>(UpdatePractitionerPayeInvoiceDocument, baseOptions);
      }
export type UpdatePractitionerPayeInvoiceMutationHookResult = ReturnType<typeof useUpdatePractitionerPayeInvoiceMutation>;
export type UpdatePractitionerPayeInvoiceMutationResult = Apollo.MutationResult<UpdatePractitionerPayeInvoiceMutation>;
export type UpdatePractitionerPayeInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerPayeInvoiceMutation, UpdatePractitionerPayeInvoiceMutationVariables>;
export const UpdatePractitionerLtdInvoiceDocument = gql`
    mutation updatePractitionerLTDInvoice($id: String, $companyName: String, $companyNumber: String, $vatNumber: String, $sortCode: String, $accountHolderName: String, $accountNO: String, $documents: [DocumentReferencecontent_Input!]) {
  PomsInvoiceBillingUpdate(
    resource: {resourceType: PomsBillingInvoice, entityType: "2", companyName: $companyName, companyNumber: $companyNumber, vatNumber: $vatNumber, accountHolderName: $accountHolderName, sortCode: $sortCode, accountNo: $accountNO, managingPractitioner: $id, documents: {resourceType: DocumentReference, status: "1", content: $documents}}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerLtdInvoiceMutationFn = Apollo.MutationFunction<UpdatePractitionerLtdInvoiceMutation, UpdatePractitionerLtdInvoiceMutationVariables>;

/**
 * __useUpdatePractitionerLtdInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerLtdInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerLtdInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerLtdInvoiceMutation, { data, loading, error }] = useUpdatePractitionerLtdInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyName: // value for 'companyName'
 *      companyNumber: // value for 'companyNumber'
 *      vatNumber: // value for 'vatNumber'
 *      sortCode: // value for 'sortCode'
 *      accountHolderName: // value for 'accountHolderName'
 *      accountNO: // value for 'accountNO'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useUpdatePractitionerLtdInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerLtdInvoiceMutation, UpdatePractitionerLtdInvoiceMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerLtdInvoiceMutation, UpdatePractitionerLtdInvoiceMutationVariables>(UpdatePractitionerLtdInvoiceDocument, baseOptions);
      }
export type UpdatePractitionerLtdInvoiceMutationHookResult = ReturnType<typeof useUpdatePractitionerLtdInvoiceMutation>;
export type UpdatePractitionerLtdInvoiceMutationResult = Apollo.MutationResult<UpdatePractitionerLtdInvoiceMutation>;
export type UpdatePractitionerLtdInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerLtdInvoiceMutation, UpdatePractitionerLtdInvoiceMutationVariables>;
export const UpdatePractitionerSelfInvoiceDocument = gql`
    mutation updatePractitionerSelfInvoice($id: String, $utrNo: String, $vatNumber: String, $documents: [DocumentReferencecontent_Input!]) {
  PomsInvoiceBillingUpdate(
    resource: {resourceType: PomsBillingInvoice, entityType: "3", utrNo: $utrNo, vatNumber: $vatNumber, managingPractitioner: $id, documents: {resourceType: DocumentReference, status: "1", content: $documents}}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerSelfInvoiceMutationFn = Apollo.MutationFunction<UpdatePractitionerSelfInvoiceMutation, UpdatePractitionerSelfInvoiceMutationVariables>;

/**
 * __useUpdatePractitionerSelfInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerSelfInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerSelfInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerSelfInvoiceMutation, { data, loading, error }] = useUpdatePractitionerSelfInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      utrNo: // value for 'utrNo'
 *      vatNumber: // value for 'vatNumber'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useUpdatePractitionerSelfInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerSelfInvoiceMutation, UpdatePractitionerSelfInvoiceMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerSelfInvoiceMutation, UpdatePractitionerSelfInvoiceMutationVariables>(UpdatePractitionerSelfInvoiceDocument, baseOptions);
      }
export type UpdatePractitionerSelfInvoiceMutationHookResult = ReturnType<typeof useUpdatePractitionerSelfInvoiceMutation>;
export type UpdatePractitionerSelfInvoiceMutationResult = Apollo.MutationResult<UpdatePractitionerSelfInvoiceMutation>;
export type UpdatePractitionerSelfInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerSelfInvoiceMutation, UpdatePractitionerSelfInvoiceMutationVariables>;
export const CreatePractitionerScheduleDocument = gql`
    mutation createPractitionerSchedule($locationName: String, $color: String, $managingPractitioner: String, $breakRequired: Int, $fromDate: String, $toDate: String, $endType: Int, $endOnDate: String, $endOnAfterNoOfOccurences: Int, $weekTimings: [PomsPractitionerScheduleWeekTimings_Input], $isRepeat: Int, $repeatSelectType: Int) {
  PomsPractitionerScheduleCreate(
    resource: {resourceType: PomsPractitionerSchedule, locationId: "0", locationName: $locationName, color: $color, managingPractitioner: $managingPractitioner, defaultVisibility: 1, breakRequired: $breakRequired, fromDate: $fromDate, toDate: $toDate, endOnType: $endType, endOnDate: $endOnDate, endOnAfterNoOfOccurences: $endOnAfterNoOfOccurences, weekTimings: $weekTimings, isRepeat: $isRepeat, repeatSelectType: $repeatSelectType}
  ) {
    id
  }
}
    `;
export type CreatePractitionerScheduleMutationFn = Apollo.MutationFunction<CreatePractitionerScheduleMutation, CreatePractitionerScheduleMutationVariables>;

/**
 * __useCreatePractitionerScheduleMutation__
 *
 * To run a mutation, you first call `useCreatePractitionerScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePractitionerScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPractitionerScheduleMutation, { data, loading, error }] = useCreatePractitionerScheduleMutation({
 *   variables: {
 *      locationName: // value for 'locationName'
 *      color: // value for 'color'
 *      managingPractitioner: // value for 'managingPractitioner'
 *      breakRequired: // value for 'breakRequired'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      endType: // value for 'endType'
 *      endOnDate: // value for 'endOnDate'
 *      endOnAfterNoOfOccurences: // value for 'endOnAfterNoOfOccurences'
 *      weekTimings: // value for 'weekTimings'
 *      isRepeat: // value for 'isRepeat'
 *      repeatSelectType: // value for 'repeatSelectType'
 *   },
 * });
 */
export function useCreatePractitionerScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreatePractitionerScheduleMutation, CreatePractitionerScheduleMutationVariables>) {
        return Apollo.useMutation<CreatePractitionerScheduleMutation, CreatePractitionerScheduleMutationVariables>(CreatePractitionerScheduleDocument, baseOptions);
      }
export type CreatePractitionerScheduleMutationHookResult = ReturnType<typeof useCreatePractitionerScheduleMutation>;
export type CreatePractitionerScheduleMutationResult = Apollo.MutationResult<CreatePractitionerScheduleMutation>;
export type CreatePractitionerScheduleMutationOptions = Apollo.BaseMutationOptions<CreatePractitionerScheduleMutation, CreatePractitionerScheduleMutationVariables>;
export const UpdatePractitionerScheduleDocument = gql`
    mutation updatePractitionerSchedule($id: id, $locationName: String, $color: String, $managingPractitioner: String, $breakRequired: Int, $fromDate: String, $toDate: String, $endType: Int, $endOnDate: String, $endOnAfterNoOfOccurences: Int, $weekTimings: [PomsPractitionerScheduleWeekTimings_Input], $isRepeat: Int, $repeatSelectType: Int) {
  PomsPractitionerScheduleUpdate(
    resource: {resourceType: PomsPractitionerSchedule, locationId: "0", id: $id, locationName: $locationName, color: $color, managingPractitioner: $managingPractitioner, defaultVisibility: 1, breakRequired: $breakRequired, fromDate: $fromDate, toDate: $toDate, endOnType: $endType, endOnDate: $endOnDate, endOnAfterNoOfOccurences: $endOnAfterNoOfOccurences, weekTimings: $weekTimings, isRepeat: $isRepeat, repeatSelectType: $repeatSelectType}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerScheduleMutationFn = Apollo.MutationFunction<UpdatePractitionerScheduleMutation, UpdatePractitionerScheduleMutationVariables>;

/**
 * __useUpdatePractitionerScheduleMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerScheduleMutation, { data, loading, error }] = useUpdatePractitionerScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      locationName: // value for 'locationName'
 *      color: // value for 'color'
 *      managingPractitioner: // value for 'managingPractitioner'
 *      breakRequired: // value for 'breakRequired'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      endType: // value for 'endType'
 *      endOnDate: // value for 'endOnDate'
 *      endOnAfterNoOfOccurences: // value for 'endOnAfterNoOfOccurences'
 *      weekTimings: // value for 'weekTimings'
 *      isRepeat: // value for 'isRepeat'
 *      repeatSelectType: // value for 'repeatSelectType'
 *   },
 * });
 */
export function useUpdatePractitionerScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerScheduleMutation, UpdatePractitionerScheduleMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerScheduleMutation, UpdatePractitionerScheduleMutationVariables>(UpdatePractitionerScheduleDocument, baseOptions);
      }
export type UpdatePractitionerScheduleMutationHookResult = ReturnType<typeof useUpdatePractitionerScheduleMutation>;
export type UpdatePractitionerScheduleMutationResult = Apollo.MutationResult<UpdatePractitionerScheduleMutation>;
export type UpdatePractitionerScheduleMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerScheduleMutation, UpdatePractitionerScheduleMutationVariables>;
export const UpdatePractitionerDocumentsDocument = gql`
    mutation updatePractitionerDocuments($id: String, $documents: [DocumentReferencecontent_Input!]) {
  DocumentReferenceUpdate(
    resource: {resourceType: DocumentReference, status: "1", subject: $id, content: $documents}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerDocumentsMutationFn = Apollo.MutationFunction<UpdatePractitionerDocumentsMutation, UpdatePractitionerDocumentsMutationVariables>;

/**
 * __useUpdatePractitionerDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerDocumentsMutation, { data, loading, error }] = useUpdatePractitionerDocumentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useUpdatePractitionerDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerDocumentsMutation, UpdatePractitionerDocumentsMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerDocumentsMutation, UpdatePractitionerDocumentsMutationVariables>(UpdatePractitionerDocumentsDocument, baseOptions);
      }
export type UpdatePractitionerDocumentsMutationHookResult = ReturnType<typeof useUpdatePractitionerDocumentsMutation>;
export type UpdatePractitionerDocumentsMutationResult = Apollo.MutationResult<UpdatePractitionerDocumentsMutation>;
export type UpdatePractitionerDocumentsMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerDocumentsMutation, UpdatePractitionerDocumentsMutationVariables>;
export const SavePatientTagsDocument = gql`
    mutation savePatientTags($id: id, $tags: [String], $practitionerId: String, $practitionerName: String, $comment: String) {
  PatientUpdate(
    resource: {resourceType: Patient, tags: $tags, patientExtension: {operationType: "UPDATE_TAGS"}, id: $id, comments: {practitionerId: $practitionerId, comments: $comment, practitionerName: $practitionerName}}
  ) {
    id
  }
}
    `;
export type SavePatientTagsMutationFn = Apollo.MutationFunction<SavePatientTagsMutation, SavePatientTagsMutationVariables>;

/**
 * __useSavePatientTagsMutation__
 *
 * To run a mutation, you first call `useSavePatientTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePatientTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePatientTagsMutation, { data, loading, error }] = useSavePatientTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *      practitionerId: // value for 'practitionerId'
 *      practitionerName: // value for 'practitionerName'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSavePatientTagsMutation(baseOptions?: Apollo.MutationHookOptions<SavePatientTagsMutation, SavePatientTagsMutationVariables>) {
        return Apollo.useMutation<SavePatientTagsMutation, SavePatientTagsMutationVariables>(SavePatientTagsDocument, baseOptions);
      }
export type SavePatientTagsMutationHookResult = ReturnType<typeof useSavePatientTagsMutation>;
export type SavePatientTagsMutationResult = Apollo.MutationResult<SavePatientTagsMutation>;
export type SavePatientTagsMutationOptions = Apollo.BaseMutationOptions<SavePatientTagsMutation, SavePatientTagsMutationVariables>;
export const SavePatientDocumentsDocument = gql`
    mutation savePatientDocuments($id: String, $tags: [String], $documentUrl: String, $documentType: String, $author: String, $documentName: String, $organizationName: String, $practitionerId: String, $practitionerName: String, $report_date: String) {
  PomsPatientDocumentCreate(
    resource: {resourceType: PomsPatientDocuments, tags: $tags, patientId: $id, documentUrl: $documentUrl, documentType: $documentType, documentName: $documentName, author: $author, organizationName: $organizationName, practitionerId: $practitionerId, practitionerName: $practitionerName, report_date: $report_date}
  ) {
    id
  }
}
    `;
export type SavePatientDocumentsMutationFn = Apollo.MutationFunction<SavePatientDocumentsMutation, SavePatientDocumentsMutationVariables>;

/**
 * __useSavePatientDocumentsMutation__
 *
 * To run a mutation, you first call `useSavePatientDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePatientDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePatientDocumentsMutation, { data, loading, error }] = useSavePatientDocumentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *      documentUrl: // value for 'documentUrl'
 *      documentType: // value for 'documentType'
 *      author: // value for 'author'
 *      documentName: // value for 'documentName'
 *      organizationName: // value for 'organizationName'
 *      practitionerId: // value for 'practitionerId'
 *      practitionerName: // value for 'practitionerName'
 *      report_date: // value for 'report_date'
 *   },
 * });
 */
export function useSavePatientDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<SavePatientDocumentsMutation, SavePatientDocumentsMutationVariables>) {
        return Apollo.useMutation<SavePatientDocumentsMutation, SavePatientDocumentsMutationVariables>(SavePatientDocumentsDocument, baseOptions);
      }
export type SavePatientDocumentsMutationHookResult = ReturnType<typeof useSavePatientDocumentsMutation>;
export type SavePatientDocumentsMutationResult = Apollo.MutationResult<SavePatientDocumentsMutation>;
export type SavePatientDocumentsMutationOptions = Apollo.BaseMutationOptions<SavePatientDocumentsMutation, SavePatientDocumentsMutationVariables>;
export const SavePractitionerPatientCommunicationDocument = gql`
    mutation savePractitionerPatientCommunication($patientId: String, $toEmail: String, $fromEmail: String, $ccEmail: String, $bccEmail: String, $subject: String, $channel: String, $messageContent: String, $practitionerId: String, $practitionerName: String, $documentUrl: String) {
  PractitionerPatientCommunicationCreate(
    resource: {resourceType: PractitionerPatientCommunication, toEmail: $toEmail, fromEmail: $fromEmail, ccEmail: $ccEmail, bccEmail: $bccEmail, subject: $subject, channel: $channel, messageContent: $messageContent, patientId: $patientId, practitionerId: $practitionerId, practitionerName: $practitionerName, documentUrl: $documentUrl, commFrom: 2}
  ) {
    id
  }
}
    `;
export type SavePractitionerPatientCommunicationMutationFn = Apollo.MutationFunction<SavePractitionerPatientCommunicationMutation, SavePractitionerPatientCommunicationMutationVariables>;

/**
 * __useSavePractitionerPatientCommunicationMutation__
 *
 * To run a mutation, you first call `useSavePractitionerPatientCommunicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePractitionerPatientCommunicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePractitionerPatientCommunicationMutation, { data, loading, error }] = useSavePractitionerPatientCommunicationMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      toEmail: // value for 'toEmail'
 *      fromEmail: // value for 'fromEmail'
 *      ccEmail: // value for 'ccEmail'
 *      bccEmail: // value for 'bccEmail'
 *      subject: // value for 'subject'
 *      channel: // value for 'channel'
 *      messageContent: // value for 'messageContent'
 *      practitionerId: // value for 'practitionerId'
 *      practitionerName: // value for 'practitionerName'
 *      documentUrl: // value for 'documentUrl'
 *   },
 * });
 */
export function useSavePractitionerPatientCommunicationMutation(baseOptions?: Apollo.MutationHookOptions<SavePractitionerPatientCommunicationMutation, SavePractitionerPatientCommunicationMutationVariables>) {
        return Apollo.useMutation<SavePractitionerPatientCommunicationMutation, SavePractitionerPatientCommunicationMutationVariables>(SavePractitionerPatientCommunicationDocument, baseOptions);
      }
export type SavePractitionerPatientCommunicationMutationHookResult = ReturnType<typeof useSavePractitionerPatientCommunicationMutation>;
export type SavePractitionerPatientCommunicationMutationResult = Apollo.MutationResult<SavePractitionerPatientCommunicationMutation>;
export type SavePractitionerPatientCommunicationMutationOptions = Apollo.BaseMutationOptions<SavePractitionerPatientCommunicationMutation, SavePractitionerPatientCommunicationMutationVariables>;
export const UpdatePatientVitalsDocument = gql`
    mutation updatePatientVitals($id: id, $vitals: [Observation_Input]) {
  PatientUpdate(
    resource: {resourceType: Patient, patientExtension: {operationType: "HEALTH_PROFILE_VITALS"}, id: $id, healthProfile: {vitals: $vitals}}
  ) {
    id
  }
}
    `;
export type UpdatePatientVitalsMutationFn = Apollo.MutationFunction<UpdatePatientVitalsMutation, UpdatePatientVitalsMutationVariables>;

/**
 * __useUpdatePatientVitalsMutation__
 *
 * To run a mutation, you first call `useUpdatePatientVitalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientVitalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientVitalsMutation, { data, loading, error }] = useUpdatePatientVitalsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vitals: // value for 'vitals'
 *   },
 * });
 */
export function useUpdatePatientVitalsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientVitalsMutation, UpdatePatientVitalsMutationVariables>) {
        return Apollo.useMutation<UpdatePatientVitalsMutation, UpdatePatientVitalsMutationVariables>(UpdatePatientVitalsDocument, baseOptions);
      }
export type UpdatePatientVitalsMutationHookResult = ReturnType<typeof useUpdatePatientVitalsMutation>;
export type UpdatePatientVitalsMutationResult = Apollo.MutationResult<UpdatePatientVitalsMutation>;
export type UpdatePatientVitalsMutationOptions = Apollo.BaseMutationOptions<UpdatePatientVitalsMutation, UpdatePatientVitalsMutationVariables>;
export const CreatePatientPrescriptionDocument = gql`
    mutation createPatientPrescription($comments: String, $practitionerName: String, $practitionerId: String, $patientId: String, $practitionerSpeciality: String, $medications: [PatientPrescriptionExtension_Input], $patientName: String, $patientAddress: String, $practitionerSignUrl: String, $gmcNumber: String, $dateofbirth: String, $practitionerEmail: String, $practitionerPhoneNumber: String, $practitionerAddress: String, $patientEmail: String, $patientPhoneNumber: String, $prescriptionType: Int, $prescriptionUploadUrl: String, $prescriptionFileUrl: String, $prescriptionFileUrlName: String) {
  PatientPrescriptionCreate(
    resource: {resourceType: PatientPrescription, comments: $comments, practitionerName: $practitionerName, practitionerId: $practitionerId, patientId: $patientId, practitionerSpeciality: $practitionerSpeciality, medications: $medications, patientName: $patientName, patientAddress: $patientAddress, practitionerSignUrl: $practitionerSignUrl, gmcNumber: $gmcNumber, dateofbirth: $dateofbirth, practitionerEmail: $practitionerEmail, prescriptionType: $prescriptionType, prescriptionUploadUrl: $prescriptionUploadUrl, practitionerPhoneNumber: $practitionerPhoneNumber, practitionerAddress: $practitionerAddress, patientEmail: $patientEmail, patientPhoneNumber: $patientPhoneNumber, prescriptionFileUrl: $prescriptionFileUrl, prescriptionFileUrlName: $prescriptionFileUrlName}
  ) {
    id
  }
}
    `;
export type CreatePatientPrescriptionMutationFn = Apollo.MutationFunction<CreatePatientPrescriptionMutation, CreatePatientPrescriptionMutationVariables>;

/**
 * __useCreatePatientPrescriptionMutation__
 *
 * To run a mutation, you first call `useCreatePatientPrescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientPrescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientPrescriptionMutation, { data, loading, error }] = useCreatePatientPrescriptionMutation({
 *   variables: {
 *      comments: // value for 'comments'
 *      practitionerName: // value for 'practitionerName'
 *      practitionerId: // value for 'practitionerId'
 *      patientId: // value for 'patientId'
 *      practitionerSpeciality: // value for 'practitionerSpeciality'
 *      medications: // value for 'medications'
 *      patientName: // value for 'patientName'
 *      patientAddress: // value for 'patientAddress'
 *      practitionerSignUrl: // value for 'practitionerSignUrl'
 *      gmcNumber: // value for 'gmcNumber'
 *      dateofbirth: // value for 'dateofbirth'
 *      practitionerEmail: // value for 'practitionerEmail'
 *      practitionerPhoneNumber: // value for 'practitionerPhoneNumber'
 *      practitionerAddress: // value for 'practitionerAddress'
 *      patientEmail: // value for 'patientEmail'
 *      patientPhoneNumber: // value for 'patientPhoneNumber'
 *      prescriptionType: // value for 'prescriptionType'
 *      prescriptionUploadUrl: // value for 'prescriptionUploadUrl'
 *      prescriptionFileUrl: // value for 'prescriptionFileUrl'
 *      prescriptionFileUrlName: // value for 'prescriptionFileUrlName'
 *   },
 * });
 */
export function useCreatePatientPrescriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientPrescriptionMutation, CreatePatientPrescriptionMutationVariables>) {
        return Apollo.useMutation<CreatePatientPrescriptionMutation, CreatePatientPrescriptionMutationVariables>(CreatePatientPrescriptionDocument, baseOptions);
      }
export type CreatePatientPrescriptionMutationHookResult = ReturnType<typeof useCreatePatientPrescriptionMutation>;
export type CreatePatientPrescriptionMutationResult = Apollo.MutationResult<CreatePatientPrescriptionMutation>;
export type CreatePatientPrescriptionMutationOptions = Apollo.BaseMutationOptions<CreatePatientPrescriptionMutation, CreatePatientPrescriptionMutationVariables>;
export const CreatePatientReferralDocument = gql`
    mutation createPatientReferral($referrer_Title: String, $referrer_FirstName: String, $referrer_SurName: String, $referrer_Specialisation: String, $referrer_Role: String, $referrer_Location: String, $referrer_PhoneNumber: String, $referrer_Email: String, $referral_Title: String, $referral_FirstName: String, $referral_SurName: String, $referral_Dob: String, $referral_Email: String, $referral_PhoneNumber: String, $referral_ReferenceNumber: String, $referral_PostCode: String, $referral_Address1: String, $referral_Address2: String, $referral_Address3: String, $referral_City: String, $referral_County: String, $referral_Country: String, $typeOfReferral_Assessments: String, $typeOfReferral_RecommendationTreatments: String, $referral_Urgent: String, $referral_RiskToSelfOrOthers: String, $referral_Reason: String, $expectationFromReferral: String, $referral_VerbalConsentCheck: String, $referral_TermsAndConditions: String, $patientId: String, $patientName: String, $practitionerId: String, $practitionerName: String, $documents: [DocumentReferencecontent_Input!], $practitionerSpeciality: String, $typeOfReferral: Int) {
  PomsReferralCreate(
    resource: {resourceType: PomsReferral, referrer_Title: $referrer_Title, referrer_FirstName: $referrer_FirstName, referrer_SurName: $referrer_SurName, referrer_Specialisation: $referrer_Specialisation, referrer_Role: $referrer_Role, referrer_Location: $referrer_Location, referrer_PhoneNumber: $referrer_PhoneNumber, referrer_Email: $referrer_Email, referral_Title: $referral_Title, referral_FirstName: $referral_FirstName, referral_SurName: $referral_SurName, referral_Dob: $referral_Dob, referral_Email: $referral_Email, referral_PhoneNumber: $referral_PhoneNumber, referral_ReferenceNumber: $referral_ReferenceNumber, referral_PostCode: $referral_PostCode, referral_Address1: $referral_Address1, referral_Address2: $referral_Address2, referral_Address3: $referral_Address3, referral_City: $referral_City, referral_County: $referral_County, referral_Country: $referral_Country, typeOfReferral_Assessments: $typeOfReferral_Assessments, typeOfReferral_RecommendationTreatments: $typeOfReferral_RecommendationTreatments, referral_Urgent: $referral_Urgent, referral_RiskToSelfOrOthers: $referral_RiskToSelfOrOthers, referral_Reason: $referral_Reason, expectationFromReferral: $expectationFromReferral, referral_VerbalConsentCheck: $referral_VerbalConsentCheck, referral_TermsAndConditions: $referral_TermsAndConditions, typeOfReferral: $typeOfReferral, patientId: $patientId, patientName: $patientName, practitionerId: $practitionerId, practitionerName: $practitionerName, practitionerSpeciality: $practitionerSpeciality, referral_UploadDocuments: {resourceType: DocumentReference, status: "", content: $documents}}
  ) {
    id
  }
}
    `;
export type CreatePatientReferralMutationFn = Apollo.MutationFunction<CreatePatientReferralMutation, CreatePatientReferralMutationVariables>;

/**
 * __useCreatePatientReferralMutation__
 *
 * To run a mutation, you first call `useCreatePatientReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientReferralMutation, { data, loading, error }] = useCreatePatientReferralMutation({
 *   variables: {
 *      referrer_Title: // value for 'referrer_Title'
 *      referrer_FirstName: // value for 'referrer_FirstName'
 *      referrer_SurName: // value for 'referrer_SurName'
 *      referrer_Specialisation: // value for 'referrer_Specialisation'
 *      referrer_Role: // value for 'referrer_Role'
 *      referrer_Location: // value for 'referrer_Location'
 *      referrer_PhoneNumber: // value for 'referrer_PhoneNumber'
 *      referrer_Email: // value for 'referrer_Email'
 *      referral_Title: // value for 'referral_Title'
 *      referral_FirstName: // value for 'referral_FirstName'
 *      referral_SurName: // value for 'referral_SurName'
 *      referral_Dob: // value for 'referral_Dob'
 *      referral_Email: // value for 'referral_Email'
 *      referral_PhoneNumber: // value for 'referral_PhoneNumber'
 *      referral_ReferenceNumber: // value for 'referral_ReferenceNumber'
 *      referral_PostCode: // value for 'referral_PostCode'
 *      referral_Address1: // value for 'referral_Address1'
 *      referral_Address2: // value for 'referral_Address2'
 *      referral_Address3: // value for 'referral_Address3'
 *      referral_City: // value for 'referral_City'
 *      referral_County: // value for 'referral_County'
 *      referral_Country: // value for 'referral_Country'
 *      typeOfReferral_Assessments: // value for 'typeOfReferral_Assessments'
 *      typeOfReferral_RecommendationTreatments: // value for 'typeOfReferral_RecommendationTreatments'
 *      referral_Urgent: // value for 'referral_Urgent'
 *      referral_RiskToSelfOrOthers: // value for 'referral_RiskToSelfOrOthers'
 *      referral_Reason: // value for 'referral_Reason'
 *      expectationFromReferral: // value for 'expectationFromReferral'
 *      referral_VerbalConsentCheck: // value for 'referral_VerbalConsentCheck'
 *      referral_TermsAndConditions: // value for 'referral_TermsAndConditions'
 *      patientId: // value for 'patientId'
 *      patientName: // value for 'patientName'
 *      practitionerId: // value for 'practitionerId'
 *      practitionerName: // value for 'practitionerName'
 *      documents: // value for 'documents'
 *      practitionerSpeciality: // value for 'practitionerSpeciality'
 *      typeOfReferral: // value for 'typeOfReferral'
 *   },
 * });
 */
export function useCreatePatientReferralMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientReferralMutation, CreatePatientReferralMutationVariables>) {
        return Apollo.useMutation<CreatePatientReferralMutation, CreatePatientReferralMutationVariables>(CreatePatientReferralDocument, baseOptions);
      }
export type CreatePatientReferralMutationHookResult = ReturnType<typeof useCreatePatientReferralMutation>;
export type CreatePatientReferralMutationResult = Apollo.MutationResult<CreatePatientReferralMutation>;
export type CreatePatientReferralMutationOptions = Apollo.BaseMutationOptions<CreatePatientReferralMutation, CreatePatientReferralMutationVariables>;
export const CreatePatientInternalReferralDocument = gql`
    mutation createPatientInternalReferral($patientId: String, $patientName: String, $practitionerId: String, $practitionerName: String, $referrer_Specialisation: String, $referredPractitionerId: String, $referredPractitionerName: String, $referredPractitionerSpecialization: String, $patientEmail: String, $patientPhone: String, $patientAddress: String, $referral_Dob: String, $referrer_PostCode: String, $referrer_Address1: String, $referrer_Address2: String, $referrer_Address3: String, $referrer_City: String, $referrer_County: String, $referrer_Country: String, $typeOfReferral_Assessments: String, $typeOfReferral_RecommendationTreatments: String, $referral_Urgent: String, $referral_VerbalConsentCheck: String, $referral_TermsAndConditions: String) {
  PomsReferralCreate(
    resource: {resourceType: PomsReferral, typeOfReferral: 3, patientId: $patientId, patientName: $patientName, practitionerId: $practitionerId, practitionerName: $practitionerName, referrer_Specialisation: $referrer_Specialisation, referredPractitionerId: $referredPractitionerId, referredPractitionerName: $referredPractitionerName, referredPractitionerSpecialization: $referredPractitionerSpecialization, patientEmail: $patientEmail, patientPhone: $patientPhone, patientAddress: $patientAddress, referral_Dob: $referral_Dob, referrer_PostCode: $referrer_PostCode, referrer_Address1: $referrer_Address1, referrer_Address2: $referrer_Address2, referrer_Address3: $referrer_Address3, referrer_City: $referrer_City, referrer_County: $referrer_County, referrer_Country: $referrer_Country, typeOfReferral_Assessments: $typeOfReferral_Assessments, typeOfReferral_RecommendationTreatments: $typeOfReferral_RecommendationTreatments, referral_Urgent: $referral_Urgent, referral_VerbalConsentCheck: $referral_VerbalConsentCheck, referral_TermsAndConditions: $referral_TermsAndConditions}
  ) {
    id
  }
}
    `;
export type CreatePatientInternalReferralMutationFn = Apollo.MutationFunction<CreatePatientInternalReferralMutation, CreatePatientInternalReferralMutationVariables>;

/**
 * __useCreatePatientInternalReferralMutation__
 *
 * To run a mutation, you first call `useCreatePatientInternalReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientInternalReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientInternalReferralMutation, { data, loading, error }] = useCreatePatientInternalReferralMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      patientName: // value for 'patientName'
 *      practitionerId: // value for 'practitionerId'
 *      practitionerName: // value for 'practitionerName'
 *      referrer_Specialisation: // value for 'referrer_Specialisation'
 *      referredPractitionerId: // value for 'referredPractitionerId'
 *      referredPractitionerName: // value for 'referredPractitionerName'
 *      referredPractitionerSpecialization: // value for 'referredPractitionerSpecialization'
 *      patientEmail: // value for 'patientEmail'
 *      patientPhone: // value for 'patientPhone'
 *      patientAddress: // value for 'patientAddress'
 *      referral_Dob: // value for 'referral_Dob'
 *      referrer_PostCode: // value for 'referrer_PostCode'
 *      referrer_Address1: // value for 'referrer_Address1'
 *      referrer_Address2: // value for 'referrer_Address2'
 *      referrer_Address3: // value for 'referrer_Address3'
 *      referrer_City: // value for 'referrer_City'
 *      referrer_County: // value for 'referrer_County'
 *      referrer_Country: // value for 'referrer_Country'
 *      typeOfReferral_Assessments: // value for 'typeOfReferral_Assessments'
 *      typeOfReferral_RecommendationTreatments: // value for 'typeOfReferral_RecommendationTreatments'
 *      referral_Urgent: // value for 'referral_Urgent'
 *      referral_VerbalConsentCheck: // value for 'referral_VerbalConsentCheck'
 *      referral_TermsAndConditions: // value for 'referral_TermsAndConditions'
 *   },
 * });
 */
export function useCreatePatientInternalReferralMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientInternalReferralMutation, CreatePatientInternalReferralMutationVariables>) {
        return Apollo.useMutation<CreatePatientInternalReferralMutation, CreatePatientInternalReferralMutationVariables>(CreatePatientInternalReferralDocument, baseOptions);
      }
export type CreatePatientInternalReferralMutationHookResult = ReturnType<typeof useCreatePatientInternalReferralMutation>;
export type CreatePatientInternalReferralMutationResult = Apollo.MutationResult<CreatePatientInternalReferralMutation>;
export type CreatePatientInternalReferralMutationOptions = Apollo.BaseMutationOptions<CreatePatientInternalReferralMutation, CreatePatientInternalReferralMutationVariables>;
export const CreatePatientFinancialInfoDocument = gql`
    mutation createPatientFinancialInfo($patientId: String, $financialType: String, $selfPayCardName: String, $selfPayCardBrand: String, $selfPayExpMonth: String, $selfPayExpYear: String, $selfPayCardType: String, $selfPayLast4: String, $selfPayPostalcode: String, $selfPayAddress1: String, $selfPayAddress2: String, $selfPayAddress3: String, $selfPayCity: String, $selfPayCounty: String, $selfPayCountry: String, $selfPayDefault: Int, $pmiName: String, $pmiResponsibleParty: String, $pmiFirstName: String, $pmiSurName: String, $pmiGroupId: String, $pmiPolicyNumber: String, $pmiExpiresOn: String, $pmiAuthorizationCode: String, $pmiAuthorizationSession: String, $pmiDocuments: [DocumentReferencecontent_Input!], $pmiDefault: Int, $thirdPartyName: String, $thirdPartyId: String, $thirdPartyComments: String, $thirdPartyContactPerson: String, $thirdPartyRoleOfPerson: String, $thirdPartyPhoneNumber: String, $thirdPartyEmail: String) {
  PatientFinancialInfoCreate(
    resource: {resourceType: PatientFinancialInfo, patientId: $patientId, financialType: $financialType, selfPayCardName: $selfPayCardName, selfPayCardBrand: $selfPayCardBrand, selfPayExpMonth: $selfPayExpMonth, selfPayExpYear: $selfPayExpYear, selfPayCardType: $selfPayCardType, selfPayLast4: $selfPayLast4, selfPayPostalcode: $selfPayPostalcode, selfPayAddress1: $selfPayAddress1, selfPayAddress2: $selfPayAddress2, selfPayAddress3: $selfPayAddress3, selfPayCity: $selfPayCity, selfPayCounty: $selfPayCounty, selfPayCountry: $selfPayCountry, selfPayDefault: $selfPayDefault, pmiName: $pmiName, pmiResponsibleParty: $pmiResponsibleParty, pmiFirstName: $pmiFirstName, pmiSurName: $pmiSurName, pmiGroupId: $pmiGroupId, pmiPolicyNumber: $pmiPolicyNumber, pmiExpiresOn: $pmiExpiresOn, pmiAuthorizationCode: $pmiAuthorizationCode, pmiAuthorizationSession: $pmiAuthorizationSession, pmiDocuments: {resourceType: DocumentReference, status: "", content: $pmiDocuments}, pmiDefault: $pmiDefault, thirdPartyName: $thirdPartyName, thirdPartyId: $thirdPartyId, thirdPartyComments: $thirdPartyComments, thirdPartyContactPerson: $thirdPartyContactPerson, thirdPartyRoleOfPerson: $thirdPartyRoleOfPerson, thirdPartyPhoneNumber: $thirdPartyPhoneNumber, thirdPartyEmail: $thirdPartyEmail}
  ) {
    id
  }
}
    `;
export type CreatePatientFinancialInfoMutationFn = Apollo.MutationFunction<CreatePatientFinancialInfoMutation, CreatePatientFinancialInfoMutationVariables>;

/**
 * __useCreatePatientFinancialInfoMutation__
 *
 * To run a mutation, you first call `useCreatePatientFinancialInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientFinancialInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientFinancialInfoMutation, { data, loading, error }] = useCreatePatientFinancialInfoMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      financialType: // value for 'financialType'
 *      selfPayCardName: // value for 'selfPayCardName'
 *      selfPayCardBrand: // value for 'selfPayCardBrand'
 *      selfPayExpMonth: // value for 'selfPayExpMonth'
 *      selfPayExpYear: // value for 'selfPayExpYear'
 *      selfPayCardType: // value for 'selfPayCardType'
 *      selfPayLast4: // value for 'selfPayLast4'
 *      selfPayPostalcode: // value for 'selfPayPostalcode'
 *      selfPayAddress1: // value for 'selfPayAddress1'
 *      selfPayAddress2: // value for 'selfPayAddress2'
 *      selfPayAddress3: // value for 'selfPayAddress3'
 *      selfPayCity: // value for 'selfPayCity'
 *      selfPayCounty: // value for 'selfPayCounty'
 *      selfPayCountry: // value for 'selfPayCountry'
 *      selfPayDefault: // value for 'selfPayDefault'
 *      pmiName: // value for 'pmiName'
 *      pmiResponsibleParty: // value for 'pmiResponsibleParty'
 *      pmiFirstName: // value for 'pmiFirstName'
 *      pmiSurName: // value for 'pmiSurName'
 *      pmiGroupId: // value for 'pmiGroupId'
 *      pmiPolicyNumber: // value for 'pmiPolicyNumber'
 *      pmiExpiresOn: // value for 'pmiExpiresOn'
 *      pmiAuthorizationCode: // value for 'pmiAuthorizationCode'
 *      pmiAuthorizationSession: // value for 'pmiAuthorizationSession'
 *      pmiDocuments: // value for 'pmiDocuments'
 *      pmiDefault: // value for 'pmiDefault'
 *      thirdPartyName: // value for 'thirdPartyName'
 *      thirdPartyId: // value for 'thirdPartyId'
 *      thirdPartyComments: // value for 'thirdPartyComments'
 *      thirdPartyContactPerson: // value for 'thirdPartyContactPerson'
 *      thirdPartyRoleOfPerson: // value for 'thirdPartyRoleOfPerson'
 *      thirdPartyPhoneNumber: // value for 'thirdPartyPhoneNumber'
 *      thirdPartyEmail: // value for 'thirdPartyEmail'
 *   },
 * });
 */
export function useCreatePatientFinancialInfoMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientFinancialInfoMutation, CreatePatientFinancialInfoMutationVariables>) {
        return Apollo.useMutation<CreatePatientFinancialInfoMutation, CreatePatientFinancialInfoMutationVariables>(CreatePatientFinancialInfoDocument, baseOptions);
      }
export type CreatePatientFinancialInfoMutationHookResult = ReturnType<typeof useCreatePatientFinancialInfoMutation>;
export type CreatePatientFinancialInfoMutationResult = Apollo.MutationResult<CreatePatientFinancialInfoMutation>;
export type CreatePatientFinancialInfoMutationOptions = Apollo.BaseMutationOptions<CreatePatientFinancialInfoMutation, CreatePatientFinancialInfoMutationVariables>;
export const UpdatePatientFinancialInfoDocument = gql`
    mutation updatePatientFinancialInfo($patientId: String, $id: id, $financialType: String, $selfPayCardName: String, $selfPayCardBrand: String, $selfPayExpMonth: String, $selfPayExpYear: String, $selfPayCardType: String, $selfPayLast4: String, $selfPayPostalcode: String, $selfPayAddress1: String, $selfPayAddress2: String, $selfPayAddress3: String, $selfPayCity: String, $selfPayCounty: String, $selfPayCountry: String, $selfPayDefault: Int, $pmiName: String, $pmiResponsibleParty: String, $pmiFirstName: String, $pmiSurName: String, $pmiGroupId: String, $pmiPolicyNumber: String, $pmiExpiresOn: String, $pmiAuthorizationCode: String, $pmiAuthorizationSession: String, $pmiDocuments: [DocumentReferencecontent_Input!], $pmiDefault: Int, $thirdPartyName: String, $thirdPartyId: String, $thirdPartyComments: String, $thirdPartyContactPerson: String, $thirdPartyRoleOfPerson: String, $thirdPartyPhoneNumber: String, $thirdPartyEmail: String) {
  PatientFinancialInfoUpdate(
    resource: {resourceType: PatientFinancialInfo, patientId: $patientId, id: $id, financialType: $financialType, selfPayCardName: $selfPayCardName, selfPayCardBrand: $selfPayCardBrand, selfPayExpMonth: $selfPayExpMonth, selfPayExpYear: $selfPayExpYear, selfPayCardType: $selfPayCardType, selfPayLast4: $selfPayLast4, selfPayPostalcode: $selfPayPostalcode, selfPayAddress1: $selfPayAddress1, selfPayAddress2: $selfPayAddress2, selfPayAddress3: $selfPayAddress3, selfPayCity: $selfPayCity, selfPayCounty: $selfPayCounty, selfPayCountry: $selfPayCountry, selfPayDefault: $selfPayDefault, pmiName: $pmiName, pmiResponsibleParty: $pmiResponsibleParty, pmiFirstName: $pmiFirstName, pmiSurName: $pmiSurName, pmiGroupId: $pmiGroupId, pmiPolicyNumber: $pmiPolicyNumber, pmiExpiresOn: $pmiExpiresOn, pmiAuthorizationCode: $pmiAuthorizationCode, pmiAuthorizationSession: $pmiAuthorizationSession, pmiDocuments: {resourceType: DocumentReference, status: "", content: $pmiDocuments}, pmiDefault: $pmiDefault, thirdPartyName: $thirdPartyName, thirdPartyId: $thirdPartyId, thirdPartyComments: $thirdPartyComments, thirdPartyContactPerson: $thirdPartyContactPerson, thirdPartyRoleOfPerson: $thirdPartyRoleOfPerson, thirdPartyPhoneNumber: $thirdPartyPhoneNumber, thirdPartyEmail: $thirdPartyEmail}
  ) {
    id
  }
}
    `;
export type UpdatePatientFinancialInfoMutationFn = Apollo.MutationFunction<UpdatePatientFinancialInfoMutation, UpdatePatientFinancialInfoMutationVariables>;

/**
 * __useUpdatePatientFinancialInfoMutation__
 *
 * To run a mutation, you first call `useUpdatePatientFinancialInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientFinancialInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientFinancialInfoMutation, { data, loading, error }] = useUpdatePatientFinancialInfoMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      id: // value for 'id'
 *      financialType: // value for 'financialType'
 *      selfPayCardName: // value for 'selfPayCardName'
 *      selfPayCardBrand: // value for 'selfPayCardBrand'
 *      selfPayExpMonth: // value for 'selfPayExpMonth'
 *      selfPayExpYear: // value for 'selfPayExpYear'
 *      selfPayCardType: // value for 'selfPayCardType'
 *      selfPayLast4: // value for 'selfPayLast4'
 *      selfPayPostalcode: // value for 'selfPayPostalcode'
 *      selfPayAddress1: // value for 'selfPayAddress1'
 *      selfPayAddress2: // value for 'selfPayAddress2'
 *      selfPayAddress3: // value for 'selfPayAddress3'
 *      selfPayCity: // value for 'selfPayCity'
 *      selfPayCounty: // value for 'selfPayCounty'
 *      selfPayCountry: // value for 'selfPayCountry'
 *      selfPayDefault: // value for 'selfPayDefault'
 *      pmiName: // value for 'pmiName'
 *      pmiResponsibleParty: // value for 'pmiResponsibleParty'
 *      pmiFirstName: // value for 'pmiFirstName'
 *      pmiSurName: // value for 'pmiSurName'
 *      pmiGroupId: // value for 'pmiGroupId'
 *      pmiPolicyNumber: // value for 'pmiPolicyNumber'
 *      pmiExpiresOn: // value for 'pmiExpiresOn'
 *      pmiAuthorizationCode: // value for 'pmiAuthorizationCode'
 *      pmiAuthorizationSession: // value for 'pmiAuthorizationSession'
 *      pmiDocuments: // value for 'pmiDocuments'
 *      pmiDefault: // value for 'pmiDefault'
 *      thirdPartyName: // value for 'thirdPartyName'
 *      thirdPartyId: // value for 'thirdPartyId'
 *      thirdPartyComments: // value for 'thirdPartyComments'
 *      thirdPartyContactPerson: // value for 'thirdPartyContactPerson'
 *      thirdPartyRoleOfPerson: // value for 'thirdPartyRoleOfPerson'
 *      thirdPartyPhoneNumber: // value for 'thirdPartyPhoneNumber'
 *      thirdPartyEmail: // value for 'thirdPartyEmail'
 *   },
 * });
 */
export function useUpdatePatientFinancialInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientFinancialInfoMutation, UpdatePatientFinancialInfoMutationVariables>) {
        return Apollo.useMutation<UpdatePatientFinancialInfoMutation, UpdatePatientFinancialInfoMutationVariables>(UpdatePatientFinancialInfoDocument, baseOptions);
      }
export type UpdatePatientFinancialInfoMutationHookResult = ReturnType<typeof useUpdatePatientFinancialInfoMutation>;
export type UpdatePatientFinancialInfoMutationResult = Apollo.MutationResult<UpdatePatientFinancialInfoMutation>;
export type UpdatePatientFinancialInfoMutationOptions = Apollo.BaseMutationOptions<UpdatePatientFinancialInfoMutation, UpdatePatientFinancialInfoMutationVariables>;
export const DeletePatientFinancialInfoDocument = gql`
    mutation deletePatientFinancialInfo($id: id!) {
  PatientFinancialInfoRemove(id: $id) {
    id
  }
}
    `;
export type DeletePatientFinancialInfoMutationFn = Apollo.MutationFunction<DeletePatientFinancialInfoMutation, DeletePatientFinancialInfoMutationVariables>;

/**
 * __useDeletePatientFinancialInfoMutation__
 *
 * To run a mutation, you first call `useDeletePatientFinancialInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientFinancialInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientFinancialInfoMutation, { data, loading, error }] = useDeletePatientFinancialInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePatientFinancialInfoMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientFinancialInfoMutation, DeletePatientFinancialInfoMutationVariables>) {
        return Apollo.useMutation<DeletePatientFinancialInfoMutation, DeletePatientFinancialInfoMutationVariables>(DeletePatientFinancialInfoDocument, baseOptions);
      }
export type DeletePatientFinancialInfoMutationHookResult = ReturnType<typeof useDeletePatientFinancialInfoMutation>;
export type DeletePatientFinancialInfoMutationResult = Apollo.MutationResult<DeletePatientFinancialInfoMutation>;
export type DeletePatientFinancialInfoMutationOptions = Apollo.BaseMutationOptions<DeletePatientFinancialInfoMutation, DeletePatientFinancialInfoMutationVariables>;
export const AssignQuestionnaireBuilderDocument = gql`
    mutation assignQuestionnaireBuilder($patientId: String, $assignedId: String, $assignedName: String, $assignedType: String, $assignedSpeciality: String, $questionnaire: QuestionnaireBuilder_Input, $questitionerId: String, $patientName: String) {
  PatientQuestionnaireCreate(
    resource: {resourceType: PatientQuestionnaire, patientId: $patientId, patientName: $patientName, assignedId: $assignedId, assignedName: $assignedName, assignedType: $assignedType, assignedSpeciality: $assignedSpeciality, questionnaire: $questionnaire, questitionerId: $questitionerId}
  ) {
    id
  }
}
    `;
export type AssignQuestionnaireBuilderMutationFn = Apollo.MutationFunction<AssignQuestionnaireBuilderMutation, AssignQuestionnaireBuilderMutationVariables>;

/**
 * __useAssignQuestionnaireBuilderMutation__
 *
 * To run a mutation, you first call `useAssignQuestionnaireBuilderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignQuestionnaireBuilderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignQuestionnaireBuilderMutation, { data, loading, error }] = useAssignQuestionnaireBuilderMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      assignedId: // value for 'assignedId'
 *      assignedName: // value for 'assignedName'
 *      assignedType: // value for 'assignedType'
 *      assignedSpeciality: // value for 'assignedSpeciality'
 *      questionnaire: // value for 'questionnaire'
 *      questitionerId: // value for 'questitionerId'
 *      patientName: // value for 'patientName'
 *   },
 * });
 */
export function useAssignQuestionnaireBuilderMutation(baseOptions?: Apollo.MutationHookOptions<AssignQuestionnaireBuilderMutation, AssignQuestionnaireBuilderMutationVariables>) {
        return Apollo.useMutation<AssignQuestionnaireBuilderMutation, AssignQuestionnaireBuilderMutationVariables>(AssignQuestionnaireBuilderDocument, baseOptions);
      }
export type AssignQuestionnaireBuilderMutationHookResult = ReturnType<typeof useAssignQuestionnaireBuilderMutation>;
export type AssignQuestionnaireBuilderMutationResult = Apollo.MutationResult<AssignQuestionnaireBuilderMutation>;
export type AssignQuestionnaireBuilderMutationOptions = Apollo.BaseMutationOptions<AssignQuestionnaireBuilderMutation, AssignQuestionnaireBuilderMutationVariables>;
export const CompleteQuestionnaireBuilderDocument = gql`
    mutation completeQuestionnaireBuilder($id: id, $questionnaire: QuestionnaireBuilder_Input, $status: String) {
  PatientQuestionnaireUpdate(
    resource: {resourceType: PatientQuestionnaire, id: $id, questionnaire: $questionnaire, status: $status}
  ) {
    id
  }
}
    `;
export type CompleteQuestionnaireBuilderMutationFn = Apollo.MutationFunction<CompleteQuestionnaireBuilderMutation, CompleteQuestionnaireBuilderMutationVariables>;

/**
 * __useCompleteQuestionnaireBuilderMutation__
 *
 * To run a mutation, you first call `useCompleteQuestionnaireBuilderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteQuestionnaireBuilderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeQuestionnaireBuilderMutation, { data, loading, error }] = useCompleteQuestionnaireBuilderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionnaire: // value for 'questionnaire'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCompleteQuestionnaireBuilderMutation(baseOptions?: Apollo.MutationHookOptions<CompleteQuestionnaireBuilderMutation, CompleteQuestionnaireBuilderMutationVariables>) {
        return Apollo.useMutation<CompleteQuestionnaireBuilderMutation, CompleteQuestionnaireBuilderMutationVariables>(CompleteQuestionnaireBuilderDocument, baseOptions);
      }
export type CompleteQuestionnaireBuilderMutationHookResult = ReturnType<typeof useCompleteQuestionnaireBuilderMutation>;
export type CompleteQuestionnaireBuilderMutationResult = Apollo.MutationResult<CompleteQuestionnaireBuilderMutation>;
export type CompleteQuestionnaireBuilderMutationOptions = Apollo.BaseMutationOptions<CompleteQuestionnaireBuilderMutation, CompleteQuestionnaireBuilderMutationVariables>;
export const UpdateAppointmentMedicationsDocument = gql`
    mutation UpdateAppointmentMedications($id: id, $practitionerName: String, $practitionerId: String, $patientId: String, $practitionerSpeciality: String, $medications: [PatientPrescriptionExtension_Input], $patientName: String, $patientAddress: String, $practitionerSignUrl: String, $gmcNumber: String, $comments: String, $dateofbirth: String, $practitionerEmail: String, $practitionerPhoneNumber: String, $practitionerAddress: String, $patientEmail: String, $patientPhoneNumber: String, $diagnosis: [String], $disorderDetails: [String], $prescriptionFileUrl: String, $prescriptionFileUrlName: String) {
  PomsAppointmentUpdate(
    id: $id
    resource: {resourceType: PomsAppointment, id: $id, appointmentStatusType: 4, appointmentStatus: "In Progress", diagnosis: $diagnosis, disorderDetails: $disorderDetails, prescriptions: {resourceType: PatientPrescription, comments: $comments, practitionerName: $practitionerName, practitionerId: $practitionerId, patientId: $patientId, practitionerSpeciality: $practitionerSpeciality, medications: $medications, practitionerEmail: $practitionerEmail, practitionerPhoneNumber: $practitionerPhoneNumber, practitionerAddress: $practitionerAddress, patientEmail: $patientEmail, patientPhoneNumber: $patientPhoneNumber, patientName: $patientName, patientAddress: $patientAddress, practitionerSignUrl: $practitionerSignUrl, gmcNumber: $gmcNumber, dateofbirth: $dateofbirth, prescriptionFileUrl: $prescriptionFileUrl, prescriptionFileUrlName: $prescriptionFileUrlName}}
  ) {
    id
  }
}
    `;
export type UpdateAppointmentMedicationsMutationFn = Apollo.MutationFunction<UpdateAppointmentMedicationsMutation, UpdateAppointmentMedicationsMutationVariables>;

/**
 * __useUpdateAppointmentMedicationsMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentMedicationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentMedicationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentMedicationsMutation, { data, loading, error }] = useUpdateAppointmentMedicationsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      practitionerName: // value for 'practitionerName'
 *      practitionerId: // value for 'practitionerId'
 *      patientId: // value for 'patientId'
 *      practitionerSpeciality: // value for 'practitionerSpeciality'
 *      medications: // value for 'medications'
 *      patientName: // value for 'patientName'
 *      patientAddress: // value for 'patientAddress'
 *      practitionerSignUrl: // value for 'practitionerSignUrl'
 *      gmcNumber: // value for 'gmcNumber'
 *      comments: // value for 'comments'
 *      dateofbirth: // value for 'dateofbirth'
 *      practitionerEmail: // value for 'practitionerEmail'
 *      practitionerPhoneNumber: // value for 'practitionerPhoneNumber'
 *      practitionerAddress: // value for 'practitionerAddress'
 *      patientEmail: // value for 'patientEmail'
 *      patientPhoneNumber: // value for 'patientPhoneNumber'
 *      diagnosis: // value for 'diagnosis'
 *      disorderDetails: // value for 'disorderDetails'
 *      prescriptionFileUrl: // value for 'prescriptionFileUrl'
 *      prescriptionFileUrlName: // value for 'prescriptionFileUrlName'
 *   },
 * });
 */
export function useUpdateAppointmentMedicationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentMedicationsMutation, UpdateAppointmentMedicationsMutationVariables>) {
        return Apollo.useMutation<UpdateAppointmentMedicationsMutation, UpdateAppointmentMedicationsMutationVariables>(UpdateAppointmentMedicationsDocument, baseOptions);
      }
export type UpdateAppointmentMedicationsMutationHookResult = ReturnType<typeof useUpdateAppointmentMedicationsMutation>;
export type UpdateAppointmentMedicationsMutationResult = Apollo.MutationResult<UpdateAppointmentMedicationsMutation>;
export type UpdateAppointmentMedicationsMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentMedicationsMutation, UpdateAppointmentMedicationsMutationVariables>;
export const UpdateAppointmentNotesDocument = gql`
    mutation UpdateAppointmentNotes($id: id, $practName: String, $practID: String, $patID: String, $practitionerSpeciality: String, $templateName: String!, $tempMode: String!, $tempType: String!, $tempData: String!, $patientName: String, $gpName: String, $gpEmail: String, $gpPractitionerName: String, $templateJsonData: String, $status: String, $diagnosis: [String], $disorderDetails: [String]) {
  PomsAppointmentUpdate(
    id: $id
    resource: {resourceType: PomsAppointment, id: $id, appointmentStatusType: 5, appointmentStatus: "In Progress", diagnosis: $diagnosis, disorderDetails: $disorderDetails, letters: {resourceType: PomsPatientLetter, patientId: $patID, practitionerId: $practID, practitionerName: $practName, practitionerSpeciality: $practitionerSpeciality, templateName: $templateName, templateMode: $tempMode, templateType: $tempType, templateData: $tempData, patientName: $patientName, gpName: $gpName, gpPractitionerName: $gpPractitionerName, gpEmail: $gpEmail, templateJsonData: $templateJsonData, status: $status}}
  ) {
    id
  }
}
    `;
export type UpdateAppointmentNotesMutationFn = Apollo.MutationFunction<UpdateAppointmentNotesMutation, UpdateAppointmentNotesMutationVariables>;

/**
 * __useUpdateAppointmentNotesMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentNotesMutation, { data, loading, error }] = useUpdateAppointmentNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      practName: // value for 'practName'
 *      practID: // value for 'practID'
 *      patID: // value for 'patID'
 *      practitionerSpeciality: // value for 'practitionerSpeciality'
 *      templateName: // value for 'templateName'
 *      tempMode: // value for 'tempMode'
 *      tempType: // value for 'tempType'
 *      tempData: // value for 'tempData'
 *      patientName: // value for 'patientName'
 *      gpName: // value for 'gpName'
 *      gpEmail: // value for 'gpEmail'
 *      gpPractitionerName: // value for 'gpPractitionerName'
 *      templateJsonData: // value for 'templateJsonData'
 *      status: // value for 'status'
 *      diagnosis: // value for 'diagnosis'
 *      disorderDetails: // value for 'disorderDetails'
 *   },
 * });
 */
export function useUpdateAppointmentNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentNotesMutation, UpdateAppointmentNotesMutationVariables>) {
        return Apollo.useMutation<UpdateAppointmentNotesMutation, UpdateAppointmentNotesMutationVariables>(UpdateAppointmentNotesDocument, baseOptions);
      }
export type UpdateAppointmentNotesMutationHookResult = ReturnType<typeof useUpdateAppointmentNotesMutation>;
export type UpdateAppointmentNotesMutationResult = Apollo.MutationResult<UpdateAppointmentNotesMutation>;
export type UpdateAppointmentNotesMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentNotesMutation, UpdateAppointmentNotesMutationVariables>;
export const SavePractitionerPatientCommunicationV1Document = gql`
    mutation savePractitionerPatientCommunicationV1($patientId: String, $toEmail: String, $fromEmail: String, $ccEmail: String, $bccEmail: String, $subject: String, $channel: String, $messageContent: String, $practitionerId: String, $practitionerName: String, $commFromType: Int, $commToType: Int, $fromId: String, $toId: String, $fromName: String, $toName: String, $documentUrl: String) {
  PractitionerPatientCommunicationCreate(
    resource: {resourceType: PractitionerPatientCommunication, toEmail: $toEmail, fromEmail: $fromEmail, ccEmail: $ccEmail, bccEmail: $bccEmail, subject: $subject, channel: $channel, messageContent: $messageContent, patientId: $patientId, practitionerId: $practitionerId, practitionerName: $practitionerName, commFromType: $commFromType, commToType: $commToType, fromId: $fromId, toId: $toId, fromName: $fromName, toName: $toName, documentUrl: $documentUrl, commFrom: 2}
  ) {
    id
  }
}
    `;
export type SavePractitionerPatientCommunicationV1MutationFn = Apollo.MutationFunction<SavePractitionerPatientCommunicationV1Mutation, SavePractitionerPatientCommunicationV1MutationVariables>;

/**
 * __useSavePractitionerPatientCommunicationV1Mutation__
 *
 * To run a mutation, you first call `useSavePractitionerPatientCommunicationV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePractitionerPatientCommunicationV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePractitionerPatientCommunicationV1Mutation, { data, loading, error }] = useSavePractitionerPatientCommunicationV1Mutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      toEmail: // value for 'toEmail'
 *      fromEmail: // value for 'fromEmail'
 *      ccEmail: // value for 'ccEmail'
 *      bccEmail: // value for 'bccEmail'
 *      subject: // value for 'subject'
 *      channel: // value for 'channel'
 *      messageContent: // value for 'messageContent'
 *      practitionerId: // value for 'practitionerId'
 *      practitionerName: // value for 'practitionerName'
 *      commFromType: // value for 'commFromType'
 *      commToType: // value for 'commToType'
 *      fromId: // value for 'fromId'
 *      toId: // value for 'toId'
 *      fromName: // value for 'fromName'
 *      toName: // value for 'toName'
 *      documentUrl: // value for 'documentUrl'
 *   },
 * });
 */
export function useSavePractitionerPatientCommunicationV1Mutation(baseOptions?: Apollo.MutationHookOptions<SavePractitionerPatientCommunicationV1Mutation, SavePractitionerPatientCommunicationV1MutationVariables>) {
        return Apollo.useMutation<SavePractitionerPatientCommunicationV1Mutation, SavePractitionerPatientCommunicationV1MutationVariables>(SavePractitionerPatientCommunicationV1Document, baseOptions);
      }
export type SavePractitionerPatientCommunicationV1MutationHookResult = ReturnType<typeof useSavePractitionerPatientCommunicationV1Mutation>;
export type SavePractitionerPatientCommunicationV1MutationResult = Apollo.MutationResult<SavePractitionerPatientCommunicationV1Mutation>;
export type SavePractitionerPatientCommunicationV1MutationOptions = Apollo.BaseMutationOptions<SavePractitionerPatientCommunicationV1Mutation, SavePractitionerPatientCommunicationV1MutationVariables>;
export const SendPractitionerReplyDocument = gql`
    mutation sendPractitionerReply($patientId: String, $toEmail: String, $fromEmail: String, $ccEmail: String, $bccEmail: String, $subject: String, $channel: String, $messageContent: String, $practitionerId: String, $practitionerName: String, $commFromType: Int, $commToType: Int, $fromId: String, $toId: String, $fromName: String, $toName: String, $id: id, $documentUrl: String) {
  PractitionerPatientCommunicationUpdate(
    resource: {id: $id, resourceType: PractitionerPatientCommunication, replies: [{resourceType: PractitionerPatientCommunication, toEmail: $toEmail, fromEmail: $fromEmail, ccEmail: $ccEmail, bccEmail: $bccEmail, subject: $subject, channel: $channel, messageContent: $messageContent, patientId: $patientId, practitionerId: $practitionerId, practitionerName: $practitionerName, commFromType: $commFromType, commToType: $commToType, fromId: $fromId, toId: $toId, fromName: $fromName, toName: $toName, documentUrl: $documentUrl, commFrom: 2}]}
  ) {
    id
  }
}
    `;
export type SendPractitionerReplyMutationFn = Apollo.MutationFunction<SendPractitionerReplyMutation, SendPractitionerReplyMutationVariables>;

/**
 * __useSendPractitionerReplyMutation__
 *
 * To run a mutation, you first call `useSendPractitionerReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPractitionerReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPractitionerReplyMutation, { data, loading, error }] = useSendPractitionerReplyMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      toEmail: // value for 'toEmail'
 *      fromEmail: // value for 'fromEmail'
 *      ccEmail: // value for 'ccEmail'
 *      bccEmail: // value for 'bccEmail'
 *      subject: // value for 'subject'
 *      channel: // value for 'channel'
 *      messageContent: // value for 'messageContent'
 *      practitionerId: // value for 'practitionerId'
 *      practitionerName: // value for 'practitionerName'
 *      commFromType: // value for 'commFromType'
 *      commToType: // value for 'commToType'
 *      fromId: // value for 'fromId'
 *      toId: // value for 'toId'
 *      fromName: // value for 'fromName'
 *      toName: // value for 'toName'
 *      id: // value for 'id'
 *      documentUrl: // value for 'documentUrl'
 *   },
 * });
 */
export function useSendPractitionerReplyMutation(baseOptions?: Apollo.MutationHookOptions<SendPractitionerReplyMutation, SendPractitionerReplyMutationVariables>) {
        return Apollo.useMutation<SendPractitionerReplyMutation, SendPractitionerReplyMutationVariables>(SendPractitionerReplyDocument, baseOptions);
      }
export type SendPractitionerReplyMutationHookResult = ReturnType<typeof useSendPractitionerReplyMutation>;
export type SendPractitionerReplyMutationResult = Apollo.MutationResult<SendPractitionerReplyMutation>;
export type SendPractitionerReplyMutationOptions = Apollo.BaseMutationOptions<SendPractitionerReplyMutation, SendPractitionerReplyMutationVariables>;
export const AddRecommendationDocument = gql`
    mutation addRecommendation($forPractitionerId: id, $forPractitionerName: String, $forPractitionerEmail: String, $toPractitionerId: String, $toPractitionerName: String, $toPractitionerEmail: String, $roleName: String) {
  PractitionerUpdate(
    id: $forPractitionerId
    resource: {resourceType: Practitioner, id: $forPractitionerId, practionerExtension: {operationType: "ADD_RECOMMENDATION"}, recommendations: [{recommendationSentFrom: 1, fromPractitionerName: $forPractitionerName, fromPractitionerId: $forPractitionerId, fromPractitionerEmail: $forPractitionerEmail, toPractitionerName: $toPractitionerName, toPractitionerId: $toPractitionerId, toPractitionerEmail: $toPractitionerEmail, roleName: $roleName, recommendationStatus: 0}]}
  ) {
    id
    status
  }
}
    `;
export type AddRecommendationMutationFn = Apollo.MutationFunction<AddRecommendationMutation, AddRecommendationMutationVariables>;

/**
 * __useAddRecommendationMutation__
 *
 * To run a mutation, you first call `useAddRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRecommendationMutation, { data, loading, error }] = useAddRecommendationMutation({
 *   variables: {
 *      forPractitionerId: // value for 'forPractitionerId'
 *      forPractitionerName: // value for 'forPractitionerName'
 *      forPractitionerEmail: // value for 'forPractitionerEmail'
 *      toPractitionerId: // value for 'toPractitionerId'
 *      toPractitionerName: // value for 'toPractitionerName'
 *      toPractitionerEmail: // value for 'toPractitionerEmail'
 *      roleName: // value for 'roleName'
 *   },
 * });
 */
export function useAddRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<AddRecommendationMutation, AddRecommendationMutationVariables>) {
        return Apollo.useMutation<AddRecommendationMutation, AddRecommendationMutationVariables>(AddRecommendationDocument, baseOptions);
      }
export type AddRecommendationMutationHookResult = ReturnType<typeof useAddRecommendationMutation>;
export type AddRecommendationMutationResult = Apollo.MutationResult<AddRecommendationMutation>;
export type AddRecommendationMutationOptions = Apollo.BaseMutationOptions<AddRecommendationMutation, AddRecommendationMutationVariables>;
export const UpdatePractStatusDocument = gql`
    mutation updatePractStatus($practId: id, $communicationStatus: Int) {
  PractitionerUpdate(
    id: $practId
    resource: {resourceType: Practitioner, id: $practId, practionerExtension: {operationType: "COMMUNICATION_STATUS"}, communicationStatus: $communicationStatus}
  ) {
    id
    status
  }
}
    `;
export type UpdatePractStatusMutationFn = Apollo.MutationFunction<UpdatePractStatusMutation, UpdatePractStatusMutationVariables>;

/**
 * __useUpdatePractStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePractStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractStatusMutation, { data, loading, error }] = useUpdatePractStatusMutation({
 *   variables: {
 *      practId: // value for 'practId'
 *      communicationStatus: // value for 'communicationStatus'
 *   },
 * });
 */
export function useUpdatePractStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractStatusMutation, UpdatePractStatusMutationVariables>) {
        return Apollo.useMutation<UpdatePractStatusMutation, UpdatePractStatusMutationVariables>(UpdatePractStatusDocument, baseOptions);
      }
export type UpdatePractStatusMutationHookResult = ReturnType<typeof useUpdatePractStatusMutation>;
export type UpdatePractStatusMutationResult = Apollo.MutationResult<UpdatePractStatusMutation>;
export type UpdatePractStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePractStatusMutation, UpdatePractStatusMutationVariables>;
export const CreatePatientFeedbackDocument = gql`
    mutation createPatientFeedback($feedBackPersonTitle: String, $documents: [DocumentReferencecontent_Input!], $feedBackPersonFirstName: String, $feedbackType: Int, $feedBackAbout: Int, $feedBackForPatientorRelative: Int, $feedBackPersonLastName: String, $feedBackPersonSurName: String, $feedBackPersonEmail: String, $feedBackPersonPhoneNumber: String, $feedBackComments: String, $feedBackServiceEmail: String, $feedBackAgainstUser: String, $feedBackServiceUserName: String, $fromUserId: String, $againstUserId: String) {
  FeedBackCreate(
    resource: {resourceType: FeedBack, feedBackType: $feedbackType, feedBackAbout: $feedBackAbout, feedBackForPatientorRelative: $feedBackForPatientorRelative, feedBackPersonTitle: $feedBackPersonTitle, feedBackPersonFirstName: $feedBackPersonFirstName, feedBackPersonLastName: $feedBackPersonLastName, feedBackPersonSurName: $feedBackPersonSurName, feedBackPersonEmail: $feedBackPersonEmail, feedBackPersonPhoneNumber: $feedBackPersonPhoneNumber, feedBackComments: $feedBackComments, feedBackAgainstUser: $feedBackAgainstUser, feedBackServiceUserName: $feedBackServiceUserName, feedBackDocuments: {resourceType: DocumentReference, status: "", content: $documents}, feedBackServiceEmail: $feedBackServiceEmail, fromUserId: $fromUserId, againstUserId: $againstUserId}
  ) {
    id
  }
}
    `;
export type CreatePatientFeedbackMutationFn = Apollo.MutationFunction<CreatePatientFeedbackMutation, CreatePatientFeedbackMutationVariables>;

/**
 * __useCreatePatientFeedbackMutation__
 *
 * To run a mutation, you first call `useCreatePatientFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientFeedbackMutation, { data, loading, error }] = useCreatePatientFeedbackMutation({
 *   variables: {
 *      feedBackPersonTitle: // value for 'feedBackPersonTitle'
 *      documents: // value for 'documents'
 *      feedBackPersonFirstName: // value for 'feedBackPersonFirstName'
 *      feedbackType: // value for 'feedbackType'
 *      feedBackAbout: // value for 'feedBackAbout'
 *      feedBackForPatientorRelative: // value for 'feedBackForPatientorRelative'
 *      feedBackPersonLastName: // value for 'feedBackPersonLastName'
 *      feedBackPersonSurName: // value for 'feedBackPersonSurName'
 *      feedBackPersonEmail: // value for 'feedBackPersonEmail'
 *      feedBackPersonPhoneNumber: // value for 'feedBackPersonPhoneNumber'
 *      feedBackComments: // value for 'feedBackComments'
 *      feedBackServiceEmail: // value for 'feedBackServiceEmail'
 *      feedBackAgainstUser: // value for 'feedBackAgainstUser'
 *      feedBackServiceUserName: // value for 'feedBackServiceUserName'
 *      fromUserId: // value for 'fromUserId'
 *      againstUserId: // value for 'againstUserId'
 *   },
 * });
 */
export function useCreatePatientFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientFeedbackMutation, CreatePatientFeedbackMutationVariables>) {
        return Apollo.useMutation<CreatePatientFeedbackMutation, CreatePatientFeedbackMutationVariables>(CreatePatientFeedbackDocument, baseOptions);
      }
export type CreatePatientFeedbackMutationHookResult = ReturnType<typeof useCreatePatientFeedbackMutation>;
export type CreatePatientFeedbackMutationResult = Apollo.MutationResult<CreatePatientFeedbackMutation>;
export type CreatePatientFeedbackMutationOptions = Apollo.BaseMutationOptions<CreatePatientFeedbackMutation, CreatePatientFeedbackMutationVariables>;
export const DeleteSlotDocument = gql`
    mutation deleteSlot($slotIds: [id]) {
  SlotRemove(id: "", slotIds: $slotIds) {
    id
  }
}
    `;
export type DeleteSlotMutationFn = Apollo.MutationFunction<DeleteSlotMutation, DeleteSlotMutationVariables>;

/**
 * __useDeleteSlotMutation__
 *
 * To run a mutation, you first call `useDeleteSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSlotMutation, { data, loading, error }] = useDeleteSlotMutation({
 *   variables: {
 *      slotIds: // value for 'slotIds'
 *   },
 * });
 */
export function useDeleteSlotMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSlotMutation, DeleteSlotMutationVariables>) {
        return Apollo.useMutation<DeleteSlotMutation, DeleteSlotMutationVariables>(DeleteSlotDocument, baseOptions);
      }
export type DeleteSlotMutationHookResult = ReturnType<typeof useDeleteSlotMutation>;
export type DeleteSlotMutationResult = Apollo.MutationResult<DeleteSlotMutation>;
export type DeleteSlotMutationOptions = Apollo.BaseMutationOptions<DeleteSlotMutation, DeleteSlotMutationVariables>;
export const ArchiveCommDocument = gql`
    mutation archiveComm($id: id!) {
  PractitionerPatientCommunicationRemove(id: $id) {
    id
  }
}
    `;
export type ArchiveCommMutationFn = Apollo.MutationFunction<ArchiveCommMutation, ArchiveCommMutationVariables>;

/**
 * __useArchiveCommMutation__
 *
 * To run a mutation, you first call `useArchiveCommMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCommMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCommMutation, { data, loading, error }] = useArchiveCommMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveCommMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCommMutation, ArchiveCommMutationVariables>) {
        return Apollo.useMutation<ArchiveCommMutation, ArchiveCommMutationVariables>(ArchiveCommDocument, baseOptions);
      }
export type ArchiveCommMutationHookResult = ReturnType<typeof useArchiveCommMutation>;
export type ArchiveCommMutationResult = Apollo.MutationResult<ArchiveCommMutation>;
export type ArchiveCommMutationOptions = Apollo.BaseMutationOptions<ArchiveCommMutation, ArchiveCommMutationVariables>;
export const UpdateFeedbackDocument = gql`
    mutation updateFeedback($id: id, $feedBackType: Int, $feedBackTypeId: String, $feedBackComments: String, $feedBackTypeName: String) {
  FeedBackUpdate(
    resource: {id: $id, resourceType: FeedBack, feedBackReplies: [{feedBackType: $feedBackType, feedBackTypeId: $feedBackTypeId, feedBackComments: $feedBackComments, feedBackTypeName: $feedBackTypeName, feedBackCreator: 1}]}
  ) {
    id
  }
}
    `;
export type UpdateFeedbackMutationFn = Apollo.MutationFunction<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>;

/**
 * __useUpdateFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackMutation, { data, loading, error }] = useUpdateFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      feedBackType: // value for 'feedBackType'
 *      feedBackTypeId: // value for 'feedBackTypeId'
 *      feedBackComments: // value for 'feedBackComments'
 *      feedBackTypeName: // value for 'feedBackTypeName'
 *   },
 * });
 */
export function useUpdateFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>) {
        return Apollo.useMutation<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>(UpdateFeedbackDocument, baseOptions);
      }
export type UpdateFeedbackMutationHookResult = ReturnType<typeof useUpdateFeedbackMutation>;
export type UpdateFeedbackMutationResult = Apollo.MutationResult<UpdateFeedbackMutation>;
export type UpdateFeedbackMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>;
export const UpdateLetterDocument = gql`
    mutation UpdateLetter($id: id, $tempData: String, $templateJsonData: String, $status: String, $gpName: String, $gpEmail: String, $adminName: String, $adminEmail: String, $adminLetter: Boolean, $notificationMessage: String, $patientName: String, $patID: String, $practID: String, $practName: String, $gpPractitionerName: String) {
  PomsPatientLetterUpdate(
    id: $id
    resource: {resourceType: PomsPatientLetter, id: $id, templateData: $tempData, templateJsonData: $templateJsonData, status: $status, gpName: $gpName, gpEmail: $gpEmail, adminName: $adminName, adminEmail: $adminEmail, adminLetter: $adminLetter, notificationMessage: $notificationMessage, patientName: $patientName, patientId: $patID, practitionerId: $practID, practitionerName: $practName, gpPractitionerName: $gpPractitionerName}
  ) {
    id
  }
}
    `;
export type UpdateLetterMutationFn = Apollo.MutationFunction<UpdateLetterMutation, UpdateLetterMutationVariables>;

/**
 * __useUpdateLetterMutation__
 *
 * To run a mutation, you first call `useUpdateLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLetterMutation, { data, loading, error }] = useUpdateLetterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tempData: // value for 'tempData'
 *      templateJsonData: // value for 'templateJsonData'
 *      status: // value for 'status'
 *      gpName: // value for 'gpName'
 *      gpEmail: // value for 'gpEmail'
 *      adminName: // value for 'adminName'
 *      adminEmail: // value for 'adminEmail'
 *      adminLetter: // value for 'adminLetter'
 *      notificationMessage: // value for 'notificationMessage'
 *      patientName: // value for 'patientName'
 *      patID: // value for 'patID'
 *      practID: // value for 'practID'
 *      practName: // value for 'practName'
 *      gpPractitionerName: // value for 'gpPractitionerName'
 *   },
 * });
 */
export function useUpdateLetterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLetterMutation, UpdateLetterMutationVariables>) {
        return Apollo.useMutation<UpdateLetterMutation, UpdateLetterMutationVariables>(UpdateLetterDocument, baseOptions);
      }
export type UpdateLetterMutationHookResult = ReturnType<typeof useUpdateLetterMutation>;
export type UpdateLetterMutationResult = Apollo.MutationResult<UpdateLetterMutation>;
export type UpdateLetterMutationOptions = Apollo.BaseMutationOptions<UpdateLetterMutation, UpdateLetterMutationVariables>;
export const UpdatePractitionerNotificationFlagDocument = gql`
    mutation updatePractitionerNotificationFlag($id: String, $isRead: Boolean, $isNotificationAll: Boolean) {
  PractitionerNotificationUpdate(
    resource: {resourceType: PractitionerNotification, practitionerId: $id, isRead: $isRead, isNotificationAll: $isNotificationAll}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerNotificationFlagMutationFn = Apollo.MutationFunction<UpdatePractitionerNotificationFlagMutation, UpdatePractitionerNotificationFlagMutationVariables>;

/**
 * __useUpdatePractitionerNotificationFlagMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerNotificationFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerNotificationFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerNotificationFlagMutation, { data, loading, error }] = useUpdatePractitionerNotificationFlagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isRead: // value for 'isRead'
 *      isNotificationAll: // value for 'isNotificationAll'
 *   },
 * });
 */
export function useUpdatePractitionerNotificationFlagMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerNotificationFlagMutation, UpdatePractitionerNotificationFlagMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerNotificationFlagMutation, UpdatePractitionerNotificationFlagMutationVariables>(UpdatePractitionerNotificationFlagDocument, baseOptions);
      }
export type UpdatePractitionerNotificationFlagMutationHookResult = ReturnType<typeof useUpdatePractitionerNotificationFlagMutation>;
export type UpdatePractitionerNotificationFlagMutationResult = Apollo.MutationResult<UpdatePractitionerNotificationFlagMutation>;
export type UpdatePractitionerNotificationFlagMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerNotificationFlagMutation, UpdatePractitionerNotificationFlagMutationVariables>;
export const CreatePractitionerSlotDocument = gql`
    mutation createPractitionerSlot($locationName: String, $color: String, $managingPractitioner: String, $breakRequired: Int, $fromDate: String, $toDate: String, $endType: Int, $endOnDate: String, $endOnAfterNoOfOccurences: Int, $weekTimings: [PomsPractitionerScheduleWeekTimings_Input], $isRepeat: Int, $repeatSelectType: Int) {
  PomsSlotCreate(
    resource: {resourceType: PomsPractitionerSchedule, locationId: "0", locationName: $locationName, color: $color, managingPractitioner: $managingPractitioner, defaultVisibility: 1, breakRequired: $breakRequired, fromDate: $fromDate, toDate: $toDate, endOnType: $endType, endOnDate: $endOnDate, endOnAfterNoOfOccurences: $endOnAfterNoOfOccurences, weekTimings: $weekTimings, isRepeat: $isRepeat, repeatSelectType: $repeatSelectType}
  ) {
    id
    message
  }
}
    `;
export type CreatePractitionerSlotMutationFn = Apollo.MutationFunction<CreatePractitionerSlotMutation, CreatePractitionerSlotMutationVariables>;

/**
 * __useCreatePractitionerSlotMutation__
 *
 * To run a mutation, you first call `useCreatePractitionerSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePractitionerSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPractitionerSlotMutation, { data, loading, error }] = useCreatePractitionerSlotMutation({
 *   variables: {
 *      locationName: // value for 'locationName'
 *      color: // value for 'color'
 *      managingPractitioner: // value for 'managingPractitioner'
 *      breakRequired: // value for 'breakRequired'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      endType: // value for 'endType'
 *      endOnDate: // value for 'endOnDate'
 *      endOnAfterNoOfOccurences: // value for 'endOnAfterNoOfOccurences'
 *      weekTimings: // value for 'weekTimings'
 *      isRepeat: // value for 'isRepeat'
 *      repeatSelectType: // value for 'repeatSelectType'
 *   },
 * });
 */
export function useCreatePractitionerSlotMutation(baseOptions?: Apollo.MutationHookOptions<CreatePractitionerSlotMutation, CreatePractitionerSlotMutationVariables>) {
        return Apollo.useMutation<CreatePractitionerSlotMutation, CreatePractitionerSlotMutationVariables>(CreatePractitionerSlotDocument, baseOptions);
      }
export type CreatePractitionerSlotMutationHookResult = ReturnType<typeof useCreatePractitionerSlotMutation>;
export type CreatePractitionerSlotMutationResult = Apollo.MutationResult<CreatePractitionerSlotMutation>;
export type CreatePractitionerSlotMutationOptions = Apollo.BaseMutationOptions<CreatePractitionerSlotMutation, CreatePractitionerSlotMutationVariables>;
export const AssignExternalQuestionnaireBuilderDocument = gql`
    mutation assignExternalQuestionnaireBuilder($patientId: String, $assignedId: String, $assignedName: String, $assignedType: String, $assignedSpeciality: String, $questionnaire: QuestionnaireBuilder_Input, $questitionerId: String, $patientName: String, $questionnaireName: String, $recipientName: String, $recipientEmail: String, $emailSubject: String, $emailBody: String) {
  ExternalPatientQuestionnaireCreate(
    resource: {resourceType: ExternalPatientQuestionnaire, patientId: $patientId, patientName: $patientName, assignedId: $assignedId, assignedName: $assignedName, assignedType: $assignedType, assignedSpeciality: $assignedSpeciality, questionnaire: $questionnaire, questitionerId: $questitionerId, questionnaireName: $questionnaireName, recipientName: $recipientName, recipientEmail: $recipientEmail, emailSubject: $emailSubject, emailBody: $emailBody}
  ) {
    id
  }
}
    `;
export type AssignExternalQuestionnaireBuilderMutationFn = Apollo.MutationFunction<AssignExternalQuestionnaireBuilderMutation, AssignExternalQuestionnaireBuilderMutationVariables>;

/**
 * __useAssignExternalQuestionnaireBuilderMutation__
 *
 * To run a mutation, you first call `useAssignExternalQuestionnaireBuilderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignExternalQuestionnaireBuilderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignExternalQuestionnaireBuilderMutation, { data, loading, error }] = useAssignExternalQuestionnaireBuilderMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      assignedId: // value for 'assignedId'
 *      assignedName: // value for 'assignedName'
 *      assignedType: // value for 'assignedType'
 *      assignedSpeciality: // value for 'assignedSpeciality'
 *      questionnaire: // value for 'questionnaire'
 *      questitionerId: // value for 'questitionerId'
 *      patientName: // value for 'patientName'
 *      questionnaireName: // value for 'questionnaireName'
 *      recipientName: // value for 'recipientName'
 *      recipientEmail: // value for 'recipientEmail'
 *      emailSubject: // value for 'emailSubject'
 *      emailBody: // value for 'emailBody'
 *   },
 * });
 */
export function useAssignExternalQuestionnaireBuilderMutation(baseOptions?: Apollo.MutationHookOptions<AssignExternalQuestionnaireBuilderMutation, AssignExternalQuestionnaireBuilderMutationVariables>) {
        return Apollo.useMutation<AssignExternalQuestionnaireBuilderMutation, AssignExternalQuestionnaireBuilderMutationVariables>(AssignExternalQuestionnaireBuilderDocument, baseOptions);
      }
export type AssignExternalQuestionnaireBuilderMutationHookResult = ReturnType<typeof useAssignExternalQuestionnaireBuilderMutation>;
export type AssignExternalQuestionnaireBuilderMutationResult = Apollo.MutationResult<AssignExternalQuestionnaireBuilderMutation>;
export type AssignExternalQuestionnaireBuilderMutationOptions = Apollo.BaseMutationOptions<AssignExternalQuestionnaireBuilderMutation, AssignExternalQuestionnaireBuilderMutationVariables>;
export const UpdatePatientContactDetailsDocument = gql`
    mutation updatePatientContactDetails($id: id, $patientBlock: PatientBlock_Input) {
  PatientBlockUpdate(
    resource: {resourceType: Patient, id: $id, patientExtension: {operationType: "BLOCK_DETAILS"}, patientBlock: $patientBlock}
  ) {
    id
  }
}
    `;
export type UpdatePatientContactDetailsMutationFn = Apollo.MutationFunction<UpdatePatientContactDetailsMutation, UpdatePatientContactDetailsMutationVariables>;

/**
 * __useUpdatePatientContactDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePatientContactDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientContactDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientContactDetailsMutation, { data, loading, error }] = useUpdatePatientContactDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patientBlock: // value for 'patientBlock'
 *   },
 * });
 */
export function useUpdatePatientContactDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientContactDetailsMutation, UpdatePatientContactDetailsMutationVariables>) {
        return Apollo.useMutation<UpdatePatientContactDetailsMutation, UpdatePatientContactDetailsMutationVariables>(UpdatePatientContactDetailsDocument, baseOptions);
      }
export type UpdatePatientContactDetailsMutationHookResult = ReturnType<typeof useUpdatePatientContactDetailsMutation>;
export type UpdatePatientContactDetailsMutationResult = Apollo.MutationResult<UpdatePatientContactDetailsMutation>;
export type UpdatePatientContactDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePatientContactDetailsMutation, UpdatePatientContactDetailsMutationVariables>;
export const UpdatePomsAppointmentUpdateVideoTokenDocument = gql`
    mutation updatePomsAppointmentUpdateVideoToken($id: id) {
  PomsAppointmentUpdate(
    id: $id
    resource: {resourceType: PomsAppointment, appointmentStatusType: 1, appointmentStatus: "VideoToken", id: $id}
  ) {
    id
  }
}
    `;
export type UpdatePomsAppointmentUpdateVideoTokenMutationFn = Apollo.MutationFunction<UpdatePomsAppointmentUpdateVideoTokenMutation, UpdatePomsAppointmentUpdateVideoTokenMutationVariables>;

/**
 * __useUpdatePomsAppointmentUpdateVideoTokenMutation__
 *
 * To run a mutation, you first call `useUpdatePomsAppointmentUpdateVideoTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePomsAppointmentUpdateVideoTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePomsAppointmentUpdateVideoTokenMutation, { data, loading, error }] = useUpdatePomsAppointmentUpdateVideoTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatePomsAppointmentUpdateVideoTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePomsAppointmentUpdateVideoTokenMutation, UpdatePomsAppointmentUpdateVideoTokenMutationVariables>) {
        return Apollo.useMutation<UpdatePomsAppointmentUpdateVideoTokenMutation, UpdatePomsAppointmentUpdateVideoTokenMutationVariables>(UpdatePomsAppointmentUpdateVideoTokenDocument, baseOptions);
      }
export type UpdatePomsAppointmentUpdateVideoTokenMutationHookResult = ReturnType<typeof useUpdatePomsAppointmentUpdateVideoTokenMutation>;
export type UpdatePomsAppointmentUpdateVideoTokenMutationResult = Apollo.MutationResult<UpdatePomsAppointmentUpdateVideoTokenMutation>;
export type UpdatePomsAppointmentUpdateVideoTokenMutationOptions = Apollo.BaseMutationOptions<UpdatePomsAppointmentUpdateVideoTokenMutation, UpdatePomsAppointmentUpdateVideoTokenMutationVariables>;
export const UpdatePatientContactDetailsSecondaryDocument = gql`
    mutation updatePatientContactDetailsSecondary($id: id, $patientDisorder: PatientDisorder_Input, $patientSecondaryDisorder: [String]) {
  PatientDisorderUpdate(
    resource: {resourceType: Patient, id: $id, patientExtension: {operationType: "DISORDER_DETAILS"}, patientDisorder: $patientDisorder, patientSecondaryDisorder: $patientSecondaryDisorder}
  ) {
    id
  }
}
    `;
export type UpdatePatientContactDetailsSecondaryMutationFn = Apollo.MutationFunction<UpdatePatientContactDetailsSecondaryMutation, UpdatePatientContactDetailsSecondaryMutationVariables>;

/**
 * __useUpdatePatientContactDetailsSecondaryMutation__
 *
 * To run a mutation, you first call `useUpdatePatientContactDetailsSecondaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientContactDetailsSecondaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientContactDetailsSecondaryMutation, { data, loading, error }] = useUpdatePatientContactDetailsSecondaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patientDisorder: // value for 'patientDisorder'
 *      patientSecondaryDisorder: // value for 'patientSecondaryDisorder'
 *   },
 * });
 */
export function useUpdatePatientContactDetailsSecondaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientContactDetailsSecondaryMutation, UpdatePatientContactDetailsSecondaryMutationVariables>) {
        return Apollo.useMutation<UpdatePatientContactDetailsSecondaryMutation, UpdatePatientContactDetailsSecondaryMutationVariables>(UpdatePatientContactDetailsSecondaryDocument, baseOptions);
      }
export type UpdatePatientContactDetailsSecondaryMutationHookResult = ReturnType<typeof useUpdatePatientContactDetailsSecondaryMutation>;
export type UpdatePatientContactDetailsSecondaryMutationResult = Apollo.MutationResult<UpdatePatientContactDetailsSecondaryMutation>;
export type UpdatePatientContactDetailsSecondaryMutationOptions = Apollo.BaseMutationOptions<UpdatePatientContactDetailsSecondaryMutation, UpdatePatientContactDetailsSecondaryMutationVariables>;
export const UpdatePractitionerCongtractFilePathDocument = gql`
    mutation updatePractitionerCongtractFilePath($id: String, $contractFilePath: String) {
  PomsPractitionerContractFile(
    resource: {resourceType: PomsPractitionerAgreement, managingPractitioner: $id, contractFilePath: $contractFilePath}
  ) {
    id
  }
}
    `;
export type UpdatePractitionerCongtractFilePathMutationFn = Apollo.MutationFunction<UpdatePractitionerCongtractFilePathMutation, UpdatePractitionerCongtractFilePathMutationVariables>;

/**
 * __useUpdatePractitionerCongtractFilePathMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerCongtractFilePathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerCongtractFilePathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerCongtractFilePathMutation, { data, loading, error }] = useUpdatePractitionerCongtractFilePathMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contractFilePath: // value for 'contractFilePath'
 *   },
 * });
 */
export function useUpdatePractitionerCongtractFilePathMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePractitionerCongtractFilePathMutation, UpdatePractitionerCongtractFilePathMutationVariables>) {
        return Apollo.useMutation<UpdatePractitionerCongtractFilePathMutation, UpdatePractitionerCongtractFilePathMutationVariables>(UpdatePractitionerCongtractFilePathDocument, baseOptions);
      }
export type UpdatePractitionerCongtractFilePathMutationHookResult = ReturnType<typeof useUpdatePractitionerCongtractFilePathMutation>;
export type UpdatePractitionerCongtractFilePathMutationResult = Apollo.MutationResult<UpdatePractitionerCongtractFilePathMutation>;
export type UpdatePractitionerCongtractFilePathMutationOptions = Apollo.BaseMutationOptions<UpdatePractitionerCongtractFilePathMutation, UpdatePractitionerCongtractFilePathMutationVariables>;
export const CrisisSafeguardCreateDocument = gql`
    mutation CrisisSafeguardCreate($patID: String!, $practID: String!, $practName: String!, $templateName: String!, $tempMode: String!, $tempType: String!, $tempData: String!, $patientName: String, $templateJsonData: String, $status: String, $notificationMessage: String, $name: String, $email: String, $gpName: String, $gpEmail: String) {
  CrisisSafeguardCreate(
    resource: {resourceType: CrisisSafeguard, name: $name, email: $email, patientId: $patID, practitionerId: $practID, practitionerName: $practName, practitionerSpeciality: "", templateName: $templateName, templateMode: $tempMode, templateType: $tempType, templateData: $tempData, patientName: $patientName, templateJsonData: $templateJsonData, status: $status, notificationMessage: $notificationMessage, gpName: $gpName, gpEmail: $gpEmail}
  ) {
    id
  }
}
    `;
export type CrisisSafeguardCreateMutationFn = Apollo.MutationFunction<CrisisSafeguardCreateMutation, CrisisSafeguardCreateMutationVariables>;

/**
 * __useCrisisSafeguardCreateMutation__
 *
 * To run a mutation, you first call `useCrisisSafeguardCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrisisSafeguardCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crisisSafeguardCreateMutation, { data, loading, error }] = useCrisisSafeguardCreateMutation({
 *   variables: {
 *      patID: // value for 'patID'
 *      practID: // value for 'practID'
 *      practName: // value for 'practName'
 *      templateName: // value for 'templateName'
 *      tempMode: // value for 'tempMode'
 *      tempType: // value for 'tempType'
 *      tempData: // value for 'tempData'
 *      patientName: // value for 'patientName'
 *      templateJsonData: // value for 'templateJsonData'
 *      status: // value for 'status'
 *      notificationMessage: // value for 'notificationMessage'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      gpName: // value for 'gpName'
 *      gpEmail: // value for 'gpEmail'
 *   },
 * });
 */
export function useCrisisSafeguardCreateMutation(baseOptions?: Apollo.MutationHookOptions<CrisisSafeguardCreateMutation, CrisisSafeguardCreateMutationVariables>) {
        return Apollo.useMutation<CrisisSafeguardCreateMutation, CrisisSafeguardCreateMutationVariables>(CrisisSafeguardCreateDocument, baseOptions);
      }
export type CrisisSafeguardCreateMutationHookResult = ReturnType<typeof useCrisisSafeguardCreateMutation>;
export type CrisisSafeguardCreateMutationResult = Apollo.MutationResult<CrisisSafeguardCreateMutation>;
export type CrisisSafeguardCreateMutationOptions = Apollo.BaseMutationOptions<CrisisSafeguardCreateMutation, CrisisSafeguardCreateMutationVariables>;
export const CrisisSafeguardvRemoveDocument = gql`
    mutation CrisisSafeguardvRemove($id: id!) {
  CrisisSafeguardvRemove(id: $id) {
    id
  }
}
    `;
export type CrisisSafeguardvRemoveMutationFn = Apollo.MutationFunction<CrisisSafeguardvRemoveMutation, CrisisSafeguardvRemoveMutationVariables>;

/**
 * __useCrisisSafeguardvRemoveMutation__
 *
 * To run a mutation, you first call `useCrisisSafeguardvRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrisisSafeguardvRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crisisSafeguardvRemoveMutation, { data, loading, error }] = useCrisisSafeguardvRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCrisisSafeguardvRemoveMutation(baseOptions?: Apollo.MutationHookOptions<CrisisSafeguardvRemoveMutation, CrisisSafeguardvRemoveMutationVariables>) {
        return Apollo.useMutation<CrisisSafeguardvRemoveMutation, CrisisSafeguardvRemoveMutationVariables>(CrisisSafeguardvRemoveDocument, baseOptions);
      }
export type CrisisSafeguardvRemoveMutationHookResult = ReturnType<typeof useCrisisSafeguardvRemoveMutation>;
export type CrisisSafeguardvRemoveMutationResult = Apollo.MutationResult<CrisisSafeguardvRemoveMutation>;
export type CrisisSafeguardvRemoveMutationOptions = Apollo.BaseMutationOptions<CrisisSafeguardvRemoveMutation, CrisisSafeguardvRemoveMutationVariables>;
export const CrisisSafeguardUpdateDocument = gql`
    mutation CrisisSafeguardUpdate($id: id, $patID: String!, $practID: String!, $practName: String!, $templateName: String!, $tempMode: String!, $tempType: String!, $tempData: String!, $patientName: String, $templateJsonData: String, $status: String, $notificationMessage: String, $name: String, $email: String, $gpName: String, $gpEmail: String) {
  CrisisSafeguardUpdate(
    resource: {resourceType: CrisisSafeguard, id: $id, name: $name, email: $email, patientId: $patID, practitionerId: $practID, practitionerName: $practName, practitionerSpeciality: "", templateName: $templateName, templateMode: $tempMode, templateType: $tempType, templateData: $tempData, patientName: $patientName, templateJsonData: $templateJsonData, status: $status, notificationMessage: $notificationMessage, gpName: $gpName, gpEmail: $gpEmail}
  ) {
    id
  }
}
    `;
export type CrisisSafeguardUpdateMutationFn = Apollo.MutationFunction<CrisisSafeguardUpdateMutation, CrisisSafeguardUpdateMutationVariables>;

/**
 * __useCrisisSafeguardUpdateMutation__
 *
 * To run a mutation, you first call `useCrisisSafeguardUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrisisSafeguardUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crisisSafeguardUpdateMutation, { data, loading, error }] = useCrisisSafeguardUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patID: // value for 'patID'
 *      practID: // value for 'practID'
 *      practName: // value for 'practName'
 *      templateName: // value for 'templateName'
 *      tempMode: // value for 'tempMode'
 *      tempType: // value for 'tempType'
 *      tempData: // value for 'tempData'
 *      patientName: // value for 'patientName'
 *      templateJsonData: // value for 'templateJsonData'
 *      status: // value for 'status'
 *      notificationMessage: // value for 'notificationMessage'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      gpName: // value for 'gpName'
 *      gpEmail: // value for 'gpEmail'
 *   },
 * });
 */
export function useCrisisSafeguardUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CrisisSafeguardUpdateMutation, CrisisSafeguardUpdateMutationVariables>) {
        return Apollo.useMutation<CrisisSafeguardUpdateMutation, CrisisSafeguardUpdateMutationVariables>(CrisisSafeguardUpdateDocument, baseOptions);
      }
export type CrisisSafeguardUpdateMutationHookResult = ReturnType<typeof useCrisisSafeguardUpdateMutation>;
export type CrisisSafeguardUpdateMutationResult = Apollo.MutationResult<CrisisSafeguardUpdateMutation>;
export type CrisisSafeguardUpdateMutationOptions = Apollo.BaseMutationOptions<CrisisSafeguardUpdateMutation, CrisisSafeguardUpdateMutationVariables>;
export const CreateSignPostingDocument = gql`
    mutation createSignPosting($organizationName: String, $organizationEmail: String, $organizationPhoneNo: String, $organizationWebsite: String, $organizationImageUrl: String, $organizationCategory: [String], $organizationSearchtag: [String], $organizationDescription: String, $uploadedBy: String, $uploadedDate: String, $uploadedUserName: String) {
  SignPostingCreate(
    resource: {resourceType: SignPosting, organizationName: $organizationName, organizationEmail: $organizationEmail, organizationPhoneNo: $organizationPhoneNo, organizationWebsite: $organizationWebsite, organizationImageUrl: $organizationImageUrl, organizationCategory: $organizationCategory, organizationSearchtag: $organizationSearchtag, organizationDescription: $organizationDescription, uploadedBy: $uploadedBy, uploadedDate: $uploadedDate, uploadedUserName: $uploadedUserName}
  ) {
    id
  }
}
    `;
export type CreateSignPostingMutationFn = Apollo.MutationFunction<CreateSignPostingMutation, CreateSignPostingMutationVariables>;

/**
 * __useCreateSignPostingMutation__
 *
 * To run a mutation, you first call `useCreateSignPostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignPostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignPostingMutation, { data, loading, error }] = useCreateSignPostingMutation({
 *   variables: {
 *      organizationName: // value for 'organizationName'
 *      organizationEmail: // value for 'organizationEmail'
 *      organizationPhoneNo: // value for 'organizationPhoneNo'
 *      organizationWebsite: // value for 'organizationWebsite'
 *      organizationImageUrl: // value for 'organizationImageUrl'
 *      organizationCategory: // value for 'organizationCategory'
 *      organizationSearchtag: // value for 'organizationSearchtag'
 *      organizationDescription: // value for 'organizationDescription'
 *      uploadedBy: // value for 'uploadedBy'
 *      uploadedDate: // value for 'uploadedDate'
 *      uploadedUserName: // value for 'uploadedUserName'
 *   },
 * });
 */
export function useCreateSignPostingMutation(baseOptions?: Apollo.MutationHookOptions<CreateSignPostingMutation, CreateSignPostingMutationVariables>) {
        return Apollo.useMutation<CreateSignPostingMutation, CreateSignPostingMutationVariables>(CreateSignPostingDocument, baseOptions);
      }
export type CreateSignPostingMutationHookResult = ReturnType<typeof useCreateSignPostingMutation>;
export type CreateSignPostingMutationResult = Apollo.MutationResult<CreateSignPostingMutation>;
export type CreateSignPostingMutationOptions = Apollo.BaseMutationOptions<CreateSignPostingMutation, CreateSignPostingMutationVariables>;
export const CreateLeafletDocument = gql`
    mutation createLeaflet($leafletName: String, $leafletDescription: String, $lefaletDocumentUrl: String, $leafletSearchtag: [String], $uploadedBy: String, $uploadedDate: String, $uploadedUserName: String) {
  LeafletCreate(
    resource: {resourceType: Leaflet, leafletName: $leafletName, leafletDescription: $leafletDescription, lefaletDocumentUrl: $lefaletDocumentUrl, leafletSearchtag: $leafletSearchtag, uploadedBy: $uploadedBy, uploadedDate: $uploadedDate, uploadedUserName: $uploadedUserName}
  ) {
    id
  }
}
    `;
export type CreateLeafletMutationFn = Apollo.MutationFunction<CreateLeafletMutation, CreateLeafletMutationVariables>;

/**
 * __useCreateLeafletMutation__
 *
 * To run a mutation, you first call `useCreateLeafletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeafletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeafletMutation, { data, loading, error }] = useCreateLeafletMutation({
 *   variables: {
 *      leafletName: // value for 'leafletName'
 *      leafletDescription: // value for 'leafletDescription'
 *      lefaletDocumentUrl: // value for 'lefaletDocumentUrl'
 *      leafletSearchtag: // value for 'leafletSearchtag'
 *      uploadedBy: // value for 'uploadedBy'
 *      uploadedDate: // value for 'uploadedDate'
 *      uploadedUserName: // value for 'uploadedUserName'
 *   },
 * });
 */
export function useCreateLeafletMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeafletMutation, CreateLeafletMutationVariables>) {
        return Apollo.useMutation<CreateLeafletMutation, CreateLeafletMutationVariables>(CreateLeafletDocument, baseOptions);
      }
export type CreateLeafletMutationHookResult = ReturnType<typeof useCreateLeafletMutation>;
export type CreateLeafletMutationResult = Apollo.MutationResult<CreateLeafletMutation>;
export type CreateLeafletMutationOptions = Apollo.BaseMutationOptions<CreateLeafletMutation, CreateLeafletMutationVariables>;
export const UpdateLeafletDocument = gql`
    mutation updateLeaflet($leafletName: String, $leafletDescription: String, $lefaletDocumentUrl: String, $leafletSearchtag: [String], $uploadedBy: String, $uploadedDate: String, $uploadedUserName: String, $id: id) {
  LeafletUpdate(
    resource: {resourceType: Leaflet, leafletName: $leafletName, leafletDescription: $leafletDescription, lefaletDocumentUrl: $lefaletDocumentUrl, leafletSearchtag: $leafletSearchtag, uploadedBy: $uploadedBy, uploadedDate: $uploadedDate, uploadedUserName: $uploadedUserName, id: $id}
  ) {
    id
  }
}
    `;
export type UpdateLeafletMutationFn = Apollo.MutationFunction<UpdateLeafletMutation, UpdateLeafletMutationVariables>;

/**
 * __useUpdateLeafletMutation__
 *
 * To run a mutation, you first call `useUpdateLeafletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeafletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeafletMutation, { data, loading, error }] = useUpdateLeafletMutation({
 *   variables: {
 *      leafletName: // value for 'leafletName'
 *      leafletDescription: // value for 'leafletDescription'
 *      lefaletDocumentUrl: // value for 'lefaletDocumentUrl'
 *      leafletSearchtag: // value for 'leafletSearchtag'
 *      uploadedBy: // value for 'uploadedBy'
 *      uploadedDate: // value for 'uploadedDate'
 *      uploadedUserName: // value for 'uploadedUserName'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLeafletMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeafletMutation, UpdateLeafletMutationVariables>) {
        return Apollo.useMutation<UpdateLeafletMutation, UpdateLeafletMutationVariables>(UpdateLeafletDocument, baseOptions);
      }
export type UpdateLeafletMutationHookResult = ReturnType<typeof useUpdateLeafletMutation>;
export type UpdateLeafletMutationResult = Apollo.MutationResult<UpdateLeafletMutation>;
export type UpdateLeafletMutationOptions = Apollo.BaseMutationOptions<UpdateLeafletMutation, UpdateLeafletMutationVariables>;
export const LeafletRemoveDocument = gql`
    mutation leafletRemove($id: id!) {
  LeafletRemove(id: $id) {
    id
  }
}
    `;
export type LeafletRemoveMutationFn = Apollo.MutationFunction<LeafletRemoveMutation, LeafletRemoveMutationVariables>;

/**
 * __useLeafletRemoveMutation__
 *
 * To run a mutation, you first call `useLeafletRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeafletRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leafletRemoveMutation, { data, loading, error }] = useLeafletRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeafletRemoveMutation(baseOptions?: Apollo.MutationHookOptions<LeafletRemoveMutation, LeafletRemoveMutationVariables>) {
        return Apollo.useMutation<LeafletRemoveMutation, LeafletRemoveMutationVariables>(LeafletRemoveDocument, baseOptions);
      }
export type LeafletRemoveMutationHookResult = ReturnType<typeof useLeafletRemoveMutation>;
export type LeafletRemoveMutationResult = Apollo.MutationResult<LeafletRemoveMutation>;
export type LeafletRemoveMutationOptions = Apollo.BaseMutationOptions<LeafletRemoveMutation, LeafletRemoveMutationVariables>;
export const UpdateSignPostingDocument = gql`
    mutation updateSignPosting($organizationWebsite: String, $organizationName: String, $organizationCategory: [String], $organizationSearchtag: [String], $organizationDescription: String, $uploadedBy: String, $uploadedDate: String, $uploadedUserName: String, $organizationImageUrl: String, $id: id) {
  SignPostingUpdate(
    resource: {resourceType: SignPosting, organizationWebsite: $organizationWebsite, organizationName: $organizationName, organizationCategory: $organizationCategory, organizationSearchtag: $organizationSearchtag, organizationDescription: $organizationDescription, uploadedBy: $uploadedBy, uploadedDate: $uploadedDate, uploadedUserName: $uploadedUserName, organizationImageUrl: $organizationImageUrl, id: $id}
  ) {
    id
  }
}
    `;
export type UpdateSignPostingMutationFn = Apollo.MutationFunction<UpdateSignPostingMutation, UpdateSignPostingMutationVariables>;

/**
 * __useUpdateSignPostingMutation__
 *
 * To run a mutation, you first call `useUpdateSignPostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignPostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignPostingMutation, { data, loading, error }] = useUpdateSignPostingMutation({
 *   variables: {
 *      organizationWebsite: // value for 'organizationWebsite'
 *      organizationName: // value for 'organizationName'
 *      organizationCategory: // value for 'organizationCategory'
 *      organizationSearchtag: // value for 'organizationSearchtag'
 *      organizationDescription: // value for 'organizationDescription'
 *      uploadedBy: // value for 'uploadedBy'
 *      uploadedDate: // value for 'uploadedDate'
 *      uploadedUserName: // value for 'uploadedUserName'
 *      organizationImageUrl: // value for 'organizationImageUrl'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateSignPostingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSignPostingMutation, UpdateSignPostingMutationVariables>) {
        return Apollo.useMutation<UpdateSignPostingMutation, UpdateSignPostingMutationVariables>(UpdateSignPostingDocument, baseOptions);
      }
export type UpdateSignPostingMutationHookResult = ReturnType<typeof useUpdateSignPostingMutation>;
export type UpdateSignPostingMutationResult = Apollo.MutationResult<UpdateSignPostingMutation>;
export type UpdateSignPostingMutationOptions = Apollo.BaseMutationOptions<UpdateSignPostingMutation, UpdateSignPostingMutationVariables>;
export const SignPostingRemoveDocument = gql`
    mutation signPostingRemove($id: id!) {
  SignPostingRemove(id: $id) {
    id
  }
}
    `;
export type SignPostingRemoveMutationFn = Apollo.MutationFunction<SignPostingRemoveMutation, SignPostingRemoveMutationVariables>;

/**
 * __useSignPostingRemoveMutation__
 *
 * To run a mutation, you first call `useSignPostingRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignPostingRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signPostingRemoveMutation, { data, loading, error }] = useSignPostingRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignPostingRemoveMutation(baseOptions?: Apollo.MutationHookOptions<SignPostingRemoveMutation, SignPostingRemoveMutationVariables>) {
        return Apollo.useMutation<SignPostingRemoveMutation, SignPostingRemoveMutationVariables>(SignPostingRemoveDocument, baseOptions);
      }
export type SignPostingRemoveMutationHookResult = ReturnType<typeof useSignPostingRemoveMutation>;
export type SignPostingRemoveMutationResult = Apollo.MutationResult<SignPostingRemoveMutation>;
export type SignPostingRemoveMutationOptions = Apollo.BaseMutationOptions<SignPostingRemoveMutation, SignPostingRemoveMutationVariables>;
export const ShareDocumentDocument = gql`
    mutation shareDocument($selectedDocuments: [String], $recipientEmails: [String], $patientId: String, $sendById: String, $sendByName: String, $sendByUserType: String, $patientName: String) {
  ShareDocument(
    resource: {selectedDocuments: $selectedDocuments, recipientEmails: $recipientEmails, patientId: $patientId, sendById: $sendById, sendByName: $sendByName, sendByUserType: $sendByUserType, patientName: $patientName}
  ) {
    id
  }
}
    `;
export type ShareDocumentMutationFn = Apollo.MutationFunction<ShareDocumentMutation, ShareDocumentMutationVariables>;

/**
 * __useShareDocumentMutation__
 *
 * To run a mutation, you first call `useShareDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDocumentMutation, { data, loading, error }] = useShareDocumentMutation({
 *   variables: {
 *      selectedDocuments: // value for 'selectedDocuments'
 *      recipientEmails: // value for 'recipientEmails'
 *      patientId: // value for 'patientId'
 *      sendById: // value for 'sendById'
 *      sendByName: // value for 'sendByName'
 *      sendByUserType: // value for 'sendByUserType'
 *      patientName: // value for 'patientName'
 *   },
 * });
 */
export function useShareDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ShareDocumentMutation, ShareDocumentMutationVariables>) {
        return Apollo.useMutation<ShareDocumentMutation, ShareDocumentMutationVariables>(ShareDocumentDocument, baseOptions);
      }
export type ShareDocumentMutationHookResult = ReturnType<typeof useShareDocumentMutation>;
export type ShareDocumentMutationResult = Apollo.MutationResult<ShareDocumentMutation>;
export type ShareDocumentMutationOptions = Apollo.BaseMutationOptions<ShareDocumentMutation, ShareDocumentMutationVariables>;
export const TaskManagerCreateDocument = gql`
    mutation TaskManagerCreate($task_name: String, $task_type: String) {
  TaskManagerCreate(
    resource: {resourceType: TaskManager, task_name: $task_name, task_type: $task_type}
  ) {
    id
  }
}
    `;
export type TaskManagerCreateMutationFn = Apollo.MutationFunction<TaskManagerCreateMutation, TaskManagerCreateMutationVariables>;

/**
 * __useTaskManagerCreateMutation__
 *
 * To run a mutation, you first call `useTaskManagerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskManagerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskManagerCreateMutation, { data, loading, error }] = useTaskManagerCreateMutation({
 *   variables: {
 *      task_name: // value for 'task_name'
 *      task_type: // value for 'task_type'
 *   },
 * });
 */
export function useTaskManagerCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaskManagerCreateMutation, TaskManagerCreateMutationVariables>) {
        return Apollo.useMutation<TaskManagerCreateMutation, TaskManagerCreateMutationVariables>(TaskManagerCreateDocument, baseOptions);
      }
export type TaskManagerCreateMutationHookResult = ReturnType<typeof useTaskManagerCreateMutation>;
export type TaskManagerCreateMutationResult = Apollo.MutationResult<TaskManagerCreateMutation>;
export type TaskManagerCreateMutationOptions = Apollo.BaseMutationOptions<TaskManagerCreateMutation, TaskManagerCreateMutationVariables>;
export const TaskManagerUpdateDocument = gql`
    mutation TaskManagerUpdate($task_name: String, $id: id) {
  TaskManagerUpdate(
    resource: {resourceType: TaskManager, task_name: $task_name, id: $id}
  ) {
    message
  }
}
    `;
export type TaskManagerUpdateMutationFn = Apollo.MutationFunction<TaskManagerUpdateMutation, TaskManagerUpdateMutationVariables>;

/**
 * __useTaskManagerUpdateMutation__
 *
 * To run a mutation, you first call `useTaskManagerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskManagerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskManagerUpdateMutation, { data, loading, error }] = useTaskManagerUpdateMutation({
 *   variables: {
 *      task_name: // value for 'task_name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskManagerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaskManagerUpdateMutation, TaskManagerUpdateMutationVariables>) {
        return Apollo.useMutation<TaskManagerUpdateMutation, TaskManagerUpdateMutationVariables>(TaskManagerUpdateDocument, baseOptions);
      }
export type TaskManagerUpdateMutationHookResult = ReturnType<typeof useTaskManagerUpdateMutation>;
export type TaskManagerUpdateMutationResult = Apollo.MutationResult<TaskManagerUpdateMutation>;
export type TaskManagerUpdateMutationOptions = Apollo.BaseMutationOptions<TaskManagerUpdateMutation, TaskManagerUpdateMutationVariables>;
export const TaskManagerRemoveDocument = gql`
    mutation TaskManagerRemove($id: id!) {
  TaskManagerRemove(id: $id) {
    message
  }
}
    `;
export type TaskManagerRemoveMutationFn = Apollo.MutationFunction<TaskManagerRemoveMutation, TaskManagerRemoveMutationVariables>;

/**
 * __useTaskManagerRemoveMutation__
 *
 * To run a mutation, you first call `useTaskManagerRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskManagerRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskManagerRemoveMutation, { data, loading, error }] = useTaskManagerRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskManagerRemoveMutation(baseOptions?: Apollo.MutationHookOptions<TaskManagerRemoveMutation, TaskManagerRemoveMutationVariables>) {
        return Apollo.useMutation<TaskManagerRemoveMutation, TaskManagerRemoveMutationVariables>(TaskManagerRemoveDocument, baseOptions);
      }
export type TaskManagerRemoveMutationHookResult = ReturnType<typeof useTaskManagerRemoveMutation>;
export type TaskManagerRemoveMutationResult = Apollo.MutationResult<TaskManagerRemoveMutation>;
export type TaskManagerRemoveMutationOptions = Apollo.BaseMutationOptions<TaskManagerRemoveMutation, TaskManagerRemoveMutationVariables>;
export const TaskAssignDocument = gql`
    mutation TaskAssign($assigner_type: String, $assigner_id: String, $assignee_type: String, $assignee_id: String, $task_category_id: id, $additional_notes: String, $priority: String, $assignee_email: String, $attachment: String, $patient_id: String, $due_date: String, $task_for: String) {
  TaskAssign(
    resource: {resourceType: TaskManager, assigner_type: $assigner_type, assigner_id: $assigner_id, assignee_type: $assignee_type, assignee_id: $assignee_id, task_category_id: $task_category_id, additional_notes: $additional_notes, priority: $priority, assignee_email: $assignee_email, attachment: $attachment, patient_id: $patient_id, due_date: $due_date, task_for: $task_for}
  ) {
    message
  }
}
    `;
export type TaskAssignMutationFn = Apollo.MutationFunction<TaskAssignMutation, TaskAssignMutationVariables>;

/**
 * __useTaskAssignMutation__
 *
 * To run a mutation, you first call `useTaskAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskAssignMutation, { data, loading, error }] = useTaskAssignMutation({
 *   variables: {
 *      assigner_type: // value for 'assigner_type'
 *      assigner_id: // value for 'assigner_id'
 *      assignee_type: // value for 'assignee_type'
 *      assignee_id: // value for 'assignee_id'
 *      task_category_id: // value for 'task_category_id'
 *      additional_notes: // value for 'additional_notes'
 *      priority: // value for 'priority'
 *      assignee_email: // value for 'assignee_email'
 *      attachment: // value for 'attachment'
 *      patient_id: // value for 'patient_id'
 *      due_date: // value for 'due_date'
 *      task_for: // value for 'task_for'
 *   },
 * });
 */
export function useTaskAssignMutation(baseOptions?: Apollo.MutationHookOptions<TaskAssignMutation, TaskAssignMutationVariables>) {
        return Apollo.useMutation<TaskAssignMutation, TaskAssignMutationVariables>(TaskAssignDocument, baseOptions);
      }
export type TaskAssignMutationHookResult = ReturnType<typeof useTaskAssignMutation>;
export type TaskAssignMutationResult = Apollo.MutationResult<TaskAssignMutation>;
export type TaskAssignMutationOptions = Apollo.BaseMutationOptions<TaskAssignMutation, TaskAssignMutationVariables>;
export const CompleteAssignTaskDocument = gql`
    mutation CompleteAssignTask($assignment_ids: [String], $completion_note: String) {
  CompleteAssignTask(
    resource: {resourceType: TaskManager, assignment_ids: $assignment_ids, completion_note: $completion_note}
  ) {
    message
  }
}
    `;
export type CompleteAssignTaskMutationFn = Apollo.MutationFunction<CompleteAssignTaskMutation, CompleteAssignTaskMutationVariables>;

/**
 * __useCompleteAssignTaskMutation__
 *
 * To run a mutation, you first call `useCompleteAssignTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAssignTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAssignTaskMutation, { data, loading, error }] = useCompleteAssignTaskMutation({
 *   variables: {
 *      assignment_ids: // value for 'assignment_ids'
 *      completion_note: // value for 'completion_note'
 *   },
 * });
 */
export function useCompleteAssignTaskMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAssignTaskMutation, CompleteAssignTaskMutationVariables>) {
        return Apollo.useMutation<CompleteAssignTaskMutation, CompleteAssignTaskMutationVariables>(CompleteAssignTaskDocument, baseOptions);
      }
export type CompleteAssignTaskMutationHookResult = ReturnType<typeof useCompleteAssignTaskMutation>;
export type CompleteAssignTaskMutationResult = Apollo.MutationResult<CompleteAssignTaskMutation>;
export type CompleteAssignTaskMutationOptions = Apollo.BaseMutationOptions<CompleteAssignTaskMutation, CompleteAssignTaskMutationVariables>;
export const GetPractitionerPersonalDetailsDocument = gql`
    query getPractitionerPersonalDetails($id: token) {
  Practitioner(_id: $id) {
    name {
      use
      family
      given
      prefix
    }
    fullName
    gender
    nationality
    birthDate
    communication {
      coding {
        system
        code
        display
      }
    }
    communicationUpdated
    communicationStatus
  }
}
    `;

/**
 * __useGetPractitionerPersonalDetailsQuery__
 *
 * To run a query within a React component, call `useGetPractitionerPersonalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerPersonalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerPersonalDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerPersonalDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerPersonalDetailsQuery, GetPractitionerPersonalDetailsQueryVariables>) {
        return Apollo.useQuery<GetPractitionerPersonalDetailsQuery, GetPractitionerPersonalDetailsQueryVariables>(GetPractitionerPersonalDetailsDocument, baseOptions);
      }
export function useGetPractitionerPersonalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerPersonalDetailsQuery, GetPractitionerPersonalDetailsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerPersonalDetailsQuery, GetPractitionerPersonalDetailsQueryVariables>(GetPractitionerPersonalDetailsDocument, baseOptions);
        }
export type GetPractitionerPersonalDetailsQueryHookResult = ReturnType<typeof useGetPractitionerPersonalDetailsQuery>;
export type GetPractitionerPersonalDetailsLazyQueryHookResult = ReturnType<typeof useGetPractitionerPersonalDetailsLazyQuery>;
export type GetPractitionerPersonalDetailsQueryResult = Apollo.QueryResult<GetPractitionerPersonalDetailsQuery, GetPractitionerPersonalDetailsQueryVariables>;
export const GetPractitionerAboutDocument = gql`
    query getPractitionerAbout($id: token) {
  Practitioner(_id: $id) {
    practionerAbout {
      about
      personalStatement
      videourl
      profileTags
    }
    photo {
      title
      url
    }
  }
}
    `;

/**
 * __useGetPractitionerAboutQuery__
 *
 * To run a query within a React component, call `useGetPractitionerAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerAboutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerAboutQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerAboutQuery, GetPractitionerAboutQueryVariables>) {
        return Apollo.useQuery<GetPractitionerAboutQuery, GetPractitionerAboutQueryVariables>(GetPractitionerAboutDocument, baseOptions);
      }
export function useGetPractitionerAboutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerAboutQuery, GetPractitionerAboutQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerAboutQuery, GetPractitionerAboutQueryVariables>(GetPractitionerAboutDocument, baseOptions);
        }
export type GetPractitionerAboutQueryHookResult = ReturnType<typeof useGetPractitionerAboutQuery>;
export type GetPractitionerAboutLazyQueryHookResult = ReturnType<typeof useGetPractitionerAboutLazyQuery>;
export type GetPractitionerAboutQueryResult = Apollo.QueryResult<GetPractitionerAboutQuery, GetPractitionerAboutQueryVariables>;
export const GetPractitionerContactDetailsDocument = gql`
    query getPractitionerContactDetails($id: token) {
  Practitioner(_id: $id) {
    address {
      line
      city
      state
      country
      postalCode
    }
    telecom {
      system
      value
      use
      rank
    }
    emergencyContact {
      fullname
      realtionship
      email
      mobile
    }
  }
}
    `;

/**
 * __useGetPractitionerContactDetailsQuery__
 *
 * To run a query within a React component, call `useGetPractitionerContactDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerContactDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerContactDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerContactDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerContactDetailsQuery, GetPractitionerContactDetailsQueryVariables>) {
        return Apollo.useQuery<GetPractitionerContactDetailsQuery, GetPractitionerContactDetailsQueryVariables>(GetPractitionerContactDetailsDocument, baseOptions);
      }
export function useGetPractitionerContactDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerContactDetailsQuery, GetPractitionerContactDetailsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerContactDetailsQuery, GetPractitionerContactDetailsQueryVariables>(GetPractitionerContactDetailsDocument, baseOptions);
        }
export type GetPractitionerContactDetailsQueryHookResult = ReturnType<typeof useGetPractitionerContactDetailsQuery>;
export type GetPractitionerContactDetailsLazyQueryHookResult = ReturnType<typeof useGetPractitionerContactDetailsLazyQuery>;
export type GetPractitionerContactDetailsQueryResult = Apollo.QueryResult<GetPractitionerContactDetailsQuery, GetPractitionerContactDetailsQueryVariables>;
export const GetPractitonerQualificationDetailsDocument = gql`
    query getPractitonerQualificationDetails($id: token) {
  Practitioner(_id: $id) {
    qualification {
      code {
        coding {
          system
          display
          code
        }
        text
      }
      period {
        start
      }
      university
      fieldOfStudy
      country
    }
  }
}
    `;

/**
 * __useGetPractitonerQualificationDetailsQuery__
 *
 * To run a query within a React component, call `useGetPractitonerQualificationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitonerQualificationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitonerQualificationDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitonerQualificationDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitonerQualificationDetailsQuery, GetPractitonerQualificationDetailsQueryVariables>) {
        return Apollo.useQuery<GetPractitonerQualificationDetailsQuery, GetPractitonerQualificationDetailsQueryVariables>(GetPractitonerQualificationDetailsDocument, baseOptions);
      }
export function useGetPractitonerQualificationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitonerQualificationDetailsQuery, GetPractitonerQualificationDetailsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitonerQualificationDetailsQuery, GetPractitonerQualificationDetailsQueryVariables>(GetPractitonerQualificationDetailsDocument, baseOptions);
        }
export type GetPractitonerQualificationDetailsQueryHookResult = ReturnType<typeof useGetPractitonerQualificationDetailsQuery>;
export type GetPractitonerQualificationDetailsLazyQueryHookResult = ReturnType<typeof useGetPractitonerQualificationDetailsLazyQuery>;
export type GetPractitonerQualificationDetailsQueryResult = Apollo.QueryResult<GetPractitonerQualificationDetailsQuery, GetPractitonerQualificationDetailsQueryVariables>;
export const GetPractitonerProfessionalDetailsDocument = gql`
    query getPractitonerProfessionalDetails($id: token) {
  Practitioner(_id: $id) {
    identifier {
      sectionType
      system
      value
      identifierUrl
      identifierNumber
      identifierType
      country
      period {
        start
        end
      }
    }
  }
  PractitionerRole(_id: $id) {
    code {
      coding {
        system
        display
        code
      }
    }
    specialty {
      coding {
        system
        display
        code
      }
    }
    subSpecialty {
      coding {
        system
        display
        code
      }
    }
    subSpecialtyMaster {
      coding {
        display
        code
      }
    }
    band
    yearsOfExp
  }
}
    `;

/**
 * __useGetPractitonerProfessionalDetailsQuery__
 *
 * To run a query within a React component, call `useGetPractitonerProfessionalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitonerProfessionalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitonerProfessionalDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitonerProfessionalDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitonerProfessionalDetailsQuery, GetPractitonerProfessionalDetailsQueryVariables>) {
        return Apollo.useQuery<GetPractitonerProfessionalDetailsQuery, GetPractitonerProfessionalDetailsQueryVariables>(GetPractitonerProfessionalDetailsDocument, baseOptions);
      }
export function useGetPractitonerProfessionalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitonerProfessionalDetailsQuery, GetPractitonerProfessionalDetailsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitonerProfessionalDetailsQuery, GetPractitonerProfessionalDetailsQueryVariables>(GetPractitonerProfessionalDetailsDocument, baseOptions);
        }
export type GetPractitonerProfessionalDetailsQueryHookResult = ReturnType<typeof useGetPractitonerProfessionalDetailsQuery>;
export type GetPractitonerProfessionalDetailsLazyQueryHookResult = ReturnType<typeof useGetPractitonerProfessionalDetailsLazyQuery>;
export type GetPractitonerProfessionalDetailsQueryResult = Apollo.QueryResult<GetPractitonerProfessionalDetailsQuery, GetPractitonerProfessionalDetailsQueryVariables>;
export const GetPractitonerExpertiseDocument = gql`
    query getPractitonerExpertise($id: token) {
  PractitionerRole(_id: $id) {
    expertise {
      expertiseType
      expertiseTypeValues
    }
  }
}
    `;

/**
 * __useGetPractitonerExpertiseQuery__
 *
 * To run a query within a React component, call `useGetPractitonerExpertiseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitonerExpertiseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitonerExpertiseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitonerExpertiseQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitonerExpertiseQuery, GetPractitonerExpertiseQueryVariables>) {
        return Apollo.useQuery<GetPractitonerExpertiseQuery, GetPractitonerExpertiseQueryVariables>(GetPractitonerExpertiseDocument, baseOptions);
      }
export function useGetPractitonerExpertiseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitonerExpertiseQuery, GetPractitonerExpertiseQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitonerExpertiseQuery, GetPractitonerExpertiseQueryVariables>(GetPractitonerExpertiseDocument, baseOptions);
        }
export type GetPractitonerExpertiseQueryHookResult = ReturnType<typeof useGetPractitonerExpertiseQuery>;
export type GetPractitonerExpertiseLazyQueryHookResult = ReturnType<typeof useGetPractitonerExpertiseLazyQuery>;
export type GetPractitonerExpertiseQueryResult = Apollo.QueryResult<GetPractitonerExpertiseQuery, GetPractitonerExpertiseQueryVariables>;
export const GetPractitonerAwardsAndMediaMentionsDocument = gql`
    query getPractitonerAwardsAndMediaMentions($id: token) {
  Practitioner(_id: $id) {
    awards {
      awardName
      awardedOn
      institutionName
      country
    }
    media {
      mediaOulet
      mentinedIn
      typeOfMedium
      url
    }
  }
}
    `;

/**
 * __useGetPractitonerAwardsAndMediaMentionsQuery__
 *
 * To run a query within a React component, call `useGetPractitonerAwardsAndMediaMentionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitonerAwardsAndMediaMentionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitonerAwardsAndMediaMentionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitonerAwardsAndMediaMentionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitonerAwardsAndMediaMentionsQuery, GetPractitonerAwardsAndMediaMentionsQueryVariables>) {
        return Apollo.useQuery<GetPractitonerAwardsAndMediaMentionsQuery, GetPractitonerAwardsAndMediaMentionsQueryVariables>(GetPractitonerAwardsAndMediaMentionsDocument, baseOptions);
      }
export function useGetPractitonerAwardsAndMediaMentionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitonerAwardsAndMediaMentionsQuery, GetPractitonerAwardsAndMediaMentionsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitonerAwardsAndMediaMentionsQuery, GetPractitonerAwardsAndMediaMentionsQueryVariables>(GetPractitonerAwardsAndMediaMentionsDocument, baseOptions);
        }
export type GetPractitonerAwardsAndMediaMentionsQueryHookResult = ReturnType<typeof useGetPractitonerAwardsAndMediaMentionsQuery>;
export type GetPractitonerAwardsAndMediaMentionsLazyQueryHookResult = ReturnType<typeof useGetPractitonerAwardsAndMediaMentionsLazyQuery>;
export type GetPractitonerAwardsAndMediaMentionsQueryResult = Apollo.QueryResult<GetPractitonerAwardsAndMediaMentionsQuery, GetPractitonerAwardsAndMediaMentionsQueryVariables>;
export const GetPractitonerPublicationsDocument = gql`
    query getPractitonerPublications($id: token) {
  Practitioner(_id: $id) {
    publications {
      publishedOn
      publicationName
      publicationType
      url
    }
  }
}
    `;

/**
 * __useGetPractitonerPublicationsQuery__
 *
 * To run a query within a React component, call `useGetPractitonerPublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitonerPublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitonerPublicationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitonerPublicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitonerPublicationsQuery, GetPractitonerPublicationsQueryVariables>) {
        return Apollo.useQuery<GetPractitonerPublicationsQuery, GetPractitonerPublicationsQueryVariables>(GetPractitonerPublicationsDocument, baseOptions);
      }
export function useGetPractitonerPublicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitonerPublicationsQuery, GetPractitonerPublicationsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitonerPublicationsQuery, GetPractitonerPublicationsQueryVariables>(GetPractitonerPublicationsDocument, baseOptions);
        }
export type GetPractitonerPublicationsQueryHookResult = ReturnType<typeof useGetPractitonerPublicationsQuery>;
export type GetPractitonerPublicationsLazyQueryHookResult = ReturnType<typeof useGetPractitonerPublicationsLazyQuery>;
export type GetPractitonerPublicationsQueryResult = Apollo.QueryResult<GetPractitonerPublicationsQuery, GetPractitonerPublicationsQueryVariables>;
export const GetPractitonerAffiliationsDocument = gql`
    query getPractitonerAffiliations($id: token) {
  Practitioner(_id: $id) {
    affiliations {
      institutionName
      relationshipWithOrganization
      fromDate
      toDate
      country
      title
      supervisorsLastName
      supervisorsFirstName
      mobile
      email
      alternateEmail
    }
  }
}
    `;

/**
 * __useGetPractitonerAffiliationsQuery__
 *
 * To run a query within a React component, call `useGetPractitonerAffiliationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitonerAffiliationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitonerAffiliationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitonerAffiliationsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitonerAffiliationsQuery, GetPractitonerAffiliationsQueryVariables>) {
        return Apollo.useQuery<GetPractitonerAffiliationsQuery, GetPractitonerAffiliationsQueryVariables>(GetPractitonerAffiliationsDocument, baseOptions);
      }
export function useGetPractitonerAffiliationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitonerAffiliationsQuery, GetPractitonerAffiliationsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitonerAffiliationsQuery, GetPractitonerAffiliationsQueryVariables>(GetPractitonerAffiliationsDocument, baseOptions);
        }
export type GetPractitonerAffiliationsQueryHookResult = ReturnType<typeof useGetPractitonerAffiliationsQuery>;
export type GetPractitonerAffiliationsLazyQueryHookResult = ReturnType<typeof useGetPractitonerAffiliationsLazyQuery>;
export type GetPractitonerAffiliationsQueryResult = Apollo.QueryResult<GetPractitonerAffiliationsQuery, GetPractitonerAffiliationsQueryVariables>;
export const GetPractitonerAccredationsDocument = gql`
    query getPractitonerAccredations($id: token) {
  Practitioner(_id: $id) {
    accreditations {
      insuranceCompanyName
      providerNo
      healthcodeIdentifier
      registrationDate
      healthcodeIdentifier
      imageUrl
      shareData
    }
  }
}
    `;

/**
 * __useGetPractitonerAccredationsQuery__
 *
 * To run a query within a React component, call `useGetPractitonerAccredationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitonerAccredationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitonerAccredationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitonerAccredationsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitonerAccredationsQuery, GetPractitonerAccredationsQueryVariables>) {
        return Apollo.useQuery<GetPractitonerAccredationsQuery, GetPractitonerAccredationsQueryVariables>(GetPractitonerAccredationsDocument, baseOptions);
      }
export function useGetPractitonerAccredationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitonerAccredationsQuery, GetPractitonerAccredationsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitonerAccredationsQuery, GetPractitonerAccredationsQueryVariables>(GetPractitonerAccredationsDocument, baseOptions);
        }
export type GetPractitonerAccredationsQueryHookResult = ReturnType<typeof useGetPractitonerAccredationsQuery>;
export type GetPractitonerAccredationsLazyQueryHookResult = ReturnType<typeof useGetPractitonerAccredationsLazyQuery>;
export type GetPractitonerAccredationsQueryResult = Apollo.QueryResult<GetPractitonerAccredationsQuery, GetPractitonerAccredationsQueryVariables>;
export const GetPractitionerInvoiceBillingDocument = gql`
    query getPractitionerInvoiceBilling($id: token) {
  PomsInvoiceBilling(_id: $id) {
    entityType
    nationalInsuranceNumber
    buildingSocietyName
    accountHolderName
    sortCode
    accountNo
    managingPractitioner
    companyName
    companyNumber
    vatNumber
    accountHolderName
    sortCode
    accountNo
    utrNo
    vatNumber
    documents {
      content {
        attachment {
          title
          url
          creation
          documentType
        }
      }
    }
  }
}
    `;

/**
 * __useGetPractitionerInvoiceBillingQuery__
 *
 * To run a query within a React component, call `useGetPractitionerInvoiceBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerInvoiceBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerInvoiceBillingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerInvoiceBillingQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerInvoiceBillingQuery, GetPractitionerInvoiceBillingQueryVariables>) {
        return Apollo.useQuery<GetPractitionerInvoiceBillingQuery, GetPractitionerInvoiceBillingQueryVariables>(GetPractitionerInvoiceBillingDocument, baseOptions);
      }
export function useGetPractitionerInvoiceBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerInvoiceBillingQuery, GetPractitionerInvoiceBillingQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerInvoiceBillingQuery, GetPractitionerInvoiceBillingQueryVariables>(GetPractitionerInvoiceBillingDocument, baseOptions);
        }
export type GetPractitionerInvoiceBillingQueryHookResult = ReturnType<typeof useGetPractitionerInvoiceBillingQuery>;
export type GetPractitionerInvoiceBillingLazyQueryHookResult = ReturnType<typeof useGetPractitionerInvoiceBillingLazyQuery>;
export type GetPractitionerInvoiceBillingQueryResult = Apollo.QueryResult<GetPractitionerInvoiceBillingQuery, GetPractitionerInvoiceBillingQueryVariables>;
export const GetPractitionerAgreementsDocument = gql`
    query getPractitionerAgreements($id: token) {
  PomsPractitionerAgreement(_id: $id) {
    pomsHandBook
    termsOfUse
    pomsContract
    managingPractitioner
    contractFilePath
    documents {
      content {
        attachment {
          title
          url
          creation
          documentType
        }
      }
    }
  }
}
    `;

/**
 * __useGetPractitionerAgreementsQuery__
 *
 * To run a query within a React component, call `useGetPractitionerAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerAgreementsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerAgreementsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerAgreementsQuery, GetPractitionerAgreementsQueryVariables>) {
        return Apollo.useQuery<GetPractitionerAgreementsQuery, GetPractitionerAgreementsQueryVariables>(GetPractitionerAgreementsDocument, baseOptions);
      }
export function useGetPractitionerAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerAgreementsQuery, GetPractitionerAgreementsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerAgreementsQuery, GetPractitionerAgreementsQueryVariables>(GetPractitionerAgreementsDocument, baseOptions);
        }
export type GetPractitionerAgreementsQueryHookResult = ReturnType<typeof useGetPractitionerAgreementsQuery>;
export type GetPractitionerAgreementsLazyQueryHookResult = ReturnType<typeof useGetPractitionerAgreementsLazyQuery>;
export type GetPractitionerAgreementsQueryResult = Apollo.QueryResult<GetPractitionerAgreementsQuery, GetPractitionerAgreementsQueryVariables>;
export const GetPractitinerDocumentsDocument = gql`
    query getPractitinerDocuments($id: token) {
  DocumentReference(_id: $id) {
    id
    resourceType
    content {
      attachment {
        title
        url
        creation
        documentType
      }
    }
  }
}
    `;

/**
 * __useGetPractitinerDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPractitinerDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitinerDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitinerDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitinerDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitinerDocumentsQuery, GetPractitinerDocumentsQueryVariables>) {
        return Apollo.useQuery<GetPractitinerDocumentsQuery, GetPractitinerDocumentsQueryVariables>(GetPractitinerDocumentsDocument, baseOptions);
      }
export function useGetPractitinerDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitinerDocumentsQuery, GetPractitinerDocumentsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitinerDocumentsQuery, GetPractitinerDocumentsQueryVariables>(GetPractitinerDocumentsDocument, baseOptions);
        }
export type GetPractitinerDocumentsQueryHookResult = ReturnType<typeof useGetPractitinerDocumentsQuery>;
export type GetPractitinerDocumentsLazyQueryHookResult = ReturnType<typeof useGetPractitinerDocumentsLazyQuery>;
export type GetPractitinerDocumentsQueryResult = Apollo.QueryResult<GetPractitinerDocumentsQuery, GetPractitinerDocumentsQueryVariables>;
export const GetPractitionerLocationsDocument = gql`
    query getPractitionerLocations($id: token) {
  LocationList(_id: $id) {
    id
    locationExtension {
      practitionerReference
      GTNID
      COCID
      locationRank
    }
    name
    address {
      line
      city
      state
      country
      postalCode
    }
    telecom {
      system
      value
      use
      rank
    }
  }
}
    `;

/**
 * __useGetPractitionerLocationsQuery__
 *
 * To run a query within a React component, call `useGetPractitionerLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerLocationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerLocationsQuery, GetPractitionerLocationsQueryVariables>) {
        return Apollo.useQuery<GetPractitionerLocationsQuery, GetPractitionerLocationsQueryVariables>(GetPractitionerLocationsDocument, baseOptions);
      }
export function useGetPractitionerLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerLocationsQuery, GetPractitionerLocationsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerLocationsQuery, GetPractitionerLocationsQueryVariables>(GetPractitionerLocationsDocument, baseOptions);
        }
export type GetPractitionerLocationsQueryHookResult = ReturnType<typeof useGetPractitionerLocationsQuery>;
export type GetPractitionerLocationsLazyQueryHookResult = ReturnType<typeof useGetPractitionerLocationsLazyQuery>;
export type GetPractitionerLocationsQueryResult = Apollo.QueryResult<GetPractitionerLocationsQuery, GetPractitionerLocationsQueryVariables>;
export const GetPractitionerPreferencesDocument = gql`
    query getPractitionerPreferences($id: token) {
  PomsPractitionerPreference(_id: $id) {
    country {
      coding {
        system
        code
        display
      }
    }
    language {
      coding {
        system
        code
        display
      }
    }
    timezone {
      coding {
        system
        code
        display
      }
    }
    currency {
      coding {
        system
        code
        display
      }
    }
    managingPractitioner
    sendCommunicationMessage
  }
}
    `;

/**
 * __useGetPractitionerPreferencesQuery__
 *
 * To run a query within a React component, call `useGetPractitionerPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerPreferencesQuery, GetPractitionerPreferencesQueryVariables>) {
        return Apollo.useQuery<GetPractitionerPreferencesQuery, GetPractitionerPreferencesQueryVariables>(GetPractitionerPreferencesDocument, baseOptions);
      }
export function useGetPractitionerPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerPreferencesQuery, GetPractitionerPreferencesQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerPreferencesQuery, GetPractitionerPreferencesQueryVariables>(GetPractitionerPreferencesDocument, baseOptions);
        }
export type GetPractitionerPreferencesQueryHookResult = ReturnType<typeof useGetPractitionerPreferencesQuery>;
export type GetPractitionerPreferencesLazyQueryHookResult = ReturnType<typeof useGetPractitionerPreferencesLazyQuery>;
export type GetPractitionerPreferencesQueryResult = Apollo.QueryResult<GetPractitionerPreferencesQuery, GetPractitionerPreferencesQueryVariables>;
export const GetPractitionerPrivacyDocument = gql`
    query getPractitionerPrivacy($id: token) {
  PomsPractitionerPrivacy(_id: $id) {
    contactSMS
    contactPost
    contactPhone
    contactEmail
    notifySMS
    notifyPost
    notifyPhone
    notifyEmail
    gdprConsent
  }
}
    `;

/**
 * __useGetPractitionerPrivacyQuery__
 *
 * To run a query within a React component, call `useGetPractitionerPrivacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerPrivacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerPrivacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerPrivacyQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerPrivacyQuery, GetPractitionerPrivacyQueryVariables>) {
        return Apollo.useQuery<GetPractitionerPrivacyQuery, GetPractitionerPrivacyQueryVariables>(GetPractitionerPrivacyDocument, baseOptions);
      }
export function useGetPractitionerPrivacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerPrivacyQuery, GetPractitionerPrivacyQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerPrivacyQuery, GetPractitionerPrivacyQueryVariables>(GetPractitionerPrivacyDocument, baseOptions);
        }
export type GetPractitionerPrivacyQueryHookResult = ReturnType<typeof useGetPractitionerPrivacyQuery>;
export type GetPractitionerPrivacyLazyQueryHookResult = ReturnType<typeof useGetPractitionerPrivacyLazyQuery>;
export type GetPractitionerPrivacyQueryResult = Apollo.QueryResult<GetPractitionerPrivacyQuery, GetPractitionerPrivacyQueryVariables>;
export const GetPractitionerActivityDocument = gql`
    query getPractitionerActivity($id: token) {
  PomsPractitionerActivityList(_id: $id) {
    id
    ipaddress
    device
    accessedOn
    country
    logInTime
    logOutTime
  }
}
    `;

/**
 * __useGetPractitionerActivityQuery__
 *
 * To run a query within a React component, call `useGetPractitionerActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerActivityQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerActivityQuery, GetPractitionerActivityQueryVariables>) {
        return Apollo.useQuery<GetPractitionerActivityQuery, GetPractitionerActivityQueryVariables>(GetPractitionerActivityDocument, baseOptions);
      }
export function useGetPractitionerActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerActivityQuery, GetPractitionerActivityQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerActivityQuery, GetPractitionerActivityQueryVariables>(GetPractitionerActivityDocument, baseOptions);
        }
export type GetPractitionerActivityQueryHookResult = ReturnType<typeof useGetPractitionerActivityQuery>;
export type GetPractitionerActivityLazyQueryHookResult = ReturnType<typeof useGetPractitionerActivityLazyQuery>;
export type GetPractitionerActivityQueryResult = Apollo.QueryResult<GetPractitionerActivityQuery, GetPractitionerActivityQueryVariables>;
export const GetPractitionerEmergencyDetailsDocument = gql`
    query getPractitionerEmergencyDetails($id: token) {
  Practitioner(_id: $id) {
    emergencyContact {
      fullname
      mobile
      email
      realtionship
    }
  }
}
    `;

/**
 * __useGetPractitionerEmergencyDetailsQuery__
 *
 * To run a query within a React component, call `useGetPractitionerEmergencyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerEmergencyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerEmergencyDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerEmergencyDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerEmergencyDetailsQuery, GetPractitionerEmergencyDetailsQueryVariables>) {
        return Apollo.useQuery<GetPractitionerEmergencyDetailsQuery, GetPractitionerEmergencyDetailsQueryVariables>(GetPractitionerEmergencyDetailsDocument, baseOptions);
      }
export function useGetPractitionerEmergencyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerEmergencyDetailsQuery, GetPractitionerEmergencyDetailsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerEmergencyDetailsQuery, GetPractitionerEmergencyDetailsQueryVariables>(GetPractitionerEmergencyDetailsDocument, baseOptions);
        }
export type GetPractitionerEmergencyDetailsQueryHookResult = ReturnType<typeof useGetPractitionerEmergencyDetailsQuery>;
export type GetPractitionerEmergencyDetailsLazyQueryHookResult = ReturnType<typeof useGetPractitionerEmergencyDetailsLazyQuery>;
export type GetPractitionerEmergencyDetailsQueryResult = Apollo.QueryResult<GetPractitionerEmergencyDetailsQuery, GetPractitionerEmergencyDetailsQueryVariables>;
export const GetMasterDataDocument = gql`
    query getMasterData($id: token) {
  ValueSet(_id: $id) {
    compose {
      include {
        system
        concept {
          code
          display
          disorder
          img
        }
      }
    }
  }
}
    `;

/**
 * __useGetMasterDataQuery__
 *
 * To run a query within a React component, call `useGetMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterDataQuery, GetMasterDataQueryVariables>) {
        return Apollo.useQuery<GetMasterDataQuery, GetMasterDataQueryVariables>(GetMasterDataDocument, baseOptions);
      }
export function useGetMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterDataQuery, GetMasterDataQueryVariables>) {
          return Apollo.useLazyQuery<GetMasterDataQuery, GetMasterDataQueryVariables>(GetMasterDataDocument, baseOptions);
        }
export type GetMasterDataQueryHookResult = ReturnType<typeof useGetMasterDataQuery>;
export type GetMasterDataLazyQueryHookResult = ReturnType<typeof useGetMasterDataLazyQuery>;
export type GetMasterDataQueryResult = Apollo.QueryResult<GetMasterDataQuery, GetMasterDataQueryVariables>;
export const GetLanguagesDataDocument = gql`
    query getLanguagesData($id: token) {
  ValueSet(_id: $id) {
    compose {
      include {
        system
        concept {
          code
          display
        }
      }
    }
  }
}
    `;

/**
 * __useGetLanguagesDataQuery__
 *
 * To run a query within a React component, call `useGetLanguagesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLanguagesDataQuery(baseOptions?: Apollo.QueryHookOptions<GetLanguagesDataQuery, GetLanguagesDataQueryVariables>) {
        return Apollo.useQuery<GetLanguagesDataQuery, GetLanguagesDataQueryVariables>(GetLanguagesDataDocument, baseOptions);
      }
export function useGetLanguagesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesDataQuery, GetLanguagesDataQueryVariables>) {
          return Apollo.useLazyQuery<GetLanguagesDataQuery, GetLanguagesDataQueryVariables>(GetLanguagesDataDocument, baseOptions);
        }
export type GetLanguagesDataQueryHookResult = ReturnType<typeof useGetLanguagesDataQuery>;
export type GetLanguagesDataLazyQueryHookResult = ReturnType<typeof useGetLanguagesDataLazyQuery>;
export type GetLanguagesDataQueryResult = Apollo.QueryResult<GetLanguagesDataQuery, GetLanguagesDataQueryVariables>;
export const GetPractitionerScheduleDocument = gql`
    query getPractitionerSchedule($id: token) {
  PomsPractitionerSchedule(_id: $id) {
    id
    locationId
    locationName
    color
    managingPractitioner
    breakRequired
    fromDate
    toDate
    endOnType
    endOnDate
    isRepeat
    endOnAfterNoOfOccurences
    repeatSelectType
    weekTimings {
      weekDayName
      weekDayNumber
      weekDayTimings {
        endTime
        startTime
      }
    }
  }
}
    `;

/**
 * __useGetPractitionerScheduleQuery__
 *
 * To run a query within a React component, call `useGetPractitionerScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerScheduleQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerScheduleQuery, GetPractitionerScheduleQueryVariables>) {
        return Apollo.useQuery<GetPractitionerScheduleQuery, GetPractitionerScheduleQueryVariables>(GetPractitionerScheduleDocument, baseOptions);
      }
export function useGetPractitionerScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerScheduleQuery, GetPractitionerScheduleQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerScheduleQuery, GetPractitionerScheduleQueryVariables>(GetPractitionerScheduleDocument, baseOptions);
        }
export type GetPractitionerScheduleQueryHookResult = ReturnType<typeof useGetPractitionerScheduleQuery>;
export type GetPractitionerScheduleLazyQueryHookResult = ReturnType<typeof useGetPractitionerScheduleLazyQuery>;
export type GetPractitionerScheduleQueryResult = Apollo.QueryResult<GetPractitionerScheduleQuery, GetPractitionerScheduleQueryVariables>;
export const GetPractitionerSlotsDocument = gql`
    query getPractitionerSlots($id: token, $date: date) {
  SlotList(_id: $id, start: $date) {
    id
    start
    end
    slotExtension {
      managingPractitioner
    }
    appointmentTypeId
    professionalId
    status
    appointmentMode
  }
}
    `;

/**
 * __useGetPractitionerSlotsQuery__
 *
 * To run a query within a React component, call `useGetPractitionerSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerSlotsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetPractitionerSlotsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerSlotsQuery, GetPractitionerSlotsQueryVariables>) {
        return Apollo.useQuery<GetPractitionerSlotsQuery, GetPractitionerSlotsQueryVariables>(GetPractitionerSlotsDocument, baseOptions);
      }
export function useGetPractitionerSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerSlotsQuery, GetPractitionerSlotsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerSlotsQuery, GetPractitionerSlotsQueryVariables>(GetPractitionerSlotsDocument, baseOptions);
        }
export type GetPractitionerSlotsQueryHookResult = ReturnType<typeof useGetPractitionerSlotsQuery>;
export type GetPractitionerSlotsLazyQueryHookResult = ReturnType<typeof useGetPractitionerSlotsLazyQuery>;
export type GetPractitionerSlotsQueryResult = Apollo.QueryResult<GetPractitionerSlotsQuery, GetPractitionerSlotsQueryVariables>;
export const GetPatientProfileDetailsDocument = gql`
    query GetPatientProfileDetails($id: token) {
  Patient(_id: $id) {
    name {
      use
      family
      given
      prefix
    }
    gender
    birthDate
    nationality
    occupation
    patientProfileExtension {
      genderIdentity {
        coding {
          system
          code
          display
        }
      }
      sexualOrientation {
        coding {
          system
          code
          display
        }
      }
      race {
        coding {
          system
          code
          display
        }
      }
      ethnicity {
        coding {
          system
          code
          display
        }
      }
      whereDidYouHearFrom
      aboutYourSelf
      profileTags
    }
    maritalStatus {
      coding {
        system
        code
        display
      }
    }
    photo {
      url
      title
    }
    tags
    comments {
      practitionerId
      practitionerName
      commentedOn
      comments
    }
    communication {
      language {
        coding {
          system
          code
          display
        }
      }
    }
    patientDisorder {
      disorderName
      createdOn
    }
    patientSecondaryDisorder
  }
}
    `;

/**
 * __useGetPatientProfileDetailsQuery__
 *
 * To run a query within a React component, call `useGetPatientProfileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientProfileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientProfileDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientProfileDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientProfileDetailsQuery, GetPatientProfileDetailsQueryVariables>) {
        return Apollo.useQuery<GetPatientProfileDetailsQuery, GetPatientProfileDetailsQueryVariables>(GetPatientProfileDetailsDocument, baseOptions);
      }
export function useGetPatientProfileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientProfileDetailsQuery, GetPatientProfileDetailsQueryVariables>) {
          return Apollo.useLazyQuery<GetPatientProfileDetailsQuery, GetPatientProfileDetailsQueryVariables>(GetPatientProfileDetailsDocument, baseOptions);
        }
export type GetPatientProfileDetailsQueryHookResult = ReturnType<typeof useGetPatientProfileDetailsQuery>;
export type GetPatientProfileDetailsLazyQueryHookResult = ReturnType<typeof useGetPatientProfileDetailsLazyQuery>;
export type GetPatientProfileDetailsQueryResult = Apollo.QueryResult<GetPatientProfileDetailsQuery, GetPatientProfileDetailsQueryVariables>;
export const GetPatientContactDetailsDocument = gql`
    query getPatientContactDetails($id: token) {
  Patient(_id: $id) {
    address {
      line
      city
      state
      country
      postalCode
    }
    dob
    telecom {
      system
      value
      use
      rank
    }
  }
}
    `;

/**
 * __useGetPatientContactDetailsQuery__
 *
 * To run a query within a React component, call `useGetPatientContactDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientContactDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientContactDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientContactDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientContactDetailsQuery, GetPatientContactDetailsQueryVariables>) {
        return Apollo.useQuery<GetPatientContactDetailsQuery, GetPatientContactDetailsQueryVariables>(GetPatientContactDetailsDocument, baseOptions);
      }
export function useGetPatientContactDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientContactDetailsQuery, GetPatientContactDetailsQueryVariables>) {
          return Apollo.useLazyQuery<GetPatientContactDetailsQuery, GetPatientContactDetailsQueryVariables>(GetPatientContactDetailsDocument, baseOptions);
        }
export type GetPatientContactDetailsQueryHookResult = ReturnType<typeof useGetPatientContactDetailsQuery>;
export type GetPatientContactDetailsLazyQueryHookResult = ReturnType<typeof useGetPatientContactDetailsLazyQuery>;
export type GetPatientContactDetailsQueryResult = Apollo.QueryResult<GetPatientContactDetailsQuery, GetPatientContactDetailsQueryVariables>;
export const GetFamilyDetailsDocument = gql`
    query getFamilyDetails($id: token) {
  Patient(_id: $id) {
    contact {
      contactPreference
      preferredSMS
      preferredEmail
      preferredEmail
      gender
      birthDate
      relationship {
        coding {
          system
          code
          display
        }
      }
      address {
        line
        city
        state
        country
        postalCode
      }
      telecom {
        system
        value
        use
        rank
      }
      name {
        use
        given
        family
        prefix
      }
    }
  }
}
    `;

/**
 * __useGetFamilyDetailsQuery__
 *
 * To run a query within a React component, call `useGetFamilyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFamilyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFamilyDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFamilyDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetFamilyDetailsQuery, GetFamilyDetailsQueryVariables>) {
        return Apollo.useQuery<GetFamilyDetailsQuery, GetFamilyDetailsQueryVariables>(GetFamilyDetailsDocument, baseOptions);
      }
export function useGetFamilyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFamilyDetailsQuery, GetFamilyDetailsQueryVariables>) {
          return Apollo.useLazyQuery<GetFamilyDetailsQuery, GetFamilyDetailsQueryVariables>(GetFamilyDetailsDocument, baseOptions);
        }
export type GetFamilyDetailsQueryHookResult = ReturnType<typeof useGetFamilyDetailsQuery>;
export type GetFamilyDetailsLazyQueryHookResult = ReturnType<typeof useGetFamilyDetailsLazyQuery>;
export type GetFamilyDetailsQueryResult = Apollo.QueryResult<GetFamilyDetailsQuery, GetFamilyDetailsQueryVariables>;
export const GetPatientHealthProfileDocument = gql`
    query getPatientHealthProfile($id: token) {
  Patient(_id: $id) {
    id
    healthProfile {
      nhsCity
      nhsNumber
      nhsPracticeName
      nhsPracticeEmail
      nhsPhone
      disabilities
      risk
      deviceImplant
      gpName
      medication {
        code {
          coding {
            display
          }
        }
      }
      diagnosis {
        code {
          coding {
            display
          }
        }
      }
      immunization {
        vaccineCode {
          text
        }
        occurrenceDateTime
      }
      allergies {
        allergyType
        allergyTypeValues
      }
      vitals {
        valueString
        valueInteger
        effectiveDateTime
        id
      }
      canWeContactYourGP
    }
  }
}
    `;

/**
 * __useGetPatientHealthProfileQuery__
 *
 * To run a query within a React component, call `useGetPatientHealthProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientHealthProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientHealthProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientHealthProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientHealthProfileQuery, GetPatientHealthProfileQueryVariables>) {
        return Apollo.useQuery<GetPatientHealthProfileQuery, GetPatientHealthProfileQueryVariables>(GetPatientHealthProfileDocument, baseOptions);
      }
export function useGetPatientHealthProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientHealthProfileQuery, GetPatientHealthProfileQueryVariables>) {
          return Apollo.useLazyQuery<GetPatientHealthProfileQuery, GetPatientHealthProfileQueryVariables>(GetPatientHealthProfileDocument, baseOptions);
        }
export type GetPatientHealthProfileQueryHookResult = ReturnType<typeof useGetPatientHealthProfileQuery>;
export type GetPatientHealthProfileLazyQueryHookResult = ReturnType<typeof useGetPatientHealthProfileLazyQuery>;
export type GetPatientHealthProfileQueryResult = Apollo.QueryResult<GetPatientHealthProfileQuery, GetPatientHealthProfileQueryVariables>;
export const GetPomsPatientDocumentListDocument = gql`
    query getPomsPatientDocumentList($id: token, $documentType: String) {
  PomsPatientDocumentList(_id: $id, documentType: $documentType) {
    documentUrl
    documentName
    practitionerId
    practitionerName
    documentType
    author
    organizationName
    createdOn
    id
    report_date
  }
}
    `;

/**
 * __useGetPomsPatientDocumentListQuery__
 *
 * To run a query within a React component, call `useGetPomsPatientDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPomsPatientDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPomsPatientDocumentListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useGetPomsPatientDocumentListQuery(baseOptions?: Apollo.QueryHookOptions<GetPomsPatientDocumentListQuery, GetPomsPatientDocumentListQueryVariables>) {
        return Apollo.useQuery<GetPomsPatientDocumentListQuery, GetPomsPatientDocumentListQueryVariables>(GetPomsPatientDocumentListDocument, baseOptions);
      }
export function useGetPomsPatientDocumentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPomsPatientDocumentListQuery, GetPomsPatientDocumentListQueryVariables>) {
          return Apollo.useLazyQuery<GetPomsPatientDocumentListQuery, GetPomsPatientDocumentListQueryVariables>(GetPomsPatientDocumentListDocument, baseOptions);
        }
export type GetPomsPatientDocumentListQueryHookResult = ReturnType<typeof useGetPomsPatientDocumentListQuery>;
export type GetPomsPatientDocumentListLazyQueryHookResult = ReturnType<typeof useGetPomsPatientDocumentListLazyQuery>;
export type GetPomsPatientDocumentListQueryResult = Apollo.QueryResult<GetPomsPatientDocumentListQuery, GetPomsPatientDocumentListQueryVariables>;
export const GetPractitionerPatientCommListDocument = gql`
    query getPractitionerPatientCommList($id: token) {
  PractitionerPatientCommunicationList(_id: $id) {
    createdOn
    toEmail
    fromEmail
    ccEmail
    bccEmail
    subject
    channel
    status
    messageContent
    id
    practitionerId
    practitionerName
    practitionerSpeciality
    commFrom
  }
}
    `;

/**
 * __useGetPractitionerPatientCommListQuery__
 *
 * To run a query within a React component, call `useGetPractitionerPatientCommListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerPatientCommListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerPatientCommListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerPatientCommListQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerPatientCommListQuery, GetPractitionerPatientCommListQueryVariables>) {
        return Apollo.useQuery<GetPractitionerPatientCommListQuery, GetPractitionerPatientCommListQueryVariables>(GetPractitionerPatientCommListDocument, baseOptions);
      }
export function useGetPractitionerPatientCommListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerPatientCommListQuery, GetPractitionerPatientCommListQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerPatientCommListQuery, GetPractitionerPatientCommListQueryVariables>(GetPractitionerPatientCommListDocument, baseOptions);
        }
export type GetPractitionerPatientCommListQueryHookResult = ReturnType<typeof useGetPractitionerPatientCommListQuery>;
export type GetPractitionerPatientCommListLazyQueryHookResult = ReturnType<typeof useGetPractitionerPatientCommListLazyQuery>;
export type GetPractitionerPatientCommListQueryResult = Apollo.QueryResult<GetPractitionerPatientCommListQuery, GetPractitionerPatientCommListQueryVariables>;
export const GetMedicationMasterListDocument = gql`
    query getMedicationMasterList {
  MedicationMasterList {
    drugName
    controlledDrug
    dosage
    frequency
    route
    id
  }
}
    `;

/**
 * __useGetMedicationMasterListQuery__
 *
 * To run a query within a React component, call `useGetMedicationMasterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicationMasterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicationMasterListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMedicationMasterListQuery(baseOptions?: Apollo.QueryHookOptions<GetMedicationMasterListQuery, GetMedicationMasterListQueryVariables>) {
        return Apollo.useQuery<GetMedicationMasterListQuery, GetMedicationMasterListQueryVariables>(GetMedicationMasterListDocument, baseOptions);
      }
export function useGetMedicationMasterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMedicationMasterListQuery, GetMedicationMasterListQueryVariables>) {
          return Apollo.useLazyQuery<GetMedicationMasterListQuery, GetMedicationMasterListQueryVariables>(GetMedicationMasterListDocument, baseOptions);
        }
export type GetMedicationMasterListQueryHookResult = ReturnType<typeof useGetMedicationMasterListQuery>;
export type GetMedicationMasterListLazyQueryHookResult = ReturnType<typeof useGetMedicationMasterListLazyQuery>;
export type GetMedicationMasterListQueryResult = Apollo.QueryResult<GetMedicationMasterListQuery, GetMedicationMasterListQueryVariables>;
export const GetPatientPrescriptionsDocument = gql`
    query getPatientPrescriptions($id: String) {
  PatientPrescriptionList(patientId: $id) {
    id
    comments
    practitionerName
    practitionerId
    patientId
    practitionerSpeciality
    patientName
    patientAddress
    practitionerSignUrl
    gmcNumber
    dateofbirth
    prescriptionStatus
    prescriptionSentStatus
    medications {
      drugName
      drugType
      dosage
      frequency
      route
      durationOfPrescription
      neededToIncrease
      neededToDecrease
      furtherInstructions
      anyChanges
    }
    prescriptionId
    prescriptionDate
    prescriptionType
    prescriptionUploadUrl
    practitionerEmail
    practitionerPhoneNumber
    practitionerAddress
    patientEmail
    patientPhoneNumber
    prescriptionFileUrl
    prescriptionFileUrlName
  }
}
    `;

/**
 * __useGetPatientPrescriptionsQuery__
 *
 * To run a query within a React component, call `useGetPatientPrescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientPrescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientPrescriptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientPrescriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientPrescriptionsQuery, GetPatientPrescriptionsQueryVariables>) {
        return Apollo.useQuery<GetPatientPrescriptionsQuery, GetPatientPrescriptionsQueryVariables>(GetPatientPrescriptionsDocument, baseOptions);
      }
export function useGetPatientPrescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientPrescriptionsQuery, GetPatientPrescriptionsQueryVariables>) {
          return Apollo.useLazyQuery<GetPatientPrescriptionsQuery, GetPatientPrescriptionsQueryVariables>(GetPatientPrescriptionsDocument, baseOptions);
        }
export type GetPatientPrescriptionsQueryHookResult = ReturnType<typeof useGetPatientPrescriptionsQuery>;
export type GetPatientPrescriptionsLazyQueryHookResult = ReturnType<typeof useGetPatientPrescriptionsLazyQuery>;
export type GetPatientPrescriptionsQueryResult = Apollo.QueryResult<GetPatientPrescriptionsQuery, GetPatientPrescriptionsQueryVariables>;
export const GetPatientReferralsDocument = gql`
    query getPatientReferrals($id: String) {
  PomsReferralList(referral_Type: "1", patientId: $id) {
    id
    typeOfReferral
    referrer_Title
    referrer_FirstName
    referrer_SurName
    referrer_Specialisation
    referrer_Role
    referrer_Location
    referrer_PhoneNumber
    referrer_Email
    patientAddress
    referrer_PostCode
    referrer_Address1
    referrer_Address2
    referrer_Address3
    referrer_City
    referrer_County
    referrer_Country
    referral_Title
    referral_FirstName
    referral_SurName
    referral_Dob
    referral_Email
    referral_PhoneNumber
    referral_ReferenceNumber
    referral_PostCode
    referral_Address1
    referral_Address2
    referral_Address3
    referral_City
    referral_County
    referral_Country
    typeOfReferral_Assessments
    typeOfReferral_RecommendationTreatments
    referral_Urgent
    referral_RiskToSelfOrOthers
    referral_Reason
    expectationFromReferral
    referral_VerbalConsentCheck
    referral_TermsAndConditions
    patientId
    patientName
    practitionerId
    practitionerName
    practitionerSpeciality
    typeOfReferral
    referredPractitionerId
    referredPractitionerName
    referredPractitionerSpecialization
    referral_createdOn
    patientEmail
    patientPhone
    referral_UploadDocuments {
      content {
        attachment {
          title
          url
          creation
          documentType
        }
      }
    }
  }
}
    `;

/**
 * __useGetPatientReferralsQuery__
 *
 * To run a query within a React component, call `useGetPatientReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientReferralsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientReferralsQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientReferralsQuery, GetPatientReferralsQueryVariables>) {
        return Apollo.useQuery<GetPatientReferralsQuery, GetPatientReferralsQueryVariables>(GetPatientReferralsDocument, baseOptions);
      }
export function useGetPatientReferralsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientReferralsQuery, GetPatientReferralsQueryVariables>) {
          return Apollo.useLazyQuery<GetPatientReferralsQuery, GetPatientReferralsQueryVariables>(GetPatientReferralsDocument, baseOptions);
        }
export type GetPatientReferralsQueryHookResult = ReturnType<typeof useGetPatientReferralsQuery>;
export type GetPatientReferralsLazyQueryHookResult = ReturnType<typeof useGetPatientReferralsLazyQuery>;
export type GetPatientReferralsQueryResult = Apollo.QueryResult<GetPatientReferralsQuery, GetPatientReferralsQueryVariables>;
export const GetOaktreeReferralsDocument = gql`
    query getOaktreeReferrals($id: String) {
  PomsReferralList(referral_Type: "4", patientId: $id) {
    id
    typeOfReferral
    referrer_Title
    referrer_FirstName
    referrer_SurName
    referrer_Specialisation
    referrer_Role
    referrer_Location
    referrer_PhoneNumber
    referrer_Email
    patientAddress
    referrer_PostCode
    referrer_Address1
    referrer_Address2
    referrer_Address3
    referrer_City
    referrer_County
    referrer_Country
    referral_Title
    referral_FirstName
    referral_SurName
    referral_Dob
    referral_Email
    referral_PhoneNumber
    referral_ReferenceNumber
    referral_PostCode
    referral_Address1
    referral_Address2
    referral_Address3
    referral_City
    referral_County
    referral_Country
    typeOfReferral_Assessments
    typeOfReferral_RecommendationTreatments
    referral_Urgent
    referral_RiskToSelfOrOthers
    referral_Reason
    expectationFromReferral
    referral_VerbalConsentCheck
    referral_TermsAndConditions
    patientId
    patientName
    practitionerId
    practitionerName
    practitionerSpeciality
    typeOfReferral
    referredPractitionerId
    referredPractitionerName
    referredPractitionerSpecialization
    referral_createdOn
    patientEmail
    patientPhone
    referral_UploadDocuments {
      content {
        attachment {
          title
          url
          creation
          documentType
        }
      }
    }
  }
}
    `;

/**
 * __useGetOaktreeReferralsQuery__
 *
 * To run a query within a React component, call `useGetOaktreeReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOaktreeReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOaktreeReferralsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOaktreeReferralsQuery(baseOptions?: Apollo.QueryHookOptions<GetOaktreeReferralsQuery, GetOaktreeReferralsQueryVariables>) {
        return Apollo.useQuery<GetOaktreeReferralsQuery, GetOaktreeReferralsQueryVariables>(GetOaktreeReferralsDocument, baseOptions);
      }
export function useGetOaktreeReferralsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOaktreeReferralsQuery, GetOaktreeReferralsQueryVariables>) {
          return Apollo.useLazyQuery<GetOaktreeReferralsQuery, GetOaktreeReferralsQueryVariables>(GetOaktreeReferralsDocument, baseOptions);
        }
export type GetOaktreeReferralsQueryHookResult = ReturnType<typeof useGetOaktreeReferralsQuery>;
export type GetOaktreeReferralsLazyQueryHookResult = ReturnType<typeof useGetOaktreeReferralsLazyQuery>;
export type GetOaktreeReferralsQueryResult = Apollo.QueryResult<GetOaktreeReferralsQuery, GetOaktreeReferralsQueryVariables>;
export const GetPatientFinancialInfoDocument = gql`
    query getPatientFinancialInfo($id: String) {
  PatientFinancialInfoList(patientId: $id) {
    id
    financialType
    patientId
    selfPayCardName
    selfPayCardBrand
    selfPayExpMonth
    selfPayExpYear
    selfPayCardType
    selfPayLast4
    selfPayPostalcode
    selfPayAddress1
    selfPayAddress2
    selfPayAddress3
    selfPayCity
    selfPayCounty
    selfPayCountry
    selfPayDefault
    pmiName
    pmiResponsibleParty
    pmiFirstName
    pmiSurName
    pmiGroupId
    pmiPolicyNumber
    pmiExpiresOn
    pmiAuthorizationCode
    pmiAuthorizationSession
    pmiDefault
    pmiDocuments {
      content {
        attachment {
          title
          url
          creation
          documentType
        }
      }
    }
    thirdPartyName
    thirdPartyId
    thirdPartyComments
    thirdPartyContactPerson
    thirdPartyRoleOfPerson
    thirdPartyPhoneNumber
    thirdPartyEmail
  }
}
    `;

/**
 * __useGetPatientFinancialInfoQuery__
 *
 * To run a query within a React component, call `useGetPatientFinancialInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientFinancialInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientFinancialInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientFinancialInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientFinancialInfoQuery, GetPatientFinancialInfoQueryVariables>) {
        return Apollo.useQuery<GetPatientFinancialInfoQuery, GetPatientFinancialInfoQueryVariables>(GetPatientFinancialInfoDocument, baseOptions);
      }
export function useGetPatientFinancialInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientFinancialInfoQuery, GetPatientFinancialInfoQueryVariables>) {
          return Apollo.useLazyQuery<GetPatientFinancialInfoQuery, GetPatientFinancialInfoQueryVariables>(GetPatientFinancialInfoDocument, baseOptions);
        }
export type GetPatientFinancialInfoQueryHookResult = ReturnType<typeof useGetPatientFinancialInfoQuery>;
export type GetPatientFinancialInfoLazyQueryHookResult = ReturnType<typeof useGetPatientFinancialInfoLazyQuery>;
export type GetPatientFinancialInfoQueryResult = Apollo.QueryResult<GetPatientFinancialInfoQuery, GetPatientFinancialInfoQueryVariables>;
export const GetQuestionnaireBuilderListDocument = gql`
    query getQuestionnaireBuilderList {
  QuestionnaireBuilderList {
    id
    resourceType
    questionnaireName
    questionnaireDescription
    administeredType
    totalScore
    questions {
      question
      options {
        option
        optionId
        optionScore
      }
      optionType
      showCommentBox
      isCommentBoxRequired
    }
  }
}
    `;

/**
 * __useGetQuestionnaireBuilderListQuery__
 *
 * To run a query within a React component, call `useGetQuestionnaireBuilderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireBuilderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionnaireBuilderListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuestionnaireBuilderListQuery(baseOptions?: Apollo.QueryHookOptions<GetQuestionnaireBuilderListQuery, GetQuestionnaireBuilderListQueryVariables>) {
        return Apollo.useQuery<GetQuestionnaireBuilderListQuery, GetQuestionnaireBuilderListQueryVariables>(GetQuestionnaireBuilderListDocument, baseOptions);
      }
export function useGetQuestionnaireBuilderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionnaireBuilderListQuery, GetQuestionnaireBuilderListQueryVariables>) {
          return Apollo.useLazyQuery<GetQuestionnaireBuilderListQuery, GetQuestionnaireBuilderListQueryVariables>(GetQuestionnaireBuilderListDocument, baseOptions);
        }
export type GetQuestionnaireBuilderListQueryHookResult = ReturnType<typeof useGetQuestionnaireBuilderListQuery>;
export type GetQuestionnaireBuilderListLazyQueryHookResult = ReturnType<typeof useGetQuestionnaireBuilderListLazyQuery>;
export type GetQuestionnaireBuilderListQueryResult = Apollo.QueryResult<GetQuestionnaireBuilderListQuery, GetQuestionnaireBuilderListQueryVariables>;
export const GetPatientQuestionnaireDocument = gql`
    query getPatientQuestionnaire($id: String) {
  PatientQuestionnaireList(patientId: $id) {
    id
    resourceType
    patientId
    patientName
    assignedId
    assignedName
    assignedType
    assignedSpeciality
    questitionerId
    status
    assignedOn
    questionnaire {
      id
      questionnaireName
      questionnaireDescription
      administeredType
      totalScore
      questions {
        question
        selectedOptionId
        selectedOptionText
        comments
        options {
          option
          optionId
          optionScore
        }
        optionType
        showCommentBox
        isCommentBoxRequired
      }
    }
  }
}
    `;

/**
 * __useGetPatientQuestionnaireQuery__
 *
 * To run a query within a React component, call `useGetPatientQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientQuestionnaireQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientQuestionnaireQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientQuestionnaireQuery, GetPatientQuestionnaireQueryVariables>) {
        return Apollo.useQuery<GetPatientQuestionnaireQuery, GetPatientQuestionnaireQueryVariables>(GetPatientQuestionnaireDocument, baseOptions);
      }
export function useGetPatientQuestionnaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientQuestionnaireQuery, GetPatientQuestionnaireQueryVariables>) {
          return Apollo.useLazyQuery<GetPatientQuestionnaireQuery, GetPatientQuestionnaireQueryVariables>(GetPatientQuestionnaireDocument, baseOptions);
        }
export type GetPatientQuestionnaireQueryHookResult = ReturnType<typeof useGetPatientQuestionnaireQuery>;
export type GetPatientQuestionnaireLazyQueryHookResult = ReturnType<typeof useGetPatientQuestionnaireLazyQuery>;
export type GetPatientQuestionnaireQueryResult = Apollo.QueryResult<GetPatientQuestionnaireQuery, GetPatientQuestionnaireQueryVariables>;
export const GetPractitionerTasksDocument = gql`
    query getPractitionerTasks($id: String) {
  TasksMessages(
    typeOfMessage: 1
    typeOfMessageForType: 2
    typeOfMessageForTypeId: $id
  ) {
    id
    taskmessage
    createdOn
  }
}
    `;

/**
 * __useGetPractitionerTasksQuery__
 *
 * To run a query within a React component, call `useGetPractitionerTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerTasksQuery, GetPractitionerTasksQueryVariables>) {
        return Apollo.useQuery<GetPractitionerTasksQuery, GetPractitionerTasksQueryVariables>(GetPractitionerTasksDocument, baseOptions);
      }
export function useGetPractitionerTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerTasksQuery, GetPractitionerTasksQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerTasksQuery, GetPractitionerTasksQueryVariables>(GetPractitionerTasksDocument, baseOptions);
        }
export type GetPractitionerTasksQueryHookResult = ReturnType<typeof useGetPractitionerTasksQuery>;
export type GetPractitionerTasksLazyQueryHookResult = ReturnType<typeof useGetPractitionerTasksLazyQuery>;
export type GetPractitionerTasksQueryResult = Apollo.QueryResult<GetPractitionerTasksQuery, GetPractitionerTasksQueryVariables>;
export const GetPractitionerNotificationsDocument = gql`
    query getPractitionerNotifications($id: String) {
  TasksMessages(
    typeOfMessage: 2
    typeOfMessageForType: 2
    typeOfMessageForTypeId: $id
  ) {
    id
    taskmessage
    createdOn
  }
}
    `;

/**
 * __useGetPractitionerNotificationsQuery__
 *
 * To run a query within a React component, call `useGetPractitionerNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerNotificationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerNotificationsQuery, GetPractitionerNotificationsQueryVariables>) {
        return Apollo.useQuery<GetPractitionerNotificationsQuery, GetPractitionerNotificationsQueryVariables>(GetPractitionerNotificationsDocument, baseOptions);
      }
export function useGetPractitionerNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerNotificationsQuery, GetPractitionerNotificationsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerNotificationsQuery, GetPractitionerNotificationsQueryVariables>(GetPractitionerNotificationsDocument, baseOptions);
        }
export type GetPractitionerNotificationsQueryHookResult = ReturnType<typeof useGetPractitionerNotificationsQuery>;
export type GetPractitionerNotificationsLazyQueryHookResult = ReturnType<typeof useGetPractitionerNotificationsLazyQuery>;
export type GetPractitionerNotificationsQueryResult = Apollo.QueryResult<GetPractitionerNotificationsQuery, GetPractitionerNotificationsQueryVariables>;
export const GetPractitionerStatementsDocument = gql`
    query getPractitionerStatements($practitionerId: String) {
  PractitionerStatementList(practitionerId: $practitionerId) {
    id
    statementNo
    statementFromDate
    statementToDate
    practitionerId
    practitionerSpeciality
    practitionerEmail
    practitionerName
    practitionerPhoneNumber
    totalPaymentStatus
    totalInvoiceAmount
    totalAmountPaid
    totalPendingAmount
    statementMonth
    statementYear
    practitionerAddress
    paymentDueDate
    statementItems {
      id
      statementNo
      statementPaidOn
      appointmentDate
      appointmentTime
      createdOn
      appointmentId
      appointmentPayType
      appointmentBookedForTitle
      appointmentBookedForFirstName
      appointmentBookedForSurName
      appointmentBookedForEmail
      appointmentBookedForPhoneNumber
      appointmentDuration
      appointmentPrice
      appointmentType
      appointmentMode
      appointmentPayType
      thirdPartyPayer
      pmiName
      pmiGroupId
      pmiPolicyNumber
      pmiAuthSession
      paymentStatus
      paymentToOkatree
      paymentFromOkatree
      statementPaidOn
      statementAmount
    }
  }
}
    `;

/**
 * __useGetPractitionerStatementsQuery__
 *
 * To run a query within a React component, call `useGetPractitionerStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerStatementsQuery({
 *   variables: {
 *      practitionerId: // value for 'practitionerId'
 *   },
 * });
 */
export function useGetPractitionerStatementsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerStatementsQuery, GetPractitionerStatementsQueryVariables>) {
        return Apollo.useQuery<GetPractitionerStatementsQuery, GetPractitionerStatementsQueryVariables>(GetPractitionerStatementsDocument, baseOptions);
      }
export function useGetPractitionerStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerStatementsQuery, GetPractitionerStatementsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerStatementsQuery, GetPractitionerStatementsQueryVariables>(GetPractitionerStatementsDocument, baseOptions);
        }
export type GetPractitionerStatementsQueryHookResult = ReturnType<typeof useGetPractitionerStatementsQuery>;
export type GetPractitionerStatementsLazyQueryHookResult = ReturnType<typeof useGetPractitionerStatementsLazyQuery>;
export type GetPractitionerStatementsQueryResult = Apollo.QueryResult<GetPractitionerStatementsQuery, GetPractitionerStatementsQueryVariables>;
export const GetPractitionerCommV1Document = gql`
    query getPractitionerCommV1($fromId: String, $listType: String) {
  PractitionerPatientCommunicationList(
    fromId: $fromId
    commFromType: 2
    commToType: 0
    listType: $listType
  ) {
    id
    subject
    fromId
    toId
    fromEmail
    toEmail
    commFromType
    commToType
    bccEmail
    ccEmail
    createdOn
    fromName
    toName
    messageContent
    documentUrl
    commFrom
    readStatus
    replies {
      subject
      fromId
      toId
      fromEmail
      toEmail
      commFromType
      commToType
      bccEmail
      ccEmail
      createdOn
      fromName
      toName
      messageContent
      documentUrl
      commFrom
    }
  }
}
    `;

/**
 * __useGetPractitionerCommV1Query__
 *
 * To run a query within a React component, call `useGetPractitionerCommV1Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerCommV1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerCommV1Query({
 *   variables: {
 *      fromId: // value for 'fromId'
 *      listType: // value for 'listType'
 *   },
 * });
 */
export function useGetPractitionerCommV1Query(baseOptions?: Apollo.QueryHookOptions<GetPractitionerCommV1Query, GetPractitionerCommV1QueryVariables>) {
        return Apollo.useQuery<GetPractitionerCommV1Query, GetPractitionerCommV1QueryVariables>(GetPractitionerCommV1Document, baseOptions);
      }
export function useGetPractitionerCommV1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerCommV1Query, GetPractitionerCommV1QueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerCommV1Query, GetPractitionerCommV1QueryVariables>(GetPractitionerCommV1Document, baseOptions);
        }
export type GetPractitionerCommV1QueryHookResult = ReturnType<typeof useGetPractitionerCommV1Query>;
export type GetPractitionerCommV1LazyQueryHookResult = ReturnType<typeof useGetPractitionerCommV1LazyQuery>;
export type GetPractitionerCommV1QueryResult = Apollo.QueryResult<GetPractitionerCommV1Query, GetPractitionerCommV1QueryVariables>;
export const GetPractitionerPatientCommV1Document = gql`
    query getPractitionerPatientCommV1($fromId: String, $toId: String) {
  PractitionerPatientCommunicationList(
    fromId: $fromId
    toId: $toId
    commFromType: 2
    commToType: 1
  ) {
    id
    subject
    fromId
    toId
    fromEmail
    toEmail
    commFromType
    commToType
    bccEmail
    ccEmail
    createdOn
    fromName
    toName
    messageContent
    documentUrl
    commFrom
    replies {
      subject
      fromId
      toId
      fromEmail
      toEmail
      commFromType
      commToType
      bccEmail
      ccEmail
      createdOn
      fromName
      toName
      messageContent
      documentUrl
      commFrom
    }
  }
}
    `;

/**
 * __useGetPractitionerPatientCommV1Query__
 *
 * To run a query within a React component, call `useGetPractitionerPatientCommV1Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerPatientCommV1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerPatientCommV1Query({
 *   variables: {
 *      fromId: // value for 'fromId'
 *      toId: // value for 'toId'
 *   },
 * });
 */
export function useGetPractitionerPatientCommV1Query(baseOptions?: Apollo.QueryHookOptions<GetPractitionerPatientCommV1Query, GetPractitionerPatientCommV1QueryVariables>) {
        return Apollo.useQuery<GetPractitionerPatientCommV1Query, GetPractitionerPatientCommV1QueryVariables>(GetPractitionerPatientCommV1Document, baseOptions);
      }
export function useGetPractitionerPatientCommV1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerPatientCommV1Query, GetPractitionerPatientCommV1QueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerPatientCommV1Query, GetPractitionerPatientCommV1QueryVariables>(GetPractitionerPatientCommV1Document, baseOptions);
        }
export type GetPractitionerPatientCommV1QueryHookResult = ReturnType<typeof useGetPractitionerPatientCommV1Query>;
export type GetPractitionerPatientCommV1LazyQueryHookResult = ReturnType<typeof useGetPractitionerPatientCommV1LazyQuery>;
export type GetPractitionerPatientCommV1QueryResult = Apollo.QueryResult<GetPractitionerPatientCommV1Query, GetPractitionerPatientCommV1QueryVariables>;
export const GetPractitionerReviewsDocument = gql`
    query getPractitionerReviews($id: token) {
  Practitioner(_id: $id) {
    reviews {
      reviewType
      reviewStatus
      isBookingAppointmentEasy
      isVideoQualityGood
      questionnarieFillingFor
      isDoctorPolite
      isDoctorListenedToYou
      isAssessmentFeltComplete
      isInvolvedInDecisions
      isAbleToProvideTreatment
      happyToSeeDoctorAgain
      recommendThisDoctor
      patientId
      appointmentId
      patientName
      review
      createdOn
      rating
    }
  }
}
    `;

/**
 * __useGetPractitionerReviewsQuery__
 *
 * To run a query within a React component, call `useGetPractitionerReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerReviewsQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerReviewsQuery, GetPractitionerReviewsQueryVariables>) {
        return Apollo.useQuery<GetPractitionerReviewsQuery, GetPractitionerReviewsQueryVariables>(GetPractitionerReviewsDocument, baseOptions);
      }
export function useGetPractitionerReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerReviewsQuery, GetPractitionerReviewsQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerReviewsQuery, GetPractitionerReviewsQueryVariables>(GetPractitionerReviewsDocument, baseOptions);
        }
export type GetPractitionerReviewsQueryHookResult = ReturnType<typeof useGetPractitionerReviewsQuery>;
export type GetPractitionerReviewsLazyQueryHookResult = ReturnType<typeof useGetPractitionerReviewsLazyQuery>;
export type GetPractitionerReviewsQueryResult = Apollo.QueryResult<GetPractitionerReviewsQuery, GetPractitionerReviewsQueryVariables>;
export const GetPractitionerRecommendationDocument = gql`
    query getPractitionerRecommendation($id: token) {
  Practitioner(_id: $id) {
    recommendations {
      recommendationId
      recommendationText
      recommendationStatus
      recommendationSentFrom
      roleName
      fromPractitionerName
      toPractitionerName
      createdOn
      fromPractitionerEmail
      toPractitionerEmail
    }
  }
}
    `;

/**
 * __useGetPractitionerRecommendationQuery__
 *
 * To run a query within a React component, call `useGetPractitionerRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerRecommendationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerRecommendationQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerRecommendationQuery, GetPractitionerRecommendationQueryVariables>) {
        return Apollo.useQuery<GetPractitionerRecommendationQuery, GetPractitionerRecommendationQueryVariables>(GetPractitionerRecommendationDocument, baseOptions);
      }
export function useGetPractitionerRecommendationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerRecommendationQuery, GetPractitionerRecommendationQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerRecommendationQuery, GetPractitionerRecommendationQueryVariables>(GetPractitionerRecommendationDocument, baseOptions);
        }
export type GetPractitionerRecommendationQueryHookResult = ReturnType<typeof useGetPractitionerRecommendationQuery>;
export type GetPractitionerRecommendationLazyQueryHookResult = ReturnType<typeof useGetPractitionerRecommendationLazyQuery>;
export type GetPractitionerRecommendationQueryResult = Apollo.QueryResult<GetPractitionerRecommendationQuery, GetPractitionerRecommendationQueryVariables>;
export const GetAppointmentListDocument = gql`
    query getAppointmentList($id: token, $page: Int, $limit: Int) {
  PomsAppointmentList(_id: $id, _tag: "3", _page: $page, _limit: $limit) {
    id
    practitionerName
    practitionerId
    practitionerSpeciality
    appointmentDate
    appointmentTime
    slotId
    countAll
    appointmentCreatedOn
    appointmentFor
    appointmentNumber
    appointmentBookedBy
    appointmentBookedId
    appointmentBookedDOB
    appointmentType
    appointmentMode
    appointmentDuration
    appointmentBookedByTitle
    appointmentBookedByFirstName
    appointmentBookedBySurName
    appointmentBookedByGender
    appointmentBookedByEmail
    appointmentBookedByPhoneNumber
    appointmentBookedForTitle
    appointmentBookedForFirstName
    appointmentBookedForSurName
    appointmentBookedForGender
    appointmentBookedForEmail
    appointmentBookedForPhoneNumber
    appointmentBookedForRelationship
    appointmentNeedLanguageSupport
    appointmentSpecialNotes
    appointmentPrice
    appointmentPayType
    appointmentPMIName
    appointmentPMIResponsibleParty
    appointmentPMIFirstName
    appointmentPMISurName
    appointmentGroupId
    appointmentMemberPolicyNumber
    appointmentExpiresOn
    appointmentPMIAuthorisationCode
    appointmentPMIAuthorisationSession
    appointmentThirdPartyName
    appointmentThirdPartyId
    appointmentThirdPartyComments
    appointmentPatientTechAbility
    appointmentPatientMentalAbility
    appointmentPatientConsent
    appointmentStatus
    videoSessionId
    videoSessionToken
    videoAPIKey
    videoAPISecret
    diagnosis
    disorderDetails
    videoStartTime
    videoEndTime
    currentVideoTime
    isStartVideoClicked
    prescriptions {
      id
      comments
      practitionerName
      practitionerId
      patientId
      practitionerSpeciality
      patientName
      patientAddress
      practitionerSignUrl
      gmcNumber
      dateofbirth
      medications {
        drugName
        drugType
        dosage
        frequency
        route
        durationOfPrescription
        neededToIncrease
        neededToDecrease
        furtherInstructions
        anyChanges
      }
      prescriptionFileUrl
      prescriptionFileUrlName
      prescriptionId
      prescriptionDate
    }
    letters {
      id
      templateName
      templateMode
      templateType
      templateData
      patientId
      practitionerName
      practitionerSpeciality
      practitionerId
      templateJsonData
    }
  }
}
    `;

/**
 * __useGetAppointmentListQuery__
 *
 * To run a query within a React component, call `useGetAppointmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAppointmentListQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentListQuery, GetAppointmentListQueryVariables>) {
        return Apollo.useQuery<GetAppointmentListQuery, GetAppointmentListQueryVariables>(GetAppointmentListDocument, baseOptions);
      }
export function useGetAppointmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentListQuery, GetAppointmentListQueryVariables>) {
          return Apollo.useLazyQuery<GetAppointmentListQuery, GetAppointmentListQueryVariables>(GetAppointmentListDocument, baseOptions);
        }
export type GetAppointmentListQueryHookResult = ReturnType<typeof useGetAppointmentListQuery>;
export type GetAppointmentListLazyQueryHookResult = ReturnType<typeof useGetAppointmentListLazyQuery>;
export type GetAppointmentListQueryResult = Apollo.QueryResult<GetAppointmentListQuery, GetAppointmentListQueryVariables>;
export const GetFeedBackListDocument = gql`
    query getFeedBackList($feedBackType: Int, $fromUserId: String, $fromEmail: String) {
  FeedBackList(
    feedBackType: $feedBackType
    feedBackGetFrom: 1
    fromUserId: $fromUserId
    fromEmail: $fromEmail
  ) {
    id
    feedBackType
    feedBackAbout
    feedBackForPatientorRelative
    feedBackPersonTitle
    feedBackPersonFirstName
    feedBackPersonLastName
    feedBackPersonSurName
    feedBackPersonDOB
    feedBackPersonEmail
    feedBackPersonPhoneNumber
    feedBackDateOfService
    feedBackTimeOfService
    feedBackComments
    feedBackServiceUserName
    feedBackAgainstUser
    feedBackCreatedOn
    feedBackStatus
    feedBackServiceEmail
    feedBackNumber
    feedBackRespondStatus
    fromUserId
    feedBackReplies {
      feedBackType
      feedBackTypeId
      feedBackTypeName
      feedBackComments
      feedBackRepliedOn
      feedBackCreator
    }
    feedBackDocuments {
      content {
        attachment {
          title
          url
          creation
          documentType
        }
      }
    }
  }
}
    `;

/**
 * __useGetFeedBackListQuery__
 *
 * To run a query within a React component, call `useGetFeedBackListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedBackListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedBackListQuery({
 *   variables: {
 *      feedBackType: // value for 'feedBackType'
 *      fromUserId: // value for 'fromUserId'
 *      fromEmail: // value for 'fromEmail'
 *   },
 * });
 */
export function useGetFeedBackListQuery(baseOptions?: Apollo.QueryHookOptions<GetFeedBackListQuery, GetFeedBackListQueryVariables>) {
        return Apollo.useQuery<GetFeedBackListQuery, GetFeedBackListQueryVariables>(GetFeedBackListDocument, baseOptions);
      }
export function useGetFeedBackListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedBackListQuery, GetFeedBackListQueryVariables>) {
          return Apollo.useLazyQuery<GetFeedBackListQuery, GetFeedBackListQueryVariables>(GetFeedBackListDocument, baseOptions);
        }
export type GetFeedBackListQueryHookResult = ReturnType<typeof useGetFeedBackListQuery>;
export type GetFeedBackListLazyQueryHookResult = ReturnType<typeof useGetFeedBackListLazyQuery>;
export type GetFeedBackListQueryResult = Apollo.QueryResult<GetFeedBackListQuery, GetFeedBackListQueryVariables>;
export const GetTasksListDocument = gql`
    query getTasksList($id: String) {
  PractitionerTaskList(id: $id) {
    id
    taskUrl
    taskType
    taskMessage
    taskCount
  }
}
    `;

/**
 * __useGetTasksListQuery__
 *
 * To run a query within a React component, call `useGetTasksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTasksListQuery(baseOptions?: Apollo.QueryHookOptions<GetTasksListQuery, GetTasksListQueryVariables>) {
        return Apollo.useQuery<GetTasksListQuery, GetTasksListQueryVariables>(GetTasksListDocument, baseOptions);
      }
export function useGetTasksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksListQuery, GetTasksListQueryVariables>) {
          return Apollo.useLazyQuery<GetTasksListQuery, GetTasksListQueryVariables>(GetTasksListDocument, baseOptions);
        }
export type GetTasksListQueryHookResult = ReturnType<typeof useGetTasksListQuery>;
export type GetTasksListLazyQueryHookResult = ReturnType<typeof useGetTasksListLazyQuery>;
export type GetTasksListQueryResult = Apollo.QueryResult<GetTasksListQuery, GetTasksListQueryVariables>;
export const GetNotfnListDocument = gql`
    query getNotfnList($id: String, $isNotification: Boolean, $limit: Int, $skip: Int) {
  PractitionerNotificationList(
    id: $id
    isNotification: $isNotification
    limit: $limit
    skip: $skip
  ) {
    id
    notificationMessage
    notificationUrl
    createdOn
    isRead
  }
}
    `;

/**
 * __useGetNotfnListQuery__
 *
 * To run a query within a React component, call `useGetNotfnListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotfnListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotfnListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isNotification: // value for 'isNotification'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetNotfnListQuery(baseOptions?: Apollo.QueryHookOptions<GetNotfnListQuery, GetNotfnListQueryVariables>) {
        return Apollo.useQuery<GetNotfnListQuery, GetNotfnListQueryVariables>(GetNotfnListDocument, baseOptions);
      }
export function useGetNotfnListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotfnListQuery, GetNotfnListQueryVariables>) {
          return Apollo.useLazyQuery<GetNotfnListQuery, GetNotfnListQueryVariables>(GetNotfnListDocument, baseOptions);
        }
export type GetNotfnListQueryHookResult = ReturnType<typeof useGetNotfnListQuery>;
export type GetNotfnListLazyQueryHookResult = ReturnType<typeof useGetNotfnListLazyQuery>;
export type GetNotfnListQueryResult = Apollo.QueryResult<GetNotfnListQuery, GetNotfnListQueryVariables>;
export const GetPatientCommV1Document = gql`
    query getPatientCommV1($fromId: String) {
  PractitionerPatientCommunicationList(
    fromId: $fromId
    commFromType: 1
    commToType: 0
  ) {
    id
    subject
    fromId
    toId
    fromEmail
    toEmail
    commFromType
    commToType
    bccEmail
    ccEmail
    createdOn
    fromName
    toName
    messageContent
    documentUrl
    commFrom
    replies {
      subject
      fromId
      toId
      fromEmail
      toEmail
      commFromType
      commToType
      bccEmail
      ccEmail
      createdOn
      fromName
      toName
      messageContent
      documentUrl
      commFrom
    }
  }
}
    `;

/**
 * __useGetPatientCommV1Query__
 *
 * To run a query within a React component, call `useGetPatientCommV1Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientCommV1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientCommV1Query({
 *   variables: {
 *      fromId: // value for 'fromId'
 *   },
 * });
 */
export function useGetPatientCommV1Query(baseOptions?: Apollo.QueryHookOptions<GetPatientCommV1Query, GetPatientCommV1QueryVariables>) {
        return Apollo.useQuery<GetPatientCommV1Query, GetPatientCommV1QueryVariables>(GetPatientCommV1Document, baseOptions);
      }
export function useGetPatientCommV1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientCommV1Query, GetPatientCommV1QueryVariables>) {
          return Apollo.useLazyQuery<GetPatientCommV1Query, GetPatientCommV1QueryVariables>(GetPatientCommV1Document, baseOptions);
        }
export type GetPatientCommV1QueryHookResult = ReturnType<typeof useGetPatientCommV1Query>;
export type GetPatientCommV1LazyQueryHookResult = ReturnType<typeof useGetPatientCommV1LazyQuery>;
export type GetPatientCommV1QueryResult = Apollo.QueryResult<GetPatientCommV1Query, GetPatientCommV1QueryVariables>;
export const GetBlogListDocument = gql`
    query getBlogList {
  BlogList {
    id
    categoryName
    categoryId
    subCategoryName
    subCategoryId
    blogTitle
    blogDescription
    blogDescriptionHtml
    blogBannerImage
    authorType
    authorTypeId
    authorName
    authorDescription
    authorImage
    createdOn
    blogDescriptionPlainText
  }
}
    `;

/**
 * __useGetBlogListQuery__
 *
 * To run a query within a React component, call `useGetBlogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBlogListQuery(baseOptions?: Apollo.QueryHookOptions<GetBlogListQuery, GetBlogListQueryVariables>) {
        return Apollo.useQuery<GetBlogListQuery, GetBlogListQueryVariables>(GetBlogListDocument, baseOptions);
      }
export function useGetBlogListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogListQuery, GetBlogListQueryVariables>) {
          return Apollo.useLazyQuery<GetBlogListQuery, GetBlogListQueryVariables>(GetBlogListDocument, baseOptions);
        }
export type GetBlogListQueryHookResult = ReturnType<typeof useGetBlogListQuery>;
export type GetBlogListLazyQueryHookResult = ReturnType<typeof useGetBlogListLazyQuery>;
export type GetBlogListQueryResult = Apollo.QueryResult<GetBlogListQuery, GetBlogListQueryVariables>;
export const GetSignpostingListDocument = gql`
    query getSignpostingList($id: token) {
  Patient(_id: $id) {
    signPostingList {
      organizationName
      organizationEmail
      organizationPhoneNo
      organizationWebsite
      organizationLogoUrl
      practitionerId
      practitionerName
      practitionerSpeciality
      sentOn
      services
      organizationId
      reason
    }
  }
}
    `;

/**
 * __useGetSignpostingListQuery__
 *
 * To run a query within a React component, call `useGetSignpostingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignpostingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignpostingListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSignpostingListQuery(baseOptions?: Apollo.QueryHookOptions<GetSignpostingListQuery, GetSignpostingListQueryVariables>) {
        return Apollo.useQuery<GetSignpostingListQuery, GetSignpostingListQueryVariables>(GetSignpostingListDocument, baseOptions);
      }
export function useGetSignpostingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignpostingListQuery, GetSignpostingListQueryVariables>) {
          return Apollo.useLazyQuery<GetSignpostingListQuery, GetSignpostingListQueryVariables>(GetSignpostingListDocument, baseOptions);
        }
export type GetSignpostingListQueryHookResult = ReturnType<typeof useGetSignpostingListQuery>;
export type GetSignpostingListLazyQueryHookResult = ReturnType<typeof useGetSignpostingListLazyQuery>;
export type GetSignpostingListQueryResult = Apollo.QueryResult<GetSignpostingListQuery, GetSignpostingListQueryVariables>;
export const GetPractitionerProfessionalTypeListDocument = gql`
    query getPractitionerProfessionalTypeList($id: String) {
  ProfessionalTypeList(id: $id) {
    resourceType
    id
    name
    status
  }
}
    `;

/**
 * __useGetPractitionerProfessionalTypeListQuery__
 *
 * To run a query within a React component, call `useGetPractitionerProfessionalTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerProfessionalTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerProfessionalTypeListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerProfessionalTypeListQuery(baseOptions?: Apollo.QueryHookOptions<GetPractitionerProfessionalTypeListQuery, GetPractitionerProfessionalTypeListQueryVariables>) {
        return Apollo.useQuery<GetPractitionerProfessionalTypeListQuery, GetPractitionerProfessionalTypeListQueryVariables>(GetPractitionerProfessionalTypeListDocument, baseOptions);
      }
export function useGetPractitionerProfessionalTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPractitionerProfessionalTypeListQuery, GetPractitionerProfessionalTypeListQueryVariables>) {
          return Apollo.useLazyQuery<GetPractitionerProfessionalTypeListQuery, GetPractitionerProfessionalTypeListQueryVariables>(GetPractitionerProfessionalTypeListDocument, baseOptions);
        }
export type GetPractitionerProfessionalTypeListQueryHookResult = ReturnType<typeof useGetPractitionerProfessionalTypeListQuery>;
export type GetPractitionerProfessionalTypeListLazyQueryHookResult = ReturnType<typeof useGetPractitionerProfessionalTypeListLazyQuery>;
export type GetPractitionerProfessionalTypeListQueryResult = Apollo.QueryResult<GetPractitionerProfessionalTypeListQuery, GetPractitionerProfessionalTypeListQueryVariables>;
export const GetAppointmentTypeMasterListDocument = gql`
    query getAppointmentTypeMasterList {
  AppointmentTypeMasterList {
    resourceType
    id
    name
    status
    professionalTypeRelation {
      professionalTypeId
    }
  }
}
    `;

/**
 * __useGetAppointmentTypeMasterListQuery__
 *
 * To run a query within a React component, call `useGetAppointmentTypeMasterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentTypeMasterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentTypeMasterListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentTypeMasterListQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentTypeMasterListQuery, GetAppointmentTypeMasterListQueryVariables>) {
        return Apollo.useQuery<GetAppointmentTypeMasterListQuery, GetAppointmentTypeMasterListQueryVariables>(GetAppointmentTypeMasterListDocument, baseOptions);
      }
export function useGetAppointmentTypeMasterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentTypeMasterListQuery, GetAppointmentTypeMasterListQueryVariables>) {
          return Apollo.useLazyQuery<GetAppointmentTypeMasterListQuery, GetAppointmentTypeMasterListQueryVariables>(GetAppointmentTypeMasterListDocument, baseOptions);
        }
export type GetAppointmentTypeMasterListQueryHookResult = ReturnType<typeof useGetAppointmentTypeMasterListQuery>;
export type GetAppointmentTypeMasterListLazyQueryHookResult = ReturnType<typeof useGetAppointmentTypeMasterListLazyQuery>;
export type GetAppointmentTypeMasterListQueryResult = Apollo.QueryResult<GetAppointmentTypeMasterListQuery, GetAppointmentTypeMasterListQueryVariables>;
export const AppointmentTypeDocument = gql`
    query AppointmentType($id: String) {
  AppointmentTypeMaster(id: $id) {
    resourceType
    id
    name
    status
    professionalTypeRelation {
      professionalTypeId
    }
  }
}
    `;

/**
 * __useAppointmentTypeQuery__
 *
 * To run a query within a React component, call `useAppointmentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentTypeQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentTypeQuery, AppointmentTypeQueryVariables>) {
        return Apollo.useQuery<AppointmentTypeQuery, AppointmentTypeQueryVariables>(AppointmentTypeDocument, baseOptions);
      }
export function useAppointmentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentTypeQuery, AppointmentTypeQueryVariables>) {
          return Apollo.useLazyQuery<AppointmentTypeQuery, AppointmentTypeQueryVariables>(AppointmentTypeDocument, baseOptions);
        }
export type AppointmentTypeQueryHookResult = ReturnType<typeof useAppointmentTypeQuery>;
export type AppointmentTypeLazyQueryHookResult = ReturnType<typeof useAppointmentTypeLazyQuery>;
export type AppointmentTypeQueryResult = Apollo.QueryResult<AppointmentTypeQuery, AppointmentTypeQueryVariables>;
export const SubSpecialtyMasterDataDocument = gql`
    query SubSpecialtyMasterData($id: String) {
  SubSpecialtyMaster(id: $id) {
    resourceType
    id
    name
    status
    professionalTypeRelation {
      professionalTypeId
    }
  }
}
    `;

/**
 * __useSubSpecialtyMasterDataQuery__
 *
 * To run a query within a React component, call `useSubSpecialtyMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubSpecialtyMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubSpecialtyMasterDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubSpecialtyMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<SubSpecialtyMasterDataQuery, SubSpecialtyMasterDataQueryVariables>) {
        return Apollo.useQuery<SubSpecialtyMasterDataQuery, SubSpecialtyMasterDataQueryVariables>(SubSpecialtyMasterDataDocument, baseOptions);
      }
export function useSubSpecialtyMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubSpecialtyMasterDataQuery, SubSpecialtyMasterDataQueryVariables>) {
          return Apollo.useLazyQuery<SubSpecialtyMasterDataQuery, SubSpecialtyMasterDataQueryVariables>(SubSpecialtyMasterDataDocument, baseOptions);
        }
export type SubSpecialtyMasterDataQueryHookResult = ReturnType<typeof useSubSpecialtyMasterDataQuery>;
export type SubSpecialtyMasterDataLazyQueryHookResult = ReturnType<typeof useSubSpecialtyMasterDataLazyQuery>;
export type SubSpecialtyMasterDataQueryResult = Apollo.QueryResult<SubSpecialtyMasterDataQuery, SubSpecialtyMasterDataQueryVariables>;
export const PomsAppointmentSummeryDocument = gql`
    query PomsAppointmentSummery($id: token) {
  PomsAppointmentSummery(_id: $id) {
    totalCompleteCount
    lastMonthCompleteCount
    currentMonthCompleteCount
    increaseCompleteStatus
    totalCancelCount
    lastMonthCancelCount
    currentMonthCancelCount
    increaseCancelStatus
    totalPatientCount
    lastMonthPatientCount
    currentMonthPatientCount
    increasePatientStatus
  }
}
    `;

/**
 * __usePomsAppointmentSummeryQuery__
 *
 * To run a query within a React component, call `usePomsAppointmentSummeryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePomsAppointmentSummeryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePomsAppointmentSummeryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePomsAppointmentSummeryQuery(baseOptions?: Apollo.QueryHookOptions<PomsAppointmentSummeryQuery, PomsAppointmentSummeryQueryVariables>) {
        return Apollo.useQuery<PomsAppointmentSummeryQuery, PomsAppointmentSummeryQueryVariables>(PomsAppointmentSummeryDocument, baseOptions);
      }
export function usePomsAppointmentSummeryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PomsAppointmentSummeryQuery, PomsAppointmentSummeryQueryVariables>) {
          return Apollo.useLazyQuery<PomsAppointmentSummeryQuery, PomsAppointmentSummeryQueryVariables>(PomsAppointmentSummeryDocument, baseOptions);
        }
export type PomsAppointmentSummeryQueryHookResult = ReturnType<typeof usePomsAppointmentSummeryQuery>;
export type PomsAppointmentSummeryLazyQueryHookResult = ReturnType<typeof usePomsAppointmentSummeryLazyQuery>;
export type PomsAppointmentSummeryQueryResult = Apollo.QueryResult<PomsAppointmentSummeryQuery, PomsAppointmentSummeryQueryVariables>;
export const PatientCountByMonthDocument = gql`
    query PatientCountByMonth($id: token) {
  PatientCountByMonth(_id: $id) {
    patientTotalCount
    patientTotalCountByMonth
  }
}
    `;

/**
 * __usePatientCountByMonthQuery__
 *
 * To run a query within a React component, call `usePatientCountByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientCountByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientCountByMonthQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePatientCountByMonthQuery(baseOptions?: Apollo.QueryHookOptions<PatientCountByMonthQuery, PatientCountByMonthQueryVariables>) {
        return Apollo.useQuery<PatientCountByMonthQuery, PatientCountByMonthQueryVariables>(PatientCountByMonthDocument, baseOptions);
      }
export function usePatientCountByMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientCountByMonthQuery, PatientCountByMonthQueryVariables>) {
          return Apollo.useLazyQuery<PatientCountByMonthQuery, PatientCountByMonthQueryVariables>(PatientCountByMonthDocument, baseOptions);
        }
export type PatientCountByMonthQueryHookResult = ReturnType<typeof usePatientCountByMonthQuery>;
export type PatientCountByMonthLazyQueryHookResult = ReturnType<typeof usePatientCountByMonthLazyQuery>;
export type PatientCountByMonthQueryResult = Apollo.QueryResult<PatientCountByMonthQuery, PatientCountByMonthQueryVariables>;
export const PractitionerReviewsCountDocument = gql`
    query PractitionerReviewsCount($id: token) {
  PractitionerReviewCount(_id: $id) {
    reviewCount
    recommendationCount
  }
}
    `;

/**
 * __usePractitionerReviewsCountQuery__
 *
 * To run a query within a React component, call `usePractitionerReviewsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractitionerReviewsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractitionerReviewsCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePractitionerReviewsCountQuery(baseOptions?: Apollo.QueryHookOptions<PractitionerReviewsCountQuery, PractitionerReviewsCountQueryVariables>) {
        return Apollo.useQuery<PractitionerReviewsCountQuery, PractitionerReviewsCountQueryVariables>(PractitionerReviewsCountDocument, baseOptions);
      }
export function usePractitionerReviewsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PractitionerReviewsCountQuery, PractitionerReviewsCountQueryVariables>) {
          return Apollo.useLazyQuery<PractitionerReviewsCountQuery, PractitionerReviewsCountQueryVariables>(PractitionerReviewsCountDocument, baseOptions);
        }
export type PractitionerReviewsCountQueryHookResult = ReturnType<typeof usePractitionerReviewsCountQuery>;
export type PractitionerReviewsCountLazyQueryHookResult = ReturnType<typeof usePractitionerReviewsCountLazyQuery>;
export type PractitionerReviewsCountQueryResult = Apollo.QueryResult<PractitionerReviewsCountQuery, PractitionerReviewsCountQueryVariables>;
export const PractitionerToDoTaskListDocument = gql`
    query PractitionerToDoTaskList($id: String, $text: String, $limit: Int) {
  PractitionerToDoTaskList(_text: $text, id: $id, limit: $limit) {
    toId
    taskType
    message
    status
    createdOn
    updatedOn
    fullName
    phonenumber
    email
    dob
    MRNNumber
  }
}
    `;

/**
 * __usePractitionerToDoTaskListQuery__
 *
 * To run a query within a React component, call `usePractitionerToDoTaskListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractitionerToDoTaskListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractitionerToDoTaskListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePractitionerToDoTaskListQuery(baseOptions?: Apollo.QueryHookOptions<PractitionerToDoTaskListQuery, PractitionerToDoTaskListQueryVariables>) {
        return Apollo.useQuery<PractitionerToDoTaskListQuery, PractitionerToDoTaskListQueryVariables>(PractitionerToDoTaskListDocument, baseOptions);
      }
export function usePractitionerToDoTaskListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PractitionerToDoTaskListQuery, PractitionerToDoTaskListQueryVariables>) {
          return Apollo.useLazyQuery<PractitionerToDoTaskListQuery, PractitionerToDoTaskListQueryVariables>(PractitionerToDoTaskListDocument, baseOptions);
        }
export type PractitionerToDoTaskListQueryHookResult = ReturnType<typeof usePractitionerToDoTaskListQuery>;
export type PractitionerToDoTaskListLazyQueryHookResult = ReturnType<typeof usePractitionerToDoTaskListLazyQuery>;
export type PractitionerToDoTaskListQueryResult = Apollo.QueryResult<PractitionerToDoTaskListQuery, PractitionerToDoTaskListQueryVariables>;
export const PatientToDoTaskListCountDocument = gql`
    query PatientToDoTaskListCount($id: String, $text: String, $limit: Int, $skip: Int) {
  PatientToDoTaskListCount(_text: $text, id: $id, limit: $limit, skip: $skip) {
    taskCount
    taskList {
      toId
      fromId
      taskId
      taskType
      message
      actionType
      status
      createdOn
      id
    }
  }
}
    `;

/**
 * __usePatientToDoTaskListCountQuery__
 *
 * To run a query within a React component, call `usePatientToDoTaskListCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientToDoTaskListCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientToDoTaskListCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePatientToDoTaskListCountQuery(baseOptions?: Apollo.QueryHookOptions<PatientToDoTaskListCountQuery, PatientToDoTaskListCountQueryVariables>) {
        return Apollo.useQuery<PatientToDoTaskListCountQuery, PatientToDoTaskListCountQueryVariables>(PatientToDoTaskListCountDocument, baseOptions);
      }
export function usePatientToDoTaskListCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientToDoTaskListCountQuery, PatientToDoTaskListCountQueryVariables>) {
          return Apollo.useLazyQuery<PatientToDoTaskListCountQuery, PatientToDoTaskListCountQueryVariables>(PatientToDoTaskListCountDocument, baseOptions);
        }
export type PatientToDoTaskListCountQueryHookResult = ReturnType<typeof usePatientToDoTaskListCountQuery>;
export type PatientToDoTaskListCountLazyQueryHookResult = ReturnType<typeof usePatientToDoTaskListCountLazyQuery>;
export type PatientToDoTaskListCountQueryResult = Apollo.QueryResult<PatientToDoTaskListCountQuery, PatientToDoTaskListCountQueryVariables>;
export const PractitionerToDoTaskListCountDocument = gql`
    query PractitionerToDoTaskListCount($id: String, $text: String, $limit: Int, $skip: Int) {
  PractitionerToDoTaskListCount(id: $id, _text: $text, limit: $limit, skip: $skip) {
    taskCount
    taskList {
      toId
      taskType
      message
      status
      createdOn
      updatedOn
      fullName
      phonenumber
      email
      dob
      MRNNumber
    }
  }
}
    `;

/**
 * __usePractitionerToDoTaskListCountQuery__
 *
 * To run a query within a React component, call `usePractitionerToDoTaskListCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractitionerToDoTaskListCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractitionerToDoTaskListCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePractitionerToDoTaskListCountQuery(baseOptions?: Apollo.QueryHookOptions<PractitionerToDoTaskListCountQuery, PractitionerToDoTaskListCountQueryVariables>) {
        return Apollo.useQuery<PractitionerToDoTaskListCountQuery, PractitionerToDoTaskListCountQueryVariables>(PractitionerToDoTaskListCountDocument, baseOptions);
      }
export function usePractitionerToDoTaskListCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PractitionerToDoTaskListCountQuery, PractitionerToDoTaskListCountQueryVariables>) {
          return Apollo.useLazyQuery<PractitionerToDoTaskListCountQuery, PractitionerToDoTaskListCountQueryVariables>(PractitionerToDoTaskListCountDocument, baseOptions);
        }
export type PractitionerToDoTaskListCountQueryHookResult = ReturnType<typeof usePractitionerToDoTaskListCountQuery>;
export type PractitionerToDoTaskListCountLazyQueryHookResult = ReturnType<typeof usePractitionerToDoTaskListCountLazyQuery>;
export type PractitionerToDoTaskListCountQueryResult = Apollo.QueryResult<PractitionerToDoTaskListCountQuery, PractitionerToDoTaskListCountQueryVariables>;
export const GetExternalPatientQuestionnaireListDocument = gql`
    query getExternalPatientQuestionnaireList($id: String, $practitionerId: String) {
  ExternalPatientQuestionnaireList(
    patientId: $id
    practitionerId: $practitionerId
  ) {
    id
    resourceType
    patientId
    patientName
    assignedId
    assignedName
    assignedType
    assignedSpeciality
    questitionerId
    questionnaireName
    recipientName
    recipientEmail
    emailSubject
    emailBody
    status
    assignedOn
    questionnaire {
      id
      questionnaireName
      questionnaireDescription
      administeredType
      totalScore
      questions {
        question
        selectedOptionId
        selectedOptionText
        comments
        options {
          option
          optionId
          optionScore
        }
        optionType
        showCommentBox
        isCommentBoxRequired
      }
    }
  }
}
    `;

/**
 * __useGetExternalPatientQuestionnaireListQuery__
 *
 * To run a query within a React component, call `useGetExternalPatientQuestionnaireListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalPatientQuestionnaireListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalPatientQuestionnaireListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      practitionerId: // value for 'practitionerId'
 *   },
 * });
 */
export function useGetExternalPatientQuestionnaireListQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalPatientQuestionnaireListQuery, GetExternalPatientQuestionnaireListQueryVariables>) {
        return Apollo.useQuery<GetExternalPatientQuestionnaireListQuery, GetExternalPatientQuestionnaireListQueryVariables>(GetExternalPatientQuestionnaireListDocument, baseOptions);
      }
export function useGetExternalPatientQuestionnaireListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalPatientQuestionnaireListQuery, GetExternalPatientQuestionnaireListQueryVariables>) {
          return Apollo.useLazyQuery<GetExternalPatientQuestionnaireListQuery, GetExternalPatientQuestionnaireListQueryVariables>(GetExternalPatientQuestionnaireListDocument, baseOptions);
        }
export type GetExternalPatientQuestionnaireListQueryHookResult = ReturnType<typeof useGetExternalPatientQuestionnaireListQuery>;
export type GetExternalPatientQuestionnaireListLazyQueryHookResult = ReturnType<typeof useGetExternalPatientQuestionnaireListLazyQuery>;
export type GetExternalPatientQuestionnaireListQueryResult = Apollo.QueryResult<GetExternalPatientQuestionnaireListQuery, GetExternalPatientQuestionnaireListQueryVariables>;
export const GetExternalPatientQuestionnaireDocument = gql`
    query getExternalPatientQuestionnaire($id: String) {
  ExternalPatientQuestionnaire(id: $id) {
    id
    resourceType
    patientId
    patientName
    assignedId
    assignedName
    assignedType
    assignedSpeciality
    questitionerId
    questionnaireName
    recipientName
    recipientEmail
    emailSubject
    emailBody
    status
    assignedOn
    questionnaire {
      id
      questionnaireName
      questionnaireDescription
      administeredType
      totalScore
      questions {
        question
        selectedOptionId
        selectedOptionText
        comments
        options {
          option
          optionId
          optionScore
        }
        optionType
        showCommentBox
        isCommentBoxRequired
      }
    }
  }
}
    `;

/**
 * __useGetExternalPatientQuestionnaireQuery__
 *
 * To run a query within a React component, call `useGetExternalPatientQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalPatientQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalPatientQuestionnaireQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExternalPatientQuestionnaireQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalPatientQuestionnaireQuery, GetExternalPatientQuestionnaireQueryVariables>) {
        return Apollo.useQuery<GetExternalPatientQuestionnaireQuery, GetExternalPatientQuestionnaireQueryVariables>(GetExternalPatientQuestionnaireDocument, baseOptions);
      }
export function useGetExternalPatientQuestionnaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalPatientQuestionnaireQuery, GetExternalPatientQuestionnaireQueryVariables>) {
          return Apollo.useLazyQuery<GetExternalPatientQuestionnaireQuery, GetExternalPatientQuestionnaireQueryVariables>(GetExternalPatientQuestionnaireDocument, baseOptions);
        }
export type GetExternalPatientQuestionnaireQueryHookResult = ReturnType<typeof useGetExternalPatientQuestionnaireQuery>;
export type GetExternalPatientQuestionnaireLazyQueryHookResult = ReturnType<typeof useGetExternalPatientQuestionnaireLazyQuery>;
export type GetExternalPatientQuestionnaireQueryResult = Apollo.QueryResult<GetExternalPatientQuestionnaireQuery, GetExternalPatientQuestionnaireQueryVariables>;
export const GetDisorderActiveListDocument = gql`
    query getDisorderActiveList {
  DisorderActiveList {
    id
    disorderName
    disorderValue
    disorderStatus
    createdOn
  }
}
    `;

/**
 * __useGetDisorderActiveListQuery__
 *
 * To run a query within a React component, call `useGetDisorderActiveListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisorderActiveListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisorderActiveListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDisorderActiveListQuery(baseOptions?: Apollo.QueryHookOptions<GetDisorderActiveListQuery, GetDisorderActiveListQueryVariables>) {
        return Apollo.useQuery<GetDisorderActiveListQuery, GetDisorderActiveListQueryVariables>(GetDisorderActiveListDocument, baseOptions);
      }
export function useGetDisorderActiveListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisorderActiveListQuery, GetDisorderActiveListQueryVariables>) {
          return Apollo.useLazyQuery<GetDisorderActiveListQuery, GetDisorderActiveListQueryVariables>(GetDisorderActiveListDocument, baseOptions);
        }
export type GetDisorderActiveListQueryHookResult = ReturnType<typeof useGetDisorderActiveListQuery>;
export type GetDisorderActiveListLazyQueryHookResult = ReturnType<typeof useGetDisorderActiveListLazyQuery>;
export type GetDisorderActiveListQueryResult = Apollo.QueryResult<GetDisorderActiveListQuery, GetDisorderActiveListQueryVariables>;
export const HandbookListDocument = gql`
    query handbookList {
  HandbookList {
    id
    name
    filePath
  }
}
    `;

/**
 * __useHandbookListQuery__
 *
 * To run a query within a React component, call `useHandbookListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHandbookListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHandbookListQuery({
 *   variables: {
 *   },
 * });
 */
export function useHandbookListQuery(baseOptions?: Apollo.QueryHookOptions<HandbookListQuery, HandbookListQueryVariables>) {
        return Apollo.useQuery<HandbookListQuery, HandbookListQueryVariables>(HandbookListDocument, baseOptions);
      }
export function useHandbookListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HandbookListQuery, HandbookListQueryVariables>) {
          return Apollo.useLazyQuery<HandbookListQuery, HandbookListQueryVariables>(HandbookListDocument, baseOptions);
        }
export type HandbookListQueryHookResult = ReturnType<typeof useHandbookListQuery>;
export type HandbookListLazyQueryHookResult = ReturnType<typeof useHandbookListLazyQuery>;
export type HandbookListQueryResult = Apollo.QueryResult<HandbookListQuery, HandbookListQueryVariables>;
export const GetCrisisSafeguardListDocument = gql`
    query getCrisisSafeguardList($patID: String!, $page: Int, $limit: Int, $search: String, $type: String) {
  CrisisSafeguardList(
    patientId: $patID
    _page: $page
    _limit: $limit
    search: $search
    type: $type
  ) {
    id
    countAll
    templateName
    templateMode
    templateType
    templateData
    patientId
    practitionerName
    practitionerSpeciality
    practitionerId
    templateJsonData
    patientName
    gpName
    gpPractitionerName
    gpEmail
    name
    email
    letterType
    letterUploadUrl
    createdOn
  }
}
    `;

/**
 * __useGetCrisisSafeguardListQuery__
 *
 * To run a query within a React component, call `useGetCrisisSafeguardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrisisSafeguardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrisisSafeguardListQuery({
 *   variables: {
 *      patID: // value for 'patID'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetCrisisSafeguardListQuery(baseOptions: Apollo.QueryHookOptions<GetCrisisSafeguardListQuery, GetCrisisSafeguardListQueryVariables>) {
        return Apollo.useQuery<GetCrisisSafeguardListQuery, GetCrisisSafeguardListQueryVariables>(GetCrisisSafeguardListDocument, baseOptions);
      }
export function useGetCrisisSafeguardListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrisisSafeguardListQuery, GetCrisisSafeguardListQueryVariables>) {
          return Apollo.useLazyQuery<GetCrisisSafeguardListQuery, GetCrisisSafeguardListQueryVariables>(GetCrisisSafeguardListDocument, baseOptions);
        }
export type GetCrisisSafeguardListQueryHookResult = ReturnType<typeof useGetCrisisSafeguardListQuery>;
export type GetCrisisSafeguardListLazyQueryHookResult = ReturnType<typeof useGetCrisisSafeguardListLazyQuery>;
export type GetCrisisSafeguardListQueryResult = Apollo.QueryResult<GetCrisisSafeguardListQuery, GetCrisisSafeguardListQueryVariables>;
export const GetPatientPrivacyDocument = gql`
    query getPatientPrivacy($id: token) {
  PomsPatientPrivacy(_id: $id) {
    contactSMS
    contactPost
    contactPhone
    contactEmail
    notifySMS
    notifyPost
    notifyPhone
    notifyEmail
    gdprConsent
    consentDisclosure
    prescriptionPolicy
    informationPolicy
    okatreeContract
    cancellationPolicy
    patientorGuardianName
    guardianFirstName
    guardianSurname
    relationtoPatient
    specialOfferPolicy
    whatsappOfferPolicy
    patientName
    patientAddress
    gpName
    gpPracticeName
    gpPracticeAddress
  }
}
    `;

/**
 * __useGetPatientPrivacyQuery__
 *
 * To run a query within a React component, call `useGetPatientPrivacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientPrivacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientPrivacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientPrivacyQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientPrivacyQuery, GetPatientPrivacyQueryVariables>) {
        return Apollo.useQuery<GetPatientPrivacyQuery, GetPatientPrivacyQueryVariables>(GetPatientPrivacyDocument, baseOptions);
      }
export function useGetPatientPrivacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientPrivacyQuery, GetPatientPrivacyQueryVariables>) {
          return Apollo.useLazyQuery<GetPatientPrivacyQuery, GetPatientPrivacyQueryVariables>(GetPatientPrivacyDocument, baseOptions);
        }
export type GetPatientPrivacyQueryHookResult = ReturnType<typeof useGetPatientPrivacyQuery>;
export type GetPatientPrivacyLazyQueryHookResult = ReturnType<typeof useGetPatientPrivacyLazyQuery>;
export type GetPatientPrivacyQueryResult = Apollo.QueryResult<GetPatientPrivacyQuery, GetPatientPrivacyQueryVariables>;